/* eslint-disable */
import {
    PreConstruct,
    Bean,
    BeanStub,
    Autowired,
    RefSelector,
    PostConstruct,
    Component,
    ModuleNames,
    Events,
    _,
    KeyCode,
    AgRichSelect,
    VirtualListDragFeature,
    DragSourceType,
    AgInputDateField,
    AgInputNumberField,
    AgInputTextField,
    TooltipFeature,
    DragAndDropService,
    TabGuardComp,
    VirtualList,
    AgDialog,
    FocusService,
    AgAutocomplete,
    ChangedPath,
    Optional,
    CsvExportModule,
    EventService,
    Column,
    ProvidedColumnGroup,
    AgMenuList,
    AgMenuItemComponent,
    CssClassApplier,
    TouchListener,
    PreDestroy,
    NumberSequence,
    RowNode,
    ManagedFocusFeature,
    PositionableFeature,
    AgSelect,
    AgPromise,
    ModuleRegistry,
    ExcelFactoryMode,
    XmlFactory,
    RowType,
    BaseGridSerializingSession,
    Downloader,
    BaseCreator,
    ZipContainer,
    GridSerializer,
    CsvCreator,
    AgGroupComponent,
    AutoScrollService,
    AgRadioButton,
    AgToggleButton,
    AgCheckbox,
    AgAbstractLabel,
    AgSlider,
    DEFAULT_CHART_GROUPS,
    TabbedLayout,
    CHART_TOOLBAR_ALLOW_LIST,
    CHART_TOOL_PANEL_ALLOW_LIST,
    CHART_TOOL_PANEL_MENU_OPTIONS,
    AgPanel,
    CellRangeType,
    CellCtrl,
    SelectionHandleType,
    AgPickerField,
    Grid,
    ProvidedFilter,
    PopupComponent,
    RowNodeBlock,
    ServerSideTransactionResultStatus,
    RowNodeBlockLoader,
    GROUP_AUTO_COLUMN_ID,
    TextFilter,
    AllCommunityModules,
} from 'ag-grid-community';
export * from 'ag-grid-community';

var MD5 = /** @class */ (function () {
    function MD5() {
        this.ieCompatibility = false;
    }
    MD5.prototype.init = function () {
        this.ieCompatibility = this.md5('hello') != '5d41402abc4b2a76b9719d911017c592';
    };
    MD5.prototype.md5cycle = function (x, k) {
        var a = x[0],
            b = x[1],
            c = x[2],
            d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    };
    MD5.prototype.cmn = function (q, a, b, x, s, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32((a << s) | (a >>> (32 - s)), b);
    };
    MD5.prototype.ff = function (a, b, c, d, x, s, t) {
        return this.cmn((b & c) | (~b & d), a, b, x, s, t);
    };
    MD5.prototype.gg = function (a, b, c, d, x, s, t) {
        return this.cmn((b & d) | (c & ~d), a, b, x, s, t);
    };
    MD5.prototype.hh = function (a, b, c, d, x, s, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s, t);
    };
    MD5.prototype.ii = function (a, b, c, d, x, s, t) {
        return this.cmn(c ^ (b | ~d), a, b, x, s, t);
    };
    MD5.prototype.md51 = function (s) {
        var n = s.length;
        var state = [1732584193, -271733879, -1732584194, 271733878];
        var i;
        for (i = 64; i <= s.length; i += 64) {
            this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
        }
        s = s.substring(i - 64);
        var tail = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        for (i = 0; i < s.length; i++) {
            tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        }
        tail[i >> 2] |= 0x80 << (i % 4 << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for (i = 0; i < 16; i++) {
                tail[i] = 0;
            }
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    };
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
     * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
     * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
     * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
     * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
     * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
     * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
     */
    MD5.prototype.md5blk = function (s) {
        var md5blks = [];
        /* Andy King said do it this way. */
        for (var i = 0; i < 64; i += 4) {
            md5blks[i >> 2] =
                s.charCodeAt(i) +
                (s.charCodeAt(i + 1) << 8) +
                (s.charCodeAt(i + 2) << 16) +
                (s.charCodeAt(i + 3) << 24);
        }
        return md5blks;
    };
    MD5.prototype.rhex = function (n) {
        var hex_chr = '0123456789abcdef'.split('');
        var s = '',
            j = 0;
        for (; j < 4; j++) {
            s += hex_chr[(n >> (j * 8 + 4)) & 0x0f] + hex_chr[(n >> (j * 8)) & 0x0f];
        }
        return s;
    };
    MD5.prototype.hex = function (x) {
        for (var i = 0; i < x.length; i++) {
            x[i] = this.rhex(x[i]);
        }
        return x.join('');
    };
    MD5.prototype.md5 = function (s) {
        return this.hex(this.md51(s));
    };
    MD5.prototype.add32 = function (a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    };
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
     need the idiotic second function, generated by an if clause.  */
    MD5.prototype.add32Std = function (a, b) {
        return (a + b) & 0xffffffff;
    };
    MD5.prototype.add32Compat = function (x, y) {
        var lsw = (x & 0xffff) + (y & 0xffff),
            msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return (msw << 16) | (lsw & 0xffff);
    };
    return MD5;
})();

var __read$1r =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
// move to general utils
function missingOrEmpty(value) {
    return value == null || value.length === 0;
}
function exists(value, allowEmptyString) {
    if (allowEmptyString === void 0) {
        allowEmptyString = false;
    }
    return value != null && (value !== '' || allowEmptyString);
}
var LicenseManager = /** @class */ (function () {
    function LicenseManager(document) {
        this.watermarkMessage = undefined;
        this.document = document;
        this.md5 = new MD5();
        this.md5.init();
    }
    LicenseManager.prototype.validateLicense = function () {
        if (missingOrEmpty(LicenseManager.licenseKey)) {
            if (!this.isWebsiteUrl() || this.isForceWatermark()) {
                this.outputMissingLicenseKey();
            }
        } else if (LicenseManager.licenseKey.length > 32) {
            if (LicenseManager.licenseKey.indexOf('For_Trialing_ag-Grid_Only') !== -1) {
                this.outputInvalidLicenseKey();
            } else {
                var _a = LicenseManager.extractLicenseComponents(LicenseManager.licenseKey),
                    md5 = _a.md5,
                    license = _a.license,
                    version = _a.version,
                    isTrial = _a.isTrial;
                if (md5 === this.md5.md5(license)) {
                    if (exists(version) && version) {
                        this.validateLicenseKeyForVersion(version, !!isTrial, license);
                    } else {
                        this.validateLegacyKey(license);
                    }
                } else {
                    this.outputInvalidLicenseKey();
                }
            }
        } else {
            this.outputInvalidLicenseKey();
        }
    };
    LicenseManager.extractExpiry = function (license) {
        var restrictionHashed = license.substring(license.lastIndexOf('_') + 1, license.length);
        return new Date(parseInt(LicenseManager.decode(restrictionHashed), 10));
    };
    LicenseManager.extractLicenseComponents = function (licenseKey) {
        // when users copy the license key from a PDF extra zero width characters are sometimes copied too
        // carriage returns and line feeds are problematic too
        // all of which causes license key validation to fail - strip these out
        var cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, '');
        cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, '');
        var hashStart = cleanedLicenseKey.length - 32;
        var md5 = cleanedLicenseKey.substring(hashStart);
        var license = cleanedLicenseKey.substring(0, hashStart);
        var _a = __read$1r(LicenseManager.extractBracketedInformation(cleanedLicenseKey), 2),
            version = _a[0],
            isTrial = _a[1];
        return { md5: md5, license: license, version: version, isTrial: isTrial };
    };
    LicenseManager.prototype.getLicenseDetails = function (licenseKey) {
        var _a = LicenseManager.extractLicenseComponents(licenseKey),
            md5 = _a.md5,
            license = _a.license,
            version = _a.version,
            isTrial = _a.isTrial;
        var valid = md5 === this.md5.md5(license) && licenseKey.indexOf('For_Trialing_ag-Grid_Only') === -1;
        var trialExpired = null;
        var expiry = null;
        if (valid) {
            expiry = LicenseManager.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
            if (isTrial) {
                var now = new Date();
                trialExpired = expiry < now;
            }
        }
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: valid ? LicenseManager.formatDate(expiry) : null,
            version: version ? version : 'legacy',
            isTrial: isTrial,
            trialExpired: trialExpired,
        };
    };
    LicenseManager.prototype.isDisplayWatermark = function () {
        return (
            this.isForceWatermark() ||
            (!this.isLocalhost() && !this.isWebsiteUrl() && !missingOrEmpty(this.watermarkMessage))
        );
    };
    LicenseManager.prototype.getWatermarkMessage = function () {
        return this.watermarkMessage || '';
    };
    LicenseManager.prototype.getHostname = function () {
        var win = this.document.defaultView || window;
        var loc = win.location;
        var _a = loc.hostname,
            hostname = _a === void 0 ? '' : _a;
        return hostname;
    };
    LicenseManager.prototype.isForceWatermark = function () {
        var win = this.document.defaultView || window;
        var loc = win.location;
        var pathname = loc.pathname;
        return pathname ? pathname.indexOf('forceWatermark') !== -1 : false;
    };
    LicenseManager.prototype.isWebsiteUrl = function () {
        var hostname = this.getHostname();
        return hostname.match(/^((?:\w+\.)?ag-grid\.com)$/) !== null;
    };
    LicenseManager.prototype.isLocalhost = function () {
        var hostname = this.getHostname();
        return hostname.match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
    };
    LicenseManager.formatDate = function (date) {
        var monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        var day = date.getDate();
        var monthIndex = date.getMonth();
        var year = date.getFullYear();
        return day + ' ' + monthNames[monthIndex] + ' ' + year;
    };
    LicenseManager.getGridReleaseDate = function () {
        return new Date(parseInt(LicenseManager.decode(LicenseManager.RELEASE_INFORMATION), 10));
    };
    LicenseManager.decode = function (input) {
        var keystr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
        var t = '';
        var n, r, i;
        var s, o, u, a;
        var f = 0;
        var e = input.replace(/[^A-Za-z0-9+/=]/g, '');
        while (f < e.length) {
            s = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = (s << 2) | (o >> 4);
            r = ((o & 15) << 4) | (u >> 2);
            i = ((u & 3) << 6) | a;
            t = t + String.fromCharCode(n);
            if (u != 64) {
                t = t + String.fromCharCode(r);
            }
            if (a != 64) {
                t = t + String.fromCharCode(i);
            }
        }
        t = LicenseManager.utf8_decode(t);
        return t;
    };
    LicenseManager.utf8_decode = function (input) {
        input = input.replace(/rn/g, 'n');
        var t = '';
        for (var n = 0; n < input.length; n++) {
            var r = input.charCodeAt(n);
            if (r < 128) {
                t += String.fromCharCode(r);
            } else if (r > 127 && r < 2048) {
                t += String.fromCharCode((r >> 6) | 192);
                t += String.fromCharCode((r & 63) | 128);
            } else {
                t += String.fromCharCode((r >> 12) | 224);
                t += String.fromCharCode(((r >> 6) & 63) | 128);
                t += String.fromCharCode((r & 63) | 128);
            }
        }
        return t;
    };
    LicenseManager.setLicenseKey = function (licenseKey) {
        this.licenseKey = licenseKey;
    };
    LicenseManager.extractBracketedInformation = function (licenseKey) {
        var matches = licenseKey
            .split('[')
            .filter(function (v) {
                return v.indexOf(']') > -1;
            })
            .map(function (value) {
                return value.split(']')[0];
            });
        if (!matches || matches.length === 0) {
            return [null, null];
        }
        var isTrial =
            matches.filter(function (match) {
                return match === 'TRIAL';
            }).length === 1;
        var version = matches
            .filter(function (match) {
                return match.indexOf('v') === 0;
            })
            .map(function (match) {
                return match.replace(/^v/, '');
            })[0];
        return [version, isTrial];
    };
    LicenseManager.prototype.validateLicenseKeyForVersion = function (version, isTrial, license) {
        if (version !== '2') {
            return;
        }
        if (isTrial) {
            this.validateForTrial(license);
        } else {
            this.validateLegacyKey(license);
        }
    };
    LicenseManager.prototype.validateLegacyKey = function (license) {
        var gridReleaseDate = LicenseManager.getGridReleaseDate();
        var expiry = LicenseManager.extractExpiry(license);
        var valid = false;
        var current = false;
        if (!isNaN(expiry.getTime())) {
            valid = true;
            current = gridReleaseDate < expiry;
        }
        if (!valid) {
            this.outputInvalidLicenseKey();
        } else if (!current) {
            var formattedExpiryDate = LicenseManager.formatDate(expiry);
            var formattedReleaseDate = LicenseManager.formatDate(gridReleaseDate);
            this.outputIncompatibleVersion(formattedExpiryDate, formattedReleaseDate);
        }
    };
    LicenseManager.prototype.validateForTrial = function (license) {
        var expiry = LicenseManager.extractExpiry(license);
        var now = new Date();
        var valid = false;
        var current = false;
        if (!isNaN(expiry.getTime())) {
            valid = true;
            current = expiry > now;
        }
        if (!valid) {
            this.outputInvalidLicenseKey();
        } else if (!current) {
            var formattedExpiryDate = LicenseManager.formatDate(expiry);
            this.outputExpiredTrialKey(formattedExpiryDate);
        }
    };
    LicenseManager.prototype.outputInvalidLicenseKey = function () {
        console.error(
            '*****************************************************************************************************************',
        );
        console.error(
            '***************************************** AG Grid Enterprise License ********************************************',
        );
        console.error(
            '********************************************* Invalid License ***************************************************',
        );
        console.error(
            '* Your license for AG Grid Enterprise is not valid - please contact info@ag-grid.com to obtain a valid license. *',
        );
        console.error(
            '*****************************************************************************************************************',
        );
        console.error(
            '*****************************************************************************************************************',
        );
        this.watermarkMessage = 'Invalid License';
    };
    LicenseManager.prototype.outputExpiredTrialKey = function (formattedExpiryDate) {
        console.error(
            '****************************************************************************************************************',
        );
        console.error(
            '***************************************** AG Grid Enterprise License *******************************************',
        );
        console.error(
            '*****************************************   Trial Period Expired.    *******************************************',
        );
        console.error(
            '* Your license for AG Grid Enterprise expired on ' +
                formattedExpiryDate +
                '.                                                *',
        );
        console.error(
            '* Please email info@ag-grid.com to purchase a license.                                                         *',
        );
        console.error(
            '****************************************************************************************************************',
        );
        console.error(
            '****************************************************************************************************************',
        );
        this.watermarkMessage = 'Trial Period Expired';
    };
    LicenseManager.prototype.outputMissingLicenseKey = function () {
        // console.error('****************************************************************************************************************');
        // console.error('***************************************** AG Grid Enterprise License *******************************************');
        // console.error('****************************************** License Key Not Found ***********************************************');
        // console.error('* All AG Grid Enterprise features are unlocked.                                                                *');
        // console.error('* This is an evaluation only version, it is not licensed for development projects intended for production.     *');
        // console.error('* If you want to hide the watermark, please email info@ag-grid.com for a trial license.                        *');
        // console.error('****************************************************************************************************************');
        // console.error('****************************************************************************************************************');
        // this.watermarkMessage = "For Trial Use Only";
    };
    LicenseManager.prototype.outputIncompatibleVersion = function (formattedExpiryDate, formattedReleaseDate) {
        console.error(
            '****************************************************************************************************************************',
        );
        console.error(
            '****************************************************************************************************************************',
        );
        console.error(
            '*                                             AG Grid Enterprise License                                                   *',
        );
        console.error(
            '*                           License not compatible with installed version of AG Grid Enterprise.                           *',
        );
        console.error(
            '*                                                                                                                          *',
        );
        console.error(
            '* Your AG Grid License entitles you to all versions of AG Grid that we release within the time covered by your license     *',
        );
        console.error(
            '* - typically we provide one year licenses which entitles you to all releases / updates of AG Grid within that year.       *',
        );
        console.error(
            '* Your license has an end (expiry) date which stops the license key working with versions of AG Grid released after the    *',
        );
        console.error(
            '* license end date. The license key that you have expires on ' +
                formattedExpiryDate +
                ', however the version of AG Grid you    *',
        );
        console.error(
            '* are trying to use was released on ' +
                formattedReleaseDate +
                '.                                                               *',
        );
        console.error(
            '*                                                                                                                          *',
        );
        console.error(
            '* Please contact info@ag-grid.com to renew your subscription to new versions and get a new license key to work with this   *',
        );
        console.error(
            '* version of AG Grid.                                                                                                      *',
        );
        console.error(
            '****************************************************************************************************************************',
        );
        console.error(
            '****************************************************************************************************************************',
        );
        this.watermarkMessage = 'License Expired';
    };
    LicenseManager.RELEASE_INFORMATION = 'MTY5NTU0ODUwMjk2NQ==';
    return LicenseManager;
})();

var __extends$3F =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2N =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var GridLicenseManager = /** @class */ (function (_super) {
    __extends$3F(GridLicenseManager, _super);
    function GridLicenseManager() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    GridLicenseManager.prototype.validateLicense = function () {
        this.licenseManager = new LicenseManager(this.gridOptionsService.getDocument());
        this.licenseManager.validateLicense();
    };
    GridLicenseManager.getLicenseDetails = function (licenseKey) {
        return new LicenseManager(null).getLicenseDetails(licenseKey);
    };
    GridLicenseManager.prototype.isDisplayWatermark = function () {
        return this.licenseManager.isDisplayWatermark();
    };
    GridLicenseManager.prototype.getWatermarkMessage = function () {
        return this.licenseManager.getWatermarkMessage();
    };
    GridLicenseManager.setLicenseKey = function (licenseKey) {
        LicenseManager.setLicenseKey(licenseKey);
    };
    __decorate$2N([PreConstruct], GridLicenseManager.prototype, 'validateLicense', null);
    GridLicenseManager = __decorate$2N([Bean('licenseManager')], GridLicenseManager);
    return GridLicenseManager;
})(BeanStub);

var __extends$3E =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2M =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var WatermarkComp = /** @class */ (function (_super) {
    __extends$3E(WatermarkComp, _super);
    function WatermarkComp() {
        return (
            _super.call(
                this,
                /* html*/ '<div class="ag-watermark">\n                <div ref="eLicenseTextRef" class="ag-watermark-text"></div>\n            </div>',
            ) || this
        );
    }
    WatermarkComp.prototype.postConstruct = function () {
        var _this = this;
        var show = this.shouldDisplayWatermark();
        this.setDisplayed(show);
        if (show) {
            this.eLicenseTextRef.innerText = this.licenseManager.getWatermarkMessage();
            window.setTimeout(function () {
                return _this.addCssClass('ag-opacity-zero');
            }, 0);
            window.setTimeout(function () {
                return _this.setDisplayed(false);
            }, 5000);
        }
    };
    WatermarkComp.prototype.shouldDisplayWatermark = function () {
        return this.licenseManager.isDisplayWatermark();
    };
    __decorate$2M([Autowired('licenseManager')], WatermarkComp.prototype, 'licenseManager', void 0);
    __decorate$2M([RefSelector('eLicenseTextRef')], WatermarkComp.prototype, 'eLicenseTextRef', void 0);
    __decorate$2M([PostConstruct], WatermarkComp.prototype, 'postConstruct', null);
    return WatermarkComp;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$j = '30.2.0';

var EnterpriseCoreModule = {
    version: VERSION$j,
    moduleName: ModuleNames.EnterpriseCoreModule,
    beans: [GridLicenseManager],
    agStackComponents: [{ componentName: 'AgWatermark', componentClass: WatermarkComp }],
};

var __extends$3D =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2L =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterHeaderComp = /** @class */ (function (_super) {
    __extends$3D(AdvancedFilterHeaderComp, _super);
    function AdvancedFilterHeaderComp(enabled) {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-header" role="row">\n            </div>',
            ) || this;
        _this.enabled = enabled;
        return _this;
    }
    AdvancedFilterHeaderComp.prototype.postConstruct = function () {
        var _this = this;
        this.setupAdvancedFilter(this.enabled);
        this.addDestroyFunc(function () {
            return _this.destroyBean(_this.eAdvancedFilter);
        });
        this.addManagedListener(this.eventService, Events.EVENT_GRID_COLUMNS_CHANGED, function () {
            return _this.onGridColumnsChanged();
        });
        this.addGuiEventListener('keydown', function (event) {
            return _this.onKeyDown(event);
        });
        this.addGuiEventListener('focusout', function (event) {
            if (!_this.getFocusableElement().contains(event.relatedTarget)) {
                _this.focusService.clearAdvancedFilterColumn();
            }
        });
    };
    AdvancedFilterHeaderComp.prototype.getFocusableElement = function () {
        var _a, _b;
        return (_b = (_a = this.eAdvancedFilter) === null || _a === void 0 ? void 0 : _a.getGui()) !== null &&
            _b !== void 0
            ? _b
            : this.getGui();
    };
    AdvancedFilterHeaderComp.prototype.setEnabled = function (enabled) {
        if (enabled === this.enabled) {
            return;
        }
        this.setupAdvancedFilter(enabled);
    };
    AdvancedFilterHeaderComp.prototype.refresh = function () {
        var _a;
        (_a = this.eAdvancedFilter) === null || _a === void 0 ? void 0 : _a.refresh();
    };
    AdvancedFilterHeaderComp.prototype.getHeight = function () {
        return this.height;
    };
    AdvancedFilterHeaderComp.prototype.setInputDisabled = function (disabled) {
        var _a;
        (_a = this.eAdvancedFilter) === null || _a === void 0 ? void 0 : _a.setInputDisabled(disabled);
    };
    AdvancedFilterHeaderComp.prototype.setupAdvancedFilter = function (enabled) {
        var eGui = this.getGui();
        if (enabled) {
            // unmanaged as can be recreated
            this.eAdvancedFilter = this.createBean(new AdvancedFilterComp());
            var eAdvancedFilterGui = this.eAdvancedFilter.getGui();
            this.eAdvancedFilter.addCssClass('ag-advanced-filter-header-cell');
            this.height = this.columnModel.getFloatingFiltersHeight();
            var height = this.height + 'px';
            eGui.style.height = height;
            eGui.style.minHeight = height;
            this.setAriaRowIndex();
            _.setAriaRole(eAdvancedFilterGui, 'gridcell');
            _.setAriaColIndex(eAdvancedFilterGui, 1);
            this.setAriaColumnCount(eAdvancedFilterGui);
            eGui.appendChild(eAdvancedFilterGui);
        } else {
            _.clearElement(eGui);
            this.destroyBean(this.eAdvancedFilter);
            this.height = 0;
        }
        _.setDisplayed(eGui, enabled);
        this.enabled = enabled;
    };
    AdvancedFilterHeaderComp.prototype.setAriaColumnCount = function (eAdvancedFilterGui) {
        var _a, _b;
        _.setAriaColSpan(
            eAdvancedFilterGui,
            (_b = (_a = this.columnModel.getAllGridColumns()) === null || _a === void 0 ? void 0 : _a.length) !==
                null && _b !== void 0
                ? _b
                : 0,
        );
    };
    AdvancedFilterHeaderComp.prototype.setAriaRowIndex = function () {
        _.setAriaRowIndex(this.getGui(), this.headerNavigationService.getHeaderRowCount());
    };
    AdvancedFilterHeaderComp.prototype.onGridColumnsChanged = function () {
        if (!this.eAdvancedFilter) {
            return;
        }
        this.setAriaColumnCount(this.eAdvancedFilter.getGui());
        this.setAriaRowIndex();
    };
    AdvancedFilterHeaderComp.prototype.onKeyDown = function (event) {
        switch (event.key) {
            case KeyCode.ENTER: {
                if (this.hasFocus()) {
                    if (this.focusService.focusInto(this.getFocusableElement())) {
                        event.preventDefault();
                    }
                }
                break;
            }
            case KeyCode.ESCAPE:
                if (!this.hasFocus()) {
                    this.getFocusableElement().focus();
                }
                break;
            case KeyCode.UP:
                this.navigateUpDown(true, event);
                break;
            case KeyCode.DOWN:
                this.navigateUpDown(false, event);
                break;
            case KeyCode.TAB:
                if (this.hasFocus()) {
                    this.navigateLeftRight(event);
                } else {
                    var nextFocusableEl = this.focusService.findNextFocusableElement(
                        this.getFocusableElement(),
                        null,
                        event.shiftKey,
                    );
                    if (nextFocusableEl) {
                        event.preventDefault();
                        nextFocusableEl.focus();
                    } else {
                        this.navigateLeftRight(event);
                    }
                }
                break;
        }
    };
    AdvancedFilterHeaderComp.prototype.navigateUpDown = function (backwards, event) {
        if (this.hasFocus()) {
            if (this.focusService.focusNextFromAdvancedFilter(backwards)) {
                event.preventDefault();
            }
        }
    };
    AdvancedFilterHeaderComp.prototype.navigateLeftRight = function (event) {
        if (
            event.shiftKey
                ? this.focusService.focusLastHeader()
                : this.focusService.focusNextFromAdvancedFilter(false, true)
        ) {
            event.preventDefault();
        }
    };
    AdvancedFilterHeaderComp.prototype.hasFocus = function () {
        var eDocument = this.gridOptionsService.getDocument();
        return eDocument.activeElement === this.getFocusableElement();
    };
    __decorate$2L([Autowired('columnModel')], AdvancedFilterHeaderComp.prototype, 'columnModel', void 0);
    __decorate$2L([Autowired('focusService')], AdvancedFilterHeaderComp.prototype, 'focusService', void 0);
    __decorate$2L(
        [Autowired('headerNavigationService')],
        AdvancedFilterHeaderComp.prototype,
        'headerNavigationService',
        void 0,
    );
    __decorate$2L([PostConstruct], AdvancedFilterHeaderComp.prototype, 'postConstruct', null);
    return AdvancedFilterHeaderComp;
})(Component);

var __extends$3C =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$13 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$13 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$13.apply(this, arguments);
    };
var AddDropdownComp = /** @class */ (function (_super) {
    __extends$3C(AddDropdownComp, _super);
    function AddDropdownComp(params) {
        var _this =
            _super.call(
                this,
                __assign$13(__assign$13({}, params), {
                    template:
                        /* html */ '\n                <div class="ag-picker-field" role="presentation">\n                    <div ref="eLabel"></div>\n                    <div ref="eWrapper" class="ag-wrapper ag-picker-collapsed">\n                        <div ref="eDisplayField" class="ag-picker-field-display"></div>\n                        <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>\n                        <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>\n                    </div>\n                </div>',
                }),
            ) || this;
        _this.params = params;
        return _this;
    }
    AddDropdownComp.prototype.showPicker = function () {
        var _this = this;
        // avoid focus handling issues with multiple rich selects
        setTimeout(function () {
            return _super.prototype.showPicker.call(_this);
        });
    };
    AddDropdownComp.prototype.hidePicker = function () {
        var _this = this;
        // avoid focus handling issues with multiple rich selects
        setTimeout(function () {
            return _super.prototype.hidePicker.call(_this);
        });
    };
    AddDropdownComp.prototype.postConstruct = function () {
        _super.prototype.postConstruct.call(this);
        var _a = this.params,
            wrapperClassName = _a.wrapperClassName,
            ariaLabel = _a.ariaLabel;
        _.setDisplayed(this.eDisplayField, false);
        if (wrapperClassName) {
            this.eWrapper.classList.add(wrapperClassName);
        }
        _.setAriaLabelledBy(this.eWrapper, '');
        _.setAriaLabel(this.eWrapper, ariaLabel);
    };
    AddDropdownComp.prototype.onEnterKeyDown = function (event) {
        _.stopPropagationForAgGrid(event);
        if (this.isPickerDisplayed) {
            _super.prototype.onEnterKeyDown.call(this, event);
        } else {
            event.preventDefault();
            this.showPicker();
        }
    };
    return AddDropdownComp;
})(AgRichSelect);

var __extends$3B =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2K =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterBuilderDragFeature = /** @class */ (function (_super) {
    __extends$3B(AdvancedFilterBuilderDragFeature, _super);
    function AdvancedFilterBuilderDragFeature(comp, virtualList) {
        var _this = _super.call(this) || this;
        _this.comp = comp;
        _this.virtualList = virtualList;
        return _this;
    }
    AdvancedFilterBuilderDragFeature.prototype.postConstruct = function () {
        var _this = this;
        this.createManagedBean(
            new VirtualListDragFeature(this.comp, this.virtualList, {
                dragSourceType: DragSourceType.AdvancedFilterBuilder,
                listItemDragStartEvent: AdvancedFilterBuilderDragFeature.EVENT_DRAG_STARTED,
                listItemDragEndEvent: AdvancedFilterBuilderDragFeature.EVENT_DRAG_ENDED,
                eventSource: this,
                getCurrentDragValue: function (listItemDragStartEvent) {
                    return _this.getCurrentDragValue(listItemDragStartEvent);
                },
                isMoveBlocked: function () {
                    return false;
                },
                getNumRows: function (comp) {
                    return comp.getNumItems();
                },
                moveItem: function (currentDragValue, lastHoveredListItem) {
                    return _this.moveItem(currentDragValue, lastHoveredListItem);
                },
            }),
        );
    };
    AdvancedFilterBuilderDragFeature.prototype.getCurrentDragValue = function (listItemDragStartEvent) {
        return listItemDragStartEvent.item;
    };
    AdvancedFilterBuilderDragFeature.prototype.moveItem = function (currentDragValue, lastHoveredListItem) {
        this.comp.moveItem(currentDragValue, lastHoveredListItem);
    };
    AdvancedFilterBuilderDragFeature.EVENT_DRAG_STARTED = 'advancedFilterBuilderDragStarted';
    AdvancedFilterBuilderDragFeature.EVENT_DRAG_ENDED = 'advancedFilterBuilderDragEnded';
    __decorate$2K([PostConstruct], AdvancedFilterBuilderDragFeature.prototype, 'postConstruct', null);
    return AdvancedFilterBuilderDragFeature;
})(BeanStub);

var __extends$3A =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2J =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterBuilderItemNavigationFeature = /** @class */ (function (_super) {
    __extends$3A(AdvancedFilterBuilderItemNavigationFeature, _super);
    function AdvancedFilterBuilderItemNavigationFeature(eGui, focusWrapper, eFocusableComp) {
        var _this = _super.call(this) || this;
        _this.eGui = eGui;
        _this.focusWrapper = focusWrapper;
        _this.eFocusableComp = eFocusableComp;
        return _this;
    }
    AdvancedFilterBuilderItemNavigationFeature.prototype.postConstruct = function () {
        var _this = this;
        this.addManagedListener(this.eGui, 'keydown', function (event) {
            switch (event.key) {
                case KeyCode.TAB:
                    if (!event.defaultPrevented) {
                        // tab guard handled the navigation. stop from reaching virtual list
                        _.stopPropagationForAgGrid(event);
                    }
                    break;
                case KeyCode.UP:
                case KeyCode.DOWN:
                    // if this hasn't been handled by an editor, prevent virtual list navigation
                    _.stopPropagationForAgGrid(event);
                    break;
                case KeyCode.ESCAPE:
                    if (_.isStopPropagationForAgGrid(event)) {
                        return;
                    }
                    var eDocument = _this.gridOptionsService.getDocument();
                    if (_this.eGui.contains(eDocument.activeElement)) {
                        event.preventDefault();
                        _.stopPropagationForAgGrid(event);
                        _this.focusWrapper.focus();
                    }
                    break;
            }
        });
        this.addManagedListener(this.focusWrapper, 'keydown', function (event) {
            switch (event.key) {
                case KeyCode.ENTER:
                    if (_.isStopPropagationForAgGrid(event)) {
                        return;
                    }
                    var eDocument = _this.gridOptionsService.getDocument();
                    if (eDocument.activeElement === _this.focusWrapper) {
                        event.preventDefault();
                        _.stopPropagationForAgGrid(event);
                        _this.eFocusableComp.getFocusableElement().focus();
                    }
                    break;
            }
        });
        this.addManagedListener(this.focusWrapper, 'focusin', function () {
            _this.focusWrapper.classList.add('ag-advanced-filter-builder-virtual-list-item-highlight');
        });
        this.addManagedListener(this.focusWrapper, 'focusout', function (event) {
            if (!_this.focusWrapper.contains(event.relatedTarget)) {
                _this.focusWrapper.classList.remove('ag-advanced-filter-builder-virtual-list-item-highlight');
            }
        });
    };
    __decorate$2J([PostConstruct], AdvancedFilterBuilderItemNavigationFeature.prototype, 'postConstruct', null);
    return AdvancedFilterBuilderItemNavigationFeature;
})(BeanStub);

function getAdvancedFilterBuilderAddButtonParams(translate, maxPickerWidth) {
    return {
        pickerAriaLabelKey: 'ariaLabelAdvancedFilterBuilderAddField',
        pickerAriaLabelValue: 'Advanced Filter Builder Add Field',
        pickerType: 'ag-list',
        valueList: [
            {
                key: 'condition',
                displayValue: translate('advancedFilterBuilderAddCondition'),
            },
            {
                key: 'join',
                displayValue: translate('advancedFilterBuilderAddJoin'),
            },
        ],
        valueFormatter: function (value) {
            var _a;
            return value == null ? null : (_a = value.displayValue) !== null && _a !== void 0 ? _a : value.key;
        },
        pickerIcon: 'advancedFilterBuilderAdd',
        maxPickerWidth: (maxPickerWidth !== null && maxPickerWidth !== void 0 ? maxPickerWidth : 120) + 'px',
        wrapperClassName: 'ag-advanced-filter-builder-item-button',
        ariaLabel: translate('advancedFilterBuilderAddButtonTooltip'),
    };
}

var AdvancedFilterBuilderEvents = /** @class */ (function () {
    function AdvancedFilterBuilderEvents() {}
    AdvancedFilterBuilderEvents.EVENT_ADDED = 'advancedFilterBuilderAdded';
    AdvancedFilterBuilderEvents.EVENT_MOVED = 'advancedFilterBuilderMoved';
    AdvancedFilterBuilderEvents.EVENT_REMOVED = 'advancedFilterBuilderRemoved';
    AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED = 'advancedFilterBuilderValueChanged';
    AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED = 'advancedFilterBuilderValidChanged';
    return AdvancedFilterBuilderEvents;
})();

var __extends$3z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2I =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ConditionPillWrapperComp = /** @class */ (function (_super) {
    __extends$3z(ConditionPillWrapperComp, _super);
    function ConditionPillWrapperComp() {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>\n        ',
            ) || this;
        _this.validationMessage = null;
        return _this;
    }
    ConditionPillWrapperComp.prototype.init = function (params) {
        var _this = this;
        var item = params.item,
            createPill = params.createPill;
        this.item = item;
        this.createPill = createPill;
        this.filterModel = item.filterModel;
        this.setupColumnCondition(this.filterModel);
        this.validate();
        this.addDestroyFunc(function () {
            return _this.destroyBeans([_this.eColumnPill, _this.eOperatorPill, _this.eOperandPill]);
        });
    };
    ConditionPillWrapperComp.prototype.getDragName = function () {
        return this.filterModel.colId
            ? this.advancedFilterExpressionService.parseColumnFilterModel(this.filterModel)
            : this.getDefaultColumnDisplayValue();
    };
    ConditionPillWrapperComp.prototype.getAriaLabel = function () {
        return (
            this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderFilterItem') +
            ' ' +
            this.getDragName()
        );
    };
    ConditionPillWrapperComp.prototype.getValidationMessage = function () {
        return this.validationMessage;
    };
    ConditionPillWrapperComp.prototype.getFocusableElement = function () {
        return this.eColumnPill.getFocusableElement();
    };
    ConditionPillWrapperComp.prototype.setupColumnCondition = function (filterModel) {
        var _this = this;
        var _a, _b;
        var columnDetails = this.advancedFilterExpressionService.getColumnDetails(filterModel.colId);
        this.baseCellDataType =
            (_a = columnDetails === null || columnDetails === void 0 ? void 0 : columnDetails.baseCellDataType) !==
                null && _a !== void 0
                ? _a
                : 'text';
        this.column = columnDetails === null || columnDetails === void 0 ? void 0 : columnDetails.column;
        this.numOperands = this.getNumOperands(this.getOperatorKey());
        this.eColumnPill = this.createPill({
            key: this.getColumnKey(),
            displayValue:
                (_b = this.getColumnDisplayValue()) !== null && _b !== void 0
                    ? _b
                    : this.getDefaultColumnDisplayValue(),
            cssClass: 'ag-advanced-filter-builder-column-pill',
            isSelect: true,
            getEditorParams: function () {
                return { values: _this.advancedFilterExpressionService.getColumnAutocompleteEntries() };
            },
            update: function (key) {
                return _this.setColumnKey(key);
            },
            pickerAriaLabelKey: 'ariaLabelAdvancedFilterBuilderColumnSelectField',
            pickerAriaLabelValue: 'Advanced Filter Builder Column Select Field',
            ariaLabel: this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderColumn'),
        });
        this.getGui().appendChild(this.eColumnPill.getGui());
        if (_.exists(this.getColumnKey())) {
            this.createOperatorPill();
            if (this.hasOperand()) {
                this.createOperandPill();
            }
        }
    };
    ConditionPillWrapperComp.prototype.createOperatorPill = function () {
        var _this = this;
        var _a;
        this.eOperatorPill = this.createPill({
            key: this.getOperatorKey(),
            displayValue:
                (_a = this.getOperatorDisplayValue()) !== null && _a !== void 0
                    ? _a
                    : this.getDefaultOptionSelectValue(),
            cssClass: 'ag-advanced-filter-builder-option-pill',
            isSelect: true,
            getEditorParams: function () {
                return { values: _this.getOperatorAutocompleteEntries() };
            },
            update: function (key) {
                return _this.setOperatorKey(key);
            },
            pickerAriaLabelKey: 'ariaLabelAdvancedFilterBuilderOptionSelectField',
            pickerAriaLabelValue: 'Advanced Filter Builder Option Select Field',
            ariaLabel: this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderOption'),
        });
        this.eColumnPill.getGui().insertAdjacentElement('afterend', this.eOperatorPill.getGui());
    };
    ConditionPillWrapperComp.prototype.createOperandPill = function () {
        var _this = this;
        var _a;
        var key = (_a = this.getOperandDisplayValue()) !== null && _a !== void 0 ? _a : '';
        this.eOperandPill = this.createPill({
            key: key,
            displayValue: key,
            baseCellDataType: this.baseCellDataType,
            cssClass: 'ag-advanced-filter-builder-value-pill',
            isSelect: false,
            update: function (key) {
                return _this.setOperand(key);
            },
            ariaLabel: this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderValue'),
        });
        this.getGui().appendChild(this.eOperandPill.getGui());
    };
    ConditionPillWrapperComp.prototype.getColumnKey = function () {
        return this.filterModel.colId;
    };
    ConditionPillWrapperComp.prototype.getColumnDisplayValue = function () {
        return this.advancedFilterExpressionService.getColumnDisplayValue(this.filterModel);
    };
    ConditionPillWrapperComp.prototype.getOperatorKey = function () {
        return this.filterModel.type;
    };
    ConditionPillWrapperComp.prototype.getOperatorDisplayValue = function () {
        return this.advancedFilterExpressionService.getOperatorDisplayValue(this.filterModel);
    };
    ConditionPillWrapperComp.prototype.getOperandDisplayValue = function () {
        return this.advancedFilterExpressionService.getOperandDisplayValue(this.filterModel, true);
    };
    ConditionPillWrapperComp.prototype.hasOperand = function () {
        return this.numOperands > 0;
    };
    ConditionPillWrapperComp.prototype.getOperatorAutocompleteEntries = function () {
        return this.column
            ? this.advancedFilterExpressionService.getOperatorAutocompleteEntries(this.column, this.baseCellDataType)
            : [];
    };
    ConditionPillWrapperComp.prototype.setColumnKey = function (colId) {
        var _a;
        if (!this.eOperatorPill) {
            this.createOperatorPill();
        }
        var newColumnDetails = this.advancedFilterExpressionService.getColumnDetails(colId);
        this.column = newColumnDetails === null || newColumnDetails === void 0 ? void 0 : newColumnDetails.column;
        var newBaseCellDataType =
            (_a =
                newColumnDetails === null || newColumnDetails === void 0
                    ? void 0
                    : newColumnDetails.baseCellDataType) !== null && _a !== void 0
                ? _a
                : 'text';
        if (this.baseCellDataType !== newBaseCellDataType) {
            this.baseCellDataType = newBaseCellDataType;
            this.setOperatorKey(undefined);
            if (this.eOperatorPill) {
                _.removeFromParent(this.eOperatorPill.getGui());
                this.destroyBean(this.eOperatorPill);
                this.createOperatorPill();
            }
            this.validate();
        }
        this.filterModel.colId = colId;
        this.filterModel.filterType = this.baseCellDataType;
    };
    ConditionPillWrapperComp.prototype.setOperatorKey = function (operator) {
        var newNumOperands = this.getNumOperands(operator);
        if (newNumOperands !== this.numOperands) {
            this.numOperands = newNumOperands;
            if (newNumOperands === 0) {
                this.destroyOperandPill();
            } else {
                this.createOperandPill();
                if (this.baseCellDataType !== 'number') {
                    this.setOperand('');
                }
            }
        }
        this.filterModel.type = operator;
        this.validate();
    };
    ConditionPillWrapperComp.prototype.setOperand = function (operand) {
        var _a;
        var parsedOperand = operand;
        if (this.column) {
            parsedOperand =
                (_a = this.advancedFilterExpressionService.getOperandModelValue(
                    operand,
                    this.baseCellDataType,
                    this.column,
                )) !== null && _a !== void 0
                    ? _a
                    : '';
        }
        this.filterModel.filter = parsedOperand;
        this.validate();
    };
    ConditionPillWrapperComp.prototype.getNumOperands = function (operator) {
        var _a, _b;
        return (_b =
            (_a = this.advancedFilterExpressionService.getExpressionOperator(this.baseCellDataType, operator)) ===
                null || _a === void 0
                ? void 0
                : _a.numOperands) !== null && _b !== void 0
            ? _b
            : 0;
    };
    ConditionPillWrapperComp.prototype.destroyOperandPill = function () {
        delete this.filterModel.filter;
        this.getGui().removeChild(this.eOperandPill.getGui());
        this.destroyBean(this.eOperandPill);
        this.eOperandPill = undefined;
    };
    ConditionPillWrapperComp.prototype.validate = function () {
        var validationMessage = null;
        if (!_.exists(this.getColumnKey())) {
            validationMessage = this.advancedFilterExpressionService.translate(
                'advancedFilterBuilderValidationSelectColumn',
            );
        } else if (!_.exists(this.getOperatorKey())) {
            validationMessage = this.advancedFilterExpressionService.translate(
                'advancedFilterBuilderValidationSelectOption',
            );
        } else if (this.numOperands > 0 && !_.exists(this.getOperandDisplayValue())) {
            validationMessage = this.advancedFilterExpressionService.translate(
                'advancedFilterBuilderValidationEnterValue',
            );
        }
        this.item.valid = !validationMessage;
        if (validationMessage !== this.validationMessage) {
            this.validationMessage = validationMessage;
            this.dispatchEvent({
                type: AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED,
            });
        }
    };
    ConditionPillWrapperComp.prototype.getDefaultColumnDisplayValue = function () {
        return this.advancedFilterExpressionService.translate('advancedFilterBuilderSelectColumn');
    };
    ConditionPillWrapperComp.prototype.getDefaultOptionSelectValue = function () {
        return this.advancedFilterExpressionService.translate('advancedFilterBuilderSelectOption');
    };
    __decorate$2I(
        [Autowired('advancedFilterExpressionService')],
        ConditionPillWrapperComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2I([Autowired('valueParserService')], ConditionPillWrapperComp.prototype, 'valueParserService', void 0);
    return ConditionPillWrapperComp;
})(Component);

var __extends$3y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2H =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var InputPillComp = /** @class */ (function (_super) {
    __extends$3y(InputPillComp, _super);
    function InputPillComp(params) {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-builder-pill-wrapper" role="presentation">\n                <div ref="ePill" class="ag-advanced-filter-builder-pill" role="button">\n                    <span ref="eLabel" class="ag-advanced-filter-builder-pill-display"></span>\n                </div>\n            </div>\n        ',
            ) || this;
        _this.params = params;
        _this.value = params.value;
        return _this;
    }
    InputPillComp.prototype.postConstruct = function () {
        var _this = this;
        var _a = this.params,
            cssClass = _a.cssClass,
            ariaLabel = _a.ariaLabel;
        this.ePill.classList.add(cssClass);
        this.activateTabIndex([this.ePill]);
        this.eLabel.id = '' + this.getCompId();
        _.setAriaDescribedBy(this.ePill, this.eLabel.id);
        _.setAriaLabel(this.ePill, ariaLabel);
        this.renderValue();
        this.addManagedListener(this.ePill, 'click', function (event) {
            event.preventDefault();
            _this.showEditor();
        });
        this.addManagedListener(this.ePill, 'keydown', function (event) {
            switch (event.key) {
                case KeyCode.ENTER:
                    event.preventDefault();
                    _.stopPropagationForAgGrid(event);
                    _this.showEditor();
                    break;
            }
        });
        this.addDestroyFunc(function () {
            return _this.destroyBean(_this.eEditor);
        });
    };
    InputPillComp.prototype.getFocusableElement = function () {
        return this.ePill;
    };
    InputPillComp.prototype.showEditor = function () {
        var _this = this;
        if (this.eEditor) {
            return;
        }
        _.setDisplayed(this.ePill, false);
        this.eEditor = this.createEditorComp(this.params.type);
        this.eEditor.setValue(this.value);
        var eEditorGui = this.eEditor.getGui();
        this.eEditor.addManagedListener(eEditorGui, 'keydown', function (event) {
            switch (event.key) {
                case KeyCode.ENTER:
                    event.preventDefault();
                    _.stopPropagationForAgGrid(event);
                    _this.updateValue(true);
                    break;
                case KeyCode.ESCAPE:
                    event.preventDefault();
                    _.stopPropagationForAgGrid(event);
                    _this.hideEditor(true);
                    break;
            }
        });
        this.eEditor.addManagedListener(eEditorGui, 'focusout', function () {
            _this.updateValue(false);
        });
        this.getGui().appendChild(eEditorGui);
        this.eEditor.getFocusableElement().focus();
    };
    InputPillComp.prototype.createEditorComp = function (type) {
        var comp;
        switch (type) {
            case 'text':
                comp = new AgInputTextField();
                break;
            case 'number':
                comp = new AgInputNumberField();
                break;
            case 'date':
                comp = new AgInputDateField();
                break;
        }
        return this.createBean(comp);
    };
    InputPillComp.prototype.hideEditor = function (keepFocus) {
        var eEditor = this.eEditor;
        if (!eEditor) {
            return;
        }
        this.eEditor = undefined;
        this.getGui().removeChild(eEditor.getGui());
        this.destroyBean(eEditor);
        _.setDisplayed(this.ePill, true);
        if (keepFocus) {
            this.ePill.focus();
        }
    };
    InputPillComp.prototype.renderValue = function () {
        var value;
        this.eLabel.classList.remove(
            'ag-advanced-filter-builder-value-empty',
            'ag-advanced-filter-builder-value-number',
            'ag-advanced-filter-builder-value-text',
        );
        if (!_.exists(this.value)) {
            value = this.advancedFilterExpressionService.translate('advancedFilterBuilderEnterValue');
            this.eLabel.classList.add('ag-advanced-filter-builder-value-empty');
        } else if (this.params.type === 'number') {
            value = this.value;
            this.eLabel.classList.add('ag-advanced-filter-builder-value-number');
        } else {
            value = '"' + this.value + '"';
            this.eLabel.classList.add('ag-advanced-filter-builder-value-text');
        }
        this.eLabel.innerText = value;
    };
    InputPillComp.prototype.updateValue = function (keepFocus) {
        var _a;
        if (!this.eEditor) {
            return;
        }
        var value = (_a = this.eEditor.getValue()) !== null && _a !== void 0 ? _a : '';
        this.dispatchEvent({
            type: Events.EVENT_FIELD_VALUE_CHANGED,
            value: value,
        });
        this.value = value;
        this.renderValue();
        this.hideEditor(keepFocus);
    };
    __decorate$2H([RefSelector('ePill')], InputPillComp.prototype, 'ePill', void 0);
    __decorate$2H([RefSelector('eLabel')], InputPillComp.prototype, 'eLabel', void 0);
    __decorate$2H(
        [Autowired('advancedFilterExpressionService')],
        InputPillComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2H([PostConstruct], InputPillComp.prototype, 'postConstruct', null);
    return InputPillComp;
})(Component);

var __extends$3x =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2G =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var JoinPillWrapperComp = /** @class */ (function (_super) {
    __extends$3x(JoinPillWrapperComp, _super);
    function JoinPillWrapperComp() {
        return (
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>\n        ',
            ) || this
        );
    }
    JoinPillWrapperComp.prototype.init = function (params) {
        var _this = this;
        var item = params.item,
            createPill = params.createPill;
        var filterModel = item.filterModel;
        this.filterModel = filterModel;
        this.ePill = createPill({
            key: filterModel.type,
            displayValue: this.advancedFilterExpressionService.parseJoinOperator(filterModel),
            cssClass: 'ag-advanced-filter-builder-join-pill',
            isSelect: true,
            getEditorParams: function () {
                return { values: _this.advancedFilterExpressionService.getJoinOperatorAutocompleteEntries() };
            },
            update: function (key) {
                return (filterModel.type = key);
            },
            pickerAriaLabelKey: 'ariaLabelAdvancedFilterBuilderJoinSelectField',
            pickerAriaLabelValue: 'Advanced Filter Builder Join Operator Select Field',
            ariaLabel: this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderJoinOperator'),
        });
        this.getGui().appendChild(this.ePill.getGui());
        this.addDestroyFunc(function () {
            return _this.destroyBean(_this.ePill);
        });
    };
    JoinPillWrapperComp.prototype.getDragName = function () {
        return this.advancedFilterExpressionService.parseJoinOperator(this.filterModel);
    };
    JoinPillWrapperComp.prototype.getAriaLabel = function () {
        return (
            this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderGroupItem') +
            ' ' +
            this.getDragName()
        );
    };
    JoinPillWrapperComp.prototype.getValidationMessage = function () {
        return null;
    };
    JoinPillWrapperComp.prototype.getFocusableElement = function () {
        return this.ePill.getFocusableElement();
    };
    __decorate$2G(
        [Autowired('advancedFilterExpressionService')],
        JoinPillWrapperComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    return JoinPillWrapperComp;
})(Component);

var __extends$3w =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$12 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$12 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$12.apply(this, arguments);
    };
var SelectPillComp = /** @class */ (function (_super) {
    __extends$3w(SelectPillComp, _super);
    function SelectPillComp(params) {
        var _this =
            _super.call(
                this,
                __assign$12(__assign$12({}, params), {
                    template:
                        /* html */ '\n                <div class="ag-picker-field ag-advanced-filter-builder-pill-wrapper" role="presentation">\n                    <div ref="eLabel"></div>\n                    <div ref="eWrapper" class="ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed">\n                        <div ref="eDisplayField" class="ag-picker-field-display ag-advanced-filter-builder-pill-display"></div>\n                        <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>\n                        <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>\n                    </div>\n                </div>',
                }),
            ) || this;
        _this.params = params;
        return _this;
    }
    SelectPillComp.prototype.getFocusableElement = function () {
        return this.eWrapper;
    };
    SelectPillComp.prototype.showPicker = function () {
        var _this = this;
        // avoid focus handling issues with multiple rich selects
        setTimeout(function () {
            return _super.prototype.showPicker.call(_this);
        });
    };
    SelectPillComp.prototype.hidePicker = function () {
        var _this = this;
        // avoid focus handling issues with multiple rich selects
        setTimeout(function () {
            return _super.prototype.hidePicker.call(_this);
        });
    };
    SelectPillComp.prototype.postConstruct = function () {
        _super.prototype.postConstruct.call(this);
        var _a = this.params,
            wrapperClassName = _a.wrapperClassName,
            ariaLabel = _a.ariaLabel;
        this.eWrapper.classList.add(wrapperClassName);
        _.setAriaLabelledBy(this.eWrapper, '');
        _.setAriaLabel(this.eWrapper, ariaLabel);
    };
    SelectPillComp.prototype.createPickerComponent = function () {
        var _a;
        if (!this.values) {
            var values = this.params.getEditorParams().values;
            this.values = values;
            var key_1 = this.value.key;
            var value =
                (_a = values.find(function (value) {
                    return value.key === key_1;
                })) !== null && _a !== void 0
                    ? _a
                    : {
                          key: key_1,
                          displayValue: this.value.displayValue,
                      };
            this.value = value;
        }
        return _super.prototype.createPickerComponent.call(this);
    };
    SelectPillComp.prototype.onEnterKeyDown = function (event) {
        _.stopPropagationForAgGrid(event);
        if (this.isPickerDisplayed) {
            _super.prototype.onEnterKeyDown.call(this, event);
        } else {
            event.preventDefault();
            this.showPicker();
        }
    };
    return SelectPillComp;
})(AgRichSelect);

var __extends$3v =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2F =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterBuilderItemComp = /** @class */ (function (_super) {
    __extends$3v(AdvancedFilterBuilderItemComp, _super);
    function AdvancedFilterBuilderItemComp(item, dragFeature, focusWrapper) {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">\n                <div ref="eItem" class="ag-advanced-filter-builder-item" role="presentation">\n                    <div ref="eTreeLines" class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true"></div>\n                    <span ref="eDragHandle" class="ag-drag-handle" aria-hidden="true"></span>\n                    <span ref="eValidation" class="ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid" aria-hidden="true"></span>\n                </div>\n                <div ref="eButtons" class="ag-advanced-filter-builder-item-buttons">\n                    <span ref="eMoveUpButton" class="ag-advanced-filter-builder-item-button" role="button"></span>\n                    <span ref="eMoveDownButton" class="ag-advanced-filter-builder-item-button" role="button"></span>\n                    <div ref="eAddButton" role="presentation"></div>\n                    <span ref="eRemoveButton" class="ag-advanced-filter-builder-item-button" role="button"></span>\n                </div>\n            </div>\n        ',
            ) || this;
        _this.item = item;
        _this.dragFeature = dragFeature;
        _this.focusWrapper = focusWrapper;
        _this.moveUpDisabled = false;
        _this.moveDownDisabled = false;
        return _this;
    }
    AdvancedFilterBuilderItemComp.prototype.postConstruct = function () {
        var _this = this;
        var _a = this.item,
            filterModel = _a.filterModel,
            level = _a.level,
            showMove = _a.showMove;
        var isJoin = filterModel.filterType === 'join';
        this.ePillWrapper = this.createManagedBean(isJoin ? new JoinPillWrapperComp() : new ConditionPillWrapperComp());
        this.ePillWrapper.init({
            item: this.item,
            createPill: function (params) {
                return _this.createPill(params);
            },
        });
        this.eDragHandle.insertAdjacentElement('afterend', this.ePillWrapper.getGui());
        if (level === 0) {
            var eTreeLine = document.createElement('div');
            eTreeLine.classList.add('ag-advanced-filter-builder-item-tree-line-vertical-bottom');
            eTreeLine.classList.add('ag-advanced-filter-builder-item-tree-line-root');
            this.eTreeLines.appendChild(eTreeLine);
            _.setDisplayed(this.eDragHandle, false);
            _.setDisplayed(this.eButtons, false);
            _.setAriaExpanded(this.focusWrapper, true);
        } else {
            this.setupTreeLines(level);
            this.eDragHandle.appendChild(_.createIconNoSpan('advancedFilterBuilderDrag', this.gridOptionsService));
            this.setupValidation();
            this.setupMoveButtons(showMove);
            this.setupAddButton();
            this.setupRemoveButton();
            this.setupDragging();
            this.updateAriaExpanded();
        }
        _.setAriaLevel(this.focusWrapper, level + 1);
        this.initialiseTabGuard({});
        this.createManagedBean(
            new AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, this.ePillWrapper),
        );
        this.updateAriaLabel();
        this.addManagedListener(this.ePillWrapper, AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED, function () {
            return _this.dispatchEvent({
                type: AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED,
            });
        });
        this.addManagedListener(this.ePillWrapper, AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED, function () {
            return _this.updateValidity();
        });
    };
    AdvancedFilterBuilderItemComp.prototype.setState = function (params) {
        var level = this.item.level;
        if (level === 0) {
            return;
        }
        var showMove = this.item.showMove;
        var disableMoveUp = params.disableMoveUp,
            disableMoveDown = params.disableMoveDown,
            treeLines = params.treeLines,
            showStartTreeLine = params.showStartTreeLine;
        this.updateTreeLines(treeLines, showStartTreeLine);
        this.updateAriaExpanded();
        if (showMove) {
            this.moveUpDisabled = !!disableMoveUp;
            this.moveDownDisabled = !!disableMoveDown;
            this.eMoveUpButton.classList.toggle('ag-advanced-filter-builder-item-button-disabled', disableMoveUp);
            this.eMoveDownButton.classList.toggle('ag-advanced-filter-builder-item-button-disabled', disableMoveDown);
            _.setAriaDisabled(this.eMoveUpButton, !!disableMoveUp);
            _.setAriaDisabled(this.eMoveDownButton, !!disableMoveDown);
            this.moveUpTooltipFeature.refreshToolTip();
            this.moveDownTooltipFeature.refreshToolTip();
        }
    };
    AdvancedFilterBuilderItemComp.prototype.focusMoveButton = function (backwards) {
        (backwards ? this.eMoveUpButton : this.eMoveDownButton).focus();
    };
    AdvancedFilterBuilderItemComp.prototype.afterAdd = function () {
        this.ePillWrapper.getFocusableElement().focus();
    };
    AdvancedFilterBuilderItemComp.prototype.setupTreeLines = function (level) {
        for (var i = 0; i < level; i++) {
            var eTreeLine = document.createElement('div');
            this.eTreeLines.appendChild(eTreeLine);
        }
    };
    AdvancedFilterBuilderItemComp.prototype.updateTreeLines = function (treeLines, showStartTreeLine) {
        var lastTreeLineIndex = treeLines.length - 1;
        var children = this.eTreeLines.children;
        for (var i = 0; i < lastTreeLineIndex; i++) {
            var eTreeLine_1 = children.item(i);
            if (eTreeLine_1) {
                eTreeLine_1.classList.toggle('ag-advanced-filter-builder-item-tree-line-vertical', !treeLines[i]);
            }
        }
        var eTreeLine = children.item(lastTreeLineIndex);
        if (eTreeLine) {
            eTreeLine.classList.add('ag-advanced-filter-builder-item-tree-line-horizontal');
            var isLastChild = treeLines[lastTreeLineIndex];
            eTreeLine.classList.toggle('ag-advanced-filter-builder-item-tree-line-vertical-top', isLastChild);
            eTreeLine.classList.toggle('ag-advanced-filter-builder-item-tree-line-vertical', !isLastChild);
        }
        this.eDragHandle.classList.toggle(
            'ag-advanced-filter-builder-item-tree-line-vertical-bottom',
            showStartTreeLine,
        );
    };
    AdvancedFilterBuilderItemComp.prototype.setupValidation = function () {
        var _this = this;
        this.eValidation.appendChild(_.createIconNoSpan('advancedFilterBuilderInvalid', this.gridOptionsService));
        this.validationTooltipFeature = this.createManagedBean(
            new TooltipFeature(
                {
                    getGui: function () {
                        return _this.eValidation;
                    },
                    getLocation: function () {
                        return 'advancedFilter';
                    },
                    getTooltipValue: function () {
                        return _this.ePillWrapper.getValidationMessage();
                    },
                    getTooltipShowDelayOverride: function () {
                        return 1000;
                    },
                },
                this.beans,
            ),
        );
        this.validationTooltipFeature.setComp(this.eValidation);
        this.updateValidity();
    };
    AdvancedFilterBuilderItemComp.prototype.setupAddButton = function () {
        var _this = this;
        var _a;
        var addButtonParams = getAdvancedFilterBuilderAddButtonParams(
            function (key) {
                return _this.advancedFilterExpressionService.translate(key);
            },
            (_a = this.gridOptionsService.get('advancedFilterBuilderParams')) === null || _a === void 0
                ? void 0
                : _a.addSelectWidth,
        );
        var eAddButton = this.createManagedBean(new AddDropdownComp(addButtonParams));
        this.addManagedListener(eAddButton, Events.EVENT_FIELD_PICKER_VALUE_SELECTED, function (_a) {
            var value = _a.value;
            return _this.dispatchEvent({
                type: AdvancedFilterBuilderEvents.EVENT_ADDED,
                item: _this.item,
                isJoin: value.key === 'join',
            });
        });
        this.eAddButton.appendChild(eAddButton.getGui());
        var tooltipFeature = this.createManagedBean(
            new TooltipFeature(
                {
                    getGui: function () {
                        return _this.eAddButton;
                    },
                    getLocation: function () {
                        return 'advancedFilter';
                    },
                    getTooltipValue: function () {
                        return _this.advancedFilterExpressionService.translate('advancedFilterBuilderAddButtonTooltip');
                    },
                },
                this.beans,
            ),
        );
        tooltipFeature.setComp(this.eAddButton);
    };
    AdvancedFilterBuilderItemComp.prototype.setupRemoveButton = function () {
        var _this = this;
        this.eRemoveButton.appendChild(_.createIconNoSpan('advancedFilterBuilderRemove', this.gridOptionsService));
        this.addManagedListener(this.eRemoveButton, 'click', function () {
            return _this.removeItem();
        });
        this.addManagedListener(this.eRemoveButton, 'keydown', function (event) {
            switch (event.key) {
                case KeyCode.ENTER:
                    event.preventDefault();
                    _.stopPropagationForAgGrid(event);
                    _this.removeItem();
                    break;
            }
        });
        var tooltipFeature = this.createManagedBean(
            new TooltipFeature(
                {
                    getGui: function () {
                        return _this.eRemoveButton;
                    },
                    getLocation: function () {
                        return 'advancedFilter';
                    },
                    getTooltipValue: function () {
                        return _this.advancedFilterExpressionService.translate(
                            'advancedFilterBuilderRemoveButtonTooltip',
                        );
                    },
                },
                this.beans,
            ),
        );
        tooltipFeature.setComp(this.eRemoveButton);
        _.setAriaLabel(
            this.eRemoveButton,
            this.advancedFilterExpressionService.translate('advancedFilterBuilderRemoveButtonTooltip'),
        );
        this.activateTabIndex([this.eRemoveButton]);
    };
    AdvancedFilterBuilderItemComp.prototype.setupMoveButtons = function (showMove) {
        var _this = this;
        if (showMove) {
            this.eMoveUpButton.appendChild(_.createIconNoSpan('advancedFilterBuilderMoveUp', this.gridOptionsService));
            this.addManagedListener(this.eMoveUpButton, 'click', function () {
                return _this.moveItem(true);
            });
            this.addManagedListener(this.eMoveUpButton, 'keydown', function (event) {
                switch (event.key) {
                    case KeyCode.ENTER:
                        event.preventDefault();
                        _.stopPropagationForAgGrid(event);
                        _this.moveItem(true);
                        break;
                }
            });
            this.moveUpTooltipFeature = this.createManagedBean(
                new TooltipFeature(
                    {
                        getGui: function () {
                            return _this.eMoveUpButton;
                        },
                        getLocation: function () {
                            return 'advancedFilter';
                        },
                        getTooltipValue: function () {
                            return _this.moveUpDisabled
                                ? null
                                : _this.advancedFilterExpressionService.translate(
                                      'advancedFilterBuilderMoveUpButtonTooltip',
                                  );
                        },
                    },
                    this.beans,
                ),
            );
            this.moveUpTooltipFeature.setComp(this.eMoveUpButton);
            _.setAriaLabel(
                this.eMoveUpButton,
                this.advancedFilterExpressionService.translate('advancedFilterBuilderMoveUpButtonTooltip'),
            );
            this.eMoveDownButton.appendChild(
                _.createIconNoSpan('advancedFilterBuilderMoveDown', this.gridOptionsService),
            );
            this.addManagedListener(this.eMoveDownButton, 'click', function () {
                return _this.moveItem(false);
            });
            this.addManagedListener(this.eMoveDownButton, 'keydown', function (event) {
                switch (event.key) {
                    case KeyCode.ENTER:
                        event.preventDefault();
                        _.stopPropagationForAgGrid(event);
                        _this.moveItem(false);
                        break;
                }
            });
            this.moveDownTooltipFeature = this.createManagedBean(
                new TooltipFeature(
                    {
                        getGui: function () {
                            return _this.eMoveDownButton;
                        },
                        getLocation: function () {
                            return 'advancedFilter';
                        },
                        getTooltipValue: function () {
                            return _this.moveDownDisabled
                                ? null
                                : _this.advancedFilterExpressionService.translate(
                                      'advancedFilterBuilderMoveDownButtonTooltip',
                                  );
                        },
                    },
                    this.beans,
                ),
            );
            this.moveDownTooltipFeature.setComp(this.eMoveDownButton);
            _.setAriaLabel(
                this.eMoveDownButton,
                this.advancedFilterExpressionService.translate('advancedFilterBuilderMoveDownButtonTooltip'),
            );
            this.activateTabIndex([this.eMoveUpButton, this.eMoveDownButton]);
        } else {
            _.setDisplayed(this.eMoveUpButton, false);
            _.setDisplayed(this.eMoveDownButton, false);
        }
    };
    AdvancedFilterBuilderItemComp.prototype.updateValidity = function () {
        _.setVisible(this.eValidation, !this.item.valid);
        this.validationTooltipFeature.refreshToolTip();
        this.updateAriaLabel();
    };
    AdvancedFilterBuilderItemComp.prototype.createPill = function (params) {
        var _this = this;
        var _a, _b;
        var key = params.key,
            displayValue = params.displayValue,
            cssClass = params.cssClass,
            update = params.update,
            ariaLabel = params.ariaLabel;
        var onUpdated = function (key) {
            if (key == null) {
                return;
            }
            update(key);
            _this.dispatchEvent({
                type: AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED,
            });
        };
        if (params.isSelect) {
            var getEditorParams = params.getEditorParams,
                pickerAriaLabelKey = params.pickerAriaLabelKey,
                pickerAriaLabelValue = params.pickerAriaLabelValue;
            var advancedFilterBuilderParams = this.gridOptionsService.get('advancedFilterBuilderParams');
            var minPickerWidth =
                ((_a =
                    advancedFilterBuilderParams === null || advancedFilterBuilderParams === void 0
                        ? void 0
                        : advancedFilterBuilderParams.pillSelectMinWidth) !== null && _a !== void 0
                    ? _a
                    : 140) + 'px';
            var maxPickerWidth =
                ((_b =
                    advancedFilterBuilderParams === null || advancedFilterBuilderParams === void 0
                        ? void 0
                        : advancedFilterBuilderParams.pillSelectMaxWidth) !== null && _b !== void 0
                    ? _b
                    : 200) + 'px';
            var comp = this.createBean(
                new SelectPillComp({
                    pickerAriaLabelKey: pickerAriaLabelKey,
                    pickerAriaLabelValue: pickerAriaLabelValue,
                    pickerType: 'ag-list',
                    value: {
                        key: key,
                        displayValue: displayValue,
                    },
                    valueFormatter: function (value) {
                        var _a;
                        return value == null
                            ? null
                            : (_a = value.displayValue) !== null && _a !== void 0
                            ? _a
                            : value.key;
                    },
                    variableWidth: true,
                    minPickerWidth: minPickerWidth,
                    maxPickerWidth: maxPickerWidth,
                    getEditorParams: getEditorParams,
                    wrapperClassName: cssClass,
                    ariaLabel: ariaLabel,
                }),
            );
            this.addManagedListener(comp, Events.EVENT_FIELD_PICKER_VALUE_SELECTED, function (_a) {
                var value = _a.value;
                return onUpdated(value === null || value === void 0 ? void 0 : value.key);
            });
            return comp;
        } else {
            var comp = this.createBean(
                new InputPillComp({
                    value: displayValue,
                    cssClass: cssClass,
                    type: this.getInputType(params.baseCellDataType),
                    ariaLabel: ariaLabel,
                }),
            );
            this.addManagedListener(comp, Events.EVENT_FIELD_VALUE_CHANGED, function (_a) {
                var value = _a.value;
                return onUpdated(value);
            });
            return comp;
        }
    };
    AdvancedFilterBuilderItemComp.prototype.getInputType = function (baseCellDataType) {
        switch (baseCellDataType) {
            case 'text':
            case 'object':
            case 'boolean':
                return 'text';
            case 'number':
                return 'number';
            case 'date':
            case 'dateString':
                return 'date';
        }
    };
    AdvancedFilterBuilderItemComp.prototype.setupDragging = function () {
        var _this = this;
        var dragSource = {
            type: DragSourceType.AdvancedFilterBuilder,
            eElement: this.eDragHandle,
            dragItemName: function () {
                return _this.ePillWrapper.getDragName();
            },
            getDefaultIconName: function () {
                return DragAndDropService.ICON_NOT_ALLOWED;
            },
            getDragItem: function () {
                return {};
            },
            onDragStarted: function () {
                return _this.dragFeature.dispatchEvent({
                    type: AdvancedFilterBuilderDragFeature.EVENT_DRAG_STARTED,
                    item: _this.item,
                });
            },
            onDragStopped: function () {
                return _this.dragFeature.dispatchEvent({
                    type: AdvancedFilterBuilderDragFeature.EVENT_DRAG_ENDED,
                });
            },
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDragSource(dragSource);
        });
    };
    AdvancedFilterBuilderItemComp.prototype.updateAriaLabel = function () {
        var wrapperLabel = this.ePillWrapper.getAriaLabel();
        var level = '' + (this.item.level + 1);
        var validationMessage = this.ePillWrapper.getValidationMessage();
        var ariaLabel;
        if (validationMessage) {
            ariaLabel = this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderItemValidation', [
                wrapperLabel,
                level,
                validationMessage,
            ]);
        } else {
            ariaLabel = this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderItem', [
                wrapperLabel,
                level,
            ]);
        }
        _.setAriaLabel(this.focusWrapper, ariaLabel);
    };
    AdvancedFilterBuilderItemComp.prototype.updateAriaExpanded = function () {
        _.removeAriaExpanded(this.focusWrapper);
        var filterModel = this.item.filterModel;
        if (
            (filterModel === null || filterModel === void 0 ? void 0 : filterModel.filterType) === 'join' &&
            filterModel.conditions.length
        ) {
            _.setAriaExpanded(this.focusWrapper, true);
        }
    };
    AdvancedFilterBuilderItemComp.prototype.removeItem = function () {
        this.dispatchEvent({
            type: AdvancedFilterBuilderEvents.EVENT_REMOVED,
            item: this.item,
        });
    };
    AdvancedFilterBuilderItemComp.prototype.moveItem = function (backwards) {
        this.dispatchEvent({
            type: AdvancedFilterBuilderEvents.EVENT_MOVED,
            item: this.item,
            backwards: backwards,
        });
    };
    __decorate$2F([RefSelector('eTreeLines')], AdvancedFilterBuilderItemComp.prototype, 'eTreeLines', void 0);
    __decorate$2F([RefSelector('eDragHandle')], AdvancedFilterBuilderItemComp.prototype, 'eDragHandle', void 0);
    __decorate$2F([RefSelector('eItem')], AdvancedFilterBuilderItemComp.prototype, 'eItem', void 0);
    __decorate$2F([RefSelector('eButtons')], AdvancedFilterBuilderItemComp.prototype, 'eButtons', void 0);
    __decorate$2F([RefSelector('eValidation')], AdvancedFilterBuilderItemComp.prototype, 'eValidation', void 0);
    __decorate$2F([RefSelector('eMoveUpButton')], AdvancedFilterBuilderItemComp.prototype, 'eMoveUpButton', void 0);
    __decorate$2F([RefSelector('eMoveDownButton')], AdvancedFilterBuilderItemComp.prototype, 'eMoveDownButton', void 0);
    __decorate$2F([RefSelector('eAddButton')], AdvancedFilterBuilderItemComp.prototype, 'eAddButton', void 0);
    __decorate$2F([RefSelector('eRemoveButton')], AdvancedFilterBuilderItemComp.prototype, 'eRemoveButton', void 0);
    __decorate$2F([Autowired('beans')], AdvancedFilterBuilderItemComp.prototype, 'beans', void 0);
    __decorate$2F(
        [Autowired('dragAndDropService')],
        AdvancedFilterBuilderItemComp.prototype,
        'dragAndDropService',
        void 0,
    );
    __decorate$2F(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterBuilderItemComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2F([PostConstruct], AdvancedFilterBuilderItemComp.prototype, 'postConstruct', null);
    return AdvancedFilterBuilderItemComp;
})(TabGuardComp);

var __extends$3u =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2E =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterBuilderItemAddComp = /** @class */ (function (_super) {
    __extends$3u(AdvancedFilterBuilderItemAddComp, _super);
    function AdvancedFilterBuilderItemAddComp(item, focusWrapper) {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">\n                <div ref="eItem" class="ag-advanced-filter-builder-item" role="presentation">\n                    <div class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true">\n                        <div class="ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"></div>\n                    </div>\n                </div>\n            </div>\n        ',
            ) || this;
        _this.item = item;
        _this.focusWrapper = focusWrapper;
        return _this;
    }
    AdvancedFilterBuilderItemAddComp.prototype.postConstruct = function () {
        var _this = this;
        var _a;
        _.setAriaLevel(this.focusWrapper, 2);
        var addButtonParams = getAdvancedFilterBuilderAddButtonParams(
            function (key) {
                return _this.advancedFilterExpressionService.translate(key);
            },
            (_a = this.gridOptionsService.get('advancedFilterBuilderParams')) === null || _a === void 0
                ? void 0
                : _a.addSelectWidth,
        );
        var eAddButton = this.createManagedBean(new AddDropdownComp(addButtonParams));
        this.addManagedListener(eAddButton, Events.EVENT_FIELD_PICKER_VALUE_SELECTED, function (_a) {
            var value = _a.value;
            _this.dispatchEvent({
                type: AdvancedFilterBuilderEvents.EVENT_ADDED,
                item: _this.item,
                isJoin: value.key === 'join',
            });
        });
        this.eItem.appendChild(eAddButton.getGui());
        var tooltipFeature = this.createManagedBean(
            new TooltipFeature(
                {
                    getGui: function () {
                        return eAddButton.getGui();
                    },
                    getLocation: function () {
                        return 'advancedFilter';
                    },
                    getTooltipValue: function () {
                        return _this.advancedFilterExpressionService.translate('advancedFilterBuilderAddButtonTooltip');
                    },
                },
                this.beans,
            ),
        );
        tooltipFeature.setComp(eAddButton.getGui());
        this.createManagedBean(
            new AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, eAddButton),
        );
        _.setAriaLabel(
            this.focusWrapper,
            this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderItem', [
                this.advancedFilterExpressionService.translate('advancedFilterBuilderAddButtonTooltip'),
                '' + (this.item.level + 1),
            ]),
        );
    };
    AdvancedFilterBuilderItemAddComp.prototype.afterAdd = function () {
        // do nothing
    };
    __decorate$2E([Autowired('beans')], AdvancedFilterBuilderItemAddComp.prototype, 'beans', void 0);
    __decorate$2E(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterBuilderItemAddComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2E([RefSelector('eItem')], AdvancedFilterBuilderItemAddComp.prototype, 'eItem', void 0);
    __decorate$2E([PostConstruct], AdvancedFilterBuilderItemAddComp.prototype, 'postConstruct', null);
    return AdvancedFilterBuilderItemAddComp;
})(Component);

var __extends$3t =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2D =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1q =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$T =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var AdvancedFilterBuilderComp = /** @class */ (function (_super) {
    __extends$3t(AdvancedFilterBuilderComp, _super);
    function AdvancedFilterBuilderComp() {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div role="presentation" class="ag-advanced-filter-builder" tabindex="-1">\n                <div role="presentation" class="ag-advanced-filter-builder-list" ref="eList"></div>\n                <div role="presentation" class="ag-advanced-filter-builder-button-panel">\n                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-apply-button" ref="eApplyFilterButton"></button>\n                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-cancel-button" ref="eCancelFilterButton"></button>\n                </div>\n            </div>',
            ) || this;
        _this.validationMessage = null;
        return _this;
    }
    AdvancedFilterBuilderComp.prototype.postConstruct = function () {
        var _this = this;
        var _a;
        var showMoveButtons = (
            (_a = this.gridOptionsService.get('advancedFilterBuilderParams')) !== null && _a !== void 0 ? _a : {}
        ).showMoveButtons;
        this.showMove = !!showMoveButtons;
        this.addManagedPropertyListener('advancedFilterBuilderParams', function (_a) {
            var currentValue = _a.currentValue;
            _this.showMove = !!(currentValue === null || currentValue === void 0
                ? void 0
                : currentValue.showMoveButtons);
            _this.refreshList(false);
        });
        this.filterModel = this.setupFilterModel();
        this.setupVirtualList();
        this.dragFeature = this.createManagedBean(new AdvancedFilterBuilderDragFeature(this, this.virtualList));
        this.setupButtons();
    };
    AdvancedFilterBuilderComp.prototype.refresh = function () {
        var indexToFocus = this.virtualList.getLastFocusedRow();
        this.setupFilterModel();
        this.validateItems();
        this.refreshList(false);
        if (indexToFocus != null) {
            // last focused row is cleared on focus out, so if defined, we need to put the focus back
            if (!this.virtualList.getComponentAt(indexToFocus)) {
                indexToFocus = 0;
            }
            this.virtualList.focusRow(indexToFocus);
        }
    };
    AdvancedFilterBuilderComp.prototype.getNumItems = function () {
        return this.items.length;
    };
    AdvancedFilterBuilderComp.prototype.moveItem = function (item, destination) {
        if (!destination || !item) {
            return;
        }
        this.moveItemToIndex(item, destination.rowIndex, destination.position);
    };
    AdvancedFilterBuilderComp.prototype.afterGuiAttached = function () {
        this.virtualList.focusRow(0);
    };
    AdvancedFilterBuilderComp.prototype.setupVirtualList = function () {
        var _this = this;
        this.virtualList = this.createManagedBean(
            new VirtualList({
                cssIdentifier: 'advanced-filter-builder',
                ariaRole: 'tree',
                listName: this.advancedFilterExpressionService.translate('ariaAdvancedFilterBuilderList'),
            }),
        );
        this.virtualList.setComponentCreator(this.createItemComponent.bind(this));
        this.virtualList.setComponentUpdater(this.updateItemComponent.bind(this));
        this.virtualList.setRowHeight(40);
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: function () {
                return _this.items.length;
            },
            getRow: function (index) {
                return _this.items[index];
            },
            areRowsEqual: function (oldRow, newRow) {
                return oldRow === newRow;
            },
        });
        this.buildList();
        this.virtualList.refresh();
    };
    AdvancedFilterBuilderComp.prototype.setupButtons = function () {
        var _this = this;
        this.eApplyFilterButton.innerText =
            this.advancedFilterExpressionService.translate('advancedFilterBuilderApply');
        this.activateTabIndex([this.eApplyFilterButton]);
        this.addManagedListener(this.eApplyFilterButton, 'click', function () {
            _this.advancedFilterService.setModel(_this.filterModel);
            _this.filterManager.onFilterChanged({ source: 'advancedFilter' });
            _this.close();
        });
        this.validationTooltipFeature = this.createManagedBean(
            new TooltipFeature(
                {
                    getGui: function () {
                        return _this.eApplyFilterButton;
                    },
                    getLocation: function () {
                        return 'advancedFilter';
                    },
                    getTooltipValue: function () {
                        return _this.validationMessage;
                    },
                    getTooltipShowDelayOverride: function () {
                        return 1000;
                    },
                },
                this.beans,
            ),
        );
        this.validationTooltipFeature.setComp(this.eApplyFilterButton);
        this.validate();
        this.addManagedListener(this.eApplyFilterButton, 'mouseenter', function () {
            return _this.addOrRemoveCssClass('ag-advanced-filter-builder-validation', true);
        });
        this.addManagedListener(this.eApplyFilterButton, 'mouseleave', function () {
            return _this.addOrRemoveCssClass('ag-advanced-filter-builder-validation', false);
        });
        this.eCancelFilterButton.innerText =
            this.advancedFilterExpressionService.translate('advancedFilterBuilderCancel');
        this.activateTabIndex([this.eCancelFilterButton]);
        this.addManagedListener(this.eCancelFilterButton, 'click', function () {
            return _this.close();
        });
    };
    AdvancedFilterBuilderComp.prototype.removeItemFromParent = function (item) {
        var sourceParentIndex = item.parent.conditions.indexOf(item.filterModel);
        item.parent.conditions.splice(sourceParentIndex, 1);
        return sourceParentIndex;
    };
    AdvancedFilterBuilderComp.prototype.moveItemToIndex = function (item, destinationRowIndex, destinationPosition) {
        var _a;
        var destinationItem = this.items[destinationRowIndex];
        var destinationIsParent =
            ((_a = destinationItem.filterModel) === null || _a === void 0 ? void 0 : _a.filterType) === 'join' &&
            destinationPosition === 'bottom';
        var destinationParent = destinationIsParent ? destinationItem.filterModel : destinationItem.parent;
        // trying to move before the root
        if (!destinationParent) {
            return;
        }
        // can't move into itself
        if (this.isChildOrSelf(destinationParent, item.filterModel) || destinationItem === item) {
            return;
        }
        this.removeItemFromParent(item);
        var destinationParentIndex;
        if (destinationIsParent) {
            destinationParentIndex = 0;
        } else {
            destinationParentIndex = destinationParent.conditions.indexOf(destinationItem.filterModel);
            if (destinationParentIndex === -1) {
                destinationParentIndex = destinationParent.conditions.length;
            } else if (destinationPosition === 'bottom') {
                destinationParentIndex += 1;
            }
        }
        destinationParent.conditions.splice(destinationParentIndex, 0, item.filterModel);
        this.refreshList(false);
    };
    AdvancedFilterBuilderComp.prototype.isChildOrSelf = function (modelToCheck, potentialParentModel) {
        var _this = this;
        return (
            modelToCheck === potentialParentModel ||
            (potentialParentModel.filterType === 'join' &&
                potentialParentModel.conditions.some(function (condition) {
                    return _this.isChildOrSelf(modelToCheck, condition);
                }))
        );
    };
    AdvancedFilterBuilderComp.prototype.setupFilterModel = function () {
        var filterModel = this.formatFilterModel(this.advancedFilterService.getModel());
        this.stringifiedModel = JSON.stringify(filterModel);
        return filterModel;
    };
    AdvancedFilterBuilderComp.prototype.formatFilterModel = function (filterModel) {
        filterModel =
            filterModel !== null && filterModel !== void 0
                ? filterModel
                : {
                      filterType: 'join',
                      type: 'AND',
                      conditions: [],
                  };
        if (filterModel.filterType !== 'join') {
            filterModel = {
                filterType: 'join',
                type: 'AND',
                conditions: [filterModel],
            };
        }
        return filterModel;
    };
    AdvancedFilterBuilderComp.prototype.buildList = function () {
        var _this = this;
        var parseFilterModel = function (filterModel, items, level, parent) {
            items.push({
                filterModel: filterModel,
                level: level,
                parent: parent,
                valid: true,
                showMove: _this.showMove,
            });
            if (filterModel.filterType === 'join') {
                filterModel.conditions.forEach(function (childFilterModel) {
                    return parseFilterModel(childFilterModel, items, level + 1, filterModel);
                });
                if (level === 0) {
                    items.push({ filterModel: null, level: level + 1, parent: filterModel, valid: true });
                }
            }
        };
        this.items = [];
        parseFilterModel(this.filterModel, this.items, 0);
    };
    AdvancedFilterBuilderComp.prototype.refreshList = function (softRefresh) {
        if (!softRefresh) {
            var invalidModels_1 = [];
            this.items.forEach(function (item) {
                if (!item.valid) {
                    invalidModels_1.push(item.filterModel);
                }
            });
            this.buildList();
            if (invalidModels_1.length) {
                this.items.forEach(function (item) {
                    if (item.filterModel && invalidModels_1.includes(item.filterModel)) {
                        item.valid = false;
                    }
                });
            }
        }
        this.virtualList.refresh(softRefresh);
        this.validate();
    };
    AdvancedFilterBuilderComp.prototype.updateItemComponent = function (item, comp) {
        var _this = this;
        var index = this.items.indexOf(item);
        var populateTreeLines = function (filterModel, treeLines) {
            var parentItem = _this.items.find(function (itemToCheck) {
                return itemToCheck.filterModel === filterModel;
            });
            var parentFilterModel = parentItem === null || parentItem === void 0 ? void 0 : parentItem.parent;
            if (parentFilterModel) {
                var conditions = parentFilterModel.conditions;
                // check parent
                populateTreeLines(parentFilterModel, treeLines);
                treeLines.push(conditions[conditions.length - 1] === filterModel);
            }
        };
        var treeLines = [];
        var filterModel = item.filterModel;
        if (filterModel) {
            populateTreeLines(filterModel, treeLines);
            // the add item button is always last child
            treeLines[0] = false;
        }
        var showStartTreeLine =
            (filterModel === null || filterModel === void 0 ? void 0 : filterModel.filterType) === 'join' &&
            !!filterModel.conditions.length;
        comp.setState({
            disableMoveUp: index === 1,
            disableMoveDown: !this.canMoveDown(item, index),
            treeLines: treeLines,
            showStartTreeLine: showStartTreeLine,
        });
    };
    AdvancedFilterBuilderComp.prototype.createItemComponent = function (item, focusWrapper) {
        var _this = this;
        var itemComp = this.createBean(
            item.filterModel
                ? new AdvancedFilterBuilderItemComp(item, this.dragFeature, focusWrapper)
                : new AdvancedFilterBuilderItemAddComp(item, focusWrapper),
        );
        itemComp.addManagedListener(itemComp, AdvancedFilterBuilderEvents.EVENT_REMOVED, function (_a) {
            var item = _a.item;
            return _this.removeItem(item);
        });
        itemComp.addManagedListener(itemComp, AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED, function () {
            return _this.validate();
        });
        itemComp.addManagedListener(itemComp, AdvancedFilterBuilderEvents.EVENT_ADDED, function (_a) {
            var item = _a.item,
                isJoin = _a.isJoin;
            return _this.addItem(item, isJoin);
        });
        itemComp.addManagedListener(itemComp, AdvancedFilterBuilderEvents.EVENT_MOVED, function (_a) {
            var item = _a.item,
                backwards = _a.backwards;
            return _this.moveItemUpDown(item, backwards);
        });
        if (itemComp instanceof AdvancedFilterBuilderItemComp) {
            this.updateItemComponent(item, itemComp);
        }
        return itemComp;
    };
    AdvancedFilterBuilderComp.prototype.addItem = function (item, isJoin) {
        var _a;
        var _b;
        var itemParent = item.parent,
            level = item.level,
            itemFilterModel = item.filterModel;
        var itemIsJoin =
            (itemFilterModel === null || itemFilterModel === void 0 ? void 0 : itemFilterModel.filterType) === 'join';
        var filterModel = isJoin
            ? {
                  filterType: 'join',
                  type: 'AND',
                  conditions: [],
              }
            : {};
        var parent = itemIsJoin ? itemFilterModel : itemParent;
        var insertIndex = itemIsJoin ? 0 : parent.conditions.indexOf(itemFilterModel);
        if (insertIndex >= 0) {
            if (!itemIsJoin) {
                insertIndex += 1;
            }
            parent.conditions.splice(insertIndex, 0, filterModel);
        } else {
            parent.conditions.push(filterModel);
        }
        var index = this.items.indexOf(item);
        var softRefresh = index >= 0;
        if (softRefresh) {
            if (item.filterModel) {
                index++;
            }
            var newItems = [
                {
                    filterModel: filterModel,
                    level: itemIsJoin ? level + 1 : level,
                    parent: parent,
                    valid: isJoin,
                    showMove: this.showMove,
                },
            ];
            (_a = this.items).splice.apply(_a, __spreadArray$T([index, 0], __read$1q(newItems)));
        }
        this.refreshList(softRefresh);
        if (softRefresh) {
            (_b = this.virtualList.getComponentAt(index)) === null || _b === void 0 ? void 0 : _b.afterAdd();
        }
    };
    AdvancedFilterBuilderComp.prototype.removeItem = function (item) {
        var _a;
        var parent = item.parent;
        var filterModel = item.filterModel;
        var parentIndex = parent.conditions.indexOf(filterModel);
        parent.conditions.splice(parentIndex, 1);
        var isJoin = ((_a = item.filterModel) === null || _a === void 0 ? void 0 : _a.filterType) === 'join';
        var index = this.items.indexOf(item);
        // if it's a join, we don't know how many children there are, so always rebuild
        var softRefresh = !isJoin && index >= 0;
        if (softRefresh) {
            this.items.splice(index, 1);
        }
        this.refreshList(softRefresh);
        if (index >= 0) {
            this.virtualList.focusRow(index);
        }
    };
    AdvancedFilterBuilderComp.prototype.moveItemUpDown = function (item, backwards) {
        var itemIndex = this.items.indexOf(item);
        var destinationIndex = backwards ? itemIndex - 1 : itemIndex + 1;
        if (destinationIndex === 0 || (!backwards && !this.canMoveDown(item, itemIndex))) {
            return;
        }
        var destinationItem = this.items[destinationIndex];
        var indexInParent = this.removeItemFromParent(item);
        var level = item.level,
            filterModel = item.filterModel,
            parent = item.parent;
        var destinationLevel = destinationItem.level,
            destinationFilterModel = destinationItem.filterModel,
            destinationParent = destinationItem.parent;
        if (backwards) {
            if (destinationLevel === level && destinationFilterModel.filterType === 'join') {
                // destination is empty join. move to last child
                destinationFilterModel.conditions.push(filterModel);
            } else if (destinationLevel <= level) {
                // same parent or first child. move above destination in destination parent
                var destinationIndex_1 = destinationParent.conditions.indexOf(destinationFilterModel);
                destinationParent.conditions.splice(destinationIndex_1, 0, filterModel);
            } else {
                // need to move up a level. move to end of previous item's children
                var newParentItem = parent.conditions[indexInParent - 1];
                newParentItem.conditions.push(filterModel);
            }
        } else {
            if (destinationLevel === level) {
                if (destinationFilterModel.filterType === 'join') {
                    // destination is join. move to first child
                    destinationFilterModel.conditions.splice(0, 0, filterModel);
                } else {
                    // switch positions
                    var destinationIndex_2 = destinationParent.conditions.indexOf(destinationFilterModel);
                    destinationParent.conditions.splice(destinationIndex_2 + 1, 0, filterModel);
                }
            } else {
                if (indexInParent < parent.conditions.length) {
                    // keep in parent, but swap with next child
                    parent.conditions.splice(indexInParent + 1, 0, filterModel);
                } else {
                    // need to move down a level. move after parent in its parent
                    var parentItem = this.items.find(function (itemToCheck) {
                        return itemToCheck.filterModel === parent;
                    });
                    var destinationIndex_3 = parentItem.parent.conditions.indexOf(parentItem.filterModel) + 1;
                    parentItem.parent.conditions.splice(destinationIndex_3, 0, filterModel);
                }
            }
        }
        this.refreshList(false);
        var newIndex = this.items.findIndex(function (_a) {
            var filterModelToCheck = _a.filterModel;
            return filterModelToCheck === filterModel;
        });
        if (newIndex >= 0) {
            var comp = this.virtualList.getComponentAt(newIndex);
            if (comp instanceof AdvancedFilterBuilderItemComp) {
                comp.focusMoveButton(backwards);
            }
        }
    };
    AdvancedFilterBuilderComp.prototype.canMoveDown = function (item, index) {
        return !(
            (item.level === 1 && index === this.items.length - 2) ||
            (item.level === 1 && item.parent.conditions[item.parent.conditions.length - 1] === item.filterModel)
        );
    };
    AdvancedFilterBuilderComp.prototype.close = function () {
        this.advancedFilterService.getCtrl().toggleFilterBuilder('ui');
    };
    AdvancedFilterBuilderComp.prototype.validate = function () {
        var disableApply = !this.items.every(function (_a) {
            var valid = _a.valid;
            return valid;
        });
        if (!disableApply) {
            disableApply = JSON.stringify(this.filterModel) === this.stringifiedModel;
            if (disableApply) {
                this.validationMessage = this.advancedFilterExpressionService.translate(
                    'advancedFilterBuilderValidationAlreadyApplied',
                );
            } else {
                this.validationMessage = null;
            }
        } else {
            this.validationMessage = this.advancedFilterExpressionService.translate(
                'advancedFilterBuilderValidationIncomplete',
            );
        }
        _.setDisabled(this.eApplyFilterButton, disableApply);
        this.validationTooltipFeature.refreshToolTip();
    };
    AdvancedFilterBuilderComp.prototype.validateItems = function () {
        var _this = this;
        var clearOperator = function (filterModel) {
            filterModel.type = undefined;
        };
        var clearOperand = function (filterModel) {
            delete filterModel.filter;
        };
        this.items.forEach(function (item) {
            if (!item.valid || !item.filterModel || item.filterModel.filterType === 'join') {
                return;
            }
            var filterModel = item.filterModel;
            var colId = filterModel.colId;
            var hasColumn = _this.advancedFilterExpressionService.getColumnAutocompleteEntries().find(function (_a) {
                var key = _a.key;
                return key === colId;
            });
            var columnDetails = _this.advancedFilterExpressionService.getColumnDetails(filterModel.colId);
            if (!hasColumn || !columnDetails) {
                item.valid = false;
                filterModel.colId = undefined;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            var operatorForType = _this.advancedFilterExpressionService.getDataTypeExpressionOperator(
                columnDetails.baseCellDataType,
            );
            var operator = operatorForType.operators[filterModel.type];
            if (!operator) {
                item.valid = false;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            if (operator.numOperands > 0 && !_.exists(filterModel.filter)) {
                item.valid = false;
                return;
            }
        });
    };
    __decorate$2D([RefSelector('eList')], AdvancedFilterBuilderComp.prototype, 'eList', void 0);
    __decorate$2D(
        [RefSelector('eApplyFilterButton')],
        AdvancedFilterBuilderComp.prototype,
        'eApplyFilterButton',
        void 0,
    );
    __decorate$2D(
        [RefSelector('eCancelFilterButton')],
        AdvancedFilterBuilderComp.prototype,
        'eCancelFilterButton',
        void 0,
    );
    __decorate$2D([Autowired('filterManager')], AdvancedFilterBuilderComp.prototype, 'filterManager', void 0);
    __decorate$2D(
        [Autowired('advancedFilterService')],
        AdvancedFilterBuilderComp.prototype,
        'advancedFilterService',
        void 0,
    );
    __decorate$2D(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterBuilderComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2D([Autowired('beans')], AdvancedFilterBuilderComp.prototype, 'beans', void 0);
    __decorate$2D([PostConstruct], AdvancedFilterBuilderComp.prototype, 'postConstruct', null);
    return AdvancedFilterBuilderComp;
})(Component);

var __extends$3s =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2C =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1p =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$S =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var AdvancedFilterCtrl = /** @class */ (function (_super) {
    __extends$3s(AdvancedFilterCtrl, _super);
    function AdvancedFilterCtrl(enabled) {
        var _this = _super.call(this) || this;
        _this.enabled = enabled;
        return _this;
    }
    AdvancedFilterCtrl.prototype.postConstruct = function () {
        var _this = this;
        this.hasAdvancedFilterParent = !!this.gridOptionsService.get('advancedFilterParent');
        this.ctrlsService.whenReady(function () {
            return _this.setAdvancedFilterComp();
        });
        this.addManagedListener(this.eventService, Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, function (_a) {
            var enabled = _a.enabled;
            return _this.onEnabledChanged(enabled);
        });
        this.addManagedPropertyListener('advancedFilterParent', function () {
            return _this.updateComps();
        });
        this.addDestroyFunc(function () {
            _this.destroyAdvancedFilterComp();
            _this.destroyBean(_this.eBuilderComp);
            if (_this.eBuilderDialog && _this.eBuilderDialog.isAlive()) {
                _this.destroyBean(_this.eBuilderDialog);
            }
        });
    };
    AdvancedFilterCtrl.prototype.setupHeaderComp = function (eCompToInsertBefore) {
        this.eHeaderComp = this.createManagedBean(
            new AdvancedFilterHeaderComp(this.enabled && !this.hasAdvancedFilterParent),
        );
        eCompToInsertBefore.insertAdjacentElement('beforebegin', this.eHeaderComp.getGui());
    };
    AdvancedFilterCtrl.prototype.focusHeaderComp = function () {
        if (this.eHeaderComp) {
            this.eHeaderComp.getFocusableElement().focus();
            return true;
        }
        return false;
    };
    AdvancedFilterCtrl.prototype.refreshComp = function () {
        var _a, _b;
        (_a = this.eFilterComp) === null || _a === void 0 ? void 0 : _a.refresh();
        (_b = this.eHeaderComp) === null || _b === void 0 ? void 0 : _b.refresh();
    };
    AdvancedFilterCtrl.prototype.refreshBuilderComp = function () {
        var _a;
        (_a = this.eBuilderComp) === null || _a === void 0 ? void 0 : _a.refresh();
    };
    AdvancedFilterCtrl.prototype.getHeaderHeight = function () {
        var _a, _b;
        return (_b = (_a = this.eHeaderComp) === null || _a === void 0 ? void 0 : _a.getHeight()) !== null &&
            _b !== void 0
            ? _b
            : 0;
    };
    AdvancedFilterCtrl.prototype.setInputDisabled = function (disabled) {
        var _a, _b;
        (_a = this.eFilterComp) === null || _a === void 0 ? void 0 : _a.setInputDisabled(disabled);
        (_b = this.eHeaderComp) === null || _b === void 0 ? void 0 : _b.setInputDisabled(disabled);
    };
    AdvancedFilterCtrl.prototype.toggleFilterBuilder = function (source, force) {
        var _this = this;
        if ((force && this.eBuilderDialog) || (force === false && !this.eBuilderDialog)) {
            // state requested is already active
            return;
        }
        if (this.eBuilderDialog) {
            this.builderDestroySource = source;
            this.destroyBean(this.eBuilderDialog);
            return;
        }
        this.setInputDisabled(true);
        var _a = this.getBuilderDialogSize(),
            width = _a.width,
            height = _a.height,
            minWidth = _a.minWidth;
        this.eBuilderComp = this.createBean(new AdvancedFilterBuilderComp());
        this.eBuilderDialog = this.createBean(
            new AgDialog({
                title: this.advancedFilterExpressionService.translate('advancedFilterBuilderTitle'),
                component: this.eBuilderComp,
                width: width,
                height: height,
                resizable: true,
                movable: true,
                maximizable: true,
                centered: true,
                closable: true,
                minWidth: minWidth,
                afterGuiAttached: function () {
                    var _a;
                    return (_a = _this.eBuilderComp) === null || _a === void 0 ? void 0 : _a.afterGuiAttached();
                },
            }),
        );
        this.dispatchFilterBuilderVisibleChangedEvent(source, true);
        this.eBuilderDialog.addEventListener(AgDialog.EVENT_DESTROYED, function () {
            var _a;
            _this.destroyBean(_this.eBuilderComp);
            _this.eBuilderComp = undefined;
            _this.eBuilderDialog = undefined;
            _this.setInputDisabled(false);
            _this.dispatchEvent({
                type: AdvancedFilterCtrl.EVENT_BUILDER_CLOSED,
            });
            _this.dispatchFilterBuilderVisibleChangedEvent(
                (_a = _this.builderDestroySource) !== null && _a !== void 0 ? _a : 'ui',
                false,
            );
            _this.builderDestroySource = undefined;
        });
    };
    AdvancedFilterCtrl.prototype.dispatchFilterBuilderVisibleChangedEvent = function (source, visible) {
        var event = {
            type: Events.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED,
            source: source,
            visible: visible,
        };
        this.eventService.dispatchEvent(event);
    };
    AdvancedFilterCtrl.prototype.getBuilderDialogSize = function () {
        var _a, _b;
        var minWidth =
            (_b =
                (_a = this.gridOptionsService.get('advancedFilterBuilderParams')) === null || _a === void 0
                    ? void 0
                    : _a.minWidth) !== null && _b !== void 0
                ? _b
                : 500;
        var popupParent = this.popupService.getPopupParent();
        var maxWidth = Math.round(_.getAbsoluteWidth(popupParent)) - 2; // assume 1 pixel border
        var maxHeight = Math.round(_.getAbsoluteHeight(popupParent) * 0.75) - 2;
        var width = Math.min(Math.max(600, minWidth), maxWidth);
        var height = Math.min(600, maxHeight);
        return { width: width, height: height, minWidth: minWidth };
    };
    AdvancedFilterCtrl.prototype.onEnabledChanged = function (enabled) {
        this.enabled = enabled;
        this.updateComps();
    };
    AdvancedFilterCtrl.prototype.updateComps = function () {
        this.setAdvancedFilterComp();
        this.setHeaderCompEnabled();
        this.eventService.dispatchEvent({
            type: Events.EVENT_HEADER_HEIGHT_CHANGED,
        });
    };
    AdvancedFilterCtrl.prototype.setAdvancedFilterComp = function () {
        var _a;
        this.destroyAdvancedFilterComp();
        if (!this.enabled) {
            return;
        }
        var advancedFilterParent = this.gridOptionsService.get('advancedFilterParent');
        this.hasAdvancedFilterParent = !!advancedFilterParent;
        if (advancedFilterParent) {
            // unmanaged as can be recreated
            var eAdvancedFilterComp = this.createBean(new AdvancedFilterComp());
            var eAdvancedFilterCompGui_1 = eAdvancedFilterComp.getGui();
            var allThemes = this.environment.getTheme().allThemes;
            if (allThemes.length) {
                (_a = eAdvancedFilterCompGui_1.classList).add.apply(_a, __spreadArray$S([], __read$1p(allThemes)));
            }
            eAdvancedFilterCompGui_1.classList.add(this.gridOptionsService.is('enableRtl') ? 'ag-rtl' : 'ag-ltr');
            if (this.focusService.isKeyboardMode()) {
                eAdvancedFilterCompGui_1.classList.add(FocusService.AG_KEYBOARD_FOCUS);
            }
            var gridCtrl = this.ctrlsService.getGridCtrl();
            eAdvancedFilterComp.addManagedListener(gridCtrl, Events.EVENT_KEYBOARD_FOCUS, function () {
                return eAdvancedFilterCompGui_1.classList.add(FocusService.AG_KEYBOARD_FOCUS);
            });
            eAdvancedFilterComp.addManagedListener(gridCtrl, Events.EVENT_MOUSE_FOCUS, function () {
                return eAdvancedFilterCompGui_1.classList.remove(FocusService.AG_KEYBOARD_FOCUS);
            });
            advancedFilterParent.appendChild(eAdvancedFilterCompGui_1);
            this.eFilterComp = eAdvancedFilterComp;
        }
    };
    AdvancedFilterCtrl.prototype.setHeaderCompEnabled = function () {
        var _a;
        (_a = this.eHeaderComp) === null || _a === void 0
            ? void 0
            : _a.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
    };
    AdvancedFilterCtrl.prototype.destroyAdvancedFilterComp = function () {
        if (this.eFilterComp) {
            _.removeFromParent(this.eFilterComp.getGui());
            this.destroyBean(this.eFilterComp);
        }
    };
    AdvancedFilterCtrl.EVENT_BUILDER_CLOSED = 'advancedFilterBuilderClosed';
    __decorate$2C([Autowired('focusService')], AdvancedFilterCtrl.prototype, 'focusService', void 0);
    __decorate$2C([Autowired('ctrlsService')], AdvancedFilterCtrl.prototype, 'ctrlsService', void 0);
    __decorate$2C([Autowired('popupService')], AdvancedFilterCtrl.prototype, 'popupService', void 0);
    __decorate$2C(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterCtrl.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2C([PostConstruct], AdvancedFilterCtrl.prototype, 'postConstruct', null);
    return AdvancedFilterCtrl;
})(BeanStub);

var __extends$3r =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2B =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterComp = /** @class */ (function (_super) {
    __extends$3r(AdvancedFilterComp, _super);
    function AdvancedFilterComp() {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-advanced-filter" role="presentation" tabindex="-1">\n                <ag-autocomplete ref="eAutocomplete"></ag-autocomplete>\n                <button class="ag-button ag-standard-button ag-advanced-filter-apply-button" ref="eApplyFilterButton"></button>\n                <button class="ag-advanced-filter-builder-button" ref="eBuilderFilterButton">\n                    <span ref="eBuilderFilterButtonIcon" aria-hidden="true"></span>\n                    <span class="ag-advanced-filter-builder-button-label" ref="eBuilderFilterButtonLabel"></span>\n                </button>\n            </div>',
            ) || this;
        _this.expressionParser = null;
        _this.isApplyDisabled = true;
        _this.builderOpen = false;
        return _this;
    }
    AdvancedFilterComp.prototype.postConstruct = function () {
        var _this = this;
        this.eAutocomplete
            .setListGenerator(function (_value, position) {
                return _this.generateAutocompleteListParams(position);
            })
            .setValidator(function () {
                return _this.validateValue();
            })
            .setForceLastSelection(function (lastSelection, searchString) {
                return _this.forceLastSelection(lastSelection, searchString);
            })
            .setInputAriaLabel(this.advancedFilterExpressionService.translate('ariaAdvancedFilterInput'))
            .setListAriaLabel(this.advancedFilterExpressionService.translate('ariaLabelAdvancedFilterAutocomplete'));
        this.refresh();
        this.addManagedListener(this.eAutocomplete, AgAutocomplete.EVENT_VALUE_CHANGED, function (_a) {
            var value = _a.value;
            return _this.onValueChanged(value);
        });
        this.addManagedListener(this.eAutocomplete, AgAutocomplete.EVENT_VALUE_CONFIRMED, function (_a) {
            var isValid = _a.isValid;
            return _this.onValueConfirmed(isValid);
        });
        this.addManagedListener(this.eAutocomplete, AgAutocomplete.EVENT_OPTION_SELECTED, function (_a) {
            var position = _a.position,
                updateEntry = _a.updateEntry,
                autocompleteType = _a.autocompleteType;
            return _this.onOptionSelected(position, updateEntry, autocompleteType);
        });
        this.addManagedListener(this.eAutocomplete, AgAutocomplete.EVENT_VALID_CHANGED, function (_a) {
            var isValid = _a.isValid,
                validationMessage = _a.validationMessage;
            return _this.onValidChanged(isValid, validationMessage);
        });
        this.setupApplyButton();
        this.setupBuilderButton();
    };
    AdvancedFilterComp.prototype.refresh = function () {
        var expression = this.advancedFilterService.getExpressionDisplayValue();
        this.eAutocomplete.setValue({
            value: expression !== null && expression !== void 0 ? expression : '',
            position: expression === null || expression === void 0 ? void 0 : expression.length,
            updateListOnlyIfOpen: true,
        });
    };
    AdvancedFilterComp.prototype.setInputDisabled = function (disabled) {
        this.eAutocomplete.setInputDisabled(disabled);
        _.setDisabled(this.eApplyFilterButton, disabled || this.isApplyDisabled);
    };
    AdvancedFilterComp.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'advancedFilter';
        return res;
    };
    AdvancedFilterComp.prototype.setupApplyButton = function () {
        var _this = this;
        this.eApplyFilterButton.innerText = this.advancedFilterExpressionService.translate('advancedFilterApply');
        this.activateTabIndex([this.eApplyFilterButton]);
        this.addManagedListener(this.eApplyFilterButton, 'click', function () {
            return _this.onValueConfirmed(_this.eAutocomplete.isValid());
        });
        _.setDisabled(this.eApplyFilterButton, this.isApplyDisabled);
    };
    AdvancedFilterComp.prototype.setupBuilderButton = function () {
        var _this = this;
        this.eBuilderFilterButtonIcon.appendChild(_.createIconNoSpan('advancedFilterBuilder', this.gridOptionsService));
        this.eBuilderFilterButtonLabel.innerText =
            this.advancedFilterExpressionService.translate('advancedFilterBuilder');
        this.activateTabIndex([this.eBuilderFilterButton]);
        this.addManagedListener(this.eBuilderFilterButton, 'click', function () {
            return _this.openBuilder();
        });
        this.addManagedListener(
            this.advancedFilterService.getCtrl(),
            AdvancedFilterCtrl.EVENT_BUILDER_CLOSED,
            function () {
                return _this.closeBuilder();
            },
        );
    };
    AdvancedFilterComp.prototype.onValueChanged = function (value) {
        var _a;
        value = _.makeNull(value);
        this.advancedFilterService.setExpressionDisplayValue(value);
        this.expressionParser = this.advancedFilterService.createExpressionParser(value);
        var updatedExpression = (_a = this.expressionParser) === null || _a === void 0 ? void 0 : _a.parseExpression();
        if (updatedExpression && updatedExpression !== value) {
            this.eAutocomplete.setValue({ value: updatedExpression, silent: true, restoreFocus: true });
        }
    };
    AdvancedFilterComp.prototype.onValueConfirmed = function (isValid) {
        if (!isValid || this.isApplyDisabled) {
            return;
        }
        _.setDisabled(this.eApplyFilterButton, true);
        this.advancedFilterService.applyExpression();
        this.filterManager.onFilterChanged({ source: 'advancedFilter' });
    };
    AdvancedFilterComp.prototype.onOptionSelected = function (position, updateEntry, type) {
        var _a = this.updateExpression(position, updateEntry, type),
            updatedValue = _a.updatedValue,
            updatedPosition = _a.updatedPosition,
            hideAutocomplete = _a.hideAutocomplete;
        this.eAutocomplete.setValue({
            value: updatedValue,
            position: updatedPosition,
            updateListOnlyIfOpen: hideAutocomplete,
            restoreFocus: true,
        });
    };
    AdvancedFilterComp.prototype.validateValue = function () {
        var _a, _b, _c;
        return ((_a = this.expressionParser) === null || _a === void 0 ? void 0 : _a.isValid())
            ? null
            : (_c = (_b = this.expressionParser) === null || _b === void 0 ? void 0 : _b.getValidationMessage()) !==
                  null && _c !== void 0
            ? _c
            : null;
    };
    AdvancedFilterComp.prototype.onValidChanged = function (isValid, validationMessage) {
        this.isApplyDisabled = !isValid || this.advancedFilterService.isCurrentExpressionApplied();
        _.setDisabled(this.eApplyFilterButton, this.isApplyDisabled);
        this.setTooltip(validationMessage, 1000);
    };
    AdvancedFilterComp.prototype.generateAutocompleteListParams = function (position) {
        return this.expressionParser
            ? this.expressionParser.getAutocompleteListParams(position)
            : this.advancedFilterExpressionService.getDefaultAutocompleteListParams('');
    };
    AdvancedFilterComp.prototype.updateExpression = function (position, updateEntry, type) {
        var _a, _b;
        this.advancedFilterExpressionService.updateAutocompleteCache(updateEntry, type);
        return (_b =
            (_a = this.expressionParser) === null || _a === void 0
                ? void 0
                : _a.updateExpression(position, updateEntry, type)) !== null && _b !== void 0
            ? _b
            : this.advancedFilterService.getDefaultExpression(updateEntry);
    };
    AdvancedFilterComp.prototype.forceLastSelection = function (_a, searchString) {
        var key = _a.key,
            displayValue = _a.displayValue;
        return !!searchString
            .toLocaleLowerCase()
            .match(
                '^' +
                    (displayValue !== null && displayValue !== void 0 ? displayValue : key).toLocaleLowerCase() +
                    '\\s*$',
            );
    };
    AdvancedFilterComp.prototype.openBuilder = function () {
        if (this.builderOpen) {
            return;
        }
        this.builderOpen = true;
        _.setDisabled(this.eBuilderFilterButton, true);
        this.advancedFilterService.getCtrl().toggleFilterBuilder('ui');
    };
    AdvancedFilterComp.prototype.closeBuilder = function () {
        if (!this.builderOpen) {
            return;
        }
        this.builderOpen = false;
        _.setDisabled(this.eBuilderFilterButton, false);
        this.eBuilderFilterButton.focus();
    };
    __decorate$2B([RefSelector('eAutocomplete')], AdvancedFilterComp.prototype, 'eAutocomplete', void 0);
    __decorate$2B([RefSelector('eApplyFilterButton')], AdvancedFilterComp.prototype, 'eApplyFilterButton', void 0);
    __decorate$2B([RefSelector('eBuilderFilterButton')], AdvancedFilterComp.prototype, 'eBuilderFilterButton', void 0);
    __decorate$2B(
        [RefSelector('eBuilderFilterButtonIcon')],
        AdvancedFilterComp.prototype,
        'eBuilderFilterButtonIcon',
        void 0,
    );
    __decorate$2B(
        [RefSelector('eBuilderFilterButtonLabel')],
        AdvancedFilterComp.prototype,
        'eBuilderFilterButtonLabel',
        void 0,
    );
    __decorate$2B([Autowired('advancedFilterService')], AdvancedFilterComp.prototype, 'advancedFilterService', void 0);
    __decorate$2B(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterComp.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2B([Autowired('filterManager')], AdvancedFilterComp.prototype, 'filterManager', void 0);
    __decorate$2B([PostConstruct], AdvancedFilterComp.prototype, 'postConstruct', null);
    return AdvancedFilterComp;
})(Component);

var ADVANCED_FILTER_LOCALE_TEXT = {
    ariaAdvancedFilterBuilderItem: function (variableValues) {
        return variableValues[0] + '. Level ' + variableValues[1] + '. Press ENTER to edit.';
    },
    ariaAdvancedFilterBuilderItemValidation: function (variableValues) {
        return variableValues[0] + '. Level ' + variableValues[1] + '. ' + variableValues[2] + ' Press ENTER to edit.';
    },
    ariaAdvancedFilterBuilderList: 'Advanced Filter Builder List',
    ariaAdvancedFilterBuilderFilterItem: 'Filter Condition',
    ariaAdvancedFilterBuilderGroupItem: 'Filter Group',
    ariaAdvancedFilterBuilderColumn: 'Column',
    ariaAdvancedFilterBuilderOption: 'Option',
    ariaAdvancedFilterBuilderValue: 'Value',
    ariaAdvancedFilterBuilderJoinOperator: 'Join Operator',
    ariaAdvancedFilterInput: 'Advanced Filter Input',
    ariaLabelAdvancedFilterAutocomplete: 'Advanced Filter Autocomplete',
    advancedFilterContains: 'contains',
    advancedFilterNotContains: 'does not contain',
    advancedFilterTextEquals: 'equals',
    advancedFilterTextNotEqual: 'does not equal',
    advancedFilterStartsWith: 'starts with',
    advancedFilterEndsWith: 'ends with',
    advancedFilterBlank: 'is blank',
    advancedFilterNotBlank: 'is not blank',
    advancedFilterEquals: '=',
    advancedFilterNotEqual: '!=',
    advancedFilterGreaterThan: '>',
    advancedFilterGreaterThanOrEqual: '>=',
    advancedFilterLessThan: '<',
    advancedFilterLessThanOrEqual: '<=',
    advancedFilterTrue: 'is true',
    advancedFilterFalse: 'is false',
    advancedFilterAnd: 'AND',
    advancedFilterOr: 'OR',
    advancedFilterApply: 'Apply',
    advancedFilterBuilder: 'Builder',
    advancedFilterValidationMissingColumn: 'Column is missing',
    advancedFilterValidationMissingOption: 'Option is missing',
    advancedFilterValidationMissingValue: 'Value is missing',
    advancedFilterValidationInvalidColumn: 'Column not found',
    advancedFilterValidationInvalidOption: 'Option not found',
    advancedFilterValidationMissingQuote: 'Value is missing an end quote',
    advancedFilterValidationNotANumber: 'Value is not a number',
    advancedFilterValidationInvalidDate: 'Value is not a valid date',
    advancedFilterValidationMissingCondition: 'Condition is missing',
    advancedFilterValidationJoinOperatorMismatch: 'Join operators within a condition must be the same',
    advancedFilterValidationInvalidJoinOperator: 'Join operator not found',
    advancedFilterValidationMissingEndBracket: 'Missing end bracket',
    advancedFilterValidationExtraEndBracket: 'Too many end brackets',
    advancedFilterValidationMessage: function (variableValues) {
        return 'Expression has an error. ' + variableValues[0] + ' - ' + variableValues[1] + '.';
    },
    advancedFilterValidationMessageAtEnd: function (variableValues) {
        return 'Expression has an error. ' + variableValues[0] + ' at end of expression.';
    },
    advancedFilterBuilderTitle: 'Advanced Filter',
    advancedFilterBuilderApply: 'Apply',
    advancedFilterBuilderCancel: 'Cancel',
    advancedFilterBuilderAddButtonTooltip: 'Add Filter or Group',
    advancedFilterBuilderRemoveButtonTooltip: 'Remove',
    advancedFilterBuilderMoveUpButtonTooltip: 'Move Up',
    advancedFilterBuilderMoveDownButtonTooltip: 'Move Down',
    advancedFilterBuilderAddJoin: 'Add Group',
    advancedFilterBuilderAddCondition: 'Add Filter',
    advancedFilterBuilderSelectColumn: 'Select a column',
    advancedFilterBuilderSelectOption: 'Select an option',
    advancedFilterBuilderEnterValue: 'Enter a value...',
    advancedFilterBuilderValidationAlreadyApplied: 'Current filter already applied.',
    advancedFilterBuilderValidationIncomplete: 'Not all conditions are complete.',
    advancedFilterBuilderValidationSelectColumn: 'Must select a column.',
    advancedFilterBuilderValidationSelectOption: 'Must select an option.',
    advancedFilterBuilderValidationEnterValue: 'Must enter a value.',
};

function getSearchString(value, position, endPosition) {
    if (!value) {
        return '';
    }
    var numChars = endPosition - position;
    return numChars ? value.slice(0, value.length - numChars) : value;
}
function updateExpression(expression, startPosition, endPosition, updatedValuePart, appendSpace, appendQuote) {
    var secondPartStartPosition = endPosition + (!expression.length ? 0 : 1);
    var positionOffset = 0;
    if (appendSpace) {
        if (expression[secondPartStartPosition] === ' ') {
            // already a space, just move the position
            positionOffset = 1;
        } else {
            updatedValuePart += ' ';
            if (appendQuote) {
                updatedValuePart += '"';
            }
        }
    }
    var updatedValue =
        expression.slice(0, startPosition) + updatedValuePart + expression.slice(secondPartStartPosition);
    return { updatedValue: updatedValue, updatedPosition: startPosition + updatedValuePart.length + positionOffset };
}
function findStartPosition(expression, position, endPosition) {
    var startPosition = position;
    while (startPosition < endPosition) {
        var char = expression[startPosition];
        if (char !== ' ') {
            break;
        }
        startPosition++;
    }
    return startPosition;
}
function findEndPosition(expression, position) {
    var endPosition = position;
    while (endPosition < expression.length) {
        var char = expression[endPosition];
        if (char === ' ') {
            endPosition = endPosition - 1;
            break;
        }
        endPosition++;
    }
    return endPosition;
}
function checkAndUpdateExpression(params, userValue, displayValue, endPosition) {
    if (displayValue !== userValue) {
        params.expression = updateExpression(
            params.expression,
            endPosition - userValue.length + 1,
            endPosition,
            displayValue,
        ).updatedValue;
    }
}
function escapeQuotes(value) {
    return value.replace(/(['"])/, '\\$1');
}

var __assign$11 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$11 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$11.apply(this, arguments);
    };
var ColumnParser = /** @class */ (function () {
    function ColumnParser(params, startPosition) {
        this.params = params;
        this.startPosition = startPosition;
        this.type = 'column';
        this.valid = true;
        this.hasStartChar = false;
        this.hasEndChar = false;
        this.colName = '';
    }
    ColumnParser.prototype.parse = function (char, position) {
        if (char === ColFilterExpressionParser.COL_START_CHAR && !this.colName) {
            this.hasStartChar = true;
        } else if (char === ColFilterExpressionParser.COL_END_CHAR && this.hasStartChar) {
            var isMatch = this.parseColumn(false, position);
            if (isMatch) {
                this.hasEndChar = true;
                return false;
            } else {
                this.colName += char;
            }
        } else {
            this.colName += char;
        }
        return undefined;
    };
    ColumnParser.prototype.getDisplayValue = function () {
        return (
            (this.hasStartChar ? ColFilterExpressionParser.COL_START_CHAR : '') +
            this.colName +
            (this.hasEndChar ? ColFilterExpressionParser.COL_END_CHAR : '')
        );
    };
    ColumnParser.prototype.getColId = function () {
        return this.colId;
    };
    ColumnParser.prototype.complete = function (position) {
        this.parseColumn(true, position);
    };
    ColumnParser.prototype.getValidationError = function () {
        var _a;
        return this.valid
            ? null
            : {
                  message: this.params.advancedFilterExpressionService.translate(
                      'advancedFilterValidationInvalidColumn',
                  ),
                  startPosition: this.startPosition,
                  endPosition:
                      (_a = this.endPosition) !== null && _a !== void 0 ? _a : this.params.expression.length - 1,
              };
    };
    ColumnParser.prototype.parseColumn = function (fromComplete, endPosition) {
        var _a;
        this.endPosition = endPosition;
        var colValue = this.params.advancedFilterExpressionService.getColId(this.colName);
        if (colValue && this.hasStartChar) {
            this.colId = colValue.colId;
            checkAndUpdateExpression(this.params, this.colName, colValue.columnName, endPosition - 1);
            this.colName = colValue.columnName;
            this.column = this.params.columnModel.getPrimaryColumn(this.colId);
            if (this.column) {
                this.baseCellDataType =
                    (_a = this.params.dataTypeService.getBaseDataType(this.column)) !== null && _a !== void 0
                        ? _a
                        : 'text';
                return true;
            }
        }
        if (fromComplete) {
            this.valid = false;
        }
        this.baseCellDataType = 'text';
        return false;
    };
    return ColumnParser;
})();
var OperatorParser$1 = /** @class */ (function () {
    function OperatorParser(params, startPosition, baseCellDataType) {
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.type = 'operator';
        this.valid = true;
        this.expectedNumOperands = 0;
        this.operator = '';
    }
    OperatorParser.prototype.parse = function (char, position) {
        if (char === ' ' || char === ')') {
            var isMatch = this.parseOperator(false, position - 1);
            if (isMatch) {
                return true;
            } else {
                this.operator += char;
            }
        } else {
            this.operator += char;
        }
        return undefined;
    };
    OperatorParser.prototype.complete = function (position) {
        this.parseOperator(true, position);
    };
    OperatorParser.prototype.getValidationError = function () {
        var _a;
        return this.valid
            ? null
            : {
                  message: this.params.advancedFilterExpressionService.translate(
                      'advancedFilterValidationInvalidOption',
                  ),
                  startPosition: this.startPosition,
                  endPosition:
                      (_a = this.endPosition) !== null && _a !== void 0 ? _a : this.params.expression.length - 1,
              };
    };
    OperatorParser.prototype.getDisplayValue = function () {
        return this.operator;
    };
    OperatorParser.prototype.getOperatorKey = function () {
        return this.parsedOperator;
    };
    OperatorParser.prototype.parseOperator = function (fromComplete, endPosition) {
        var operatorForType = this.params.advancedFilterExpressionService.getDataTypeExpressionOperator(
            this.baseCellDataType,
        );
        var parsedOperator = operatorForType.findOperator(this.operator);
        this.endPosition = endPosition;
        if (parsedOperator) {
            this.parsedOperator = parsedOperator;
            var operator = operatorForType.operators[parsedOperator];
            this.expectedNumOperands = operator.numOperands;
            var operatorDisplayValue = operator.displayValue;
            checkAndUpdateExpression(this.params, this.operator, operatorDisplayValue, endPosition);
            this.operator = operatorDisplayValue;
            return true;
        }
        var isPartialMatch = parsedOperator === null;
        if (fromComplete || !isPartialMatch) {
            this.valid = false;
        }
        return false;
    };
    return OperatorParser;
})();
var OperandParser = /** @class */ (function () {
    function OperandParser(params, startPosition, baseCellDataType, column) {
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.column = column;
        this.type = 'operand';
        this.valid = true;
        this.operand = '';
        this.validationMessage = null;
    }
    OperandParser.prototype.parse = function (char, position) {
        if (char === ' ') {
            if (this.quotes) {
                this.operand += char;
            } else {
                this.parseOperand(false, position);
                return true;
            }
        } else if (char === ')') {
            if (this.baseCellDataType === 'number' || !this.quotes) {
                this.parseOperand(false, position - 1);
                return true;
            } else {
                this.operand += char;
            }
        } else if (!this.operand && !this.quotes && (char === "'" || char === '"')) {
            this.quotes = char;
        } else if (this.quotes && char === this.quotes) {
            this.parseOperand(false, position);
            return false;
        } else {
            this.operand += char;
        }
        return undefined;
    };
    OperandParser.prototype.complete = function (position) {
        this.parseOperand(true, position);
    };
    OperandParser.prototype.getValidationError = function () {
        var _a;
        return this.validationMessage
            ? {
                  message: this.validationMessage,
                  startPosition: this.startPosition,
                  endPosition:
                      (_a = this.endPosition) !== null && _a !== void 0 ? _a : this.params.expression.length - 1,
              }
            : null;
    };
    OperandParser.prototype.getRawValue = function () {
        return this.operand;
    };
    OperandParser.prototype.getModelValue = function () {
        return this.modelValue;
    };
    OperandParser.prototype.parseOperand = function (fromComplete, position) {
        var advancedFilterExpressionService = this.params.advancedFilterExpressionService;
        this.endPosition = position;
        this.modelValue = this.operand;
        if (fromComplete && this.quotes) {
            // missing end quote
            this.valid = false;
            this.validationMessage = advancedFilterExpressionService.translate('advancedFilterValidationMissingQuote');
        } else if (this.modelValue === '') {
            this.valid = false;
            this.validationMessage = advancedFilterExpressionService.translate('advancedFilterValidationMissingValue');
        } else {
            var modelValue = advancedFilterExpressionService.getOperandModelValue(
                this.operand,
                this.baseCellDataType,
                this.column,
            );
            if (modelValue != null) {
                this.modelValue = modelValue;
            }
            switch (this.baseCellDataType) {
                case 'number':
                    if (this.quotes || isNaN(this.modelValue)) {
                        this.valid = false;
                        this.validationMessage = advancedFilterExpressionService.translate(
                            'advancedFilterValidationNotANumber',
                        );
                    }
                    break;
                case 'date':
                case 'dateString':
                    if (modelValue == null) {
                        this.valid = false;
                        this.validationMessage = advancedFilterExpressionService.translate(
                            'advancedFilterValidationInvalidDate',
                        );
                    }
                    break;
            }
        }
    };
    return OperandParser;
})();
var ColFilterExpressionParser = /** @class */ (function () {
    function ColFilterExpressionParser(params, startPosition) {
        this.params = params;
        this.startPosition = startPosition;
        this.isAwaiting = true;
    }
    ColFilterExpressionParser.prototype.parseExpression = function () {
        var _a, _b;
        var i = this.startPosition;
        var expression = this.params.expression;
        while (i < expression.length) {
            var char = expression[i];
            if (char === ' ' && this.isAwaiting);
            else {
                this.isAwaiting = false;
                if (!this.parser) {
                    var parser = void 0;
                    if (!this.columnParser) {
                        this.columnParser = new ColumnParser(this.params, i);
                        parser = this.columnParser;
                    } else if (!this.operatorParser) {
                        this.operatorParser = new OperatorParser$1(this.params, i, this.columnParser.baseCellDataType);
                        parser = this.operatorParser;
                    } else {
                        this.operandParser = new OperandParser(
                            this.params,
                            i,
                            this.columnParser.baseCellDataType,
                            this.columnParser.column,
                        );
                        parser = this.operandParser;
                    }
                    this.parser = parser;
                }
                var hasCompletedOnPrevChar = this.parser.parse(char, i);
                if (hasCompletedOnPrevChar != null) {
                    if (this.isComplete()) {
                        return this.returnEndPosition(hasCompletedOnPrevChar ? i - 1 : i, true);
                    }
                    this.parser = undefined;
                    this.isAwaiting = true;
                }
            }
            i++;
        }
        (_b = (_a = this.parser) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0
            ? void 0
            : _b.call(_a, i - 1);
        return this.returnEndPosition(i);
    };
    ColFilterExpressionParser.prototype.isValid = function () {
        return (
            this.isComplete() &&
            this.columnParser.valid &&
            this.operatorParser.valid &&
            (!this.operandParser || this.operandParser.valid)
        );
    };
    ColFilterExpressionParser.prototype.getValidationError = function () {
        var _a, _b, _c, _d, _e;
        var validationError =
            (_d =
                (_b = (_a = this.columnParser) === null || _a === void 0 ? void 0 : _a.getValidationError()) !== null &&
                _b !== void 0
                    ? _b
                    : (_c = this.operatorParser) === null || _c === void 0
                    ? void 0
                    : _c.getValidationError()) !== null && _d !== void 0
                ? _d
                : (_e = this.operandParser) === null || _e === void 0
                ? void 0
                : _e.getValidationError();
        if (validationError) {
            return validationError;
        }
        var endPosition = this.params.expression.length;
        var translateKey;
        if (!this.columnParser) {
            translateKey = 'advancedFilterValidationMissingColumn';
        } else if (!this.operatorParser) {
            translateKey = 'advancedFilterValidationMissingOption';
        } else if (this.operatorParser.expectedNumOperands && !this.operandParser) {
            translateKey = 'advancedFilterValidationMissingValue';
        }
        if (translateKey) {
            return {
                message: this.params.advancedFilterExpressionService.translate(translateKey),
                startPosition: endPosition,
                endPosition: endPosition,
            };
        }
        return null;
    };
    ColFilterExpressionParser.prototype.getFunction = function (params) {
        var _a, _b;
        var colId = this.columnParser.getColId();
        var escapedColId = escapeQuotes(colId);
        var operator = (_a = this.operatorParser) === null || _a === void 0 ? void 0 : _a.getOperatorKey();
        var operators = params.operators,
            evaluatorParams = params.evaluatorParams,
            operands = params.operands;
        var operatorForColumn = this.params.advancedFilterExpressionService.getExpressionOperator(
            this.columnParser.baseCellDataType,
            operator,
        );
        var operatorIndex = this.addToListAndGetIndex(operators, operatorForColumn);
        var evaluatorParamsForColumn = this.params.advancedFilterExpressionService.getExpressionEvaluatorParams(colId);
        var evaluatorParamsIndex = this.addToListAndGetIndex(evaluatorParams, evaluatorParamsForColumn);
        var operand;
        if (((_b = this.operatorParser) === null || _b === void 0 ? void 0 : _b.expectedNumOperands) === 0) {
            operand = '';
        } else {
            var operandIndex = this.addToListAndGetIndex(operands, this.getOperandValue());
            operand = ', params.operands[' + operandIndex + ']';
        }
        return (
            'params.operators[' +
            operatorIndex +
            "].evaluator(expressionProxy.getValue('" +
            escapedColId +
            "', node), node, params.evaluatorParams[" +
            evaluatorParamsIndex +
            ']' +
            operand +
            ')'
        );
    };
    ColFilterExpressionParser.prototype.getAutocompleteListParams = function (position) {
        if (this.isColumnPosition(position)) {
            return this.getColumnAutocompleteListParams(position);
        }
        if (this.isOperatorPosition(position)) {
            return this.getOperatorAutocompleteListParams(position);
        }
        if (this.isBeyondEndPosition(position)) {
            return undefined;
        }
        return { enabled: false };
    };
    ColFilterExpressionParser.prototype.updateExpression = function (position, updateEntry, type) {
        var _a, _b, _c, _d, _e;
        var expression = this.params.expression;
        if (this.isColumnPosition(position)) {
            return updateExpression(
                this.params.expression,
                this.startPosition,
                ((_a = this.columnParser) === null || _a === void 0 ? void 0 : _a.getColId())
                    ? this.columnParser.endPosition
                    : findEndPosition(expression, position),
                this.params.advancedFilterExpressionService.getColumnValue(updateEntry),
                true,
            );
        } else if (this.isOperatorPosition(position)) {
            var baseCellDataType = this.getBaseCellDataTypeFromOperatorAutocompleteType(type);
            var hasOperand = this.hasOperand(baseCellDataType, updateEntry.key);
            var doesOperandNeedQuotes = hasOperand && this.doesOperandNeedQuotes(baseCellDataType);
            var update = void 0;
            if (
                ((_b = this.operatorParser) === null || _b === void 0 ? void 0 : _b.startPosition) != null &&
                position < this.operatorParser.startPosition
            ) {
                // in between multiple spaces, just insert direct
                update = updateExpression(
                    expression,
                    position,
                    position,
                    (_c = updateEntry.displayValue) !== null && _c !== void 0 ? _c : updateEntry.key,
                    hasOperand,
                    doesOperandNeedQuotes,
                );
            } else {
                var endPosition = ((_d = this.operatorParser) === null || _d === void 0 ? void 0 : _d.getOperatorKey())
                    ? this.operatorParser.endPosition
                    : findEndPosition(expression, position);
                update = updateExpression(
                    expression,
                    findStartPosition(expression, this.columnParser.endPosition + 1, endPosition),
                    endPosition,
                    (_e = updateEntry.displayValue) !== null && _e !== void 0 ? _e : updateEntry.key,
                    hasOperand,
                    doesOperandNeedQuotes,
                );
            }
            return __assign$11(__assign$11({}, update), { hideAutocomplete: !hasOperand });
        }
        return null;
    };
    ColFilterExpressionParser.prototype.getModel = function () {
        var colId = this.columnParser.getColId();
        var model = {
            filterType: this.columnParser.baseCellDataType,
            colId: colId,
            type: this.operatorParser.getOperatorKey(),
        };
        if (this.operatorParser.expectedNumOperands) {
            model.filter = this.operandParser.getModelValue();
        }
        return model;
    };
    ColFilterExpressionParser.prototype.getOperandValue = function () {
        var operand = this.operandParser.getRawValue();
        var _a = this.columnParser,
            baseCellDataType = _a.baseCellDataType,
            column = _a.column;
        switch (baseCellDataType) {
            case 'number':
                operand = Number(operand);
                break;
            case 'date':
            case 'dateString':
                operand = this.params.valueParserService.parseValue(column, null, operand, undefined);
                break;
        }
        if (baseCellDataType === 'dateString') {
            return this.params.dataTypeService.getDateParserFunction()(operand);
        }
        return operand;
    };
    ColFilterExpressionParser.prototype.isComplete = function () {
        return !!(
            this.operatorParser &&
            (!this.operatorParser.expectedNumOperands ||
                (this.operatorParser.expectedNumOperands && this.operandParser))
        );
    };
    ColFilterExpressionParser.prototype.isColumnPosition = function (position) {
        return (
            !this.columnParser || this.columnParser.endPosition == null || position <= this.columnParser.endPosition + 1
        );
    };
    ColFilterExpressionParser.prototype.isOperatorPosition = function (position) {
        return (
            !this.operatorParser ||
            this.operatorParser.endPosition == null ||
            position <= this.operatorParser.endPosition + 1
        );
    };
    ColFilterExpressionParser.prototype.isBeyondEndPosition = function (position) {
        return (
            this.isComplete() &&
            this.endPosition != null &&
            position > this.endPosition + 1 &&
            this.endPosition + 1 < this.params.expression.length
        );
    };
    ColFilterExpressionParser.prototype.returnEndPosition = function (returnPosition, treatAsEnd) {
        this.endPosition = treatAsEnd ? returnPosition : returnPosition - 1;
        return returnPosition;
    };
    ColFilterExpressionParser.prototype.getColumnAutocompleteListParams = function (position) {
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(
            this.params.advancedFilterExpressionService.getColumnAutocompleteEntries(),
            'column',
            this.getColumnSearchString(position),
        );
    };
    ColFilterExpressionParser.prototype.getColumnSearchString = function (position) {
        var _a, _b, _c, _d, _e;
        var columnName =
            (_b = (_a = this.columnParser) === null || _a === void 0 ? void 0 : _a.getDisplayValue()) !== null &&
            _b !== void 0
                ? _b
                : '';
        var searchString = getSearchString(
            columnName,
            position,
            ((_c = this.columnParser) === null || _c === void 0 ? void 0 : _c.endPosition) == null
                ? this.params.expression.length
                : this.columnParser.endPosition + 1,
        );
        var containsStartChar =
            ((_d = this.columnParser) === null || _d === void 0 ? void 0 : _d.hasStartChar) && searchString.length > 0;
        var containsEndChar =
            ((_e = this.columnParser) === null || _e === void 0 ? void 0 : _e.hasEndChar) &&
            searchString.length === columnName.length + 2;
        if (containsStartChar) {
            return searchString.slice(1, containsEndChar ? -1 : undefined);
        }
        return searchString;
    };
    ColFilterExpressionParser.prototype.getOperatorAutocompleteListParams = function (position) {
        var _a, _b, _c, _d, _e;
        var column = (_a = this.columnParser) === null || _a === void 0 ? void 0 : _a.column;
        if (!column) {
            return { enabled: false };
        }
        var baseCellDataType = this.columnParser.baseCellDataType;
        var searchString =
            ((_b = this.operatorParser) === null || _b === void 0 ? void 0 : _b.startPosition) != null &&
            position < this.operatorParser.startPosition
                ? ''
                : getSearchString(
                      (_d = (_c = this.operatorParser) === null || _c === void 0 ? void 0 : _c.getDisplayValue()) !==
                          null && _d !== void 0
                          ? _d
                          : '',
                      position,
                      ((_e = this.operatorParser) === null || _e === void 0 ? void 0 : _e.endPosition) == null
                          ? this.params.expression.length
                          : this.operatorParser.endPosition + 1,
                  );
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(
            this.params.advancedFilterExpressionService.getOperatorAutocompleteEntries(column, baseCellDataType),
            'operator-' + baseCellDataType,
            searchString,
        );
    };
    ColFilterExpressionParser.prototype.getBaseCellDataTypeFromOperatorAutocompleteType = function (type) {
        return type === null || type === void 0 ? void 0 : type.replace('operator-', '');
    };
    ColFilterExpressionParser.prototype.hasOperand = function (baseCellDataType, operator) {
        var _a, _b;
        return (
            !baseCellDataType ||
            !operator ||
            ((_b =
                (_a = this.params.advancedFilterExpressionService.getExpressionOperator(baseCellDataType, operator)) ===
                    null || _a === void 0
                    ? void 0
                    : _a.numOperands) !== null && _b !== void 0
                ? _b
                : 0) > 0
        );
    };
    ColFilterExpressionParser.prototype.doesOperandNeedQuotes = function (baseCellDataType) {
        return baseCellDataType !== 'number';
    };
    ColFilterExpressionParser.prototype.addToListAndGetIndex = function (list, value) {
        var index = list.length;
        list.push(value);
        return index;
    };
    ColFilterExpressionParser.COL_START_CHAR = '[';
    ColFilterExpressionParser.COL_END_CHAR = ']';
    return ColFilterExpressionParser;
})();

var __read$1o =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
// null = partial match, undefined = no match
function findMatch(searchValue, values, getDisplayValue) {
    var partialMatch = false;
    var searchValueLowerCase = searchValue.toLocaleLowerCase();
    var partialSearchValue = searchValueLowerCase + ' ';
    var parsedValue = Object.entries(values).find(function (_a) {
        var _b = __read$1o(_a, 2);
        _b[0];
        var value = _b[1];
        var displayValueLowerCase = getDisplayValue(value).toLocaleLowerCase();
        if (displayValueLowerCase.startsWith(partialSearchValue)) {
            partialMatch = true;
        }
        return displayValueLowerCase === searchValueLowerCase;
    });
    if (parsedValue) {
        return parsedValue[0];
    } else if (partialMatch) {
        return null;
    } else {
        return undefined;
    }
}
function getEntries(operators, activeOperatorKeys) {
    var keys =
        activeOperatorKeys !== null && activeOperatorKeys !== void 0 ? activeOperatorKeys : Object.keys(operators);
    return keys.map(function (key) {
        return {
            key: key,
            displayValue: operators[key].displayValue,
        };
    });
}
var TextFilterExpressionOperators = /** @class */ (function () {
    function TextFilterExpressionOperators(params) {
        this.params = params;
        this.initOperators();
    }
    TextFilterExpressionOperators.prototype.getEntries = function (activeOperators) {
        return getEntries(this.operators, activeOperators);
    };
    TextFilterExpressionOperators.prototype.findOperator = function (displayValue) {
        return findMatch(displayValue, this.operators, function (_a) {
            var displayValue = _a.displayValue;
            return displayValue;
        });
    };
    TextFilterExpressionOperators.prototype.initOperators = function () {
        var _this = this;
        var translate = this.params.translate;
        this.operators = {
            contains: {
                displayValue: translate('advancedFilterContains'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, false, function (v, o) {
                        return v.includes(o);
                    });
                },
                numOperands: 1,
            },
            notContains: {
                displayValue: translate('advancedFilterNotContains'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, true, function (v, o) {
                        return !v.includes(o);
                    });
                },
                numOperands: 1,
            },
            equals: {
                displayValue: translate('advancedFilterTextEquals'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, false, function (v, o) {
                        return v === o;
                    });
                },
                numOperands: 1,
            },
            notEqual: {
                displayValue: translate('advancedFilterTextNotEqual'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, true, function (v, o) {
                        return v != o;
                    });
                },
                numOperands: 1,
            },
            startsWith: {
                displayValue: translate('advancedFilterStartsWith'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, false, function (v, o) {
                        return v.startsWith(o);
                    });
                },
                numOperands: 1,
            },
            endsWith: {
                displayValue: translate('advancedFilterEndsWith'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateExpression(value, node, params, operand1, false, function (v, o) {
                        return v.endsWith(o);
                    });
                },
                numOperands: 1,
            },
            blank: {
                displayValue: translate('advancedFilterBlank'),
                evaluator: function (value) {
                    return value == null || (typeof value === 'string' && value.trim().length === 0);
                },
                numOperands: 0,
            },
            notBlank: {
                displayValue: translate('advancedFilterNotBlank'),
                evaluator: function (value) {
                    return value != null && (typeof value !== 'string' || value.trim().length > 0);
                },
                numOperands: 0,
            },
        };
    };
    TextFilterExpressionOperators.prototype.evaluateExpression = function (
        value,
        node,
        params,
        operand,
        nullsMatch,
        expression,
    ) {
        if (value == null) {
            return nullsMatch;
        }
        return params.caseSensitive
            ? expression(params.valueConverter(value, node), operand)
            : expression(params.valueConverter(value, node).toLocaleLowerCase(), operand.toLocaleLowerCase());
    };
    return TextFilterExpressionOperators;
})();
var ScalarFilterExpressionOperators = /** @class */ (function () {
    function ScalarFilterExpressionOperators(params) {
        this.params = params;
        this.initOperators();
    }
    ScalarFilterExpressionOperators.prototype.getEntries = function (activeOperators) {
        return getEntries(this.operators, activeOperators);
    };
    ScalarFilterExpressionOperators.prototype.findOperator = function (displayValue) {
        return findMatch(displayValue, this.operators, function (_a) {
            var displayValue = _a.displayValue;
            return displayValue;
        });
    };
    ScalarFilterExpressionOperators.prototype.initOperators = function () {
        var _this = this;
        var _a = this.params,
            translate = _a.translate,
            equals = _a.equals;
        this.operators = {
            equals: {
                displayValue: translate('advancedFilterEquals'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInEquals,
                        equals,
                    );
                },
                numOperands: 1,
            },
            notEqual: {
                displayValue: translate('advancedFilterNotEqual'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInEquals,
                        function (v, o) {
                            return !equals(v, o);
                        },
                    );
                },
                numOperands: 1,
            },
            greaterThan: {
                displayValue: translate('advancedFilterGreaterThan'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInGreaterThan,
                        function (v, o) {
                            return v > o;
                        },
                    );
                },
                numOperands: 1,
            },
            greaterThanOrEqual: {
                displayValue: translate('advancedFilterGreaterThanOrEqual'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInGreaterThan,
                        function (v, o) {
                            return v >= o;
                        },
                    );
                },
                numOperands: 1,
            },
            lessThan: {
                displayValue: translate('advancedFilterLessThan'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInLessThan,
                        function (v, o) {
                            return v < o;
                        },
                    );
                },
                numOperands: 1,
            },
            lessThanOrEqual: {
                displayValue: translate('advancedFilterLessThanOrEqual'),
                evaluator: function (value, node, params, operand1) {
                    return _this.evaluateSingleOperandExpression(
                        value,
                        node,
                        params,
                        operand1,
                        !!params.includeBlanksInLessThan,
                        function (v, o) {
                            return v <= o;
                        },
                    );
                },
                numOperands: 1,
            },
            blank: {
                displayValue: translate('advancedFilterBlank'),
                evaluator: function (value) {
                    return value == null;
                },
                numOperands: 0,
            },
            notBlank: {
                displayValue: translate('advancedFilterNotBlank'),
                evaluator: function (value) {
                    return value != null;
                },
                numOperands: 0,
            },
        };
    };
    ScalarFilterExpressionOperators.prototype.evaluateSingleOperandExpression = function (
        value,
        node,
        params,
        operand,
        nullsMatch,
        expression,
    ) {
        if (value == null) {
            return nullsMatch;
        }
        return expression(params.valueConverter(value, node), operand);
    };
    return ScalarFilterExpressionOperators;
})();
var BooleanFilterExpressionOperators = /** @class */ (function () {
    function BooleanFilterExpressionOperators(params) {
        this.params = params;
        this.initOperators();
    }
    BooleanFilterExpressionOperators.prototype.getEntries = function (activeOperators) {
        return getEntries(this.operators, activeOperators);
    };
    BooleanFilterExpressionOperators.prototype.findOperator = function (displayValue) {
        return findMatch(displayValue, this.operators, function (_a) {
            var displayValue = _a.displayValue;
            return displayValue;
        });
    };
    BooleanFilterExpressionOperators.prototype.initOperators = function () {
        var translate = this.params.translate;
        this.operators = {
            true: {
                displayValue: translate('advancedFilterTrue'),
                evaluator: function (value) {
                    return !!value;
                },
                numOperands: 0,
            },
            false: {
                displayValue: translate('advancedFilterFalse'),
                evaluator: function (value) {
                    return value === false;
                },
                numOperands: 0,
            },
            blank: {
                displayValue: translate('advancedFilterBlank'),
                evaluator: function (value) {
                    return value == null;
                },
                numOperands: 0,
            },
            notBlank: {
                displayValue: translate('advancedFilterNotBlank'),
                evaluator: function (value) {
                    return value != null;
                },
                numOperands: 0,
            },
        };
    };
    return BooleanFilterExpressionOperators;
})();

var __extends$3q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2A =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1n =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var AdvancedFilterExpressionService = /** @class */ (function (_super) {
    __extends$3q(AdvancedFilterExpressionService, _super);
    function AdvancedFilterExpressionService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.columnNameToIdMap = {};
        _this.columnAutocompleteEntries = null;
        _this.expressionEvaluatorParams = {};
        return _this;
    }
    AdvancedFilterExpressionService.prototype.postConstruct = function () {
        this.expressionJoinOperators = this.generateExpressionJoinOperators();
        this.expressionOperators = this.generateExpressionOperators();
    };
    AdvancedFilterExpressionService.prototype.parseJoinOperator = function (model) {
        var _a;
        var type = model.type;
        return (_a = this.expressionJoinOperators[type]) !== null && _a !== void 0 ? _a : type;
    };
    AdvancedFilterExpressionService.prototype.getColumnDisplayValue = function (model) {
        var colId = model.colId;
        var columnEntries = this.getColumnAutocompleteEntries();
        var columnEntry = columnEntries.find(function (_a) {
            var key = _a.key;
            return key === colId;
        });
        var columnName;
        if (columnEntry) {
            columnName = columnEntry.displayValue;
            this.columnNameToIdMap[columnName.toLocaleUpperCase()] = { colId: colId, columnName: columnName };
        } else {
            columnName = colId;
        }
        return columnName;
    };
    AdvancedFilterExpressionService.prototype.getOperatorDisplayValue = function (model) {
        var _a, _b;
        return (_b =
            (_a = this.getExpressionOperator(model.filterType, model.type)) === null || _a === void 0
                ? void 0
                : _a.displayValue) !== null && _b !== void 0
            ? _b
            : model.type;
    };
    AdvancedFilterExpressionService.prototype.getOperandModelValue = function (operand, baseCellDataType, column) {
        var _a;
        switch (baseCellDataType) {
            case 'number':
                return _.exists(operand) ? Number(operand) : null;
            case 'date':
                return _.serialiseDate(this.valueParserService.parseValue(column, null, operand, undefined), false);
            case 'dateString':
                // displayed string format may be different from data string format, so parse before converting to date
                var parsedDateString = this.valueParserService.parseValue(column, null, operand, undefined);
                return _.serialiseDate(
                    (_a = this.dataTypeService.getDateParserFunction()(parsedDateString)) !== null && _a !== void 0
                        ? _a
                        : null,
                    false,
                );
        }
        return operand;
    };
    AdvancedFilterExpressionService.prototype.getOperandDisplayValue = function (model, skipFormatting) {
        var _a, _b;
        var _c = model,
            colId = _c.colId,
            filter = _c.filter;
        var column = this.columnModel.getPrimaryColumn(colId);
        var operand = '';
        if (filter != null) {
            var operand1 = void 0;
            switch (model.filterType) {
                case 'number':
                    operand1 = (_a = _.toStringOrNull(filter)) !== null && _a !== void 0 ? _a : '';
                    break;
                case 'date':
                    var dateValue = _.parseDateTimeFromString(filter);
                    operand1 = column ? this.valueFormatterService.formatValue(column, null, dateValue) : null;
                    break;
                case 'dateString':
                    // need to convert from ISO date string to Date to data string format to formatted string format
                    var dateStringDateValue = _.parseDateTimeFromString(filter);
                    var dateStringStringValue = column
                        ? this.dataTypeService.getDateFormatterFunction()(
                              dateStringDateValue !== null && dateStringDateValue !== void 0
                                  ? dateStringDateValue
                                  : undefined,
                          )
                        : null;
                    operand1 = column
                        ? this.valueFormatterService.formatValue(column, null, dateStringStringValue)
                        : null;
                    break;
            }
            if (model.filterType !== 'number') {
                operand1 =
                    (_b = operand1 !== null && operand1 !== void 0 ? operand1 : _.toStringOrNull(filter)) !== null &&
                    _b !== void 0
                        ? _b
                        : '';
                if (!skipFormatting) {
                    operand1 = '"' + operand1 + '"';
                }
            }
            operand = skipFormatting ? operand1 : ' ' + operand1;
        }
        return operand;
    };
    AdvancedFilterExpressionService.prototype.parseColumnFilterModel = function (model) {
        var _a, _b;
        var columnName = (_a = this.getColumnDisplayValue(model)) !== null && _a !== void 0 ? _a : '';
        var operator = (_b = this.getOperatorDisplayValue(model)) !== null && _b !== void 0 ? _b : '';
        var operands = this.getOperandDisplayValue(model);
        return '[' + columnName + '] ' + operator + operands;
    };
    AdvancedFilterExpressionService.prototype.updateAutocompleteCache = function (updateEntry, type) {
        if (type === 'column') {
            var colId = updateEntry.key,
                displayValue = updateEntry.displayValue;
            this.columnNameToIdMap[updateEntry.displayValue.toLocaleUpperCase()] = {
                colId: colId,
                columnName: displayValue,
            };
        }
    };
    AdvancedFilterExpressionService.prototype.translate = function (key, variableValues) {
        var defaultValue = ADVANCED_FILTER_LOCALE_TEXT[key];
        if (typeof defaultValue === 'function') {
            defaultValue = defaultValue(variableValues);
        }
        return this.localeService.getLocaleTextFunc()(key, defaultValue, variableValues);
    };
    AdvancedFilterExpressionService.prototype.generateAutocompleteListParams = function (entries, type, searchString) {
        return {
            enabled: true,
            type: type,
            searchString: searchString,
            entries: entries,
        };
    };
    AdvancedFilterExpressionService.prototype.getColumnAutocompleteEntries = function () {
        var _this = this;
        var _a;
        if (this.columnAutocompleteEntries) {
            return this.columnAutocompleteEntries;
        }
        var columns = (_a = this.columnModel.getAllPrimaryColumns()) !== null && _a !== void 0 ? _a : [];
        var entries = [];
        var includeHiddenColumns = this.gridOptionsService.is('includeHiddenColumnsInAdvancedFilter');
        columns.forEach(function (column) {
            if (
                column.getColDef().filter &&
                (includeHiddenColumns || column.isVisible() || column.isRowGroupActive())
            ) {
                entries.push({
                    key: column.getColId(),
                    displayValue: _this.columnModel.getDisplayNameForColumn(column, 'advancedFilter'),
                });
            }
        });
        entries.sort(function (a, b) {
            var _a, _b;
            var aValue = (_a = a.displayValue) !== null && _a !== void 0 ? _a : '';
            var bValue = (_b = b.displayValue) !== null && _b !== void 0 ? _b : '';
            if (aValue < bValue) {
                return -1;
            } else if (bValue > aValue) {
                return 1;
            }
            return 0;
        });
        return entries;
    };
    AdvancedFilterExpressionService.prototype.getOperatorAutocompleteEntries = function (column, baseCellDataType) {
        var activeOperators = this.getActiveOperators(column);
        return this.getDataTypeExpressionOperator(baseCellDataType).getEntries(activeOperators);
    };
    AdvancedFilterExpressionService.prototype.getJoinOperatorAutocompleteEntries = function () {
        return Object.entries(this.expressionJoinOperators).map(function (_a) {
            var _b = __read$1n(_a, 2),
                key = _b[0],
                displayValue = _b[1];
            return { key: key, displayValue: displayValue };
        });
    };
    AdvancedFilterExpressionService.prototype.getDefaultAutocompleteListParams = function (searchString) {
        return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), 'column', searchString);
    };
    AdvancedFilterExpressionService.prototype.getDataTypeExpressionOperator = function (baseCellDataType) {
        return this.expressionOperators[baseCellDataType];
    };
    AdvancedFilterExpressionService.prototype.getExpressionOperator = function (baseCellDataType, operator) {
        var _a, _b;
        return (_b =
            (_a = this.getDataTypeExpressionOperator(baseCellDataType)) === null || _a === void 0
                ? void 0
                : _a.operators) === null || _b === void 0
            ? void 0
            : _b[operator];
    };
    AdvancedFilterExpressionService.prototype.getExpressionJoinOperators = function () {
        return this.expressionJoinOperators;
    };
    AdvancedFilterExpressionService.prototype.getColId = function (columnName) {
        var upperCaseColumnName = columnName.toLocaleUpperCase();
        var cachedColId = this.columnNameToIdMap[upperCaseColumnName];
        if (cachedColId) {
            return cachedColId;
        }
        var columnAutocompleteEntries = this.getColumnAutocompleteEntries();
        var colEntry = columnAutocompleteEntries.find(function (_a) {
            var displayValue = _a.displayValue;
            return displayValue.toLocaleUpperCase() === upperCaseColumnName;
        });
        if (colEntry) {
            var colId = colEntry.key,
                displayValue = colEntry.displayValue;
            var colValue = { colId: colId, columnName: displayValue };
            // cache for faster lookup
            this.columnNameToIdMap[upperCaseColumnName] = colValue;
            return colValue;
        }
        return null;
    };
    AdvancedFilterExpressionService.prototype.getExpressionEvaluatorParams = function (colId) {
        var _this = this;
        var params = this.expressionEvaluatorParams[colId];
        if (params) {
            return params;
        }
        var column = this.columnModel.getPrimaryColumn(colId);
        if (!column) {
            return {
                valueConverter: function (v) {
                    return v;
                },
            };
        }
        var baseCellDataType = this.dataTypeService.getBaseDataType(column);
        switch (baseCellDataType) {
            case 'dateString':
                params = {
                    valueConverter: this.dataTypeService.getDateParserFunction(),
                };
                break;
            case 'object':
                // If there's a filter value getter, assume the value is already a string. Otherwise we need to format it.
                if (column.getColDef().filterValueGetter) {
                    params = {
                        valueConverter: function (v) {
                            return v;
                        },
                    };
                } else {
                    params = {
                        valueConverter: function (value, node) {
                            var _a;
                            return (_a = _this.valueFormatterService.formatValue(column, node, value)) !== null &&
                                _a !== void 0
                                ? _a
                                : typeof value.toString === 'function'
                                ? value.toString()
                                : '';
                        },
                    };
                }
                break;
            case 'text':
            case undefined:
                params = {
                    valueConverter: function (v) {
                        return _.toStringOrNull(v);
                    },
                };
                break;
            default:
                params = {
                    valueConverter: function (v) {
                        return v;
                    },
                };
                break;
        }
        var filterParams = column.getColDef().filterParams;
        if (filterParams) {
            ['caseSensitive', 'includeBlanksInEquals', 'includeBlanksInLessThan', 'includeBlanksInGreaterThan'].forEach(
                function (param) {
                    var paramValue = filterParams[param];
                    if (paramValue) {
                        params[param] = paramValue;
                    }
                },
            );
        }
        this.expressionEvaluatorParams[colId] = params;
        return params;
    };
    AdvancedFilterExpressionService.prototype.getColumnDetails = function (colId) {
        var column = this.columnModel.getPrimaryColumn(colId);
        if (!column) {
            return null;
        }
        var baseCellDataType = this.dataTypeService.getBaseDataType(column);
        if (!baseCellDataType) {
            return null;
        }
        return { column: column, baseCellDataType: baseCellDataType };
    };
    AdvancedFilterExpressionService.prototype.generateExpressionOperators = function () {
        var _this = this;
        var translate = function (key, variableValues) {
            return _this.translate(key, variableValues);
        };
        return {
            text: new TextFilterExpressionOperators({ translate: translate }),
            boolean: new BooleanFilterExpressionOperators({ translate: translate }),
            object: new TextFilterExpressionOperators({ translate: translate }),
            number: new ScalarFilterExpressionOperators({
                translate: translate,
                equals: function (v, o) {
                    return v === o;
                },
            }),
            date: new ScalarFilterExpressionOperators({
                translate: translate,
                equals: function (v, o) {
                    return v.getTime() === o.getTime();
                },
            }),
            dateString: new ScalarFilterExpressionOperators({
                translate: translate,
                equals: function (v, o) {
                    return v.getTime() === o.getTime();
                },
            }),
        };
    };
    AdvancedFilterExpressionService.prototype.getColumnValue = function (_a) {
        var displayValue = _a.displayValue;
        return '' + ColFilterExpressionParser.COL_START_CHAR + displayValue + ColFilterExpressionParser.COL_END_CHAR;
    };
    AdvancedFilterExpressionService.prototype.generateExpressionJoinOperators = function () {
        return {
            AND: this.translate('advancedFilterAnd'),
            OR: this.translate('advancedFilterOr'),
        };
    };
    AdvancedFilterExpressionService.prototype.getActiveOperators = function (column) {
        var _a;
        var filterOptions =
            (_a = column.getColDef().filterParams) === null || _a === void 0 ? void 0 : _a.filterOptions;
        if (!filterOptions) {
            return undefined;
        }
        var isValid = filterOptions.every(function (filterOption) {
            return typeof filterOption === 'string';
        });
        return isValid ? filterOptions : undefined;
    };
    AdvancedFilterExpressionService.prototype.resetColumnCaches = function () {
        this.columnAutocompleteEntries = null;
        this.columnNameToIdMap = {};
    };
    __decorate$2A(
        [Autowired('valueFormatterService')],
        AdvancedFilterExpressionService.prototype,
        'valueFormatterService',
        void 0,
    );
    __decorate$2A(
        [Autowired('valueParserService')],
        AdvancedFilterExpressionService.prototype,
        'valueParserService',
        void 0,
    );
    __decorate$2A([Autowired('columnModel')], AdvancedFilterExpressionService.prototype, 'columnModel', void 0);
    __decorate$2A([Autowired('dataTypeService')], AdvancedFilterExpressionService.prototype, 'dataTypeService', void 0);
    __decorate$2A([PostConstruct], AdvancedFilterExpressionService.prototype, 'postConstruct', null);
    AdvancedFilterExpressionService = __decorate$2A(
        [Bean('advancedFilterExpressionService')],
        AdvancedFilterExpressionService,
    );
    return AdvancedFilterExpressionService;
})(BeanStub);

var OperatorParser = /** @class */ (function () {
    function OperatorParser(params) {
        this.params = params;
        this.operators = [];
        this.operatorStartPositions = [];
        this.operatorEndPositions = [];
        this.activeOperator = 0;
        this.validationError = null;
    }
    OperatorParser.prototype.parseExpression = function (i) {
        this.operators.push('');
        this.operatorStartPositions.push(i);
        this.operatorEndPositions.push(undefined);
        var expression = this.params.expression;
        while (i < expression.length) {
            var char = expression[i];
            if (char === ' ') {
                var isComplete = this.parseOperator(i - 1);
                if (isComplete) {
                    this.activeOperator++;
                    return i - 1;
                } else {
                    this.operators[this.activeOperator] += char;
                }
            } else {
                this.operators[this.activeOperator] += char;
            }
            i++;
        }
        this.parseOperator(i - 1);
        return i;
    };
    OperatorParser.prototype.isValid = function () {
        return !this.validationError && (!this.operators.length || !!this.parsedOperator);
    };
    OperatorParser.prototype.getValidationError = function () {
        return this.validationError;
    };
    OperatorParser.prototype.getFunction = function () {
        return this.parsedOperator === 'OR' ? '||' : '&&';
    };
    OperatorParser.prototype.getModel = function () {
        return this.parsedOperator === 'OR' ? 'OR' : 'AND';
    };
    OperatorParser.prototype.getAutocompleteListParams = function (position, operatorIndex) {
        var _this = this;
        var searchString;
        if (operatorIndex == null) {
            searchString = '';
        } else {
            var operator = this.operators[operatorIndex];
            var operatorEndPosition = this.operatorEndPositions[operatorIndex];
            searchString = getSearchString(
                operator,
                position,
                operatorEndPosition == null ? this.params.expression.length : operatorEndPosition + 1,
            );
        }
        var entries = this.params.advancedFilterExpressionService.getJoinOperatorAutocompleteEntries();
        if (operatorIndex || (operatorIndex == null && this.activeOperator)) {
            // if operator already chosen, don't allow other operators
            entries = entries.filter(function (_a) {
                var key = _a.key;
                return key === _this.parsedOperator;
            });
        }
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(
            entries,
            'join',
            searchString,
        );
    };
    OperatorParser.prototype.updateExpression = function (position, updateEntry, operatorIndex) {
        var _a, _b;
        var expression = this.params.expression;
        var updatedValuePart = (_a = updateEntry.displayValue) !== null && _a !== void 0 ? _a : updateEntry.key;
        if (operatorIndex === 0) {
            // need to update all others
            for (var i = this.operatorEndPositions.length - 1; i > 0; i--) {
                var operatorEndPosition = this.operatorEndPositions[i];
                if (operatorEndPosition == null) {
                    continue;
                }
                expression = updateExpression(
                    expression,
                    this.operatorStartPositions[i],
                    operatorEndPosition,
                    updatedValuePart,
                ).updatedValue;
            }
        }
        var startPosition =
            this.operatorStartPositions.length > operatorIndex
                ? this.operatorStartPositions[operatorIndex]
                : expression.length;
        var endPosition =
            (_b =
                this.operatorEndPositions.length > operatorIndex
                    ? this.operatorEndPositions[operatorIndex]
                    : undefined) !== null && _b !== void 0
                ? _b
                : findEndPosition(expression, position);
        return updateExpression(expression, startPosition, endPosition, updatedValuePart, true);
    };
    OperatorParser.prototype.getNumOperators = function () {
        return this.operators.length;
    };
    OperatorParser.prototype.getLastOperatorEndPosition = function () {
        return this.operatorEndPositions[this.operatorEndPositions.length - 1];
    };
    OperatorParser.prototype.parseOperator = function (endPosition) {
        var operator = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : '';
        var joinOperators = this.params.advancedFilterExpressionService.getExpressionJoinOperators();
        var parsedValue = findMatch(operator, joinOperators, function (v) {
            return v;
        });
        if (parsedValue) {
            // exact match
            this.operatorEndPositions[this.activeOperator] = endPosition;
            var displayValue = joinOperators[parsedValue];
            if (this.activeOperator) {
                if (parsedValue !== this.parsedOperator) {
                    if (!this.validationError) {
                        this.validationError = {
                            message: this.params.advancedFilterExpressionService.translate(
                                'advancedFilterValidationJoinOperatorMismatch',
                            ),
                            startPosition: endPosition - operator.length + 1,
                            endPosition: endPosition,
                        };
                    }
                    return false;
                }
            } else {
                this.parsedOperator = parsedValue;
            }
            if (operator !== displayValue) {
                checkAndUpdateExpression(this.params, operator, displayValue, endPosition);
                this.operators[this.activeOperator] = displayValue;
            }
            return true;
        } else if (parsedValue === null) {
            // partial match
            return false;
        } else {
            // no match
            if (!this.validationError) {
                this.validationError = {
                    message: this.params.advancedFilterExpressionService.translate(
                        'advancedFilterValidationInvalidJoinOperator',
                    ),
                    startPosition: endPosition - operator.length + 1,
                    endPosition: endPosition,
                };
            }
            return true;
        }
    };
    return OperatorParser;
})();
var JoinFilterExpressionParser = /** @class */ (function () {
    function JoinFilterExpressionParser(params, startPosition) {
        this.params = params;
        this.startPosition = startPosition;
        this.expectingExpression = true;
        this.expectingOperator = false;
        this.expressionParsers = [];
        this.operatorParser = new OperatorParser(this.params);
        this.missingEndBracket = false;
        this.extraEndBracket = false;
    }
    JoinFilterExpressionParser.prototype.parseExpression = function () {
        var i = this.startPosition;
        var expression = this.params.expression;
        while (i < expression.length) {
            var char = expression[i];
            if (char === '(' && !this.expectingOperator) {
                var nestedParser = new JoinFilterExpressionParser(this.params, i + 1);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (char === ')') {
                this.endPosition = i - 1;
                if (this.startPosition === 0) {
                    this.extraEndBracket = true;
                }
                return i;
            } else if (char === ' ');
            else if (this.expectingExpression) {
                var nestedParser = new ColFilterExpressionParser(this.params, i);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (this.expectingOperator) {
                i = this.operatorParser.parseExpression(i);
                this.expectingOperator = false;
                this.expectingExpression = true;
            }
            i++;
        }
        if (this.startPosition > 0) {
            this.missingEndBracket = true;
        }
        return i;
    };
    JoinFilterExpressionParser.prototype.isValid = function () {
        return (
            !this.missingEndBracket &&
            !this.extraEndBracket &&
            this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 &&
            this.operatorParser.isValid() &&
            this.expressionParsers.every(function (expressionParser) {
                return expressionParser.isValid();
            })
        );
    };
    JoinFilterExpressionParser.prototype.getValidationError = function () {
        var operatorError = this.operatorParser.getValidationError();
        for (var i = 0; i < this.expressionParsers.length; i++) {
            var expressionError = this.expressionParsers[i].getValidationError();
            if (expressionError) {
                return operatorError && operatorError.startPosition < expressionError.startPosition
                    ? operatorError
                    : expressionError;
            }
        }
        if (operatorError) {
            return operatorError;
        }
        if (this.extraEndBracket) {
            return {
                message: this.params.advancedFilterExpressionService.translate(
                    'advancedFilterValidationExtraEndBracket',
                ),
                startPosition: this.endPosition + 1,
                endPosition: this.endPosition + 1,
            };
        }
        var translateKey;
        if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
            translateKey = 'advancedFilterValidationMissingCondition';
        } else if (this.missingEndBracket) {
            translateKey = 'advancedFilterValidationMissingEndBracket';
        }
        if (translateKey) {
            return {
                message: this.params.advancedFilterExpressionService.translate(translateKey),
                startPosition: this.params.expression.length,
                endPosition: this.params.expression.length,
            };
        }
        return null;
    };
    JoinFilterExpressionParser.prototype.getFunction = function (params) {
        var hasMultipleExpressions = this.expressionParsers.length > 1;
        var expression = this.expressionParsers
            .map(function (expressionParser) {
                return expressionParser.getFunction(params);
            })
            .join(' ' + this.operatorParser.getFunction() + ' ');
        return hasMultipleExpressions ? '(' + expression + ')' : expression;
    };
    JoinFilterExpressionParser.prototype.getAutocompleteListParams = function (position) {
        if (this.endPosition != null && position > this.endPosition + 1) {
            return undefined;
        }
        if (!this.expressionParsers.length) {
            return this.getColumnAutocompleteListParams();
        }
        var expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            if (this.params.expression[position] === '(') {
                return { enabled: false };
            }
            // positioned before the expression, so new expression
            return this.getColumnAutocompleteListParams();
        }
        var expressionParser = this.expressionParsers[expressionParserIndex];
        var autocompleteType = expressionParser.getAutocompleteListParams(position);
        if (!autocompleteType) {
            // beyond the end of the expression
            if (expressionParserIndex < this.expressionParsers.length - 1) {
                // in the middle of two expressions
                return this.operatorParser.getAutocompleteListParams(position, expressionParserIndex);
            }
            if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
                var operatorEndPosition = this.operatorParser.getLastOperatorEndPosition();
                return operatorEndPosition == null || position <= operatorEndPosition + 1
                    ? this.operatorParser.getAutocompleteListParams(position, this.operatorParser.getNumOperators() - 1)
                    : this.getColumnAutocompleteListParams();
            }
            if (this.params.expression[position - 1] === ')') {
                return { enabled: false };
            }
            return this.operatorParser.getAutocompleteListParams(position);
        }
        return autocompleteType;
    };
    JoinFilterExpressionParser.prototype.updateExpression = function (position, updateEntry, type) {
        var _a;
        var expression = this.params.expression;
        var expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            // positioned before the expression
            var updatedValuePart =
                type === 'column'
                    ? this.params.advancedFilterExpressionService.getColumnValue(updateEntry)
                    : (_a = updateEntry.displayValue) !== null && _a !== void 0
                    ? _a
                    : updateEntry.key;
            return updateExpression(expression, this.startPosition, this.startPosition, updatedValuePart, true);
        }
        var expressionParser = this.expressionParsers[expressionParserIndex];
        var updatedExpression = expressionParser.updateExpression(position, updateEntry, type);
        if (updatedExpression == null) {
            if (type === 'column') {
                // beyond the end of the expression, just do simple update
                return updateExpression(
                    expression,
                    position,
                    expression.length - 1,
                    this.params.advancedFilterExpressionService.getColumnValue(updateEntry),
                    true,
                );
            } else {
                return this.operatorParser.updateExpression(position, updateEntry, expressionParserIndex);
            }
        }
        return updatedExpression;
    };
    JoinFilterExpressionParser.prototype.getModel = function () {
        if (this.expressionParsers.length > 1) {
            return {
                filterType: 'join',
                type: this.operatorParser.getModel(),
                conditions: this.expressionParsers.map(function (parser) {
                    return parser.getModel();
                }),
            };
        } else {
            return this.expressionParsers[0].getModel();
        }
    };
    JoinFilterExpressionParser.prototype.getColumnAutocompleteListParams = function () {
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(
            this.params.advancedFilterExpressionService.getColumnAutocompleteEntries(),
            'column',
            '',
        );
    };
    JoinFilterExpressionParser.prototype.getExpressionParserIndex = function (position) {
        var expressionParserIndex;
        for (var i = 0; i < this.expressionParsers.length; i++) {
            var expressionParserToCheck = this.expressionParsers[i];
            if (expressionParserToCheck.startPosition > position) {
                break;
            }
            expressionParserIndex = i;
        }
        return expressionParserIndex;
    };
    return JoinFilterExpressionParser;
})();

var FilterExpressionParser = /** @class */ (function () {
    function FilterExpressionParser(params) {
        this.params = params;
        this.valid = false;
    }
    FilterExpressionParser.prototype.parseExpression = function () {
        this.joinExpressionParser = new JoinFilterExpressionParser(this.params, 0);
        var i = this.joinExpressionParser.parseExpression();
        this.valid = i >= this.params.expression.length - 1 && this.joinExpressionParser.isValid();
        return this.params.expression;
    };
    FilterExpressionParser.prototype.isValid = function () {
        return this.valid;
    };
    FilterExpressionParser.prototype.getValidationMessage = function () {
        var error = this.joinExpressionParser.getValidationError();
        if (!error) {
            return null;
        }
        var message = error.message,
            startPosition = error.startPosition,
            endPosition = error.endPosition;
        return startPosition < this.params.expression.length
            ? this.params.advancedFilterExpressionService.translate('advancedFilterValidationMessage', [
                  message,
                  this.params.expression.slice(startPosition, endPosition + 1).trim(),
              ])
            : this.params.advancedFilterExpressionService.translate('advancedFilterValidationMessageAtEnd', [message]);
    };
    FilterExpressionParser.prototype.getFunction = function () {
        var params = {
            operands: [],
            operators: [],
            evaluatorParams: [],
        };
        var functionBody = 'return ' + this.joinExpressionParser.getFunction(params) + ';';
        return {
            functionBody: functionBody,
            params: params,
        };
    };
    FilterExpressionParser.prototype.getAutocompleteListParams = function (position) {
        var _a;
        return (_a = this.joinExpressionParser.getAutocompleteListParams(position)) !== null && _a !== void 0
            ? _a
            : { enabled: false };
    };
    FilterExpressionParser.prototype.updateExpression = function (position, updateEntry, type) {
        return this.joinExpressionParser.updateExpression(position, updateEntry, type);
    };
    FilterExpressionParser.prototype.getModel = function () {
        return this.isValid() ? this.joinExpressionParser.getModel() : null;
    };
    return FilterExpressionParser;
})();

var __extends$3p =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2z =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AdvancedFilterService = /** @class */ (function (_super) {
    __extends$3p(AdvancedFilterService, _super);
    function AdvancedFilterService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.appliedExpression = null;
        /** The value displayed in the input, which may be invalid */
        _this.expression = null;
        _this.isValid = true;
        return _this;
    }
    AdvancedFilterService.prototype.postConstruct = function () {
        var _this = this;
        this.setEnabled(this.gridOptionsService.is('enableAdvancedFilter'), true);
        this.ctrl = this.createManagedBean(new AdvancedFilterCtrl(this.enabled));
        this.expressionProxy = {
            getValue: function (colId, node) {
                var column = _this.columnModel.getPrimaryColumn(colId);
                return column ? _this.valueService.getValue(column, node, true) : undefined;
            },
        };
        this.addManagedPropertyListener('enableAdvancedFilter', function (event) {
            return _this.setEnabled(!!event.currentValue);
        });
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, function (event) {
            return _this.onNewColumnsLoaded(event);
        });
        this.addManagedPropertyListener('includeHiddenColumnsInAdvancedFilter', function () {
            return _this.updateValidity();
        });
    };
    AdvancedFilterService.prototype.isEnabled = function () {
        return this.enabled;
    };
    AdvancedFilterService.prototype.isFilterPresent = function () {
        return !!this.expressionFunction;
    };
    AdvancedFilterService.prototype.doesFilterPass = function (node) {
        return this.expressionFunction(this.expressionProxy, node, this.expressionParams);
    };
    AdvancedFilterService.prototype.getModel = function () {
        var _a;
        var expressionParser = this.createExpressionParser(this.appliedExpression);
        expressionParser === null || expressionParser === void 0 ? void 0 : expressionParser.parseExpression();
        return (_a =
            expressionParser === null || expressionParser === void 0 ? void 0 : expressionParser.getModel()) !== null &&
            _a !== void 0
            ? _a
            : null;
    };
    AdvancedFilterService.prototype.setModel = function (model) {
        var _this = this;
        var parseModel = function (model, isFirstParent) {
            if (model.filterType === 'join') {
                var operator = _this.advancedFilterExpressionService.parseJoinOperator(model);
                var expression_1 = model.conditions
                    .map(function (condition) {
                        return parseModel(condition);
                    })
                    .filter(function (condition) {
                        return _.exists(condition);
                    })
                    .join(' ' + operator + ' ');
                return isFirstParent || model.conditions.length <= 1 ? expression_1 : '(' + expression_1 + ')';
            } else {
                return _this.advancedFilterExpressionService.parseColumnFilterModel(model);
            }
        };
        var expression = model ? parseModel(model, true) : null;
        this.setExpressionDisplayValue(expression);
        this.applyExpression();
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
    };
    AdvancedFilterService.prototype.getExpressionDisplayValue = function () {
        return this.expression;
    };
    AdvancedFilterService.prototype.setExpressionDisplayValue = function (expression) {
        this.expression = expression;
    };
    AdvancedFilterService.prototype.isCurrentExpressionApplied = function () {
        return this.appliedExpression === this.expression;
    };
    AdvancedFilterService.prototype.createExpressionParser = function (expression) {
        if (!expression) {
            return null;
        }
        return new FilterExpressionParser({
            expression: expression,
            columnModel: this.columnModel,
            dataTypeService: this.dataTypeService,
            valueParserService: this.valueParserService,
            advancedFilterExpressionService: this.advancedFilterExpressionService,
        });
    };
    AdvancedFilterService.prototype.getDefaultExpression = function (updateEntry) {
        var updatedValue = this.advancedFilterExpressionService.getColumnValue(updateEntry) + ' ';
        return {
            updatedValue: updatedValue,
            updatedPosition: updatedValue.length,
        };
    };
    AdvancedFilterService.prototype.isHeaderActive = function () {
        return !this.gridOptionsService.get('advancedFilterParent');
    };
    AdvancedFilterService.prototype.getCtrl = function () {
        return this.ctrl;
    };
    AdvancedFilterService.prototype.setEnabled = function (enabled, silent) {
        var previousValue = this.enabled;
        var isClientSideRowModel = this.rowModel.getType() === 'clientSide';
        if (enabled && !isClientSideRowModel) {
            _.doOnce(function () {
                console.warn('AG Grid: Advanced Filter is only supported with the Client-Side Row Model.');
            }, 'advancedFilterCSRM');
        }
        this.enabled = enabled && isClientSideRowModel;
        if (!silent && this.enabled !== previousValue) {
            var event_1 = {
                type: Events.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
                enabled: this.enabled,
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    AdvancedFilterService.prototype.applyExpression = function () {
        var expressionParser = this.createExpressionParser(this.expression);
        expressionParser === null || expressionParser === void 0 ? void 0 : expressionParser.parseExpression();
        this.applyExpressionFromParser(expressionParser);
    };
    AdvancedFilterService.prototype.applyExpressionFromParser = function (expressionParser) {
        this.isValid = !expressionParser || expressionParser.isValid();
        if (!expressionParser || !this.isValid) {
            this.expressionFunction = null;
            this.expressionParams = null;
            this.appliedExpression = null;
            return;
        }
        var _a = expressionParser.getFunction(),
            functionBody = _a.functionBody,
            params = _a.params;
        this.expressionFunction = new Function('expressionProxy', 'node', 'params', functionBody);
        this.expressionParams = params;
        this.appliedExpression = this.expression;
    };
    AdvancedFilterService.prototype.updateValidity = function () {
        this.advancedFilterExpressionService.resetColumnCaches();
        var expressionParser = this.createExpressionParser(this.expression);
        expressionParser === null || expressionParser === void 0 ? void 0 : expressionParser.parseExpression();
        var isValid = !expressionParser || expressionParser.isValid();
        var updatedValidity = isValid !== this.isValid;
        if (updatedValidity) {
            this.applyExpressionFromParser(expressionParser);
            this.ctrl.refreshComp();
        }
        this.ctrl.refreshBuilderComp();
        return updatedValidity;
    };
    AdvancedFilterService.prototype.onNewColumnsLoaded = function (event) {
        var _this = this;
        if (event.source !== 'gridInitializing') {
            return;
        }
        var setModel = function () {
            var _a;
            return _this.setModel(
                (_a = _this.gridOptionsService.get('advancedFilterModel')) !== null && _a !== void 0 ? _a : null,
            );
        };
        if (this.dataTypeService.isPendingInference()) {
            this.ctrl.setInputDisabled(true);
            var destroyFunc_1 = this.addManagedListener(
                this.eventService,
                Events.EVENT_DATA_TYPES_INFERRED,
                function () {
                    destroyFunc_1 === null || destroyFunc_1 === void 0 ? void 0 : destroyFunc_1();
                    setModel();
                    _this.ctrl.setInputDisabled(false);
                },
            );
        } else {
            setModel();
        }
    };
    __decorate$2z([Autowired('valueService')], AdvancedFilterService.prototype, 'valueService', void 0);
    __decorate$2z([Autowired('columnModel')], AdvancedFilterService.prototype, 'columnModel', void 0);
    __decorate$2z([Autowired('dataTypeService')], AdvancedFilterService.prototype, 'dataTypeService', void 0);
    __decorate$2z([Autowired('valueParserService')], AdvancedFilterService.prototype, 'valueParserService', void 0);
    __decorate$2z([Autowired('rowModel')], AdvancedFilterService.prototype, 'rowModel', void 0);
    __decorate$2z(
        [Autowired('advancedFilterExpressionService')],
        AdvancedFilterService.prototype,
        'advancedFilterExpressionService',
        void 0,
    );
    __decorate$2z([PostConstruct], AdvancedFilterService.prototype, 'postConstruct', null);
    AdvancedFilterService = __decorate$2z([Bean('advancedFilterService')], AdvancedFilterService);
    return AdvancedFilterService;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$i = '30.2.0';

var AdvancedFilterModule = {
    version: VERSION$i,
    moduleName: ModuleNames.AdvancedFilterModule,
    beans: [AdvancedFilterService, AdvancedFilterExpressionService],
    agStackComponents: [{ componentName: 'agAdvancedFilter', componentClass: AdvancedFilterComp }],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$3o =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2y =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1m =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$R =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$Q =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
// Matches value in changeDetectionService
var SOURCE_PASTE = 'paste';
var EXPORT_TYPE_DRAG_COPY = 'dragCopy';
var EXPORT_TYPE_CLIPBOARD = 'clipboard';
var CellClearType;
(function (CellClearType) {
    CellClearType[(CellClearType['CellRange'] = 0)] = 'CellRange';
    CellClearType[(CellClearType['SelectedRows'] = 1)] = 'SelectedRows';
    CellClearType[(CellClearType['FocusedCell'] = 2)] = 'FocusedCell';
})(CellClearType || (CellClearType = {}));
var ClipboardService = /** @class */ (function (_super) {
    __extends$3o(ClipboardService, _super);
    function ClipboardService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.lastPasteOperationTime = 0;
        _this.navigatorApiFailed = false;
        return _this;
    }
    ClipboardService_1 = ClipboardService;
    ClipboardService.prototype.init = function () {
        var _this = this;
        this.logger = this.loggerFactory.create('ClipboardService');
        if (this.rowModel.getType() === 'clientSide') {
            this.clientSideRowModel = this.rowModel;
        }
        this.ctrlsService.whenReady(function (p) {
            _this.gridCtrl = p.gridCtrl;
        });
    };
    ClipboardService.prototype.pasteFromClipboard = function () {
        var _this = this;
        this.logger.log('pasteFromClipboard');
        // Method 1 - native clipboard API, available in modern chrome browsers
        var allowNavigator = !this.gridOptionsService.is('suppressClipboardApi');
        // Some browsers (Firefox) do not allow Web Applications to read from
        // the clipboard so verify if not only the ClipboardAPI is available,
        // but also if the `readText` method is public.
        if (allowNavigator && !this.navigatorApiFailed && navigator.clipboard && navigator.clipboard.readText) {
            navigator.clipboard
                .readText()
                .then(this.processClipboardData.bind(this))
                .catch(function (e) {
                    _.doOnce(function () {
                        console.warn(e);
                        console.warn(
                            'AG Grid: Unable to use the Clipboard API (navigator.clipboard.readText()). ' +
                                'The reason why it could not be used has been logged in the previous line. ' +
                                "For this reason the grid has defaulted to using a workaround which doesn't perform as well. " +
                                'Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid ' +
                                'property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API',
                        );
                    }, 'clipboardApiError');
                    _this.navigatorApiFailed = true;
                    _this.pasteFromClipboardLegacy();
                });
        } else {
            this.pasteFromClipboardLegacy();
        }
    };
    ClipboardService.prototype.pasteFromClipboardLegacy = function () {
        var _this = this;
        // Method 2 - if modern API fails, the old school hack
        var defaultPrevented = false;
        var handlePasteEvent = function (e) {
            var currentPastOperationTime = new Date().getTime();
            if (currentPastOperationTime - _this.lastPasteOperationTime < 50) {
                defaultPrevented = true;
                e.preventDefault();
            }
            _this.lastPasteOperationTime = currentPastOperationTime;
        };
        this.executeOnTempElement(
            function (textArea) {
                textArea.addEventListener('paste', handlePasteEvent);
                textArea.focus({ preventScroll: true });
            },
            function (element) {
                var data = element.value;
                if (!defaultPrevented) {
                    _this.processClipboardData(data);
                } else {
                    _this.refocusLastFocusedCell();
                }
                element.removeEventListener('paste', handlePasteEvent);
            },
        );
    };
    ClipboardService.prototype.refocusLastFocusedCell = function () {
        var focusedCell = this.focusService.getFocusedCell();
        if (focusedCell) {
            this.focusService.setFocusedCell({
                rowIndex: focusedCell.rowIndex,
                column: focusedCell.column,
                rowPinned: focusedCell.rowPinned,
                forceBrowserFocus: true,
            });
        }
    };
    ClipboardService.prototype.getClipboardDelimiter = function () {
        var delimiter = this.gridOptionsService.get('clipboardDelimiter');
        return _.exists(delimiter) ? delimiter : '\t';
    };
    ClipboardService.prototype.processClipboardData = function (data) {
        var _this = this;
        if (data == null) {
            return;
        }
        var parsedData = ClipboardService_1.stringToArray(data, this.getClipboardDelimiter());
        var userFunc = this.gridOptionsService.getCallback('processDataFromClipboard');
        if (userFunc) {
            parsedData = userFunc({ data: parsedData });
        }
        if (parsedData == null) {
            return;
        }
        if (this.gridOptionsService.is('suppressLastEmptyLineOnPaste')) {
            this.removeLastLineIfBlank(parsedData);
        }
        var pasteOperation = function (cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
            var rangeActive = _this.rangeService && _this.rangeService.isMoreThanOneCell();
            var pasteIntoRange = rangeActive && !_this.hasOnlyOneValueToPaste(parsedData);
            if (pasteIntoRange) {
                _this.pasteIntoActiveRange(parsedData, cellsToFlash, updatedRowNodes, changedPath);
            } else {
                _this.pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath);
            }
        };
        this.doPasteOperation(pasteOperation);
    };
    // This will parse a delimited string into an array of arrays.
    ClipboardService.stringToArray = function (strData, delimiter) {
        if (delimiter === void 0) {
            delimiter = ',';
        }
        var data = [];
        var isNewline = function (char) {
            return char === '\r' || char === '\n';
        };
        var insideQuotedField = false;
        if (strData === '') {
            return [['']];
        }
        var _loop_1 = function (row, column, position) {
            var previousChar = strData[position - 1];
            var currentChar = strData[position];
            var nextChar = strData[position + 1];
            var ensureDataExists = function () {
                if (!data[row]) {
                    // create row if it doesn't exist
                    data[row] = [];
                }
                if (!data[row][column]) {
                    // create column if it doesn't exist
                    data[row][column] = '';
                }
            };
            ensureDataExists();
            if (currentChar === '"') {
                if (insideQuotedField) {
                    if (nextChar === '"') {
                        // unescape double quote
                        data[row][column] += '"';
                        position++;
                    } else {
                        // exit quoted field
                        insideQuotedField = false;
                    }
                    // continue;
                } else if (previousChar === undefined || previousChar === delimiter || isNewline(previousChar)) {
                    // enter quoted field
                    insideQuotedField = true;
                    // continue;
                }
            }
            if (!insideQuotedField && currentChar !== '"') {
                if (currentChar === delimiter) {
                    // move to next column
                    column++;
                    ensureDataExists();
                    return (out_row_1 = row), (out_column_1 = column), (out_position_1 = position), 'continue';
                } else if (isNewline(currentChar)) {
                    // move to next row
                    column = 0;
                    row++;
                    ensureDataExists();
                    if (currentChar === '\r' && nextChar === '\n') {
                        // skip over second newline character if it exists
                        position++;
                    }
                    return (out_row_1 = row), (out_column_1 = column), (out_position_1 = position), 'continue';
                }
            }
            // add current character to current column
            data[row][column] += currentChar;
            out_row_1 = row;
            out_column_1 = column;
            out_position_1 = position;
        };
        var out_row_1, out_column_1, out_position_1;
        // iterate over each character, keep track of current row and column (of the returned array)
        for (var row = 0, column = 0, position = 0; position < strData.length; position++) {
            _loop_1(row, column, position);
            row = out_row_1;
            column = out_column_1;
            position = out_position_1;
        }
        return data;
    };
    // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
    ClipboardService.prototype.doPasteOperation = function (pasteOperationFunc) {
        var api = this.gridOptionsService.api;
        var columnApi = this.gridOptionsService.columnApi;
        var source = 'clipboard';
        this.eventService.dispatchEvent({
            type: Events.EVENT_PASTE_START,
            api: api,
            columnApi: columnApi,
            source: source,
        });
        var changedPath;
        if (this.clientSideRowModel) {
            var onlyChangedColumns = this.gridOptionsService.is('aggregateOnlyChangedColumns');
            changedPath = new ChangedPath(onlyChangedColumns, this.clientSideRowModel.getRootNode());
        }
        var cellsToFlash = {};
        var updatedRowNodes = [];
        var focusedCell = this.focusService.getFocusedCell();
        pasteOperationFunc(cellsToFlash, updatedRowNodes, focusedCell, changedPath);
        var nodesToRefresh = __spreadArray$R([], __read$1m(updatedRowNodes));
        if (changedPath) {
            this.clientSideRowModel.doAggregate(changedPath);
            // add all nodes impacted by aggregation, as they need refreshed also.
            changedPath.forEachChangedNodeDepthFirst(function (rowNode) {
                nodesToRefresh.push(rowNode);
            });
        }
        // clipboardService has to do changeDetection itself, to prevent repeat logic in favour of batching.
        // changeDetectionService is disabled for this action.
        this.rowRenderer.refreshCells({ rowNodes: nodesToRefresh });
        this.dispatchFlashCells(cellsToFlash);
        this.fireRowChanged(updatedRowNodes);
        // if using the clipboard hack with a temp element, then the focus has been lost,
        // so need to put it back. otherwise paste operation loosed focus on cell and keyboard
        // navigation stops.
        this.refocusLastFocusedCell();
        var event = {
            type: Events.EVENT_PASTE_END,
            source: source,
        };
        this.eventService.dispatchEvent(event);
    };
    ClipboardService.prototype.pasteIntoActiveRange = function (
        clipboardData,
        cellsToFlash,
        updatedRowNodes,
        changedPath,
    ) {
        var _this = this;
        // true if clipboard data can be evenly pasted into range, otherwise false
        var abortRepeatingPasteIntoRows = this.getRangeSize() % clipboardData.length != 0;
        var indexOffset = 0;
        var dataRowIndex = 0;
        var rowCallback = function (currentRow, rowNode, columns, index) {
            var atEndOfClipboardData = index - indexOffset >= clipboardData.length;
            if (atEndOfClipboardData) {
                if (abortRepeatingPasteIntoRows) {
                    return;
                }
                // increment offset and reset data index to repeat paste of data
                indexOffset += dataRowIndex;
                dataRowIndex = 0;
            }
            var currentRowData = clipboardData[index - indexOffset];
            // otherwise we are not the first row, so copy
            updatedRowNodes.push(rowNode);
            var processCellFromClipboardFunc = _this.gridOptionsService.getCallback('processCellFromClipboard');
            columns.forEach(function (column, idx) {
                if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
                    return;
                }
                // repeat data for columns we don't have data for - happens when to range is bigger than copied data range
                if (idx >= currentRowData.length) {
                    idx = idx % currentRowData.length;
                }
                var newValue = _this.processCell(
                    rowNode,
                    column,
                    currentRowData[idx],
                    EXPORT_TYPE_DRAG_COPY,
                    processCellFromClipboardFunc,
                    true,
                );
                rowNode.setDataValue(column, newValue, SOURCE_PASTE);
                if (changedPath) {
                    changedPath.addParentNode(rowNode.parent, [column]);
                }
                var rowIndex = currentRow.rowIndex,
                    rowPinned = currentRow.rowPinned;
                var cellId = _this.cellPositionUtils.createIdFromValues({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                });
                cellsToFlash[cellId] = true;
            });
            dataRowIndex++;
        };
        this.iterateActiveRanges(false, rowCallback);
    };
    ClipboardService.prototype.pasteStartingFromFocusedCell = function (
        parsedData,
        cellsToFlash,
        updatedRowNodes,
        focusedCell,
        changedPath,
    ) {
        if (!focusedCell) {
            return;
        }
        var currentRow = { rowIndex: focusedCell.rowIndex, rowPinned: focusedCell.rowPinned };
        var columnsToPasteInto = this.columnModel.getDisplayedColumnsStartingAt(focusedCell.column);
        if (this.isPasteSingleValueIntoRange(parsedData)) {
            this.pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath);
        } else {
            this.pasteMultipleValues(
                parsedData,
                currentRow,
                updatedRowNodes,
                columnsToPasteInto,
                cellsToFlash,
                EXPORT_TYPE_CLIPBOARD,
                changedPath,
            );
        }
    };
    // if range is active, and only one cell, then we paste this cell into all cells in the active range.
    ClipboardService.prototype.isPasteSingleValueIntoRange = function (parsedData) {
        return this.hasOnlyOneValueToPaste(parsedData) && this.rangeService != null && !this.rangeService.isEmpty();
    };
    ClipboardService.prototype.pasteSingleValueIntoRange = function (
        parsedData,
        updatedRowNodes,
        cellsToFlash,
        changedPath,
    ) {
        var _this = this;
        var value = parsedData[0][0];
        var rowCallback = function (currentRow, rowNode, columns) {
            updatedRowNodes.push(rowNode);
            columns.forEach(function (column) {
                return _this.updateCellValue(rowNode, column, value, cellsToFlash, EXPORT_TYPE_CLIPBOARD, changedPath);
            });
        };
        this.iterateActiveRanges(false, rowCallback);
    };
    ClipboardService.prototype.hasOnlyOneValueToPaste = function (parsedData) {
        return parsedData.length === 1 && parsedData[0].length === 1;
    };
    ClipboardService.prototype.copyRangeDown = function () {
        var _this = this;
        if (!this.rangeService || this.rangeService.isEmpty()) {
            return;
        }
        var firstRowValues = [];
        var pasteOperation = function (cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
            var processCellForClipboardFunc = _this.gridOptionsService.getCallback('processCellForClipboard');
            var processCellFromClipboardFunc = _this.gridOptionsService.getCallback('processCellFromClipboard');
            var rowCallback = function (currentRow, rowNode, columns) {
                // take reference of first row, this is the one we will be using to copy from
                if (!firstRowValues.length) {
                    // two reasons for looping through columns
                    columns.forEach(function (column) {
                        // get the initial values to copy down
                        var value = _this.processCell(
                            rowNode,
                            column,
                            _this.valueService.getValue(column, rowNode),
                            EXPORT_TYPE_DRAG_COPY,
                            processCellForClipboardFunc,
                            false,
                            true,
                        );
                        firstRowValues.push(value);
                    });
                } else {
                    // otherwise we are not the first row, so copy
                    updatedRowNodes.push(rowNode);
                    columns.forEach(function (column, index) {
                        if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
                            return;
                        }
                        var firstRowValue = _this.processCell(
                            rowNode,
                            column,
                            firstRowValues[index],
                            EXPORT_TYPE_DRAG_COPY,
                            processCellFromClipboardFunc,
                            true,
                        );
                        rowNode.setDataValue(column, firstRowValue, SOURCE_PASTE);
                        if (changedPath) {
                            changedPath.addParentNode(rowNode.parent, [column]);
                        }
                        var rowIndex = currentRow.rowIndex,
                            rowPinned = currentRow.rowPinned;
                        var cellId = _this.cellPositionUtils.createIdFromValues({
                            rowIndex: rowIndex,
                            column: column,
                            rowPinned: rowPinned,
                        });
                        cellsToFlash[cellId] = true;
                    });
                }
            };
            _this.iterateActiveRanges(true, rowCallback);
        };
        this.doPasteOperation(pasteOperation);
    };
    ClipboardService.prototype.removeLastLineIfBlank = function (parsedData) {
        // remove last row if empty, excel puts empty last row in
        var lastLine = _.last(parsedData);
        var lastLineIsBlank = lastLine && lastLine.length === 1 && lastLine[0] === '';
        if (lastLineIsBlank) {
            // do not remove the last empty line when that is the only line pasted
            if (parsedData.length === 1) {
                return;
            }
            _.removeFromArray(parsedData, lastLine);
        }
    };
    ClipboardService.prototype.fireRowChanged = function (rowNodes) {
        var _this = this;
        if (this.gridOptionsService.get('editType') !== 'fullRow') {
            return;
        }
        rowNodes.forEach(function (rowNode) {
            var event = {
                type: Events.EVENT_ROW_VALUE_CHANGED,
                node: rowNode,
                data: rowNode.data,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned,
            };
            _this.eventService.dispatchEvent(event);
        });
    };
    ClipboardService.prototype.pasteMultipleValues = function (
        clipboardGridData,
        currentRow,
        updatedRowNodes,
        columnsToPasteInto,
        cellsToFlash,
        type,
        changedPath,
    ) {
        var _this = this;
        var rowPointer = currentRow;
        // if doing CSRM and NOT tree data, then it means groups are aggregates, which are read only,
        // so we should skip them when doing paste operations.
        var skipGroupRows =
            this.clientSideRowModel != null &&
            !this.gridOptionsService.is('enableGroupEdit') &&
            !this.gridOptionsService.is('treeData');
        var getNextGoodRowNode = function () {
            while (true) {
                if (!rowPointer) {
                    return null;
                }
                var res = _this.rowPositionUtils.getRowNode(rowPointer);
                // move to next row down for next set of values
                rowPointer = _this.cellNavigationService.getRowBelow({
                    rowPinned: rowPointer.rowPinned,
                    rowIndex: rowPointer.rowIndex,
                });
                // if no more rows, return null
                if (res == null) {
                    return null;
                }
                // skip details rows and footer rows, never paste into them as they don't hold data
                var skipRow = res.detail || res.footer || (skipGroupRows && res.group);
                // skipping row means we go into the next iteration of the while loop
                if (!skipRow) {
                    return res;
                }
            }
        };
        clipboardGridData.forEach(function (clipboardRowData) {
            var rowNode = getNextGoodRowNode();
            // if we have come to end of rows in grid, then skip
            if (!rowNode) {
                return;
            }
            clipboardRowData.forEach(function (value, index) {
                return _this.updateCellValue(
                    rowNode,
                    columnsToPasteInto[index],
                    value,
                    cellsToFlash,
                    type,
                    changedPath,
                );
            });
            updatedRowNodes.push(rowNode);
        });
    };
    ClipboardService.prototype.updateCellValue = function (rowNode, column, value, cellsToFlash, type, changedPath) {
        if (!rowNode || !column || !column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) {
            return;
        }
        // if the cell is a group and the col is an aggregation, skip the cell.
        if (rowNode.group && column.isValueActive()) {
            return;
        }
        var processedValue = this.processCell(
            rowNode,
            column,
            value,
            type,
            this.gridOptionsService.getCallback('processCellFromClipboard'),
            true,
        );
        rowNode.setDataValue(column, processedValue, SOURCE_PASTE);
        var rowIndex = rowNode.rowIndex,
            rowPinned = rowNode.rowPinned;
        var cellId = this.cellPositionUtils.createIdFromValues({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned,
        });
        cellsToFlash[cellId] = true;
        if (changedPath) {
            changedPath.addParentNode(rowNode.parent, [column]);
        }
    };
    ClipboardService.prototype.copyToClipboard = function (params) {
        if (params === void 0) {
            params = {};
        }
        this.copyOrCutToClipboard(params);
    };
    ClipboardService.prototype.cutToClipboard = function (params, source) {
        if (params === void 0) {
            params = {};
        }
        if (source === void 0) {
            source = 'api';
        }
        if (this.gridOptionsService.is('suppressCutToClipboard')) {
            return;
        }
        var startEvent = {
            type: Events.EVENT_CUT_START,
            source: source,
        };
        this.eventService.dispatchEvent(startEvent);
        this.copyOrCutToClipboard(params, true);
        var endEvent = {
            type: Events.EVENT_CUT_END,
            source: source,
        };
        this.eventService.dispatchEvent(endEvent);
    };
    ClipboardService.prototype.copyOrCutToClipboard = function (params, cut) {
        var includeHeaders = params.includeHeaders,
            includeGroupHeaders = params.includeGroupHeaders;
        this.logger.log('copyToClipboard: includeHeaders = ' + includeHeaders);
        // don't override 'includeHeaders' if it has been explicitly set to 'false'
        if (includeHeaders == null) {
            includeHeaders = this.gridOptionsService.is('copyHeadersToClipboard');
        }
        if (includeGroupHeaders == null) {
            includeGroupHeaders = this.gridOptionsService.is('copyGroupHeadersToClipboard');
        }
        var copyParams = { includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders };
        var shouldCopyRows = !this.gridOptionsService.is('suppressCopyRowsToClipboard');
        var cellClearType = null;
        // Copy priority is Range > Row > Focus
        if (this.rangeService && !this.rangeService.isEmpty() && !this.shouldSkipSingleCellRange()) {
            this.copySelectedRangeToClipboard(copyParams);
            cellClearType = CellClearType.CellRange;
        } else if (shouldCopyRows && !this.selectionService.isEmpty()) {
            this.copySelectedRowsToClipboard(copyParams);
            cellClearType = CellClearType.SelectedRows;
        } else if (this.focusService.isAnyCellFocused()) {
            this.copyFocusedCellToClipboard(copyParams);
            cellClearType = CellClearType.FocusedCell;
        }
        if (cut && cellClearType !== null) {
            this.clearCellsAfterCopy(cellClearType);
        }
    };
    ClipboardService.prototype.clearCellsAfterCopy = function (type) {
        this.eventService.dispatchEvent({ type: Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_START });
        if (type === CellClearType.CellRange) {
            this.rangeService.clearCellRangeCellValues({ cellEventSource: 'clipboardService' });
        } else if (type === CellClearType.SelectedRows) {
            this.clearSelectedRows();
        } else {
            var focusedCell = this.focusService.getFocusedCell();
            if (focusedCell == null) {
                return;
            }
            var rowNode = this.rowPositionUtils.getRowNode(focusedCell);
            if (rowNode) {
                this.clearCellValue(rowNode, focusedCell.column);
            }
        }
        this.eventService.dispatchEvent({ type: Events.EVENT_KEY_SHORTCUT_CHANGED_CELL_END });
    };
    ClipboardService.prototype.clearSelectedRows = function () {
        var e_1, _a, e_2, _b;
        var selected = this.selectionService.getSelectedNodes();
        var columns = this.columnModel.getAllDisplayedColumns();
        try {
            for (
                var selected_1 = __values$Q(selected), selected_1_1 = selected_1.next();
                !selected_1_1.done;
                selected_1_1 = selected_1.next()
            ) {
                var row = selected_1_1.value;
                try {
                    for (
                        var columns_1 = ((e_2 = void 0), __values$Q(columns)), columns_1_1 = columns_1.next();
                        !columns_1_1.done;
                        columns_1_1 = columns_1.next()
                    ) {
                        var col = columns_1_1.value;
                        this.clearCellValue(row, col);
                    }
                } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                } finally {
                    try {
                        if (columns_1_1 && !columns_1_1.done && (_b = columns_1.return)) _b.call(columns_1);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (selected_1_1 && !selected_1_1.done && (_a = selected_1.return)) _a.call(selected_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    ClipboardService.prototype.clearCellValue = function (rowNode, column) {
        if (!column.isCellEditable(rowNode)) {
            return;
        }
        rowNode.setDataValue(column, null, 'clipboardService');
    };
    ClipboardService.prototype.shouldSkipSingleCellRange = function () {
        return this.gridOptionsService.is('suppressCopySingleCellRanges') && !this.rangeService.isMoreThanOneCell();
    };
    ClipboardService.prototype.iterateActiveRanges = function (onlyFirst, rowCallback, columnCallback) {
        var _this = this;
        if (!this.rangeService || this.rangeService.isEmpty()) {
            return;
        }
        var cellRanges = this.rangeService.getCellRanges();
        if (onlyFirst) {
            this.iterateActiveRange(cellRanges[0], rowCallback, columnCallback, true);
        } else {
            cellRanges.forEach(function (range, idx) {
                return _this.iterateActiveRange(range, rowCallback, columnCallback, idx === cellRanges.length - 1);
            });
        }
    };
    ClipboardService.prototype.iterateActiveRange = function (range, rowCallback, columnCallback, isLastRange) {
        if (!this.rangeService) {
            return;
        }
        var currentRow = this.rangeService.getRangeStartRow(range);
        var lastRow = this.rangeService.getRangeEndRow(range);
        if (columnCallback && range.columns) {
            columnCallback(range.columns);
        }
        var rangeIndex = 0;
        var isLastRow = false;
        // the currentRow could be missing if the user sets the active range manually, and sets a range
        // that is outside of the grid (eg. sets range rows 0 to 100, but grid has only 20 rows).
        while (!isLastRow && currentRow != null) {
            var rowNode = this.rowPositionUtils.getRowNode(currentRow);
            isLastRow = this.rowPositionUtils.sameRow(currentRow, lastRow);
            rowCallback(currentRow, rowNode, range.columns, rangeIndex++, isLastRow && isLastRange);
            currentRow = this.cellNavigationService.getRowBelow(currentRow);
        }
    };
    ClipboardService.prototype.copySelectedRangeToClipboard = function (params) {
        if (params === void 0) {
            params = {};
        }
        if (!this.rangeService || this.rangeService.isEmpty()) {
            return;
        }
        var allRangesMerge = this.rangeService.areAllRangesAbleToMerge();
        var _a = allRangesMerge ? this.buildDataFromMergedRanges(params) : this.buildDataFromRanges(params),
            data = _a.data,
            cellsToFlash = _a.cellsToFlash;
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(cellsToFlash);
    };
    ClipboardService.prototype.buildDataFromMergedRanges = function (params) {
        var _this = this;
        var columnsSet = new Set();
        var ranges = this.rangeService.getCellRanges();
        var rowPositionsMap = new Map();
        var allRowPositions = [];
        var allCellsToFlash = {};
        ranges.forEach(function (range) {
            range.columns.forEach(function (col) {
                return columnsSet.add(col);
            });
            var _a = _this.getRangeRowPositionsAndCellsToFlash(range),
                rowPositions = _a.rowPositions,
                cellsToFlash = _a.cellsToFlash;
            rowPositions.forEach(function (rowPosition) {
                var rowPositionAsString = rowPosition.rowIndex + '-' + (rowPosition.rowPinned || 'null');
                if (!rowPositionsMap.get(rowPositionAsString)) {
                    rowPositionsMap.set(rowPositionAsString, true);
                    allRowPositions.push(rowPosition);
                }
            });
            Object.assign(allCellsToFlash, cellsToFlash);
        });
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var exportedColumns = Array.from(columnsSet);
        exportedColumns.sort(function (a, b) {
            var posA = allColumns.indexOf(a);
            var posB = allColumns.indexOf(b);
            return posA - posB;
        });
        var data = this.buildExportParams({
            columns: exportedColumns,
            rowPositions: allRowPositions,
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders,
        });
        return { data: data, cellsToFlash: allCellsToFlash };
    };
    ClipboardService.prototype.buildDataFromRanges = function (params) {
        var _this = this;
        var ranges = this.rangeService.getCellRanges();
        var data = [];
        var allCellsToFlash = {};
        ranges.forEach(function (range) {
            var _a = _this.getRangeRowPositionsAndCellsToFlash(range),
                rowPositions = _a.rowPositions,
                cellsToFlash = _a.cellsToFlash;
            Object.assign(allCellsToFlash, cellsToFlash);
            data.push(
                _this.buildExportParams({
                    columns: range.columns,
                    rowPositions: rowPositions,
                    includeHeaders: params.includeHeaders,
                    includeGroupHeaders: params.includeGroupHeaders,
                }),
            );
        });
        return { data: data.join('\n'), cellsToFlash: allCellsToFlash };
    };
    ClipboardService.prototype.getRangeRowPositionsAndCellsToFlash = function (range) {
        var _this = this;
        var rowPositions = [];
        var cellsToFlash = {};
        var startRow = this.rangeService.getRangeStartRow(range);
        var lastRow = this.rangeService.getRangeEndRow(range);
        var node = startRow;
        while (node) {
            rowPositions.push(node);
            range.columns.forEach(function (column) {
                var _a = node,
                    rowIndex = _a.rowIndex,
                    rowPinned = _a.rowPinned;
                var cellId = _this.cellPositionUtils.createIdFromValues({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                });
                cellsToFlash[cellId] = true;
            });
            if (this.rowPositionUtils.sameRow(node, lastRow)) {
                break;
            }
            node = this.cellNavigationService.getRowBelow(node);
        }
        return { rowPositions: rowPositions, cellsToFlash: cellsToFlash };
    };
    ClipboardService.prototype.copyFocusedCellToClipboard = function (params) {
        var _a;
        if (params === void 0) {
            params = {};
        }
        var focusedCell = this.focusService.getFocusedCell();
        if (focusedCell == null) {
            return;
        }
        var cellId = this.cellPositionUtils.createId(focusedCell);
        var currentRow = { rowPinned: focusedCell.rowPinned, rowIndex: focusedCell.rowIndex };
        var column = focusedCell.column;
        var data = this.buildExportParams({
            columns: [column],
            rowPositions: [currentRow],
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders,
        });
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(((_a = {}), (_a[cellId] = true), _a));
    };
    ClipboardService.prototype.copySelectedRowsToClipboard = function (params) {
        if (params === void 0) {
            params = {};
        }
        var columnKeys = params.columnKeys,
            includeHeaders = params.includeHeaders,
            includeGroupHeaders = params.includeGroupHeaders;
        var data = this.buildExportParams({
            columns: columnKeys,
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders,
        });
        this.copyDataToClipboard(data);
    };
    ClipboardService.prototype.buildExportParams = function (params) {
        var _this = this;
        var columns = params.columns,
            rowPositions = params.rowPositions,
            _a = params.includeHeaders,
            includeHeaders = _a === void 0 ? false : _a,
            _b = params.includeGroupHeaders,
            includeGroupHeaders = _b === void 0 ? false : _b;
        var exportParams = {
            columnKeys: columns,
            rowPositions: rowPositions,
            skipColumnHeaders: !includeHeaders,
            skipColumnGroupHeaders: !includeGroupHeaders,
            suppressQuotes: true,
            columnSeparator: this.getClipboardDelimiter(),
            onlySelected: !rowPositions,
            processCellCallback: this.gridOptionsService.getCallback('processCellForClipboard'),
            processRowGroupCallback: function (params) {
                return _this.processRowGroupCallback(params);
            },
            processHeaderCallback: this.gridOptionsService.getCallback('processHeaderForClipboard'),
            processGroupHeaderCallback: this.gridOptionsService.getCallback('processGroupHeaderForClipboard'),
        };
        return this.csvCreator.getDataAsCsv(exportParams, true);
    };
    ClipboardService.prototype.processRowGroupCallback = function (params) {
        var _this = this;
        var node = params.node;
        var key = node.key;
        var value = key != null ? key : '';
        if (params.node.footer) {
            var suffix = '';
            if (key && key.length) {
                suffix = ' ' + key;
            }
            value = 'Total' + suffix;
        }
        var processCellForClipboard = this.gridOptionsService.getCallback('processCellForClipboard');
        if (processCellForClipboard) {
            var column_1 = node.rowGroupColumn;
            if (!column_1 && node.footer && node.level === -1) {
                column_1 = this.columnModel.getRowGroupColumns()[0];
            }
            return processCellForClipboard({
                value: value,
                node: node,
                column: column_1,
                type: 'clipboard',
                formatValue: function (valueToFormat) {
                    var _a;
                    return (_a = _this.valueFormatterService.formatValue(column_1, node, valueToFormat)) !== null &&
                        _a !== void 0
                        ? _a
                        : valueToFormat;
                },
                parseValue: function (valueToParse) {
                    return _this.valueParserService.parseValue(
                        column_1,
                        node,
                        valueToParse,
                        _this.valueService.getValue(column_1, node),
                    );
                },
            });
        }
        return value;
    };
    ClipboardService.prototype.dispatchFlashCells = function (cellsToFlash) {
        var _this = this;
        window.setTimeout(function () {
            var event = {
                type: Events.EVENT_FLASH_CELLS,
                cells: cellsToFlash,
            };
            _this.eventService.dispatchEvent(event);
        }, 0);
    };
    ClipboardService.prototype.processCell = function (rowNode, column, value, type, func, canParse, canFormat) {
        var _this = this;
        var _a;
        if (func) {
            var params = {
                column: column,
                node: rowNode,
                value: value,
                type: type,
                formatValue: function (valueToFormat) {
                    var _a;
                    return (_a = _this.valueFormatterService.formatValue(
                        column,
                        rowNode !== null && rowNode !== void 0 ? rowNode : null,
                        valueToFormat,
                    )) !== null && _a !== void 0
                        ? _a
                        : valueToFormat;
                },
                parseValue: function (valueToParse) {
                    return _this.valueParserService.parseValue(
                        column,
                        rowNode !== null && rowNode !== void 0 ? rowNode : null,
                        valueToParse,
                        _this.valueService.getValue(column, rowNode),
                    );
                },
            };
            return func(params);
        }
        if (canParse && column.getColDef().useValueParserForImport) {
            return this.valueParserService.parseValue(
                column,
                rowNode !== null && rowNode !== void 0 ? rowNode : null,
                value,
                this.valueService.getValue(column, rowNode),
            );
        } else if (canFormat && column.getColDef().useValueFormatterForExport) {
            return (_a = this.valueFormatterService.formatValue(
                column,
                rowNode !== null && rowNode !== void 0 ? rowNode : null,
                value,
            )) !== null && _a !== void 0
                ? _a
                : value;
        }
        return value;
    };
    ClipboardService.prototype.copyDataToClipboard = function (data) {
        var _this = this;
        var userProvidedFunc = this.gridOptionsService.getCallback('sendToClipboard');
        // method 1 - user provided func
        if (userProvidedFunc) {
            userProvidedFunc({ data: data });
            return;
        }
        // method 2 - native clipboard API, available in modern chrome browsers
        var allowNavigator = !this.gridOptionsService.is('suppressClipboardApi');
        if (allowNavigator && navigator.clipboard) {
            navigator.clipboard.writeText(data).catch(function (e) {
                _.doOnce(function () {
                    console.warn(e);
                    console.warn(
                        'AG Grid: Unable to use the Clipboard API (navigator.clipboard.writeText()). ' +
                            'The reason why it could not be used has been logged in the previous line. ' +
                            "For this reason the grid has defaulted to using a workaround which doesn't perform as well. " +
                            'Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid ' +
                            'property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.',
                    );
                }, 'clipboardApiError');
                _this.copyDataToClipboardLegacy(data);
            });
            return;
        }
        this.copyDataToClipboardLegacy(data);
    };
    ClipboardService.prototype.copyDataToClipboardLegacy = function (data) {
        var _this = this;
        // method 3 - if all else fails, the old school hack
        this.executeOnTempElement(function (element) {
            var eDocument = _this.gridOptionsService.getDocument();
            var focusedElementBefore = eDocument.activeElement;
            element.value = data || ' '; // has to be non-empty value or execCommand will not do anything
            element.select();
            element.focus({ preventScroll: true });
            var result = eDocument.execCommand('copy');
            if (!result) {
                console.warn(
                    "AG Grid: Browser did not allow document.execCommand('copy'). Ensure " +
                        'api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise ' +
                        'the browser will prevent it for security reasons.',
                );
            }
            if (focusedElementBefore != null && focusedElementBefore.focus != null) {
                focusedElementBefore.focus({ preventScroll: true });
            }
        });
    };
    ClipboardService.prototype.executeOnTempElement = function (callbackNow, callbackAfter) {
        var eDoc = this.gridOptionsService.getDocument();
        var eTempInput = eDoc.createElement('textarea');
        eTempInput.style.width = '1px';
        eTempInput.style.height = '1px';
        // removing items from the DOM causes the document element to scroll to the
        // position where the element was positioned. Here we set scrollTop / scrollLeft
        // to prevent the document element from scrolling when we remove it from the DOM.
        eTempInput.style.top = eDoc.documentElement.scrollTop + 'px';
        eTempInput.style.left = eDoc.documentElement.scrollLeft + 'px';
        eTempInput.style.position = 'absolute';
        eTempInput.style.opacity = '0';
        var guiRoot = this.gridCtrl.getGui();
        guiRoot.appendChild(eTempInput);
        try {
            callbackNow(eTempInput);
        } catch (err) {
            console.warn("AG Grid: Browser does not support document.execCommand('copy') for clipboard operations");
        }
        //It needs 100 otherwise OS X seemed to not always be able to paste... Go figure...
        if (callbackAfter) {
            window.setTimeout(function () {
                callbackAfter(eTempInput);
                guiRoot.removeChild(eTempInput);
            }, 100);
        } else {
            guiRoot.removeChild(eTempInput);
        }
    };
    ClipboardService.prototype.getRangeSize = function () {
        var ranges = this.rangeService.getCellRanges();
        var startRangeIndex = 0;
        var endRangeIndex = 0;
        if (ranges.length > 0) {
            startRangeIndex = this.rangeService.getRangeStartRow(ranges[0]).rowIndex;
            endRangeIndex = this.rangeService.getRangeEndRow(ranges[0]).rowIndex;
        }
        return startRangeIndex - endRangeIndex + 1;
    };
    var ClipboardService_1;
    __decorate$2y([Autowired('csvCreator')], ClipboardService.prototype, 'csvCreator', void 0);
    __decorate$2y([Autowired('loggerFactory')], ClipboardService.prototype, 'loggerFactory', void 0);
    __decorate$2y([Autowired('selectionService')], ClipboardService.prototype, 'selectionService', void 0);
    __decorate$2y([Optional('rangeService')], ClipboardService.prototype, 'rangeService', void 0);
    __decorate$2y([Autowired('rowModel')], ClipboardService.prototype, 'rowModel', void 0);
    __decorate$2y([Autowired('ctrlsService')], ClipboardService.prototype, 'ctrlsService', void 0);
    __decorate$2y([Autowired('valueService')], ClipboardService.prototype, 'valueService', void 0);
    __decorate$2y([Autowired('focusService')], ClipboardService.prototype, 'focusService', void 0);
    __decorate$2y([Autowired('rowRenderer')], ClipboardService.prototype, 'rowRenderer', void 0);
    __decorate$2y([Autowired('columnModel')], ClipboardService.prototype, 'columnModel', void 0);
    __decorate$2y([Autowired('cellNavigationService')], ClipboardService.prototype, 'cellNavigationService', void 0);
    __decorate$2y([Autowired('cellPositionUtils')], ClipboardService.prototype, 'cellPositionUtils', void 0);
    __decorate$2y([Autowired('rowPositionUtils')], ClipboardService.prototype, 'rowPositionUtils', void 0);
    __decorate$2y([Autowired('valueFormatterService')], ClipboardService.prototype, 'valueFormatterService', void 0);
    __decorate$2y([Autowired('valueParserService')], ClipboardService.prototype, 'valueParserService', void 0);
    __decorate$2y([PostConstruct], ClipboardService.prototype, 'init', null);
    ClipboardService = ClipboardService_1 = __decorate$2y([Bean('clipboardService')], ClipboardService);
    return ClipboardService;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$h = '30.2.0';

var ClipboardModule = {
    version: VERSION$h,
    moduleName: ModuleNames.ClipboardModule,
    beans: [ClipboardService],
    dependantModules: [EnterpriseCoreModule, CsvExportModule],
};

var __extends$3n =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2x =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ExpandState;
(function (ExpandState) {
    ExpandState[(ExpandState['EXPANDED'] = 0)] = 'EXPANDED';
    ExpandState[(ExpandState['COLLAPSED'] = 1)] = 'COLLAPSED';
    ExpandState[(ExpandState['INDETERMINATE'] = 2)] = 'INDETERMINATE';
})(ExpandState || (ExpandState = {}));
var PrimaryColsHeaderPanel = /** @class */ (function (_super) {
    __extends$3n(PrimaryColsHeaderPanel, _super);
    function PrimaryColsHeaderPanel() {
        return _super.call(this, PrimaryColsHeaderPanel.TEMPLATE) || this;
    }
    PrimaryColsHeaderPanel.prototype.postConstruct = function () {
        var _this = this;
        this.createExpandIcons();
        this.addManagedListener(this.eExpand, 'click', this.onExpandClicked.bind(this));
        this.addManagedListener(this.eExpand, 'keydown', function (e) {
            if (e.key === KeyCode.SPACE) {
                e.preventDefault();
                _this.onExpandClicked();
            }
        });
        this.addManagedListener(this.eSelect.getInputElement(), 'click', this.onSelectClicked.bind(this));
        this.eFilterTextField.onValueChange(function () {
            return _this.onFilterTextChanged();
        });
        this.addManagedListener(
            this.eFilterTextField.getInputElement(),
            'keydown',
            this.onMiniFilterKeyDown.bind(this),
        );
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
        var translate = this.localeService.getLocaleTextFunc();
        this.eSelect.setInputAriaLabel(translate('ariaColumnSelectAll', 'Toggle Select All Columns'));
        this.eFilterTextField.setInputAriaLabel(translate('ariaFilterColumnsInput', 'Filter Columns Input'));
        this.activateTabIndex([this.eExpand]);
    };
    PrimaryColsHeaderPanel.prototype.init = function (params) {
        this.params = params;
        if (this.columnModel.isReady()) {
            this.showOrHideOptions();
        }
    };
    PrimaryColsHeaderPanel.prototype.createExpandIcons = function () {
        this.eExpand.appendChild(
            (this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsService)),
        );
        this.eExpand.appendChild(
            (this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsService)),
        );
        this.eExpand.appendChild(
            (this.eExpandIndeterminate = _.createIconNoSpan('columnSelectIndeterminate', this.gridOptionsService)),
        );
        this.setExpandState(ExpandState.EXPANDED);
    };
    // we only show expand / collapse if we are showing columns
    PrimaryColsHeaderPanel.prototype.showOrHideOptions = function () {
        var showFilter = !this.params.suppressColumnFilter;
        var showSelect = !this.params.suppressColumnSelectAll;
        var showExpand = !this.params.suppressColumnExpandAll;
        var groupsPresent = this.columnModel.isPrimaryColumnGroupsPresent();
        var translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate('searchOoo', 'Search...'));
        _.setDisplayed(this.eFilterTextField.getGui(), showFilter);
        _.setDisplayed(this.eSelect.getGui(), showSelect);
        _.setDisplayed(this.eExpand, showExpand && groupsPresent);
    };
    PrimaryColsHeaderPanel.prototype.onFilterTextChanged = function () {
        var _this = this;
        if (!this.onFilterTextChangedDebounced) {
            this.onFilterTextChangedDebounced = _.debounce(function () {
                var filterText = _this.eFilterTextField.getValue();
                _this.dispatchEvent({ type: 'filterChanged', filterText: filterText });
            }, PrimaryColsHeaderPanel.DEBOUNCE_DELAY);
        }
        this.onFilterTextChangedDebounced();
    };
    PrimaryColsHeaderPanel.prototype.onMiniFilterKeyDown = function (e) {
        var _this = this;
        if (e.key === KeyCode.ENTER) {
            // we need to add a delay that corresponds to the filter text debounce delay to ensure
            // the text filtering has happened, otherwise all columns will be deselected
            setTimeout(function () {
                return _this.onSelectClicked();
            }, PrimaryColsHeaderPanel.DEBOUNCE_DELAY);
        }
    };
    PrimaryColsHeaderPanel.prototype.onSelectClicked = function () {
        this.dispatchEvent({ type: this.selectState ? 'unselectAll' : 'selectAll' });
    };
    PrimaryColsHeaderPanel.prototype.onExpandClicked = function () {
        this.dispatchEvent({ type: this.expandState === ExpandState.EXPANDED ? 'collapseAll' : 'expandAll' });
    };
    PrimaryColsHeaderPanel.prototype.setExpandState = function (state) {
        this.expandState = state;
        _.setDisplayed(this.eExpandChecked, this.expandState === ExpandState.EXPANDED);
        _.setDisplayed(this.eExpandUnchecked, this.expandState === ExpandState.COLLAPSED);
        _.setDisplayed(this.eExpandIndeterminate, this.expandState === ExpandState.INDETERMINATE);
    };
    PrimaryColsHeaderPanel.prototype.setSelectionState = function (state) {
        this.selectState = state;
        this.eSelect.setValue(this.selectState);
    };
    PrimaryColsHeaderPanel.DEBOUNCE_DELAY = 300;
    PrimaryColsHeaderPanel.TEMPLATE =
        '<div class="ag-column-select-header" role="presentation">\n            <div ref="eExpand" class="ag-column-select-header-icon"></div>\n            <ag-checkbox ref="eSelect" class="ag-column-select-header-checkbox"></ag-checkbox>\n            <ag-input-text-field class="ag-column-select-header-filter-wrapper" ref="eFilterTextField"></ag-input-text-field>\n        </div>';
    __decorate$2x([Autowired('columnModel')], PrimaryColsHeaderPanel.prototype, 'columnModel', void 0);
    __decorate$2x([RefSelector('eExpand')], PrimaryColsHeaderPanel.prototype, 'eExpand', void 0);
    __decorate$2x([RefSelector('eSelect')], PrimaryColsHeaderPanel.prototype, 'eSelect', void 0);
    __decorate$2x([RefSelector('eFilterTextField')], PrimaryColsHeaderPanel.prototype, 'eFilterTextField', void 0);
    __decorate$2x([PostConstruct], PrimaryColsHeaderPanel.prototype, 'postConstruct', null);
    return PrimaryColsHeaderPanel;
})(Component);

var ColumnModelItem = /** @class */ (function () {
    function ColumnModelItem(displayName, columnOrGroup, dept, group, expanded) {
        if (group === void 0) {
            group = false;
        }
        this.eventService = new EventService();
        this.displayName = displayName;
        this.dept = dept;
        this.group = group;
        if (group) {
            this.columnGroup = columnOrGroup;
            this.expanded = expanded;
            this.children = [];
        } else {
            this.column = columnOrGroup;
        }
    }
    ColumnModelItem.prototype.isGroup = function () {
        return this.group;
    };
    ColumnModelItem.prototype.getDisplayName = function () {
        return this.displayName;
    };
    ColumnModelItem.prototype.getColumnGroup = function () {
        return this.columnGroup;
    };
    ColumnModelItem.prototype.getColumn = function () {
        return this.column;
    };
    ColumnModelItem.prototype.getDept = function () {
        return this.dept;
    };
    ColumnModelItem.prototype.isExpanded = function () {
        return !!this.expanded;
    };
    ColumnModelItem.prototype.getChildren = function () {
        return this.children;
    };
    ColumnModelItem.prototype.isPassesFilter = function () {
        return this.passesFilter;
    };
    ColumnModelItem.prototype.setExpanded = function (expanded) {
        if (expanded === this.expanded) {
            return;
        }
        this.expanded = expanded;
        this.eventService.dispatchEvent({ type: ColumnModelItem.EVENT_EXPANDED_CHANGED });
    };
    ColumnModelItem.prototype.setPassesFilter = function (passesFilter) {
        this.passesFilter = passesFilter;
    };
    ColumnModelItem.prototype.addEventListener = function (eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    };
    ColumnModelItem.prototype.removeEventListener = function (eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    };
    ColumnModelItem.EVENT_EXPANDED_CHANGED = 'expandedChanged';
    return ColumnModelItem;
})();

var __extends$3m =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2w =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1l =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$Q =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$P =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var ToolPanelContextMenu = /** @class */ (function (_super) {
    __extends$3m(ToolPanelContextMenu, _super);
    function ToolPanelContextMenu(column, mouseEvent, parentEl) {
        var _this = _super.call(this, /* html */ '<div class="ag-menu"></div>') || this;
        _this.column = column;
        _this.mouseEvent = mouseEvent;
        _this.parentEl = parentEl;
        _this.displayName = null;
        return _this;
    }
    ToolPanelContextMenu.prototype.postConstruct = function () {
        this.initializeProperties(this.column);
        this.buildMenuItemMap();
        if (this.column instanceof Column) {
            this.displayName = this.columnModel.getDisplayNameForColumn(this.column, 'columnToolPanel');
        } else {
            this.displayName = this.columnModel.getDisplayNameForProvidedColumnGroup(
                null,
                this.column,
                'columnToolPanel',
            );
        }
        if (this.isActive()) {
            this.mouseEvent.preventDefault();
            this.displayContextMenu();
        }
    };
    ToolPanelContextMenu.prototype.initializeProperties = function (column) {
        if (column instanceof ProvidedColumnGroup) {
            this.columns = column.getLeafColumns();
        } else {
            this.columns = [column];
        }
        this.allowGrouping = this.columns.some(function (col) {
            return col.isPrimary() && col.isAllowRowGroup();
        });
        this.allowValues = this.columns.some(function (col) {
            return col.isPrimary() && col.isAllowValue();
        });
        this.allowPivoting =
            this.columnModel.isPivotMode() &&
            this.columns.some(function (col) {
                return col.isPrimary() && col.isAllowPivot();
            });
    };
    ToolPanelContextMenu.prototype.buildMenuItemMap = function () {
        var _this = this;
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        this.menuItemMap = new Map();
        this.menuItemMap.set('rowGroup', {
            allowedFunction: function (col) {
                return col.isPrimary() && col.isAllowRowGroup();
            },
            activeFunction: function (col) {
                return col.isRowGroupActive();
            },
            activateLabel: function () {
                return localeTextFunc('groupBy', 'Group by') + ' ' + _this.displayName;
            },
            deactivateLabel: function () {
                return localeTextFunc('ungroupBy', 'Un-Group by') + ' ' + _this.displayName;
            },
            activateFunction: function () {
                var groupedColumns = _this.columnModel.getRowGroupColumns();
                _this.columnModel.setRowGroupColumns(_this.addColumnsToList(groupedColumns), 'toolPanelUi');
            },
            deActivateFunction: function () {
                var groupedColumns = _this.columnModel.getRowGroupColumns();
                _this.columnModel.setRowGroupColumns(_this.removeColumnsFromList(groupedColumns), 'toolPanelUi');
            },
            addIcon: 'menuAddRowGroup',
            removeIcon: 'menuRemoveRowGroup',
        });
        this.menuItemMap.set('value', {
            allowedFunction: function (col) {
                return col.isPrimary() && col.isAllowValue();
            },
            activeFunction: function (col) {
                return col.isValueActive();
            },
            activateLabel: function () {
                return localeTextFunc('addToValues', 'Add ' + _this.displayName + ' to values', [_this.displayName]);
            },
            deactivateLabel: function () {
                return localeTextFunc('removeFromValues', 'Remove ' + _this.displayName + ' from values', [
                    _this.displayName,
                ]);
            },
            activateFunction: function () {
                var valueColumns = _this.columnModel.getValueColumns();
                _this.columnModel.setValueColumns(_this.addColumnsToList(valueColumns), 'toolPanelUi');
            },
            deActivateFunction: function () {
                var valueColumns = _this.columnModel.getValueColumns();
                _this.columnModel.setValueColumns(_this.removeColumnsFromList(valueColumns), 'toolPanelUi');
            },
            addIcon: 'valuePanel',
            removeIcon: 'valuePanel',
        });
        this.menuItemMap.set('pivot', {
            allowedFunction: function (col) {
                return _this.columnModel.isPivotMode() && col.isPrimary() && col.isAllowPivot();
            },
            activeFunction: function (col) {
                return col.isPivotActive();
            },
            activateLabel: function () {
                return localeTextFunc('addToLabels', 'Add ' + _this.displayName + ' to labels', [_this.displayName]);
            },
            deactivateLabel: function () {
                return localeTextFunc('removeFromLabels', 'Remove ' + _this.displayName + ' from labels', [
                    _this.displayName,
                ]);
            },
            activateFunction: function () {
                var pivotColumns = _this.columnModel.getPivotColumns();
                _this.columnModel.setPivotColumns(_this.addColumnsToList(pivotColumns), 'toolPanelUi');
            },
            deActivateFunction: function () {
                var pivotColumns = _this.columnModel.getPivotColumns();
                _this.columnModel.setPivotColumns(_this.removeColumnsFromList(pivotColumns), 'toolPanelUi');
            },
            addIcon: 'pivotPanel',
            removeIcon: 'pivotPanel',
        });
    };
    ToolPanelContextMenu.prototype.addColumnsToList = function (columnList) {
        return __spreadArray$Q([], __read$1l(columnList)).concat(
            this.columns.filter(function (col) {
                return columnList.indexOf(col) === -1;
            }),
        );
    };
    ToolPanelContextMenu.prototype.removeColumnsFromList = function (columnList) {
        var _this = this;
        return columnList.filter(function (col) {
            return _this.columns.indexOf(col) === -1;
        });
    };
    ToolPanelContextMenu.prototype.displayContextMenu = function () {
        var _this = this;
        var eGui = this.getGui();
        var menuList = this.createBean(new AgMenuList());
        var menuItemsMapped = this.getMappedMenuItems();
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var hideFunc = function () {};
        eGui.appendChild(menuList.getGui());
        menuList.addMenuItems(menuItemsMapped);
        menuList.addManagedListener(menuList, AgMenuItemComponent.EVENT_MENU_ITEM_SELECTED, function () {
            _this.parentEl.focus();
            hideFunc();
        });
        var addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            afterGuiAttached: function () {
                return _this.focusService.focusInto(menuList.getGui());
            },
            ariaLabel: localeTextFunc('ariaLabelContextMenu', 'Context Menu'),
            closedCallback: function (e) {
                if (e instanceof KeyboardEvent) {
                    _this.parentEl.focus();
                }
                _this.destroyBean(menuList);
            },
        });
        if (addPopupRes) {
            hideFunc = addPopupRes.hideFunc;
        }
        this.popupService.positionPopupUnderMouseEvent({
            type: 'columnContextMenu',
            mouseEvent: this.mouseEvent,
            ePopup: eGui,
        });
    };
    ToolPanelContextMenu.prototype.isActive = function () {
        return this.allowGrouping || this.allowValues || this.allowPivoting;
    };
    ToolPanelContextMenu.prototype.getMappedMenuItems = function () {
        var e_1, _a;
        var ret = [];
        var _loop_1 = function (val) {
            var isInactive = this_1.columns.some(function (col) {
                return val.allowedFunction(col) && !val.activeFunction(col);
            });
            var isActive = this_1.columns.some(function (col) {
                return val.allowedFunction(col) && val.activeFunction(col);
            });
            if (isInactive) {
                ret.push({
                    name: val.activateLabel(this_1.displayName),
                    icon: _.createIconNoSpan(val.addIcon, this_1.gridOptionsService, null),
                    action: function () {
                        return val.activateFunction();
                    },
                });
            }
            if (isActive) {
                ret.push({
                    name: val.deactivateLabel(this_1.displayName),
                    icon: _.createIconNoSpan(val.removeIcon, this_1.gridOptionsService, null),
                    action: function () {
                        return val.deActivateFunction();
                    },
                });
            }
        };
        var this_1 = this;
        try {
            for (var _b = __values$P(this.menuItemMap.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var val = _c.value;
                _loop_1(val);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return ret;
    };
    __decorate$2w([Autowired('columnModel')], ToolPanelContextMenu.prototype, 'columnModel', void 0);
    __decorate$2w([Autowired('popupService')], ToolPanelContextMenu.prototype, 'popupService', void 0);
    __decorate$2w([Autowired('focusService')], ToolPanelContextMenu.prototype, 'focusService', void 0);
    __decorate$2w([PostConstruct], ToolPanelContextMenu.prototype, 'postConstruct', null);
    return ToolPanelContextMenu;
})(Component);

var __extends$3l =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2v =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelColumnGroupComp = /** @class */ (function (_super) {
    __extends$3l(ToolPanelColumnGroupComp, _super);
    function ToolPanelColumnGroupComp(modelItem, allowDragging, eventType, focusWrapper) {
        var _this = _super.call(this) || this;
        _this.modelItem = modelItem;
        _this.allowDragging = allowDragging;
        _this.eventType = eventType;
        _this.focusWrapper = focusWrapper;
        _this.processingColumnStateChange = false;
        _this.modelItem = modelItem;
        _this.columnGroup = modelItem.getColumnGroup();
        _this.columnDept = modelItem.getDept();
        _this.displayName = modelItem.getDisplayName();
        _this.allowDragging = allowDragging;
        return _this;
    }
    ToolPanelColumnGroupComp.prototype.init = function () {
        var _this = this;
        this.setTemplate(ToolPanelColumnGroupComp.TEMPLATE);
        this.eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsService);
        this.eDragHandle.classList.add('ag-drag-handle', 'ag-column-select-column-group-drag-handle');
        var checkboxGui = this.cbSelect.getGui();
        var checkboxInput = this.cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement('afterend', this.eDragHandle);
        checkboxInput.setAttribute('tabindex', '-1');
        this.eLabel.innerHTML = this.displayName ? this.displayName : '';
        this.setupExpandContract();
        this.addCssClass('ag-column-select-indent-' + this.columnDept);
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            this.onColumnStateChanged.bind(this),
        );
        this.addManagedListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
        this.addManagedListener(this.cbSelect, Events.EVENT_FIELD_VALUE_CHANGED, this.onCheckboxChanged.bind(this));
        this.addManagedListener(
            this.modelItem,
            ColumnModelItem.EVENT_EXPANDED_CHANGED,
            this.onExpandChanged.bind(this),
        );
        this.addManagedListener(this.focusWrapper, 'keydown', this.handleKeyDown.bind(this));
        this.addManagedListener(this.focusWrapper, 'contextmenu', this.onContextMenu.bind(this));
        this.setOpenClosedIcons();
        this.setupDragging();
        this.onColumnStateChanged();
        this.addVisibilityListenersToAllChildren();
        this.refreshAriaExpanded();
        this.refreshAriaLabel();
        this.setupTooltip();
        var classes = CssClassApplier.getToolPanelClassesFromColDef(
            this.columnGroup.getColGroupDef(),
            this.gridOptionsService,
            null,
            this.columnGroup,
        );
        classes.forEach(function (c) {
            return _this.addOrRemoveCssClass(c, true);
        });
    };
    ToolPanelColumnGroupComp.prototype.getColumns = function () {
        return this.columnGroup.getLeafColumns();
    };
    ToolPanelColumnGroupComp.prototype.setupTooltip = function () {
        var _this = this;
        var colGroupDef = this.columnGroup.getColGroupDef();
        if (!colGroupDef) {
            return;
        }
        var refresh = function () {
            var newTooltipText = colGroupDef.headerTooltip;
            _this.setTooltip(newTooltipText);
        };
        refresh();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    };
    ToolPanelColumnGroupComp.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'columnToolPanelColumnGroup';
        return res;
    };
    ToolPanelColumnGroupComp.prototype.handleKeyDown = function (e) {
        switch (e.key) {
            case KeyCode.LEFT:
                e.preventDefault();
                this.modelItem.setExpanded(false);
                break;
            case KeyCode.RIGHT:
                e.preventDefault();
                this.modelItem.setExpanded(true);
                break;
            case KeyCode.SPACE:
                e.preventDefault();
                if (this.isSelectable()) {
                    this.onSelectAllChanged(!this.isSelected());
                }
                break;
        }
    };
    ToolPanelColumnGroupComp.prototype.onContextMenu = function (e) {
        var _this = this;
        var _a = this,
            columnGroup = _a.columnGroup,
            gridOptionsService = _a.gridOptionsService;
        if (gridOptionsService.is('functionsReadOnly')) {
            return;
        }
        var contextMenu = this.createBean(new ToolPanelContextMenu(columnGroup, e, this.focusWrapper));
        this.addDestroyFunc(function () {
            if (contextMenu.isAlive()) {
                _this.destroyBean(contextMenu);
            }
        });
    };
    ToolPanelColumnGroupComp.prototype.addVisibilityListenersToAllChildren = function () {
        var _this = this;
        this.columnGroup.getLeafColumns().forEach(function (column) {
            _this.addManagedListener(column, Column.EVENT_VISIBLE_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addManagedListener(column, Column.EVENT_VALUE_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addManagedListener(column, Column.EVENT_PIVOT_CHANGED, _this.onColumnStateChanged.bind(_this));
            _this.addManagedListener(column, Column.EVENT_ROW_GROUP_CHANGED, _this.onColumnStateChanged.bind(_this));
        });
    };
    ToolPanelColumnGroupComp.prototype.setupDragging = function () {
        var _this = this;
        if (!this.allowDragging) {
            _.setDisplayed(this.eDragHandle, false);
            return;
        }
        var hideColumnOnExit = !this.gridOptionsService.is('suppressDragLeaveHidesColumns');
        var dragSource = {
            type: DragSourceType.ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: function () {
                return hideColumnOnExit ? DragAndDropService.ICON_HIDE : DragAndDropService.ICON_NOT_ALLOWED;
            },
            getDragItem: function () {
                return _this.createDragItem();
            },
            onDragStarted: function () {
                hideColumnOnExit = !_this.gridOptionsService.is('suppressDragLeaveHidesColumns');
                var event = {
                    type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
                    column: _this.columnGroup,
                };
                _this.eventService.dispatchEvent(event);
            },
            onDragStopped: function () {
                var event = {
                    type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
                };
                _this.eventService.dispatchEvent(event);
            },
            onGridEnter: function (dragItem) {
                if (hideColumnOnExit) {
                    // when dragged into the grid, restore the state that was active pre-drag
                    _this.modelItemUtils.updateColumns({
                        columns: _this.columnGroup.getLeafColumns(),
                        visibleState: dragItem === null || dragItem === void 0 ? void 0 : dragItem.visibleState,
                        pivotState: dragItem === null || dragItem === void 0 ? void 0 : dragItem.pivotState,
                        eventType: _this.eventType,
                    });
                }
            },
            onGridExit: function () {
                if (hideColumnOnExit) {
                    // when dragged outside of the grid, mimic what happens when checkbox is disabled
                    // this handles the behaviour for pivot which is different to just hiding a column.
                    _this.onChangeCommon(false);
                }
            },
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDragSource(dragSource);
        });
    };
    ToolPanelColumnGroupComp.prototype.createDragItem = function () {
        var _this = this;
        var columns = this.columnGroup.getLeafColumns();
        var visibleState = {};
        var pivotState = {};
        columns.forEach(function (col) {
            var colId = col.getId();
            visibleState[colId] = col.isVisible();
            pivotState[colId] = _this.modelItemUtils.createPivotState(col);
        });
        return {
            columns: columns,
            visibleState: visibleState,
            pivotState: pivotState,
        };
    };
    ToolPanelColumnGroupComp.prototype.setupExpandContract = function () {
        this.eGroupClosedIcon.appendChild(_.createIcon('columnSelectClosed', this.gridOptionsService, null));
        this.eGroupOpenedIcon.appendChild(_.createIcon('columnSelectOpen', this.gridOptionsService, null));
        this.addManagedListener(this.eGroupClosedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        this.addManagedListener(this.eGroupOpenedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        var touchListener = new TouchListener(this.eColumnGroupIcons, true);
        this.addManagedListener(touchListener, TouchListener.EVENT_TAP, this.onExpandOrContractClicked.bind(this));
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    };
    ToolPanelColumnGroupComp.prototype.onLabelClicked = function () {
        var nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    };
    ToolPanelColumnGroupComp.prototype.onCheckboxChanged = function (event) {
        this.onChangeCommon(event.selected);
    };
    ToolPanelColumnGroupComp.prototype.getVisibleLeafColumns = function () {
        var childColumns = [];
        var extractCols = function (children) {
            children.forEach(function (child) {
                if (!child.isPassesFilter()) {
                    return;
                }
                if (child.isGroup()) {
                    extractCols(child.getChildren());
                } else {
                    childColumns.push(child.getColumn());
                }
            });
        };
        extractCols(this.modelItem.getChildren());
        return childColumns;
    };
    ToolPanelColumnGroupComp.prototype.onChangeCommon = function (nextState) {
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) {
            return;
        }
        this.modelItemUtils.selectAllChildren(this.modelItem.getChildren(), nextState, this.eventType);
    };
    ToolPanelColumnGroupComp.prototype.refreshAriaLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var columnLabel = translate('ariaColumnGroup', 'Column Group');
        var checkboxValue = this.cbSelect.getValue();
        var state =
            checkboxValue === undefined
                ? translate('ariaIndeterminate', 'indeterminate')
                : checkboxValue
                ? translate('ariaVisible', 'visible')
                : translate('ariaHidden', 'hidden');
        var visibilityLabel = translate('ariaToggleVisibility', 'Press SPACE to toggle visibility');
        _.setAriaLabel(this.focusWrapper, this.displayName + ' ' + columnLabel);
        this.cbSelect.setInputAriaLabel(visibilityLabel + ' (' + state + ')');
        _.setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
    };
    ToolPanelColumnGroupComp.prototype.onColumnStateChanged = function () {
        var selectedValue = this.workOutSelectedValue();
        var readOnlyValue = this.workOutReadOnlyValue();
        this.processingColumnStateChange = true;
        this.cbSelect.setValue(selectedValue);
        this.cbSelect.setReadOnly(readOnlyValue);
        this.addOrRemoveCssClass('ag-column-select-column-group-readonly', readOnlyValue);
        this.processingColumnStateChange = false;
    };
    ToolPanelColumnGroupComp.prototype.workOutSelectedValue = function () {
        var _this = this;
        var pivotMode = this.columnModel.isPivotMode();
        var visibleLeafColumns = this.getVisibleLeafColumns();
        var checkedCount = 0;
        var uncheckedCount = 0;
        visibleLeafColumns.forEach(function (column) {
            if (!pivotMode && column.getColDef().lockVisible) {
                return;
            }
            if (_this.isColumnChecked(column, pivotMode)) {
                checkedCount++;
            } else {
                uncheckedCount++;
            }
        });
        if (checkedCount > 0 && uncheckedCount > 0) {
            return undefined;
        }
        return checkedCount > 0;
    };
    ToolPanelColumnGroupComp.prototype.workOutReadOnlyValue = function () {
        var pivotMode = this.columnModel.isPivotMode();
        var colsThatCanAction = 0;
        this.columnGroup.getLeafColumns().forEach(function (col) {
            if (pivotMode) {
                if (col.isAnyFunctionAllowed()) {
                    colsThatCanAction++;
                }
            } else {
                if (!col.getColDef().lockVisible) {
                    colsThatCanAction++;
                }
            }
        });
        return colsThatCanAction === 0;
    };
    ToolPanelColumnGroupComp.prototype.isColumnChecked = function (column, pivotMode) {
        if (pivotMode) {
            var pivoted = column.isPivotActive();
            var grouped = column.isRowGroupActive();
            var aggregated = column.isValueActive();
            return pivoted || grouped || aggregated;
        }
        return column.isVisible();
    };
    ToolPanelColumnGroupComp.prototype.onExpandOrContractClicked = function () {
        var oldState = this.modelItem.isExpanded();
        this.modelItem.setExpanded(!oldState);
    };
    ToolPanelColumnGroupComp.prototype.onExpandChanged = function () {
        this.setOpenClosedIcons();
        this.refreshAriaExpanded();
    };
    ToolPanelColumnGroupComp.prototype.setOpenClosedIcons = function () {
        var folderOpen = this.modelItem.isExpanded();
        _.setDisplayed(this.eGroupClosedIcon, !folderOpen);
        _.setDisplayed(this.eGroupOpenedIcon, folderOpen);
    };
    ToolPanelColumnGroupComp.prototype.refreshAriaExpanded = function () {
        _.setAriaExpanded(this.focusWrapper, this.modelItem.isExpanded());
    };
    ToolPanelColumnGroupComp.prototype.getDisplayName = function () {
        return this.displayName;
    };
    ToolPanelColumnGroupComp.prototype.onSelectAllChanged = function (value) {
        var cbValue = this.cbSelect.getValue();
        var readOnly = this.cbSelect.isReadOnly();
        if (!readOnly && ((value && !cbValue) || (!value && cbValue))) {
            this.cbSelect.toggle();
        }
    };
    ToolPanelColumnGroupComp.prototype.isSelected = function () {
        return this.cbSelect.getValue();
    };
    ToolPanelColumnGroupComp.prototype.isSelectable = function () {
        return !this.cbSelect.isReadOnly();
    };
    ToolPanelColumnGroupComp.prototype.setSelected = function (selected) {
        this.cbSelect.setValue(selected, true);
    };
    ToolPanelColumnGroupComp.TEMPLATE =
        '<div class="ag-column-select-column-group" aria-hidden="true">\n            <span class="ag-column-group-icons" ref="eColumnGroupIcons" >\n                <span class="ag-column-group-closed-icon" ref="eGroupClosedIcon"></span>\n                <span class="ag-column-group-opened-icon" ref="eGroupOpenedIcon"></span>\n            </span>\n            <ag-checkbox ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>\n            <span class="ag-column-select-column-label" ref="eLabel"></span>\n        </div>';
    __decorate$2v([Autowired('columnModel')], ToolPanelColumnGroupComp.prototype, 'columnModel', void 0);
    __decorate$2v([Autowired('dragAndDropService')], ToolPanelColumnGroupComp.prototype, 'dragAndDropService', void 0);
    __decorate$2v([Autowired('modelItemUtils')], ToolPanelColumnGroupComp.prototype, 'modelItemUtils', void 0);
    __decorate$2v([RefSelector('cbSelect')], ToolPanelColumnGroupComp.prototype, 'cbSelect', void 0);
    __decorate$2v([RefSelector('eLabel')], ToolPanelColumnGroupComp.prototype, 'eLabel', void 0);
    __decorate$2v([RefSelector('eGroupOpenedIcon')], ToolPanelColumnGroupComp.prototype, 'eGroupOpenedIcon', void 0);
    __decorate$2v([RefSelector('eGroupClosedIcon')], ToolPanelColumnGroupComp.prototype, 'eGroupClosedIcon', void 0);
    __decorate$2v([RefSelector('eColumnGroupIcons')], ToolPanelColumnGroupComp.prototype, 'eColumnGroupIcons', void 0);
    __decorate$2v([PostConstruct], ToolPanelColumnGroupComp.prototype, 'init', null);
    return ToolPanelColumnGroupComp;
})(Component);

var __extends$3k =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2u =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PrimaryColsListPanelItemDragFeature = /** @class */ (function (_super) {
    __extends$3k(PrimaryColsListPanelItemDragFeature, _super);
    function PrimaryColsListPanelItemDragFeature(comp, virtualList) {
        var _this = _super.call(this) || this;
        _this.comp = comp;
        _this.virtualList = virtualList;
        return _this;
    }
    PrimaryColsListPanelItemDragFeature.prototype.postConstruct = function () {
        var _this = this;
        this.createManagedBean(
            new VirtualListDragFeature(this.comp, this.virtualList, {
                dragSourceType: DragSourceType.ToolPanel,
                listItemDragStartEvent: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
                listItemDragEndEvent: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
                eventSource: this.eventService,
                getCurrentDragValue: function (listItemDragStartEvent) {
                    return _this.getCurrentDragValue(listItemDragStartEvent);
                },
                isMoveBlocked: function (currentDragValue) {
                    return _this.isMoveBlocked(currentDragValue);
                },
                getNumRows: function (comp) {
                    return comp.getDisplayedColsList().length;
                },
                moveItem: function (currentDragValue, lastHoveredListItem) {
                    return _this.moveItem(currentDragValue, lastHoveredListItem);
                },
            }),
        );
    };
    PrimaryColsListPanelItemDragFeature.prototype.getCurrentDragValue = function (listItemDragStartEvent) {
        return listItemDragStartEvent.column;
    };
    PrimaryColsListPanelItemDragFeature.prototype.isMoveBlocked = function (currentDragValue) {
        var currentColumns = this.getCurrentColumns(currentDragValue);
        var hasNotMovable = currentColumns.find(function (col) {
            var colDef = col.getColDef();
            return !!colDef.suppressMovable || !!colDef.lockPosition;
        });
        return !!hasNotMovable;
    };
    PrimaryColsListPanelItemDragFeature.prototype.moveItem = function (currentDragValue, lastHoveredListItem) {
        var targetIndex = this.getTargetIndex(currentDragValue, lastHoveredListItem);
        var columnsToMove = this.getCurrentColumns(currentDragValue);
        if (targetIndex != null) {
            this.columnModel.moveColumns(columnsToMove, targetIndex, 'toolPanelUi');
        }
    };
    PrimaryColsListPanelItemDragFeature.prototype.getMoveDiff = function (currentDragValue, end) {
        var allColumns = this.columnModel.getAllGridColumns();
        var currentColumns = this.getCurrentColumns(currentDragValue);
        var currentColumn = currentColumns[0];
        var span = currentColumns.length;
        var currentIndex = allColumns.indexOf(currentColumn);
        if (currentIndex < end) {
            return span;
        }
        return 0;
    };
    PrimaryColsListPanelItemDragFeature.prototype.getCurrentColumns = function (currentDragValue) {
        if (currentDragValue instanceof ProvidedColumnGroup) {
            return currentDragValue.getLeafColumns();
        }
        return [currentDragValue];
    };
    PrimaryColsListPanelItemDragFeature.prototype.getTargetIndex = function (currentDragValue, lastHoveredListItem) {
        if (!lastHoveredListItem) {
            return null;
        }
        var columnItemComponent = lastHoveredListItem.component;
        var isBefore = lastHoveredListItem.position === 'top';
        var targetColumn;
        if (columnItemComponent instanceof ToolPanelColumnGroupComp) {
            var columns = columnItemComponent.getColumns();
            targetColumn = columns[0];
            isBefore = true;
        } else {
            targetColumn = columnItemComponent.getColumn();
        }
        // if the target col is in the cols to be moved, no index to move.
        var movingCols = this.getCurrentColumns(currentDragValue);
        if (movingCols.indexOf(targetColumn) !== -1) {
            return null;
        }
        var targetColumnIndex = this.columnModel.getAllGridColumns().indexOf(targetColumn);
        var adjustedTarget = isBefore ? targetColumnIndex : targetColumnIndex + 1;
        var diff = this.getMoveDiff(currentDragValue, adjustedTarget);
        return adjustedTarget - diff;
    };
    __decorate$2u([Autowired('columnModel')], PrimaryColsListPanelItemDragFeature.prototype, 'columnModel', void 0);
    __decorate$2u([PostConstruct], PrimaryColsListPanelItemDragFeature.prototype, 'postConstruct', null);
    return PrimaryColsListPanelItemDragFeature;
})(BeanStub);

var __extends$3j =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2t =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelColumnComp = /** @class */ (function (_super) {
    __extends$3j(ToolPanelColumnComp, _super);
    function ToolPanelColumnComp(modelItem, allowDragging, groupsExist, focusWrapper) {
        var _this = _super.call(this) || this;
        _this.allowDragging = allowDragging;
        _this.groupsExist = groupsExist;
        _this.focusWrapper = focusWrapper;
        _this.processingColumnStateChange = false;
        _this.column = modelItem.getColumn();
        _this.columnDept = modelItem.getDept();
        _this.displayName = modelItem.getDisplayName();
        return _this;
    }
    ToolPanelColumnComp.prototype.init = function () {
        var _this = this;
        this.setTemplate(ToolPanelColumnComp.TEMPLATE);
        this.eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsService);
        this.eDragHandle.classList.add('ag-drag-handle', 'ag-column-select-column-drag-handle');
        var checkboxGui = this.cbSelect.getGui();
        var checkboxInput = this.cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement('afterend', this.eDragHandle);
        checkboxInput.setAttribute('tabindex', '-1');
        var displayNameSanitised = _.escapeString(this.displayName);
        this.eLabel.innerHTML = displayNameSanitised;
        // if grouping, we add an extra level of indent, to cater for expand/contract icons we need to indent for
        var indent = this.columnDept;
        if (this.groupsExist) {
            this.addCssClass('ag-column-select-add-group-indent');
        }
        this.addCssClass('ag-column-select-indent-' + indent);
        this.setupDragging();
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            this.onColumnStateChanged.bind(this),
        );
        this.addManagedListener(this.column, Column.EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, Column.EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, Column.EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, Column.EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.focusWrapper, 'keydown', this.handleKeyDown.bind(this));
        this.addManagedListener(this.focusWrapper, 'contextmenu', this.onContextMenu.bind(this));
        this.addManagedPropertyListener('functionsReadOnly', this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.cbSelect, Events.EVENT_FIELD_VALUE_CHANGED, this.onCheckboxChanged.bind(this));
        this.addManagedListener(this.eLabel, 'click', this.onLabelClicked.bind(this));
        this.onColumnStateChanged();
        this.refreshAriaLabel();
        this.setupTooltip();
        var classes = CssClassApplier.getToolPanelClassesFromColDef(
            this.column.getColDef(),
            this.gridOptionsService,
            this.column,
            null,
        );
        classes.forEach(function (c) {
            return _this.addOrRemoveCssClass(c, true);
        });
    };
    ToolPanelColumnComp.prototype.getColumn = function () {
        return this.column;
    };
    ToolPanelColumnComp.prototype.setupTooltip = function () {
        var _this = this;
        var refresh = function () {
            var newTooltipText = _this.column.getColDef().headerTooltip;
            _this.setTooltip(newTooltipText);
        };
        refresh();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    };
    ToolPanelColumnComp.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'columnToolPanelColumn';
        res.colDef = this.column.getColDef();
        return res;
    };
    ToolPanelColumnComp.prototype.onContextMenu = function (e) {
        var _this = this;
        var _a = this,
            column = _a.column,
            gridOptionsService = _a.gridOptionsService;
        if (gridOptionsService.is('functionsReadOnly')) {
            return;
        }
        var contextMenu = this.createBean(new ToolPanelContextMenu(column, e, this.focusWrapper));
        this.addDestroyFunc(function () {
            if (contextMenu.isAlive()) {
                _this.destroyBean(contextMenu);
            }
        });
    };
    ToolPanelColumnComp.prototype.handleKeyDown = function (e) {
        if (e.key === KeyCode.SPACE) {
            e.preventDefault();
            if (this.isSelectable()) {
                this.onSelectAllChanged(!this.isSelected());
            }
        }
    };
    ToolPanelColumnComp.prototype.onLabelClicked = function () {
        if (this.gridOptionsService.is('functionsReadOnly')) {
            return;
        }
        var nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    };
    ToolPanelColumnComp.prototype.onCheckboxChanged = function (event) {
        this.onChangeCommon(event.selected);
    };
    ToolPanelColumnComp.prototype.onChangeCommon = function (nextState) {
        // ignore lock visible columns
        if (this.cbSelect.isReadOnly()) {
            return;
        }
        this.refreshAriaLabel();
        // only want to action if the user clicked the checkbox, not if we are setting the checkbox because
        // of a change in the model
        if (this.processingColumnStateChange) {
            return;
        }
        this.modelItemUtils.setColumn(this.column, nextState, 'toolPanelUi');
    };
    ToolPanelColumnComp.prototype.refreshAriaLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var columnLabel = translate('ariaColumn', 'Column');
        var state = this.cbSelect.getValue() ? translate('ariaVisible', 'visible') : translate('ariaHidden', 'hidden');
        var visibilityLabel = translate('ariaToggleVisibility', 'Press SPACE to toggle visibility');
        _.setAriaLabel(this.focusWrapper, this.displayName + ' ' + columnLabel);
        this.cbSelect.setInputAriaLabel(visibilityLabel + ' (' + state + ')');
        _.setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
    };
    ToolPanelColumnComp.prototype.setupDragging = function () {
        var _this = this;
        if (!this.allowDragging) {
            _.setDisplayed(this.eDragHandle, false);
            return;
        }
        var hideColumnOnExit = !this.gridOptionsService.is('suppressDragLeaveHidesColumns');
        var dragSource = {
            type: DragSourceType.ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: function () {
                return hideColumnOnExit ? DragAndDropService.ICON_HIDE : DragAndDropService.ICON_NOT_ALLOWED;
            },
            getDragItem: function () {
                return _this.createDragItem();
            },
            onDragStarted: function () {
                hideColumnOnExit = !_this.gridOptionsService.is('suppressDragLeaveHidesColumns');
                var event = {
                    type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
                    column: _this.column,
                };
                _this.eventService.dispatchEvent(event);
            },
            onDragStopped: function () {
                var event = {
                    type: Events.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
                };
                _this.eventService.dispatchEvent(event);
            },
            onGridEnter: function (dragItem) {
                if (hideColumnOnExit) {
                    // when dragged into the grid, restore the state that was active pre-drag
                    _this.modelItemUtils.updateColumns({
                        columns: [_this.column],
                        visibleState: dragItem === null || dragItem === void 0 ? void 0 : dragItem.visibleState,
                        pivotState: dragItem === null || dragItem === void 0 ? void 0 : dragItem.pivotState,
                        eventType: 'toolPanelUi',
                    });
                }
            },
            onGridExit: function () {
                if (hideColumnOnExit) {
                    // when dragged outside of the grid, mimic what happens when checkbox is disabled
                    // this handles the behaviour for pivot which is different to just hiding a column.
                    _this.onChangeCommon(false);
                }
            },
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDragSource(dragSource);
        });
    };
    ToolPanelColumnComp.prototype.createDragItem = function () {
        var _a, _b;
        var colId = this.column.getColId();
        var visibleState = ((_a = {}), (_a[colId] = this.column.isVisible()), _a);
        var pivotState = ((_b = {}), (_b[colId] = this.modelItemUtils.createPivotState(this.column)), _b);
        return {
            columns: [this.column],
            visibleState: visibleState,
            pivotState: pivotState,
        };
    };
    ToolPanelColumnComp.prototype.onColumnStateChanged = function () {
        this.processingColumnStateChange = true;
        var isPivotMode = this.columnModel.isPivotMode();
        if (isPivotMode) {
            // if reducing, checkbox means column is one of pivot, value or group
            var anyFunctionActive = this.column.isAnyFunctionActive();
            this.cbSelect.setValue(anyFunctionActive);
        } else {
            // if not reducing, the checkbox tells us if column is visible or not
            this.cbSelect.setValue(this.column.isVisible());
        }
        var canBeToggled = true;
        var canBeDragged = true;
        if (isPivotMode) {
            // when in pivot mode, the item should be read only if:
            //  a) gui is not allowed make any changes
            var functionsReadOnly = this.gridOptionsService.is('functionsReadOnly');
            //  b) column is not allow any functions on it
            var noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
            canBeToggled = !functionsReadOnly && !noFunctionsAllowed;
            canBeDragged = canBeToggled;
        } else {
            var _a = this.column.getColDef(),
                enableRowGroup = _a.enableRowGroup,
                enableValue = _a.enableValue,
                lockPosition = _a.lockPosition,
                suppressMovable = _a.suppressMovable,
                lockVisible = _a.lockVisible;
            var forceDraggable = !!enableRowGroup || !!enableValue;
            var disableDraggable = !!lockPosition || !!suppressMovable;
            canBeToggled = !lockVisible;
            canBeDragged = forceDraggable || !disableDraggable;
        }
        this.cbSelect.setReadOnly(!canBeToggled);
        this.eDragHandle.classList.toggle('ag-column-select-column-readonly', !canBeDragged);
        this.addOrRemoveCssClass('ag-column-select-column-readonly', !canBeDragged && !canBeToggled);
        var checkboxPassive = isPivotMode && this.gridOptionsService.is('functionsPassive');
        this.cbSelect.setPassive(checkboxPassive);
        this.processingColumnStateChange = false;
    };
    ToolPanelColumnComp.prototype.getDisplayName = function () {
        return this.displayName;
    };
    ToolPanelColumnComp.prototype.onSelectAllChanged = function (value) {
        if (value !== this.cbSelect.getValue()) {
            if (!this.cbSelect.isReadOnly()) {
                this.cbSelect.toggle();
            }
        }
    };
    ToolPanelColumnComp.prototype.isSelected = function () {
        return this.cbSelect.getValue();
    };
    ToolPanelColumnComp.prototype.isSelectable = function () {
        return !this.cbSelect.isReadOnly();
    };
    ToolPanelColumnComp.prototype.isExpandable = function () {
        return false;
    };
    ToolPanelColumnComp.prototype.setExpanded = function (value) {
        console.warn('AG Grid: can not expand a column item that does not represent a column group header');
    };
    ToolPanelColumnComp.TEMPLATE =
        '<div class="ag-column-select-column" aria-hidden="true">\n            <ag-checkbox ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>\n            <span class="ag-column-select-column-label" ref="eLabel"></span>\n        </div>';
    __decorate$2t([Autowired('columnModel')], ToolPanelColumnComp.prototype, 'columnModel', void 0);
    __decorate$2t([Autowired('dragAndDropService')], ToolPanelColumnComp.prototype, 'dragAndDropService', void 0);
    __decorate$2t([Autowired('modelItemUtils')], ToolPanelColumnComp.prototype, 'modelItemUtils', void 0);
    __decorate$2t([RefSelector('eLabel')], ToolPanelColumnComp.prototype, 'eLabel', void 0);
    __decorate$2t([RefSelector('cbSelect')], ToolPanelColumnComp.prototype, 'cbSelect', void 0);
    __decorate$2t([PostConstruct], ToolPanelColumnComp.prototype, 'init', null);
    return ToolPanelColumnComp;
})(Component);

var __extends$3i =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2s =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var UIColumnModel = /** @class */ (function () {
    function UIColumnModel(items) {
        this.items = items;
    }
    UIColumnModel.prototype.getRowCount = function () {
        return this.items.length;
    };
    UIColumnModel.prototype.getRow = function (index) {
        return this.items[index];
    };
    return UIColumnModel;
})();
var PRIMARY_COLS_LIST_PANEL_CLASS = 'ag-column-select-list';
var PrimaryColsListPanel = /** @class */ (function (_super) {
    __extends$3i(PrimaryColsListPanel, _super);
    function PrimaryColsListPanel() {
        var _this = _super.call(this, PrimaryColsListPanel.TEMPLATE) || this;
        _this.destroyColumnItemFuncs = [];
        return _this;
    }
    PrimaryColsListPanel.prototype.destroyColumnTree = function () {
        this.allColsTree = [];
        this.destroyColumnItemFuncs.forEach(function (f) {
            return f();
        });
        this.destroyColumnItemFuncs = [];
    };
    PrimaryColsListPanel.prototype.init = function (params, allowDragging, eventType) {
        var _this = this;
        this.params = params;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        if (!this.params.suppressSyncLayoutWithGrid) {
            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.onColumnsChanged.bind(this));
        }
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnsChanged.bind(this));
        var eventsImpactingCheckedState = [
            Events.EVENT_COLUMN_PIVOT_CHANGED,
            Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
            Events.EVENT_COLUMN_VALUE_CHANGED,
            Events.EVENT_COLUMN_VISIBLE,
            Events.EVENT_NEW_COLUMNS_LOADED,
        ];
        eventsImpactingCheckedState.forEach(function (event) {
            // update header select all checkbox with current selection state
            _this.addManagedListener(_this.eventService, event, _this.fireSelectionChangedEvent.bind(_this));
        });
        this.expandGroupsByDefault = !this.params.contractColumnSelection;
        var translate = this.localeService.getLocaleTextFunc();
        var columnListName = translate('ariaColumnList', 'Column List');
        this.virtualList = this.createManagedBean(
            new VirtualList({
                cssIdentifier: 'column-select',
                ariaRole: 'tree',
                listName: columnListName,
            }),
        );
        this.appendChild(this.virtualList.getGui());
        this.virtualList.setComponentCreator(function (item, listItemElement) {
            _.setAriaLevel(listItemElement, item.getDept() + 1);
            return _this.createComponentFromItem(item, listItemElement);
        });
        if (this.columnModel.isReady()) {
            this.onColumnsChanged();
        }
        if (!params.suppressColumnMove && !this.gridOptionsService.is('suppressMovableColumns')) {
            this.createManagedBean(new PrimaryColsListPanelItemDragFeature(this, this.virtualList));
        }
    };
    PrimaryColsListPanel.prototype.createComponentFromItem = function (item, listItemElement) {
        if (item.isGroup()) {
            var renderedGroup = new ToolPanelColumnGroupComp(item, this.allowDragging, this.eventType, listItemElement);
            this.getContext().createBean(renderedGroup);
            return renderedGroup;
        }
        var columnComp = new ToolPanelColumnComp(item, this.allowDragging, this.groupsExist, listItemElement);
        this.getContext().createBean(columnComp);
        return columnComp;
    };
    PrimaryColsListPanel.prototype.onColumnsChanged = function () {
        var expandedStates = this.getExpandedStates();
        var pivotModeActive = this.columnModel.isPivotMode();
        var shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        if (shouldSyncColumnLayoutWithGrid) {
            this.buildTreeFromWhatGridIsDisplaying();
        } else {
            this.buildTreeFromProvidedColumnDefs();
        }
        this.setExpandedStates(expandedStates);
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    };
    PrimaryColsListPanel.prototype.getDisplayedColsList = function () {
        return this.displayedColsList;
    };
    PrimaryColsListPanel.prototype.getExpandedStates = function () {
        if (!this.allColsTree) {
            return {};
        }
        var res = {};
        this.forEachItem(function (item) {
            if (!item.isGroup()) {
                return;
            }
            var colGroup = item.getColumnGroup();
            if (colGroup) {
                // group should always exist, this is defensive
                res[colGroup.getId()] = item.isExpanded();
            }
        });
        return res;
    };
    PrimaryColsListPanel.prototype.setExpandedStates = function (states) {
        if (!this.allColsTree) {
            return;
        }
        this.forEachItem(function (item) {
            if (!item.isGroup()) {
                return;
            }
            var colGroup = item.getColumnGroup();
            if (colGroup) {
                // group should always exist, this is defensive
                var expanded = states[colGroup.getId()];
                var groupExistedLastTime = expanded != null;
                if (groupExistedLastTime) {
                    item.setExpanded(expanded);
                }
            }
        });
    };
    PrimaryColsListPanel.prototype.buildTreeFromWhatGridIsDisplaying = function () {
        this.colDefService.syncLayoutWithGrid(this.setColumnLayout.bind(this));
    };
    PrimaryColsListPanel.prototype.setColumnLayout = function (colDefs) {
        var columnTree = this.colDefService.createColumnTree(colDefs);
        this.buildListModel(columnTree);
        // using col defs to check if groups exist as it could be a custom layout
        this.groupsExist = colDefs.some(function (colDef) {
            return colDef && typeof colDef.children !== 'undefined';
        });
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    };
    PrimaryColsListPanel.prototype.buildTreeFromProvidedColumnDefs = function () {
        // add column / group comps to tool panel
        this.buildListModel(this.columnModel.getPrimaryColumnTree());
        this.groupsExist = this.columnModel.isPrimaryColumnGroupsPresent();
    };
    PrimaryColsListPanel.prototype.buildListModel = function (columnTree) {
        var _this = this;
        var columnExpandedListener = this.onColumnExpanded.bind(this);
        var addListeners = function (item) {
            item.addEventListener(ColumnModelItem.EVENT_EXPANDED_CHANGED, columnExpandedListener);
            var removeFunc = item.removeEventListener.bind(
                item,
                ColumnModelItem.EVENT_EXPANDED_CHANGED,
                columnExpandedListener,
            );
            _this.destroyColumnItemFuncs.push(removeFunc);
        };
        var recursivelyBuild = function (tree, dept, parentList) {
            tree.forEach(function (child) {
                if (child instanceof ProvidedColumnGroup) {
                    createGroupItem(child, dept, parentList);
                } else {
                    createColumnItem(child, dept, parentList);
                }
            });
        };
        var createGroupItem = function (columnGroup, dept, parentList) {
            var columnGroupDef = columnGroup.getColGroupDef();
            var skipThisGroup = columnGroupDef && columnGroupDef.suppressColumnsToolPanel;
            if (skipThisGroup) {
                return;
            }
            if (columnGroup.isPadding()) {
                recursivelyBuild(columnGroup.getChildren(), dept, parentList);
                return;
            }
            var displayName = _this.columnModel.getDisplayNameForProvidedColumnGroup(
                null,
                columnGroup,
                'columnToolPanel',
            );
            var item = new ColumnModelItem(displayName, columnGroup, dept, true, _this.expandGroupsByDefault);
            parentList.push(item);
            addListeners(item);
            recursivelyBuild(columnGroup.getChildren(), dept + 1, item.getChildren());
        };
        var createColumnItem = function (column, dept, parentList) {
            var skipThisColumn = column.getColDef() && column.getColDef().suppressColumnsToolPanel;
            if (skipThisColumn) {
                return;
            }
            var displayName = _this.columnModel.getDisplayNameForColumn(column, 'columnToolPanel');
            parentList.push(new ColumnModelItem(displayName, column, dept));
        };
        this.destroyColumnTree();
        recursivelyBuild(columnTree, 0, this.allColsTree);
    };
    PrimaryColsListPanel.prototype.onColumnExpanded = function () {
        this.flattenAndFilterModel();
    };
    PrimaryColsListPanel.prototype.flattenAndFilterModel = function () {
        var _this = this;
        this.displayedColsList = [];
        var recursiveFunc = function (item) {
            if (!item.isPassesFilter()) {
                return;
            }
            _this.displayedColsList.push(item);
            if (item.isGroup() && item.isExpanded()) {
                item.getChildren().forEach(recursiveFunc);
            }
        };
        this.allColsTree.forEach(recursiveFunc);
        this.virtualList.setModel(new UIColumnModel(this.displayedColsList));
        var focusedRow = this.virtualList.getLastFocusedRow();
        this.virtualList.refresh();
        if (focusedRow != null) {
            this.focusRowIfAlive(focusedRow);
        }
        this.notifyListeners();
    };
    PrimaryColsListPanel.prototype.focusRowIfAlive = function (rowIndex) {
        var _this = this;
        window.setTimeout(function () {
            if (_this.isAlive()) {
                _this.virtualList.focusRow(rowIndex);
            }
        }, 0);
    };
    PrimaryColsListPanel.prototype.forEachItem = function (callback) {
        var recursiveFunc = function (items) {
            items.forEach(function (item) {
                callback(item);
                if (item.isGroup()) {
                    recursiveFunc(item.getChildren());
                }
            });
        };
        recursiveFunc(this.allColsTree);
    };
    PrimaryColsListPanel.prototype.doSetExpandedAll = function (value) {
        this.forEachItem(function (item) {
            if (item.isGroup()) {
                item.setExpanded(value);
            }
        });
    };
    PrimaryColsListPanel.prototype.setGroupsExpanded = function (expand, groupIds) {
        if (!groupIds) {
            this.doSetExpandedAll(expand);
            return;
        }
        var expandedGroupIds = [];
        this.forEachItem(function (item) {
            if (!item.isGroup()) {
                return;
            }
            var groupId = item.getColumnGroup().getId();
            if (groupIds.indexOf(groupId) >= 0) {
                item.setExpanded(expand);
                expandedGroupIds.push(groupId);
            }
        });
        var unrecognisedGroupIds = groupIds.filter(function (groupId) {
            return !_.includes(expandedGroupIds, groupId);
        });
        if (unrecognisedGroupIds.length > 0) {
            console.warn('AG Grid: unable to find group(s) for supplied groupIds:', unrecognisedGroupIds);
        }
    };
    PrimaryColsListPanel.prototype.getExpandState = function () {
        var expandedCount = 0;
        var notExpandedCount = 0;
        this.forEachItem(function (item) {
            if (!item.isGroup()) {
                return;
            }
            if (item.isExpanded()) {
                expandedCount++;
            } else {
                notExpandedCount++;
            }
        });
        if (expandedCount > 0 && notExpandedCount > 0) {
            return ExpandState.INDETERMINATE;
        }
        if (notExpandedCount > 0) {
            return ExpandState.COLLAPSED;
        }
        return ExpandState.EXPANDED;
    };
    PrimaryColsListPanel.prototype.doSetSelectedAll = function (selectAllChecked) {
        this.modelItemUtils.selectAllChildren(this.allColsTree, selectAllChecked, this.eventType);
    };
    PrimaryColsListPanel.prototype.getSelectionState = function () {
        var checkedCount = 0;
        var uncheckedCount = 0;
        var pivotMode = this.columnModel.isPivotMode();
        this.forEachItem(function (item) {
            if (item.isGroup()) {
                return;
            }
            if (!item.isPassesFilter()) {
                return;
            }
            var column = item.getColumn();
            var colDef = column.getColDef();
            var checked;
            if (pivotMode) {
                var noPivotModeOptionsAllowed =
                    !column.isAllowPivot() && !column.isAllowRowGroup() && !column.isAllowValue();
                if (noPivotModeOptionsAllowed) {
                    return;
                }
                checked = column.isValueActive() || column.isPivotActive() || column.isRowGroupActive();
            } else {
                if (colDef.lockVisible) {
                    return;
                }
                checked = column.isVisible();
            }
            checked ? checkedCount++ : uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) {
            return undefined;
        }
        return !(checkedCount === 0 || uncheckedCount > 0);
    };
    PrimaryColsListPanel.prototype.setFilterText = function (filterText) {
        this.filterText = _.exists(filterText) ? filterText.toLowerCase() : null;
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    };
    PrimaryColsListPanel.prototype.markFilteredColumns = function () {
        var _this = this;
        var passesFilter = function (item) {
            if (!_.exists(_this.filterText)) {
                return true;
            }
            var displayName = item.getDisplayName();
            return displayName == null || displayName.toLowerCase().indexOf(_this.filterText) !== -1;
        };
        var recursivelyCheckFilter = function (item, parentPasses) {
            var atLeastOneChildPassed = false;
            if (item.isGroup()) {
                var groupPasses_1 = passesFilter(item);
                item.getChildren().forEach(function (child) {
                    var childPasses = recursivelyCheckFilter(child, groupPasses_1 || parentPasses);
                    if (childPasses) {
                        atLeastOneChildPassed = childPasses;
                    }
                });
            }
            var filterPasses = parentPasses || atLeastOneChildPassed ? true : passesFilter(item);
            item.setPassesFilter(filterPasses);
            return filterPasses;
        };
        this.allColsTree.forEach(function (item) {
            return recursivelyCheckFilter(item, false);
        });
    };
    PrimaryColsListPanel.prototype.notifyListeners = function () {
        this.fireGroupExpandedEvent();
        this.fireSelectionChangedEvent();
    };
    PrimaryColsListPanel.prototype.fireGroupExpandedEvent = function () {
        var expandState = this.getExpandState();
        this.dispatchEvent({ type: 'groupExpanded', state: expandState });
    };
    PrimaryColsListPanel.prototype.fireSelectionChangedEvent = function () {
        var selectionState = this.getSelectionState();
        this.dispatchEvent({ type: 'selectionChanged', state: selectionState });
    };
    PrimaryColsListPanel.TEMPLATE = '<div class="' + PRIMARY_COLS_LIST_PANEL_CLASS + '" role="presentation"></div>';
    __decorate$2s([Autowired('columnModel')], PrimaryColsListPanel.prototype, 'columnModel', void 0);
    __decorate$2s([Autowired('toolPanelColDefService')], PrimaryColsListPanel.prototype, 'colDefService', void 0);
    __decorate$2s([Autowired('modelItemUtils')], PrimaryColsListPanel.prototype, 'modelItemUtils', void 0);
    __decorate$2s([PreDestroy], PrimaryColsListPanel.prototype, 'destroyColumnTree', null);
    return PrimaryColsListPanel;
})(Component);

var __extends$3h =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2r =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PivotModePanel = /** @class */ (function (_super) {
    __extends$3h(PivotModePanel, _super);
    function PivotModePanel() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    PivotModePanel.prototype.createTemplate = function () {
        return /* html */ '<div class="ag-pivot-mode-panel">\n                <ag-toggle-button ref="cbPivotMode" class="ag-pivot-mode-select"></ag-toggle-button>\n            </div>';
    };
    PivotModePanel.prototype.init = function () {
        this.setTemplate(this.createTemplate());
        this.cbPivotMode.setValue(this.columnModel.isPivotMode());
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        this.cbPivotMode.setLabel(localeTextFunc('pivotMode', 'Pivot Mode'));
        this.addManagedListener(this.cbPivotMode, Events.EVENT_FIELD_VALUE_CHANGED, this.onBtPivotMode.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onPivotModeChanged.bind(this));
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            this.onPivotModeChanged.bind(this),
        );
    };
    PivotModePanel.prototype.onBtPivotMode = function () {
        var newValue = !!this.cbPivotMode.getValue();
        if (newValue !== this.columnModel.isPivotMode()) {
            this.columnModel.setPivotMode(newValue, 'toolPanelUi');
            var api = this.gridOptionsService.api;
            if (api) {
                api.refreshHeader();
            }
        }
    };
    PivotModePanel.prototype.onPivotModeChanged = function () {
        var pivotModeActive = this.columnModel.isPivotMode();
        this.cbPivotMode.setValue(pivotModeActive);
    };
    __decorate$2r([Autowired('columnModel')], PivotModePanel.prototype, 'columnModel', void 0);
    __decorate$2r([RefSelector('cbPivotMode')], PivotModePanel.prototype, 'cbPivotMode', void 0);
    __decorate$2r([PreConstruct], PivotModePanel.prototype, 'init', null);
    return PivotModePanel;
})(Component);

var __extends$3g =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2q =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AggregationStage = /** @class */ (function (_super) {
    __extends$3g(AggregationStage, _super);
    function AggregationStage() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    AggregationStage.prototype.execute = function (params) {
        // if changed path is active, it means we came from a) change detection or b) transaction update.
        // for both of these, if no value columns are present, it means there is nothing to aggregate now
        // and there is no cleanup to be done (as value columns don't change between transactions or change
        // detections). if no value columns and no changed path, means we have to go through all nodes in
        // case we need to clean up agg data from before.
        var noValueColumns = _.missingOrEmpty(this.columnModel.getValueColumns());
        var noUserAgg = !this.gridOptionsService.getCallback('getGroupRowAgg');
        var changedPathActive = params.changedPath && params.changedPath.isActive();
        if (noValueColumns && noUserAgg && changedPathActive) {
            return;
        }
        var aggDetails = this.createAggDetails(params);
        this.recursivelyCreateAggData(aggDetails);
    };
    AggregationStage.prototype.createAggDetails = function (params) {
        var pivotActive = this.columnModel.isPivotActive();
        var measureColumns = this.columnModel.getValueColumns();
        var pivotColumns = pivotActive ? this.columnModel.getPivotColumns() : [];
        var aggDetails = {
            alwaysAggregateAtRootLevel: this.gridOptionsService.is('alwaysAggregateAtRootLevel'),
            groupIncludeTotalFooter: this.gridOptionsService.is('groupIncludeTotalFooter'),
            changedPath: params.changedPath,
            valueColumns: measureColumns,
            pivotColumns: pivotColumns,
            filteredOnly: !this.isSuppressAggFilteredOnly(),
            userAggFunc: this.gridOptionsService.getCallback('getGroupRowAgg'),
        };
        return aggDetails;
    };
    AggregationStage.prototype.isSuppressAggFilteredOnly = function () {
        var isGroupAggFiltering = this.gridOptionsService.getGroupAggFiltering() !== undefined;
        return isGroupAggFiltering || this.gridOptionsService.is('suppressAggFilteredOnly');
    };
    AggregationStage.prototype.recursivelyCreateAggData = function (aggDetails) {
        var _this = this;
        var callback = function (rowNode) {
            var hasNoChildren = !rowNode.hasChildren();
            if (hasNoChildren) {
                // this check is needed for TreeData, in case the node is no longer a child,
                // but it was a child previously.
                if (rowNode.aggData) {
                    rowNode.setAggData(null);
                }
                // never agg data for leaf nodes
                return;
            }
            //Optionally enable the aggregation at the root Node
            var isRootNode = rowNode.level === -1;
            // if total footer is displayed, the value is in use
            if (isRootNode && !aggDetails.groupIncludeTotalFooter) {
                var notPivoting = !_this.columnModel.isPivotMode();
                if (!aggDetails.alwaysAggregateAtRootLevel && notPivoting) {
                    return;
                }
            }
            _this.aggregateRowNode(rowNode, aggDetails);
        };
        aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
    };
    AggregationStage.prototype.aggregateRowNode = function (rowNode, aggDetails) {
        var measureColumnsMissing = aggDetails.valueColumns.length === 0;
        var pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
        var aggResult;
        if (aggDetails.userAggFunc) {
            aggResult = aggDetails.userAggFunc({ nodes: rowNode.childrenAfterFilter });
        } else if (measureColumnsMissing) {
            aggResult = null;
        } else if (pivotColumnsMissing) {
            aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
        } else {
            aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
        }
        rowNode.setAggData(aggResult);
        // if we are grouping, then it's possible there is a sibling footer
        // to the group, so update the data here also if there is one
        if (rowNode.sibling) {
            rowNode.sibling.setAggData(aggResult);
        }
    };
    AggregationStage.prototype.aggregateRowNodeUsingValuesAndPivot = function (rowNode) {
        var _this = this;
        var _a;
        var result = {};
        var secondaryColumns = (_a = this.columnModel.getSecondaryColumns()) !== null && _a !== void 0 ? _a : [];
        secondaryColumns.forEach(function (secondaryCol) {
            var _a = secondaryCol.getColDef(),
                pivotValueColumn = _a.pivotValueColumn,
                pivotTotalColumnIds = _a.pivotTotalColumnIds,
                colId = _a.colId,
                pivotKeys = _a.pivotKeys;
            if (_.exists(pivotTotalColumnIds)) {
                return;
            }
            var keys = pivotKeys !== null && pivotKeys !== void 0 ? pivotKeys : [];
            var values;
            if (rowNode.leafGroup) {
                // lowest level group, get the values from the mapped set
                values = _this.getValuesFromMappedSet(rowNode.childrenMapped, keys, pivotValueColumn);
            } else {
                // value columns and pivot columns, non-leaf group
                values = _this.getValuesPivotNonLeaf(rowNode, colId);
            }
            result[colId] = _this.aggregateValues(
                values,
                pivotValueColumn.getAggFunc(),
                pivotValueColumn,
                rowNode,
                secondaryCol,
            );
        });
        secondaryColumns.forEach(function (secondaryCol) {
            var _a = secondaryCol.getColDef(),
                pivotValueColumn = _a.pivotValueColumn,
                pivotTotalColumnIds = _a.pivotTotalColumnIds,
                colId = _a.colId;
            if (!_.exists(pivotTotalColumnIds)) {
                return;
            }
            var aggResults = [];
            //retrieve results for colIds associated with this pivot total column
            if (!pivotTotalColumnIds || !pivotTotalColumnIds.length) {
                return;
            }
            pivotTotalColumnIds.forEach(function (currentColId) {
                aggResults.push(result[currentColId]);
            });
            result[colId] = _this.aggregateValues(
                aggResults,
                pivotValueColumn.getAggFunc(),
                pivotValueColumn,
                rowNode,
                secondaryCol,
            );
        });
        return result;
    };
    AggregationStage.prototype.aggregateRowNodeUsingValuesOnly = function (rowNode, aggDetails) {
        var _this = this;
        var result = {};
        var changedValueColumns = aggDetails.changedPath.isActive()
            ? aggDetails.changedPath.getValueColumnsForNode(rowNode, aggDetails.valueColumns)
            : aggDetails.valueColumns;
        var notChangedValueColumns = aggDetails.changedPath.isActive()
            ? aggDetails.changedPath.getNotValueColumnsForNode(rowNode, aggDetails.valueColumns)
            : null;
        var values2d = this.getValuesNormal(rowNode, changedValueColumns, aggDetails.filteredOnly);
        var oldValues = rowNode.aggData;
        changedValueColumns.forEach(function (valueColumn, index) {
            result[valueColumn.getId()] = _this.aggregateValues(
                values2d[index],
                valueColumn.getAggFunc(),
                valueColumn,
                rowNode,
            );
        });
        if (notChangedValueColumns && oldValues) {
            notChangedValueColumns.forEach(function (valueColumn) {
                result[valueColumn.getId()] = oldValues[valueColumn.getId()];
            });
        }
        return result;
    };
    AggregationStage.prototype.getValuesPivotNonLeaf = function (rowNode, colId) {
        var values = [];
        rowNode.childrenAfterFilter.forEach(function (node) {
            var value = node.aggData[colId];
            values.push(value);
        });
        return values;
    };
    AggregationStage.prototype.getValuesFromMappedSet = function (mappedSet, keys, valueColumn) {
        var _this = this;
        var mapPointer = mappedSet;
        keys.forEach(function (key) {
            return (mapPointer = mapPointer ? mapPointer[key] : null);
        });
        if (!mapPointer) {
            return [];
        }
        var values = [];
        mapPointer.forEach(function (rowNode) {
            var value = _this.valueService.getValue(valueColumn, rowNode);
            values.push(value);
        });
        return values;
    };
    AggregationStage.prototype.getValuesNormal = function (rowNode, valueColumns, filteredOnly) {
        // create 2d array, of all values for all valueColumns
        var values = [];
        valueColumns.forEach(function () {
            return values.push([]);
        });
        var valueColumnCount = valueColumns.length;
        var nodeList = filteredOnly ? rowNode.childrenAfterFilter : rowNode.childrenAfterGroup;
        var rowCount = nodeList.length;
        for (var i = 0; i < rowCount; i++) {
            var childNode = nodeList[i];
            for (var j = 0; j < valueColumnCount; j++) {
                var valueColumn = valueColumns[j];
                // if the row is a group, then it will only have an agg result value,
                // which means valueGetter is never used.
                var value = this.valueService.getValue(valueColumn, childNode);
                values[j].push(value);
            }
        }
        return values;
    };
    AggregationStage.prototype.aggregateValues = function (
        values,
        aggFuncOrString,
        column,
        rowNode,
        pivotResultColumn,
    ) {
        var aggFunc =
            typeof aggFuncOrString === 'string' ? this.aggFuncService.getAggFunc(aggFuncOrString) : aggFuncOrString;
        if (typeof aggFunc !== 'function') {
            console.error('AG Grid: unrecognised aggregation function ' + aggFuncOrString);
            return null;
        }
        var aggFuncAny = aggFunc;
        var params = {
            values: values,
            column: column,
            colDef: column ? column.getColDef() : undefined,
            pivotResultColumn: pivotResultColumn,
            rowNode: rowNode,
            data: rowNode ? rowNode.data : undefined,
            api: this.gridOptionsService.api,
            columnApi: this.gridOptionsService.columnApi,
            context: this.gridOptionsService.context,
        }; // the "as any" is needed to allow the deprecation warning messages
        return aggFuncAny(params);
    };
    __decorate$2q([Autowired('columnModel')], AggregationStage.prototype, 'columnModel', void 0);
    __decorate$2q([Autowired('valueService')], AggregationStage.prototype, 'valueService', void 0);
    __decorate$2q([Autowired('aggFuncService')], AggregationStage.prototype, 'aggFuncService', void 0);
    AggregationStage = __decorate$2q([Bean('aggregationStage')], AggregationStage);
    return AggregationStage;
})(BeanStub);

var BatchRemover = /** @class */ (function () {
    function BatchRemover() {
        this.allSets = {};
        this.allParents = [];
    }
    BatchRemover.prototype.removeFromChildrenAfterGroup = function (parent, child) {
        var set = this.getSet(parent);
        set.removeFromChildrenAfterGroup[child.id] = true;
    };
    BatchRemover.prototype.isRemoveFromAllLeafChildren = function (parent, child) {
        var set = this.getSet(parent);
        return !!set.removeFromAllLeafChildren[child.id];
    };
    BatchRemover.prototype.preventRemoveFromAllLeafChildren = function (parent, child) {
        var set = this.getSet(parent);
        delete set.removeFromAllLeafChildren[child.id];
    };
    BatchRemover.prototype.removeFromAllLeafChildren = function (parent, child) {
        var set = this.getSet(parent);
        set.removeFromAllLeafChildren[child.id] = true;
    };
    BatchRemover.prototype.getSet = function (parent) {
        if (!this.allSets[parent.id]) {
            this.allSets[parent.id] = {
                removeFromAllLeafChildren: {},
                removeFromChildrenAfterGroup: {},
            };
            this.allParents.push(parent);
        }
        return this.allSets[parent.id];
    };
    BatchRemover.prototype.getAllParents = function () {
        return this.allParents;
    };
    BatchRemover.prototype.flush = function () {
        var _this = this;
        this.allParents.forEach(function (parent) {
            var nodeDetails = _this.allSets[parent.id];
            parent.childrenAfterGroup = parent.childrenAfterGroup.filter(function (child) {
                return !nodeDetails.removeFromChildrenAfterGroup[child.id];
            });
            parent.allLeafChildren = parent.allLeafChildren.filter(function (child) {
                return !nodeDetails.removeFromAllLeafChildren[child.id];
            });
            parent.updateHasChildren();
            if (parent.sibling) {
                parent.sibling.childrenAfterGroup = parent.childrenAfterGroup;
                parent.sibling.allLeafChildren = parent.allLeafChildren;
            }
        });
        this.allSets = {};
        this.allParents.length = 0;
    };
    return BatchRemover;
})();

var __extends$3f =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2p =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1k =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$P =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var GroupStage = /** @class */ (function (_super) {
    __extends$3f(GroupStage, _super);
    function GroupStage() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        // we use a sequence variable so that each time we do a grouping, we don't
        // reuse the ids - otherwise the rowRenderer will confuse rowNodes between redraws
        // when it tries to animate between rows.
        _this.groupIdSequence = new NumberSequence();
        return _this;
    }
    GroupStage.prototype.execute = function (params) {
        var details = this.createGroupingDetails(params);
        if (details.transactions) {
            this.handleTransaction(details);
        } else {
            var afterColsChanged = params.afterColumnsChanged === true;
            this.shotgunResetEverything(details, afterColsChanged);
        }
        if (!details.usingTreeData) {
            // we don't do group sorting for tree data
            this.positionLeafsAndGroups(params.changedPath);
            this.orderGroups(details);
        }
        this.selectableService.updateSelectableAfterGrouping(details.rootNode);
    };
    GroupStage.prototype.positionLeafsAndGroups = function (changedPath) {
        changedPath.forEachChangedNodeDepthFirst(function (group) {
            if (group.childrenAfterGroup) {
                var leafNodes_1 = [];
                var groupNodes_1 = [];
                var unbalancedNode_1;
                group.childrenAfterGroup.forEach(function (row) {
                    var _a;
                    if (!((_a = row.childrenAfterGroup) === null || _a === void 0 ? void 0 : _a.length)) {
                        leafNodes_1.push(row);
                    } else {
                        if (row.key === '' && !unbalancedNode_1) {
                            unbalancedNode_1 = row;
                        } else {
                            groupNodes_1.push(row);
                        }
                    }
                });
                if (unbalancedNode_1) {
                    groupNodes_1.push(unbalancedNode_1);
                }
                group.childrenAfterGroup = __spreadArray$P(
                    __spreadArray$P([], __read$1k(leafNodes_1)),
                    __read$1k(groupNodes_1),
                );
            }
        }, false);
    };
    GroupStage.prototype.createGroupingDetails = function (params) {
        var rowNode = params.rowNode,
            changedPath = params.changedPath,
            rowNodeTransactions = params.rowNodeTransactions,
            rowNodeOrder = params.rowNodeOrder;
        var usingTreeData = this.gridOptionsService.is('treeData');
        var groupedCols = usingTreeData ? null : this.columnModel.getRowGroupColumns();
        var details = {
            // someone complained that the parent attribute was causing some change detection
            // to break in an angular add-on.  Taking the parent out breaks a cyclic dependency, hence this flag got introduced.
            includeParents: !this.gridOptionsService.is('suppressParentsInRowNodes'),
            expandByDefault: this.gridOptionsService.getNum('groupDefaultExpanded'),
            groupedCols: groupedCols,
            rootNode: rowNode,
            pivotMode: this.columnModel.isPivotMode(),
            groupedColCount: usingTreeData || !groupedCols ? 0 : groupedCols.length,
            rowNodeOrder: rowNodeOrder,
            transactions: rowNodeTransactions,
            // if no transaction, then it's shotgun, changed path would be 'not active' at this point anyway
            changedPath: changedPath,
            groupAllowUnbalanced: this.gridOptionsService.is('groupAllowUnbalanced'),
            isGroupOpenByDefault: this.gridOptionsService.getCallback('isGroupOpenByDefault'),
            initialGroupOrderComparator: this.gridOptionsService.getCallback('initialGroupOrderComparator'),
            createGroupFooter: this.gridOptionsService.isGroupIncludeFooterTrueOrCallback(),
            usingTreeData: usingTreeData,
            getDataPath: usingTreeData ? this.gridOptionsService.get('getDataPath') : undefined,
        };
        return details;
    };
    GroupStage.prototype.handleTransaction = function (details) {
        var _this = this;
        details.transactions.forEach(function (tran) {
            // we don't allow batch remover for tree data as tree data uses Filler Nodes,
            // and creating/deleting filler nodes needs to be done alongside the node deleting
            // and moving. if we want to Batch Remover working with tree data then would need
            // to consider how Filler Nodes would be impacted (it's possible that it can be easily
            // modified to work, however for now I don't have the brain energy to work it all out).
            var batchRemover = !details.usingTreeData ? new BatchRemover() : undefined;
            // the order here of [add, remove, update] needs to be the same as in ClientSideNodeManager,
            // as the order is important when a record with the same id is added and removed in the same
            // transaction.
            if (_.existsAndNotEmpty(tran.remove)) {
                _this.removeNodes(tran.remove, details, batchRemover);
            }
            if (_.existsAndNotEmpty(tran.update)) {
                _this.moveNodesInWrongPath(tran.update, details, batchRemover);
            }
            if (_.existsAndNotEmpty(tran.add)) {
                _this.insertNodes(tran.add, details, false);
            }
            // must flush here, and not allow another transaction to be applied,
            // as each transaction must finish leaving the data in a consistent state.
            if (batchRemover) {
                var parentsWithChildrenRemoved = batchRemover.getAllParents().slice();
                batchRemover.flush();
                _this.removeEmptyGroups(parentsWithChildrenRemoved, details);
            }
        });
        if (details.rowNodeOrder) {
            this.sortChildren(details);
        }
    };
    // this is used when doing delta updates, eg Redux, keeps nodes in right order
    GroupStage.prototype.sortChildren = function (details) {
        details.changedPath.forEachChangedNodeDepthFirst(
            function (node) {
                if (!node.childrenAfterGroup) {
                    return;
                }
                var didSort = _.sortRowNodesByOrder(node.childrenAfterGroup, details.rowNodeOrder);
                if (didSort) {
                    details.changedPath.addParentNode(node);
                }
            },
            false,
            true,
        );
    };
    GroupStage.prototype.orderGroups = function (details) {
        var comparator = details.initialGroupOrderComparator;
        if (_.exists(comparator)) {
            recursiveSort(details.rootNode);
        }
        function recursiveSort(rowNode) {
            var doSort =
                _.exists(rowNode.childrenAfterGroup) &&
                // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
                !rowNode.leafGroup;
            if (doSort) {
                rowNode.childrenAfterGroup.sort(function (nodeA, nodeB) {
                    return comparator({ nodeA: nodeA, nodeB: nodeB });
                });
                rowNode.childrenAfterGroup.forEach(function (childNode) {
                    return recursiveSort(childNode);
                });
            }
        }
    };
    GroupStage.prototype.getExistingPathForNode = function (node, details) {
        var res = [];
        // when doing tree data, the node is part of the path,
        // but when doing grid grouping, the node is not part of the path so we start with the parent.
        var pointer = details.usingTreeData ? node : node.parent;
        while (pointer && pointer !== details.rootNode) {
            res.push({
                key: pointer.key,
                rowGroupColumn: pointer.rowGroupColumn,
                field: pointer.field,
            });
            pointer = pointer.parent;
        }
        res.reverse();
        return res;
    };
    GroupStage.prototype.moveNodesInWrongPath = function (childNodes, details, batchRemover) {
        var _this = this;
        childNodes.forEach(function (childNode) {
            // we add node, even if parent has not changed, as the data could have
            // changed, hence aggregations will be wrong
            if (details.changedPath.isActive()) {
                details.changedPath.addParentNode(childNode.parent);
            }
            var infoToKeyMapper = function (item) {
                return item.key;
            };
            var oldPath = _this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
            var newPath = _this.getGroupInfo(childNode, details).map(infoToKeyMapper);
            var nodeInCorrectPath = _.areEqual(oldPath, newPath);
            if (!nodeInCorrectPath) {
                _this.moveNode(childNode, details, batchRemover);
            }
        });
    };
    GroupStage.prototype.moveNode = function (childNode, details, batchRemover) {
        this.removeNodesInStages([childNode], details, batchRemover);
        this.insertOneNode(childNode, details, true, batchRemover);
        // hack - if we didn't do this, then renaming a tree item (ie changing rowNode.key) wouldn't get
        // refreshed into the gui.
        // this is needed to kick off the event that rowComp listens to for refresh. this in turn
        // then will get each cell in the row to refresh - which is what we need as we don't know which
        // columns will be displaying the rowNode.key info.
        childNode.setData(childNode.data);
        // we add both old and new parents to changed path, as both will need to be refreshed.
        // we already added the old parent (in calling method), so just add the new parent here
        if (details.changedPath.isActive()) {
            var newParent = childNode.parent;
            details.changedPath.addParentNode(newParent);
        }
    };
    GroupStage.prototype.removeNodes = function (leafRowNodes, details, batchRemover) {
        this.removeNodesInStages(leafRowNodes, details, batchRemover);
        if (details.changedPath.isActive()) {
            leafRowNodes.forEach(function (rowNode) {
                return details.changedPath.addParentNode(rowNode.parent);
            });
        }
    };
    GroupStage.prototype.removeNodesInStages = function (leafRowNodes, details, batchRemover) {
        this.removeNodesFromParents(leafRowNodes, details, batchRemover);
        if (details.usingTreeData) {
            this.postRemoveCreateFillerNodes(leafRowNodes, details);
            // When not TreeData, then removeEmptyGroups is called just before the BatchRemover is flushed.
            // However for TreeData, there is no BatchRemover, so we have to call removeEmptyGroups here.
            var nodeParents = leafRowNodes.map(function (n) {
                return n.parent;
            });
            this.removeEmptyGroups(nodeParents, details);
        }
    };
    GroupStage.prototype.forEachParentGroup = function (details, group, callback) {
        var pointer = group;
        while (pointer && pointer !== details.rootNode) {
            callback(pointer);
            pointer = pointer.parent;
        }
    };
    GroupStage.prototype.removeNodesFromParents = function (nodesToRemove, details, provided) {
        var _this = this;
        // this method can be called with BatchRemover as optional. if it is missed, we created a local version
        // and flush it at the end. if one is provided, we add to the provided one and it gets flushed elsewhere.
        var batchRemoverIsLocal = provided == null;
        var batchRemoverToUse = provided ? provided : new BatchRemover();
        nodesToRemove.forEach(function (nodeToRemove) {
            _this.removeFromParent(nodeToRemove, batchRemoverToUse);
            // remove from allLeafChildren. we clear down all parents EXCEPT the Root Node, as
            // the ClientSideNodeManager is responsible for the Root Node.
            _this.forEachParentGroup(details, nodeToRemove.parent, function (parentNode) {
                batchRemoverToUse.removeFromAllLeafChildren(parentNode, nodeToRemove);
            });
        });
        if (batchRemoverIsLocal) {
            batchRemoverToUse.flush();
        }
    };
    GroupStage.prototype.postRemoveCreateFillerNodes = function (nodesToRemove, details) {
        var _this = this;
        nodesToRemove.forEach(function (nodeToRemove) {
            // if not group, and children are present, need to move children to a group.
            // otherwise if no children, we can just remove without replacing.
            var replaceWithGroup = nodeToRemove.hasChildren();
            if (replaceWithGroup) {
                var oldPath = _this.getExistingPathForNode(nodeToRemove, details);
                // because we just removed the userGroup, this will always return new support group
                var newGroupNode_1 = _this.findParentForNode(nodeToRemove, oldPath, details);
                // these properties are the ones that will be incorrect in the newly created group,
                // so copy them from the old childNode
                newGroupNode_1.expanded = nodeToRemove.expanded;
                newGroupNode_1.allLeafChildren = nodeToRemove.allLeafChildren;
                newGroupNode_1.childrenAfterGroup = nodeToRemove.childrenAfterGroup;
                newGroupNode_1.childrenMapped = nodeToRemove.childrenMapped;
                newGroupNode_1.updateHasChildren();
                newGroupNode_1.childrenAfterGroup.forEach(function (rowNode) {
                    return (rowNode.parent = newGroupNode_1);
                });
            }
        });
    };
    GroupStage.prototype.removeEmptyGroups = function (possibleEmptyGroups, details) {
        var _this = this;
        // we do this multiple times, as when we remove groups, that means the parent of just removed
        // group can then be empty. to get around this, if we remove, then we check everything again for
        // newly emptied groups. the max number of times this will execute is the depth of the group tree.
        var checkAgain = true;
        var groupShouldBeRemoved = function (rowNode) {
            // because of the while loop below, it's possible we already moved the node,
            // so double check before trying to remove again.
            var mapKey = _this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
            var parentRowNode = rowNode.parent;
            var groupAlreadyRemoved =
                parentRowNode && parentRowNode.childrenMapped ? !parentRowNode.childrenMapped[mapKey] : true;
            if (groupAlreadyRemoved) {
                // if not linked, then group was already removed
                return false;
            }
            // if still not removed, then we remove if this group is empty
            return !!rowNode.isEmptyRowGroupNode();
        };
        var _loop_1 = function () {
            checkAgain = false;
            var batchRemover = new BatchRemover();
            possibleEmptyGroups.forEach(function (possibleEmptyGroup) {
                // remove empty groups
                _this.forEachParentGroup(details, possibleEmptyGroup, function (rowNode) {
                    if (groupShouldBeRemoved(rowNode)) {
                        checkAgain = true;
                        _this.removeFromParent(rowNode, batchRemover);
                        // we remove selection on filler nodes here, as the selection would not be removed
                        // from the RowNodeManager, as filler nodes don't exist on the RowNodeManager
                        rowNode.setSelectedParams({ newValue: false, source: 'rowGroupChanged' });
                    }
                });
            });
            batchRemover.flush();
        };
        while (checkAgain) {
            _loop_1();
        }
    };
    // removes the node from the parent by:
    // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
    // b) removing from childrenMapped (immediately)
    // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
    // d) setRowIndex(null) - as the rowNode will no longer be displayed.
    GroupStage.prototype.removeFromParent = function (child, batchRemover) {
        if (child.parent) {
            if (batchRemover) {
                batchRemover.removeFromChildrenAfterGroup(child.parent, child);
            } else {
                _.removeFromArray(child.parent.childrenAfterGroup, child);
                child.parent.updateHasChildren();
            }
        }
        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (child.parent && child.parent.childrenMapped) {
            child.parent.childrenMapped[mapKey] = undefined;
        }
        // this is important for transition, see rowComp removeFirstPassFuncs. when doing animation and
        // remove, if rowTop is still present, the rowComp thinks it's just moved position.
        child.setRowTop(null);
        child.setRowIndex(null);
    };
    GroupStage.prototype.addToParent = function (child, parent) {
        var mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (parent) {
            var children = parent.childrenMapped != null;
            if (children) {
                parent.childrenMapped[mapKey] = child;
            }
            parent.childrenAfterGroup.push(child);
            parent.updateHasChildren();
        }
    };
    GroupStage.prototype.areGroupColsEqual = function (d1, d2) {
        if (d1 == null || d2 == null || d1.pivotMode !== d2.pivotMode) {
            return false;
        }
        return _.areEqual(d1.groupedCols, d2.groupedCols);
    };
    GroupStage.prototype.checkAllGroupDataAfterColsChanged = function (details) {
        var _this = this;
        var recurse = function (rowNodes) {
            if (!rowNodes) {
                return;
            }
            rowNodes.forEach(function (rowNode) {
                var isLeafNode = !details.usingTreeData && !rowNode.group;
                if (isLeafNode) {
                    return;
                }
                var groupInfo = {
                    field: rowNode.field,
                    key: rowNode.key,
                    rowGroupColumn: rowNode.rowGroupColumn,
                };
                _this.setGroupData(rowNode, groupInfo, details);
                recurse(rowNode.childrenAfterGroup);
            });
        };
        recurse(details.rootNode.childrenAfterGroup);
    };
    GroupStage.prototype.shotgunResetEverything = function (details, afterColumnsChanged) {
        if (this.noChangeInGroupingColumns(details, afterColumnsChanged)) {
            return;
        }
        // groups are about to get disposed, so need to deselect any that are selected
        this.selectionService.filterFromSelection(function (node) {
            return node && !node.group;
        });
        var rootNode = details.rootNode,
            groupedCols = details.groupedCols;
        // because we are not creating the root node each time, we have the logic
        // here to change leafGroup once.
        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
        rootNode.leafGroup = details.usingTreeData ? false : groupedCols.length === 0;
        // we are doing everything from scratch, so reset childrenAfterGroup and childrenMapped from the rootNode
        rootNode.childrenAfterGroup = [];
        rootNode.childrenMapped = {};
        rootNode.updateHasChildren();
        var sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenMapped = rootNode.childrenMapped;
        }
        this.insertNodes(rootNode.allLeafChildren, details, false);
    };
    GroupStage.prototype.noChangeInGroupingColumns = function (details, afterColumnsChanged) {
        var noFurtherProcessingNeeded = false;
        var groupDisplayColumns = this.columnModel.getGroupDisplayColumns();
        var newGroupDisplayColIds = groupDisplayColumns
            ? groupDisplayColumns
                  .map(function (c) {
                      return c.getId();
                  })
                  .join('-')
            : '';
        if (afterColumnsChanged) {
            // we only need to redo grouping if doing normal grouping (ie not tree data)
            // and the group cols have changed.
            noFurtherProcessingNeeded =
                details.usingTreeData || this.areGroupColsEqual(details, this.oldGroupingDetails);
            // if the group display cols have changed, then we need to update rowNode.groupData
            // (regardless of tree data or row grouping)
            if (this.oldGroupDisplayColIds !== newGroupDisplayColIds) {
                this.checkAllGroupDataAfterColsChanged(details);
            }
        }
        this.oldGroupingDetails = details;
        this.oldGroupDisplayColIds = newGroupDisplayColIds;
        return noFurtherProcessingNeeded;
    };
    GroupStage.prototype.insertNodes = function (newRowNodes, details, isMove) {
        var _this = this;
        newRowNodes.forEach(function (rowNode) {
            _this.insertOneNode(rowNode, details, isMove);
            if (details.changedPath.isActive()) {
                details.changedPath.addParentNode(rowNode.parent);
            }
        });
    };
    GroupStage.prototype.insertOneNode = function (childNode, details, isMove, batchRemover) {
        var path = this.getGroupInfo(childNode, details);
        var parentGroup = this.findParentForNode(childNode, path, details, batchRemover);
        if (!parentGroup.group) {
            console.warn('AG Grid: duplicate group keys for row data, keys should be unique', [
                parentGroup.data,
                childNode.data,
            ]);
        }
        if (details.usingTreeData) {
            this.swapGroupWithUserNode(parentGroup, childNode, isMove);
        } else {
            childNode.parent = parentGroup;
            childNode.level = path.length;
            parentGroup.childrenAfterGroup.push(childNode);
            parentGroup.updateHasChildren();
        }
    };
    GroupStage.prototype.findParentForNode = function (childNode, path, details, batchRemover) {
        var _this = this;
        var nextNode = details.rootNode;
        path.forEach(function (groupInfo, level) {
            nextNode = _this.getOrCreateNextNode(nextNode, groupInfo, level, details);
            // node gets added to all group nodes.
            // note: we do not add to rootNode here, as the rootNode is the master list of rowNodes
            if (
                !(batchRemover === null || batchRemover === void 0
                    ? void 0
                    : batchRemover.isRemoveFromAllLeafChildren(nextNode, childNode))
            ) {
                nextNode.allLeafChildren.push(childNode);
            } else {
                // if this node is about to be removed, prevent that
                batchRemover === null || batchRemover === void 0
                    ? void 0
                    : batchRemover.preventRemoveFromAllLeafChildren(nextNode, childNode);
            }
        });
        return nextNode;
    };
    GroupStage.prototype.swapGroupWithUserNode = function (fillerGroup, userGroup, isMove) {
        userGroup.parent = fillerGroup.parent;
        userGroup.key = fillerGroup.key;
        userGroup.field = fillerGroup.field;
        userGroup.groupData = fillerGroup.groupData;
        userGroup.level = fillerGroup.level;
        // AG-3441 - preserve the existing expanded status of the node if we're moving it, so that
        // you can drag a sub tree from one parent to another without changing its expansion
        if (!isMove) {
            userGroup.expanded = fillerGroup.expanded;
        }
        // we set .leafGroup to false for tree data, as .leafGroup is only used when pivoting, and pivoting
        // isn't allowed with treeData, so the grid never actually use .leafGroup when doing treeData.
        userGroup.leafGroup = fillerGroup.leafGroup;
        // always null for userGroups, as row grouping is not allowed when doing tree data
        userGroup.rowGroupIndex = fillerGroup.rowGroupIndex;
        userGroup.allLeafChildren = fillerGroup.allLeafChildren;
        userGroup.childrenAfterGroup = fillerGroup.childrenAfterGroup;
        userGroup.childrenMapped = fillerGroup.childrenMapped;
        userGroup.sibling = fillerGroup.sibling;
        userGroup.updateHasChildren();
        this.removeFromParent(fillerGroup);
        userGroup.childrenAfterGroup.forEach(function (rowNode) {
            return (rowNode.parent = userGroup);
        });
        this.addToParent(userGroup, fillerGroup.parent);
    };
    GroupStage.prototype.getOrCreateNextNode = function (parentGroup, groupInfo, level, details) {
        var key = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
        var nextNode = parentGroup.childrenMapped ? parentGroup.childrenMapped[key] : undefined;
        if (!nextNode) {
            nextNode = this.createGroup(groupInfo, parentGroup, level, details);
            // attach the new group to the parent
            this.addToParent(nextNode, parentGroup);
        }
        return nextNode;
    };
    GroupStage.prototype.createGroup = function (groupInfo, parent, level, details) {
        var groupNode = new RowNode(this.beans);
        groupNode.group = true;
        groupNode.field = groupInfo.field;
        groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
        this.setGroupData(groupNode, groupInfo, details);
        // we put 'row-group-' before the group id, so it doesn't clash with standard row id's. we also use 't-' and 'b-'
        // for top pinned and bottom pinned rows.
        groupNode.id = RowNode.ID_PREFIX_ROW_GROUP + this.groupIdSequence.next();
        groupNode.key = groupInfo.key;
        groupNode.level = level;
        groupNode.leafGroup = details.usingTreeData ? false : level === details.groupedColCount - 1;
        groupNode.allLeafChildren = [];
        // why is this done here? we are not updating the children count as we go,
        // i suspect this is updated in the filter stage
        groupNode.setAllChildrenCount(0);
        groupNode.rowGroupIndex = details.usingTreeData ? null : level;
        groupNode.childrenAfterGroup = [];
        groupNode.childrenMapped = {};
        groupNode.updateHasChildren();
        groupNode.parent = details.includeParents ? parent : null;
        this.setExpandedInitialValue(details, groupNode);
        return groupNode;
    };
    GroupStage.prototype.setGroupData = function (groupNode, groupInfo, details) {
        groupNode.groupData = {};
        var groupDisplayCols = this.columnModel.getGroupDisplayColumns();
        groupDisplayCols.forEach(function (col) {
            // newGroup.rowGroupColumn=null when working off GroupInfo, and we always display the group in the group column
            // if rowGroupColumn is present, then it's grid row grouping and we only include if configuration says so
            var displayGroupForCol =
                details.usingTreeData ||
                (groupNode.rowGroupColumn ? col.isRowGroupDisplayed(groupNode.rowGroupColumn.getId()) : false);
            if (displayGroupForCol) {
                groupNode.groupData[col.getColId()] = groupInfo.key;
            }
        });
    };
    GroupStage.prototype.getChildrenMappedKey = function (key, rowGroupColumn) {
        if (rowGroupColumn) {
            // grouping by columns
            return rowGroupColumn.getId() + '-' + key;
        }
        // tree data - we don't have rowGroupColumns
        return key;
    };
    GroupStage.prototype.setExpandedInitialValue = function (details, groupNode) {
        // if pivoting the leaf group is never expanded as we do not show leaf rows
        if (details.pivotMode && groupNode.leafGroup) {
            groupNode.expanded = false;
            return;
        }
        // use callback if exists
        var userCallback = details.isGroupOpenByDefault;
        if (userCallback) {
            var params = {
                rowNode: groupNode,
                field: groupNode.field,
                key: groupNode.key,
                level: groupNode.level,
                rowGroupColumn: groupNode.rowGroupColumn,
            };
            groupNode.expanded = userCallback(params) == true;
            return;
        }
        // use expandByDefault if exists
        var expandByDefault = details.expandByDefault;
        if (details.expandByDefault === -1) {
            groupNode.expanded = true;
            return;
        }
        // otherwise
        groupNode.expanded = groupNode.level < expandByDefault;
    };
    GroupStage.prototype.getGroupInfo = function (rowNode, details) {
        if (details.usingTreeData) {
            return this.getGroupInfoFromCallback(rowNode, details);
        }
        return this.getGroupInfoFromGroupColumns(rowNode, details);
    };
    GroupStage.prototype.getGroupInfoFromCallback = function (rowNode, details) {
        var keys = details.getDataPath ? details.getDataPath(rowNode.data) : null;
        if (keys === null || keys === undefined || keys.length === 0) {
            _.doOnce(function () {
                return console.warn('AG Grid: getDataPath() should not return an empty path for data', rowNode.data);
            }, 'groupStage.getGroupInfoFromCallback');
        }
        var groupInfoMapper = function (key) {
            return { key: key, field: null, rowGroupColumn: null };
        };
        return keys ? keys.map(groupInfoMapper) : [];
    };
    GroupStage.prototype.getGroupInfoFromGroupColumns = function (rowNode, details) {
        var _this = this;
        var res = [];
        details.groupedCols.forEach(function (groupCol) {
            var key = _this.valueService.getKeyForNode(groupCol, rowNode);
            var keyExists = key !== null && key !== undefined && key !== '';
            // unbalanced tree and pivot mode don't work together - not because of the grid, it doesn't make
            // mathematical sense as you are building up a cube. so if pivot mode, we put in a blank key where missing.
            // this keeps the tree balanced and hence can be represented as a group.
            var createGroupForEmpty = details.pivotMode || !details.groupAllowUnbalanced;
            if (createGroupForEmpty && !keyExists) {
                key = '';
                keyExists = true;
            }
            if (keyExists) {
                var item = {
                    key: key,
                    field: groupCol.getColDef().field,
                    rowGroupColumn: groupCol,
                };
                res.push(item);
            }
        });
        return res;
    };
    __decorate$2p([Autowired('columnModel')], GroupStage.prototype, 'columnModel', void 0);
    __decorate$2p([Autowired('selectableService')], GroupStage.prototype, 'selectableService', void 0);
    __decorate$2p([Autowired('valueService')], GroupStage.prototype, 'valueService', void 0);
    __decorate$2p([Autowired('beans')], GroupStage.prototype, 'beans', void 0);
    __decorate$2p([Autowired('selectionService')], GroupStage.prototype, 'selectionService', void 0);
    GroupStage = __decorate$2p([Bean('groupStage')], GroupStage);
    return GroupStage;
})(BeanStub);

var __extends$3e =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$10 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$10 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$10.apply(this, arguments);
    };
var __decorate$2o =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1j =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$O =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var PivotColDefService = /** @class */ (function (_super) {
    __extends$3e(PivotColDefService, _super);
    function PivotColDefService() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    PivotColDefService_1 = PivotColDefService;
    PivotColDefService.prototype.init = function () {
        var _this = this;
        var getFieldSeparator = function () {
            var _a;
            return (_a = _this.gos.get('serverSidePivotResultFieldSeparator')) !== null && _a !== void 0 ? _a : '_';
        };
        this.fieldSeparator = getFieldSeparator();
        this.addManagedPropertyListener('serverSidePivotResultFieldSeparator', function () {
            _this.fieldSeparator = getFieldSeparator();
        });
        var getPivotDefaultExpanded = function () {
            var _a;
            return (_a = _this.gos.getNum('pivotDefaultExpanded')) !== null && _a !== void 0 ? _a : 0;
        };
        this.pivotDefaultExpanded = getPivotDefaultExpanded();
        this.addManagedPropertyListener('pivotDefaultExpanded', function () {
            _this.pivotDefaultExpanded = getPivotDefaultExpanded();
        });
    };
    PivotColDefService.prototype.createPivotColumnDefs = function (uniqueValues) {
        // this is passed to the columnModel, to configure the columns and groups we show
        var pivotColumnGroupDefs = this.createPivotColumnsFromUniqueValues(uniqueValues);
        function extractColDefs(input, arr) {
            if (arr === void 0) {
                arr = [];
            }
            input.forEach(function (def) {
                if (def.children !== undefined) {
                    extractColDefs(def.children, arr);
                } else {
                    arr.push(def);
                }
            });
            return arr;
        }
        var pivotColumnDefs = extractColDefs(pivotColumnGroupDefs);
        // additional columns that contain the aggregated total for each value column per row
        this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs);
        // additional group columns that contain child totals for each collapsed child column / group
        this.addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs);
        // additional group columns that contain an aggregated total across all child columns
        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs);
        // we clone, so the colDefs in pivotColumnsGroupDefs and pivotColumnDefs are not shared. this is so that
        // any changes the user makes (via processSecondaryColumnDefinitions) don't impact the internal aggregations,
        // as these use the col defs also
        var pivotColumnDefsClone = pivotColumnDefs.map(function (colDef) {
            return _.cloneObject(colDef);
        });
        return {
            pivotColumnGroupDefs: pivotColumnGroupDefs,
            pivotColumnDefs: pivotColumnDefsClone,
        };
    };
    PivotColDefService.prototype.createPivotColumnsFromUniqueValues = function (uniqueValues) {
        var pivotColumns = this.columnModel.getPivotColumns();
        var maxDepth = pivotColumns.length;
        var pivotColumnGroupDefs = this.recursivelyBuildGroup(0, uniqueValues, [], maxDepth, pivotColumns);
        return pivotColumnGroupDefs;
    };
    PivotColDefService.prototype.recursivelyBuildGroup = function (
        index,
        uniqueValue,
        pivotKeys,
        maxDepth,
        primaryPivotColumns,
    ) {
        var _this = this;
        var measureColumns = this.columnModel.getValueColumns();
        if (index >= maxDepth) {
            // Base case - build the measure columns
            return this.buildMeasureCols(pivotKeys);
        }
        // sort by either user provided comparator, or our own one
        var primaryPivotColumnDefs = primaryPivotColumns[index].getColDef();
        var comparator = this.headerNameComparator.bind(this, primaryPivotColumnDefs.pivotComparator);
        // Base case for the compact layout, instead of recursing build the last layer of groups as measure columns instead
        if (
            measureColumns.length === 1 &&
            this.gridOptionsService.is('removePivotHeaderRowWhenSingleValueColumn') &&
            index === maxDepth - 1
        ) {
            var leafCols_1 = [];
            _.iterateObject(uniqueValue, function (key) {
                var newPivotKeys = __spreadArray$O(__spreadArray$O([], __read$1j(pivotKeys)), [key]);
                var colDef = _this.createColDef(measureColumns[0], key, newPivotKeys);
                colDef.columnGroupShow = 'open';
                leafCols_1.push(colDef);
            });
            leafCols_1.sort(comparator);
            return leafCols_1;
        }
        // Recursive case
        var groups = [];
        _.iterateObject(uniqueValue, function (key, value) {
            // expand group by default based on depth of group. (pivotDefaultExpanded provides desired level of depth for expanding group by default)
            var openByDefault = _this.pivotDefaultExpanded === -1 || index < _this.pivotDefaultExpanded;
            var newPivotKeys = __spreadArray$O(__spreadArray$O([], __read$1j(pivotKeys)), [key]);
            groups.push({
                children: _this.recursivelyBuildGroup(index + 1, value, newPivotKeys, maxDepth, primaryPivotColumns),
                headerName: key,
                pivotKeys: newPivotKeys,
                columnGroupShow: 'open',
                openByDefault: openByDefault,
                groupId: _this.generateColumnGroupId(newPivotKeys),
            });
        });
        groups.sort(comparator);
        return groups;
    };
    PivotColDefService.prototype.buildMeasureCols = function (pivotKeys) {
        var _this = this;
        var measureColumns = this.columnModel.getValueColumns();
        if (measureColumns.length === 0) {
            // if no value columns selected, then we insert one blank column, so the user at least sees columns
            // rendered. otherwise the grid would render with no columns (just empty groups) which would give the
            // impression that the grid is broken
            return [this.createColDef(null, '-', pivotKeys)];
        }
        return measureColumns.map(function (measureCol) {
            var columnName = _this.columnModel.getDisplayNameForColumn(measureCol, 'header');
            return __assign$10(__assign$10({}, _this.createColDef(measureCol, columnName, pivotKeys)), {
                columnGroupShow: 'open',
            });
        });
    };
    PivotColDefService.prototype.addExpandablePivotGroups = function (pivotColumnGroupDefs, pivotColumnDefs) {
        var _this = this;
        if (
            this.gridOptionsService.is('suppressExpandablePivotGroups') ||
            this.gridOptionsService.get('pivotColumnGroupTotals')
        ) {
            return;
        }
        var recursivelyAddSubTotals = function (groupDef, currentPivotColumnDefs, acc) {
            var group = groupDef;
            if (group.children) {
                var childAcc_1 = new Map();
                group.children.forEach(function (grp) {
                    recursivelyAddSubTotals(grp, currentPivotColumnDefs, childAcc_1);
                });
                var firstGroup_1 = !group.children.some(function (child) {
                    return child.children;
                });
                _this.columnModel.getValueColumns().forEach(function (valueColumn) {
                    var columnName = _this.columnModel.getDisplayNameForColumn(valueColumn, 'header');
                    var totalColDef = _this.createColDef(valueColumn, columnName, groupDef.pivotKeys);
                    totalColDef.pivotTotalColumnIds = childAcc_1.get(valueColumn.getColId());
                    totalColDef.columnGroupShow = 'closed';
                    totalColDef.aggFunc = valueColumn.getAggFunc();
                    if (!firstGroup_1) {
                        // add total colDef to group and pivot colDefs array
                        var children = groupDef.children;
                        children.push(totalColDef);
                        currentPivotColumnDefs.push(totalColDef);
                    }
                });
                _this.merge(acc, childAcc_1);
            } else {
                var def = groupDef;
                // check that value column exists, i.e. aggFunc is supplied
                if (!def.pivotValueColumn) {
                    return;
                }
                var pivotValueColId = def.pivotValueColumn.getColId();
                var arr = acc.has(pivotValueColId) ? acc.get(pivotValueColId) : [];
                arr.push(def.colId);
                acc.set(pivotValueColId, arr);
            }
        };
        pivotColumnGroupDefs.forEach(function (groupDef) {
            recursivelyAddSubTotals(groupDef, pivotColumnDefs, new Map());
        });
    };
    PivotColDefService.prototype.addPivotTotalsToGroups = function (pivotColumnGroupDefs, pivotColumnDefs) {
        var _this = this;
        if (!this.gridOptionsService.get('pivotColumnGroupTotals')) {
            return;
        }
        var insertAfter = this.gridOptionsService.get('pivotColumnGroupTotals') === 'after';
        var valueCols = this.columnModel.getValueColumns();
        var aggFuncs = valueCols.map(function (valueCol) {
            return valueCol.getAggFunc();
        });
        // don't add pivot totals if there is less than 1 aggFunc or they are not all the same
        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) {
            // console.warn('AG Grid: aborting adding pivot total columns - value columns require same aggFunc');
            return;
        }
        // arbitrarily select a value column to use as a template for pivot columns
        var valueColumn = valueCols[0];
        pivotColumnGroupDefs.forEach(function (groupDef) {
            _this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter);
        });
    };
    PivotColDefService.prototype.recursivelyAddPivotTotal = function (
        groupDef,
        pivotColumnDefs,
        valueColumn,
        insertAfter,
    ) {
        var _this = this;
        var group = groupDef;
        if (!group.children) {
            var def = groupDef;
            return def.colId ? [def.colId] : null;
        }
        var colIds = [];
        // need to recurse children first to obtain colIds used in the aggregation stage
        group.children.forEach(function (grp) {
            var childColIds = _this.recursivelyAddPivotTotal(grp, pivotColumnDefs, valueColumn, insertAfter);
            if (childColIds) {
                colIds = colIds.concat(childColIds);
            }
        });
        // only add total colDef if there is more than 1 child node
        if (group.children.length > 1) {
            var localeTextFunc = this.localeService.getLocaleTextFunc();
            var headerName = localeTextFunc('pivotColumnGroupTotals', 'Total');
            //create total colDef using an arbitrary value column as a template
            var totalColDef = this.createColDef(valueColumn, headerName, groupDef.pivotKeys, true);
            totalColDef.pivotTotalColumnIds = colIds;
            totalColDef.aggFunc = valueColumn.getAggFunc();
            // add total colDef to group and pivot colDefs array
            var children = groupDef.children;
            insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
            pivotColumnDefs.push(totalColDef);
        }
        return colIds;
    };
    PivotColDefService.prototype.addRowGroupTotals = function (pivotColumnGroupDefs, pivotColumnDefs) {
        var _this = this;
        if (!this.gridOptionsService.get('pivotRowTotals')) {
            return;
        }
        var insertAfter = this.gridOptionsService.get('pivotRowTotals') === 'after';
        var valueColumns = this.columnModel.getValueColumns();
        // order of row group totals depends on position
        var valueCols = insertAfter ? valueColumns.slice() : valueColumns.slice().reverse();
        var _loop_1 = function (i) {
            var valueCol = valueCols[i];
            var colIds = [];
            pivotColumnGroupDefs.forEach(function (groupDef) {
                colIds = colIds.concat(_this.extractColIdsForValueColumn(groupDef, valueCol));
            });
            var withGroup =
                valueCols.length > 1 || !this_1.gridOptionsService.is('removePivotHeaderRowWhenSingleValueColumn');
            this_1.createRowGroupTotal(pivotColumnGroupDefs, pivotColumnDefs, valueCol, colIds, insertAfter, withGroup);
        };
        var this_1 = this;
        for (var i = 0; i < valueCols.length; i++) {
            _loop_1(i);
        }
    };
    PivotColDefService.prototype.extractColIdsForValueColumn = function (groupDef, valueColumn) {
        var _this = this;
        var group = groupDef;
        if (!group.children) {
            var colDef = group;
            return colDef.pivotValueColumn === valueColumn && colDef.colId ? [colDef.colId] : [];
        }
        var colIds = [];
        group.children.forEach(function (grp) {
            _this.extractColIdsForValueColumn(grp, valueColumn);
            var childColIds = _this.extractColIdsForValueColumn(grp, valueColumn);
            colIds = colIds.concat(childColIds);
        });
        return colIds;
    };
    PivotColDefService.prototype.createRowGroupTotal = function (
        parentChildren,
        pivotColumnDefs,
        valueColumn,
        colIds,
        insertAfter,
        addGroup,
    ) {
        var measureColumns = this.columnModel.getValueColumns();
        var colDef;
        if (measureColumns.length === 0) {
            colDef = this.createColDef(null, '-', []);
        } else {
            var columnName = this.columnModel.getDisplayNameForColumn(valueColumn, 'header');
            colDef = this.createColDef(valueColumn, columnName, []);
            colDef.pivotTotalColumnIds = colIds;
        }
        colDef.colId = PivotColDefService_1.PIVOT_ROW_TOTAL_PREFIX + colDef.colId;
        pivotColumnDefs.push(colDef);
        var valueGroup = addGroup
            ? {
                  children: [colDef],
                  pivotKeys: [],
                  groupId: PivotColDefService_1.PIVOT_ROW_TOTAL_PREFIX + '_pivotGroup_' + valueColumn.getColId(),
              }
            : colDef;
        insertAfter ? parentChildren.push(valueGroup) : parentChildren.unshift(valueGroup);
    };
    PivotColDefService.prototype.createColDef = function (valueColumn, headerName, pivotKeys, totalColumn) {
        if (totalColumn === void 0) {
            totalColumn = false;
        }
        var colDef = {};
        // This is null when there are no measure columns and we're creating placeholder columns
        if (valueColumn) {
            var colDefToCopy = valueColumn.getColDef();
            Object.assign(colDef, colDefToCopy);
            // even if original column was hidden, we always show the pivot value column, otherwise it would be
            // very confusing for people thinking the pivot is broken
            colDef.hide = false;
        }
        colDef.headerName = headerName;
        colDef.colId = this.generateColumnId(
            pivotKeys || [],
            valueColumn && !totalColumn ? valueColumn.getColId() : '',
        );
        // pivot columns repeat over field, so it makes sense to use the unique id instead. For example if you want to
        // assign values to pinned bottom rows using setPinnedBottomRowData the value service will use this colId.
        colDef.field = colDef.colId;
        // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
        // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
        colDef.valueGetter = function (params) {
            var _a;
            return (_a = params.data) === null || _a === void 0 ? void 0 : _a[params.colDef.field];
        };
        colDef.pivotKeys = pivotKeys;
        colDef.pivotValueColumn = valueColumn;
        if (colDef.filter === true) {
            colDef.filter = 'agNumberColumnFilter';
        }
        return colDef;
    };
    PivotColDefService.prototype.sameAggFuncs = function (aggFuncs) {
        if (aggFuncs.length == 1) {
            return true;
        }
        //check if all aggFunc's match
        for (var i = 1; i < aggFuncs.length; i++) {
            if (aggFuncs[i] !== aggFuncs[0]) {
                return false;
            }
        }
        return true;
    };
    PivotColDefService.prototype.headerNameComparator = function (userComparator, a, b) {
        if (userComparator) {
            return userComparator(a.headerName, b.headerName);
        } else {
            if (a.headerName && !b.headerName) {
                return 1;
            } else if (!a.headerName && b.headerName) {
                return -1;
            }
            // slightly naff here - just to satify typescript
            // really should be &&, but if so ts complains
            // the above if/else checks would deal with either being falsy, so at this stage if either are falsy, both are
            // ..still naff though
            if (!a.headerName || !b.headerName) {
                return 0;
            }
            if (a.headerName < b.headerName) {
                return -1;
            }
            if (a.headerName > b.headerName) {
                return 1;
            }
            return 0;
        }
    };
    PivotColDefService.prototype.merge = function (m1, m2) {
        m2.forEach(function (value, key, map) {
            var existingList = m1.has(key) ? m1.get(key) : [];
            var updatedList = __spreadArray$O(__spreadArray$O([], __read$1j(existingList)), __read$1j(value));
            m1.set(key, updatedList);
        });
    };
    PivotColDefService.prototype.generateColumnGroupId = function (pivotKeys) {
        var pivotCols = this.columnModel.getPivotColumns().map(function (col) {
            return col.getColId();
        });
        return 'pivotGroup_' + pivotCols.join('-') + '_' + pivotKeys.join('-');
    };
    PivotColDefService.prototype.generateColumnId = function (pivotKeys, measureColumnId) {
        var pivotCols = this.columnModel.getPivotColumns().map(function (col) {
            return col.getColId();
        });
        return 'pivot_' + pivotCols.join('-') + '_' + pivotKeys.join('-') + '_' + measureColumnId;
    };
    /**
     * Used by the SSRM to create secondary columns from provided fields
     * @param fields
     */
    PivotColDefService.prototype.createColDefsFromFields = function (fields) {
        var _this = this;
        // tear the ids down into groups, while this could be done in-step with the next stage, the lookup is faster
        // than searching col group children array for the right group
        var uniqueValues = {};
        for (var i = 0; i < fields.length; i++) {
            var field = fields[i];
            var parts = field.split(this.fieldSeparator);
            var level = uniqueValues;
            for (var p = 0; p < parts.length; p++) {
                var part = parts[p];
                if (level[part] == null) {
                    level[part] = {};
                }
                level = level[part];
            }
        }
        var uniqueValuesToGroups = function (id, key, uniqueValues, depth) {
            var _a;
            var children = [];
            for (var key_1 in uniqueValues) {
                var item = uniqueValues[key_1];
                var child = uniqueValuesToGroups('' + id + _this.fieldSeparator + key_1, key_1, item, depth + 1);
                children.push(child);
            }
            if (children.length === 0) {
                var col = {
                    colId: id,
                    headerName: key,
                    // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
                    // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
                    valueGetter: function (params) {
                        var _a;
                        return (_a = params.data) === null || _a === void 0 ? void 0 : _a[id];
                    },
                };
                var potentialAggCol = _this.columnModel.getPrimaryColumn(key);
                if (potentialAggCol) {
                    col.headerName =
                        (_a = _this.columnModel.getDisplayNameForColumn(potentialAggCol, 'header')) !== null &&
                        _a !== void 0
                            ? _a
                            : key;
                    col.aggFunc = potentialAggCol.getAggFunc();
                    col.pivotValueColumn = potentialAggCol;
                }
                return col;
            }
            // this is a bit sketchy. As the fields can be anything we just build groups as deep as the fields go.
            // nothing says user has to give us groups the same depth.
            var collapseSingleChildren = _this.gridOptionsService.is('removePivotHeaderRowWhenSingleValueColumn');
            if (collapseSingleChildren && children.length === 1 && 'colId' in children[0]) {
                children[0].headerName = key;
                return children[0];
            }
            var group = {
                openByDefault: _this.pivotDefaultExpanded === -1 || depth < _this.pivotDefaultExpanded,
                groupId: id,
                headerName: key,
                children: children,
            };
            return group;
        };
        var res = [];
        for (var key in uniqueValues) {
            var item = uniqueValues[key];
            var col = uniqueValuesToGroups(key, key, item, 0);
            res.push(col);
        }
        return res;
    };
    var PivotColDefService_1;
    PivotColDefService.PIVOT_ROW_TOTAL_PREFIX = 'PivotRowTotal_';
    __decorate$2o([Autowired('columnModel')], PivotColDefService.prototype, 'columnModel', void 0);
    __decorate$2o([Autowired('gridOptionsService')], PivotColDefService.prototype, 'gos', void 0);
    __decorate$2o([PostConstruct], PivotColDefService.prototype, 'init', null);
    PivotColDefService = PivotColDefService_1 = __decorate$2o([Bean('pivotColDefService')], PivotColDefService);
    return PivotColDefService;
})(BeanStub);

var __extends$3d =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2n =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PivotStage = /** @class */ (function (_super) {
    __extends$3d(PivotStage, _super);
    function PivotStage() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.uniqueValues = {};
        return _this;
    }
    PivotStage.prototype.execute = function (params) {
        var changedPath = params.changedPath;
        if (this.columnModel.isPivotActive()) {
            this.executePivotOn(changedPath);
        } else {
            this.executePivotOff(changedPath);
        }
    };
    PivotStage.prototype.executePivotOff = function (changedPath) {
        this.aggregationColumnsHashLastTime = null;
        this.uniqueValues = {};
        if (this.columnModel.isSecondaryColumnsPresent()) {
            this.columnModel.setSecondaryColumns(null, 'rowModelUpdated');
            if (changedPath) {
                changedPath.setInactive();
            }
        }
    };
    PivotStage.prototype.executePivotOn = function (changedPath) {
        var uniqueValues = this.bucketUpRowNodes(changedPath);
        var uniqueValuesChanged = this.setUniqueValues(uniqueValues);
        var aggregationColumns = this.columnModel.getValueColumns();
        var aggregationColumnsHash = aggregationColumns
            .map(function (column) {
                return column.getId() + '-' + column.getColDef().headerName;
            })
            .join('#');
        var aggregationFuncsHash = aggregationColumns
            .map(function (column) {
                return column.getAggFunc().toString();
            })
            .join('#');
        var aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
        var aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
        var groupColumnsHash = this.columnModel
            .getRowGroupColumns()
            .map(function (column) {
                return column.getId();
            })
            .join('#');
        var groupColumnsChanged = groupColumnsHash !== this.groupColumnsHashLastTime;
        this.groupColumnsHashLastTime = groupColumnsHash;
        if (uniqueValuesChanged || aggregationColumnsChanged || groupColumnsChanged || aggregationFuncsChanged) {
            var _a = this.pivotColDefService.createPivotColumnDefs(this.uniqueValues),
                pivotColumnGroupDefs = _a.pivotColumnGroupDefs,
                pivotColumnDefs = _a.pivotColumnDefs;
            this.pivotColumnDefs = pivotColumnDefs;
            this.columnModel.setSecondaryColumns(pivotColumnGroupDefs, 'rowModelUpdated');
            // because the secondary columns have changed, then the aggregation needs to visit the whole
            // tree again, so we make the changedPath not active, to force aggregation to visit all paths.
            if (changedPath) {
                changedPath.setInactive();
            }
        }
    };
    PivotStage.prototype.setUniqueValues = function (newValues) {
        var json1 = JSON.stringify(newValues);
        var json2 = JSON.stringify(this.uniqueValues);
        var uniqueValuesChanged = json1 !== json2;
        // we only continue the below if the unique values are different, as otherwise
        // the result will be the same as the last time we did it
        if (uniqueValuesChanged) {
            this.uniqueValues = newValues;
            return true;
        } else {
            return false;
        }
    };
    PivotStage.prototype.bucketUpRowNodes = function (changedPath) {
        var _this = this;
        // accessed from inside inner function
        var uniqueValues = {};
        // ensure childrenMapped is cleared, as if a node has been filtered out it should not have mapped children.
        changedPath.forEachChangedNodeDepthFirst(function (node) {
            if (node.leafGroup) {
                node.childrenMapped = null;
            }
        });
        var recursivelyBucketFilteredChildren = function (node) {
            var _a;
            if (node.leafGroup) {
                _this.bucketRowNode(node, uniqueValues);
            } else {
                (_a = node.childrenAfterFilter) === null || _a === void 0
                    ? void 0
                    : _a.forEach(recursivelyBucketFilteredChildren);
            }
        };
        changedPath.executeFromRootNode(recursivelyBucketFilteredChildren);
        return uniqueValues;
    };
    PivotStage.prototype.bucketRowNode = function (rowNode, uniqueValues) {
        var pivotColumns = this.columnModel.getPivotColumns();
        if (pivotColumns.length === 0) {
            rowNode.childrenMapped = null;
        } else {
            rowNode.childrenMapped = this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues);
        }
        if (rowNode.sibling) {
            rowNode.sibling.childrenMapped = rowNode.childrenMapped;
        }
    };
    PivotStage.prototype.bucketChildren = function (children, pivotColumns, pivotIndex, uniqueValues) {
        var _this = this;
        var mappedChildren = {};
        var pivotColumn = pivotColumns[pivotIndex];
        // map the children out based on the pivot column
        children.forEach(function (child) {
            var key = _this.valueService.getKeyForNode(pivotColumn, child);
            if (_.missing(key)) {
                key = '';
            }
            if (!uniqueValues[key]) {
                uniqueValues[key] = {};
            }
            if (!mappedChildren[key]) {
                mappedChildren[key] = [];
            }
            mappedChildren[key].push(child);
        });
        // if it's the last pivot column, return as is, otherwise go one level further in the map
        if (pivotIndex === pivotColumns.length - 1) {
            return mappedChildren;
        } else {
            var result_1 = {};
            _.iterateObject(mappedChildren, function (key, value) {
                result_1[key] = _this.bucketChildren(value, pivotColumns, pivotIndex + 1, uniqueValues[key]);
            });
            return result_1;
        }
    };
    PivotStage.prototype.getPivotColumnDefs = function () {
        return this.pivotColumnDefs;
    };
    __decorate$2n([Autowired('valueService')], PivotStage.prototype, 'valueService', void 0);
    __decorate$2n([Autowired('columnModel')], PivotStage.prototype, 'columnModel', void 0);
    __decorate$2n([Autowired('pivotColDefService')], PivotStage.prototype, 'pivotColDefService', void 0);
    PivotStage = __decorate$2n([Bean('pivotStage')], PivotStage);
    return PivotStage;
})(BeanStub);

var __extends$3c =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2m =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
// @ts-ignore
var AGBigInt = typeof BigInt === 'undefined' ? null : BigInt;
var AggFuncService = /** @class */ (function (_super) {
    __extends$3c(AggFuncService, _super);
    function AggFuncService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.aggFuncsMap = {};
        _this.initialised = false;
        return _this;
    }
    AggFuncService_1 = AggFuncService;
    AggFuncService.prototype.init = function () {
        if (this.initialised) {
            return;
        }
        this.initialiseWithDefaultAggregations();
        this.addAggFuncs(this.gridOptionsService.get('aggFuncs'));
    };
    AggFuncService.prototype.initialiseWithDefaultAggregations = function () {
        this.aggFuncsMap[AggFuncService_1.AGG_SUM] = aggSum;
        this.aggFuncsMap[AggFuncService_1.AGG_FIRST] = aggFirst;
        this.aggFuncsMap[AggFuncService_1.AGG_LAST] = aggLast;
        this.aggFuncsMap[AggFuncService_1.AGG_MIN] = aggMin;
        this.aggFuncsMap[AggFuncService_1.AGG_MAX] = aggMax;
        this.aggFuncsMap[AggFuncService_1.AGG_COUNT] = aggCount;
        this.aggFuncsMap[AggFuncService_1.AGG_AVG] = aggAvg;
        this.initialised = true;
    };
    AggFuncService.prototype.isAggFuncPossible = function (column, func) {
        var allKeys = this.getFuncNames(column);
        var allowed = _.includes(allKeys, func);
        var funcExists = _.exists(this.aggFuncsMap[func]);
        return allowed && funcExists;
    };
    AggFuncService.prototype.getDefaultAggFunc = function (column) {
        var defaultAgg = column.getColDef().defaultAggFunc;
        if (_.exists(defaultAgg) && this.isAggFuncPossible(column, defaultAgg)) {
            return defaultAgg;
        }
        if (this.isAggFuncPossible(column, AggFuncService_1.AGG_SUM)) {
            return AggFuncService_1.AGG_SUM;
        }
        var allKeys = this.getFuncNames(column);
        return _.existsAndNotEmpty(allKeys) ? allKeys[0] : null;
    };
    AggFuncService.prototype.addAggFuncs = function (aggFuncs) {
        _.iterateObject(aggFuncs, this.addAggFunc.bind(this));
    };
    AggFuncService.prototype.addAggFunc = function (key, aggFunc) {
        this.init();
        this.aggFuncsMap[key] = aggFunc;
    };
    AggFuncService.prototype.getAggFunc = function (name) {
        this.init();
        return this.aggFuncsMap[name];
    };
    AggFuncService.prototype.getFuncNames = function (column) {
        var userAllowedFuncs = column.getColDef().allowedAggFuncs;
        return userAllowedFuncs == null ? Object.keys(this.aggFuncsMap).sort() : userAllowedFuncs;
    };
    AggFuncService.prototype.clear = function () {
        this.aggFuncsMap = {};
    };
    var AggFuncService_1;
    AggFuncService.AGG_SUM = 'sum';
    AggFuncService.AGG_FIRST = 'first';
    AggFuncService.AGG_LAST = 'last';
    AggFuncService.AGG_MIN = 'min';
    AggFuncService.AGG_MAX = 'max';
    AggFuncService.AGG_COUNT = 'count';
    AggFuncService.AGG_AVG = 'avg';
    __decorate$2m([PostConstruct], AggFuncService.prototype, 'init', null);
    AggFuncService = AggFuncService_1 = __decorate$2m([Bean('aggFuncService')], AggFuncService);
    return AggFuncService;
})(BeanStub);
function aggSum(params) {
    var values = params.values;
    var result = null; // the logic ensures that we never combine bigint arithmetic with numbers, but TS is hard to please
    // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        if (typeof value === 'number') {
            if (result === null) {
                result = value;
            } else {
                if (AGBigInt) {
                    result += typeof result === 'number' ? value : AGBigInt(value);
                } else {
                    result += value;
                }
            }
        } else if (typeof value === 'bigint') {
            if (result === null) {
                result = value;
            } else {
                result = (typeof result === 'bigint' ? result : AGBigInt(result)) + value;
            }
        }
    }
    return result;
}
function aggFirst(params) {
    return params.values.length > 0 ? params.values[0] : null;
}
function aggLast(params) {
    return params.values.length > 0 ? _.last(params.values) : null;
}
function aggMin(params) {
    var values = params.values;
    var result = null;
    // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        if ((typeof value === 'number' || typeof value === 'bigint') && (result === null || result > value)) {
            result = value;
        }
    }
    return result;
}
function aggMax(params) {
    var values = params.values;
    var result = null;
    // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        if ((typeof value === 'number' || typeof value === 'bigint') && (result === null || result < value)) {
            result = value;
        }
    }
    return result;
}
function aggCount(params) {
    var _a, _b;
    var values = params.values;
    var result = 0;
    // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        // check if the value is from a group, in which case use the group's count
        result += value != null && typeof value.value === 'number' ? value.value : 1;
    }
    // the previous aggregation data
    var existingAggData =
        (_b = (_a = params.rowNode) === null || _a === void 0 ? void 0 : _a.aggData) === null || _b === void 0
            ? void 0
            : _b[params.column.getColId()];
    if (existingAggData && existingAggData.value === result) {
        // the underlying values haven't changed, return the old object to avoid triggering change detection
        return existingAggData;
    }
    // it's important to wrap it in the object so we can determine if this is a group level
    return {
        value: result,
        toString: function () {
            return this.value.toString();
        },
        // used for sorting
        toNumber: function () {
            return this.value;
        },
    };
}
// the average function is tricky as the multiple levels require weighted averages
// for the non-leaf node aggregations.
function aggAvg(params) {
    var _a, _b, _c;
    var values = params.values;
    var sum = 0; // the logic ensures that we never combine bigint arithmetic with numbers, but TS is hard to please
    var count = 0;
    // for optimum performance, we use a for loop here rather than calling any helper methods or using functional code
    for (var i = 0; i < values.length; i++) {
        var currentValue = values[i];
        var valueToAdd = null;
        if (typeof currentValue === 'number' || typeof currentValue === 'bigint') {
            valueToAdd = currentValue;
            count++;
        } else if (
            currentValue != null &&
            (typeof currentValue.value === 'number' || typeof currentValue.value === 'bigint') &&
            typeof currentValue.count === 'number'
        ) {
            // we are aggregating groups, so we take the aggregated values to calculated a weighted average
            if (AGBigInt) {
                valueToAdd =
                    currentValue.value *
                    (typeof currentValue.value === 'number' ? currentValue.count : AGBigInt(currentValue.count));
            } else {
                valueToAdd = currentValue.value * currentValue.count;
            }
            count += currentValue.count;
        }
        if (typeof valueToAdd === 'number') {
            if (AGBigInt) {
                sum += typeof sum === 'number' ? valueToAdd : AGBigInt(valueToAdd);
            } else {
                sum += valueToAdd;
            }
        } else if (typeof valueToAdd === 'bigint') {
            sum = (typeof sum === 'bigint' ? sum : AGBigInt(sum)) + valueToAdd;
        }
    }
    var value = null;
    // avoid divide by zero error
    if (count > 0) {
        if (AGBigInt) {
            value = sum / (typeof sum === 'number' ? count : AGBigInt(count));
        } else {
            value = sum / count;
        }
    }
    // the previous aggregation data
    var existingAggData =
        (_b = (_a = params.rowNode) === null || _a === void 0 ? void 0 : _a.aggData) === null || _b === void 0
            ? void 0
            : _b[(_c = params.column) === null || _c === void 0 ? void 0 : _c.getColId()];
    if (existingAggData && existingAggData.count === count && existingAggData.value === value) {
        // the underlying values haven't changed, return the old object to avoid triggering change detection
        return existingAggData;
    }
    // the result will be an object. when this cell is rendered, only the avg is shown.
    // however when this cell is part of another aggregation, the count is also needed
    // to create a weighted average for the next level.
    return {
        count: count,
        value: value,
        // the grid by default uses toString to render values for an object, so this
        // is a trick to get the default cellRenderer to display the avg value
        toString: function () {
            return typeof this.value === 'number' || typeof this.value === 'bigint' ? this.value.toString() : '';
        },
        // used for sorting
        toNumber: function () {
            return this.value;
        },
    };
}

var __extends$3b =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2l =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DropZoneColumnComp = /** @class */ (function (_super) {
    __extends$3b(DropZoneColumnComp, _super);
    function DropZoneColumnComp(column, dragSourceDropTarget, ghost, dropZonePurpose, horizontal) {
        var _this = _super.call(this) || this;
        _this.column = column;
        _this.dragSourceDropTarget = dragSourceDropTarget;
        _this.ghost = ghost;
        _this.dropZonePurpose = dropZonePurpose;
        _this.horizontal = horizontal;
        _this.popupShowing = false;
        return _this;
    }
    DropZoneColumnComp.prototype.init = function () {
        var _this = this;
        this.setTemplate(DropZoneColumnComp.TEMPLATE);
        var eGui = this.getGui();
        var isFunctionsReadOnly = this.gridOptionsService.is('functionsReadOnly');
        this.addElementClasses(eGui);
        this.addElementClasses(this.eDragHandle, 'drag-handle');
        this.addElementClasses(this.eText, 'text');
        this.addElementClasses(this.eButton, 'button');
        this.eDragHandle.appendChild(_.createIconNoSpan('columnDrag', this.gridOptionsService));
        this.eButton.appendChild(_.createIconNoSpan('cancel', this.gridOptionsService));
        this.setupSort();
        this.displayName = this.columnModel.getDisplayNameForColumn(this.column, 'columnDrop');
        this.setupComponents();
        if (!this.ghost && !isFunctionsReadOnly) {
            this.addDragSource();
        }
        this.setupAria();
        this.addManagedListener(this.eventService, Column.EVENT_SORT_CHANGED, function () {
            _this.setupAria();
        });
        this.setupTooltip();
        this.activateTabIndex();
    };
    DropZoneColumnComp.prototype.setupAria = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var _a = this.getColumnAndAggFuncName(),
            name = _a.name,
            aggFuncName = _a.aggFuncName;
        var aggSeparator = translate('ariaDropZoneColumnComponentAggFuncSeparator', ' of ');
        var sortDirection = {
            asc: translate('ariaDropZoneColumnComponentSortAscending', 'ascending'),
            desc: translate('ariaDropZoneColumnComponentSortDescending', 'descending'),
        };
        var columnSort = this.column.getSort();
        var isSortSuppressed = this.gridOptionsService.is('rowGroupPanelSuppressSort');
        var ariaInstructions = [
            [
                aggFuncName && '' + aggFuncName + aggSeparator,
                name,
                this.isGroupingZone() && !isSortSuppressed && columnSort && ', ' + sortDirection[columnSort],
            ]
                .filter(function (part) {
                    return !!part;
                })
                .join(''),
        ];
        var isFunctionsReadOnly = this.gridOptionsService.is('functionsReadOnly');
        if (this.isAggregationZone() && !isFunctionsReadOnly) {
            var aggregationMenuAria = translate(
                'ariaDropZoneColumnValueItemDescription',
                'Press ENTER to change the aggregation type',
            );
            ariaInstructions.push(aggregationMenuAria);
        }
        if (this.isGroupingZone() && this.column.getColDef().sortable && !isSortSuppressed) {
            var sortProgressAria = translate('ariaDropZoneColumnGroupItemDescription', 'Press ENTER to sort');
            ariaInstructions.push(sortProgressAria);
        }
        var deleteAria = translate('ariaDropZoneColumnComponentDescription', 'Press DELETE to remove');
        ariaInstructions.push(deleteAria);
        _.setAriaLabel(this.getGui(), ariaInstructions.join('. '));
    };
    DropZoneColumnComp.prototype.setupTooltip = function () {
        var _this = this;
        var refresh = function () {
            var newTooltipText = _this.column.getColDef().headerTooltip;
            _this.setTooltip(newTooltipText);
        };
        refresh();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    };
    DropZoneColumnComp.prototype.setupSort = function () {
        var _this = this;
        var canSort = this.column.getColDef().sortable;
        var isGroupingZone = this.isGroupingZone();
        if (!canSort || !isGroupingZone) {
            return;
        }
        if (!this.gridOptionsService.is('rowGroupPanelSuppressSort')) {
            this.eSortIndicator.setupSort(this.column, true);
            var performSort_1 = function (event) {
                event.preventDefault();
                var sortUsingCtrl = _this.gridOptionsService.get('multiSortKey') === 'ctrl';
                var multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
                _this.sortController.progressSort(_this.column, multiSort, 'uiColumnSorted');
            };
            this.addGuiEventListener('click', performSort_1);
            this.addGuiEventListener('keydown', function (e) {
                var isEnter = e.key === KeyCode.ENTER;
                if (isEnter && _this.isGroupingZone()) {
                    performSort_1(e);
                }
            });
        }
    };
    DropZoneColumnComp.prototype.addDragSource = function () {
        var _this = this;
        var dragSource = {
            type: DragSourceType.ToolPanel,
            eElement: this.eDragHandle,
            getDefaultIconName: function () {
                return DragAndDropService.ICON_HIDE;
            },
            getDragItem: function () {
                return _this.createDragItem();
            },
            dragItemName: this.displayName,
            dragSourceDropTarget: this.dragSourceDropTarget,
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDragSource(dragSource);
        });
    };
    DropZoneColumnComp.prototype.createDragItem = function () {
        var visibleState = {};
        visibleState[this.column.getId()] = this.column.isVisible();
        return {
            columns: [this.column],
            visibleState: visibleState,
        };
    };
    DropZoneColumnComp.prototype.setupComponents = function () {
        this.setTextValue();
        this.setupRemove();
        if (this.ghost) {
            this.addCssClass('ag-column-drop-cell-ghost');
        }
        if (this.isAggregationZone() && !this.gridOptionsService.is('functionsReadOnly')) {
            this.addGuiEventListener('click', this.onShowAggFuncSelection.bind(this));
        }
    };
    DropZoneColumnComp.prototype.setupRemove = function () {
        var _this = this;
        _.setDisplayed(this.eButton, !this.gridOptionsService.is('functionsReadOnly'));
        var agEvent = { type: DropZoneColumnComp.EVENT_COLUMN_REMOVE };
        this.addGuiEventListener('keydown', function (e) {
            var isEnter = e.key === KeyCode.ENTER;
            var isDelete = e.key === KeyCode.DELETE;
            if (isDelete) {
                e.preventDefault();
                _this.dispatchEvent(agEvent);
            }
            if (isEnter && _this.isAggregationZone() && !_this.gridOptionsService.is('functionsReadOnly')) {
                e.preventDefault();
                _this.onShowAggFuncSelection();
            }
        });
        this.addManagedListener(this.eButton, 'click', function (mouseEvent) {
            _this.dispatchEvent(agEvent);
            mouseEvent.stopPropagation();
        });
        var touchListener = new TouchListener(this.eButton);
        this.addManagedListener(touchListener, TouchListener.EVENT_TAP, function () {
            _this.dispatchEvent(agEvent);
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    };
    DropZoneColumnComp.prototype.getColumnAndAggFuncName = function () {
        var name = this.displayName;
        var aggFuncName = '';
        if (this.isAggregationZone()) {
            var aggFunc = this.column.getAggFunc();
            // if aggFunc is a string, we can use it, but if it's a function, then we swap with 'func'
            var aggFuncString = typeof aggFunc === 'string' ? aggFunc : 'agg';
            var localeTextFunc = this.localeService.getLocaleTextFunc();
            aggFuncName = localeTextFunc(aggFuncString, aggFuncString);
        }
        return { name: name, aggFuncName: aggFuncName };
    };
    DropZoneColumnComp.prototype.setTextValue = function () {
        var _a = this.getColumnAndAggFuncName(),
            name = _a.name,
            aggFuncName = _a.aggFuncName;
        var displayValue = this.isAggregationZone() ? aggFuncName + '(' + name + ')' : name;
        var displayValueSanitised = _.escapeString(displayValue);
        this.eText.innerHTML = displayValueSanitised;
    };
    DropZoneColumnComp.prototype.onShowAggFuncSelection = function () {
        var _this = this;
        if (this.popupShowing) {
            return;
        }
        this.popupShowing = true;
        var virtualList = new VirtualList({ cssIdentifier: 'select-agg-func' });
        var rows = this.aggFuncService.getFuncNames(this.column);
        var eGui = this.getGui();
        var virtualListGui = virtualList.getGui();
        virtualList.setModel({
            getRow: function (index) {
                return rows[index];
            },
            getRowCount: function () {
                return rows.length;
            },
        });
        this.getContext().createBean(virtualList);
        var ePopup = _.loadTemplate(/* html*/ '<div class="ag-select-agg-func-popup"></div>');
        ePopup.style.top = '0px';
        ePopup.style.left = '0px';
        ePopup.appendChild(virtualListGui);
        ePopup.style.width = eGui.clientWidth + 'px';
        var focusoutListener = this.addManagedListener(ePopup, 'focusout', function (e) {
            if (!ePopup.contains(e.relatedTarget) && addPopupRes) {
                addPopupRes.hideFunc();
            }
        });
        var popupHiddenFunc = function (callbackEvent) {
            _this.destroyBean(virtualList);
            _this.popupShowing = false;
            if ((callbackEvent === null || callbackEvent === void 0 ? void 0 : callbackEvent.key) === 'Escape') {
                eGui.focus();
            }
            if (focusoutListener) {
                focusoutListener();
            }
        };
        var translate = this.localeService.getLocaleTextFunc();
        var addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: ePopup,
            closeOnEsc: true,
            closedCallback: popupHiddenFunc,
            ariaLabel: translate('ariaLabelAggregationFunction', 'Aggregation Function'),
        });
        if (addPopupRes) {
            virtualList.setComponentCreator(this.createAggSelect.bind(this, addPopupRes.hideFunc));
        }
        virtualList.addGuiEventListener('keydown', function (e) {
            if (e.key === KeyCode.ENTER || e.key === KeyCode.SPACE) {
                var row = virtualList.getLastFocusedRow();
                if (row == null) {
                    return;
                }
                var comp = virtualList.getComponentAt(row);
                if (comp) {
                    comp.selectItem();
                }
            }
        });
        this.popupService.positionPopupByComponent({
            type: 'aggFuncSelect',
            eventSource: eGui,
            ePopup: ePopup,
            keepWithinBounds: true,
            column: this.column,
            position: 'under',
        });
        virtualList.refresh();
        var rowToFocus = rows.findIndex(function (r) {
            return r === _this.column.getAggFunc();
        });
        if (rowToFocus === -1) {
            rowToFocus = 0;
        }
        virtualList.focusRow(rowToFocus);
    };
    DropZoneColumnComp.prototype.createAggSelect = function (hidePopup, value) {
        var _this = this;
        var itemSelected = function () {
            hidePopup();
            if (_this.gridOptionsService.is('functionsPassive')) {
                var event_1 = {
                    type: Events.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST,
                    columns: [_this.column],
                    aggFunc: value,
                };
                _this.eventService.dispatchEvent(event_1);
            } else {
                _this.columnModel.setColumnAggFunc(_this.column, value, 'toolPanelDragAndDrop');
            }
        };
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var aggFuncString = value.toString();
        var aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        var comp = new AggItemComp(itemSelected, aggFuncStringTranslated);
        return comp;
    };
    DropZoneColumnComp.prototype.addElementClasses = function (el, suffix) {
        suffix = suffix ? '-' + suffix : '';
        var direction = this.horizontal ? 'horizontal' : 'vertical';
        el.classList.add('ag-column-drop-cell' + suffix, 'ag-column-drop-' + direction + '-cell' + suffix);
    };
    DropZoneColumnComp.prototype.isAggregationZone = function () {
        return this.dropZonePurpose === 'aggregation';
    };
    DropZoneColumnComp.prototype.isGroupingZone = function () {
        return this.dropZonePurpose === 'rowGroup';
    };
    DropZoneColumnComp.EVENT_COLUMN_REMOVE = 'columnRemove';
    DropZoneColumnComp.TEMPLATE =
        '<span role="option">\n          <span ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>\n          <span ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>\n          <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>\n          <span ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>\n        </span>';
    __decorate$2l([Autowired('dragAndDropService')], DropZoneColumnComp.prototype, 'dragAndDropService', void 0);
    __decorate$2l([Autowired('columnModel')], DropZoneColumnComp.prototype, 'columnModel', void 0);
    __decorate$2l([Autowired('popupService')], DropZoneColumnComp.prototype, 'popupService', void 0);
    __decorate$2l([Optional('aggFuncService')], DropZoneColumnComp.prototype, 'aggFuncService', void 0);
    __decorate$2l([Autowired('sortController')], DropZoneColumnComp.prototype, 'sortController', void 0);
    __decorate$2l([RefSelector('eText')], DropZoneColumnComp.prototype, 'eText', void 0);
    __decorate$2l([RefSelector('eDragHandle')], DropZoneColumnComp.prototype, 'eDragHandle', void 0);
    __decorate$2l([RefSelector('eButton')], DropZoneColumnComp.prototype, 'eButton', void 0);
    __decorate$2l([RefSelector('eSortIndicator')], DropZoneColumnComp.prototype, 'eSortIndicator', void 0);
    __decorate$2l([PostConstruct], DropZoneColumnComp.prototype, 'init', null);
    return DropZoneColumnComp;
})(Component);
var AggItemComp = /** @class */ (function (_super) {
    __extends$3b(AggItemComp, _super);
    function AggItemComp(itemSelected, value) {
        var _this = _super.call(this, /* html */ '<div class="ag-select-agg-func-item"/>') || this;
        _this.selectItem = itemSelected;
        _this.getGui().innerText = value;
        _this.addGuiEventListener('click', _this.selectItem);
        return _this;
    }
    return AggItemComp;
})(Component);

var __extends$3a =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2k =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$1i =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$N =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var BaseDropZonePanel = /** @class */ (function (_super) {
    __extends$3a(BaseDropZonePanel, _super);
    function BaseDropZonePanel(horizontal, dropZonePurpose) {
        var _this = _super.call(this, /* html */ '<div class="ag-unselectable" role="presentation"></div>') || this;
        _this.horizontal = horizontal;
        _this.dropZonePurpose = dropZonePurpose;
        _this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
        _this.guiDestroyFunctions = [];
        _this.childColumnComponents = [];
        _this.resizeEnabled = false;
        _this.addElementClasses(_this.getGui());
        _this.eColumnDropList = document.createElement('div');
        _this.addElementClasses(_this.eColumnDropList, 'list');
        _.setAriaRole(_this.eColumnDropList, 'listbox');
        return _this;
    }
    BaseDropZonePanel.prototype.isHorizontal = function () {
        return this.horizontal;
    };
    BaseDropZonePanel.prototype.toggleResizable = function (resizable) {
        this.positionableFeature.setResizable(resizable ? { bottom: true } : false);
        this.resizeEnabled = resizable;
    };
    BaseDropZonePanel.prototype.setBeans = function (beans) {
        this.beans = beans;
    };
    BaseDropZonePanel.prototype.destroy = function () {
        this.destroyGui();
        _super.prototype.destroy.call(this);
    };
    BaseDropZonePanel.prototype.destroyGui = function () {
        this.guiDestroyFunctions.forEach(function (func) {
            return func();
        });
        this.guiDestroyFunctions.length = 0;
        this.childColumnComponents.length = 0;
        _.clearElement(this.getGui());
        _.clearElement(this.eColumnDropList);
    };
    BaseDropZonePanel.prototype.init = function (params) {
        this.params = params;
        this.createManagedBean(
            new ManagedFocusFeature(this.getFocusableElement(), {
                handleKeyDown: this.handleKeyDown.bind(this),
            }),
        );
        this.addManagedListener(this.beans.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.refreshGui.bind(this));
        this.addManagedPropertyListener('functionsReadOnly', this.refreshGui.bind(this));
        this.setupDropTarget();
        this.positionableFeature = new PositionableFeature(this.getGui(), { minHeight: 100 });
        this.createManagedBean(this.positionableFeature);
        // we don't know if this bean will be initialised before columnModel.
        // if columnModel first, then below will work
        // if columnModel second, then below will put blank in, and then above event gets first when columnModel is set up
        this.refreshGui();
        _.setAriaLabel(this.eColumnDropList, this.getAriaLabel());
    };
    BaseDropZonePanel.prototype.handleKeyDown = function (e) {
        var isVertical = !this.horizontal;
        var isNext = e.key === KeyCode.DOWN;
        var isPrevious = e.key === KeyCode.UP;
        if (!isVertical) {
            var isRtl = this.gridOptionsService.is('enableRtl');
            isNext = (!isRtl && e.key === KeyCode.RIGHT) || (isRtl && e.key === KeyCode.LEFT);
            isPrevious = (!isRtl && e.key === KeyCode.LEFT) || (isRtl && e.key === KeyCode.RIGHT);
        }
        if (!isNext && !isPrevious) {
            return;
        }
        var el = this.focusService.findNextFocusableElement(this.getFocusableElement(), false, isPrevious);
        if (el) {
            e.preventDefault();
            el.focus();
        }
    };
    BaseDropZonePanel.prototype.addElementClasses = function (el, suffix) {
        suffix = suffix ? '-' + suffix : '';
        var direction = this.horizontal ? 'horizontal' : 'vertical';
        el.classList.add('ag-column-drop' + suffix, 'ag-column-drop-' + direction + suffix);
    };
    BaseDropZonePanel.prototype.setupDropTarget = function () {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this),
        };
        this.beans.dragAndDropService.addDropTarget(this.dropTarget);
    };
    BaseDropZonePanel.prototype.isInterestedIn = function (type) {
        // not interested in row drags
        return type === DragSourceType.HeaderCell || type === DragSourceType.ToolPanel;
    };
    BaseDropZonePanel.prototype.checkInsertIndex = function (draggingEvent) {
        var newIndex = this.getNewInsertIndex(draggingEvent);
        // <0 happens when drag is no a direction we are interested in, eg drag is up/down but in horizontal panel
        if (newIndex < 0) {
            return false;
        }
        var changed = newIndex !== this.insertIndex;
        if (changed) {
            this.insertIndex = newIndex;
        }
        return changed;
    };
    BaseDropZonePanel.prototype.getNewInsertIndex = function (draggingEvent) {
        var _this = this;
        var mouseEvent = draggingEvent.event;
        var mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
        var boundsList = this.childColumnComponents.map(function (col) {
            return col.getGui().getBoundingClientRect();
        });
        // find the non-ghost component we're hovering
        var hoveredIndex = boundsList.findIndex(function (rect) {
            return _this.horizontal
                ? rect.right > mouseLocation && rect.left < mouseLocation
                : rect.top < mouseLocation && rect.bottom > mouseLocation;
        });
        // not hovering a non-ghost component
        if (hoveredIndex === -1) {
            var enableRtl = this.beans.gridOptionsService.is('enableRtl');
            // if mouse is below or right of all components then new index should be placed last
            var isLast = boundsList.every(function (rect) {
                return mouseLocation > (_this.horizontal ? rect.right : rect.bottom);
            });
            if (isLast) {
                return enableRtl && this.horizontal ? 0 : this.childColumnComponents.length;
            }
            // if mouse is above or left of all components, new index is first
            var isFirst = boundsList.every(function (rect) {
                return mouseLocation < (_this.horizontal ? rect.left : rect.top);
            });
            if (isFirst) {
                return enableRtl && this.horizontal ? this.childColumnComponents.length : 0;
            }
            // must be hovering a ghost, don't change the index
            return this.insertIndex;
        }
        // if the old index is equal to or less than the index of our new target
        // we need to shift right, to insert after rather than before
        if (this.insertIndex <= hoveredIndex) {
            return hoveredIndex + 1;
        }
        return hoveredIndex;
    };
    BaseDropZonePanel.prototype.checkDragStartedBySelf = function (draggingEvent) {
        if (this.state !== BaseDropZonePanel.STATE_NOT_DRAGGING) {
            return;
        }
        this.state = BaseDropZonePanel.STATE_REARRANGE_COLUMNS;
        this.potentialDndColumns = draggingEvent.dragSource.getDragItem().columns || [];
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    };
    BaseDropZonePanel.prototype.onDragging = function (draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        if (this.checkInsertIndex(draggingEvent)) {
            this.refreshGui();
        }
    };
    BaseDropZonePanel.prototype.onDragEnter = function (draggingEvent) {
        // this will contain all columns that are potential drops
        var dragColumns = draggingEvent.dragSource.getDragItem().columns || [];
        this.state = BaseDropZonePanel.STATE_NEW_COLUMNS_IN;
        // take out columns that are not droppable
        var goodDragColumns = dragColumns.filter(this.isColumnDroppable.bind(this));
        if (goodDragColumns.length > 0) {
            var hideColumnOnExit =
                this.isRowGroupPanel() &&
                !this.gridOptionsService.is('suppressRowGroupHidesColumns') &&
                !draggingEvent.fromNudge;
            if (hideColumnOnExit) {
                var dragItem = draggingEvent.dragSource.getDragItem();
                var columns = dragItem.columns;
                this.setColumnsVisible(columns, false, 'uiColumnDragged');
            }
            this.potentialDndColumns = goodDragColumns;
            this.checkInsertIndex(draggingEvent);
            this.refreshGui();
        }
    };
    BaseDropZonePanel.prototype.setColumnsVisible = function (columns, visible, source) {
        if (source === void 0) {
            source = 'api';
        }
        if (columns) {
            var allowedCols = columns.filter(function (c) {
                return !c.getColDef().lockVisible;
            });
            this.colModel.setColumnsVisible(allowedCols, visible, source);
        }
    };
    BaseDropZonePanel.prototype.isPotentialDndColumns = function () {
        return _.existsAndNotEmpty(this.potentialDndColumns);
    };
    BaseDropZonePanel.prototype.isRowGroupPanel = function () {
        return this.dropZonePurpose === 'rowGroup';
    };
    BaseDropZonePanel.prototype.onDragLeave = function (draggingEvent) {
        // if the dragging started from us, we remove the group, however if it started
        // some place else, then we don't, as it was only 'asking'
        if (this.state === BaseDropZonePanel.STATE_REARRANGE_COLUMNS) {
            var columns = draggingEvent.dragSource.getDragItem().columns || [];
            this.removeColumns(columns);
        }
        if (this.isPotentialDndColumns()) {
            var showColumnOnExit =
                this.isRowGroupPanel() &&
                !this.gridOptionsService.is('suppressMakeColumnVisibleAfterUnGroup') &&
                !draggingEvent.fromNudge;
            if (showColumnOnExit) {
                var dragItem = draggingEvent.dragSource.getDragItem();
                this.setColumnsVisible(dragItem.columns, true, 'uiColumnDragged');
            }
            this.potentialDndColumns = [];
            this.refreshGui();
        }
        this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
    };
    BaseDropZonePanel.prototype.onDragStop = function () {
        if (this.isPotentialDndColumns()) {
            var success = false;
            if (this.state === BaseDropZonePanel.STATE_NEW_COLUMNS_IN) {
                this.addColumns(this.potentialDndColumns);
                success = true;
            } else {
                success = this.rearrangeColumns(this.potentialDndColumns);
            }
            this.potentialDndColumns = [];
            // If the function is passive, then we don't refresh, as we assume the client application
            // is going to call setRowGroups / setPivots / setValues at a later point which will then
            // cause a refresh. This gives a nice GUI where the ghost stays until the app has caught
            // up with the changes. However, if there was no change in the order, then we do need to
            // refresh to reset the columns
            if (!this.beans.gridOptionsService.is('functionsPassive') || !success) {
                this.refreshGui();
            }
        }
        this.state = BaseDropZonePanel.STATE_NOT_DRAGGING;
    };
    BaseDropZonePanel.prototype.removeColumns = function (columnsToRemove) {
        var newColumnList = this.getExistingColumns().filter(function (col) {
            return !_.includes(columnsToRemove, col);
        });
        this.updateColumns(newColumnList);
    };
    BaseDropZonePanel.prototype.addColumns = function (columnsToAdd) {
        if (!columnsToAdd) {
            return;
        }
        var newColumnList = this.getExistingColumns().slice();
        var colsToAddNoDuplicates = columnsToAdd.filter(function (col) {
            return newColumnList.indexOf(col) < 0;
        });
        _.insertArrayIntoArray(newColumnList, colsToAddNoDuplicates, this.insertIndex);
        this.updateColumns(newColumnList);
    };
    BaseDropZonePanel.prototype.rearrangeColumns = function (columnsToAdd) {
        var newColumnList = this.getNonGhostColumns().slice();
        _.insertArrayIntoArray(newColumnList, columnsToAdd, this.insertIndex);
        if (_.areEqual(newColumnList, this.getExistingColumns())) {
            return false;
        }
        this.updateColumns(newColumnList);
        return true;
    };
    BaseDropZonePanel.prototype.refreshGui = function () {
        // we reset the scroll position after the refresh.
        // if we don't do this, then the list will always scroll to the top
        // each time we refresh it. this is because part of the refresh empties
        // out the list which sets scroll to zero. so the user could be just
        // reordering the list - we want to prevent the resetting of the scroll.
        // this is relevant for vertical display only (as horizontal has no scroll)
        var scrollTop = this.eColumnDropList.scrollTop;
        var resizeEnabled = this.resizeEnabled;
        var focusedIndex = this.getFocusedItem();
        var alternateElement = this.focusService.findNextFocusableElement();
        if (!alternateElement) {
            alternateElement = this.focusService.findNextFocusableElement(undefined, false, true);
        }
        this.toggleResizable(false);
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addColumnsToGui();
        if (!this.isHorizontal()) {
            this.eColumnDropList.scrollTop = scrollTop;
        }
        if (resizeEnabled) {
            this.toggleResizable(resizeEnabled);
        }
        // focus should only be restored when keyboard mode
        // otherwise mouse clicks will cause containers to scroll
        // without no apparent reason.
        if (this.focusService.isKeyboardMode()) {
            this.restoreFocus(focusedIndex, alternateElement);
        }
    };
    BaseDropZonePanel.prototype.getFocusedItem = function () {
        var eGui = this.getGui();
        var activeElement = this.gridOptionsService.getDocument().activeElement;
        if (!eGui.contains(activeElement)) {
            return -1;
        }
        var items = Array.from(eGui.querySelectorAll('.ag-column-drop-cell'));
        return items.indexOf(activeElement);
    };
    BaseDropZonePanel.prototype.restoreFocus = function (index, alternateElement) {
        var eGui = this.getGui();
        var items = Array.from(eGui.querySelectorAll('.ag-column-drop-cell'));
        if (index === -1) {
            return;
        }
        if (items.length === 0) {
            alternateElement.focus();
        }
        var indexToFocus = Math.min(items.length - 1, index);
        var el = items[indexToFocus];
        if (el) {
            el.focus();
        }
    };
    BaseDropZonePanel.prototype.getNonGhostColumns = function () {
        var _this = this;
        var existingColumns = this.getExistingColumns();
        if (this.isPotentialDndColumns()) {
            return existingColumns.filter(function (column) {
                return !_.includes(_this.potentialDndColumns, column);
            });
        }
        return existingColumns;
    };
    BaseDropZonePanel.prototype.addColumnsToGui = function () {
        var _this = this;
        var nonGhostColumns = this.getNonGhostColumns();
        var itemsToAddToGui = nonGhostColumns.map(function (column) {
            return _this.createColumnComponent(column, false);
        });
        if (this.isPotentialDndColumns()) {
            var dndColumns = this.potentialDndColumns.map(function (column) {
                return _this.createColumnComponent(column, true);
            });
            if (this.insertIndex >= itemsToAddToGui.length) {
                itemsToAddToGui.push.apply(itemsToAddToGui, __spreadArray$N([], __read$1i(dndColumns)));
            } else {
                itemsToAddToGui.splice.apply(
                    itemsToAddToGui,
                    __spreadArray$N([this.insertIndex, 0], __read$1i(dndColumns)),
                );
            }
        }
        this.appendChild(this.eColumnDropList);
        itemsToAddToGui.forEach(function (columnComponent, index) {
            if (index > 0) {
                _this.addArrow(_this.eColumnDropList);
            }
            _this.eColumnDropList.appendChild(columnComponent.getGui());
        });
        this.addAriaLabelsToComponents();
    };
    BaseDropZonePanel.prototype.addAriaLabelsToComponents = function () {
        var _this = this;
        this.childColumnComponents.forEach(function (comp, idx) {
            var eGui = comp.getGui();
            _.setAriaPosInSet(eGui, idx + 1);
            _.setAriaSetSize(eGui, _this.childColumnComponents.length);
        });
    };
    BaseDropZonePanel.prototype.createColumnComponent = function (column, ghost) {
        var _this = this;
        var columnComponent = new DropZoneColumnComp(
            column,
            this.dropTarget,
            ghost,
            this.dropZonePurpose,
            this.horizontal,
        );
        columnComponent.addEventListener(
            DropZoneColumnComp.EVENT_COLUMN_REMOVE,
            this.removeColumns.bind(this, [column]),
        );
        this.beans.context.createBean(columnComponent);
        this.guiDestroyFunctions.push(function () {
            return _this.destroyBean(columnComponent);
        });
        if (!ghost) {
            this.childColumnComponents.push(columnComponent);
        }
        return columnComponent;
    };
    BaseDropZonePanel.prototype.addIconAndTitleToGui = function () {
        var eGroupIcon = this.params.icon;
        var eTitleBar = document.createElement('div');
        _.setAriaHidden(eTitleBar, true);
        this.addElementClasses(eTitleBar, 'title-bar');
        this.addElementClasses(eGroupIcon, 'icon');
        this.addOrRemoveCssClass('ag-column-drop-empty', this.isExistingColumnsEmpty());
        eTitleBar.appendChild(eGroupIcon);
        if (!this.horizontal) {
            var eTitle = document.createElement('span');
            this.addElementClasses(eTitle, 'title');
            eTitle.innerHTML = this.params.title;
            eTitleBar.appendChild(eTitle);
        }
        this.appendChild(eTitleBar);
    };
    BaseDropZonePanel.prototype.isExistingColumnsEmpty = function () {
        return this.getExistingColumns().length === 0;
    };
    BaseDropZonePanel.prototype.addEmptyMessageToGui = function () {
        if (!this.isExistingColumnsEmpty() || this.isPotentialDndColumns()) {
            return;
        }
        var eMessage = document.createElement('span');
        eMessage.innerHTML = this.params.emptyMessage;
        this.addElementClasses(eMessage, 'empty-message');
        this.eColumnDropList.appendChild(eMessage);
    };
    BaseDropZonePanel.prototype.addArrow = function (eParent) {
        // only add the arrows if the layout is horizontal
        if (this.horizontal) {
            // for RTL it's a left arrow, otherwise it's a right arrow
            var enableRtl = this.beans.gridOptionsService.is('enableRtl');
            var icon = _.createIconNoSpan(enableRtl ? 'smallLeft' : 'smallRight', this.beans.gridOptionsService);
            this.addElementClasses(icon, 'cell-separator');
            eParent.appendChild(icon);
        }
    };
    BaseDropZonePanel.STATE_NOT_DRAGGING = 'notDragging';
    BaseDropZonePanel.STATE_NEW_COLUMNS_IN = 'newColumnsIn';
    BaseDropZonePanel.STATE_REARRANGE_COLUMNS = 'rearrangeColumns';
    __decorate$2k([Autowired('columnModel')], BaseDropZonePanel.prototype, 'colModel', void 0);
    __decorate$2k([Autowired('focusService')], BaseDropZonePanel.prototype, 'focusService', void 0);
    return BaseDropZonePanel;
})(Component);

var __extends$39 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2j =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var RowGroupDropZonePanel = /** @class */ (function (_super) {
    __extends$39(RowGroupDropZonePanel, _super);
    function RowGroupDropZonePanel(horizontal) {
        return _super.call(this, horizontal, 'rowGroup') || this;
    }
    RowGroupDropZonePanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsService: this.gridOptionsService,
            eventService: this.eventService,
            context: this.getContext(),
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService,
        });
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('rowGroupColumnsEmptyMessage', 'Drag here to set row groups');
        var title = localeTextFunc('groups', 'Row Groups');
        _super.prototype.init.call(this, {
            dragAndDropIcon: DragAndDropService.ICON_GROUP,
            icon: _.createIconNoSpan('rowGroupPanel', this.gridOptionsService, null),
            emptyMessage: emptyMessage,
            title: title,
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshGui.bind(this));
    };
    RowGroupDropZonePanel.prototype.getAriaLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var label = translate('ariaRowGroupDropZonePanelLabel', 'Row Groups');
        return label;
    };
    RowGroupDropZonePanel.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'rowGroupColumnsList';
        return res;
    };
    RowGroupDropZonePanel.prototype.isColumnDroppable = function (column) {
        // we never allow grouping of secondary columns
        if (this.gridOptionsService.is('functionsReadOnly') || !column.isPrimary()) {
            return false;
        }
        return column.isAllowRowGroup() && !column.isRowGroupActive();
    };
    RowGroupDropZonePanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsService.is('functionsPassive')) {
            var event_1 = {
                type: Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                columns: columns,
            };
            this.eventService.dispatchEvent(event_1);
        } else {
            this.columnModel.setRowGroupColumns(columns, 'toolPanelUi');
        }
    };
    RowGroupDropZonePanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? DragAndDropService.ICON_GROUP : DragAndDropService.ICON_NOT_ALLOWED;
    };
    RowGroupDropZonePanel.prototype.getExistingColumns = function () {
        return this.columnModel.getRowGroupColumns();
    };
    __decorate$2j([Autowired('columnModel')], RowGroupDropZonePanel.prototype, 'columnModel', void 0);
    __decorate$2j([Autowired('loggerFactory')], RowGroupDropZonePanel.prototype, 'loggerFactory', void 0);
    __decorate$2j([Autowired('dragAndDropService')], RowGroupDropZonePanel.prototype, 'dragAndDropService', void 0);
    __decorate$2j([PostConstruct], RowGroupDropZonePanel.prototype, 'passBeansUp', null);
    return RowGroupDropZonePanel;
})(BaseDropZonePanel);

var __extends$38 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2i =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PivotDropZonePanel = /** @class */ (function (_super) {
    __extends$38(PivotDropZonePanel, _super);
    function PivotDropZonePanel(horizontal) {
        return _super.call(this, horizontal, 'pivot') || this;
    }
    PivotDropZonePanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsService: this.gridOptionsService,
            eventService: this.eventService,
            context: this.getContext(),
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService,
        });
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('pivotColumnsEmptyMessage', 'Drag here to set column labels');
        var title = localeTextFunc('pivots', 'Column Labels');
        _super.prototype.init.call(this, {
            dragAndDropIcon: DragAndDropService.ICON_GROUP,
            icon: _.createIconNoSpan('pivotPanel', this.gridOptionsService, null),
            emptyMessage: emptyMessage,
            title: title,
        });
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.refresh.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, this.refresh.bind(this));
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
            this.checkVisibility.bind(this),
        );
        this.refresh();
    };
    PivotDropZonePanel.prototype.getAriaLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var label = translate('ariaPivotDropZonePanelLabel', 'Column Labels');
        return label;
    };
    PivotDropZonePanel.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'pivotColumnsList';
        return res;
    };
    PivotDropZonePanel.prototype.refresh = function () {
        this.checkVisibility();
        this.refreshGui();
    };
    PivotDropZonePanel.prototype.checkVisibility = function () {
        var pivotMode = this.columnModel.isPivotMode();
        if (this.isHorizontal()) {
            // what we do for horizontal (ie the pivot panel at the top) depends
            // on the user property as well as pivotMode.
            switch (this.gridOptionsService.get('pivotPanelShow')) {
                case 'always':
                    this.setDisplayed(pivotMode);
                    break;
                case 'onlyWhenPivoting':
                    var pivotActive = this.columnModel.isPivotActive();
                    this.setDisplayed(pivotMode && pivotActive);
                    break;
                default:
                    // never show it
                    this.setDisplayed(false);
                    break;
            }
        } else {
            // in toolPanel, the pivot panel is always shown when pivot mode is on
            this.setDisplayed(pivotMode);
        }
    };
    PivotDropZonePanel.prototype.isColumnDroppable = function (column) {
        // we never allow grouping of secondary columns
        if (this.gridOptionsService.is('functionsReadOnly') || !column.isPrimary()) {
            return false;
        }
        return column.isAllowPivot() && !column.isPivotActive();
    };
    PivotDropZonePanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsService.is('functionsPassive')) {
            var event_1 = {
                type: Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                columns: columns,
            };
            this.eventService.dispatchEvent(event_1);
        } else {
            this.columnModel.setPivotColumns(columns, 'toolPanelUi');
        }
    };
    PivotDropZonePanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? DragAndDropService.ICON_PIVOT : DragAndDropService.ICON_NOT_ALLOWED;
    };
    PivotDropZonePanel.prototype.getExistingColumns = function () {
        return this.columnModel.getPivotColumns();
    };
    __decorate$2i([Autowired('columnModel')], PivotDropZonePanel.prototype, 'columnModel', void 0);
    __decorate$2i([Autowired('loggerFactory')], PivotDropZonePanel.prototype, 'loggerFactory', void 0);
    __decorate$2i([Autowired('dragAndDropService')], PivotDropZonePanel.prototype, 'dragAndDropService', void 0);
    __decorate$2i([PostConstruct], PivotDropZonePanel.prototype, 'passBeansUp', null);
    return PivotDropZonePanel;
})(BaseDropZonePanel);

var __extends$37 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2h =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var GridHeaderDropZones = /** @class */ (function (_super) {
    __extends$37(GridHeaderDropZones, _super);
    function GridHeaderDropZones() {
        return _super.call(this) || this;
    }
    GridHeaderDropZones.prototype.postConstruct = function () {
        this.setGui(this.createNorthPanel());
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
            this.onRowGroupChanged.bind(this),
        );
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onRowGroupChanged.bind(this));
        this.addManagedPropertyListener('rowGroupPanelShow', this.onRowGroupChanged.bind(this));
        this.onRowGroupChanged();
    };
    GridHeaderDropZones.prototype.createNorthPanel = function () {
        var topPanelGui = document.createElement('div');
        var dropPanelVisibleListener = this.onDropPanelVisible.bind(this);
        topPanelGui.classList.add('ag-column-drop-wrapper');
        _.setAriaRole(topPanelGui, 'presentation');
        this.rowGroupComp = new RowGroupDropZonePanel(true);
        this.createManagedBean(this.rowGroupComp);
        this.pivotComp = new PivotDropZonePanel(true);
        this.createManagedBean(this.pivotComp);
        topPanelGui.appendChild(this.rowGroupComp.getGui());
        topPanelGui.appendChild(this.pivotComp.getGui());
        this.addManagedListener(this.rowGroupComp, Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
        this.addManagedListener(this.pivotComp, Component.EVENT_DISPLAYED_CHANGED, dropPanelVisibleListener);
        this.onDropPanelVisible();
        return topPanelGui;
    };
    GridHeaderDropZones.prototype.onDropPanelVisible = function () {
        var bothDisplayed = this.rowGroupComp.isDisplayed() && this.pivotComp.isDisplayed();
        this.rowGroupComp.addOrRemoveCssClass('ag-column-drop-horizontal-half-width', bothDisplayed);
        this.pivotComp.addOrRemoveCssClass('ag-column-drop-horizontal-half-width', bothDisplayed);
    };
    GridHeaderDropZones.prototype.onRowGroupChanged = function () {
        if (!this.rowGroupComp) {
            return;
        }
        var rowGroupPanelShow = this.gridOptionsService.get('rowGroupPanelShow');
        if (rowGroupPanelShow === 'always') {
            this.rowGroupComp.setDisplayed(true);
        } else if (rowGroupPanelShow === 'onlyWhenGrouping') {
            var grouping = !this.columnModel.isRowGroupEmpty();
            this.rowGroupComp.setDisplayed(grouping);
        } else {
            this.rowGroupComp.setDisplayed(false);
        }
    };
    __decorate$2h([Autowired('columnModel')], GridHeaderDropZones.prototype, 'columnModel', void 0);
    __decorate$2h([PostConstruct], GridHeaderDropZones.prototype, 'postConstruct', null);
    return GridHeaderDropZones;
})(Component);

var __extends$36 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2g =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FilterAggregatesStage = /** @class */ (function (_super) {
    __extends$36(FilterAggregatesStage, _super);
    function FilterAggregatesStage() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    FilterAggregatesStage.prototype.execute = function (params) {
        var _this = this;
        var isPivotMode = this.columnModel.isPivotMode();
        var isAggFilterActive =
            this.filterManager.isAggregateFilterPresent() || this.filterManager.isAggregateQuickFilterPresent();
        // This is the default filter for applying only to leaf nodes, realistically this should not apply as primary agg columns,
        // should not be applied by the filterManager if getGroupAggFiltering is missing. Predicate will apply filters to leaf level.
        var defaultPrimaryColumnPredicate = function (params) {
            return !params.node.group;
        };
        // Default secondary column predicate, selecting only leaf level groups.
        var defaultSecondaryColumnPredicate = function (params) {
            return params.node.leafGroup;
        };
        // The predicate to determine whether filters should apply to this row. Either defined by the user in groupAggFiltering or a default depending
        // on current pivot mode status.
        var applyFilterToNode =
            this.gridOptionsService.getGroupAggFiltering() ||
            (isPivotMode ? defaultSecondaryColumnPredicate : defaultPrimaryColumnPredicate);
        var changedPath = params.changedPath;
        var preserveChildren = function (node, recursive) {
            if (recursive === void 0) {
                recursive = false;
            }
            if (node.childrenAfterFilter) {
                node.childrenAfterAggFilter = node.childrenAfterFilter;
                if (recursive) {
                    node.childrenAfterAggFilter.forEach(function (child) {
                        return preserveChildren(child, recursive);
                    });
                }
                _this.setAllChildrenCount(node);
            }
            if (node.sibling) {
                node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
            }
        };
        var filterChildren = function (node) {
            var _a;
            node.childrenAfterAggFilter =
                ((_a = node.childrenAfterFilter) === null || _a === void 0
                    ? void 0
                    : _a.filter(function (child) {
                          var _a;
                          var shouldFilterRow = applyFilterToNode({ node: child });
                          if (shouldFilterRow) {
                              var doesNodePassFilter = _this.filterManager.doesRowPassAggregateFilters({
                                  rowNode: child,
                              });
                              if (doesNodePassFilter) {
                                  // Node has passed, so preserve children
                                  preserveChildren(child, true);
                                  return true;
                              }
                          }
                          var hasChildPassed =
                              (_a = child.childrenAfterAggFilter) === null || _a === void 0 ? void 0 : _a.length;
                          return hasChildPassed;
                      })) || null;
            _this.setAllChildrenCount(node);
            if (node.sibling) {
                node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
            }
        };
        changedPath.forEachChangedNodeDepthFirst(isAggFilterActive ? filterChildren : preserveChildren, true);
    };
    FilterAggregatesStage.prototype.setAllChildrenCountTreeData = function (rowNode) {
        // for tree data, we include all children, groups and leafs
        var allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach(function (child) {
            // include child itself
            allChildrenCount++;
            // include children of children
            allChildrenCount += child.allChildrenCount;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    };
    FilterAggregatesStage.prototype.setAllChildrenCountGridGrouping = function (rowNode) {
        // for grid data, we only count the leafs
        var allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach(function (child) {
            if (child.group) {
                allChildrenCount += child.allChildrenCount;
            } else {
                allChildrenCount++;
            }
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    };
    FilterAggregatesStage.prototype.setAllChildrenCount = function (rowNode) {
        if (!rowNode.hasChildren()) {
            rowNode.setAllChildrenCount(null);
            return;
        }
        if (this.gridOptionsService.is('treeData')) {
            this.setAllChildrenCountTreeData(rowNode);
        } else {
            this.setAllChildrenCountGridGrouping(rowNode);
        }
    };
    __decorate$2g([Autowired('filterManager')], FilterAggregatesStage.prototype, 'filterManager', void 0);
    __decorate$2g([Autowired('columnModel')], FilterAggregatesStage.prototype, 'columnModel', void 0);
    FilterAggregatesStage = __decorate$2g([Bean('filterAggregatesStage')], FilterAggregatesStage);
    return FilterAggregatesStage;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$g = '30.2.0';

var __extends$35 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2f =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var GroupFilter = /** @class */ (function (_super) {
    __extends$35(GroupFilter, _super);
    function GroupFilter() {
        return (
            _super.call(
                this,
                /* html */ '\n            <div class="ag-group-filter">\n                <div ref="eGroupField"></div>\n                <div ref="eUnderlyingFilter"></div>\n            </div>\n        ',
            ) || this
        );
    }
    GroupFilter.prototype.postConstruct = function () {
        this.initialiseTabGuard({});
    };
    GroupFilter.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.validateParams();
        return this.updateGroups().then(function () {
            _this.addManagedListener(_this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
                return _this.onColumnRowGroupChanged();
            });
        });
    };
    GroupFilter.prototype.validateParams = function () {
        var colDef = this.params.colDef;
        if (colDef.field) {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Group Column Filter does not work with the colDef property "field". This property will be ignored.',
                );
            }, 'groupFilterFieldParam');
        }
        if (colDef.filterValueGetter) {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.',
                );
            }, 'groupFilterFilterValueGetterParam');
        }
        if (colDef.filterParams) {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.',
                );
            }, 'groupFilterFilterParams');
        }
    };
    GroupFilter.prototype.updateGroups = function () {
        var sourceColumns = this.updateGroupField();
        return this.getUnderlyingFilters(sourceColumns);
    };
    GroupFilter.prototype.getSourceColumns = function () {
        this.groupColumn = this.params.column;
        if (this.gridOptionsService.is('treeData')) {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.',
                );
            }, 'groupFilterTreeData');
            return [];
        }
        var sourceColumns = this.columnModel.getSourceColumnsForGroupColumn(this.groupColumn);
        if (!sourceColumns) {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Group Column Filter only works on group columns. Please use a different filter.',
                );
            }, 'groupFilterNotGroupColumn');
            return [];
        }
        return sourceColumns;
    };
    GroupFilter.prototype.updateGroupField = function () {
        var _this = this;
        _.clearElement(this.eGroupField);
        if (this.eGroupFieldSelect) {
            this.destroyBean(this.eGroupFieldSelect);
        }
        var allSourceColumns = this.getSourceColumns();
        var sourceColumns = allSourceColumns.filter(function (sourceColumn) {
            return sourceColumn.isFilterAllowed();
        });
        if (!sourceColumns.length) {
            this.selectedColumn = undefined;
            _.setDisplayed(this.eGroupField, false);
            return null;
        }
        if (allSourceColumns.length === 1) {
            // we only want to hide the group field element if there's only one group column.
            // If there's one group column that has a filter, but multiple columns in total,
            // we should still show the select so the user knows which column it's for.
            this.selectedColumn = sourceColumns[0];
            _.setDisplayed(this.eGroupField, false);
        } else {
            // keep the old selected column if it's still valid
            if (
                !this.selectedColumn ||
                !sourceColumns.some(function (column) {
                    return column.getId() === _this.selectedColumn.getId();
                })
            ) {
                this.selectedColumn = sourceColumns[0];
            }
            this.createGroupFieldSelectElement(sourceColumns);
            this.eGroupField.appendChild(this.eGroupFieldSelect.getGui());
            this.eGroupField.appendChild(_.loadTemplate(/* html */ '<div class="ag-filter-separator"></div>'));
            _.setDisplayed(this.eGroupField, true);
        }
        return sourceColumns;
    };
    GroupFilter.prototype.createGroupFieldSelectElement = function (sourceColumns) {
        var _this = this;
        this.eGroupFieldSelect = this.createManagedBean(new AgSelect());
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eGroupFieldSelect.setLabel(localeTextFunc('groupFilterSelect', 'Select field:'));
        this.eGroupFieldSelect.setLabelAlignment('top');
        this.eGroupFieldSelect.addOptions(
            sourceColumns.map(function (sourceColumn) {
                var _a;
                return {
                    value: sourceColumn.getId(),
                    text:
                        (_a = _this.columnModel.getDisplayNameForColumn(sourceColumn, 'groupFilter', false)) !== null &&
                        _a !== void 0
                            ? _a
                            : undefined,
                };
            }),
        );
        this.eGroupFieldSelect.setValue(this.selectedColumn.getId());
        this.eGroupFieldSelect.onValueChange(function (newValue) {
            return _this.updateSelectedColumn(newValue);
        });
        this.eGroupFieldSelect.addCssClass('ag-group-filter-field-select-wrapper');
        if (sourceColumns.length === 1) {
            this.eGroupFieldSelect.setDisabled(true);
        }
    };
    GroupFilter.prototype.getUnderlyingFilters = function (sourceColumns) {
        var _this = this;
        if (!sourceColumns) {
            this.filterColumnPairs = undefined;
            this.selectedFilter = undefined;
            this.groupColumn.setFilterActive(false, 'columnRowGroupChanged');
            return AgPromise.resolve();
        }
        var filterPromises = [];
        var filterColumnPairs = [];
        sourceColumns.forEach(function (column) {
            var filterWrapper = _this.filterManager.getOrCreateFilterWrapper(column, 'COLUMN_MENU');
            if (filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.filterPromise) {
                filterPromises.push(
                    filterWrapper.filterPromise.then(function (filter) {
                        if (filter) {
                            filterColumnPairs.push({
                                filter: filter,
                                column: column,
                            });
                        }
                        if (column.getId() === _this.selectedColumn.getId()) {
                            _this.selectedFilter = filter !== null && filter !== void 0 ? filter : undefined;
                        }
                        return filter;
                    }),
                );
            }
        });
        return AgPromise.all(filterPromises).then(function () {
            _this.filterColumnPairs = filterColumnPairs;
            _this.groupColumn.setFilterActive(_this.isFilterActive(), 'columnRowGroupChanged');
        });
    };
    GroupFilter.prototype.addUnderlyingFilterElement = function () {
        var _this = this;
        _.clearElement(this.eUnderlyingFilter);
        if (!this.selectedColumn) {
            return AgPromise.resolve();
        }
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.selectedColumn, 'COLUMN_MENU');
        if (!filterWrapper) {
            return AgPromise.resolve();
        }
        return filterWrapper.guiPromise.then(function (gui) {
            var _a;
            _this.eUnderlyingFilter.appendChild(gui);
            (_a = filterWrapper.filterPromise) === null || _a === void 0
                ? void 0
                : _a.then(function (filter) {
                      var _a, _b;
                      (_a = filter === null || filter === void 0 ? void 0 : filter.afterGuiAttached) === null ||
                      _a === void 0
                          ? void 0
                          : _a.call(filter, _this.afterGuiAttachedParams);
                      if (
                          !((_b = _this.afterGuiAttachedParams) === null || _b === void 0
                              ? void 0
                              : _b.suppressFocus) &&
                          _this.eGroupFieldSelect &&
                          !_this.eGroupFieldSelect.isDisabled()
                      ) {
                          _this.eGroupFieldSelect.getFocusableElement().focus();
                      }
                  });
        });
    };
    GroupFilter.prototype.updateSelectedColumn = function (columnId) {
        var _a, _b;
        if (!columnId) {
            return;
        }
        (_b = (_a = this.selectedFilter) === null || _a === void 0 ? void 0 : _a.afterGuiDetached) === null ||
        _b === void 0
            ? void 0
            : _b.call(_a);
        var selectedFilterColumnPair = this.getFilterColumnPair(columnId);
        this.selectedColumn =
            selectedFilterColumnPair === null || selectedFilterColumnPair === void 0
                ? void 0
                : selectedFilterColumnPair.column;
        this.selectedFilter =
            selectedFilterColumnPair === null || selectedFilterColumnPair === void 0
                ? void 0
                : selectedFilterColumnPair.filter;
        this.dispatchEvent({
            type: GroupFilter.EVENT_SELECTED_COLUMN_CHANGED,
        });
        this.addUnderlyingFilterElement();
    };
    GroupFilter.prototype.isFilterActive = function () {
        var _a;
        return !!((_a = this.filterColumnPairs) === null || _a === void 0
            ? void 0
            : _a.some(function (_a) {
                  var filter = _a.filter;
                  return filter.isFilterActive();
              }));
    };
    GroupFilter.prototype.doesFilterPass = function () {
        return true;
    };
    GroupFilter.prototype.getModel = function () {
        return null;
    };
    GroupFilter.prototype.setModel = function () {
        return AgPromise.resolve();
    };
    GroupFilter.prototype.afterGuiAttached = function (params) {
        this.afterGuiAttachedParams = params;
        this.addUnderlyingFilterElement();
    };
    GroupFilter.prototype.afterGuiDetached = function () {
        var _a, _b;
        _.clearElement(this.eUnderlyingFilter);
        (_b = (_a = this.selectedFilter) === null || _a === void 0 ? void 0 : _a.afterGuiDetached) === null ||
        _b === void 0
            ? void 0
            : _b.call(_a);
    };
    GroupFilter.prototype.onColumnRowGroupChanged = function () {
        var _this = this;
        this.updateGroups().then(function () {
            _this.dispatchEvent({
                type: GroupFilter.EVENT_COLUMN_ROW_GROUP_CHANGED,
            });
            _this.eventService.dispatchEvent({
                type: 'filterAllowedUpdated',
            });
        });
    };
    GroupFilter.prototype.getFilterColumnPair = function (columnId) {
        var _a;
        if (!columnId) {
            return undefined;
        }
        return (_a = this.filterColumnPairs) === null || _a === void 0
            ? void 0
            : _a.find(function (_a) {
                  var column = _a.column;
                  return column.getId() === columnId;
              });
    };
    GroupFilter.prototype.getSelectedFilter = function () {
        return this.selectedFilter;
    };
    GroupFilter.prototype.getSelectedColumn = function () {
        return this.selectedColumn;
    };
    GroupFilter.prototype.isFilterAllowed = function () {
        return !!this.selectedColumn;
    };
    GroupFilter.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    GroupFilter.EVENT_COLUMN_ROW_GROUP_CHANGED = 'columnRowGroupChanged';
    GroupFilter.EVENT_SELECTED_COLUMN_CHANGED = 'selectedColumnChanged';
    __decorate$2f([Autowired('filterManager')], GroupFilter.prototype, 'filterManager', void 0);
    __decorate$2f([Autowired('columnModel')], GroupFilter.prototype, 'columnModel', void 0);
    __decorate$2f([RefSelector('eGroupField')], GroupFilter.prototype, 'eGroupField', void 0);
    __decorate$2f([RefSelector('eUnderlyingFilter')], GroupFilter.prototype, 'eUnderlyingFilter', void 0);
    __decorate$2f([PostConstruct], GroupFilter.prototype, 'postConstruct', null);
    return GroupFilter;
})(TabGuardComp);

var __extends$34 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2e =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var GroupFloatingFilterComp = /** @class */ (function (_super) {
    __extends$34(GroupFloatingFilterComp, _super);
    function GroupFloatingFilterComp() {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div ref="eFloatingFilter" class="ag-group-floating-filter ag-floating-filter-input" role="presentation"></div>\n        ',
            ) || this;
        _this.haveAddedColumnListeners = false;
        return _this;
    }
    GroupFloatingFilterComp.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        // we only support showing the underlying floating filter for multiple group columns
        var canShowUnderlyingFloatingFilter = this.gridOptionsService.get('groupDisplayType') === 'multipleColumns';
        return new AgPromise(function (resolve) {
            _this.params.parentFilterInstance(function (parentFilterInstance) {
                _this.parentFilterInstance = parentFilterInstance;
                if (canShowUnderlyingFloatingFilter) {
                    _this.setupUnderlyingFloatingFilterElement().then(function () {
                        return resolve();
                    });
                } else {
                    _this.setupReadOnlyFloatingFilterElement();
                    resolve();
                }
            });
        }).then(function () {
            _this.addManagedListener(
                _this.parentFilterInstance,
                GroupFilter.EVENT_SELECTED_COLUMN_CHANGED,
                function () {
                    return _this.onSelectedColumnChanged();
                },
            );
            _this.addManagedListener(
                _this.parentFilterInstance,
                GroupFilter.EVENT_COLUMN_ROW_GROUP_CHANGED,
                function () {
                    return _this.onColumnRowGroupChanged();
                },
            );
        });
    };
    GroupFloatingFilterComp.prototype.onParamsUpdated = function (params) {
        this.params = params;
        this.setParams();
    };
    GroupFloatingFilterComp.prototype.setParams = function () {
        var _a;
        var displayName = this.columnModel.getDisplayNameForColumn(this.params.column, 'header', true);
        var translate = this.localeService.getLocaleTextFunc();
        (_a = this.eFloatingFilterText) === null || _a === void 0
            ? void 0
            : _a.setInputAriaLabel(displayName + ' ' + translate('ariaFilterInput', 'Filter Input'));
    };
    GroupFloatingFilterComp.prototype.setupReadOnlyFloatingFilterElement = function () {
        var _this = this;
        if (!this.eFloatingFilterText) {
            this.eFloatingFilterText = this.createManagedBean(new AgInputTextField());
            this.eFloatingFilterText.setDisabled(true).addGuiEventListener('click', function () {
                return _this.params.showParentFilter();
            });
            this.setParams();
        }
        this.updateDisplayedValue();
        this.eFloatingFilter.appendChild(this.eFloatingFilterText.getGui());
    };
    GroupFloatingFilterComp.prototype.setupUnderlyingFloatingFilterElement = function () {
        var _this = this;
        this.showingUnderlyingFloatingFilter = false;
        this.underlyingFloatingFilter = undefined;
        _.clearElement(this.eFloatingFilter);
        var column = this.parentFilterInstance.getSelectedColumn();
        // we can only show the underlying filter if there is one instance (e.g. the underlying column is not visible)
        if (column && !column.isVisible()) {
            var compDetails = this.filterManager.getFloatingFilterCompDetails(column, this.params.showParentFilter);
            if (compDetails) {
                this.compDetails = compDetails;
                if (!this.haveAddedColumnListeners) {
                    this.haveAddedColumnListeners = true;
                    this.addManagedListener(
                        column,
                        Column.EVENT_VISIBLE_CHANGED,
                        this.onColumnVisibleChanged.bind(this),
                    );
                    this.addManagedListener(column, Column.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
                }
                return compDetails.newAgStackInstance().then(function (floatingFilter) {
                    var _a, _b;
                    _this.underlyingFloatingFilter = floatingFilter;
                    (_a = _this.underlyingFloatingFilter) === null || _a === void 0
                        ? void 0
                        : _a.onParentModelChanged(
                              (_b = _this.parentFilterInstance.getSelectedFilter()) === null || _b === void 0
                                  ? void 0
                                  : _b.getModel(),
                          );
                    _this.appendChild(floatingFilter.getGui());
                    _this.showingUnderlyingFloatingFilter = true;
                });
            }
        }
        // fallback to the read-only version
        this.setupReadOnlyFloatingFilterElement();
        return AgPromise.resolve();
    };
    GroupFloatingFilterComp.prototype.onColumnVisibleChanged = function () {
        this.setupUnderlyingFloatingFilterElement();
    };
    GroupFloatingFilterComp.prototype.onColDefChanged = function (event) {
        var _a, _b;
        if (!event.column) {
            return;
        }
        var compDetails = this.filterManager.getFloatingFilterCompDetails(event.column, this.params.showParentFilter);
        if (compDetails) {
            (_b = (_a = this.underlyingFloatingFilter) === null || _a === void 0 ? void 0 : _a.onParamsUpdated) ===
                null || _b === void 0
                ? void 0
                : _b.call(_a, compDetails.params);
        }
    };
    GroupFloatingFilterComp.prototype.onParentModelChanged = function (_model, event) {
        var _a, _b;
        if (this.showingUnderlyingFloatingFilter) {
            (_a = this.underlyingFloatingFilter) === null || _a === void 0
                ? void 0
                : _a.onParentModelChanged(
                      (_b = this.parentFilterInstance.getSelectedFilter()) === null || _b === void 0
                          ? void 0
                          : _b.getModel(),
                      event,
                  );
        } else {
            this.updateDisplayedValue();
        }
    };
    GroupFloatingFilterComp.prototype.updateDisplayedValue = function () {
        if (!this.parentFilterInstance || !this.eFloatingFilterText) {
            return;
        }
        var selectedFilter = this.parentFilterInstance.getSelectedFilter();
        if (!selectedFilter) {
            this.eFloatingFilterText.setValue('');
            this.eFloatingFilterText.setDisplayed(false);
            return;
        }
        this.eFloatingFilterText.setDisplayed(true);
        if (selectedFilter.getModelAsString) {
            var filterModel = selectedFilter.getModel();
            this.eFloatingFilterText.setValue(filterModel == null ? '' : selectedFilter.getModelAsString(filterModel));
        } else {
            this.eFloatingFilterText.setValue('');
        }
    };
    GroupFloatingFilterComp.prototype.onSelectedColumnChanged = function () {
        if (!this.showingUnderlyingFloatingFilter) {
            this.updateDisplayedValue();
        }
    };
    GroupFloatingFilterComp.prototype.onColumnRowGroupChanged = function () {
        if (!this.showingUnderlyingFloatingFilter) {
            this.updateDisplayedValue();
        }
    };
    GroupFloatingFilterComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    __decorate$2e([Autowired('columnModel')], GroupFloatingFilterComp.prototype, 'columnModel', void 0);
    __decorate$2e([Autowired('filterManager')], GroupFloatingFilterComp.prototype, 'filterManager', void 0);
    __decorate$2e([RefSelector('eFloatingFilter')], GroupFloatingFilterComp.prototype, 'eFloatingFilter', void 0);
    return GroupFloatingFilterComp;
})(Component);

var RowGroupingModule = {
    version: VERSION$g,
    moduleName: ModuleNames.RowGroupingModule,
    beans: [AggregationStage, FilterAggregatesStage, GroupStage, PivotColDefService, PivotStage, AggFuncService],
    agStackComponents: [{ componentName: 'AgGridHeaderDropZones', componentClass: GridHeaderDropZones }],
    userComponents: [
        { componentName: 'agGroupColumnFilter', componentClass: GroupFilter },
        { componentName: 'agGroupColumnFloatingFilter', componentClass: GroupFloatingFilterComp },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$33 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2d =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ValuesDropZonePanel = /** @class */ (function (_super) {
    __extends$33(ValuesDropZonePanel, _super);
    function ValuesDropZonePanel(horizontal) {
        return _super.call(this, horizontal, 'aggregation') || this;
    }
    ValuesDropZonePanel.prototype.passBeansUp = function () {
        _super.prototype.setBeans.call(this, {
            gridOptionsService: this.gridOptionsService,
            eventService: this.eventService,
            context: this.getContext(),
            loggerFactory: this.loggerFactory,
            dragAndDropService: this.dragAndDropService,
        });
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var emptyMessage = localeTextFunc('valueColumnsEmptyMessage', 'Drag here to aggregate');
        var title = localeTextFunc('values', 'Values');
        _super.prototype.init.call(this, {
            dragAndDropIcon: DragAndDropService.ICON_AGGREGATE,
            icon: _.createIconNoSpan('valuePanel', this.gridOptionsService, null),
            emptyMessage: emptyMessage,
            title: title,
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.refreshGui.bind(this));
    };
    ValuesDropZonePanel.prototype.getAriaLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var label = translate('ariaValuesDropZonePanelLabel', 'Values');
        return label;
    };
    ValuesDropZonePanel.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'valueColumnsList';
        return res;
    };
    ValuesDropZonePanel.prototype.getIconName = function () {
        return this.isPotentialDndColumns() ? DragAndDropService.ICON_AGGREGATE : DragAndDropService.ICON_NOT_ALLOWED;
    };
    ValuesDropZonePanel.prototype.isColumnDroppable = function (column) {
        // we never allow grouping of secondary columns
        if (this.gridOptionsService.is('functionsReadOnly') || !column.isPrimary()) {
            return false;
        }
        return column.isAllowValue() && !column.isValueActive();
    };
    ValuesDropZonePanel.prototype.updateColumns = function (columns) {
        if (this.gridOptionsService.is('functionsPassive')) {
            var event_1 = {
                type: Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                columns: columns,
            };
            this.eventService.dispatchEvent(event_1);
        } else {
            this.columnModel.setValueColumns(columns, 'toolPanelUi');
        }
    };
    ValuesDropZonePanel.prototype.getExistingColumns = function () {
        return this.columnModel.getValueColumns();
    };
    __decorate$2d([Autowired('columnModel')], ValuesDropZonePanel.prototype, 'columnModel', void 0);
    __decorate$2d([Autowired('loggerFactory')], ValuesDropZonePanel.prototype, 'loggerFactory', void 0);
    __decorate$2d([Autowired('dragAndDropService')], ValuesDropZonePanel.prototype, 'dragAndDropService', void 0);
    __decorate$2d([PostConstruct], ValuesDropZonePanel.prototype, 'passBeansUp', null);
    return ValuesDropZonePanel;
})(BaseDropZonePanel);

var __extends$32 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2c =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PrimaryColsPanel = /** @class */ (function (_super) {
    __extends$32(PrimaryColsPanel, _super);
    function PrimaryColsPanel() {
        return _super.call(this, PrimaryColsPanel.TEMPLATE) || this;
    }
    // we allow dragging in the toolPanel, but not when this component appears in the column menu
    PrimaryColsPanel.prototype.init = function (allowDragging, params, eventType) {
        this.allowDragging = allowDragging;
        this.params = params;
        this.eventType = eventType;
        this.primaryColsHeaderPanel.init(this.params);
        var hideFilter = this.params.suppressColumnFilter;
        var hideSelect = this.params.suppressColumnSelectAll;
        var hideExpand = this.params.suppressColumnExpandAll;
        if (hideExpand && hideFilter && hideSelect) {
            this.primaryColsHeaderPanel.setDisplayed(false);
        }
        this.addManagedListener(this.primaryColsListPanel, 'groupExpanded', this.onGroupExpanded.bind(this));
        this.addManagedListener(this.primaryColsListPanel, 'selectionChanged', this.onSelectionChange.bind(this));
        this.primaryColsListPanel.init(this.params, this.allowDragging, this.eventType);
        this.addManagedListener(this.primaryColsHeaderPanel, 'expandAll', this.onExpandAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, 'collapseAll', this.onCollapseAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, 'selectAll', this.onSelectAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, 'unselectAll', this.onUnselectAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, 'filterChanged', this.onFilterChanged.bind(this));
        this.positionableFeature = new PositionableFeature(this.getGui(), { minHeight: 100 });
        this.createManagedBean(this.positionableFeature);
    };
    PrimaryColsPanel.prototype.toggleResizable = function (resizable) {
        this.positionableFeature.setResizable(resizable ? { bottom: true } : false);
    };
    PrimaryColsPanel.prototype.onExpandAll = function () {
        this.primaryColsListPanel.doSetExpandedAll(true);
    };
    PrimaryColsPanel.prototype.onCollapseAll = function () {
        this.primaryColsListPanel.doSetExpandedAll(false);
    };
    PrimaryColsPanel.prototype.expandGroups = function (groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(true, groupIds);
    };
    PrimaryColsPanel.prototype.collapseGroups = function (groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(false, groupIds);
    };
    PrimaryColsPanel.prototype.setColumnLayout = function (colDefs) {
        this.primaryColsListPanel.setColumnLayout(colDefs);
    };
    PrimaryColsPanel.prototype.onFilterChanged = function (event) {
        this.primaryColsListPanel.setFilterText(event.filterText);
    };
    PrimaryColsPanel.prototype.syncLayoutWithGrid = function () {
        this.primaryColsListPanel.onColumnsChanged();
    };
    PrimaryColsPanel.prototype.onSelectAll = function () {
        this.primaryColsListPanel.doSetSelectedAll(true);
    };
    PrimaryColsPanel.prototype.onUnselectAll = function () {
        this.primaryColsListPanel.doSetSelectedAll(false);
    };
    PrimaryColsPanel.prototype.onGroupExpanded = function (event) {
        this.primaryColsHeaderPanel.setExpandState(event.state);
    };
    PrimaryColsPanel.prototype.onSelectionChange = function (event) {
        this.primaryColsHeaderPanel.setSelectionState(event.state);
    };
    PrimaryColsPanel.TEMPLATE =
        '<div class="ag-column-select">\n            <ag-primary-cols-header ref="primaryColsHeaderPanel"></ag-primary-cols-header>\n            <ag-primary-cols-list ref="primaryColsListPanel"></ag-primary-cols-list>\n        </div>';
    __decorate$2c(
        [RefSelector('primaryColsHeaderPanel')],
        PrimaryColsPanel.prototype,
        'primaryColsHeaderPanel',
        void 0,
    );
    __decorate$2c([RefSelector('primaryColsListPanel')], PrimaryColsPanel.prototype, 'primaryColsListPanel', void 0);
    return PrimaryColsPanel;
})(Component);

var __extends$31 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$$ =
    (undefined && undefined.__assign) ||
    function () {
        __assign$$ =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$$.apply(this, arguments);
    };
var __decorate$2b =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ColumnToolPanel = /** @class */ (function (_super) {
    __extends$31(ColumnToolPanel, _super);
    function ColumnToolPanel() {
        var _this = _super.call(this, ColumnToolPanel.TEMPLATE) || this;
        _this.initialised = false;
        _this.childDestroyFuncs = [];
        return _this;
    }
    // lazy initialise the panel
    ColumnToolPanel.prototype.setVisible = function (visible) {
        _super.prototype.setDisplayed.call(this, visible);
        if (visible && !this.initialised) {
            this.init(this.params);
        }
    };
    ColumnToolPanel.prototype.init = function (params) {
        var _this = this;
        var defaultParams = {
            suppressColumnMove: false,
            suppressColumnSelectAll: false,
            suppressColumnFilter: false,
            suppressColumnExpandAll: false,
            contractColumnSelection: false,
            suppressPivotMode: false,
            suppressRowGroups: false,
            suppressValues: false,
            suppressPivots: false,
            suppressSyncLayoutWithGrid: false,
            api: this.gridApi,
            columnApi: this.columnApi,
        };
        this.params = __assign$$(__assign$$(__assign$$({}, defaultParams), params), {
            context: this.gridOptionsService.context,
        });
        if (this.isRowGroupingModuleLoaded() && !this.params.suppressPivotMode) {
            // DO NOT CHANGE TO createManagedBean
            this.pivotModePanel = this.createBean(new PivotModePanel());
            this.childDestroyFuncs.push(function () {
                return _this.destroyBean(_this.pivotModePanel);
            });
            this.appendChild(this.pivotModePanel);
        }
        // DO NOT CHANGE TO createManagedBean
        this.primaryColsPanel = this.createBean(new PrimaryColsPanel());
        this.childDestroyFuncs.push(function () {
            return _this.destroyBean(_this.primaryColsPanel);
        });
        this.primaryColsPanel.init(true, this.params, 'toolPanelUi');
        this.primaryColsPanel.addCssClass('ag-column-panel-column-select');
        this.appendChild(this.primaryColsPanel);
        if (this.isRowGroupingModuleLoaded()) {
            if (!this.params.suppressRowGroups) {
                // DO NOT CHANGE TO createManagedBean
                this.rowGroupDropZonePanel = this.createBean(new RowGroupDropZonePanel(false));
                this.childDestroyFuncs.push(function () {
                    return _this.destroyBean(_this.rowGroupDropZonePanel);
                });
                this.appendChild(this.rowGroupDropZonePanel);
            }
            if (!this.params.suppressValues) {
                // DO NOT CHANGE TO createManagedBean
                this.valuesDropZonePanel = this.createBean(new ValuesDropZonePanel(false));
                this.childDestroyFuncs.push(function () {
                    return _this.destroyBean(_this.valuesDropZonePanel);
                });
                this.appendChild(this.valuesDropZonePanel);
            }
            if (!this.params.suppressPivots) {
                // DO NOT CHANGE TO createManagedBean
                this.pivotDropZonePanel = this.createBean(new PivotDropZonePanel(false));
                this.childDestroyFuncs.push(function () {
                    return _this.destroyBean(_this.pivotDropZonePanel);
                });
                this.appendChild(this.pivotDropZonePanel);
            }
            this.setLastVisible();
            var pivotModeListener_1 = this.addManagedListener(
                this.eventService,
                Events.EVENT_COLUMN_PIVOT_MODE_CHANGED,
                function () {
                    _this.resetChildrenHeight();
                    _this.setLastVisible();
                },
            );
            this.childDestroyFuncs.push(function () {
                return pivotModeListener_1();
            });
        }
        this.initialised = true;
    };
    ColumnToolPanel.prototype.setPivotModeSectionVisible = function (visible) {
        var _this = this;
        if (!this.isRowGroupingModuleLoaded()) {
            return;
        }
        if (this.pivotModePanel) {
            this.pivotModePanel.setDisplayed(visible);
        } else if (visible) {
            this.pivotModePanel = this.createBean(new PivotModePanel());
            // ensure pivot mode panel is positioned at the top of the columns tool panel
            this.getGui().insertBefore(this.pivotModePanel.getGui(), this.getGui().firstChild);
            this.childDestroyFuncs.push(function () {
                return _this.destroyBean(_this.pivotModePanel);
            });
        }
        this.setLastVisible();
    };
    ColumnToolPanel.prototype.setRowGroupsSectionVisible = function (visible) {
        if (!this.isRowGroupingModuleLoaded()) {
            return;
        }
        if (this.rowGroupDropZonePanel) {
            this.rowGroupDropZonePanel.setDisplayed(visible);
        } else if (visible) {
            this.rowGroupDropZonePanel = this.createManagedBean(new RowGroupDropZonePanel(false));
            this.appendChild(this.rowGroupDropZonePanel);
        }
        this.setLastVisible();
    };
    ColumnToolPanel.prototype.setValuesSectionVisible = function (visible) {
        if (!this.isRowGroupingModuleLoaded()) {
            return;
        }
        if (this.valuesDropZonePanel) {
            this.valuesDropZonePanel.setDisplayed(visible);
        } else if (visible) {
            this.valuesDropZonePanel = this.createManagedBean(new ValuesDropZonePanel(false));
            this.appendChild(this.valuesDropZonePanel);
        }
        this.setLastVisible();
    };
    ColumnToolPanel.prototype.setPivotSectionVisible = function (visible) {
        if (!this.isRowGroupingModuleLoaded()) {
            return;
        }
        if (this.pivotDropZonePanel) {
            this.pivotDropZonePanel.setDisplayed(visible);
        } else if (visible) {
            this.pivotDropZonePanel = this.createManagedBean(new PivotDropZonePanel(false));
            this.appendChild(this.pivotDropZonePanel);
            this.pivotDropZonePanel.setDisplayed(visible);
        }
        this.setLastVisible();
    };
    ColumnToolPanel.prototype.setResizers = function () {
        [this.primaryColsPanel, this.rowGroupDropZonePanel, this.valuesDropZonePanel, this.pivotDropZonePanel].forEach(
            function (panel) {
                if (!panel) {
                    return;
                }
                var eGui = panel.getGui();
                panel.toggleResizable(
                    !eGui.classList.contains('ag-last-column-drop') && !eGui.classList.contains('ag-hidden'),
                );
            },
        );
    };
    ColumnToolPanel.prototype.setLastVisible = function () {
        var eGui = this.getGui();
        var columnDrops = Array.prototype.slice.call(eGui.querySelectorAll('.ag-column-drop'));
        columnDrops.forEach(function (columnDrop) {
            return columnDrop.classList.remove('ag-last-column-drop');
        });
        var columnDropEls = eGui.querySelectorAll('.ag-column-drop:not(.ag-hidden)');
        var lastVisible = _.last(columnDropEls);
        if (lastVisible) {
            lastVisible.classList.add('ag-last-column-drop');
        }
        this.setResizers();
    };
    ColumnToolPanel.prototype.resetChildrenHeight = function () {
        var eGui = this.getGui();
        var children = eGui.children;
        for (var i = 0; i < children.length; i++) {
            var child = children[i];
            child.style.removeProperty('height');
            child.style.removeProperty('flex');
        }
    };
    ColumnToolPanel.prototype.isRowGroupingModuleLoaded = function () {
        return ModuleRegistry.__assertRegistered(
            ModuleNames.RowGroupingModule,
            'Row Grouping',
            this.context.getGridId(),
        );
    };
    ColumnToolPanel.prototype.expandColumnGroups = function (groupIds) {
        this.primaryColsPanel.expandGroups(groupIds);
    };
    ColumnToolPanel.prototype.collapseColumnGroups = function (groupIds) {
        this.primaryColsPanel.collapseGroups(groupIds);
    };
    ColumnToolPanel.prototype.setColumnLayout = function (colDefs) {
        this.primaryColsPanel.setColumnLayout(colDefs);
    };
    ColumnToolPanel.prototype.syncLayoutWithGrid = function () {
        this.primaryColsPanel.syncLayoutWithGrid();
    };
    ColumnToolPanel.prototype.destroyChildren = function () {
        this.childDestroyFuncs.forEach(function (func) {
            return func();
        });
        this.childDestroyFuncs.length = 0;
        _.clearElement(this.getGui());
    };
    ColumnToolPanel.prototype.refresh = function () {
        this.destroyChildren();
        this.init(this.params);
    };
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so this must be public.
    ColumnToolPanel.prototype.destroy = function () {
        this.destroyChildren();
        _super.prototype.destroy.call(this);
    };
    ColumnToolPanel.TEMPLATE = '<div class="ag-column-panel"></div>';
    __decorate$2b([Autowired('gridApi')], ColumnToolPanel.prototype, 'gridApi', void 0);
    __decorate$2b([Autowired('columnApi')], ColumnToolPanel.prototype, 'columnApi', void 0);
    return ColumnToolPanel;
})(Component);

var __extends$30 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2a =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var HorizontalResizeComp = /** @class */ (function (_super) {
    __extends$30(HorizontalResizeComp, _super);
    function HorizontalResizeComp() {
        var _this = _super.call(this, /* html */ '<div class="ag-tool-panel-horizontal-resize"></div>') || this;
        _this.minWidth = 100;
        _this.maxWidth = null;
        return _this;
    }
    HorizontalResizeComp.prototype.setElementToResize = function (elementToResize) {
        this.elementToResize = elementToResize;
    };
    HorizontalResizeComp.prototype.postConstruct = function () {
        var finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
            eResizeBar: this.getGui(),
            dragStartPixels: 1,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this),
            onResizeEnd: this.onResizeEnd.bind(this),
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        this.setInverted(this.gridOptionsService.is('enableRtl'));
    };
    HorizontalResizeComp.prototype.dispatchResizeEvent = function (start, end, width) {
        var event = {
            type: Events.EVENT_TOOL_PANEL_SIZE_CHANGED,
            width: width,
            started: start,
            ended: end,
        };
        this.eventService.dispatchEvent(event);
    };
    HorizontalResizeComp.prototype.onResizeStart = function () {
        this.startingWidth = this.elementToResize.offsetWidth;
        this.dispatchResizeEvent(true, false, this.startingWidth);
    };
    HorizontalResizeComp.prototype.onResizeEnd = function (delta) {
        return this.onResizing(delta, true);
    };
    HorizontalResizeComp.prototype.onResizing = function (delta, isEnd) {
        if (isEnd === void 0) {
            isEnd = false;
        }
        var direction = this.inverted ? -1 : 1;
        var newWidth = Math.max(this.minWidth, Math.floor(this.startingWidth - delta * direction));
        if (this.maxWidth != null) {
            newWidth = Math.min(this.maxWidth, newWidth);
        }
        this.elementToResize.style.width = newWidth + 'px';
        this.dispatchResizeEvent(false, isEnd, newWidth);
    };
    HorizontalResizeComp.prototype.setInverted = function (inverted) {
        this.inverted = inverted;
    };
    HorizontalResizeComp.prototype.setMaxWidth = function (value) {
        this.maxWidth = value;
    };
    HorizontalResizeComp.prototype.setMinWidth = function (value) {
        if (value != null) {
            this.minWidth = value;
        } else {
            this.minWidth = 100;
        }
    };
    __decorate$2a(
        [Autowired('horizontalResizeService')],
        HorizontalResizeComp.prototype,
        'horizontalResizeService',
        void 0,
    );
    __decorate$2a([PostConstruct], HorizontalResizeComp.prototype, 'postConstruct', null);
    return HorizontalResizeComp;
})(Component);

var __extends$2$ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$29 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SideBarButtonComp = /** @class */ (function (_super) {
    __extends$2$(SideBarButtonComp, _super);
    function SideBarButtonComp(toolPanelDef) {
        var _this = _super.call(this) || this;
        _this.toolPanelDef = toolPanelDef;
        return _this;
    }
    SideBarButtonComp.prototype.getToolPanelId = function () {
        return this.toolPanelDef.id;
    };
    SideBarButtonComp.prototype.postConstruct = function () {
        var template = this.createTemplate();
        this.setTemplate(template);
        this.setLabel();
        this.setIcon();
        this.addManagedListener(this.eToggleButton, 'click', this.onButtonPressed.bind(this));
        this.eToggleButton.setAttribute('id', 'ag-' + this.getCompId() + '-button');
    };
    SideBarButtonComp.prototype.createTemplate = function () {
        var res =
            /* html */ '<div class="ag-side-button" role="presentation">\n                <button type="button" ref="eToggleButton" tabindex="-1" role="tab" aria-expanded="false" class="ag-button ag-side-button-button">\n                    <div ref="eIconWrapper" class="ag-side-button-icon-wrapper" aria-hidden="true"></div>\n                    <span ref ="eLabel" class="ag-side-button-label"></span>\n                </button>\n            </div>';
        return res;
    };
    SideBarButtonComp.prototype.setLabel = function () {
        var translate = this.localeService.getLocaleTextFunc();
        var def = this.toolPanelDef;
        var label = translate(def.labelKey, def.labelDefault);
        this.eLabel.innerText = label;
    };
    SideBarButtonComp.prototype.setIcon = function () {
        this.eIconWrapper.insertAdjacentElement(
            'afterbegin',
            _.createIconNoSpan(this.toolPanelDef.iconKey, this.gridOptionsService),
        );
    };
    SideBarButtonComp.prototype.onButtonPressed = function () {
        this.dispatchEvent({ type: SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED });
    };
    SideBarButtonComp.prototype.setSelected = function (selected) {
        this.addOrRemoveCssClass('ag-selected', selected);
        _.setAriaExpanded(this.eToggleButton, selected);
    };
    SideBarButtonComp.prototype.getButtonElement = function () {
        return this.eToggleButton;
    };
    SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED = 'toggleButtonClicked';
    __decorate$29([RefSelector('eToggleButton')], SideBarButtonComp.prototype, 'eToggleButton', void 0);
    __decorate$29([RefSelector('eIconWrapper')], SideBarButtonComp.prototype, 'eIconWrapper', void 0);
    __decorate$29([RefSelector('eLabel')], SideBarButtonComp.prototype, 'eLabel', void 0);
    __decorate$29([PostConstruct], SideBarButtonComp.prototype, 'postConstruct', null);
    return SideBarButtonComp;
})(Component);

var __extends$2_ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$28 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SideBarButtonsComp = /** @class */ (function (_super) {
    __extends$2_(SideBarButtonsComp, _super);
    function SideBarButtonsComp() {
        var _this = _super.call(this, SideBarButtonsComp.TEMPLATE) || this;
        _this.buttonComps = [];
        return _this;
    }
    SideBarButtonsComp.prototype.postConstruct = function () {
        this.addManagedListener(this.getFocusableElement(), 'keydown', this.handleKeyDown.bind(this));
    };
    SideBarButtonsComp.prototype.handleKeyDown = function (e) {
        if (e.key !== KeyCode.TAB || !e.shiftKey) {
            return;
        }
        var lastColumn = _.last(this.columnModel.getAllDisplayedColumns());
        if (this.focusService.focusGridView(lastColumn, true)) {
            e.preventDefault();
        }
    };
    SideBarButtonsComp.prototype.setActiveButton = function (id) {
        this.buttonComps.forEach(function (comp) {
            comp.setSelected(id === comp.getToolPanelId());
        });
    };
    SideBarButtonsComp.prototype.addButtonComp = function (def) {
        var _this = this;
        var buttonComp = this.createBean(new SideBarButtonComp(def));
        this.buttonComps.push(buttonComp);
        this.appendChild(buttonComp);
        buttonComp.addEventListener(SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED, function () {
            _this.dispatchEvent({
                type: SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED,
                toolPanelId: def.id,
            });
        });
        return buttonComp;
    };
    SideBarButtonsComp.prototype.clearButtons = function () {
        this.buttonComps = this.destroyBeans(this.buttonComps);
        _.clearElement(this.getGui());
    };
    SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED = 'sideBarButtonClicked';
    SideBarButtonsComp.TEMPLATE = '<div class="ag-side-buttons" role="tablist"></div>';
    __decorate$28([Autowired('focusService')], SideBarButtonsComp.prototype, 'focusService', void 0);
    __decorate$28([Autowired('columnModel')], SideBarButtonsComp.prototype, 'columnModel', void 0);
    __decorate$28([PostConstruct], SideBarButtonsComp.prototype, 'postConstruct', null);
    __decorate$28([PreDestroy], SideBarButtonsComp.prototype, 'clearButtons', null);
    return SideBarButtonsComp;
})(Component);

var SideBarDefParser = /** @class */ (function () {
    function SideBarDefParser() {}
    SideBarDefParser.parse = function (toParse) {
        if (!toParse) {
            return undefined;
        }
        if (toParse === true) {
            return {
                toolPanels: [SideBarDefParser.DEFAULT_COLUMN_COMP, SideBarDefParser.DEFAULT_FILTER_COMP],
                defaultToolPanel: 'columns',
            };
        }
        if (typeof toParse === 'string') {
            return SideBarDefParser.parse([toParse]);
        }
        if (Array.isArray(toParse)) {
            var comps_1 = [];
            toParse.forEach(function (key) {
                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[key];
                if (!lookupResult) {
                    console.warn(
                        'AG Grid: the key ' +
                            key +
                            ' is not a valid key for specifying a tool panel, valid keys are: ' +
                            Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','),
                    );
                    return;
                }
                comps_1.push(lookupResult);
            });
            if (comps_1.length === 0) {
                return undefined;
            }
            return {
                toolPanels: comps_1,
                defaultToolPanel: comps_1[0].id,
            };
        }
        var result = {
            toolPanels: SideBarDefParser.parseComponents(toParse.toolPanels),
            defaultToolPanel: toParse.defaultToolPanel,
            hiddenByDefault: toParse.hiddenByDefault,
            position: toParse.position,
        };
        return result;
    };
    SideBarDefParser.parseComponents = function (from) {
        var result = [];
        if (!from) {
            return result;
        }
        from.forEach(function (it) {
            var toAdd = null;
            if (typeof it === 'string') {
                var lookupResult = SideBarDefParser.DEFAULT_BY_KEY[it];
                if (!lookupResult) {
                    console.warn(
                        'AG Grid: the key ' +
                            it +
                            ' is not a valid key for specifying a tool panel, valid keys are: ' +
                            Object.keys(SideBarDefParser.DEFAULT_BY_KEY).join(','),
                    );
                    return;
                }
                toAdd = lookupResult;
            } else {
                toAdd = it;
            }
            result.push(toAdd);
        });
        return result;
    };
    SideBarDefParser.DEFAULT_COLUMN_COMP = {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
    };
    SideBarDefParser.DEFAULT_FILTER_COMP = {
        id: 'filters',
        labelDefault: 'Filters',
        labelKey: 'filters',
        iconKey: 'filter',
        toolPanel: 'agFiltersToolPanel',
    };
    SideBarDefParser.DEFAULT_BY_KEY = {
        columns: SideBarDefParser.DEFAULT_COLUMN_COMP,
        filters: SideBarDefParser.DEFAULT_FILTER_COMP,
    };
    return SideBarDefParser;
})();

var __extends$2Z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$27 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelWrapper = /** @class */ (function (_super) {
    __extends$2Z(ToolPanelWrapper, _super);
    function ToolPanelWrapper() {
        return _super.call(this, ToolPanelWrapper.TEMPLATE) || this;
    }
    ToolPanelWrapper.prototype.setupResize = function () {
        var eGui = this.getGui();
        var resizeBar = (this.resizeBar = this.createManagedBean(new HorizontalResizeComp()));
        eGui.setAttribute('id', 'ag-' + this.getCompId());
        resizeBar.setElementToResize(eGui);
        this.appendChild(resizeBar);
    };
    ToolPanelWrapper.prototype.getToolPanelId = function () {
        return this.toolPanelId;
    };
    ToolPanelWrapper.prototype.setToolPanelDef = function (toolPanelDef) {
        var id = toolPanelDef.id,
            minWidth = toolPanelDef.minWidth,
            maxWidth = toolPanelDef.maxWidth,
            width = toolPanelDef.width;
        this.toolPanelId = id;
        this.width = width;
        var params = {};
        var compDetails = this.userComponentFactory.getToolPanelCompDetails(toolPanelDef, params);
        var componentPromise = compDetails.newAgStackInstance();
        if (componentPromise == null) {
            console.warn('AG Grid: error processing tool panel component ' + id + ". You need to specify 'toolPanel'");
            return;
        }
        componentPromise.then(this.setToolPanelComponent.bind(this));
        if (minWidth != null) {
            this.resizeBar.setMinWidth(minWidth);
        }
        if (maxWidth != null) {
            this.resizeBar.setMaxWidth(maxWidth);
        }
    };
    ToolPanelWrapper.prototype.setToolPanelComponent = function (compInstance) {
        var _this = this;
        this.toolPanelCompInstance = compInstance;
        this.appendChild(compInstance.getGui());
        this.addDestroyFunc(function () {
            _this.destroyBean(compInstance);
        });
        if (this.width) {
            this.getGui().style.width = this.width + 'px';
        }
    };
    ToolPanelWrapper.prototype.getToolPanelInstance = function () {
        return this.toolPanelCompInstance;
    };
    ToolPanelWrapper.prototype.setResizerSizerSide = function (side) {
        var isRtl = this.gridOptionsService.is('enableRtl');
        var isLeft = side === 'left';
        var inverted = isRtl ? isLeft : !isLeft;
        this.resizeBar.setInverted(inverted);
    };
    ToolPanelWrapper.prototype.refresh = function () {
        this.toolPanelCompInstance.refresh();
    };
    ToolPanelWrapper.TEMPLATE = '<div class="ag-tool-panel-wrapper" role="tabpanel"/>';
    __decorate$27([Autowired('userComponentFactory')], ToolPanelWrapper.prototype, 'userComponentFactory', void 0);
    __decorate$27([PostConstruct], ToolPanelWrapper.prototype, 'setupResize', null);
    return ToolPanelWrapper;
})(Component);

var __extends$2Y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$26 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$O =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var SideBarComp = /** @class */ (function (_super) {
    __extends$2Y(SideBarComp, _super);
    function SideBarComp() {
        var _this = _super.call(this, SideBarComp.TEMPLATE) || this;
        _this.toolPanelWrappers = [];
        return _this;
    }
    SideBarComp.prototype.postConstruct = function () {
        var _this = this;
        this.sideBarButtonsComp.addEventListener(
            SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED,
            this.onToolPanelButtonClicked.bind(this),
        );
        this.setSideBarDef();
        this.addManagedPropertyListener('sideBar', function () {
            _this.clearDownUi();
            _this.setSideBarDef();
        });
        this.gridApi.registerSideBarComp(this);
        this.createManagedBean(
            new ManagedFocusFeature(this.getFocusableElement(), {
                onTabKeyDown: this.onTabKeyDown.bind(this),
                handleKeyDown: this.handleKeyDown.bind(this),
            }),
        );
    };
    SideBarComp.prototype.onTabKeyDown = function (e) {
        if (e.defaultPrevented) {
            return;
        }
        var _a = this,
            focusService = _a.focusService,
            sideBarButtonsComp = _a.sideBarButtonsComp;
        var eGui = this.getGui();
        var sideBarGui = sideBarButtonsComp.getGui();
        var eDocument = this.gridOptionsService.getDocument();
        var activeElement = eDocument.activeElement;
        var openPanel = eGui.querySelector('.ag-tool-panel-wrapper:not(.ag-hidden)');
        var target = e.target;
        if (!openPanel) {
            return;
        }
        if (sideBarGui.contains(activeElement)) {
            if (focusService.focusInto(openPanel, e.shiftKey)) {
                e.preventDefault();
            }
            return;
        }
        // only handle backwards focus to target the sideBar buttons
        if (!e.shiftKey) {
            return;
        }
        var nextEl = null;
        if (openPanel.contains(activeElement)) {
            nextEl = this.focusService.findNextFocusableElement(openPanel, undefined, true);
        } else if (focusService.isTargetUnderManagedComponent(openPanel, target) && e.shiftKey) {
            nextEl = this.focusService.findFocusableElementBeforeTabGuard(openPanel, target);
        }
        if (!nextEl) {
            nextEl = sideBarGui.querySelector('.ag-selected button');
        }
        if (nextEl) {
            e.preventDefault();
            nextEl.focus();
        }
    };
    SideBarComp.prototype.handleKeyDown = function (e) {
        var eDocument = this.gridOptionsService.getDocument();
        if (!this.sideBarButtonsComp.getGui().contains(eDocument.activeElement)) {
            return;
        }
        var sideBarGui = this.sideBarButtonsComp.getGui();
        var buttons = Array.prototype.slice.call(sideBarGui.querySelectorAll('.ag-side-button'));
        var currentButton = eDocument.activeElement;
        var currentPos = buttons.findIndex(function (button) {
            return button.contains(currentButton);
        });
        var nextPos = null;
        switch (e.key) {
            case KeyCode.LEFT:
            case KeyCode.UP:
                nextPos = Math.max(0, currentPos - 1);
                break;
            case KeyCode.RIGHT:
            case KeyCode.DOWN:
                nextPos = Math.min(currentPos + 1, buttons.length - 1);
                break;
        }
        if (nextPos === null) {
            return;
        }
        var innerButton = buttons[nextPos].querySelector('button');
        if (innerButton) {
            innerButton.focus();
            e.preventDefault();
        }
    };
    SideBarComp.prototype.onToolPanelButtonClicked = function (event) {
        var id = event.toolPanelId;
        var openedItem = this.openedItem();
        // if item was already open, we close it
        if (openedItem === id) {
            this.openToolPanel(undefined, 'sideBarButtonClicked'); // passing undefined closes
        } else {
            this.openToolPanel(id, 'sideBarButtonClicked');
        }
    };
    SideBarComp.prototype.clearDownUi = function () {
        this.sideBarButtonsComp.clearButtons();
        this.destroyToolPanelWrappers();
    };
    SideBarComp.prototype.setSideBarDef = function () {
        // initially hide side bar
        this.setDisplayed(false);
        var sideBarRaw = this.gridOptionsService.get('sideBar');
        this.sideBar = SideBarDefParser.parse(sideBarRaw);
        if (!!this.sideBar && !!this.sideBar.toolPanels) {
            var toolPanelDefs = this.sideBar.toolPanels;
            this.createToolPanelsAndSideButtons(toolPanelDefs);
            if (!this.toolPanelWrappers.length) {
                return;
            }
            var shouldDisplaySideBar = !this.sideBar.hiddenByDefault;
            this.setDisplayed(shouldDisplaySideBar);
            this.setSideBarPosition(this.sideBar.position);
            if (!this.sideBar.hiddenByDefault) {
                this.openToolPanel(this.sideBar.defaultToolPanel, 'sideBarInitializing');
            }
        }
    };
    SideBarComp.prototype.getDef = function () {
        return this.sideBar;
    };
    SideBarComp.prototype.setSideBarPosition = function (position) {
        if (!position) {
            position = 'right';
        }
        var isLeft = position === 'left';
        var resizerSide = isLeft ? 'right' : 'left';
        this.addOrRemoveCssClass('ag-side-bar-left', isLeft);
        this.addOrRemoveCssClass('ag-side-bar-right', !isLeft);
        this.toolPanelWrappers.forEach(function (wrapper) {
            wrapper.setResizerSizerSide(resizerSide);
        });
        return this;
    };
    SideBarComp.prototype.createToolPanelsAndSideButtons = function (defs) {
        var e_1, _a;
        try {
            for (var defs_1 = __values$O(defs), defs_1_1 = defs_1.next(); !defs_1_1.done; defs_1_1 = defs_1.next()) {
                var def = defs_1_1.value;
                this.createToolPanelAndSideButton(def);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (defs_1_1 && !defs_1_1.done && (_a = defs_1.return)) _a.call(defs_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    SideBarComp.prototype.validateDef = function (def) {
        if (def.id == null) {
            console.warn(
                "AG Grid: please review all your toolPanel components, it seems like at least one of them doesn't have an id",
            );
            return false;
        }
        // helpers, in case user doesn't have the right module loaded
        if (def.toolPanel === 'agColumnsToolPanel') {
            var moduleMissing = !ModuleRegistry.__assertRegistered(
                ModuleNames.ColumnsToolPanelModule,
                'Column Tool Panel',
                this.context.getGridId(),
            );
            if (moduleMissing) {
                return false;
            }
        }
        if (def.toolPanel === 'agFiltersToolPanel') {
            var moduleMissing = !ModuleRegistry.__assertRegistered(
                ModuleNames.FiltersToolPanelModule,
                'Filters Tool Panel',
                this.context.getGridId(),
            );
            if (moduleMissing) {
                return false;
            }
            if (this.filterManager.isAdvancedFilterEnabled()) {
                _.doOnce(function () {
                    console.warn(
                        'AG Grid: Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.',
                    );
                }, 'advancedFilterToolPanel');
                return false;
            }
        }
        return true;
    };
    SideBarComp.prototype.createToolPanelAndSideButton = function (def) {
        if (!this.validateDef(def)) {
            return;
        }
        var button = this.sideBarButtonsComp.addButtonComp(def);
        var wrapper = this.getContext().createBean(new ToolPanelWrapper());
        wrapper.setToolPanelDef(def);
        wrapper.setDisplayed(false);
        var wrapperGui = wrapper.getGui();
        this.appendChild(wrapperGui);
        this.toolPanelWrappers.push(wrapper);
        _.setAriaControls(button.getButtonElement(), wrapperGui);
    };
    SideBarComp.prototype.refresh = function () {
        this.toolPanelWrappers.forEach(function (wrapper) {
            return wrapper.refresh();
        });
    };
    SideBarComp.prototype.openToolPanel = function (key, source) {
        if (source === void 0) {
            source = 'api';
        }
        var currentlyOpenedKey = this.openedItem();
        if (currentlyOpenedKey === key) {
            return;
        }
        this.toolPanelWrappers.forEach(function (wrapper) {
            var show = key === wrapper.getToolPanelId();
            wrapper.setDisplayed(show);
        });
        var newlyOpenedKey = this.openedItem();
        var openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
        if (openToolPanelChanged) {
            this.sideBarButtonsComp.setActiveButton(key);
            this.raiseToolPanelVisibleEvent(
                key,
                currentlyOpenedKey !== null && currentlyOpenedKey !== void 0 ? currentlyOpenedKey : undefined,
                source,
            );
        }
    };
    SideBarComp.prototype.getToolPanelInstance = function (key) {
        var toolPanelWrapper = this.toolPanelWrappers.filter(function (toolPanel) {
            return toolPanel.getToolPanelId() === key;
        })[0];
        if (!toolPanelWrapper) {
            console.warn('AG Grid: unable to lookup Tool Panel as invalid key supplied: ' + key);
            return;
        }
        return toolPanelWrapper.getToolPanelInstance();
    };
    SideBarComp.prototype.raiseToolPanelVisibleEvent = function (key, previousKey, source) {
        var switchingToolPanel = !!key && !!previousKey;
        if (previousKey) {
            var event_1 = {
                type: Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED,
                source: source,
                key: previousKey,
                visible: false,
                switchingToolPanel: switchingToolPanel,
            };
            this.eventService.dispatchEvent(event_1);
        }
        if (key) {
            var event_2 = {
                type: Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED,
                source: source,
                key: key,
                visible: true,
                switchingToolPanel: switchingToolPanel,
            };
            this.eventService.dispatchEvent(event_2);
        }
    };
    SideBarComp.prototype.close = function (source) {
        if (source === void 0) {
            source = 'api';
        }
        this.openToolPanel(undefined, source);
    };
    SideBarComp.prototype.isToolPanelShowing = function () {
        return !!this.openedItem();
    };
    SideBarComp.prototype.openedItem = function () {
        var activeToolPanel = null;
        this.toolPanelWrappers.forEach(function (wrapper) {
            if (wrapper.isDisplayed()) {
                activeToolPanel = wrapper.getToolPanelId();
            }
        });
        return activeToolPanel;
    };
    SideBarComp.prototype.destroyToolPanelWrappers = function () {
        var _this = this;
        this.toolPanelWrappers.forEach(function (wrapper) {
            _.removeFromParent(wrapper.getGui());
            _this.destroyBean(wrapper);
        });
        this.toolPanelWrappers.length = 0;
    };
    SideBarComp.prototype.destroy = function () {
        this.destroyToolPanelWrappers();
        _super.prototype.destroy.call(this);
    };
    SideBarComp.TEMPLATE =
        '<div class="ag-side-bar ag-unselectable">\n            <ag-side-bar-buttons ref="sideBarButtons"></ag-side-bar-buttons>\n        </div>';
    __decorate$26([Autowired('gridApi')], SideBarComp.prototype, 'gridApi', void 0);
    __decorate$26([Autowired('focusService')], SideBarComp.prototype, 'focusService', void 0);
    __decorate$26([Autowired('filterManager')], SideBarComp.prototype, 'filterManager', void 0);
    __decorate$26([RefSelector('sideBarButtons')], SideBarComp.prototype, 'sideBarButtonsComp', void 0);
    __decorate$26([PostConstruct], SideBarComp.prototype, 'postConstruct', null);
    return SideBarComp;
})(Component);

var __extends$2X =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$25 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelColDefService = /** @class */ (function (_super) {
    __extends$2X(ToolPanelColDefService, _super);
    function ToolPanelColDefService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.isColGroupDef = function (colDef) {
            return colDef && typeof colDef.children !== 'undefined';
        };
        _this.getId = function (colDef) {
            return _this.isColGroupDef(colDef) ? colDef.groupId : colDef.colId;
        };
        return _this;
    }
    ToolPanelColDefService.prototype.createColumnTree = function (colDefs) {
        var _this = this;
        var invalidColIds = [];
        var createDummyColGroup = function (abstractColDef, depth) {
            if (_this.isColGroupDef(abstractColDef)) {
                // creating 'dummy' group which is not associated with grid column group
                var groupDef = abstractColDef;
                var groupId = typeof groupDef.groupId !== 'undefined' ? groupDef.groupId : groupDef.headerName;
                var group = new ProvidedColumnGroup(groupDef, groupId, false, depth);
                var children_1 = [];
                groupDef.children.forEach(function (def) {
                    var child = createDummyColGroup(def, depth + 1);
                    // check column exists in case invalid colDef is supplied for primary column
                    if (child) {
                        children_1.push(child);
                    }
                });
                group.setChildren(children_1);
                return group;
            } else {
                var colDef = abstractColDef;
                var key = colDef.colId ? colDef.colId : colDef.field;
                var column = _this.columnModel.getPrimaryColumn(key);
                if (!column) {
                    invalidColIds.push(colDef);
                }
                return column;
            }
        };
        var mappedResults = [];
        colDefs.forEach(function (colDef) {
            var result = createDummyColGroup(colDef, 0);
            if (result) {
                // only return correctly mapped colDef results
                mappedResults.push(result);
            }
        });
        if (invalidColIds.length > 0) {
            console.warn('AG Grid: unable to find grid columns for the supplied colDef(s):', invalidColIds);
        }
        return mappedResults;
    };
    ToolPanelColDefService.prototype.syncLayoutWithGrid = function (syncLayoutCallback) {
        // extract ordered list of leaf path trees (column group hierarchy for each individual leaf column)
        var leafPathTrees = this.getLeafPathTrees();
        // merge leaf path tree taking split column groups into account
        var mergedColumnTrees = this.mergeLeafPathTrees(leafPathTrees);
        // sync layout with merged column trees
        syncLayoutCallback(mergedColumnTrees);
    };
    ToolPanelColDefService.prototype.getLeafPathTrees = function () {
        // leaf tree paths are obtained by walking up the tree starting at a column until we reach the top level group.
        var getLeafPathTree = function (node, childDef) {
            var leafPathTree;
            // build up tree in reverse order
            if (node instanceof ProvidedColumnGroup) {
                if (node.isPadding()) {
                    // skip over padding groups
                    leafPathTree = childDef;
                } else {
                    var groupDef = Object.assign({}, node.getColGroupDef());
                    // ensure group contains groupId
                    groupDef.groupId = node.getGroupId();
                    groupDef.children = [childDef];
                    leafPathTree = groupDef;
                }
            } else {
                var colDef = Object.assign({}, node.getColDef());
                // ensure col contains colId
                colDef.colId = node.getColId();
                leafPathTree = colDef;
            }
            // walk tree
            var parent = node.getOriginalParent();
            if (parent) {
                // keep walking up the tree until we reach the root
                return getLeafPathTree(parent, leafPathTree);
            } else {
                // we have reached the root - exit with resulting leaf path tree
                return leafPathTree;
            }
        };
        // obtain a sorted list of all grid columns
        var allGridColumns = this.columnModel.getAllGridColumns();
        // only primary columns and non row group columns should appear in the tool panel
        var allPrimaryGridColumns = allGridColumns.filter(function (column) {
            var colDef = column.getColDef();
            return column.isPrimary() && !colDef.showRowGroup;
        });
        // construct a leaf path tree for each column
        return allPrimaryGridColumns.map(function (col) {
            return getLeafPathTree(col, col.getColDef());
        });
    };
    ToolPanelColDefService.prototype.mergeLeafPathTrees = function (leafPathTrees) {
        var _this = this;
        var matchingRootGroupIds = function (pathA, pathB) {
            var bothPathsAreGroups = _this.isColGroupDef(pathA) && _this.isColGroupDef(pathB);
            return bothPathsAreGroups && _this.getId(pathA) === _this.getId(pathB);
        };
        var mergeTrees = function (treeA, treeB) {
            if (!_this.isColGroupDef(treeB)) {
                return treeA;
            }
            var mergeResult = treeA;
            var groupToMerge = treeB;
            if (groupToMerge.children && groupToMerge.groupId) {
                var added = _this.addChildrenToGroup(mergeResult, groupToMerge.groupId, groupToMerge.children[0]);
                if (added) {
                    return mergeResult;
                }
            }
            groupToMerge.children.forEach(function (child) {
                return mergeTrees(mergeResult, child);
            });
            return mergeResult;
        };
        // we can't just merge the leaf path trees as groups can be split apart - instead only merge if leaf
        // path groups with the same root group id are contiguous.
        var mergeColDefs = [];
        for (var i = 1; i <= leafPathTrees.length; i++) {
            var first = leafPathTrees[i - 1];
            var second = leafPathTrees[i];
            if (matchingRootGroupIds(first, second)) {
                leafPathTrees[i] = mergeTrees(first, second);
            } else {
                mergeColDefs.push(first);
            }
        }
        return mergeColDefs;
    };
    ToolPanelColDefService.prototype.addChildrenToGroup = function (tree, groupId, colDef) {
        var _this = this;
        var subGroupIsSplit = function (currentSubGroup, currentSubGroupToAdd) {
            var existingChildIds = currentSubGroup.children.map(_this.getId);
            var childGroupAlreadyExists = _.includes(existingChildIds, _this.getId(currentSubGroupToAdd));
            var lastChild = _.last(currentSubGroup.children);
            var lastChildIsDifferent = lastChild && _this.getId(lastChild) !== _this.getId(currentSubGroupToAdd);
            return childGroupAlreadyExists && lastChildIsDifferent;
        };
        if (!this.isColGroupDef(tree)) {
            return true;
        }
        var currentGroup = tree;
        var groupToAdd = colDef;
        if (subGroupIsSplit(currentGroup, groupToAdd)) {
            currentGroup.children.push(groupToAdd);
            return true;
        }
        if (currentGroup.groupId === groupId) {
            // add children that don't already exist to group
            var existingChildIds = currentGroup.children.map(this.getId);
            var colDefAlreadyPresent = _.includes(existingChildIds, this.getId(groupToAdd));
            if (!colDefAlreadyPresent) {
                currentGroup.children.push(groupToAdd);
                return true;
            }
        }
        // recurse until correct group is found to add children
        currentGroup.children.forEach(function (subGroup) {
            return _this.addChildrenToGroup(subGroup, groupId, colDef);
        });
        return false;
    };
    __decorate$25([Autowired('columnModel')], ToolPanelColDefService.prototype, 'columnModel', void 0);
    ToolPanelColDefService = __decorate$25([Bean('toolPanelColDefService')], ToolPanelColDefService);
    return ToolPanelColDefService;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$f = '30.2.0';

var SideBarModule = {
    version: VERSION$f,
    moduleName: ModuleNames.SideBarModule,
    beans: [ToolPanelColDefService],
    agStackComponents: [
        { componentName: 'AgHorizontalResize', componentClass: HorizontalResizeComp },
        { componentName: 'AgSideBar', componentClass: SideBarComp },
        { componentName: 'AgSideBarButtons', componentClass: SideBarButtonsComp },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __decorate$24 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ModelItemUtils = /** @class */ (function () {
    function ModelItemUtils() {}
    ModelItemUtils.prototype.selectAllChildren = function (colTree, selectAllChecked, eventType) {
        var cols = this.extractAllLeafColumns(colTree);
        this.setAllColumns(cols, selectAllChecked, eventType);
    };
    ModelItemUtils.prototype.setColumn = function (col, selectAllChecked, eventType) {
        this.setAllColumns([col], selectAllChecked, eventType);
    };
    ModelItemUtils.prototype.setAllColumns = function (cols, selectAllChecked, eventType) {
        if (this.columnModel.isPivotMode()) {
            this.setAllPivot(cols, selectAllChecked, eventType);
        } else {
            this.setAllVisible(cols, selectAllChecked, eventType);
        }
    };
    ModelItemUtils.prototype.extractAllLeafColumns = function (allItems) {
        var res = [];
        var recursiveFunc = function (items) {
            items.forEach(function (item) {
                if (!item.isPassesFilter()) {
                    return;
                }
                if (item.isGroup()) {
                    recursiveFunc(item.getChildren());
                } else {
                    res.push(item.getColumn());
                }
            });
        };
        recursiveFunc(allItems);
        return res;
    };
    ModelItemUtils.prototype.setAllVisible = function (columns, visible, eventType) {
        var colStateItems = [];
        columns.forEach(function (col) {
            if (col.getColDef().lockVisible) {
                return;
            }
            if (col.isVisible() != visible) {
                colStateItems.push({
                    colId: col.getId(),
                    hide: !visible,
                });
            }
        });
        if (colStateItems.length > 0) {
            this.columnModel.applyColumnState({ state: colStateItems }, eventType);
        }
    };
    ModelItemUtils.prototype.setAllPivot = function (columns, value, eventType) {
        if (this.gridOptionsService.is('functionsPassive')) {
            this.setAllPivotPassive(columns, value);
        } else {
            this.setAllPivotActive(columns, value, eventType);
        }
    };
    ModelItemUtils.prototype.setAllPivotPassive = function (columns, value) {
        var copyOfPivotColumns = this.columnModel.getPivotColumns().slice();
        var copyOfValueColumns = this.columnModel.getValueColumns().slice();
        var copyOfRowGroupColumns = this.columnModel.getRowGroupColumns().slice();
        var pivotChanged = false;
        var valueChanged = false;
        var rowGroupChanged = false;
        var turnOnAction = function (col) {
            // don't change any column that's already got a function active
            if (col.isAnyFunctionActive()) {
                return;
            }
            if (col.isAllowValue()) {
                copyOfValueColumns.push(col);
                valueChanged = true;
            } else if (col.isAllowRowGroup()) {
                copyOfRowGroupColumns.push(col);
                pivotChanged = true;
            } else if (col.isAllowPivot()) {
                copyOfPivotColumns.push(col);
                rowGroupChanged = true;
            }
        };
        var turnOffAction = function (col) {
            if (!col.isAnyFunctionActive()) {
                return;
            }
            if (copyOfPivotColumns.indexOf(col) >= 0) {
                _.removeFromArray(copyOfPivotColumns, col);
                pivotChanged = true;
            }
            if (copyOfValueColumns.indexOf(col) >= 0) {
                _.removeFromArray(copyOfValueColumns, col);
                valueChanged = true;
            }
            if (copyOfRowGroupColumns.indexOf(col) >= 0) {
                _.removeFromArray(copyOfRowGroupColumns, col);
                rowGroupChanged = true;
            }
        };
        var action = value ? turnOnAction : turnOffAction;
        columns.forEach(action);
        if (pivotChanged) {
            var event_1 = {
                type: Events.EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                columns: copyOfPivotColumns,
            };
            this.eventService.dispatchEvent(event_1);
        }
        if (rowGroupChanged) {
            var event_2 = {
                type: Events.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                columns: copyOfRowGroupColumns,
            };
            this.eventService.dispatchEvent(event_2);
        }
        if (valueChanged) {
            var event_3 = {
                type: Events.EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                columns: copyOfRowGroupColumns,
            };
            this.eventService.dispatchEvent(event_3);
        }
    };
    ModelItemUtils.prototype.setAllPivotActive = function (columns, value, eventType) {
        var _this = this;
        var colStateItems = [];
        var turnOnAction = function (col) {
            // don't change any column that's already got a function active
            if (col.isAnyFunctionActive()) {
                return;
            }
            if (col.isAllowValue()) {
                var aggFunc =
                    typeof col.getAggFunc() === 'string'
                        ? col.getAggFunc()
                        : _this.aggFuncService.getDefaultAggFunc(col);
                colStateItems.push({
                    colId: col.getId(),
                    aggFunc: aggFunc,
                });
            } else if (col.isAllowRowGroup()) {
                colStateItems.push({
                    colId: col.getId(),
                    rowGroup: true,
                });
            } else if (col.isAllowPivot()) {
                colStateItems.push({
                    colId: col.getId(),
                    pivot: true,
                });
            }
        };
        var turnOffAction = function (col) {
            var isActive = col.isPivotActive() || col.isRowGroupActive() || col.isValueActive();
            if (isActive) {
                colStateItems.push({
                    colId: col.getId(),
                    pivot: false,
                    rowGroup: false,
                    aggFunc: null,
                });
            }
        };
        var action = value ? turnOnAction : turnOffAction;
        columns.forEach(action);
        if (colStateItems.length > 0) {
            this.columnModel.applyColumnState({ state: colStateItems }, eventType);
        }
    };
    ModelItemUtils.prototype.updateColumns = function (params) {
        var _this = this;
        var columns = params.columns,
            visibleState = params.visibleState,
            pivotState = params.pivotState,
            eventType = params.eventType;
        var state = columns.map(function (column) {
            var colId = column.getColId();
            if (_this.columnModel.isPivotMode()) {
                var pivotStateForColumn = pivotState === null || pivotState === void 0 ? void 0 : pivotState[colId];
                return {
                    colId: colId,
                    pivot:
                        pivotStateForColumn === null || pivotStateForColumn === void 0
                            ? void 0
                            : pivotStateForColumn.pivot,
                    rowGroup:
                        pivotStateForColumn === null || pivotStateForColumn === void 0
                            ? void 0
                            : pivotStateForColumn.rowGroup,
                    aggFunc:
                        pivotStateForColumn === null || pivotStateForColumn === void 0
                            ? void 0
                            : pivotStateForColumn.aggFunc,
                };
            } else {
                return {
                    colId: colId,
                    hide: !(visibleState === null || visibleState === void 0 ? void 0 : visibleState[colId]),
                };
            }
        });
        this.columnModel.applyColumnState({ state: state }, eventType);
    };
    ModelItemUtils.prototype.createPivotState = function (column) {
        return {
            pivot: column.isPivotActive(),
            rowGroup: column.isRowGroupActive(),
            aggFunc: column.isValueActive() ? column.getAggFunc() : undefined,
        };
    };
    __decorate$24([Autowired('aggFuncService')], ModelItemUtils.prototype, 'aggFuncService', void 0);
    __decorate$24([Autowired('columnModel')], ModelItemUtils.prototype, 'columnModel', void 0);
    __decorate$24([Autowired('gridOptionsService')], ModelItemUtils.prototype, 'gridOptionsService', void 0);
    __decorate$24([Autowired('eventService')], ModelItemUtils.prototype, 'eventService', void 0);
    ModelItemUtils = __decorate$24([Bean('modelItemUtils')], ModelItemUtils);
    return ModelItemUtils;
})();

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$e = '30.2.0';

var ColumnsToolPanelModule = {
    version: VERSION$e,
    moduleName: ModuleNames.ColumnsToolPanelModule,
    beans: [ModelItemUtils],
    agStackComponents: [
        { componentName: 'AgPrimaryColsHeader', componentClass: PrimaryColsHeaderPanel },
        { componentName: 'AgPrimaryColsList', componentClass: PrimaryColsListPanel },
        { componentName: 'AgPrimaryCols', componentClass: PrimaryColsPanel },
    ],
    userComponents: [{ componentName: 'agColumnsToolPanel', componentClass: ColumnToolPanel }],
    dependantModules: [EnterpriseCoreModule, RowGroupingModule, SideBarModule],
};

var workbook = {
    getTemplate: function () {
        return {
            name: 'Workbook',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'xmlns:',
                        map: {
                            o: 'urn:schemas-microsoft-com:office:office',
                            x: 'urn:schemas-microsoft-com:office:excel',
                            ss: 'urn:schemas-microsoft-com:office:spreadsheet',
                            html: 'http://www.w3.org/TR/REC-html40',
                        },
                    },
                ],
                rawMap: {
                    xmlns: 'urn:schemas-microsoft-com:office:spreadsheet',
                },
            },
        };
    },
};

var excelWorkbook = {
    getTemplate: function () {
        return {
            name: 'ExcelWorkbook',
            properties: {
                rawMap: {
                    xmlns: 'urn:schemas-microsoft-com:office:excel',
                },
            },
            children: [
                {
                    name: 'WindowHeight',
                    textNode: '8130',
                },
                {
                    name: 'WindowWidth',
                    textNode: '15135',
                },
                {
                    name: 'WindowHeight',
                    textNode: '8130',
                },
                {
                    name: 'WindowTopX',
                    textNode: '120',
                },
                {
                    name: 'WindowTopY',
                    textNode: '45',
                },
                {
                    name: 'ProtectStructure',
                    textNode: 'False',
                },
                {
                    name: 'ProtectWindow',
                    textNode: 'False',
                },
            ],
        };
    },
};

var column = {
    getTemplate: function (c) {
        var width = c.width;
        return {
            name: 'Column',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Width: width,
                        },
                    },
                ],
            },
        };
    },
};

var cell = {
    getTemplate: function (c) {
        var mergeAcross = c.mergeAcross,
            styleId = c.styleId,
            data = c.data;
        var properties = {};
        if (mergeAcross) {
            properties.MergeAcross = mergeAcross;
        }
        if (styleId) {
            properties.StyleID = styleId;
        }
        return {
            name: 'Cell',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: properties,
                    },
                ],
            },
            children: [
                {
                    name: 'Data',
                    properties: {
                        prefixedAttributes: [
                            {
                                prefix: 'ss:',
                                map: {
                                    Type: data === null || data === void 0 ? void 0 : data.type,
                                },
                            },
                        ],
                    },
                    textNode: data === null || data === void 0 ? void 0 : data.value,
                },
            ],
        };
    },
};

var row = {
    getTemplate: function (r) {
        var cells = r.cells;
        return {
            name: 'Row',
            children: cells.map(function (it) {
                return cell.getTemplate(it);
            }),
        };
    },
};

var worksheet = {
    getTemplate: function (ws) {
        var table = ws.table,
            name = ws.name;
        var columns = table.columns,
            rows = table.rows;
        var c = columns.map(function (it) {
            return column.getTemplate(it);
        });
        var r = rows.map(function (it) {
            return row.getTemplate(it);
        });
        return {
            name: 'Worksheet',
            children: [
                {
                    name: 'Table',
                    children: c.concat(r),
                },
            ],
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Name: name,
                        },
                    },
                ],
            },
        };
    },
};

var documentProperties = {
    getTemplate: function () {
        return {
            name: 'DocumentProperties',
            properties: {
                rawMap: {
                    xmlns: 'urn:schemas-microsoft-com:office:office',
                },
            },
            children: [
                {
                    name: 'Version',
                    textNode: '12.00',
                },
            ],
        };
    },
};

var alignment = {
    getTemplate: function (styleProperties) {
        var _a = styleProperties.alignment,
            vertical = _a.vertical,
            horizontal = _a.horizontal,
            indent = _a.indent,
            readingOrder = _a.readingOrder,
            rotate = _a.rotate,
            shrinkToFit = _a.shrinkToFit,
            verticalText = _a.verticalText,
            wrapText = _a.wrapText;
        return {
            name: 'Alignment',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Vertical: vertical,
                            Horizontal: horizontal,
                            Indent: indent,
                            ReadingOrder: readingOrder,
                            Rotate: rotate,
                            ShrinkToFit: shrinkToFit,
                            VerticalText: verticalText,
                            WrapText: wrapText,
                        },
                    },
                ],
            },
        };
    },
};

var borders = {
    getTemplate: function (styleProperties) {
        var _a = styleProperties.borders,
            borderBottom = _a.borderBottom,
            borderLeft = _a.borderLeft,
            borderRight = _a.borderRight,
            borderTop = _a.borderTop;
        return {
            name: 'Borders',
            children: [borderBottom, borderLeft, borderRight, borderTop].map(function (it, index) {
                var current = index == 0 ? 'Bottom' : index == 1 ? 'Left' : index == 2 ? 'Right' : 'Top';
                return {
                    name: 'Border',
                    properties: {
                        prefixedAttributes: [
                            {
                                prefix: 'ss:',
                                map: {
                                    Position: current,
                                    LineStyle: it.lineStyle,
                                    Weight: it.weight,
                                    Color: it.color,
                                },
                            },
                        ],
                    },
                };
            }),
        };
    },
};

var font = {
    getTemplate: function (styleProperties) {
        var _a = styleProperties.font,
            bold = _a.bold,
            fontName = _a.fontName,
            italic = _a.italic,
            color = _a.color,
            outline = _a.outline,
            shadow = _a.shadow,
            size = _a.size,
            strikeThrough = _a.strikeThrough,
            underline = _a.underline,
            verticalAlign = _a.verticalAlign,
            charSet = _a.charSet,
            family = _a.family;
        return {
            name: 'Font',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Bold: bold,
                            FontName: fontName,
                            Italic: italic,
                            Color: color,
                            Outline: outline,
                            Shadow: shadow,
                            Size: size,
                            StrikeThrough: strikeThrough,
                            Underline: underline,
                            VerticalAlign: verticalAlign,
                        },
                    },
                    {
                        prefix: 'x:',
                        map: {
                            CharSet: charSet,
                            Family: family,
                        },
                    },
                ],
            },
        };
    },
};

var interior = {
    getTemplate: function (styleProperties) {
        var _a = styleProperties.interior,
            color = _a.color,
            pattern = _a.pattern,
            patternColor = _a.patternColor;
        return {
            name: 'Interior',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Color: color,
                            Pattern: pattern,
                            PatternColor: patternColor,
                        },
                    },
                ],
            },
        };
    },
};

var protection = {
    getTemplate: function (styleProperties) {
        return {
            name: 'Protection',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Protected: styleProperties.protection.protected,
                            HideFormula: styleProperties.protection.hideFormula,
                        },
                    },
                ],
            },
        };
    },
};

var numberFormat = {
    getTemplate: function (styleProperties) {
        var format = styleProperties.numberFormat.format;
        return {
            name: 'NumberFormat',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            Format: format,
                        },
                    },
                ],
            },
        };
    },
};

var style = {
    getTemplate: function (styleProperties) {
        var id = styleProperties.id,
            name = styleProperties.name;
        return {
            name: 'Style',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'ss:',
                        map: {
                            ID: id,
                            Name: name ? name : id,
                        },
                    },
                ],
            },
        };
    },
};

/**
 * See https://msdn.microsoft.com/en-us/library/aa140066(v=office.10).aspx
 */
var ExcelXmlFactory = /** @class */ (function () {
    function ExcelXmlFactory() {}
    ExcelXmlFactory.createExcel = function (styles, currentWorksheet) {
        var header = this.excelXmlHeader();
        var docProps = documentProperties.getTemplate();
        var eWorkbook = excelWorkbook.getTemplate();
        var wb = this.workbook(docProps, eWorkbook, styles, currentWorksheet);
        return (
            '' +
            header +
            XmlFactory.createXml(wb, function (boolean) {
                return boolean ? '1' : '0';
            })
        );
    };
    ExcelXmlFactory.workbook = function (docProperties, eWorkbook, styles, currentWorksheet) {
        var children = [docProperties, eWorkbook, this.stylesXmlElement(styles)].concat(
            worksheet.getTemplate(currentWorksheet),
        );
        return Object.assign({}, workbook.getTemplate(), { children: children });
    };
    ExcelXmlFactory.excelXmlHeader = function () {
        return '<?xml version="1.0" ?>\n        <?mso-application progid="Excel.Sheet" ?>\n        ';
    };
    ExcelXmlFactory.stylesXmlElement = function (styles) {
        var _this = this;
        return {
            name: 'Styles',
            children: styles
                ? styles.map(function (it) {
                      return _this.styleXmlElement(it);
                  })
                : [],
        };
    };
    ExcelXmlFactory.styleXmlElement = function (styleProperties) {
        var children = _.compose(
            this.addProperty('alignment', styleProperties),
            this.addProperty('borders', styleProperties),
            this.addProperty('font', styleProperties),
            this.addProperty('interior', styleProperties),
            this.addProperty('protection', styleProperties),
            this.addProperty('numberFormat', styleProperties),
        )([]);
        return Object.assign({}, style.getTemplate(styleProperties), { children: children });
    };
    ExcelXmlFactory.addProperty = function (property, styleProperties) {
        return function (children) {
            if (!styleProperties[property]) {
                return children;
            }
            var options = {
                alignment: alignment,
                borders: borders,
                font: font,
                interior: interior,
                numberFormat: numberFormat,
                protection: protection,
            };
            return children.concat(options[property].getTemplate(styleProperties));
        };
    };
    ExcelXmlFactory.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
    return ExcelXmlFactory;
})();

var INCH_TO_EMU = 9525;
var numberFormatMap = {
    '0': 1,
    '0.00': 2,
    '#,##0': 3,
    '#,##0.00': 4,
    '0%': 9,
    '0.00%': 10,
    '0.00E+00': 11,
    '# ?/?': 12,
    '# ??/??': 13,
    'mm-dd-yy': 14,
    'd-mmm-yy': 15,
    'd-mmm': 16,
    'mmm-yy': 17,
    'h:mm AM/PM': 18,
    'h:mm:ss AM/PM': 19,
    'h:mm': 20,
    'h:mm:ss': 21,
    'm/d/yy h:mm': 22,
    '#,##0 ;(#,##0)': 37,
    '#,##0 ;[Red](#,##0)': 38,
    '#,##0.00;(#,##0.00)': 39,
    '#,##0.00;[Red](#,##0.00)': 40,
    'mm:ss': 45,
    '[h]:mm:ss': 46,
    'mmss.0': 47,
    '##0.0E+0': 48,
    '@': 49,
};

var pixelsToPoint = function (pixels) {
    return Math.round((pixels * 72) / 96);
};
var pointsToPixel = function (points) {
    return Math.round((points * 96) / 72);
};
var pixelsToEMU = function (value) {
    return Math.ceil(value * INCH_TO_EMU);
};
var getFontFamilyId = function (name) {
    if (name === undefined) {
        return;
    }
    var families = ['Automatic', 'Roman', 'Swiss', 'Modern', 'Script', 'Decorative'];
    var pos = families.indexOf(name || 'Automatic');
    return Math.max(pos, 0);
};
var getHeightFromProperty = function (rowIndex, height) {
    if (!height) {
        return;
    }
    var finalHeight;
    if (typeof height === 'number') {
        finalHeight = height;
    } else {
        var heightFunc = height;
        finalHeight = heightFunc({ rowIndex: rowIndex });
    }
    return pixelsToPoint(finalHeight);
};
var setExcelImageTotalWidth = function (image, columnsToExport) {
    var _a = image.position,
        colSpan = _a.colSpan,
        column = _a.column;
    if (image.width) {
        if (colSpan) {
            var columnsInSpan = columnsToExport.slice(column - 1, column + colSpan - 1);
            var totalWidth = 0;
            for (var i = 0; i < columnsInSpan.length; i++) {
                var colWidth = columnsInSpan[i].getActualWidth();
                if (image.width < totalWidth + colWidth) {
                    image.position.colSpan = i + 1;
                    image.totalWidth = image.width;
                    image.width = image.totalWidth - totalWidth;
                    break;
                }
                totalWidth += colWidth;
            }
        } else {
            image.totalWidth = image.width;
        }
    }
};
var setExcelImageTotalHeight = function (image, rowHeight) {
    var _a = image.position,
        rowSpan = _a.rowSpan,
        row = _a.row;
    if (image.height) {
        if (rowSpan) {
            var totalHeight = 0;
            var counter = 0;
            for (var i = row; i < row + rowSpan; i++) {
                var nextRowHeight = pointsToPixel(getHeightFromProperty(i, rowHeight) || 20);
                if (image.height < totalHeight + nextRowHeight) {
                    image.position.rowSpan = counter + 1;
                    image.totalHeight = image.height;
                    image.height = image.totalHeight - totalHeight;
                    break;
                }
                totalHeight += nextRowHeight;
                counter++;
            }
        } else {
            image.totalHeight = image.height;
        }
    }
};
var createXmlPart = function (body) {
    var header = XmlFactory.createHeader({
        encoding: 'UTF-8',
        standalone: 'yes',
    });
    var xmlBody = XmlFactory.createXml(body);
    return '' + header + xmlBody;
};
var getExcelColumnName = function (colIdx) {
    var startCode = 65;
    var tableWidth = 26;
    var fromCharCode = String.fromCharCode;
    var pos = Math.floor(colIdx / tableWidth);
    var tableIdx = colIdx % tableWidth;
    if (!pos || colIdx === tableWidth) {
        return fromCharCode(startCode + colIdx - 1);
    }
    if (!tableIdx) {
        return getExcelColumnName(pos - 1) + 'Z';
    }
    if (pos < tableWidth) {
        return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
    }
    return getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
};

var __extends$2W =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$_ =
    (undefined && undefined.__assign) ||
    function () {
        __assign$_ =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$_.apply(this, arguments);
    };
var __read$1h =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$M =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var BaseExcelSerializingSession = /** @class */ (function (_super) {
    __extends$2W(BaseExcelSerializingSession, _super);
    function BaseExcelSerializingSession(config) {
        var _this = _super.call(this, config) || this;
        _this.mixedStyles = {};
        _this.mixedStyleCounter = 0;
        _this.rows = [];
        _this.config = Object.assign({}, config);
        _this.stylesByIds = {};
        _this.config.baseExcelStyles.forEach(function (style) {
            _this.stylesByIds[style.id] = style;
        });
        _this.excelStyles = __spreadArray$M([], __read$1h(_this.config.baseExcelStyles));
        return _this;
    }
    BaseExcelSerializingSession.prototype.addCustomContent = function (customContent) {
        var _this = this;
        customContent.forEach(function (row) {
            var rowLen = _this.rows.length + 1;
            var outlineLevel;
            if (!_this.config.suppressRowOutline && row.outlineLevel != null) {
                outlineLevel = row.outlineLevel;
            }
            var rowObj = {
                height: getHeightFromProperty(rowLen, row.height || _this.config.rowHeight),
                cells: (row.cells || []).map(function (cell, idx) {
                    var _a, _b, _c;
                    var image = _this.addImage(
                        rowLen,
                        _this.columnsToExport[idx],
                        (_a = cell.data) === null || _a === void 0 ? void 0 : _a.value,
                    );
                    var excelStyles = null;
                    if (cell.styleId) {
                        excelStyles = typeof cell.styleId === 'string' ? [cell.styleId] : cell.styleId;
                    }
                    var excelStyleId = _this.getStyleId(excelStyles);
                    if (image) {
                        return _this.createCell(
                            excelStyleId,
                            _this.getDataTypeForValue(image.value),
                            image.value == null ? '' : image.value,
                        );
                    }
                    var value =
                        (_c = (_b = cell.data) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0
                            ? _c
                            : '';
                    var type = _this.getDataTypeForValue(value);
                    if (cell.mergeAcross) {
                        return _this.createMergedCell(excelStyleId, type, value, cell.mergeAcross);
                    }
                    return _this.createCell(excelStyleId, type, value);
                }),
                outlineLevel: outlineLevel,
            };
            if (row.collapsed != null) {
                rowObj.collapsed = row.collapsed;
            }
            if (row.hidden != null) {
                rowObj.hidden = row.hidden;
            }
            _this.rows.push(rowObj);
        });
    };
    BaseExcelSerializingSession.prototype.onNewHeaderGroupingRow = function () {
        var _this = this;
        var currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: getHeightFromProperty(this.rows.length + 1, this.config.headerRowHeight),
        });
        return {
            onColumn: function (columnGroup, header, index, span, collapsibleRanges) {
                var styleIds = _this.config.styleLinker({
                    rowType: RowType.HEADER_GROUPING,
                    rowIndex: 1,
                    value: 'grouping-' + header,
                    columnGroup: columnGroup,
                });
                currentCells.push(
                    __assign$_(
                        __assign$_(
                            {},
                            _this.createMergedCell(
                                _this.getStyleId(styleIds),
                                _this.getDataTypeForValue('string'),
                                header,
                                span,
                            ),
                        ),
                        { collapsibleRanges: collapsibleRanges },
                    ),
                );
            },
        };
    };
    BaseExcelSerializingSession.prototype.onNewHeaderRow = function () {
        return this.onNewRow(this.onNewHeaderColumn, this.config.headerRowHeight);
    };
    BaseExcelSerializingSession.prototype.onNewBodyRow = function (node) {
        var rowAccumulator = this.onNewRow(this.onNewBodyColumn, this.config.rowHeight);
        if (node) {
            this.addRowOutlineIfNecessary(node);
        }
        return rowAccumulator;
    };
    BaseExcelSerializingSession.prototype.addRowOutlineIfNecessary = function (node) {
        var _a = this.config,
            gridOptionsService = _a.gridOptionsService,
            suppressRowOutline = _a.suppressRowOutline,
            _b = _a.rowGroupExpandState,
            rowGroupExpandState = _b === void 0 ? 'expanded' : _b;
        var isGroupHideOpenParents = gridOptionsService.is('groupHideOpenParents');
        if (isGroupHideOpenParents || suppressRowOutline || node.level == null) {
            return;
        }
        var padding = node.footer ? 1 : 0;
        var currentRow = _.last(this.rows);
        currentRow.outlineLevel = node.level + padding;
        if (rowGroupExpandState === 'expanded') {
            return;
        }
        var collapseAll = rowGroupExpandState === 'collapsed';
        if (node.isExpandable()) {
            var isExpanded = !collapseAll && node.expanded;
            currentRow.collapsed = !isExpanded;
        }
        currentRow.hidden =
            // always show the node if there is no parent to be expanded
            !!node.parent &&
            // or if it is a child of the root node
            node.parent.level !== -1 &&
            (collapseAll || this.isAnyParentCollapsed(node.parent));
    };
    BaseExcelSerializingSession.prototype.isAnyParentCollapsed = function (node) {
        while (node && node.level !== -1) {
            if (!node.expanded) {
                return true;
            }
            node = node.parent;
        }
        return false;
    };
    BaseExcelSerializingSession.prototype.prepare = function (columnsToExport) {
        var _this = this;
        _super.prototype.prepare.call(this, columnsToExport);
        this.columnsToExport = __spreadArray$M([], __read$1h(columnsToExport));
        this.cols = columnsToExport.map(function (col, i) {
            return _this.convertColumnToExcel(col, i);
        });
    };
    BaseExcelSerializingSession.prototype.parse = function () {
        // adding custom content might have made some rows wider than the grid, so add new columns
        var longestRow = this.rows.reduce(function (a, b) {
            return Math.max(a, b.cells.length);
        }, 0);
        while (this.cols.length < longestRow) {
            this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
        }
        var data = {
            name: this.config.sheetName,
            table: {
                columns: this.cols,
                rows: this.rows,
            },
        };
        return this.createExcel(data);
    };
    BaseExcelSerializingSession.prototype.isFormula = function (value) {
        if (value == null) {
            return false;
        }
        return this.config.autoConvertFormulas && value.toString().startsWith('=');
    };
    BaseExcelSerializingSession.prototype.isNumerical = function (value) {
        if (typeof value === 'bigint') {
            return true;
        }
        return isFinite(value) && value !== '' && !isNaN(parseFloat(value));
    };
    BaseExcelSerializingSession.prototype.getStyleById = function (styleId) {
        if (styleId == null) {
            return null;
        }
        return this.stylesByIds[styleId] || null;
    };
    BaseExcelSerializingSession.prototype.convertColumnToExcel = function (column, index) {
        var columnWidth = this.config.columnWidth;
        if (columnWidth) {
            if (typeof columnWidth === 'number') {
                return { width: columnWidth };
            }
            return { width: columnWidth({ column: column, index: index }) };
        }
        if (column) {
            var smallestUsefulWidth = 75;
            return { width: Math.max(column.getActualWidth(), smallestUsefulWidth) };
        }
        return {};
    };
    BaseExcelSerializingSession.prototype.onNewHeaderColumn = function (rowIndex, currentCells) {
        var _this = this;
        return function (column, index) {
            var nameForCol = _this.extractHeaderValue(column);
            var styleIds = _this.config.styleLinker({
                rowType: RowType.HEADER,
                rowIndex: rowIndex,
                value: nameForCol,
                column: column,
            });
            currentCells.push(
                _this.createCell(_this.getStyleId(styleIds), _this.getDataTypeForValue('string'), nameForCol),
            );
        };
    };
    BaseExcelSerializingSession.prototype.onNewRow = function (onNewColumnAccumulator, height) {
        var currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: getHeightFromProperty(this.rows.length + 1, height),
        });
        return {
            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)(),
        };
    };
    BaseExcelSerializingSession.prototype.onNewBodyColumn = function (rowIndex, currentCells) {
        var _this = this;
        var skipCols = 0;
        return function (column, index, node) {
            if (skipCols > 0) {
                skipCols -= 1;
                return;
            }
            var _a = _this.extractRowCellValue(column, index, rowIndex, 'excel', node),
                valueForCell = _a.value,
                valueFormatted = _a.valueFormatted;
            var styleIds = _this.config.styleLinker({
                rowType: RowType.BODY,
                rowIndex: rowIndex,
                value: valueForCell,
                column: column,
                node: node,
            });
            var excelStyleId = _this.getStyleId(styleIds);
            var colSpan = column.getColSpan(node);
            var addedImage = _this.addImage(rowIndex, column, valueForCell);
            if (addedImage) {
                currentCells.push(
                    _this.createCell(
                        excelStyleId,
                        _this.getDataTypeForValue(addedImage.value),
                        addedImage.value == null ? '' : addedImage.value,
                    ),
                );
            } else if (colSpan > 1) {
                skipCols = colSpan - 1;
                currentCells.push(
                    _this.createMergedCell(
                        excelStyleId,
                        _this.getDataTypeForValue(valueForCell),
                        valueForCell,
                        colSpan - 1,
                    ),
                );
            } else {
                currentCells.push(
                    _this.createCell(
                        excelStyleId,
                        _this.getDataTypeForValue(valueForCell),
                        valueForCell,
                        valueFormatted,
                    ),
                );
            }
        };
    };
    BaseExcelSerializingSession.prototype.getStyleId = function (styleIds) {
        if (!styleIds || !styleIds.length) {
            return null;
        }
        if (styleIds.length === 1) {
            return styleIds[0];
        }
        var key = styleIds.join('-');
        if (!this.mixedStyles[key]) {
            this.addNewMixedStyle(styleIds);
        }
        return this.mixedStyles[key].excelID;
    };
    BaseExcelSerializingSession.prototype.addNewMixedStyle = function (styleIds) {
        var _this = this;
        this.mixedStyleCounter += 1;
        var excelId = 'mixedStyle' + this.mixedStyleCounter;
        var resultantStyle = {};
        styleIds.forEach(function (styleId) {
            _this.excelStyles.forEach(function (excelStyle) {
                if (excelStyle.id === styleId) {
                    _.mergeDeep(resultantStyle, _.deepCloneObject(excelStyle));
                }
            });
        });
        resultantStyle.id = excelId;
        resultantStyle.name = excelId;
        var key = styleIds.join('-');
        this.mixedStyles[key] = {
            excelID: excelId,
            key: key,
            result: resultantStyle,
        };
        this.excelStyles.push(resultantStyle);
        this.stylesByIds[excelId] = resultantStyle;
    };
    return BaseExcelSerializingSession;
})(BaseGridSerializingSession);

var __extends$2V =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var ExcelXmlSerializingSession = /** @class */ (function (_super) {
    __extends$2V(ExcelXmlSerializingSession, _super);
    function ExcelXmlSerializingSession() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ExcelXmlSerializingSession.prototype.createExcel = function (data) {
        return ExcelXmlFactory.createExcel(this.excelStyles, data);
    };
    ExcelXmlSerializingSession.prototype.getDataTypeForValue = function (valueForCell) {
        return this.isNumerical(valueForCell) ? 'Number' : 'String';
    };
    ExcelXmlSerializingSession.prototype.getType = function (type, style, value) {
        if (this.isFormula(value)) {
            return 'Formula';
        }
        if (style && style.dataType) {
            switch (style.dataType.toLocaleLowerCase()) {
                case 'string':
                    return 'Formula';
                case 'number':
                    return 'Number';
                case 'datetime':
                    return 'DateTime';
                case 'error':
                    return 'Error';
                case 'boolean':
                    return 'Boolean';
                default:
                    console.warn(
                        'AG Grid: Unrecognized data type for excel export [' +
                            style.id +
                            '.dataType=' +
                            style.dataType +
                            ']',
                    );
            }
        }
        return type;
    };
    ExcelXmlSerializingSession.prototype.addImage = function () {
        return;
    };
    ExcelXmlSerializingSession.prototype.createCell = function (styleId, type, value, valueFormatted) {
        var actualStyle = this.getStyleById(styleId);
        if (
            !(actualStyle === null || actualStyle === void 0 ? void 0 : actualStyle.dataType) &&
            type === 'String' &&
            valueFormatted
        ) {
            value = valueFormatted;
        }
        var typeTransformed = this.getType(type, actualStyle, value) || type;
        return {
            styleId: !!actualStyle ? styleId : undefined,
            data: {
                type: typeTransformed,
                value: this.getValueTransformed(typeTransformed, value),
            },
        };
    };
    ExcelXmlSerializingSession.prototype.getValueTransformed = function (typeTransformed, value) {
        var _this = this;
        var wrapText = function (val) {
            if (_this.config.suppressTextAsCDATA) {
                return _.escapeString(val);
            }
            var cdataStart = '<![CDATA[';
            var cdataEnd = ']]>';
            var cdataEndRegex = new RegExp(cdataEnd, 'g');
            return (
                cdataStart +
                // CDATA sections are closed by the character sequence ']]>' and there is no
                // way of escaping this, so if the text contains the offending sequence, emit
                // multiple CDATA sections and split the characters between them.
                String(val).replace(cdataEndRegex, ']]' + cdataEnd + cdataStart + '>') +
                cdataEnd
            );
        };
        var convertBoolean = function (val) {
            if (!val || val === '0' || val === 'false') {
                return '0';
            }
            return '1';
        };
        switch (typeTransformed) {
            case 'String':
                return wrapText(value);
            case 'Number':
                return Number(value).valueOf() + '';
            case 'Boolean':
                return convertBoolean(value);
            default:
                return value;
        }
    };
    ExcelXmlSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
        return {
            styleId: !!this.getStyleById(styleId) ? styleId : undefined,
            data: {
                type: type,
                value: value,
            },
            mergeAcross: numOfCells,
        };
    };
    return ExcelXmlSerializingSession;
})(BaseExcelSerializingSession);

var coreFactory = {
    getTemplate: function (author) {
        var dt = new Date();
        var jsonDate = dt.toJSON();
        return {
            name: 'cp:coreProperties',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'xmlns:',
                        map: {
                            cp: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
                            dc: 'http://purl.org/dc/elements/1.1/',
                            dcterms: 'http://purl.org/dc/terms/',
                            dcmitype: 'http://purl.org/dc/dcmitype/',
                            xsi: 'http://www.w3.org/2001/XMLSchema-instance',
                        },
                    },
                ],
            },
            children: [
                {
                    name: 'dc:creator',
                    textNode: author,
                },
                {
                    name: 'dc:title',
                    textNode: 'Workbook',
                },
                {
                    name: 'dcterms:created',
                    properties: {
                        rawMap: {
                            'xsi:type': 'dcterms:W3CDTF',
                        },
                    },
                    textNode: jsonDate,
                },
                {
                    name: 'dcterms:modified',
                    properties: {
                        rawMap: {
                            'xsi:type': 'dcterms:W3CDTF',
                        },
                    },
                    textNode: jsonDate,
                },
            ],
        };
    },
};

var contentTypeFactory = {
    getTemplate: function (config) {
        var name = config.name,
            ContentType = config.ContentType,
            Extension = config.Extension,
            PartName = config.PartName;
        return {
            name: name,
            properties: {
                rawMap: {
                    Extension: Extension,
                    PartName: PartName,
                    ContentType: ContentType,
                },
            },
        };
    },
};

var __read$1g =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$L =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var contentTypesFactory = {
    getTemplate: function (sheetLen) {
        var worksheets = new Array(sheetLen).fill(undefined).map(function (v, i) {
            return {
                name: 'Override',
                ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml',
                PartName: '/xl/worksheets/sheet' + (i + 1) + '.xml',
            };
        });
        var sheetsWithImages = ExcelXlsxFactory.worksheetImages.size;
        var imageTypesObject = {};
        ExcelXlsxFactory.workbookImageIds.forEach(function (v) {
            imageTypesObject[v.type] = true;
        });
        var imageDocs = new Array(sheetsWithImages).fill(undefined).map(function (v, i) {
            return {
                name: 'Override',
                ContentType: 'application/vnd.openxmlformats-officedocument.drawing+xml',
                PartName: '/xl/drawings/drawing' + (i + 1) + '.xml',
            };
        });
        var imageTypes = Object.keys(imageTypesObject).map(function (ext) {
            return {
                name: 'Default',
                ContentType: 'image/' + ext,
                Extension: ext,
            };
        });
        var children = __spreadArray$L(
            __spreadArray$L(
                __spreadArray$L(
                    __spreadArray$L(
                        __spreadArray$L(__spreadArray$L([], __read$1g(imageTypes)), [
                            {
                                name: 'Default',
                                Extension: 'rels',
                                ContentType: 'application/vnd.openxmlformats-package.relationships+xml',
                            },
                            {
                                name: 'Default',
                                ContentType: 'application/xml',
                                Extension: 'xml',
                            },
                            {
                                name: 'Override',
                                ContentType:
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml',
                                PartName: '/xl/workbook.xml',
                            },
                        ]),
                        __read$1g(worksheets),
                    ),
                    [
                        {
                            name: 'Override',
                            ContentType: 'application/vnd.openxmlformats-officedocument.theme+xml',
                            PartName: '/xl/theme/theme1.xml',
                        },
                        {
                            name: 'Override',
                            ContentType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml',
                            PartName: '/xl/styles.xml',
                        },
                        {
                            name: 'Override',
                            ContentType:
                                'application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml',
                            PartName: '/xl/sharedStrings.xml',
                        },
                    ],
                ),
                __read$1g(imageDocs),
            ),
            [
                {
                    name: 'Override',
                    ContentType: 'application/vnd.openxmlformats-package.core-properties+xml',
                    PartName: '/docProps/core.xml',
                },
            ],
        ).map(function (contentType) {
            return contentTypeFactory.getTemplate(contentType);
        });
        return {
            name: 'Types',
            properties: {
                rawMap: {
                    xmlns: 'http://schemas.openxmlformats.org/package/2006/content-types',
                },
            },
            children: children,
        };
    },
};

var getAnchor = function (name, imageAnchor) {
    return {
        name: 'xdr:' + name,
        children: [
            {
                name: 'xdr:col',
                textNode: imageAnchor.col.toString(),
            },
            {
                name: 'xdr:colOff',
                textNode: imageAnchor.offsetX.toString(),
            },
            {
                name: 'xdr:row',
                textNode: imageAnchor.row.toString(),
            },
            {
                name: 'xdr:rowOff',
                textNode: imageAnchor.offsetY.toString(),
            },
        ],
    };
};
var getExt = function (image) {
    var children = [
        {
            name: 'a:ext',
            properties: {
                rawMap: {
                    uri: '{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}',
                },
            },
            children: [
                {
                    name: 'a16:creationId',
                    properties: {
                        rawMap: {
                            'id': '{822E6D20-D7BC-2841-A643-D49A6EF008A2}',
                            'xmlns:a16': 'http://schemas.microsoft.com/office/drawing/2014/main',
                        },
                    },
                },
            ],
        },
    ];
    var recolor = image.recolor && image.recolor.toLowerCase();
    switch (recolor) {
        case 'grayscale':
        case 'sepia':
        case 'washout':
            children.push({
                name: 'a:ext',
                properties: {
                    rawMap: {
                        uri: '{C183D7F6-B498-43B3-948B-1728B52AA6E4}',
                    },
                },
                children: [
                    {
                        name: 'adec:decorative',
                        properties: {
                            rawMap: {
                                'val': '0',
                                'xmlns:adec': 'http://schemas.microsoft.com/office/drawing/2017/decorative',
                            },
                        },
                    },
                ],
            });
    }
    return {
        name: 'a:extLst',
        children: children,
    };
};
var getNvPicPr = function (image, index) {
    return {
        name: 'xdr:nvPicPr',
        children: [
            {
                name: 'xdr:cNvPr',
                properties: {
                    rawMap: {
                        id: index,
                        name: image.id,
                        descr: image.altText != null ? image.altText : undefined,
                    },
                },
                children: [getExt(image)],
            },
            {
                name: 'xdr:cNvPicPr',
                properties: {
                    rawMap: {
                        preferRelativeResize: '0',
                    },
                },
                children: [
                    {
                        name: 'a:picLocks',
                    },
                ],
            },
        ],
    };
};
var getColorDetails = function (color) {
    if (!color.saturation && !color.tint) {
        return;
    }
    var ret = [];
    if (color.saturation) {
        ret.push({
            name: 'a:satMod',
            properties: {
                rawMap: {
                    val: color.saturation * 1000,
                },
            },
        });
    }
    if (color.tint) {
        ret.push({
            name: 'a:tint',
            properties: {
                rawMap: {
                    val: color.tint * 1000,
                },
            },
        });
    }
    return ret;
};
var getDuoTone = function (primaryColor, secondaryColor) {
    return {
        name: 'a:duotone',
        children: [
            {
                name: 'a:prstClr',
                properties: {
                    rawMap: {
                        val: primaryColor.color,
                    },
                },
                children: getColorDetails(primaryColor),
            },
            {
                name: 'a:srgbClr',
                properties: {
                    rawMap: {
                        val: secondaryColor.color,
                    },
                },
                children: getColorDetails(secondaryColor),
            },
        ],
    };
};
var getBlipFill = function (image, index) {
    var blipChildren;
    if (image.transparency) {
        var transparency = Math.min(Math.max(image.transparency, 0), 100);
        blipChildren = [
            {
                name: 'a:alphaModFix',
                properties: {
                    rawMap: {
                        amt: 100000 - Math.round(transparency * 1000),
                    },
                },
            },
        ];
    }
    if (image.recolor) {
        if (!blipChildren) {
            blipChildren = [];
        }
        switch (image.recolor.toLocaleLowerCase()) {
            case 'grayscale':
                blipChildren.push({ name: 'a:grayscl' });
                break;
            case 'sepia':
                blipChildren.push(getDuoTone({ color: 'black' }, { color: 'D9C3A5', tint: 50, saturation: 180 }));
                break;
            case 'washout':
                blipChildren.push({
                    name: 'a:lum',
                    properties: {
                        rawMap: {
                            bright: '70000',
                            contrast: '-70000',
                        },
                    },
                });
                break;
        }
    }
    return {
        name: 'xdr:blipFill',
        children: [
            {
                name: 'a:blip',
                properties: {
                    rawMap: {
                        'cstate': 'print',
                        'r:embed': 'rId' + index,
                        'xmlns:r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
                    },
                },
                children: blipChildren,
            },
            {
                name: 'a:stretch',
                children: [
                    {
                        name: 'a:fillRect',
                    },
                ],
            },
        ],
    };
};
var getSpPr = function (image, imageBoxSize) {
    var xfrm = {
        name: 'a:xfrm',
        children: [
            {
                name: 'a:off',
                properties: {
                    rawMap: {
                        x: 0,
                        y: 0,
                    },
                },
            },
            {
                name: 'a:ext',
                properties: {
                    rawMap: {
                        cx: imageBoxSize.width,
                        cy: imageBoxSize.height,
                    },
                },
            },
        ],
    };
    if (image.rotation) {
        var rotation = image.rotation;
        xfrm.properties = {
            rawMap: {
                rot: Math.min(Math.max(rotation, 0), 360) * 60000,
            },
        };
    }
    var prstGeom = {
        name: 'a:prstGeom',
        properties: {
            rawMap: {
                prst: 'rect',
            },
        },
        children: [{ name: 'a:avLst' }],
    };
    var ret = {
        name: 'xdr:spPr',
        children: [xfrm, prstGeom],
    };
    return ret;
};
var getImageBoxSize = function (image) {
    image.fitCell = !!image.fitCell || !image.width || !image.height;
    var _a = image.position,
        position = _a === void 0 ? {} : _a,
        fitCell = image.fitCell,
        _b = image.width,
        width = _b === void 0 ? 0 : _b,
        _c = image.height,
        height = _c === void 0 ? 0 : _c,
        totalHeight = image.totalHeight,
        totalWidth = image.totalWidth;
    var _d = position.offsetX,
        offsetX = _d === void 0 ? 0 : _d,
        _e = position.offsetY,
        offsetY = _e === void 0 ? 0 : _e,
        _f = position.row,
        row = _f === void 0 ? 1 : _f,
        _g = position.rowSpan,
        rowSpan = _g === void 0 ? 1 : _g,
        _h = position.column,
        column = _h === void 0 ? 1 : _h,
        _j = position.colSpan,
        colSpan = _j === void 0 ? 1 : _j;
    return {
        from: {
            row: row - 1,
            col: column - 1,
            offsetX: pixelsToEMU(offsetX),
            offsetY: pixelsToEMU(offsetY),
        },
        to: {
            row: row - 1 + (fitCell ? 1 : rowSpan - 1),
            col: column - 1 + (fitCell ? 1 : colSpan - 1),
            offsetX: pixelsToEMU(width + offsetX),
            offsetY: pixelsToEMU(height + offsetY),
        },
        height: pixelsToEMU(totalHeight || height),
        width: pixelsToEMU(totalWidth || width),
    };
};
var getPicture = function (image, currentIndex, worksheetImageIndex, imageBoxSize) {
    return {
        name: 'xdr:pic',
        children: [
            getNvPicPr(image, currentIndex + 1),
            getBlipFill(image, worksheetImageIndex + 1),
            getSpPr(image, imageBoxSize),
        ],
    };
};
var drawingFactory = {
    getTemplate: function (config) {
        var sheetIndex = config.sheetIndex;
        var sheetImages = ExcelXlsxFactory.worksheetImages.get(sheetIndex);
        var sheetImageIds = ExcelXlsxFactory.worksheetImageIds.get(sheetIndex);
        var children = sheetImages.map(function (image, idx) {
            var boxSize = getImageBoxSize(image);
            return {
                name: 'xdr:twoCellAnchor',
                properties: {
                    rawMap: {
                        editAs: 'absolute',
                    },
                },
                children: [
                    getAnchor('from', boxSize.from),
                    getAnchor('to', boxSize.to),
                    getPicture(image, idx, sheetImageIds.get(image.id).index, boxSize),
                    { name: 'xdr:clientData' },
                ],
            };
        });
        return {
            name: 'xdr:wsDr',
            properties: {
                rawMap: {
                    'xmlns:a': 'http://schemas.openxmlformats.org/drawingml/2006/main',
                    'xmlns:xdr': 'http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing',
                },
            },
            children: children,
        };
    },
};

var __read$1f =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var getColorChildren = function (props) {
    var _a = __read$1f(props, 4),
        type = _a[0],
        innerType = _a[1],
        val = _a[2],
        lastClr = _a[3];
    return {
        name: 'a:' + type,
        children: [
            {
                name: 'a:' + innerType,
                properties: {
                    rawMap: {
                        val: val,
                        lastClr: lastClr,
                    },
                },
            },
        ],
    };
};
var colorScheme = {
    getTemplate: function () {
        return {
            name: 'a:clrScheme',
            properties: {
                rawMap: {
                    name: 'Office',
                },
            },
            children: [
                getColorChildren(['dk1', 'sysClr', 'windowText', '000000']),
                getColorChildren(['lt1', 'sysClr', 'window', 'FFFFFF']),
                getColorChildren(['dk2', 'srgbClr', '44546A']),
                getColorChildren(['lt2', 'srgbClr', 'E7E6E6']),
                getColorChildren(['accent1', 'srgbClr', '4472C4']),
                getColorChildren(['accent2', 'srgbClr', 'ED7D31']),
                getColorChildren(['accent3', 'srgbClr', 'A5A5A5']),
                getColorChildren(['accent4', 'srgbClr', 'FFC000']),
                getColorChildren(['accent5', 'srgbClr', '5B9BD5']),
                getColorChildren(['accent6', 'srgbClr', '70AD47']),
                getColorChildren(['hlink', 'srgbClr', '0563C1']),
                getColorChildren(['folHlink', 'srgbClr', '954F72']),
            ],
        };
    },
};

var __read$1e =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var getFont$1 = function (props) {
    var _a = __read$1e(props, 4),
        type = _a[0],
        typeface = _a[1],
        script = _a[2],
        panose = _a[3];
    return {
        name: 'a:' + type,
        properties: {
            rawMap: {
                script: script,
                typeface: typeface,
                panose: panose,
            },
        },
    };
};
var fontScheme = {
    getTemplate: function () {
        var utf8_encode = _.utf8_encode;
        return {
            name: 'a:fontScheme',
            properties: {
                rawMap: {
                    name: 'Office',
                },
            },
            children: [
                {
                    name: 'a:majorFont',
                    children: [
                        getFont$1(['latin', 'Calibri Light', undefined, '020F0302020204030204']),
                        getFont$1(['ea', '']),
                        getFont$1(['cs', '']),
                        getFont$1(['font', utf8_encode('游ゴシック Light'), 'Jpan']),
                        getFont$1(['font', utf8_encode('맑은 고딕'), 'Hang']),
                        getFont$1(['font', utf8_encode('等线 Light'), 'Hans']),
                        getFont$1(['font', utf8_encode('新細明體'), 'Hant']),
                        getFont$1(['font', 'Times New Roman', 'Arab']),
                        getFont$1(['font', 'Times New Roman', 'Hebr']),
                        getFont$1(['font', 'Tahoma', 'Thai']),
                        getFont$1(['font', 'Nyala', 'Ethi']),
                        getFont$1(['font', 'Vrinda', 'Beng']),
                        getFont$1(['font', 'Shruti', 'Gujr']),
                        getFont$1(['font', 'MoolBoran', 'Khmr']),
                        getFont$1(['font', 'Tunga', 'Knda']),
                        getFont$1(['font', 'Raavi', 'Guru']),
                        getFont$1(['font', 'Euphemia', 'Cans']),
                        getFont$1(['font', 'Plantagenet Cherokee', 'Cher']),
                        getFont$1(['font', 'Microsoft Yi Baiti', 'Yiii']),
                        getFont$1(['font', 'Microsoft Himalaya', 'Tibt']),
                        getFont$1(['font', 'MV Boli', 'Thaa']),
                        getFont$1(['font', 'Mangal', 'Deva']),
                        getFont$1(['font', 'Gautami', 'Telu']),
                        getFont$1(['font', 'Latha', 'Taml']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrc']),
                        getFont$1(['font', 'Kalinga', 'Orya']),
                        getFont$1(['font', 'Kartika', 'Mlym']),
                        getFont$1(['font', 'DokChampa', 'Laoo']),
                        getFont$1(['font', 'Iskoola Pota', 'Sinh']),
                        getFont$1(['font', 'Mongolian Baiti', 'Mong']),
                        getFont$1(['font', 'Times New Roman', 'Viet']),
                        getFont$1(['font', 'Microsoft Uighur', 'Uigh']),
                        getFont$1(['font', 'Sylfaen', 'Geor']),
                        getFont$1(['font', 'Arial', 'Armn']),
                        getFont$1(['font', 'Leelawadee UI', 'Bugi']),
                        getFont$1(['font', 'Microsoft JhengHei', 'Bopo']),
                        getFont$1(['font', 'Javanese Text', 'Java']),
                        getFont$1(['font', 'Segoe UI', 'Lisu']),
                        getFont$1(['font', 'Myanmar Text', 'Mymr']),
                        getFont$1(['font', 'Ebrima', 'Nkoo']),
                        getFont$1(['font', 'Nirmala UI', 'Olck']),
                        getFont$1(['font', 'Ebrima', 'Osma']),
                        getFont$1(['font', 'Phagspa', 'Phag']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrn']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrj']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syre']),
                        getFont$1(['font', 'Nirmala UI', 'Sora']),
                        getFont$1(['font', 'Microsoft Tai Le', 'Tale']),
                        getFont$1(['font', 'Microsoft New Tai Lue', 'Talu']),
                        getFont$1(['font', 'Ebrima', 'Tfng']),
                    ],
                },
                {
                    name: 'a:minorFont',
                    children: [
                        getFont$1(['latin', 'Calibri', undefined, '020F0502020204030204']),
                        getFont$1(['ea', '']),
                        getFont$1(['cs', '']),
                        getFont$1(['font', utf8_encode('游ゴシック'), 'Jpan']),
                        getFont$1(['font', utf8_encode('맑은 고딕'), 'Hang']),
                        getFont$1(['font', utf8_encode('等线'), 'Hans']),
                        getFont$1(['font', utf8_encode('新細明體'), 'Hant']),
                        getFont$1(['font', 'Arial', 'Arab']),
                        getFont$1(['font', 'Arial', 'Hebr']),
                        getFont$1(['font', 'Tahoma', 'Thai']),
                        getFont$1(['font', 'Nyala', 'Ethi']),
                        getFont$1(['font', 'Vrinda', 'Beng']),
                        getFont$1(['font', 'Shruti', 'Gujr']),
                        getFont$1(['font', 'DaunPenh', 'Khmr']),
                        getFont$1(['font', 'Tunga', 'Knda']),
                        getFont$1(['font', 'Raavi', 'Guru']),
                        getFont$1(['font', 'Euphemia', 'Cans']),
                        getFont$1(['font', 'Plantagenet Cherokee', 'Cher']),
                        getFont$1(['font', 'Microsoft Yi Baiti', 'Yiii']),
                        getFont$1(['font', 'Microsoft Himalaya', 'Tibt']),
                        getFont$1(['font', 'MV Boli', 'Thaa']),
                        getFont$1(['font', 'Mangal', 'Deva']),
                        getFont$1(['font', 'Gautami', 'Telu']),
                        getFont$1(['font', 'Latha', 'Taml']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrc']),
                        getFont$1(['font', 'Kalinga', 'Orya']),
                        getFont$1(['font', 'Kartika', 'Mlym']),
                        getFont$1(['font', 'DokChampa', 'Laoo']),
                        getFont$1(['font', 'Iskoola Pota', 'Sinh']),
                        getFont$1(['font', 'Mongolian Baiti', 'Mong']),
                        getFont$1(['font', 'Arial', 'Viet']),
                        getFont$1(['font', 'Microsoft Uighur', 'Uigh']),
                        getFont$1(['font', 'Sylfaen', 'Geor']),
                        getFont$1(['font', 'Arial', 'Armn']),
                        getFont$1(['font', 'Leelawadee UI', 'Bugi']),
                        getFont$1(['font', 'Microsoft JhengHei', 'Bopo']),
                        getFont$1(['font', 'Javanese Text', 'Java']),
                        getFont$1(['font', 'Segoe UI', 'Lisu']),
                        getFont$1(['font', 'Myanmar Text', 'Mymr']),
                        getFont$1(['font', 'Ebrima', 'Nkoo']),
                        getFont$1(['font', 'Nirmala UI', 'Olck']),
                        getFont$1(['font', 'Ebrima', 'Osma']),
                        getFont$1(['font', 'Phagspa', 'Phag']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrn']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syrj']),
                        getFont$1(['font', 'Estrangelo Edessa', 'Syre']),
                        getFont$1(['font', 'Nirmala UI', 'Sora']),
                        getFont$1(['font', 'Microsoft Tai Le', 'Tale']),
                        getFont$1(['font', 'Microsoft New Tai Lue', 'Talu']),
                        getFont$1(['font', 'Ebrima', 'Tfng']),
                    ],
                },
            ],
        };
    },
};

var __read$1d =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var getPropertyVal = function (name, val, children) {
    return {
        name: 'a:' + name,
        properties: {
            rawMap: {
                val: val,
            },
        },
        children: children,
    };
};
var getGs = function (props) {
    var _a = __read$1d(props, 6),
        pos = _a[0],
        schemeColor = _a[1],
        satMod = _a[2],
        lumMod = _a[3],
        tint = _a[4],
        shade = _a[5];
    var children = [];
    children.push(getPropertyVal('satMod', satMod));
    if (lumMod) {
        children.push(getPropertyVal('lumMod', lumMod));
    }
    if (tint) {
        children.push(getPropertyVal('tint', tint));
    }
    if (shade) {
        children.push(getPropertyVal('shade', shade));
    }
    return {
        name: 'a:gs',
        properties: {
            rawMap: {
                pos: pos,
            },
        },
        children: [
            {
                name: 'a:schemeClr',
                properties: {
                    rawMap: {
                        val: schemeColor,
                    },
                },
                children: children,
            },
        ],
    };
};
var getSolidFill = function (val, children) {
    return {
        name: 'a:solidFill',
        children: [getPropertyVal('schemeClr', val, children)],
    };
};
var getGradFill = function (props) {
    var _a = __read$1d(props, 5),
        rotWithShape = _a[0],
        gs1 = _a[1],
        gs2 = _a[2],
        gs3 = _a[3],
        lin = _a[4];
    var _b = __read$1d(lin, 2),
        ang = _b[0],
        scaled = _b[1];
    return {
        name: 'a:gradFill',
        properties: {
            rawMap: {
                rotWithShape: rotWithShape,
            },
        },
        children: [
            {
                name: 'a:gsLst',
                children: [getGs(gs1), getGs(gs2), getGs(gs3)],
            },
            {
                name: 'a:lin',
                properties: {
                    rawMap: {
                        ang: ang,
                        scaled: scaled,
                    },
                },
            },
        ],
    };
};
var getLine = function (props) {
    var _a = __read$1d(props, 4),
        w = _a[0],
        cap = _a[1],
        cmpd = _a[2],
        algn = _a[3];
    return {
        name: 'a:ln',
        properties: {
            rawMap: { w: w, cap: cap, cmpd: cmpd, algn: algn },
        },
        children: [
            getSolidFill('phClr'),
            getPropertyVal('prstDash', 'solid'),
            {
                name: 'a:miter',
                properties: {
                    rawMap: {
                        lim: '800000',
                    },
                },
            },
        ],
    };
};
var getEffectStyle = function (shadow) {
    var children = [];
    if (shadow) {
        var _a = __read$1d(shadow, 5),
            blurRad = _a[0],
            dist = _a[1],
            dir = _a[2],
            algn = _a[3],
            rotWithShape = _a[4];
        children.push({
            name: 'a:outerShdw',
            properties: {
                rawMap: { blurRad: blurRad, dist: dist, dir: dir, algn: algn, rotWithShape: rotWithShape },
            },
            children: [getPropertyVal('srgbClr', '000000', [getPropertyVal('alpha', '63000')])],
        });
    }
    return {
        name: 'a:effectStyle',
        children: [
            Object.assign(
                {},
                {
                    name: 'a:effectLst',
                },
                children.length ? { children: children } : {},
            ),
        ],
    };
};
var getFillStyleList = function () {
    return {
        name: 'a:fillStyleLst',
        children: [
            getSolidFill('phClr'),
            getGradFill([
                '1',
                ['0', 'phClr', '105000', '110000', '67000'],
                ['50000', 'phClr', '103000', '105000', '73000'],
                ['100000', 'phClr', '109000', '105000', '81000'],
                ['5400000', '0'],
            ]),
            getGradFill([
                '1',
                ['0', 'phClr', '103000', '102000', '94000'],
                ['50000', 'phClr', '110000', '100000', undefined, '100000'],
                ['100000', 'phClr', '120000', '99000', undefined, '78000'],
                ['5400000', '0'],
            ]),
        ],
    };
};
var getLineStyleList = function () {
    return {
        name: 'a:lnStyleLst',
        children: [
            getLine(['6350', 'flat', 'sng', 'ctr']),
            getLine(['12700', 'flat', 'sng', 'ctr']),
            getLine(['19050', 'flat', 'sng', 'ctr']),
        ],
    };
};
var getEffectStyleList = function () {
    return {
        name: 'a:effectStyleLst',
        children: [getEffectStyle(), getEffectStyle(), getEffectStyle(['57150', '19050', '5400000', 'ctr', '0'])],
    };
};
var getBgFillStyleList = function () {
    return {
        name: 'a:bgFillStyleLst',
        children: [
            getSolidFill('phClr'),
            getSolidFill('phClr', [getPropertyVal('tint', '95000'), getPropertyVal('satMod', '170000')]),
            getGradFill([
                '1',
                ['0', 'phClr', '150000', '102000', '93000', '98000'],
                ['50000', 'phClr', '130000', '103000', '98000', '90000'],
                ['100000', 'phClr', '120000', undefined, undefined, '63000'],
                ['5400000', '0'],
            ]),
        ],
    };
};
var formatScheme = {
    getTemplate: function () {
        return {
            name: 'a:fmtScheme',
            properties: {
                rawMap: {
                    name: 'Office',
                },
            },
            children: [getFillStyleList(), getLineStyleList(), getEffectStyleList(), getBgFillStyleList()],
        };
    },
};

var themeElements = {
    getTemplate: function () {
        return {
            name: 'a:themeElements',
            children: [colorScheme.getTemplate(), fontScheme.getTemplate(), formatScheme.getTemplate()],
        };
    },
};

var officeTheme = {
    getTemplate: function () {
        return {
            name: 'a:theme',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'xmlns:',
                        map: {
                            a: 'http://schemas.openxmlformats.org/drawingml/2006/main',
                        },
                    },
                ],
                rawMap: {
                    name: 'Office Theme',
                },
            },
            children: [
                themeElements.getTemplate(),
                {
                    name: 'a:objectDefaults',
                },
                {
                    name: 'a:extraClrSchemeLst',
                },
            ],
        };
    },
};

var buildSharedString = function (strMap) {
    var ret = [];
    strMap.forEach(function (val, key) {
        var textNode = key.toString();
        var child = {
            name: 't',
            textNode: _.utf8_encode(_.escapeString(textNode)),
        };
        // if we have leading or trailing spaces, instruct Excel not to trim them
        var preserveSpaces = textNode.trim().length !== textNode.length;
        if (preserveSpaces) {
            child.properties = {
                rawMap: {
                    'xml:space': 'preserve',
                },
            };
        }
        ret.push({
            name: 'si',
            children: [child],
        });
    });
    return ret;
};
var sharedStrings = {
    getTemplate: function (strings) {
        return {
            name: 'sst',
            properties: {
                rawMap: {
                    xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
                    count: strings.size,
                    uniqueCount: strings.size,
                },
            },
            children: buildSharedString(strings),
        };
    },
};

function prepareString(str) {
    var split = str.split(/(\[[^\]]*\])/);
    for (var i = 0; i < split.length; i++) {
        // excel formulas require symbols to be escaped. Excel also requires $ to be
        // placed in quotes but only when the $ is not wrapped inside of square brackets.
        var currentString = split[i];
        if (!currentString.length) {
            continue;
        }
        if (!currentString.startsWith('[')) {
            currentString = currentString.replace(/\$/g, '"$"');
        }
        split[i] = _.escapeString(currentString);
    }
    return split.join('');
}
var numberFormatFactory = {
    getTemplate: function (numberFormat) {
        var formatCode = numberFormat.formatCode,
            numFmtId = numberFormat.numFmtId;
        if (formatCode.length) {
            formatCode = prepareString(formatCode);
        }
        return {
            name: 'numFmt',
            properties: {
                rawMap: {
                    formatCode: formatCode,
                    numFmtId: numFmtId,
                },
            },
        };
    },
};

var numberFormatsFactory = {
    getTemplate: function (numberFormats) {
        return {
            name: 'numFmts',
            properties: {
                rawMap: {
                    count: numberFormats.length,
                },
            },
            children: numberFormats.map(function (numberFormat) {
                return numberFormatFactory.getTemplate(numberFormat);
            }),
        };
    },
};

var fontFactory = {
    getTemplate: function (font) {
        var size = font.size,
            colorTheme = font.colorTheme,
            _a = font.color,
            color = _a === void 0 ? 'FF000000' : _a,
            _b = font.fontName,
            fontName = _b === void 0 ? 'Calibri' : _b,
            family = font.family,
            scheme = font.scheme,
            italic = font.italic,
            bold = font.bold,
            strikeThrough = font.strikeThrough,
            outline = font.outline,
            shadow = font.shadow,
            underline = font.underline,
            verticalAlign = font.verticalAlign;
        var children = [
            { name: 'sz', properties: { rawMap: { val: size } } },
            { name: 'color', properties: { rawMap: { theme: colorTheme, rgb: color } } },
            { name: 'name', properties: { rawMap: { val: fontName } } },
        ];
        if (family) {
            children.push({ name: 'family', properties: { rawMap: { val: family } } });
        }
        if (scheme) {
            children.push({ name: 'scheme', properties: { rawMap: { val: scheme } } });
        }
        if (italic) {
            children.push({ name: 'i' });
        }
        if (bold) {
            children.push({ name: 'b' });
        }
        if (strikeThrough) {
            children.push({ name: 'strike' });
        }
        if (outline) {
            children.push({ name: 'outline' });
        }
        if (shadow) {
            children.push({ name: 'shadow' });
        }
        if (underline) {
            children.push({ name: 'u', properties: { rawMap: { val: underline } } });
        }
        if (verticalAlign) {
            children.push({ name: 'vertAlign', properties: { rawMap: { val: verticalAlign } } });
        }
        return { name: 'font', children: children };
    },
};

var fontsFactory = {
    getTemplate: function (fonts) {
        return {
            name: 'fonts',
            properties: {
                rawMap: {
                    count: fonts.length,
                },
            },
            children: fonts.map(function (font) {
                return fontFactory.getTemplate(font);
            }),
        };
    },
};

var fillFactory = {
    getTemplate: function (fill) {
        var patternType = fill.patternType,
            fgTheme = fill.fgTheme,
            fgTint = fill.fgTint,
            fgRgb = fill.fgRgb,
            bgRgb = fill.bgRgb,
            bgIndexed = fill.bgIndexed;
        var pf = {
            name: 'patternFill',
            properties: {
                rawMap: {
                    patternType: patternType,
                },
            },
        };
        if (fgTheme || fgTint || fgRgb) {
            pf.children = [
                {
                    name: 'fgColor',
                    properties: {
                        rawMap: {
                            theme: fgTheme,
                            tint: fgTint,
                            rgb: fgRgb,
                        },
                    },
                },
            ];
        }
        if (bgIndexed || bgRgb) {
            if (!pf.children) {
                pf.children = [];
            }
            pf.children.push({
                name: 'bgColor',
                properties: {
                    rawMap: {
                        indexed: bgIndexed,
                        rgb: bgRgb,
                    },
                },
            });
        }
        return {
            name: 'fill',
            children: [pf],
        };
    },
};

var fillsFactory = {
    getTemplate: function (fills) {
        return {
            name: 'fills',
            properties: {
                rawMap: {
                    count: fills.length,
                },
            },
            children: fills.map(function (fill) {
                return fillFactory.getTemplate(fill);
            }),
        };
    },
};

var getWeightName = function (value) {
    switch (value) {
        case 1:
            return 'thin';
        case 2:
            return 'medium';
        case 3:
            return 'thick';
        default:
            return 'hair';
    }
};
var mappedBorderNames = {
    None: 'None',
    Dot: 'Dotted',
    Dash: 'Dashed',
    Double: 'Double',
    DashDot: 'DashDot',
    DashDotDot: 'DashDotDot',
    SlantDashDot: 'SlantDashDot',
};
var mediumBorders = ['Dashed', 'DashDot', 'DashDotDot'];
var colorMap = {
    None: 'none',
    Solid: 'solid',
    Gray50: 'mediumGray',
    Gray75: 'darkGray',
    Gray25: 'lightGray',
    HorzStripe: 'darkHorizontal',
    VertStripe: 'darkVertical',
    ReverseDiagStripe: 'darkDown',
    DiagStripe: 'darkUp',
    DiagCross: 'darkGrid',
    ThickDiagCross: 'darkTrellis',
    ThinHorzStripe: 'lightHorizontal',
    ThinVertStripe: 'lightVertical',
    ThinReverseDiagStripe: 'lightDown',
    ThinDiagStripe: 'lightUp',
    ThinHorzCross: 'lightGrid',
    ThinDiagCross: 'lightTrellis',
    Gray125: 'gray125',
    Gray0625: 'gray0625',
};
var horizontalAlignmentMap = {
    Automatic: 'general',
    Left: 'left',
    Center: 'center',
    Right: 'right',
    Fill: 'fill',
    Justify: 'justify',
    CenterAcrossSelection: 'centerContinuous',
    Distributed: 'distributed',
    JustifyDistributed: 'justify',
};
var verticalAlignmentMap = {
    Automatic: undefined,
    Top: 'top',
    Bottom: 'bottom',
    Center: 'center',
    Justify: 'justify',
    Distributed: 'distributed',
    JustifyDistributed: 'justify',
};
var convertLegacyPattern = function (name) {
    if (!name) {
        return 'none';
    }
    return colorMap[name] || name;
};
var convertLegacyColor = function (color) {
    if (color == undefined) {
        return color;
    }
    if (color.charAt(0) === '#') {
        color = color.substr(1);
    }
    return color.length === 6 ? 'FF' + color : color;
};
var convertLegacyBorder = function (type, weight) {
    if (!type) {
        return 'thin';
    }
    // Legacy Types are: None, Continuous, Dash, Dot, DashDot, DashDotDot, SlantDashDot, and Double
    // Weight represents: 0—Hairline, 1—Thin , 2—Medium, 3—Thick
    // New types: none, thin, medium, dashed, dotted, thick, double, hair, mediumDashed, dashDot, mediumDashDot,
    // dashDotDot, mediumDashDotDot, slantDashDot
    var namedWeight = getWeightName(weight);
    var mappedName = mappedBorderNames[type];
    if (type === 'Continuous') {
        return namedWeight;
    }
    if (namedWeight === 'medium' && mediumBorders.indexOf(mappedName) !== -1) {
        return 'medium' + mappedName;
    }
    return mappedName.charAt(0).toLowerCase() + mappedName.substr(1);
};
var convertLegacyHorizontalAlignment = function (alignment) {
    return horizontalAlignmentMap[alignment] || 'general';
};
var convertLegacyVerticalAlignment = function (alignment) {
    return verticalAlignmentMap[alignment] || undefined;
};

var getBorderColor = function (color) {
    return {
        name: 'color',
        properties: {
            rawMap: {
                rgb: convertLegacyColor(color || '#000000'),
            },
        },
    };
};
var borderFactory$1 = {
    getTemplate: function (border) {
        var left = border.left,
            right = border.right,
            top = border.top,
            bottom = border.bottom,
            diagonal = border.diagonal;
        var leftChildren = left ? [getBorderColor(left.color)] : undefined;
        var rightChildren = right ? [getBorderColor(right.color)] : undefined;
        var topChildren = top ? [getBorderColor(top.color)] : undefined;
        var bottomChildren = bottom ? [getBorderColor(bottom.color)] : undefined;
        var diagonalChildren = diagonal ? [getBorderColor(diagonal.color)] : undefined;
        return {
            name: 'border',
            children: [
                {
                    name: 'left',
                    properties: { rawMap: { style: left && left.style } },
                    children: leftChildren,
                },
                {
                    name: 'right',
                    properties: { rawMap: { style: right && right.style } },
                    children: rightChildren,
                },
                {
                    name: 'top',
                    properties: { rawMap: { style: top && top.style } },
                    children: topChildren,
                },
                {
                    name: 'bottom',
                    properties: { rawMap: { style: bottom && bottom.style } },
                    children: bottomChildren,
                },
                {
                    name: 'diagonal',
                    properties: { rawMap: { style: diagonal && diagonal.style } },
                    children: diagonalChildren,
                },
            ],
        };
    },
};

var bordersFactory = {
    getTemplate: function (borders) {
        return {
            name: 'borders',
            properties: {
                rawMap: {
                    count: borders.length,
                },
            },
            children: borders.map(function (border) {
                return borderFactory$1.getTemplate(border);
            }),
        };
    },
};

var getReadingOrderId = function (readingOrder) {
    var order = ['Context', 'LeftToRight', 'RightToLeft'];
    var pos = order.indexOf(readingOrder);
    return Math.max(pos, 0);
};
var alignmentFactory = {
    getTemplate: function (alignment) {
        var horizontal = alignment.horizontal,
            indent = alignment.indent,
            readingOrder = alignment.readingOrder,
            rotate = alignment.rotate,
            shrinkToFit = alignment.shrinkToFit,
            vertical = alignment.vertical,
            wrapText = alignment.wrapText;
        return {
            name: 'alignment',
            properties: {
                rawMap: {
                    horizontal: horizontal && convertLegacyHorizontalAlignment(horizontal),
                    indent: indent,
                    readingOrder: readingOrder && getReadingOrderId(readingOrder),
                    textRotation: rotate,
                    shrinkToFit: shrinkToFit,
                    vertical: vertical && convertLegacyVerticalAlignment(vertical),
                    wrapText: wrapText,
                },
            },
        };
    },
};

var protectionFactory = {
    getTemplate: function (protection) {
        var locked = protection.protected === false ? 0 : 1;
        var hidden = protection.hideFormula === true ? 1 : 0;
        return {
            name: 'protection',
            properties: {
                rawMap: {
                    hidden: hidden,
                    locked: locked,
                },
            },
        };
    },
};

var xfFactory = {
    getTemplate: function (xf) {
        var alignment = xf.alignment,
            borderId = xf.borderId,
            fillId = xf.fillId,
            fontId = xf.fontId,
            numFmtId = xf.numFmtId,
            protection = xf.protection,
            xfId = xf.xfId;
        var children = [];
        if (alignment) {
            children.push(alignmentFactory.getTemplate(alignment));
        }
        if (protection) {
            children.push(protectionFactory.getTemplate(protection));
        }
        return {
            name: 'xf',
            properties: {
                rawMap: {
                    applyAlignment: alignment ? 1 : undefined,
                    applyProtection: protection ? 1 : undefined,
                    applyBorder: borderId ? 1 : undefined,
                    applyFill: fillId ? 1 : undefined,
                    borderId: borderId,
                    fillId: fillId,
                    applyFont: fontId ? 1 : undefined,
                    fontId: fontId,
                    applyNumberFormat: numFmtId ? 1 : undefined,
                    numFmtId: numFmtId,
                    xfId: xfId,
                },
            },
            children: children.length ? children : undefined,
        };
    },
};

var cellStylesXfsFactory = {
    getTemplate: function (xfs) {
        return {
            name: 'cellStyleXfs',
            properties: {
                rawMap: {
                    count: xfs.length,
                },
            },
            children: xfs.map(function (xf) {
                return xfFactory.getTemplate(xf);
            }),
        };
    },
};

var cellXfsFactory = {
    getTemplate: function (xfs) {
        return {
            name: 'cellXfs',
            properties: {
                rawMap: {
                    count: xfs.length,
                },
            },
            children: xfs.map(function (xf) {
                return xfFactory.getTemplate(xf);
            }),
        };
    },
};

var borderFactory = {
    getTemplate: function (cellStyle) {
        var builtinId = cellStyle.builtinId,
            name = cellStyle.name,
            xfId = cellStyle.xfId;
        return {
            name: 'cellStyle',
            properties: {
                rawMap: {
                    builtinId: builtinId,
                    name: name,
                    xfId: xfId,
                },
            },
        };
    },
};

var cellStylesFactory = {
    getTemplate: function (cellStyles) {
        return {
            name: 'cellStyles',
            properties: {
                rawMap: {
                    count: cellStyles.length,
                },
            },
            children: cellStyles.map(function (cellStyle) {
                return borderFactory.getTemplate(cellStyle);
            }),
        };
    },
};

var __assign$Z =
    (undefined && undefined.__assign) ||
    function () {
        __assign$Z =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$Z.apply(this, arguments);
    };
var stylesMap;
var registeredNumberFmts;
var registeredFonts;
var registeredFills;
var registeredBorders;
var registeredCellStyleXfs;
var registeredCellXfs;
var registeredCellStyles;
var currentSheet;
var getStyleName = function (name, currentSheet) {
    if (name.indexOf('mixedStyle') !== -1 && currentSheet > 1) {
        name += '_' + currentSheet;
    }
    return name;
};
var resetStylesheetValues = function () {
    stylesMap = { base: 0 };
    registeredNumberFmts = [];
    registeredFonts = [{ fontName: 'Calibri', colorTheme: '1', family: '2', scheme: 'minor' }];
    registeredFills = [{ patternType: 'none' }, { patternType: 'gray125' }];
    registeredBorders = [{ left: undefined, right: undefined, top: undefined, bottom: undefined, diagonal: undefined }];
    registeredCellStyleXfs = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0 }];
    registeredCellXfs = [{ borderId: 0, fillId: 0, fontId: 0, numFmtId: 0, xfId: 0 }];
    registeredCellStyles = [{ builtinId: 0, name: 'Normal', xfId: 0 }];
};
var registerFill = function (fill) {
    var convertedPattern = convertLegacyPattern(fill.pattern);
    var convertedFillColor = convertLegacyColor(fill.color);
    var convertedPatternColor = convertLegacyColor(fill.patternColor);
    var pos = registeredFills.findIndex(function (currentFill) {
        var patternType = currentFill.patternType,
            fgRgb = currentFill.fgRgb,
            bgRgb = currentFill.bgRgb;
        if (patternType != convertedPattern || fgRgb != convertedFillColor || bgRgb != convertedPatternColor) {
            return false;
        }
        return true;
    });
    if (pos === -1) {
        pos = registeredFills.length;
        registeredFills.push({
            patternType: convertedPattern,
            fgRgb: convertedFillColor,
            bgRgb: convertedPatternColor,
        });
    }
    return pos;
};
var registerNumberFmt = function (format) {
    format = _.utf8_encode(format);
    if (numberFormatMap[format]) {
        return numberFormatMap[format];
    }
    var pos = registeredNumberFmts.findIndex(function (currentFormat) {
        return currentFormat.formatCode === format;
    });
    if (pos === -1) {
        pos = registeredNumberFmts.length + 164;
        registeredNumberFmts.push({ formatCode: format, numFmtId: pos });
    } else {
        pos = registeredNumberFmts[pos].numFmtId;
    }
    return pos;
};
var registerBorders = function (borders) {
    var borderBottom = borders.borderBottom,
        borderTop = borders.borderTop,
        borderLeft = borders.borderLeft,
        borderRight = borders.borderRight;
    var bottomStyle;
    var topStyle;
    var leftStyle;
    var rightStyle;
    var bottomColor;
    var topColor;
    var leftColor;
    var rightColor;
    if (borderLeft) {
        leftStyle = convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
        leftColor = convertLegacyColor(borderLeft.color);
    }
    if (borderRight) {
        rightStyle = convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
        rightColor = convertLegacyColor(borderRight.color);
    }
    if (borderBottom) {
        bottomStyle = convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
        bottomColor = convertLegacyColor(borderBottom.color);
    }
    if (borderTop) {
        topStyle = convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
        topColor = convertLegacyColor(borderTop.color);
    }
    var pos = registeredBorders.findIndex(function (currentBorder) {
        var left = currentBorder.left,
            right = currentBorder.right,
            top = currentBorder.top,
            bottom = currentBorder.bottom;
        if (!left && (leftStyle || leftColor)) {
            return false;
        }
        if (!right && (rightStyle || rightColor)) {
            return false;
        }
        if (!top && (topStyle || topColor)) {
            return false;
        }
        if (!bottom && (bottomStyle || bottomColor)) {
            return false;
        }
        var _a = left || {},
            clS = _a.style,
            clC = _a.color;
        var _b = right || {},
            crS = _b.style,
            crC = _b.color;
        var _c = top || {},
            ctS = _c.style,
            ctC = _c.color;
        var _d = bottom || {},
            cbS = _d.style,
            cbC = _d.color;
        if (clS != leftStyle || clC != leftColor) {
            return false;
        }
        if (crS != rightStyle || crC != rightColor) {
            return false;
        }
        if (ctS != topStyle || ctC != topColor) {
            return false;
        }
        if (cbS != bottomStyle || cbC != bottomColor) {
            return false;
        }
        return true;
    });
    if (pos === -1) {
        pos = registeredBorders.length;
        registeredBorders.push({
            left: {
                style: leftStyle,
                color: leftColor,
            },
            right: {
                style: rightStyle,
                color: rightColor,
            },
            top: {
                style: topStyle,
                color: topColor,
            },
            bottom: {
                style: bottomStyle,
                color: bottomColor,
            },
            diagonal: {
                style: undefined,
                color: undefined,
            },
        });
    }
    return pos;
};
var registerFont = function (font) {
    var _a = font.fontName,
        name = _a === void 0 ? 'Calibri' : _a,
        color = font.color,
        size = font.size,
        bold = font.bold,
        italic = font.italic,
        outline = font.outline,
        shadow = font.shadow,
        strikeThrough = font.strikeThrough,
        underline = font.underline,
        family = font.family,
        verticalAlign = font.verticalAlign;
    var utf8Name = name ? _.utf8_encode(name) : name;
    var convertedColor = convertLegacyColor(color);
    var familyId = getFontFamilyId(family);
    var convertedUnderline = underline ? underline.toLocaleLowerCase() : undefined;
    var convertedVerticalAlign = verticalAlign ? verticalAlign.toLocaleLowerCase() : undefined;
    var pos = registeredFonts.findIndex(function (currentFont) {
        if (
            currentFont.fontName != utf8Name ||
            currentFont.color != convertedColor ||
            currentFont.size != size ||
            currentFont.bold != bold ||
            currentFont.italic != italic ||
            currentFont.outline != outline ||
            currentFont.shadow != shadow ||
            currentFont.strikeThrough != strikeThrough ||
            currentFont.underline != convertedUnderline ||
            currentFont.verticalAlign != convertedVerticalAlign ||
            // @ts-ignore
            currentFont.family != familyId
        ) {
            return false;
        }
        return true;
    });
    if (pos === -1) {
        pos = registeredFonts.length;
        registeredFonts.push({
            fontName: utf8Name,
            color: convertedColor,
            size: size,
            bold: bold,
            italic: italic,
            outline: outline,
            shadow: shadow,
            strikeThrough: strikeThrough,
            underline: convertedUnderline,
            verticalAlign: convertedVerticalAlign,
            family: familyId != null ? familyId.toString() : undefined,
        });
    }
    return pos;
};
var registerStyle = function (config) {
    var alignment = config.alignment,
        borders = config.borders,
        font = config.font,
        interior = config.interior,
        numberFormat = config.numberFormat,
        protection = config.protection;
    var id = config.id;
    var currentFill = 0;
    var currentBorder = 0;
    var currentFont = 0;
    var currentNumberFmt = 0;
    if (!id) {
        return;
    }
    id = getStyleName(id, currentSheet);
    if (stylesMap[id] != undefined) {
        return;
    }
    if (interior) {
        currentFill = registerFill(interior);
    }
    if (borders) {
        currentBorder = registerBorders(borders);
    }
    if (font) {
        currentFont = registerFont(font);
    }
    if (numberFormat) {
        currentNumberFmt = registerNumberFmt(numberFormat.format);
    }
    stylesMap[id] = registeredCellXfs.length;
    registeredCellXfs.push({
        alignment: alignment,
        borderId: currentBorder || 0,
        fillId: currentFill || 0,
        fontId: currentFont || 0,
        numFmtId: currentNumberFmt || 0,
        protection: protection,
        xfId: 0,
    });
};
var stylesheetFactory = {
    getTemplate: function (defaultFontSize) {
        var numberFormats = numberFormatsFactory.getTemplate(registeredNumberFmts);
        var fonts = fontsFactory.getTemplate(
            registeredFonts.map(function (font) {
                return __assign$Z(__assign$Z({}, font), { size: font.size != null ? font.size : defaultFontSize });
            }),
        );
        var fills = fillsFactory.getTemplate(registeredFills);
        var borders = bordersFactory.getTemplate(registeredBorders);
        var cellStylesXfs = cellStylesXfsFactory.getTemplate(registeredCellStyleXfs);
        var cellXfs = cellXfsFactory.getTemplate(registeredCellXfs);
        var cellStyles = cellStylesFactory.getTemplate(registeredCellStyles);
        resetStylesheetValues();
        return {
            name: 'styleSheet',
            properties: {
                rawMap: {
                    'mc:Ignorable': 'x14ac x16r2 xr',
                    'xmlns': 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
                    'xmlns:mc': 'http://schemas.openxmlformats.org/markup-compatibility/2006',
                    'xmlns:x14ac': 'http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac',
                    'xmlns:x16r2': 'http://schemas.microsoft.com/office/spreadsheetml/2015/02/main',
                    'xmlns:xr': 'http://schemas.microsoft.com/office/spreadsheetml/2014/revision',
                },
            },
            children: [
                numberFormats,
                fonts,
                fills,
                borders,
                cellStylesXfs,
                cellXfs,
                cellStyles,
                {
                    name: 'tableStyles',
                    properties: {
                        rawMap: {
                            count: 0,
                            defaultPivotStyle: 'PivotStyleLight16',
                            defaultTableStyle: 'TableStyleMedium2',
                        },
                    },
                },
            ],
        };
    },
};
var getStyleId = function (name, currentSheet) {
    return stylesMap[getStyleName(name, currentSheet)] || 0;
};
var registerStyles = function (styles, _currentSheet) {
    currentSheet = _currentSheet;
    if (currentSheet === 1) {
        resetStylesheetValues();
    }
    styles.forEach(registerStyle);
};

var sheetFactory = {
    getTemplate: function (name, idx) {
        var sheetId = (idx + 1).toString();
        return {
            name: 'sheet',
            properties: {
                rawMap: {
                    'name': name,
                    'sheetId': sheetId,
                    'r:id': 'rId' + sheetId,
                },
            },
        };
    },
};

var sheetsFactory = {
    getTemplate: function (names) {
        return {
            name: 'sheets',
            children: names.map(function (sheet, idx) {
                return sheetFactory.getTemplate(sheet, idx);
            }),
        };
    },
};

var workbookFactory = {
    getTemplate: function (names) {
        return {
            name: 'workbook',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'xmlns:',
                        map: {
                            r: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
                        },
                    },
                ],
                rawMap: {
                    xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
                },
            },
            children: [sheetsFactory.getTemplate(names)],
        };
    },
};

// https://docs.microsoft.com/en-us/office/troubleshoot/excel/determine-column-widths
var getExcelCellWidth = function (width) {
    return Math.ceil((width - 12) / 7 + 1);
};
var columnFactory = {
    getTemplate: function (config) {
        var min = config.min,
            max = config.max,
            outlineLevel = config.outlineLevel,
            s = config.s,
            width = config.width,
            hidden = config.hidden,
            bestFit = config.bestFit;
        var excelWidth = 1;
        var customWidth = '0';
        if (width > 1) {
            excelWidth = getExcelCellWidth(width);
            customWidth = '1';
        }
        return {
            name: 'col',
            properties: {
                rawMap: {
                    min: min,
                    max: max,
                    outlineLevel: outlineLevel != null ? outlineLevel : undefined,
                    width: excelWidth,
                    style: s,
                    hidden: hidden ? '1' : '0',
                    bestFit: bestFit ? '1' : '0',
                    customWidth: customWidth,
                },
            },
        };
    },
};

var convertLegacyType = function (type) {
    var t = type.charAt(0).toLowerCase();
    return t === 's' ? 'inlineStr' : t;
};
var cellFactory = {
    getTemplate: function (config, idx, currentSheet) {
        var ref = config.ref,
            data = config.data,
            styleId = config.styleId;
        var _a = data || { type: 'empty', value: null },
            type = _a.type,
            value = _a.value;
        var convertedType = type;
        if (type === 'f') {
            convertedType = 'str';
        } else if (type.charAt(0) === type.charAt(0).toUpperCase()) {
            convertedType = convertLegacyType(type);
        }
        var obj = {
            name: 'c',
            properties: {
                rawMap: {
                    r: ref,
                    t: convertedType === 'empty' ? undefined : convertedType,
                    s: styleId ? getStyleId(styleId, currentSheet) : undefined,
                },
            },
        };
        if (convertedType === 'empty') {
            return obj;
        }
        var children;
        if (convertedType === 'str' && type === 'f') {
            children = [
                {
                    name: 'f',
                    textNode: _.escapeString(_.utf8_encode(value)),
                },
            ];
        } else if (convertedType === 'inlineStr') {
            children = [
                {
                    name: 'is',
                    children: [
                        {
                            name: 't',
                            textNode: _.escapeString(_.utf8_encode(value)),
                        },
                    ],
                },
            ];
        } else {
            children = [
                {
                    name: 'v',
                    textNode: value,
                },
            ];
        }
        return Object.assign({}, obj, { children: children });
    },
};

var __read$1c =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$K =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var addEmptyCells = function (cells, rowIdx) {
    var mergeMap = [];
    var posCounter = 0;
    for (var i = 0; i < cells.length; i++) {
        var cell = cells[i];
        if (cell.mergeAcross) {
            mergeMap.push({
                pos: i,
                excelPos: posCounter,
            });
            posCounter += cell.mergeAcross;
        }
        posCounter++;
    }
    if (mergeMap.length) {
        for (var i = mergeMap.length - 1; i >= 0; i--) {
            var mergedCells = [];
            var cell = cells[mergeMap[i].pos];
            for (var j = 1; j <= cell.mergeAcross; j++) {
                mergedCells.push({
                    ref: '' + getExcelColumnName(mergeMap[i].excelPos + 1 + j) + (rowIdx + 1),
                    styleId: cell.styleId,
                    data: { type: 'empty', value: null },
                });
            }
            if (mergedCells.length) {
                cells.splice.apply(cells, __spreadArray$K([mergeMap[i].pos + 1, 0], __read$1c(mergedCells)));
            }
        }
    }
};
var shouldDisplayCell = function (cell) {
    var _a;
    return ((_a = cell.data) === null || _a === void 0 ? void 0 : _a.value) !== '' || cell.styleId !== undefined;
};
var rowFactory = {
    getTemplate: function (config, idx, currentSheet) {
        var collapsed = config.collapsed,
            hidden = config.hidden,
            height = config.height,
            outlineLevel = config.outlineLevel,
            _a = config.cells,
            cells = _a === void 0 ? [] : _a;
        addEmptyCells(cells, idx);
        var children = cells.filter(shouldDisplayCell).map(function (cell, idx) {
            return cellFactory.getTemplate(cell, idx, currentSheet);
        });
        return {
            name: 'row',
            properties: {
                rawMap: {
                    r: idx + 1,
                    collapsed: collapsed ? '1' : '0',
                    hidden: hidden ? '1' : '0',
                    ht: height,
                    customHeight: height != null ? '1' : '0',
                    spans: '1:1',
                    outlineLevel: outlineLevel || undefined,
                },
            },
            children: children,
        };
    },
};

var mergeCellFactory = {
    getTemplate: function (ref) {
        return {
            name: 'mergeCell',
            properties: {
                rawMap: {
                    ref: ref,
                },
            },
        };
    },
};

var getMergedCellsAndAddColumnGroups = function (rows, cols, suppressColumnOutline) {
    var mergedCells = [];
    var cellsWithCollapsibleGroups = [];
    rows.forEach(function (currentRow, rowIdx) {
        var cells = currentRow.cells;
        var merges = 0;
        var lastCol;
        cells.forEach(function (currentCell, cellIdx) {
            var min = cellIdx + merges + 1;
            var start = getExcelColumnName(min);
            var outputRow = rowIdx + 1;
            if (currentCell.mergeAcross) {
                merges += currentCell.mergeAcross;
                var end = getExcelColumnName(cellIdx + merges + 1);
                mergedCells.push('' + start + outputRow + ':' + end + outputRow);
            }
            if (!cols[min - 1]) {
                cols[min - 1] = {};
            }
            var collapsibleRanges = currentCell.collapsibleRanges;
            if (collapsibleRanges) {
                collapsibleRanges.forEach(function (range) {
                    cellsWithCollapsibleGroups.push([min + range[0], min + range[1]]);
                });
            }
            lastCol = cols[min - 1];
            lastCol.min = min;
            lastCol.max = min;
            currentCell.ref = '' + start + outputRow;
        });
    });
    cellsWithCollapsibleGroups.sort(function (a, b) {
        if (a[0] !== b[0]) {
            return a[0] - b[0];
        }
        return b[1] - a[1];
    });
    var rangeMap = new Map();
    var outlineLevel = new Map();
    cellsWithCollapsibleGroups
        .filter(function (currentRange) {
            var rangeString = currentRange.toString();
            var inMap = rangeMap.get(rangeString);
            if (inMap) {
                return false;
            }
            rangeMap.set(rangeString, true);
            return true;
        })
        .forEach(function (range) {
            var refCol = cols.find(function (col) {
                return col.min == range[0] && col.max == range[1];
            });
            var currentOutlineLevel = outlineLevel.get(range[0]);
            cols.push({
                min: range[0],
                max: range[1],
                outlineLevel: suppressColumnOutline ? undefined : currentOutlineLevel || 1,
                width: (refCol || { width: 100 }).width,
            });
            outlineLevel.set(range[0], (currentOutlineLevel || 0) + 1);
        });
    return mergedCells;
};
var getPageOrientation = function (orientation) {
    if (!orientation || (orientation !== 'Portrait' && orientation !== 'Landscape')) {
        return 'portrait';
    }
    return orientation.toLocaleLowerCase();
};
var getPageSize = function (pageSize) {
    if (pageSize == null) {
        return 1;
    }
    var positions = [
        'Letter',
        'Letter Small',
        'Tabloid',
        'Ledger',
        'Legal',
        'Statement',
        'Executive',
        'A3',
        'A4',
        'A4 Small',
        'A5',
        'A6',
        'B4',
        'B5',
        'Folio',
        'Envelope',
        'Envelope DL',
        'Envelope C5',
        'Envelope B5',
        'Envelope C3',
        'Envelope C4',
        'Envelope C6',
        'Envelope Monarch',
        'Japanese Postcard',
        'Japanese Double Postcard',
    ];
    var pos = positions.indexOf(pageSize);
    return pos === -1 ? 1 : pos + 1;
};
var addColumns = function (columns) {
    return function (children) {
        if (columns.length) {
            children.push({
                name: 'cols',
                children: columns.map(function (column) {
                    return columnFactory.getTemplate(column);
                }),
            });
        }
        return children;
    };
};
var addSheetData = function (rows, sheetNumber) {
    return function (children) {
        if (rows.length) {
            children.push({
                name: 'sheetData',
                children: rows.map(function (row, idx) {
                    return rowFactory.getTemplate(row, idx, sheetNumber);
                }),
            });
        }
        return children;
    };
};
var addMergeCells = function (mergeCells) {
    return function (children) {
        if (mergeCells.length) {
            children.push({
                name: 'mergeCells',
                properties: {
                    rawMap: {
                        count: mergeCells.length,
                    },
                },
                children: mergeCells.map(function (mergedCell) {
                    return mergeCellFactory.getTemplate(mergedCell);
                }),
            });
        }
        return children;
    };
};
var addPageMargins = function (margins) {
    return function (children) {
        var _a = margins.top,
            top = _a === void 0 ? 0.75 : _a,
            _b = margins.right,
            right = _b === void 0 ? 0.7 : _b,
            _c = margins.bottom,
            bottom = _c === void 0 ? 0.75 : _c,
            _d = margins.left,
            left = _d === void 0 ? 0.7 : _d,
            _e = margins.header,
            header = _e === void 0 ? 0.3 : _e,
            _f = margins.footer,
            footer = _f === void 0 ? 0.3 : _f;
        children.push({
            name: 'pageMargins',
            properties: {
                rawMap: { bottom: bottom, footer: footer, header: header, left: left, right: right, top: top },
            },
        });
        return children;
    };
};
var addPageSetup = function (pageSetup) {
    return function (children) {
        if (pageSetup) {
            children.push({
                name: 'pageSetup',
                properties: {
                    rawMap: {
                        horizontalDpi: 0,
                        verticalDpi: 0,
                        orientation: getPageOrientation(pageSetup.orientation),
                        paperSize: getPageSize(pageSetup.pageSize),
                    },
                },
            });
        }
        return children;
    };
};
var replaceHeaderFooterTokens = function (value) {
    var map = {
        '&[Page]': '&P',
        '&[Pages]': '&N',
        '&[Date]': '&D',
        '&[Time]': '&T',
        '&[Tab]': '&A',
        '&[Path]': '&Z',
        '&[File]': '&F',
    };
    _.iterateObject(map, function (key, val) {
        value = value.replace(key, val);
    });
    return value;
};
var getHeaderPosition = function (position) {
    if (position === 'Center') {
        return 'C';
    }
    if (position === 'Right') {
        return 'R';
    }
    return 'L';
};
var applyHeaderFontStyle = function (headerString, font) {
    if (!font) {
        return headerString;
    }
    headerString += '&amp;&quot;';
    headerString += font.fontName || 'Calibri';
    if (font.bold !== font.italic) {
        headerString += font.bold ? ',Bold' : ',Italic';
    } else if (font.bold) {
        headerString += ',Bold Italic';
    } else {
        headerString += ',Regular';
    }
    headerString += '&quot;';
    if (font.size) {
        headerString += '&amp;' + font.size;
    }
    if (font.strikeThrough) {
        headerString += '&amp;S';
    }
    if (font.underline) {
        headerString += '&amp;' + (font.underline === 'Double' ? 'E' : 'U');
    }
    if (font.color) {
        headerString += '&amp;K' + font.color.replace('#', '').toUpperCase();
    }
    return headerString;
};
var processHeaderFooterContent = function (content) {
    return content.reduce(function (prev, curr) {
        var pos = getHeaderPosition(curr.position);
        var output = applyHeaderFontStyle(prev + '&amp;' + pos, curr.font);
        return '' + output + _.escapeString(_.utf8_encode(replaceHeaderFooterTokens(curr.value)));
    }, '');
};
var buildHeaderFooter = function (headerFooterConfig) {
    var rules = ['all', 'first', 'even'];
    var headersAndFooters = [];
    rules.forEach(function (rule) {
        var headerFooter = headerFooterConfig[rule];
        var namePrefix = rule === 'all' ? 'odd' : rule;
        if (!headerFooter || (!headerFooter.header && !headerFooter.footer)) {
            return;
        }
        _.iterateObject(headerFooter, function (key, value) {
            var nameSuffix = '' + key.charAt(0).toUpperCase() + key.slice(1);
            if (value) {
                headersAndFooters.push({
                    name: '' + namePrefix + nameSuffix,
                    properties: {
                        rawMap: {
                            'xml:space': 'preserve',
                        },
                    },
                    textNode: processHeaderFooterContent(value),
                });
            }
        });
    });
    return headersAndFooters;
};
var addHeaderFooter = function (headerFooterConfig) {
    return function (children) {
        if (!headerFooterConfig) {
            return children;
        }
        var differentFirst = headerFooterConfig.first != null ? 1 : 0;
        var differentOddEven = headerFooterConfig.even != null ? 1 : 0;
        children.push({
            name: 'headerFooter',
            properties: {
                rawMap: {
                    differentFirst: differentFirst,
                    differentOddEven: differentOddEven,
                },
            },
            children: buildHeaderFooter(headerFooterConfig),
        });
        return children;
    };
};
var addDrawingRel = function (currentSheet) {
    return function (children) {
        if (ExcelXlsxFactory.worksheetImages.get(currentSheet)) {
            children.push({
                name: 'drawing',
                properties: {
                    rawMap: {
                        'r:id': 'rId1',
                    },
                },
            });
        }
        return children;
    };
};
var addSheetPr = function () {
    return function (children) {
        children.push({
            name: 'sheetPr',
            children: [
                {
                    name: 'outlinePr',
                    properties: {
                        rawMap: {
                            summaryBelow: 0,
                        },
                    },
                },
            ],
        });
        return children;
    };
};
var addSheetFormatPr = function (rows) {
    return function (children) {
        var maxOutline = rows.reduce(function (prev, row) {
            if (row.outlineLevel && row.outlineLevel > prev) {
                return row.outlineLevel;
            }
            return prev;
        }, 0);
        children.push({
            name: 'sheetFormatPr',
            properties: {
                rawMap: {
                    baseColWidth: 10,
                    defaultRowHeight: 16,
                    outlineLevelRow: maxOutline ? maxOutline : undefined,
                },
            },
        });
        return children;
    };
};
var worksheetFactory = {
    getTemplate: function (params) {
        var worksheet = params.worksheet,
            currentSheet = params.currentSheet,
            config = params.config;
        var _a = config.margins,
            margins = _a === void 0 ? {} : _a,
            pageSetup = config.pageSetup,
            headerFooterConfig = config.headerFooterConfig,
            suppressColumnOutline = config.suppressColumnOutline;
        var table = worksheet.table;
        var rows = table.rows,
            columns = table.columns;
        var mergedCells =
            columns && columns.length ? getMergedCellsAndAddColumnGroups(rows, columns, !!suppressColumnOutline) : [];
        var createWorksheetChildren = _.compose(
            addSheetPr(),
            addSheetFormatPr(rows),
            addColumns(columns),
            addSheetData(rows, currentSheet + 1),
            addMergeCells(mergedCells),
            addPageMargins(margins),
            addPageSetup(pageSetup),
            addHeaderFooter(headerFooterConfig),
            addDrawingRel(currentSheet),
        );
        var children = createWorksheetChildren([]);
        return {
            name: 'worksheet',
            properties: {
                prefixedAttributes: [
                    {
                        prefix: 'xmlns:',
                        map: {
                            r: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
                        },
                    },
                ],
                rawMap: {
                    xmlns: 'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
                },
            },
            children: children,
        };
    },
};

var relationshipFactory = {
    getTemplate: function (config) {
        var Id = config.Id,
            Type = config.Type,
            Target = config.Target;
        return {
            name: 'Relationship',
            properties: {
                rawMap: {
                    Id: Id,
                    Type: Type,
                    Target: Target,
                },
            },
        };
    },
};

var relationshipsFactory = {
    getTemplate: function (c) {
        var children = c.map(function (relationship) {
            return relationshipFactory.getTemplate(relationship);
        });
        return {
            name: 'Relationships',
            properties: {
                rawMap: {
                    xmlns: 'http://schemas.openxmlformats.org/package/2006/relationships',
                },
            },
            children: children,
        };
    },
};

var __read$1b =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$J =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
/**
 * See https://www.ecma-international.org/news/TC45_current_work/OpenXML%20White%20Paper.pdf
 */
var ExcelXlsxFactory = /** @class */ (function () {
    function ExcelXlsxFactory() {}
    ExcelXlsxFactory.createExcel = function (styles, worksheet, config) {
        this.addSheetName(worksheet);
        registerStyles(styles, this.sheetNames.length);
        return this.createWorksheet(worksheet, config);
    };
    ExcelXlsxFactory.buildImageMap = function (image, rowIndex, col, columnsToExport, rowHeight) {
        var currentSheetIndex = this.sheetNames.length;
        var registeredImage = this.images.get(image.id);
        if (!image.position || !image.position.row || !image.position.column) {
            if (!image.position) {
                image.position = {};
            }
            image.position = Object.assign({}, image.position, {
                row: rowIndex,
                column: columnsToExport.indexOf(col) + 1,
            });
        }
        var calculatedImage = image;
        setExcelImageTotalWidth(calculatedImage, columnsToExport);
        setExcelImageTotalHeight(calculatedImage, rowHeight);
        if (registeredImage) {
            var currentSheetImages = registeredImage.find(function (currentImage) {
                return currentImage.sheetId === currentSheetIndex;
            });
            if (currentSheetImages) {
                currentSheetImages.image.push(calculatedImage);
            } else {
                registeredImage.push({
                    sheetId: currentSheetIndex,
                    image: [calculatedImage],
                });
            }
        } else {
            this.images.set(calculatedImage.id, [{ sheetId: currentSheetIndex, image: [calculatedImage] }]);
            this.workbookImageIds.set(calculatedImage.id, {
                type: calculatedImage.imageType,
                index: this.workbookImageIds.size,
            });
        }
        this.buildSheetImageMap(currentSheetIndex, calculatedImage);
    };
    ExcelXlsxFactory.buildSheetImageMap = function (sheetIndex, image) {
        var worksheetImageIdMap = this.worksheetImageIds.get(sheetIndex);
        if (!worksheetImageIdMap) {
            worksheetImageIdMap = new Map();
            this.worksheetImageIds.set(sheetIndex, worksheetImageIdMap);
        }
        var sheetImages = this.worksheetImages.get(sheetIndex);
        if (!sheetImages) {
            this.worksheetImages.set(sheetIndex, [image]);
            worksheetImageIdMap.set(image.id, { index: 0, type: image.imageType });
        } else {
            sheetImages.push(image);
            if (!worksheetImageIdMap.get(image.id)) {
                worksheetImageIdMap.set(image.id, { index: worksheetImageIdMap.size, type: image.imageType });
            }
        }
    };
    ExcelXlsxFactory.addSheetName = function (worksheet) {
        var name = _.escapeString(worksheet.name) || '';
        var append = '';
        while (this.sheetNames.indexOf('' + name + append) !== -1) {
            if (append === '') {
                append = '_1';
            } else {
                var curr = parseInt(append.slice(1), 10);
                append = '_' + (curr + 1);
            }
        }
        worksheet.name = '' + name + append;
        this.sheetNames.push(worksheet.name);
    };
    ExcelXlsxFactory.getStringPosition = function (str) {
        if (this.sharedStrings.has(str)) {
            return this.sharedStrings.get(str);
        }
        this.sharedStrings.set(str, this.sharedStrings.size);
        return this.sharedStrings.size - 1;
    };
    ExcelXlsxFactory.resetFactory = function () {
        this.sharedStrings = new Map();
        this.images = new Map();
        this.worksheetImages = new Map();
        this.workbookImageIds = new Map();
        this.worksheetImageIds = new Map();
        this.sheetNames = [];
        this.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
    };
    ExcelXlsxFactory.createWorkbook = function () {
        return createXmlPart(workbookFactory.getTemplate(this.sheetNames));
    };
    ExcelXlsxFactory.createStylesheet = function (defaultFontSize) {
        return createXmlPart(stylesheetFactory.getTemplate(defaultFontSize));
    };
    ExcelXlsxFactory.createSharedStrings = function () {
        return createXmlPart(sharedStrings.getTemplate(this.sharedStrings));
    };
    ExcelXlsxFactory.createCore = function (author) {
        return createXmlPart(coreFactory.getTemplate(author));
    };
    ExcelXlsxFactory.createContentTypes = function (sheetLen) {
        return createXmlPart(contentTypesFactory.getTemplate(sheetLen));
    };
    ExcelXlsxFactory.createRels = function () {
        var rs = relationshipsFactory.getTemplate([
            {
                Id: 'rId1',
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument',
                Target: 'xl/workbook.xml',
            },
            {
                Id: 'rId2',
                Type: 'http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties',
                Target: 'docProps/core.xml',
            },
        ]);
        return createXmlPart(rs);
    };
    ExcelXlsxFactory.createTheme = function () {
        return createXmlPart(officeTheme.getTemplate());
    };
    ExcelXlsxFactory.createWorkbookRels = function (sheetLen) {
        var worksheets = new Array(sheetLen).fill(undefined).map(function (v, i) {
            return {
                Id: 'rId' + (i + 1),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet',
                Target: 'worksheets/sheet' + (i + 1) + '.xml',
            };
        });
        var rs = relationshipsFactory.getTemplate(
            __spreadArray$J(__spreadArray$J([], __read$1b(worksheets)), [
                {
                    Id: 'rId' + (sheetLen + 1),
                    Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme',
                    Target: 'theme/theme1.xml',
                },
                {
                    Id: 'rId' + (sheetLen + 2),
                    Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles',
                    Target: 'styles.xml',
                },
                {
                    Id: 'rId' + (sheetLen + 3),
                    Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings',
                    Target: 'sharedStrings.xml',
                },
            ]),
        );
        return createXmlPart(rs);
    };
    ExcelXlsxFactory.createDrawing = function (sheetIndex) {
        return createXmlPart(drawingFactory.getTemplate({ sheetIndex: sheetIndex }));
    };
    ExcelXlsxFactory.createDrawingRel = function (sheetIndex) {
        var _this = this;
        var worksheetImageIds = this.worksheetImageIds.get(sheetIndex);
        var XMLArr = [];
        worksheetImageIds.forEach(function (value, key) {
            XMLArr.push({
                Id: 'rId' + (value.index + 1),
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/image',
                Target: '../media/image' + (_this.workbookImageIds.get(key).index + 1) + '.' + value.type,
            });
        });
        return createXmlPart(relationshipsFactory.getTemplate(XMLArr));
    };
    ExcelXlsxFactory.createWorksheetDrawingRel = function (currentRelationIndex) {
        var rs = relationshipsFactory.getTemplate([
            {
                Id: 'rId1',
                Type: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing',
                Target: '../drawings/drawing' + (currentRelationIndex + 1) + '.xml',
            },
        ]);
        return createXmlPart(rs);
    };
    ExcelXlsxFactory.createWorksheet = function (worksheet, config) {
        return createXmlPart(
            worksheetFactory.getTemplate({
                worksheet: worksheet,
                currentSheet: this.sheetNames.length - 1,
                config: config,
            }),
        );
    };
    ExcelXlsxFactory.sharedStrings = new Map();
    ExcelXlsxFactory.sheetNames = [];
    /** Maps images to sheet */
    ExcelXlsxFactory.images = new Map();
    /** Maps sheets to images */
    ExcelXlsxFactory.worksheetImages = new Map();
    /** Maps all workbook images to a global Id */
    ExcelXlsxFactory.workbookImageIds = new Map();
    /** Maps all sheet images to unique Ids */
    ExcelXlsxFactory.worksheetImageIds = new Map();
    ExcelXlsxFactory.factoryMode = ExcelFactoryMode.SINGLE_SHEET;
    return ExcelXlsxFactory;
})();

var __extends$2U =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var ExcelXlsxSerializingSession = /** @class */ (function (_super) {
    __extends$2U(ExcelXlsxSerializingSession, _super);
    function ExcelXlsxSerializingSession() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ExcelXlsxSerializingSession.prototype.createExcel = function (data) {
        var _a = this,
            excelStyles = _a.excelStyles,
            config = _a.config;
        return ExcelXlsxFactory.createExcel(excelStyles, data, config);
    };
    ExcelXlsxSerializingSession.prototype.getDataTypeForValue = function (valueForCell) {
        if (valueForCell === undefined) {
            return 'empty';
        }
        return this.isNumerical(valueForCell) ? 'n' : 's';
    };
    ExcelXlsxSerializingSession.prototype.getType = function (type, style, value) {
        if (this.isFormula(value)) {
            return 'f';
        }
        if (style && style.dataType) {
            switch (style.dataType.toLocaleLowerCase()) {
                case 'formula':
                    return 'f';
                case 'string':
                    return 's';
                case 'number':
                    return 'n';
                case 'datetime':
                    return 'd';
                case 'error':
                    return 'e';
                case 'boolean':
                    return 'b';
                default:
                    console.warn(
                        'AG Grid: Unrecognized data type for excel export [' +
                            style.id +
                            '.dataType=' +
                            style.dataType +
                            ']',
                    );
            }
        }
        return type;
    };
    ExcelXlsxSerializingSession.prototype.addImage = function (rowIndex, column, value) {
        if (!this.config.addImageToCell) {
            return;
        }
        var addedImage = this.config.addImageToCell(rowIndex, column, value);
        if (!addedImage) {
            return;
        }
        ExcelXlsxFactory.buildImageMap(addedImage.image, rowIndex, column, this.columnsToExport, this.config.rowHeight);
        return addedImage;
    };
    ExcelXlsxSerializingSession.prototype.createCell = function (styleId, type, value, valueFormatted) {
        var actualStyle = this.getStyleById(styleId);
        if (
            !(actualStyle === null || actualStyle === void 0 ? void 0 : actualStyle.dataType) &&
            type === 's' &&
            valueFormatted
        ) {
            value = valueFormatted;
        }
        var typeTransformed = this.getType(type, actualStyle, value) || type;
        return {
            styleId: actualStyle ? styleId : undefined,
            data: {
                type: typeTransformed,
                value: this.getCellValue(typeTransformed, value),
            },
        };
    };
    ExcelXlsxSerializingSession.prototype.createMergedCell = function (styleId, type, value, numOfCells) {
        var valueToUse = value == null ? '' : value;
        return {
            styleId: !!this.getStyleById(styleId) ? styleId : undefined,
            data: {
                type: type,
                value: type === 's' ? ExcelXlsxFactory.getStringPosition(valueToUse).toString() : value,
            },
            mergeAcross: numOfCells,
        };
    };
    ExcelXlsxSerializingSession.prototype.getCellValue = function (type, value) {
        if (value == null) {
            return ExcelXlsxFactory.getStringPosition('').toString();
        }
        switch (type) {
            case 's':
                return value === '' ? '' : ExcelXlsxFactory.getStringPosition(value).toString();
            case 'f':
                return value.slice(1);
            case 'n':
                return Number(value).toString();
            default:
                return value;
        }
    };
    return ExcelXlsxSerializingSession;
})(BaseExcelSerializingSession);

var __extends$2T =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$Y =
    (undefined && undefined.__assign) ||
    function () {
        __assign$Y =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$Y.apply(this, arguments);
    };
var __decorate$23 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var getMultipleSheetsAsExcel = function (params) {
    var data = params.data,
        _a = params.fontSize,
        fontSize = _a === void 0 ? 11 : _a,
        _b = params.author,
        author = _b === void 0 ? 'AG Grid' : _b;
    var hasImages = ExcelXlsxFactory.images.size > 0;
    ZipContainer.addFolders(['_rels/', 'docProps/', 'xl/', 'xl/theme/', 'xl/_rels/', 'xl/worksheets/']);
    if (hasImages) {
        ZipContainer.addFolders(['xl/worksheets/_rels', 'xl/drawings/', 'xl/drawings/_rels', 'xl/media/']);
        var imgCounter_1 = 0;
        ExcelXlsxFactory.images.forEach(function (value) {
            var firstImage = value[0].image[0];
            var ext = firstImage.imageType;
            ZipContainer.addFile('xl/media/image' + ++imgCounter_1 + '.' + ext, firstImage.base64, true);
        });
    }
    if (!data || data.length === 0) {
        console.warn(
            'AG Grid: Invalid params supplied to getMultipleSheetsAsExcel() - `ExcelExportParams.data` is empty.',
        );
        ExcelXlsxFactory.resetFactory();
        return;
    }
    var sheetLen = data.length;
    var imageRelationCounter = 0;
    data.forEach(function (value, idx) {
        ZipContainer.addFile('xl/worksheets/sheet' + (idx + 1) + '.xml', value);
        if (hasImages && ExcelXlsxFactory.worksheetImages.get(idx)) {
            createImageRelationsForSheet(idx, imageRelationCounter++);
        }
    });
    ZipContainer.addFile('xl/workbook.xml', ExcelXlsxFactory.createWorkbook());
    ZipContainer.addFile('xl/styles.xml', ExcelXlsxFactory.createStylesheet(fontSize));
    ZipContainer.addFile('xl/sharedStrings.xml', ExcelXlsxFactory.createSharedStrings());
    ZipContainer.addFile('xl/theme/theme1.xml', ExcelXlsxFactory.createTheme());
    ZipContainer.addFile('xl/_rels/workbook.xml.rels', ExcelXlsxFactory.createWorkbookRels(sheetLen));
    ZipContainer.addFile('docProps/core.xml', ExcelXlsxFactory.createCore(author));
    ZipContainer.addFile('[Content_Types].xml', ExcelXlsxFactory.createContentTypes(sheetLen));
    ZipContainer.addFile('_rels/.rels', ExcelXlsxFactory.createRels());
    ExcelXlsxFactory.resetFactory();
    var mimeType = params.mimeType || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    return ZipContainer.getContent(mimeType);
};
var exportMultipleSheetsAsExcel = function (params) {
    var _a = params.fileName,
        fileName = _a === void 0 ? 'export.xlsx' : _a;
    var contents = getMultipleSheetsAsExcel(params);
    if (contents) {
        Downloader.download(fileName, contents);
    }
};
var createImageRelationsForSheet = function (sheetIndex, currentRelationIndex) {
    var drawingFolder = 'xl/drawings';
    var drawingFileName = drawingFolder + '/drawing' + (currentRelationIndex + 1) + '.xml';
    var relFileName = drawingFolder + '/_rels/drawing' + (currentRelationIndex + 1) + '.xml.rels';
    var worksheetRelFile = 'xl/worksheets/_rels/sheet' + (sheetIndex + 1) + '.xml.rels';
    ZipContainer.addFile(relFileName, ExcelXlsxFactory.createDrawingRel(sheetIndex));
    ZipContainer.addFile(drawingFileName, ExcelXlsxFactory.createDrawing(sheetIndex));
    ZipContainer.addFile(worksheetRelFile, ExcelXlsxFactory.createWorksheetDrawingRel(currentRelationIndex));
};
var ExcelCreator = /** @class */ (function (_super) {
    __extends$2T(ExcelCreator, _super);
    function ExcelCreator() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.exportMode = 'xlsx';
        return _this;
    }
    ExcelCreator.prototype.postConstruct = function () {
        this.setBeans({
            gridSerializer: this.gridSerializer,
            gridOptionsService: this.gridOptionsService,
        });
    };
    ExcelCreator.prototype.getMergedParams = function (params) {
        var baseParams = this.gridOptionsService.get('defaultExcelExportParams');
        return Object.assign({}, baseParams, params);
    };
    ExcelCreator.prototype.getData = function (params) {
        this.setExportMode(params.exportMode || 'xlsx');
        return _super.prototype.getData.call(this, params);
    };
    ExcelCreator.prototype.export = function (userParams) {
        if (this.isExportSuppressed()) {
            console.warn('AG Grid: Export cancelled. Export is not allowed as per your configuration.');
            return '';
        }
        var mergedParams = this.getMergedParams(userParams);
        var data = this.getData(mergedParams);
        var exportParams = {
            data: [data],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType,
        };
        var packageFile = this.packageFile(exportParams);
        if (packageFile) {
            Downloader.download(this.getFileName(mergedParams.fileName), packageFile);
        }
        return data;
    };
    ExcelCreator.prototype.exportDataAsExcel = function (params) {
        return this.export(params);
    };
    ExcelCreator.prototype.getDataAsExcel = function (params) {
        var mergedParams = this.getMergedParams(params);
        var data = this.getData(mergedParams);
        if (params && params.exportMode === 'xml') {
            return data;
        }
        var exportParams = {
            data: [data],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType,
        };
        return this.packageFile(exportParams);
    };
    ExcelCreator.prototype.setFactoryMode = function (factoryMode, exportMode) {
        if (exportMode === void 0) {
            exportMode = 'xlsx';
        }
        var factory = exportMode === 'xlsx' ? ExcelXlsxFactory : ExcelXmlFactory;
        factory.factoryMode = factoryMode;
    };
    ExcelCreator.prototype.getFactoryMode = function (exportMode) {
        var factory = exportMode === 'xlsx' ? ExcelXlsxFactory : ExcelXmlFactory;
        return factory.factoryMode;
    };
    ExcelCreator.prototype.getSheetDataForExcel = function (params) {
        var mergedParams = this.getMergedParams(params);
        var data = this.getData(mergedParams);
        return data;
    };
    ExcelCreator.prototype.getMultipleSheetsAsExcel = function (params) {
        return getMultipleSheetsAsExcel(params);
    };
    ExcelCreator.prototype.exportMultipleSheetsAsExcel = function (params) {
        return exportMultipleSheetsAsExcel(params);
    };
    ExcelCreator.prototype.getDefaultFileName = function () {
        return 'export.' + this.getExportMode();
    };
    ExcelCreator.prototype.getDefaultFileExtension = function () {
        return this.getExportMode();
    };
    ExcelCreator.prototype.createSerializingSession = function (params) {
        var _a = this,
            columnModel = _a.columnModel,
            valueService = _a.valueService,
            gridOptionsService = _a.gridOptionsService,
            valueFormatterService = _a.valueFormatterService,
            valueParserService = _a.valueParserService;
        var isXlsx = this.getExportMode() === 'xlsx';
        var sheetName = 'ag-grid';
        if (params.sheetName != null) {
            sheetName = _.utf8_encode(params.sheetName.toString().substr(0, 31));
        }
        var config = __assign$Y(__assign$Y({}, params), {
            sheetName: sheetName,
            columnModel: columnModel,
            valueService: valueService,
            gridOptionsService: gridOptionsService,
            valueFormatterService: valueFormatterService,
            valueParserService: valueParserService,
            headerRowHeight: params.headerRowHeight || params.rowHeight,
            baseExcelStyles: this.gridOptionsService.get('excelStyles') || [],
            styleLinker: this.styleLinker.bind(this),
        });
        return new (isXlsx ? ExcelXlsxSerializingSession : ExcelXmlSerializingSession)(config);
    };
    ExcelCreator.prototype.styleLinker = function (params) {
        var rowType = params.rowType,
            rowIndex = params.rowIndex,
            value = params.value,
            column = params.column,
            columnGroup = params.columnGroup,
            node = params.node;
        var isHeader = rowType === RowType.HEADER;
        var isGroupHeader = rowType === RowType.HEADER_GROUPING;
        var col = isHeader ? column : columnGroup;
        var headerClasses = [];
        if (isHeader || isGroupHeader) {
            headerClasses.push('header');
            if (isGroupHeader) {
                headerClasses.push('headerGroup');
            }
            if (col) {
                headerClasses = headerClasses.concat(
                    CssClassApplier.getHeaderClassesFromColDef(
                        col.getDefinition(),
                        this.gridOptionsService,
                        column || null,
                        columnGroup || null,
                    ),
                );
            }
            return headerClasses;
        }
        var styles = this.gridOptionsService.get('excelStyles');
        var applicableStyles = ['cell'];
        if (!styles || !styles.length) {
            return applicableStyles;
        }
        var styleIds = styles.map(function (it) {
            return it.id;
        });
        this.stylingService.processAllCellClasses(
            column.getDefinition(),
            {
                value: value,
                data: node.data,
                node: node,
                colDef: column.getDefinition(),
                column: column,
                rowIndex: rowIndex,
                api: this.gridOptionsService.api,
                columnApi: this.gridOptionsService.columnApi,
                context: this.gridOptionsService.context,
            },
            function (className) {
                if (styleIds.indexOf(className) > -1) {
                    applicableStyles.push(className);
                }
            },
        );
        return applicableStyles.sort(function (left, right) {
            return styleIds.indexOf(left) < styleIds.indexOf(right) ? -1 : 1;
        });
    };
    ExcelCreator.prototype.isExportSuppressed = function () {
        return this.gridOptionsService.is('suppressExcelExport');
    };
    ExcelCreator.prototype.setExportMode = function (exportMode) {
        this.exportMode = exportMode;
    };
    ExcelCreator.prototype.getExportMode = function () {
        return this.exportMode;
    };
    ExcelCreator.prototype.packageFile = function (params) {
        if (this.getExportMode() === 'xml') {
            var mimeType = params.mimeType || 'application/vnd.ms-excel';
            return new Blob(['\ufeff', params.data[0]], { type: mimeType });
        }
        return getMultipleSheetsAsExcel(params);
    };
    __decorate$23([Autowired('columnModel')], ExcelCreator.prototype, 'columnModel', void 0);
    __decorate$23([Autowired('valueService')], ExcelCreator.prototype, 'valueService', void 0);
    __decorate$23([Autowired('stylingService')], ExcelCreator.prototype, 'stylingService', void 0);
    __decorate$23([Autowired('gridSerializer')], ExcelCreator.prototype, 'gridSerializer', void 0);
    __decorate$23([Autowired('gridOptionsService')], ExcelCreator.prototype, 'gridOptionsService', void 0);
    __decorate$23([Autowired('valueFormatterService')], ExcelCreator.prototype, 'valueFormatterService', void 0);
    __decorate$23([Autowired('valueParserService')], ExcelCreator.prototype, 'valueParserService', void 0);
    __decorate$23([PostConstruct], ExcelCreator.prototype, 'postConstruct', null);
    ExcelCreator = __decorate$23([Bean('excelCreator')], ExcelCreator);
    return ExcelCreator;
})(BaseCreator);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$d = '30.2.0';

var ExcelExportModule = {
    version: VERSION$d,
    moduleName: ModuleNames.ExcelExportModule,
    beans: [
        // beans in this module
        ExcelCreator,
        // these beans are part of CSV Export module
        GridSerializer,
        CsvCreator,
    ],
    dependantModules: [CsvExportModule, EnterpriseCoreModule],
};

var __extends$2S =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$22 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var EXPAND_STATE;
(function (EXPAND_STATE) {
    EXPAND_STATE[(EXPAND_STATE['EXPANDED'] = 0)] = 'EXPANDED';
    EXPAND_STATE[(EXPAND_STATE['COLLAPSED'] = 1)] = 'COLLAPSED';
    EXPAND_STATE[(EXPAND_STATE['INDETERMINATE'] = 2)] = 'INDETERMINATE';
})(EXPAND_STATE || (EXPAND_STATE = {}));
var FiltersToolPanelHeaderPanel = /** @class */ (function (_super) {
    __extends$2S(FiltersToolPanelHeaderPanel, _super);
    function FiltersToolPanelHeaderPanel() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    FiltersToolPanelHeaderPanel.prototype.preConstruct = function () {
        this.setTemplate(
            /* html */ '<div class="ag-filter-toolpanel-search" role="presentation">\n                <div ref="eExpand" class="ag-filter-toolpanel-expand"></div>\n                <ag-input-text-field ref="eFilterTextField" class="ag-filter-toolpanel-search-input"></ag-input-text-field>\n            </div>',
        );
    };
    FiltersToolPanelHeaderPanel.prototype.postConstruct = function () {
        var translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.onValueChange(this.onSearchTextChanged.bind(this));
        this.eFilterTextField.setInputAriaLabel(translate('ariaFilterColumnsInput', 'Filter Columns Input'));
        this.createExpandIcons();
        this.setExpandState(EXPAND_STATE.EXPANDED);
        this.addManagedListener(this.eExpand, 'click', this.onExpandClicked.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
    };
    FiltersToolPanelHeaderPanel.prototype.init = function (params) {
        this.params = params;
        if (this.columnModel.isReady()) {
            this.showOrHideOptions();
        }
    };
    FiltersToolPanelHeaderPanel.prototype.createExpandIcons = function () {
        this.eExpand.appendChild(
            (this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsService)),
        );
        this.eExpand.appendChild(
            (this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsService)),
        );
        this.eExpand.appendChild(
            (this.eExpandIndeterminate = _.createIconNoSpan('columnSelectIndeterminate', this.gridOptionsService)),
        );
    };
    // we only show expand / collapse if we are showing filters
    FiltersToolPanelHeaderPanel.prototype.showOrHideOptions = function () {
        var showFilterSearch = !this.params.suppressFilterSearch;
        var showExpand = !this.params.suppressExpandAll;
        var translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate('searchOoo', 'Search...'));
        var isFilterGroupPresent = function (col) {
            return col.getOriginalParent() && col.isFilterAllowed();
        };
        var filterGroupsPresent = this.columnModel.getAllGridColumns().some(isFilterGroupPresent);
        _.setDisplayed(this.eFilterTextField.getGui(), showFilterSearch);
        _.setDisplayed(this.eExpand, showExpand && filterGroupsPresent);
    };
    FiltersToolPanelHeaderPanel.prototype.onSearchTextChanged = function () {
        var _this = this;
        if (!this.onSearchTextChangedDebounced) {
            this.onSearchTextChangedDebounced = _.debounce(function () {
                _this.dispatchEvent({ type: 'searchChanged', searchText: _this.eFilterTextField.getValue() });
            }, 300);
        }
        this.onSearchTextChangedDebounced();
    };
    FiltersToolPanelHeaderPanel.prototype.onExpandClicked = function () {
        var event = this.currentExpandState === EXPAND_STATE.EXPANDED ? { type: 'collapseAll' } : { type: 'expandAll' };
        this.dispatchEvent(event);
    };
    FiltersToolPanelHeaderPanel.prototype.setExpandState = function (state) {
        this.currentExpandState = state;
        _.setDisplayed(this.eExpandChecked, this.currentExpandState === EXPAND_STATE.EXPANDED);
        _.setDisplayed(this.eExpandUnchecked, this.currentExpandState === EXPAND_STATE.COLLAPSED);
        _.setDisplayed(this.eExpandIndeterminate, this.currentExpandState === EXPAND_STATE.INDETERMINATE);
    };
    __decorate$22([Autowired('columnModel')], FiltersToolPanelHeaderPanel.prototype, 'columnModel', void 0);
    __decorate$22([RefSelector('eExpand')], FiltersToolPanelHeaderPanel.prototype, 'eExpand', void 0);
    __decorate$22([RefSelector('eFilterTextField')], FiltersToolPanelHeaderPanel.prototype, 'eFilterTextField', void 0);
    __decorate$22([PreConstruct], FiltersToolPanelHeaderPanel.prototype, 'preConstruct', null);
    __decorate$22([PostConstruct], FiltersToolPanelHeaderPanel.prototype, 'postConstruct', null);
    return FiltersToolPanelHeaderPanel;
})(Component);

var __extends$2R =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$21 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelFilterComp = /** @class */ (function (_super) {
    __extends$2R(ToolPanelFilterComp, _super);
    function ToolPanelFilterComp(hideHeader) {
        if (hideHeader === void 0) {
            hideHeader = false;
        }
        var _this = _super.call(this, ToolPanelFilterComp.TEMPLATE) || this;
        _this.expanded = false;
        _this.hideHeader = hideHeader;
        return _this;
    }
    ToolPanelFilterComp.prototype.postConstruct = function () {
        this.eExpandChecked = _.createIconNoSpan('columnSelectOpen', this.gridOptionsService);
        this.eExpandUnchecked = _.createIconNoSpan('columnSelectClosed', this.gridOptionsService);
        this.eExpand.appendChild(this.eExpandChecked);
        this.eExpand.appendChild(this.eExpandUnchecked);
    };
    ToolPanelFilterComp.prototype.setColumn = function (column) {
        var _this = this;
        this.column = column;
        this.eFilterName.innerText =
            this.columnModel.getDisplayNameForColumn(this.column, 'filterToolPanel', false) || '';
        this.addManagedListener(this.eFilterToolPanelHeader, 'click', this.toggleExpanded.bind(this));
        this.addManagedListener(this.eFilterToolPanelHeader, 'keydown', function (e) {
            if (e.key === KeyCode.ENTER || e.key === KeyCode.SPACE) {
                e.preventDefault();
                _this.toggleExpanded();
            }
        });
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
        this.addInIcon('filter', this.eFilterIcon, this.column);
        _.setDisplayed(this.eFilterIcon, this.isFilterActive(), { skipAriaHidden: true });
        _.setDisplayed(this.eExpandChecked, false);
        if (this.hideHeader) {
            _.setDisplayed(this.eFilterToolPanelHeader, false);
            this.eFilterToolPanelHeader.removeAttribute('tabindex');
        } else {
            this.eFilterToolPanelHeader.setAttribute('tabindex', '0');
        }
        this.addManagedListener(this.column, Column.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_DESTROYED, this.onFilterDestroyed.bind(this));
    };
    ToolPanelFilterComp.prototype.getColumn = function () {
        return this.column;
    };
    ToolPanelFilterComp.prototype.getColumnFilterName = function () {
        return this.columnModel.getDisplayNameForColumn(this.column, 'filterToolPanel', false);
    };
    ToolPanelFilterComp.prototype.addCssClassToTitleBar = function (cssClass) {
        this.eFilterToolPanelHeader.classList.add(cssClass);
    };
    ToolPanelFilterComp.prototype.addInIcon = function (iconName, eParent, column) {
        if (eParent == null) {
            return;
        }
        var eIcon = _.createIconNoSpan(iconName, this.gridOptionsService, column);
        eParent.appendChild(eIcon);
    };
    ToolPanelFilterComp.prototype.isFilterActive = function () {
        return this.filterManager.isFilterActive(this.column);
    };
    ToolPanelFilterComp.prototype.onFilterChanged = function () {
        _.setDisplayed(this.eFilterIcon, this.isFilterActive(), { skipAriaHidden: true });
        this.dispatchEvent({ type: Column.EVENT_FILTER_CHANGED });
    };
    ToolPanelFilterComp.prototype.onFilterDestroyed = function (event) {
        if (
            this.expanded &&
            event.source === 'api' &&
            event.column.getId() === this.column.getId() &&
            this.columnModel.getPrimaryColumn(this.column)
        ) {
            // filter was visible and has been destroyed by the API. If the column still exists, need to recreate UI component
            this.removeFilterElement();
            this.addFilterElement();
        }
    };
    ToolPanelFilterComp.prototype.toggleExpanded = function () {
        this.expanded ? this.collapse() : this.expand();
    };
    ToolPanelFilterComp.prototype.expand = function () {
        if (this.expanded) {
            return;
        }
        this.expanded = true;
        _.setAriaExpanded(this.eFilterToolPanelHeader, true);
        _.setDisplayed(this.eExpandChecked, true);
        _.setDisplayed(this.eExpandUnchecked, false);
        this.addFilterElement();
    };
    ToolPanelFilterComp.prototype.addFilterElement = function () {
        var _this = this;
        var filterPanelWrapper = _.loadTemplate(/* html */ '<div class="ag-filter-toolpanel-instance-filter"></div>');
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.column, 'TOOLBAR');
        if (!filterWrapper) {
            return;
        }
        var filterPromise = filterWrapper.filterPromise,
            guiPromise = filterWrapper.guiPromise;
        filterPromise === null || filterPromise === void 0
            ? void 0
            : filterPromise.then(function (filter) {
                  _this.underlyingFilter = filter;
                  if (!filter) {
                      return;
                  }
                  guiPromise.then(function (filterContainerEl) {
                      if (filterContainerEl) {
                          filterPanelWrapper.appendChild(filterContainerEl);
                      }
                      _this.agFilterToolPanelBody.appendChild(filterPanelWrapper);
                      if (filter.afterGuiAttached) {
                          filter.afterGuiAttached({ container: 'toolPanel' });
                      }
                  });
              });
    };
    ToolPanelFilterComp.prototype.collapse = function () {
        var _a, _b;
        if (!this.expanded) {
            return;
        }
        this.expanded = false;
        _.setAriaExpanded(this.eFilterToolPanelHeader, false);
        this.removeFilterElement();
        _.setDisplayed(this.eExpandChecked, false);
        _.setDisplayed(this.eExpandUnchecked, true);
        (_b = (_a = this.underlyingFilter) === null || _a === void 0 ? void 0 : _a.afterGuiDetached) === null ||
        _b === void 0
            ? void 0
            : _b.call(_a);
    };
    ToolPanelFilterComp.prototype.removeFilterElement = function () {
        _.clearElement(this.agFilterToolPanelBody);
    };
    ToolPanelFilterComp.prototype.isExpanded = function () {
        return this.expanded;
    };
    ToolPanelFilterComp.prototype.refreshFilter = function (isDisplayed) {
        var _a;
        if (!this.expanded) {
            return;
        }
        var filter = this.underlyingFilter;
        if (!filter) {
            return;
        }
        if (isDisplayed) {
            // set filters should be updated when the filter has been changed elsewhere, i.e. via api. Note that we can't
            // use 'afterGuiAttached' to refresh the virtual list as it also focuses on the mini filter which changes the
            // scroll position in the filter list panel
            if (typeof filter.refreshVirtualList === 'function') {
                filter.refreshVirtualList();
            }
        } else {
            (_a = filter.afterGuiDetached) === null || _a === void 0 ? void 0 : _a.call(filter);
        }
    };
    ToolPanelFilterComp.prototype.onFilterOpened = function (event) {
        if (event.source !== 'COLUMN_MENU') {
            return;
        }
        if (event.column !== this.column) {
            return;
        }
        if (!this.expanded) {
            return;
        }
        this.collapse();
    };
    ToolPanelFilterComp.TEMPLATE =
        '\n        <div class="ag-filter-toolpanel-instance">\n            <div class="ag-filter-toolpanel-header ag-filter-toolpanel-instance-header" ref="eFilterToolPanelHeader" role="button" aria-expanded="false">\n                <div ref="eExpand" class="ag-filter-toolpanel-expand"></div>\n                <span ref="eFilterName" class="ag-header-cell-text"></span>\n                <span ref="eFilterIcon" class="ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon" aria-hidden="true"></span>\n            </div>\n            <div class="ag-filter-toolpanel-instance-body ag-filter" ref="agFilterToolPanelBody"></div>\n        </div>';
    __decorate$21(
        [RefSelector('eFilterToolPanelHeader')],
        ToolPanelFilterComp.prototype,
        'eFilterToolPanelHeader',
        void 0,
    );
    __decorate$21([RefSelector('eFilterName')], ToolPanelFilterComp.prototype, 'eFilterName', void 0);
    __decorate$21(
        [RefSelector('agFilterToolPanelBody')],
        ToolPanelFilterComp.prototype,
        'agFilterToolPanelBody',
        void 0,
    );
    __decorate$21([RefSelector('eFilterIcon')], ToolPanelFilterComp.prototype, 'eFilterIcon', void 0);
    __decorate$21([RefSelector('eExpand')], ToolPanelFilterComp.prototype, 'eExpand', void 0);
    __decorate$21([Autowired('filterManager')], ToolPanelFilterComp.prototype, 'filterManager', void 0);
    __decorate$21([Autowired('columnModel')], ToolPanelFilterComp.prototype, 'columnModel', void 0);
    __decorate$21([PostConstruct], ToolPanelFilterComp.prototype, 'postConstruct', null);
    return ToolPanelFilterComp;
})(Component);

var __extends$2Q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$20 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ToolPanelFilterGroupComp = /** @class */ (function (_super) {
    __extends$2Q(ToolPanelFilterGroupComp, _super);
    function ToolPanelFilterGroupComp(columnGroup, childFilterComps, expandedCallback, depth, showingColumn) {
        var _this = _super.call(this) || this;
        _this.columnGroup = columnGroup;
        _this.childFilterComps = childFilterComps;
        _this.depth = depth;
        _this.expandedCallback = expandedCallback;
        _this.showingColumn = showingColumn;
        return _this;
    }
    ToolPanelFilterGroupComp.prototype.preConstruct = function () {
        var groupParams = {
            cssIdentifier: 'filter-toolpanel',
            direction: 'vertical',
        };
        this.setTemplate(ToolPanelFilterGroupComp.TEMPLATE, { filterGroupComp: groupParams });
    };
    ToolPanelFilterGroupComp.prototype.init = function () {
        var _this = this;
        this.setGroupTitle();
        this.filterGroupComp.setAlignItems('stretch');
        this.filterGroupComp.addCssClass('ag-filter-toolpanel-group-level-' + this.depth);
        this.filterGroupComp.addCssClassToTitleBar('ag-filter-toolpanel-group-level-' + this.depth + '-header');
        this.childFilterComps.forEach(function (filterComp) {
            _this.filterGroupComp.addItem(filterComp);
            filterComp.addCssClassToTitleBar('ag-filter-toolpanel-group-level-' + (_this.depth + 1) + '-header');
        });
        this.refreshFilterClass();
        this.addExpandCollapseListeners();
        this.addFilterChangedListeners();
        this.setupTooltip();
    };
    ToolPanelFilterGroupComp.prototype.setupTooltip = function () {
        var _this = this;
        // we don't show tooltips for groups, as when the group expands, it's div contains the columns which also
        // have tooltips, so the tooltips would clash. Eg mouse over group, tooltip shows, mouse over column, another
        // tooltip shows but cos we didn't leave the group the group tooltip remains. this should be fixed in the future,
        // maybe the group shouldn't contain the children form a DOM perspective.
        if (!this.showingColumn) {
            return;
        }
        var refresh = function () {
            var newTooltipText = _this.columnGroup.getColDef().headerTooltip;
            _this.setTooltip(newTooltipText);
        };
        refresh();
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, refresh);
    };
    ToolPanelFilterGroupComp.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'filterToolPanelColumnGroup';
        return res;
    };
    ToolPanelFilterGroupComp.prototype.addCssClassToTitleBar = function (cssClass) {
        this.filterGroupComp.addCssClassToTitleBar(cssClass);
    };
    ToolPanelFilterGroupComp.prototype.refreshFilters = function (isDisplayed) {
        this.childFilterComps.forEach(function (filterComp) {
            if (filterComp instanceof ToolPanelFilterGroupComp) {
                filterComp.refreshFilters(isDisplayed);
            } else {
                filterComp.refreshFilter(isDisplayed);
            }
        });
    };
    ToolPanelFilterGroupComp.prototype.isColumnGroup = function () {
        return this.columnGroup instanceof ProvidedColumnGroup;
    };
    ToolPanelFilterGroupComp.prototype.isExpanded = function () {
        return this.filterGroupComp.isExpanded();
    };
    ToolPanelFilterGroupComp.prototype.getChildren = function () {
        return this.childFilterComps;
    };
    ToolPanelFilterGroupComp.prototype.getFilterGroupName = function () {
        return this.filterGroupName ? this.filterGroupName : '';
    };
    ToolPanelFilterGroupComp.prototype.getFilterGroupId = function () {
        return this.columnGroup.getId();
    };
    ToolPanelFilterGroupComp.prototype.hideGroupItem = function (hide, index) {
        this.filterGroupComp.hideItem(hide, index);
    };
    ToolPanelFilterGroupComp.prototype.hideGroup = function (hide) {
        this.setDisplayed(!hide);
    };
    ToolPanelFilterGroupComp.prototype.forEachToolPanelFilterChild = function (action) {
        this.childFilterComps.forEach(function (filterComp) {
            if (filterComp instanceof ToolPanelFilterComp) {
                action(filterComp);
            }
        });
    };
    ToolPanelFilterGroupComp.prototype.addExpandCollapseListeners = function () {
        var _this = this;
        var expandListener = this.isColumnGroup()
            ? function () {
                  return _this.expandedCallback();
              }
            : function () {
                  return _this.forEachToolPanelFilterChild(function (filterComp) {
                      return filterComp.expand();
                  });
              };
        var collapseListener = this.isColumnGroup()
            ? function () {
                  return _this.expandedCallback();
              }
            : function () {
                  return _this.forEachToolPanelFilterChild(function (filterComp) {
                      return filterComp.collapse();
                  });
              };
        this.addManagedListener(this.filterGroupComp, AgGroupComponent.EVENT_EXPANDED, expandListener);
        this.addManagedListener(this.filterGroupComp, AgGroupComponent.EVENT_COLLAPSED, collapseListener);
    };
    ToolPanelFilterGroupComp.prototype.getColumns = function () {
        if (this.columnGroup instanceof ProvidedColumnGroup) {
            return this.columnGroup.getLeafColumns();
        }
        return [this.columnGroup];
    };
    ToolPanelFilterGroupComp.prototype.addFilterChangedListeners = function () {
        var _this = this;
        this.getColumns().forEach(function (column) {
            _this.addManagedListener(column, Column.EVENT_FILTER_CHANGED, function () {
                return _this.refreshFilterClass();
            });
        });
        if (!(this.columnGroup instanceof ProvidedColumnGroup)) {
            this.addManagedListener(this.eventService, Events.EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
        }
    };
    ToolPanelFilterGroupComp.prototype.refreshFilterClass = function () {
        var columns = this.getColumns();
        var anyChildFiltersActive = function () {
            return columns.some(function (col) {
                return col.isFilterActive();
            });
        };
        this.filterGroupComp.addOrRemoveCssClass('ag-has-filter', anyChildFiltersActive());
    };
    ToolPanelFilterGroupComp.prototype.onFilterOpened = function (event) {
        // when a filter is opened elsewhere, i.e. column menu we close the filter comp so we also need to collapse
        // the column group. This approach means we don't need to try and sync filter models on the same column.
        if (event.source !== 'COLUMN_MENU') {
            return;
        }
        if (event.column !== this.columnGroup) {
            return;
        }
        if (!this.isExpanded()) {
            return;
        }
        this.collapse();
    };
    ToolPanelFilterGroupComp.prototype.expand = function () {
        this.filterGroupComp.toggleGroupExpand(true);
    };
    ToolPanelFilterGroupComp.prototype.collapse = function () {
        this.filterGroupComp.toggleGroupExpand(false);
    };
    ToolPanelFilterGroupComp.prototype.setGroupTitle = function () {
        this.filterGroupName =
            this.columnGroup instanceof ProvidedColumnGroup
                ? this.getColumnGroupName(this.columnGroup)
                : this.getColumnName(this.columnGroup);
        this.filterGroupComp.setTitle(this.filterGroupName || '');
    };
    ToolPanelFilterGroupComp.prototype.getColumnGroupName = function (columnGroup) {
        return this.columnModel.getDisplayNameForProvidedColumnGroup(null, columnGroup, 'filterToolPanel');
    };
    ToolPanelFilterGroupComp.prototype.getColumnName = function (column) {
        return this.columnModel.getDisplayNameForColumn(column, 'filterToolPanel', false);
    };
    ToolPanelFilterGroupComp.prototype.destroyFilters = function () {
        this.childFilterComps = this.destroyBeans(this.childFilterComps);
        _.clearElement(this.getGui());
    };
    ToolPanelFilterGroupComp.prototype.destroy = function () {
        this.destroyFilters();
        _super.prototype.destroy.call(this);
    };
    ToolPanelFilterGroupComp.TEMPLATE =
        '<div class="ag-filter-toolpanel-group-wrapper">\n            <ag-group-component ref="filterGroupComp"></ag-group-component>\n        </div>';
    __decorate$20([RefSelector('filterGroupComp')], ToolPanelFilterGroupComp.prototype, 'filterGroupComp', void 0);
    __decorate$20([Autowired('columnModel')], ToolPanelFilterGroupComp.prototype, 'columnModel', void 0);
    __decorate$20([PreConstruct], ToolPanelFilterGroupComp.prototype, 'preConstruct', null);
    __decorate$20([PostConstruct], ToolPanelFilterGroupComp.prototype, 'init', null);
    return ToolPanelFilterGroupComp;
})(Component);

var __extends$2P =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1$ =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FiltersToolPanelListPanel = /** @class */ (function (_super) {
    __extends$2P(FiltersToolPanelListPanel, _super);
    function FiltersToolPanelListPanel() {
        var _this = _super.call(this, FiltersToolPanelListPanel.TEMPLATE) || this;
        _this.initialised = false;
        _this.filterGroupComps = [];
        return _this;
    }
    FiltersToolPanelListPanel.prototype.init = function (params) {
        var _this = this;
        this.initialised = true;
        var defaultParams = {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false,
            api: this.gridApi,
            columnApi: this.columnApi,
            context: this.gridOptionsService.context,
        };
        _.mergeDeep(defaultParams, params);
        this.params = defaultParams;
        if (!this.params.suppressSyncLayoutWithGrid) {
            this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, function () {
                return _this.onColumnsChanged();
            });
        }
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, function () {
            return _this.onColumnsChanged();
        });
        this.addManagedListener(this.eventService, Events.EVENT_TOOL_PANEL_VISIBLE_CHANGED, function (event) {
            // when re-entering the filters tool panel we need to refresh the virtual lists in the set filters in case
            // filters have been changed elsewhere, i.e. via an api call.
            if (event.key === 'filters') {
                _this.refreshFilters(event.visible);
            }
        });
        if (this.columnModel.isReady()) {
            this.onColumnsChanged();
        }
    };
    FiltersToolPanelListPanel.prototype.onColumnsChanged = function () {
        var pivotModeActive = this.columnModel.isPivotMode();
        var shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        shouldSyncColumnLayoutWithGrid ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs();
    };
    FiltersToolPanelListPanel.prototype.syncFilterLayout = function () {
        this.toolPanelColDefService.syncLayoutWithGrid(this.setFiltersLayout.bind(this));
    };
    FiltersToolPanelListPanel.prototype.buildTreeFromProvidedColumnDefs = function () {
        var columnTree = this.columnModel.getPrimaryColumnTree();
        this.recreateFilters(columnTree);
    };
    FiltersToolPanelListPanel.prototype.setFiltersLayout = function (colDefs) {
        var columnTree = this.toolPanelColDefService.createColumnTree(colDefs);
        this.recreateFilters(columnTree);
    };
    FiltersToolPanelListPanel.prototype.recreateFilters = function (columnTree) {
        var _this = this;
        // Underlying filter comp/element won't get recreated if the column still exists (the element just gets detached/re-attached).
        // We can therefore restore focus if an element in the filter tool panel was focused.
        var activeElement = this.gridOptionsService.getDocument().activeElement;
        // Want to restore the expansion state where possible.
        var expansionState = this.getExpansionState();
        this.destroyFilters();
        this.filterGroupComps = this.recursivelyAddComps(columnTree, 0, expansionState);
        var len = this.filterGroupComps.length;
        if (len) {
            // skip the destroy function because this will be managed
            // by the `destroyFilters` function
            this.filterGroupComps.forEach(function (comp) {
                return _this.appendChild(comp);
            });
            this.setFirstAndLastVisible(0, len - 1);
        }
        // perform search if searchFilterText exists
        if (_.exists(this.searchFilterText)) {
            this.searchFilters(this.searchFilterText);
        }
        // notify header of expand
        this.fireExpandedEvent();
        // We only care about restoring focus if the originally focused element was in the filter tool panel.
        if (this.getGui().contains(activeElement)) {
            activeElement.focus();
        }
    };
    FiltersToolPanelListPanel.prototype.recursivelyAddComps = function (tree, depth, expansionState) {
        var _this = this;
        return _.flatten(
            tree.map(function (child) {
                if (child instanceof ProvidedColumnGroup) {
                    return _.flatten(_this.recursivelyAddFilterGroupComps(child, depth, expansionState));
                }
                var column = child;
                if (!_this.shouldDisplayFilter(column)) {
                    return [];
                }
                var hideFilterCompHeader = depth === 0;
                var filterComp = new ToolPanelFilterComp(hideFilterCompHeader);
                _this.createBean(filterComp);
                filterComp.setColumn(column);
                if (expansionState.get(column.getId())) {
                    // Default state on creation and desired state are both collapsed. Expand if expanded before.
                    filterComp.expand();
                }
                if (depth > 0) {
                    return filterComp;
                }
                var filterGroupComp = _this.createBean(
                    new ToolPanelFilterGroupComp(column, [filterComp], _this.onGroupExpanded.bind(_this), depth, true),
                );
                filterGroupComp.addCssClassToTitleBar('ag-filter-toolpanel-header');
                if (!expansionState.get(filterGroupComp.getFilterGroupId())) {
                    // Default state on creation is expanded. Desired initial state is collapsed. Always collapse unless expanded before.
                    filterGroupComp.collapse();
                }
                return filterGroupComp;
            }),
        );
    };
    FiltersToolPanelListPanel.prototype.recursivelyAddFilterGroupComps = function (columnGroup, depth, expansionState) {
        if (!this.filtersExistInChildren(columnGroup.getChildren())) {
            return;
        }
        var colGroupDef = columnGroup.getColGroupDef();
        if (colGroupDef && colGroupDef.suppressFiltersToolPanel) {
            return [];
        }
        var newDepth = columnGroup.isPadding() ? depth : depth + 1;
        var childFilterComps = _.flatten(this.recursivelyAddComps(columnGroup.getChildren(), newDepth, expansionState));
        if (columnGroup.isPadding()) {
            return childFilterComps;
        }
        var filterGroupComp = new ToolPanelFilterGroupComp(
            columnGroup,
            childFilterComps,
            this.onGroupExpanded.bind(this),
            depth,
            false,
        );
        this.createBean(filterGroupComp);
        filterGroupComp.addCssClassToTitleBar('ag-filter-toolpanel-header');
        if (expansionState.get(filterGroupComp.getFilterGroupId()) === false) {
            // Default state on creation is expanded. Desired initial state is expanded. Only collapse if collapsed before.
            filterGroupComp.collapse();
        }
        return [filterGroupComp];
    };
    FiltersToolPanelListPanel.prototype.filtersExistInChildren = function (tree) {
        var _this = this;
        return tree.some(function (child) {
            if (child instanceof ProvidedColumnGroup) {
                return _this.filtersExistInChildren(child.getChildren());
            }
            return _this.shouldDisplayFilter(child);
        });
    };
    FiltersToolPanelListPanel.prototype.shouldDisplayFilter = function (column) {
        var suppressFiltersToolPanel = column.getColDef() && column.getColDef().suppressFiltersToolPanel;
        return column.isFilterAllowed() && !suppressFiltersToolPanel;
    };
    FiltersToolPanelListPanel.prototype.getExpansionState = function () {
        var expansionState = new Map();
        var recursiveGetExpansionState = function (filterGroupComp) {
            expansionState.set(filterGroupComp.getFilterGroupId(), filterGroupComp.isExpanded());
            filterGroupComp.getChildren().forEach(function (child) {
                if (child instanceof ToolPanelFilterGroupComp) {
                    recursiveGetExpansionState(child);
                } else {
                    expansionState.set(child.getColumn().getId(), child.isExpanded());
                }
            });
        };
        this.filterGroupComps.forEach(recursiveGetExpansionState);
        return expansionState;
    };
    // we don't support refreshing, but must implement because it's on the tool panel interface
    FiltersToolPanelListPanel.prototype.refresh = function () {};
    // lazy initialise the panel
    FiltersToolPanelListPanel.prototype.setVisible = function (visible) {
        _super.prototype.setDisplayed.call(this, visible);
        if (visible && !this.initialised) {
            this.init(this.params);
        }
    };
    FiltersToolPanelListPanel.prototype.expandFilterGroups = function (expand, groupIds) {
        var updatedGroupIds = [];
        var updateGroupExpandState = function (filterGroup) {
            var groupId = filterGroup.getFilterGroupId();
            var shouldExpandOrCollapse = !groupIds || _.includes(groupIds, groupId);
            if (shouldExpandOrCollapse) {
                // don't expand 'column groups', i.e. top level columns wrapped in a group
                if (expand && filterGroup.isColumnGroup()) {
                    filterGroup.expand();
                } else {
                    filterGroup.collapse();
                }
                updatedGroupIds.push(groupId);
            }
            // recursively look for more groups to expand / collapse
            filterGroup.getChildren().forEach(function (child) {
                if (child instanceof ToolPanelFilterGroupComp) {
                    updateGroupExpandState(child);
                }
            });
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        // update header expand / collapse icon
        this.onGroupExpanded();
        if (groupIds) {
            var unrecognisedGroupIds = groupIds.filter(function (groupId) {
                return updatedGroupIds.indexOf(groupId) < 0;
            });
            if (unrecognisedGroupIds.length > 0) {
                console.warn('AG Grid: unable to find groups for these supplied groupIds:', unrecognisedGroupIds);
            }
        }
    };
    FiltersToolPanelListPanel.prototype.expandFilters = function (expand, colIds) {
        var updatedColIds = [];
        var updateGroupExpandState = function (filterComp) {
            if (filterComp instanceof ToolPanelFilterGroupComp) {
                var anyChildrenChanged_1 = false;
                filterComp.getChildren().forEach(function (child) {
                    var childUpdated = updateGroupExpandState(child);
                    if (childUpdated) {
                        if (expand) {
                            filterComp.expand();
                            anyChildrenChanged_1 = true;
                        } else if (!filterComp.isColumnGroup()) {
                            // we only collapse columns wrapped in groups
                            filterComp.collapse();
                        }
                    }
                });
                return anyChildrenChanged_1;
            }
            var colId = filterComp.getColumn().getColId();
            var updateFilterExpandState = !colIds || _.includes(colIds, colId);
            if (updateFilterExpandState) {
                expand ? filterComp.expand() : filterComp.collapse();
                updatedColIds.push(colId);
            }
            return updateFilterExpandState;
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        // update header expand / collapse icon
        this.onGroupExpanded();
        if (colIds) {
            var unrecognisedColIds = colIds.filter(function (colId) {
                return updatedColIds.indexOf(colId) < 0;
            });
            if (unrecognisedColIds.length > 0) {
                console.warn('AG Grid: unable to find columns for these supplied colIds:', unrecognisedColIds);
            }
        }
    };
    FiltersToolPanelListPanel.prototype.onGroupExpanded = function () {
        this.fireExpandedEvent();
    };
    FiltersToolPanelListPanel.prototype.fireExpandedEvent = function () {
        var expandedCount = 0;
        var notExpandedCount = 0;
        var updateExpandCounts = function (filterGroup) {
            if (!filterGroup.isColumnGroup()) {
                return;
            }
            filterGroup.isExpanded() ? expandedCount++ : notExpandedCount++;
            filterGroup.getChildren().forEach(function (child) {
                if (child instanceof ToolPanelFilterGroupComp) {
                    updateExpandCounts(child);
                }
            });
        };
        this.filterGroupComps.forEach(updateExpandCounts);
        var state;
        if (expandedCount > 0 && notExpandedCount > 0) {
            state = EXPAND_STATE.INDETERMINATE;
        } else if (notExpandedCount > 0) {
            state = EXPAND_STATE.COLLAPSED;
        } else {
            state = EXPAND_STATE.EXPANDED;
        }
        this.dispatchEvent({ type: 'groupExpanded', state: state });
    };
    FiltersToolPanelListPanel.prototype.performFilterSearch = function (searchText) {
        this.searchFilterText = _.exists(searchText) ? searchText.toLowerCase() : null;
        this.searchFilters(this.searchFilterText);
    };
    FiltersToolPanelListPanel.prototype.searchFilters = function (searchFilter) {
        var passesFilter = function (groupName) {
            return !_.exists(searchFilter) || groupName.toLowerCase().indexOf(searchFilter) !== -1;
        };
        var recursivelySearch = function (filterItem, parentPasses) {
            if (!(filterItem instanceof ToolPanelFilterGroupComp)) {
                return passesFilter(filterItem.getColumnFilterName() || '');
            }
            var children = filterItem.getChildren();
            var groupNamePasses = passesFilter(filterItem.getFilterGroupName());
            // if group or parent already passed - ensure this group and all children are visible
            var alreadyPassed = parentPasses || groupNamePasses;
            if (alreadyPassed) {
                // ensure group visible
                filterItem.hideGroup(false);
                // ensure all children are visible
                for (var i = 0; i < children.length; i++) {
                    recursivelySearch(children[i], alreadyPassed);
                    filterItem.hideGroupItem(false, i);
                }
                return true;
            }
            // hide group item filters
            var anyChildPasses = false;
            children.forEach(function (child, index) {
                var childPasses = recursivelySearch(child, parentPasses);
                filterItem.hideGroupItem(!childPasses, index);
                if (childPasses) {
                    anyChildPasses = true;
                }
            });
            // hide group if no children pass
            filterItem.hideGroup(!anyChildPasses);
            return anyChildPasses;
        };
        var firstVisible;
        var lastVisible;
        this.filterGroupComps.forEach(function (filterGroup, idx) {
            recursivelySearch(filterGroup, false);
            if (firstVisible === undefined) {
                if (!filterGroup.containsCssClass('ag-hidden')) {
                    firstVisible = idx;
                    lastVisible = idx;
                }
            } else if (!filterGroup.containsCssClass('ag-hidden') && lastVisible !== idx) {
                lastVisible = idx;
            }
        });
        this.setFirstAndLastVisible(firstVisible, lastVisible);
    };
    FiltersToolPanelListPanel.prototype.setFirstAndLastVisible = function (firstIdx, lastIdx) {
        this.filterGroupComps.forEach(function (filterGroup, idx) {
            filterGroup.removeCssClass('ag-first-group-visible');
            filterGroup.removeCssClass('ag-last-group-visible');
            if (idx === firstIdx) {
                filterGroup.addCssClass('ag-first-group-visible');
            }
            if (idx === lastIdx) {
                filterGroup.addCssClass('ag-last-group-visible');
            }
        });
    };
    FiltersToolPanelListPanel.prototype.refreshFilters = function (isDisplayed) {
        this.filterGroupComps.forEach(function (filterGroupComp) {
            return filterGroupComp.refreshFilters(isDisplayed);
        });
    };
    FiltersToolPanelListPanel.prototype.destroyFilters = function () {
        this.filterGroupComps = this.destroyBeans(this.filterGroupComps);
        _.clearElement(this.getGui());
    };
    FiltersToolPanelListPanel.prototype.destroy = function () {
        this.destroyFilters();
        _super.prototype.destroy.call(this);
    };
    FiltersToolPanelListPanel.TEMPLATE = '<div class="ag-filter-list-panel"></div>';
    __decorate$1$([Autowired('gridApi')], FiltersToolPanelListPanel.prototype, 'gridApi', void 0);
    __decorate$1$([Autowired('columnApi')], FiltersToolPanelListPanel.prototype, 'columnApi', void 0);
    __decorate$1$(
        [Autowired('toolPanelColDefService')],
        FiltersToolPanelListPanel.prototype,
        'toolPanelColDefService',
        void 0,
    );
    __decorate$1$([Autowired('columnModel')], FiltersToolPanelListPanel.prototype, 'columnModel', void 0);
    return FiltersToolPanelListPanel;
})(Component);

var __extends$2O =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$X =
    (undefined && undefined.__assign) ||
    function () {
        __assign$X =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$X.apply(this, arguments);
    };
var __decorate$1_ =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FiltersToolPanel = /** @class */ (function (_super) {
    __extends$2O(FiltersToolPanel, _super);
    function FiltersToolPanel() {
        var _this = _super.call(this, FiltersToolPanel.TEMPLATE) || this;
        _this.initialised = false;
        _this.listenerDestroyFuncs = [];
        return _this;
    }
    FiltersToolPanel.prototype.init = function (params) {
        // if initialised is true, means this is a refresh
        if (this.initialised) {
            this.listenerDestroyFuncs.forEach(function (func) {
                return func();
            });
            this.listenerDestroyFuncs = [];
        }
        this.initialised = true;
        var defaultParams = {
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false,
            api: this.gridApi,
            columnApi: this.columnApi,
        };
        this.params = __assign$X(__assign$X(__assign$X({}, defaultParams), params), {
            context: this.gridOptionsService.context,
        });
        this.filtersToolPanelHeaderPanel.init(this.params);
        this.filtersToolPanelListPanel.init(this.params);
        var hideExpand = this.params.suppressExpandAll;
        var hideSearch = this.params.suppressFilterSearch;
        if (hideExpand && hideSearch) {
            this.filtersToolPanelHeaderPanel.setDisplayed(false);
        }
        // this is necessary to prevent a memory leak while refreshing the tool panel
        this.listenerDestroyFuncs.push(
            this.addManagedListener(this.filtersToolPanelHeaderPanel, 'expandAll', this.onExpandAll.bind(this)),
            this.addManagedListener(this.filtersToolPanelHeaderPanel, 'collapseAll', this.onCollapseAll.bind(this)),
            this.addManagedListener(this.filtersToolPanelHeaderPanel, 'searchChanged', this.onSearchChanged.bind(this)),
            this.addManagedListener(this.filtersToolPanelListPanel, 'groupExpanded', this.onGroupExpanded.bind(this)),
        );
    };
    // lazy initialise the panel
    FiltersToolPanel.prototype.setVisible = function (visible) {
        _super.prototype.setDisplayed.call(this, visible);
        if (visible && !this.initialised) {
            this.init(this.params);
        }
    };
    FiltersToolPanel.prototype.onExpandAll = function () {
        this.filtersToolPanelListPanel.expandFilterGroups(true);
    };
    FiltersToolPanel.prototype.onCollapseAll = function () {
        this.filtersToolPanelListPanel.expandFilterGroups(false);
    };
    FiltersToolPanel.prototype.onSearchChanged = function (event) {
        this.filtersToolPanelListPanel.performFilterSearch(event.searchText);
    };
    FiltersToolPanel.prototype.setFilterLayout = function (colDefs) {
        this.filtersToolPanelListPanel.setFiltersLayout(colDefs);
    };
    FiltersToolPanel.prototype.onGroupExpanded = function (event) {
        this.filtersToolPanelHeaderPanel.setExpandState(event.state);
    };
    FiltersToolPanel.prototype.expandFilterGroups = function (groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(true, groupIds);
    };
    FiltersToolPanel.prototype.collapseFilterGroups = function (groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(false, groupIds);
    };
    FiltersToolPanel.prototype.expandFilters = function (colIds) {
        this.filtersToolPanelListPanel.expandFilters(true, colIds);
    };
    FiltersToolPanel.prototype.collapseFilters = function (colIds) {
        this.filtersToolPanelListPanel.expandFilters(false, colIds);
    };
    FiltersToolPanel.prototype.syncLayoutWithGrid = function () {
        this.filtersToolPanelListPanel.syncFilterLayout();
    };
    FiltersToolPanel.prototype.refresh = function () {
        this.init(this.params);
    };
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    FiltersToolPanel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    FiltersToolPanel.TEMPLATE =
        '<div class="ag-filter-toolpanel">\n            <ag-filters-tool-panel-header ref="filtersToolPanelHeaderPanel"></ag-filters-tool-panel-header>\n            <ag-filters-tool-panel-list ref="filtersToolPanelListPanel"></ag-filters-tool-panel-list>\n         </div>';
    __decorate$1_(
        [RefSelector('filtersToolPanelHeaderPanel')],
        FiltersToolPanel.prototype,
        'filtersToolPanelHeaderPanel',
        void 0,
    );
    __decorate$1_(
        [RefSelector('filtersToolPanelListPanel')],
        FiltersToolPanel.prototype,
        'filtersToolPanelListPanel',
        void 0,
    );
    __decorate$1_([Autowired('gridApi')], FiltersToolPanel.prototype, 'gridApi', void 0);
    __decorate$1_([Autowired('columnApi')], FiltersToolPanel.prototype, 'columnApi', void 0);
    return FiltersToolPanel;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$c = '30.2.0';

var FiltersToolPanelModule = {
    version: VERSION$c,
    moduleName: ModuleNames.FiltersToolPanelModule,
    beans: [],
    agStackComponents: [
        { componentName: 'AgFiltersToolPanelHeader', componentClass: FiltersToolPanelHeaderPanel },
        { componentName: 'AgFiltersToolPanelList', componentClass: FiltersToolPanelListPanel },
    ],
    userComponents: [{ componentName: 'agFiltersToolPanel', componentClass: FiltersToolPanel }],
    dependantModules: [SideBarModule, EnterpriseCoreModule],
};

var __extends$2N =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
/**
 * The interval methods don't mutate Date parameters.
 */
var TimeInterval = /** @class */ (function () {
    function TimeInterval(encode, decode, rangeCallback) {
        this._encode = encode;
        this._decode = decode;
        this._rangeCallback = rangeCallback;
    }
    /**
     * Returns a new date representing the latest interval boundary date before or equal to date.
     * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
     * @param date
     */
    TimeInterval.prototype.floor = function (date) {
        var d = new Date(date);
        var e = this._encode(d);
        return this._decode(e);
    };
    /**
     * Returns a new date representing the earliest interval boundary date after or equal to date.
     * @param date
     */
    TimeInterval.prototype.ceil = function (date) {
        var d = new Date(Number(date) - 1);
        var e = this._encode(d);
        return this._decode(e + 1);
    };
    /**
     * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
     * @param start Range start.
     * @param stop Range end.
     * @param extend If specified, the requested range will be extended to the closest "nice" values.
     */
    TimeInterval.prototype.range = function (start, stop, extend) {
        var _a;
        var rangeCallback = (_a = this._rangeCallback) === null || _a === void 0 ? void 0 : _a.call(this, start, stop);
        var e0 = this._encode(extend ? this.floor(start) : this.ceil(start));
        var e1 = this._encode(extend ? this.ceil(stop) : this.floor(stop));
        if (e1 < e0) {
            return [];
        }
        var range = [];
        for (var e = e0; e <= e1; e++) {
            var d = this._decode(e);
            range.push(d);
        }
        rangeCallback === null || rangeCallback === void 0 ? void 0 : rangeCallback();
        return range;
    };
    return TimeInterval;
})();
var CountableTimeInterval = /** @class */ (function (_super) {
    __extends$2N(CountableTimeInterval, _super);
    function CountableTimeInterval() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    CountableTimeInterval.prototype.getOffset = function (snapTo, step) {
        var s = typeof snapTo === 'number' || snapTo instanceof Date ? this._encode(new Date(snapTo)) : 0;
        return Math.floor(s) % step;
    };
    /**
     * Returns a filtered view of this interval representing every step'th date.
     * It can be a number of minutes, hours, days etc.
     * Must be a positive integer.
     * @param step
     */
    CountableTimeInterval.prototype.every = function (step, options) {
        var _this = this;
        var offset = 0;
        var rangeCallback;
        var _a = (options !== null && options !== void 0 ? options : {}).snapTo,
            snapTo = _a === void 0 ? 'start' : _a;
        if (typeof snapTo === 'string') {
            var initialOffset_1 = offset;
            rangeCallback = function (start, stop) {
                var s = snapTo === 'start' ? start : stop;
                offset = _this.getOffset(s, step);
                return function () {
                    return (offset = initialOffset_1);
                };
            };
        } else if (typeof snapTo === 'number') {
            offset = this.getOffset(new Date(snapTo), step);
        } else if (snapTo instanceof Date) {
            offset = this.getOffset(snapTo, step);
        }
        var encode = function (date) {
            var e = _this._encode(date);
            return Math.floor((e - offset) / step);
        };
        var decode = function (encoded) {
            return _this._decode(encoded * step + offset);
        };
        var interval = new TimeInterval(encode, decode, rangeCallback);
        return interval;
    };
    return CountableTimeInterval;
})(TimeInterval);

function encode$b(date) {
    return date.getTime();
}
function decode$b(encoded) {
    return new Date(encoded);
}
var millisecond = new CountableTimeInterval(encode$b, decode$b);

// Common time unit sizes in milliseconds.
new Date(0).getFullYear();
var durationSecond = 1000;
var durationMinute = durationSecond * 60;
var durationHour = durationMinute * 60;
var durationDay = durationHour * 24;
var durationWeek = durationDay * 7;
var durationMonth = durationDay * 30;
var durationYear = durationDay * 365;

var offset$2 = new Date().getTimezoneOffset() * durationMinute;
function encode$a(date) {
    return Math.floor((date.getTime() - offset$2) / durationSecond);
}
function decode$a(encoded) {
    return new Date(offset$2 + encoded * durationSecond);
}
var second = new CountableTimeInterval(encode$a, decode$a);

var offset$1 = new Date().getTimezoneOffset() * durationMinute;
function encode$9(date) {
    return Math.floor((date.getTime() - offset$1) / durationMinute);
}
function decode$9(encoded) {
    return new Date(offset$1 + encoded * durationMinute);
}
var minute = new CountableTimeInterval(encode$9, decode$9);

var offset = new Date().getTimezoneOffset() * durationMinute;
function encode$8(date) {
    return Math.floor((date.getTime() - offset) / durationHour);
}
function decode$8(encoded) {
    return new Date(offset + encoded * durationHour);
}
var hour = new CountableTimeInterval(encode$8, decode$8);

function encode$7(date) {
    var tzOffsetMs = date.getTimezoneOffset() * 60000;
    return Math.floor((date.getTime() - tzOffsetMs) / durationDay);
}
function decode$7(encoded) {
    var d = new Date(1970, 0, 1);
    d.setDate(d.getDate() + encoded);
    return d;
}
var day = new CountableTimeInterval(encode$7, decode$7);

// Set date to n-th day of the week.
function weekday(n) {
    var base = new Date(2023, 0, 1 + n).getTime();
    function encode(date) {
        var dateMs = date.getTime();
        return Math.floor((dateMs - base) / durationWeek);
    }
    function decode(encoded) {
        var d = new Date(base);
        d.setDate(d.getDate() + encoded * 7);
        return d;
    }
    return new CountableTimeInterval(encode, decode);
}
var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

function encode$6(date) {
    return date.getFullYear() * 12 + date.getMonth();
}
function decode$6(encoded) {
    var year = Math.floor(encoded / 12);
    var month = encoded - year * 12;
    return new Date(year, month, 1);
}
var month = new CountableTimeInterval(encode$6, decode$6);

function encode$5(date) {
    return date.getFullYear();
}
function decode$5(encoded) {
    // Note: assigning years through the constructor
    // will break for years 0 - 99 AD (will turn 1900's).
    var d = new Date();
    d.setFullYear(encoded);
    d.setMonth(0, 1);
    d.setHours(0, 0, 0, 0);
    return d;
}
var year = new CountableTimeInterval(encode$5, decode$5);

function encode$4(date) {
    return Math.floor(date.getTime() / durationMinute);
}
function decode$4(encoded) {
    return new Date(encoded * durationMinute);
}
var utcMinute = new CountableTimeInterval(encode$4, decode$4);

function encode$3(date) {
    return Math.floor(date.getTime() / durationHour);
}
function decode$3(encoded) {
    return new Date(encoded * durationHour);
}
var utcHour = new CountableTimeInterval(encode$3, decode$3);

function encode$2(date) {
    return Math.floor(date.getTime() / durationDay);
}
function decode$2(encoded) {
    var d = new Date(0);
    d.setUTCDate(d.getUTCDate() + encoded);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var utcDay = new CountableTimeInterval(encode$2, decode$2);

function encode$1(date) {
    return date.getUTCFullYear() * 12 + date.getUTCMonth();
}
function decode$1(encoded) {
    var year = Math.floor(encoded / 12);
    var month = encoded - year * 12;
    return new Date(Date.UTC(year, month, 1));
}
var utcMonth = new CountableTimeInterval(encode$1, decode$1);

function encode(date) {
    return date.getUTCFullYear();
}
function decode(encoded) {
    // Note: assigning years through the constructor
    // will break for years 0 - 99 AD (will turn 1900's).
    var d = new Date();
    d.setUTCFullYear(encoded);
    d.setUTCMonth(0, 1);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var utcYear = new CountableTimeInterval(encode, decode);

var time = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    millisecond: millisecond,
    second: second,
    minute: minute,
    hour: hour,
    day: day,
    sunday: sunday,
    monday: monday,
    tuesday: tuesday,
    wednesday: wednesday,
    thursday: thursday,
    friday: friday,
    saturday: saturday,
    month: month,
    year: year,
    utcMinute: utcMinute,
    utcHour: utcHour,
    utcDay: utcDay,
    utcMonth: utcMonth,
    utcYear: utcYear,
});

var MOBILE = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];
function isDesktop() {
    var userAgent = navigator.userAgent;
    if (
        MOBILE.some(function (r) {
            return r.test(userAgent);
        })
    ) {
        return false;
    }
    return true;
}

/**
 * Wraps the native Canvas element and overrides its CanvasRenderingContext2D to
 * provide resolution independent rendering based on `window.devicePixelRatio`.
 */
var HdpiCanvas = /** @class */ (function () {
    // The width/height attributes of the Canvas element default to
    // 300/150 according to w3.org.
    function HdpiCanvas(_a) {
        var _b = _a.document,
            document = _b === void 0 ? window.document : _b,
            _c = _a.width,
            width = _c === void 0 ? 600 : _c,
            _d = _a.height,
            height = _d === void 0 ? 300 : _d,
            _e = _a.domLayer,
            domLayer = _e === void 0 ? false : _e,
            _f = _a.zIndex,
            zIndex = _f === void 0 ? 0 : _f,
            _g = _a.name,
            name = _g === void 0 ? undefined : _g,
            _h = _a.overrideDevicePixelRatio,
            overrideDevicePixelRatio = _h === void 0 ? undefined : _h;
        this._container = undefined;
        this._enabled = true;
        // `NaN` is deliberate here, so that overrides are always applied
        // and the `resetTransform` inside the `resize` method works in IE11.
        this._pixelRatio = NaN;
        this._width = 0;
        this._height = 0;
        this.document = document;
        // Create canvas and immediately apply width + height to avoid out-of-memory
        // errors on iOS/iPadOS Safari.
        this.element = document.createElement('canvas');
        this.element.width = width;
        this.element.height = height;
        this.context = this.element.getContext('2d');
        this.imageSource = this.context.canvas;
        var style = this.element.style;
        style.userSelect = 'none';
        style.display = 'block';
        if (domLayer) {
            style.position = 'absolute';
            style.zIndex = String(zIndex);
            style.top = '0';
            style.left = '0';
            style.pointerEvents = 'none';
            style.opacity = '1';
            if (name) {
                this.element.id = name;
            }
        }
        this.setPixelRatio(overrideDevicePixelRatio);
        this.resize(width, height);
    }
    Object.defineProperty(HdpiCanvas.prototype, 'container', {
        get: function () {
            return this._container;
        },
        set: function (value) {
            if (this._container !== value) {
                this.remove();
                if (value) {
                    value.appendChild(this.element);
                }
                this._container = value;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiCanvas.prototype, 'enabled', {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this.element.style.display = value ? 'block' : 'none';
            this._enabled = !!value;
        },
        enumerable: false,
        configurable: true,
    });
    HdpiCanvas.prototype.remove = function () {
        var parentNode = this.element.parentNode;
        if (parentNode != null) {
            parentNode.removeChild(this.element);
        }
    };
    HdpiCanvas.prototype.destroy = function () {
        this.element.remove();
        // Workaround memory allocation quirks in iOS Safari by resizing to 0x0 and clearing.
        // See https://bugs.webkit.org/show_bug.cgi?id=195325.
        this.element.width = 0;
        this.element.height = 0;
        this.context.clearRect(0, 0, 0, 0);
        Object.freeze(this);
    };
    HdpiCanvas.prototype.snapshot = function () {
        // No-op for compatibility with HdpiOffscreenCanvas.
    };
    HdpiCanvas.prototype.clear = function () {
        this.context.save();
        this.context.resetTransform();
        this.context.clearRect(0, 0, this.width, this.height);
        this.context.restore();
    };
    HdpiCanvas.prototype.toImage = function () {
        var img = this.document.createElement('img');
        img.src = this.getDataURL();
        return img;
    };
    HdpiCanvas.prototype.getDataURL = function (type) {
        return this.element.toDataURL(type);
    };
    /**
     * @param fileName The name of the downloaded file.
     * @param fileFormat The file format, the default is `image/png`
     */
    HdpiCanvas.prototype.download = function (fileName, fileFormat) {
        if (fileFormat === void 0) {
            fileFormat = 'image/png';
        }
        fileName = (fileName !== null && fileName !== void 0 ? fileName : '').trim() || 'image';
        var dataUrl = this.getDataURL(fileFormat);
        var document = this.document;
        var a = document.createElement('a');
        a.href = dataUrl;
        a.download = fileName;
        a.style.display = 'none';
        document.body.appendChild(a); // required for the `click` to work in Firefox
        a.click();
        document.body.removeChild(a);
    };
    Object.defineProperty(HdpiCanvas.prototype, 'pixelRatio', {
        get: function () {
            return this._pixelRatio;
        },
        enumerable: false,
        configurable: true,
    });
    /**
     * Changes the pixel ratio of the Canvas element to the given value,
     * or uses the window.devicePixelRatio (default), then resizes the Canvas
     * element accordingly (default).
     */
    HdpiCanvas.prototype.setPixelRatio = function (ratio) {
        var pixelRatio = ratio !== null && ratio !== void 0 ? ratio : window.devicePixelRatio;
        if (!isDesktop()) {
            // Mobile browsers have stricter memory limits, we reduce rendering resolution to
            // improve stability on mobile browsers. iOS Safari 12->16 are pain-points since they
            // have memory allocation quirks - see https://bugs.webkit.org/show_bug.cgi?id=195325.
            pixelRatio = 1;
        }
        HdpiCanvas.overrideScale(this.context, pixelRatio);
        this._pixelRatio = pixelRatio;
    };
    Object.defineProperty(HdpiCanvas.prototype, 'pixelated', {
        get: function () {
            return this.element.style.imageRendering === 'pixelated';
        },
        set: function (value) {
            this.element.style.imageRendering = value ? 'pixelated' : 'auto';
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiCanvas.prototype, 'width', {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiCanvas.prototype, 'height', {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true,
    });
    HdpiCanvas.prototype.resize = function (width, height) {
        if (!(width > 0 && height > 0)) {
            return;
        }
        var _a = this,
            element = _a.element,
            context = _a.context,
            pixelRatio = _a.pixelRatio;
        element.width = Math.round(width * pixelRatio);
        element.height = Math.round(height * pixelRatio);
        element.style.width = width + 'px';
        element.style.height = height + 'px';
        context.resetTransform();
        this._width = width;
        this._height = height;
    };
    Object.defineProperty(HdpiCanvas, 'textMeasuringContext', {
        get: function () {
            if (this._textMeasuringContext) {
                return this._textMeasuringContext;
            }
            var canvas = document.createElement('canvas');
            this._textMeasuringContext = canvas.getContext('2d');
            return this._textMeasuringContext;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiCanvas, 'svgText', {
        get: function () {
            if (this._svgText) {
                return this._svgText;
            }
            var xmlns = 'http://www.w3.org/2000/svg';
            var svg = document.createElementNS(xmlns, 'svg');
            svg.setAttribute('width', '100');
            svg.setAttribute('height', '100');
            // Add a descriptive class name in case someone sees this SVG element
            // in devtools and wonders about its purpose:
            if (svg.classList) {
                svg.classList.add('text-measuring-svg');
            } else {
                svg.setAttribute('class', 'text-measuring-svg');
            }
            svg.style.position = 'absolute';
            svg.style.top = '-1000px';
            svg.style.visibility = 'hidden';
            var svgText = document.createElementNS(xmlns, 'text');
            svgText.setAttribute('x', '0');
            svgText.setAttribute('y', '30');
            svgText.setAttribute('text', 'black');
            svg.appendChild(svgText);
            document.body.appendChild(svg);
            this._svgText = svgText;
            return svgText;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiCanvas, 'has', {
        get: function () {
            if (this._has) {
                return this._has;
            }
            var isChrome = navigator.userAgent.indexOf('Chrome') > -1;
            var isFirefox = navigator.userAgent.indexOf('Firefox') > -1;
            var isSafari = !isChrome && navigator.userAgent.indexOf('Safari') > -1;
            this._has = Object.freeze({
                textMetrics:
                    this.textMeasuringContext.measureText('test').actualBoundingBoxDescent !== undefined &&
                    // Firefox implemented advanced TextMetrics object in v74:
                    // https://bugzilla.mozilla.org/show_bug.cgi?id=1102584
                    // but it's buggy, so we'll keep using the SVG for text measurement in Firefox for now.
                    !isFirefox &&
                    !isSafari,
                getTransform: this.textMeasuringContext.getTransform !== undefined,
            });
            return this._has;
        },
        enumerable: false,
        configurable: true,
    });
    HdpiCanvas.measureText = function (text, font, textBaseline, textAlign) {
        var ctx = this.textMeasuringContext;
        ctx.font = font;
        ctx.textBaseline = textBaseline;
        ctx.textAlign = textAlign;
        return ctx.measureText(text);
    };
    /**
     * Returns the width and height of the measured text.
     * @param text The single-line text to measure.
     * @param font The font shorthand string.
     */
    HdpiCanvas.getTextSize = function (text, font) {
        if (this.has.textMetrics) {
            var ctx = this.textMeasuringContext;
            ctx.font = font;
            var metrics = ctx.measureText(text);
            return {
                width: metrics.width,
                height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent,
            };
        } else {
            return this.measureSvgText(text, font);
        }
    };
    HdpiCanvas.measureSvgText = function (text, font) {
        var cache = this.textSizeCache;
        var fontCache = cache[font];
        // Note: consider not caching the size of numeric strings.
        // For example: if (isNaN(+text)) { // skip
        if (fontCache) {
            var size_1 = fontCache[text];
            if (size_1) {
                return size_1;
            }
        } else {
            cache[font] = {};
        }
        var svgText = this.svgText;
        svgText.style.font = font;
        svgText.textContent = text;
        // `getBBox` returns an instance of `SVGRect` with the same `width` and `height`
        // measurements as `DOMRect` instance returned by the `getBoundingClientRect`.
        // But the `SVGRect` instance has half the properties of the `DOMRect`,
        // so we use the `getBBox` method.
        var bbox = svgText.getBBox();
        var size = {
            width: bbox.width,
            height: bbox.height,
        };
        cache[font][text] = size;
        return size;
    };
    HdpiCanvas.overrideScale = function (ctx, scale) {
        var depth = 0;
        var overrides = {
            save: function () {
                this.$save();
                depth++;
            },
            restore: function () {
                if (depth > 0) {
                    this.$restore();
                    depth--;
                } else {
                    throw new Error('AG Charts - Unable to restore() past depth 0');
                }
            },
            setTransform: function (a, b, c, d, e, f) {
                if (typeof a === 'object') {
                    this.$setTransform(a);
                } else {
                    this.$setTransform(a * scale, b * scale, c * scale, d * scale, e * scale, f * scale);
                }
            },
            resetTransform: function () {
                // As of Jan 8, 2019, `resetTransform` is still an "experimental technology",
                // and doesn't work in IE11 and Edge 44.
                this.$setTransform(scale, 0, 0, scale, 0, 0);
            },
            verifyDepthZero: function () {
                if (depth !== 0) {
                    throw new Error('AG Charts - Save/restore depth is non-zero: ' + depth);
                }
            },
        };
        for (var name_1 in overrides) {
            if (Object.prototype.hasOwnProperty.call(overrides, name_1)) {
                // Save native methods under prefixed names,
                // if this hasn't been done by the previous overrides already.
                if (!ctx['$' + name_1]) {
                    ctx['$' + name_1] = ctx[name_1];
                }
                // Replace native methods with overrides,
                // or previous overrides with the new ones.
                ctx[name_1] = overrides[name_1];
            }
        }
    };
    HdpiCanvas.textSizeCache = {};
    return HdpiCanvas;
})();

// For small data structs like a bounding box, objects are superior to arrays
// in terms of performance (by 3-4% in Chrome 71, Safari 12 and by 20% in Firefox 64).
// They are also self descriptive and harder to abuse.
// For example, one has to do:
// `ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);`
// rather than become enticed by the much slower:
// `ctx.strokeRect(...bbox);`
// https://jsperf.com/array-vs-object-create-access
var __assign$W =
    (undefined && undefined.__assign) ||
    function () {
        __assign$W =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$W.apply(this, arguments);
    };
var __read$1a =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var BBox = /** @class */ (function () {
    function BBox(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    BBox.prototype.clone = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height;
        return new BBox(x, y, width, height);
    };
    BBox.prototype.equals = function (other) {
        return this.x === other.x && this.y === other.y && this.width === other.width && this.height === other.height;
    };
    BBox.prototype.containsPoint = function (x, y) {
        return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
    };
    BBox.prototype.collidesBBox = function (other) {
        return (
            this.x < other.x + other.width &&
            this.x + this.width > other.x &&
            this.y < other.y + other.height &&
            this.y + this.height > other.y
        );
    };
    BBox.prototype.isInfinite = function () {
        return (
            Math.abs(this.x) === Infinity ||
            Math.abs(this.y) === Infinity ||
            Math.abs(this.width) === Infinity ||
            Math.abs(this.height) === Infinity
        );
    };
    BBox.prototype.shrink = function (amount, position) {
        var _this = this;
        var apply = function (pos, amt) {
            switch (pos) {
                case 'top':
                    _this.y += amt;
                // eslint-disable-next-line no-fallthrough
                case 'bottom':
                    _this.height -= amt;
                    break;
                case 'left':
                    _this.x += amt;
                // eslint-disable-next-line no-fallthrough
                case 'right':
                    _this.width -= amt;
                    break;
                case 'vertical':
                    _this.y += amt;
                    _this.height -= amt * 2;
                    break;
                case 'horizontal':
                    _this.x += amt;
                    _this.width -= amt * 2;
                    break;
                default:
                    _this.x += amt;
                    _this.width -= amt * 2;
                    _this.y += amt;
                    _this.height -= amt * 2;
            }
        };
        if (typeof amount === 'number') {
            apply(position, amount);
        } else {
            Object.entries(amount).forEach(function (_a) {
                var _b = __read$1a(_a, 2),
                    pos = _b[0],
                    amt = _b[1];
                return apply(pos, amt);
            });
        }
        return this;
    };
    BBox.prototype.grow = function (amount, position) {
        if (typeof amount === 'number') {
            this.shrink(-amount, position);
        } else {
            var paddingCopy = __assign$W({}, amount);
            for (var key in paddingCopy) {
                paddingCopy[key] *= -1;
            }
            this.shrink(paddingCopy);
        }
        return this;
    };
    BBox.merge = function (boxes) {
        var left = Infinity;
        var top = Infinity;
        var right = -Infinity;
        var bottom = -Infinity;
        boxes.forEach(function (box) {
            if (box.x < left) {
                left = box.x;
            }
            if (box.y < top) {
                top = box.y;
            }
            if (box.x + box.width > right) {
                right = box.x + box.width;
            }
            if (box.y + box.height > bottom) {
                bottom = box.y + box.height;
            }
        });
        return new BBox(left, top, right - left, bottom - top);
    };
    return BBox;
})();

var __read$19 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$I =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
/**
 * As of Jan 8, 2019, Firefox still doesn't implement
 * `getTransform(): DOMMatrix;`
 * `setTransform(transform?: DOMMatrix2DInit)`
 * in the `CanvasRenderingContext2D`.
 * Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=928150
 * IE11 and Edge 44 also don't have the support.
 * Thus this class, to keep track of the current transform and
 * combine transformations.
 * Standards:
 * https://html.spec.whatwg.org/dev/canvas.html
 * https://www.w3.org/TR/geometry-1/
 */
var Matrix = /** @class */ (function () {
    function Matrix(elements) {
        if (elements === void 0) {
            elements = [1, 0, 0, 1, 0, 0];
        }
        this.elements = elements;
    }
    Object.defineProperty(Matrix.prototype, 'e', {
        get: function () {
            return __spreadArray$I([], __read$19(this.elements));
        },
        enumerable: false,
        configurable: true,
    });
    Matrix.prototype.setElements = function (elements) {
        var e = this.elements;
        // `this.elements = elements.slice()` is 4-5 times slower
        // (in Chrome 71 and FF 64) than manually copying elements,
        // since slicing allocates new memory.
        // The performance of passing parameters individually
        // vs as an array is about the same in both browsers, so we
        // go with a single (array of elements) parameter, because
        // `setElements(elements)` and `setElements([a, b, c, d, e, f])`
        // calls give us roughly the same performance, versus
        // `setElements(...elements)` and `setElements(a, b, c, d, e, f)`,
        // where the spread operator causes a 20-30x performance drop
        // (30x when compiled to ES5's `.apply(this, elements)`
        //  20x when used natively).
        e[0] = elements[0];
        e[1] = elements[1];
        e[2] = elements[2];
        e[3] = elements[3];
        e[4] = elements[4];
        e[5] = elements[5];
        return this;
    };
    Object.defineProperty(Matrix.prototype, 'identity', {
        get: function () {
            var e = this.elements;
            return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0;
        },
        enumerable: false,
        configurable: true,
    });
    /**
     * Performs the AxB matrix multiplication and saves the result
     * to `C`, if given, or to `A` otherwise.
     */
    Matrix.prototype.AxB = function (A, B, C) {
        var a = A[0] * B[0] + A[2] * B[1],
            b = A[1] * B[0] + A[3] * B[1],
            c = A[0] * B[2] + A[2] * B[3],
            d = A[1] * B[2] + A[3] * B[3],
            e = A[0] * B[4] + A[2] * B[5] + A[4],
            f = A[1] * B[4] + A[3] * B[5] + A[5];
        C = C !== null && C !== void 0 ? C : A;
        C[0] = a;
        C[1] = b;
        C[2] = c;
        C[3] = d;
        C[4] = e;
        C[5] = f;
    };
    /**
     * The `other` matrix gets post-multiplied to the current matrix.
     * Returns the current matrix.
     * @param other
     */
    Matrix.prototype.multiplySelf = function (other) {
        this.AxB(this.elements, other.elements);
        return this;
    };
    /**
     * The `other` matrix gets post-multiplied to the current matrix.
     * Returns a new matrix.
     * @param other
     */
    Matrix.prototype.multiply = function (other) {
        var elements = new Array(6);
        this.AxB(this.elements, other.elements, elements);
        return new Matrix(elements);
    };
    Matrix.prototype.preMultiplySelf = function (other) {
        this.AxB(other.elements, this.elements, this.elements);
        return this;
    };
    /**
     * Returns the inverse of this matrix as a new matrix.
     */
    Matrix.prototype.inverse = function () {
        var el = this.elements;
        var a = el[0],
            b = el[1],
            c = el[2],
            d = el[3];
        var e = el[4],
            f = el[5];
        var rD = 1 / (a * d - b * c); // reciprocal of determinant
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        return new Matrix([d, -b, -c, a, c * f - d * e, b * e - a * f]);
    };
    /**
     * Save the inverse of this matrix to the given matrix.
     */
    Matrix.prototype.inverseTo = function (other) {
        var el = this.elements;
        var a = el[0],
            b = el[1],
            c = el[2],
            d = el[3];
        var e = el[4],
            f = el[5];
        var rD = 1 / (a * d - b * c); // reciprocal of determinant
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        other.setElements([d, -b, -c, a, c * f - d * e, b * e - a * f]);
        return this;
    };
    Matrix.prototype.invertSelf = function () {
        var el = this.elements;
        var a = el[0],
            b = el[1],
            c = el[2],
            d = el[3];
        var e = el[4],
            f = el[5];
        var rD = 1 / (a * d - b * c); // reciprocal of determinant
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        el[0] = d;
        el[1] = -b;
        el[2] = -c;
        el[3] = a;
        el[4] = c * f - d * e;
        el[5] = b * e - a * f;
        return this;
    };
    Matrix.prototype.transformPoint = function (x, y) {
        var e = this.elements;
        return {
            x: x * e[0] + y * e[2] + e[4],
            y: x * e[1] + y * e[3] + e[5],
        };
    };
    Matrix.prototype.transformBBox = function (bbox, target) {
        var elements = this.elements;
        var xx = elements[0];
        var xy = elements[1];
        var yx = elements[2];
        var yy = elements[3];
        var h_w = bbox.width * 0.5;
        var h_h = bbox.height * 0.5;
        var cx = bbox.x + h_w;
        var cy = bbox.y + h_h;
        var w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
        var h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
        if (!target) {
            target = new BBox(0, 0, 0, 0);
        }
        target.x = cx * xx + cy * yx + elements[4] - w;
        target.y = cx * xy + cy * yy + elements[5] - h;
        target.width = w + w;
        target.height = h + h;
        return target;
    };
    Matrix.prototype.toContext = function (ctx) {
        // It's fair to say that matrix multiplications are not cheap.
        // However, updating path definitions on every frame isn't either, so
        // it may be cheaper to just translate paths. It's also fair to
        // say, that most paths will have to be re-rendered anyway, say
        // rectangle paths in a bar chart, where an animation would happen when
        // the data set changes and existing bars are morphed into new ones.
        // Or a pie chart, where old sectors are also morphed into new ones.
        // Same for the line chart. The only plausible case where translating
        // existing paths would be enough, is the scatter chart, where marker
        // icons, typically circles, stay the same size. But if circle radii
        // are bound to some data points, even circle paths would have to be
        // updated. And thus it makes sense to optimize for fewer matrix
        // transforms, where transform matrices of paths are mostly identity
        // matrices and `x`/`y`, `centerX`/`centerY` and similar properties
        // are used to define a path at specific coordinates. And only groups
        // are used to collectively apply a transform to a set of nodes.
        // If the matrix is mostly identity (95% of the time),
        // the `if (this.isIdentity)` check can make this call 3-4 times
        // faster on average: https://jsperf.com/matrix-check-first-vs-always-set
        if (this.identity) {
            return;
        }
        var e = this.elements;
        ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
    };
    Matrix.flyweight = function (sourceMatrix) {
        return Matrix.instance.setElements(sourceMatrix.elements);
    };
    Matrix.updateTransformMatrix = function (matrix, scalingX, scalingY, rotation, translationX, translationY, opts) {
        // Assume that centers of scaling and rotation are at the origin.
        var _a = __read$19([0, 0], 2),
            bbcx = _a[0],
            bbcy = _a[1];
        var sx = scalingX;
        var sy = scalingY;
        var scx;
        var scy;
        if (sx === 1 && sy === 1) {
            scx = 0;
            scy = 0;
        } else {
            scx =
                (opts === null || opts === void 0 ? void 0 : opts.scalingCenterX) == null
                    ? bbcx
                    : opts === null || opts === void 0
                    ? void 0
                    : opts.scalingCenterX;
            scy =
                (opts === null || opts === void 0 ? void 0 : opts.scalingCenterY) == null
                    ? bbcy
                    : opts === null || opts === void 0
                    ? void 0
                    : opts.scalingCenterY;
        }
        var r = rotation;
        var cos = Math.cos(r);
        var sin = Math.sin(r);
        var rcx;
        var rcy;
        if (r === 0) {
            rcx = 0;
            rcy = 0;
        } else {
            rcx =
                (opts === null || opts === void 0 ? void 0 : opts.rotationCenterX) == null
                    ? bbcx
                    : opts === null || opts === void 0
                    ? void 0
                    : opts.rotationCenterX;
            rcy =
                (opts === null || opts === void 0 ? void 0 : opts.rotationCenterY) == null
                    ? bbcy
                    : opts === null || opts === void 0
                    ? void 0
                    : opts.rotationCenterY;
        }
        var tx = translationX;
        var ty = translationY;
        // The transform matrix `M` is a result of the following transformations:
        // 1) translate the center of scaling to the origin
        // 2) scale
        // 3) translate back
        // 4) translate the center of rotation to the origin
        // 5) rotate
        // 6) translate back
        // 7) translate
        //         (7)          (6)             (5)             (4)           (3)           (2)           (1)
        //     | 1 0 tx |   | 1 0 rcx |   | cos -sin 0 |   | 1 0 -rcx |   | 1 0 scx |   | sx 0 0 |   | 1 0 -scx |
        // M = | 0 1 ty | * | 0 1 rcy | * | sin  cos 0 | * | 0 1 -rcy | * | 0 1 scy | * | 0 sy 0 | * | 0 1 -scy |
        //     | 0 0  1 |   | 0 0  1  |   |  0    0  1 |   | 0 0  1   |   | 0 0  1  |   | 0  0 0 |   | 0 0  1   |
        // Translation after steps 1-4 above:
        var tx4 = scx * (1 - sx) - rcx;
        var ty4 = scy * (1 - sy) - rcy;
        matrix.setElements([
            cos * sx,
            sin * sx,
            -sin * sy,
            cos * sy,
            cos * tx4 - sin * ty4 + rcx + tx,
            sin * tx4 + cos * ty4 + rcy + ty,
        ]);
        return matrix;
    };
    Matrix.fromContext = function (ctx) {
        var domMatrix = ctx.getTransform();
        return new Matrix([domMatrix.a, domMatrix.b, domMatrix.c, domMatrix.d, domMatrix.e, domMatrix.f]);
    };
    Matrix.instance = new Matrix();
    return Matrix;
})();

var ID_MAP = {};
function createId$1(instance) {
    var _a;
    var constructor = instance.constructor;
    var className = Object.prototype.hasOwnProperty.call(constructor, 'className')
        ? constructor.className
        : constructor.name;
    if (!className) {
        throw new Error('The ' + constructor + " is missing the 'className' property.");
    }
    var nextId = ((_a = ID_MAP[className]) !== null && _a !== void 0 ? _a : 0) + 1;
    ID_MAP[className] = nextId;
    return className + '-' + nextId;
}

var RedrawType;
(function (RedrawType) {
    RedrawType[(RedrawType['NONE'] = 0)] = 'NONE';
    // Canvas doesn't need clearing, an incremental re-rerender is sufficient.
    RedrawType[(RedrawType['TRIVIAL'] = 1)] = 'TRIVIAL';
    // Group needs clearing, a semi-incremental re-render is sufficient.
    RedrawType[(RedrawType['MINOR'] = 2)] = 'MINOR';
    // Canvas needs to be cleared for these redraw types.
    RedrawType[(RedrawType['MAJOR'] = 3)] = 'MAJOR';
})(RedrawType || (RedrawType = {}));
/** @returns true if new Function() is disabled in the current execution context. */
function functionConstructorAvailable() {
    try {
        new Function('return true');
        return true;
    } catch (e) {
        return false;
    }
}
var STRING_FUNCTION_USEABLE = functionConstructorAvailable();
function SceneChangeDetection(opts) {
    var _a = opts !== null && opts !== void 0 ? opts : {},
        changeCb = _a.changeCb,
        convertor = _a.convertor;
    return function (target, key) {
        // `target` is either a constructor (static member) or prototype (instance member)
        var privateKey = '__' + key;
        if (target[key]) {
            return;
        }
        if (STRING_FUNCTION_USEABLE && changeCb == null && convertor == null) {
            prepareFastGetSet(target, key, privateKey, opts);
        } else {
            prepareSlowGetSet(target, key, privateKey, opts);
        }
    };
}
function prepareFastGetSet(target, key, privateKey, opts) {
    var _a = opts !== null && opts !== void 0 ? opts : {},
        _b = _a.redraw,
        redraw = _b === void 0 ? RedrawType.TRIVIAL : _b,
        _c = _a.type,
        type = _c === void 0 ? 'normal' : _c,
        _d = _a.checkDirtyOnAssignment,
        checkDirtyOnAssignment = _d === void 0 ? false : _d;
    // Optimised code-path.
    // Remove all conditional logic from runtime - generate a setter with the exact necessary
    // steps, as these setters are called a LOT during update cycles.
    var setterJs = new Function(
        'value',
        '\n        const oldValue = this.' +
            privateKey +
            ';\n        if (value !== oldValue) {\n            this.' +
            privateKey +
            ' = value;\n            ' +
            (type === 'normal' ? 'this.markDirty(this, ' + redraw + ');' : '') +
            '\n            ' +
            (type === 'transform' ? 'this.markDirtyTransform(' + redraw + ');' : '') +
            '\n            ' +
            (type === 'path'
                ? 'if (!this._dirtyPath) { this._dirtyPath = true; this.markDirty(this, ' + redraw + '); }'
                : '') +
            '\n            ' +
            (type === 'font'
                ? 'if (!this._dirtyFont) { this._dirtyFont = true; this.markDirty(this, ' + redraw + '); }'
                : '') +
            '\n        }\n        ' +
            (checkDirtyOnAssignment
                ? 'if (value != null && value._dirty > ' +
                  RedrawType.NONE +
                  ') { this.markDirty(value, value._dirty); }'
                : '') +
            '\n',
    );
    var getterJs = new Function('return this.' + privateKey + ';');
    Object.defineProperty(target, key, {
        set: setterJs,
        get: getterJs,
        enumerable: true,
        configurable: true,
    });
}
function prepareSlowGetSet(target, key, privateKey, opts) {
    var _a = opts !== null && opts !== void 0 ? opts : {},
        _b = _a.redraw,
        redraw = _b === void 0 ? RedrawType.TRIVIAL : _b,
        _c = _a.type,
        type = _c === void 0 ? 'normal' : _c,
        changeCb = _a.changeCb,
        convertor = _a.convertor,
        _d = _a.checkDirtyOnAssignment,
        checkDirtyOnAssignment = _d === void 0 ? false : _d;
    // Unoptimised but 'safe' code-path, for environments with CSP headers and no 'unsafe-eval'.
    // We deliberately do not support debug branches found in the optimised path above, since
    // for large data-set series performance deteriorates with every extra branch here.
    var setter = function (value) {
        var oldValue = this[privateKey];
        value = convertor ? convertor(value) : value;
        if (value !== oldValue) {
            this[privateKey] = value;
            if (type === 'normal') this.markDirty(this, redraw);
            if (type === 'transform') this.markDirtyTransform(redraw);
            if (type === 'path' && !this._dirtyPath) {
                this._dirtyPath = true;
                this.markDirty(this, redraw);
            }
            if (type === 'font' && !this._dirtyFont) {
                this._dirtyFont = true;
                this.markDirty(this, redraw);
            }
            if (changeCb) changeCb(this);
        }
        if (checkDirtyOnAssignment && value != null && value._dirty > RedrawType.NONE)
            this.markDirty(value, value._dirty);
    };
    var getter = function () {
        return this[privateKey];
    };
    Object.defineProperty(target, key, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: true,
    });
}
var ChangeDetectable = /** @class */ (function () {
    function ChangeDetectable() {
        this._dirty = RedrawType.MAJOR;
    }
    ChangeDetectable.prototype.markDirty = function (_source, type) {
        if (type === void 0) {
            type = RedrawType.TRIVIAL;
        }
        if (this._dirty > type) {
            return;
        }
        this._dirty = type;
    };
    ChangeDetectable.prototype.markClean = function (_opts) {
        this._dirty = RedrawType.NONE;
    };
    ChangeDetectable.prototype.isDirty = function () {
        return this._dirty > RedrawType.NONE;
    };
    return ChangeDetectable;
})();

var __extends$2M =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1Z =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$N =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$18 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$H =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var PointerEvents;
(function (PointerEvents) {
    PointerEvents[(PointerEvents['All'] = 0)] = 'All';
    PointerEvents[(PointerEvents['None'] = 1)] = 'None';
})(PointerEvents || (PointerEvents = {}));
var zIndexChangedCallback = function (o) {
    if (o.parent) {
        o.parent.dirtyZIndex = true;
    }
    o.zIndexChanged();
};
/**
 * Abstract scene graph node.
 * Each node can have zero or one parent and belong to zero or one scene.
 */
var Node = /** @class */ (function (_super) {
    __extends$2M(Node, _super);
    function Node(_a) {
        var _b = _a === void 0 ? {} : _a,
            isVirtual = _b.isVirtual;
        var _this = _super.call(this) || this;
        /** Unique number to allow creation order to be easily determined. */
        _this.serialNumber = Node._nextSerialNumber++;
        /**
         * Unique node ID in the form `ClassName-NaturalNumber`.
         */
        _this.id = createId$1(_this);
        /**
         * Some number to identify this node, typically within a `Group` node.
         * Usually this will be some enum value used as a selector.
         */
        _this.tag = NaN;
        /**
         * To simplify the type system (especially in Selections) we don't have the `Parent` node
         * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
         * But we still need to distinguish regular leaf nodes from container leafs somehow.
         */
        _this.isContainerNode = false;
        _this._virtualChildren = [];
        _this._children = [];
        // Used to check for duplicate nodes.
        _this.childSet = {}; // new Set<Node>()
        // These matrices may need to have package level visibility
        // for performance optimization purposes.
        _this.matrix = new Matrix();
        _this.inverseMatrix = new Matrix();
        _this.dirtyTransform = false;
        _this.scalingX = 1;
        _this.scalingY = 1;
        /**
         * The center of scaling.
         * The default value of `null` means the scaling center will be
         * determined automatically, as the center of the bounding box
         * of a node.
         */
        _this.scalingCenterX = null;
        _this.scalingCenterY = null;
        _this.rotationCenterX = null;
        _this.rotationCenterY = null;
        /**
         * Rotation angle in radians.
         * The value is set as is. No normalization to the [-180, 180) or [0, 360)
         * interval is performed.
         */
        _this.rotation = 0;
        _this.translationX = 0;
        _this.translationY = 0;
        _this.visible = true;
        _this.dirtyZIndex = false;
        _this.zIndex = 0;
        /** Discriminators for render order within a zIndex. */
        _this.zIndexSubOrder = undefined;
        _this.pointerEvents = PointerEvents.All;
        _this.isVirtual = isVirtual !== null && isVirtual !== void 0 ? isVirtual : false;
        return _this;
    }
    Object.defineProperty(Node.prototype, 'datum', {
        /**
         * Some arbitrary data bound to the node.
         */
        get: function () {
            var _a;
            if (this._datum !== undefined) {
                return this._datum;
            }
            return (_a = this._parent) === null || _a === void 0 ? void 0 : _a.datum;
        },
        set: function (datum) {
            this._datum = datum;
        },
        enumerable: false,
        configurable: true,
    });
    Node.prototype._setLayerManager = function (value) {
        var e_1, _a, e_2, _b;
        this._layerManager = value;
        this._debug = value === null || value === void 0 ? void 0 : value.debug;
        try {
            for (var _c = __values$N(this._children), _d = _c.next(); !_d.done; _d = _c.next()) {
                var child = _d.value;
                child._setLayerManager(value);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        try {
            for (var _e = __values$N(this._virtualChildren), _f = _e.next(); !_f.done; _f = _e.next()) {
                var child = _f.value;
                child._setLayerManager(value);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    };
    Object.defineProperty(Node.prototype, 'layerManager', {
        get: function () {
            return this._layerManager;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Node.prototype, 'parent', {
        get: function () {
            return this._parent;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Node.prototype, 'children', {
        get: function () {
            var e_3, _a;
            if (this._virtualChildren.length === 0) return this._children;
            var result = __spreadArray$H([], __read$18(this._children));
            try {
                for (var _b = __values$N(this._virtualChildren), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var next = _c.value;
                    result.push.apply(result, __spreadArray$H([], __read$18(next.children)));
                }
            } catch (e_3_1) {
                e_3 = { error: e_3_1 };
            } finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally {
                    if (e_3) throw e_3.error;
                }
            }
            return result;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Node.prototype, 'virtualChildren', {
        get: function () {
            return this._virtualChildren;
        },
        enumerable: false,
        configurable: true,
    });
    Node.prototype.hasVirtualChildren = function () {
        return this._virtualChildren.length > 0;
    };
    /**
     * Appends one or more new node instances to this parent.
     * If one needs to:
     * - move a child to the end of the list of children
     * - move a child from one parent to another (including parents in other scenes)
     * one should use the {@link insertBefore} method instead.
     * @param nodes A node or nodes to append.
     */
    Node.prototype.append = function (nodes) {
        var e_4, _a;
        // Passing a single parameter to an open-ended version of `append`
        // would be 30-35% slower than this.
        if (!Array.isArray(nodes)) {
            nodes = [nodes];
        }
        try {
            for (
                var nodes_1 = __values$N(nodes), nodes_1_1 = nodes_1.next();
                !nodes_1_1.done;
                nodes_1_1 = nodes_1.next()
            ) {
                var node = nodes_1_1.value;
                if (node.parent) {
                    throw new Error(node + ' already belongs to another parent: ' + node.parent + '.');
                }
                if (node.layerManager) {
                    throw new Error(node + ' already belongs to a scene: ' + node.layerManager + '.');
                }
                if (this.childSet[node.id]) {
                    // Cast to `any` to avoid `Property 'name' does not exist on type 'Function'`.
                    throw new Error('Duplicate ' + node.constructor.name + ' node: ' + node);
                }
                if (node.isVirtual) {
                    this._virtualChildren.push(node);
                } else {
                    this._children.push(node);
                }
                this.childSet[node.id] = true;
                node._parent = this;
                node._setLayerManager(this.layerManager);
            }
        } catch (e_4_1) {
            e_4 = { error: e_4_1 };
        } finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            } finally {
                if (e_4) throw e_4.error;
            }
        }
        this.dirtyZIndex = true;
        this.markDirty(this, RedrawType.MAJOR);
    };
    Node.prototype.appendChild = function (node) {
        this.append(node);
        return node;
    };
    Node.prototype.removeChild = function (node) {
        var error = function () {
            throw new Error('The node to be removed is not a child of this node.');
        };
        if (node.parent !== this) {
            error();
        }
        if (node.isVirtual) {
            var i = this._virtualChildren.indexOf(node);
            if (i < 0) error();
            this._virtualChildren.splice(i, 1);
        } else {
            var i = this._children.indexOf(node);
            if (i < 0) error();
            this._children.splice(i, 1);
        }
        delete this.childSet[node.id];
        node._parent = undefined;
        node._setLayerManager();
        this.dirtyZIndex = true;
        this.markDirty(node, RedrawType.MAJOR);
        return node;
    };
    Node.prototype.calculateCumulativeMatrix = function () {
        this.computeTransformMatrix();
        var matrix = Matrix.flyweight(this.matrix);
        var parent = this.parent;
        while (parent) {
            parent.computeTransformMatrix();
            matrix.preMultiplySelf(parent.matrix);
            parent = parent.parent;
        }
        return matrix;
    };
    Node.prototype.transformPoint = function (x, y) {
        var matrix = this.calculateCumulativeMatrix();
        return matrix.invertSelf().transformPoint(x, y);
    };
    Node.prototype.inverseTransformPoint = function (x, y) {
        var matrix = this.calculateCumulativeMatrix();
        return matrix.transformPoint(x, y);
    };
    Node.prototype.transformBBox = function (bbox) {
        var matrix = this.calculateCumulativeMatrix();
        return matrix.invertSelf().transformBBox(bbox);
    };
    Node.prototype.inverseTransformBBox = function (bbox) {
        var matrix = this.calculateCumulativeMatrix();
        return matrix.transformBBox(bbox);
    };
    Node.prototype.markDirtyTransform = function () {
        this.dirtyTransform = true;
        this.markDirty(this, RedrawType.MAJOR);
    };
    Node.prototype.containsPoint = function (_x, _y) {
        return false;
    };
    /**
     * Hit testing method.
     * Recursively checks if the given point is inside this node or any of its children.
     * Returns the first matching node or `undefined`.
     * Nodes that render later (show on top) are hit tested first.
     */
    Node.prototype.pickNode = function (x, y) {
        var _a;
        if (!this.visible || this.pointerEvents === PointerEvents.None || !this.containsPoint(x, y)) {
            return;
        }
        var children = this.children;
        if (children.length > 1000) {
            // Try to optimise which children to interrogate; BBox calculation is an approximation
            // for more complex shapes, so discarding items based on this will save a lot of
            // processing when the point is nowhere near the child.
            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];
                var containsPoint =
                    (_a = child.computeTransformedBBox()) === null || _a === void 0 ? void 0 : _a.containsPoint(x, y);
                var hit = containsPoint ? child.pickNode(x, y) : undefined;
                if (hit) {
                    return hit;
                }
            }
        } else if (children.length) {
            // Nodes added later should be hit-tested first,
            // as they are rendered on top of the previously added nodes.
            for (var i = children.length - 1; i >= 0; i--) {
                var hit = children[i].pickNode(x, y);
                if (hit) {
                    return hit;
                }
            }
        } else if (!this.isContainerNode) {
            // a leaf node, but not a container leaf
            return this;
        }
    };
    Node.prototype.findNodes = function (predicate) {
        var e_5, _a;
        var result = predicate(this) ? [this] : [];
        try {
            for (var _b = __values$N(this.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                var childResult = child.findNodes(predicate);
                if (childResult) {
                    result.push.apply(result, __spreadArray$H([], __read$18(childResult)));
                }
            }
        } catch (e_5_1) {
            e_5 = { error: e_5_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_5) throw e_5.error;
            }
        }
        return result;
    };
    Node.prototype.computeBBox = function () {
        return;
    };
    Node.prototype.computeTransformedBBox = function () {
        var bbox = this.computeBBox();
        if (!bbox) {
            return undefined;
        }
        this.computeTransformMatrix();
        var matrix = Matrix.flyweight(this.matrix);
        var parent = this.parent;
        while (parent) {
            parent.computeTransformMatrix();
            matrix.preMultiplySelf(parent.matrix);
            parent = parent.parent;
        }
        matrix.transformBBox(bbox, bbox);
        return bbox;
    };
    Node.prototype.computeTransformMatrix = function () {
        if (!this.dirtyTransform) {
            return;
        }
        var _a = this,
            matrix = _a.matrix,
            scalingX = _a.scalingX,
            scalingY = _a.scalingY,
            rotation = _a.rotation,
            translationX = _a.translationX,
            translationY = _a.translationY,
            scalingCenterX = _a.scalingCenterX,
            scalingCenterY = _a.scalingCenterY,
            rotationCenterX = _a.rotationCenterX,
            rotationCenterY = _a.rotationCenterY;
        Matrix.updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, {
            scalingCenterX: scalingCenterX,
            scalingCenterY: scalingCenterY,
            rotationCenterX: rotationCenterX,
            rotationCenterY: rotationCenterY,
        });
        matrix.inverseTo(this.inverseMatrix);
        this.dirtyTransform = false;
    };
    Node.prototype.render = function (renderCtx) {
        var stats = renderCtx.stats;
        this._dirty = RedrawType.NONE;
        if (stats) stats.nodesRendered++;
    };
    Node.prototype.clearBBox = function (ctx) {
        var bbox = this.computeBBox();
        if (bbox == null) {
            return;
        }
        var x = bbox.x,
            y = bbox.y,
            width = bbox.width,
            height = bbox.height;
        var topLeft = this.transformPoint(x, y);
        var bottomRight = this.transformPoint(x + width, y + height);
        ctx.clearRect(topLeft.x, topLeft.y, bottomRight.x - topLeft.x, bottomRight.y - topLeft.y);
    };
    Node.prototype.markDirty = function (_source, type, parentType) {
        if (type === void 0) {
            type = RedrawType.TRIVIAL;
        }
        if (parentType === void 0) {
            parentType = type;
        }
        if (this._dirty > type) {
            return;
        }
        if (this._dirty === type && type === parentType) {
            return;
        }
        this._dirty = type;
        if (this.parent) {
            this.parent.markDirty(this, parentType);
        } else if (this.layerManager) {
            this.layerManager.markDirty();
        }
    };
    Object.defineProperty(Node.prototype, 'dirty', {
        get: function () {
            return this._dirty;
        },
        enumerable: false,
        configurable: true,
    });
    Node.prototype.markClean = function (opts) {
        var e_6, _a, e_7, _b;
        var _c = opts !== null && opts !== void 0 ? opts : {},
            _d = _c.force,
            force = _d === void 0 ? false : _d,
            _e = _c.recursive,
            recursive = _e === void 0 ? true : _e;
        if (this._dirty === RedrawType.NONE && !force) {
            return;
        }
        this._dirty = RedrawType.NONE;
        if (recursive !== false) {
            try {
                for (var _f = __values$N(this._virtualChildren), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var child = _g.value;
                    child.markClean({ force: force });
                }
            } catch (e_6_1) {
                e_6 = { error: e_6_1 };
            } finally {
                try {
                    if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                } finally {
                    if (e_6) throw e_6.error;
                }
            }
        }
        if (recursive === true) {
            try {
                for (var _h = __values$N(this._children), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var child = _j.value;
                    child.markClean({ force: force });
                }
            } catch (e_7_1) {
                e_7 = { error: e_7_1 };
            } finally {
                try {
                    if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                } finally {
                    if (e_7) throw e_7.error;
                }
            }
        }
    };
    Node.prototype.visibilityChanged = function () {
        // Override point for sub-classes to react to visibility changes.
    };
    Object.defineProperty(Node.prototype, 'nodeCount', {
        get: function () {
            var e_8, _a, e_9, _b;
            var count = 1;
            var dirtyCount = this._dirty >= RedrawType.NONE || this.dirtyTransform ? 1 : 0;
            var visibleCount = this.visible ? 1 : 0;
            var countChild = function (child) {
                var _a = child.nodeCount,
                    childCount = _a.count,
                    childVisibleCount = _a.visibleCount,
                    childDirtyCount = _a.dirtyCount;
                count += childCount;
                visibleCount += childVisibleCount;
                dirtyCount += childDirtyCount;
            };
            try {
                for (var _c = __values$N(this._children), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    countChild(child);
                }
            } catch (e_8_1) {
                e_8 = { error: e_8_1 };
            } finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally {
                    if (e_8) throw e_8.error;
                }
            }
            try {
                for (var _e = __values$N(this._virtualChildren), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var child = _f.value;
                    countChild(child);
                }
            } catch (e_9_1) {
                e_9 = { error: e_9_1 };
            } finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                    if (e_9) throw e_9.error;
                }
            }
            return { count: count, visibleCount: visibleCount, dirtyCount: dirtyCount };
        },
        enumerable: false,
        configurable: true,
    });
    Node.prototype.zIndexChanged = function () {
        // Override point for sub-classes.
    };
    Node._nextSerialNumber = 0;
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'scalingX', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'scalingY', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'scalingCenterX', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'scalingCenterY', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'rotationCenterX', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'rotationCenterY', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'rotation', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'translationX', void 0);
    __decorate$1Z([SceneChangeDetection({ type: 'transform' })], Node.prototype, 'translationY', void 0);
    __decorate$1Z(
        [
            SceneChangeDetection({
                redraw: RedrawType.MAJOR,
                changeCb: function (o) {
                    return o.visibilityChanged();
                },
            }),
        ],
        Node.prototype,
        'visible',
        void 0,
    );
    __decorate$1Z(
        [
            SceneChangeDetection({
                redraw: RedrawType.TRIVIAL,
                changeCb: zIndexChangedCallback,
            }),
        ],
        Node.prototype,
        'zIndex',
        void 0,
    );
    __decorate$1Z(
        [
            SceneChangeDetection({
                redraw: RedrawType.TRIVIAL,
                changeCb: zIndexChangedCallback,
            }),
        ],
        Node.prototype,
        'zIndexSubOrder',
        void 0,
    );
    return Node;
})(ChangeDetectable);

function ascendingStringNumberUndefined(a, b) {
    var diff = 0;
    if (typeof a === 'number' && typeof b === 'number') {
        diff = a - b;
    } else if (typeof a === 'string' && typeof b === 'string') {
        diff = a.localeCompare(b);
    } else if (a == null && b == null);
    else if (a == null) {
        diff = -1;
    } else if (b == null) {
        diff = 1;
    } else {
        diff = String(a).localeCompare(String(b));
    }
    return diff;
}
function compoundAscending(a, b, comparator) {
    var toLiteral = function (v) {
        if (typeof v === 'function') {
            return v();
        }
        return v;
    };
    for (var idx in a) {
        var diff = comparator(toLiteral(a[idx]), toLiteral(b[idx]));
        if (diff !== 0) {
            return diff;
        }
    }
    return 0;
}

var doOnceFlags$1 = {};
/**
 * If the key was passed before, then doesn't execute the func
 */
function doOnce$1(func, key) {
    if (doOnceFlags$1[key]) {
        return;
    }
    func();
    doOnceFlags$1[key] = true;
}

var __read$17 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$G =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var Logger = {
    debug: function () {
        var logContent = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            logContent[_i] = arguments[_i];
        }
        console.log.apply(console, __spreadArray$G([], __read$17(logContent)));
    },
    warn: function (message) {
        var logContent = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logContent[_i - 1] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray$G(['AG Charts - ' + message], __read$17(logContent)));
    },
    error: function (message) {
        var logContent = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logContent[_i - 1] = arguments[_i];
        }
        if (typeof message === 'object') {
            console.error.apply(console, __spreadArray$G(['AG Charts error', message], __read$17(logContent)));
        } else {
            console.error.apply(console, __spreadArray$G(['AG Charts - ' + message], __read$17(logContent)));
        }
    },
    warnOnce: function (message) {
        var logContent = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logContent[_i - 1] = arguments[_i];
        }
        doOnce$1(function () {
            return Logger.warn.apply(Logger, __spreadArray$G([message], __read$17(logContent)));
        }, 'Logger.warn: ' + message);
    },
    errorOnce: function (message) {
        var logContent = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            logContent[_i - 1] = arguments[_i];
        }
        doOnce$1(function () {
            return Logger.error.apply(Logger, __spreadArray$G([message], __read$17(logContent)));
        }, 'Logger.warn: ' + message);
    },
};

var __extends$2L =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$V =
    (undefined && undefined.__assign) ||
    function () {
        __assign$V =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$V.apply(this, arguments);
    };
var __decorate$1Y =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$M =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$16 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$F =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var Group = /** @class */ (function (_super) {
    __extends$2L(Group, _super);
    function Group(opts) {
        var _a;
        var _this =
            _super.call(this, { isVirtual: opts === null || opts === void 0 ? void 0 : opts.isVirtual }) || this;
        _this.opts = opts;
        _this.opacity = 1;
        _this.lastBBox = undefined;
        var _b = opts !== null && opts !== void 0 ? opts : {},
            zIndex = _b.zIndex,
            zIndexSubOrder = _b.zIndexSubOrder;
        _this.isContainerNode = true;
        if (zIndex !== undefined) {
            _this.zIndex = zIndex;
        }
        if (zIndexSubOrder !== undefined) {
            _this.zIndexSubOrder = zIndexSubOrder;
        }
        _this.name = (_a = _this.opts) === null || _a === void 0 ? void 0 : _a.name;
        return _this;
    }
    Group.prototype.zIndexChanged = function () {
        var _a;
        if (this.layer) {
            (_a = this._layerManager) === null || _a === void 0
                ? void 0
                : _a.moveLayer(this.layer, this.zIndex, this.zIndexSubOrder);
        }
    };
    Group.prototype.isLayer = function () {
        return this.layer != null;
    };
    Group.prototype._setLayerManager = function (scene) {
        var _this = this;
        var _a, _b;
        if (this._layerManager && this.layer) {
            this._layerManager.removeLayer(this.layer);
            this.layer = undefined;
        }
        if (this.layer) {
            throw new Error('AG Charts - unable to deregister scene rendering layer!');
        }
        _super.prototype._setLayerManager.call(this, scene);
        if (scene && ((_a = this.opts) === null || _a === void 0 ? void 0 : _a.layer)) {
            var _c = (_b = this.opts) !== null && _b !== void 0 ? _b : {},
                zIndex = _c.zIndex,
                zIndexSubOrder = _c.zIndexSubOrder,
                name_1 = _c.name;
            var getComputedOpacity = function () {
                return _this.getComputedOpacity();
            };
            var getVisibility = function () {
                return _this.getVisibility();
            };
            this.layer = scene.addLayer({
                zIndex: zIndex,
                zIndexSubOrder: zIndexSubOrder,
                name: name_1,
                getComputedOpacity: getComputedOpacity,
                getVisibility: getVisibility,
            });
        }
    };
    Group.prototype.getComputedOpacity = function () {
        var opacity = 1;
        var node = this;
        do {
            if (node instanceof Group) {
                opacity *= node.opacity;
            }
        } while ((node = node.parent));
        return opacity;
    };
    Group.prototype.getVisibility = function () {
        var node = this;
        var visible = this.visible;
        while ((node = node.parent)) {
            if (node.visible) {
                continue;
            }
            visible = node.visible;
        }
        return visible;
    };
    Group.prototype.visibilityChanged = function () {
        if (this.layer) {
            this.layer.enabled = this.visible;
        }
    };
    Group.prototype.markDirty = function (source, type) {
        if (type === void 0) {
            type = RedrawType.TRIVIAL;
        }
        if (this.isVirtual) {
            // Always percolate directly for virtual nodes - they don't exist for rendering purposes.
            _super.prototype.markDirty.call(this, source, type);
            return;
        }
        // Downgrade dirty-ness percolated to parent in special cases.
        var parentType = type;
        if (type < RedrawType.MINOR) {
            parentType = RedrawType.TRIVIAL;
        } else if (this.layer != null) {
            parentType = RedrawType.TRIVIAL;
        }
        _super.prototype.markDirty.call(this, source, type, parentType);
    };
    // We consider a group to be boundless, thus any point belongs to it.
    Group.prototype.containsPoint = function (_x, _y) {
        return true;
    };
    Group.prototype.computeBBox = function () {
        this.computeTransformMatrix();
        return Group.computeBBox(this.children);
    };
    Group.prototype.computeTransformedBBox = function () {
        return this.computeBBox();
    };
    Group.prototype.render = function (renderCtx) {
        var e_1, _a, e_2, _b, e_3, _c;
        var _d, _e;
        var _f = this.opts,
            _g = _f === void 0 ? {} : _f,
            _h = _g.name,
            name = _h === void 0 ? undefined : _h;
        var _j = this._debug,
            _k = _j === void 0 ? {} : _j,
            _l = _k.consoleLog,
            consoleLog = _l === void 0 ? false : _l;
        var _m = this,
            dirty = _m.dirty,
            dirtyZIndex = _m.dirtyZIndex,
            layer = _m.layer,
            children = _m.children,
            clipRect = _m.clipRect,
            dirtyTransform = _m.dirtyTransform;
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            clipBBox = renderCtx.clipBBox;
        var resized = renderCtx.resized,
            stats = renderCtx.stats;
        var canvasCtxTransform = ctx.getTransform();
        var isDirty = dirty >= RedrawType.MINOR || dirtyZIndex || resized;
        var isChildDirty = isDirty;
        var isChildLayerDirty = false;
        try {
            for (
                var children_1 = __values$M(children), children_1_1 = children_1.next();
                !children_1_1.done;
                children_1_1 = children_1.next()
            ) {
                var child = children_1_1.value;
                isChildDirty || (isChildDirty = child.layerManager == null && child.dirty >= RedrawType.TRIVIAL);
                isChildLayerDirty ||
                    (isChildLayerDirty = child.layerManager != null && child.dirty >= RedrawType.TRIVIAL);
                if (isChildDirty) {
                    break;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        if (name && consoleLog) {
            Logger.debug({
                name: name,
                group: this,
                isDirty: isDirty,
                isChildDirty: isChildDirty,
                dirtyTransform: dirtyTransform,
                renderCtx: renderCtx,
                forceRender: forceRender,
            });
        }
        if (dirtyTransform) {
            forceRender = 'dirtyTransform';
        } else if (layer) {
            // If bounding-box of a layer changes, force re-render.
            var currentBBox = this.computeBBox();
            if (this.lastBBox === undefined || !this.lastBBox.equals(currentBBox)) {
                forceRender = 'dirtyTransform';
                this.lastBBox = currentBBox;
            }
        }
        if (!isDirty && !isChildDirty && !isChildLayerDirty && !forceRender) {
            if (name && consoleLog && stats) {
                var counts = this.nodeCount;
                Logger.debug({ name: name, result: 'skipping', renderCtx: renderCtx, counts: counts, group: this });
            }
            if (layer && stats) {
                stats.layersSkipped++;
                stats.nodesSkipped += this.nodeCount.count;
            }
            this.markClean({ recursive: false });
            // Nothing to do.
            return;
        }
        var groupVisible = this.visible;
        if (layer) {
            // Switch context to the canvas layer we use for this group.
            ctx = layer.context;
            ctx.save();
            ctx.resetTransform();
            if (forceRender !== 'dirtyTransform') {
                forceRender = isChildDirty || dirtyZIndex;
            }
            if (forceRender) layer.clear();
            if (clipBBox) {
                // clipBBox is in the canvas coordinate space, when we hit a layer we apply the new clipping at which point there are no transforms in play
                var width = clipBBox.width,
                    height = clipBBox.height,
                    x = clipBBox.x,
                    y = clipBBox.y;
                if (consoleLog) {
                    Logger.debug({
                        name: name,
                        clipBBox: clipBBox,
                        ctxTransform: ctx.getTransform(),
                        renderCtx: renderCtx,
                        group: this,
                    });
                }
                this.clipCtx(ctx, x, y, width, height);
            }
            ctx.setTransform(canvasCtxTransform);
        } else {
            // Only apply opacity if this isn't a distinct layer - opacity will be applied
            // at composition time.
            ctx.globalAlpha *= this.opacity;
        }
        // A group can have `scaling`, `rotation`, `translation` properties
        // that are applied to the canvas context before children are rendered,
        // so all children can be transformed at once.
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        if (clipRect) {
            // clipRect is in the group's coordinate space
            var x = clipRect.x,
                y = clipRect.y,
                width = clipRect.width,
                height = clipRect.height;
            ctx.save();
            if (consoleLog) {
                Logger.debug({
                    name: name,
                    clipRect: clipRect,
                    ctxTransform: ctx.getTransform(),
                    renderCtx: renderCtx,
                    group: this,
                });
            }
            this.clipCtx(ctx, x, y, width, height);
            // clipBBox is in the canvas coordinate space, when we hit a layer we apply the new clipping at which point there are no transforms in play
            clipBBox = this.matrix.transformBBox(clipRect);
        }
        var hasVirtualChildren = this.hasVirtualChildren();
        if (dirtyZIndex) {
            this.sortChildren(children);
            if (forceRender !== 'dirtyTransform') forceRender = true;
        } else if (hasVirtualChildren) {
            this.sortChildren(children);
        }
        // Reduce churn if renderCtx is identical.
        var renderContextChanged =
            forceRender !== renderCtx.forceRender || clipBBox !== renderCtx.clipBBox || ctx !== renderCtx.ctx;
        var childRenderContext = renderContextChanged
            ? __assign$V(__assign$V({}, renderCtx), { ctx: ctx, forceRender: forceRender, clipBBox: clipBBox })
            : renderCtx;
        // Render visible children.
        var skipped = 0;
        try {
            for (
                var children_2 = __values$M(children), children_2_1 = children_2.next();
                !children_2_1.done;
                children_2_1 = children_2.next()
            ) {
                var child = children_2_1.value;
                if (!child.visible || !groupVisible) {
                    // Skip invisible children, but make sure their dirty flag is reset.
                    child.markClean();
                    if (stats) skipped += child.nodeCount.count;
                    continue;
                }
                if (!forceRender && child.dirty === RedrawType.NONE) {
                    // Skip children that don't need to be redrawn.
                    if (stats) skipped += child.nodeCount.count;
                    continue;
                }
                // Render marks this node (and children) as clean - no need to explicitly markClean().
                ctx.save();
                child.render(childRenderContext);
                ctx.restore();
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (children_2_1 && !children_2_1.done && (_b = children_2.return)) _b.call(children_2);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        if (stats) stats.nodesSkipped += skipped;
        // Render marks this node as clean - no need to explicitly markClean().
        _super.prototype.render.call(this, renderCtx);
        if (clipRect) {
            ctx.restore();
        }
        if (hasVirtualChildren) {
            try {
                // Mark virtual nodes as clean and their virtual children - all other nodes have already
                // been visited and marked clean.
                for (var _o = __values$M(this.virtualChildren), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var child = _p.value;
                    child.markClean({ recursive: 'virtual' });
                }
            } catch (e_3_1) {
                e_3 = { error: e_3_1 };
            } finally {
                try {
                    if (_p && !_p.done && (_c = _o.return)) _c.call(_o);
                } finally {
                    if (e_3) throw e_3.error;
                }
            }
        }
        if (layer) {
            if (stats) stats.layersRendered++;
            ctx.restore();
            if (forceRender) layer.snapshot();
            // Check for save/restore depth of zero!
            (_e = (_d = layer.context).verifyDepthZero) === null || _e === void 0 ? void 0 : _e.call(_d);
        }
        if (name && consoleLog && stats) {
            var counts = this.nodeCount;
            Logger.debug({
                name: name,
                result: 'rendered',
                skipped: skipped,
                renderCtx: renderCtx,
                counts: counts,
                group: this,
            });
        }
    };
    Group.prototype.sortChildren = function (children) {
        this.dirtyZIndex = false;
        children.sort(function (a, b) {
            var _a, _b;
            return compoundAscending(
                __spreadArray$F(
                    __spreadArray$F(
                        [a.zIndex],
                        __read$16((_a = a.zIndexSubOrder) !== null && _a !== void 0 ? _a : [undefined, undefined]),
                    ),
                    [a.serialNumber],
                ),
                __spreadArray$F(
                    __spreadArray$F(
                        [b.zIndex],
                        __read$16((_b = b.zIndexSubOrder) !== null && _b !== void 0 ? _b : [undefined, undefined]),
                    ),
                    [b.serialNumber],
                ),
                ascendingStringNumberUndefined,
            );
        });
    };
    Group.prototype.clipCtx = function (ctx, x, y, width, height) {
        ctx.beginPath();
        ctx.moveTo(x, y);
        ctx.lineTo(x + width, y);
        ctx.lineTo(x + width, y + height);
        ctx.lineTo(x, y + height);
        ctx.closePath();
        ctx.clip();
    };
    Group.computeBBox = function (nodes) {
        var left = Infinity;
        var right = -Infinity;
        var top = Infinity;
        var bottom = -Infinity;
        nodes.forEach(function (n) {
            if (!n.visible) {
                return;
            }
            var bbox = n.computeTransformedBBox();
            if (!bbox) {
                return;
            }
            var x = bbox.x;
            var y = bbox.y;
            if (x < left) {
                left = x;
            }
            if (y < top) {
                top = y;
            }
            if (x + bbox.width > right) {
                right = x + bbox.width;
            }
            if (y + bbox.height > bottom) {
                bottom = y + bbox.height;
            }
        });
        return new BBox(left, top, right - left, bottom - top);
    };
    /**
     * Transforms bbox given in the canvas coordinate space to bbox in this group's coordinate space and
     * sets this group's clipRect to the transformed bbox.
     * @param bbox clipRect bbox in the canvas coordinate space.
     */
    Group.prototype.setClipRectInGroupCoordinateSpace = function (bbox) {
        this.clipRect = bbox ? this.transformBBox(bbox) : undefined;
    };
    Group.className = 'Group';
    __decorate$1Y(
        [
            SceneChangeDetection({
                redraw: RedrawType.MAJOR,
                convertor: function (v) {
                    return Math.min(1, Math.max(0, v));
                },
            }),
        ],
        Group.prototype,
        'opacity',
        void 0,
    );
    return Group;
})(Node);

/**
 * Wraps a native OffscreenCanvas and overrides its OffscreenCanvasRenderingContext2D to
 * provide resolution independent rendering based on `window.devicePixelRatio`.
 */
var HdpiOffscreenCanvas = /** @class */ (function () {
    // The width/height attributes of the Canvas element default to
    // 300/150 according to w3.org.
    function HdpiOffscreenCanvas(_a) {
        var _b = _a.width,
            width = _b === void 0 ? 600 : _b,
            _c = _a.height,
            height = _c === void 0 ? 300 : _c,
            _d = _a.overrideDevicePixelRatio,
            overrideDevicePixelRatio = _d === void 0 ? undefined : _d;
        this.enabled = true;
        // `NaN` is deliberate here, so that overrides are always applied
        // and the `resetTransform` inside the `resize` method works in IE11.
        this._pixelRatio = NaN;
        this._width = 0;
        this._height = 0;
        this.canvas = new OffscreenCanvas(width, height);
        this.context = this.canvas.getContext('2d');
        this.imageSource = this.canvas.transferToImageBitmap();
        this.setPixelRatio(overrideDevicePixelRatio);
        this.resize(width, height);
    }
    HdpiOffscreenCanvas.isSupported = function () {
        return window['OffscreenCanvas'] != null;
    };
    HdpiOffscreenCanvas.prototype.snapshot = function () {
        this.imageSource.close();
        this.imageSource = this.canvas.transferToImageBitmap();
    };
    HdpiOffscreenCanvas.prototype.destroy = function () {
        this.imageSource.close();
        // Workaround memory allocation quirks in iOS Safari by resizing to 0x0 and clearing.
        // See https://bugs.webkit.org/show_bug.cgi?id=195325.
        this.canvas.width = 0;
        this.canvas.height = 0;
        this.context.clearRect(0, 0, 0, 0);
    };
    HdpiOffscreenCanvas.prototype.clear = function () {
        this.context.save();
        this.context.resetTransform();
        this.context.clearRect(0, 0, this.width, this.height);
        this.context.restore();
    };
    Object.defineProperty(HdpiOffscreenCanvas.prototype, 'pixelRatio', {
        get: function () {
            return this._pixelRatio;
        },
        enumerable: false,
        configurable: true,
    });
    /**
     * Changes the pixel ratio of the Canvas element to the given value,
     * or uses the window.devicePixelRatio (default), then resizes the Canvas
     * element accordingly (default).
     */
    HdpiOffscreenCanvas.prototype.setPixelRatio = function (ratio) {
        var pixelRatio = ratio !== null && ratio !== void 0 ? ratio : window.devicePixelRatio;
        if (!isDesktop()) {
            // Mobile browsers have stricter memory limits, we reduce rendering resolution to
            // improve stability on mobile browsers. iOS Safari 12->16 are pain-points since they
            // have memory allocation quirks - see https://bugs.webkit.org/show_bug.cgi?id=195325.
            pixelRatio = 1;
        }
        HdpiCanvas.overrideScale(this.context, pixelRatio);
        this._pixelRatio = pixelRatio;
    };
    Object.defineProperty(HdpiOffscreenCanvas.prototype, 'width', {
        get: function () {
            return this._width;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(HdpiOffscreenCanvas.prototype, 'height', {
        get: function () {
            return this._height;
        },
        enumerable: false,
        configurable: true,
    });
    HdpiOffscreenCanvas.prototype.resize = function (width, height) {
        if (!(width > 0 && height > 0)) {
            return;
        }
        var _a = this,
            canvas = _a.canvas,
            context = _a.context,
            pixelRatio = _a.pixelRatio;
        canvas.width = Math.round(width * pixelRatio);
        canvas.height = Math.round(height * pixelRatio);
        context.resetTransform();
        this._width = width;
        this._height = height;
    };
    return HdpiOffscreenCanvas;
})();

function windowValue(name) {
    /**
     * Redeclaration of window that is safe for use with Gatsby server-side (webpack) compilation.
     */
    var WINDOW =
        typeof window !== 'undefined'
            ? window
            : // typeof global !== 'undefined' ? (global as any) :
              undefined;
    return WINDOW === null || WINDOW === void 0 ? void 0 : WINDOW[name];
}

var SceneDebugLevel;
(function (SceneDebugLevel) {
    SceneDebugLevel[(SceneDebugLevel['SUMMARY'] = 0)] = 'SUMMARY';
    SceneDebugLevel[(SceneDebugLevel['DETAILED'] = 1)] = 'DETAILED';
})(SceneDebugLevel || (SceneDebugLevel = {}));

var __assign$U =
    (undefined && undefined.__assign) ||
    function () {
        __assign$U =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$U.apply(this, arguments);
    };
var __awaiter$g =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$g =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$15 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$E =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$L =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function buildSceneNodeHighlight() {
    var _a;
    var config = (_a = windowValue('agChartsSceneDebug')) !== null && _a !== void 0 ? _a : [];
    if (typeof config === 'string') {
        config = [config];
    }
    var result = [];
    config.forEach(function (name) {
        if (name === 'layout') {
            result.push('seriesRoot', 'legend', 'root', /.*Axis-\d+-axis.*/);
        } else {
            result.push(name);
        }
    });
    return result;
}
var Scene = /** @class */ (function () {
    function Scene(opts) {
        var _a, _b, _c;
        this.id = createId$1(this);
        this.layers = [];
        this._nextZIndex = 0;
        this._nextLayerId = 0;
        this._dirty = false;
        this._root = null;
        this.debug = {
            dirtyTree: false,
            stats: false,
            renderBoundingBoxes: false,
            consoleLog: false,
            level: SceneDebugLevel.SUMMARY,
            sceneNodeHighlight: [],
        };
        var _d = opts.document,
            document = _d === void 0 ? window.document : _d,
            _e = opts.mode,
            mode =
                _e === void 0
                    ? (_a = windowValue('agChartsSceneRenderModel')) !== null && _a !== void 0
                        ? _a
                        : 'adv-composite'
                    : _e,
            width = opts.width,
            height = opts.height,
            _f = opts.overrideDevicePixelRatio,
            overrideDevicePixelRatio = _f === void 0 ? undefined : _f;
        this.overrideDevicePixelRatio = overrideDevicePixelRatio;
        this.opts = { document: document, mode: mode };
        this.debug.consoleLog = [true, 'scene'].includes(windowValue('agChartsDebug'));
        this.debug.level = ['scene'].includes(windowValue('agChartsDebug'))
            ? SceneDebugLevel.DETAILED
            : SceneDebugLevel.SUMMARY;
        this.debug.stats = (_b = windowValue('agChartsSceneStats')) !== null && _b !== void 0 ? _b : false;
        this.debug.dirtyTree = (_c = windowValue('agChartsSceneDirtyTree')) !== null && _c !== void 0 ? _c : false;
        this.debug.sceneNodeHighlight = buildSceneNodeHighlight();
        this.canvas = new HdpiCanvas({
            document: document,
            width: width,
            height: height,
            overrideDevicePixelRatio: overrideDevicePixelRatio,
        });
    }
    Object.defineProperty(Scene.prototype, 'container', {
        get: function () {
            return this.canvas.container;
        },
        set: function (value) {
            this.canvas.container = value;
        },
        enumerable: false,
        configurable: true,
    });
    Scene.prototype.download = function (fileName, fileFormat) {
        this.canvas.download(fileName, fileFormat);
    };
    Scene.prototype.getDataURL = function (type) {
        return this.canvas.getDataURL(type);
    };
    Object.defineProperty(Scene.prototype, 'width', {
        get: function () {
            return this.pendingSize ? this.pendingSize[0] : this.canvas.width;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Scene.prototype, 'height', {
        get: function () {
            return this.pendingSize ? this.pendingSize[1] : this.canvas.height;
        },
        enumerable: false,
        configurable: true,
    });
    Scene.prototype.resize = function (width, height) {
        width = Math.round(width);
        height = Math.round(height);
        // HdpiCanvas doesn't allow width/height <= 0.
        var lessThanZero = width <= 0 || height <= 0;
        var nan = isNaN(width) || isNaN(height);
        var unchanged = width === this.width && height === this.height;
        if (unchanged || nan || lessThanZero) {
            return false;
        }
        this.pendingSize = [width, height];
        this.markDirty();
        return true;
    };
    Scene.prototype.addLayer = function (opts) {
        var _a;
        var mode = this.opts.mode;
        var layeredModes = ['composite', 'dom-composite', 'adv-composite'];
        if (!layeredModes.includes(mode)) {
            return undefined;
        }
        var _b = opts.zIndex,
            zIndex = _b === void 0 ? this._nextZIndex++ : _b,
            name = opts.name,
            zIndexSubOrder = opts.zIndexSubOrder,
            getComputedOpacity = opts.getComputedOpacity,
            getVisibility = opts.getVisibility;
        var _c = this,
            width = _c.width,
            height = _c.height,
            overrideDevicePixelRatio = _c.overrideDevicePixelRatio;
        var domLayer = mode === 'dom-composite';
        var advLayer = mode === 'adv-composite';
        var canvas =
            !advLayer || !HdpiOffscreenCanvas.isSupported()
                ? new HdpiCanvas({
                      document: this.opts.document,
                      width: width,
                      height: height,
                      domLayer: domLayer,
                      zIndex: zIndex,
                      name: name,
                      overrideDevicePixelRatio: overrideDevicePixelRatio,
                  })
                : new HdpiOffscreenCanvas({
                      width: width,
                      height: height,
                      overrideDevicePixelRatio: overrideDevicePixelRatio,
                  });
        var newLayer = {
            id: this._nextLayerId++,
            name: name,
            zIndex: zIndex,
            zIndexSubOrder: zIndexSubOrder,
            canvas: canvas,
            getComputedOpacity: getComputedOpacity,
            getVisibility: getVisibility,
        };
        if (zIndex >= this._nextZIndex) {
            this._nextZIndex = zIndex + 1;
        }
        this.layers.push(newLayer);
        this.sortLayers();
        if (domLayer) {
            var domCanvases = this.layers
                .map(function (v) {
                    return v.canvas;
                })
                .filter(function (v) {
                    return v instanceof HdpiCanvas;
                });
            var newLayerIndex = domCanvases.findIndex(function (v) {
                return v === canvas;
            });
            var lastLayer = (_a = domCanvases[newLayerIndex - 1]) !== null && _a !== void 0 ? _a : this.canvas;
            lastLayer.element.insertAdjacentElement('afterend', canvas.element);
        }
        if (this.debug.consoleLog) {
            Logger.debug('Scene.addLayer() - layers', this.layers);
        }
        return newLayer.canvas;
    };
    Scene.prototype.removeLayer = function (canvas) {
        var index = this.layers.findIndex(function (l) {
            return l.canvas === canvas;
        });
        if (index >= 0) {
            this.layers.splice(index, 1);
            canvas.destroy();
            this.markDirty();
            if (this.debug.consoleLog) {
                Logger.debug('Scene.removeLayer() -  layers', this.layers);
            }
        }
    };
    Scene.prototype.moveLayer = function (canvas, newZIndex, newZIndexSubOrder) {
        var layer = this.layers.find(function (l) {
            return l.canvas === canvas;
        });
        if (layer) {
            layer.zIndex = newZIndex;
            layer.zIndexSubOrder = newZIndexSubOrder;
            this.sortLayers();
            this.markDirty();
            if (this.debug.consoleLog) {
                Logger.debug('Scene.moveLayer() -  layers', this.layers);
            }
        }
    };
    Scene.prototype.sortLayers = function () {
        this.layers.sort(function (a, b) {
            var _a, _b;
            return compoundAscending(
                __spreadArray$E(
                    __spreadArray$E(
                        [a.zIndex],
                        __read$15((_a = a.zIndexSubOrder) !== null && _a !== void 0 ? _a : [undefined, undefined]),
                    ),
                    [a.id],
                ),
                __spreadArray$E(
                    __spreadArray$E(
                        [b.zIndex],
                        __read$15((_b = b.zIndexSubOrder) !== null && _b !== void 0 ? _b : [undefined, undefined]),
                    ),
                    [b.id],
                ),
                ascendingStringNumberUndefined,
            );
        });
    };
    Scene.prototype.markDirty = function () {
        this._dirty = true;
    };
    Object.defineProperty(Scene.prototype, 'dirty', {
        get: function () {
            return this._dirty;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Scene.prototype, 'root', {
        get: function () {
            return this._root;
        },
        set: function (node) {
            var _this = this;
            if (node === this._root) {
                return;
            }
            if (this._root) {
                this._root._setLayerManager();
            }
            this._root = node;
            if (node) {
                // If `node` is the root node of another scene ...
                if (node.parent === null && node.layerManager && node.layerManager !== this) {
                    node.layerManager.root = null;
                }
                node._setLayerManager({
                    addLayer: function (opts) {
                        return _this.addLayer(opts);
                    },
                    moveLayer: function () {
                        var opts = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            opts[_i] = arguments[_i];
                        }
                        return _this.moveLayer.apply(_this, __spreadArray$E([], __read$15(opts)));
                    },
                    removeLayer: function () {
                        var opts = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            opts[_i] = arguments[_i];
                        }
                        return _this.removeLayer.apply(_this, __spreadArray$E([], __read$15(opts)));
                    },
                    markDirty: function () {
                        return _this.markDirty();
                    },
                    canvas: this.canvas,
                    debug: __assign$U(__assign$U({}, this.debug), {
                        consoleLog: this.debug.level >= SceneDebugLevel.DETAILED,
                    }),
                });
            }
            this.markDirty();
        },
        enumerable: false,
        configurable: true,
    });
    /** Alternative to destroy() that preserves re-usable resources. */
    Scene.prototype.strip = function () {
        var e_1, _a;
        var layers = this.layers;
        try {
            for (
                var layers_1 = __values$L(layers), layers_1_1 = layers_1.next();
                !layers_1_1.done;
                layers_1_1 = layers_1.next()
            ) {
                var layer = layers_1_1.value;
                layer.canvas.destroy();
                delete layer['canvas'];
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (layers_1_1 && !layers_1_1.done && (_a = layers_1.return)) _a.call(layers_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        layers.splice(0, layers.length);
        this.root = null;
        this._dirty = false;
        this.canvas.context.resetTransform();
    };
    Scene.prototype.destroy = function () {
        this.container = undefined;
        this.strip();
        this.canvas.destroy();
        Object.assign(this, { canvas: undefined, ctx: undefined });
    };
    Scene.prototype.render = function (opts) {
        var _a;
        return __awaiter$g(this, void 0, void 0, function () {
            var _b,
                _c,
                debugSplitTimes,
                _d,
                extraDebugStats,
                _e,
                canvas,
                ctx,
                root,
                layers,
                pendingSize,
                mode,
                renderCtx,
                canvasCleared,
                _f,
                dirtyTree,
                paths;
            var _g;
            return __generator$g(this, function (_h) {
                (_b = opts !== null && opts !== void 0 ? opts : {}),
                    (_c = _b.debugSplitTimes),
                    (debugSplitTimes = _c === void 0 ? [performance.now()] : _c),
                    (_d = _b.extraDebugStats),
                    (extraDebugStats = _d === void 0 ? {} : _d);
                (_e = this),
                    (canvas = _e.canvas),
                    (ctx = _e.canvas.context),
                    (root = _e.root),
                    (layers = _e.layers),
                    (pendingSize = _e.pendingSize),
                    (mode = _e.opts.mode);
                if (pendingSize) {
                    (_g = this.canvas).resize.apply(_g, __spreadArray$E([], __read$15(pendingSize)));
                    this.layers.forEach(function (layer) {
                        var _a;
                        return (_a = layer.canvas).resize.apply(_a, __spreadArray$E([], __read$15(pendingSize)));
                    });
                    this.pendingSize = undefined;
                }
                if (root && !root.visible) {
                    this._dirty = false;
                    return [2 /*return*/];
                }
                if (root && !this.dirty) {
                    if (this.debug.consoleLog) {
                        Logger.debug('Scene.render() - no-op', {
                            redrawType: RedrawType[root.dirty],
                            tree: this.buildTree(root),
                        });
                    }
                    this.debugStats(debugSplitTimes, ctx, undefined, extraDebugStats);
                    return [2 /*return*/];
                }
                renderCtx = {
                    ctx: ctx,
                    forceRender: true,
                    resized: !!pendingSize,
                    debugNodes: {},
                };
                if (this.debug.stats === 'detailed') {
                    renderCtx.stats = { layersRendered: 0, layersSkipped: 0, nodesRendered: 0, nodesSkipped: 0 };
                }
                canvasCleared = false;
                if (!root || root.dirty >= RedrawType.TRIVIAL) {
                    // start with a blank canvas, clear previous drawing
                    canvasCleared = true;
                    canvas.clear();
                }
                if (root && this.debug.dirtyTree) {
                    (_f = this.buildDirtyTree(root)), (dirtyTree = _f.dirtyTree), (paths = _f.paths);
                    Logger.debug('Scene.render() - dirtyTree', { dirtyTree: dirtyTree, paths: paths });
                }
                if (root && canvasCleared) {
                    if (this.debug.consoleLog) {
                        Logger.debug('Scene.render() - before', {
                            redrawType: RedrawType[root.dirty],
                            canvasCleared: canvasCleared,
                            tree: this.buildTree(root),
                        });
                    }
                    if (root.visible) {
                        ctx.save();
                        root.render(renderCtx);
                        ctx.restore();
                    }
                }
                if (mode !== 'dom-composite' && layers.length > 0 && canvasCleared) {
                    this.sortLayers();
                    ctx.save();
                    ctx.setTransform(1 / canvas.pixelRatio, 0, 0, 1 / canvas.pixelRatio, 0, 0);
                    layers.forEach(function (_a) {
                        var _b = _a.canvas,
                            imageSource = _b.imageSource,
                            enabled = _b.enabled,
                            getComputedOpacity = _a.getComputedOpacity,
                            getVisibility = _a.getVisibility;
                        if (!enabled || !getVisibility()) {
                            return;
                        }
                        ctx.globalAlpha = getComputedOpacity();
                        ctx.drawImage(imageSource, 0, 0);
                    });
                    ctx.restore();
                }
                // Check for save/restore depth of zero!
                (_a = ctx.verifyDepthZero) === null || _a === void 0 ? void 0 : _a.call(ctx);
                this._dirty = false;
                this.debugStats(debugSplitTimes, ctx, renderCtx.stats, extraDebugStats);
                this.debugSceneNodeHighlight(ctx, this.debug.sceneNodeHighlight, renderCtx.debugNodes);
                if (root && this.debug.consoleLog) {
                    Logger.debug('Scene.render() - after', {
                        redrawType: RedrawType[root.dirty],
                        canvasCleared: canvasCleared,
                        tree: this.buildTree(root),
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    Scene.prototype.debugStats = function (debugSplitTimes, ctx, renderCtxStats, extraDebugStats) {
        var e_2, _a;
        if (extraDebugStats === void 0) {
            extraDebugStats = {};
        }
        var end = performance.now();
        if (this.debug.stats) {
            var start = debugSplitTimes[0];
            debugSplitTimes.push(end);
            var pct = function (rendered, skipped) {
                var total = rendered + skipped;
                return rendered + ' / ' + total + ' (' + Math.round((100 * rendered) / total) + '%)';
            };
            var time_1 = function (start, end) {
                return Math.round((end - start) * 100) / 100 + 'ms';
            };
            var _b = renderCtxStats !== null && renderCtxStats !== void 0 ? renderCtxStats : {},
                _c = _b.layersRendered,
                layersRendered = _c === void 0 ? 0 : _c,
                _d = _b.layersSkipped,
                layersSkipped = _d === void 0 ? 0 : _d,
                _e = _b.nodesRendered,
                nodesRendered = _e === void 0 ? 0 : _e,
                _f = _b.nodesSkipped,
                nodesSkipped = _f === void 0 ? 0 : _f;
            var splits = debugSplitTimes
                .map(function (t, i) {
                    return i > 0 ? time_1(debugSplitTimes[i - 1], t) : null;
                })
                .filter(function (v) {
                    return v != null;
                })
                .join(' + ');
            var extras = Object.entries(extraDebugStats)
                .map(function (_a) {
                    var _b = __read$15(_a, 2),
                        k = _b[0],
                        v = _b[1];
                    return k + ': ' + v;
                })
                .join(' ; ');
            var stats = [
                time_1(start, end) + ' (' + splits + ')',
                '' + extras,
                this.debug.stats === 'detailed' ? 'Layers: ' + pct(layersRendered, layersSkipped) : null,
                this.debug.stats === 'detailed' ? 'Nodes: ' + pct(nodesRendered, nodesSkipped) : null,
            ].filter(function (v) {
                return v != null;
            });
            var statsSize = stats.map(function (t) {
                return [t, HdpiCanvas.getTextSize(t, ctx.font)];
            });
            var width = Math.max.apply(
                Math,
                __spreadArray$E(
                    [],
                    __read$15(
                        statsSize.map(function (_a) {
                            var _b = __read$15(_a, 2),
                                width = _b[1].width;
                            return width;
                        }),
                    ),
                ),
            );
            var height = statsSize.reduce(function (total, _a) {
                var _b = __read$15(_a, 2),
                    height = _b[1].height;
                return total + height;
            }, 0);
            ctx.save();
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, width, height);
            ctx.fillStyle = 'black';
            var y = 0;
            try {
                for (
                    var statsSize_1 = __values$L(statsSize), statsSize_1_1 = statsSize_1.next();
                    !statsSize_1_1.done;
                    statsSize_1_1 = statsSize_1.next()
                ) {
                    var _g = __read$15(statsSize_1_1.value, 2),
                        stat = _g[0],
                        size = _g[1];
                    y += size.height;
                    ctx.fillText(stat, 2, y);
                }
            } catch (e_2_1) {
                e_2 = { error: e_2_1 };
            } finally {
                try {
                    if (statsSize_1_1 && !statsSize_1_1.done && (_a = statsSize_1.return)) _a.call(statsSize_1);
                } finally {
                    if (e_2) throw e_2.error;
                }
            }
            ctx.restore();
        }
    };
    Scene.prototype.debugSceneNodeHighlight = function (ctx, sceneNodeHighlight, debugNodes) {
        var e_3, _a, e_4, _b, e_5, _c;
        var _d;
        var regexpPredicate = function (matcher) {
            return function (n) {
                if (matcher.test(n.id)) {
                    return true;
                }
                return n instanceof Group && n.name != null && matcher.test(n.name);
            };
        };
        var stringPredicate = function (match) {
            return function (n) {
                if (match === n.id) {
                    return true;
                }
                return n instanceof Group && n.name != null && match === n.name;
            };
        };
        try {
            for (
                var sceneNodeHighlight_1 = __values$L(sceneNodeHighlight),
                    sceneNodeHighlight_1_1 = sceneNodeHighlight_1.next();
                !sceneNodeHighlight_1_1.done;
                sceneNodeHighlight_1_1 = sceneNodeHighlight_1.next()
            ) {
                var next = sceneNodeHighlight_1_1.value;
                if (typeof next === 'string' && debugNodes[next] != null) continue;
                var predicate = typeof next === 'string' ? stringPredicate(next) : regexpPredicate(next);
                var nodes = (_d = this.root) === null || _d === void 0 ? void 0 : _d.findNodes(predicate);
                if (!nodes || nodes.length === 0) {
                    Logger.debug('Scene.render() - no debugging node with id [' + next + '] in scene graph.');
                    continue;
                }
                try {
                    for (
                        var nodes_1 = ((e_4 = void 0), __values$L(nodes)), nodes_1_1 = nodes_1.next();
                        !nodes_1_1.done;
                        nodes_1_1 = nodes_1.next()
                    ) {
                        var node = nodes_1_1.value;
                        if (node instanceof Group && node.name) {
                            debugNodes[node.name] = node;
                        } else {
                            debugNodes[node.id] = node;
                        }
                    }
                } catch (e_4_1) {
                    e_4 = { error: e_4_1 };
                } finally {
                    try {
                        if (nodes_1_1 && !nodes_1_1.done && (_b = nodes_1.return)) _b.call(nodes_1);
                    } finally {
                        if (e_4) throw e_4.error;
                    }
                }
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (sceneNodeHighlight_1_1 && !sceneNodeHighlight_1_1.done && (_a = sceneNodeHighlight_1.return))
                    _a.call(sceneNodeHighlight_1);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        ctx.save();
        try {
            for (var _e = __values$L(Object.entries(debugNodes)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var _g = __read$15(_f.value, 2),
                    name_1 = _g[0],
                    node = _g[1];
                var bbox = node.computeTransformedBBox();
                if (!bbox) {
                    Logger.debug('Scene.render() - no bbox for debugged node [' + name_1 + '].');
                    continue;
                }
                ctx.globalAlpha = 0.8;
                ctx.strokeStyle = 'red';
                ctx.lineWidth = 1;
                ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);
                ctx.fillStyle = 'red';
                ctx.strokeStyle = 'white';
                ctx.font = '16px sans-serif';
                ctx.textBaseline = 'top';
                ctx.textAlign = 'left';
                ctx.lineWidth = 2;
                ctx.strokeText(name_1, bbox.x, bbox.y, bbox.width);
                ctx.fillText(name_1, bbox.x, bbox.y, bbox.width);
            }
        } catch (e_5_1) {
            e_5 = { error: e_5_1 };
        } finally {
            try {
                if (_f && !_f.done && (_c = _e.return)) _c.call(_e);
            } finally {
                if (e_5) throw e_5.error;
            }
        }
        ctx.restore();
    };
    Scene.prototype.buildTree = function (node) {
        var _this = this;
        var _a, _b;
        var name = (_a = node instanceof Group ? node.name : null) !== null && _a !== void 0 ? _a : node.id;
        return __assign$U(
            __assign$U(
                { name: name, node: node, dirty: RedrawType[node.dirty] },
                ((_b = node.parent) === null || _b === void 0 ? void 0 : _b.isVirtual)
                    ? {
                          virtualParentDirty: RedrawType[node.parent.dirty],
                          virtualParent: node.parent,
                      }
                    : {},
            ),
            node.children
                .map(function (c) {
                    return _this.buildTree(c);
                })
                .reduce(function (result, childTree) {
                    var treeNodeName = childTree.name;
                    var _a = childTree.node,
                        visible = _a.visible,
                        opacity = _a.opacity,
                        zIndex = _a.zIndex,
                        zIndexSubOrder = _a.zIndexSubOrder,
                        childNode = childTree.node,
                        virtualParent = childTree.virtualParent;
                    if (!visible || opacity <= 0) {
                        treeNodeName = '(' + treeNodeName + ')';
                    }
                    if (childNode instanceof Group && childNode.isLayer()) {
                        treeNodeName = '*' + treeNodeName + '*';
                    }
                    var key = [
                        '' + (treeNodeName !== null && treeNodeName !== void 0 ? treeNodeName : '<unknown>'),
                        'z: ' + zIndex,
                        zIndexSubOrder &&
                            'zo: ' +
                                zIndexSubOrder
                                    .map(function (v) {
                                        return typeof v === 'function' ? v() + ' (fn)' : v;
                                    })
                                    .join(' / '),
                        virtualParent && '(virtual parent)',
                    ]
                        .filter(function (v) {
                            return !!v;
                        })
                        .join(' ');
                    var selectedKey = key;
                    var index = 1;
                    while (result[selectedKey] != null && index < 100) {
                        selectedKey = key + ' (' + index++ + ')';
                    }
                    result[selectedKey] = childTree;
                    return result;
                }, {}),
        );
    };
    Scene.prototype.buildDirtyTree = function (node) {
        var _this = this;
        var _a;
        if (node.dirty === RedrawType.NONE) {
            return { dirtyTree: {}, paths: [] };
        }
        var childrenDirtyTree = node.children
            .map(function (c) {
                return _this.buildDirtyTree(c);
            })
            .filter(function (c) {
                return c.paths.length > 0;
            });
        var name = (_a = node instanceof Group ? node.name : null) !== null && _a !== void 0 ? _a : node.id;
        var paths =
            childrenDirtyTree.length === 0
                ? [name]
                : childrenDirtyTree
                      .map(function (c) {
                          return c.paths;
                      })
                      .reduce(function (r, p) {
                          return r.concat(p);
                      }, [])
                      .map(function (p) {
                          return name + '.' + p;
                      });
        return {
            dirtyTree: __assign$U(
                { name: name, node: node, dirty: RedrawType[node.dirty] },
                childrenDirtyTree
                    .map(function (c) {
                        return c.dirtyTree;
                    })
                    .filter(function (t) {
                        return t.dirty !== undefined;
                    })
                    .reduce(function (result, childTree) {
                        var _a;
                        result[(_a = childTree.name) !== null && _a !== void 0 ? _a : '<unknown>'] = childTree;
                        return result;
                    }, {}),
            ),
            paths: paths,
        };
    };
    Scene.className = 'Scene';
    return Scene;
})();

var Gradient = /** @class */ (function () {
    function Gradient() {
        this.stops = [];
    }
    return Gradient;
})();

var twoPi = Math.PI * 2;
/**
 * Normalize the given angle to be in the [0, 2π) interval.
 * @param radians Angle in radians.
 */
function normalizeAngle360(radians) {
    radians %= twoPi;
    radians += twoPi;
    radians %= twoPi;
    return radians;
}
/**
 * Normalize the given angle to be in the [-π, π) interval.
 * @param radians Angle in radians.
 */
function normalizeAngle180(radians) {
    radians %= twoPi;
    if (radians < -Math.PI) {
        radians += twoPi;
    } else if (radians >= Math.PI) {
        radians -= twoPi;
    }
    return radians;
}
function toRadians$1(degrees) {
    return (degrees / 180) * Math.PI;
}

var __extends$2K =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var LinearGradient = /** @class */ (function (_super) {
    __extends$2K(LinearGradient, _super);
    function LinearGradient() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.angle = 0;
        return _this;
    }
    LinearGradient.prototype.createGradient = function (ctx, bbox) {
        // Gradient 0° angle starts at top according to CSS spec
        var angleOffset = 90;
        var _a = this,
            stops = _a.stops,
            angle = _a.angle;
        var radians = normalizeAngle360(toRadians$1(angle + angleOffset));
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);
        var w = bbox.width;
        var h = bbox.height;
        var cx = bbox.x + w * 0.5;
        var cy = bbox.y + h * 0.5;
        if (w > 0 && h > 0) {
            var diagonal = Math.sqrt(h * h + w * w) / 2;
            var diagonalAngle = Math.atan2(h, w);
            var quarteredAngle = void 0;
            if (radians < Math.PI / 2) {
                quarteredAngle = radians;
            } else if (radians < Math.PI) {
                quarteredAngle = Math.PI - radians;
            } else if (radians < (3 * Math.PI) / 2) {
                quarteredAngle = radians - Math.PI;
            } else {
                quarteredAngle = 2 * Math.PI - radians;
            }
            var l = diagonal * Math.abs(Math.cos(quarteredAngle - diagonalAngle));
            var gradient_1 = ctx.createLinearGradient(cx + cos * l, cy + sin * l, cx - cos * l, cy - sin * l);
            stops.forEach(function (stop) {
                gradient_1.addColorStop(stop.offset, stop.color);
            });
            return gradient_1;
        }
        return 'black';
    };
    return LinearGradient;
})(Gradient);

var __extends$2J =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1X =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var LINEAR_GRADIENT_REGEXP = /^linear-gradient\((.*?)deg,\s*(.*?)\s*\)$/i;
var Shape = /** @class */ (function (_super) {
    __extends$2J(Shape, _super);
    function Shape() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.lastInstanceId = 0;
        _this.fillOpacity = 1;
        _this.strokeOpacity = 1;
        _this.fill = Shape.defaultStyles.fill;
        /**
         * Note that `strokeStyle = null` means invisible stroke,
         * while `lineWidth = 0` means no stroke, and sometimes this can mean different things.
         * For example, a rect shape with an invisible stroke may not align to the pixel grid
         * properly because the stroke affects the rules of alignment, and arc shapes forming
         * a pie chart will have a gap between them if they have an invisible stroke, whereas
         * there would be not gap if there was no stroke at all.
         * The preferred way of making the stroke invisible is setting the `lineWidth` to zero,
         * unless specific looks that is achieved by having an invisible stroke is desired.
         */
        _this.stroke = Shape.defaultStyles.stroke;
        _this.strokeWidth = Shape.defaultStyles.strokeWidth;
        _this.lineDash = Shape.defaultStyles.lineDash;
        _this.lineDashOffset = Shape.defaultStyles.lineDashOffset;
        _this.lineCap = Shape.defaultStyles.lineCap;
        _this.lineJoin = Shape.defaultStyles.lineJoin;
        _this.opacity = Shape.defaultStyles.opacity;
        _this.fillShadow = Shape.defaultStyles.fillShadow;
        return _this;
    }
    /**
     * Creates a light-weight instance of the given shape (that serves as a template).
     * The created instance only stores the properites set on the instance itself
     * and the rest of the properties come via the prototype chain from the template.
     * This can greatly reduce memory usage in cases where one has many similar shapes,
     * for example, circles of different size, position and color. The exact memory usage
     * reduction will depend on the size of the template and the number of own properties
     * set on its lightweight instances, but will typically be around an order of magnitude
     * or more.
     *
     * Note: template shapes are not supposed to be part of the scene graph (they should not
     * have a parent).
     *
     * @param template
     */
    Shape.createInstance = function (template) {
        var shape = Object.create(template);
        shape._setParent(undefined);
        shape.id = template.id + '-Instance-' + String(++template.lastInstanceId);
        return shape;
    };
    /**
     * Restores the default styles introduced by this subclass.
     */
    Shape.prototype.restoreOwnStyles = function () {
        var styles = this.constructor.defaultStyles;
        var keys = Object.getOwnPropertyNames(styles);
        // getOwnPropertyNames is about 2.5 times faster than
        // for..in with the hasOwnProperty check and in this
        // case, where most properties are inherited, can be
        // more then an order of magnitude faster.
        for (var i = 0, n = keys.length; i < n; i++) {
            var key = keys[i];
            this[key] = styles[key];
        }
    };
    Shape.prototype.restoreAllStyles = function () {
        var styles = this.constructor.defaultStyles;
        for (var property in styles) {
            this[property] = styles[property];
        }
    };
    /**
     * Restores the base class default styles that have been overridden by this subclass.
     */
    Shape.prototype.restoreOverriddenStyles = function () {
        var styles = this.constructor.defaultStyles;
        var protoStyles = Object.getPrototypeOf(styles);
        for (var property in styles) {
            if (
                Object.prototype.hasOwnProperty.call(styles, property) &&
                Object.prototype.hasOwnProperty.call(protoStyles, property)
            ) {
                this[property] = styles[property];
            }
        }
    };
    Shape.prototype.updateGradient = function () {
        var fill = this.fill;
        var linearGradientMatch;
        if (
            (fill === null || fill === void 0 ? void 0 : fill.startsWith('linear-gradient')) &&
            (linearGradientMatch = LINEAR_GRADIENT_REGEXP.exec(fill))
        ) {
            var angle = parseFloat(linearGradientMatch[1]);
            var colors_1 = [];
            var colorsPart = linearGradientMatch[2];
            var colorRegex = /(#[0-9a-f]+)|(rgba?\(.+?\))|([a-z]+)/gi;
            var c = void 0;
            while ((c = colorRegex.exec(colorsPart))) {
                colors_1.push(c[0]);
            }
            this.gradient = new LinearGradient();
            this.gradient.angle = angle;
            this.gradient.stops = colors_1.map(function (color, index) {
                var offset = index / (colors_1.length - 1);
                return { offset: offset, color: color };
            });
        } else {
            this.gradient = undefined;
        }
    };
    /**
     * Returns a device-pixel aligned coordinate (or length if length is supplied).
     *
     * NOTE: Not suitable for strokes, since the stroke needs to be offset to the middle
     * of a device pixel.
     */
    Shape.prototype.align = function (start, length) {
        var _a, _b, _c;
        var pixelRatio =
            (_c =
                (_b = (_a = this.layerManager) === null || _a === void 0 ? void 0 : _a.canvas) === null || _b === void 0
                    ? void 0
                    : _b.pixelRatio) !== null && _c !== void 0
                ? _c
                : 1;
        var alignedStart = Math.round(start * pixelRatio) / pixelRatio;
        if (length == undefined) {
            return alignedStart;
        }
        if (length === 0) {
            return 0;
        }
        if (length < 1) {
            // Avoid hiding crisp shapes
            return Math.ceil(length * pixelRatio) / pixelRatio;
        }
        // Account for the rounding of alignedStart by increasing length to compensate before
        // alignment.
        return Math.round((length + start) * pixelRatio) / pixelRatio - alignedStart;
    };
    Shape.prototype.fillStroke = function (ctx) {
        this.renderFill(ctx);
        this.renderStroke(ctx);
    };
    Shape.prototype.renderFill = function (ctx) {
        if (this.fill) {
            var globalAlpha = ctx.globalAlpha;
            this.applyFill(ctx);
            this.applyFillAlpha(ctx);
            this.applyShadow(ctx);
            ctx.fill();
            ctx.globalAlpha = globalAlpha;
        }
        ctx.shadowColor = 'rgba(0, 0, 0, 0)';
    };
    Shape.prototype.applyFill = function (ctx) {
        if (this.gradient) {
            ctx.fillStyle = this.gradient.createGradient(ctx, this.computeBBox());
        } else {
            ctx.fillStyle = this.fill;
        }
    };
    Shape.prototype.applyFillAlpha = function (ctx) {
        var globalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
    };
    Shape.prototype.applyShadow = function (ctx) {
        var _a, _b;
        // The canvas context scaling (depends on the device's pixel ratio)
        // has no effect on shadows, so we have to account for the pixel ratio
        // manually here.
        var pixelRatio =
            (_b = (_a = this.layerManager) === null || _a === void 0 ? void 0 : _a.canvas.pixelRatio) !== null &&
            _b !== void 0
                ? _b
                : 1;
        var fillShadow = this.fillShadow;
        if (fillShadow === null || fillShadow === void 0 ? void 0 : fillShadow.enabled) {
            ctx.shadowColor = fillShadow.color;
            ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
            ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
            ctx.shadowBlur = fillShadow.blur * pixelRatio;
        }
    };
    Shape.prototype.renderStroke = function (ctx) {
        if (this.stroke && this.strokeWidth) {
            var globalAlpha = ctx.globalAlpha;
            ctx.strokeStyle = this.stroke;
            ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
            ctx.lineWidth = this.strokeWidth;
            if (this.lineDash) {
                ctx.setLineDash(this.lineDash);
            }
            if (this.lineDashOffset) {
                ctx.lineDashOffset = this.lineDashOffset;
            }
            if (this.lineCap) {
                ctx.lineCap = this.lineCap;
            }
            if (this.lineJoin) {
                ctx.lineJoin = this.lineJoin;
            }
            ctx.stroke();
            ctx.globalAlpha = globalAlpha;
        }
    };
    Shape.prototype.containsPoint = function (x, y) {
        return this.isPointInPath(x, y);
    };
    /**
     * Defaults for style properties. Note that properties that affect the position
     * and shape of the node are not considered style properties, for example:
     * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
     * Can be used to reset to the original styling after some custom styling
     * has been applied (using the `restoreOwnStyles` and `restoreAllStyles` methods).
     * These static defaults are meant to be inherited by subclasses.
     */
    Shape.defaultStyles = Object.assign(
        {},
        {
            fill: 'black',
            stroke: undefined,
            strokeWidth: 0,
            lineDash: undefined,
            lineDashOffset: 0,
            lineCap: undefined,
            lineJoin: undefined,
            opacity: 1,
            fillShadow: undefined,
        },
    );
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'fillOpacity', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'strokeOpacity', void 0);
    __decorate$1X(
        [
            SceneChangeDetection({
                redraw: RedrawType.MINOR,
                changeCb: function (s) {
                    return s.updateGradient();
                },
            }),
        ],
        Shape.prototype,
        'fill',
        void 0,
    );
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'stroke', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'strokeWidth', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'lineDash', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'lineDashOffset', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'lineCap', void 0);
    __decorate$1X([SceneChangeDetection({ redraw: RedrawType.MINOR })], Shape.prototype, 'lineJoin', void 0);
    __decorate$1X(
        [
            SceneChangeDetection({
                redraw: RedrawType.MINOR,
                convertor: function (v) {
                    return Math.min(1, Math.max(0, v));
                },
            }),
        ],
        Shape.prototype,
        'opacity',
        void 0,
    );
    __decorate$1X(
        [SceneChangeDetection({ redraw: RedrawType.MINOR, checkDirtyOnAssignment: true })],
        Shape.prototype,
        'fillShadow',
        void 0,
    );
    return Shape;
})(Node);

var __extends$2I =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1W =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$K =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var ellipsis = '\u2026';
function SceneFontChangeDetection(opts) {
    var _a = opts !== null && opts !== void 0 ? opts : {},
        _b = _a.redraw,
        redraw = _b === void 0 ? RedrawType.MAJOR : _b,
        changeCb = _a.changeCb;
    return SceneChangeDetection({ redraw: redraw, type: 'font', changeCb: changeCb });
}
var Text = /** @class */ (function (_super) {
    __extends$2I(Text, _super);
    function Text() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.x = 0;
        _this.y = 0;
        _this.lines = [];
        _this.text = undefined;
        _this._dirtyFont = true;
        _this.fontSize = 10;
        _this.fontFamily = 'sans-serif';
        _this.textAlign = Text.defaultStyles.textAlign;
        _this.textBaseline = Text.defaultStyles.textBaseline;
        // TextMetrics are used if lineHeight is not defined.
        _this.lineHeight = undefined;
        return _this;
    }
    Text.prototype._setLines = function () {
        this.lines = splitText(this.text);
    };
    Object.defineProperty(Text.prototype, 'font', {
        get: function () {
            if (this._font == null || this._dirtyFont) {
                this._dirtyFont = false;
                this._font = getFont(this);
            }
            return this._font;
        },
        enumerable: false,
        configurable: true,
    });
    Text.prototype.computeBBox = function () {
        return HdpiCanvas.has.textMetrics
            ? getPreciseBBox(this.lines, this.x, this.y, this)
            : getApproximateBBox(this.lines, this.x, this.y, this);
    };
    Text.prototype.getLineHeight = function (line) {
        var _a, _b;
        if (this.lineHeight) return this.lineHeight;
        if (HdpiCanvas.has.textMetrics) {
            var metrics = HdpiCanvas.measureText(line, this.font, this.textBaseline, this.textAlign);
            return (
                ((_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.emHeightAscent) +
                ((_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.emHeightDescent)
            );
        }
        return HdpiCanvas.getTextSize(line, this.font).height;
    };
    Text.prototype.isPointInPath = function (x, y) {
        var point = this.transformPoint(x, y);
        var bbox = this.computeBBox();
        return bbox ? bbox.containsPoint(point.x, point.y) : false;
    };
    Text.prototype.render = function (renderCtx) {
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        if (!this.lines.length || !this.layerManager) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        var _a = this,
            fill = _a.fill,
            stroke = _a.stroke,
            strokeWidth = _a.strokeWidth;
        ctx.font = this.font;
        ctx.textAlign = this.textAlign;
        ctx.textBaseline = this.textBaseline;
        var pixelRatio = this.layerManager.canvas.pixelRatio || 1;
        var globalAlpha = ctx.globalAlpha;
        if (fill) {
            ctx.fillStyle = fill;
            ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
            var fillShadow = this.fillShadow;
            if (fillShadow === null || fillShadow === void 0 ? void 0 : fillShadow.enabled) {
                ctx.shadowColor = fillShadow.color;
                ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
                ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
                ctx.shadowBlur = fillShadow.blur * pixelRatio;
            }
            this.renderLines(function (line, x, y) {
                return ctx.fillText(line, x, y);
            });
        }
        if (stroke && strokeWidth) {
            ctx.strokeStyle = stroke;
            ctx.lineWidth = strokeWidth;
            ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
            var _b = this,
                lineDash = _b.lineDash,
                lineDashOffset = _b.lineDashOffset,
                lineCap = _b.lineCap,
                lineJoin = _b.lineJoin;
            if (lineDash) {
                ctx.setLineDash(lineDash);
            }
            if (lineDashOffset) {
                ctx.lineDashOffset = lineDashOffset;
            }
            if (lineCap) {
                ctx.lineCap = lineCap;
            }
            if (lineJoin) {
                ctx.lineJoin = lineJoin;
            }
            this.renderLines(function (line, x, y) {
                return ctx.strokeText(line, x, y);
            });
        }
        _super.prototype.render.call(this, renderCtx);
    };
    Text.prototype.renderLines = function (renderCallback) {
        var _this = this;
        var _a = this,
            lines = _a.lines,
            x = _a.x,
            y = _a.y;
        var lineHeights = this.lines.map(function (line) {
            return _this.getLineHeight(line);
        });
        var totalHeight = lineHeights.reduce(function (a, b) {
            return a + b;
        }, 0);
        var offsetY = -(totalHeight - lineHeights[0]) * getVerticalOffset(this.textBaseline);
        for (var i = 0; i < lines.length; i++) {
            renderCallback(lines[i], x, y + offsetY);
            offsetY += lineHeights[i];
        }
    };
    Text.wrap = function (text, maxWidth, maxHeight, textProps, wrapping) {
        var e_1, _a;
        var font = getFont(textProps);
        var measurer = createTextMeasurer(font);
        var lines = text.split(/\r?\n/g);
        if (lines.length === 0) {
            return '';
        }
        if (wrapping === 'never') {
            return Text.truncateLine(lines[0], maxWidth, measurer, false);
        }
        var result = [];
        var cumulativeHeight = 0;
        try {
            for (
                var lines_1 = __values$K(lines), lines_1_1 = lines_1.next();
                !lines_1_1.done;
                lines_1_1 = lines_1.next()
            ) {
                var line = lines_1_1.value;
                var wrappedLine = Text.wrapLine(
                    line,
                    maxWidth,
                    maxHeight,
                    measurer,
                    textProps,
                    wrapping,
                    cumulativeHeight,
                );
                result.push(wrappedLine.result);
                cumulativeHeight = wrappedLine.cumulativeHeight;
                if (wrappedLine.truncated) {
                    break;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (lines_1_1 && !lines_1_1.done && (_a = lines_1.return)) _a.call(lines_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return result.join('\n').trim();
    };
    Text.wrapLine = function (text, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight) {
        text = text.trim();
        if (!text) {
            return { result: '', truncated: false, cumulativeHeight: cumulativeHeight };
        }
        var initialSize = measurer.size(text);
        if (initialSize.width <= maxWidth) {
            // Text fits into a single line
            return { result: text, truncated: false, cumulativeHeight: cumulativeHeight + initialSize.height };
        }
        if (initialSize.height > maxHeight || measurer.width('W') > maxWidth) {
            // Not enough space for a single line or character
            return { result: '', truncated: true, cumulativeHeight: cumulativeHeight };
        }
        var words = text.split(/\s+/g);
        var wrapResult = Text.wrapLineSequentially(
            words,
            maxWidth,
            maxHeight,
            measurer,
            textProps,
            wrapping,
            cumulativeHeight,
        );
        cumulativeHeight = wrapResult.cumulativeHeight;
        var lines = wrapResult.lines;
        if (!(wrapResult.wordsBrokenOrTruncated || wrapResult.linesTruncated)) {
            // If no word breaks or truncations, try the balanced wrapping
            var linesCount = wrapResult.lines.length;
            var balanced = Text.wrapLineBalanced(words, maxWidth, measurer, linesCount);
            if (balanced.length === lines.length) {
                // Some lines can't be balanced properly because of unusually long words
                lines = balanced;
            }
        }
        var wrappedText = lines
            .map(function (ln) {
                return ln.join(' ');
            })
            .join('\n');
        return { result: wrappedText, truncated: wrapResult.linesTruncated, cumulativeHeight: cumulativeHeight };
    };
    Text.breakWord = function (word, firstLineWidth, maxWidth, hyphens, measurer) {
        var e_2, _a;
        var isPunctuationAt = function (index) {
            return Text.punctuationMarks.includes(word[index]);
        };
        var h = hyphens ? measurer.width('-') : 0;
        var breaks = [];
        var partWidth = 0;
        var p = 0;
        for (var i = 0; i < word.length; i++) {
            var c = word[i];
            var w = measurer.width(c);
            var limit = p === 0 ? firstLineWidth : maxWidth;
            if (partWidth + w + h > limit) {
                breaks.push(i);
                partWidth = 0;
                p++;
            }
            partWidth += w;
        }
        var parts = [];
        var start = 0;
        try {
            for (
                var breaks_1 = __values$K(breaks), breaks_1_1 = breaks_1.next();
                !breaks_1_1.done;
                breaks_1_1 = breaks_1.next()
            ) {
                var index = breaks_1_1.value;
                var part = word.substring(start, index);
                if (hyphens && part.length > 0 && !isPunctuationAt(index - 1) && !isPunctuationAt(index)) {
                    part += '-';
                }
                parts.push(part);
                start = index;
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (breaks_1_1 && !breaks_1_1.done && (_a = breaks_1.return)) _a.call(breaks_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        parts.push(word.substring(start));
        return parts;
    };
    Text.truncateLine = function (text, maxWidth, measurer, forceEllipsis) {
        var lineWidth = measurer.width(text);
        if (lineWidth < maxWidth && !forceEllipsis) {
            return text;
        }
        var ellipsisWidth = measurer.width(ellipsis);
        if (lineWidth + ellipsisWidth <= maxWidth) {
            return '' + text + ellipsis;
        }
        var index = Math.floor((text.length * maxWidth) / lineWidth) + 1;
        var trunc;
        var truncWidth;
        do {
            trunc = text.substring(0, index);
            truncWidth = measurer.width(trunc);
        } while (--index >= 0 && truncWidth + ellipsisWidth > maxWidth);
        return '' + trunc + ellipsis;
    };
    Text.wrapLineSequentially = function (words, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight) {
        var fontSize = textProps.fontSize,
            _a = textProps.lineHeight,
            lineHeight = _a === void 0 ? fontSize * Text.defaultLineHeightRatio : _a;
        var breakWord = wrapping === 'always' || wrapping === 'hyphenate';
        var hyphenate = wrapping === 'hyphenate';
        var spaceWidth = measurer.width(' ');
        var wordsBrokenOrTruncated = false;
        var linesTruncated = false;
        var lines = [];
        var currentLine = [];
        var lineWidth = 0;
        var addNewLine = function () {
            var expectedHeight = cumulativeHeight + lineHeight;
            if (expectedHeight >= maxHeight) {
                // Truncate the last line
                var lastLine = currentLine.join(' ');
                var trunc = Text.truncateLine(lastLine, maxWidth, measurer, true);
                currentLine.splice(0, currentLine.length, trunc);
                linesTruncated = true;
                return false;
            }
            // Add new line
            currentLine = [];
            lineWidth = 0;
            cumulativeHeight = expectedHeight;
            lines.push(currentLine);
            return true;
        };
        if (!addNewLine()) {
            return {
                lines: lines,
                linesTruncated: true,
                wordsBrokenOrTruncated: wordsBrokenOrTruncated,
                cumulativeHeight: cumulativeHeight,
            };
        }
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            var wordWidth = measurer.width(word);
            var expectedSpaceWidth = currentLine.length === 0 ? 0 : spaceWidth;
            var expectedLineWidth = lineWidth + expectedSpaceWidth + wordWidth;
            if (expectedLineWidth <= maxWidth) {
                // If the word fits, add it to the current line
                currentLine.push(word);
                lineWidth = expectedLineWidth;
                continue;
            }
            if (wordWidth <= maxWidth) {
                // If the word is not too long, put it onto new line
                if (!addNewLine()) {
                    break;
                }
                currentLine.push(word);
                lineWidth = wordWidth;
                continue;
            }
            // Handle a long word
            wordsBrokenOrTruncated = true;
            if (breakWord) {
                // Break the word into parts
                var availWidth = maxWidth - lineWidth - expectedSpaceWidth;
                var parts = Text.breakWord(word, availWidth, maxWidth, hyphenate, measurer);
                var breakLoop = false;
                for (var p = 0; p < parts.length; p++) {
                    var part = parts[p];
                    part && currentLine.push(part);
                    if (p === parts.length - 1) {
                        lineWidth = measurer.width(part);
                    } else if (!addNewLine()) {
                        breakLoop = true;
                        break;
                    }
                }
                if (breakLoop) break;
            } else {
                // Truncate the word
                if (!addNewLine()) {
                    break;
                }
                var trunc = Text.truncateLine(word, maxWidth, measurer, true);
                currentLine.push(trunc);
                if (i < words.length - 1) {
                    linesTruncated = true;
                }
                break;
            }
        }
        return {
            lines: lines,
            linesTruncated: linesTruncated,
            wordsBrokenOrTruncated: wordsBrokenOrTruncated,
            cumulativeHeight: cumulativeHeight,
        };
    };
    Text.wrapLineBalanced = function (words, maxWidth, measurer, linesCount) {
        var e_3, _a;
        var totalWordsWidth = words.reduce(function (sum, w) {
            return sum + measurer.width(w);
        }, 0);
        var spaceWidth = measurer.width(' ');
        var totalSpaceWidth = spaceWidth * (words.length - linesCount - 2);
        var averageLineWidth = (totalWordsWidth + totalSpaceWidth) / linesCount;
        var lines = [];
        var currentLine = [];
        var lineWidth = measurer.width(words[0]);
        var newLine = true;
        try {
            for (
                var words_1 = __values$K(words), words_1_1 = words_1.next();
                !words_1_1.done;
                words_1_1 = words_1.next()
            ) {
                var word = words_1_1.value;
                var width = measurer.width(word);
                if (newLine) {
                    // New line
                    currentLine = [];
                    currentLine.push(word);
                    lineWidth = width;
                    newLine = false;
                    lines.push(currentLine);
                    continue;
                }
                var expectedLineWidth = lineWidth + spaceWidth + width;
                if (expectedLineWidth <= averageLineWidth) {
                    // Keep adding words to the line
                    currentLine.push(word);
                    lineWidth = expectedLineWidth;
                } else if (expectedLineWidth <= maxWidth) {
                    // Add the last word to the line
                    currentLine.push(word);
                    newLine = true;
                } else {
                    // Put the word onto the next line
                    currentLine = [word];
                    lineWidth = width;
                    lines.push(currentLine);
                }
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (words_1_1 && !words_1_1.done && (_a = words_1.return)) _a.call(words_1);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        return lines;
    };
    Text.prototype.setFont = function (props) {
        this.fontFamily = props.fontFamily;
        this.fontSize = props.fontSize;
        this.fontStyle = props.fontStyle;
        this.fontWeight = props.fontWeight;
    };
    Text.prototype.setAlign = function (props) {
        this.textAlign = props.textAlign;
        this.textBaseline = props.textBaseline;
    };
    Text.className = 'Text';
    // The default line spacing for document editors is usually 1.15
    Text.defaultLineHeightRatio = 1.15;
    Text.defaultStyles = Object.assign({}, Shape.defaultStyles, {
        textAlign: 'start',
        fontStyle: undefined,
        fontWeight: undefined,
        fontSize: 10,
        fontFamily: 'sans-serif',
        textBaseline: 'alphabetic',
    });
    Text.punctuationMarks = ['.', ',', '-', ':', ';', '!', '?', "'", '"', '(', ')'];
    __decorate$1W([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Text.prototype, 'x', void 0);
    __decorate$1W([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Text.prototype, 'y', void 0);
    __decorate$1W(
        [
            SceneChangeDetection({
                redraw: RedrawType.MAJOR,
                changeCb: function (o) {
                    return o._setLines();
                },
            }),
        ],
        Text.prototype,
        'text',
        void 0,
    );
    __decorate$1W([SceneFontChangeDetection()], Text.prototype, 'fontStyle', void 0);
    __decorate$1W([SceneFontChangeDetection()], Text.prototype, 'fontWeight', void 0);
    __decorate$1W([SceneFontChangeDetection()], Text.prototype, 'fontSize', void 0);
    __decorate$1W([SceneFontChangeDetection()], Text.prototype, 'fontFamily', void 0);
    __decorate$1W([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Text.prototype, 'textAlign', void 0);
    __decorate$1W([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Text.prototype, 'textBaseline', void 0);
    __decorate$1W([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Text.prototype, 'lineHeight', void 0);
    return Text;
})(Shape);
function createTextMeasurer(font) {
    var cache = new Map();
    var getTextSize = function (text) {
        return HdpiCanvas.getTextSize(text, font);
    };
    var getLineWidth = function (text) {
        if (cache.has(text)) {
            return cache.get(text);
        }
        var width = getTextSize(text).width;
        cache.set(text, width);
        return width;
    };
    return { size: getTextSize, width: getLineWidth };
}
function getFont(fontProps) {
    var fontFamily = fontProps.fontFamily,
        fontSize = fontProps.fontSize,
        fontStyle = fontProps.fontStyle,
        fontWeight = fontProps.fontWeight;
    return [
        fontStyle !== null && fontStyle !== void 0 ? fontStyle : '',
        fontWeight !== null && fontWeight !== void 0 ? fontWeight : '',
        fontSize + 'px',
        fontFamily,
    ]
        .join(' ')
        .trim();
}
function measureText(lines, x, y, textProps) {
    return HdpiCanvas.has.textMetrics
        ? getPreciseBBox(lines, x, y, textProps)
        : getApproximateBBox(lines, x, y, textProps);
}
function getPreciseBBox(lines, x, y, textProps) {
    var _a, _b;
    var left = 0;
    var top = 0;
    var width = 0;
    var height = 0;
    // Distance between first and last base lines.
    var baselineDistance = 0;
    var font = getFont(textProps);
    var lineHeight = textProps.lineHeight,
        _c = textProps.textBaseline,
        textBaseline = _c === void 0 ? Text.defaultStyles.textBaseline : _c,
        _d = textProps.textAlign,
        textAlign = _d === void 0 ? Text.defaultStyles.textAlign : _d;
    for (var i = 0; i < lines.length; i++) {
        var metrics = HdpiCanvas.measureText(lines[i], font, textBaseline, textAlign);
        left = Math.max(left, metrics.actualBoundingBoxLeft);
        width = Math.max(width, metrics.width);
        if (i == 0) {
            top += metrics.actualBoundingBoxAscent;
            height += metrics.actualBoundingBoxAscent;
        } else {
            baselineDistance +=
                (_a = metrics.fontBoundingBoxAscent) !== null && _a !== void 0 ? _a : metrics.emHeightAscent;
        }
        if (i == lines.length - 1) {
            height += metrics.actualBoundingBoxDescent;
        } else {
            baselineDistance +=
                (_b = metrics.fontBoundingBoxDescent) !== null && _b !== void 0 ? _b : metrics.emHeightDescent;
        }
    }
    if (lineHeight !== undefined) {
        baselineDistance = (lines.length - 1) * lineHeight;
    }
    height += baselineDistance;
    top += baselineDistance * getVerticalOffset(textBaseline);
    return new BBox(x - left, y - top, width, height);
}
function getApproximateBBox(lines, x, y, textProps) {
    var width = 0;
    var firstLineHeight = 0;
    // Distance between first and last base lines.
    var baselineDistance = 0;
    var font = getFont(textProps);
    var lineHeight = textProps.lineHeight,
        _a = textProps.textBaseline,
        textBaseline = _a === void 0 ? Text.defaultStyles.textBaseline : _a,
        _b = textProps.textAlign,
        textAlign = _b === void 0 ? Text.defaultStyles.textAlign : _b;
    if (lines.length > 0) {
        var lineSize = HdpiCanvas.getTextSize(lines[0], font);
        width = lineSize.width;
        firstLineHeight = lineSize.height;
    }
    for (var i = 1; i < lines.length; i++) {
        var lineSize = HdpiCanvas.getTextSize(lines[i], font);
        width = Math.max(width, lineSize.width);
        baselineDistance += lineHeight !== null && lineHeight !== void 0 ? lineHeight : lineSize.height;
    }
    switch (textAlign) {
        case 'end':
        case 'right':
            x -= width;
            break;
        case 'center':
            x -= width / 2;
    }
    switch (textBaseline) {
        case 'alphabetic':
            y -= firstLineHeight * 0.7 + baselineDistance * 0.5;
            break;
        case 'middle':
            y -= firstLineHeight * 0.45 + baselineDistance * 0.5;
            break;
        case 'ideographic':
            y -= firstLineHeight + baselineDistance;
            break;
        case 'hanging':
            y -= firstLineHeight * 0.2 + baselineDistance * 0.5;
            break;
        case 'bottom':
            y -= firstLineHeight + baselineDistance;
            break;
    }
    return new BBox(x, y, width, firstLineHeight + baselineDistance);
}
function getVerticalOffset(textBaseline) {
    switch (textBaseline) {
        case 'top':
        case 'hanging':
            return 0;
        case 'bottom':
        case 'alphabetic':
        case 'ideographic':
            return 1;
        case 'middle':
            return 0.5;
    }
}
function splitText(text) {
    return typeof text === 'string' ? text.split(/\r?\n/g) : [];
}

var Observable = /** @class */ (function () {
    function Observable() {
        this.allEventListeners = new Map();
    }
    Observable.prototype.addEventListener = function (type, listener) {
        if (typeof listener !== 'function') {
            throw new Error('AG Charts - listener must be a Function');
        }
        var allEventListeners = this.allEventListeners;
        var eventListeners = allEventListeners.get(type);
        if (!eventListeners) {
            eventListeners = new Set();
            allEventListeners.set(type, eventListeners);
        }
        if (!eventListeners.has(listener)) {
            eventListeners.add(listener);
        }
    };
    Observable.prototype.removeEventListener = function (type, listener) {
        var allEventListeners = this.allEventListeners;
        var eventListeners = allEventListeners.get(type);
        if (!eventListeners) {
            return;
        }
        eventListeners.delete(listener);
        if (eventListeners.size === 0) {
            allEventListeners.delete(type);
        }
    };
    Observable.prototype.hasEventListener = function (type) {
        return this.allEventListeners.has(type);
    };
    Observable.prototype.clearEventListeners = function () {
        this.allEventListeners.clear();
    };
    Observable.prototype.fireEvent = function (event) {
        var listeners = this.allEventListeners.get(event.type);
        listeners === null || listeners === void 0
            ? void 0
            : listeners.forEach(function (listener) {
                  return listener(event);
              });
    };
    return Observable;
})();

var isString$2 = function (v) {
    return typeof v === 'string';
};
var isStringObject$1 = function (v) {
    return !!v && Object.prototype.hasOwnProperty.call(v, 'toString') && isString$2(v.toString());
};
var isDate$1 = function (v) {
    return v instanceof Date && !isNaN(+v);
};
function isDiscrete(value) {
    return isString$2(value) || isStringObject$1(value);
}
function isContinuous(value) {
    var isNumberObject = function (v) {
        return !!v && Object.prototype.hasOwnProperty.call(v, 'valueOf') && isNumber$4(v.valueOf());
    };
    var isDate = function (v) {
        return v instanceof Date && !isNaN(+v);
    };
    return isNumber$4(value) || isNumberObject(value) || isDate(value);
}
function checkDatum(value, isContinuousScale) {
    if (isContinuousScale && isContinuous(value)) {
        return value;
    } else if (!isContinuousScale) {
        if (!isDiscrete(value)) {
            return String(value);
        }
        return value;
    }
    return undefined;
}
var isNumber$4 = function (v) {
    return typeof v === 'number' && Number.isFinite(v);
};

var __read$14 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var Color = /** @class */ (function () {
    /**
     * Every color component should be in the [0, 1] range.
     * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
     * So, when animating colors, if the source or target color components are already near
     * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
     * component value to end up outside of that range mid-animation. For this reason the constructor
     * performs range checking/constraining.
     * @param r Red component.
     * @param g Green component.
     * @param b Blue component.
     * @param a Alpha (opacity) component.
     */
    function Color(r, g, b, a) {
        if (a === void 0) {
            a = 1;
        }
        // NaN is treated as 0.
        this.r = Math.min(1, Math.max(0, r || 0));
        this.g = Math.min(1, Math.max(0, g || 0));
        this.b = Math.min(1, Math.max(0, b || 0));
        this.a = Math.min(1, Math.max(0, a || 0));
    }
    /**
     * A color string can be in one of the following formats to be valid:
     * - #rgb
     * - #rrggbb
     * - rgb(r, g, b)
     * - rgba(r, g, b, a)
     * - CSS color name such as 'white', 'orange', 'cyan', etc.
     */
    Color.validColorString = function (str) {
        if (str.indexOf('#') >= 0) {
            return !!Color.parseHex(str);
        }
        if (str.indexOf('rgb') >= 0) {
            return !!Color.stringToRgba(str);
        }
        return !!Color.nameToHex[str.toLowerCase()];
    };
    /**
     * The given string can be in one of the following formats:
     * - #rgb
     * - #rrggbb
     * - rgb(r, g, b)
     * - rgba(r, g, b, a)
     * - CSS color name such as 'white', 'orange', 'cyan', etc.
     * @param str
     */
    Color.fromString = function (str) {
        // hexadecimal notation
        if (str.indexOf('#') >= 0) {
            // there can be some leading whitespace
            return Color.fromHexString(str);
        }
        // color name
        var hex = Color.nameToHex[str.toLowerCase()];
        if (hex) {
            return Color.fromHexString(hex);
        }
        // rgb(a) notation
        if (str.indexOf('rgb') >= 0) {
            return Color.fromRgbaString(str);
        }
        throw new Error("Invalid color string: '" + str + "'");
    };
    Color.tryParseFromString = function (str) {
        try {
            return Color.fromString(str);
        } catch (e) {
            Logger.warnOnce("invalid color string: '" + str + "'.");
            return Color.fromArray([0, 0, 0]);
        }
    };
    // See https://drafts.csswg.org/css-color/#hex-notation
    Color.parseHex = function (input) {
        input = input.replace(/ /g, '').slice(1);
        var parts;
        switch (input.length) {
            case 6:
            case 8:
                parts = [];
                for (var i = 0; i < input.length; i += 2) {
                    parts.push(parseInt('' + input[i] + input[i + 1], 16));
                }
                break;
            case 3:
            case 4:
                parts = input
                    .split('')
                    .map(function (p) {
                        return parseInt(p, 16);
                    })
                    .map(function (p) {
                        return p + p * 16;
                    });
                break;
        }
        if ((parts === null || parts === void 0 ? void 0 : parts.length) >= 3) {
            if (
                parts.every(function (p) {
                    return p >= 0;
                })
            ) {
                if (parts.length === 3) {
                    parts.push(255);
                }
                return parts;
            }
        }
    };
    Color.fromHexString = function (str) {
        var values = Color.parseHex(str);
        if (values) {
            var _a = __read$14(values, 4),
                r = _a[0],
                g = _a[1],
                b = _a[2],
                a = _a[3];
            return new Color(r / 255, g / 255, b / 255, a / 255);
        }
        throw new Error("Malformed hexadecimal color string: '" + str + "'");
    };
    Color.stringToRgba = function (str) {
        // Find positions of opening and closing parentheses.
        var _a = __read$14([NaN, NaN], 2),
            po = _a[0],
            pc = _a[1];
        for (var i = 0; i < str.length; i++) {
            var c = str[i];
            if (!po && c === '(') {
                po = i;
            } else if (c === ')') {
                pc = i;
                break;
            }
        }
        var contents = po && pc && str.substring(po + 1, pc);
        if (!contents) {
            return;
        }
        var parts = contents.split(',');
        var rgba = [];
        for (var i = 0; i < parts.length; i++) {
            var part = parts[i];
            var value = parseFloat(part);
            if (isNaN(value)) {
                return;
            }
            if (part.indexOf('%') >= 0) {
                // percentage r, g, or b value
                value = Math.max(0, Math.min(100, value));
                value /= 100;
            } else {
                if (i === 3) {
                    // alpha component
                    value = Math.max(0, Math.min(1, value));
                } else {
                    // absolute r, g, or b value
                    value = Math.max(0, Math.min(255, value));
                    value /= 255;
                }
            }
            rgba.push(value);
        }
        return rgba;
    };
    Color.fromRgbaString = function (str) {
        var rgba = Color.stringToRgba(str);
        if (rgba) {
            if (rgba.length === 3) {
                return new Color(rgba[0], rgba[1], rgba[2]);
            } else if (rgba.length === 4) {
                return new Color(rgba[0], rgba[1], rgba[2], rgba[3]);
            }
        }
        throw new Error("Malformed rgb/rgba color string: '" + str + "'");
    };
    Color.fromArray = function (arr) {
        if (arr.length === 4) {
            return new Color(arr[0], arr[1], arr[2], arr[3]);
        }
        if (arr.length === 3) {
            return new Color(arr[0], arr[1], arr[2]);
        }
        throw new Error('The given array should contain 3 or 4 color components (numbers).');
    };
    Color.fromHSB = function (h, s, b, alpha) {
        if (alpha === void 0) {
            alpha = 1;
        }
        var rgb = Color.HSBtoRGB(h, s, b);
        return new Color(rgb[0], rgb[1], rgb[2], alpha);
    };
    Color.padHex = function (str) {
        // Can't use `padStart(2, '0')` here because of IE.
        return str.length === 1 ? '0' + str : str;
    };
    Color.prototype.toHexString = function () {
        var hex =
            '#' +
            Color.padHex(Math.round(this.r * 255).toString(16)) +
            Color.padHex(Math.round(this.g * 255).toString(16)) +
            Color.padHex(Math.round(this.b * 255).toString(16));
        if (this.a < 1) {
            hex += Color.padHex(Math.round(this.a * 255).toString(16));
        }
        return hex;
    };
    Color.prototype.toRgbaString = function (fractionDigits) {
        if (fractionDigits === void 0) {
            fractionDigits = 3;
        }
        var components = [Math.round(this.r * 255), Math.round(this.g * 255), Math.round(this.b * 255)];
        var k = Math.pow(10, fractionDigits);
        if (this.a !== 1) {
            components.push(Math.round(this.a * k) / k);
            return 'rgba(' + components.join(', ') + ')';
        }
        return 'rgb(' + components.join(', ') + ')';
    };
    Color.prototype.toString = function () {
        if (this.a === 1) {
            return this.toHexString();
        }
        return this.toRgbaString();
    };
    Color.prototype.toHSB = function () {
        return Color.RGBtoHSB(this.r, this.g, this.b);
    };
    /**
     * Converts the given RGB triple to an array of HSB (HSV) components.
     * The hue component will be `NaN` for achromatic colors.
     */
    Color.RGBtoHSB = function (r, g, b) {
        var min = Math.min(r, g, b);
        var max = Math.max(r, g, b);
        var S = max !== 0 ? (max - min) / max : 0;
        var H = NaN;
        // min == max, means all components are the same
        // and the color is a shade of gray with no hue (H is NaN)
        if (min !== max) {
            var delta = max - min;
            var rc = (max - r) / delta;
            var gc = (max - g) / delta;
            var bc = (max - b) / delta;
            if (r === max) {
                H = bc - gc;
            } else if (g === max) {
                H = 2.0 + rc - bc;
            } else {
                H = 4.0 + gc - rc;
            }
            H /= 6.0;
            if (H < 0) {
                H = H + 1.0;
            }
        }
        return [H * 360, S, max];
    };
    /**
     * Converts the given HSB (HSV) triple to an array of RGB components.
     */
    Color.HSBtoRGB = function (H, S, B) {
        if (isNaN(H)) {
            H = 0;
        }
        H = (((H % 360) + 360) % 360) / 360; // normalize hue to [0, 360] interval, then scale to [0, 1]
        var r = 0;
        var g = 0;
        var b = 0;
        if (S === 0) {
            r = g = b = B;
        } else {
            var h = (H - Math.floor(H)) * 6;
            var f = h - Math.floor(h);
            var p = B * (1 - S);
            var q = B * (1 - S * f);
            var t = B * (1 - S * (1 - f));
            switch (
                h >> 0 // discard the floating point part of the number
            ) {
                case 0:
                    r = B;
                    g = t;
                    b = p;
                    break;
                case 1:
                    r = q;
                    g = B;
                    b = p;
                    break;
                case 2:
                    r = p;
                    g = B;
                    b = t;
                    break;
                case 3:
                    r = p;
                    g = q;
                    b = B;
                    break;
                case 4:
                    r = t;
                    g = p;
                    b = B;
                    break;
                case 5:
                    r = B;
                    g = p;
                    b = q;
                    break;
            }
        }
        return [r, g, b];
    };
    Color.prototype.derive = function (hueShift, saturationFactor, brightnessFactor, opacityFactor) {
        var hsb = Color.RGBtoHSB(this.r, this.g, this.b);
        var b = hsb[2];
        if (b == 0 && brightnessFactor > 1.0) {
            b = 0.05;
        }
        var h = (((hsb[0] + hueShift) % 360) + 360) % 360;
        var s = Math.max(Math.min(hsb[1] * saturationFactor, 1.0), 0.0);
        b = Math.max(Math.min(b * brightnessFactor, 1.0), 0.0);
        var a = Math.max(Math.min(this.a * opacityFactor, 1.0), 0.0);
        var rgba = Color.HSBtoRGB(h, s, b);
        rgba.push(a);
        return Color.fromArray(rgba);
    };
    Color.prototype.brighter = function () {
        return this.derive(0, 1.0, 1.0 / 0.7, 1.0);
    };
    Color.prototype.darker = function () {
        return this.derive(0, 1.0, 0.7, 1.0);
    };
    Color.interpolate = function (color, other) {
        var c0 = Color.tryParseFromString(color);
        var c1 = Color.tryParseFromString(other);
        return function (t) {
            var i = function (x, y) {
                return x * (1 - t) + y * t;
            };
            var c = new Color(i(c0.r, c1.r), i(c0.g, c1.g), i(c0.b, c1.b), i(c0.a, c1.a));
            return c.toString();
        };
    };
    /**
     * CSS Color Module Level 4:
     * https://drafts.csswg.org/css-color/#named-colors
     */
    Color.nameToHex = Object.freeze({
        aliceblue: '#F0F8FF',
        antiquewhite: '#FAEBD7',
        aqua: '#00FFFF',
        aquamarine: '#7FFFD4',
        azure: '#F0FFFF',
        beige: '#F5F5DC',
        bisque: '#FFE4C4',
        black: '#000000',
        blanchedalmond: '#FFEBCD',
        blue: '#0000FF',
        blueviolet: '#8A2BE2',
        brown: '#A52A2A',
        burlywood: '#DEB887',
        cadetblue: '#5F9EA0',
        chartreuse: '#7FFF00',
        chocolate: '#D2691E',
        coral: '#FF7F50',
        cornflowerblue: '#6495ED',
        cornsilk: '#FFF8DC',
        crimson: '#DC143C',
        cyan: '#00FFFF',
        darkblue: '#00008B',
        darkcyan: '#008B8B',
        darkgoldenrod: '#B8860B',
        darkgray: '#A9A9A9',
        darkgreen: '#006400',
        darkgrey: '#A9A9A9',
        darkkhaki: '#BDB76B',
        darkmagenta: '#8B008B',
        darkolivegreen: '#556B2F',
        darkorange: '#FF8C00',
        darkorchid: '#9932CC',
        darkred: '#8B0000',
        darksalmon: '#E9967A',
        darkseagreen: '#8FBC8F',
        darkslateblue: '#483D8B',
        darkslategray: '#2F4F4F',
        darkslategrey: '#2F4F4F',
        darkturquoise: '#00CED1',
        darkviolet: '#9400D3',
        deeppink: '#FF1493',
        deepskyblue: '#00BFFF',
        dimgray: '#696969',
        dimgrey: '#696969',
        dodgerblue: '#1E90FF',
        firebrick: '#B22222',
        floralwhite: '#FFFAF0',
        forestgreen: '#228B22',
        fuchsia: '#FF00FF',
        gainsboro: '#DCDCDC',
        ghostwhite: '#F8F8FF',
        gold: '#FFD700',
        goldenrod: '#DAA520',
        gray: '#808080',
        green: '#008000',
        greenyellow: '#ADFF2F',
        grey: '#808080',
        honeydew: '#F0FFF0',
        hotpink: '#FF69B4',
        indianred: '#CD5C5C',
        indigo: '#4B0082',
        ivory: '#FFFFF0',
        khaki: '#F0E68C',
        lavender: '#E6E6FA',
        lavenderblush: '#FFF0F5',
        lawngreen: '#7CFC00',
        lemonchiffon: '#FFFACD',
        lightblue: '#ADD8E6',
        lightcoral: '#F08080',
        lightcyan: '#E0FFFF',
        lightgoldenrodyellow: '#FAFAD2',
        lightgray: '#D3D3D3',
        lightgreen: '#90EE90',
        lightgrey: '#D3D3D3',
        lightpink: '#FFB6C1',
        lightsalmon: '#FFA07A',
        lightseagreen: '#20B2AA',
        lightskyblue: '#87CEFA',
        lightslategray: '#778899',
        lightslategrey: '#778899',
        lightsteelblue: '#B0C4DE',
        lightyellow: '#FFFFE0',
        lime: '#00FF00',
        limegreen: '#32CD32',
        linen: '#FAF0E6',
        magenta: '#FF00FF',
        maroon: '#800000',
        mediumaquamarine: '#66CDAA',
        mediumblue: '#0000CD',
        mediumorchid: '#BA55D3',
        mediumpurple: '#9370DB',
        mediumseagreen: '#3CB371',
        mediumslateblue: '#7B68EE',
        mediumspringgreen: '#00FA9A',
        mediumturquoise: '#48D1CC',
        mediumvioletred: '#C71585',
        midnightblue: '#191970',
        mintcream: '#F5FFFA',
        mistyrose: '#FFE4E1',
        moccasin: '#FFE4B5',
        navajowhite: '#FFDEAD',
        navy: '#000080',
        oldlace: '#FDF5E6',
        olive: '#808000',
        olivedrab: '#6B8E23',
        orange: '#FFA500',
        orangered: '#FF4500',
        orchid: '#DA70D6',
        palegoldenrod: '#EEE8AA',
        palegreen: '#98FB98',
        paleturquoise: '#AFEEEE',
        palevioletred: '#DB7093',
        papayawhip: '#FFEFD5',
        peachpuff: '#FFDAB9',
        peru: '#CD853F',
        pink: '#FFC0CB',
        plum: '#DDA0DD',
        powderblue: '#B0E0E6',
        purple: '#800080',
        rebeccapurple: '#663399',
        red: '#FF0000',
        rosybrown: '#BC8F8F',
        royalblue: '#4169E1',
        saddlebrown: '#8B4513',
        salmon: '#FA8072',
        sandybrown: '#F4A460',
        seagreen: '#2E8B57',
        seashell: '#FFF5EE',
        sienna: '#A0522D',
        silver: '#C0C0C0',
        skyblue: '#87CEEB',
        slateblue: '#6A5ACD',
        slategray: '#708090',
        slategrey: '#708090',
        snow: '#FFFAFA',
        springgreen: '#00FF7F',
        steelblue: '#4682B4',
        tan: '#D2B48C',
        teal: '#008080',
        thistle: '#D8BFD8',
        tomato: '#FF6347',
        transparent: '#00000000',
        turquoise: '#40E0D0',
        violet: '#EE82EE',
        wheat: '#F5DEB3',
        white: '#FFFFFF',
        whitesmoke: '#F5F5F5',
        yellow: '#FFFF00',
        yellowgreen: '#9ACD32',
    });
    return Color;
})();

var __values$J =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var BREAK_TRANSFORM_CHAIN = Symbol('BREAK');
var CONFIG_KEY = '__decorator_config';
function initialiseConfig(target, propertyKeyOrSymbol, propertyKey, valueStoreKey) {
    if (Object.getOwnPropertyDescriptor(target, CONFIG_KEY) == null) {
        Object.defineProperty(target, CONFIG_KEY, { value: {} });
    }
    var config = target[CONFIG_KEY];
    if (config[propertyKey] != null) {
        return config[propertyKey];
    }
    config[propertyKey] = { setters: [], getters: [] };
    var descriptor = Object.getOwnPropertyDescriptor(target, propertyKeyOrSymbol);
    var prevSet = descriptor === null || descriptor === void 0 ? void 0 : descriptor.set;
    var prevGet = descriptor === null || descriptor === void 0 ? void 0 : descriptor.get;
    var getter = function () {
        var e_1, _a;
        var _b, _c;
        var value = prevGet ? prevGet.call(this) : this[valueStoreKey];
        try {
            for (
                var _d = __values$J(
                        (_c = (_b = config[propertyKey]) === null || _b === void 0 ? void 0 : _b.getters) !== null &&
                            _c !== void 0
                            ? _c
                            : [],
                    ),
                    _e = _d.next();
                !_e.done;
                _e = _d.next()
            ) {
                var transformFn = _e.value;
                value = transformFn(this, propertyKeyOrSymbol, value);
                if (value === BREAK_TRANSFORM_CHAIN) {
                    return undefined;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return value;
    };
    var setter = function (value) {
        var e_2, _a;
        var _b, _c;
        var setters =
            (_c = (_b = config[propertyKey]) === null || _b === void 0 ? void 0 : _b.setters) !== null && _c !== void 0
                ? _c
                : [];
        var oldValue;
        if (
            setters.some(function (f) {
                return f.length > 2;
            })
        ) {
            // Lazily retrieve old value.
            oldValue = prevGet ? prevGet.call(this) : this[valueStoreKey];
        }
        try {
            for (
                var setters_1 = __values$J(setters), setters_1_1 = setters_1.next();
                !setters_1_1.done;
                setters_1_1 = setters_1.next()
            ) {
                var transformFn = setters_1_1.value;
                value = transformFn(this, propertyKeyOrSymbol, value, oldValue);
                if (value === BREAK_TRANSFORM_CHAIN) {
                    return;
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (setters_1_1 && !setters_1_1.done && (_a = setters_1.return)) _a.call(setters_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        if (prevSet) {
            prevSet.call(this, value);
        } else {
            this[valueStoreKey] = value;
        }
    };
    Object.defineProperty(target, propertyKeyOrSymbol, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: false,
    });
    return config[propertyKey];
}
function addTransformToInstanceProperty(setTransform, getTransform) {
    return function (target, propertyKeyOrSymbol) {
        var propertyKey = propertyKeyOrSymbol.toString();
        var valueStoreKey = '__' + propertyKey;
        var _a = initialiseConfig(target, propertyKeyOrSymbol, propertyKey, valueStoreKey),
            getters = _a.getters,
            setters = _a.setters;
        setters.push(setTransform);
        if (getTransform) {
            getters.splice(0, 0, getTransform);
        }
    };
}

function Validate(predicate) {
    return addTransformToInstanceProperty(function (target, prop, v) {
        var _a, _b, _c;
        if (predicate(v, { target: target })) {
            return v;
        }
        var cleanKey = prop.toString().replace(/^_*/, '');
        var targetClass =
            (_b = (_a = target.constructor) === null || _a === void 0 ? void 0 : _a.className) !== null && _b !== void 0
                ? _b
                : (_c = target.constructor) === null || _c === void 0
                ? void 0
                : _c.name;
        if ((targetClass === null || targetClass === void 0 ? void 0 : targetClass.length) < 3) {
            targetClass = null;
        }
        var targetClassName = targetClass ? 'of [' + targetClass + '] ' : '';
        if (predicate.message) {
            Logger.warn(
                'Property [' +
                    cleanKey +
                    '] ' +
                    targetClassName +
                    'cannot be set to [' +
                    JSON.stringify(v) +
                    ']; ' +
                    predicate.message +
                    ', ignoring.',
            );
        } else {
            Logger.warn(
                'Property [' +
                    cleanKey +
                    '] ' +
                    targetClassName +
                    'cannot be set to [' +
                    JSON.stringify(v) +
                    '], ignoring.',
            );
        }
        return BREAK_TRANSFORM_CHAIN;
    });
}
function predicateWithMessage(predicate, message) {
    predicate.message = message;
    return predicate;
}
var OPTIONAL = function (v, ctx, predicate) {
    return v === undefined || predicate(v, ctx);
};
var ARRAY = function (length, predicate) {
    return predicateWithMessage(function (v, ctx) {
        return (
            Array.isArray(v) &&
            (length ? v.length === length : true) &&
            (predicate
                ? v.every(function (e) {
                      return predicate(e, ctx);
                  })
                : true)
        );
    }, 'expecting an Array');
};
var OPT_ARRAY = function (length) {
    return predicateWithMessage(function (v, ctx) {
        return OPTIONAL(v, ctx, ARRAY(length));
    }, 'expecting an optional Array');
};
var AND = function () {
    var predicates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        predicates[_i] = arguments[_i];
    }
    return predicateWithMessage(
        function (v, ctx) {
            return predicates.every(function (p) {
                return p(v, ctx);
            });
        },
        predicates
            .map(function (p) {
                return p.message;
            })
            .filter(function (m) {
                return m != null;
            })
            .join(' AND '),
    );
};
var OR = function () {
    var predicates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        predicates[_i] = arguments[_i];
    }
    return predicateWithMessage(
        function (v, ctx) {
            return predicates.some(function (p) {
                return p(v, ctx);
            });
        },
        predicates
            .map(function (p) {
                return p.message;
            })
            .filter(function (m) {
                return m != null;
            })
            .join(' OR '),
    );
};
var isComparable = function (v) {
    return v != null && !isNaN(v);
};
var LESS_THAN = function (otherField) {
    return predicateWithMessage(function (v, ctx) {
        return !isComparable(v) || !isComparable(ctx.target[otherField]) || v < ctx.target[otherField];
    }, 'expected to be less than ' + otherField);
};
var GREATER_THAN = function (otherField) {
    return predicateWithMessage(function (v, ctx) {
        return !isComparable(v) || !isComparable(ctx.target[otherField]) || v > ctx.target[otherField];
    }, 'expected to be greater than ' + otherField);
};
var FUNCTION = predicateWithMessage(function (v) {
    return typeof v === 'function';
}, 'expecting a Function');
var OPT_FUNCTION = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, FUNCTION);
}, 'expecting an optional Function');
var BOOLEAN = predicateWithMessage(function (v) {
    return v === true || v === false;
}, 'expecting a Boolean');
var OPT_BOOLEAN = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, BOOLEAN);
}, 'expecting an optional Boolean');
var STRING = predicateWithMessage(function (v) {
    return typeof v === 'string';
}, 'expecting a String');
var OPT_STRING = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, STRING);
}, 'expecting an optional String');
var DATE = predicateWithMessage(function (v) {
    return v instanceof Date && !isNaN(+v);
}, 'expecting a Date object');
var OPT_DATE = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, DATE);
}, 'expecting an optional Date');
predicateWithMessage(ARRAY(undefined, DATE), 'expecting an Array of Date objects');
var DATETIME_MS = NUMBER(0);
var OPT_DATETIME_MS = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, DATETIME_MS);
}, 'expecting an optional number');
var OPT_DATE_OR_DATETIME_MS = OR(OPT_DATE, OPT_DATETIME_MS);
var colorMessage =
    "A color string can be in one of the following formats to be valid: #rgb, #rrggbb, rgb(r, g, b), rgba(r, g, b, a) or a CSS color name such as 'white', 'orange', 'cyan', etc";
var COLOR_STRING = predicateWithMessage(function (v) {
    if (typeof v !== 'string') {
        return false;
    }
    return Color.validColorString(v);
}, 'expecting a color String. ' + colorMessage);
var OPT_COLOR_STRING = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, COLOR_STRING);
}, 'expecting an optional color String. ' + colorMessage);
var COLOR_STRING_ARRAY = predicateWithMessage(
    ARRAY(undefined, COLOR_STRING),
    'expecting an Array of color strings. ' + colorMessage,
);
var OPT_COLOR_STRING_ARRAY = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, COLOR_STRING_ARRAY);
}, 'expecting an optional Array of color strings. ' + colorMessage);
function NUMBER(min, max) {
    var message =
        'expecting a finite Number' +
        ((min !== undefined ? ', more than or equal to ' + min : '') +
            (max !== undefined ? ', less than or equal to ' + max : ''));
    return predicateWithMessage(function (v) {
        return (
            typeof v === 'number' &&
            Number.isFinite(v) &&
            (min !== undefined ? v >= min : true) &&
            (max !== undefined ? v <= max : true)
        );
    }, message);
}
function OPT_NUMBER(min, max) {
    var message =
        'expecting an optional finite Number' +
        ((min !== undefined ? ', more than or equal to ' + min : '') +
            (max !== undefined ? ', less than or equal to ' + max : ''));
    return predicateWithMessage(function (v, ctx) {
        return OPTIONAL(v, ctx, NUMBER(min, max));
    }, message);
}
function NUMBER_OR_NAN(min, max) {
    // Can be NaN or finite number
    var message =
        'expecting a finite Number' +
        ((min !== undefined ? ', more than or equal to ' + min : '') +
            (max !== undefined ? ', less than or equal to ' + max : ''));
    return predicateWithMessage(function (v) {
        return (
            typeof v === 'number' &&
            (isNaN(v) ||
                (Number.isFinite(v) && (min !== undefined ? v >= min : true) && (max !== undefined ? v <= max : true)))
        );
    }, message);
}
var NUMBER_ARRAY = predicateWithMessage(ARRAY(undefined, NUMBER()), 'expecting an Array of numbers');
var OPT_NUMBER_ARRAY = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, NUMBER_ARRAY);
}, 'expecting an optional Array of numbers');
var STRING_ARRAY = predicateWithMessage(ARRAY(undefined, STRING), 'expecting an Array of strings');
predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, STRING_ARRAY);
}, 'expecting an optional Array of strings');
function STRING_UNION() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var message = 'expecting one of: ' + values.join(', ');
    return predicateWithMessage(function (v) {
        return typeof v === 'string' && values.indexOf(v) >= 0;
    }, message);
}
var BOOLEAN_ARRAY = predicateWithMessage(ARRAY(undefined, BOOLEAN), 'expecting an Array of boolean values');
predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, BOOLEAN_ARRAY);
}, 'expecting an optional Array of boolean values');
var FONT_WEIGHTS = [
    'normal',
    'bold',
    'bolder',
    'lighter',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
];
var FONT_STYLE = predicateWithMessage(function (v) {
    return v === 'normal' || v === 'italic' || v === 'oblique';
}, "expecting a font style keyword such as 'normal', 'italic' or 'oblique'");
var OPT_FONT_STYLE = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, FONT_STYLE);
}, "expecting an optional font style keyword such as 'normal', 'italic' or 'oblique'");
var FONT_WEIGHT = predicateWithMessage(function (v) {
    return FONT_WEIGHTS.includes(v);
}, "expecting a font weight keyword such as 'normal', 'bold' or 'bolder' or a numeric value such as 100, 300 or 600");
var OPT_FONT_WEIGHT = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, FONT_WEIGHT);
}, "expecting an optional font weight keyword such as 'normal', 'bold' or 'bolder' or a numeric value such as 100, 300 or 600");
var LINE_DASH = predicateWithMessage(
    ARRAY(undefined, NUMBER(0)),
    'expecting an Array of numbers specifying the length in pixels of alternating dashes and gaps, for example, [6, 3] means dashes with a length of 6 pixels with gaps between of 3 pixels.',
);
var OPT_LINE_DASH = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, LINE_DASH);
}, 'expecting an optional Array of numbers specifying the length in pixels of alternating dashes and gaps, for example, [6, 3] means dashes with a length of 6 pixels with gaps between of 3 pixels.');
var LINE_CAPS = ['butt', 'round', 'square'];
var LINE_CAP = predicateWithMessage(function (v) {
    return LINE_CAPS.includes(v);
}, "expecting a line cap keyword such as 'butt', 'round' or 'square'");
predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, LINE_CAP);
}, "expecting an optional line cap keyword such as 'butt', 'round' or 'square'");
var LINE_JOINS = ['round', 'bevel', 'miter'];
var LINE_JOIN = predicateWithMessage(function (v) {
    return LINE_JOINS.includes(v);
}, "expecting a line join keyword such as 'round', 'bevel' or 'miter'");
predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, LINE_JOIN);
}, "expecting an optional line join keyword such as 'round', 'bevel' or 'miter'");
var POSITIONS = ['top', 'right', 'bottom', 'left'];
var POSITION = predicateWithMessage(function (v) {
    return POSITIONS.includes(v);
}, "expecting a position keyword such as 'top', 'right', 'bottom' or 'left");
var INTERACTION_RANGES = ['exact', 'nearest'];
var INTERACTION_RANGE = predicateWithMessage(function (v) {
    return (typeof v === 'number' && Number.isFinite(v)) || INTERACTION_RANGES.includes(v);
}, "expecting an interaction range of 'exact', 'nearest' or a number");
var TEXT_WRAPS = ['never', 'always', 'hyphenate', 'on-space'];
var TEXT_WRAP = predicateWithMessage(function (v) {
    return TEXT_WRAPS.includes(v);
}, "expecting a text wrap strategy keyword such as 'never', 'always', 'hyphenate', 'on-space'");

/**
 * Constants to declare the expected nominal zIndex for all types of layer in chart rendering.
 */
var Layers;
(function (Layers) {
    Layers[(Layers['SERIES_BACKGROUND_ZINDEX'] = -10)] = 'SERIES_BACKGROUND_ZINDEX';
    Layers[(Layers['AXIS_GRID_ZINDEX'] = 0)] = 'AXIS_GRID_ZINDEX';
    Layers[(Layers['AXIS_ZINDEX'] = 20)] = 'AXIS_ZINDEX';
    Layers[(Layers['SERIES_CROSSLINE_RANGE_ZINDEX'] = 30)] = 'SERIES_CROSSLINE_RANGE_ZINDEX';
    Layers[(Layers['SERIES_LAYER_ZINDEX'] = 500)] = 'SERIES_LAYER_ZINDEX';
    Layers[(Layers['SERIES_CROSSHAIR_ZINDEX'] = 1000)] = 'SERIES_CROSSHAIR_ZINDEX';
    Layers[(Layers['SERIES_LABEL_ZINDEX'] = 1500)] = 'SERIES_LABEL_ZINDEX';
    Layers[(Layers['SERIES_CROSSLINE_LINE_ZINDEX'] = 2500)] = 'SERIES_CROSSLINE_LINE_ZINDEX';
    Layers[(Layers['LEGEND_ZINDEX'] = 3000)] = 'LEGEND_ZINDEX';
})(Layers || (Layers = {}));

var ChartAxisDirection;
(function (ChartAxisDirection) {
    ChartAxisDirection['X'] = 'x';
    ChartAxisDirection['Y'] = 'y';
})(ChartAxisDirection || (ChartAxisDirection = {}));

var DataDomain = /** @class */ (function () {
    function DataDomain(type) {
        this.type = type;
        this.continuousDomain = [Infinity, -Infinity];
        this.discreteDomain = new Set();
    }
    DataDomain.prototype.extend = function (val) {
        if (this.type === 'discrete') {
            this.discreteDomain.add(val);
        } else if (this.type === 'continuous') {
            if (this.continuousDomain[0] > val) {
                this.continuousDomain[0] = val;
            }
            if (this.continuousDomain[1] < val) {
                this.continuousDomain[1] = val;
            }
        }
    };
    DataDomain.prototype.getDomain = function () {
        if (this.type === 'discrete') {
            return this.discreteDomain;
        } else if (this.type === 'continuous') {
            return this.continuousDomain;
        }
        throw new Error('AG Charts - Unsupported data domain type: ' + this.type);
    };
    return DataDomain;
})();

var __values$I =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function extendDomain(values, domain) {
    var e_1, _a;
    if (domain === void 0) {
        domain = [Infinity, -Infinity];
    }
    try {
        for (
            var values_1 = __values$I(values), values_1_1 = values_1.next();
            !values_1_1.done;
            values_1_1 = values_1.next()
        ) {
            var value = values_1_1.value;
            if (typeof value !== 'number') {
                continue;
            }
            if (value < domain[0]) {
                domain[0] = value;
            }
            if (value > domain[1]) {
                domain[1] = value;
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return domain;
}

var __assign$T =
    (undefined && undefined.__assign) ||
    function () {
        __assign$T =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$T.apply(this, arguments);
    };
var __read$13 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __values$H =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __spreadArray$D =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
function toKeyString(keys) {
    return keys
        .map(function (v) {
            if (v == null) {
                return v;
            } else if (typeof v === 'number' || typeof v === 'string' || typeof v === 'boolean') {
                return v;
            } else if (typeof v === 'object') {
                return JSON.stringify(v);
            }
            return v;
        })
        .join('-');
}
function round(val) {
    var accuracy = 10000;
    if (Number.isInteger(val)) {
        return val;
    } else if (Math.abs(val) > accuracy) {
        return Math.trunc(val);
    }
    return Math.round(val * accuracy) / accuracy;
}
function fixNumericExtent(extent) {
    if (extent === undefined) {
        // Don't return a range, there is no range.
        return [];
    }
    var _a = __read$13(extent, 2),
        min = _a[0],
        max = _a[1];
    min = +min;
    max = +max;
    if (min === 0 && max === 0) {
        // domain has zero length and the single valid value is 0. Use the default of [0, 1].
        return [0, 1];
    }
    if (min === Infinity && max === -Infinity) {
        // There's no data in the domain.
        return [];
    }
    if (min === Infinity) {
        min = 0;
    }
    if (max === -Infinity) {
        max = 0;
    }
    if (!(isNumber$4(min) && isNumber$4(max))) {
        return [];
    }
    return [min, max];
}
var INVALID_VALUE = Symbol('invalid');
var DataModel = /** @class */ (function () {
    function DataModel(opts) {
        var e_1, _a, e_2, _b, e_3, _c;
        var _this = this;
        var props = opts.props;
        // Validate that keys appear before values in the definitions, as output ordering depends
        // on configuration ordering, but we process keys before values.
        var keys = true;
        try {
            for (
                var props_1 = __values$H(props), props_1_1 = props_1.next();
                !props_1_1.done;
                props_1_1 = props_1.next()
            ) {
                var next = props_1_1.value;
                if (next.type === 'key' && !keys) {
                    throw new Error('AG Charts - internal config error: keys must come before values.');
                }
                if (next.type === 'value' && keys) {
                    keys = false;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        this.opts = __assign$T({ dataVisible: true }, opts);
        this.keys = props
            .filter(function (def) {
                return def.type === 'key';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index, missing: 0 });
            });
        this.values = props
            .filter(function (def) {
                return def.type === 'value';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index, missing: 0 });
            });
        this.aggregates = props
            .filter(function (def) {
                return def.type === 'aggregate';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index });
            });
        this.groupProcessors = props
            .filter(function (def) {
                return def.type === 'group-value-processor';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index });
            });
        this.propertyProcessors = props
            .filter(function (def) {
                return def.type === 'property-value-processor';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index });
            });
        this.reducers = props
            .filter(function (def) {
                return def.type === 'reducer';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index });
            });
        this.processors = props
            .filter(function (def) {
                return def.type === 'processor';
            })
            .map(function (def, index) {
                return __assign$T(__assign$T({}, def), { index: index });
            });
        try {
            for (var _d = __values$H(this.values), _e = _d.next(); !_e.done; _e = _d.next()) {
                var def = _e.value;
                if (def.property == null) {
                    throw new Error(
                        'AG Charts - internal config error: no properties specified for value definitions: ' +
                            JSON.stringify(def),
                    );
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        var verifyMatchGroupId = function (_a) {
            var e_4, _b;
            var matchGroupIds = _a.matchGroupIds;
            var _loop_1 = function (matchGroupId) {
                if (
                    !_this.values.some(function (def) {
                        return def.groupId === matchGroupId;
                    })
                ) {
                    throw new Error(
                        'AG Charts - internal config error: matchGroupIds properties must match defined groups (' +
                            matchGroupId +
                            ').',
                    );
                }
            };
            try {
                for (
                    var _c = __values$H(matchGroupIds !== null && matchGroupIds !== void 0 ? matchGroupIds : []),
                        _d = _c.next();
                    !_d.done;
                    _d = _c.next()
                ) {
                    var matchGroupId = _d.value;
                    _loop_1(matchGroupId);
                }
            } catch (e_4_1) {
                e_4 = { error: e_4_1 };
            } finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally {
                    if (e_4) throw e_4.error;
                }
            }
        };
        var verifyMatchScopes = function (_a) {
            var e_5, _b;
            var matchScopes = _a.matchScopes;
            var _loop_2 = function (matchScope) {
                if (
                    !_this.values.some(function (def) {
                        var _a;
                        return (_a = def.scopes) === null || _a === void 0 ? void 0 : _a.includes(matchScope);
                    })
                ) {
                    throw new Error(
                        'AG Charts - internal config error: matchGroupIds properties must match defined groups (' +
                            matchScope +
                            ').',
                    );
                }
            };
            try {
                for (
                    var _c = __values$H(matchScopes !== null && matchScopes !== void 0 ? matchScopes : []),
                        _d = _c.next();
                    !_d.done;
                    _d = _c.next()
                ) {
                    var matchScope = _d.value;
                    _loop_2(matchScope);
                }
            } catch (e_5_1) {
                e_5 = { error: e_5_1 };
            } finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally {
                    if (e_5) throw e_5.error;
                }
            }
        };
        var verifyMatchIds = function (_a) {
            var e_6, _b;
            var matchIds = _a.matchIds;
            var _loop_3 = function (matchId) {
                if (
                    !_this.values.some(function (def) {
                        return def.id === matchId;
                    })
                ) {
                    throw new Error(
                        'AG Charts - internal config error: matchGroupIds properties must match defined groups (' +
                            matchId +
                            ').',
                    );
                }
            };
            try {
                for (
                    var _c = __values$H(matchIds !== null && matchIds !== void 0 ? matchIds : []), _d = _c.next();
                    !_d.done;
                    _d = _c.next()
                ) {
                    var matchId = _d.value;
                    _loop_3(matchId);
                }
            } catch (e_6_1) {
                e_6 = { error: e_6_1 };
            } finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                } finally {
                    if (e_6) throw e_6.error;
                }
            }
        };
        try {
            for (
                var _f = __values$H(
                        __spreadArray$D(
                            __spreadArray$D([], __read$13(this.groupProcessors)),
                            __read$13(this.aggregates),
                        ),
                    ),
                    _g = _f.next();
                !_g.done;
                _g = _f.next()
            ) {
                var def = _g.value;
                verifyMatchIds(def);
                verifyMatchGroupId(def);
                verifyMatchScopes(def);
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
    }
    DataModel.prototype.resolveProcessedDataIndexById = function (scope, searchId, type) {
        var _a;
        if (type === void 0) {
            type = 'value';
        }
        var _b = (_a = this.resolveProcessedDataDefById(scope, searchId, type)) !== null && _a !== void 0 ? _a : {},
            index = _b.index,
            def = _b.def;
        return { type: type, index: index, def: def };
    };
    DataModel.prototype.resolveProcessedDataIndicesById = function (scope, searchId, type) {
        if (type === void 0) {
            type = 'value';
        }
        return this.resolveProcessedDataDefsById(scope, searchId, type).map(function (_a) {
            var index = _a.index,
                def = _a.def;
            return { type: type, index: index, def: def };
        });
    };
    DataModel.prototype.resolveProcessedDataDefById = function (scope, searchId, type) {
        if (type === void 0) {
            type = 'value';
        }
        return this.resolveProcessedDataDefsById(scope, searchId, type)[0];
    };
    DataModel.prototype.resolveProcessedDataDefsById = function (scope, searchId, type) {
        var e_7, _a;
        if (type === void 0) {
            type = 'value';
        }
        var _b = this,
            keys = _b.keys,
            values = _b.values,
            aggregates = _b.aggregates,
            groupProcessors = _b.groupProcessors,
            reducers = _b.reducers;
        var match = function (_a) {
            var id = _a.id,
                scopes = _a.scopes;
            if (id == null) return false;
            if (scope != null && !(scopes === null || scopes === void 0 ? void 0 : scopes.includes(scope.id)))
                return false;
            if (typeof searchId === 'string') {
                return id === searchId;
            }
            return searchId.test(id);
        };
        var allDefs = [keys, values, aggregates, groupProcessors, reducers];
        var result = [];
        try {
            for (
                var allDefs_1 = __values$H(allDefs), allDefs_1_1 = allDefs_1.next();
                !allDefs_1_1.done;
                allDefs_1_1 = allDefs_1.next()
            ) {
                var defs = allDefs_1_1.value;
                result.push.apply(
                    result,
                    __spreadArray$D(
                        [],
                        __read$13(
                            defs.filter(match).map(function (def) {
                                return { index: def.index, def: def };
                            }),
                        ),
                    ),
                );
            }
        } catch (e_7_1) {
            e_7 = { error: e_7_1 };
        } finally {
            try {
                if (allDefs_1_1 && !allDefs_1_1.done && (_a = allDefs_1.return)) _a.call(allDefs_1);
            } finally {
                if (e_7) throw e_7.error;
            }
        }
        if (result.length > 0) {
            return result;
        }
        throw new Error(
            "AG Charts - didn't find property definition for [" + searchId + ', ' + scope.id + ', ' + type + ']',
        );
    };
    DataModel.prototype.getDomain = function (scope, searchId, type, processedData) {
        var e_8, _a;
        var _b, _c, _d, _e;
        if (type === void 0) {
            type = 'value';
        }
        var matches;
        try {
            matches = this.resolveProcessedDataIndicesById(scope, searchId, type);
        } catch (e) {
            if (typeof searchId !== 'string' && /didn't find property definition/.test(e.message)) return [];
            throw e;
        }
        var domainProp;
        switch (type) {
            case 'key':
                domainProp = 'keys';
                break;
            case 'value':
                domainProp = 'values';
                break;
            case 'aggregate':
                domainProp = 'aggValues';
                break;
            case 'group-value-processor':
                domainProp = 'groups';
                break;
            default:
                return [];
        }
        var firstMatch =
            (_c = (_b = processedData.domain[domainProp]) === null || _b === void 0 ? void 0 : _b[matches[0].index]) !==
                null && _c !== void 0
                ? _c
                : [];
        if (matches.length === 1) {
            return firstMatch;
        }
        var result = __spreadArray$D([], __read$13(firstMatch));
        try {
            for (var _f = __values$H(matches.slice(1)), _g = _f.next(); !_g.done; _g = _f.next()) {
                var idx = _g.value;
                extendDomain(
                    (_e =
                        (_d = processedData.domain[domainProp]) === null || _d === void 0 ? void 0 : _d[idx.index]) !==
                        null && _e !== void 0
                        ? _e
                        : [],
                    result,
                );
            }
        } catch (e_8_1) {
            e_8 = { error: e_8_1 };
        } finally {
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            } finally {
                if (e_8) throw e_8.error;
            }
        }
        return result;
    };
    DataModel.prototype.processData = function (data) {
        var e_9, _a, e_10, _b;
        var _c = this,
            _d = _c.opts,
            groupByKeys = _d.groupByKeys,
            groupByFn = _d.groupByFn,
            aggregates = _c.aggregates,
            groupProcessors = _c.groupProcessors,
            reducers = _c.reducers,
            processors = _c.processors,
            propertyProcessors = _c.propertyProcessors;
        var start = performance.now();
        try {
            for (
                var _e = __values$H(__spreadArray$D(__spreadArray$D([], __read$13(this.keys)), __read$13(this.values))),
                    _f = _e.next();
                !_f.done;
                _f = _e.next()
            ) {
                var def = _f.value;
                def.missing = 0;
            }
        } catch (e_9_1) {
            e_9 = { error: e_9_1 };
        } finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally {
                if (e_9) throw e_9.error;
            }
        }
        if (groupByKeys && this.keys.length === 0) {
            return undefined;
        }
        var processedData = this.extractData(data);
        if (groupByKeys) {
            processedData = this.groupData(processedData);
        } else if (groupByFn) {
            processedData = this.groupData(processedData, groupByFn(processedData));
        }
        if (groupProcessors.length > 0) {
            this.postProcessGroups(processedData);
        }
        if (aggregates.length > 0) {
            this.aggregateData(processedData);
        }
        if (propertyProcessors.length > 0) {
            this.postProcessProperties(processedData);
        }
        if (reducers.length > 0) {
            this.reduceData(processedData);
        }
        if (processors.length > 0) {
            this.postProcessData(processedData);
        }
        try {
            for (
                var _g = __values$H(__spreadArray$D(__spreadArray$D([], __read$13(this.keys)), __read$13(this.values))),
                    _h = _g.next();
                !_h.done;
                _h = _g.next()
            ) {
                var def = _h.value;
                if (data.length > 0 && def.missing >= data.length) {
                    Logger.warnOnce("the key '" + def.property + "' was not found in any data element.");
                }
            }
        } catch (e_10_1) {
            e_10 = { error: e_10_1 };
        } finally {
            try {
                if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
            } finally {
                if (e_10) throw e_10.error;
            }
        }
        var end = performance.now();
        processedData.time = end - start;
        if (DataModel.DEBUG()) {
            logProcessedData(processedData);
        }
        return processedData;
    };
    DataModel.prototype.valueGroupIdxLookup = function (_a) {
        var matchGroupIds = _a.matchGroupIds,
            matchIds = _a.matchIds,
            matchScopes = _a.matchScopes;
        return this.values
            .map(function (def, index) {
                return { def: def, index: index };
            })
            .filter(function (_a) {
                var def = _a.def;
                if (matchGroupIds && (def.groupId == null || !matchGroupIds.includes(def.groupId))) {
                    return false;
                }
                if (matchIds && (def.id == null || !matchIds.includes(def.id))) {
                    return false;
                }
                if (
                    matchScopes &&
                    (def.scopes == null ||
                        !matchScopes.some(function (s) {
                            var _a;
                            return (_a = def.scopes) === null || _a === void 0 ? void 0 : _a.includes(s);
                        }))
                ) {
                    return false;
                }
                return true;
            })
            .map(function (_a) {
                var index = _a.index;
                return index;
            });
    };
    DataModel.prototype.valueIdxLookup = function (scopes, prop) {
        var result;
        var noScopesToMatch = scopes == null || scopes.length === 0;
        var scopeMatch = function (compareTo) {
            var anyScope = compareTo == null;
            if (anyScope) return true;
            var noScopes = compareTo == null || compareTo.length === 0;
            if (noScopesToMatch === noScopes) return true;
            return compareTo === null || compareTo === void 0
                ? void 0
                : compareTo.some(function (s) {
                      return scopes.includes(s);
                  });
        };
        if (typeof prop === 'string') {
            result = this.values.findIndex(function (def) {
                return scopeMatch(def.scopes) && def.property === prop;
            });
        } else {
            result = this.values.findIndex(function (def) {
                return scopeMatch(def.scopes) && def.id === prop.id;
            });
        }
        if (result >= 0) {
            return result;
        }
        throw new Error(
            'AG Charts - configuration error, unknown property ' +
                JSON.stringify(prop) +
                ' in scope(s) ' +
                JSON.stringify(scopes),
        );
    };
    DataModel.prototype.extractData = function (data) {
        var e_11, _a, e_12, _b, e_13, _c, e_14, _d;
        var _e;
        var _f = this,
            keyDefs = _f.keys,
            valueDefs = _f.values,
            dataVisible = _f.opts.dataVisible;
        var _g = this.initDataDomainProcessor(),
            dataDomain = _g.dataDomain,
            processValue = _g.processValue,
            scopes = _g.scopes,
            allScopesHaveSameDefs = _g.allScopesHaveSameDefs;
        var resultData = new Array(dataVisible ? data.length : 0);
        var resultDataIdx = 0;
        var partialValidDataCount = 0;
        try {
            for (var data_1 = __values$H(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var datum = data_1_1.value;
                var validScopes = scopes.size > 0 ? new Set(scopes) : undefined;
                var keys = dataVisible ? new Array(keyDefs.length) : undefined;
                var keyIdx = 0;
                var key = void 0;
                try {
                    for (
                        var keyDefs_1 = ((e_12 = void 0), __values$H(keyDefs)), keyDefs_1_1 = keyDefs_1.next();
                        !keyDefs_1_1.done;
                        keyDefs_1_1 = keyDefs_1.next()
                    ) {
                        var def = keyDefs_1_1.value;
                        key = processValue(def, datum, key);
                        if (key === INVALID_VALUE) break;
                        if (keys) {
                            keys[keyIdx++] = key;
                        }
                    }
                } catch (e_12_1) {
                    e_12 = { error: e_12_1 };
                } finally {
                    try {
                        if (keyDefs_1_1 && !keyDefs_1_1.done && (_b = keyDefs_1.return)) _b.call(keyDefs_1);
                    } finally {
                        if (e_12) throw e_12.error;
                    }
                }
                if (key === INVALID_VALUE) continue;
                var values = dataVisible && valueDefs.length > 0 ? new Array(valueDefs.length) : undefined;
                var valueIdx = 0;
                var value = void 0;
                try {
                    for (
                        var valueDefs_1 = ((e_13 = void 0), __values$H(valueDefs)), valueDefs_1_1 = valueDefs_1.next();
                        !valueDefs_1_1.done;
                        valueDefs_1_1 = valueDefs_1.next()
                    ) {
                        var def = valueDefs_1_1.value;
                        value = processValue(def, datum, value);
                        if (value === INVALID_VALUE) {
                            if (allScopesHaveSameDefs) break;
                            try {
                                for (
                                    var _h =
                                            ((e_14 = void 0),
                                            __values$H((_e = def.scopes) !== null && _e !== void 0 ? _e : scopes)),
                                        _j = _h.next();
                                    !_j.done;
                                    _j = _h.next()
                                ) {
                                    var scope = _j.value;
                                    validScopes === null || validScopes === void 0 ? void 0 : validScopes.delete(scope);
                                }
                            } catch (e_14_1) {
                                e_14 = { error: e_14_1 };
                            } finally {
                                try {
                                    if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                                } finally {
                                    if (e_14) throw e_14.error;
                                }
                            }
                            valueIdx++;
                            if ((validScopes === null || validScopes === void 0 ? void 0 : validScopes.size) === 0)
                                break;
                        } else if (values) {
                            values[valueIdx++] = value;
                        }
                    }
                } catch (e_13_1) {
                    e_13 = { error: e_13_1 };
                } finally {
                    try {
                        if (valueDefs_1_1 && !valueDefs_1_1.done && (_c = valueDefs_1.return)) _c.call(valueDefs_1);
                    } finally {
                        if (e_13) throw e_13.error;
                    }
                }
                if (value === INVALID_VALUE && allScopesHaveSameDefs) continue;
                if ((validScopes === null || validScopes === void 0 ? void 0 : validScopes.size) === 0) continue;
                if (dataVisible) {
                    var result = {
                        datum: datum,
                        keys: keys,
                        values: values,
                    };
                    if (!allScopesHaveSameDefs && validScopes && validScopes.size < scopes.size) {
                        partialValidDataCount++;
                        result.validScopes = __spreadArray$D([], __read$13(validScopes));
                    }
                    resultData[resultDataIdx++] = result;
                }
            }
        } catch (e_11_1) {
            e_11 = { error: e_11_1 };
        } finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally {
                if (e_11) throw e_11.error;
            }
        }
        resultData.length = resultDataIdx;
        var propertyDomain = function (def) {
            var result = dataDomain.get(def).getDomain();
            if (Array.isArray(result) && result[0] > result[1]) {
                // Ignore starting values.
                return [];
            }
            return __spreadArray$D([], __read$13(result));
        };
        return {
            type: 'ungrouped',
            data: resultData,
            domain: {
                keys: keyDefs.map(function (def) {
                    return propertyDomain(def);
                }),
                values: valueDefs.map(function (def) {
                    return propertyDomain(def);
                }),
            },
            defs: {
                allScopesHaveSameDefs: allScopesHaveSameDefs,
                keys: keyDefs,
                values: valueDefs,
            },
            partialValidDataCount: partialValidDataCount,
            time: 0,
        };
    };
    DataModel.prototype.groupData = function (data, groupingFn) {
        var e_15, _a, e_16, _b;
        var _c, _d, _e, _f;
        var processedData = new Map();
        try {
            for (var _g = __values$H(data.data), _h = _g.next(); !_h.done; _h = _g.next()) {
                var dataEntry = _h.value;
                var keys = dataEntry.keys,
                    values = dataEntry.values,
                    datum = dataEntry.datum,
                    validScopes = dataEntry.validScopes;
                var group = groupingFn ? groupingFn(dataEntry) : keys;
                var groupStr = toKeyString(group);
                if (processedData.has(groupStr)) {
                    var existingData = processedData.get(groupStr);
                    existingData.values.push(values);
                    existingData.datum.push(datum);
                    if (validScopes != null) {
                        var _loop_4 = function (index) {
                            var scope = (_e = existingData.validScopes) === null || _e === void 0 ? void 0 : _e[index];
                            if (
                                validScopes.some(function (s) {
                                    return s === scope;
                                })
                            )
                                return 'continue';
                            (_f = existingData.validScopes) === null || _f === void 0 ? void 0 : _f.splice(index, 1);
                        };
                        // Intersection of existing validScopes with new validScopes.
                        for (
                            var index = 0;
                            index <
                            ((_d = (_c = existingData.validScopes) === null || _c === void 0 ? void 0 : _c.length) !==
                                null && _d !== void 0
                                ? _d
                                : 0);
                            index++
                        ) {
                            _loop_4(index);
                        }
                    }
                } else {
                    processedData.set(groupStr, {
                        keys: group,
                        values: [values],
                        datum: [datum],
                        validScopes: validScopes,
                    });
                }
            }
        } catch (e_15_1) {
            e_15 = { error: e_15_1 };
        } finally {
            try {
                if (_h && !_h.done && (_a = _g.return)) _a.call(_g);
            } finally {
                if (e_15) throw e_15.error;
            }
        }
        var resultData = new Array(processedData.size);
        var resultGroups = new Array(processedData.size);
        var dataIndex = 0;
        try {
            for (var _j = __values$H(processedData.entries()), _k = _j.next(); !_k.done; _k = _j.next()) {
                var _l = __read$13(_k.value, 2),
                    _m = _l[1],
                    keys = _m.keys,
                    values = _m.values,
                    datum = _m.datum,
                    validScopes = _m.validScopes;
                if ((validScopes === null || validScopes === void 0 ? void 0 : validScopes.length) === 0) continue;
                resultGroups[dataIndex] = keys;
                resultData[dataIndex++] = {
                    keys: keys,
                    values: values,
                    datum: datum,
                    validScopes: validScopes,
                };
            }
        } catch (e_16_1) {
            e_16 = { error: e_16_1 };
        } finally {
            try {
                if (_k && !_k.done && (_b = _j.return)) _b.call(_j);
            } finally {
                if (e_16) throw e_16.error;
            }
        }
        return __assign$T(__assign$T({}, data), {
            type: 'grouped',
            data: resultData,
            domain: __assign$T(__assign$T({}, data.domain), { groups: resultGroups }),
        });
    };
    DataModel.prototype.aggregateData = function (processedData) {
        var e_17, _a;
        var _this = this;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        var aggDefs = this.aggregates;
        if (!aggDefs) return;
        var resultAggValues = aggDefs.map(function () {
            return [Infinity, -Infinity];
        });
        var resultAggValueIndices = aggDefs.map(function (def) {
            return _this.valueGroupIdxLookup(def);
        });
        var resultAggFns = aggDefs.map(function (def) {
            return def.aggregateFunction;
        });
        var resultGroupAggFns = aggDefs.map(function (def) {
            return def.groupAggregateFunction;
        });
        var resultFinalFns = aggDefs.map(function (def) {
            return def.finalFunction;
        });
        var _loop_5 = function (group) {
            var e_18, _m, e_19, _o;
            var values = group.values;
            var validScopes = group.validScopes;
            (_b = group.aggValues) !== null && _b !== void 0
                ? _b
                : (group.aggValues = new Array(resultAggValueIndices.length));
            if (processedData.type === 'ungrouped') {
                values = [values];
            }
            var resultIdx = 0;
            try {
                for (
                    var resultAggValueIndices_1 = ((e_18 = void 0), __values$H(resultAggValueIndices)),
                        resultAggValueIndices_1_1 = resultAggValueIndices_1.next();
                    !resultAggValueIndices_1_1.done;
                    resultAggValueIndices_1_1 = resultAggValueIndices_1.next()
                ) {
                    var indices = resultAggValueIndices_1_1.value;
                    var scopeValid =
                        (_c =
                            validScopes === null || validScopes === void 0
                                ? void 0
                                : validScopes.some(function (s) {
                                      var _a;
                                      return (_a = aggDefs[resultIdx].matchScopes) === null || _a === void 0
                                          ? void 0
                                          : _a.some(function (as) {
                                                return s === as;
                                            });
                                  })) !== null && _c !== void 0
                            ? _c
                            : true;
                    if (!scopeValid) {
                        resultIdx++;
                        continue;
                    }
                    var groupAggValues =
                        (_e =
                            (_d = resultGroupAggFns[resultIdx]) === null || _d === void 0
                                ? void 0
                                : _d.call(resultGroupAggFns)) !== null && _e !== void 0
                            ? _e
                            : extendDomain([]);
                    var _loop_6 = function (distinctValues) {
                        var valuesToAgg = indices.map(function (valueIdx) {
                            return distinctValues[valueIdx];
                        });
                        var valuesAgg = resultAggFns[resultIdx](valuesToAgg, group.keys);
                        if (valuesAgg) {
                            groupAggValues =
                                (_g =
                                    (_f = resultGroupAggFns[resultIdx]) === null || _f === void 0
                                        ? void 0
                                        : _f.call(resultGroupAggFns, valuesAgg, groupAggValues)) !== null &&
                                _g !== void 0
                                    ? _g
                                    : extendDomain(valuesAgg, groupAggValues);
                        }
                    };
                    try {
                        for (
                            var values_1 = ((e_19 = void 0), __values$H(values)), values_1_1 = values_1.next();
                            !values_1_1.done;
                            values_1_1 = values_1.next()
                        ) {
                            var distinctValues = values_1_1.value;
                            _loop_6(distinctValues);
                        }
                    } catch (e_19_1) {
                        e_19 = { error: e_19_1 };
                    } finally {
                        try {
                            if (values_1_1 && !values_1_1.done && (_o = values_1.return)) _o.call(values_1);
                        } finally {
                            if (e_19) throw e_19.error;
                        }
                    }
                    var finalValues = (
                        (_j =
                            (_h = resultFinalFns[resultIdx]) === null || _h === void 0
                                ? void 0
                                : _h.call(resultFinalFns, groupAggValues)) !== null && _j !== void 0
                            ? _j
                            : groupAggValues
                    ).map(function (v) {
                        return round(v);
                    });
                    extendDomain(finalValues, resultAggValues[resultIdx]);
                    group.aggValues[resultIdx++] = finalValues;
                }
            } catch (e_18_1) {
                e_18 = { error: e_18_1 };
            } finally {
                try {
                    if (
                        resultAggValueIndices_1_1 &&
                        !resultAggValueIndices_1_1.done &&
                        (_m = resultAggValueIndices_1.return)
                    )
                        _m.call(resultAggValueIndices_1);
                } finally {
                    if (e_18) throw e_18.error;
                }
            }
        };
        try {
            for (var _k = __values$H(processedData.data), _l = _k.next(); !_l.done; _l = _k.next()) {
                var group = _l.value;
                _loop_5(group);
            }
        } catch (e_17_1) {
            e_17 = { error: e_17_1 };
        } finally {
            try {
                if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
            } finally {
                if (e_17) throw e_17.error;
            }
        }
        processedData.domain.aggValues = resultAggValues;
    };
    DataModel.prototype.postProcessGroups = function (processedData) {
        var e_20, _a, e_21, _b, e_22, _c, e_23, _d, e_24, _e, e_25, _f;
        var _g, _h, _j, _k, _l;
        var groupProcessors = this.groupProcessors;
        if (!groupProcessors) return;
        var affectedIndices = new Set();
        var updatedDomains = new Map();
        var groupProcessorIndices = new Map();
        var groupProcessorInitFns = new Map();
        try {
            for (
                var groupProcessors_1 = __values$H(groupProcessors), groupProcessors_1_1 = groupProcessors_1.next();
                !groupProcessors_1_1.done;
                groupProcessors_1_1 = groupProcessors_1.next()
            ) {
                var processor = groupProcessors_1_1.value;
                var indices = this.valueGroupIdxLookup(processor);
                groupProcessorIndices.set(processor, indices);
                groupProcessorInitFns.set(processor, processor.adjust());
                try {
                    for (
                        var indices_1 = ((e_21 = void 0), __values$H(indices)), indices_1_1 = indices_1.next();
                        !indices_1_1.done;
                        indices_1_1 = indices_1.next()
                    ) {
                        var idx = indices_1_1.value;
                        var valueDef = this.values[idx];
                        affectedIndices.add(idx);
                        updatedDomains.set(
                            idx,
                            new DataDomain(valueDef.valueType === 'category' ? 'discrete' : 'continuous'),
                        );
                    }
                } catch (e_21_1) {
                    e_21 = { error: e_21_1 };
                } finally {
                    try {
                        if (indices_1_1 && !indices_1_1.done && (_b = indices_1.return)) _b.call(indices_1);
                    } finally {
                        if (e_21) throw e_21.error;
                    }
                }
            }
        } catch (e_20_1) {
            e_20 = { error: e_20_1 };
        } finally {
            try {
                if (groupProcessors_1_1 && !groupProcessors_1_1.done && (_a = groupProcessors_1.return))
                    _a.call(groupProcessors_1);
            } finally {
                if (e_20) throw e_20.error;
            }
        }
        var updateDomains = function (values) {
            var e_26, _a;
            var _b;
            try {
                for (
                    var affectedIndices_1 = __values$H(affectedIndices), affectedIndices_1_1 = affectedIndices_1.next();
                    !affectedIndices_1_1.done;
                    affectedIndices_1_1 = affectedIndices_1.next()
                ) {
                    var valueIndex = affectedIndices_1_1.value;
                    (_b = updatedDomains.get(valueIndex)) === null || _b === void 0
                        ? void 0
                        : _b.extend(values[valueIndex]);
                }
            } catch (e_26_1) {
                e_26 = { error: e_26_1 };
            } finally {
                try {
                    if (affectedIndices_1_1 && !affectedIndices_1_1.done && (_a = affectedIndices_1.return))
                        _a.call(affectedIndices_1);
                } finally {
                    if (e_26) throw e_26.error;
                }
            }
        };
        try {
            for (var _m = __values$H(processedData.data), _o = _m.next(); !_o.done; _o = _m.next()) {
                var group = _o.value;
                var _loop_7 = function (processor) {
                    var e_27, _s;
                    var scopeValid =
                        (_h =
                            (_g = group.validScopes) === null || _g === void 0
                                ? void 0
                                : _g.some(function (s) {
                                      var _a;
                                      return (_a = processor.matchScopes) === null || _a === void 0
                                          ? void 0
                                          : _a.some(function (as) {
                                                return s === as;
                                            });
                                  })) !== null && _h !== void 0
                            ? _h
                            : true;
                    if (!scopeValid) {
                        return 'continue';
                    }
                    var valueIndexes = (_j = groupProcessorIndices.get(processor)) !== null && _j !== void 0 ? _j : [];
                    var adjustFn =
                        (_l = (_k = groupProcessorInitFns.get(processor)) === null || _k === void 0 ? void 0 : _k()) !==
                            null && _l !== void 0
                            ? _l
                            : function () {
                                  return undefined;
                              };
                    if (processedData.type === 'grouped') {
                        try {
                            for (
                                var _t = ((e_27 = void 0), __values$H(group.values)), _u = _t.next();
                                !_u.done;
                                _u = _t.next()
                            ) {
                                var values = _u.value;
                                if (values) {
                                    adjustFn(values, valueIndexes);
                                }
                            }
                        } catch (e_27_1) {
                            e_27 = { error: e_27_1 };
                        } finally {
                            try {
                                if (_u && !_u.done && (_s = _t.return)) _s.call(_t);
                            } finally {
                                if (e_27) throw e_27.error;
                            }
                        }
                        return 'continue';
                    }
                    if (group.values) {
                        adjustFn(group.values, valueIndexes);
                    }
                };
                try {
                    for (
                        var groupProcessors_2 = ((e_23 = void 0), __values$H(groupProcessors)),
                            groupProcessors_2_1 = groupProcessors_2.next();
                        !groupProcessors_2_1.done;
                        groupProcessors_2_1 = groupProcessors_2.next()
                    ) {
                        var processor = groupProcessors_2_1.value;
                        _loop_7(processor);
                    }
                } catch (e_23_1) {
                    e_23 = { error: e_23_1 };
                } finally {
                    try {
                        if (groupProcessors_2_1 && !groupProcessors_2_1.done && (_d = groupProcessors_2.return))
                            _d.call(groupProcessors_2);
                    } finally {
                        if (e_23) throw e_23.error;
                    }
                }
                if (processedData.type === 'grouped') {
                    try {
                        for (
                            var _p = ((e_24 = void 0), __values$H(group.values)), _q = _p.next();
                            !_q.done;
                            _q = _p.next()
                        ) {
                            var values = _q.value;
                            updateDomains(values);
                        }
                    } catch (e_24_1) {
                        e_24 = { error: e_24_1 };
                    } finally {
                        try {
                            if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                        } finally {
                            if (e_24) throw e_24.error;
                        }
                    }
                } else {
                    updateDomains(group.values);
                }
            }
        } catch (e_22_1) {
            e_22 = { error: e_22_1 };
        } finally {
            try {
                if (_o && !_o.done && (_c = _m.return)) _c.call(_m);
            } finally {
                if (e_22) throw e_22.error;
            }
        }
        try {
            for (
                var updatedDomains_1 = __values$H(updatedDomains), updatedDomains_1_1 = updatedDomains_1.next();
                !updatedDomains_1_1.done;
                updatedDomains_1_1 = updatedDomains_1.next()
            ) {
                var _r = __read$13(updatedDomains_1_1.value, 2),
                    idx = _r[0],
                    dataDomain = _r[1];
                processedData.domain.values[idx] = __spreadArray$D([], __read$13(dataDomain.getDomain()));
            }
        } catch (e_25_1) {
            e_25 = { error: e_25_1 };
        } finally {
            try {
                if (updatedDomains_1_1 && !updatedDomains_1_1.done && (_f = updatedDomains_1.return))
                    _f.call(updatedDomains_1);
            } finally {
                if (e_25) throw e_25.error;
            }
        }
    };
    DataModel.prototype.postProcessProperties = function (processedData) {
        var e_28, _a;
        var propertyProcessors = this.propertyProcessors;
        if (!propertyProcessors) return;
        try {
            for (
                var propertyProcessors_1 = __values$H(propertyProcessors),
                    propertyProcessors_1_1 = propertyProcessors_1.next();
                !propertyProcessors_1_1.done;
                propertyProcessors_1_1 = propertyProcessors_1.next()
            ) {
                var _b = propertyProcessors_1_1.value,
                    adjust = _b.adjust,
                    property = _b.property,
                    scopes = _b.scopes;
                adjust()(
                    processedData,
                    this.valueIdxLookup(scopes !== null && scopes !== void 0 ? scopes : [], property),
                );
            }
        } catch (e_28_1) {
            e_28 = { error: e_28_1 };
        } finally {
            try {
                if (propertyProcessors_1_1 && !propertyProcessors_1_1.done && (_a = propertyProcessors_1.return))
                    _a.call(propertyProcessors_1);
            } finally {
                if (e_28) throw e_28.error;
            }
        }
    };
    DataModel.prototype.reduceData = function (processedData) {
        var e_29, _a;
        var _b, _c, _d;
        var reducerDefs = this.reducers;
        var scopes = reducerDefs.map(function (def) {
            return def.scopes;
        });
        var reducers = reducerDefs.map(function (def) {
            return def.reducer();
        });
        var accValues = reducerDefs.map(function (def) {
            return def.initialValue;
        });
        var _loop_8 = function (group) {
            var e_30, _g;
            var reducerIndex = 0;
            try {
                for (
                    var reducers_1 = ((e_30 = void 0), __values$H(reducers)), reducers_1_1 = reducers_1.next();
                    !reducers_1_1.done;
                    reducers_1_1 = reducers_1.next()
                ) {
                    var reducer = reducers_1_1.value;
                    var scopeValid =
                        (_c =
                            (_b = group.validScopes) === null || _b === void 0
                                ? void 0
                                : _b.some(function (s) {
                                      var _a;
                                      return (_a = scopes[reducerIndex]) === null || _a === void 0
                                          ? void 0
                                          : _a.some(function (as) {
                                                return s === as;
                                            });
                                  })) !== null && _c !== void 0
                            ? _c
                            : true;
                    if (!scopeValid) {
                        reducerIndex++;
                        continue;
                    }
                    accValues[reducerIndex] = reducer(accValues[reducerIndex], group);
                    reducerIndex++;
                }
            } catch (e_30_1) {
                e_30 = { error: e_30_1 };
            } finally {
                try {
                    if (reducers_1_1 && !reducers_1_1.done && (_g = reducers_1.return)) _g.call(reducers_1);
                } finally {
                    if (e_30) throw e_30.error;
                }
            }
        };
        try {
            for (var _e = __values$H(processedData.data), _f = _e.next(); !_f.done; _f = _e.next()) {
                var group = _f.value;
                _loop_8(group);
            }
        } catch (e_29_1) {
            e_29 = { error: e_29_1 };
        } finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            } finally {
                if (e_29) throw e_29.error;
            }
        }
        for (var accIdx = 0; accIdx < accValues.length; accIdx++) {
            (_d = processedData.reduced) !== null && _d !== void 0 ? _d : (processedData.reduced = {});
            processedData.reduced[reducerDefs[accIdx].property] = accValues[accIdx];
        }
    };
    DataModel.prototype.postProcessData = function (processedData) {
        var e_31, _a;
        var _b;
        var processorDefs = this.processors;
        try {
            for (
                var processorDefs_1 = __values$H(processorDefs), processorDefs_1_1 = processorDefs_1.next();
                !processorDefs_1_1.done;
                processorDefs_1_1 = processorDefs_1.next()
            ) {
                var def = processorDefs_1_1.value;
                (_b = processedData.reduced) !== null && _b !== void 0 ? _b : (processedData.reduced = {});
                processedData.reduced[def.property] = def.calculate(processedData);
            }
        } catch (e_31_1) {
            e_31 = { error: e_31_1 };
        } finally {
            try {
                if (processorDefs_1_1 && !processorDefs_1_1.done && (_a = processorDefs_1.return))
                    _a.call(processorDefs_1);
            } finally {
                if (e_31) throw e_31.error;
            }
        }
    };
    DataModel.prototype.initDataDomainProcessor = function () {
        var e_32, _a, e_33, _b;
        var _c;
        var _d = this,
            keyDefs = _d.keys,
            valueDefs = _d.values;
        var scopes = new Set();
        try {
            for (
                var valueDefs_2 = __values$H(valueDefs), valueDefs_2_1 = valueDefs_2.next();
                !valueDefs_2_1.done;
                valueDefs_2_1 = valueDefs_2.next()
            ) {
                var valueDef = valueDefs_2_1.value;
                try {
                    for (
                        var _e =
                                ((e_33 = void 0),
                                __values$H((_c = valueDef.scopes) !== null && _c !== void 0 ? _c : [])),
                            _f = _e.next();
                        !_f.done;
                        _f = _e.next()
                    ) {
                        var scope = _f.value;
                        scopes.add(scope);
                    }
                } catch (e_33_1) {
                    e_33 = { error: e_33_1 };
                } finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally {
                        if (e_33) throw e_33.error;
                    }
                }
            }
        } catch (e_32_1) {
            e_32 = { error: e_32_1 };
        } finally {
            try {
                if (valueDefs_2_1 && !valueDefs_2_1.done && (_a = valueDefs_2.return)) _a.call(valueDefs_2);
            } finally {
                if (e_32) throw e_32.error;
            }
        }
        var scopesCount = scopes.size;
        var dataDomain = new Map();
        var processorFns = new Map();
        var allScopesHaveSameDefs = true;
        var initDataDomainKey = function (key, type, updateDataDomain) {
            var _a;
            if (updateDataDomain === void 0) {
                updateDataDomain = dataDomain;
            }
            if (type === 'category') {
                updateDataDomain.set(key, new DataDomain('discrete'));
            } else {
                updateDataDomain.set(key, new DataDomain('continuous'));
                allScopesHaveSameDefs &&
                    (allScopesHaveSameDefs =
                        ((_a = key.scopes) !== null && _a !== void 0 ? _a : []).length === scopesCount);
            }
        };
        var initDataDomain = function () {
            keyDefs.forEach(function (def) {
                return initDataDomainKey(def, def.valueType);
            });
            valueDefs.forEach(function (def) {
                return initDataDomainKey(def, def.valueType);
            });
        };
        initDataDomain();
        var accessors = this.buildAccessors.apply(
            this,
            __spreadArray$D(__spreadArray$D([], __read$13(keyDefs)), __read$13(valueDefs)),
        );
        var processValue = function (def, datum, previousDatum) {
            var _a, _b, _c, _d;
            var hasAccessor = def.property in accessors;
            var valueInDatum = false;
            var value;
            if (hasAccessor) {
                try {
                    value = accessors[def.property](datum);
                } catch (error) {
                    // Swallow errors - these get reported as missing values to the user later.
                }
                valueInDatum = value !== undefined;
            } else {
                valueInDatum = def.property in datum;
                value = valueInDatum ? datum[def.property] : def.missingValue;
            }
            var missingValueDef = 'missingValue' in def;
            if (!valueInDatum && !missingValueDef) {
                def.missing++;
            }
            if (!dataDomain.has(def)) {
                initDataDomain();
            }
            if (valueInDatum) {
                var valid =
                    (_b = (_a = def.validation) === null || _a === void 0 ? void 0 : _a.call(def, value, datum)) !==
                        null && _b !== void 0
                        ? _b
                        : true;
                if (!valid) {
                    if ('invalidValue' in def) {
                        value = def.invalidValue;
                    } else {
                        return INVALID_VALUE;
                    }
                }
            }
            if (def.processor) {
                if (!processorFns.has(def)) {
                    processorFns.set(def, def.processor());
                }
                value =
                    (_c = processorFns.get(def)) === null || _c === void 0
                        ? void 0
                        : _c(value, previousDatum !== INVALID_VALUE ? previousDatum : undefined);
            }
            (_d = dataDomain.get(def)) === null || _d === void 0 ? void 0 : _d.extend(value);
            return value;
        };
        return {
            dataDomain: dataDomain,
            processValue: processValue,
            initDataDomain: initDataDomain,
            scopes: scopes,
            allScopesHaveSameDefs: allScopesHaveSameDefs,
        };
    };
    DataModel.prototype.buildAccessors = function () {
        var e_34, _a;
        var defs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            defs[_i] = arguments[_i];
        }
        var result = {};
        try {
            for (var defs_1 = __values$H(defs), defs_1_1 = defs_1.next(); !defs_1_1.done; defs_1_1 = defs_1.next()) {
                var def = defs_1_1.value;
                var isPath = def.property.indexOf('.') >= 0 || def.property.indexOf('[') >= 0;
                if (!isPath) continue;
                var fnBody = void 0;
                if (def.property.startsWith('[')) {
                    fnBody = 'return datum' + def.property + ';';
                } else {
                    fnBody = 'return datum.' + def.property + ';';
                }
                result[def.property] = new Function('datum', fnBody);
            }
        } catch (e_34_1) {
            e_34 = { error: e_34_1 };
        } finally {
            try {
                if (defs_1_1 && !defs_1_1.done && (_a = defs_1.return)) _a.call(defs_1);
            } finally {
                if (e_34) throw e_34.error;
            }
        }
        return result;
    };
    DataModel.DEBUG = function () {
        var _a;
        return (_a = [true, 'data-model'].includes(windowValue('agChartsDebug'))) !== null && _a !== void 0
            ? _a
            : false;
    };
    return DataModel;
})();
function logProcessedData(processedData) {
    var _a, _b;
    var log = function (name, data) {
        if (data.length > 0) {
            // eslint-disable-next-line no-console
            console.log('DataModel.processData() - ' + name);
            // eslint-disable-next-line no-console
            console.table(data);
        }
    };
    // eslint-disable-next-line no-console
    console.log('DataModel.processData() - processedData', processedData);
    log('Key Domains', processedData.domain.keys);
    log('Group Domains', (_a = processedData.domain.groups) !== null && _a !== void 0 ? _a : []);
    log('Value Domains', processedData.domain.values);
    log('Aggregate Domains', (_b = processedData.domain.aggValues) !== null && _b !== void 0 ? _b : []);
    if (processedData.type === 'grouped') {
        var flattenedValues = processedData.data.reduce(function (acc, next) {
            var _a, _b;
            var keys = (_a = next.keys) !== null && _a !== void 0 ? _a : [];
            var aggValues = (_b = next.aggValues) !== null && _b !== void 0 ? _b : [];
            var skipKeys = next.keys.map(function () {
                return undefined;
            });
            var skipAggValues =
                aggValues === null || aggValues === void 0
                    ? void 0
                    : aggValues.map(function () {
                          return undefined;
                      });
            acc.push.apply(
                acc,
                __spreadArray$D(
                    [],
                    __read$13(
                        next.values.map(function (v, i) {
                            return __spreadArray$D(
                                __spreadArray$D(
                                    __spreadArray$D([], __read$13(i === 0 ? keys : skipKeys)),
                                    __read$13(v !== null && v !== void 0 ? v : []),
                                ),
                                __read$13(i == 0 ? aggValues : skipAggValues),
                            );
                        }),
                    ),
                ),
            );
            return acc;
        }, []);
        log('Values', flattenedValues);
    } else {
        var flattenedValues = processedData.data.reduce(function (acc, next) {
            var _a;
            var aggValues = (_a = next.aggValues) !== null && _a !== void 0 ? _a : [];
            acc.push(
                __spreadArray$D(
                    __spreadArray$D(__spreadArray$D([], __read$13(next.keys)), __read$13(next.values)),
                    __read$13(aggValues),
                ),
            );
            return acc;
        }, []);
        log('Values', flattenedValues);
    }
}

function createDeprecationWarning() {
    return function (key, message) {
        var msg = ['Property [' + key + '] is deprecated.', message]
            .filter(function (v) {
                return v != null;
            })
            .join(' ');
        Logger.warnOnce(msg);
    };
}
function Deprecated(message, opts) {
    var def = opts === null || opts === void 0 ? void 0 : opts.default;
    var warn = createDeprecationWarning();
    return addTransformToInstanceProperty(function (_, key, value) {
        if (value !== def) {
            warn(key.toString(), message);
        }
        return value;
    });
}
function DeprecatedAndRenamedTo(newPropName, mapValue) {
    var warnDeprecated = createDeprecationWarning();
    return addTransformToInstanceProperty(
        function (target, key, value) {
            if (value !== target[newPropName]) {
                warnDeprecated(key.toString(), 'Use [' + newPropName + '] instead.');
                target[newPropName] = mapValue ? mapValue(value) : value;
            }
            return BREAK_TRANSFORM_CHAIN;
        },
        function (target, key) {
            warnDeprecated(key.toString(), 'Use [' + newPropName + '] instead.');
            return target[newPropName];
        },
    );
}

var __decorate$1V =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$G =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var DEFAULT_TOOLTIP_CLASS = 'ag-chart-tooltip';
var defaultTooltipCss$1 =
    '\n.' +
    DEFAULT_TOOLTIP_CLASS +
    ' {\n    transition: transform 0.1s ease;\n    display: table;\n    position: fixed;\n    left: 0px;\n    top: 0px;\n    white-space: nowrap;\n    z-index: 99999;\n    font: 12px Verdana, sans-serif;\n    color: black;\n    background: rgb(244, 244, 244);\n    border-radius: 5px;\n    box-shadow: 0 0 1px rgba(3, 3, 3, 0.7), 0.5vh 0.5vh 1vh rgba(3, 3, 3, 0.25);\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-no-interaction {\n    pointer-events: none;\n    user-select: none;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-no-animation {\n    transition: none !important;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-hidden {\n    visibility: hidden;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-title {\n    font-weight: bold;\n    padding: 7px;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n    color: white;\n    background-color: #888888;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-content {\n    padding: 7px;\n    line-height: 1.7em;\n    border-bottom-left-radius: 5px;\n    border-bottom-right-radius: 5px;\n    overflow: hidden;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-content:empty {\n    padding: 0;\n    height: 7px;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-arrow::before {\n    content: "";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 6px solid #989898;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: #989898;\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.' +
    DEFAULT_TOOLTIP_CLASS +
    '-arrow::after {\n    content: "";\n\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    transform: translateX(-50%);\n\n    border: 5px solid black;\n\n    border-left-color: transparent;\n    border-right-color: transparent;\n    border-top-color: rgb(244, 244, 244);\n    border-bottom-color: transparent;\n\n    width: 0;\n    height: 0;\n\n    margin: 0 auto;\n}\n\n.ag-chart-wrapper {\n    box-sizing: border-box;\n    overflow: hidden;\n}\n';
function toTooltipHtml$1(input, defaults) {
    var _a, _b, _c, _d;
    if (typeof input === 'string') {
        return input;
    }
    defaults = defaults !== null && defaults !== void 0 ? defaults : {};
    var _e = input.content,
        content = _e === void 0 ? ((_a = defaults.content) !== null && _a !== void 0 ? _a : '') : _e,
        _f = input.title,
        title = _f === void 0 ? ((_b = defaults.title) !== null && _b !== void 0 ? _b : undefined) : _f,
        _g = input.color,
        color = _g === void 0 ? ((_c = defaults.color) !== null && _c !== void 0 ? _c : 'white') : _g,
        _h = input.backgroundColor,
        backgroundColor =
            _h === void 0 ? ((_d = defaults.backgroundColor) !== null && _d !== void 0 ? _d : '#888') : _h;
    var titleHtml = title
        ? '<div class="' +
          DEFAULT_TOOLTIP_CLASS +
          '-title"\n        style="color: ' +
          color +
          '; background-color: ' +
          backgroundColor +
          '">' +
          title +
          '</div>'
        : '';
    return titleHtml + '<div class="' + DEFAULT_TOOLTIP_CLASS + '-content">' + content + '</div>';
}
var POSITION_TYPES = ['pointer', 'node'];
var POSITION_TYPE = predicateWithMessage(function (v) {
    return POSITION_TYPES.includes(v);
}, "expecting a position type keyword such as 'pointer' or 'node'");
var TooltipPosition = /** @class */ (function () {
    function TooltipPosition() {
        /** The type of positioning for the tooltip. By default, the tooltip follows the pointer. */
        this.type = 'pointer';
        /** The horizontal offset in pixels for the position of the tooltip. */
        this.xOffset = 0;
        /** The vertical offset in pixels for the position of the tooltip. */
        this.yOffset = 0;
    }
    __decorate$1V([Validate(POSITION_TYPE)], TooltipPosition.prototype, 'type', void 0);
    __decorate$1V([Validate(NUMBER())], TooltipPosition.prototype, 'xOffset', void 0);
    __decorate$1V([Validate(NUMBER())], TooltipPosition.prototype, 'yOffset', void 0);
    return TooltipPosition;
})();
var Tooltip = /** @class */ (function () {
    function Tooltip(canvasElement, document, container) {
        var _this = this;
        this.enableInteraction = false;
        this.enabled = true;
        this.showArrow = undefined;
        this.class = undefined;
        this.lastClass = undefined;
        this.delay = 0;
        this.range = 'nearest';
        this.position = new TooltipPosition();
        this.showTimeout = 0;
        this._showArrow = true;
        this.tooltipRoot = container;
        var element = document.createElement('div');
        this.element = this.tooltipRoot.appendChild(element);
        this.element.classList.add(DEFAULT_TOOLTIP_CLASS);
        this.canvasElement = canvasElement;
        // Detect when the chart becomes invisible and hide the tooltip as well.
        if (window.IntersectionObserver) {
            var observer = new IntersectionObserver(
                function (entries) {
                    var e_1, _a;
                    try {
                        for (
                            var entries_1 = __values$G(entries), entries_1_1 = entries_1.next();
                            !entries_1_1.done;
                            entries_1_1 = entries_1.next()
                        ) {
                            var entry = entries_1_1.value;
                            if (entry.target === _this.canvasElement && entry.intersectionRatio === 0) {
                                _this.toggle(false);
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = { error: e_1_1 };
                    } finally {
                        try {
                            if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                        } finally {
                            if (e_1) throw e_1.error;
                        }
                    }
                },
                { root: this.tooltipRoot },
            );
            observer.observe(this.canvasElement);
            this.observer = observer;
        }
        if (Tooltip.tooltipDocuments.indexOf(document) < 0) {
            var styleElement = document.createElement('style');
            styleElement.innerHTML = defaultTooltipCss$1;
            // Make sure the default tooltip style goes before other styles so it can be overridden.
            document.head.insertBefore(styleElement, document.head.querySelector('style'));
            Tooltip.tooltipDocuments.push(document);
        }
    }
    Tooltip.prototype.destroy = function () {
        var parentNode = this.element.parentNode;
        if (parentNode) {
            parentNode.removeChild(this.element);
        }
        if (this.observer) {
            this.observer.unobserve(this.canvasElement);
        }
    };
    Tooltip.prototype.isVisible = function () {
        var element = this.element;
        return !element.classList.contains(DEFAULT_TOOLTIP_CLASS + '-hidden');
    };
    Tooltip.prototype.updateClass = function (visible, showArrow) {
        var _a = this,
            element = _a.element,
            newClass = _a.class,
            lastClass = _a.lastClass,
            enableInteraction = _a.enableInteraction;
        var wasVisible = this.isVisible();
        var toggleClass = function (name, include) {
            var className = DEFAULT_TOOLTIP_CLASS + '-' + name;
            if (include) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        };
        toggleClass('no-animation', !wasVisible && !!visible); // No animation on first show.
        toggleClass('no-interaction', !enableInteraction); // Prevent interaction.
        toggleClass('hidden', !visible); // Hide if not visible.
        toggleClass('arrow', !!showArrow); // Add arrow if tooltip is constrained.
        if (newClass !== lastClass) {
            if (lastClass) {
                element.classList.remove(lastClass);
            }
            if (newClass) {
                element.classList.add(newClass);
            }
            this.lastClass = newClass;
        }
    };
    /**
     * Shows tooltip at the given event's coordinates.
     * If the `html` parameter is missing, moves the existing tooltip to the new position.
     */
    Tooltip.prototype.show = function (meta, html, instantly) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        if (instantly === void 0) {
            instantly = false;
        }
        var _h = this,
            element = _h.element,
            canvasElement = _h.canvasElement;
        if (html !== undefined) {
            element.innerHTML = html;
        } else if (!element.innerHTML) {
            this.toggle(false);
            return;
        }
        var limit = function (low, actual, high) {
            return Math.max(Math.min(actual, high), low);
        };
        var xOffset =
            (_b = (_a = meta.position) === null || _a === void 0 ? void 0 : _a.xOffset) !== null && _b !== void 0
                ? _b
                : 0;
        var yOffset =
            (_d = (_c = meta.position) === null || _c === void 0 ? void 0 : _c.yOffset) !== null && _d !== void 0
                ? _d
                : 0;
        var canvasRect = canvasElement.getBoundingClientRect();
        var naiveLeft = canvasRect.left + meta.offsetX - element.clientWidth / 2 + xOffset;
        var naiveTop = canvasRect.top + meta.offsetY - element.clientHeight - 8 + yOffset;
        var windowBounds = this.getWindowBoundingBox();
        var maxLeft = windowBounds.x + windowBounds.width - element.clientWidth - 1;
        var maxTop = windowBounds.y + windowBounds.height - element.clientHeight;
        var left = limit(windowBounds.x, naiveLeft, maxLeft);
        var top = limit(windowBounds.y, naiveTop, maxTop);
        var constrained = left !== naiveLeft || top !== naiveTop;
        var defaultShowArrow = !constrained && !xOffset && !yOffset;
        var showArrow =
            (_f = (_e = meta.showArrow) !== null && _e !== void 0 ? _e : this.showArrow) !== null && _f !== void 0
                ? _f
                : defaultShowArrow;
        this.updateShowArrow(showArrow);
        element.style.transform = 'translate(' + Math.round(left) + 'px, ' + Math.round(top) + 'px)';
        this.enableInteraction = (_g = meta.enableInteraction) !== null && _g !== void 0 ? _g : false;
        if (this.delay > 0 && !instantly) {
            this.toggle(false);
            this.showTimeout = window.setTimeout(function () {
                _this.toggle(true);
            }, this.delay);
            return;
        }
        this.toggle(true);
    };
    Tooltip.prototype.getWindowBoundingBox = function () {
        return new BBox(0, 0, window.innerWidth, window.innerHeight);
    };
    Tooltip.prototype.toggle = function (visible) {
        if (!visible) {
            window.clearTimeout(this.showTimeout);
        }
        this.updateClass(visible, this._showArrow);
    };
    Tooltip.prototype.pointerLeftOntoTooltip = function (event) {
        var _a;
        if (!this.enableInteraction) return false;
        var classList = (_a = event.sourceEvent.relatedTarget) === null || _a === void 0 ? void 0 : _a.classList;
        var classes = ['', '-title', '-content'];
        var classListContains = Boolean(
            classes.filter(function (c) {
                return classList === null || classList === void 0
                    ? void 0
                    : classList.contains('' + DEFAULT_TOOLTIP_CLASS + c);
            }),
        );
        return classList !== undefined && classListContains;
    };
    Tooltip.prototype.updateShowArrow = function (show) {
        this._showArrow = show;
    };
    Tooltip.tooltipDocuments = [];
    __decorate$1V([Validate(BOOLEAN)], Tooltip.prototype, 'enabled', void 0);
    __decorate$1V([Validate(OPT_BOOLEAN)], Tooltip.prototype, 'showArrow', void 0);
    __decorate$1V([Validate(OPT_STRING)], Tooltip.prototype, 'class', void 0);
    __decorate$1V([Validate(NUMBER(0))], Tooltip.prototype, 'delay', void 0);
    __decorate$1V(
        [
            DeprecatedAndRenamedTo('range', function (value) {
                return value ? 'nearest' : 'exact';
            }),
        ],
        Tooltip.prototype,
        'tracking',
        void 0,
    );
    __decorate$1V([Validate(INTERACTION_RANGE)], Tooltip.prototype, 'range', void 0);
    return Tooltip;
})();

var __values$F =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function sumValues(values, accumulator) {
    var e_1, _a;
    if (accumulator === void 0) {
        accumulator = [0, 0];
    }
    try {
        for (
            var values_1 = __values$F(values), values_1_1 = values_1.next();
            !values_1_1.done;
            values_1_1 = values_1.next()
        ) {
            var value = values_1_1.value;
            if (typeof value !== 'number') {
                continue;
            }
            if (value < 0) {
                accumulator[0] += value;
            }
            if (value > 0) {
                accumulator[1] += value;
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return accumulator;
}
function groupSum(scope, id, matchGroupId) {
    return {
        id: id,
        scopes: [scope.id],
        type: 'aggregate',
        matchGroupIds: matchGroupId ? [matchGroupId] : undefined,
        aggregateFunction: function (values) {
            return sumValues(values);
        },
        groupAggregateFunction: function (next, acc) {
            var _a, _b;
            if (acc === void 0) {
                acc = [0, 0];
            }
            acc[0] += (_a = next === null || next === void 0 ? void 0 : next[0]) !== null && _a !== void 0 ? _a : 0;
            acc[1] += (_b = next === null || next === void 0 ? void 0 : next[1]) !== null && _b !== void 0 ? _b : 0;
            return acc;
        },
    };
}
function groupCount(scope, id) {
    return {
        id: id,
        scopes: [scope.id],
        type: 'aggregate',
        aggregateFunction: function () {
            return [0, 1];
        },
        groupAggregateFunction: function (next, acc) {
            var _a, _b;
            if (acc === void 0) {
                acc = [0, 0];
            }
            acc[0] += (_a = next === null || next === void 0 ? void 0 : next[0]) !== null && _a !== void 0 ? _a : 0;
            acc[1] += (_b = next === null || next === void 0 ? void 0 : next[1]) !== null && _b !== void 0 ? _b : 0;
            return acc;
        },
    };
}
function groupAverage(scope, id, matchGroupId) {
    var result = {
        id: id,
        scopes: [scope.id],
        matchGroupIds: matchGroupId ? [matchGroupId] : undefined,
        type: 'aggregate',
        aggregateFunction: function (values) {
            return sumValues(values);
        },
        groupAggregateFunction: function (next, acc) {
            var _a, _b;
            if (acc === void 0) {
                acc = [0, 0, -1];
            }
            acc[0] += (_a = next === null || next === void 0 ? void 0 : next[0]) !== null && _a !== void 0 ? _a : 0;
            acc[1] += (_b = next === null || next === void 0 ? void 0 : next[1]) !== null && _b !== void 0 ? _b : 0;
            acc[2]++;
            return acc;
        },
        finalFunction: function (acc) {
            if (acc === void 0) {
                acc = [0, 0, 0];
            }
            var result = acc[0] + acc[1];
            if (result >= 0) {
                return [0, result / acc[2]];
            }
            return [result / acc[2], 0];
        },
    };
    return result;
}
function area(scope, id, aggFn, matchGroupId) {
    var result = {
        id: id,
        scopes: [scope.id],
        matchGroupIds: matchGroupId ? [matchGroupId] : undefined,
        type: 'aggregate',
        aggregateFunction: function (values, keyRange) {
            if (keyRange === void 0) {
                keyRange = [];
            }
            var keyWidth = keyRange[1] - keyRange[0];
            return aggFn.aggregateFunction(values).map(function (v) {
                return v / keyWidth;
            });
        },
    };
    if (aggFn.groupAggregateFunction) {
        result.groupAggregateFunction = aggFn.groupAggregateFunction;
    }
    return result;
}
function accumulatedValue() {
    return function () {
        var value = 0;
        return function (datum) {
            if (typeof datum !== 'number') return datum;
            if (isNaN(datum)) return datum;
            value += datum;
            return value;
        };
    };
}

var memorizedFns = new Map();
function memo(params, fnGenerator) {
    var _a, _b, _c;
    var serialisedParams = JSON.stringify(params, null, 0);
    if (!memorizedFns.has(fnGenerator)) {
        memorizedFns.set(fnGenerator, new Map());
    }
    if (!((_a = memorizedFns.get(fnGenerator)) === null || _a === void 0 ? void 0 : _a.has(serialisedParams))) {
        (_b = memorizedFns.get(fnGenerator)) === null || _b === void 0
            ? void 0
            : _b.set(serialisedParams, fnGenerator(params));
    }
    return (_c = memorizedFns.get(fnGenerator)) === null || _c === void 0 ? void 0 : _c.get(serialisedParams);
}

var __read$12 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$C =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$E =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var SMALLEST_KEY_INTERVAL = {
    type: 'reducer',
    property: 'smallestKeyInterval',
    initialValue: Infinity,
    reducer: function () {
        var prevX = NaN;
        return function (smallestSoFar, next) {
            var nextX = next.keys[0];
            var interval = Math.abs(nextX - prevX);
            prevX = nextX;
            if (!isNaN(interval) && interval > 0 && interval < smallestSoFar) {
                return interval;
            }
            return smallestSoFar;
        };
    },
};
var SORT_DOMAIN_GROUPS = {
    type: 'processor',
    property: 'sortedGroupDomain',
    calculate: function (_a) {
        var groups = _a.domain.groups;
        if (groups == null) return undefined;
        return __spreadArray$C([], __read$12(groups)).sort(function (a, b) {
            for (var i = 0; i < a.length; i++) {
                var result = a[i] - b[i];
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        });
    },
};
function normaliseFnBuilder(_a) {
    var normaliseTo = _a.normaliseTo,
        mode = _a.mode;
    var normalise = function (val, extent) {
        var result = (val * normaliseTo) / extent;
        if (result >= 0) {
            return Math.min(normaliseTo, result);
        }
        return Math.max(-normaliseTo, result);
    };
    return function () {
        return function () {
            return function (values, valueIndexes) {
                var e_2, _a, e_3, _b;
                var valuesExtent = [0, 0];
                try {
                    for (
                        var valueIndexes_1 = __values$E(valueIndexes), valueIndexes_1_1 = valueIndexes_1.next();
                        !valueIndexes_1_1.done;
                        valueIndexes_1_1 = valueIndexes_1.next()
                    ) {
                        var valueIdx = valueIndexes_1_1.value;
                        var value = values[valueIdx];
                        var valIdx = value < 0 ? 0 : 1;
                        if (mode === 'sum') {
                            valuesExtent[valIdx] += value;
                        } else if (valIdx === 0) {
                            valuesExtent[valIdx] = Math.min(valuesExtent[valIdx], value);
                        } else {
                            valuesExtent[valIdx] = Math.max(valuesExtent[valIdx], value);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                } finally {
                    try {
                        if (valueIndexes_1_1 && !valueIndexes_1_1.done && (_a = valueIndexes_1.return))
                            _a.call(valueIndexes_1);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                }
                var extent = Math.max(Math.abs(valuesExtent[0]), valuesExtent[1]);
                try {
                    for (
                        var valueIndexes_2 = __values$E(valueIndexes), valueIndexes_2_1 = valueIndexes_2.next();
                        !valueIndexes_2_1.done;
                        valueIndexes_2_1 = valueIndexes_2.next()
                    ) {
                        var valueIdx = valueIndexes_2_1.value;
                        values[valueIdx] = normalise(values[valueIdx], extent);
                    }
                } catch (e_3_1) {
                    e_3 = { error: e_3_1 };
                } finally {
                    try {
                        if (valueIndexes_2_1 && !valueIndexes_2_1.done && (_b = valueIndexes_2.return))
                            _b.call(valueIndexes_2);
                    } finally {
                        if (e_3) throw e_3.error;
                    }
                }
            };
        };
    };
}
function normaliseGroupTo(scope, matchGroupIds, normaliseTo, mode) {
    if (mode === void 0) {
        mode = 'sum';
    }
    return {
        scopes: [scope.id],
        type: 'group-value-processor',
        matchGroupIds: matchGroupIds,
        adjust: memo({ normaliseTo: normaliseTo, mode: mode }, normaliseFnBuilder),
    };
}
function normalisePropertyFnBuilder(_a) {
    var normaliseTo = _a.normaliseTo,
        rangeMin = _a.rangeMin,
        rangeMax = _a.rangeMax;
    var normaliseSpan = normaliseTo[1] - normaliseTo[0];
    var normalise = function (val, start, span) {
        var result = normaliseTo[0] + ((val - start) / span) * normaliseSpan;
        if (span === 0) return normaliseTo[1];
        if (result >= normaliseTo[1]) return normaliseTo[1];
        if (result < normaliseTo[0]) return normaliseTo[0];
        return result;
    };
    return function () {
        return function (pData, pIdx) {
            var e_4, _a, e_5, _b;
            var _c = __read$12(pData.domain.values[pIdx], 2),
                start = _c[0],
                end = _c[1];
            if (rangeMin != null) start = rangeMin;
            if (rangeMax != null) end = rangeMax;
            var span = end - start;
            pData.domain.values[pIdx] = [normaliseTo[0], normaliseTo[1]];
            try {
                for (var _d = __values$E(pData.data), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var group = _e.value;
                    var groupValues = group.values;
                    if (pData.type === 'ungrouped') {
                        groupValues = [groupValues];
                    }
                    try {
                        for (
                            var groupValues_1 = ((e_5 = void 0), __values$E(groupValues)),
                                groupValues_1_1 = groupValues_1.next();
                            !groupValues_1_1.done;
                            groupValues_1_1 = groupValues_1.next()
                        ) {
                            var values = groupValues_1_1.value;
                            values[pIdx] = normalise(values[pIdx], start, span);
                        }
                    } catch (e_5_1) {
                        e_5 = { error: e_5_1 };
                    } finally {
                        try {
                            if (groupValues_1_1 && !groupValues_1_1.done && (_b = groupValues_1.return))
                                _b.call(groupValues_1);
                        } finally {
                            if (e_5) throw e_5.error;
                        }
                    }
                }
            } catch (e_4_1) {
                e_4 = { error: e_4_1 };
            } finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                } finally {
                    if (e_4) throw e_4.error;
                }
            }
        };
    };
}
function normalisePropertyTo(scope, property, normaliseTo, rangeMin, rangeMax) {
    return {
        scopes: [scope.id],
        type: 'property-value-processor',
        property: property,
        adjust: memo({ normaliseTo: normaliseTo, rangeMin: rangeMin, rangeMax: rangeMax }, normalisePropertyFnBuilder),
    };
}
function buildGroupAccFn(mode) {
    return function () {
        return function () {
            return function (values, valueIndexes) {
                var e_6, _a;
                // Datum scope.
                var acc = 0;
                try {
                    for (
                        var valueIndexes_3 = __values$E(valueIndexes), valueIndexes_3_1 = valueIndexes_3.next();
                        !valueIndexes_3_1.done;
                        valueIndexes_3_1 = valueIndexes_3.next()
                    ) {
                        var valueIdx = valueIndexes_3_1.value;
                        var currentVal = values[valueIdx];
                        if (typeof currentVal !== 'number' || isNaN(currentVal)) continue;
                        if (mode === 'normal') acc += currentVal;
                        values[valueIdx] = acc;
                        if (mode === 'trailing') acc += currentVal;
                    }
                } catch (e_6_1) {
                    e_6 = { error: e_6_1 };
                } finally {
                    try {
                        if (valueIndexes_3_1 && !valueIndexes_3_1.done && (_a = valueIndexes_3.return))
                            _a.call(valueIndexes_3);
                    } finally {
                        if (e_6) throw e_6.error;
                    }
                }
            };
        };
    };
}
function buildGroupWindowAccFn(_a) {
    var mode = _a.mode,
        sum = _a.sum;
    return function () {
        // Entire data-set scope.
        var lastValues = [];
        var firstRow = true;
        return function () {
            // Group scope.
            return function (values, valueIndexes) {
                var e_7, _a;
                // Datum scope.
                var acc = 0;
                try {
                    for (
                        var valueIndexes_4 = __values$E(valueIndexes), valueIndexes_4_1 = valueIndexes_4.next();
                        !valueIndexes_4_1.done;
                        valueIndexes_4_1 = valueIndexes_4.next()
                    ) {
                        var valueIdx = valueIndexes_4_1.value;
                        var currentVal = values[valueIdx];
                        var lastValue = firstRow && sum === 'current' ? 0 : lastValues[valueIdx];
                        lastValues[valueIdx] = currentVal;
                        var sumValue = sum === 'current' ? currentVal : lastValue;
                        if (typeof currentVal !== 'number' || isNaN(currentVal)) {
                            values[valueIdx] = sumValue;
                            continue;
                        }
                        if (typeof lastValue !== 'number' || isNaN(lastValue)) {
                            values[valueIdx] = sumValue;
                            continue;
                        }
                        if (mode === 'normal') acc += sumValue;
                        values[valueIdx] = acc;
                        if (mode === 'trailing') acc += sumValue;
                    }
                } catch (e_7_1) {
                    e_7 = { error: e_7_1 };
                } finally {
                    try {
                        if (valueIndexes_4_1 && !valueIndexes_4_1.done && (_a = valueIndexes_4.return))
                            _a.call(valueIndexes_4);
                    } finally {
                        if (e_7) throw e_7.error;
                    }
                }
                firstRow = false;
            };
        };
    };
}
function accumulateGroup(scope, matchGroupId, mode, sum) {
    var adjust;
    if (mode.startsWith('window')) {
        var modeParam = mode.endsWith('-trailing') ? 'trailing' : 'normal';
        adjust = memo({ mode: modeParam, sum: sum }, buildGroupWindowAccFn);
    } else {
        adjust = memo(mode, buildGroupAccFn);
    }
    return {
        scopes: [scope.id],
        type: 'group-value-processor',
        matchGroupIds: [matchGroupId],
        adjust: adjust,
    };
}
function diff(previousData, updateMovedDatums) {
    if (updateMovedDatums === void 0) {
        updateMovedDatums = true;
    }
    return {
        type: 'processor',
        property: 'diff',
        calculate: function (processedData) {
            var diff = {
                changed: false,
                added: [],
                updated: [],
                removed: [],
            };
            var added = new Map();
            var updated = new Map();
            var removed = new Map();
            var sep = '___';
            for (var i = 0; i < Math.max(previousData.data.length, processedData.data.length); i++) {
                var prev = previousData.data[i];
                var datum = processedData.data[i];
                var prevId = prev === null || prev === void 0 ? void 0 : prev.keys.join(sep);
                var datumId = datum === null || datum === void 0 ? void 0 : datum.keys.join(sep);
                if (prevId === datumId) {
                    if (!arraysEqual(prev.values, datum.values)) {
                        updated.set(datumId, datum);
                    }
                    continue;
                }
                if (removed.has(datumId)) {
                    if (updateMovedDatums || !arraysEqual(removed.get(datumId).values, datum.values)) {
                        updated.set(datumId, datum);
                    }
                    removed.delete(datumId);
                } else if (datum) {
                    added.set(datumId, datum);
                }
                if (added.has(prevId)) {
                    if (updateMovedDatums || !arraysEqual(added.get(prevId).values, prev.values)) {
                        updated.set(prevId, prev);
                    }
                    added.delete(prevId);
                } else if (prev) {
                    removed.set(prevId, prev);
                }
            }
            diff.added = Array.from(added.values()).map(function (datum) {
                return datum.keys;
            });
            diff.updated = Array.from(updated.values()).map(function (datum) {
                return datum.keys;
            });
            diff.removed = Array.from(removed.values()).map(function (datum) {
                return datum.keys;
            });
            diff.changed = diff.added.length > 0 || diff.updated.length > 0 || diff.removed.length > 0;
            return diff;
        },
    };
}
function arraysEqual(a, b) {
    if (a == null || b == null) return false;
    if (a.length !== b.length) return false;
    for (var i = 0; i < a.length; i++) {
        if (Array.isArray(a[i]) && Array.isArray(b[i])) return arraysEqual(a[i], b[i]);
        if (a[i] !== b[i]) return false;
    }
    return true;
}

function ProxyPropertyOnWrite(childName, childProperty) {
    return addTransformToInstanceProperty(function (target, key, value) {
        target[childName][childProperty !== null && childProperty !== void 0 ? childProperty : key] = value;
        return value;
    });
}
/**
 * Allows side-effects to be triggered on property write.
 *
 * @param opts.newValue called when a new value is set - never called for undefined values.
 * @param opts.oldValue called with the old value before a new value is set - never called for
 *                      undefined values.
 * @param opts.changeValue called on any change to the value - always called.
 */
function ActionOnSet(opts) {
    var newValueFn = opts.newValue,
        oldValueFn = opts.oldValue,
        changeValueFn = opts.changeValue;
    return addTransformToInstanceProperty(function (target, _, newValue, oldValue) {
        if (newValue !== oldValue) {
            if (oldValue !== undefined) {
                oldValueFn === null || oldValueFn === void 0 ? void 0 : oldValueFn.call(target, oldValue);
            }
            if (newValue !== undefined) {
                newValueFn === null || newValueFn === void 0 ? void 0 : newValueFn.call(target, newValue);
            }
            changeValueFn === null || changeValueFn === void 0
                ? void 0
                : changeValueFn.call(target, newValue, oldValue);
        }
        return newValue;
    });
}

var __extends$2H =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$S =
    (undefined && undefined.__assign) ||
    function () {
        __assign$S =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$S.apply(this, arguments);
    };
var __decorate$1U =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __rest$6 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __values$D =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$11 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$B =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
/** Modes of matching user interactions to rendered nodes (e.g. hover or click) */
var SeriesNodePickMode;
(function (SeriesNodePickMode) {
    /** Pick matches based upon pick coordinates being inside a matching shape/marker. */
    SeriesNodePickMode[(SeriesNodePickMode['EXACT_SHAPE_MATCH'] = 0)] = 'EXACT_SHAPE_MATCH';
    /** Pick matches by nearest category/X-axis value, then distance within that category/X-value. */
    SeriesNodePickMode[(SeriesNodePickMode['NEAREST_BY_MAIN_AXIS_FIRST'] = 1)] = 'NEAREST_BY_MAIN_AXIS_FIRST';
    /** Pick matches by nearest category value, then distance within that category. */
    SeriesNodePickMode[(SeriesNodePickMode['NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST'] = 2)] =
        'NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST';
    /** Pick matches based upon distance to ideal position */
    SeriesNodePickMode[(SeriesNodePickMode['NEAREST_NODE'] = 3)] = 'NEAREST_NODE';
})(SeriesNodePickMode || (SeriesNodePickMode = {}));
function basicContinuousCheckDatumValidation(v) {
    return checkDatum(v, true) != null;
}
function basicDiscreteCheckDatumValidation(v) {
    return checkDatum(v, false) != null;
}
function keyProperty(scope, propName, continuous, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var result = __assign$S(
        {
            scopes: [scope.id],
            property: propName,
            type: 'key',
            valueType: continuous ? 'range' : 'category',
            validation: continuous ? basicContinuousCheckDatumValidation : basicDiscreteCheckDatumValidation,
        },
        opts,
    );
    return result;
}
function valueProperty(scope, propName, continuous, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var result = __assign$S(
        {
            scopes: [scope.id],
            property: propName,
            type: 'value',
            valueType: continuous ? 'range' : 'category',
            validation: continuous ? basicContinuousCheckDatumValidation : basicDiscreteCheckDatumValidation,
        },
        opts,
    );
    return result;
}
function rangedValueProperty(scope, propName, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var _a = opts.min,
        min = _a === void 0 ? -Infinity : _a,
        _b = opts.max,
        max = _b === void 0 ? Infinity : _b,
        defOpts = __rest$6(opts, ['min', 'max']);
    return __assign$S(
        {
            scopes: [scope.id],
            type: 'value',
            property: propName,
            valueType: 'range',
            validation: basicContinuousCheckDatumValidation,
            processor: function () {
                return function (datum) {
                    if (typeof datum !== 'number') return datum;
                    if (isNaN(datum)) return datum;
                    return Math.min(Math.max(datum, min), max);
                };
            },
        },
        defOpts,
    );
}
function accumulativeValueProperty(scope, propName, continuous, opts) {
    if (opts === void 0) {
        opts = {};
    }
    var result = __assign$S(__assign$S({}, valueProperty(scope, propName, continuous, opts)), {
        processor: accumulatedValue(),
    });
    return result;
}
function groupAccumulativeValueProperty(scope, propName, continuous, mode, sum, opts) {
    if (sum === void 0) {
        sum = 'current';
    }
    return [valueProperty(scope, propName, continuous, opts), accumulateGroup(scope, opts.groupId, mode, sum)];
}
var SeriesNodeBaseClickEvent = /** @class */ (function () {
    function SeriesNodeBaseClickEvent(nativeEvent, datum, series) {
        this.type = 'nodeClick';
        this.event = nativeEvent;
        this.datum = datum.datum;
        this.seriesId = series.id;
    }
    return SeriesNodeBaseClickEvent;
})();
var SeriesNodeClickEvent = /** @class */ (function (_super) {
    __extends$2H(SeriesNodeClickEvent, _super);
    function SeriesNodeClickEvent() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    return SeriesNodeClickEvent;
})(SeriesNodeBaseClickEvent);
var SeriesNodeDoubleClickEvent = /** @class */ (function (_super) {
    __extends$2H(SeriesNodeDoubleClickEvent, _super);
    function SeriesNodeDoubleClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeDoubleClick';
        return _this;
    }
    return SeriesNodeDoubleClickEvent;
})(SeriesNodeBaseClickEvent);
var SeriesItemHighlightStyle = /** @class */ (function () {
    function SeriesItemHighlightStyle() {
        this.fill = 'yellow';
        this.fillOpacity = undefined;
        this.stroke = undefined;
        this.strokeWidth = undefined;
    }
    __decorate$1U([Validate(OPT_COLOR_STRING)], SeriesItemHighlightStyle.prototype, 'fill', void 0);
    __decorate$1U([Validate(OPT_NUMBER(0, 1))], SeriesItemHighlightStyle.prototype, 'fillOpacity', void 0);
    __decorate$1U([Validate(OPT_COLOR_STRING)], SeriesItemHighlightStyle.prototype, 'stroke', void 0);
    __decorate$1U([Validate(OPT_NUMBER(0))], SeriesItemHighlightStyle.prototype, 'strokeWidth', void 0);
    return SeriesItemHighlightStyle;
})();
var SeriesHighlightStyle = /** @class */ (function () {
    function SeriesHighlightStyle() {
        this.strokeWidth = undefined;
        this.dimOpacity = undefined;
        this.enabled = undefined;
    }
    __decorate$1U([Validate(OPT_NUMBER(0))], SeriesHighlightStyle.prototype, 'strokeWidth', void 0);
    __decorate$1U([Validate(OPT_NUMBER(0, 1))], SeriesHighlightStyle.prototype, 'dimOpacity', void 0);
    __decorate$1U([Validate(OPT_BOOLEAN)], SeriesHighlightStyle.prototype, 'enabled', void 0);
    return SeriesHighlightStyle;
})();
var TextHighlightStyle = /** @class */ (function () {
    function TextHighlightStyle() {
        this.color = 'black';
    }
    __decorate$1U([Validate(OPT_COLOR_STRING)], TextHighlightStyle.prototype, 'color', void 0);
    return TextHighlightStyle;
})();
var HighlightStyle = /** @class */ (function () {
    function HighlightStyle() {
        this.item = new SeriesItemHighlightStyle();
        this.series = new SeriesHighlightStyle();
        this.text = new TextHighlightStyle();
    }
    return HighlightStyle;
})();
var SeriesTooltip = /** @class */ (function () {
    function SeriesTooltip() {
        this.enabled = true;
        this.showArrow = undefined;
        this.interaction = new SeriesTooltipInteraction();
        this.position = new TooltipPosition();
    }
    __decorate$1U([Validate(BOOLEAN)], SeriesTooltip.prototype, 'enabled', void 0);
    __decorate$1U([Validate(OPT_BOOLEAN)], SeriesTooltip.prototype, 'showArrow', void 0);
    return SeriesTooltip;
})();
var SeriesTooltipInteraction = /** @class */ (function () {
    function SeriesTooltipInteraction() {
        this.enabled = false;
    }
    __decorate$1U([Validate(BOOLEAN)], SeriesTooltipInteraction.prototype, 'enabled', void 0);
    return SeriesTooltipInteraction;
})();
var Series = /** @class */ (function (_super) {
    __extends$2H(Series, _super);
    function Series(seriesOpts) {
        var _a;
        var _this = _super.call(this) || this;
        _this.id = createId$1(_this);
        // The group node that contains all the nodes used to render this series.
        _this.rootGroup = new Group({ name: 'seriesRoot', isVirtual: true });
        _this.axes = ((_a = {}), (_a[ChartAxisDirection.X] = undefined), (_a[ChartAxisDirection.Y] = undefined), _a);
        _this.directions = [ChartAxisDirection.X, ChartAxisDirection.Y];
        // Flag to determine if we should recalculate node data.
        _this.nodeDataRefresh = true;
        _this._data = undefined;
        _this._visible = true;
        _this.showInLegend = true;
        _this.cursor = 'default';
        _this.nodeClickRange = 'exact';
        _this.seriesGrouping = undefined;
        _this._declarationOrder = -1;
        _this.highlightStyle = new HighlightStyle();
        _this.ctx = seriesOpts.moduleCtx;
        var _b = seriesOpts.useLabelLayer,
            useLabelLayer = _b === void 0 ? false : _b,
            _c = seriesOpts.pickModes,
            pickModes = _c === void 0 ? [SeriesNodePickMode.NEAREST_BY_MAIN_AXIS_FIRST] : _c,
            _d = seriesOpts.directionKeys,
            directionKeys = _d === void 0 ? {} : _d,
            _e = seriesOpts.directionNames,
            directionNames = _e === void 0 ? {} : _e,
            _f = seriesOpts.contentGroupVirtual,
            contentGroupVirtual = _f === void 0 ? true : _f;
        var rootGroup = _this.rootGroup;
        _this.directionKeys = directionKeys;
        _this.directionNames = directionNames;
        _this.contentGroup = rootGroup.appendChild(
            new Group({
                name: _this.id + '-content',
                layer: !contentGroupVirtual,
                isVirtual: contentGroupVirtual,
                zIndex: Layers.SERIES_LAYER_ZINDEX,
                zIndexSubOrder: _this.getGroupZIndexSubOrder('data'),
            }),
        );
        _this.highlightGroup = rootGroup.appendChild(
            new Group({
                name: _this.id + '-highlight',
                layer: true,
                zIndex: Layers.SERIES_LAYER_ZINDEX,
                zIndexSubOrder: _this.getGroupZIndexSubOrder('highlight'),
            }),
        );
        _this.highlightNode = _this.highlightGroup.appendChild(new Group({ name: 'highlightNode' }));
        _this.highlightLabel = _this.highlightGroup.appendChild(new Group({ name: 'highlightLabel' }));
        _this.highlightNode.zIndex = 0;
        _this.highlightLabel.zIndex = 10;
        _this.pickModes = pickModes;
        if (useLabelLayer) {
            _this.labelGroup = rootGroup.appendChild(
                new Group({
                    name: _this.id + '-series-labels',
                    layer: true,
                    zIndex: Layers.SERIES_LABEL_ZINDEX,
                }),
            );
        }
        return _this;
    }
    Object.defineProperty(Series.prototype, 'type', {
        get: function () {
            var _a;
            return (_a = this.constructor.type) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Series.prototype, 'data', {
        get: function () {
            return this._data;
        },
        set: function (input) {
            this._data = input;
            this.nodeDataRefresh = true;
        },
        enumerable: false,
        configurable: true,
    });
    Series.prototype.hasData = function () {
        var data = this.data;
        return data && (!Array.isArray(data) || data.length > 0);
    };
    Object.defineProperty(Series.prototype, 'visible', {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            this._visible = value;
            this.visibleChanged();
        },
        enumerable: false,
        configurable: true,
    });
    Series.prototype.onSeriesGroupingChange = function (prev, next) {
        var _this = this;
        var _a = this,
            id = _a.id,
            type = _a.type,
            visible = _a.visible,
            rootGroup = _a.rootGroup;
        if (prev) {
            this.ctx.seriesStateManager.deregisterSeries({ id: id, type: type });
        }
        if (next) {
            this.ctx.seriesStateManager.registerSeries({ id: id, type: type, visible: visible, seriesGrouping: next });
        }
        this.ctx.seriesLayerManager.changeGroup({
            id: id,
            type: type,
            rootGroup: rootGroup,
            getGroupZIndexSubOrder: function (type) {
                return _this.getGroupZIndexSubOrder(type);
            },
            seriesGrouping: next,
            oldGrouping: prev,
        });
    };
    Series.prototype.getBandScalePadding = function () {
        return { inner: 1, outer: 0 };
    };
    Series.prototype.getGroupZIndexSubOrder = function (type, subIndex) {
        var _this = this;
        if (subIndex === void 0) {
            subIndex = 0;
        }
        var mainAdjust = 0;
        switch (type) {
            case 'data':
            case 'paths':
                break;
            case 'labels':
                mainAdjust += 20000;
                break;
            case 'marker':
                mainAdjust += 10000;
                break;
            // Following cases are in their own layer, so need to be careful to respect declarationOrder.
            case 'highlight':
                subIndex += 15000;
                break;
        }
        var main = function () {
            return _this._declarationOrder + mainAdjust;
        };
        return [main, subIndex];
    };
    Series.prototype.addChartEventListeners = function () {
        return;
    };
    Series.prototype.destroy = function () {
        this.ctx.seriesStateManager.deregisterSeries(this);
        this.ctx.seriesLayerManager.releaseGroup(this);
    };
    Series.prototype.getDirectionValues = function (direction, properties) {
        var _this = this;
        var resolvedDirection = this.resolveKeyDirection(direction);
        var keys = properties === null || properties === void 0 ? void 0 : properties[resolvedDirection];
        var values = [];
        var flatten = function () {
            var e_1, _a;
            var array = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                array[_i] = arguments[_i];
            }
            try {
                for (
                    var array_1 = __values$D(array), array_1_1 = array_1.next();
                    !array_1_1.done;
                    array_1_1 = array_1.next()
                ) {
                    var value = array_1_1.value;
                    addValue(value);
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (array_1_1 && !array_1_1.done && (_a = array_1.return)) _a.call(array_1);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
        };
        var addValue = function (value) {
            if (Array.isArray(value)) {
                flatten.apply(void 0, __spreadArray$B([], __read$11(value)));
            } else if (typeof value === 'object') {
                flatten(Object.values(value));
            } else {
                values.push(value);
            }
        };
        if (!keys) return values;
        keys.forEach(function (key) {
            var value = _this[key];
            addValue(value);
        });
        return values;
    };
    Series.prototype.getKeys = function (direction) {
        return this.getDirectionValues(direction, this.directionKeys);
    };
    Series.prototype.getNames = function (direction) {
        return this.getDirectionValues(direction, this.directionNames);
    };
    Series.prototype.resolveKeyDirection = function (direction) {
        return direction;
    };
    // Indicate that something external changed and we should recalculate nodeData.
    Series.prototype.markNodeDataDirty = function () {
        this.nodeDataRefresh = true;
    };
    Series.prototype.visibleChanged = function () {
        this.ctx.seriesStateManager.registerSeries(this);
    };
    Series.prototype.getOpacity = function (datum) {
        var _a = this.highlightStyle.series,
            _b = _a.dimOpacity,
            dimOpacity = _b === void 0 ? 1 : _b,
            _c = _a.enabled,
            enabled = _c === void 0 ? true : _c;
        var defaultOpacity = 1;
        if (enabled === false || dimOpacity === defaultOpacity) {
            return defaultOpacity;
        }
        switch (this.isItemIdHighlighted(datum)) {
            case 'no-highlight':
            case 'highlighted':
                return defaultOpacity;
            case 'peer-highlighted':
            case 'other-highlighted':
                return dimOpacity;
        }
    };
    Series.prototype.getStrokeWidth = function (defaultStrokeWidth, datum) {
        var _a = this.highlightStyle.series,
            strokeWidth = _a.strokeWidth,
            _b = _a.enabled,
            enabled = _b === void 0 ? true : _b;
        if (enabled === false || strokeWidth === undefined) {
            // No change in styling for highlight cases.
            return defaultStrokeWidth;
        }
        switch (this.isItemIdHighlighted(datum)) {
            case 'highlighted':
                return strokeWidth;
            case 'no-highlight':
            case 'other-highlighted':
            case 'peer-highlighted':
                return defaultStrokeWidth;
        }
    };
    Series.prototype.isItemIdHighlighted = function (datum) {
        var _a;
        var highlightedDatum =
            (_a = this.ctx.highlightManager) === null || _a === void 0 ? void 0 : _a.getActiveHighlight();
        var _b = highlightedDatum !== null && highlightedDatum !== void 0 ? highlightedDatum : {},
            series = _b.series,
            itemId = _b.itemId;
        var highlighting = series != null;
        if (!highlighting) {
            // Highlighting not active.
            return 'no-highlight';
        }
        if (series !== this) {
            // Highlighting active, this series not highlighted.
            return 'other-highlighted';
        }
        if (itemId === undefined) {
            // Series doesn't use itemIds - so no further refinement needed, series is highlighted.
            return 'highlighted';
        }
        if (datum && highlightedDatum !== datum && itemId !== datum.itemId) {
            // A peer (in same Series instance) sub-series has highlight active, but this sub-series
            // does not.
            return 'peer-highlighted';
        }
        return 'highlighted';
    };
    Series.prototype.pickNode = function (point, limitPickModes) {
        var e_2, _a;
        var _b = this,
            pickModes = _b.pickModes,
            visible = _b.visible,
            rootGroup = _b.rootGroup;
        if (!visible || !rootGroup.visible) {
            return;
        }
        try {
            for (
                var pickModes_1 = __values$D(pickModes), pickModes_1_1 = pickModes_1.next();
                !pickModes_1_1.done;
                pickModes_1_1 = pickModes_1.next()
            ) {
                var pickMode = pickModes_1_1.value;
                if (limitPickModes && !limitPickModes.includes(pickMode)) {
                    continue;
                }
                var match = undefined;
                switch (pickMode) {
                    case SeriesNodePickMode.EXACT_SHAPE_MATCH:
                        match = this.pickNodeExactShape(point);
                        break;
                    case SeriesNodePickMode.NEAREST_BY_MAIN_AXIS_FIRST:
                    case SeriesNodePickMode.NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST:
                        match = this.pickNodeMainAxisFirst(
                            point,
                            pickMode === SeriesNodePickMode.NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST,
                        );
                        break;
                    case SeriesNodePickMode.NEAREST_NODE:
                        match = this.pickNodeClosestDatum(point);
                        break;
                }
                if (match) {
                    return { pickMode: pickMode, match: match.datum, distance: match.distance };
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (pickModes_1_1 && !pickModes_1_1.done && (_a = pickModes_1.return)) _a.call(pickModes_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
    };
    Series.prototype.pickNodeExactShape = function (point) {
        var match = this.contentGroup.pickNode(point.x, point.y);
        if (match) {
            return {
                datum: match.datum,
                distance: 0,
            };
        }
    };
    Series.prototype.pickNodeClosestDatum = function (_point) {
        // Override point for sub-classes - but if this is invoked, the sub-class specified it wants
        // to use this feature.
        throw new Error('AG Charts - Series.pickNodeClosestDatum() not implemented');
    };
    Series.prototype.pickNodeMainAxisFirst = function (_point, _requireCategoryAxis) {
        // Override point for sub-classes - but if this is invoked, the sub-class specified it wants
        // to use this feature.
        throw new Error('AG Charts - Series.pickNodeMainAxisFirst() not implemented');
    };
    Series.prototype.fireNodeClickEvent = function (event, _datum) {
        var eventObject = this.getNodeClickEvent(event, _datum);
        this.fireEvent(eventObject);
    };
    Series.prototype.fireNodeDoubleClickEvent = function (event, _datum) {
        var eventObject = this.getNodeDoubleClickEvent(event, _datum);
        this.fireEvent(eventObject);
    };
    Series.prototype.getNodeClickEvent = function (event, datum) {
        return new SeriesNodeClickEvent(event, datum, this);
    };
    Series.prototype.getNodeDoubleClickEvent = function (event, datum) {
        return new SeriesNodeDoubleClickEvent(event, datum, this);
    };
    Series.prototype.toggleSeriesItem = function (_itemId, enabled) {
        this.visible = enabled;
        this.nodeDataRefresh = true;
    };
    Series.prototype.isEnabled = function () {
        return this.visible;
    };
    Series.prototype.fixNumericExtent = function (extent, axis) {
        var _a;
        var fixedExtent = fixNumericExtent(extent);
        if (fixedExtent.length === 0) {
            return fixedExtent;
        }
        var _b = __read$11(fixedExtent, 2),
            min = _b[0],
            max = _b[1];
        if (min === max) {
            // domain has zero length, there is only a single valid value in data
            var _c = __read$11(
                    (_a = axis === null || axis === void 0 ? void 0 : axis.calculatePadding(min, max)) !== null &&
                        _a !== void 0
                        ? _a
                        : [1, 1],
                    2,
                ),
                paddingMin = _c[0],
                paddingMax = _c[1];
            min -= paddingMin;
            max += paddingMax;
        }
        return [min, max];
    };
    Series.highlightedZIndex = 1000000000000;
    __decorate$1U([Validate(STRING)], Series.prototype, 'id', void 0);
    __decorate$1U([Validate(BOOLEAN)], Series.prototype, '_visible', void 0);
    __decorate$1U([Validate(BOOLEAN)], Series.prototype, 'showInLegend', void 0);
    __decorate$1U([Validate(STRING)], Series.prototype, 'cursor', void 0);
    __decorate$1U([Validate(INTERACTION_RANGE)], Series.prototype, 'nodeClickRange', void 0);
    __decorate$1U(
        [
            ActionOnSet({
                changeValue: function (newVal, oldVal) {
                    this.onSeriesGroupingChange(oldVal, newVal);
                },
            }),
        ],
        Series.prototype,
        'seriesGrouping',
        void 0,
    );
    return Series;
})(Observable);

var __decorate$1T =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Padding$1 = /** @class */ (function () {
    function Padding(top, right, bottom, left) {
        if (top === void 0) {
            top = 0;
        }
        if (right === void 0) {
            right = top;
        }
        if (bottom === void 0) {
            bottom = top;
        }
        if (left === void 0) {
            left = right;
        }
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    Padding.prototype.clear = function () {
        this.top = this.right = this.bottom = this.left = 0;
    };
    __decorate$1T([Validate(NUMBER(0))], Padding.prototype, 'top', void 0);
    __decorate$1T([Validate(NUMBER(0))], Padding.prototype, 'right', void 0);
    __decorate$1T([Validate(NUMBER(0))], Padding.prototype, 'bottom', void 0);
    __decorate$1T([Validate(NUMBER(0))], Padding.prototype, 'left', void 0);
    return Padding;
})();

var __values$C =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var SizeMonitor = /** @class */ (function () {
    function SizeMonitor() {}
    SizeMonitor.init = function () {
        var _this = this;
        var NativeResizeObserver = window.ResizeObserver;
        if (NativeResizeObserver) {
            this.resizeObserver = new NativeResizeObserver(function (entries) {
                var e_1, _a;
                try {
                    for (
                        var entries_1 = __values$C(entries), entries_1_1 = entries_1.next();
                        !entries_1_1.done;
                        entries_1_1 = entries_1.next()
                    ) {
                        var entry = entries_1_1.value;
                        var _b = entry.contentRect,
                            width = _b.width,
                            height = _b.height;
                        _this.checkSize(_this.elements.get(entry.target), entry.target, width, height);
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (entries_1_1 && !entries_1_1.done && (_a = entries_1.return)) _a.call(entries_1);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
            });
        } else {
            // polyfill (more reliable even in browsers that support ResizeObserver)
            var step = function () {
                _this.elements.forEach(function (entry, element) {
                    _this.checkClientSize(element, entry);
                });
            };
            this.pollerHandler = window.setInterval(step, 100);
        }
        this.ready = true;
    };
    SizeMonitor.destroy = function () {
        var _a;
        if (this.pollerHandler != null) {
            clearInterval(this.pollerHandler);
            this.pollerHandler = undefined;
        }
        (_a = this.resizeObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.resizeObserver = undefined;
        this.ready = false;
    };
    SizeMonitor.checkSize = function (entry, element, width, height) {
        if (entry) {
            if (!entry.size || width !== entry.size.width || height !== entry.size.height) {
                entry.size = { width: width, height: height };
                entry.cb(entry.size, element);
            }
        }
    };
    // Only a single callback is supported.
    SizeMonitor.observe = function (element, cb) {
        if (!this.ready) {
            this.init();
        }
        this.unobserve(element, false);
        if (this.resizeObserver) {
            this.resizeObserver.observe(element);
        }
        this.elements.set(element, { cb: cb });
        // Ensure first size callback happens synchronously.
        this.checkClientSize(element, { cb: cb });
    };
    SizeMonitor.unobserve = function (element, cleanup) {
        if (cleanup === void 0) {
            cleanup = true;
        }
        if (this.resizeObserver) {
            this.resizeObserver.unobserve(element);
        }
        this.elements.delete(element);
        if (cleanup && this.elements.size === 0) {
            this.destroy();
        }
    };
    SizeMonitor.checkClientSize = function (element, entry) {
        var width = element.clientWidth ? element.clientWidth : 0;
        var height = element.clientHeight ? element.clientHeight : 0;
        this.checkSize(entry, element, width, height);
    };
    SizeMonitor.elements = new Map();
    SizeMonitor.ready = false;
    return SizeMonitor;
})();

function circleRectOverlap(c, x, y, w, h) {
    // Find closest horizontal and vertical edges.
    var edgeX = c.x;
    if (c.x < x) {
        edgeX = x;
    } else if (c.x > x + w) {
        edgeX = x + w;
    }
    var edgeY = c.y;
    if (c.y < y) {
        edgeY = y;
    } else if (c.y > y + h) {
        edgeY = y + h;
    }
    // Find distance to closest edges.
    var dx = c.x - edgeX;
    var dy = c.y - edgeY;
    var d = Math.sqrt(dx * dx + dy * dy);
    return d <= c.size * 0.5;
}
function rectRectOverlap(r1, x2, y2, w2, h2) {
    var xOverlap = r1.x + r1.width > x2 && r1.x < x2 + w2;
    var yOverlap = r1.y + r1.height > y2 && r1.y < y2 + h2;
    return xOverlap && yOverlap;
}
function rectContainsRect(r1, r2x, r2y, r2w, r2h) {
    return r2x + r2w < r1.x + r1.width && r2x > r1.x && r2y > r1.y && r2y + r2h < r1.y + r1.height;
}
function isPointLabelDatum(x) {
    return x != null && typeof x.point === 'object' && typeof x.label === 'object';
}
/**
 * @param data Points and labels for one or more series. The order of series determines label placement precedence.
 * @param bounds Bounds to fit the labels into. If a label can't be fully contained, it doesn't fit.
 * @returns Placed labels for the given series (in the given order).
 */
function placeLabels(data, bounds, padding) {
    if (padding === void 0) {
        padding = 5;
    }
    var result = [];
    data = data.map(function (d) {
        return d.slice().sort(function (a, b) {
            return b.point.size - a.point.size;
        });
    });
    for (var j = 0; j < data.length; j++) {
        var labels = (result[j] = []);
        var datum = data[j];
        if (!((datum === null || datum === void 0 ? void 0 : datum.length) && datum[0].label)) {
            continue;
        }
        var _loop_1 = function (i, ln) {
            var d = datum[i];
            var l = d.label;
            var r = d.point.size * 0.5;
            var x = d.point.x - l.width * 0.5;
            var y = d.point.y - r - l.height - padding;
            var width = l.width,
                height = l.height;
            var withinBounds = !bounds || rectContainsRect(bounds, x, y, width, height);
            if (!withinBounds) {
                return 'continue';
            }
            var overlapPoints = data.some(function (datum) {
                return datum.some(function (d) {
                    return circleRectOverlap(d.point, x, y, width, height);
                });
            });
            if (overlapPoints) {
                return 'continue';
            }
            var overlapLabels = result.some(function (labels) {
                return labels.some(function (l) {
                    return rectRectOverlap(l, x, y, width, height);
                });
            });
            if (overlapLabels) {
                return 'continue';
            }
            labels.push({
                index: i,
                text: l.text,
                x: x,
                y: y,
                width: width,
                height: height,
                datum: d,
            });
        };
        for (var i = 0, ln = datum.length; i < ln; i++) {
            _loop_1(i, ln);
        }
    }
    return result;
}
function axisLabelsOverlap(data, padding) {
    var result = [];
    var _loop_2 = function (i) {
        var datum = data[i];
        var _a = datum.point,
            x = _a.x,
            y = _a.y,
            text = datum.label.text;
        var _b = datum.label,
            width = _b.width,
            height = _b.height;
        width += padding !== null && padding !== void 0 ? padding : 0;
        height += padding !== null && padding !== void 0 ? padding : 0;
        var overlapLabels = result.some(function (l) {
            var overlap = rectRectOverlap(l, x, y, width, height);
            return overlap;
        });
        if (overlapLabels) {
            return { value: true };
        }
        result.push({
            index: i,
            text: text,
            x: x,
            y: y,
            width: width,
            height: height,
            datum: datum,
        });
    };
    for (var i = 0; i < data.length; i++) {
        var state_1 = _loop_2(i);
        if (typeof state_1 === 'object') return state_1.value;
    }
    return false;
}

var __awaiter$f =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$f =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
/**
 * Wrap a function in debouncing trigger function. A requestAnimationFrame() is scheduled
 * after the first schedule() call, and subsequent schedule() calls will be ignored until the
 * animation callback executes.
 */
function debouncedAnimationFrame(cb) {
    return buildScheduler(function (cb, _delayMs) {
        return requestAnimationFrame(cb);
    }, cb);
}
function debouncedCallback(cb) {
    return buildScheduler(function (cb, delayMs) {
        if (delayMs === void 0) {
            delayMs = 0;
        }
        return setTimeout(cb, delayMs);
    }, cb);
}
function buildScheduler(scheduleFn, cb) {
    var scheduleCount = 0;
    var promiseRunning = false;
    var awaitingPromise;
    var awaitingDone;
    var busy = function () {
        return promiseRunning;
    };
    var done = function () {
        promiseRunning = false;
        awaitingDone === null || awaitingDone === void 0 ? void 0 : awaitingDone();
        awaitingDone = undefined;
        awaitingPromise = undefined;
        if (scheduleCount > 0) {
            scheduleFn(scheduleCb);
        }
    };
    var scheduleCb = function () {
        var count = scheduleCount;
        scheduleCount = 0;
        promiseRunning = true;
        var maybePromise = cb({ count: count });
        if (!maybePromise) {
            done();
            return;
        }
        maybePromise.then(done).catch(done);
    };
    return {
        schedule: function (delayMs) {
            if (scheduleCount === 0 && !busy()) {
                scheduleFn(scheduleCb, delayMs);
            }
            scheduleCount++;
        },
        await: function () {
            return __awaiter$f(this, void 0, void 0, function () {
                return __generator$f(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!busy()) {
                                return [2 /*return*/];
                            }
                            if (awaitingPromise == null) {
                                awaitingPromise = new Promise(function (resolve) {
                                    awaitingDone = resolve;
                                });
                            }
                            _a.label = 1;
                        case 1:
                            if (!busy()) return [3 /*break*/, 3];
                            return [4 /*yield*/, awaitingPromise];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 1];
                        case 3:
                            return [2 /*return*/];
                    }
                });
            });
        },
    };
}

function sleep(sleepTimeoutMs) {
    return new Promise(function (resolve) {
        setTimeout(function () {
            return resolve(undefined);
        }, sleepTimeoutMs);
    });
}

var __decorate$1S =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Overlay = /** @class */ (function () {
    function Overlay(className, parent) {
        this.renderer = undefined;
        this.text = undefined;
        this.className = className;
        this.parentElement = parent;
    }
    Overlay.prototype.show = function (rect) {
        var _a, _b;
        var element = this.element;
        if (!element) {
            element = document.createElement('div');
            element.className = this.className;
            this.element = element;
        }
        element.style.position = 'absolute';
        element.style.left = rect.x + 'px';
        element.style.top = rect.y + 'px';
        element.style.width = rect.width + 'px';
        element.style.height = rect.height + 'px';
        if (this.renderer) {
            element.innerHTML = this.renderer();
        } else {
            var content = document.createElement('div');
            content.style.alignItems = 'center';
            content.style.boxSizing = 'border-box';
            content.style.display = 'flex';
            content.style.justifyContent = 'center';
            content.style.margin = '8px';
            content.style.height = '100%';
            content.style.font = '12px Verdana, sans-serif';
            content.innerText = (_a = this.text) !== null && _a !== void 0 ? _a : 'No data to display';
            element.append(content);
        }
        (_b = this.parentElement) === null || _b === void 0 ? void 0 : _b.append(element);
    };
    Overlay.prototype.hide = function () {
        var _a;
        (_a = this.element) === null || _a === void 0 ? void 0 : _a.remove();
        this.element = undefined;
    };
    __decorate$1S([Validate(OPT_FUNCTION)], Overlay.prototype, 'renderer', void 0);
    __decorate$1S([Validate(OPT_STRING)], Overlay.prototype, 'text', void 0);
    return Overlay;
})();

var ChartOverlays = /** @class */ (function () {
    function ChartOverlays(parent) {
        this.noData = new Overlay('ag-chart-no-data-overlay', parent);
    }
    return ChartOverlays;
})();

var __assign$R =
    (undefined && undefined.__assign) ||
    function () {
        __assign$R =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$R.apply(this, arguments);
    };
var __read$10 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$A =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$B =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
/**
 * Performs a JSON-diff between a source and target JSON structure.
 *
 * On a per property basis, takes the target property value where:
 * - types are different.
 * - type is primitive.
 * - type is array and length or content have changed.
 *
 * Recurses for object types.
 *
 * @param source starting point for diff
 * @param target target for diff vs. source
 *
 * @returns `null` if no differences, or an object with the subset of properties that have changed.
 */
function jsonDiff(source, target) {
    var e_1, _a;
    var sourceType = classify(source);
    var targetType = classify(target);
    if (targetType === 'array') {
        var targetArray = target;
        if (sourceType !== 'array' || source.length !== targetArray.length) {
            return __spreadArray$A([], __read$10(targetArray));
        }
        if (
            targetArray.some(function (targetElement, i) {
                var _a;
                return jsonDiff((_a = source) === null || _a === void 0 ? void 0 : _a[i], targetElement) != null;
            })
        ) {
            return __spreadArray$A([], __read$10(targetArray));
        }
        return null;
    }
    if (targetType === 'primitive') {
        if (sourceType !== 'primitive') {
            return __assign$R({}, target);
        }
        if (source !== target) {
            return target;
        }
        return null;
    }
    var lhs = source || {};
    var rhs = target || {};
    var allProps = new Set(
        __spreadArray$A(__spreadArray$A([], __read$10(Object.keys(lhs))), __read$10(Object.keys(rhs))),
    );
    var propsChangedCount = 0;
    var result = {};
    var _loop_1 = function (prop) {
        // Cheap-and-easy equality check.
        if (lhs[prop] === rhs[prop]) {
            return 'continue';
        }
        var take = function (v) {
            result[prop] = v;
            propsChangedCount++;
        };
        var lhsType = classify(lhs[prop]);
        var rhsType = classify(rhs[prop]);
        if (lhsType !== rhsType) {
            // Types changed, just take RHS.
            take(rhs[prop]);
            return 'continue';
        }
        if (rhsType === 'primitive' || rhsType === null) {
            take(rhs[prop]);
            return 'continue';
        }
        if (rhsType === 'array' && lhs[prop].length !== rhs[prop].length) {
            // Arrays are different sizes, so just take target array.
            take(rhs[prop]);
            return 'continue';
        }
        if (rhsType === 'class-instance') {
            // Don't try to do anything tricky with array diffs!
            take(rhs[prop]);
            return 'continue';
        }
        if (rhsType === 'function' && lhs[prop] !== rhs[prop]) {
            take(rhs[prop]);
            return 'continue';
        }
        var diff = jsonDiff(lhs[prop], rhs[prop]);
        if (diff !== null) {
            take(diff);
        }
    };
    try {
        for (
            var allProps_1 = __values$B(allProps), allProps_1_1 = allProps_1.next();
            !allProps_1_1.done;
            allProps_1_1 = allProps_1.next()
        ) {
            var prop = allProps_1_1.value;
            _loop_1(prop);
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (allProps_1_1 && !allProps_1_1.done && (_a = allProps_1.return)) _a.call(allProps_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return propsChangedCount === 0 ? null : result;
}
/**
 * Special value used by `jsonMerge` to signal that a property should be removed from the merged
 * output.
 */
var DELETE = Symbol('<delete-property>');
var NOT_SPECIFIED = Symbol('<unspecified-property>');
/**
 * Merge together the provide JSON object structures, with the precedence of application running
 * from higher indexes to lower indexes.
 *
 * Deep-clones all objects to avoid mutation of the inputs changing the output object. For arrays,
 * just performs a deep-clone of the entire array, no merging of elements attempted.
 *
 * @param json all json objects to merge
 * @param opts merge options
 * @param opts.avoidDeepClone contains a list of properties where deep clones should be avoided
 *
 * @returns the combination of all of the json inputs
 */
function jsonMerge(json, opts) {
    var e_2, _a;
    var _b;
    var avoidDeepClone =
        (_b = opts === null || opts === void 0 ? void 0 : opts.avoidDeepClone) !== null && _b !== void 0 ? _b : [];
    var jsonTypes = json.map(function (v) {
        return classify(v);
    });
    if (
        jsonTypes.some(function (v) {
            return v === 'array';
        })
    ) {
        // Clone final array.
        var finalValue = json[json.length - 1];
        if (finalValue instanceof Array) {
            return finalValue.map(function (v) {
                var type = classify(v);
                if (type === 'array') return jsonMerge([[], v], opts);
                if (type === 'object') return jsonMerge([{}, v], opts);
                return v;
            });
        }
        return finalValue;
    }
    var result = {};
    var props = new Set(
        json
            .map(function (v) {
                return v != null ? Object.keys(v) : [];
            })
            .reduce(function (r, n) {
                return r.concat(n);
            }, []),
    );
    var _loop_2 = function (nextProp) {
        var values = json
            .map(function (j) {
                if (j != null && typeof j === 'object' && nextProp in j) {
                    return j[nextProp];
                }
                return NOT_SPECIFIED;
            })
            .filter(function (v) {
                return v !== NOT_SPECIFIED;
            });
        if (values.length === 0) {
            return 'continue';
        }
        var lastValue = values[values.length - 1];
        if (lastValue === DELETE) {
            return 'continue';
        }
        var types = values.map(function (v) {
            return classify(v);
        });
        var type = types[0];
        if (
            types.some(function (t) {
                return t !== type;
            })
        ) {
            // Short-circuit if mismatching types.
            result[nextProp] = lastValue;
            return 'continue';
        }
        if ((type === 'array' || type === 'object') && !avoidDeepClone.includes(nextProp)) {
            result[nextProp] = jsonMerge(values, opts);
        } else if (type === 'array') {
            // Arrays need to be shallow copied to avoid external mutation and allow jsonDiff to
            // detect changes.
            result[nextProp] = __spreadArray$A([], __read$10(lastValue));
        } else {
            // Just directly assign/overwrite.
            result[nextProp] = lastValue;
        }
    };
    try {
        for (var props_1 = __values$B(props), props_1_1 = props_1.next(); !props_1_1.done; props_1_1 = props_1.next()) {
            var nextProp = props_1_1.value;
            _loop_2(nextProp);
        }
    } catch (e_2_1) {
        e_2 = { error: e_2_1 };
    } finally {
        try {
            if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
        } finally {
            if (e_2) throw e_2.error;
        }
    }
    return result;
}
/**
 * Recursively apply a JSON object into a class-hierarchy, optionally instantiating certain classes
 * by property name.
 *
 * @param target to apply source JSON properties into
 * @param source to be applied
 * @param params.path path for logging/error purposes, to aid with pinpointing problems
 * @param params.matcherPath path for pattern matching, to lookup allowedTypes override.
 * @param params.skip property names to skip from the source
 * @param params.constructors dictionary of property name to class constructors for properties that
 *                            require object construction
 * @param params.constructedArrays map stores arrays which items should be initialised
 *                                 using a class constructor
 * @param params.allowedTypes overrides by path for allowed property types
 */
function jsonApply(target, source, params) {
    var _a, _b, _c;
    if (params === void 0) {
        params = {};
    }
    var _d = params.path,
        path = _d === void 0 ? undefined : _d,
        _e = params.matcherPath,
        matcherPath = _e === void 0 ? (path ? path.replace(/(\[[0-9+]+\])/i, '[]') : undefined) : _e,
        _f = params.skip,
        skip = _f === void 0 ? [] : _f,
        _g = params.constructors,
        constructors = _g === void 0 ? {} : _g,
        _h = params.constructedArrays,
        constructedArrays = _h === void 0 ? new WeakMap() : _h,
        _j = params.allowedTypes,
        allowedTypes = _j === void 0 ? {} : _j,
        idx = params.idx;
    if (target == null) {
        throw new Error('AG Charts - target is uninitialised: ' + (path !== null && path !== void 0 ? path : '<root>'));
    }
    if (source == null) {
        return target;
    }
    var targetAny = target;
    if (idx != null && '_declarationOrder' in targetAny) {
        targetAny['_declarationOrder'] = idx;
    }
    var targetType = classify(target);
    var _loop_3 = function (property) {
        var propertyMatcherPath = '' + (matcherPath ? matcherPath + '.' : '') + property;
        if (skip.indexOf(propertyMatcherPath) >= 0) {
            return 'continue';
        }
        var newValue = source[property];
        var propertyPath = '' + (path ? path + '.' : '') + property;
        var targetClass = targetAny.constructor;
        var currentValue = targetAny[property];
        var ctr = (_a = constructors[propertyMatcherPath]) !== null && _a !== void 0 ? _a : constructors[property];
        try {
            var currentValueType = classify(currentValue);
            var newValueType = classify(newValue);
            if (
                targetType === 'class-instance' &&
                !(property in target || Object.prototype.hasOwnProperty.call(targetAny, property))
            ) {
                Logger.warn(
                    'unable to set [' +
                        propertyPath +
                        '] in ' +
                        (targetClass === null || targetClass === void 0 ? void 0 : targetClass.name) +
                        ' - property is unknown',
                );
                return 'continue';
            }
            var allowableTypes =
                (_b = allowedTypes[propertyMatcherPath]) !== null && _b !== void 0 ? _b : [currentValueType];
            if (currentValueType === 'class-instance' && newValueType === 'object') {
                // Allowed, this is the common case! - do not error.
            } else if (currentValueType != null && newValueType != null && !allowableTypes.includes(newValueType)) {
                Logger.warn(
                    'unable to set [' +
                        propertyPath +
                        '] in ' +
                        (targetClass === null || targetClass === void 0 ? void 0 : targetClass.name) +
                        " - can't apply type of [" +
                        newValueType +
                        '], allowed types are: [' +
                        allowableTypes +
                        ']',
                );
                return 'continue';
            }
            if (newValueType === 'array') {
                ctr =
                    (_c = ctr !== null && ctr !== void 0 ? ctr : constructedArrays.get(currentValue)) !== null &&
                    _c !== void 0
                        ? _c
                        : constructors[propertyMatcherPath + '[]'];
                if (ctr != null) {
                    var newValueArray = newValue;
                    targetAny[property] = newValueArray.map(function (v, idx) {
                        return jsonApply(
                            new ctr(),
                            v,
                            __assign$R(__assign$R({}, params), {
                                path: propertyPath,
                                matcherPath: propertyMatcherPath + '[]',
                                idx: idx,
                            }),
                        );
                    });
                } else {
                    targetAny[property] = newValue;
                }
            } else if (newValueType === 'class-instance') {
                targetAny[property] = newValue;
            } else if (newValueType === 'object') {
                if (currentValue != null) {
                    jsonApply(
                        currentValue,
                        newValue,
                        __assign$R(__assign$R({}, params), {
                            path: propertyPath,
                            matcherPath: propertyMatcherPath,
                            idx: undefined,
                        }),
                    );
                } else if (ctr != null) {
                    targetAny[property] = jsonApply(
                        new ctr(),
                        newValue,
                        __assign$R(__assign$R({}, params), {
                            path: propertyPath,
                            matcherPath: propertyMatcherPath,
                            idx: undefined,
                        }),
                    );
                } else {
                    targetAny[property] = newValue;
                }
            } else {
                targetAny[property] = newValue;
            }
        } catch (error) {
            Logger.warn(
                'unable to set [' +
                    propertyPath +
                    '] in [' +
                    (targetClass === null || targetClass === void 0 ? void 0 : targetClass.name) +
                    ']; nested error is: ' +
                    error.message,
            );
            return 'continue';
        }
    };
    for (var property in source) {
        _loop_3(property);
    }
    return target;
}
/**
 * Walk the given JSON object graphs, invoking the visit() callback for every object encountered.
 * Arrays are descended into without a callback, however their elements will have the visit()
 * callback invoked if they are objects.
 *
 * @param json to traverse
 * @param visit callback for each non-primitive and non-array object found
 * @param opts.skip property names to skip when walking
 * @param jsons to traverse in parallel
 */
function jsonWalk(json, visit, opts) {
    var _a;
    var jsons = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        jsons[_i - 3] = arguments[_i];
    }
    var jsonType = classify(json);
    var skip = (_a = opts.skip) !== null && _a !== void 0 ? _a : [];
    if (jsonType === 'array') {
        json.forEach(function (element, index) {
            jsonWalk.apply(
                void 0,
                __spreadArray$A(
                    [element, visit, opts],
                    __read$10(
                        (jsons !== null && jsons !== void 0 ? jsons : []).map(function (o) {
                            return o === null || o === void 0 ? void 0 : o[index];
                        }),
                    ),
                ),
            );
        });
        return;
    } else if (jsonType !== 'object') {
        return;
    }
    visit.apply(void 0, __spreadArray$A([jsonType, json], __read$10(jsons)));
    var _loop_4 = function (property) {
        if (skip.indexOf(property) >= 0) {
            return 'continue';
        }
        var value = json[property];
        var otherValues =
            jsons === null || jsons === void 0
                ? void 0
                : jsons.map(function (o) {
                      return o === null || o === void 0 ? void 0 : o[property];
                  });
        var valueType = classify(value);
        if (valueType === 'object' || valueType === 'array') {
            jsonWalk.apply(void 0, __spreadArray$A([value, visit, opts], __read$10(otherValues)));
        }
    };
    for (var property in json) {
        _loop_4(property);
    }
}
var isBrowser = typeof window !== 'undefined';
/**
 * Classify the type of a value to assist with handling for merge purposes.
 */
function classify(value) {
    if (value == null) {
        return null;
    } else if (isBrowser && value instanceof HTMLElement) {
        return 'primitive';
    } else if (value instanceof Array) {
        return 'array';
    } else if (value instanceof Date) {
        return 'primitive';
    } else if (typeof value === 'object' && value.constructor === Object) {
        return 'object';
    } else if (typeof value === 'function') {
        return 'function';
    } else if (typeof value === 'object' && value.constructor != null) {
        return 'class-instance';
    }
    return 'primitive';
}

var __values$A =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$$ =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$z =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var Listeners = /** @class */ (function () {
    function Listeners() {
        this.registeredListeners = {};
    }
    Listeners.prototype.addListener = function (type, cb) {
        var _a;
        var symbol = Symbol(type);
        if (!this.registeredListeners[type]) {
            this.registeredListeners[type] = [];
        }
        (_a = this.registeredListeners[type]) === null || _a === void 0
            ? void 0
            : _a.push({ symbol: symbol, handler: cb });
        return symbol;
    };
    Listeners.prototype.dispatch = function (type) {
        var e_1, _a;
        var _b;
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var listeners = (_b = this.registeredListeners[type]) !== null && _b !== void 0 ? _b : [];
        var results = [];
        try {
            for (
                var listeners_1 = __values$A(listeners), listeners_1_1 = listeners_1.next();
                !listeners_1_1.done;
                listeners_1_1 = listeners_1.next()
            ) {
                var listener = listeners_1_1.value;
                try {
                    results.push(listener.handler.apply(listener, __spreadArray$z([], __read$$(params))));
                } catch (e) {
                    Logger.errorOnce(e);
                    results.push(undefined);
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (listeners_1_1 && !listeners_1_1.done && (_a = listeners_1.return)) _a.call(listeners_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return results;
    };
    Listeners.prototype.cancellableDispatch = function (type, cancelled) {
        var e_2, _a;
        var _b;
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        var listeners = (_b = this.registeredListeners[type]) !== null && _b !== void 0 ? _b : [];
        var results = [];
        try {
            for (
                var listeners_2 = __values$A(listeners), listeners_2_1 = listeners_2.next();
                !listeners_2_1.done;
                listeners_2_1 = listeners_2.next()
            ) {
                var listener = listeners_2_1.value;
                if (cancelled()) break;
                results.push(listener.handler.apply(listener, __spreadArray$z([], __read$$(params))));
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (listeners_2_1 && !listeners_2_1.done && (_a = listeners_2.return)) _a.call(listeners_2);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        return results;
    };
    Listeners.prototype.reduceDispatch = function (type, reduceFn) {
        var e_3, _a;
        var _b;
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        var listeners = (_b = this.registeredListeners[type]) !== null && _b !== void 0 ? _b : [];
        var listenerResult = undefined;
        try {
            for (
                var listeners_3 = __values$A(listeners), listeners_3_1 = listeners_3.next();
                !listeners_3_1.done;
                listeners_3_1 = listeners_3.next()
            ) {
                var listener = listeners_3_1.value;
                listenerResult = listener.handler.apply(listener, __spreadArray$z([], __read$$(params)));
                params = reduceFn.apply(void 0, __spreadArray$z([listenerResult], __read$$(params)));
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (listeners_3_1 && !listeners_3_1.done && (_a = listeners_3.return)) _a.call(listeners_3);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        return listenerResult;
    };
    Listeners.prototype.removeListener = function (listenerSymbol) {
        for (var type in this.registeredListeners) {
            var listeners = this.registeredListeners[type];
            var match =
                listeners === null || listeners === void 0
                    ? void 0
                    : listeners.findIndex(function (entry) {
                          return entry.symbol === listenerSymbol;
                      });
            if (match != null && match >= 0) {
                listeners === null || listeners === void 0 ? void 0 : listeners.splice(match, 1);
            }
            if (match != null && (listeners === null || listeners === void 0 ? void 0 : listeners.length) === 0) {
                delete this.registeredListeners[type];
            }
        }
    };
    return Listeners;
})();

var BaseManager = /** @class */ (function () {
    function BaseManager() {
        this.listeners = new Listeners();
    }
    BaseManager.prototype.addListener = function (type, cb) {
        return this.listeners.addListener(type, cb);
    };
    BaseManager.prototype.removeListener = function (listenerSymbol) {
        this.listeners.removeListener(listenerSymbol);
    };
    return BaseManager;
})();

function number(a, b) {
    a = +a;
    b = +b;
    return function (t) {
        return a * (1 - t) + b * t;
    };
}

function interpolateColor(a, b) {
    if (typeof a === 'string') {
        try {
            a = Color.fromString(a);
        } catch (e) {
            a = Color.fromArray([0, 0, 0]);
        }
    }
    if (typeof b === 'string') {
        try {
            b = Color.fromString(b);
        } catch (e) {
            b = Color.fromArray([0, 0, 0]);
        }
    }
    var red = number(a.r, b.r);
    var green = number(a.g, b.g);
    var blue = number(a.b, b.b);
    var alpha = number(a.a, b.a);
    return function (t) {
        return Color.fromArray([red(t), green(t), blue(t), alpha(t)]).toRgbaString();
    };
}

function interpolate$1(a, b) {
    var t = typeof b;
    var c;
    if (t === 'number') {
        return number(a, b);
    }
    if (t === 'string') {
        try {
            c = Color.fromString(b);
            b = c;
            return interpolateColor(a, b);
        } catch (e) {
            // Error-case handled below.
        }
    }
    throw new Error('Unable to interpolate values');
}

function createEase(fn) {
    return function (_a) {
        var from = _a.from,
            to = _a.to;
        var interp = interpolate$1(from, to);
        return function (time) {
            return interp(fn(time));
        };
    };
}
function linear(_a) {
    var from = _a.from,
        to = _a.to;
    return interpolate$1(from, to);
}
var easeOut = createEase(function (x) {
    return Math.sin((x * Math.PI) / 2);
});

var __assign$Q =
    (undefined && undefined.__assign) ||
    function () {
        __assign$Q =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$Q.apply(this, arguments);
    };
var RepeatType;
(function (RepeatType) {
    RepeatType['Loop'] = 'loop';
    RepeatType['Reverse'] = 'reverse';
})(RepeatType || (RepeatType = {}));
function animate(_a) {
    var driver = _a.driver,
        duration = _a.duration,
        from = _a.from,
        to = _a.to,
        _b = _a.autoplay,
        autoplay = _b === void 0 ? true : _b,
        _c = _a.delay,
        delay = _c === void 0 ? 0 : _c,
        _d = _a.ease,
        ease = _d === void 0 ? linear : _d,
        _e = _a.repeat,
        repeatMax = _e === void 0 ? 0 : _e,
        _f = _a.repeatType,
        repeatType = _f === void 0 ? RepeatType.Loop : _f,
        onComplete = _a.onComplete,
        onPlay = _a.onPlay,
        onRepeat = _a.onRepeat,
        onStop = _a.onStop,
        onUpdate = _a.onUpdate;
    var state;
    var delayElapsed = 0;
    var elapsed = 0;
    var iteration = 0;
    var isForward = true;
    var isComplete = false;
    var easing = ease({ from: from, to: to });
    var controls = { isPlaying: false, play: play, pause: pause, stop: stop, reset: reset };
    var driverControls = driver(update);
    function play() {
        controls.isPlaying = true;
        driverControls.start();
        onPlay === null || onPlay === void 0 ? void 0 : onPlay();
        return controls;
    }
    function pause() {
        controls.isPlaying = false;
        return controls;
    }
    function stop() {
        controls.isPlaying = false;
        driverControls.stop();
        onStop === null || onStop === void 0 ? void 0 : onStop();
        return controls;
    }
    function reset() {
        isComplete = false;
        elapsed = 0;
        iteration = 0;
        driverControls.reset();
        return controls;
    }
    function repeat() {
        iteration++;
        if (repeatType === RepeatType.Reverse) {
            isForward = iteration % 2 === 0;
            elapsed = isForward ? elapsed % duration : duration - (elapsed % duration);
        } else {
            elapsed = elapsed % duration;
        }
        isComplete = false;
        onRepeat === null || onRepeat === void 0 ? void 0 : onRepeat();
    }
    function complete() {
        stop();
        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
    }
    function update(delta) {
        if (!isForward) delta = -delta;
        if (delayElapsed >= delay) {
            elapsed += delta;
        } else {
            delayElapsed += delta;
            return;
        }
        if (!isComplete) {
            state = easing(Math.min(1, Math.max(0, elapsed / duration)));
            isComplete = isForward ? elapsed >= duration : elapsed <= 0;
        }
        onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate(state);
        if (isComplete) {
            if (iteration < repeatMax) {
                repeat();
            } else {
                complete();
            }
        }
    }
    if (autoplay) play();
    return controls;
}
function tween(opts) {
    var handleUpdate;
    var animateOpts = __assign$Q(__assign$Q({}, opts), {
        autoplay: false,
        onUpdate: function (value) {
            handleUpdate === null || handleUpdate === void 0 ? void 0 : handleUpdate(value);
        },
    });
    var animationControls = animate(animateOpts);
    var controls = {
        start: function (onUpdate) {
            animationControls.stop();
            animationControls.reset();
            animationControls.play();
            handleUpdate = onUpdate;
            return controls;
        },
        stop: function () {
            animationControls.stop();
            return controls;
        },
    };
    return controls;
}

var __extends$2G =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$P =
    (undefined && undefined.__assign) ||
    function () {
        __assign$P =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$P.apply(this, arguments);
    };
var __rest$5 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __values$z =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$_ =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var AnimationManager = /** @class */ (function (_super) {
    __extends$2G(AnimationManager, _super);
    function AnimationManager(interactionManager) {
        var _this = _super.call(this) || this;
        _this.controllers = {};
        _this.throttles = {};
        _this.throttleGroups = new Set();
        _this.updaters = [];
        _this.isPlaying = false;
        _this.readyToPlay = false;
        _this.defaultOptions = {};
        _this.skipAnimations = false;
        _this.debug = false;
        _this.interactionManager = interactionManager;
        window.addEventListener('DOMContentLoaded', function () {
            _this.readyToPlay = true;
        });
        // Fallback if `DOMContentLoaded` event is not fired, e.g. in an iframe
        setTimeout(function () {
            _this.readyToPlay = true;
        }, 10);
        return _this;
    }
    AnimationManager.prototype.play = function () {
        if (this.isPlaying) return;
        this.isPlaying = true;
        if (this.debug) {
            Logger.debug('AnimationManager.play()');
        }
        for (var id in this.controllers) {
            this.controllers[id].play();
        }
        this.startAnimationCycle();
    };
    AnimationManager.prototype.pause = function () {
        if (!this.isPlaying) return;
        this.isPlaying = false;
        this.cancelAnimationFrame();
        if (this.debug) {
            Logger.debug('AnimationManager.pause()');
        }
        for (var id in this.controllers) {
            this.controllers[id].pause();
        }
    };
    AnimationManager.prototype.stop = function () {
        this.isPlaying = false;
        this.cancelAnimationFrame();
        if (this.debug) {
            Logger.debug('AnimationManager.stop()');
        }
        for (var id in this.controllers) {
            this.controllers[id].stop();
        }
    };
    AnimationManager.prototype.reset = function () {
        if (this.isPlaying) {
            this.stop();
            this.play();
        } else {
            this.stop();
        }
    };
    AnimationManager.prototype.animate = function (id, _a) {
        var _b, _c;
        var _d = _a.disableInteractions,
            disableInteractions = _d === void 0 ? true : _d,
            opts = __rest$5(_a, ['disableInteractions']);
        if (this.skipAnimations) {
            // Initialise the animation with the final values immediately and then stop the animation
            (_b = opts.onUpdate) === null || _b === void 0 ? void 0 : _b.call(opts, opts.to);
            return;
        }
        var optsExtra = __assign$P(__assign$P({}, opts), {
            autoplay: this.isPlaying ? opts.autoplay : false,
            driver: this.createDriver(id, disableInteractions),
        });
        if (this.controllers[id]) {
            this.controllers[id].stop();
        }
        var controller = animate(optsExtra);
        this.controllers[id] = controller;
        // Initialise the animation immediately without requesting a frame to prevent flashes
        (_c = opts.onUpdate) === null || _c === void 0 ? void 0 : _c.call(opts, opts.from);
        return controller;
    };
    AnimationManager.prototype.animateMany = function (id, props, opts) {
        var e_1, _a;
        var _b;
        if (this.skipAnimations) {
            var state_1 = props.map(function (prop) {
                return prop.to;
            });
            opts.onUpdate(state_1);
            (_b = opts.onComplete) === null || _b === void 0 ? void 0 : _b.call(opts);
            return;
        }
        var state = props.map(function (prop) {
            return prop.from;
        });
        var playBatch = 0;
        var stopBatch = 0;
        var updateBatch = 0;
        var completeBatch = 0;
        var onUpdate = function (index) {
            return function (v) {
                var _a;
                state[index] = v;
                if (++updateBatch >= props.length) {
                    (_a = opts.onUpdate) === null || _a === void 0 ? void 0 : _a.call(opts, state);
                    updateBatch = 0;
                }
            };
        };
        var onPlay = function () {
            var _a;
            if (++playBatch >= props.length) {
                (_a = opts.onPlay) === null || _a === void 0 ? void 0 : _a.call(opts);
            }
        };
        var onStop = function () {
            var _a;
            if (++stopBatch >= props.length) {
                (_a = opts.onStop) === null || _a === void 0 ? void 0 : _a.call(opts);
            }
        };
        var onComplete = function () {
            var _a;
            if (++completeBatch >= props.length) {
                (_a = opts.onComplete) === null || _a === void 0 ? void 0 : _a.call(opts);
            }
        };
        var index = 0;
        try {
            for (
                var props_1 = __values$z(props), props_1_1 = props_1.next();
                !props_1_1.done;
                props_1_1 = props_1.next()
            ) {
                var prop = props_1_1.value;
                var inner_id = id + '-' + index;
                this.animate(
                    inner_id,
                    __assign$P(__assign$P(__assign$P({}, opts), prop), {
                        onUpdate: onUpdate(index),
                        onPlay: onPlay,
                        onStop: onStop,
                        onComplete: onComplete,
                    }),
                );
                index++;
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (props_1_1 && !props_1_1.done && (_a = props_1.return)) _a.call(props_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    AnimationManager.prototype.animateWithThrottle = function (id, opts) {
        var _a;
        var throttleId = (_a = opts.throttleId) !== null && _a !== void 0 ? _a : id;
        if (this.throttles[throttleId] && opts.duration && Date.now() - this.throttles[throttleId] < opts.duration) {
            opts.delay = 0;
            opts.duration = 1;
        }
        this.throttles[id] = Date.now();
        this.animate(id, __assign$P({}, opts));
    };
    AnimationManager.prototype.animateManyWithThrottle = function (id, props, opts) {
        var _this = this;
        var _a;
        var throttleGroup = opts.throttleGroup;
        var throttleId = (_a = opts.throttleId) !== null && _a !== void 0 ? _a : id;
        var now = Date.now();
        var isThrottled =
            this.throttles[throttleId] && opts.duration && now - this.throttles[throttleId] < opts.duration;
        var inGroup = throttleGroup && this.throttleGroups.has(throttleGroup);
        if (isThrottled && !inGroup) {
            opts.delay = 0;
            opts.duration = 1;
        }
        if (!isThrottled && throttleGroup) {
            this.throttleGroups.add(throttleGroup);
        }
        var onStop = function () {
            var _a;
            if (throttleGroup) {
                _this.throttleGroups.delete(throttleGroup);
            }
            (_a = opts.onStop) === null || _a === void 0 ? void 0 : _a.call(opts);
        };
        this.throttles[throttleId] = now;
        return this.animateMany(id, props, __assign$P(__assign$P({}, opts), { onStop: onStop }));
    };
    AnimationManager.prototype.tween = function (opts) {
        var id = 'tween-' + btoa(JSON.stringify(opts));
        var optsExtra = __assign$P(__assign$P({}, opts), { driver: this.createDriver(id) });
        return tween(optsExtra);
    };
    AnimationManager.prototype.createDriver = function (id, disableInteractions) {
        var _this = this;
        return function (update) {
            return {
                start: function () {
                    _this.updaters.push([id, update]);
                    if (_this.requestId == null) {
                        _this.startAnimationCycle();
                    }
                    if (disableInteractions) {
                        _this.interactionManager.pause('animation_' + id);
                    }
                },
                stop: function () {
                    delete _this.controllers[id];
                    _this.updaters = _this.updaters.filter(function (_a) {
                        var _b = __read$_(_a, 1),
                            uid = _b[0];
                        return uid !== id;
                    });
                    if (_this.updaters.length <= 0) {
                        _this.cancelAnimationFrame();
                    }
                    if (disableInteractions) {
                        _this.interactionManager.resume('animation_' + id);
                    }
                },
                reset: function () {},
            };
        };
    };
    AnimationManager.prototype.startAnimationCycle = function () {
        var _this = this;
        if (this.updaters.length === 0) return;
        var frame = function (time) {
            _this.requestId = requestAnimationFrame(frame);
            if (!_this.readyToPlay) return;
            if (_this.lastTime === undefined) _this.lastTime = time;
            var deltaMs = time - _this.lastTime;
            _this.lastTime = time;
            if (_this.debug) {
                Logger.debug('AnimationManager - frame()', { updaterCount: _this.updaters.length });
            }
            _this.updaters.forEach(function (_a) {
                var _b = __read$_(_a, 2);
                _b[0];
                var update = _b[1];
                return update(deltaMs);
            });
            _this.listeners.dispatch('animation-frame', { type: 'animation-frame', deltaMs: deltaMs });
        };
        this.requestId = requestAnimationFrame(frame);
    };
    AnimationManager.prototype.cancelAnimationFrame = function () {
        if (!this.requestId) return;
        cancelAnimationFrame(this.requestId);
        this.requestId = undefined;
        this.lastTime = undefined;
    };
    return AnimationManager;
})(BaseManager);

var __read$Z =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
/**
 * Manages the cursor styling for an element. Tracks the requested styling from distinct
 * dependents and handles conflicting styling requests.
 */
var CursorManager = /** @class */ (function () {
    function CursorManager(element) {
        this.states = {};
        this.element = element;
    }
    CursorManager.prototype.updateCursor = function (callerId, style) {
        delete this.states[callerId];
        if (style != null) {
            this.states[callerId] = { style: style };
        }
        this.applyStates();
    };
    CursorManager.prototype.applyStates = function () {
        var styleToApply = 'default';
        // Last added entry wins.
        Object.entries(this.states)
            .reverse()
            .slice(0, 1)
            .forEach(function (_a) {
                var _b = __read$Z(_a, 2);
                _b[0];
                var style = _b[1].style;
                return (styleToApply = style);
            });
        this.element.style.cursor = styleToApply;
    };
    return CursorManager;
})();

var __extends$2F =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var ChartEventManager = /** @class */ (function (_super) {
    __extends$2F(ChartEventManager, _super);
    function ChartEventManager() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartEventManager.prototype.legendItemClick = function (series, itemId, enabled, legendItemName) {
        var event = {
            type: 'legend-item-click',
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName,
        };
        this.listeners.dispatch('legend-item-click', event);
    };
    ChartEventManager.prototype.legendItemDoubleClick = function (
        series,
        itemId,
        enabled,
        numVisibleItems,
        legendItemName,
    ) {
        var event = {
            type: 'legend-item-double-click',
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName,
            numVisibleItems: numVisibleItems,
        };
        this.listeners.dispatch('legend-item-double-click', event);
    };
    ChartEventManager.prototype.axisHover = function (axisId, direction) {
        var event = {
            type: 'axis-hover',
            axisId: axisId,
            direction: direction,
        };
        this.listeners.dispatch('axis-hover', event);
    };
    return ChartEventManager;
})(BaseManager);

var __extends$2E =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$Y =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
function isEqual$1(a, b) {
    if (a === b) return true;
    if ((a === null || a === void 0 ? void 0 : a.series) !== (b === null || b === void 0 ? void 0 : b.series))
        return false;
    if ((a === null || a === void 0 ? void 0 : a.itemId) !== (b === null || b === void 0 ? void 0 : b.itemId))
        return false;
    if ((a === null || a === void 0 ? void 0 : a.datum) !== (b === null || b === void 0 ? void 0 : b.datum))
        return false;
    return true;
}
/**
 * Manages the actively highlighted series/datum for a chart. Tracks the requested highlights from
 * distinct dependents and handles conflicting highlight requests.
 */
var HighlightManager = /** @class */ (function (_super) {
    __extends$2E(HighlightManager, _super);
    function HighlightManager() {
        var _this = _super.call(this) || this;
        _this.states = {};
        _this.activeHighlight = undefined;
        return _this;
    }
    HighlightManager.prototype.updateHighlight = function (callerId, highlightedDatum) {
        delete this.states[callerId];
        if (highlightedDatum != null) {
            this.states[callerId] = { highlightedDatum: highlightedDatum };
        }
        this.applyStates();
    };
    HighlightManager.prototype.getActiveHighlight = function () {
        return this.activeHighlight;
    };
    HighlightManager.prototype.applyStates = function () {
        var previousHighlight = this.activeHighlight;
        var highlightToApply = undefined;
        // Last added entry wins.
        Object.entries(this.states)
            .reverse()
            .slice(0, 1)
            .forEach(function (_a) {
                var _b = __read$Y(_a, 2);
                _b[0];
                var highlightedDatum = _b[1].highlightedDatum;
                return (highlightToApply = highlightedDatum);
            });
        this.activeHighlight = highlightToApply;
        var changed = !isEqual$1(previousHighlight, this.activeHighlight);
        if (changed) {
            var event_1 = {
                type: 'highlight-change',
                previousHighlight: previousHighlight,
                currentHighlight: this.activeHighlight,
            };
            this.listeners.dispatch('highlight-change', event_1);
        }
    };
    return HighlightManager;
})(BaseManager);

var __extends$2D =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$O =
    (undefined && undefined.__assign) ||
    function () {
        __assign$O =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$O.apply(this, arguments);
    };
var __awaiter$e =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$e =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __values$y =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var WINDOW_EVENT_HANDLERS = ['pagehide', 'mousemove', 'mouseup', 'wheel'];
var EVENT_HANDLERS = [
    'click',
    'dblclick',
    'contextmenu',
    'mousedown',
    'mouseout',
    'mouseenter',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
];
var CSS = '\n.ag-chart-wrapper {\n    touch-action: none;\n}\n';
/**
 * Manages user interactions with a specific HTMLElement (or interactions that bubble from it's
 * children)
 */
var InteractionManager = /** @class */ (function (_super) {
    __extends$2D(InteractionManager, _super);
    function InteractionManager(element, doc) {
        var e_1, _a, e_2, _b;
        if (doc === void 0) {
            doc = document;
        }
        var _this = _super.call(this) || this;
        _this.eventHandler = function (event) {
            return _this.processEvent(event);
        };
        _this.mouseDown = false;
        _this.touchDown = false;
        _this.enabled = true;
        _this.pausers = [];
        _this.rootElement = doc.body;
        _this.element = element;
        try {
            for (
                var EVENT_HANDLERS_1 = __values$y(EVENT_HANDLERS), EVENT_HANDLERS_1_1 = EVENT_HANDLERS_1.next();
                !EVENT_HANDLERS_1_1.done;
                EVENT_HANDLERS_1_1 = EVENT_HANDLERS_1.next()
            ) {
                var type = EVENT_HANDLERS_1_1.value;
                if (type.startsWith('touch')) {
                    element.addEventListener(type, _this.eventHandler, { passive: true });
                } else {
                    element.addEventListener(type, _this.eventHandler);
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (EVENT_HANDLERS_1_1 && !EVENT_HANDLERS_1_1.done && (_a = EVENT_HANDLERS_1.return))
                    _a.call(EVENT_HANDLERS_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        try {
            for (
                var WINDOW_EVENT_HANDLERS_1 = __values$y(WINDOW_EVENT_HANDLERS),
                    WINDOW_EVENT_HANDLERS_1_1 = WINDOW_EVENT_HANDLERS_1.next();
                !WINDOW_EVENT_HANDLERS_1_1.done;
                WINDOW_EVENT_HANDLERS_1_1 = WINDOW_EVENT_HANDLERS_1.next()
            ) {
                var type = WINDOW_EVENT_HANDLERS_1_1.value;
                if (type === 'wheel') {
                    window.addEventListener(type, _this.eventHandler, { passive: false });
                } else {
                    window.addEventListener(type, _this.eventHandler);
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (
                    WINDOW_EVENT_HANDLERS_1_1 &&
                    !WINDOW_EVENT_HANDLERS_1_1.done &&
                    (_b = WINDOW_EVENT_HANDLERS_1.return)
                )
                    _b.call(WINDOW_EVENT_HANDLERS_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        if (InteractionManager.interactionDocuments.indexOf(doc) < 0) {
            var styleElement = document.createElement('style');
            styleElement.innerHTML = CSS;
            document.head.insertBefore(styleElement, document.head.querySelector('style'));
            InteractionManager.interactionDocuments.push(doc);
        }
        return _this;
    }
    InteractionManager.prototype.destroy = function () {
        var e_3, _a, e_4, _b;
        try {
            for (
                var WINDOW_EVENT_HANDLERS_2 = __values$y(WINDOW_EVENT_HANDLERS),
                    WINDOW_EVENT_HANDLERS_2_1 = WINDOW_EVENT_HANDLERS_2.next();
                !WINDOW_EVENT_HANDLERS_2_1.done;
                WINDOW_EVENT_HANDLERS_2_1 = WINDOW_EVENT_HANDLERS_2.next()
            ) {
                var type = WINDOW_EVENT_HANDLERS_2_1.value;
                window.removeEventListener(type, this.eventHandler);
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (
                    WINDOW_EVENT_HANDLERS_2_1 &&
                    !WINDOW_EVENT_HANDLERS_2_1.done &&
                    (_a = WINDOW_EVENT_HANDLERS_2.return)
                )
                    _a.call(WINDOW_EVENT_HANDLERS_2);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        try {
            for (
                var EVENT_HANDLERS_2 = __values$y(EVENT_HANDLERS), EVENT_HANDLERS_2_1 = EVENT_HANDLERS_2.next();
                !EVENT_HANDLERS_2_1.done;
                EVENT_HANDLERS_2_1 = EVENT_HANDLERS_2.next()
            ) {
                var type = EVENT_HANDLERS_2_1.value;
                this.element.removeEventListener(type, this.eventHandler);
            }
        } catch (e_4_1) {
            e_4 = { error: e_4_1 };
        } finally {
            try {
                if (EVENT_HANDLERS_2_1 && !EVENT_HANDLERS_2_1.done && (_b = EVENT_HANDLERS_2.return))
                    _b.call(EVENT_HANDLERS_2);
            } finally {
                if (e_4) throw e_4.error;
            }
        }
    };
    InteractionManager.prototype.resume = function (callerId) {
        this.pausers = this.pausers.filter(function (id) {
            return id !== callerId;
        });
        this.enabled = this.pausers.length <= 0;
        return this.enabled;
    };
    InteractionManager.prototype.pause = function (callerId) {
        this.enabled = false;
        this.pausers.push(callerId);
    };
    InteractionManager.prototype.processEvent = function (event) {
        var types = this.decideInteractionEventTypes(event);
        if (types.length > 0 && this.enabled) {
            // Async dispatch to avoid blocking the event-processing thread.
            this.dispatchEvent(event, types).catch(function (e) {
                return Logger.errorOnce(e);
            });
        }
    };
    InteractionManager.prototype.dispatchEvent = function (event, types) {
        return __awaiter$e(this, void 0, void 0, function () {
            var coords, _loop_1, this_1, types_1, types_1_1, type;
            var e_5, _a;
            return __generator$e(this, function (_b) {
                coords = this.calculateCoordinates(event);
                if (coords == null) {
                    return [2 /*return*/];
                }
                _loop_1 = function (type) {
                    var interactionEvent = this_1.buildEvent(
                        __assign$O(__assign$O({ event: event }, coords), { type: type }),
                    );
                    this_1.listeners.cancellableDispatch(
                        type,
                        function () {
                            return interactionEvent.consumed;
                        },
                        interactionEvent,
                    );
                };
                this_1 = this;
                try {
                    for (
                        types_1 = __values$y(types), types_1_1 = types_1.next();
                        !types_1_1.done;
                        types_1_1 = types_1.next()
                    ) {
                        type = types_1_1.value;
                        _loop_1(type);
                    }
                } catch (e_5_1) {
                    e_5 = { error: e_5_1 };
                } finally {
                    try {
                        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
                    } finally {
                        if (e_5) throw e_5.error;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    InteractionManager.prototype.decideInteractionEventTypes = function (event) {
        switch (event.type) {
            case 'click':
                return ['click'];
            case 'dblclick':
                return ['dblclick'];
            case 'contextmenu':
                return ['contextmenu'];
            case 'mousedown':
                this.mouseDown = true;
                this.dragStartElement = event.target;
                return ['drag-start'];
            case 'touchstart':
                this.touchDown = true;
                this.dragStartElement = event.target;
                return ['drag-start'];
            case 'touchmove':
            case 'mousemove':
                if (!this.mouseDown && !this.touchDown && !this.isEventOverElement(event)) {
                    // We only care about these events if the target is the canvas, unless
                    // we're in the middle of a drag/slide.
                    return [];
                }
                return this.mouseDown || this.touchDown ? ['drag'] : ['hover'];
            case 'mouseup':
                if (!this.mouseDown && !this.isEventOverElement(event)) {
                    // We only care about these events if the target is the canvas, unless
                    // we're in the middle of a drag.
                    return [];
                }
                this.mouseDown = false;
                this.dragStartElement = undefined;
                return ['drag-end'];
            case 'touchend':
                if (!this.touchDown && !this.isEventOverElement(event)) {
                    // We only care about these events if the target is the canvas, unless
                    // we're in the middle of a slide.
                    return [];
                }
                this.touchDown = false;
                this.dragStartElement = undefined;
                return ['drag-end'];
            case 'mouseout':
            case 'touchcancel':
                return ['leave'];
            case 'mouseenter':
                var mouseButtonDown = event instanceof MouseEvent && (event.buttons & 1) === 1;
                if (this.mouseDown !== mouseButtonDown) {
                    this.mouseDown = mouseButtonDown;
                    return [mouseButtonDown ? 'drag-start' : 'drag-end'];
                }
                return [];
            case 'pagehide':
                return ['page-left'];
            case 'wheel':
                return ['wheel'];
        }
        return [];
    };
    InteractionManager.prototype.isEventOverElement = function (event) {
        var _a;
        return (
            event.target === this.element ||
            ((_a = event.target) === null || _a === void 0 ? void 0 : _a.parentElement) === this.element
        );
    };
    InteractionManager.prototype.calculateCoordinates = function (event) {
        var _a;
        if (event instanceof MouseEvent) {
            var clientX = event.clientX,
                clientY = event.clientY,
                pageX = event.pageX,
                pageY = event.pageY,
                offsetX = event.offsetX,
                offsetY = event.offsetY;
            return this.fixOffsets(event, {
                clientX: clientX,
                clientY: clientY,
                pageX: pageX,
                pageY: pageY,
                offsetX: offsetX,
                offsetY: offsetY,
            });
        } else if (typeof TouchEvent !== 'undefined' && event instanceof TouchEvent) {
            var lastTouch = (_a = event.touches[0]) !== null && _a !== void 0 ? _a : event.changedTouches[0];
            var clientX = lastTouch.clientX,
                clientY = lastTouch.clientY,
                pageX = lastTouch.pageX,
                pageY = lastTouch.pageY;
            return __assign$O(__assign$O({}, InteractionManager.NULL_COORDS), {
                clientX: clientX,
                clientY: clientY,
                pageX: pageX,
                pageY: pageY,
            });
        } else if (event instanceof PageTransitionEvent) {
            if (event.persisted) {
                // Don't fire the page-left event since the page maybe revisited.
                return;
            }
            return InteractionManager.NULL_COORDS;
        }
        // Unsupported event - abort.
    };
    InteractionManager.prototype.fixOffsets = function (event, coords) {
        var offsets = function (el) {
            var x = 0;
            var y = 0;
            while (el) {
                x += el.offsetLeft;
                y += el.offsetTop;
                el = el.offsetParent;
            }
            return { x: x, y: y };
        };
        if (this.dragStartElement != null && event.target !== this.dragStartElement) {
            // Offsets need to be relative to the drag-start element to avoid jumps when
            // the pointer moves between element boundaries.
            var offsetDragStart = offsets(this.dragStartElement);
            var offsetEvent = offsets(event.target);
            coords.offsetX -= offsetDragStart.x - offsetEvent.x;
            coords.offsetY -= offsetDragStart.y - offsetEvent.y;
        }
        return coords;
    };
    InteractionManager.prototype.buildEvent = function (opts) {
        var type = opts.type,
            event = opts.event,
            clientX = opts.clientX,
            clientY = opts.clientY;
        var offsetX = opts.offsetX,
            offsetY = opts.offsetY,
            pageX = opts.pageX,
            pageY = opts.pageY;
        if (!isNumber$4(offsetX) || !isNumber$4(offsetY)) {
            var rect = this.element.getBoundingClientRect();
            offsetX = clientX - rect.left;
            offsetY = clientY - rect.top;
        }
        if (!isNumber$4(pageX) || !isNumber$4(pageY)) {
            var pageRect = this.rootElement.getBoundingClientRect();
            pageX = clientX - pageRect.left;
            pageY = clientY - pageRect.top;
        }
        var builtEvent = {
            type: type,
            offsetX: offsetX,
            offsetY: offsetY,
            pageX: pageX,
            pageY: pageY,
            sourceEvent: event,
            consumed: false,
            consume: function () {
                return (builtEvent.consumed = true);
            },
        };
        return builtEvent;
    };
    InteractionManager.interactionDocuments = [];
    InteractionManager.NULL_COORDS = {
        clientX: -Infinity,
        clientY: -Infinity,
        pageX: -Infinity,
        pageY: -Infinity,
        offsetX: -Infinity,
        offsetY: -Infinity,
    };
    return InteractionManager;
})(BaseManager);

var __values$x =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$X =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
/**
 * Manages the tooltip HTML an element. Tracks the requested HTML from distinct dependents and
 * handles conflicting tooltip requests.
 */
var TooltipManager = /** @class */ (function () {
    function TooltipManager(tooltip, interactionManager) {
        var _this = this;
        this.states = {};
        this.exclusiveAreas = {};
        this.destroyFns = [];
        this.tooltip = tooltip;
        var hoverRef = interactionManager.addListener('hover', function (e) {
            return _this.checkExclusiveRects(e);
        });
        this.destroyFns.push(function () {
            return interactionManager.removeListener(hoverRef);
        });
    }
    TooltipManager.prototype.updateTooltip = function (callerId, meta, content) {
        var _a;
        if (content == null) {
            content = (_a = this.states[callerId]) === null || _a === void 0 ? void 0 : _a.content;
        }
        this.states[callerId] = { content: content, meta: meta };
        this.applyStates();
    };
    TooltipManager.prototype.updateExclusiveRect = function (callerId, area) {
        if (area) {
            this.exclusiveAreas[callerId] = area;
        } else {
            delete this.exclusiveAreas[callerId];
        }
    };
    TooltipManager.prototype.removeTooltip = function (callerId) {
        delete this.states[callerId];
        this.applyStates();
    };
    TooltipManager.prototype.getTooltipMeta = function (callerId) {
        var _a;
        return (_a = this.states[callerId]) === null || _a === void 0 ? void 0 : _a.meta;
    };
    TooltipManager.prototype.destroy = function () {
        var e_1, _a;
        try {
            for (var _b = __values$x(this.destroyFns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var destroyFn = _c.value;
                destroyFn();
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    TooltipManager.prototype.checkExclusiveRects = function (e) {
        var e_2, _a;
        var newAppliedExclusiveArea;
        try {
            for (var _b = __values$x(Object.entries(this.exclusiveAreas)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read$X(_c.value, 2),
                    entryId = _d[0],
                    area = _d[1];
                if (!area.containsPoint(e.offsetX, e.offsetY)) {
                    continue;
                }
                newAppliedExclusiveArea = entryId;
                break;
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        if (newAppliedExclusiveArea === this.appliedExclusiveArea) {
            return;
        }
        this.appliedExclusiveArea = newAppliedExclusiveArea;
        this.applyStates();
    };
    TooltipManager.prototype.applyStates = function () {
        var _this = this;
        var _a;
        var ids = this.appliedExclusiveArea ? [this.appliedExclusiveArea] : Object.keys(this.states);
        var contentToApply = undefined;
        var metaToApply = undefined;
        // Last added entry wins.
        ids.reverse();
        ids.slice(0, 1).forEach(function (id) {
            var _a;
            var _b = (_a = _this.states[id]) !== null && _a !== void 0 ? _a : {},
                content = _b.content,
                meta = _b.meta;
            contentToApply = content;
            metaToApply = meta;
        });
        if (metaToApply === undefined || contentToApply === undefined) {
            this.appliedState = undefined;
            this.tooltip.toggle(false);
            return;
        }
        if (((_a = this.appliedState) === null || _a === void 0 ? void 0 : _a.content) === contentToApply) {
            var renderInstantly = this.tooltip.isVisible();
            this.tooltip.show(metaToApply, undefined, renderInstantly);
        } else {
            this.tooltip.show(metaToApply, contentToApply);
        }
        this.appliedState = { content: contentToApply, meta: metaToApply };
    };
    return TooltipManager;
})();

var __extends$2C =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$N =
    (undefined && undefined.__assign) ||
    function () {
        __assign$N =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$N.apply(this, arguments);
    };
var __values$w =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$W =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
/**
 * Manages the current zoom state for a chart. Tracks the requested zoom from distinct dependents
 * and handles conflicting zoom requests.
 */
var ZoomManager = /** @class */ (function (_super) {
    __extends$2C(ZoomManager, _super);
    function ZoomManager() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.axes = {};
        return _this;
    }
    ZoomManager.prototype.updateAxes = function (axes) {
        var _this = this;
        var removedAxes = new Set(Object.keys(this.axes));
        axes.forEach(function (axis) {
            var _a;
            var _b, _c;
            removedAxes.delete(axis.id);
            (_a = (_b = _this.axes)[(_c = axis.id)]) !== null && _a !== void 0
                ? _a
                : (_b[_c] = new AxisZoomManager(axis));
        });
        removedAxes.forEach(function (axisId) {
            delete _this.axes[axisId];
        });
        if (this.initialZoom) {
            this.updateZoom(this.initialZoom.callerId, this.initialZoom.newZoom);
            this.initialZoom = undefined;
        }
    };
    ZoomManager.prototype.updateZoom = function (callerId, newZoom) {
        if (Object.keys(this.axes).length === 0) {
            this.initialZoom = { callerId: callerId, newZoom: newZoom };
            return;
        }
        Object.values(this.axes).forEach(function (axis) {
            axis.updateZoom(callerId, newZoom === null || newZoom === void 0 ? void 0 : newZoom[axis.getDirection()]);
        });
        this.applyStates();
    };
    ZoomManager.prototype.updateAxisZoom = function (callerId, axisId, newZoom) {
        var _a;
        (_a = this.axes[axisId]) === null || _a === void 0 ? void 0 : _a.updateZoom(callerId, newZoom);
        this.applyStates();
    };
    ZoomManager.prototype.getZoom = function () {
        var x;
        var y;
        // TODO: this only works when there is a single axis on each direction as it gets the last of each
        Object.values(this.axes).forEach(function (axis) {
            if (axis.getDirection() === ChartAxisDirection.X) {
                x = axis.getZoom();
            } else if (axis.getDirection() === ChartAxisDirection.Y) {
                y = axis.getZoom();
            }
        });
        if (x || y) {
            return { x: x, y: y };
        }
    };
    ZoomManager.prototype.getAxisZoom = function (axisId) {
        var _a;
        return (_a = this.axes[axisId]) === null || _a === void 0 ? void 0 : _a.getZoom();
    };
    ZoomManager.prototype.getAxisZooms = function () {
        var e_1, _a;
        var axes = {};
        try {
            for (var _b = __values$w(Object.entries(this.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read$W(_c.value, 2),
                    axisId = _d[0],
                    axis = _d[1];
                axes[axisId] = {
                    direction: axis.getDirection(),
                    zoom: axis.getZoom(),
                };
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return axes;
    };
    ZoomManager.prototype.applyStates = function () {
        var e_2, _a;
        var changed = Object.values(this.axes)
            .map(function (axis) {
                return axis.applyStates();
            })
            .some(Boolean);
        if (!changed) {
            return;
        }
        var currentZoom = this.getZoom();
        var axes = {};
        try {
            for (var _b = __values$w(Object.entries(this.axes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read$W(_c.value, 2),
                    axisId = _d[0],
                    axis = _d[1];
                axes[axisId] = axis.getZoom();
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        var event = __assign$N(
            __assign$N({ type: 'zoom-change' }, currentZoom !== null && currentZoom !== void 0 ? currentZoom : {}),
            { axes: axes },
        );
        this.listeners.dispatch('zoom-change', event);
    };
    return ZoomManager;
})(BaseManager);
var AxisZoomManager = /** @class */ (function () {
    function AxisZoomManager(axis) {
        this.states = {};
        this.currentZoom = undefined;
        this.axis = axis;
    }
    AxisZoomManager.prototype.getDirection = function () {
        return this.axis.direction;
    };
    AxisZoomManager.prototype.updateZoom = function (callerId, newZoom) {
        delete this.states[callerId];
        if (newZoom != null) {
            this.states[callerId] = __assign$N({}, newZoom);
        }
    };
    AxisZoomManager.prototype.getZoom = function () {
        return this.currentZoom;
    };
    AxisZoomManager.prototype.applyStates = function () {
        var _a, _b;
        var prevZoom = this.currentZoom;
        var last = Object.keys(this.states)[Object.keys(this.states).length - 1];
        this.currentZoom = __assign$N({}, this.states[last]);
        var changed =
            (prevZoom === null || prevZoom === void 0 ? void 0 : prevZoom.min) !==
                ((_a = this.currentZoom) === null || _a === void 0 ? void 0 : _a.min) ||
            (prevZoom === null || prevZoom === void 0 ? void 0 : prevZoom.max) !==
                ((_b = this.currentZoom) === null || _b === void 0 ? void 0 : _b.max);
        return changed;
    };
    return AxisZoomManager;
})();

var __assign$M =
    (undefined && undefined.__assign) ||
    function () {
        __assign$M =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$M.apply(this, arguments);
    };
function isLayoutStage(t) {
    return t !== 'layout-complete';
}
function isLayoutComplete(t) {
    return t === 'layout-complete';
}
var LayoutService = /** @class */ (function () {
    function LayoutService() {
        this.layoutProcessors = new Listeners();
        this.listeners = new Listeners();
    }
    LayoutService.prototype.addListener = function (type, cb) {
        if (isLayoutStage(type)) {
            return this.layoutProcessors.addListener(type, cb);
        } else if (isLayoutComplete(type)) {
            return this.listeners.addListener(type, cb);
        }
        throw new Error('AG Charts - unsupported listener type: ' + type);
    };
    LayoutService.prototype.removeListener = function (listenerSymbol) {
        this.listeners.removeListener(listenerSymbol);
        this.layoutProcessors.removeListener(listenerSymbol);
    };
    LayoutService.prototype.dispatchPerformLayout = function (stage, ctx) {
        var result = this.layoutProcessors.reduceDispatch(
            stage,
            function (_a, ctx) {
                var shrinkRect = _a.shrinkRect;
                return [__assign$M(__assign$M({}, ctx), { shrinkRect: shrinkRect })];
            },
            ctx,
        );
        return result !== null && result !== void 0 ? result : ctx;
    };
    LayoutService.prototype.dispatchLayoutComplete = function (event) {
        this.listeners.dispatch('layout-complete', event);
    };
    return LayoutService;
})();

var DataService = /** @class */ (function () {
    function DataService(getSeries) {
        this.getSeries = getSeries;
    }
    return DataService;
})();

/** Types of chart-update, in pipeline execution order. */
var ChartUpdateType;
(function (ChartUpdateType) {
    ChartUpdateType[(ChartUpdateType['FULL'] = 0)] = 'FULL';
    ChartUpdateType[(ChartUpdateType['PROCESS_DATA'] = 1)] = 'PROCESS_DATA';
    ChartUpdateType[(ChartUpdateType['PERFORM_LAYOUT'] = 2)] = 'PERFORM_LAYOUT';
    ChartUpdateType[(ChartUpdateType['SERIES_UPDATE'] = 3)] = 'SERIES_UPDATE';
    ChartUpdateType[(ChartUpdateType['TOOLTIP_RECALCULATION'] = 4)] = 'TOOLTIP_RECALCULATION';
    ChartUpdateType[(ChartUpdateType['SCENE_RENDER'] = 5)] = 'SCENE_RENDER';
    ChartUpdateType[(ChartUpdateType['NONE'] = 6)] = 'NONE';
})(ChartUpdateType || (ChartUpdateType = {}));

var UpdateService = /** @class */ (function () {
    function UpdateService(updateCallback) {
        this.updateCallback = updateCallback;
    }
    UpdateService.prototype.update = function (type, _a) {
        if (type === void 0) {
            type = ChartUpdateType.FULL;
        }
        var _b = _a === void 0 ? {} : _a,
            _c = _b.forceNodeDataRefresh,
            forceNodeDataRefresh = _c === void 0 ? false : _c;
        this.updateCallback(type, { forceNodeDataRefresh: forceNodeDataRefresh });
    };
    return UpdateService;
})();

var __decorate$1R =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartHighlight = /** @class */ (function () {
    function ChartHighlight() {
        this.range = 'tooltip';
    }
    __decorate$1R([Validate(STRING_UNION('tooltip', 'node'))], ChartHighlight.prototype, 'range', void 0);
    return ChartHighlight;
})();

var __values$v =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$V =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var Selection = /** @class */ (function () {
    function Selection(parent, classOrFactory, garbageCollection) {
        if (garbageCollection === void 0) {
            garbageCollection = true;
        }
        this._nodes = [];
        this._data = [];
        this._datumNodeIndices = new Map();
        // If garbage collection is set to false, you must call `selection.cleanup()` to remove deleted nodes
        this._garbage = [];
        this._garbageCollection = true;
        this._parent = parent;
        this._factory = Object.prototype.isPrototypeOf.call(Node, classOrFactory)
            ? function () {
                  return new classOrFactory();
              }
            : classOrFactory;
        this._garbageCollection = garbageCollection;
    }
    Selection.select = function (parent, classOrFactory, garbageCollection) {
        if (garbageCollection === void 0) {
            garbageCollection = true;
        }
        return new Selection(parent, classOrFactory, garbageCollection);
    };
    Selection.prototype.each = function (iterate) {
        this._nodes.forEach(function (node, i) {
            return iterate(node, node.datum, i);
        });
        return this;
    };
    /**
     * Update the data in a selection. If an `getDatumId()` function is provided, maintain a list of ids related to
     * the nodes. Otherwise, take the more efficient route of simply creating and destroying nodes at the end
     * of the array.
     */
    Selection.prototype.update = function (data, init, getDatumId) {
        var e_1, _a;
        var _this = this;
        var old = this._data;
        var parent = this._parent;
        var factory = this._factory;
        var datumIds = new Map();
        if (getDatumId) {
            // Check if new datum and append node and save map of datum id to node index
            data.forEach(function (datum, index) {
                var datumId = getDatumId(datum);
                datumIds.set(datumId, index);
                if (!_this._datumNodeIndices.has(datumId)) {
                    var node = factory(datum);
                    node.datum = datum;
                    init === null || init === void 0 ? void 0 : init(node);
                    parent.appendChild(node);
                    _this._nodes.push(node);
                    _this._datumNodeIndices.set(datumId, _this._nodes.length - 1);
                }
            });
        } else if (data.length > old.length) {
            // Create and append nodes for new data
            data.slice(old.length).forEach(function (datum) {
                var node = factory(datum);
                node.datum = datum;
                init === null || init === void 0 ? void 0 : init(node);
                parent.appendChild(node);
                _this._nodes.push(node);
            });
        } else if (data.length < old.length) {
            // Destroy any nodes that are in excess of the new data
            this._nodes.splice(data.length).forEach(function (node) {
                parent.removeChild(node);
            });
        }
        // Copy the data into a new array to prevent mutation and duplicates
        this._data = data.slice(0);
        if (getDatumId) {
            try {
                // Find and update the datum for each node or throw into garbage if datum no longer exists
                for (var _b = __values$v(this._datumNodeIndices), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var _d = __read$V(_c.value, 2),
                        datumId = _d[0],
                        nodeIndex = _d[1];
                    var datumIndex = datumIds.get(datumId);
                    if (datumIndex !== undefined) {
                        this._nodes[nodeIndex].datum = data[datumIndex];
                    } else {
                        this._garbage.push(datumId);
                    }
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
            if (this._garbageCollection) {
                this.cleanup();
            }
        } else {
            // Reset the node data by index
            for (var i = 0; i < data.length; i++) {
                this._nodes[i].datum = this._data[i];
            }
        }
        return this;
    };
    Selection.prototype.clear = function () {
        this.update([]);
        return this;
    };
    Selection.prototype.cleanup = function () {
        var e_2, _a;
        var _this = this;
        if (this._garbage.length === 0) return;
        this._garbage.forEach(function (datumId) {
            var nodeIndex = _this._datumNodeIndices.get(datumId);
            if (nodeIndex === undefined) return;
            var node = _this._nodes[nodeIndex];
            delete _this._nodes[nodeIndex];
            _this._datumNodeIndices.delete(datumId);
            if (node) {
                _this._parent.removeChild(node);
            }
        });
        // Reset map of datum ids to node indices while filtering out any removed, undefined, nodes
        var newIndex = 0;
        var datumNodeIndices = this._datumNodeIndices.entries();
        var nodeIndexDatums = new Map();
        try {
            for (
                var datumNodeIndices_1 = __values$v(datumNodeIndices), datumNodeIndices_1_1 = datumNodeIndices_1.next();
                !datumNodeIndices_1_1.done;
                datumNodeIndices_1_1 = datumNodeIndices_1.next()
            ) {
                var _b = __read$V(datumNodeIndices_1_1.value, 2),
                    datumId = _b[0],
                    nodeIndex = _b[1];
                nodeIndexDatums.set(nodeIndex, datumId);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (datumNodeIndices_1_1 && !datumNodeIndices_1_1.done && (_a = datumNodeIndices_1.return))
                    _a.call(datumNodeIndices_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        this._nodes = this._nodes.filter(function (node, index) {
            if (node === undefined) return false;
            var datumId = nodeIndexDatums.get(index);
            _this._datumNodeIndices.set(datumId, newIndex);
            newIndex++;
            return true;
        });
        this._garbage = [];
    };
    Selection.selectAll = function (parent, predicate) {
        var results = [];
        var traverse = function (node) {
            if (predicate(node)) {
                results.push(node);
            }
            node.children.forEach(traverse);
        };
        traverse(parent);
        return results;
    };
    Selection.selectByClass = function (node, Class) {
        return Selection.selectAll(node, function (node) {
            return node instanceof Class;
        });
    };
    Selection.selectByTag = function (node, tag) {
        return Selection.selectAll(node, function (node) {
            return node.tag === tag;
        });
    };
    Selection.prototype.select = function (predicate) {
        return Selection.selectAll(this._parent, predicate);
    };
    Selection.prototype.selectByClass = function (Class) {
        return this.select(function (node) {
            return node instanceof Class;
        });
    };
    Selection.prototype.selectByTag = function (tag) {
        return this.select(function (node) {
            return node.tag === tag;
        });
    };
    Selection.prototype.nodes = function () {
        return this._nodes;
    };
    return Selection;
})();

/**
 * Finds the roots of a parametric linear equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function linearRoot(a, b) {
    var t = -b / a;
    return a !== 0 && t >= 0 && t <= 1 ? [t] : [];
}
/**
 * Finds the roots of a parametric quadratic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 */
function quadraticRoots(a, b, c) {
    if (a === 0) {
        return linearRoot(b, c);
    }
    var D = b * b - 4 * a * c; // The polynomial's discriminant.
    var roots = [];
    if (D === 0) {
        // A single real root.
        var t = -b / (2 * a);
        if (t >= 0 && t <= 1) {
            roots.push(t);
        }
    } else if (D > 0) {
        // A pair of distinct real roots.
        var rD = Math.sqrt(D);
        var t1 = (-b - rD) / (2 * a);
        var t2 = (-b + rD) / (2 * a);
        if (t1 >= 0 && t1 <= 1) {
            roots.push(t1);
        }
        if (t2 >= 0 && t2 <= 1) {
            roots.push(t2);
        }
    }
    // else -> Complex roots.
    return roots;
}
/**
 * Finds the roots of a parametric cubic equation in `t`,
 * where `t` lies in the interval of `[0,1]`.
 * Returns an array of parametric intersection locations along the cubic,
 * excluding out-of-bounds intersections (before or after the end point
 * or in the imaginary plane).
 * An adaptation of http://www.particleincell.com/blog/2013/cubic-line-intersection/
 */
function cubicRoots(a, b, c, d) {
    if (a === 0) {
        return quadraticRoots(b, c, d);
    }
    var A = b / a;
    var B = c / a;
    var C = d / a;
    var Q = (3 * B - A * A) / 9;
    var R = (9 * A * B - 27 * C - 2 * A * A * A) / 54;
    var D = Q * Q * Q + R * R; // The polynomial's discriminant.
    var third = 1 / 3;
    var roots = [];
    if (D >= 0) {
        // Complex or duplicate roots.
        var rD = Math.sqrt(D);
        var S = Math.sign(R + rD) * Math.pow(Math.abs(R + rD), third);
        var T = Math.sign(R - rD) * Math.pow(Math.abs(R - rD), third);
        var Im = Math.abs((Math.sqrt(3) * (S - T)) / 2); // Complex part of the root pair.
        var t = -third * A + (S + T); // A real root.
        if (t >= 0 && t <= 1) {
            roots.push(t);
        }
        if (Im === 0) {
            var t_1 = -third * A - (S + T) / 2; // The real part of a complex root.
            if (t_1 >= 0 && t_1 <= 1) {
                roots.push(t_1);
            }
        }
    } else {
        // Distinct real roots.
        var theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
        var thirdA = third * A;
        var twoSqrtQ = 2 * Math.sqrt(-Q);
        var t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
        var t2 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
        var t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
        if (t1 >= 0 && t1 <= 1) {
            roots.push(t1);
        }
        if (t2 >= 0 && t2 <= 1) {
            roots.push(t2);
        }
        if (t3 >= 0 && t3 <= 1) {
            roots.push(t3);
        }
    }
    return roots;
}

var __values$u =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
/**
 * Returns the intersection point for the given pair of line segments, or null,
 * if the segments are parallel or don't intersect.
 * Based on http://paulbourke.net/geometry/pointlineplane/
 */
function segmentIntersection(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
    var d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
    if (d === 0) {
        // The lines are parallel.
        return null;
    }
    var ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
    var ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) {
        return {
            x: ax1 + ua * (ax2 - ax1),
            y: ay1 + ua * (ay2 - ay1),
        };
    }
    return null; // The intersection point is outside either or both segments.
}
/**
 * Returns intersection points of the given cubic curve and the line segment.
 * Takes in x/y components of cubic control points and line segment start/end points
 * as parameters.
 */
function cubicSegmentIntersections(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
    var e_1, _a;
    var intersections = [];
    // Find line equation coefficients.
    var A = y1 - y2;
    var B = x2 - x1;
    var C = x1 * (y2 - y1) - y1 * (x2 - x1);
    // Find cubic Bezier curve equation coefficients from control points.
    var bx = bezierCoefficients(px1, px2, px3, px4);
    var by = bezierCoefficients(py1, py2, py3, py4);
    var a = A * bx[0] + B * by[0]; // t^3
    var b = A * bx[1] + B * by[1]; // t^2
    var c = A * bx[2] + B * by[2]; // t
    var d = A * bx[3] + B * by[3] + C; // 1
    var roots = cubicRoots(a, b, c, d);
    try {
        // Verify that the roots are within bounds of the linear segment.
        for (var roots_1 = __values$u(roots), roots_1_1 = roots_1.next(); !roots_1_1.done; roots_1_1 = roots_1.next()) {
            var t = roots_1_1.value;
            var tt = t * t;
            var ttt = t * tt;
            // Find the cartesian plane coordinates for the parametric root `t`.
            var x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
            var y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
            // The parametric cubic roots we found are intersection points
            // with an infinite line, and so the x/y coordinates above are as well.
            // Make sure the x/y is also within the bounds of the given segment.
            var s = void 0;
            if (x1 !== x2) {
                s = (x - x1) / (x2 - x1);
            } else {
                // the line is vertical
                s = (y - y1) / (y2 - y1);
            }
            if (s >= 0 && s <= 1) {
                intersections.push({ x: x, y: y });
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (roots_1_1 && !roots_1_1.done && (_a = roots_1.return)) _a.call(roots_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return intersections;
}
/**
 * Returns the given coordinates vector multiplied by the coefficient matrix
 * of the parametric cubic Bézier equation.
 */
function bezierCoefficients(P1, P2, P3, P4) {
    return [
        // Bézier expressed as matrix operations:
        -P1 + 3 * P2 - 3 * P3 + P4,
        3 * P1 - 6 * P2 + 3 * P3,
        -3 * P1 + 3 * P2,
        P1, //                 | 1  0  0  0| |P4|
    ];
}
/**
 * Returns intersection points of the arc and the line segment.
 * Takes in arc parameters and line segment start/end points.
 */
function arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, x1, y1, x2, y2) {
    // Solving the quadratic equation:
    // 1. y = k * x + y0
    // 2. (x - cx)^2 + (y - cy)^2 = r^2
    var k = (y2 - y1) / (x2 - x1);
    var y0 = y1 - k * x1;
    var a = Math.pow(k, 2) + 1;
    var b = 2 * (k * (y0 - cy) - cx);
    var c = Math.pow(cx, 2) + Math.pow(y0 - cy, 2) - Math.pow(r, 2);
    var d = Math.pow(b, 2) - 4 * a * c;
    if (d < 0) {
        return [];
    }
    var i1x = (-b + Math.sqrt(d)) / 2 / a;
    var i2x = (-b - Math.sqrt(d)) / 2 / a;
    var intersections = [];
    [i1x, i2x].forEach(function (x) {
        var isXInsideLine = x >= Math.min(x1, x2) && x <= Math.max(x1, x2);
        if (!isXInsideLine) {
            return;
        }
        var y = k * x;
        var a1 = normalizeAngle360(counterClockwise ? endAngle : startAngle);
        var a2 = normalizeAngle360(counterClockwise ? startAngle : endAngle);
        var intersectionAngle = normalizeAngle360(Math.atan2(y, x));
        // Order angles clockwise after the start angle
        // (end angle if counter-clockwise)
        if (a2 <= a1) {
            a2 += 2 * Math.PI;
        }
        if (intersectionAngle < a1) {
            intersectionAngle += 2 * Math.PI;
        }
        if (intersectionAngle >= a1 && intersectionAngle <= a2) {
            intersections.push({ x: x, y: y });
        }
    });
    return intersections;
}

var __values$t =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var Command;
(function (Command) {
    Command[(Command['Move'] = 0)] = 'Move';
    Command[(Command['Line'] = 1)] = 'Line';
    Command[(Command['Arc'] = 2)] = 'Arc';
    Command[(Command['Curve'] = 3)] = 'Curve';
    Command[(Command['ClosePath'] = 4)] = 'ClosePath';
})(Command || (Command = {}));
var Path2D = /** @class */ (function () {
    function Path2D() {
        // The methods of this class will likely be called many times per animation frame,
        // and any allocation can trigger a GC cycle during animation, so we attempt
        // to minimize the number of allocations.
        this.previousCommands = [];
        this.previousParams = [];
        this.previousClosedPath = false;
        this.commands = [];
        this.params = [];
        this._closedPath = false;
    }
    Path2D.prototype.isDirty = function () {
        if (this._closedPath !== this.previousClosedPath) {
            return true;
        }
        if (this.previousCommands.length !== this.commands.length) {
            return true;
        }
        if (this.previousParams.length !== this.params.length) {
            return true;
        }
        for (var i = 0; i < this.commands.length; i++) {
            if (this.commands[i] !== this.previousCommands[i]) {
                return true;
            }
        }
        for (var i = 0; i < this.params.length; i++) {
            if (this.params[i] !== this.previousParams[i]) {
                return true;
            }
        }
        return false;
    };
    Path2D.prototype.draw = function (ctx) {
        var e_1, _a;
        var commands = this.commands;
        var params = this.params;
        var j = 0;
        ctx.beginPath();
        try {
            for (
                var commands_1 = __values$t(commands), commands_1_1 = commands_1.next();
                !commands_1_1.done;
                commands_1_1 = commands_1.next()
            ) {
                var command = commands_1_1.value;
                switch (command) {
                    case Command.Move:
                        ctx.moveTo(params[j++], params[j++]);
                        break;
                    case Command.Line:
                        ctx.lineTo(params[j++], params[j++]);
                        break;
                    case Command.Curve:
                        ctx.bezierCurveTo(params[j++], params[j++], params[j++], params[j++], params[j++], params[j++]);
                        break;
                    case Command.Arc:
                        ctx.arc(params[j++], params[j++], params[j++], params[j++], params[j++], params[j++] === 1);
                        break;
                    case Command.ClosePath:
                        ctx.closePath();
                        break;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (commands_1_1 && !commands_1_1.done && (_a = commands_1.return)) _a.call(commands_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        if (commands.length === 0) {
            ctx.closePath();
        }
    };
    Path2D.prototype.moveTo = function (x, y) {
        if (this.xy) {
            this.xy[0] = x;
            this.xy[1] = y;
        } else {
            this.xy = [x, y];
        }
        this.commands.push(Command.Move);
        this.params.push(x, y);
    };
    Path2D.prototype.lineTo = function (x, y) {
        if (this.xy) {
            this.commands.push(Command.Line);
            this.params.push(x, y);
            this.xy[0] = x;
            this.xy[1] = y;
        } else {
            this.moveTo(x, y);
        }
    };
    Path2D.prototype.rect = function (x, y, width, height) {
        this.moveTo(x, y);
        this.lineTo(x + width, y);
        this.lineTo(x + width, y + height);
        this.lineTo(x, y + height);
        this.closePath();
    };
    Path2D.prototype.arc = function (x, y, r, sAngle, eAngle, antiClockwise) {
        if (antiClockwise === void 0) {
            antiClockwise = false;
        }
        var endX = x + r * Math.cos(eAngle);
        var endY = y + r * Math.sin(eAngle);
        if (this.xy) {
            this.xy[0] = endX;
            this.xy[1] = endY;
        } else {
            this.xy = [endX, endY];
        }
        this.commands.push(Command.Arc);
        this.params.push(x, y, r, sAngle, eAngle, antiClockwise ? 1 : 0);
    };
    Path2D.prototype.cubicCurveTo = function (cx1, cy1, cx2, cy2, x, y) {
        if (!this.xy) {
            this.moveTo(cx1, cy1);
        }
        this.commands.push(Command.Curve);
        this.params.push(cx1, cy1, cx2, cy2, x, y);
        if (this.xy) {
            this.xy[0] = x;
            this.xy[1] = y;
        }
    };
    Object.defineProperty(Path2D.prototype, 'closedPath', {
        get: function () {
            return this._closedPath;
        },
        enumerable: false,
        configurable: true,
    });
    Path2D.prototype.closePath = function () {
        if (this.xy) {
            this.xy = undefined;
            this.commands.push(Command.ClosePath);
            this._closedPath = true;
        }
    };
    Path2D.prototype.clear = function (_a) {
        var _b = _a === void 0 ? { trackChanges: false } : _a,
            trackChanges = _b.trackChanges;
        if (trackChanges) {
            this.previousCommands = this.commands;
            this.previousParams = this.params;
            this.previousClosedPath = this._closedPath;
            this.commands = [];
            this.params = [];
        } else {
            this.commands.length = 0;
            this.params.length = 0;
        }
        this.xy = undefined;
        this._closedPath = false;
    };
    Path2D.prototype.isPointInPath = function (x, y) {
        var commands = this.commands;
        var params = this.params;
        var cn = commands.length;
        // Hit testing using ray casting method, where the ray's origin is some point
        // outside the path. In this case, an offscreen point that is remote enough, so that
        // even if the path itself is large and is partially offscreen, the ray's origin
        // will likely be outside the path anyway. To test if the given point is inside the
        // path or not, we cast a ray from the origin to the given point and check the number
        // of intersections of this segment with the path. If the number of intersections is
        // even, then the ray both entered and exited the path an equal number of times,
        // therefore the point is outside the path, and inside the path, if the number of
        // intersections is odd. Since the path is compound, we check if the ray segment
        // intersects with each of the path's segments, which can be either a line segment
        // (one or no intersection points) or a Bézier curve segment (up to 3 intersection
        // points).
        var ox = -10000;
        var oy = -10000;
        // the starting point of the  current path
        var sx = NaN;
        var sy = NaN;
        // the previous point of the current path
        var px = 0;
        var py = 0;
        var intersectionCount = 0;
        for (var ci = 0, pi = 0; ci < cn; ci++) {
            switch (commands[ci]) {
                case Command.Move:
                    if (!isNaN(sx)) {
                        if (segmentIntersection(sx, sy, px, py, ox, oy, x, y)) {
                            intersectionCount++;
                        }
                    }
                    px = params[pi++];
                    sx = px;
                    py = params[pi++];
                    sy = py;
                    break;
                case Command.Line:
                    if (segmentIntersection(px, py, params[pi++], params[pi++], ox, oy, x, y)) {
                        intersectionCount++;
                    }
                    px = params[pi - 2];
                    py = params[pi - 1];
                    break;
                case Command.Curve:
                    intersectionCount += cubicSegmentIntersections(
                        px,
                        py,
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        ox,
                        oy,
                        x,
                        y,
                    ).length;
                    px = params[pi - 2];
                    py = params[pi - 1];
                    break;
                case Command.Arc:
                    intersectionCount += arcIntersections(
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        params[pi++],
                        Boolean(params[pi++]),
                        ox,
                        oy,
                        x,
                        y,
                    ).length;
                    px = params[pi - 2];
                    py = params[pi - 1];
                    break;
                case Command.ClosePath:
                    if (!isNaN(sx)) {
                        if (segmentIntersection(sx, sy, px, py, ox, oy, x, y)) {
                            intersectionCount++;
                        }
                    }
                    break;
            }
        }
        return intersectionCount % 2 === 1;
    };
    return Path2D;
})();

var __extends$2B =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1Q =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
function ScenePathChangeDetection(opts) {
    var _a = opts !== null && opts !== void 0 ? opts : {},
        _b = _a.redraw,
        redraw = _b === void 0 ? RedrawType.MAJOR : _b,
        changeCb = _a.changeCb,
        convertor = _a.convertor;
    return SceneChangeDetection({ redraw: redraw, type: 'path', convertor: convertor, changeCb: changeCb });
}
var Path = /** @class */ (function (_super) {
    __extends$2B(Path, _super);
    function Path() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        /**
         * Declare a path to retain for later rendering and hit testing
         * using custom Path2D class. Think of it as a TypeScript version
         * of the native Path2D (with some differences) that works in all browsers.
         */
        _this.path = new Path2D();
        /**
         * The path only has to be updated when certain attributes change.
         * For example, if transform attributes (such as `translationX`)
         * are changed, we don't have to update the path. The `dirtyPath` flag
         * is how we keep track if the path has to be updated or not.
         */
        _this._dirtyPath = true;
        return _this;
    }
    Object.defineProperty(Path.prototype, 'dirtyPath', {
        get: function () {
            return this._dirtyPath;
        },
        set: function (value) {
            if (this._dirtyPath !== value) {
                this._dirtyPath = value;
                if (value) {
                    this.markDirty(this, RedrawType.MAJOR);
                }
            }
        },
        enumerable: false,
        configurable: true,
    });
    Path.prototype.checkPathDirty = function () {
        var _a, _b;
        if (this._dirtyPath) {
            return;
        }
        this.dirtyPath =
            this.path.isDirty() ||
            ((_b = (_a = this.fillShadow) === null || _a === void 0 ? void 0 : _a.isDirty()) !== null && _b !== void 0
                ? _b
                : false);
    };
    Path.prototype.isPointInPath = function (x, y) {
        var point = this.transformPoint(x, y);
        return this.path.closedPath && this.path.isPointInPath(point.x, point.y);
    };
    Path.prototype.isDirtyPath = function () {
        // Override point for more expensive dirty checks.
        return false;
    };
    Path.prototype.updatePath = function () {
        // Override point for subclasses.
    };
    Path.prototype.render = function (renderCtx) {
        var _a, _b;
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        if (this.dirtyPath || this.isDirtyPath()) {
            this.updatePath();
            this.dirtyPath = false;
        }
        if (this.clipPath) {
            ctx.save();
            if (this.clipMode === 'normal') {
                // Bound the shape rendered to the clipping path.
                this.clipPath.draw(ctx);
                ctx.clip();
            }
            this.path.draw(ctx);
            this.fillStroke(ctx);
            if (this.clipMode === 'punch-out') {
                // Bound the shape rendered to outside the clipping path.
                this.clipPath.draw(ctx);
                ctx.clip();
                // Fallback values, but practically these should never be used.
                var _c = (_a = this.computeBBox()) !== null && _a !== void 0 ? _a : {},
                    _d = _c.x,
                    x = _d === void 0 ? -10000 : _d,
                    _e = _c.y,
                    y = _e === void 0 ? -10000 : _e,
                    _f = _c.width,
                    width = _f === void 0 ? 20000 : _f,
                    _g = _c.height,
                    height = _g === void 0 ? 20000 : _g;
                ctx.clearRect(x, y, width, height);
            }
            ctx.restore();
        } else {
            this.path.draw(ctx);
            this.fillStroke(ctx);
        }
        (_b = this.fillShadow) === null || _b === void 0 ? void 0 : _b.markClean();
        _super.prototype.render.call(this, renderCtx);
    };
    Path.className = 'Path';
    __decorate$1Q([ScenePathChangeDetection()], Path.prototype, 'clipPath', void 0);
    __decorate$1Q([ScenePathChangeDetection()], Path.prototype, 'clipMode', void 0);
    return Path;
})(Shape);

var __extends$2A =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1P =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$s =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var Marker = /** @class */ (function (_super) {
    __extends$2A(Marker, _super);
    function Marker() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.x = 0;
        _this.y = 0;
        _this.size = 12;
        return _this;
    }
    Marker.prototype.computeBBox = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            size = _a.size;
        var half = size / 2;
        return new BBox(x - half, y - half, size, size);
    };
    Marker.prototype.applyPath = function (s, moves) {
        var e_1, _a;
        var path = this.path;
        var _b = this,
            x = _b.x,
            y = _b.y;
        path.clear();
        try {
            for (
                var moves_1 = __values$s(moves), moves_1_1 = moves_1.next();
                !moves_1_1.done;
                moves_1_1 = moves_1.next()
            ) {
                var _c = moves_1_1.value,
                    mx = _c.x,
                    my = _c.y,
                    t = _c.t;
                x += mx * s;
                y += my * s;
                if (t === 'move') {
                    path.moveTo(x, y);
                } else {
                    path.lineTo(x, y);
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (moves_1_1 && !moves_1_1.done && (_a = moves_1.return)) _a.call(moves_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        path.closePath();
    };
    __decorate$1P([ScenePathChangeDetection()], Marker.prototype, 'x', void 0);
    __decorate$1P([ScenePathChangeDetection()], Marker.prototype, 'y', void 0);
    __decorate$1P([ScenePathChangeDetection({ convertor: Math.abs })], Marker.prototype, 'size', void 0);
    return Marker;
})(Path);

var __extends$2z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Square = /** @class */ (function (_super) {
    __extends$2z(Square, _super);
    function Square() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Square.prototype.updatePath = function () {
        var _a = this,
            path = _a.path,
            x = _a.x,
            y = _a.y;
        var hs = this.size / 2;
        path.clear();
        path.moveTo(this.align(x - hs), this.align(y - hs));
        path.lineTo(this.align(x + hs), this.align(y - hs));
        path.lineTo(this.align(x + hs), this.align(y + hs));
        path.lineTo(this.align(x - hs), this.align(y + hs));
        path.closePath();
    };
    Square.className = 'Square';
    return Square;
})(Marker);

var __extends$2y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1O =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MarkerLabel = /** @class */ (function (_super) {
    __extends$2y(MarkerLabel, _super);
    function MarkerLabel() {
        var _this = _super.call(this, { name: 'markerLabelGroup' }) || this;
        _this.label = new Text();
        _this._marker = new Square();
        _this._markerSize = 15;
        _this._spacing = 8;
        var label = _this.label;
        label.textBaseline = 'middle';
        label.fontSize = 12;
        label.fontFamily = 'Verdana, sans-serif';
        label.fill = 'black';
        // For better looking vertical alignment of labels to markers.
        label.y = HdpiCanvas.has.textMetrics ? 1 : 0;
        _this.append([_this.marker, label]);
        _this.update();
        return _this;
    }
    Object.defineProperty(MarkerLabel.prototype, 'marker', {
        get: function () {
            return this._marker;
        },
        set: function (value) {
            if (this._marker !== value) {
                this.removeChild(this._marker);
                this._marker = value;
                this.appendChild(value);
                this.update();
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(MarkerLabel.prototype, 'markerSize', {
        get: function () {
            return this._markerSize;
        },
        set: function (value) {
            if (this._markerSize !== value) {
                this._markerSize = value;
                this.update();
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(MarkerLabel.prototype, 'spacing', {
        get: function () {
            return this._spacing;
        },
        set: function (value) {
            if (this._spacing !== value) {
                this._spacing = value;
                this.update();
            }
        },
        enumerable: false,
        configurable: true,
    });
    MarkerLabel.prototype.update = function () {
        var marker = this.marker;
        var markerSize = this.markerSize;
        marker.size = markerSize;
        this.label.x = markerSize / 2 + this.spacing;
    };
    MarkerLabel.prototype.render = function (renderCtx) {
        // Cannot override field Group.opacity with get/set pair, so
        // propagate opacity changes here.
        this.marker.opacity = this.opacity;
        this.label.opacity = this.opacity;
        _super.prototype.render.call(this, renderCtx);
    };
    MarkerLabel.className = 'MarkerLabel';
    __decorate$1O([ProxyPropertyOnWrite('label')], MarkerLabel.prototype, 'text', void 0);
    __decorate$1O([ProxyPropertyOnWrite('label')], MarkerLabel.prototype, 'fontStyle', void 0);
    __decorate$1O([ProxyPropertyOnWrite('label')], MarkerLabel.prototype, 'fontWeight', void 0);
    __decorate$1O([ProxyPropertyOnWrite('label')], MarkerLabel.prototype, 'fontSize', void 0);
    __decorate$1O([ProxyPropertyOnWrite('label')], MarkerLabel.prototype, 'fontFamily', void 0);
    __decorate$1O([ProxyPropertyOnWrite('label', 'fill')], MarkerLabel.prototype, 'color', void 0);
    __decorate$1O([ProxyPropertyOnWrite('marker', 'fill')], MarkerLabel.prototype, 'markerFill', void 0);
    __decorate$1O([ProxyPropertyOnWrite('marker', 'stroke')], MarkerLabel.prototype, 'markerStroke', void 0);
    __decorate$1O([ProxyPropertyOnWrite('marker', 'strokeWidth')], MarkerLabel.prototype, 'markerStrokeWidth', void 0);
    __decorate$1O([ProxyPropertyOnWrite('marker', 'fillOpacity')], MarkerLabel.prototype, 'markerFillOpacity', void 0);
    __decorate$1O(
        [ProxyPropertyOnWrite('marker', 'strokeOpacity')],
        MarkerLabel.prototype,
        'markerStrokeOpacity',
        void 0,
    );
    return MarkerLabel;
})(Group);

var __extends$2x =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Circle = /** @class */ (function (_super) {
    __extends$2x(Circle, _super);
    function Circle() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Circle.prototype.updatePath = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            path = _a.path,
            size = _a.size;
        var r = size / 2;
        path.clear();
        path.arc(x, y, r, 0, Math.PI * 2);
        path.closePath();
    };
    Circle.className = 'Circle';
    return Circle;
})(Marker);

var __extends$2w =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Cross = /** @class */ (function (_super) {
    __extends$2w(Cross, _super);
    function Cross() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Cross.prototype.updatePath = function () {
        var s = this.size / 4.2;
        _super.prototype.applyPath.call(this, s, Cross.moves);
    };
    Cross.className = 'Cross';
    Cross.moves = [
        { x: -1, y: 0, t: 'move' },
        { x: -1, y: -1 },
        { x: +1, y: -1 },
        { x: +1, y: +1 },
        { x: +1, y: -1 },
        { x: +1, y: +1 },
        { x: -1, y: +1 },
        { x: +1, y: +1 },
        { x: -1, y: +1 },
        { x: -1, y: -1 },
        { x: -1, y: +1 },
        { x: -1, y: -1 },
    ];
    return Cross;
})(Marker);

var __extends$2v =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Diamond = /** @class */ (function (_super) {
    __extends$2v(Diamond, _super);
    function Diamond() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Diamond.prototype.updatePath = function () {
        var s = this.size / 2;
        _super.prototype.applyPath.call(this, s, Diamond.moves);
    };
    Diamond.className = 'Diamond';
    Diamond.moves = [
        { x: 0, y: -1, t: 'move' },
        { x: +1, y: +1 },
        { x: -1, y: +1 },
        { x: -1, y: -1 },
        { x: +1, y: -1 },
    ];
    return Diamond;
})(Marker);

var __extends$2u =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Heart = /** @class */ (function (_super) {
    __extends$2u(Heart, _super);
    function Heart() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Heart.prototype.rad = function (degree) {
        return (degree / 180) * Math.PI;
    };
    Heart.prototype.updatePath = function () {
        var _a = this,
            x = _a.x,
            path = _a.path,
            size = _a.size,
            rad = _a.rad;
        var r = size / 4;
        var y = this.y + r / 2;
        path.clear();
        path.arc(x - r, y - r, r, rad(130), rad(330));
        path.arc(x + r, y - r, r, rad(220), rad(50));
        path.lineTo(x, y + r);
        path.closePath();
    };
    Heart.className = 'Heart';
    return Heart;
})(Marker);

var __extends$2t =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Plus = /** @class */ (function (_super) {
    __extends$2t(Plus, _super);
    function Plus() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Plus.prototype.updatePath = function () {
        var s = this.size / 3;
        _super.prototype.applyPath.call(this, s, Plus.moves);
    };
    Plus.className = 'Plus';
    Plus.moves = [
        { x: -0.5, y: -0.5, t: 'move' },
        { x: 0, y: -1 },
        { x: +1, y: 0 },
        { x: 0, y: +1 },
        { x: +1, y: 0 },
        { x: 0, y: +1 },
        { x: -1, y: 0 },
        { x: 0, y: +1 },
        { x: -1, y: 0 },
        { x: 0, y: -1 },
        { x: -1, y: 0 },
        { x: 0, y: -1 },
    ];
    return Plus;
})(Marker);

var __extends$2s =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var Triangle = /** @class */ (function (_super) {
    __extends$2s(Triangle, _super);
    function Triangle() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    Triangle.prototype.updatePath = function () {
        var s = this.size * 1.1;
        _super.prototype.applyPath.call(this, s, Triangle.moves);
    };
    Triangle.className = 'Triangle';
    Triangle.moves = [
        { x: 0, y: -0.48, t: 'move' },
        { x: 0.5, y: 0.87 },
        { x: -1, y: 0 },
    ];
    return Triangle;
})(Marker);

// This function is in its own file because putting it into SeriesMarker makes the Legend
// suddenly aware of the series (it's an agnostic component), and putting it into Marker
// introduces circular dependencies.
function getMarker$1(shape) {
    if (shape === void 0) {
        shape = Square;
    }
    if (typeof shape === 'string') {
        switch (shape) {
            case 'circle':
                return Circle;
            case 'cross':
                return Cross;
            case 'diamond':
                return Diamond;
            case 'heart':
                return Heart;
            case 'plus':
                return Plus;
            case 'triangle':
                return Triangle;
            default:
                return Square;
        }
    }
    if (typeof shape === 'function') {
        return shape;
    }
    return Square;
}

var __values$r =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function gridLayout(_a) {
    var orientation = _a.orientation,
        bboxes = _a.bboxes,
        maxHeight = _a.maxHeight,
        maxWidth = _a.maxWidth,
        _b = _a.itemPaddingY,
        itemPaddingY = _b === void 0 ? 0 : _b,
        _c = _a.itemPaddingX,
        itemPaddingX = _c === void 0 ? 0 : _c,
        _d = _a.forceResult,
        forceResult = _d === void 0 ? false : _d;
    var horizontal = orientation === 'horizontal';
    var primary = {
        max: horizontal ? maxWidth : maxHeight,
        fn: horizontal
            ? function (b) {
                  return b.width;
              }
            : function (b) {
                  return b.height;
              },
        padding: horizontal ? itemPaddingX : itemPaddingY,
    };
    var secondary = {
        max: !horizontal ? maxWidth : maxHeight,
        fn: !horizontal
            ? function (b) {
                  return b.width;
              }
            : function (b) {
                  return b.height;
              },
        padding: !horizontal ? itemPaddingX : itemPaddingY,
    };
    var processedBBoxCount = 0;
    var rawPages = [];
    while (processedBBoxCount < bboxes.length) {
        var unprocessedBBoxes = bboxes.slice(processedBBoxCount);
        var result = processBBoxes(unprocessedBBoxes, processedBBoxCount, primary, secondary, forceResult);
        if (!result) {
            return;
        }
        processedBBoxCount += result.processedBBoxCount;
        rawPages.push(result.pageIndices);
    }
    return buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX);
}
function processBBoxes(bboxes, indexOffset, primary, secondary, forceResult) {
    // If calculatePage() fails on the first guess, we could use the number of items that fit
    // as a good guess for the next iteration.
    var minGuess = 1;
    var startingGuess = estimateStartingGuess(bboxes, primary);
    if (startingGuess < minGuess) {
        if (!forceResult) {
            return undefined;
        }
        // Legend constraints too small! Display at least one row/column if forceResult is true
        startingGuess = minGuess;
    }
    for (var guess = startingGuess; guess >= minGuess; guess--) {
        var pageIndices = calculatePage(bboxes, indexOffset, guess, primary, secondary, forceResult);
        if (pageIndices == null && guess <= minGuess) {
            // Can't layout!
            return undefined;
        }
        if (pageIndices == null) {
            // Guess again!
            continue;
        }
        if (typeof pageIndices === 'number') {
            // calculatePage() suggested a better guess, use that if it's more than minGuess.
            if (pageIndices <= minGuess) {
                // Can't layout!
                return undefined;
            }
            guess = pageIndices < guess && pageIndices > minGuess ? pageIndices : guess;
            continue;
        }
        var processedBBoxCount = pageIndices.length * pageIndices[0].length; // this is an estimate, not all rows/columns will have the same length
        return { processedBBoxCount: processedBBoxCount, pageIndices: pageIndices };
    }
}
function calculatePage(bboxes, indexOffset, primaryCount, primary, secondary, forceResult) {
    var _a;
    var result = [];
    var sumSecondary = 0;
    var currentMaxSecondary = 0;
    var currentPrimaryIndices = [];
    var maxPrimaryValues = [];
    for (var bboxIndex = 0; bboxIndex < bboxes.length; bboxIndex++) {
        var primaryValueIdx = (bboxIndex + primaryCount) % primaryCount;
        if (primaryValueIdx === 0) {
            sumSecondary += currentMaxSecondary;
            currentMaxSecondary = 0;
            if (currentPrimaryIndices.length > 0) {
                result.push(currentPrimaryIndices);
            }
            currentPrimaryIndices = [];
        }
        var primaryValue = primary.fn(bboxes[bboxIndex]) + primary.padding;
        maxPrimaryValues[primaryValueIdx] = Math.max(
            (_a = maxPrimaryValues[primaryValueIdx]) !== null && _a !== void 0 ? _a : 0,
            primaryValue,
        );
        currentMaxSecondary = Math.max(currentMaxSecondary, secondary.fn(bboxes[bboxIndex]) + secondary.padding);
        var currentSecondaryDimension = sumSecondary + currentMaxSecondary;
        var returnResult = !forceResult || result.length > 0;
        if (currentSecondaryDimension > secondary.max && returnResult) {
            // Breached max secondary dimension size, return indices accumlated so far (but not in-progress row/column).
            currentPrimaryIndices = [];
            break;
        }
        var sumPrimary = maxPrimaryValues.reduce(function (sum, next) {
            return sum + next;
        }, 0);
        if (sumPrimary > primary.max && !forceResult) {
            // Breached max main dimension size.
            if (maxPrimaryValues.length < primaryCount) {
                // Feedback as guess for next iteration if we're on the first round still.
                return maxPrimaryValues.length;
            }
            return undefined;
        }
        currentPrimaryIndices.push(bboxIndex + indexOffset);
    }
    if (currentPrimaryIndices.length > 0) {
        result.push(currentPrimaryIndices);
    }
    return result.length > 0 ? result : undefined;
}
function buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX) {
    var maxPageWidth = 0;
    var maxPageHeight = 0;
    var pages = rawPages.map(function (indices) {
        if (orientation === 'horizontal') {
            indices = transpose(indices);
        }
        var endIndex = 0;
        var columns = indices.map(function (colIndices) {
            var colBBoxes = colIndices.map(function (bboxIndex) {
                endIndex = Math.max(bboxIndex, endIndex);
                return bboxes[bboxIndex];
            });
            var columnHeight = 0;
            var columnWidth = 0;
            colBBoxes.forEach(function (bbox) {
                columnHeight += bbox.height + itemPaddingY;
                columnWidth = Math.max(columnWidth, bbox.width + itemPaddingX);
            });
            return {
                indices: colIndices,
                bboxes: colBBoxes,
                columnHeight: columnHeight,
                columnWidth: columnWidth,
            };
        });
        var pageWidth = 0;
        var pageHeight = 0;
        columns.forEach(function (column) {
            pageWidth += column.columnWidth;
            pageHeight = Math.max(pageHeight, column.columnHeight);
        });
        maxPageWidth = Math.max(pageWidth, maxPageWidth);
        maxPageHeight = Math.max(pageHeight, maxPageHeight);
        return {
            columns: columns,
            startIndex: indices[0][0],
            endIndex: endIndex,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
        };
    });
    return { pages: pages, maxPageWidth: maxPageWidth, maxPageHeight: maxPageHeight };
}
function transpose(data) {
    var e_1, _a;
    var result = [];
    try {
        for (var _b = __values$r(data[0]), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _ = _c.value;
            result.push([]);
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    data.forEach(function (innerData, dataIdx) {
        innerData.forEach(function (item, itemIdx) {
            result[itemIdx][dataIdx] = item;
        });
    });
    return result;
}
function estimateStartingGuess(bboxes, primary) {
    var n = bboxes.length;
    var primarySum = 0;
    for (var bboxIndex = 0; bboxIndex < n; bboxIndex++) {
        primarySum += primary.fn(bboxes[bboxIndex]) + primary.padding;
        if (primarySum > primary.max) {
            var ratio = n / bboxIndex;
            if (ratio < 2) {
                return Math.ceil(n / 2);
            }
            return bboxIndex;
        }
    }
    return n;
}

var __decorate$1N =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PaginationLabel = /** @class */ (function () {
    function PaginationLabel() {
        this.color = 'black';
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.fontSize = 12;
        this.fontFamily = 'Verdana, sans-serif';
    }
    __decorate$1N([Validate(COLOR_STRING)], PaginationLabel.prototype, 'color', void 0);
    __decorate$1N([Validate(OPT_FONT_STYLE)], PaginationLabel.prototype, 'fontStyle', void 0);
    __decorate$1N([Validate(OPT_FONT_WEIGHT)], PaginationLabel.prototype, 'fontWeight', void 0);
    __decorate$1N([Validate(NUMBER(0))], PaginationLabel.prototype, 'fontSize', void 0);
    __decorate$1N([Validate(STRING)], PaginationLabel.prototype, 'fontFamily', void 0);
    return PaginationLabel;
})();
var PaginationMarkerStyle = /** @class */ (function () {
    function PaginationMarkerStyle() {
        this.size = 15;
        this.fill = undefined;
        this.fillOpacity = undefined;
        this.stroke = undefined;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
    }
    __decorate$1N([Validate(NUMBER(0))], PaginationMarkerStyle.prototype, 'size', void 0);
    __decorate$1N([Validate(OPT_COLOR_STRING)], PaginationMarkerStyle.prototype, 'fill', void 0);
    __decorate$1N([Validate(OPT_NUMBER(0, 1))], PaginationMarkerStyle.prototype, 'fillOpacity', void 0);
    __decorate$1N([Validate(OPT_COLOR_STRING)], PaginationMarkerStyle.prototype, 'stroke', void 0);
    __decorate$1N([Validate(NUMBER(0))], PaginationMarkerStyle.prototype, 'strokeWidth', void 0);
    __decorate$1N([Validate(NUMBER(0, 1))], PaginationMarkerStyle.prototype, 'strokeOpacity', void 0);
    return PaginationMarkerStyle;
})();
var PaginationMarker = /** @class */ (function () {
    function PaginationMarker() {
        this.size = 15;
        this._shape = Triangle;
        /**
         * Inner padding between a pagination button and the label.
         */
        this.padding = 8;
    }
    Object.defineProperty(PaginationMarker.prototype, 'shape', {
        get: function () {
            return this._shape;
        },
        set: function (value) {
            var _a;
            this._shape = value;
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.onMarkerShapeChange();
        },
        enumerable: false,
        configurable: true,
    });
    __decorate$1N([Validate(NUMBER(0))], PaginationMarker.prototype, 'size', void 0);
    __decorate$1N([Validate(NUMBER(0))], PaginationMarker.prototype, 'padding', void 0);
    return PaginationMarker;
})();
var Pagination = /** @class */ (function () {
    function Pagination(chartUpdateCallback, pageUpdateCallback, interactionManager, cursorManager) {
        var _this = this;
        this.chartUpdateCallback = chartUpdateCallback;
        this.pageUpdateCallback = pageUpdateCallback;
        this.interactionManager = interactionManager;
        this.cursorManager = cursorManager;
        this.id = createId$1(this);
        this.group = new Group({ name: 'pagination' });
        this.labelNode = new Text();
        this.marker = new PaginationMarker();
        this.activeStyle = new PaginationMarkerStyle();
        this.inactiveStyle = new PaginationMarkerStyle();
        this.highlightStyle = new PaginationMarkerStyle();
        this.label = new PaginationLabel();
        this.totalPages = 0;
        this.currentPage = 0;
        this.translationX = 0;
        this.translationY = 0;
        this.nextButtonDisabled = false;
        this.previousButtonDisabled = false;
        this._visible = true;
        this._enabled = true;
        this._orientation = 'vertical';
        this._nextButton = new Triangle();
        this._previousButton = new Triangle();
        var labelNode = this.labelNode;
        labelNode.textBaseline = 'middle';
        labelNode.fontSize = 12;
        labelNode.fontFamily = 'Verdana, sans-serif';
        labelNode.fill = 'black';
        labelNode.y = HdpiCanvas.has.textMetrics ? 1 : 0;
        this.group.append([this.nextButton, this.previousButton, labelNode]);
        this.interactionManager.addListener('click', function (event) {
            return _this.onPaginationClick(event);
        });
        this.interactionManager.addListener('hover', function (event) {
            return _this.onPaginationMouseMove(event);
        });
        this.marker.parent = this;
        this.update();
        this.updateMarkers();
    }
    Object.defineProperty(Pagination.prototype, 'visible', {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            this._visible = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Pagination.prototype, 'enabled', {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Pagination.prototype.updateGroupVisibility = function () {
        this.group.visible = this.enabled && this.visible;
    };
    Object.defineProperty(Pagination.prototype, 'orientation', {
        get: function () {
            return this._orientation;
        },
        set: function (value) {
            this._orientation = value;
            switch (value) {
                case 'horizontal': {
                    this.previousButton.rotation = -Math.PI / 2;
                    this.nextButton.rotation = Math.PI / 2;
                    break;
                }
                case 'vertical':
                default: {
                    this.previousButton.rotation = 0;
                    this.nextButton.rotation = Math.PI;
                }
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Pagination.prototype, 'nextButton', {
        get: function () {
            return this._nextButton;
        },
        set: function (value) {
            if (this._nextButton !== value) {
                this.group.removeChild(this._nextButton);
                this._nextButton = value;
                this.group.appendChild(value);
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Pagination.prototype, 'previousButton', {
        get: function () {
            return this._previousButton;
        },
        set: function (value) {
            if (this._previousButton !== value) {
                this.group.removeChild(this._previousButton);
                this._previousButton = value;
                this.group.appendChild(value);
            }
        },
        enumerable: false,
        configurable: true,
    });
    Pagination.prototype.update = function () {
        this.updateLabel();
        this.updatePositions();
        this.enableOrDisableButtons();
    };
    Pagination.prototype.updatePositions = function () {
        this.group.translationX = this.translationX;
        this.group.translationY = this.translationY;
        this.updateLabelPosition();
        this.updateNextButtonPosition();
    };
    Pagination.prototype.updateLabelPosition = function () {
        var _a = this.marker,
            markerSize = _a.size,
            markerPadding = _a.padding;
        this.nextButton.size = markerSize;
        this.previousButton.size = markerSize;
        this.labelNode.x = markerSize / 2 + markerPadding;
    };
    Pagination.prototype.updateNextButtonPosition = function () {
        var labelBBox = this.labelNode.computeBBox();
        this.nextButton.translationX = labelBBox.x + labelBBox.width + this.marker.size / 2 + this.marker.padding;
    };
    Pagination.prototype.updateLabel = function () {
        var _a = this,
            currentPage = _a.currentPage,
            pages = _a.totalPages,
            labelNode = _a.labelNode,
            _b = _a.label,
            color = _b.color,
            fontStyle = _b.fontStyle,
            fontWeight = _b.fontWeight,
            fontSize = _b.fontSize,
            fontFamily = _b.fontFamily;
        labelNode.text = currentPage + 1 + ' / ' + pages;
        labelNode.fill = color;
        labelNode.fontStyle = fontStyle;
        labelNode.fontWeight = fontWeight;
        labelNode.fontSize = fontSize;
        labelNode.fontFamily = fontFamily;
    };
    Pagination.prototype.updateMarkers = function () {
        var _a = this,
            nextButton = _a.nextButton,
            previousButton = _a.previousButton,
            nextButtonDisabled = _a.nextButtonDisabled,
            previousButtonDisabled = _a.previousButtonDisabled,
            activeStyle = _a.activeStyle,
            inactiveStyle = _a.inactiveStyle,
            highlightStyle = _a.highlightStyle,
            highlightActive = _a.highlightActive;
        var buttonStyle = function (button, disabled) {
            if (disabled) {
                return inactiveStyle;
            } else if (button === highlightActive) {
                return highlightStyle;
            }
            return activeStyle;
        };
        this.updateMarker(nextButton, buttonStyle('next', nextButtonDisabled));
        this.updateMarker(previousButton, buttonStyle('previous', previousButtonDisabled));
    };
    Pagination.prototype.updateMarker = function (marker, style) {
        var _a;
        var size = this.marker.size;
        marker.size = size;
        marker.fill = style.fill;
        marker.fillOpacity = (_a = style.fillOpacity) !== null && _a !== void 0 ? _a : 1;
        marker.stroke = style.stroke;
        marker.strokeWidth = style.strokeWidth;
        marker.strokeOpacity = style.strokeOpacity;
    };
    Pagination.prototype.enableOrDisableButtons = function () {
        var _a = this,
            currentPage = _a.currentPage,
            totalPages = _a.totalPages;
        var zeroPagesToDisplay = totalPages === 0;
        var onLastPage = currentPage === totalPages - 1;
        var onFirstPage = currentPage === 0;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.previousButtonDisabled = onFirstPage || zeroPagesToDisplay;
    };
    Pagination.prototype.nextButtonContainsPoint = function (offsetX, offsetY) {
        return !this.nextButtonDisabled && this.nextButton.containsPoint(offsetX, offsetY);
    };
    Pagination.prototype.previousButtonContainsPoint = function (offsetX, offsetY) {
        return !this.previousButtonDisabled && this.previousButton.containsPoint(offsetX, offsetY);
    };
    Pagination.prototype.onPaginationClick = function (event) {
        var offsetX = event.offsetX,
            offsetY = event.offsetY;
        if (this.nextButtonContainsPoint(offsetX, offsetY)) {
            this.incrementPage();
            this.onPaginationChanged();
            event.consume();
        } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
            this.decrementPage();
            this.onPaginationChanged();
            event.consume();
        }
    };
    Pagination.prototype.onPaginationMouseMove = function (event) {
        var offsetX = event.offsetX,
            offsetY = event.offsetY;
        if (this.nextButtonContainsPoint(offsetX, offsetY)) {
            this.cursorManager.updateCursor(this.id, 'pointer');
            this.highlightActive = 'next';
        } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
            this.cursorManager.updateCursor(this.id, 'pointer');
            this.highlightActive = 'previous';
        } else {
            this.cursorManager.updateCursor(this.id);
            this.highlightActive = undefined;
        }
        this.updateMarkers();
        this.chartUpdateCallback(ChartUpdateType.SCENE_RENDER);
    };
    Pagination.prototype.onPaginationChanged = function () {
        this.pageUpdateCallback(this.currentPage);
    };
    Pagination.prototype.incrementPage = function () {
        this.currentPage = Math.min(this.currentPage + 1, this.totalPages - 1);
    };
    Pagination.prototype.decrementPage = function () {
        this.currentPage = Math.max(this.currentPage - 1, 0);
    };
    Pagination.prototype.onMarkerShapeChange = function () {
        var Marker = getMarker$1(this.marker.shape || Triangle);
        this.previousButton = new Marker();
        this.nextButton = new Marker();
        this.updatePositions();
        this.updateMarkers();
        this.chartUpdateCallback(ChartUpdateType.SCENE_RENDER);
    };
    Pagination.prototype.attachPagination = function (node) {
        node.append(this.group);
    };
    Pagination.prototype.computeBBox = function () {
        return this.group.computeBBox();
    };
    Pagination.className = 'Pagination';
    return Pagination;
})();

var __decorate$1M =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$U =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$y =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$q =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var ORIENTATIONS = ['horizontal', 'vertical'];
var OPT_ORIENTATION = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, function (v) {
        return ORIENTATIONS.includes(v);
    });
}, "expecting an orientation keyword such as 'horizontal' or 'vertical'");
var LegendLabel = /** @class */ (function () {
    function LegendLabel() {
        this.maxLength = undefined;
        this.color = 'black';
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.fontSize = 12;
        this.fontFamily = 'Verdana, sans-serif';
        this.formatter = undefined;
    }
    __decorate$1M([Validate(OPT_NUMBER(0))], LegendLabel.prototype, 'maxLength', void 0);
    __decorate$1M([Validate(COLOR_STRING)], LegendLabel.prototype, 'color', void 0);
    __decorate$1M([Validate(OPT_FONT_STYLE)], LegendLabel.prototype, 'fontStyle', void 0);
    __decorate$1M([Validate(OPT_FONT_WEIGHT)], LegendLabel.prototype, 'fontWeight', void 0);
    __decorate$1M([Validate(NUMBER(0))], LegendLabel.prototype, 'fontSize', void 0);
    __decorate$1M([Validate(STRING)], LegendLabel.prototype, 'fontFamily', void 0);
    __decorate$1M([Validate(OPT_FUNCTION)], LegendLabel.prototype, 'formatter', void 0);
    return LegendLabel;
})();
var LegendMarker = /** @class */ (function () {
    function LegendMarker() {
        this.size = 15;
        /**
         * If the marker type is set, the legend will always use that marker type for all its items,
         * regardless of the type that comes from the `data`.
         */
        this._shape = undefined;
        /**
         * Padding between the marker and the label within each legend item.
         */
        this.padding = 8;
        this.strokeWidth = 1;
    }
    Object.defineProperty(LegendMarker.prototype, 'shape', {
        get: function () {
            return this._shape;
        },
        set: function (value) {
            var _a;
            this._shape = value;
            (_a = this.parent) === null || _a === void 0 ? void 0 : _a.onMarkerShapeChange();
        },
        enumerable: false,
        configurable: true,
    });
    __decorate$1M([Validate(NUMBER(0))], LegendMarker.prototype, 'size', void 0);
    __decorate$1M([Validate(NUMBER(0))], LegendMarker.prototype, 'padding', void 0);
    __decorate$1M([Validate(NUMBER(0))], LegendMarker.prototype, 'strokeWidth', void 0);
    return LegendMarker;
})();
var LegendItem = /** @class */ (function () {
    function LegendItem() {
        this.marker = new LegendMarker();
        this.label = new LegendLabel();
        /** Used to constrain the width of legend items. */
        this.maxWidth = undefined;
        /**
         * The legend uses grid layout for its items, occupying as few columns as possible when positioned to left or right,
         * and as few rows as possible when positioned to top or bottom. This config specifies the amount of horizontal
         * padding between legend items.
         */
        this.paddingX = 16;
        /**
         * The legend uses grid layout for its items, occupying as few columns as possible when positioned to left or right,
         * and as few rows as possible when positioned to top or bottom. This config specifies the amount of vertical
         * padding between legend items.
         */
        this.paddingY = 8;
        this.toggleSeriesVisible = true;
    }
    __decorate$1M([Validate(OPT_NUMBER(0))], LegendItem.prototype, 'maxWidth', void 0);
    __decorate$1M([Validate(NUMBER(0))], LegendItem.prototype, 'paddingX', void 0);
    __decorate$1M([Validate(NUMBER(0))], LegendItem.prototype, 'paddingY', void 0);
    __decorate$1M([Validate(BOOLEAN)], LegendItem.prototype, 'toggleSeriesVisible', void 0);
    return LegendItem;
})();
var LegendListeners = /** @class */ (function () {
    function LegendListeners() {
        this.legendItemClick = undefined;
        this.legendItemDoubleClick = undefined;
    }
    __decorate$1M([Validate(OPT_FUNCTION)], LegendListeners.prototype, 'legendItemClick', void 0);
    return LegendListeners;
})();
var Legend = /** @class */ (function () {
    function Legend(ctx) {
        var _a;
        var _this = this;
        this.ctx = ctx;
        this.id = createId$1(this);
        this.group = new Group({ name: 'legend', layer: true, zIndex: Layers.LEGEND_ZINDEX });
        this.itemSelection = Selection.select(this.group, MarkerLabel);
        this.oldSize = [0, 0];
        this.pages = [];
        this.maxPageSize = [0, 0];
        /** Item index to track on re-pagination, so current page updates appropriately. */
        this.paginationTrackingIndex = 0;
        this.item = new LegendItem();
        this.listeners = new LegendListeners();
        this.truncatedItems = new Set();
        this._data = [];
        this._enabled = true;
        this.position = 'bottom';
        /** Used to constrain the width of the legend. */
        this.maxWidth = undefined;
        /** Used to constrain the height of the legend. */
        this.maxHeight = undefined;
        /** Reverse the display order of legend items if `true`. */
        this.reverseOrder = undefined;
        this.destroyFns = [];
        /**
         * Spacing between the legend and the edge of the chart's element.
         */
        this.spacing = 20;
        this.characterWidths = new Map();
        this.size = [0, 0];
        this._visible = true;
        this.item.marker.parent = this;
        this.pagination = new Pagination(
            function (type) {
                return ctx.updateService.update(type);
            },
            function (page) {
                return _this.updatePageNumber(page);
            },
            ctx.interactionManager,
            ctx.cursorManager,
        );
        this.pagination.attachPagination(this.group);
        this.item.marker.parent = this;
        var interactionListeners = [
            ctx.interactionManager.addListener('click', function (e) {
                return _this.checkLegendClick(e);
            }),
            ctx.interactionManager.addListener('dblclick', function (e) {
                return _this.checkLegendDoubleClick(e);
            }),
            ctx.interactionManager.addListener('hover', function (e) {
                return _this.handleLegendMouseMove(e);
            }),
        ];
        var layoutListeners = [
            ctx.layoutService.addListener('start-layout', function (e) {
                return _this.positionLegend(e.shrinkRect);
            }),
        ];
        (_a = this.destroyFns).push.apply(
            _a,
            __spreadArray$y(
                __spreadArray$y(
                    __spreadArray$y(
                        [],
                        __read$U(
                            interactionListeners.map(function (s) {
                                return function () {
                                    return ctx.interactionManager.removeListener(s);
                                };
                            }),
                        ),
                    ),
                    __read$U(
                        layoutListeners.map(function (s) {
                            return function () {
                                return ctx.layoutService.removeListener(s);
                            };
                        }),
                    ),
                ),
                [
                    function () {
                        return _this.detachLegend();
                    },
                ],
            ),
        );
    }
    Object.defineProperty(Legend.prototype, 'data', {
        get: function () {
            return this._data;
        },
        set: function (value) {
            this._data = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Legend.prototype, 'enabled', {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Legend.prototype.getOrientation = function () {
        if (this.orientation !== undefined) {
            return this.orientation;
        }
        switch (this.position) {
            case 'right':
            case 'left':
                return 'vertical';
            case 'bottom':
            case 'top':
                return 'horizontal';
        }
    };
    Legend.prototype.destroy = function () {
        this.destroyFns.forEach(function (f) {
            return f();
        });
    };
    Legend.prototype.onMarkerShapeChange = function () {
        this.itemSelection.clear();
        this.group.markDirty(this.group, RedrawType.MINOR);
    };
    Legend.prototype.getCharacterWidths = function (font) {
        var characterWidths = this.characterWidths;
        if (characterWidths.has(font)) {
            return characterWidths.get(font);
        }
        var cw = {
            '...': HdpiCanvas.getTextSize('...', font).width,
        };
        characterWidths.set(font, cw);
        return cw;
    };
    Object.defineProperty(Legend.prototype, 'visible', {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            this._visible = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Legend.prototype.updateGroupVisibility = function () {
        this.group.visible = this.enabled && this.visible && this.data.length > 0;
    };
    Legend.prototype.attachLegend = function (node) {
        node.append(this.group);
    };
    Legend.prototype.detachLegend = function () {
        var _a;
        (_a = this.group.parent) === null || _a === void 0 ? void 0 : _a.removeChild(this.group);
    };
    Legend.prototype.getItemLabel = function (datum) {
        var callbackCache = this.ctx.callbackCache;
        var formatter = this.item.label.formatter;
        if (formatter) {
            return callbackCache.call(formatter, {
                itemId: datum.itemId,
                value: datum.label.text,
                seriesId: datum.seriesId,
            });
        }
        return datum.label.text;
    };
    /**
     * The method is given the desired size of the legend, which only serves as a hint.
     * The vertically oriented legend will take as much horizontal space as needed, but will
     * respect the height constraints, and the horizontal legend will take as much vertical
     * space as needed in an attempt not to exceed the given width.
     * After the layout is done, the {@link size} will contain the actual size of the legend.
     * If the actual size is not the same as the previous actual size, the legend will fire
     * the 'layoutChange' event to communicate that another layout is needed, and the above
     * process should be repeated.
     * @param width
     * @param height
     */
    Legend.prototype.performLayout = function (width, height) {
        var _this = this;
        var _a = this.item,
            paddingX = _a.paddingX,
            paddingY = _a.paddingY,
            label = _a.label,
            maxWidth = _a.maxWidth,
            _b = _a.marker,
            markerSize = _b.size,
            markerPadding = _b.padding,
            markerShape = _b.shape,
            _c = _a.label,
            _d = _c.maxLength,
            maxLength = _d === void 0 ? Infinity : _d,
            fontStyle = _c.fontStyle,
            fontWeight = _c.fontWeight,
            fontSize = _c.fontSize,
            fontFamily = _c.fontFamily;
        var data = __spreadArray$y([], __read$U(this.data));
        if (this.reverseOrder) {
            data.reverse();
        }
        this.itemSelection.update(data);
        // Update properties that affect the size of the legend items and measure them.
        var bboxes = [];
        var font = getFont(label);
        var itemMaxWidthPercentage = 0.8;
        var maxItemWidth = maxWidth !== null && maxWidth !== void 0 ? maxWidth : width * itemMaxWidthPercentage;
        var paddedMarkerWidth = markerSize + markerPadding + paddingX;
        this.itemSelection.each(function (markerLabel, datum) {
            var _a;
            var Marker = getMarker$1(markerShape !== null && markerShape !== void 0 ? markerShape : datum.marker.shape);
            if (!(markerLabel.marker && markerLabel.marker instanceof Marker)) {
                markerLabel.marker = new Marker();
            }
            markerLabel.markerSize = markerSize;
            markerLabel.spacing = markerPadding;
            markerLabel.fontStyle = fontStyle;
            markerLabel.fontWeight = fontWeight;
            markerLabel.fontSize = fontSize;
            markerLabel.fontFamily = fontFamily;
            var id = (_a = datum.itemId) !== null && _a !== void 0 ? _a : datum.id;
            var labelText = _this.getItemLabel(datum);
            var text = (labelText !== null && labelText !== void 0 ? labelText : '<unknown>').replace(/\r?\n/g, ' ');
            markerLabel.text = _this.truncate(text, maxLength, maxItemWidth, paddedMarkerWidth, font, id);
            bboxes.push(markerLabel.computeBBox());
        });
        width = Math.max(1, width);
        height = Math.max(1, height);
        if (!isFinite(width)) {
            return false;
        }
        var size = this.size;
        var oldSize = this.oldSize;
        size[0] = width;
        size[1] = height;
        if (size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            oldSize[0] = size[0];
            oldSize[1] = size[1];
        }
        var _e = this.updatePagination(bboxes, width, height),
            pages = _e.pages,
            maxPageHeight = _e.maxPageHeight,
            maxPageWidth = _e.maxPageWidth;
        this.pages = pages;
        this.maxPageSize = [maxPageWidth - paddingX, maxPageHeight - paddingY];
        var pageNumber = this.pagination.currentPage;
        var page = this.pages[pageNumber];
        if (this.pages.length < 1 || !page) {
            this.visible = false;
            return;
        }
        this.visible = true;
        // Position legend items
        this.updatePositions(pageNumber);
        // Update legend item properties that don't affect the layout.
        this.update();
    };
    Legend.prototype.truncate = function (text, maxCharLength, maxItemWidth, paddedMarkerWidth, font, id) {
        var e_1, _a;
        var ellipsis = '...';
        var textChars = text.split('');
        var addEllipsis = false;
        if (text.length > maxCharLength) {
            text = '' + text.substring(0, maxCharLength);
            addEllipsis = true;
        }
        var labelWidth = Math.floor(paddedMarkerWidth + HdpiCanvas.getTextSize(text, font).width);
        if (labelWidth > maxItemWidth) {
            var truncatedText = '';
            var characterWidths = this.getCharacterWidths(font);
            var cumulativeWidth = paddedMarkerWidth + characterWidths[ellipsis];
            try {
                for (
                    var textChars_1 = __values$q(textChars), textChars_1_1 = textChars_1.next();
                    !textChars_1_1.done;
                    textChars_1_1 = textChars_1.next()
                ) {
                    var char = textChars_1_1.value;
                    if (!characterWidths[char]) {
                        characterWidths[char] = HdpiCanvas.getTextSize(char, font).width;
                    }
                    cumulativeWidth += characterWidths[char];
                    if (cumulativeWidth > maxItemWidth) {
                        break;
                    }
                    truncatedText += char;
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (textChars_1_1 && !textChars_1_1.done && (_a = textChars_1.return)) _a.call(textChars_1);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
            text = truncatedText;
            addEllipsis = true;
        }
        if (addEllipsis) {
            text += ellipsis;
            this.truncatedItems.add(id);
        } else {
            this.truncatedItems.delete(id);
        }
        return text;
    };
    Legend.prototype.updatePagination = function (bboxes, width, height) {
        var orientation = this.getOrientation();
        var trackingIndex = Math.min(this.paginationTrackingIndex, bboxes.length);
        this.pagination.orientation = orientation;
        this.pagination.translationX = 0;
        this.pagination.translationY = 0;
        var _a = this.calculatePagination(bboxes, width, height),
            pages = _a.pages,
            maxPageHeight = _a.maxPageHeight,
            maxPageWidth = _a.maxPageWidth,
            paginationBBox = _a.paginationBBox,
            paginationVertical = _a.paginationVertical;
        var newCurrentPage = pages.findIndex(function (p) {
            return p.endIndex >= trackingIndex;
        });
        this.pagination.currentPage = Math.min(Math.max(newCurrentPage, 0), pages.length - 1);
        var _b = this.item,
            itemPaddingX = _b.paddingX,
            itemPaddingY = _b.paddingY;
        var paginationComponentPadding = 8;
        var legendItemsWidth = maxPageWidth - itemPaddingX;
        var legendItemsHeight = maxPageHeight - itemPaddingY;
        var paginationX = 0;
        var paginationY = -paginationBBox.y - this.item.marker.size / 2;
        if (paginationVertical) {
            paginationY += legendItemsHeight + paginationComponentPadding;
        } else {
            paginationX += -paginationBBox.x + legendItemsWidth + paginationComponentPadding;
            paginationY += (legendItemsHeight - paginationBBox.height) / 2;
        }
        this.pagination.translationX = paginationX;
        this.pagination.translationY = paginationY;
        this.pagination.update();
        this.pagination.updateMarkers();
        return {
            maxPageHeight: maxPageHeight,
            maxPageWidth: maxPageWidth,
            pages: pages,
        };
    };
    Legend.prototype.calculatePagination = function (bboxes, width, height) {
        var _a, _b, _c;
        var _d = this.item,
            itemPaddingX = _d.paddingX,
            itemPaddingY = _d.paddingY;
        var orientation = this.getOrientation();
        var paginationVertical = ['left', 'right'].includes(this.position);
        var paginationBBox = this.pagination.computeBBox();
        var lastPassPaginationBBox = new BBox(0, 0, 0, 0);
        var pages = [];
        var maxPageWidth = 0;
        var maxPageHeight = 0;
        var count = 0;
        var stableOutput = function (lastPassPaginationBBox) {
            var width = lastPassPaginationBBox.width,
                height = lastPassPaginationBBox.height;
            return width === paginationBBox.width && height === paginationBBox.height;
        };
        var forceResult = this.maxWidth !== undefined || this.maxHeight !== undefined;
        do {
            if (count++ > 10) {
                Logger.warn('unable to find stable legend layout.');
                break;
            }
            paginationBBox = lastPassPaginationBBox;
            var maxWidth = width - (paginationVertical ? 0 : paginationBBox.width);
            var maxHeight = height - (paginationVertical ? paginationBBox.height : 0);
            var layout = gridLayout({
                orientation: orientation,
                bboxes: bboxes,
                maxHeight: maxHeight,
                maxWidth: maxWidth,
                itemPaddingY: itemPaddingY,
                itemPaddingX: itemPaddingX,
                forceResult: forceResult,
            });
            pages =
                (_a = layout === null || layout === void 0 ? void 0 : layout.pages) !== null && _a !== void 0 ? _a : [];
            maxPageWidth =
                (_b = layout === null || layout === void 0 ? void 0 : layout.maxPageWidth) !== null && _b !== void 0
                    ? _b
                    : 0;
            maxPageHeight =
                (_c = layout === null || layout === void 0 ? void 0 : layout.maxPageHeight) !== null && _c !== void 0
                    ? _c
                    : 0;
            var totalPages = pages.length;
            this.pagination.visible = totalPages > 1;
            this.pagination.totalPages = totalPages;
            this.pagination.update();
            lastPassPaginationBBox = this.pagination.computeBBox();
            if (!this.pagination.visible) {
                break;
            }
        } while (!stableOutput(lastPassPaginationBBox));
        return {
            maxPageWidth: maxPageWidth,
            maxPageHeight: maxPageHeight,
            pages: pages,
            paginationBBox: paginationBBox,
            paginationVertical: paginationVertical,
        };
    };
    Legend.prototype.updatePositions = function (pageNumber) {
        if (pageNumber === void 0) {
            pageNumber = 0;
        }
        var _a = this,
            paddingY = _a.item.paddingY,
            itemSelection = _a.itemSelection,
            pages = _a.pages;
        if (pages.length < 1 || !pages[pageNumber]) {
            return;
        }
        var _b = pages[pageNumber],
            columns = _b.columns,
            visibleStart = _b.startIndex,
            visibleEnd = _b.endIndex;
        // Position legend items using the layout computed above.
        var x = 0;
        var y = 0;
        var columnCount = columns.length;
        var rowCount = columns[0].indices.length;
        var horizontal = this.getOrientation() === 'horizontal';
        var itemHeight = columns[0].bboxes[0].height + paddingY;
        var rowSumColumnWidths = [];
        itemSelection.each(function (markerLabel, _, i) {
            var _a, _b;
            if (i < visibleStart || i > visibleEnd) {
                markerLabel.visible = false;
                return;
            }
            var pageIndex = i - visibleStart;
            var columnIndex = 0;
            var rowIndex = 0;
            if (horizontal) {
                columnIndex = pageIndex % columnCount;
                rowIndex = Math.floor(pageIndex / columnCount);
            } else {
                columnIndex = Math.floor(pageIndex / rowCount);
                rowIndex = pageIndex % rowCount;
            }
            markerLabel.visible = true;
            var column = columns[columnIndex];
            if (!column) {
                return;
            }
            y = itemHeight * rowIndex;
            x = (_a = rowSumColumnWidths[rowIndex]) !== null && _a !== void 0 ? _a : 0;
            rowSumColumnWidths[rowIndex] =
                ((_b = rowSumColumnWidths[rowIndex]) !== null && _b !== void 0 ? _b : 0) + column.columnWidth;
            // Round off for pixel grid alignment to work properly.
            markerLabel.translationX = Math.floor(x);
            markerLabel.translationY = Math.floor(y);
        });
    };
    Legend.prototype.updatePageNumber = function (pageNumber) {
        var pages = this.pages;
        // Track an item on the page in re-pagination cases (e.g. resize).
        var _a = pages[pageNumber],
            startIndex = _a.startIndex,
            endIndex = _a.endIndex;
        if (startIndex === 0) {
            // Stay on first page on pagination update.
            this.paginationTrackingIndex = 0;
        } else if (pageNumber === pages.length - 1) {
            // Stay on last page on pagination update.
            this.paginationTrackingIndex = endIndex;
        } else {
            // Track the middle item on the page).
            this.paginationTrackingIndex = Math.floor((startIndex + endIndex) / 2);
        }
        this.pagination.update();
        this.pagination.updateMarkers();
        this.updatePositions(pageNumber);
        this.ctx.updateService.update(ChartUpdateType.SCENE_RENDER);
    };
    Legend.prototype.update = function () {
        var _a = this.item,
            strokeWidth = _a.marker.strokeWidth,
            color = _a.label.color;
        this.itemSelection.each(function (markerLabel, datum) {
            var marker = datum.marker;
            markerLabel.markerFill = marker.fill;
            markerLabel.markerStroke = marker.stroke;
            markerLabel.markerStrokeWidth = strokeWidth;
            markerLabel.markerFillOpacity = marker.fillOpacity;
            markerLabel.markerStrokeOpacity = marker.strokeOpacity;
            markerLabel.opacity = datum.enabled ? 1 : 0.5;
            markerLabel.color = color;
        });
    };
    Legend.prototype.getDatumForPoint = function (x, y) {
        var e_2, _a;
        var visibleChildBBoxes = [];
        var closestLeftTop = { dist: Infinity, datum: undefined };
        try {
            for (var _b = __values$q(this.group.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (!child.visible) continue;
                if (!(child instanceof MarkerLabel)) continue;
                var childBBox = child.computeBBox();
                childBBox.grow(this.item.paddingX / 2, 'horizontal');
                childBBox.grow(this.item.paddingY / 2, 'vertical');
                if (childBBox.containsPoint(x, y)) {
                    return child.datum;
                }
                var distX = x - childBBox.x - this.item.paddingX / 2;
                var distY = y - childBBox.y - this.item.paddingY / 2;
                var dist = Math.pow(distX, 2) + Math.pow(distY, 2);
                var toTheLeftTop = distX >= 0 && distY >= 0;
                if (toTheLeftTop && dist < closestLeftTop.dist) {
                    closestLeftTop.dist = dist;
                    closestLeftTop.datum = child.datum;
                }
                visibleChildBBoxes.push(childBBox);
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        var pageBBox = BBox.merge(visibleChildBBoxes);
        if (!pageBBox.containsPoint(x, y)) {
            // We're not in-between legend items.
            return undefined;
        }
        // Fallback to returning closest match to the left/up.
        return closestLeftTop.datum;
    };
    Legend.prototype.computeBBox = function () {
        return this.group.computeBBox();
    };
    Legend.prototype.computePagedBBox = function () {
        var actualBBox = this.group.computeBBox();
        if (this.pages.length <= 1) {
            return actualBBox;
        }
        var _a = __read$U(this.maxPageSize, 2),
            maxPageWidth = _a[0],
            maxPageHeight = _a[1];
        actualBBox.height = Math.max(maxPageHeight, actualBBox.height);
        actualBBox.width = Math.max(maxPageWidth, actualBBox.width);
        return actualBBox;
    };
    Legend.prototype.checkLegendClick = function (event) {
        var _a = this,
            legendItemClick = _a.listeners.legendItemClick,
            _b = _a.ctx,
            dataService = _b.dataService,
            highlightManager = _b.highlightManager,
            toggleSeriesVisible = _a.item.toggleSeriesVisible;
        var offsetX = event.offsetX,
            offsetY = event.offsetY;
        var legendBBox = this.computeBBox();
        var pointerInsideLegend = this.group.visible && legendBBox.containsPoint(offsetX, offsetY);
        var datum = this.getDatumForPoint(offsetX, offsetY);
        if (!pointerInsideLegend || !datum) {
            return;
        }
        var id = datum.id,
            itemId = datum.itemId,
            enabled = datum.enabled;
        var chartSeries = dataService.getSeries();
        var series = chartSeries.find(function (s) {
            return s.id === id;
        });
        if (!series) {
            return;
        }
        event.consume();
        var newEnabled = enabled;
        if (toggleSeriesVisible) {
            newEnabled = !enabled;
            this.ctx.chartEventManager.legendItemClick(series, itemId, newEnabled, datum.legendItemName);
        }
        if (!newEnabled) {
            highlightManager.updateHighlight(this.id);
        } else {
            highlightManager.updateHighlight(this.id, {
                series: series,
                itemId: itemId,
                datum: undefined,
            });
        }
        this.ctx.updateService.update(ChartUpdateType.PROCESS_DATA, { forceNodeDataRefresh: true });
        legendItemClick === null || legendItemClick === void 0
            ? void 0
            : legendItemClick({ type: 'click', enabled: newEnabled, itemId: itemId, seriesId: series.id });
    };
    Legend.prototype.checkLegendDoubleClick = function (event) {
        var _a;
        var _b = this,
            legendItemDoubleClick = _b.listeners.legendItemDoubleClick,
            dataService = _b.ctx.dataService,
            toggleSeriesVisible = _b.item.toggleSeriesVisible;
        var offsetX = event.offsetX,
            offsetY = event.offsetY;
        // Integrated charts do not handle double click behaviour correctly due to multiple instances of the
        // chart being created. See https://ag-grid.atlassian.net/browse/RTI-1381
        if (this.ctx.mode === 'integrated') {
            return;
        }
        var legendBBox = this.computeBBox();
        var pointerInsideLegend = this.group.visible && legendBBox.containsPoint(offsetX, offsetY);
        var datum = this.getDatumForPoint(offsetX, offsetY);
        if (!pointerInsideLegend || !datum) {
            return;
        }
        var id = datum.id,
            itemId = datum.itemId,
            seriesId = datum.seriesId;
        var chartSeries = dataService.getSeries();
        var series = chartSeries.find(function (s) {
            return s.id === id;
        });
        if (!series) {
            return;
        }
        event.consume();
        if (toggleSeriesVisible) {
            var legendData = chartSeries.reduce(function (ls, s) {
                return __spreadArray$y(
                    __spreadArray$y([], __read$U(ls)),
                    __read$U(
                        s.getLegendData().filter(function (d) {
                            return d.legendType === 'category';
                        }),
                    ),
                );
            }, []);
            var numVisibleItems_1 = {};
            legendData.forEach(function (d) {
                var _a;
                var _b;
                (_a = numVisibleItems_1[(_b = d.seriesId)]) !== null && _a !== void 0
                    ? _a
                    : (numVisibleItems_1[_b] = 0);
                if (d.enabled) numVisibleItems_1[d.seriesId]++;
            });
            var clickedItem = legendData.find(function (d) {
                return d.itemId === itemId && d.seriesId === seriesId;
            });
            this.ctx.chartEventManager.legendItemDoubleClick(
                series,
                itemId,
                (_a = clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.enabled) !== null &&
                    _a !== void 0
                    ? _a
                    : false,
                numVisibleItems_1,
                clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.legendItemName,
            );
        }
        this.ctx.updateService.update(ChartUpdateType.PROCESS_DATA, { forceNodeDataRefresh: true });
        legendItemDoubleClick === null || legendItemDoubleClick === void 0
            ? void 0
            : legendItemDoubleClick({ type: 'dblclick', enabled: true, itemId: itemId, seriesId: series.id });
    };
    Legend.prototype.handleLegendMouseMove = function (event) {
        var _a;
        var _b = this,
            enabled = _b.enabled,
            toggleSeriesVisible = _b.item.toggleSeriesVisible,
            listeners = _b.listeners;
        if (!enabled) {
            return;
        }
        var legendBBox = this.computeBBox();
        var pageX = event.pageX,
            pageY = event.pageY,
            offsetX = event.offsetX,
            offsetY = event.offsetY;
        var pointerInsideLegend = this.group.visible && legendBBox.containsPoint(offsetX, offsetY);
        if (!pointerInsideLegend) {
            this.ctx.cursorManager.updateCursor(this.id);
            this.ctx.highlightManager.updateHighlight(this.id);
            this.ctx.tooltipManager.removeTooltip(this.id);
            return;
        }
        // Prevent other handlers from consuming this event if it's generated inside the legend
        // boundaries.
        event.consume();
        var datum = this.getDatumForPoint(offsetX, offsetY);
        var pointerOverLegendDatum = pointerInsideLegend && datum !== undefined;
        if (!pointerOverLegendDatum) {
            this.ctx.cursorManager.updateCursor(this.id);
            this.ctx.highlightManager.updateHighlight(this.id);
            return;
        }
        var series = datum
            ? this.ctx.dataService.getSeries().find(function (series) {
                  return series.id === (datum === null || datum === void 0 ? void 0 : datum.id);
              })
            : undefined;
        if (datum && this.truncatedItems.has((_a = datum.itemId) !== null && _a !== void 0 ? _a : datum.id)) {
            var labelText = this.getItemLabel(datum);
            this.ctx.tooltipManager.updateTooltip(
                this.id,
                { pageX: pageX, pageY: pageY, offsetX: offsetX, offsetY: offsetY, event: event, showArrow: false },
                toTooltipHtml$1({ content: labelText }),
            );
        } else {
            this.ctx.tooltipManager.removeTooltip(this.id);
        }
        if (toggleSeriesVisible || listeners.legendItemClick != null || listeners.legendItemDoubleClick != null) {
            this.ctx.cursorManager.updateCursor(this.id, 'pointer');
        }
        if ((datum === null || datum === void 0 ? void 0 : datum.enabled) && series) {
            this.ctx.highlightManager.updateHighlight(this.id, {
                series: series,
                itemId: datum === null || datum === void 0 ? void 0 : datum.itemId,
                datum: undefined,
            });
        } else {
            this.ctx.highlightManager.updateHighlight(this.id);
        }
    };
    Legend.prototype.positionLegend = function (shrinkRect) {
        var _this = this;
        var newShrinkRect = shrinkRect.clone();
        if (!this.enabled || !this.data.length) {
            return { shrinkRect: newShrinkRect };
        }
        var _a = __read$U(this.calculateLegendDimensions(shrinkRect), 2),
            legendWidth = _a[0],
            legendHeight = _a[1];
        this.group.translationX = 0;
        this.group.translationY = 0;
        this.performLayout(legendWidth, legendHeight);
        var legendBBox = this.computePagedBBox();
        var calculateTranslationPerpendicularDimension = function () {
            switch (_this.position) {
                case 'top':
                    return 0;
                case 'bottom':
                    return shrinkRect.height - legendBBox.height;
                case 'left':
                    return 0;
                case 'right':
                default:
                    return shrinkRect.width - legendBBox.width;
            }
        };
        if (this.visible) {
            var translationX = void 0;
            var translationY = void 0;
            switch (this.position) {
                case 'top':
                case 'bottom':
                    translationX = (shrinkRect.width - legendBBox.width) / 2;
                    translationY = calculateTranslationPerpendicularDimension();
                    newShrinkRect.shrink(legendBBox.height, this.position);
                    break;
                case 'left':
                case 'right':
                default:
                    translationX = calculateTranslationPerpendicularDimension();
                    translationY = (shrinkRect.height - legendBBox.height) / 2;
                    newShrinkRect.shrink(legendBBox.width, this.position);
            }
            // Round off for pixel grid alignment to work properly.
            this.group.translationX = Math.floor(-legendBBox.x + shrinkRect.x + translationX);
            this.group.translationY = Math.floor(-legendBBox.y + shrinkRect.y + translationY);
        }
        if (this.visible && this.enabled && this.data.length) {
            var legendPadding = this.spacing;
            newShrinkRect.shrink(legendPadding, this.position);
            var legendPositionedBBox = legendBBox.clone();
            legendPositionedBBox.x += this.group.translationX;
            legendPositionedBBox.y += this.group.translationY;
            this.ctx.tooltipManager.updateExclusiveRect(this.id, legendPositionedBBox);
        } else {
            this.ctx.tooltipManager.updateExclusiveRect(this.id);
        }
        return { shrinkRect: newShrinkRect };
    };
    Legend.prototype.calculateLegendDimensions = function (shrinkRect) {
        var width = shrinkRect.width,
            height = shrinkRect.height;
        var aspectRatio = width / height;
        var maxCoefficient = 0.5;
        var minHeightCoefficient = 0.2;
        var minWidthCoefficient = 0.25;
        var legendWidth = 0;
        var legendHeight = 0;
        switch (this.position) {
            case 'top':
            case 'bottom':
                // A horizontal legend should take maximum between 20 to 50 percent of the chart height if height is larger than width
                // and maximum 20 percent of the chart height if height is smaller than width.
                var heightCoefficient =
                    aspectRatio < 1
                        ? Math.min(maxCoefficient, minHeightCoefficient * (1 / aspectRatio))
                        : minHeightCoefficient;
                legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : width;
                legendHeight = this.maxHeight
                    ? Math.min(this.maxHeight, height)
                    : Math.round(height * heightCoefficient);
                break;
            case 'left':
            case 'right':
            default:
                // A vertical legend should take maximum between 25 to 50 percent of the chart width if width is larger than height
                // and maximum 25 percent of the chart width if width is smaller than height.
                var widthCoefficient =
                    aspectRatio > 1 ? Math.min(maxCoefficient, minWidthCoefficient * aspectRatio) : minWidthCoefficient;
                legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : Math.round(width * widthCoefficient);
                legendHeight = this.maxHeight ? Math.min(this.maxHeight, height) : height;
        }
        return [legendWidth, legendHeight];
    };
    Legend.className = 'Legend';
    __decorate$1M([Validate(BOOLEAN)], Legend.prototype, '_enabled', void 0);
    __decorate$1M([Validate(POSITION)], Legend.prototype, 'position', void 0);
    __decorate$1M([Validate(OPT_NUMBER(0))], Legend.prototype, 'maxWidth', void 0);
    __decorate$1M([Validate(OPT_NUMBER(0))], Legend.prototype, 'maxHeight', void 0);
    __decorate$1M([Validate(OPT_BOOLEAN)], Legend.prototype, 'reverseOrder', void 0);
    __decorate$1M([Validate(OPT_ORIENTATION)], Legend.prototype, 'orientation', void 0);
    __decorate$1M([Validate(NUMBER(0))], Legend.prototype, 'spacing', void 0);
    return Legend;
})();

var LEGEND_FACTORIES = {
    category: Legend,
};
function registerLegend(type, ctr) {
    if (LEGEND_FACTORIES[type]) {
        throw new Error('AG Charts - already registered legend type: ' + type);
    }
    LEGEND_FACTORIES[type] = ctr;
}
function getLegend(type, ctx) {
    if (LEGEND_FACTORIES[type]) {
        return new LEGEND_FACTORIES[type](ctx);
    }
    throw new Error('AG Charts - unknown legend type: ' + type);
}

var __read$T =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$x =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var CallbackCache = /** @class */ (function () {
    function CallbackCache() {
        this.cache = new Map();
    }
    CallbackCache.prototype.call = function (f) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var serialisedParams;
        var paramCache = this.cache.get(f);
        var invoke = function () {
            try {
                var result = f.apply(void 0, __spreadArray$x([], __read$T(params)));
                if (paramCache && serialisedParams != null) {
                    paramCache.set(serialisedParams, result);
                }
                return result;
            } catch (e) {
                Logger.warnOnce('User callback errored, ignoring', e);
                return undefined;
            }
        };
        try {
            serialisedParams = JSON.stringify(params);
        } catch (e) {
            // Unable to serialise params!
            // No caching possible.
            return invoke();
        }
        if (paramCache == null) {
            paramCache = new Map();
            this.cache.set(f, paramCache);
        }
        if (!paramCache.has(serialisedParams)) {
            return invoke();
        }
        return paramCache.get(serialisedParams);
    };
    CallbackCache.prototype.invalidateCache = function () {
        this.cache = new Map();
    };
    return CallbackCache;
})();

var __assign$L =
    (undefined && undefined.__assign) ||
    function () {
        __assign$L =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$L.apply(this, arguments);
    };
var __awaiter$d =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$d =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __values$p =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$S =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$w =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
/** Implements cross-series data model coordination. */
var DataController = /** @class */ (function () {
    function DataController() {
        this.requested = [];
        this.status = 'setup';
    }
    DataController.prototype.request = function (id, data, opts) {
        return __awaiter$d(this, void 0, void 0, function () {
            var _this = this;
            return __generator$d(this, function (_a) {
                if (this.status !== 'setup') throw new Error('AG Charts - data request after data setup phase.');
                return [
                    2 /*return*/,
                    new Promise(function (resolve, reject) {
                        _this.requested.push({
                            id: id,
                            opts: opts,
                            data: data,
                            resultCb: resolve,
                            reject: reject,
                        });
                    }),
                ];
            });
        });
    };
    DataController.prototype.execute = function () {
        return __awaiter$d(this, void 0, void 0, function () {
            var merged, _loop_1, this_1, merged_1, merged_1_1, _a, opts, data, resultCbs, rejects, ids;
            var e_1, _b;
            return __generator$d(this, function (_c) {
                if (this.status !== 'setup') throw new Error('AG Charts - data request after data setup phase.');
                this.status = 'executed';
                if (DataController.DEBUG()) Logger.debug('DataController.execute() - requested', this.requested);
                merged = this.mergeRequested();
                if (DataController.DEBUG()) Logger.debug('DataController.execute() - merged', merged);
                _loop_1 = function (opts, data, resultCbs, rejects, ids) {
                    try {
                        var dataModel_1 = new DataModel(opts);
                        var processedData_1 = dataModel_1.processData(data);
                        if (processedData_1 && processedData_1.partialValidDataCount === 0) {
                            resultCbs.forEach(function (cb) {
                                return cb({ dataModel: dataModel_1, processedData: processedData_1 });
                            });
                        } else if (processedData_1) {
                            this_1.splitResult(dataModel_1, processedData_1, ids, resultCbs);
                        } else {
                            rejects.forEach(function (cb) {
                                return cb(new Error('AG Charts - no processed data generated'));
                            });
                        }
                    } catch (error) {
                        rejects.forEach(function (cb) {
                            return cb(error);
                        });
                    }
                };
                this_1 = this;
                try {
                    for (
                        merged_1 = __values$p(merged), merged_1_1 = merged_1.next();
                        !merged_1_1.done;
                        merged_1_1 = merged_1.next()
                    ) {
                        (_a = merged_1_1.value),
                            (opts = _a.opts),
                            (data = _a.data),
                            (resultCbs = _a.resultCbs),
                            (rejects = _a.rejects),
                            (ids = _a.ids);
                        _loop_1(opts, data, resultCbs, rejects, ids);
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (merged_1_1 && !merged_1_1.done && (_b = merged_1.return)) _b.call(merged_1);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    DataController.prototype.mergeRequested = function () {
        var e_2, _a;
        var grouped = [];
        var keys = function (props) {
            return props
                .filter(function (p) {
                    return p.type === 'key';
                })
                .map(function (p) {
                    return p.property;
                })
                .join(';');
        };
        var groupMatch = function (_a) {
            var opts = _a.opts,
                data = _a.data;
            return function (gr) {
                return (
                    gr[0].data === data &&
                    gr[0].opts.groupByKeys === opts.groupByKeys &&
                    gr[0].opts.dataVisible === opts.dataVisible &&
                    gr[0].opts.groupByFn === opts.groupByFn &&
                    keys(gr[0].opts.props) === keys(opts.props)
                );
            };
        };
        var propMatch = function (prop) {
            return function (existing) {
                var _a;
                if (existing.type !== prop.type) return false;
                if (existing.id !== prop.id) return false;
                var diff = (_a = jsonDiff(existing, prop)) !== null && _a !== void 0 ? _a : {};
                delete diff['scopes'];
                return Object.keys(diff).length === 0;
            };
        };
        var mergeOpts = function (opts) {
            return __assign$L(__assign$L({}, opts[0]), {
                props: opts.reduce(function (result, next) {
                    var e_3, _a, _b;
                    var _c, _d, _e;
                    try {
                        for (var _f = __values$p(next.props), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var prop = _g.value;
                            var match = result.find(propMatch(prop));
                            if (match) {
                                (_c = match.scopes) !== null && _c !== void 0 ? _c : (match.scopes = []);
                                (_b = match.scopes).push.apply(
                                    _b,
                                    __spreadArray$w(
                                        __spreadArray$w(
                                            [],
                                            __read$S((_d = prop.scopes) !== null && _d !== void 0 ? _d : []),
                                        ),
                                        __read$S((_e = next.scopes) !== null && _e !== void 0 ? _e : []),
                                    ),
                                );
                                continue;
                            }
                            result.push(prop);
                        }
                    } catch (e_3_1) {
                        e_3 = { error: e_3_1 };
                    } finally {
                        try {
                            if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                        } finally {
                            if (e_3) throw e_3.error;
                        }
                    }
                    return result;
                }, []),
            });
        };
        var merge = function (props) {
            return {
                ids: props.map(function (_a) {
                    var id = _a.id;
                    return id;
                }),
                resultCbs: props.map(function (_a) {
                    var resultCb = _a.resultCb;
                    return resultCb;
                }),
                rejects: props.map(function (_a) {
                    var reject = _a.reject;
                    return reject;
                }),
                data: props[0].data,
                opts: mergeOpts(
                    props.map(function (_a) {
                        var opts = _a.opts;
                        return opts;
                    }),
                ),
            };
        };
        try {
            for (var _b = __values$p(this.requested), _c = _b.next(); !_c.done; _c = _b.next()) {
                var request = _c.value;
                var match = grouped.find(groupMatch(request));
                if (match) {
                    match.push(request);
                } else {
                    grouped.push([request]);
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        return grouped.map(merge);
    };
    DataController.prototype.splitResult = function (dataModel, processedData, scopes, resultCbs) {
        var _loop_2 = function (index) {
            var scope = scopes[index];
            var resultCb = resultCbs[index];
            resultCb({
                dataModel: dataModel,
                processedData: __assign$L(__assign$L({}, processedData), {
                    data: processedData.data.filter(function (_a) {
                        var validScopes = _a.validScopes;
                        return (
                            validScopes == null ||
                            validScopes.some(function (s) {
                                return s === scope;
                            })
                        );
                    }),
                }),
            });
        };
        for (var index = 0; index < scopes.length; index++) {
            _loop_2(index);
        }
    };
    DataController.DEBUG = function () {
        var _a;
        return (_a = [true, 'data-model'].includes(windowValue('agChartsDebug'))) !== null && _a !== void 0
            ? _a
            : false;
    };
    return DataController;
})();

var __read$R =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$v =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var SeriesStateManager = /** @class */ (function () {
    function SeriesStateManager() {
        this.groups = {};
    }
    SeriesStateManager.prototype.registerSeries = function (_a) {
        var _b;
        var _c;
        var id = _a.id,
            seriesGrouping = _a.seriesGrouping,
            visible = _a.visible,
            type = _a.type;
        if (!seriesGrouping) return;
        (_b = (_c = this.groups)[type]) !== null && _b !== void 0 ? _b : (_c[type] = {});
        this.groups[type][id] = { grouping: seriesGrouping, visible: visible };
    };
    SeriesStateManager.prototype.deregisterSeries = function (_a) {
        var id = _a.id,
            type = _a.type;
        if (this.groups[type]) {
            delete this.groups[type][id];
        }
        if (this.groups[type] && Object.keys(this.groups[type]).length === 0) {
            delete this.groups[type];
        }
    };
    SeriesStateManager.prototype.getVisiblePeerGroupIndex = function (_a) {
        var _b;
        var type = _a.type,
            seriesGrouping = _a.seriesGrouping;
        if (!seriesGrouping) return { visibleGroupCount: 1, index: 0 };
        var visibleGroups = __spreadArray$v(
            [],
            __read$R(
                Object.entries((_b = this.groups[type]) !== null && _b !== void 0 ? _b : {})
                    .filter(function (_a) {
                        var _b = __read$R(_a, 2);
                        _b[0];
                        var entry = _b[1];
                        return entry.visible;
                    })
                    .reduce(function (result, _a) {
                        var _b = __read$R(_a, 2);
                        _b[0];
                        var next = _b[1];
                        if (next.visible) {
                            result.add(next.grouping.groupIndex);
                        }
                        return result;
                    }, new Set())
                    .values(),
            ),
        );
        visibleGroups.sort(function (a, b) {
            return a - b;
        });
        return { visibleGroupCount: visibleGroups.length, index: visibleGroups.indexOf(seriesGrouping.groupIndex) };
    };
    return SeriesStateManager;
})();

var __values$o =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var SeriesLayerManager = /** @class */ (function () {
    function SeriesLayerManager(rootGroup) {
        this.groups = {};
        this.series = {};
        this.rootGroup = rootGroup;
    }
    SeriesLayerManager.prototype.requestGroup = function (seriesConfig) {
        var _a, _b;
        var _c, _d;
        var id = seriesConfig.id,
            type = seriesConfig.type,
            seriesRootGroup = seriesConfig.rootGroup,
            seriesGrouping = seriesConfig.seriesGrouping;
        var _e = (seriesGrouping !== null && seriesGrouping !== void 0 ? seriesGrouping : {}).groupIndex,
            groupIndex = _e === void 0 ? id : _e;
        if (this.series[id] != null) {
            throw new Error('AG Charts - series already has an allocated layer: ' + this.series[id]);
        }
        (_a = (_c = this.groups)[type]) !== null && _a !== void 0 ? _a : (_c[type] = {});
        var groupInfo = this.groups[type][groupIndex];
        if (!groupInfo) {
            groupInfo =
                (_b = (_d = this.groups[type])[groupIndex]) !== null && _b !== void 0
                    ? _b
                    : (_d[groupIndex] = {
                          seriesIds: [],
                          group: this.rootGroup.appendChild(
                              new Group({
                                  name: type + '-content',
                                  layer: true,
                                  zIndex: Layers.SERIES_LAYER_ZINDEX,
                                  zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder('data'),
                              }),
                          ),
                      });
        }
        this.series[id] = { layerState: groupInfo, seriesConfig: seriesConfig };
        groupInfo.seriesIds.push(id);
        groupInfo.group.appendChild(seriesRootGroup);
        return groupInfo.group;
    };
    SeriesLayerManager.prototype.changeGroup = function (seriesConfig) {
        var _a, _b;
        var id = seriesConfig.id,
            seriesGrouping = seriesConfig.seriesGrouping,
            type = seriesConfig.type,
            rootGroup = seriesConfig.rootGroup,
            oldGrouping = seriesConfig.oldGrouping;
        var _c = (seriesGrouping !== null && seriesGrouping !== void 0 ? seriesGrouping : {}).groupIndex,
            groupIndex = _c === void 0 ? id : _c;
        if (
            (_b = (_a = this.groups[type]) === null || _a === void 0 ? void 0 : _a[groupIndex]) === null ||
            _b === void 0
                ? void 0
                : _b.seriesIds.includes(id)
        ) {
            // Already in the right group, nothing to do.
            return;
        }
        if (this.series[id] != null) {
            this.releaseGroup({ id: id, seriesGrouping: oldGrouping, type: type, rootGroup: rootGroup });
        }
        this.requestGroup(seriesConfig);
    };
    SeriesLayerManager.prototype.releaseGroup = function (seriesConfig) {
        var _a, _b, _c, _d, _e;
        var id = seriesConfig.id,
            seriesGrouping = seriesConfig.seriesGrouping,
            rootGroup = seriesConfig.rootGroup,
            type = seriesConfig.type;
        var _f = (seriesGrouping !== null && seriesGrouping !== void 0 ? seriesGrouping : {}).groupIndex,
            groupIndex = _f === void 0 ? id : _f;
        if (this.series[id] == null) {
            throw new Error("AG Charts - series doesn't have an allocated layer: " + id);
        }
        var groupInfo =
            (_b = (_a = this.groups[type]) === null || _a === void 0 ? void 0 : _a[groupIndex]) !== null &&
            _b !== void 0
                ? _b
                : (_c = this.series[id]) === null || _c === void 0
                ? void 0
                : _c.layerState;
        if (groupInfo) {
            groupInfo.seriesIds = groupInfo.seriesIds.filter(function (v) {
                return v !== id;
            });
            groupInfo.group.removeChild(rootGroup);
        }
        if ((groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.seriesIds.length) === 0) {
            // Last member of the layer, cleanup.
            this.rootGroup.removeChild(groupInfo.group);
            delete this.groups[type][groupIndex];
            delete this.groups[type][id];
        } else if ((groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.seriesIds.length) > 0) {
            // Update zIndexSubOrder to avoid it becoming stale as series are removed and re-added
            // with the same groupIndex, but are otherwise unrelated.
            var leadSeriesConfig =
                (_e =
                    this.series[
                        (_d = groupInfo === null || groupInfo === void 0 ? void 0 : groupInfo.seriesIds) === null ||
                        _d === void 0
                            ? void 0
                            : _d[0]
                    ]) === null || _e === void 0
                    ? void 0
                    : _e.seriesConfig;
            groupInfo.group.zIndexSubOrder =
                leadSeriesConfig === null || leadSeriesConfig === void 0
                    ? void 0
                    : leadSeriesConfig.getGroupZIndexSubOrder('data');
        }
        delete this.series[id];
    };
    SeriesLayerManager.prototype.destroy = function () {
        var e_1, _a, e_2, _b;
        try {
            for (var _c = __values$o(Object.values(this.groups)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var groups = _d.value;
                try {
                    for (
                        var _e = ((e_2 = void 0), __values$o(Object.values(groups))), _f = _e.next();
                        !_f.done;
                        _f = _e.next()
                    ) {
                        var groupInfo = _f.value;
                        this.rootGroup.removeChild(groupInfo.group);
                    }
                } catch (e_2_1) {
                    e_2 = { error: e_2_1 };
                } finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    } finally {
                        if (e_2) throw e_2.error;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        this.groups = {};
        this.series = {};
    };
    return SeriesLayerManager;
})();

var __extends$2r =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$K =
    (undefined && undefined.__assign) ||
    function () {
        __assign$K =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$K.apply(this, arguments);
    };
var __decorate$1L =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$c =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$c =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$Q =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __values$n =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __spreadArray$u =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var Chart = /** @class */ (function (_super) {
    __extends$2r(Chart, _super);
    function Chart(document, overrideDevicePixelRatio, resources) {
        if (document === void 0) {
            document = window.document;
        }
        var _a;
        var _this = _super.call(this) || this;
        _this.id = createId$1(_this);
        _this.processedOptions = {};
        _this.userOptions = {};
        _this.queuedUserOptions = [];
        _this.seriesRoot = new Group({ name: _this.id + '-Series-root' });
        _this.extraDebugStats = {};
        _this.container = undefined;
        _this.data = [];
        _this.padding = new Padding$1(20);
        _this.seriesAreaPadding = new Padding$1(0);
        _this.title = undefined;
        _this.subtitle = undefined;
        _this.footnote = undefined;
        _this.mode = 'standalone';
        _this._destroyed = false;
        _this.modules = {};
        _this.legendModules = {};
        _this._pendingFactoryUpdates = [];
        _this._performUpdateNoRenderCount = 0;
        _this._performUpdateType = ChartUpdateType.NONE;
        _this.seriesToUpdate = new Set();
        _this.performUpdateTrigger = debouncedCallback(function (_a) {
            var count = _a.count;
            return __awaiter$c(_this, void 0, void 0, function () {
                var error_1;
                return __generator$c(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (this._destroyed) return [2 /*return*/];
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.performUpdate(count)];
                        case 2:
                            _b.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _b.sent();
                            this._lastPerformUpdateError = error_1;
                            Logger.error('update error', error_1);
                            return [3 /*break*/, 4];
                        case 4:
                            return [2 /*return*/];
                    }
                });
            });
        });
        _this._axes = [];
        _this._series = [];
        _this.applyLegendOptions = undefined;
        _this.lastInteractionEvent = undefined;
        _this.pointerScheduler = debouncedAnimationFrame(function () {
            if (_this.lastInteractionEvent) {
                _this.handlePointer(_this.lastInteractionEvent);
            }
            _this.lastInteractionEvent = undefined;
        });
        _this.onSeriesNodeClick = function (event) {
            var seriesNodeClickEvent = __assign$K(__assign$K({}, event), { type: 'seriesNodeClick' });
            Object.defineProperty(seriesNodeClickEvent, 'series', {
                enumerable: false,
                // Should display the deprecation warning
                get: function () {
                    return event.series;
                },
            });
            _this.fireEvent(seriesNodeClickEvent);
        };
        _this.onSeriesNodeDoubleClick = function (event) {
            var seriesNodeDoubleClick = __assign$K(__assign$K({}, event), { type: 'seriesNodeDoubleClick' });
            _this.fireEvent(seriesNodeDoubleClick);
        };
        var scene = resources === null || resources === void 0 ? void 0 : resources.scene;
        var element =
            (_a = resources === null || resources === void 0 ? void 0 : resources.element) !== null && _a !== void 0
                ? _a
                : document.createElement('div');
        var container = resources === null || resources === void 0 ? void 0 : resources.container;
        var root = new Group({ name: 'root' });
        // Prevent the scene from rendering chart components in an invalid state
        // (before first layout is performed).
        root.visible = false;
        root.append(_this.seriesRoot);
        _this.axisGroup = new Group({ name: 'Axes', layer: true, zIndex: Layers.AXIS_ZINDEX });
        root.appendChild(_this.axisGroup);
        _this.element = element;
        element.classList.add('ag-chart-wrapper');
        element.style.position = 'relative';
        _this.scene =
            scene !== null && scene !== void 0
                ? scene
                : new Scene({ document: document, overrideDevicePixelRatio: overrideDevicePixelRatio });
        _this.scene.debug.consoleLog = false;
        _this.scene.root = root;
        _this.scene.container = element;
        _this.autoSize = true;
        _this.chartEventManager = new ChartEventManager();
        _this.cursorManager = new CursorManager(element);
        _this.highlightManager = new HighlightManager();
        _this.interactionManager = new InteractionManager(element);
        _this.zoomManager = new ZoomManager();
        _this.dataService = new DataService(function () {
            return _this.series;
        });
        _this.layoutService = new LayoutService();
        _this.updateService = new UpdateService(function (type, _a) {
            if (type === void 0) {
                type = ChartUpdateType.FULL;
            }
            var forceNodeDataRefresh = _a.forceNodeDataRefresh;
            return _this.update(type, { forceNodeDataRefresh: forceNodeDataRefresh });
        });
        _this.seriesStateManager = new SeriesStateManager();
        _this.seriesLayerManager = new SeriesLayerManager(_this.seriesRoot);
        _this.callbackCache = new CallbackCache();
        _this.animationManager = new AnimationManager(_this.interactionManager);
        _this.animationManager.skipAnimations = true;
        _this.animationManager.play();
        _this.tooltip = new Tooltip(_this.scene.canvas.element, document, document.body);
        _this.tooltipManager = new TooltipManager(_this.tooltip, _this.interactionManager);
        _this.overlays = new ChartOverlays(_this.element);
        _this.highlight = new ChartHighlight();
        _this.container = container;
        _this.debug = false;
        SizeMonitor.observe(_this.element, function (size) {
            var _a;
            var width = size.width,
                height = size.height;
            if (!_this.autoSize) {
                return;
            }
            if (width === 0 && height === 0) {
                return;
            }
            var _b = __read$Q((_a = _this._lastAutoSize) !== null && _a !== void 0 ? _a : [], 2),
                _c = _b[0],
                autoWidth = _c === void 0 ? 0 : _c,
                _d = _b[1],
                authHeight = _d === void 0 ? 0 : _d;
            if (autoWidth === width && authHeight === height) {
                return;
            }
            _this._lastAutoSize = [width, height];
            _this.resize();
        });
        _this.layoutService.addListener('start-layout', function (e) {
            return _this.positionPadding(e.shrinkRect);
        });
        _this.layoutService.addListener('start-layout', function (e) {
            return _this.positionCaptions(e.shrinkRect);
        });
        // Add interaction listeners last so child components are registered first.
        _this.interactionManager.addListener('click', function (event) {
            return _this.onClick(event);
        });
        _this.interactionManager.addListener('dblclick', function (event) {
            return _this.onDoubleClick(event);
        });
        _this.interactionManager.addListener('hover', function (event) {
            return _this.onMouseMove(event);
        });
        _this.interactionManager.addListener('leave', function (event) {
            return _this.onLeave(event);
        });
        _this.interactionManager.addListener('page-left', function () {
            return _this.destroy();
        });
        _this.interactionManager.addListener('wheel', function () {
            return _this.disablePointer();
        });
        _this.animationManager.addListener('animation-frame', function (_) {
            _this.update(ChartUpdateType.SCENE_RENDER);
        });
        _this.highlightManager.addListener('highlight-change', function (event) {
            return _this.changeHighlightDatum(event);
        });
        _this.zoomManager.addListener('zoom-change', function (_) {
            return _this.update(ChartUpdateType.PROCESS_DATA, { forceNodeDataRefresh: true });
        });
        _this.attachLegend('category');
        return _this;
    }
    Chart.prototype.getOptions = function () {
        var _a;
        var queuedUserOptions = this.queuedUserOptions;
        var lastUpdateOptions =
            (_a = queuedUserOptions[queuedUserOptions.length - 1]) !== null && _a !== void 0 ? _a : this.userOptions;
        return jsonMerge([lastUpdateOptions]);
    };
    Chart.prototype.autoSizeChanged = function (value) {
        var style = this.element.style;
        if (value) {
            style.display = 'block';
            style.width = '100%';
            style.height = '100%';
            if (!this._lastAutoSize) {
                return;
            }
            this.resize();
        } else {
            style.display = 'inline-block';
            style.width = 'auto';
            style.height = 'auto';
        }
    };
    Chart.prototype.download = function (fileName, fileFormat) {
        this.scene.download(fileName, fileFormat);
    };
    Object.defineProperty(Chart.prototype, 'destroyed', {
        get: function () {
            return this._destroyed;
        },
        enumerable: false,
        configurable: true,
    });
    Chart.prototype.addModule = function (module) {
        if (this.modules[module.optionsKey] != null) {
            throw new Error('AG Charts - module already initialised: ' + module.optionsKey);
        }
        var moduleInstance = new module.instanceConstructor(this.getModuleContext());
        this.modules[module.optionsKey] = { instance: moduleInstance };
        this[module.optionsKey] = moduleInstance;
    };
    Chart.prototype.removeModule = function (module) {
        var _a, _b;
        (_b = (_a = this.modules[module.optionsKey]) === null || _a === void 0 ? void 0 : _a.instance) === null ||
        _b === void 0
            ? void 0
            : _b.destroy();
        delete this.modules[module.optionsKey];
        delete this[module.optionsKey];
    };
    Chart.prototype.isModuleEnabled = function (module) {
        return this.modules[module.optionsKey] != null;
    };
    Chart.prototype.getModuleContext = function () {
        var _a = this,
            scene = _a.scene,
            animationManager = _a.animationManager,
            chartEventManager = _a.chartEventManager,
            cursorManager = _a.cursorManager,
            highlightManager = _a.highlightManager,
            interactionManager = _a.interactionManager,
            tooltipManager = _a.tooltipManager,
            zoomManager = _a.zoomManager,
            dataService = _a.dataService,
            layoutService = _a.layoutService,
            updateService = _a.updateService,
            seriesStateManager = _a.seriesStateManager,
            seriesLayerManager = _a.seriesLayerManager,
            mode = _a.mode,
            callbackCache = _a.callbackCache;
        return {
            scene: scene,
            animationManager: animationManager,
            chartEventManager: chartEventManager,
            cursorManager: cursorManager,
            highlightManager: highlightManager,
            interactionManager: interactionManager,
            tooltipManager: tooltipManager,
            zoomManager: zoomManager,
            dataService: dataService,
            layoutService: layoutService,
            updateService: updateService,
            mode: mode,
            seriesStateManager: seriesStateManager,
            seriesLayerManager: seriesLayerManager,
            callbackCache: callbackCache,
        };
    };
    Chart.prototype.destroy = function (opts) {
        var e_1, _a;
        var _b;
        if (this._destroyed) {
            return;
        }
        var keepTransferableResources = opts === null || opts === void 0 ? void 0 : opts.keepTransferableResources;
        var result = undefined;
        this._performUpdateType = ChartUpdateType.NONE;
        this._pendingFactoryUpdates.splice(0);
        this.tooltipManager.destroy();
        this.tooltip.destroy();
        (_b = this.legend) === null || _b === void 0 ? void 0 : _b.destroy();
        this.overlays.noData.hide();
        SizeMonitor.unobserve(this.element);
        try {
            for (var _c = __values$n(Object.entries(this.modules)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read$Q(_d.value, 2),
                    key = _e[0],
                    module = _e[1];
                module.instance.destroy();
                delete this.modules[key];
                delete this[key];
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        this.interactionManager.destroy();
        this.animationManager.stop();
        if (keepTransferableResources) {
            this.scene.strip();
            result = { container: this.container, scene: this.scene, element: this.element };
        } else {
            this.scene.destroy();
            this.container = undefined;
        }
        this.removeAllSeries();
        this.seriesLayerManager.destroy();
        this.axes.forEach(function (a) {
            return a.destroy();
        });
        this.axes = [];
        this.callbackCache.invalidateCache();
        this._destroyed = true;
        return result;
    };
    Chart.prototype.log = function () {
        var opts = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            opts[_i] = arguments[_i];
        }
        if (this.debug) {
            Logger.debug.apply(Logger, __spreadArray$u([], __read$Q(opts)));
        }
    };
    Chart.prototype.disablePointer = function (highlightOnly) {
        if (highlightOnly === void 0) {
            highlightOnly = false;
        }
        if (!highlightOnly) {
            this.tooltipManager.removeTooltip(this.id);
        }
        this.highlightManager.updateHighlight(this.id);
        if (this.lastInteractionEvent) {
            this.lastInteractionEvent = undefined;
        }
    };
    Chart.prototype.requestFactoryUpdate = function (cb) {
        var callbacks = this._pendingFactoryUpdates;
        var count = callbacks.length;
        if (count === 0) {
            callbacks.push(cb);
            this._processCallbacks().catch(function (e) {
                return Logger.errorOnce(e);
            });
        } else {
            // Factory callback process already running, the callback will be invoked asynchronously.
            // Clear the queue after the first callback to prevent unnecessary re-renderings.
            callbacks.splice(1, count - 1, cb);
        }
    };
    Chart.prototype._processCallbacks = function () {
        return __awaiter$c(this, void 0, void 0, function () {
            var callbacks, e_2;
            return __generator$c(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        callbacks = this._pendingFactoryUpdates;
                        _a.label = 1;
                    case 1:
                        if (!(callbacks.length > 0)) return [3 /*break*/, 7];
                        if (!this.updatePending) return [3 /*break*/, 3];
                        return [4 /*yield*/, sleep(1)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1]; // Make sure to check queue has an item before continuing.
                    case 3:
                        _a.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, callbacks[0]()];
                    case 4:
                        _a.sent();
                        this.callbackCache.invalidateCache();
                        return [3 /*break*/, 6];
                    case 5:
                        e_2 = _a.sent();
                        Logger.error('update error', e_2);
                        return [3 /*break*/, 6];
                    case 6:
                        callbacks.shift();
                        return [3 /*break*/, 1];
                    case 7:
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(Chart.prototype, 'performUpdateType', {
        get: function () {
            return this._performUpdateType;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Chart.prototype, 'updatePending', {
        get: function () {
            return this._performUpdateType !== ChartUpdateType.NONE || this.lastInteractionEvent != null;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Chart.prototype, 'lastPerformUpdateError', {
        get: function () {
            return this._lastPerformUpdateError;
        },
        enumerable: false,
        configurable: true,
    });
    Chart.prototype.awaitUpdateCompletion = function () {
        return __awaiter$c(this, void 0, void 0, function () {
            return __generator$c(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.performUpdateTrigger.await()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Chart.prototype.update = function (type, opts) {
        var e_3, _a;
        if (type === void 0) {
            type = ChartUpdateType.FULL;
        }
        var _b = opts !== null && opts !== void 0 ? opts : {},
            _c = _b.forceNodeDataRefresh,
            forceNodeDataRefresh = _c === void 0 ? false : _c,
            _d = _b.seriesToUpdate,
            seriesToUpdate = _d === void 0 ? this.series : _d;
        if (forceNodeDataRefresh) {
            this.series.forEach(function (series) {
                return series.markNodeDataDirty();
            });
        }
        try {
            for (
                var seriesToUpdate_1 = __values$n(seriesToUpdate), seriesToUpdate_1_1 = seriesToUpdate_1.next();
                !seriesToUpdate_1_1.done;
                seriesToUpdate_1_1 = seriesToUpdate_1.next()
            ) {
                var series = seriesToUpdate_1_1.value;
                this.seriesToUpdate.add(series);
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (seriesToUpdate_1_1 && !seriesToUpdate_1_1.done && (_a = seriesToUpdate_1.return))
                    _a.call(seriesToUpdate_1);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        if (type < this._performUpdateType) {
            this._performUpdateType = type;
            this.performUpdateTrigger.schedule();
        }
    };
    Chart.prototype.performUpdate = function (count) {
        var _a;
        return __awaiter$c(this, void 0, void 0, function () {
            var _b, performUpdateType, extraDebugStats, splits, _c, seriesRect_1, seriesUpdates, tooltipMeta, end;
            return __generator$c(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_b = this),
                            (performUpdateType = _b._performUpdateType),
                            (extraDebugStats = _b.extraDebugStats);
                        this.log('Chart.performUpdate() - start', ChartUpdateType[performUpdateType]);
                        splits = [performance.now()];
                        _c = performUpdateType;
                        switch (_c) {
                            case ChartUpdateType.FULL:
                                return [3 /*break*/, 1];
                            case ChartUpdateType.PROCESS_DATA:
                                return [3 /*break*/, 1];
                            case ChartUpdateType.PERFORM_LAYOUT:
                                return [3 /*break*/, 3];
                            case ChartUpdateType.SERIES_UPDATE:
                                return [3 /*break*/, 5];
                            case ChartUpdateType.TOOLTIP_RECALCULATION:
                                return [3 /*break*/, 7];
                            case ChartUpdateType.SCENE_RENDER:
                                return [3 /*break*/, 8];
                            case ChartUpdateType.NONE:
                                return [3 /*break*/, 10];
                        }
                        return [3 /*break*/, 11];
                    case 1:
                        return [4 /*yield*/, this.processData()];
                    case 2:
                        _d.sent();
                        this.disablePointer(true);
                        splits.push(performance.now());
                        _d.label = 3;
                    case 3:
                        if (!this.checkFirstAutoSize()) return [3 /*break*/, 11];
                        return [4 /*yield*/, this.performLayout()];
                    case 4:
                        _d.sent();
                        this.handleOverlays();
                        this.log('Chart.performUpdate() - seriesRect', this.seriesRect);
                        splits.push(performance.now());
                        _d.label = 5;
                    case 5:
                        seriesRect_1 = this.seriesRect;
                        seriesUpdates = __spreadArray$u([], __read$Q(this.seriesToUpdate)).map(function (series) {
                            return series.update({ seriesRect: seriesRect_1 });
                        });
                        this.seriesToUpdate.clear();
                        return [4 /*yield*/, Promise.all(seriesUpdates)];
                    case 6:
                        _d.sent();
                        splits.push(performance.now());
                        _d.label = 7;
                    case 7:
                        tooltipMeta = this.tooltipManager.getTooltipMeta(this.id);
                        if (
                            performUpdateType < ChartUpdateType.SERIES_UPDATE &&
                            ((_a = tooltipMeta === null || tooltipMeta === void 0 ? void 0 : tooltipMeta.event) ===
                                null || _a === void 0
                                ? void 0
                                : _a.type) === 'hover'
                        ) {
                            this.handlePointer(tooltipMeta.event);
                        }
                        _d.label = 8;
                    case 8:
                        return [
                            4 /*yield*/,
                            this.scene.render({ debugSplitTimes: splits, extraDebugStats: extraDebugStats }),
                        ];
                    case 9:
                        _d.sent();
                        this.extraDebugStats = {};
                        _d.label = 10;
                    case 10:
                        // Do nothing.
                        this._performUpdateType = ChartUpdateType.NONE;
                        _d.label = 11;
                    case 11:
                        end = performance.now();
                        this.log('Chart.performUpdate() - end', {
                            chart: this,
                            durationMs: Math.round((end - splits[0]) * 100) / 100,
                            count: count,
                            performUpdateType: ChartUpdateType[performUpdateType],
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Chart.prototype.checkFirstAutoSize = function () {
        if (this.autoSize && !this._lastAutoSize) {
            var count = this._performUpdateNoRenderCount++;
            var backOffMs = (count ^ 2) * 10;
            if (count < 5) {
                // Reschedule if canvas size hasn't been set yet to avoid a race.
                this._performUpdateType = ChartUpdateType.PERFORM_LAYOUT;
                this.performUpdateTrigger.schedule(backOffMs);
                this.log('Chart.checkFirstAutoSize() - backing off until first size update', backOffMs);
                return false;
            }
            // After several failed passes, continue and accept there maybe a redundant
            // render. Sometimes this case happens when we already have the correct
            // width/height, and we end up never rendering the chart in that scenario.
            this.log('Chart.checkFirstAutoSize() - timeout for first size update.');
        }
        this._performUpdateNoRenderCount = 0;
        return true;
    };
    Object.defineProperty(Chart.prototype, 'axes', {
        get: function () {
            return this._axes;
        },
        set: function (values) {
            var _this = this;
            var removedAxes = new Set();
            this._axes.forEach(function (axis) {
                axis.detachAxis(_this.axisGroup);
                removedAxes.add(axis);
            });
            // make linked axes go after the regular ones (simulates stable sort by `linkedTo` property)
            this._axes = values
                .filter(function (a) {
                    return !a.linkedTo;
                })
                .concat(
                    values.filter(function (a) {
                        return a.linkedTo;
                    }),
                );
            this._axes.forEach(function (axis) {
                axis.attachAxis(_this.axisGroup);
                removedAxes.delete(axis);
            });
            this.zoomManager.updateAxes(this._axes);
            removedAxes.forEach(function (axis) {
                return axis.destroy();
            });
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Chart.prototype, 'series', {
        get: function () {
            return this._series;
        },
        set: function (values) {
            var _this = this;
            this.removeAllSeries();
            values.forEach(function (series) {
                return _this.addSeries(series);
            });
        },
        enumerable: false,
        configurable: true,
    });
    Chart.prototype.addSeries = function (series) {
        var allSeries = this.series;
        var canAdd = allSeries.indexOf(series) < 0;
        if (canAdd) {
            allSeries.push(series);
            if (series.rootGroup.parent == null) {
                this.seriesLayerManager.requestGroup(series);
            }
            this.initSeries(series);
            return true;
        }
        return false;
    };
    Chart.prototype.initSeries = function (series) {
        series.chart = this;
        if (!series.data) {
            series.data = this.data;
        }
        this.addSeriesListeners(series);
        series.addChartEventListeners();
    };
    Chart.prototype.removeAllSeries = function () {
        var _this = this;
        this.series.forEach(function (series) {
            series.removeEventListener('nodeClick', _this.onSeriesNodeClick);
            series.removeEventListener('nodeDoubleClick', _this.onSeriesNodeDoubleClick);
            series.destroy();
            series.chart = undefined;
        });
        this._series = []; // using `_series` instead of `series` to prevent infinite recursion
    };
    Chart.prototype.addSeriesListeners = function (series) {
        if (this.hasEventListener('seriesNodeClick')) {
            series.addEventListener('nodeClick', this.onSeriesNodeClick);
        }
        if (this.hasEventListener('seriesNodeDoubleClick')) {
            series.addEventListener('nodeDoubleClick', this.onSeriesNodeDoubleClick);
        }
    };
    Chart.prototype.updateAllSeriesListeners = function () {
        var _this = this;
        this.series.forEach(function (series) {
            series.removeEventListener('nodeClick', _this.onSeriesNodeClick);
            series.removeEventListener('nodeDoubleClick', _this.onSeriesNodeDoubleClick);
            _this.addSeriesListeners(series);
        });
    };
    Chart.prototype.assignSeriesToAxes = function () {
        var _this = this;
        this.axes.forEach(function (axis) {
            axis.boundSeries = _this.series.filter(function (s) {
                var seriesAxis = s.axes[axis.direction];
                return seriesAxis === axis;
            });
        });
    };
    Chart.prototype.assignAxesToSeries = function () {
        var _this = this;
        // This method has to run before `assignSeriesToAxes`.
        var directionToAxesMap = {};
        this.axes.forEach(function (axis) {
            var _a;
            var direction = axis.direction;
            var directionAxes =
                (_a = directionToAxesMap[direction]) !== null && _a !== void 0
                    ? _a
                    : (directionToAxesMap[direction] = []);
            directionAxes.push(axis);
        });
        this.series.forEach(function (series) {
            series.directions.forEach(function (direction) {
                var directionAxes = directionToAxesMap[direction];
                if (!directionAxes) {
                    Logger.warn(
                        'no available axis for direction [' + direction + ']; check series and axes configuration.',
                    );
                    return;
                }
                var seriesKeys = series.getKeys(direction);
                var newAxis = _this.findMatchingAxis(directionAxes, series.getKeys(direction));
                if (!newAxis) {
                    Logger.warn(
                        'no matching axis for direction [' +
                            direction +
                            '] and keys [' +
                            seriesKeys +
                            ']; check series and axes configuration.',
                    );
                    return;
                }
                series.axes[direction] = newAxis;
            });
        });
    };
    Chart.prototype.findMatchingAxis = function (directionAxes, directionKeys) {
        var e_4, _a, e_5, _b;
        try {
            for (
                var directionAxes_1 = __values$n(directionAxes), directionAxes_1_1 = directionAxes_1.next();
                !directionAxes_1_1.done;
                directionAxes_1_1 = directionAxes_1.next()
            ) {
                var axis = directionAxes_1_1.value;
                var axisKeys = axis.keys;
                if (!axisKeys.length) {
                    return axis;
                }
                if (!directionKeys) {
                    continue;
                }
                try {
                    for (
                        var directionKeys_1 = ((e_5 = void 0), __values$n(directionKeys)),
                            directionKeys_1_1 = directionKeys_1.next();
                        !directionKeys_1_1.done;
                        directionKeys_1_1 = directionKeys_1.next()
                    ) {
                        var directionKey = directionKeys_1_1.value;
                        if (axisKeys.indexOf(directionKey) >= 0) {
                            return axis;
                        }
                    }
                } catch (e_5_1) {
                    e_5 = { error: e_5_1 };
                } finally {
                    try {
                        if (directionKeys_1_1 && !directionKeys_1_1.done && (_b = directionKeys_1.return))
                            _b.call(directionKeys_1);
                    } finally {
                        if (e_5) throw e_5.error;
                    }
                }
            }
        } catch (e_4_1) {
            e_4 = { error: e_4_1 };
        } finally {
            try {
                if (directionAxes_1_1 && !directionAxes_1_1.done && (_a = directionAxes_1.return))
                    _a.call(directionAxes_1);
            } finally {
                if (e_4) throw e_4.error;
            }
        }
    };
    Chart.prototype.resize = function (width, height) {
        var _a, _b, _c, _d;
        width !== null && width !== void 0
            ? width
            : (width =
                  (_a = this.width) !== null && _a !== void 0
                      ? _a
                      : this.autoSize
                      ? (_b = this._lastAutoSize) === null || _b === void 0
                          ? void 0
                          : _b[0]
                      : this.scene.canvas.width);
        height !== null && height !== void 0
            ? height
            : (height =
                  (_c = this.height) !== null && _c !== void 0
                      ? _c
                      : this.autoSize
                      ? (_d = this._lastAutoSize) === null || _d === void 0
                          ? void 0
                          : _d[1]
                      : this.scene.canvas.height);
        this.log('Chart.resize()', { width: width, height: height });
        if (!width || !height || !Number.isFinite(width) || !Number.isFinite(height)) return;
        if (this.scene.resize(width, height)) {
            this.disablePointer();
            this.update(ChartUpdateType.PERFORM_LAYOUT, { forceNodeDataRefresh: true });
        }
    };
    Chart.prototype.processData = function () {
        return __awaiter$c(this, void 0, void 0, function () {
            var dataController, seriesPromises;
            return __generator$c(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.axes.length > 0) {
                            this.assignAxesToSeries();
                            this.assignSeriesToAxes();
                        }
                        dataController = new DataController();
                        seriesPromises = this.series.map(function (s) {
                            return s.processData(dataController);
                        });
                        return [4 /*yield*/, dataController.execute()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all(seriesPromises)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.updateLegend()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Chart.prototype.placeLabels = function () {
        var e_6, _a;
        var visibleSeries = [];
        var data = [];
        try {
            for (var _b = __values$n(this.series), _c = _b.next(); !_c.done; _c = _b.next()) {
                var series = _c.value;
                if (!series.visible) {
                    continue;
                }
                var labelData = series.getLabelData();
                if (!(labelData && isPointLabelDatum(labelData[0]))) {
                    continue;
                }
                data.push(labelData);
                visibleSeries.push(series);
            }
        } catch (e_6_1) {
            e_6 = { error: e_6_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_6) throw e_6.error;
            }
        }
        var seriesRect = this.seriesRect;
        var labels =
            seriesRect && data.length > 0
                ? placeLabels(data, { x: 0, y: 0, width: seriesRect.width, height: seriesRect.height })
                : [];
        return new Map(
            labels.map(function (l, i) {
                return [visibleSeries[i], l];
            }),
        );
    };
    Chart.prototype.attachLegend = function (legendType) {
        var _a;
        if (this.legendType === legendType && this.legend) {
            return this.legend;
        }
        (_a = this.legend) === null || _a === void 0 ? void 0 : _a.destroy();
        this.legend = undefined;
        var ctx = this.getModuleContext();
        var legend = getLegend(legendType, ctx);
        legend.attachLegend(this.scene.root);
        this.legend = legend;
        this.legendType = legendType;
        return legend;
    };
    Chart.prototype.setLegendInit = function (initLegend) {
        this.applyLegendOptions = initLegend;
    };
    Chart.prototype.updateLegend = function () {
        var _a;
        return __awaiter$c(this, void 0, void 0, function () {
            var legendData, legendType, legend;
            return __generator$c(this, function (_b) {
                legendData = [];
                this.series
                    .filter(function (s) {
                        return s.showInLegend;
                    })
                    .forEach(function (series) {
                        var data = series.getLegendData();
                        legendData.push.apply(legendData, __spreadArray$u([], __read$Q(data)));
                    });
                legendType = legendData.length > 0 ? legendData[0].legendType : 'category';
                legend = this.attachLegend(legendType);
                (_a = this.applyLegendOptions) === null || _a === void 0 ? void 0 : _a.call(this, legend);
                if (legendType === 'category') {
                    this.validateLegendData(legendData);
                }
                legend.data = legendData;
                return [2 /*return*/];
            });
        });
    };
    Chart.prototype.validateLegendData = function (legendData) {
        var _this = this;
        // Validate each series that shares a legend item label uses the same fill colour
        var labelMarkerFills = {};
        legendData.forEach(function (d) {
            var _a;
            var _b, _c, _d;
            var _e, _f;
            var seriesType =
                (_b = _this.series.find(function (s) {
                    return s.id === d.seriesId;
                })) === null || _b === void 0
                    ? void 0
                    : _b.type;
            if (!seriesType) return;
            var dc = d;
            (_c = labelMarkerFills[seriesType]) !== null && _c !== void 0
                ? _c
                : (labelMarkerFills[seriesType] = ((_a = {}), (_a[dc.label.text] = new Set()), _a));
            (_d = (_e = labelMarkerFills[seriesType])[(_f = dc.label.text)]) !== null && _d !== void 0
                ? _d
                : (_e[_f] = new Set());
            if (dc.marker.fill != null) {
                labelMarkerFills[seriesType][dc.label.text].add(dc.marker.fill);
            }
        });
        Object.keys(labelMarkerFills).forEach(function (seriesType) {
            Object.keys(labelMarkerFills[seriesType]).forEach(function (name) {
                var fills = labelMarkerFills[seriesType][name];
                if (fills.size > 1) {
                    Logger.warnOnce(
                        "legend item '" + name + "' has multiple fill colors, this may cause unexpected behaviour.",
                    );
                }
            });
        });
    };
    Chart.prototype.performLayout = function () {
        return __awaiter$c(this, void 0, void 0, function () {
            var _a, width, height, shrinkRect;
            return __generator$c(this, function (_b) {
                if (this.scene.root != null) {
                    this.scene.root.visible = true;
                }
                (_a = this.scene), (width = _a.width), (height = _a.height);
                shrinkRect = new BBox(0, 0, width, height);
                shrinkRect = this.layoutService.dispatchPerformLayout('start-layout', {
                    shrinkRect: shrinkRect,
                }).shrinkRect;
                shrinkRect = this.layoutService.dispatchPerformLayout('before-series', {
                    shrinkRect: shrinkRect,
                }).shrinkRect;
                return [2 /*return*/, shrinkRect];
            });
        });
    };
    Chart.prototype.positionPadding = function (shrinkRect) {
        var padding = this.padding;
        shrinkRect.shrink(padding.left, 'left');
        shrinkRect.shrink(padding.top, 'top');
        shrinkRect.shrink(padding.right, 'right');
        shrinkRect.shrink(padding.bottom, 'bottom');
        return { shrinkRect: shrinkRect };
    };
    Chart.prototype.positionCaptions = function (shrinkRect) {
        var _a;
        var _b = this,
            title = _b.title,
            subtitle = _b.subtitle,
            footnote = _b.footnote;
        var newShrinkRect = shrinkRect.clone();
        var updateCaption = function (caption) {
            var _a;
            var defaultCaptionHeight = shrinkRect.height / 10;
            var captionLineHeight =
                (_a = caption.lineHeight) !== null && _a !== void 0
                    ? _a
                    : caption.fontSize * Text.defaultLineHeightRatio;
            var maxWidth = shrinkRect.width;
            var maxHeight = Math.max(captionLineHeight, defaultCaptionHeight);
            caption.computeTextWrap(maxWidth, maxHeight);
        };
        var positionTopAndShrinkBBox = function (caption) {
            var _a;
            var baseY = newShrinkRect.y;
            caption.node.x = newShrinkRect.x + newShrinkRect.width / 2;
            caption.node.y = baseY;
            caption.node.textBaseline = 'top';
            updateCaption(caption);
            var bbox = caption.node.computeBBox();
            // As the bbox (x,y) ends up at a different location than specified above, we need to
            // take it into consideration when calculating how much space needs to be reserved to
            // accommodate the caption.
            var bboxHeight = Math.ceil(
                bbox.y - baseY + bbox.height + ((_a = caption.spacing) !== null && _a !== void 0 ? _a : 0),
            );
            newShrinkRect.shrink(bboxHeight, 'top');
        };
        var positionBottomAndShrinkBBox = function (caption) {
            var _a;
            var baseY = newShrinkRect.y + newShrinkRect.height;
            caption.node.x = newShrinkRect.x + newShrinkRect.width / 2;
            caption.node.y = baseY;
            caption.node.textBaseline = 'bottom';
            updateCaption(caption);
            var bbox = caption.node.computeBBox();
            var bboxHeight = Math.ceil(baseY - bbox.y + ((_a = caption.spacing) !== null && _a !== void 0 ? _a : 0));
            newShrinkRect.shrink(bboxHeight, 'bottom');
        };
        if (title) {
            title.node.visible = title.enabled;
            if (title.node.visible) {
                positionTopAndShrinkBBox(title);
            }
        }
        if (subtitle) {
            subtitle.node.visible =
                (_a = (title === null || title === void 0 ? void 0 : title.enabled) && subtitle.enabled) !== null &&
                _a !== void 0
                    ? _a
                    : false;
            if (subtitle.node.visible) {
                positionTopAndShrinkBBox(subtitle);
            }
        }
        if (footnote) {
            footnote.node.visible = footnote.enabled;
            if (footnote.node.visible) {
                positionBottomAndShrinkBBox(footnote);
            }
        }
        return { shrinkRect: newShrinkRect };
    };
    Chart.prototype.getSeriesRect = function () {
        return this.seriesRect;
    };
    // x/y are local canvas coordinates in CSS pixels, not actual pixels
    Chart.prototype.pickSeriesNode = function (point, exactMatchOnly, maxDistance) {
        var e_7, _a;
        var _b, _c;
        var start = performance.now();
        // Disable 'nearest match' options if looking for exact matches only
        var pickModes = exactMatchOnly ? [SeriesNodePickMode.EXACT_SHAPE_MATCH] : undefined;
        // Iterate through series in reverse, as later declared series appears on top of earlier
        // declared series.
        var reverseSeries = __spreadArray$u([], __read$Q(this.series)).reverse();
        var result = undefined;
        try {
            for (
                var reverseSeries_1 = __values$n(reverseSeries), reverseSeries_1_1 = reverseSeries_1.next();
                !reverseSeries_1_1.done;
                reverseSeries_1_1 = reverseSeries_1.next()
            ) {
                var series = reverseSeries_1_1.value;
                if (!series.visible || !series.rootGroup.visible) {
                    continue;
                }
                var _d = (_b = series.pickNode(point, pickModes)) !== null && _b !== void 0 ? _b : {},
                    match = _d.match,
                    distance = _d.distance;
                if (!match || distance == null) {
                    continue;
                }
                if (
                    (!result || result.distance > distance) &&
                    distance <= (maxDistance !== null && maxDistance !== void 0 ? maxDistance : Infinity)
                ) {
                    result = { series: series, distance: distance, datum: match };
                }
                if (distance === 0) {
                    break;
                }
            }
        } catch (e_7_1) {
            e_7 = { error: e_7_1 };
        } finally {
            try {
                if (reverseSeries_1_1 && !reverseSeries_1_1.done && (_a = reverseSeries_1.return))
                    _a.call(reverseSeries_1);
            } finally {
                if (e_7) throw e_7.error;
            }
        }
        this.extraDebugStats['pickSeriesNode'] = Math.round(
            ((_c = this.extraDebugStats['pickSeriesNode']) !== null && _c !== void 0 ? _c : 0) +
                (performance.now() - start),
        );
        return result;
    };
    Chart.prototype.onMouseMove = function (event) {
        this.lastInteractionEvent = event;
        this.pointerScheduler.schedule();
        this.extraDebugStats['mouseX'] = event.offsetX;
        this.extraDebugStats['mouseY'] = event.offsetY;
        this.update(ChartUpdateType.SCENE_RENDER);
    };
    Chart.prototype.onLeave = function (event) {
        if (this.tooltip.pointerLeftOntoTooltip(event)) {
            return;
        }
        this.disablePointer();
    };
    Chart.prototype.handlePointer = function (event) {
        var _this = this;
        var _a = this,
            lastPick = _a.lastPick,
            hoverRect = _a.hoverRect;
        var offsetX = event.offsetX,
            offsetY = event.offsetY;
        var disablePointer = function (highlightOnly) {
            if (highlightOnly === void 0) {
                highlightOnly = false;
            }
            if (lastPick) {
                // Cursor moved from a non-marker node to empty space.
                _this.disablePointer(highlightOnly);
            }
        };
        if (!(hoverRect === null || hoverRect === void 0 ? void 0 : hoverRect.containsPoint(offsetX, offsetY))) {
            disablePointer();
            return;
        }
        // Handle node highlighting and tooltip toggling when pointer within `tooltip.range`
        this.handlePointerTooltip(event, disablePointer);
        // Handle node highlighting and mouse cursor when pointer withing `series[].nodeClickRange`
        this.handlePointerNode(event);
    };
    Chart.prototype.handlePointerTooltip = function (event, disablePointer) {
        var _a, _b;
        var _c = this,
            lastPick = _c.lastPick,
            tooltip = _c.tooltip;
        var range = tooltip.range;
        var pageX = event.pageX,
            pageY = event.pageY,
            offsetX = event.offsetX,
            offsetY = event.offsetY;
        var pixelRange;
        if (typeof range === 'number' && Number.isFinite(range)) {
            pixelRange = range;
        }
        var pick = this.pickSeriesNode({ x: offsetX, y: offsetY }, range === 'exact', pixelRange);
        if (!pick) {
            this.tooltipManager.updateTooltip(this.id);
            if (this.highlight.range === 'tooltip') disablePointer(true);
            return;
        }
        var isNewDatum = this.highlight.range === 'node' || !lastPick || lastPick.datum !== pick.datum;
        var html;
        if (isNewDatum) {
            html = pick.series.getTooltipHtml(pick.datum);
            if (this.highlight.range === 'tooltip') {
                this.highlightManager.updateHighlight(this.id, pick.datum);
            }
        } else if (lastPick) {
            lastPick.event = event.sourceEvent;
        }
        var isPixelRange = pixelRange != null;
        var tooltipEnabled = this.tooltip.enabled && pick.series.tooltip.enabled;
        var exactlyMatched = range === 'exact' && pick.distance === 0;
        var rangeMatched = range === 'nearest' || isPixelRange || exactlyMatched;
        var shouldUpdateTooltip = tooltipEnabled && rangeMatched && (!isNewDatum || html !== undefined);
        var position = {
            xOffset: pick.datum.series.tooltip.position.xOffset,
            yOffset: pick.datum.series.tooltip.position.yOffset,
        };
        var meta = this.mergePointerDatum(
            {
                pageX: pageX,
                pageY: pageY,
                offsetX: offsetX,
                offsetY: offsetY,
                event: event,
                showArrow: pick.series.tooltip.showArrow,
                position: position,
            },
            pick.datum,
        );
        meta.enableInteraction =
            (_b = (_a = pick.series.tooltip.interaction) === null || _a === void 0 ? void 0 : _a.enabled) !== null &&
            _b !== void 0
                ? _b
                : false;
        if (shouldUpdateTooltip) {
            this.tooltipManager.updateTooltip(this.id, meta, html);
        }
    };
    Chart.prototype.handlePointerNode = function (event) {
        var _this = this;
        var found = this.checkSeriesNodeRange(event, function (series, datum) {
            if (series.hasEventListener('nodeClick') || series.hasEventListener('nodeDoubleClick')) {
                _this.cursorManager.updateCursor('chart', 'pointer');
            }
            if (_this.highlight.range === 'node') {
                _this.highlightManager.updateHighlight(_this.id, datum);
            }
        });
        if (!found) {
            this.cursorManager.updateCursor('chart');
            if (this.highlight.range === 'node') {
                this.highlightManager.updateHighlight(this.id);
            }
        }
    };
    Chart.prototype.onClick = function (event) {
        if (this.checkSeriesNodeClick(event)) {
            this.update(ChartUpdateType.SERIES_UPDATE);
            return;
        }
        this.fireEvent({
            type: 'click',
            event: event.sourceEvent,
        });
    };
    Chart.prototype.onDoubleClick = function (event) {
        if (this.checkSeriesNodeDoubleClick(event)) {
            this.update(ChartUpdateType.SERIES_UPDATE);
            return;
        }
        this.fireEvent({
            type: 'doubleClick',
            event: event.sourceEvent,
        });
    };
    Chart.prototype.checkSeriesNodeClick = function (event) {
        return this.checkSeriesNodeRange(event, function (series, datum) {
            return series.fireNodeClickEvent(event.sourceEvent, datum);
        });
    };
    Chart.prototype.checkSeriesNodeDoubleClick = function (event) {
        return this.checkSeriesNodeRange(event, function (series, datum) {
            return series.fireNodeDoubleClickEvent(event.sourceEvent, datum);
        });
    };
    Chart.prototype.checkSeriesNodeRange = function (event, callback) {
        var nearestNode = this.pickSeriesNode({ x: event.offsetX, y: event.offsetY }, false);
        var datum = nearestNode === null || nearestNode === void 0 ? void 0 : nearestNode.datum;
        var nodeClickRange = datum === null || datum === void 0 ? void 0 : datum.series.nodeClickRange;
        // First check if we should trigger the callback based on nearest node
        if (datum && nodeClickRange === 'nearest') {
            callback(datum.series, datum);
            return true;
        }
        // Then check for an exact match or within the given range
        var pixelRange;
        if (typeof nodeClickRange === 'number' && Number.isFinite(nodeClickRange)) {
            pixelRange = nodeClickRange;
        }
        var pick = this.pickSeriesNode({ x: event.offsetX, y: event.offsetY }, nodeClickRange === 'exact', pixelRange);
        if (!pick) return false;
        // Then if we've picked a node within the pixel range, or exactly, trigger the callback
        var isPixelRange = pixelRange != null;
        var exactlyMatched = nodeClickRange === 'exact' && pick.distance === 0;
        if (isPixelRange || exactlyMatched) {
            callback(pick.series, pick.datum);
            return true;
        }
        return false;
    };
    Chart.prototype.mergePointerDatum = function (meta, datum) {
        var type = datum.series.tooltip.position.type;
        if (type === 'node' && datum.nodeMidPoint) {
            var _a = datum.nodeMidPoint,
                x = _a.x,
                y = _a.y;
            var canvas = this.scene.canvas;
            var point = datum.series.contentGroup.inverseTransformPoint(x, y);
            var canvasRect = canvas.element.getBoundingClientRect();
            return __assign$K(__assign$K({}, meta), {
                pageX: Math.round(canvasRect.left + window.scrollX + point.x),
                pageY: Math.round(canvasRect.top + window.scrollY + point.y),
                offsetX: Math.round(point.x),
                offsetY: Math.round(point.y),
            });
        }
        return meta;
    };
    Chart.prototype.changeHighlightDatum = function (event) {
        var _a, _b;
        var seriesToUpdate = new Set();
        var _c = (_a = event.currentHighlight) !== null && _a !== void 0 ? _a : {},
            _d = _c.series,
            newSeries = _d === void 0 ? undefined : _d,
            newDatum = _c.datum;
        var _e = (_b = event.previousHighlight) !== null && _b !== void 0 ? _b : {},
            _f = _e.series,
            lastSeries = _f === void 0 ? undefined : _f,
            lastDatum = _e.datum;
        if (lastSeries) {
            seriesToUpdate.add(lastSeries);
        }
        if (newSeries) {
            seriesToUpdate.add(newSeries);
        }
        // Adjust cursor if a specific datum is highlighted, rather than just a series.
        if ((lastSeries === null || lastSeries === void 0 ? void 0 : lastSeries.cursor) && lastDatum) {
            this.cursorManager.updateCursor(lastSeries.id);
        }
        if ((newSeries === null || newSeries === void 0 ? void 0 : newSeries.cursor) && newDatum) {
            this.cursorManager.updateCursor(newSeries.id, newSeries.cursor);
        }
        this.lastPick = event.currentHighlight ? { datum: event.currentHighlight } : undefined;
        var updateAll = newSeries == null || lastSeries == null;
        if (updateAll) {
            this.update(ChartUpdateType.SERIES_UPDATE);
        } else {
            this.update(ChartUpdateType.SERIES_UPDATE, { seriesToUpdate: seriesToUpdate });
        }
    };
    Chart.prototype.waitForUpdate = function (timeoutMs) {
        if (timeoutMs === void 0) {
            timeoutMs = 5000;
        }
        return __awaiter$c(this, void 0, void 0, function () {
            var start;
            return __generator$c(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        start = performance.now();
                        _a.label = 1;
                    case 1:
                        if (!(this._pendingFactoryUpdates.length > 0 || this.updatePending)) return [3 /*break*/, 3];
                        if (performance.now() - start > timeoutMs) {
                            throw new Error('waitForUpdate() timeout reached.');
                        }
                        return [4 /*yield*/, sleep(5)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 1];
                    case 3:
                        return [4 /*yield*/, this.awaitUpdateCompletion()];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Chart.prototype.handleOverlays = function () {
        this.handleNoDataOverlay();
    };
    Chart.prototype.handleNoDataOverlay = function () {
        var shouldDisplayNoDataOverlay = !this.series.some(function (s) {
            return s.hasData();
        });
        var rect = this.getSeriesRect();
        if (shouldDisplayNoDataOverlay && rect) {
            this.overlays.noData.show(rect);
        } else {
            this.overlays.noData.hide();
        }
    };
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    this.scene.debug.consoleLog = value;
                    if (this.animationManager) {
                        this.animationManager.debug = value;
                    }
                },
            }),
        ],
        Chart.prototype,
        'debug',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    if (this.destroyed) return;
                    value.appendChild(this.element);
                },
                oldValue: function (value) {
                    value.removeChild(this.element);
                },
            }),
        ],
        Chart.prototype,
        'container',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    var _a;
                    (_a = this.series) === null || _a === void 0
                        ? void 0
                        : _a.forEach(function (series) {
                              return (series.data = value);
                          });
                },
            }),
        ],
        Chart.prototype,
        'data',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    this.resize(value);
                },
            }),
        ],
        Chart.prototype,
        'width',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    this.resize(undefined, value);
                },
            }),
        ],
        Chart.prototype,
        'height',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                changeValue: function (value) {
                    this.autoSizeChanged(value);
                },
            }),
            Validate(BOOLEAN),
        ],
        Chart.prototype,
        'autoSize',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.appendChild(value.node);
                },
                oldValue: function (oldValue) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.removeChild(oldValue.node);
                },
            }),
        ],
        Chart.prototype,
        'title',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.appendChild(value.node);
                },
                oldValue: function (oldValue) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.removeChild(oldValue.node);
                },
            }),
        ],
        Chart.prototype,
        'subtitle',
        void 0,
    );
    __decorate$1L(
        [
            ActionOnSet({
                newValue: function (value) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.appendChild(value.node);
                },
                oldValue: function (oldValue) {
                    var _a;
                    (_a = this.scene.root) === null || _a === void 0 ? void 0 : _a.removeChild(oldValue.node);
                },
            }),
        ],
        Chart.prototype,
        'footnote',
        void 0,
    );
    __decorate$1L([Validate(STRING_UNION('standalone', 'integrated'))], Chart.prototype, 'mode', void 0);
    return Chart;
})(Observable);

var __read$P =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
function clamp(x, min, max) {
    return Math.max(min, Math.min(max, x));
}
/**
 * Maps a discrete domain to a continuous numeric range.
 */
var BandScale$5 = /** @class */ (function () {
    function BandScale() {
        this.type = 'band';
        this.cache = null;
        this.cacheProps = ['_domain', 'range', '_paddingInner', '_paddingOuter', 'round', 'interval'];
        /**
         * Maps datum to its index in the {@link domain} array.
         * Used to check for duplicate datums (not allowed).
         */
        this.index = new Map();
        /**
         * The output range values for datum at each index.
         */
        this.ordinalRange = [];
        /**
         * Contains unique datums only. Since `{}` is used in place of `Map`
         * for IE11 compatibility, the datums are converted `toString` before
         * the uniqueness check.
         */
        this._domain = [];
        this.range = [0, 1];
        this._bandwidth = 1;
        this._rawBandwidth = 1;
        /**
         * The ratio of the range that is reserved for space between bands.
         */
        this._paddingInner = 0;
        /**
         * The ratio of the range that is reserved for space before the first
         * and after the last band.
         */
        this._paddingOuter = 0;
        this.round = false;
    }
    BandScale.prototype.didChange = function () {
        var _this = this;
        var cache = this.cache;
        var didChange =
            !cache ||
            this.cacheProps.some(function (p) {
                return _this[p] !== cache[p];
            });
        if (didChange) {
            this.cache = {};
            this.cacheProps.forEach(function (p) {
                return (_this.cache[p] = _this[p]);
            });
            return true;
        }
        return false;
    };
    BandScale.prototype.refresh = function () {
        if (this.didChange()) {
            this.update();
        }
    };
    Object.defineProperty(BandScale.prototype, 'domain', {
        get: function () {
            return this._domain;
        },
        set: function (values) {
            var domain = [];
            this.index = new Map();
            var index = this.index;
            // In case one wants to have duplicate domain values, for example, two 'Italy' categories,
            // one should use objects rather than strings for domain values like so:
            // { toString: () => 'Italy' }
            // { toString: () => 'Italy' }
            values.forEach(function (value) {
                if (index.get(value) === undefined) {
                    index.set(value, domain.push(value) - 1);
                }
            });
            this._domain = domain;
        },
        enumerable: false,
        configurable: true,
    });
    BandScale.prototype.ticks = function () {
        this.refresh();
        var _a = this.interval,
            interval = _a === void 0 ? 1 : _a;
        var step = Math.abs(Math.round(interval));
        return this._domain.filter(function (_, i) {
            return i % step === 0;
        });
    };
    BandScale.prototype.convert = function (d) {
        this.refresh();
        var i = this.index.get(d);
        if (i === undefined) {
            return NaN;
        }
        var r = this.ordinalRange[i];
        if (r === undefined) {
            return NaN;
        }
        return r;
    };
    BandScale.prototype.invert = function (position) {
        this.refresh();
        var index = this.ordinalRange.findIndex(function (p) {
            return p === position;
        });
        return this.domain[index];
    };
    Object.defineProperty(BandScale.prototype, 'bandwidth', {
        get: function () {
            this.refresh();
            return this._bandwidth;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(BandScale.prototype, 'rawBandwidth', {
        get: function () {
            this.refresh();
            return this._rawBandwidth;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(BandScale.prototype, 'padding', {
        get: function () {
            return this._paddingInner;
        },
        set: function (value) {
            value = clamp(value, 0, 1);
            this._paddingInner = value;
            this._paddingOuter = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(BandScale.prototype, 'paddingInner', {
        get: function () {
            return this._paddingInner;
        },
        set: function (value) {
            this._paddingInner = clamp(value, 0, 1);
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(BandScale.prototype, 'paddingOuter', {
        get: function () {
            return this._paddingOuter;
        },
        set: function (value) {
            this._paddingOuter = clamp(value, 0, 1);
        },
        enumerable: false,
        configurable: true,
    });
    BandScale.prototype.update = function () {
        var count = this._domain.length;
        if (count === 0) {
            return;
        }
        var round = this.round;
        var paddingInner = this._paddingInner;
        var paddingOuter = this._paddingOuter;
        var _a = __read$P(this.range, 2),
            r0 = _a[0],
            r1 = _a[1];
        var width = r1 - r0;
        var rawStep = width / Math.max(1, count + 2 * paddingOuter - paddingInner);
        var step = round ? Math.floor(rawStep) : rawStep;
        var fullBandWidth = step * (count - paddingInner);
        var x0 = r0 + (width - fullBandWidth) / 2;
        var start = round ? Math.round(x0) : x0;
        var bw = step * (1 - paddingInner);
        var bandwidth = round ? Math.round(bw) : bw;
        var rawBandwidth = rawStep * (1 - paddingInner);
        var values = [];
        for (var i = 0; i < count; i++) {
            values.push(start + step * i);
        }
        this._bandwidth = bandwidth;
        this._rawBandwidth = rawBandwidth;
        this.ordinalRange = values;
    };
    return BandScale;
})();

var __extends$2q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1K =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Line = /** @class */ (function (_super) {
    __extends$2q(Line, _super);
    function Line() {
        var _this = _super.call(this) || this;
        _this.x1 = 0;
        _this.y1 = 0;
        _this.x2 = 0;
        _this.y2 = 0;
        _this.restoreOwnStyles();
        return _this;
    }
    Line.prototype.computeBBox = function () {
        return new BBox(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
    };
    Line.prototype.isPointInPath = function (_x, _y) {
        return false;
    };
    Line.prototype.render = function (renderCtx) {
        var _a;
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        var x1 = this.x1;
        var y1 = this.y1;
        var x2 = this.x2;
        var y2 = this.y2;
        // Align to the pixel grid if the line is strictly vertical
        // or horizontal (but not both, i.e. a dot).
        if (x1 === x2) {
            var x = Math.round(x1) + (Math.floor(this.strokeWidth) % 2) / 2;
            x1 = x;
            x2 = x;
        } else if (y1 === y2) {
            var y = Math.round(y1) + (Math.floor(this.strokeWidth) % 2) / 2;
            y1 = y;
            y2 = y;
        }
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        this.fillStroke(ctx);
        (_a = this.fillShadow) === null || _a === void 0 ? void 0 : _a.markClean();
        _super.prototype.render.call(this, renderCtx);
    };
    Line.className = 'Line';
    Line.defaultStyles = Object.assign({}, Shape.defaultStyles, {
        fill: undefined,
        strokeWidth: 1,
    });
    __decorate$1K([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Line.prototype, 'x1', void 0);
    __decorate$1K([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Line.prototype, 'y1', void 0);
    __decorate$1K([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Line.prototype, 'x2', void 0);
    __decorate$1K([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Line.prototype, 'y2', void 0);
    return Line;
})(Shape);

var __decorate$1J =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Caption = /** @class */ (function () {
    function Caption() {
        this.node = new Text();
        this.enabled = false;
        this.text = undefined;
        this.fontSize = 10;
        this.fontFamily = 'sans-serif';
        this.spacing = Caption.PADDING;
        this.lineHeight = undefined;
        this.maxWidth = undefined;
        this.maxHeight = undefined;
        this.wrapping = 'always';
        var node = this.node;
        node.textAlign = 'center';
        node.pointerEvents = PointerEvents.None;
    }
    Caption.prototype.computeTextWrap = function (containerWidth, containerHeight) {
        var _a, _b;
        var _c = this,
            text = _c.text,
            wrapping = _c.wrapping;
        var maxWidth = Math.min((_a = this.maxWidth) !== null && _a !== void 0 ? _a : Infinity, containerWidth);
        var maxHeight = (_b = this.maxHeight) !== null && _b !== void 0 ? _b : containerHeight;
        if (!isFinite(maxWidth) && !isFinite(maxHeight)) {
            this.node.text = text;
            return;
        }
        var wrapped = Text.wrap(text !== null && text !== void 0 ? text : '', maxWidth, maxHeight, this, wrapping);
        this.node.text = wrapped;
    };
    Caption.PADDING = 10;
    __decorate$1J([Validate(BOOLEAN)], Caption.prototype, 'enabled', void 0);
    __decorate$1J([Validate(OPT_STRING), ProxyPropertyOnWrite('node')], Caption.prototype, 'text', void 0);
    __decorate$1J([Validate(OPT_FONT_STYLE), ProxyPropertyOnWrite('node')], Caption.prototype, 'fontStyle', void 0);
    __decorate$1J([Validate(OPT_FONT_WEIGHT), ProxyPropertyOnWrite('node')], Caption.prototype, 'fontWeight', void 0);
    __decorate$1J([Validate(NUMBER(0)), ProxyPropertyOnWrite('node')], Caption.prototype, 'fontSize', void 0);
    __decorate$1J([Validate(STRING), ProxyPropertyOnWrite('node')], Caption.prototype, 'fontFamily', void 0);
    __decorate$1J(
        [Validate(OPT_COLOR_STRING), ProxyPropertyOnWrite('node', 'fill')],
        Caption.prototype,
        'color',
        void 0,
    );
    __decorate$1J([Validate(OPT_NUMBER(0))], Caption.prototype, 'spacing', void 0);
    __decorate$1J([Validate(OPT_NUMBER(0))], Caption.prototype, 'lineHeight', void 0);
    __decorate$1J([Validate(OPT_NUMBER(0))], Caption.prototype, 'maxWidth', void 0);
    __decorate$1J([Validate(OPT_NUMBER(0))], Caption.prototype, 'maxHeight', void 0);
    __decorate$1J([Validate(TEXT_WRAP)], Caption.prototype, 'wrapping', void 0);
    return Caption;
})();

function areArrayNumbersEqual(arrA, arrB) {
    return (
        arrA.length === arrB.length &&
        arrA.every(function (item, i) {
            return Number(item) === Number(arrB[i]);
        })
    );
}

var __read$O =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var ContinuousScale = /** @class */ (function () {
    function ContinuousScale(domain, range) {
        this.domain = domain;
        this.range = range;
        this.nice = false;
        this.tickCount = ContinuousScale.defaultTickCount;
        this.minTickCount = 0;
        this.maxTickCount = Infinity;
        this.niceDomain = null;
        this.strictClampByDefault = false;
        this.cache = null;
        this.cacheProps = ['domain', 'range', 'nice', 'tickCount', 'minTickCount', 'maxTickCount'];
    }
    ContinuousScale.prototype.transform = function (x) {
        return x;
    };
    ContinuousScale.prototype.transformInvert = function (x) {
        return x;
    };
    ContinuousScale.prototype.fromDomain = function (d) {
        if (typeof d === 'number') {
            return d;
        } else if (d instanceof Date) {
            return d.getTime();
        }
        return NaN;
    };
    ContinuousScale.prototype.getDomain = function () {
        if (this.nice) {
            this.refresh();
            if (this.niceDomain) {
                return this.niceDomain;
            }
        }
        return this.domain;
    };
    ContinuousScale.prototype.convert = function (x, params) {
        var _this = this;
        var _a;
        if (!this.domain || this.domain.length < 2) {
            return NaN;
        }
        this.refresh();
        var strict =
            (_a = params === null || params === void 0 ? void 0 : params.strict) !== null && _a !== void 0
                ? _a
                : this.strictClampByDefault;
        var domain = this.getDomain().map(function (d) {
            return _this.transform(d);
        });
        var _b = __read$O(domain, 2),
            d0 = _b[0],
            d1 = _b[1];
        var range = this.range;
        var _c = __read$O(range, 2),
            r0 = _c[0],
            r1 = _c[1];
        x = this.transform(x);
        if (x < d0) {
            return strict ? NaN : r0;
        } else if (x > d1) {
            return strict ? NaN : r1;
        }
        if (d0 === d1) {
            return (r0 + r1) / 2;
        } else if (x === d0) {
            return r0;
        } else if (x === d1) {
            return r1;
        }
        return (
            r0 + ((this.fromDomain(x) - this.fromDomain(d0)) / (this.fromDomain(d1) - this.fromDomain(d0))) * (r1 - r0)
        );
    };
    ContinuousScale.prototype.invert = function (x) {
        var _this = this;
        this.refresh();
        var domain = this.getDomain().map(function (d) {
            return _this.transform(d);
        });
        var _a = __read$O(domain, 2),
            d0 = _a[0],
            d1 = _a[1];
        var range = this.range;
        var _b = __read$O(range, 2),
            r0 = _b[0],
            r1 = _b[1];
        var isReversed = r0 > r1;
        var rMin = isReversed ? r1 : r0;
        var rMax = isReversed ? r0 : r1;
        var d;
        if (x < rMin) {
            return isReversed ? d1 : d0;
        } else if (x > rMax) {
            return isReversed ? d0 : d1;
        } else if (r0 === r1) {
            d = this.toDomain((this.fromDomain(d0) + this.fromDomain(d1)) / 2);
        } else {
            d = this.toDomain(
                this.fromDomain(d0) + ((x - r0) / (r1 - r0)) * (this.fromDomain(d1) - this.fromDomain(d0)),
            );
        }
        return this.transformInvert(d);
    };
    ContinuousScale.prototype.didChange = function () {
        var _this = this;
        var cache = this.cache;
        var didChange =
            !cache ||
            this.cacheProps.some(function (p) {
                return _this[p] !== cache[p];
            });
        if (didChange) {
            this.cache = {};
            this.cacheProps.forEach(function (p) {
                return (_this.cache[p] = _this[p]);
            });
            return true;
        }
        return false;
    };
    ContinuousScale.prototype.refresh = function () {
        if (this.didChange()) {
            this.update();
        }
    };
    ContinuousScale.prototype.isDenseInterval = function (_a) {
        var start = _a.start,
            stop = _a.stop,
            interval = _a.interval,
            count = _a.count;
        var range = this.range;
        var domain = stop - start;
        var min = Math.min(range[0], range[1]);
        var max = Math.max(range[0], range[1]);
        var availableRange = max - min;
        var step = typeof interval === 'number' ? interval : 1;
        count !== null && count !== void 0 ? count : (count = domain / step);
        if (count >= availableRange) {
            Logger.warn(
                'the configured tick interval results in more than 1 tick per pixel, ignoring. Supply a larger tick interval or omit this configuration.',
            );
            return true;
        }
        return false;
    };
    ContinuousScale.defaultTickCount = 5;
    ContinuousScale.defaultMaxTickCount = 6;
    return ContinuousScale;
})();

var __extends$2p =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
function ticks(start, stop, count, minCount, maxCount) {
    if (count < 2) {
        return range(start, stop, stop - start);
    }
    var step = tickStep(start, stop, count, minCount, maxCount);
    if (isNaN(step)) {
        return new NumericTicks(0);
    }
    start = Math.ceil(start / step) * step;
    stop = Math.floor(stop / step) * step;
    return range(start, stop, step);
}
var tickMultipliers = [1, 2, 5, 10];
function tickStep(a, b, count, minCount, maxCount) {
    if (minCount === void 0) {
        minCount = 0;
    }
    if (maxCount === void 0) {
        maxCount = Infinity;
    }
    var rawStep = (b - a) / count;
    var power = Math.floor(Math.log10(rawStep));
    var step = Math.pow(10, power);
    var m = tickMultipliers
        .map(function (multiplier) {
            var s = multiplier * step;
            var c = Math.ceil((b - a) / s);
            var isWithinBounds = c >= minCount && c <= maxCount;
            var diffCount = Math.abs(c - count);
            return { multiplier: multiplier, isWithinBounds: isWithinBounds, diffCount: diffCount };
        })
        .sort(function (a, b) {
            if (a.isWithinBounds !== b.isWithinBounds) {
                return a.isWithinBounds ? -1 : 1;
            }
            return a.diffCount - b.diffCount;
        })[0].multiplier;
    if (!m || isNaN(m)) {
        return NaN;
    }
    return m * step;
}
function singleTickDomain(a, b) {
    var power = Math.floor(Math.log10(b - a));
    var step = Math.pow(10, power);
    return tickMultipliers
        .map(function (multiplier) {
            var s = multiplier * step;
            var start = Math.floor(a / s) * s;
            var end = Math.ceil(b / s) * s;
            var error = 1 - (b - a) / (end - start);
            var domain = [start, end];
            return { error: error, domain: domain };
        })
        .sort(function (a, b) {
            return a.error - b.error;
        })[0].domain;
}
var NumericTicks = /** @class */ (function (_super) {
    __extends$2p(NumericTicks, _super);
    function NumericTicks(fractionDigits, elements) {
        var _this = _super.call(this) || this;
        if (elements) {
            for (var i = 0, n = elements.length; i < n; i++) {
                _this[i] = elements[i];
            }
        }
        _this.fractionDigits = fractionDigits;
        return _this;
    }
    return NumericTicks;
})(Array);
function range(start, stop, step) {
    var countDigits = function (expNo) {
        var _a, _b;
        var parts = expNo.split('e');
        return Math.max(
            ((_b = (_a = parts[0].split('.')[1]) === null || _a === void 0 ? void 0 : _a.length) !== null &&
            _b !== void 0
                ? _b
                : 0) - Number(parts[1]),
            0,
        );
    };
    var fractionalDigits = countDigits((step % 1).toExponential());
    var f = Math.pow(10, fractionalDigits);
    var n = Math.ceil((stop - start) / step);
    var values = new NumericTicks(fractionalDigits);
    for (var i = 0; i <= n; i++) {
        var value = start + step * i;
        values.push(Math.round(value * f) / f);
    }
    return values;
}

var CONSTANTS = {
    periods: ['AM', 'PM'],
    days: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    shortDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};
function dayOfYear(date, startOfYear) {
    if (startOfYear === void 0) {
        startOfYear = new Date(date.getFullYear(), 0, 1);
    }
    var startOffset = date.getTimezoneOffset() - startOfYear.getTimezoneOffset();
    var timeDiff = date.getTime() - startOfYear.getTime() + startOffset * 60000;
    var timeOneDay = 3600000 * 24;
    return Math.floor(timeDiff / timeOneDay);
}
function weekOfYear(date, startDay) {
    var startOfYear = new Date(date.getFullYear(), 0, 1);
    var startOfYearDay = startOfYear.getDay();
    var firstWeekStartOffset = (startDay - startOfYearDay + 7) % 7;
    var startOffset = new Date(date.getFullYear(), 0, firstWeekStartOffset + 1);
    if (startOffset <= date) {
        return Math.floor(dayOfYear(date, startOffset) / 7) + 1;
    }
    // Days before week 1 are in week 0.
    return 0;
}
var SUNDAY = 0;
var MONDAY = 1;
var THURSDAY = 4;
function isoWeekOfYear(date, year) {
    if (year === void 0) {
        year = date.getFullYear();
    }
    var firstOfYear = new Date(year, 0, 1);
    var firstOfYearDay = firstOfYear.getDay();
    var firstThursdayOffset = (THURSDAY - firstOfYearDay + 7) % 7;
    var startOffset = new Date(year, 0, firstThursdayOffset - (THURSDAY - MONDAY) + 1);
    if (startOffset <= date) {
        return Math.floor(dayOfYear(date, startOffset) / 7) + 1;
    }
    // Days before week 1 are in week 52/53 of previous year.
    return isoWeekOfYear(date, year - 1);
}
function timezone(date) {
    var offset = date.getTimezoneOffset();
    var unsignedOffset = Math.abs(offset);
    var sign = offset > 0 ? '-' : '+';
    return '' + sign + pad(Math.floor(unsignedOffset / 60), 2, '0') + pad(Math.floor(unsignedOffset % 60), 2, '0');
}
var FORMATTERS = {
    'a': function (d) {
        return CONSTANTS.shortDays[d.getDay()];
    },
    'A': function (d) {
        return CONSTANTS.days[d.getDay()];
    },
    'b': function (d) {
        return CONSTANTS.shortMonths[d.getMonth()];
    },
    'B': function (d) {
        return CONSTANTS.months[d.getMonth()];
    },
    'c': '%x, %X',
    'd': function (d, p) {
        return pad(d.getDate(), 2, p !== null && p !== void 0 ? p : '0');
    },
    'e': '%_d',
    'f': function (d, p) {
        return pad(d.getMilliseconds() * 1000, 6, p !== null && p !== void 0 ? p : '0');
    },
    'H': function (d, p) {
        return pad(d.getHours(), 2, p !== null && p !== void 0 ? p : '0');
    },
    'I': function (d, p) {
        var hours = d.getHours() % 12;
        return hours === 0 ? '12' : pad(hours, 2, p !== null && p !== void 0 ? p : '0');
    },
    'j': function (d, p) {
        return pad(dayOfYear(d) + 1, 3, p !== null && p !== void 0 ? p : '0');
    },
    'm': function (d, p) {
        return pad(d.getMonth() + 1, 2, p !== null && p !== void 0 ? p : '0');
    },
    'M': function (d, p) {
        return pad(d.getMinutes(), 2, p !== null && p !== void 0 ? p : '0');
    },
    'L': function (d, p) {
        return pad(d.getMilliseconds(), 3, p !== null && p !== void 0 ? p : '0');
    },
    'p': function (d) {
        return d.getHours() < 12 ? 'AM' : 'PM';
    },
    'Q': function (d) {
        return String(d.getTime());
    },
    's': function (d) {
        return String(Math.floor(d.getTime() / 1000));
    },
    'S': function (d, p) {
        return pad(d.getSeconds(), 2, p !== null && p !== void 0 ? p : '0');
    },
    'u': function (d) {
        var day = d.getDay();
        if (day < 1) day += 7;
        return String(day % 7);
    },
    'U': function (d, p) {
        return pad(weekOfYear(d, SUNDAY), 2, p !== null && p !== void 0 ? p : '0');
    },
    'V': function (d, p) {
        return pad(isoWeekOfYear(d), 2, p !== null && p !== void 0 ? p : '0');
    },
    'w': function (d, p) {
        return pad(d.getDay(), 2, p !== null && p !== void 0 ? p : '0');
    },
    'W': function (d, p) {
        return pad(weekOfYear(d, MONDAY), 2, p !== null && p !== void 0 ? p : '0');
    },
    'x': '%-m/%-d/%Y',
    'X': '%-I:%M:%S %p',
    'y': function (d, p) {
        return pad(d.getFullYear() % 100, 2, p !== null && p !== void 0 ? p : '0');
    },
    'Y': function (d, p) {
        return pad(d.getFullYear(), 4, p !== null && p !== void 0 ? p : '0');
    },
    'Z': function (d) {
        return timezone(d);
    },
    '%': function () {
        return '%';
    },
};
var PADS = {
    '_': ' ',
    '0': '0',
    '-': '',
};
function pad(value, size, padChar) {
    var output = String(Math.floor(value));
    if (output.length >= size) {
        return output;
    }
    return '' + padChar.repeat(size - output.length) + output;
}
function buildFormatter(formatString) {
    var formatParts = [];
    while (formatString.length > 0) {
        var nextEscapeIdx = formatString.indexOf('%');
        if (nextEscapeIdx !== 0) {
            var literalPart = nextEscapeIdx > 0 ? formatString.substring(0, nextEscapeIdx) : formatString;
            formatParts.push(literalPart);
        }
        if (nextEscapeIdx < 0) break;
        var maybePadSpecifier = formatString[nextEscapeIdx + 1];
        var maybePad = PADS[maybePadSpecifier];
        if (maybePad != null) {
            nextEscapeIdx++;
        }
        var maybeFormatterSpecifier = formatString[nextEscapeIdx + 1];
        var maybeFormatter = FORMATTERS[maybeFormatterSpecifier];
        if (typeof maybeFormatter === 'function') {
            formatParts.push([maybeFormatter, maybePad]);
        } else if (typeof maybeFormatter === 'string') {
            var formatter = buildFormatter(maybeFormatter);
            formatParts.push([formatter, maybePad]);
        } else {
            formatParts.push('' + (maybePad !== null && maybePad !== void 0 ? maybePad : '') + maybeFormatterSpecifier);
        }
        formatString = formatString.substring(nextEscapeIdx + 2);
    }
    return function (dateTime) {
        var dateTimeAsDate = typeof dateTime === 'number' ? new Date(dateTime) : dateTime;
        return formatParts
            .map(function (c) {
                return typeof c === 'string' ? c : c[0](dateTimeAsDate, c[1]);
            })
            .join('');
    };
}

var __extends$2o =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __values$m =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$N =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$t =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var _a$3;
var DefaultTimeFormats;
(function (DefaultTimeFormats) {
    DefaultTimeFormats[(DefaultTimeFormats['MILLISECOND'] = 0)] = 'MILLISECOND';
    DefaultTimeFormats[(DefaultTimeFormats['SECOND'] = 1)] = 'SECOND';
    DefaultTimeFormats[(DefaultTimeFormats['MINUTE'] = 2)] = 'MINUTE';
    DefaultTimeFormats[(DefaultTimeFormats['HOUR'] = 3)] = 'HOUR';
    DefaultTimeFormats[(DefaultTimeFormats['WEEK_DAY'] = 4)] = 'WEEK_DAY';
    DefaultTimeFormats[(DefaultTimeFormats['SHORT_MONTH'] = 5)] = 'SHORT_MONTH';
    DefaultTimeFormats[(DefaultTimeFormats['MONTH'] = 6)] = 'MONTH';
    DefaultTimeFormats[(DefaultTimeFormats['SHORT_YEAR'] = 7)] = 'SHORT_YEAR';
    DefaultTimeFormats[(DefaultTimeFormats['YEAR'] = 8)] = 'YEAR';
})(DefaultTimeFormats || (DefaultTimeFormats = {}));
var formatStrings =
    ((_a$3 = {}),
    (_a$3[DefaultTimeFormats.MILLISECOND] = '.%L'),
    (_a$3[DefaultTimeFormats.SECOND] = ':%S'),
    (_a$3[DefaultTimeFormats.MINUTE] = '%I:%M'),
    (_a$3[DefaultTimeFormats.HOUR] = '%I %p'),
    (_a$3[DefaultTimeFormats.WEEK_DAY] = '%a'),
    (_a$3[DefaultTimeFormats.SHORT_MONTH] = '%b %d'),
    (_a$3[DefaultTimeFormats.MONTH] = '%B'),
    (_a$3[DefaultTimeFormats.SHORT_YEAR] = '%y'),
    (_a$3[DefaultTimeFormats.YEAR] = '%Y'),
    _a$3);
function toNumber(x) {
    return x instanceof Date ? x.getTime() : x;
}
var TimeScale$1 = /** @class */ (function (_super) {
    __extends$2o(TimeScale, _super);
    function TimeScale() {
        var _this = _super.call(this, [new Date(2022, 11, 7), new Date(2022, 11, 8)], [0, 1]) || this;
        _this.type = 'time';
        _this.cacheProps = ['domain', 'range', 'nice', 'tickCount', 'interval', 'minTickCount', 'maxTickCount'];
        _this.year = year;
        _this.month = month;
        _this.week = sunday;
        _this.day = day;
        _this.hour = hour;
        _this.minute = minute;
        _this.second = second;
        _this.millisecond = millisecond;
        /**
         * Array of default tick intervals in the following format:
         *
         *     [
         *         interval (unit of time),
         *         number of units (step),
         *         the length of that number of units in milliseconds
         *     ]
         */
        _this.tickIntervals = [
            [_this.second, 1, durationSecond],
            [_this.second, 5, 5 * durationSecond],
            [_this.second, 15, 15 * durationSecond],
            [_this.second, 30, 30 * durationSecond],
            [_this.minute, 1, durationMinute],
            [_this.minute, 5, 5 * durationMinute],
            [_this.minute, 15, 15 * durationMinute],
            [_this.minute, 30, 30 * durationMinute],
            [_this.hour, 1, durationHour],
            [_this.hour, 3, 3 * durationHour],
            [_this.hour, 6, 6 * durationHour],
            [_this.hour, 12, 12 * durationHour],
            [_this.day, 1, durationDay],
            [_this.day, 2, 2 * durationDay],
            [_this.week, 1, durationWeek],
            [_this.week, 2, 2 * durationWeek],
            [_this.week, 3, 3 * durationWeek],
            [_this.month, 1, durationMonth],
            [_this.month, 2, 2 * durationMonth],
            [_this.month, 3, 3 * durationMonth],
            [_this.month, 4, 4 * durationMonth],
            [_this.month, 6, 6 * durationMonth],
            [_this.year, 1, durationYear],
        ];
        return _this;
    }
    TimeScale.prototype.toDomain = function (d) {
        return new Date(d);
    };
    TimeScale.prototype.calculateDefaultTickFormat = function (ticks) {
        var e_1, _a;
        if (ticks === void 0) {
            ticks = [];
        }
        var defaultTimeFormat = DefaultTimeFormats.YEAR;
        var updateFormat = function (format) {
            if (format < defaultTimeFormat) {
                defaultTimeFormat = format;
            }
        };
        try {
            for (
                var ticks_1 = __values$m(ticks), ticks_1_1 = ticks_1.next();
                !ticks_1_1.done;
                ticks_1_1 = ticks_1.next()
            ) {
                var value = ticks_1_1.value;
                var format = this.getLowestGranularityFormat(value);
                updateFormat(format);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (ticks_1_1 && !ticks_1_1.done && (_a = ticks_1.return)) _a.call(ticks_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        var firstTick = toNumber(ticks[0]);
        var lastTick = toNumber(ticks[ticks.length - 1]);
        var startYear = new Date(firstTick).getFullYear();
        var stopYear = new Date(lastTick).getFullYear();
        var yearChange = stopYear - startYear > 0;
        return this.buildFormatString(defaultTimeFormat, yearChange);
    };
    TimeScale.prototype.buildFormatString = function (defaultTimeFormat, yearChange) {
        var formatStringArray = [formatStrings[defaultTimeFormat]];
        var timeEndIndex = 0;
        var domain = this.getDomain();
        var start = Math.min.apply(Math, __spreadArray$t([], __read$N(domain.map(toNumber))));
        var stop = Math.max.apply(Math, __spreadArray$t([], __read$N(domain.map(toNumber))));
        var extent = stop - start;
        switch (defaultTimeFormat) {
            case DefaultTimeFormats.SECOND:
                if (extent / durationMinute > 1) {
                    formatStringArray.push(formatStrings[DefaultTimeFormats.MINUTE]);
                }
            // fall through deliberately
            case DefaultTimeFormats.MINUTE:
                if (extent / durationHour > 1) {
                    formatStringArray.push(formatStrings[DefaultTimeFormats.HOUR]);
                }
            // fall through deliberately
            case DefaultTimeFormats.HOUR:
                timeEndIndex = formatStringArray.length;
                if (extent / durationDay > 1) {
                    formatStringArray.push(formatStrings[DefaultTimeFormats.WEEK_DAY]);
                }
            // fall through deliberately
            case DefaultTimeFormats.WEEK_DAY:
                if (extent / durationWeek > 1 || yearChange) {
                    // if it's more than a week or there is a year change, don't show week day
                    var weekDayIndex = formatStringArray.indexOf(formatStrings[DefaultTimeFormats.WEEK_DAY]);
                    if (weekDayIndex > -1) {
                        formatStringArray.splice(weekDayIndex, 1, formatStrings[DefaultTimeFormats.SHORT_MONTH]);
                    }
                }
            // fall through deliberately
            case DefaultTimeFormats.SHORT_MONTH:
            case DefaultTimeFormats.MONTH:
                if (extent / durationYear > 1 || yearChange) {
                    formatStringArray.push(formatStrings[DefaultTimeFormats.YEAR]);
                }
        }
        if (timeEndIndex < formatStringArray.length) {
            // Insert a gap between all date components.
            formatStringArray = __spreadArray$t(
                __spreadArray$t([], __read$N(formatStringArray.slice(0, timeEndIndex))),
                [formatStringArray.slice(timeEndIndex).join(' ')],
            );
        }
        if (timeEndIndex > 0) {
            // Reverse order of time components, since they should be displayed in descending
            // granularity.
            formatStringArray = __spreadArray$t(
                __spreadArray$t([], __read$N(formatStringArray.slice(0, timeEndIndex).reverse())),
                __read$N(formatStringArray.slice(timeEndIndex)),
            );
            if (timeEndIndex < formatStringArray.length) {
                // Insert a gap between time and date components.
                formatStringArray.splice(timeEndIndex, 0, ' ');
            }
        }
        return formatStringArray.join('');
    };
    TimeScale.prototype.getLowestGranularityFormat = function (value) {
        if (this.second.floor(value) < value) {
            return DefaultTimeFormats.MILLISECOND;
        } else if (this.minute.floor(value) < value) {
            return DefaultTimeFormats.SECOND;
        } else if (this.hour.floor(value) < value) {
            return DefaultTimeFormats.MINUTE;
        } else if (this.day.floor(value) < value) {
            return DefaultTimeFormats.HOUR;
        } else if (this.month.floor(value) < value) {
            if (this.week.floor(value) < value) {
                return DefaultTimeFormats.WEEK_DAY;
            }
            return DefaultTimeFormats.SHORT_MONTH;
        } else if (this.year.floor(value) < value) {
            return DefaultTimeFormats.MONTH;
        }
        return DefaultTimeFormats.YEAR;
    };
    TimeScale.prototype.defaultTickFormat = function (ticks) {
        var formatString = this.calculateDefaultTickFormat(ticks);
        return function (date) {
            return buildFormatter(formatString)(date);
        };
    };
    /**
     * @param options Tick interval options.
     * @param options.start The start time (timestamp).
     * @param options.stop The end time (timestamp).
     * @param options.count Number of intervals between ticks.
     */
    TimeScale.prototype.getTickInterval = function (_a) {
        var _b;
        var start = _a.start,
            stop = _a.stop,
            count = _a.count,
            minCount = _a.minCount,
            maxCount = _a.maxCount;
        var tickIntervals = this.tickIntervals;
        var countableTimeInterval;
        var step;
        var tickCount = count !== null && count !== void 0 ? count : ContinuousScale.defaultTickCount;
        var target = Math.abs(stop - start) / Math.max(tickCount, 1);
        var i = 0;
        while (i < tickIntervals.length && target > tickIntervals[i][2]) {
            i++;
        }
        if (i === 0) {
            step = Math.max(tickStep(start, stop, tickCount, minCount, maxCount), 1);
            countableTimeInterval = this.millisecond;
        } else if (i === tickIntervals.length) {
            var y0 = start / durationYear;
            var y1 = stop / durationYear;
            step = tickStep(y0, y1, tickCount, minCount, maxCount);
            countableTimeInterval = this.year;
        } else {
            var diff0 = target - tickIntervals[i - 1][2];
            var diff1 = tickIntervals[i][2] - target;
            var index = diff0 < diff1 ? i - 1 : i;
            (_b = __read$N(tickIntervals[index], 2)), (countableTimeInterval = _b[0]), (step = _b[1]);
        }
        return countableTimeInterval.every(step);
    };
    TimeScale.prototype.invert = function (y) {
        return new Date(_super.prototype.invert.call(this, y));
    };
    /**
     * Returns uniformly-spaced dates that represent the scale's domain.
     */
    TimeScale.prototype.ticks = function () {
        if (!this.domain || this.domain.length < 2) {
            return [];
        }
        this.refresh();
        var _a = __read$N(this.getDomain().map(toNumber), 2),
            t0 = _a[0],
            t1 = _a[1];
        if (this.interval !== undefined) {
            return this.getTicksForInterval({ start: t0, stop: t1 });
        }
        if (this.nice) {
            var tickCount = this.tickCount;
            if (tickCount === 2) {
                return this.niceDomain;
            }
            if (tickCount === 1) {
                return this.niceDomain.slice(0, 1);
            }
        }
        return this.getDefaultTicks({ start: t0, stop: t1 });
    };
    TimeScale.prototype.getDefaultTicks = function (_a) {
        var start = _a.start,
            stop = _a.stop;
        var t = this.getTickInterval({
            start: start,
            stop: stop,
            count: this.tickCount,
            minCount: this.minTickCount,
            maxCount: this.maxTickCount,
        });
        return t ? t.range(new Date(start), new Date(stop)) : []; // inclusive stop
    };
    TimeScale.prototype.getTicksForInterval = function (_a) {
        var start = _a.start,
            stop = _a.stop;
        var _b = this,
            interval = _b.interval,
            tickIntervals = _b.tickIntervals;
        if (!interval) {
            return [];
        }
        if (interval instanceof TimeInterval) {
            var ticks_2 = interval.range(new Date(start), new Date(stop));
            if (this.isDenseInterval({ start: start, stop: stop, interval: interval, count: ticks_2.length })) {
                return this.getDefaultTicks({ start: start, stop: stop });
            }
            return ticks_2;
        }
        var absInterval = Math.abs(interval);
        if (this.isDenseInterval({ start: start, stop: stop, interval: absInterval })) {
            return this.getDefaultTicks({ start: start, stop: stop });
        }
        var reversedInterval = __spreadArray$t([], __read$N(tickIntervals));
        reversedInterval.reverse();
        var timeInterval = reversedInterval.find(function (tickInterval) {
            return absInterval % tickInterval[2] === 0;
        });
        if (timeInterval) {
            var i = timeInterval[0].every(absInterval / (timeInterval[2] / timeInterval[1]));
            return i.range(new Date(start), new Date(stop));
        }
        var date = new Date(start);
        var stopDate = new Date(stop);
        var ticks = [];
        while (date <= stopDate) {
            ticks.push(date);
            date = new Date(date);
            date.setMilliseconds(date.getMilliseconds() + absInterval);
        }
        return ticks;
    };
    /**
     * Returns a time format function suitable for displaying tick values.
     * @param specifier If the specifier string is provided, this method is equivalent to
     * the {@link TimeLocaleObject.format} method.
     * If no specifier is provided, this method returns the default time format function.
     */
    TimeScale.prototype.tickFormat = function (_a) {
        var ticks = _a.ticks,
            specifier = _a.specifier;
        return specifier == undefined ? this.defaultTickFormat(ticks) : buildFormatter(specifier);
    };
    TimeScale.prototype.update = function () {
        if (!this.domain || this.domain.length < 2) {
            return;
        }
        if (this.nice) {
            this.updateNiceDomain();
        }
    };
    /**
     * Extends the domain so that it starts and ends on nice round values.
     * This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value.
     */
    TimeScale.prototype.updateNiceDomain = function () {
        var maxAttempts = 4;
        var _a = __read$N(this.domain, 2),
            d0 = _a[0],
            d1 = _a[1];
        for (var i = 0; i < maxAttempts; i++) {
            this.updateNiceDomainIteration(d0, d1);
            var _b = __read$N(this.niceDomain, 2),
                n0 = _b[0],
                n1 = _b[1];
            if (toNumber(d0) === toNumber(n0) && toNumber(d1) === toNumber(n1)) {
                break;
            }
            d0 = n0;
            d1 = n1;
        }
    };
    TimeScale.prototype.updateNiceDomainIteration = function (d0, d1) {
        var start = toNumber(d0);
        var stop = toNumber(d1);
        var interval = this.interval;
        var i;
        if (interval instanceof TimeInterval) {
            i = interval;
        } else {
            var tickCount = typeof interval === 'number' ? (stop - start) / Math.max(interval, 1) : this.tickCount;
            i = this.getTickInterval({
                start: start,
                stop: stop,
                count: tickCount,
                minCount: this.minTickCount,
                maxCount: this.maxTickCount,
            });
        }
        if (i) {
            var intervalRange = i.range(d0, d1, true);
            var n0 = intervalRange[0];
            var n1 = intervalRange[intervalRange.length - 1];
            this.niceDomain = [n0, n1];
        }
    };
    return TimeScale;
})(ContinuousScale);

var __read$M =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$s =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var _a$2;
var group = function (content) {
    return '(' + content + ')';
};
var optionalGroup = function (content) {
    return group(content) + '?';
};
var nonCapturingGroup = function (content) {
    return optionalGroup('?:' + content);
};
var formatRegEx = (function () {
    var fill = '.';
    var align = '[<>=^]';
    var sign = '[+\\-( ]';
    var symbol = '[$€£¥₣₹#]';
    var zero = '0';
    var width = '\\d+';
    var comma = ',';
    var precision = '\\d+';
    var tilde = '~';
    var type = '[%a-z]';
    return new RegExp(
        [
            '^',
            nonCapturingGroup('' + optionalGroup(fill) + group(align)),
            optionalGroup(sign),
            optionalGroup(symbol),
            optionalGroup(zero),
            optionalGroup(width),
            optionalGroup(comma),
            nonCapturingGroup('\\.' + group(precision)),
            optionalGroup(tilde),
            optionalGroup(type),
            '$',
        ].join(''),
        'i',
    );
})();
var surroundedRegEx = (function () {
    var prefix = '.*?';
    var content = '.+?';
    var suffix = '.*?';
    return new RegExp(['^', group(prefix), '#\\{' + group(content) + '\\}', group(suffix), '$'].join(''));
})();
function parseFormatter(formatter) {
    var _a;
    var prefix;
    var suffix;
    var surrounded = surroundedRegEx.exec(formatter);
    if (surrounded) {
        (_a = __read$M(surrounded, 4)), (prefix = _a[1]), (formatter = _a[2]), (suffix = _a[3]);
    }
    var match = formatRegEx.exec(formatter);
    if (!match) {
        throw new Error('The number formatter is invalid: ' + formatter);
    }
    var _b = __read$M(match, 11),
        fill = _b[1],
        align = _b[2],
        sign = _b[3],
        symbol = _b[4],
        zero = _b[5],
        width = _b[6],
        comma = _b[7],
        precision = _b[8],
        trim = _b[9],
        type = _b[10];
    return {
        fill: fill,
        align: align,
        sign: sign,
        symbol: symbol,
        zero: zero,
        width: parseInt(width),
        comma: comma,
        precision: parseInt(precision),
        trim: Boolean(trim),
        type: type,
        prefix: prefix,
        suffix: suffix,
    };
}
function format(formatter) {
    var options = typeof formatter === 'string' ? parseFormatter(formatter) : formatter;
    var fill = options.fill,
        align = options.align,
        _a = options.sign,
        sign = _a === void 0 ? '-' : _a,
        symbol = options.symbol,
        zero = options.zero,
        width = options.width,
        comma = options.comma,
        type = options.type,
        _b = options.prefix,
        prefix = _b === void 0 ? '' : _b,
        _c = options.suffix,
        suffix = _c === void 0 ? '' : _c,
        precision = options.precision;
    var trim = options.trim;
    var precisionIsNaN = precision === undefined || isNaN(precision);
    var formatBody;
    if (!type) {
        formatBody = decimalTypes['g'];
        trim = true;
    } else if (type in decimalTypes && type in integerTypes) {
        formatBody = precisionIsNaN ? integerTypes[type] : decimalTypes[type];
    } else if (type in decimalTypes) {
        formatBody = decimalTypes[type];
    } else if (type in integerTypes) {
        formatBody = integerTypes[type];
    } else {
        throw new Error('The number formatter type is invalid: ' + type);
    }
    var formatterPrecision;
    if (precision == null || precisionIsNaN) {
        formatterPrecision = type ? 6 : 12;
    } else {
        formatterPrecision = precision;
    }
    return function (n) {
        var result = formatBody(n, formatterPrecision);
        if (trim) {
            result = removeTrailingZeros(result);
        }
        if (comma) {
            result = insertSeparator(result, comma);
        }
        result = addSign(n, result, sign);
        if (symbol && symbol !== '#') {
            result = '' + symbol + result;
        }
        if (symbol === '#' && type === 'x') {
            result = '0x' + result;
        }
        if (type === 's') {
            result = '' + result + getSIPrefix(n);
        }
        if (type === '%' || type === 'p') {
            result = result + '%';
        }
        if (width != null && !isNaN(width)) {
            result = addPadding(result, width, fill !== null && fill !== void 0 ? fill : zero, align);
        }
        result = '' + prefix + result + suffix;
        return result;
    };
}
var absFloor = function (n) {
    return Math.floor(Math.abs(n));
};
var integerTypes = {
    'b': function (n) {
        return absFloor(n).toString(2);
    },
    'c': function (n) {
        return String.fromCharCode(n);
    },
    'd': function (n) {
        return Math.round(Math.abs(n)).toFixed(0);
    },
    'o': function (n) {
        return absFloor(n).toString(8);
    },
    'x': function (n) {
        return absFloor(n).toString(16);
    },
    'X': function (n) {
        return integerTypes.x(n).toUpperCase();
    },
    'n': function (n) {
        return integerTypes.d(n);
    },
    '%': function (n) {
        return '' + absFloor(n * 100).toFixed(0);
    },
};
var decimalTypes = {
    'e': function (n, f) {
        return Math.abs(n).toExponential(f);
    },
    'E': function (n, f) {
        return decimalTypes.e(n, f).toUpperCase();
    },
    'f': function (n, f) {
        return Math.abs(n).toFixed(f);
    },
    'F': function (n, f) {
        return decimalTypes.f(n, f).toUpperCase();
    },
    'g': function (n, f) {
        if (n === 0) {
            return '0';
        }
        var a = Math.abs(n);
        var p = Math.floor(Math.log10(a));
        if (p >= -4 && p < f) {
            return a.toFixed(f - 1 - p);
        }
        return a.toExponential(f - 1);
    },
    'G': function (n, f) {
        return decimalTypes.g(n, f).toUpperCase();
    },
    'n': function (n, f) {
        return decimalTypes.g(n, f);
    },
    'p': function (n, f) {
        return decimalTypes.r(n * 100, f);
    },
    'r': function (n, f) {
        if (n === 0) {
            return '0';
        }
        var a = Math.abs(n);
        var p = Math.floor(Math.log10(a));
        var q = p - (f - 1);
        if (q <= 0) {
            return a.toFixed(-q);
        }
        var x = Math.pow(10, q);
        return (Math.round(a / x) * x).toFixed();
    },
    's': function (n, f) {
        var p = getSIPrefixPower(n);
        return decimalTypes.r(n / Math.pow(10, p), f);
    },
    '%': function (n, f) {
        return decimalTypes.f(n * 100, f);
    },
};
function removeTrailingZeros(numString) {
    return numString.replace(/\.0+$/, '').replace(/(\.[1-9])0+$/, '$1');
}
function insertSeparator(numString, separator) {
    var dotIndex = numString.indexOf('.');
    if (dotIndex < 0) {
        dotIndex = numString.length;
    }
    var integerChars = numString.substring(0, dotIndex).split('');
    var fractionalPart = numString.substring(dotIndex);
    for (var i = integerChars.length - 3; i > 0; i -= 3) {
        integerChars.splice(i, 0, separator);
    }
    return '' + integerChars.join('') + fractionalPart;
}
function getSIPrefix(n) {
    return siPrefixes[getSIPrefixPower(n)];
}
function getSIPrefixPower(n) {
    var power = Math.log10(Math.abs(n));
    var p = Math.floor(power / 3) * 3;
    return Math.max(minSIPrefix, Math.min(maxSIPrefix, p));
}
var minSIPrefix = -24;
var maxSIPrefix = 24;
var siPrefixes =
    ((_a$2 = {}),
    (_a$2[minSIPrefix] = 'y'),
    (_a$2[-21] = 'z'),
    (_a$2[-18] = 'a'),
    (_a$2[-15] = 'f'),
    (_a$2[-12] = 'p'),
    (_a$2[-9] = 'n'),
    (_a$2[-6] = 'µ'),
    (_a$2[-3] = 'm'),
    (_a$2[0] = ''),
    (_a$2[3] = 'k'),
    (_a$2[6] = 'M'),
    (_a$2[9] = 'G'),
    (_a$2[12] = 'T'),
    (_a$2[15] = 'P'),
    (_a$2[18] = 'E'),
    (_a$2[21] = 'Z'),
    (_a$2[maxSIPrefix] = 'Y'),
    _a$2);
var minusSign = '\u2212';
function addSign(num, numString, signType) {
    if (signType === void 0) {
        signType = '';
    }
    if (signType === '(') {
        return num >= 0 ? numString : '(' + numString + ')';
    }
    var plusSign = signType === '+' ? '+' : '';
    return '' + (num >= 0 ? plusSign : minusSign) + numString;
}
function addPadding(numString, width, fill, align) {
    if (fill === void 0) {
        fill = ' ';
    }
    if (align === void 0) {
        align = '>';
    }
    var result = numString;
    if (align === '>' || !align) {
        result = result.padStart(width, fill);
    } else if (align === '<') {
        result = result.padEnd(width, fill);
    } else if (align === '^') {
        var padWidth = Math.max(0, width - result.length);
        var padLeft = Math.ceil(padWidth / 2);
        var padRight = Math.floor(padWidth / 2);
        result = result.padStart(padLeft + result.length, fill);
        result = result.padEnd(padRight + result.length, fill);
    }
    return result;
}
function tickFormat(ticks, formatter) {
    var options = parseFormatter(formatter !== null && formatter !== void 0 ? formatter : ',f');
    var precision = options.precision;
    if (precision == null || isNaN(precision)) {
        if (options.type === 'f' || options.type === '%') {
            options.precision = Math.max.apply(
                Math,
                __spreadArray$s(
                    [],
                    __read$M(
                        ticks.map(function (x) {
                            if (typeof x !== 'number' || x === 0) {
                                return 0;
                            }
                            var l = Math.floor(Math.log10(Math.abs(x)));
                            var digits = options.type ? 6 : 12;
                            var exp = x.toExponential(digits - 1).replace(/\.?0+e/, 'e');
                            var dotIndex = exp.indexOf('.');
                            if (dotIndex < 0) {
                                return l >= 0 ? 0 : -l;
                            }
                            var s = exp.indexOf('e') - dotIndex;
                            return Math.max(0, s - l - 1);
                        }),
                    ),
                ),
            );
        } else if (!options.type || options.type in decimalTypes) {
            options.precision = Math.max.apply(
                Math,
                __spreadArray$s(
                    [],
                    __read$M(
                        ticks.map(function (x) {
                            if (typeof x !== 'number') {
                                return 0;
                            }
                            var exp = x.toExponential((options.type ? 6 : 12) - 1).replace(/\.?0+e/, 'e');
                            return exp.substring(0, exp.indexOf('e')).replace('.', '').length;
                        }),
                    ),
                ),
            );
        }
    }
    var f = format(options);
    return function (n) {
        return f(Number(n));
    };
}

var __extends$2n =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1I =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$L =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$r =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var identity = function (x) {
    return x;
};
var LogScale = /** @class */ (function (_super) {
    __extends$2n(LogScale, _super);
    function LogScale() {
        var _this = _super.call(this, [1, 10], [0, 1]) || this;
        _this.type = 'log';
        _this.base = 10;
        _this.cacheProps = ['domain', 'range', 'nice', 'tickCount', 'base'];
        _this.baseLog = identity;
        _this.basePow = identity;
        _this.log = function (x) {
            return _this.domain[0] >= 0 ? _this.baseLog(x) : -_this.baseLog(-x);
        };
        _this.pow = function (x) {
            return _this.domain[0] >= 0 ? _this.basePow(x) : -_this.basePow(-x);
        };
        return _this;
    }
    LogScale.prototype.toDomain = function (d) {
        return d;
    };
    LogScale.prototype.transform = function (x) {
        return this.domain[0] >= 0 ? Math.log(x) : -Math.log(-x);
    };
    LogScale.prototype.transformInvert = function (x) {
        return this.domain[0] >= 0 ? Math.exp(x) : -Math.exp(-x);
    };
    LogScale.prototype.update = function () {
        if (!this.domain || this.domain.length < 2) {
            return;
        }
        this.updateLogFn();
        this.updatePowFn();
        if (this.nice) {
            this.updateNiceDomain();
        }
    };
    LogScale.prototype.updateLogFn = function () {
        var base = this.base;
        var log;
        if (base === 10) {
            log = Math.log10;
        } else if (base === Math.E) {
            log = Math.log;
        } else if (base === 2) {
            log = Math.log2;
        } else {
            var logBase_1 = Math.log(base);
            log = function (x) {
                return Math.log(x) / logBase_1;
            };
        }
        this.baseLog = log;
    };
    LogScale.prototype.updatePowFn = function () {
        var base = this.base;
        var pow;
        if (base === 10) {
            pow = LogScale.pow10;
        } else if (base === Math.E) {
            pow = Math.exp;
        } else {
            pow = function (x) {
                return Math.pow(base, x);
            };
        }
        this.basePow = pow;
    };
    LogScale.prototype.updateNiceDomain = function () {
        var _a = __read$L(this.domain, 2),
            d0 = _a[0],
            d1 = _a[1];
        var n0 = this.pow(Math.floor(this.log(d0)));
        var n1 = this.pow(Math.ceil(this.log(d1)));
        this.niceDomain = [n0, n1];
    };
    LogScale.pow10 = function (x) {
        return x >= 0 ? Math.pow(10, x) : 1 / Math.pow(10, -x);
    };
    LogScale.prototype.ticks = function () {
        var _this = this;
        var _a;
        var count = (_a = this.tickCount) !== null && _a !== void 0 ? _a : 10;
        if (!this.domain || this.domain.length < 2 || count < 1) {
            return [];
        }
        this.refresh();
        var base = this.base;
        var _b = __read$L(this.getDomain(), 2),
            d0 = _b[0],
            d1 = _b[1];
        var p0 = this.log(d0);
        var p1 = this.log(d1);
        if (this.interval) {
            var step = Math.abs(this.interval);
            var absDiff = Math.abs(p1 - p0);
            var ticks_1 = range(p0, p1, Math.min(absDiff, step))
                .map(function (x) {
                    return _this.pow(x);
                })
                .filter(function (t) {
                    return t >= d0 && t <= d1;
                });
            if (!this.isDenseInterval({ start: d0, stop: d1, interval: step, count: ticks_1.length })) {
                return ticks_1;
            }
        }
        var isBaseInteger = base % 1 === 0;
        var isDiffLarge = p1 - p0 >= count;
        if (!isBaseInteger || isDiffLarge) {
            // Returns [10^1, 10^2, 10^3, 10^4, ...]
            return ticks(p0, p1, Math.min(p1 - p0, count)).map(function (x) {
                return _this.pow(x);
            });
        }
        var ticks$1 = [];
        var isPositive = d0 > 0;
        p0 = Math.floor(p0) - 1;
        p1 = Math.round(p1) + 1;
        var min = Math.min.apply(Math, __spreadArray$r([], __read$L(this.range)));
        var max = Math.max.apply(Math, __spreadArray$r([], __read$L(this.range)));
        var availableSpacing = (max - min) / count;
        var lastTickPosition = Infinity;
        for (var p = p0; p <= p1; p++) {
            var nextMagnitudeTickPosition = this.convert(this.pow(p + 1));
            for (var k = 1; k < base; k++) {
                var q = isPositive ? k : base - k + 1;
                var t = this.pow(p) * q;
                var tickPosition = this.convert(t);
                var prevSpacing = Math.abs(lastTickPosition - tickPosition);
                var nextSpacing = Math.abs(tickPosition - nextMagnitudeTickPosition);
                var fits = prevSpacing >= availableSpacing && nextSpacing >= availableSpacing;
                if (t >= d0 && t <= d1 && (k === 1 || fits)) {
                    ticks$1.push(t);
                    lastTickPosition = tickPosition;
                }
            }
        }
        return ticks$1;
    };
    LogScale.prototype.tickFormat = function (_a) {
        var count = _a.count,
            ticks = _a.ticks,
            specifier = _a.specifier;
        var base = this.base;
        if (specifier == null) {
            specifier = base === 10 ? '.0e' : ',';
        }
        if (typeof specifier === 'string') {
            specifier = format(specifier);
        }
        if (count === Infinity) {
            return specifier;
        }
        if (ticks == null) {
            this.ticks();
        }
        return function (d) {
            return specifier(d);
        };
    };
    __decorate$1I([Validate(NUMBER(0))], LogScale.prototype, 'base', void 0);
    return LogScale;
})(ContinuousScale);

function extent$4(values) {
    var length = values.length;
    if (length === 0) {
        return undefined;
    }
    var min = Infinity;
    var max = -Infinity;
    for (var i = 0; i < length; i++) {
        var v = values[i];
        if (v instanceof Date) {
            v = v.getTime();
        }
        if (typeof v !== 'number') {
            continue;
        }
        if (v < min) {
            min = v;
        }
        if (v > max) {
            max = v;
        }
    }
    var extent = [min, max];
    if (
        extent.some(function (v) {
            return !isFinite(v);
        })
    ) {
        return undefined;
    }
    return extent;
}
function normalisedExtent(d, min, max) {
    var _a;
    if (d.length > 2) {
        d = (_a = extent$4(d)) !== null && _a !== void 0 ? _a : [NaN, NaN];
    }
    if (!isNaN(min)) {
        d = [min, d[1]];
    }
    if (!isNaN(max)) {
        d = [d[0], max];
    }
    if (d[0] > d[1]) {
        d = [];
    }
    return d;
}

var __decorate$1H =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Label$1 = /** @class */ (function () {
    function Label() {
        this.enabled = true;
        this.fontSize = 12;
        this.fontFamily = 'Verdana, sans-serif';
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.color = 'rgba(70, 70, 70, 1)';
    }
    Label.prototype.getFont = function () {
        return getFont(this);
    };
    __decorate$1H([Validate(BOOLEAN)], Label.prototype, 'enabled', void 0);
    __decorate$1H([Validate(NUMBER(0))], Label.prototype, 'fontSize', void 0);
    __decorate$1H([Validate(STRING)], Label.prototype, 'fontFamily', void 0);
    __decorate$1H([Validate(OPT_FONT_STYLE)], Label.prototype, 'fontStyle', void 0);
    __decorate$1H([Validate(OPT_FONT_WEIGHT)], Label.prototype, 'fontWeight', void 0);
    __decorate$1H([Validate(COLOR_STRING)], Label.prototype, 'color', void 0);
    return Label;
})();
function calculateLabelRotation(opts) {
    var _a = opts.parallelFlipRotation,
        parallelFlipRotation = _a === void 0 ? 0 : _a,
        _b = opts.regularFlipRotation,
        regularFlipRotation = _b === void 0 ? 0 : _b;
    var configuredRotation = opts.rotation ? normalizeAngle360(toRadians$1(opts.rotation)) : 0;
    var parallelFlipFlag = !configuredRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
    // Flip if the axis rotation angle is in the top hemisphere.
    var regularFlipFlag = !configuredRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
    var defaultRotation = 0;
    if (opts.parallel) {
        defaultRotation = (parallelFlipFlag * Math.PI) / 2;
    } else if (regularFlipFlag === -1) {
        defaultRotation = Math.PI;
    }
    return {
        configuredRotation: configuredRotation,
        defaultRotation: defaultRotation,
        parallelFlipFlag: parallelFlipFlag,
        regularFlipFlag: regularFlipFlag,
    };
}
function getLabelSpacing(minSpacing, rotated) {
    if (!isNaN(minSpacing)) {
        return minSpacing;
    }
    return rotated ? 0 : 10;
}
function getTextBaseline(parallel, labelRotation, sideFlag, parallelFlipFlag) {
    if (parallel && !labelRotation) {
        if (sideFlag * parallelFlipFlag === -1) {
            return 'hanging';
        } else {
            return 'bottom';
        }
    }
    return 'middle';
}
function getTextAlign(parallel, labelRotation, labelAutoRotation, sideFlag, regularFlipFlag) {
    var labelRotated = labelRotation > 0 && labelRotation <= Math.PI;
    var labelAutoRotated = labelAutoRotation > 0 && labelAutoRotation <= Math.PI;
    var alignFlag = labelRotated || labelAutoRotated ? -1 : 1;
    if (parallel) {
        if (labelRotation || labelAutoRotation) {
            if (sideFlag * alignFlag === -1) {
                return 'end';
            }
        } else {
            return 'center';
        }
    } else if (sideFlag * regularFlipFlag === -1) {
        return 'end';
    }
    return 'start';
}
function calculateLabelBBox(text, bbox, labelX, labelY, labelMatrix) {
    // Text.computeBBox() does not take into account any of the transformations that have been applied to the label nodes, only the width and height are useful.
    // Rather than taking into account all transformations including those of parent nodes which would be the result of `computeTransformedBBox()`, giving the x and y in the entire axis coordinate space,
    // take into account only the rotation and translation applied to individual label nodes to get the x y coordinates of the labels relative to each other
    // this makes label collision detection a lot simpler
    var width = bbox.width,
        height = bbox.height;
    var translatedBBox = new BBox(labelX, labelY, 0, 0);
    labelMatrix.transformBBox(translatedBBox, bbox);
    var _a = bbox.x,
        x = _a === void 0 ? 0 : _a,
        _b = bbox.y,
        y = _b === void 0 ? 0 : _b;
    bbox.width = width;
    bbox.height = height;
    return {
        point: {
            x: x,
            y: y,
            size: 0,
        },
        label: {
            width: width,
            height: height,
            text: text,
        },
    };
}

function Default(defaultValue, replaces) {
    if (replaces === void 0) {
        replaces = [undefined];
    }
    return addTransformToInstanceProperty(function (_, __, v) {
        if (replaces.includes(v)) {
            return defaultValue;
        }
        return v;
    });
}

var __decorate$1G =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AxisLabel = /** @class */ (function () {
    function AxisLabel() {
        this.enabled = true;
        /** If set to `false`, axis labels will not be wrapped on multiple lines. */
        this.autoWrap = false;
        /** Used to constrain the width of the label when `autoWrap` is `true`, if the label text width exceeds the `maxWidth`, it will be wrapped on multiple lines automatically. If `maxWidth` is omitted, a default width constraint will be applied. */
        this.maxWidth = undefined;
        /** Used to constrain the height of the multiline label, if the label text height exceeds the `maxHeight`, it will be truncated automatically. If `maxHeight` is omitted, a default height constraint will be applied. */
        this.maxHeight = undefined;
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.fontSize = 12;
        this.fontFamily = 'Verdana, sans-serif';
        /**
         * The padding between the labels and the ticks.
         */
        this.padding = 5;
        /**
         * Minimum gap in pixels between the axis labels before being removed to avoid collisions.
         */
        this.minSpacing = NaN;
        /**
         * The color of the labels.
         * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make labels invisible.
         */
        this.color = 'rgba(87, 87, 87, 1)';
        /**
         * Custom label rotation in degrees.
         * Labels are rendered perpendicular to the axis line by default.
         * Or parallel to the axis line, if the {@link parallel} is set to `true`.
         * The value of this config is used as the angular offset/deflection
         * from the default rotation.
         */
        this.rotation = undefined;
        /**
         * If specified and axis labels may collide, they are rotated to reduce collisions. If the
         * `rotation` property is specified, it takes precedence.
         */
        this.autoRotate = undefined;
        /**
         * Rotation angle to use when autoRotate is applied.
         */
        this.autoRotateAngle = 335;
        /**
         * Avoid axis label collision by automatically reducing the number of ticks displayed. If set to `false`, axis labels may collide.
         */
        this.avoidCollisions = true;
        /**
         * By default labels and ticks are positioned to the left of the axis line.
         * `true` positions the labels to the right of the axis line.
         * However, if the axis is rotated, it's easier to think in terms
         * of this side or the opposite side, rather than left and right.
         * We use the term `mirror` for conciseness, although it's not
         * true mirroring - for example, when a label is rotated, so that
         * it is inclined at the 45 degree angle, text flowing from north-west
         * to south-east, ending at the tick to the left of the axis line,
         * and then we set this config to `true`, the text will still be flowing
         * from north-west to south-east, _starting_ at the tick to the right
         * of the axis line.
         */
        this.mirrored = false;
        /**
         * Labels are rendered perpendicular to the axis line by default.
         * Setting this config to `true` makes labels render parallel to the axis line
         * and center aligns labels' text at the ticks.
         */
        this.parallel = false;
        /**
         * In case {@param value} is a number, the {@param fractionDigits} parameter will
         * be provided as well. The `fractionDigits` corresponds to the number of fraction
         * digits used by the tick step. For example, if the tick step is `0.0005`,
         * the `fractionDigits` is 4.
         */
        this.formatter = undefined;
        this.format = undefined;
    }
    /**
     * The side of the axis line to position the labels on.
     * -1 = left (default)
     * 1 = right
     */
    AxisLabel.prototype.getSideFlag = function () {
        return this.mirrored ? 1 : -1;
    };
    AxisLabel.prototype.getFont = function () {
        return getFont(this);
    };
    __decorate$1G([Validate(BOOLEAN)], AxisLabel.prototype, 'enabled', void 0);
    __decorate$1G([Validate(OPT_BOOLEAN)], AxisLabel.prototype, 'autoWrap', void 0);
    __decorate$1G([Validate(OPT_NUMBER(0))], AxisLabel.prototype, 'maxWidth', void 0);
    __decorate$1G([Validate(OPT_NUMBER(0))], AxisLabel.prototype, 'maxHeight', void 0);
    __decorate$1G([Validate(OPT_FONT_STYLE)], AxisLabel.prototype, 'fontStyle', void 0);
    __decorate$1G([Validate(OPT_FONT_WEIGHT)], AxisLabel.prototype, 'fontWeight', void 0);
    __decorate$1G([Validate(NUMBER(1))], AxisLabel.prototype, 'fontSize', void 0);
    __decorate$1G([Validate(STRING)], AxisLabel.prototype, 'fontFamily', void 0);
    __decorate$1G([Validate(NUMBER(0))], AxisLabel.prototype, 'padding', void 0);
    __decorate$1G([Validate(NUMBER_OR_NAN()), Default(NaN)], AxisLabel.prototype, 'minSpacing', void 0);
    __decorate$1G([Validate(OPT_COLOR_STRING)], AxisLabel.prototype, 'color', void 0);
    __decorate$1G([Validate(OPT_NUMBER(-360, 360))], AxisLabel.prototype, 'rotation', void 0);
    __decorate$1G([Validate(OPT_BOOLEAN)], AxisLabel.prototype, 'autoRotate', void 0);
    __decorate$1G([Validate(NUMBER(-360, 360))], AxisLabel.prototype, 'autoRotateAngle', void 0);
    __decorate$1G([Validate(BOOLEAN)], AxisLabel.prototype, 'avoidCollisions', void 0);
    __decorate$1G([Validate(BOOLEAN)], AxisLabel.prototype, 'mirrored', void 0);
    __decorate$1G([Validate(BOOLEAN)], AxisLabel.prototype, 'parallel', void 0);
    __decorate$1G([Validate(OPT_STRING)], AxisLabel.prototype, 'format', void 0);
    return AxisLabel;
})();

var __decorate$1F =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AxisLine = /** @class */ (function () {
    function AxisLine() {
        this.width = 1;
        this.color = 'rgba(195, 195, 195, 1)';
    }
    __decorate$1F([Validate(NUMBER(0))], AxisLine.prototype, 'width', void 0);
    __decorate$1F([Validate(OPT_COLOR_STRING)], AxisLine.prototype, 'color', void 0);
    return AxisLine;
})();

var __decorate$1E =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TICK_COUNT = predicateWithMessage(function (v, ctx) {
    return NUMBER(0)(v, ctx) || v instanceof TimeInterval;
}, "expecting a tick count Number value or, for a time axis, a Time Interval such as 'agCharts.time.month'");
var OPT_TICK_COUNT = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, TICK_COUNT);
}, "expecting an optional tick count Number value or, for a time axis, a Time Interval such as 'agCharts.time.month'");
var OPT_TICK_INTERVAL = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, function (v, ctx) {
        return (v !== 0 && NUMBER(0)(v, ctx)) || v instanceof TimeInterval;
    });
}, "expecting an optional non-zero positive Number value or, for a time axis, a Time Interval such as 'agCharts.time.month'");
var AxisTick = /** @class */ (function () {
    function AxisTick() {
        this.enabled = true;
        /**
         * The line width to be used by axis ticks.
         */
        this.width = 1;
        /**
         * The line length to be used by axis ticks.
         */
        this.size = 6;
        /**
         * The color of the axis ticks.
         * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make the ticks invisible.
         */
        this.color = 'rgba(195, 195, 195, 1)';
        /**
         * A hint of how many ticks to use (the exact number of ticks might differ),
         * a `TimeInterval` or a `CountableTimeInterval`.
         * For example:
         *
         *     axis.tick.count = 5;
         *     axis.tick.count = year;
         *     axis.tick.count = month.every(6);
         */
        this.count = undefined;
        this.interval = undefined;
        this.values = undefined;
        this.minSpacing = NaN;
    }
    __decorate$1E([Validate(BOOLEAN)], AxisTick.prototype, 'enabled', void 0);
    __decorate$1E([Validate(NUMBER(0))], AxisTick.prototype, 'width', void 0);
    __decorate$1E([Validate(NUMBER(0))], AxisTick.prototype, 'size', void 0);
    __decorate$1E([Validate(OPT_COLOR_STRING)], AxisTick.prototype, 'color', void 0);
    __decorate$1E(
        [Validate(OPT_TICK_COUNT), Deprecated('Use tick.interval or tick.minSpacing and tick.maxSpacing instead')],
        AxisTick.prototype,
        'count',
        void 0,
    );
    __decorate$1E([Validate(OPT_TICK_INTERVAL)], AxisTick.prototype, 'interval', void 0);
    __decorate$1E([Validate(OPT_ARRAY())], AxisTick.prototype, 'values', void 0);
    __decorate$1E(
        [Validate(AND(NUMBER_OR_NAN(1), LESS_THAN('maxSpacing'))), Default(NaN)],
        AxisTick.prototype,
        'minSpacing',
        void 0,
    );
    return AxisTick;
})();

var StateMachine = /** @class */ (function () {
    function StateMachine(initialState, states) {
        this.state = initialState;
        this.states = states;
        if (StateMachine.DEBUG())
            Logger.debug('%c' + this.constructor.name + ' | init -> ' + initialState, 'color: green');
    }
    StateMachine.prototype.transition = function (event, data) {
        var _a, _b, _c, _d, _e;
        var currentStateConfig = this.states[this.state];
        var destinationTransition =
            (_a = currentStateConfig === null || currentStateConfig === void 0 ? void 0 : currentStateConfig.on) ===
                null || _a === void 0
                ? void 0
                : _a[event];
        if (!destinationTransition) {
            if (StateMachine.DEBUG()) {
                Logger.debug(
                    '%c' + this.constructor.name + ' | ' + this.state + ' -> ' + event + ' -> ' + this.state,
                    'color: grey',
                );
            }
            return;
        }
        var destinationState = destinationTransition.target;
        var destinationStateConfig = this.states[destinationState];
        if (StateMachine.DEBUG()) {
            Logger.debug(
                '%c' + this.constructor.name + ' | ' + this.state + ' -> ' + event + ' -> ' + destinationState,
                'color: green',
            );
        }
        destinationTransition.action(data);
        (_c =
            (_b =
                currentStateConfig === null || currentStateConfig === void 0 ? void 0 : currentStateConfig.actions) ===
                null || _b === void 0
                ? void 0
                : _b.onExit) === null || _c === void 0
            ? void 0
            : _c.call(_b);
        (_e =
            (_d =
                destinationStateConfig === null || destinationStateConfig === void 0
                    ? void 0
                    : destinationStateConfig.actions) === null || _d === void 0
                ? void 0
                : _d.onEnter) === null || _e === void 0
            ? void 0
            : _e.call(_d);
        this.state = destinationState;
        return this.state;
    };
    StateMachine.DEBUG = function () {
        var _a;
        return (_a = [true, 'animation'].includes(windowValue('agChartsDebug'))) !== null && _a !== void 0 ? _a : false;
    };
    return StateMachine;
})();

var __extends$2m =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$J =
    (undefined && undefined.__assign) ||
    function () {
        __assign$J =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$J.apply(this, arguments);
    };
var __decorate$1D =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __rest$4 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __values$l =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$K =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$q =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var GRID_STYLE_KEYS = ['stroke', 'lineDash'];
var GRID_STYLE = predicateWithMessage(
    ARRAY(undefined, function (o) {
        for (var key in o) {
            if (!GRID_STYLE_KEYS.includes(key)) {
                return false;
            }
        }
        return true;
    }),
    "expecting an Array of objects with gridline style properties such as 'stroke' and 'lineDash'",
);
var Tags;
(function (Tags) {
    Tags[(Tags['TickLine'] = 0)] = 'TickLine';
    Tags[(Tags['TickLabel'] = 1)] = 'TickLabel';
    Tags[(Tags['GridLine'] = 2)] = 'GridLine';
    Tags[(Tags['GridArc'] = 3)] = 'GridArc';
    Tags[(Tags['AxisLine'] = 4)] = 'AxisLine';
})(Tags || (Tags = {}));
var TickGenerationType;
(function (TickGenerationType) {
    TickGenerationType[(TickGenerationType['CREATE'] = 0)] = 'CREATE';
    TickGenerationType[(TickGenerationType['CREATE_SECONDARY'] = 1)] = 'CREATE_SECONDARY';
    TickGenerationType[(TickGenerationType['FILTER'] = 2)] = 'FILTER';
    TickGenerationType[(TickGenerationType['VALUES'] = 3)] = 'VALUES';
})(TickGenerationType || (TickGenerationType = {}));
var AxisStateMachine = /** @class */ (function (_super) {
    __extends$2m(AxisStateMachine, _super);
    function AxisStateMachine() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    return AxisStateMachine;
})(StateMachine);
/**
 * A general purpose linear axis with no notion of orientation.
 * The axis is always rendered vertically, with horizontal labels positioned to the left
 * of the axis line by default. The axis can be {@link rotation | rotated} by an arbitrary angle,
 * so that it can be used as a top, right, bottom, left, radial or any other kind
 * of linear axis.
 * The generic `D` parameter is the type of the domain of the axis' scale.
 * The output range of the axis' scale is always numeric (screen coordinates).
 */
var Axis = /** @class */ (function () {
    function Axis(moduleCtx, scale) {
        var _this = this;
        this.moduleCtx = moduleCtx;
        this.id = createId$1(this);
        this.nice = true;
        this.dataDomain = [];
        this.keys = [];
        this.boundSeries = [];
        this.includeInvisibleDomains = false;
        this.axisGroup = new Group({ name: this.id + '-axis', zIndex: Layers.AXIS_ZINDEX });
        this.lineNode = this.axisGroup.appendChild(new Line());
        this.tickLineGroup = this.axisGroup.appendChild(
            new Group({ name: this.id + '-Axis-tick-lines', zIndex: Layers.AXIS_ZINDEX }),
        );
        this.tickLabelGroup = this.axisGroup.appendChild(
            new Group({ name: this.id + '-Axis-tick-labels', zIndex: Layers.AXIS_ZINDEX }),
        );
        this.crossLineGroup = new Group({ name: this.id + '-CrossLines' });
        this.gridGroup = new Group({ name: this.id + '-Axis-grid' });
        this.gridLineGroup = this.gridGroup.appendChild(
            new Group({
                name: this.id + '-gridLines',
                zIndex: Layers.AXIS_GRID_ZINDEX,
            }),
        );
        this.tickLineGroupSelection = Selection.select(this.tickLineGroup, Line, false);
        this.tickLabelGroupSelection = Selection.select(this.tickLabelGroup, Text, false);
        this.gridLineGroupSelection = Selection.select(this.gridLineGroup, Line, false);
        this.line = new AxisLine();
        this.tick = this.createTick();
        this.label = new AxisLabel();
        this.translation = { x: 0, y: 0 };
        this.rotation = 0; // axis rotation angle in degrees
        this.layout = {
            label: {
                fractionDigits: 0,
                padding: this.label.padding,
                format: this.label.format,
            },
        };
        this.modules = {};
        this.destroyFns = [];
        this.range = [0, 1];
        this.visibleRange = [0, 1];
        this.title = undefined;
        this._titleCaption = new Caption();
        /**
         * The length of the grid. The grid is only visible in case of a non-zero value.
         * In case {@link radialGrid} is `true`, the value is interpreted as an angle
         * (in degrees).
         */
        this._gridLength = 0;
        /**
         * The array of styles to cycle through when rendering grid lines.
         * For example, use two {@link GridStyle} objects for alternating styles.
         * Contains only one {@link GridStyle} object by default, meaning all grid lines
         * have the same style.
         */
        this.gridStyle = [
            {
                stroke: 'rgba(219, 219, 219, 1)',
                lineDash: [4, 2],
            },
        ];
        this.fractionDigits = 0;
        /**
         * The distance between the grid ticks and the axis ticks.
         */
        this.gridPadding = 0;
        /**
         * Is used to avoid collisions between axis labels and series.
         */
        this.seriesAreaPadding = 0;
        this.maxThickness = Infinity;
        this._scale = scale;
        this.refreshScale();
        this._titleCaption.node.rotation = -Math.PI / 2;
        this.axisGroup.appendChild(this._titleCaption.node);
        var axisHoverHandle = moduleCtx.interactionManager.addListener('hover', function (e) {
            return _this.checkAxisHover(e);
        });
        this.destroyFns.push(function () {
            return moduleCtx.interactionManager.removeListener(axisHoverHandle);
        });
        this.animationManager = moduleCtx.animationManager;
        this.animationState = new AxisStateMachine('empty', {
            empty: {
                on: {
                    update: {
                        target: 'align',
                        action: function () {
                            return _this.resetSelectionNodes();
                        },
                    },
                },
            },
            align: {
                on: {
                    update: {
                        target: 'ready',
                        action: function () {
                            return _this.resetSelectionNodes();
                        },
                    },
                },
            },
            ready: {
                on: {
                    update: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateReadyUpdate(data);
                        },
                    },
                },
            },
        });
        this._crossLines = [];
        this.assignCrossLineArrayConstructor(this._crossLines);
    }
    Object.defineProperty(Axis.prototype, 'scale', {
        get: function () {
            return this._scale;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Axis.prototype, 'type', {
        get: function () {
            var _a;
            return (_a = this.constructor.type) !== null && _a !== void 0 ? _a : '';
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Axis.prototype, 'crossLines', {
        get: function () {
            return this._crossLines;
        },
        set: function (value) {
            var _this = this;
            var _a, _b;
            (_a = this._crossLines) === null || _a === void 0
                ? void 0
                : _a.forEach(function (crossLine) {
                      return _this.detachCrossLine(crossLine);
                  });
            if (value) {
                this.assignCrossLineArrayConstructor(value);
            }
            this._crossLines = value;
            (_b = this._crossLines) === null || _b === void 0
                ? void 0
                : _b.forEach(function (crossLine) {
                      _this.attachCrossLine(crossLine);
                      _this.initCrossLine(crossLine);
                  });
        },
        enumerable: false,
        configurable: true,
    });
    Axis.prototype.attachCrossLine = function (crossLine) {
        this.crossLineGroup.appendChild(crossLine.group);
    };
    Axis.prototype.detachCrossLine = function (crossLine) {
        this.crossLineGroup.removeChild(crossLine.group);
    };
    Axis.prototype.destroy = function () {
        var e_1, _a;
        try {
            for (var _b = __values$l(Object.entries(this.modules)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read$K(_c.value, 2),
                    key = _d[0],
                    module = _d[1];
                module.instance.destroy();
                delete this.modules[key];
                delete this[key];
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        this.destroyFns.forEach(function (f) {
            return f();
        });
    };
    Axis.prototype.refreshScale = function () {
        var _this = this;
        var _a;
        this.range = this.scale.range.slice();
        (_a = this.crossLines) === null || _a === void 0
            ? void 0
            : _a.forEach(function (crossLine) {
                  _this.initCrossLine(crossLine);
              });
    };
    Axis.prototype.updateRange = function () {
        var _a;
        var _b = this,
            rr = _b.range,
            vr = _b.visibleRange,
            scale = _b.scale;
        var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        var shift = span * vr[0];
        var start = rr[0] - shift;
        scale.range = [start, start + span];
        (_a = this.crossLines) === null || _a === void 0
            ? void 0
            : _a.forEach(function (crossLine) {
                  crossLine.clippedRange = [rr[0], rr[1]];
              });
    };
    Axis.prototype.setCrossLinesVisible = function (visible) {
        this.crossLineGroup.visible = visible;
    };
    Axis.prototype.attachAxis = function (node) {
        node.appendChild(this.gridGroup);
        node.appendChild(this.axisGroup);
        node.appendChild(this.crossLineGroup);
    };
    Axis.prototype.detachAxis = function (node) {
        node.removeChild(this.gridGroup);
        node.removeChild(this.axisGroup);
        node.removeChild(this.crossLineGroup);
    };
    /**
     * Checks if a point or an object is in range.
     * @param x A point (or object's starting point).
     * @param width Object's width.
     * @param tolerance Expands the range on both ends by this amount.
     */
    Axis.prototype.inRange = function (x, width, tolerance) {
        if (width === void 0) {
            width = 0;
        }
        if (tolerance === void 0) {
            tolerance = 0;
        }
        return this.inRangeEx(x, width, tolerance) === 0;
    };
    Axis.prototype.inRangeEx = function (x, width, tolerance) {
        if (width === void 0) {
            width = 0;
        }
        if (tolerance === void 0) {
            tolerance = 0;
        }
        var range = this.range;
        // Account for inverted ranges, for example [500, 100] as well as [100, 500]
        var min = Math.min(range[0], range[1]);
        var max = Math.max(range[0], range[1]);
        if (x + width < min - tolerance) {
            return -1; // left of range
        }
        if (x > max + tolerance) {
            return 1; // right of range
        }
        return 0; // in range
    };
    Axis.prototype.onLabelFormatChange = function (ticks, format) {
        var _a = this,
            scale = _a.scale,
            fractionDigits = _a.fractionDigits;
        var logScale = scale instanceof LogScale;
        var defaultLabelFormatter =
            !logScale && fractionDigits > 0
                ? function (x) {
                      return typeof x === 'number' ? x.toFixed(fractionDigits) : String(x);
                  }
                : function (x) {
                      return String(x);
                  };
        if (format && scale && scale.tickFormat) {
            try {
                this.labelFormatter = scale.tickFormat({
                    ticks: ticks,
                    specifier: format,
                });
            } catch (e) {
                this.labelFormatter = defaultLabelFormatter;
                Logger.warnOnce(
                    'the axis label format string ' + format + ' is invalid. No formatting will be applied',
                );
            }
        } else {
            this.labelFormatter = defaultLabelFormatter;
        }
    };
    Axis.prototype.setDomain = function () {
        var _a;
        var _b = this,
            scale = _b.scale,
            dataDomain = _b.dataDomain,
            tickValues = _b.tick.values;
        if (tickValues && scale instanceof ContinuousScale) {
            var _c = __read$K((_a = extent$4(tickValues)) !== null && _a !== void 0 ? _a : [Infinity, -Infinity], 2),
                tickMin = _c[0],
                tickMax = _c[1];
            var min = Math.min(scale.fromDomain(dataDomain[0]), tickMin);
            var max = Math.max(scale.fromDomain(dataDomain[1]), tickMax);
            scale.domain = [scale.toDomain(min), scale.toDomain(max)];
        } else {
            scale.domain = dataDomain;
        }
    };
    Axis.prototype.setTickInterval = function (interval) {
        var _a;
        this.scale.interval = (_a = this.tick.interval) !== null && _a !== void 0 ? _a : interval;
    };
    Axis.prototype.setTickCount = function (count, minTickCount, maxTickCount) {
        var scale = this.scale;
        if (!(count && scale instanceof ContinuousScale)) {
            return;
        }
        if (typeof count === 'number') {
            scale.tickCount = count;
            scale.minTickCount = minTickCount !== null && minTickCount !== void 0 ? minTickCount : 0;
            scale.maxTickCount = maxTickCount !== null && maxTickCount !== void 0 ? maxTickCount : Infinity;
            return;
        }
        if (scale instanceof TimeScale$1) {
            this.setTickInterval(count);
        }
    };
    Object.defineProperty(Axis.prototype, 'gridLength', {
        get: function () {
            return this._gridLength;
        },
        set: function (value) {
            var _this = this;
            var _a;
            // Was visible and now invisible, or was invisible and now visible.
            if ((this._gridLength && !value) || (!this._gridLength && value)) {
                this.gridLineGroupSelection = this.gridLineGroupSelection.clear();
            }
            this._gridLength = value;
            (_a = this.crossLines) === null || _a === void 0
                ? void 0
                : _a.forEach(function (crossLine) {
                      _this.initCrossLine(crossLine);
                  });
        },
        enumerable: false,
        configurable: true,
    });
    Axis.prototype.createTick = function () {
        return new AxisTick();
    };
    Axis.prototype.checkAxisHover = function (event) {
        var bbox = this.computeBBox();
        var isInAxis = bbox.containsPoint(event.offsetX, event.offsetY);
        if (!isInAxis) return;
        this.moduleCtx.chartEventManager.axisHover(this.id, this.direction);
    };
    /**
     * Creates/removes/updates the scene graph nodes that constitute the axis.
     */
    Axis.prototype.update = function (primaryTickCount) {
        var previous = this.tickLabelGroupSelection.nodes().map(function (node) {
            return node.datum.tickId;
        });
        var _a = this.calculateRotations(),
            rotation = _a.rotation,
            parallelFlipRotation = _a.parallelFlipRotation,
            regularFlipRotation = _a.regularFlipRotation;
        var sideFlag = this.label.getSideFlag();
        var labelX = sideFlag * (this.tick.size + this.label.padding + this.seriesAreaPadding);
        this.updateScale();
        this.updatePosition({ rotation: rotation, sideFlag: sideFlag });
        this.updateLine();
        var _b = this.generateTicks({
                primaryTickCount: primaryTickCount,
                parallelFlipRotation: parallelFlipRotation,
                regularFlipRotation: regularFlipRotation,
                labelX: labelX,
                sideFlag: sideFlag,
            }),
            tickData = _b.tickData,
            combinedRotation = _b.combinedRotation,
            textBaseline = _b.textBaseline,
            textAlign = _b.textAlign,
            ticksResult = __rest$4(_b, ['tickData', 'combinedRotation', 'textBaseline', 'textAlign']);
        this.updateSelections(tickData.ticks);
        if (this.animationManager.skipAnimations) {
            this.resetSelectionNodes();
        } else {
            var diff = this.calculateUpdateDiff(previous, tickData);
            this.animationState.transition('update', diff);
        }
        this.updateLabels({
            tickLabelGroupSelection: this.tickLabelGroupSelection,
            combinedRotation: combinedRotation,
            textBaseline: textBaseline,
            textAlign: textAlign,
            labelX: labelX,
        });
        this.updateVisibility();
        this.updateGridLines(sideFlag);
        this.updateTickLines(sideFlag);
        this.updateTitle({ anyTickVisible: tickData.ticks.length > 0, sideFlag: sideFlag });
        this.updateCrossLines({
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
            sideFlag: sideFlag,
        });
        this.updateLayoutState();
        primaryTickCount = ticksResult.primaryTickCount;
        return primaryTickCount;
    };
    Axis.prototype.updateLayoutState = function () {
        this.layout.label = {
            fractionDigits: this.fractionDigits,
            padding: this.label.padding,
            format: this.label.format,
        };
    };
    Axis.prototype.updateScale = function () {
        this.updateRange();
        this.calculateDomain();
        this.setDomain();
        this.setTickInterval(this.tick.interval);
        var _a = this,
            scale = _a.scale,
            nice = _a.nice;
        if (!(scale instanceof ContinuousScale)) {
            return;
        }
        this.setTickCount(this.tick.count);
        scale.nice = nice;
        scale.update();
    };
    Axis.prototype.calculateRotations = function () {
        var rotation = toRadians$1(this.rotation);
        // When labels are parallel to the axis line, the `parallelFlipFlag` is used to
        // flip the labels to avoid upside-down text, when the axis is rotated
        // such that it is in the right hemisphere, i.e. the angle of rotation
        // is in the [0, π] interval.
        // The rotation angle is normalized, so that we have an easier time checking
        // if it's in the said interval. Since the axis is always rendered vertically
        // and then rotated, zero rotation means 12 (not 3) o-clock.
        // -1 = flip
        //  1 = don't flip (default)
        var parallelFlipRotation = normalizeAngle360(rotation);
        var regularFlipRotation = normalizeAngle360(rotation - Math.PI / 2);
        return {
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
        };
    };
    Axis.prototype.generateTicks = function (_a) {
        var e_2, _b, _c;
        var _d;
        var primaryTickCount = _a.primaryTickCount,
            parallelFlipRotation = _a.parallelFlipRotation,
            regularFlipRotation = _a.regularFlipRotation,
            labelX = _a.labelX,
            sideFlag = _a.sideFlag;
        var _e = this,
            scale = _e.scale,
            tick = _e.tick,
            _f = _e.label,
            parallel = _f.parallel,
            rotation = _f.rotation,
            fontFamily = _f.fontFamily,
            fontSize = _f.fontSize,
            fontStyle = _f.fontStyle,
            fontWeight = _f.fontWeight;
        var secondaryAxis = primaryTickCount !== undefined;
        var _g = calculateLabelRotation({
                rotation: rotation,
                parallel: parallel,
                regularFlipRotation: regularFlipRotation,
                parallelFlipRotation: parallelFlipRotation,
            }),
            defaultRotation = _g.defaultRotation,
            configuredRotation = _g.configuredRotation,
            parallelFlipFlag = _g.parallelFlipFlag,
            regularFlipFlag = _g.regularFlipFlag;
        var initialRotation = configuredRotation + defaultRotation;
        var labelMatrix = new Matrix();
        var maxTickCount = this.estimateTickCount({
            minSpacing: tick.minSpacing,
            maxSpacing: (_d = tick.maxSpacing) !== null && _d !== void 0 ? _d : NaN,
        }).maxTickCount;
        var continuous = scale instanceof ContinuousScale;
        var maxIterations = tick.count || !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        var textAlign = getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
        var textBaseline = getTextBaseline(parallel, configuredRotation, sideFlag, parallelFlipFlag);
        var textProps = {
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            textBaseline: textBaseline,
            textAlign: textAlign,
        };
        var tickData = {
            rawTicks: [],
            ticks: [],
            labelCount: 0,
        };
        var index = 0;
        var autoRotation = 0;
        var labelOverlap = true;
        var terminate = false;
        while (labelOverlap && index <= maxIterations) {
            if (terminate) {
                break;
            }
            autoRotation = 0;
            textAlign = getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
            var tickStrategies = this.getTickStrategies({ secondaryAxis: secondaryAxis, index: index });
            try {
                for (
                    var tickStrategies_1 = ((e_2 = void 0), __values$l(tickStrategies)),
                        tickStrategies_1_1 = tickStrategies_1.next();
                    !tickStrategies_1_1.done;
                    tickStrategies_1_1 = tickStrategies_1.next()
                ) {
                    var strategy = tickStrategies_1_1.value;
                    (_c = strategy({
                        index: index,
                        tickData: tickData,
                        textProps: textProps,
                        labelOverlap: labelOverlap,
                        terminate: terminate,
                        primaryTickCount: primaryTickCount,
                    })),
                        (tickData = _c.tickData),
                        (index = _c.index),
                        (autoRotation = _c.autoRotation),
                        (terminate = _c.terminate);
                    var ticksResult = tickData.ticks;
                    textAlign = getTextAlign(parallel, configuredRotation, autoRotation, sideFlag, regularFlipFlag);
                    var rotated = configuredRotation !== 0 || autoRotation !== 0;
                    var rotation_1 = initialRotation + autoRotation;
                    labelOverlap = this.checkLabelOverlap(
                        rotation_1,
                        rotated,
                        labelMatrix,
                        ticksResult,
                        labelX,
                        __assign$J(__assign$J({}, textProps), { textAlign: textAlign }),
                    );
                }
            } catch (e_2_1) {
                e_2 = { error: e_2_1 };
            } finally {
                try {
                    if (tickStrategies_1_1 && !tickStrategies_1_1.done && (_b = tickStrategies_1.return))
                        _b.call(tickStrategies_1);
                } finally {
                    if (e_2) throw e_2.error;
                }
            }
        }
        var combinedRotation = defaultRotation + configuredRotation + autoRotation;
        if (!secondaryAxis && tickData.rawTicks.length > 0) {
            primaryTickCount = tickData.rawTicks.length;
        }
        return {
            tickData: tickData,
            primaryTickCount: primaryTickCount,
            combinedRotation: combinedRotation,
            textBaseline: textBaseline,
            textAlign: textAlign,
        };
    };
    Axis.prototype.getTickStrategies = function (_a) {
        var _this = this;
        var index = _a.index,
            secondaryAxis = _a.secondaryAxis;
        var _b = this,
            scale = _b.scale,
            label = _b.label,
            tick = _b.tick;
        var continuous = scale instanceof ContinuousScale;
        var avoidLabelCollisions = label.enabled && label.avoidCollisions;
        var filterTicks = !(continuous && this.tick.count === undefined) && index !== 0 && avoidLabelCollisions;
        var autoRotate = label.autoRotate === true && label.rotation === undefined;
        var strategies = [];
        var tickGenerationType;
        if (this.tick.values) {
            tickGenerationType = TickGenerationType.VALUES;
        } else if (secondaryAxis) {
            tickGenerationType = TickGenerationType.CREATE_SECONDARY;
        } else if (filterTicks) {
            tickGenerationType = TickGenerationType.FILTER;
        } else {
            tickGenerationType = TickGenerationType.CREATE;
        }
        var tickGenerationStrategy = function (_a) {
            var index = _a.index,
                tickData = _a.tickData,
                primaryTickCount = _a.primaryTickCount,
                terminate = _a.terminate;
            return _this.createTickData(tickGenerationType, index, tickData, terminate, primaryTickCount);
        };
        strategies.push(tickGenerationStrategy);
        if (!continuous && !isNaN(tick.minSpacing)) {
            var tickFilterStrategy = function (_a) {
                var index = _a.index,
                    tickData = _a.tickData,
                    primaryTickCount = _a.primaryTickCount,
                    terminate = _a.terminate;
                return _this.createTickData(TickGenerationType.FILTER, index, tickData, terminate, primaryTickCount);
            };
            strategies.push(tickFilterStrategy);
        }
        if (!avoidLabelCollisions) {
            return strategies;
        }
        if (label.autoWrap) {
            var autoWrapStrategy = function (_a) {
                var index = _a.index,
                    tickData = _a.tickData,
                    textProps = _a.textProps;
                return _this.wrapLabels(tickData, index, textProps);
            };
            strategies.push(autoWrapStrategy);
        } else if (autoRotate) {
            var autoRotateStrategy = function (_a) {
                var index = _a.index,
                    tickData = _a.tickData,
                    labelOverlap = _a.labelOverlap,
                    terminate = _a.terminate;
                return {
                    index: index,
                    tickData: tickData,
                    autoRotation: _this.getAutoRotation(labelOverlap),
                    terminate: terminate,
                };
            };
            strategies.push(autoRotateStrategy);
        }
        return strategies;
    };
    Axis.prototype.createTickData = function (tickGenerationType, index, tickData, terminate, primaryTickCount) {
        var _a, _b, _c;
        var _d = this,
            scale = _d.scale,
            tick = _d.tick;
        var _e = this.estimateTickCount({
                minSpacing: tick.minSpacing,
                maxSpacing: (_a = tick.maxSpacing) !== null && _a !== void 0 ? _a : NaN,
            }),
            maxTickCount = _e.maxTickCount,
            minTickCount = _e.minTickCount,
            defaultTickCount = _e.defaultTickCount;
        var continuous = scale instanceof ContinuousScale;
        var maxIterations = tick.count || !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        var tickCount =
            (_b = tick.count) !== null && _b !== void 0
                ? _b
                : continuous
                ? Math.max(defaultTickCount - index, minTickCount)
                : maxTickCount;
        var regenerateTicks =
            tick.interval === undefined &&
            tick.values === undefined &&
            tick.count === undefined &&
            tickCount > minTickCount &&
            (continuous || tickGenerationType === TickGenerationType.FILTER);
        var unchanged = true;
        while (unchanged && index <= maxIterations) {
            var prevTicks = tickData.rawTicks;
            tickCount =
                (_c = tick.count) !== null && _c !== void 0
                    ? _c
                    : continuous
                    ? Math.max(defaultTickCount - index, minTickCount)
                    : maxTickCount;
            var _f = this.getTicks({
                    tickGenerationType: tickGenerationType,
                    previousTicks: prevTicks,
                    tickCount: tickCount,
                    minTickCount: minTickCount,
                    maxTickCount: maxTickCount,
                    primaryTickCount: primaryTickCount,
                }),
                rawTicks = _f.rawTicks,
                ticks = _f.ticks,
                labelCount = _f.labelCount;
            tickData.rawTicks = rawTicks;
            tickData.ticks = ticks;
            tickData.labelCount = labelCount;
            unchanged = regenerateTicks ? areArrayNumbersEqual(rawTicks, prevTicks) : false;
            index++;
        }
        var shouldTerminate = tick.interval !== undefined || tick.values !== undefined;
        terminate || (terminate = shouldTerminate);
        return { tickData: tickData, index: index, autoRotation: 0, terminate: terminate };
    };
    Axis.prototype.checkLabelOverlap = function (rotation, rotated, labelMatrix, tickData, labelX, textProps) {
        Matrix.updateTransformMatrix(labelMatrix, 1, 1, rotation, 0, 0);
        var labelData = this.createLabelData(tickData, labelX, textProps, labelMatrix);
        var labelSpacing = getLabelSpacing(this.label.minSpacing, rotated);
        return axisLabelsOverlap(labelData, labelSpacing);
    };
    Axis.prototype.createLabelData = function (tickData, labelX, textProps, labelMatrix) {
        var e_3, _a;
        var labelData = [];
        try {
            for (
                var tickData_1 = __values$l(tickData), tickData_1_1 = tickData_1.next();
                !tickData_1_1.done;
                tickData_1_1 = tickData_1.next()
            ) {
                var tickDatum = tickData_1_1.value;
                var tickLabel = tickDatum.tickLabel,
                    translationY = tickDatum.translationY;
                if (tickLabel === '' || tickLabel == undefined) {
                    // skip user hidden ticks
                    continue;
                }
                var lines = splitText(tickLabel);
                var _b = measureText(lines, labelX, translationY, textProps),
                    width = _b.width,
                    height = _b.height;
                var bbox = new BBox(labelX, translationY, width, height);
                var labelDatum = calculateLabelBBox(tickLabel, bbox, labelX, translationY, labelMatrix);
                labelData.push(labelDatum);
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (tickData_1_1 && !tickData_1_1.done && (_a = tickData_1.return)) _a.call(tickData_1);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        return labelData;
    };
    Axis.prototype.getAutoRotation = function (labelOveralap) {
        return labelOveralap ? normalizeAngle360(toRadians$1(this.label.autoRotateAngle)) : 0;
    };
    Axis.prototype.getTicks = function (_a) {
        var _b;
        var tickGenerationType = _a.tickGenerationType,
            previousTicks = _a.previousTicks,
            tickCount = _a.tickCount,
            minTickCount = _a.minTickCount,
            maxTickCount = _a.maxTickCount,
            primaryTickCount = _a.primaryTickCount;
        var scale = this.scale;
        var rawTicks = [];
        switch (tickGenerationType) {
            case TickGenerationType.VALUES:
                rawTicks = this.tick.values;
                break;
            case TickGenerationType.CREATE_SECONDARY:
                // `updateSecondaryAxisTicks` mutates `scale.domain` based on `primaryTickCount`
                rawTicks = this.updateSecondaryAxisTicks(primaryTickCount);
                break;
            case TickGenerationType.FILTER:
                rawTicks = this.filterTicks(previousTicks, tickCount);
                break;
            default:
                rawTicks = this.createTicks(tickCount, minTickCount, maxTickCount);
                break;
        }
        // When the scale domain or the ticks change, the label format may change
        this.onLabelFormatChange(rawTicks, this.label.format);
        // `ticks instanceof NumericTicks` doesn't work here, so we feature detect.
        this.fractionDigits = rawTicks.fractionDigits >= 0 ? rawTicks.fractionDigits : 0;
        var halfBandwidth = ((_b = this.scale.bandwidth) !== null && _b !== void 0 ? _b : 0) / 2;
        var ticks = [];
        var labelCount = 0;
        var tickIdCounts = new Map();
        for (var i = 0; i < rawTicks.length; i++) {
            var rawTick = rawTicks[i];
            var translationY = scale.convert(rawTick) + halfBandwidth;
            var tickLabel = this.formatTick(rawTick, i);
            // Create a tick id from the label, or as an increment of the last label if this tick label is blank
            var tickId = tickLabel;
            if (tickIdCounts.has(tickId)) {
                var count = tickIdCounts.get(tickId);
                tickIdCounts.set(tickId, count + 1);
                tickId = tickId + '_' + count;
            } else {
                tickIdCounts.set(tickId, 1);
            }
            ticks.push({ tick: rawTick, tickId: tickId, tickLabel: tickLabel, translationY: translationY });
            if (tickLabel === '' || tickLabel == undefined) {
                continue;
            }
            labelCount++;
        }
        return { rawTicks: rawTicks, ticks: ticks, labelCount: labelCount };
    };
    Axis.prototype.filterTicks = function (ticks, tickCount) {
        var _a;
        var tickSpacing =
            !isNaN(this.tick.minSpacing) || !isNaN((_a = this.tick.maxSpacing) !== null && _a !== void 0 ? _a : NaN);
        var keepEvery = tickSpacing ? Math.ceil(ticks.length / tickCount) : 2;
        return ticks.filter(function (_, i) {
            return i % keepEvery === 0;
        });
    };
    Axis.prototype.createTicks = function (tickCount, minTickCount, maxTickCount) {
        var _a, _b, _c;
        this.setTickCount(tickCount, minTickCount, maxTickCount);
        return (_c = (_b = (_a = this.scale).ticks) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null &&
            _c !== void 0
            ? _c
            : [];
    };
    Axis.prototype.estimateTickCount = function (_a) {
        var minSpacing = _a.minSpacing,
            maxSpacing = _a.maxSpacing;
        var availableRange = this.calculateAvailableRange();
        var defaultMinSpacing = Math.max(
            Axis.defaultTickMinSpacing,
            availableRange / ContinuousScale.defaultMaxTickCount,
        );
        if (isNaN(minSpacing) && isNaN(maxSpacing)) {
            minSpacing = defaultMinSpacing;
            maxSpacing = availableRange;
            if (minSpacing > maxSpacing) {
                // Take automatic minSpacing if there is a conflict.
                maxSpacing = minSpacing;
            }
        } else if (isNaN(minSpacing)) {
            minSpacing = defaultMinSpacing;
            if (minSpacing > maxSpacing) {
                // Take user-suplied maxSpacing if there is a conflict.
                minSpacing = maxSpacing;
            }
        } else if (isNaN(maxSpacing)) {
            maxSpacing = availableRange;
            if (minSpacing > maxSpacing) {
                // Take user-suplied minSpacing if there is a conflict.
                maxSpacing = minSpacing;
            }
        }
        var maxTickCount = Math.max(1, Math.floor(availableRange / minSpacing));
        var minTickCount = Math.min(maxTickCount, Math.ceil(availableRange / maxSpacing));
        var defaultTickCount = ContinuousScale.defaultTickCount;
        if (defaultTickCount > maxTickCount) {
            defaultTickCount = maxTickCount;
        } else if (defaultTickCount < minTickCount) {
            defaultTickCount = minTickCount;
        }
        return { minTickCount: minTickCount, maxTickCount: maxTickCount, defaultTickCount: defaultTickCount };
    };
    Axis.prototype.updateVisibility = function () {
        var requestedRange = this.range;
        var requestedRangeMin = Math.min.apply(Math, __spreadArray$q([], __read$K(requestedRange)));
        var requestedRangeMax = Math.max.apply(Math, __spreadArray$q([], __read$K(requestedRange)));
        var visibleFn = function (node) {
            var min = Math.floor(requestedRangeMin);
            var max = Math.ceil(requestedRangeMax);
            if (min === max) {
                node.visible = false;
                return;
            }
            // Fix an effect of rounding error
            if (node.translationY >= min - 1 && node.translationY < min) {
                node.translationY = min;
            }
            if (node.translationY > max && node.translationY <= max + 1) {
                node.translationY = max;
            }
            var visible = node.translationY >= min && node.translationY <= max;
            node.visible = visible;
        };
        var _a = this,
            gridLineGroupSelection = _a.gridLineGroupSelection,
            tickLineGroupSelection = _a.tickLineGroupSelection,
            tickLabelGroupSelection = _a.tickLabelGroupSelection;
        gridLineGroupSelection.each(visibleFn);
        tickLineGroupSelection.each(visibleFn);
        tickLabelGroupSelection.each(visibleFn);
        this.tickLineGroup.visible = this.tick.enabled;
        this.tickLabelGroup.visible = this.label.enabled;
    };
    Axis.prototype.updateCrossLines = function (_a) {
        var _this = this;
        var _b;
        var rotation = _a.rotation,
            parallelFlipRotation = _a.parallelFlipRotation,
            regularFlipRotation = _a.regularFlipRotation,
            sideFlag = _a.sideFlag;
        var anySeriesActive = this.isAnySeriesActive();
        (_b = this.crossLines) === null || _b === void 0
            ? void 0
            : _b.forEach(function (crossLine) {
                  var _a;
                  crossLine.sideFlag = -sideFlag;
                  crossLine.direction = rotation === -Math.PI / 2 ? ChartAxisDirection.X : ChartAxisDirection.Y;
                  crossLine.label.parallel =
                      (_a = crossLine.label.parallel) !== null && _a !== void 0 ? _a : _this.label.parallel;
                  crossLine.parallelFlipRotation = parallelFlipRotation;
                  crossLine.regularFlipRotation = regularFlipRotation;
                  crossLine.update(anySeriesActive);
              });
    };
    Axis.prototype.updateTickLines = function (sideFlag) {
        var tick = this.tick;
        this.tickLineGroupSelection.each(function (line) {
            line.strokeWidth = tick.width;
            line.stroke = tick.color;
            line.x1 = sideFlag * tick.size;
            line.x2 = 0;
            line.y1 = 0;
            line.y2 = 0;
        });
    };
    Axis.prototype.calculateAvailableRange = function () {
        var requestedRange = this.range;
        var min = Math.min.apply(Math, __spreadArray$q([], __read$K(requestedRange)));
        var max = Math.max.apply(Math, __spreadArray$q([], __read$K(requestedRange)));
        return max - min;
    };
    Axis.prototype.calculateDomain = function () {
        var e_4, _a, _b;
        var _c = this,
            direction = _c.direction,
            boundSeries = _c.boundSeries,
            includeInvisibleDomains = _c.includeInvisibleDomains;
        if (this.linkedTo) {
            this.dataDomain = this.linkedTo.dataDomain;
        } else {
            var domains = [];
            var visibleSeries = boundSeries.filter(function (s) {
                return includeInvisibleDomains || s.isEnabled();
            });
            try {
                for (
                    var visibleSeries_1 = __values$l(visibleSeries), visibleSeries_1_1 = visibleSeries_1.next();
                    !visibleSeries_1_1.done;
                    visibleSeries_1_1 = visibleSeries_1.next()
                ) {
                    var series = visibleSeries_1_1.value;
                    domains.push(series.getDomain(direction));
                }
            } catch (e_4_1) {
                e_4 = { error: e_4_1 };
            } finally {
                try {
                    if (visibleSeries_1_1 && !visibleSeries_1_1.done && (_a = visibleSeries_1.return))
                        _a.call(visibleSeries_1);
                } finally {
                    if (e_4) throw e_4.error;
                }
            }
            var domain = (_b = new Array()).concat.apply(_b, __spreadArray$q([], __read$K(domains)));
            this.dataDomain = this.normaliseDataDomain(domain);
        }
    };
    Axis.prototype.updatePosition = function (_a) {
        var rotation = _a.rotation,
            sideFlag = _a.sideFlag;
        var _b = this,
            crossLineGroup = _b.crossLineGroup,
            axisGroup = _b.axisGroup,
            gridGroup = _b.gridGroup,
            translation = _b.translation,
            gridLineGroupSelection = _b.gridLineGroupSelection,
            gridPadding = _b.gridPadding,
            gridLength = _b.gridLength;
        var translationX = Math.floor(translation.x);
        var translationY = Math.floor(translation.y);
        crossLineGroup.translationX = translationX;
        crossLineGroup.translationY = translationY;
        crossLineGroup.rotation = rotation;
        axisGroup.translationX = translationX;
        axisGroup.translationY = translationY;
        axisGroup.rotation = rotation;
        gridGroup.translationX = translationX;
        gridGroup.translationY = translationY;
        gridGroup.rotation = rotation;
        gridLineGroupSelection.each(function (line) {
            line.x1 = gridPadding;
            line.x2 = -sideFlag * gridLength + gridPadding;
            line.y1 = 0;
            line.y2 = 0;
        });
    };
    Axis.prototype.updateSecondaryAxisTicks = function (_primaryTickCount) {
        throw new Error('AG Charts - unexpected call to updateSecondaryAxisTicks() - check axes configuration.');
    };
    Axis.prototype.updateSelections = function (data) {
        var gridData = this.gridLength ? data : [];
        var gridLineGroupSelection = this.gridLineGroupSelection.update(
            gridData,
            function (group) {
                var node = new Line();
                node.tag = Tags.GridLine;
                group.append(node);
            },
            function (datum) {
                return datum.tickId;
            },
        );
        var tickLineGroupSelection = this.tickLineGroupSelection.update(
            data,
            function (group) {
                var line = new Line();
                line.tag = Tags.TickLine;
                group.appendChild(line);
            },
            function (datum) {
                return datum.tickId;
            },
        );
        var tickLabelGroupSelection = this.tickLabelGroupSelection.update(
            data,
            function (group) {
                var text = new Text();
                text.tag = Tags.TickLabel;
                group.appendChild(text);
            },
            function (datum) {
                return datum.tickId;
            },
        );
        this.tickLineGroupSelection = tickLineGroupSelection;
        this.tickLabelGroupSelection = tickLabelGroupSelection;
        this.gridLineGroupSelection = gridLineGroupSelection;
    };
    Axis.prototype.updateGridLines = function (sideFlag) {
        var _a = this,
            gridStyle = _a.gridStyle,
            tick = _a.tick,
            gridPadding = _a.gridPadding,
            gridLength = _a.gridLength;
        if (gridLength === 0 || gridStyle.length === 0) {
            return;
        }
        var styleCount = gridStyle.length;
        this.gridLineGroupSelection.each(function (line, _, index) {
            var style = gridStyle[index % styleCount];
            line.x1 = gridPadding;
            line.x2 = -sideFlag * gridLength + gridPadding;
            line.y1 = 0;
            line.y2 = 0;
            line.stroke = style.stroke;
            line.strokeWidth = tick.width;
            line.lineDash = style.lineDash;
            line.fill = undefined;
        });
    };
    Axis.prototype.updateLabels = function (_a) {
        var tickLabelGroupSelection = _a.tickLabelGroupSelection,
            combinedRotation = _a.combinedRotation,
            textBaseline = _a.textBaseline,
            textAlign = _a.textAlign,
            labelX = _a.labelX;
        var _b = this,
            label = _b.label,
            labelsEnabled = _b.label.enabled;
        if (!labelsEnabled) {
            return;
        }
        // Apply label option values
        tickLabelGroupSelection.each(function (node, datum) {
            var tickLabel = datum.tickLabel;
            node.fontStyle = label.fontStyle;
            node.fontWeight = label.fontWeight;
            node.fontSize = label.fontSize;
            node.fontFamily = label.fontFamily;
            node.fill = label.color;
            node.text = tickLabel;
            var userHidden = node.text === '' || node.text == undefined;
            if (userHidden) {
                node.visible = false; // hide empty labels
                return;
            }
            // Position labels
            node.textBaseline = textBaseline;
            node.textAlign = textAlign;
            node.x = labelX;
            node.rotationCenterX = labelX;
            node.rotation = combinedRotation;
            node.visible = true;
        });
    };
    Axis.prototype.wrapLabels = function (tickData, index, labelProps) {
        var _a = this.label,
            parallel = _a.parallel,
            maxWidth = _a.maxWidth,
            maxHeight = _a.maxHeight;
        var defaultMaxLabelWidth = parallel
            ? Math.round(this.calculateAvailableRange() / tickData.labelCount)
            : this.maxThickness;
        var maxLabelWidth = maxWidth !== null && maxWidth !== void 0 ? maxWidth : defaultMaxLabelWidth;
        var defaultMaxLabelHeight = parallel
            ? this.maxThickness
            : Math.round(this.calculateAvailableRange() / tickData.labelCount);
        var maxLabelHeight = maxHeight !== null && maxHeight !== void 0 ? maxHeight : defaultMaxLabelHeight;
        tickData.ticks.forEach(function (tickDatum) {
            var tickLabel = tickDatum.tickLabel;
            var wrapping = 'hyphenate';
            var wrappedTickLabel = Text.wrap(tickLabel, maxLabelWidth, maxLabelHeight, labelProps, wrapping);
            tickDatum.tickLabel = wrappedTickLabel;
        });
        return { tickData: tickData, index: index, autoRotation: 0, terminate: true };
    };
    Axis.prototype.updateLine = function () {
        // Render axis line.
        var _a = this,
            lineNode = _a.lineNode,
            requestedRange = _a.range;
        lineNode.x1 = 0;
        lineNode.x2 = 0;
        lineNode.y1 = requestedRange[0];
        lineNode.y2 = requestedRange[1];
        lineNode.strokeWidth = this.line.width;
        lineNode.stroke = this.line.color;
        lineNode.visible = true;
    };
    Axis.prototype.updateTitle = function (_a) {
        var _b;
        var anyTickVisible = _a.anyTickVisible,
            sideFlag = _a.sideFlag;
        var identityFormatter = function (params) {
            return params.defaultValue;
        };
        var _c = this,
            rotation = _c.rotation,
            title = _c.title,
            _titleCaption = _c._titleCaption,
            lineNode = _c.lineNode,
            requestedRange = _c.range,
            tickLineGroup = _c.tickLineGroup,
            tickLabelGroup = _c.tickLabelGroup,
            callbackCache = _c.moduleCtx.callbackCache;
        var _d = ((_b = this.title) !== null && _b !== void 0 ? _b : {}).formatter,
            formatter = _d === void 0 ? identityFormatter : _d;
        if (!title) {
            _titleCaption.enabled = false;
            return;
        }
        _titleCaption.enabled = title.enabled;
        _titleCaption.fontFamily = title.fontFamily;
        _titleCaption.fontSize = title.fontSize;
        _titleCaption.fontStyle = title.fontStyle;
        _titleCaption.fontWeight = title.fontWeight;
        _titleCaption.color = title.color;
        _titleCaption.wrapping = title.wrapping;
        var titleVisible = false;
        var titleNode = _titleCaption.node;
        if (title.enabled && lineNode.visible) {
            titleVisible = true;
            var parallelFlipRotation = normalizeAngle360(rotation);
            var padding = Caption.PADDING;
            var titleRotationFlag =
                sideFlag === -1 && parallelFlipRotation > Math.PI && parallelFlipRotation < Math.PI * 2 ? -1 : 1;
            titleNode.rotation = (titleRotationFlag * sideFlag * Math.PI) / 2;
            titleNode.x = Math.floor((titleRotationFlag * sideFlag * (requestedRange[0] + requestedRange[1])) / 2);
            var bboxYDimension = 0;
            if (anyTickVisible) {
                var tickBBox = Group.computeBBox([tickLineGroup, tickLabelGroup]);
                var tickWidth = rotation === 0 ? tickBBox.width : tickBBox.height;
                if (Math.abs(tickWidth) < Infinity) {
                    bboxYDimension += tickWidth;
                }
            }
            if (sideFlag === -1) {
                titleNode.y = Math.floor(titleRotationFlag * (-padding - bboxYDimension));
            } else {
                titleNode.y = Math.floor(-padding - bboxYDimension);
            }
            titleNode.textBaseline = titleRotationFlag === 1 ? 'bottom' : 'top';
            titleNode.text = callbackCache.call(formatter, this.getTitleFormatterParams());
        }
        titleNode.visible = titleVisible;
    };
    // For formatting (nice rounded) tick values.
    Axis.prototype.formatTick = function (datum, index) {
        var _a, _b;
        var _c = this,
            label = _c.label,
            labelFormatter = _c.labelFormatter,
            fractionDigits = _c.fractionDigits,
            callbackCache = _c.moduleCtx.callbackCache;
        if (label.formatter) {
            var defaultValue = fractionDigits > 0 ? datum : String(datum);
            return (_a = callbackCache.call(label.formatter, {
                value: defaultValue,
                index: index,
                fractionDigits: fractionDigits,
                formatter: labelFormatter,
            })) !== null && _a !== void 0
                ? _a
                : defaultValue;
        } else if (labelFormatter) {
            return (_b = callbackCache.call(labelFormatter, datum)) !== null && _b !== void 0 ? _b : String(datum);
        }
        // The axis is using a logScale or the`datum` is an integer, a string or an object
        return String(datum);
    };
    // For formatting arbitrary values between the ticks.
    Axis.prototype.formatDatum = function (datum) {
        return String(datum);
    };
    Axis.prototype.computeBBox = function () {
        return this.axisGroup.computeBBox();
    };
    Axis.prototype.initCrossLine = function (crossLine) {
        crossLine.scale = this.scale;
        crossLine.gridLength = this.gridLength;
    };
    Axis.prototype.isAnySeriesActive = function () {
        var _this = this;
        return this.boundSeries.some(function (s) {
            return _this.includeInvisibleDomains || s.isEnabled();
        });
    };
    Axis.prototype.clipTickLines = function (x, y, width, height) {
        this.tickLineGroup.setClipRectInGroupCoordinateSpace(new BBox(x, y, width, height));
    };
    Axis.prototype.clipGrid = function (x, y, width, height) {
        this.gridGroup.setClipRectInGroupCoordinateSpace(new BBox(x, y, width, height));
    };
    Axis.prototype.calculatePadding = function (min, _max) {
        return [Math.abs(min * 0.01), Math.abs(min * 0.01)];
    };
    Axis.prototype.getTitleFormatterParams = function () {
        var _this = this;
        var _a;
        var boundSeries = this.boundSeries.reduce(function (acc, next) {
            var keys = next.getKeys(_this.direction);
            var names = next.getNames(_this.direction);
            for (var idx = 0; idx < keys.length; idx++) {
                acc.push({
                    key: keys[idx],
                    name: names[idx],
                });
            }
            return acc;
        }, []);
        return {
            direction: this.direction,
            boundSeries: boundSeries,
            defaultValue: (_a = this.title) === null || _a === void 0 ? void 0 : _a.text,
        };
    };
    Axis.prototype.normaliseDataDomain = function (d) {
        return d;
    };
    Axis.prototype.getLayoutState = function () {
        return __assign$J(
            {
                rect: this.computeBBox(),
                gridPadding: this.gridPadding,
                seriesAreaPadding: this.seriesAreaPadding,
                tickSize: this.tick.size,
            },
            this.layout,
        );
    };
    Axis.prototype.createAxisContext = function () {
        var _this = this;
        var keys = function () {
            return _this.boundSeries
                .map(function (s) {
                    return s.getKeys(_this.direction);
                })
                .reduce(function (keys, seriesKeys) {
                    keys.push.apply(keys, __spreadArray$q([], __read$K(seriesKeys)));
                    return keys;
                }, []);
        };
        return {
            axisId: this.id,
            direction: this.direction,
            continuous: this.scale instanceof ContinuousScale,
            keys: keys,
            scaleValueFormatter: function (specifier) {
                var _a, _b, _c;
                return (_c =
                    (_b = (_a = _this.scale).tickFormat) === null || _b === void 0
                        ? void 0
                        : _b.call(_a, { specifier: specifier })) !== null && _c !== void 0
                    ? _c
                    : undefined;
            },
            scaleBandwidth: function () {
                var _a;
                return (_a = _this.scale.bandwidth) !== null && _a !== void 0 ? _a : 0;
            },
            scaleConvert: function (val) {
                return _this.scale.convert(val);
            },
            scaleInvert: function (val) {
                var _a, _b, _c;
                return (_c = (_b = (_a = _this.scale).invert) === null || _b === void 0 ? void 0 : _b.call(_a, val)) !==
                    null && _c !== void 0
                    ? _c
                    : undefined;
            },
        };
    };
    Axis.prototype.addModule = function (module) {
        if (this.modules[module.optionsKey] != null) {
            throw new Error('AG Charts - module already initialised: ' + module.optionsKey);
        }
        if (this.axisContext == null) {
            this.axisContext = this.createAxisContext();
        }
        var moduleInstance = new module.instanceConstructor(
            __assign$J(__assign$J({}, this.moduleCtx), { parent: this.axisContext }),
        );
        this.modules[module.optionsKey] = { instance: moduleInstance };
        this[module.optionsKey] = moduleInstance;
    };
    Axis.prototype.removeModule = function (module) {
        var _a, _b;
        (_b = (_a = this.modules[module.optionsKey]) === null || _a === void 0 ? void 0 : _a.instance) === null ||
        _b === void 0
            ? void 0
            : _b.destroy();
        delete this.modules[module.optionsKey];
        delete this[module.optionsKey];
    };
    Axis.prototype.isModuleEnabled = function (module) {
        return this.modules[module.optionsKey] != null;
    };
    Axis.prototype.animateReadyUpdate = function (diff) {
        var _this = this;
        var _a, _b;
        if (!diff.changed) {
            this.resetSelectionNodes();
            return;
        }
        var _c = this,
            gridLineGroupSelection = _c.gridLineGroupSelection,
            tickLineGroupSelection = _c.tickLineGroupSelection,
            tickLabelGroupSelection = _c.tickLabelGroupSelection;
        var addedCount = Object.keys(diff.added).length;
        var removedCount = Object.keys(diff.removed).length;
        if (removedCount === diff.tickCount) {
            this.resetSelectionNodes();
            return;
        }
        var totalDuration =
            (_b = (_a = this.animationManager) === null || _a === void 0 ? void 0 : _a.defaultOptions.duration) !==
                null && _b !== void 0
                ? _b
                : 1000;
        var sectionDuration = Math.floor(totalDuration / 2);
        if (addedCount > 0 && removedCount > 0) {
            sectionDuration = Math.floor(totalDuration / 3);
        }
        var options = {
            delay: removedCount > 0 ? sectionDuration : 0,
            duration: sectionDuration,
        };
        var animationGroup = this.id + '_' + Math.random();
        tickLabelGroupSelection.each(function (node, datum) {
            _this.animateSelectionNode(tickLabelGroupSelection, diff, options, node, datum, animationGroup);
        });
        gridLineGroupSelection.each(function (node, datum) {
            _this.animateSelectionNode(gridLineGroupSelection, diff, options, node, datum, animationGroup);
        });
        tickLineGroupSelection.each(function (node, datum) {
            _this.animateSelectionNode(tickLineGroupSelection, diff, options, node, datum, animationGroup);
        });
    };
    Axis.prototype.animateSelectionNode = function (selection, diff, options, node, datum, animationGroup) {
        var roundedTranslationY = Math.round(datum.translationY);
        var translate = { from: node.translationY, to: roundedTranslationY };
        var opacity = { from: 1, to: 1 };
        var duration = options.duration;
        var delay = options.delay;
        var datumId = datum.tickLabel;
        if (diff.added[datumId]) {
            translate = { from: roundedTranslationY, to: roundedTranslationY };
            opacity = { from: 0, to: 1 };
            delay += duration;
        } else if (diff.removed[datumId]) {
            opacity = { from: 1, to: 0 };
            delay = 0;
        }
        var props = [translate, opacity];
        this.animationManager.animateManyWithThrottle(this.id + '_ready-update_' + node.id, props, {
            disableInteractions: false,
            delay: delay,
            duration: duration,
            ease: easeOut,
            throttleId: this.id,
            throttleGroup: animationGroup,
            onUpdate: function (_a) {
                var _b = __read$K(_a, 2),
                    translationY = _b[0],
                    opacity = _b[1];
                node.translationY = translationY;
                node.opacity = opacity;
            },
            onComplete: function () {
                selection.cleanup();
            },
        });
    };
    Axis.prototype.resetSelectionNodes = function () {
        var _a = this,
            gridLineGroupSelection = _a.gridLineGroupSelection,
            tickLineGroupSelection = _a.tickLineGroupSelection,
            tickLabelGroupSelection = _a.tickLabelGroupSelection;
        gridLineGroupSelection.cleanup();
        tickLineGroupSelection.cleanup();
        tickLabelGroupSelection.cleanup();
        // We need raw `translationY` values on `datum` for accurate label collision detection in axes.update()
        // But node `translationY` values must be rounded to get pixel grid alignment
        var resetFn = function (node) {
            node.translationY = Math.round(node.datum.translationY);
            node.opacity = 1;
        };
        gridLineGroupSelection.each(resetFn);
        tickLineGroupSelection.each(resetFn);
        tickLabelGroupSelection.each(resetFn);
    };
    Axis.prototype.calculateUpdateDiff = function (previous, tickData) {
        var _a;
        var added = new Set();
        var removed = new Set();
        var tickCount = Math.max(previous.length, tickData.ticks.length);
        for (var i = 0; i < tickCount; i++) {
            var prev = previous[i];
            var tick = (_a = tickData.ticks[i]) === null || _a === void 0 ? void 0 : _a.tickId;
            if (prev === tick) {
                continue;
            }
            if (removed.has(tick)) {
                removed.delete(tick);
            } else if (tick) {
                added.add(tick);
            }
            if (added.has(prev)) {
                added.delete(prev);
            } else if (prev) {
                removed.add(prev);
            }
        }
        var addedKeys = {};
        var removedKeys = {};
        added.forEach(function (a) {
            addedKeys[a] = true;
        });
        removed.forEach(function (r) {
            removedKeys[r] = true;
        });
        return {
            changed: added.size > 0 || removed.size > 0,
            tickCount: tickCount,
            added: addedKeys,
            removed: removedKeys,
        };
    };
    Axis.defaultTickMinSpacing = 50;
    __decorate$1D([Validate(BOOLEAN)], Axis.prototype, 'nice', void 0);
    __decorate$1D([Validate(STRING_ARRAY)], Axis.prototype, 'keys', void 0);
    __decorate$1D([Validate(GRID_STYLE)], Axis.prototype, 'gridStyle', void 0);
    return Axis;
})();

var __decorate$1C =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AxisTitle = /** @class */ (function () {
    function AxisTitle() {
        this.enabled = false;
        this.text = undefined;
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.fontSize = 10;
        this.fontFamily = 'sans-serif';
        this.color = undefined;
        this.wrapping = 'always';
        this.formatter = undefined;
    }
    __decorate$1C([Validate(BOOLEAN)], AxisTitle.prototype, 'enabled', void 0);
    __decorate$1C([Validate(OPT_STRING)], AxisTitle.prototype, 'text', void 0);
    __decorate$1C([Validate(OPT_FONT_STYLE)], AxisTitle.prototype, 'fontStyle', void 0);
    __decorate$1C([Validate(OPT_FONT_WEIGHT)], AxisTitle.prototype, 'fontWeight', void 0);
    __decorate$1C([Validate(NUMBER(0))], AxisTitle.prototype, 'fontSize', void 0);
    __decorate$1C([Validate(STRING)], AxisTitle.prototype, 'fontFamily', void 0);
    __decorate$1C([Validate(OPT_COLOR_STRING)], AxisTitle.prototype, 'color', void 0);
    __decorate$1C([Validate(TEXT_WRAP)], AxisTitle.prototype, 'wrapping', void 0);
    __decorate$1C([Validate(OPT_FUNCTION)], AxisTitle.prototype, 'formatter', void 0);
    return AxisTitle;
})();

var __extends$2l =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1B =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DropShadow = /** @class */ (function (_super) {
    __extends$2l(DropShadow, _super);
    function DropShadow() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.enabled = true;
        _this.color = 'rgba(0, 0, 0, 0.5)';
        _this.xOffset = 0;
        _this.yOffset = 0;
        _this.blur = 5;
        return _this;
    }
    __decorate$1B(
        [Validate(BOOLEAN), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        DropShadow.prototype,
        'enabled',
        void 0,
    );
    __decorate$1B(
        [Validate(COLOR_STRING), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        DropShadow.prototype,
        'color',
        void 0,
    );
    __decorate$1B(
        [Validate(NUMBER()), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        DropShadow.prototype,
        'xOffset',
        void 0,
    );
    __decorate$1B(
        [Validate(NUMBER()), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        DropShadow.prototype,
        'yOffset',
        void 0,
    );
    __decorate$1B(
        [Validate(NUMBER(0)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        DropShadow.prototype,
        'blur',
        void 0,
    );
    return DropShadow;
})(ChangeDetectable);

var __extends$2k =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$J =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
/**
 * Maps continuous domain to a continuous range.
 */
var LinearScale$1 = /** @class */ (function (_super) {
    __extends$2k(LinearScale, _super);
    function LinearScale() {
        var _this = _super.call(this, [0, 1], [0, 1]) || this;
        _this.type = 'linear';
        return _this;
    }
    LinearScale.prototype.toDomain = function (d) {
        return d;
    };
    LinearScale.prototype.ticks = function () {
        var _a;
        var count = (_a = this.tickCount) !== null && _a !== void 0 ? _a : ContinuousScale.defaultTickCount;
        if (
            !this.domain ||
            this.domain.length < 2 ||
            count < 1 ||
            this.domain.some(function (d) {
                return !isFinite(d);
            })
        ) {
            return [];
        }
        this.refresh();
        var _b = __read$J(this.getDomain(), 2),
            d0 = _b[0],
            d1 = _b[1];
        var interval = this.interval;
        if (interval) {
            var step = Math.abs(interval);
            if (!this.isDenseInterval({ start: d0, stop: d1, interval: step })) {
                return range(d0, d1, step);
            }
        }
        return ticks(d0, d1, count, this.minTickCount, this.maxTickCount);
    };
    LinearScale.prototype.update = function () {
        if (!this.domain || this.domain.length < 2) {
            return;
        }
        if (this.nice) {
            this.updateNiceDomain();
        }
    };
    /**
     * Extends the domain so that it starts and ends on nice round values.
     * @param count Tick count.
     */
    LinearScale.prototype.updateNiceDomain = function () {
        var _a, _b;
        var count = (_a = this.tickCount) !== null && _a !== void 0 ? _a : ContinuousScale.defaultTickCount;
        var _c = __read$J(this.domain, 2),
            start = _c[0],
            stop = _c[1];
        if (count < 1) {
            this.niceDomain = [start, stop];
            return;
        }
        if (count === 1) {
            this.niceDomain = singleTickDomain(start, stop);
            return;
        }
        var maxAttempts = 4;
        var prev0 = start;
        var prev1 = stop;
        for (var i = 0; i < maxAttempts; i++) {
            var step =
                (_b = this.interval) !== null && _b !== void 0
                    ? _b
                    : tickStep(start, stop, count, this.minTickCount, this.maxTickCount);
            var _d = __read$J(this.domain, 2),
                d0 = _d[0],
                d1 = _d[1];
            if (step >= 1) {
                start = Math.floor(d0 / step) * step;
                stop = Math.ceil(d1 / step) * step;
            } else {
                // Prevent floating point error
                var s = 1 / step;
                start = Math.floor(d0 * s) / s;
                stop = Math.ceil(d1 * s) / s;
            }
            if (start === prev0 && stop === prev1) {
                break;
            }
            prev0 = start;
            prev1 = stop;
        }
        this.niceDomain = [start, stop];
    };
    LinearScale.prototype.tickFormat = function (_a) {
        var ticks = _a.ticks,
            specifier = _a.specifier;
        return tickFormat(ticks !== null && ticks !== void 0 ? ticks : this.ticks(), specifier);
    };
    return LinearScale;
})(ContinuousScale);

function isEqual(a, b, epsilon) {
    if (epsilon === void 0) {
        epsilon = 1e-10;
    }
    return Math.abs(a - b) < epsilon;
}
/**
 * `Number.toFixed(n)` always formats a number so that it has `n` digits after the decimal point.
 * For example, `Number(0.00003427).toFixed(2)` returns `0.00`.
 * That's not very helpful, because all the meaningful information is lost.
 * In this case we would want the formatted value to have at least two significant digits: `0.000034`,
 * not two fraction digits.
 * @param value
 * @param fractionOrSignificantDigits
 */
function toFixed(value, fractionOrSignificantDigits) {
    if (fractionOrSignificantDigits === void 0) {
        fractionOrSignificantDigits = 2;
    }
    var power = Math.floor(Math.log(Math.abs(value)) / Math.LN10);
    if (power >= 0 || !isFinite(power)) {
        return value.toFixed(fractionOrSignificantDigits); // fraction digits
    }
    return value.toFixed(Math.abs(power) - 1 + fractionOrSignificantDigits); // significant digits
}
/**
 * Returns the mathematically correct n modulus of m. For context, the JS % operator is remainder
 * NOT modulus, which is why this is needed.
 */
function mod(n, m) {
    if (n >= 0) {
        return Math.floor(n % m);
    }
    return Math.floor((n % m) + m);
}

function isPointInSector(x, y, sector) {
    var radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    var innerRadius = sector.innerRadius,
        outerRadius = sector.outerRadius;
    if (radius < Math.min(innerRadius, outerRadius) || radius > Math.max(innerRadius, outerRadius)) {
        return false;
    }
    // Start and End angles are expected to be [-90, 270]
    // while Math.atan2 returns [-180, 180]
    var angle = Math.atan2(y, x);
    if (angle < -Math.PI / 2) {
        angle += 2 * Math.PI;
    }
    // Start is actually bigger than End clock-wise
    var startAngle = sector.startAngle,
        endAngle = sector.endAngle;
    if (endAngle === -Math.PI / 2) {
        return angle < startAngle;
    }
    if (startAngle === (3 * Math.PI) / 2) {
        return angle > endAngle;
    }
    return angle <= endAngle && angle >= startAngle;
}
function lineCollidesSector(line, sector) {
    var startAngle = sector.startAngle,
        endAngle = sector.endAngle,
        innerRadius = sector.innerRadius,
        outerRadius = sector.outerRadius;
    var outerStart = { x: outerRadius * Math.cos(startAngle), y: outerRadius * Math.sin(startAngle) };
    var outerEnd = { x: outerRadius * Math.cos(endAngle), y: outerRadius * Math.sin(endAngle) };
    var innerStart =
        innerRadius === 0
            ? { x: 0, y: 0 }
            : { x: innerRadius * Math.cos(startAngle), y: innerRadius * Math.sin(startAngle) };
    var innerEnd =
        innerRadius === 0
            ? { x: 0, y: 0 }
            : { x: innerRadius * Math.cos(endAngle), y: innerRadius * Math.sin(endAngle) };
    return (
        segmentIntersection(
            line.start.x,
            line.start.y,
            line.end.x,
            line.end.y,
            outerStart.x,
            outerStart.y,
            innerStart.x,
            innerStart.y,
        ) != null ||
        segmentIntersection(
            line.start.x,
            line.start.y,
            line.end.x,
            line.end.y,
            outerEnd.x,
            outerEnd.y,
            innerEnd.x,
            innerEnd.y,
        ) != null ||
        arcIntersections(
            0,
            0,
            outerRadius,
            startAngle,
            endAngle,
            true,
            line.start.x,
            line.start.y,
            line.end.x,
            line.end.y,
        ).length > 0
    );
}
function boxCollidesSector(box, sector) {
    var topLeft = { x: box.x, y: box.y };
    var topRight = { x: box.x + box.width, y: box.y };
    var bottomLeft = { x: box.x, y: box.y + box.height };
    var bottomRight = { x: box.x + box.width, y: box.y + box.height };
    return (
        lineCollidesSector({ start: topLeft, end: topRight }, sector) ||
        lineCollidesSector({ start: bottomLeft, end: bottomRight }, sector)
    );
}

var __extends$2j =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1A =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Sector = /** @class */ (function (_super) {
    __extends$2j(Sector, _super);
    function Sector() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.centerX = 0;
        _this.centerY = 0;
        _this.innerRadius = 10;
        _this.outerRadius = 20;
        _this.startAngle = 0;
        _this.endAngle = Math.PI * 2;
        _this.angleOffset = 0;
        return _this;
    }
    Sector.prototype.computeBBox = function () {
        var radius = this.outerRadius;
        return new BBox(this.centerX - radius, this.centerY - radius, radius * 2, radius * 2);
    };
    Sector.prototype.updatePath = function () {
        var path = this.path;
        var angleOffset = this.angleOffset;
        var startAngle = this.startAngle + angleOffset;
        var endAngle = this.endAngle + angleOffset;
        var innerRadius = Math.min(this.innerRadius, this.outerRadius);
        var outerRadius = Math.max(this.innerRadius, this.outerRadius);
        var fullPie = isEqual(normalizeAngle360(this.startAngle), normalizeAngle360(this.endAngle));
        var centerX = this.centerX;
        var centerY = this.centerY;
        path.clear();
        if (fullPie) {
            path.arc(centerX, centerY, outerRadius, startAngle, endAngle);
            if (innerRadius > 0) {
                path.moveTo(centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle));
                path.arc(centerX, centerY, innerRadius, endAngle, startAngle, true);
            }
        } else {
            path.moveTo(centerX + innerRadius * Math.cos(startAngle), centerY + innerRadius * Math.sin(startAngle));
            path.arc(centerX, centerY, outerRadius, startAngle, endAngle);
            if (innerRadius > 0) {
                path.arc(centerX, centerY, innerRadius, endAngle, startAngle, true);
            } else {
                path.lineTo(centerX, centerY);
            }
        }
        path.closePath();
        this.dirtyPath = false;
    };
    Sector.prototype.isPointInPath = function (x, y) {
        var angleOffset = this.angleOffset;
        var startAngle = this.startAngle + angleOffset;
        var endAngle = this.endAngle + angleOffset;
        var innerRadius = Math.min(this.innerRadius, this.outerRadius);
        var outerRadius = Math.max(this.innerRadius, this.outerRadius);
        var point = this.transformPoint(x, y);
        return isPointInSector(point.x, point.y, {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
        });
    };
    Sector.className = 'Sector';
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'centerX', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'centerY', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'innerRadius', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'outerRadius', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'startAngle', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'endAngle', void 0);
    __decorate$1A([ScenePathChangeDetection()], Sector.prototype, 'angleOffset', void 0);
    return Sector;
})(Path);

var __extends$2i =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var PolarSeries = /** @class */ (function (_super) {
    __extends$2i(PolarSeries, _super);
    function PolarSeries(_a) {
        var _b, _c;
        var moduleCtx = _a.moduleCtx,
            _d = _a.useLabelLayer,
            useLabelLayer = _d === void 0 ? false : _d,
            _e = _a.pickModes,
            pickModes = _e === void 0 ? [SeriesNodePickMode.EXACT_SHAPE_MATCH] : _e;
        var _this =
            _super.call(this, {
                moduleCtx: moduleCtx,
                useLabelLayer: useLabelLayer,
                pickModes: pickModes,
                contentGroupVirtual: false,
                directionKeys:
                    ((_b = {}),
                    (_b[ChartAxisDirection.X] = ['angleKey']),
                    (_b[ChartAxisDirection.Y] = ['radiusKey']),
                    _b),
                directionNames:
                    ((_c = {}),
                    (_c[ChartAxisDirection.X] = ['angleName']),
                    (_c[ChartAxisDirection.Y] = ['radiusName']),
                    _c),
            }) || this;
        /**
         * The center of the polar series (for example, the center of a pie).
         * If the polar chart has multiple series, all of them will have their
         * center set to the same value as a result of the polar chart layout.
         * The center coordinates are not supposed to be set by the user.
         */
        _this.centerX = 0;
        _this.centerY = 0;
        /**
         * The maximum radius the series can use.
         * This value is set automatically as a result of the polar chart layout
         * and is not supposed to be set by the user.
         */
        _this.radius = 0;
        return _this;
    }
    PolarSeries.prototype.getLabelData = function () {
        return [];
    };
    PolarSeries.prototype.computeLabelsBBox = function (_options, _seriesRect) {
        return null;
    };
    return PolarSeries;
})(Series);

var __extends$2h =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$I =
    (undefined && undefined.__assign) ||
    function () {
        __assign$I =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$I.apply(this, arguments);
    };
var __decorate$1z =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$b =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$b =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$I =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$p =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var PieSeriesNodeBaseClickEvent = /** @class */ (function (_super) {
    __extends$2h(PieSeriesNodeBaseClickEvent, _super);
    function PieSeriesNodeBaseClickEvent(
        angleKey,
        calloutLabelKey,
        sectorLabelKey,
        radiusKey,
        nativeEvent,
        datum,
        series,
    ) {
        var _this = _super.call(this, nativeEvent, datum, series) || this;
        _this.angleKey = angleKey;
        _this.calloutLabelKey = calloutLabelKey;
        _this.sectorLabelKey = sectorLabelKey;
        _this.radiusKey = radiusKey;
        return _this;
    }
    return PieSeriesNodeBaseClickEvent;
})(SeriesNodeBaseClickEvent);
var PieSeriesNodeClickEvent = /** @class */ (function (_super) {
    __extends$2h(PieSeriesNodeClickEvent, _super);
    function PieSeriesNodeClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeClick';
        return _this;
    }
    return PieSeriesNodeClickEvent;
})(PieSeriesNodeBaseClickEvent);
var PieSeriesNodeDoubleClickEvent = /** @class */ (function (_super) {
    __extends$2h(PieSeriesNodeDoubleClickEvent, _super);
    function PieSeriesNodeDoubleClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeDoubleClick';
        return _this;
    }
    return PieSeriesNodeDoubleClickEvent;
})(PieSeriesNodeBaseClickEvent);
var PieNodeTag;
(function (PieNodeTag) {
    PieNodeTag[(PieNodeTag['Sector'] = 0)] = 'Sector';
    PieNodeTag[(PieNodeTag['Callout'] = 1)] = 'Callout';
    PieNodeTag[(PieNodeTag['Label'] = 2)] = 'Label';
})(PieNodeTag || (PieNodeTag = {}));
var PieSeriesCalloutLabel = /** @class */ (function (_super) {
    __extends$2h(PieSeriesCalloutLabel, _super);
    function PieSeriesCalloutLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.offset = 3; // from the callout line
        _this.minAngle = 0; // in degrees
        _this.formatter = undefined;
        _this.minSpacing = 4;
        _this.maxCollisionOffset = 50;
        _this.avoidCollisions = true;
        return _this;
    }
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLabel.prototype, 'offset', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLabel.prototype, 'minAngle', void 0);
    __decorate$1z([Validate(OPT_FUNCTION)], PieSeriesCalloutLabel.prototype, 'formatter', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLabel.prototype, 'minSpacing', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLabel.prototype, 'maxCollisionOffset', void 0);
    __decorate$1z([Validate(BOOLEAN)], PieSeriesCalloutLabel.prototype, 'avoidCollisions', void 0);
    return PieSeriesCalloutLabel;
})(Label$1);
var PieSeriesSectorLabel = /** @class */ (function (_super) {
    __extends$2h(PieSeriesSectorLabel, _super);
    function PieSeriesSectorLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.positionOffset = 0;
        _this.positionRatio = 0.5;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1z([Validate(NUMBER())], PieSeriesSectorLabel.prototype, 'positionOffset', void 0);
    __decorate$1z([Validate(NUMBER(0, 1))], PieSeriesSectorLabel.prototype, 'positionRatio', void 0);
    __decorate$1z([Validate(OPT_FUNCTION)], PieSeriesSectorLabel.prototype, 'formatter', void 0);
    return PieSeriesSectorLabel;
})(Label$1);
var PieSeriesCalloutLine = /** @class */ (function () {
    function PieSeriesCalloutLine() {
        this.colors = undefined;
        this.length = 10;
        this.strokeWidth = 1;
    }
    __decorate$1z([Validate(OPT_COLOR_STRING_ARRAY)], PieSeriesCalloutLine.prototype, 'colors', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLine.prototype, 'length', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeriesCalloutLine.prototype, 'strokeWidth', void 0);
    return PieSeriesCalloutLine;
})();
var PieSeriesTooltip = /** @class */ (function (_super) {
    __extends$2h(PieSeriesTooltip, _super);
    function PieSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        return _this;
    }
    __decorate$1z([Validate(OPT_FUNCTION)], PieSeriesTooltip.prototype, 'renderer', void 0);
    return PieSeriesTooltip;
})(SeriesTooltip);
var PieTitle = /** @class */ (function (_super) {
    __extends$2h(PieTitle, _super);
    function PieTitle() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.showInLegend = false;
        return _this;
    }
    __decorate$1z([Validate(BOOLEAN)], PieTitle.prototype, 'showInLegend', void 0);
    return PieTitle;
})(Caption);
var DoughnutInnerLabel = /** @class */ (function (_super) {
    __extends$2h(DoughnutInnerLabel, _super);
    function DoughnutInnerLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.text = '';
        _this.margin = 2;
        return _this;
    }
    __decorate$1z([Validate(STRING)], DoughnutInnerLabel.prototype, 'text', void 0);
    __decorate$1z([Validate(NUMBER())], DoughnutInnerLabel.prototype, 'margin', void 0);
    return DoughnutInnerLabel;
})(Label$1);
var DoughnutInnerCircle = /** @class */ (function () {
    function DoughnutInnerCircle() {
        this.fill = 'transparent';
        this.fillOpacity = 1;
    }
    __decorate$1z([Validate(COLOR_STRING)], DoughnutInnerCircle.prototype, 'fill', void 0);
    __decorate$1z([Validate(OPT_NUMBER(0, 1))], DoughnutInnerCircle.prototype, 'fillOpacity', void 0);
    return DoughnutInnerCircle;
})();
var PieStateMachine = /** @class */ (function (_super) {
    __extends$2h(PieStateMachine, _super);
    function PieStateMachine() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    return PieStateMachine;
})(StateMachine);
var PieSeries = /** @class */ (function (_super) {
    __extends$2h(PieSeries, _super);
    function PieSeries(moduleCtx) {
        var _a, _b, _c;
        var _this = _super.call(this, { moduleCtx: moduleCtx, useLabelLayer: true }) || this;
        _this.radiusScale = new LinearScale$1();
        _this.groupSelection = Selection.select(_this.contentGroup, Group);
        _this.highlightSelection = Selection.select(_this.highlightGroup, Group);
        _this.nodeData = [];
        // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
        _this.seriesItemEnabled = [];
        _this.title = undefined;
        _this.calloutLabel = new PieSeriesCalloutLabel();
        _this.sectorLabel = new PieSeriesSectorLabel();
        _this.calloutLine = new PieSeriesCalloutLine();
        _this.tooltip = new PieSeriesTooltip();
        /**
         * The key of the numeric field to use to determine the angle (for example,
         * a pie sector angle).
         */
        _this.angleKey = '';
        _this.angleName = '';
        _this.innerLabels = [];
        _this.innerCircle = undefined;
        /**
         * The key of the numeric field to use to determine the radii of pie sectors.
         * The largest value will correspond to the full radius and smaller values to
         * proportionally smaller radii.
         */
        _this.radiusKey = undefined;
        _this.radiusName = undefined;
        _this.radiusMin = undefined;
        _this.radiusMax = undefined;
        _this.calloutLabelKey = undefined;
        _this.calloutLabelName = undefined;
        _this.sectorLabelKey = undefined;
        _this.sectorLabelName = undefined;
        _this.legendItemKey = undefined;
        _this.fills = ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'];
        _this.strokes = ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'];
        _this.fillOpacity = 1;
        _this.strokeOpacity = 1;
        _this.lineDash = [0];
        _this.lineDashOffset = 0;
        _this.formatter = undefined;
        /**
         * The series rotation in degrees.
         */
        _this.rotation = 0;
        _this.outerRadiusOffset = 0;
        _this.outerRadiusRatio = 1;
        _this.innerRadiusOffset = 0;
        _this.innerRadiusRatio = 1;
        _this.strokeWidth = 1;
        _this.shadow = undefined;
        _this.highlightStyle = new HighlightStyle();
        _this.surroundingRadius = undefined;
        _this.angleScale = new LinearScale$1();
        // Each sector is a ratio of the whole, where all ratios add up to 1.
        _this.angleScale.domain = [0, 1];
        // Add 90 deg to start the first pie at 12 o'clock.
        _this.angleScale.range = [-Math.PI, Math.PI].map(function (angle) {
            return angle + Math.PI / 2;
        });
        _this.backgroundGroup = _this.rootGroup.appendChild(
            new Group({
                name: _this.id + '-background',
                layer: true,
                zIndex: Layers.SERIES_BACKGROUND_ZINDEX,
            }),
        );
        var pieCalloutLabels = new Group({ name: 'pieCalloutLabels' });
        var pieSectorLabels = new Group({ name: 'pieSectorLabels' });
        var innerLabels = new Group({ name: 'innerLabels' });
        (_a = _this.labelGroup) === null || _a === void 0 ? void 0 : _a.append(pieCalloutLabels);
        (_b = _this.labelGroup) === null || _b === void 0 ? void 0 : _b.append(pieSectorLabels);
        (_c = _this.labelGroup) === null || _c === void 0 ? void 0 : _c.append(innerLabels);
        _this.calloutLabelSelection = Selection.select(pieCalloutLabels, Group);
        _this.sectorLabelSelection = Selection.select(pieSectorLabels, Text);
        _this.innerLabelsSelection = Selection.select(innerLabels, Text);
        _this.animationState = new PieStateMachine('empty', {
            empty: {
                on: {
                    update: {
                        target: 'ready',
                        action: function () {
                            return _this.animateEmptyUpdateReady();
                        },
                    },
                },
            },
            ready: {
                on: {
                    update: {
                        target: 'ready',
                        action: function () {
                            return _this.animateReadyUpdateReady();
                        },
                    },
                },
            },
        });
        return _this;
    }
    Object.defineProperty(PieSeries.prototype, 'data', {
        get: function () {
            return this._data;
        },
        set: function (input) {
            this._data = input;
            this.processSeriesItemEnabled();
        },
        enumerable: false,
        configurable: true,
    });
    PieSeries.prototype.addChartEventListeners = function () {
        var _this = this;
        var _a;
        (_a = this.ctx.chartEventManager) === null || _a === void 0
            ? void 0
            : _a.addListener('legend-item-click', function (event) {
                  return _this.onLegendItemClick(event);
              });
    };
    PieSeries.prototype.visibleChanged = function () {
        this.processSeriesItemEnabled();
    };
    PieSeries.prototype.processSeriesItemEnabled = function () {
        var _a;
        var _b = this,
            data = _b.data,
            visible = _b.visible;
        this.seriesItemEnabled =
            (_a =
                data === null || data === void 0
                    ? void 0
                    : data.map(function () {
                          return visible;
                      })) !== null && _a !== void 0
                ? _a
                : [];
    };
    PieSeries.prototype.getDomain = function (direction) {
        if (direction === ChartAxisDirection.X) {
            return this.angleScale.domain;
        } else {
            return this.radiusScale.domain;
        }
    };
    PieSeries.prototype.processData = function (dataController) {
        var _a, _b;
        return __awaiter$b(this, void 0, void 0, function () {
            var _c,
                data,
                _d,
                angleKey,
                radiusKey,
                calloutLabelKey,
                sectorLabelKey,
                legendItemKey,
                seriesItemEnabled,
                extraProps,
                _e,
                dataModel,
                processedData;
            return __generator$b(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        (_c = this.data), (data = _c === void 0 ? [] : _c);
                        (_d = this),
                            (angleKey = _d.angleKey),
                            (radiusKey = _d.radiusKey),
                            (calloutLabelKey = _d.calloutLabelKey),
                            (sectorLabelKey = _d.sectorLabelKey),
                            (legendItemKey = _d.legendItemKey),
                            (seriesItemEnabled = _d.seriesItemEnabled);
                        if (!angleKey) return [2 /*return*/];
                        extraProps = [];
                        if (radiusKey) {
                            extraProps.push(
                                rangedValueProperty(this, radiusKey, {
                                    id: 'radiusValue',
                                    min: (_a = this.radiusMin) !== null && _a !== void 0 ? _a : 0,
                                    max: this.radiusMax,
                                }),
                                valueProperty(this, radiusKey, true, { id: 'radiusRaw' }), // Raw value pass-through.
                                normalisePropertyTo(
                                    this,
                                    { id: 'radiusValue' },
                                    [0, 1],
                                    (_b = this.radiusMin) !== null && _b !== void 0 ? _b : 0,
                                    this.radiusMax,
                                ),
                            );
                            extraProps.push();
                        }
                        if (calloutLabelKey) {
                            extraProps.push(valueProperty(this, calloutLabelKey, false, { id: 'calloutLabelValue' }));
                        }
                        if (sectorLabelKey) {
                            extraProps.push(valueProperty(this, sectorLabelKey, false, { id: 'sectorLabelValue' }));
                        }
                        if (legendItemKey) {
                            extraProps.push(valueProperty(this, legendItemKey, false, { id: 'legendItemValue' }));
                        }
                        data = data.map(function (d, idx) {
                            var _a;
                            return seriesItemEnabled[idx]
                                ? d
                                : __assign$I(__assign$I({}, d), ((_a = {}), (_a[angleKey] = 0), _a));
                        });
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data, {
                                props: __spreadArray$p(
                                    [
                                        accumulativeValueProperty(this, angleKey, true, { id: 'angleValue' }),
                                        valueProperty(this, angleKey, true, { id: 'angleRaw' }),
                                        normalisePropertyTo(this, { id: 'angleValue' }, [0, 1], 0),
                                    ],
                                    __read$I(extraProps),
                                ),
                            }),
                        ];
                    case 1:
                        (_e = _f.sent()), (dataModel = _e.dataModel), (processedData = _e.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        return [2 /*return*/];
                }
            });
        });
    };
    PieSeries.prototype.maybeRefreshNodeData = function () {
        if (!this.nodeDataRefresh) return;
        var _a = __read$I(this._createNodeData(), 1),
            _b = _a[0],
            _c = _b === void 0 ? {} : _b,
            _d = _c.nodeData,
            nodeData = _d === void 0 ? [] : _d;
        this.nodeData = nodeData;
        this.nodeDataRefresh = false;
    };
    PieSeries.prototype.createNodeData = function () {
        return __awaiter$b(this, void 0, void 0, function () {
            return __generator$b(this, function (_a) {
                return [2 /*return*/, this._createNodeData()];
            });
        });
    };
    PieSeries.prototype.getProcessedDataIndexes = function (dataModel) {
        var angleIdx = dataModel.resolveProcessedDataIndexById(this, 'angleValue').index;
        var radiusIdx = this.radiusKey ? dataModel.resolveProcessedDataIndexById(this, 'radiusValue').index : -1;
        var calloutLabelIdx = this.calloutLabelKey
            ? dataModel.resolveProcessedDataIndexById(this, 'calloutLabelValue').index
            : -1;
        var sectorLabelIdx = this.sectorLabelKey
            ? dataModel.resolveProcessedDataIndexById(this, 'sectorLabelValue').index
            : -1;
        var legendItemIdx = this.legendItemKey
            ? dataModel.resolveProcessedDataIndexById(this, 'legendItemValue').index
            : -1;
        return {
            angleIdx: angleIdx,
            radiusIdx: radiusIdx,
            calloutLabelIdx: calloutLabelIdx,
            sectorLabelIdx: sectorLabelIdx,
            legendItemIdx: legendItemIdx,
        };
    };
    PieSeries.prototype._createNodeData = function () {
        var _this = this;
        var _a = this,
            seriesId = _a.id,
            processedData = _a.processedData,
            dataModel = _a.dataModel,
            rotation = _a.rotation,
            angleScale = _a.angleScale;
        if (!processedData || !dataModel || processedData.type !== 'ungrouped') return [];
        var _b = this.getProcessedDataIndexes(dataModel),
            angleIdx = _b.angleIdx,
            radiusIdx = _b.radiusIdx,
            calloutLabelIdx = _b.calloutLabelIdx,
            sectorLabelIdx = _b.sectorLabelIdx,
            legendItemIdx = _b.legendItemIdx;
        var currentStart = 0;
        var nodeData = processedData.data.map(function (group, index) {
            var _a;
            var datum = group.datum,
                values = group.values;
            var currentValue = values[angleIdx];
            var startAngle = angleScale.convert(currentStart) + toRadians$1(rotation);
            currentStart = currentValue;
            var endAngle = angleScale.convert(currentStart) + toRadians$1(rotation);
            var span = Math.abs(endAngle - startAngle);
            var midAngle = startAngle + span / 2;
            var angleValue = values[angleIdx + 1];
            var radius = radiusIdx >= 0 ? ((_a = values[radiusIdx]) !== null && _a !== void 0 ? _a : 1) : 1;
            var radiusValue = radiusIdx >= 0 ? values[radiusIdx + 1] : undefined;
            var legendItemValue = legendItemIdx >= 0 ? values[legendItemIdx] : undefined;
            var labels = _this.getLabels(
                datum,
                midAngle,
                span,
                true,
                currentValue,
                radiusValue,
                values[calloutLabelIdx],
                values[sectorLabelIdx],
                legendItemValue,
            );
            var sectorFormat = _this.getSectorFormat(datum, index, index, false);
            return __assign$I(
                {
                    itemId: index,
                    series: _this,
                    datum: datum,
                    index: index,
                    angleValue: angleValue,
                    midAngle: midAngle,
                    midCos: Math.cos(midAngle),
                    midSin: Math.sin(midAngle),
                    startAngle: startAngle,
                    endAngle: endAngle,
                    sectorFormat: sectorFormat,
                    radius: radius,
                    radiusValue: radiusValue,
                    legendItemValue: legendItemValue,
                },
                labels,
            );
        });
        return [
            {
                itemId: seriesId,
                nodeData: nodeData,
                labelData: nodeData,
            },
        ];
    };
    PieSeries.prototype.getLabels = function (
        datum,
        midAngle,
        span,
        skipDisabled,
        angleValue,
        radiusValue,
        calloutLabelValue,
        sectorLabelValue,
        legendItemValue,
    ) {
        var _a = this,
            calloutLabel = _a.calloutLabel,
            sectorLabel = _a.sectorLabel,
            legendItemKey = _a.legendItemKey,
            callbackCache = _a.ctx.callbackCache;
        var calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.calloutLabelKey : undefined;
        var sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.sectorLabelKey : undefined;
        if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) return {};
        var labelFormatterParams = this.getLabelFormatterParams(
            datum,
            angleValue,
            radiusValue,
            calloutLabelValue,
            sectorLabelValue,
        );
        var calloutLabelText;
        if (calloutLabelKey) {
            var calloutLabelMinAngle = toRadians$1(calloutLabel.minAngle);
            var calloutLabelVisible = span > calloutLabelMinAngle;
            if (!calloutLabelVisible) {
                calloutLabelText = undefined;
            } else if (calloutLabel.formatter) {
                calloutLabelText = callbackCache.call(calloutLabel.formatter, labelFormatterParams);
            } else {
                calloutLabelText = String(calloutLabelValue);
            }
        }
        var sectorLabelText;
        if (sectorLabelKey) {
            if (sectorLabel.formatter) {
                sectorLabelText = callbackCache.call(sectorLabel.formatter, labelFormatterParams);
            } else {
                sectorLabelText = String(sectorLabelValue);
            }
        }
        return __assign$I(
            __assign$I(
                __assign$I(
                    {},
                    calloutLabelText != null
                        ? {
                              calloutLabel: __assign$I(__assign$I({}, this.getTextAlignment(midAngle)), {
                                  text: calloutLabelText,
                                  hidden: false,
                                  collisionTextAlign: undefined,
                                  collisionOffsetY: 0,
                                  box: undefined,
                              }),
                          }
                        : {},
                ),
                sectorLabelText != null ? { sectorLabel: { text: sectorLabelText } } : {},
            ),
            legendItemKey != null && legendItemValue != null
                ? { legendItem: { key: legendItemKey, text: legendItemValue } }
                : {},
        );
    };
    PieSeries.prototype.getLabelFormatterParams = function (
        datum,
        angleValue,
        radiusValue,
        calloutLabelValue,
        sectorLabelValue,
    ) {
        var _a = this,
            seriesId = _a.id,
            radiusKey = _a.radiusKey,
            radiusName = _a.radiusName,
            angleKey = _a.angleKey,
            angleName = _a.angleName,
            calloutLabelKey = _a.calloutLabelKey,
            calloutLabelName = _a.calloutLabelName,
            sectorLabelKey = _a.sectorLabelKey,
            sectorLabelName = _a.sectorLabelName;
        return {
            datum: datum,
            angleKey: angleKey,
            angleValue: angleValue,
            angleName: angleName,
            radiusKey: radiusKey,
            radiusValue: radiusValue,
            radiusName: radiusName,
            calloutLabelKey: calloutLabelKey,
            calloutLabelValue: calloutLabelValue,
            calloutLabelName: calloutLabelName,
            sectorLabelKey: sectorLabelKey,
            sectorLabelValue: sectorLabelValue,
            sectorLabelName: sectorLabelName,
            seriesId: seriesId,
        };
    };
    PieSeries.prototype.getTextAlignment = function (midAngle) {
        var quadrantTextOpts = [
            { textAlign: 'center', textBaseline: 'bottom' },
            { textAlign: 'left', textBaseline: 'middle' },
            { textAlign: 'center', textBaseline: 'hanging' },
            { textAlign: 'right', textBaseline: 'middle' },
        ];
        var midAngle180 = normalizeAngle180(midAngle);
        // Split the circle into quadrants like so: ⊗
        var quadrantStart = (-3 * Math.PI) / 4; // same as `normalizeAngle180(toRadians(-135))`
        var quadrantOffset = midAngle180 - quadrantStart;
        var quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
        var quadrantIndex = mod(quadrant, quadrantTextOpts.length);
        return quadrantTextOpts[quadrantIndex];
    };
    PieSeries.prototype.getSectorFormat = function (datum, itemId, index, highlight) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this,
            angleKey = _j.angleKey,
            radiusKey = _j.radiusKey,
            fills = _j.fills,
            strokes = _j.strokes,
            seriesFillOpacity = _j.fillOpacity,
            formatter = _j.formatter,
            seriesId = _j.id,
            _k = _j.ctx,
            callbackCache = _k.callbackCache,
            highlightManager = _k.highlightManager;
        var highlightedDatum =
            highlightManager === null || highlightManager === void 0 ? void 0 : highlightManager.getActiveHighlight();
        var isDatumHighlighted =
            highlight &&
            (highlightedDatum === null || highlightedDatum === void 0 ? void 0 : highlightedDatum.series) === this &&
            itemId === highlightedDatum.itemId;
        var highlightedStyle = isDatumHighlighted ? this.highlightStyle.item : null;
        var fill =
            (_a = highlightedStyle === null || highlightedStyle === void 0 ? void 0 : highlightedStyle.fill) !== null &&
            _a !== void 0
                ? _a
                : fills[index % fills.length];
        var fillOpacity =
            (_b = highlightedStyle === null || highlightedStyle === void 0 ? void 0 : highlightedStyle.fillOpacity) !==
                null && _b !== void 0
                ? _b
                : seriesFillOpacity;
        var stroke =
            (_c = highlightedStyle === null || highlightedStyle === void 0 ? void 0 : highlightedStyle.stroke) !==
                null && _c !== void 0
                ? _c
                : strokes[index % strokes.length];
        var strokeWidth =
            (_d = highlightedStyle === null || highlightedStyle === void 0 ? void 0 : highlightedStyle.strokeWidth) !==
                null && _d !== void 0
                ? _d
                : this.getStrokeWidth(this.strokeWidth);
        var format;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: datum,
                angleKey: angleKey,
                radiusKey: radiusKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                highlighted: isDatumHighlighted,
                seriesId: seriesId,
            });
        }
        return {
            fill:
                (_e = format === null || format === void 0 ? void 0 : format.fill) !== null && _e !== void 0
                    ? _e
                    : fill,
            fillOpacity:
                (_f = format === null || format === void 0 ? void 0 : format.fillOpacity) !== null && _f !== void 0
                    ? _f
                    : fillOpacity,
            stroke:
                (_g = format === null || format === void 0 ? void 0 : format.stroke) !== null && _g !== void 0
                    ? _g
                    : stroke,
            strokeWidth:
                (_h = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null && _h !== void 0
                    ? _h
                    : strokeWidth,
        };
    };
    PieSeries.prototype.getInnerRadius = function () {
        var _a = this,
            radius = _a.radius,
            innerRadiusRatio = _a.innerRadiusRatio,
            innerRadiusOffset = _a.innerRadiusOffset;
        var innerRadius =
            radius * (innerRadiusRatio !== null && innerRadiusRatio !== void 0 ? innerRadiusRatio : 1) +
            (innerRadiusOffset ? innerRadiusOffset : 0);
        if (innerRadius === radius || innerRadius < 0) {
            return 0;
        }
        return innerRadius;
    };
    PieSeries.prototype.getOuterRadius = function () {
        var _a = this,
            radius = _a.radius,
            outerRadiusRatio = _a.outerRadiusRatio,
            outerRadiusOffset = _a.outerRadiusOffset;
        var outerRadius =
            radius * (outerRadiusRatio !== null && outerRadiusRatio !== void 0 ? outerRadiusRatio : 1) +
            (outerRadiusOffset ? outerRadiusOffset : 0);
        if (outerRadius < 0) {
            return 0;
        }
        return outerRadius;
    };
    PieSeries.prototype.updateRadiusScale = function () {
        var innerRadius = this.getInnerRadius();
        var outerRadius = this.getOuterRadius();
        this.radiusScale.range = [innerRadius, outerRadius];
    };
    PieSeries.prototype.getTitleTranslationY = function () {
        var _a, _b;
        var outerRadius = Math.max(0, this.radiusScale.range[1]);
        if (outerRadius === 0) {
            return NaN;
        }
        var spacing =
            (_b = (_a = this.title) === null || _a === void 0 ? void 0 : _a.spacing) !== null && _b !== void 0 ? _b : 0;
        var titleOffset = 2 + spacing;
        var dy = Math.max(0, -outerRadius);
        return -outerRadius - titleOffset - dy;
    };
    PieSeries.prototype.update = function (_a) {
        var seriesRect = _a.seriesRect;
        return __awaiter$b(this, void 0, void 0, function () {
            var title, dy, titleBox;
            return __generator$b(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        title = this.title;
                        this.maybeRefreshNodeData();
                        this.updateTitleNodes();
                        this.updateRadiusScale();
                        this.updateInnerCircleNodes();
                        this.contentGroup.translationX = this.centerX;
                        this.contentGroup.translationY = this.centerY;
                        this.highlightGroup.translationX = this.centerX;
                        this.highlightGroup.translationY = this.centerY;
                        this.backgroundGroup.translationX = this.centerX;
                        this.backgroundGroup.translationY = this.centerY;
                        if (this.labelGroup) {
                            this.labelGroup.translationX = this.centerX;
                            this.labelGroup.translationY = this.centerY;
                        }
                        if (title) {
                            dy = this.getTitleTranslationY();
                            titleBox = title.node.computeBBox();
                            title.node.visible =
                                title.enabled && isFinite(dy) && !this.bboxIntersectsSurroundingSeries(titleBox, 0, dy);
                            title.node.translationY = isFinite(dy) ? dy : 0;
                        }
                        this.updateNodeMidPoint();
                        return [4 /*yield*/, this.updateSelections()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, this.updateNodes(seriesRect)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PieSeries.prototype.updateTitleNodes = function () {
        var _a, _b;
        var _c = this,
            title = _c.title,
            oldTitle = _c.oldTitle;
        if (oldTitle !== title) {
            if (oldTitle) {
                (_a = this.labelGroup) === null || _a === void 0 ? void 0 : _a.removeChild(oldTitle.node);
            }
            if (title) {
                title.node.textBaseline = 'bottom';
                (_b = this.labelGroup) === null || _b === void 0 ? void 0 : _b.appendChild(title.node);
            }
            this.oldTitle = title;
        }
    };
    PieSeries.prototype.updateInnerCircleNodes = function () {
        var _a;
        var _b = this,
            innerCircle = _b.innerCircle,
            oldInnerCircle = _b.oldInnerCircle,
            oldNode = _b.innerCircleNode;
        if (oldInnerCircle !== innerCircle) {
            var circle = void 0;
            if (oldNode) {
                this.backgroundGroup.removeChild(oldNode);
            }
            if (innerCircle) {
                circle = new Circle();
                circle.fill = innerCircle.fill;
                circle.fillOpacity = (_a = innerCircle.fillOpacity) !== null && _a !== void 0 ? _a : 1;
                this.backgroundGroup.appendChild(circle);
            }
            this.oldInnerCircle = innerCircle;
            this.innerCircleNode = circle;
        }
    };
    PieSeries.prototype.updateNodeMidPoint = function () {
        var _this = this;
        this.nodeData.forEach(function (d) {
            var radius = _this.radiusScale.convert(d.radius);
            d.nodeMidPoint = {
                x: d.midCos * Math.max(0, radius / 2),
                y: d.midSin * Math.max(0, radius / 2),
            };
        });
    };
    PieSeries.prototype.updateSelections = function () {
        return __awaiter$b(this, void 0, void 0, function () {
            return __generator$b(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.updateGroupSelection()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    PieSeries.prototype.updateGroupSelection = function () {
        return __awaiter$b(this, void 0, void 0, function () {
            var _a,
                groupSelection,
                highlightSelection,
                calloutLabelSelection,
                sectorLabelSelection,
                innerLabelsSelection,
                update;
            var _this = this;
            return __generator$b(this, function (_b) {
                (_a = this),
                    (groupSelection = _a.groupSelection),
                    (highlightSelection = _a.highlightSelection),
                    (calloutLabelSelection = _a.calloutLabelSelection),
                    (sectorLabelSelection = _a.sectorLabelSelection),
                    (innerLabelsSelection = _a.innerLabelsSelection);
                update = function (selection) {
                    return selection.update(_this.nodeData, function (group) {
                        var sector = new Sector();
                        sector.tag = PieNodeTag.Sector;
                        group.appendChild(sector);
                    });
                };
                this.groupSelection = update(groupSelection);
                this.highlightSelection = update(highlightSelection);
                calloutLabelSelection.update(this.nodeData, function (group) {
                    var line = new Line();
                    line.tag = PieNodeTag.Callout;
                    line.pointerEvents = PointerEvents.None;
                    group.appendChild(line);
                    var text = new Text();
                    text.tag = PieNodeTag.Label;
                    text.pointerEvents = PointerEvents.None;
                    group.appendChild(text);
                });
                sectorLabelSelection.update(this.nodeData, function (node) {
                    node.pointerEvents = PointerEvents.None;
                });
                innerLabelsSelection.update(this.innerLabels, function (node) {
                    node.pointerEvents = PointerEvents.None;
                });
                return [2 /*return*/];
            });
        });
    };
    PieSeries.prototype.updateNodes = function (seriesRect) {
        var _a;
        return __awaiter$b(this, void 0, void 0, function () {
            var highlightedDatum, isVisible, radiusScale, innerRadius, updateSectorFn;
            var _this = this;
            return __generator$b(this, function (_b) {
                highlightedDatum =
                    (_a = this.ctx.highlightManager) === null || _a === void 0 ? void 0 : _a.getActiveHighlight();
                isVisible = this.seriesItemEnabled.indexOf(true) >= 0;
                this.rootGroup.visible = isVisible;
                this.backgroundGroup.visible = isVisible;
                this.contentGroup.visible = isVisible;
                this.highlightGroup.visible =
                    isVisible &&
                    (highlightedDatum === null || highlightedDatum === void 0 ? void 0 : highlightedDatum.series) ===
                        this;
                if (this.labelGroup) {
                    this.labelGroup.visible = isVisible;
                }
                this.contentGroup.opacity = this.getOpacity();
                this.updateInnerCircle();
                radiusScale = this.radiusScale;
                innerRadius = radiusScale.convert(0);
                updateSectorFn = function (sector, datum, index, isDatumHighlighted) {
                    var radius = radiusScale.convert(datum.radius);
                    // Bring highlighted sector's parent group to front.
                    var sectorParent = sector.parent;
                    var sectorGrandParent =
                        sectorParent === null || sectorParent === void 0 ? void 0 : sectorParent.parent;
                    if (isDatumHighlighted && sectorParent && sectorGrandParent) {
                        sectorGrandParent.removeChild(sectorParent);
                        sectorGrandParent.appendChild(sectorParent);
                    }
                    sector.innerRadius = Math.max(0, innerRadius);
                    sector.outerRadius = Math.max(0, radius);
                    if (isDatumHighlighted) {
                        sector.startAngle = datum.startAngle;
                        sector.endAngle = datum.endAngle;
                    }
                    var format = _this.getSectorFormat(datum.datum, datum.itemId, index, isDatumHighlighted);
                    sector.fill = format.fill;
                    sector.stroke = format.stroke;
                    sector.strokeWidth = format.strokeWidth;
                    sector.fillOpacity = format.fillOpacity;
                    sector.strokeOpacity = _this.strokeOpacity;
                    sector.lineDash = _this.lineDash;
                    sector.lineDashOffset = _this.lineDashOffset;
                    sector.fillShadow = _this.shadow;
                    sector.lineJoin = 'round';
                    sector.visible = _this.seriesItemEnabled[index];
                };
                this.groupSelection.selectByTag(PieNodeTag.Sector).forEach(function (node, index) {
                    return updateSectorFn(node, node.datum, index, false);
                });
                this.highlightSelection.selectByTag(PieNodeTag.Sector).forEach(function (node, index) {
                    var isDatumHighlighted =
                        (highlightedDatum === null || highlightedDatum === void 0
                            ? void 0
                            : highlightedDatum.series) === _this && node.datum.itemId === highlightedDatum.itemId;
                    if (isDatumHighlighted) {
                        updateSectorFn(node, node.datum, index, isDatumHighlighted);
                    } else {
                        node.visible = false;
                    }
                });
                this.animationState.transition('update');
                this.updateCalloutLineNodes();
                this.updateCalloutLabelNodes(seriesRect);
                this.updateSectorLabelNodes();
                this.updateInnerLabelNodes();
                return [2 /*return*/];
            });
        });
    };
    PieSeries.prototype.updateCalloutLineNodes = function () {
        var _a;
        var _b = this,
            radiusScale = _b.radiusScale,
            calloutLine = _b.calloutLine;
        var calloutLength = calloutLine.length;
        var calloutStrokeWidth = calloutLine.strokeWidth;
        var calloutColors = (_a = calloutLine.colors) !== null && _a !== void 0 ? _a : this.strokes;
        var offset = this.calloutLabel.offset;
        this.calloutLabelSelection.selectByTag(PieNodeTag.Callout).forEach(function (line, index) {
            var datum = line.datum;
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            var label = datum.calloutLabel;
            if ((label === null || label === void 0 ? void 0 : label.text) && !label.hidden && outerRadius !== 0) {
                line.visible = true;
                line.strokeWidth = calloutStrokeWidth;
                line.stroke = calloutColors[index % calloutColors.length];
                line.fill = undefined;
                var x1 = datum.midCos * outerRadius;
                var y1 = datum.midSin * outerRadius;
                var x2 = datum.midCos * (outerRadius + calloutLength);
                var y2 = datum.midSin * (outerRadius + calloutLength);
                var isMoved = label.collisionTextAlign || label.collisionOffsetY !== 0;
                if (isMoved && label.box != null) {
                    // Get the closest point to the text bounding box
                    var box = label.box;
                    var cx = x2;
                    var cy = y2;
                    if (x2 < box.x) {
                        cx = box.x;
                    } else if (x2 > box.x + box.width) {
                        cx = box.x + box.width;
                    }
                    if (y2 < box.y) {
                        cy = box.y;
                    } else if (y2 > box.y + box.height) {
                        cy = box.y + box.height;
                    }
                    // Apply label offset
                    var dx = cx - x2;
                    var dy = cy - y2;
                    var length_1 = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    var paddedLength = length_1 - offset;
                    if (paddedLength > 0) {
                        x2 = x2 + (dx * paddedLength) / length_1;
                        y2 = y2 + (dy * paddedLength) / length_1;
                    }
                }
                line.x1 = x1;
                line.y1 = y1;
                line.x2 = x2;
                line.y2 = y2;
            } else {
                line.visible = false;
            }
        });
    };
    PieSeries.prototype.getLabelOverflow = function (text, box, seriesRect) {
        var seriesLeft = seriesRect.x - this.centerX;
        var seriesRight = seriesRect.x + seriesRect.width - this.centerX;
        var seriesTop = seriesRect.y - this.centerY;
        var seriesBottom = seriesRect.y + seriesRect.height - this.centerY;
        var errPx = 1; // Prevents errors related to floating point calculations
        var visibleTextPart = 1;
        if (box.x + errPx < seriesLeft) {
            visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
        } else if (box.x + box.width - errPx > seriesRight) {
            visibleTextPart = (seriesRight - box.x) / box.width;
        }
        var hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
        var textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
        var hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
        return {
            textLength: textLength,
            hasVerticalOverflow: hasVerticalOverflow,
            hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow,
        };
    };
    PieSeries.prototype.bboxIntersectsSurroundingSeries = function (box, dx, dy) {
        if (dx === void 0) {
            dx = 0;
        }
        if (dy === void 0) {
            dy = 0;
        }
        var surroundingRadius = this.surroundingRadius;
        if (surroundingRadius == null) {
            return false;
        }
        var corners = [
            { x: box.x + dx, y: box.y + dy },
            { x: box.x + box.width + dx, y: box.y + dy },
            { x: box.x + box.width + dx, y: box.y + box.height + dy },
            { x: box.x + dx, y: box.y + box.height + dy },
        ];
        var sur2 = Math.pow(surroundingRadius, 2);
        return corners.some(function (corner) {
            return Math.pow(corner.x, 2) + Math.pow(corner.y, 2) > sur2;
        });
    };
    PieSeries.prototype.computeCalloutLabelCollisionOffsets = function () {
        var _this = this;
        var _a = this,
            radiusScale = _a.radiusScale,
            calloutLabel = _a.calloutLabel,
            calloutLine = _a.calloutLine;
        var offset = calloutLabel.offset,
            minSpacing = calloutLabel.minSpacing;
        var innerRadius = radiusScale.convert(0);
        var shouldSkip = function (datum) {
            var label = datum.calloutLabel;
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            return !label || outerRadius === 0;
        };
        var fullData = this.nodeData;
        var data = this.nodeData.filter(function (t) {
            return !shouldSkip(t);
        });
        data.forEach(function (datum) {
            var label = datum.calloutLabel;
            if (label == null) return;
            label.hidden = false;
            label.collisionTextAlign = undefined;
            label.collisionOffsetY = 0;
        });
        if (data.length <= 1) {
            return;
        }
        var leftLabels = data
            .filter(function (d) {
                return d.midCos < 0;
            })
            .sort(function (a, b) {
                return a.midSin - b.midSin;
            });
        var rightLabels = data
            .filter(function (d) {
                return d.midCos >= 0;
            })
            .sort(function (a, b) {
                return a.midSin - b.midSin;
            });
        var topLabels = data
            .filter(function (d) {
                var _a;
                return (
                    d.midSin < 0 &&
                    ((_a = d.calloutLabel) === null || _a === void 0 ? void 0 : _a.textAlign) === 'center'
                );
            })
            .sort(function (a, b) {
                return a.midCos - b.midCos;
            });
        var bottomLabels = data
            .filter(function (d) {
                var _a;
                return (
                    d.midSin >= 0 &&
                    ((_a = d.calloutLabel) === null || _a === void 0 ? void 0 : _a.textAlign) === 'center'
                );
            })
            .sort(function (a, b) {
                return a.midCos - b.midCos;
            });
        var tempTextNode = new Text();
        var getTextBBox = function (datum) {
            var _a;
            var label = datum.calloutLabel;
            if (label == null) return new BBox(0, 0, 0, 0);
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            var labelRadius = outerRadius + calloutLine.length + offset;
            var x = datum.midCos * labelRadius;
            var y = datum.midSin * labelRadius + label.collisionOffsetY;
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(_this.calloutLabel);
            tempTextNode.setAlign({
                textAlign: (_a = label.collisionTextAlign) !== null && _a !== void 0 ? _a : label.textAlign,
                textBaseline: label.textBaseline,
            });
            return tempTextNode.computeBBox();
        };
        var avoidNeighbourYCollision = function (label, next, direction) {
            var box = getTextBBox(label).grow(minSpacing / 2);
            var other = getTextBBox(next).grow(minSpacing / 2);
            // The full collision is not detected, because sometimes
            // the next label can appear behind the label with offset
            var collidesOrBehind =
                box.x < other.x + other.width &&
                box.x + box.width > other.x &&
                (direction === 'to-top' ? box.y < other.y + other.height : box.y + box.height > other.y);
            if (collidesOrBehind) {
                var dy = direction === 'to-top' ? box.y - other.y - other.height : box.y + box.height - other.y;
                next.calloutLabel.collisionOffsetY = dy;
            }
        };
        var avoidYCollisions = function (labels) {
            var midLabel = labels.slice().sort(function (a, b) {
                return Math.abs(a.midSin) - Math.abs(b.midSin);
            })[0];
            var midIndex = labels.indexOf(midLabel);
            for (var i = midIndex - 1; i >= 0; i--) {
                var prev = labels[i + 1];
                var next = labels[i];
                avoidNeighbourYCollision(prev, next, 'to-top');
            }
            for (var i = midIndex + 1; i < labels.length; i++) {
                var prev = labels[i - 1];
                var next = labels[i];
                avoidNeighbourYCollision(prev, next, 'to-bottom');
            }
        };
        var avoidXCollisions = function (labels) {
            var labelsCollideLabelsByY = data.some(function (datum) {
                return datum.calloutLabel.collisionOffsetY !== 0;
            });
            var boxes = labels.map(function (label) {
                return getTextBBox(label);
            });
            var paddedBoxes = boxes.map(function (box) {
                return box.clone().grow(minSpacing / 2);
            });
            var labelsCollideLabelsByX = false;
            for (var i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++) {
                var box = paddedBoxes[i];
                for (var j = i + 1; j < labels.length; j++) {
                    var other = paddedBoxes[j];
                    if (box.collidesBBox(other)) {
                        labelsCollideLabelsByX = true;
                        break;
                    }
                }
            }
            var sectors = fullData.map(function (datum) {
                var startAngle = datum.startAngle,
                    endAngle = datum.endAngle;
                var radius = radiusScale.convert(datum.radius);
                var outerRadius = Math.max(0, radius);
                return {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                };
            });
            var labelsCollideSectors = boxes.some(function (box) {
                return sectors.some(function (sector) {
                    return boxCollidesSector(box, sector);
                });
            });
            if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) {
                return;
            }
            labels
                .filter(function (d) {
                    return d.calloutLabel.textAlign === 'center';
                })
                .forEach(function (d) {
                    var label = d.calloutLabel;
                    if (d.midCos < 0) {
                        label.collisionTextAlign = 'right';
                    } else if (d.midCos > 0) {
                        label.collisionTextAlign = 'left';
                    } else {
                        label.collisionTextAlign = 'center';
                    }
                });
        };
        avoidYCollisions(leftLabels);
        avoidYCollisions(rightLabels);
        avoidXCollisions(topLabels);
        avoidXCollisions(bottomLabels);
    };
    PieSeries.prototype.updateCalloutLabelNodes = function (seriesRect) {
        var _this = this;
        var _a = this,
            radiusScale = _a.radiusScale,
            calloutLabel = _a.calloutLabel,
            calloutLine = _a.calloutLine;
        var calloutLength = calloutLine.length;
        var offset = calloutLabel.offset,
            color = calloutLabel.color;
        var tempTextNode = new Text();
        this.calloutLabelSelection.selectByTag(PieNodeTag.Label).forEach(function (text) {
            var _a;
            var datum = text.datum;
            var label = datum.calloutLabel;
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            if (!(label === null || label === void 0 ? void 0 : label.text) || outerRadius === 0 || label.hidden) {
                text.visible = false;
                return;
            }
            var labelRadius = outerRadius + calloutLength + offset;
            var x = datum.midCos * labelRadius;
            var y = datum.midSin * labelRadius + label.collisionOffsetY;
            // Detect text overflow
            var align = {
                textAlign: (_a = label.collisionTextAlign) !== null && _a !== void 0 ? _a : label.textAlign,
                textBaseline: label.textBaseline,
            };
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(_this.calloutLabel);
            tempTextNode.setAlign(align);
            var box = tempTextNode.computeBBox();
            var displayText = label.text;
            var visible = true;
            if (calloutLabel.avoidCollisions) {
                var _b = _this.getLabelOverflow(label.text, box, seriesRect),
                    textLength = _b.textLength,
                    hasVerticalOverflow = _b.hasVerticalOverflow;
                displayText =
                    label.text.length === textLength ? label.text : label.text.substring(0, textLength) + '\u2026';
                visible = !hasVerticalOverflow;
            }
            text.text = displayText;
            text.x = x;
            text.y = y;
            text.setFont(_this.calloutLabel);
            text.setAlign(align);
            text.fill = color;
            text.visible = visible;
        });
    };
    PieSeries.prototype.computeLabelsBBox = function (options, seriesRect) {
        var _this = this;
        var _a;
        var _b = this,
            radiusScale = _b.radiusScale,
            calloutLabel = _b.calloutLabel,
            calloutLine = _b.calloutLine;
        var calloutLength = calloutLine.length;
        var offset = calloutLabel.offset,
            maxCollisionOffset = calloutLabel.maxCollisionOffset,
            minSpacing = calloutLabel.minSpacing;
        if (!calloutLabel.avoidCollisions) {
            return null;
        }
        this.maybeRefreshNodeData();
        this.updateRadiusScale();
        this.computeCalloutLabelCollisionOffsets();
        var textBoxes = [];
        var text = new Text();
        var titleBox;
        if (((_a = this.title) === null || _a === void 0 ? void 0 : _a.text) && this.title.enabled) {
            var dy = this.getTitleTranslationY();
            if (isFinite(dy)) {
                text.text = this.title.text;
                text.x = 0;
                text.y = dy;
                text.setFont(this.title);
                text.setAlign({
                    textBaseline: 'bottom',
                    textAlign: 'center',
                });
                titleBox = text.computeBBox();
                textBoxes.push(titleBox);
            }
        }
        this.nodeData.forEach(function (datum) {
            var _a;
            var label = datum.calloutLabel;
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            if (!label || outerRadius === 0) {
                return null;
            }
            var labelRadius = outerRadius + calloutLength + offset;
            var x = datum.midCos * labelRadius;
            var y = datum.midSin * labelRadius + label.collisionOffsetY;
            text.text = label.text;
            text.x = x;
            text.y = y;
            text.setFont(_this.calloutLabel);
            text.setAlign({
                textAlign: (_a = label.collisionTextAlign) !== null && _a !== void 0 ? _a : label.textAlign,
                textBaseline: label.textBaseline,
            });
            var box = text.computeBBox();
            label.box = box;
            // Hide labels that where pushed too far by the collision avoidance algorithm
            if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                label.hidden = true;
                return;
            }
            // Hide labels intersecting or above the title
            if (titleBox) {
                var seriesTop = seriesRect.y - _this.centerY;
                var titleCleanArea = new BBox(
                    titleBox.x - minSpacing,
                    seriesTop,
                    titleBox.width + 2 * minSpacing,
                    titleBox.y + titleBox.height + minSpacing - seriesTop,
                );
                if (box.collidesBBox(titleCleanArea)) {
                    label.hidden = true;
                    return;
                }
            }
            if (options.hideWhenNecessary) {
                var _b = _this.getLabelOverflow(label.text, box, seriesRect),
                    textLength = _b.textLength,
                    hasVerticalOverflow = _b.hasVerticalOverflow,
                    hasSurroundingSeriesOverflow = _b.hasSurroundingSeriesOverflow;
                var isTooShort = label.text.length > 2 && textLength < 2;
                if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                    label.hidden = true;
                    return;
                }
            }
            label.hidden = false;
            textBoxes.push(box);
        });
        if (textBoxes.length === 0) {
            return null;
        }
        return BBox.merge(textBoxes);
    };
    PieSeries.prototype.updateSectorLabelNodes = function () {
        var radiusScale = this.radiusScale;
        var innerRadius = radiusScale.convert(0);
        var _a = this.sectorLabel,
            fontSize = _a.fontSize,
            fontStyle = _a.fontStyle,
            fontWeight = _a.fontWeight,
            fontFamily = _a.fontFamily,
            positionOffset = _a.positionOffset,
            positionRatio = _a.positionRatio,
            color = _a.color;
        var isDoughnut = innerRadius > 0;
        var singleVisibleSector = this.seriesItemEnabled.filter(Boolean).length === 1;
        this.sectorLabelSelection.each(function (text, datum) {
            var sectorLabel = datum.sectorLabel;
            var radius = radiusScale.convert(datum.radius);
            var outerRadius = Math.max(0, radius);
            var isTextVisible = false;
            if (sectorLabel && outerRadius !== 0) {
                var labelRadius = innerRadius * (1 - positionRatio) + radius * positionRatio + positionOffset;
                text.fill = color;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.text = sectorLabel.text;
                var shouldPutTextInCenter = !isDoughnut && singleVisibleSector;
                if (shouldPutTextInCenter) {
                    text.x = 0;
                    text.y = 0;
                } else {
                    text.x = datum.midCos * labelRadius;
                    text.y = datum.midSin * labelRadius;
                }
                text.textAlign = 'center';
                text.textBaseline = 'middle';
                var bbox = text.computeBBox();
                var corners = [
                    [bbox.x, bbox.y],
                    [bbox.x + bbox.width, bbox.y],
                    [bbox.x + bbox.width, bbox.y + bbox.height],
                    [bbox.x, bbox.y + bbox.height],
                ];
                var startAngle = datum.startAngle,
                    endAngle = datum.endAngle;
                var sectorBounds_1 = {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                };
                if (
                    corners.every(function (_a) {
                        var _b = __read$I(_a, 2),
                            x = _b[0],
                            y = _b[1];
                        return isPointInSector(x, y, sectorBounds_1);
                    })
                ) {
                    isTextVisible = true;
                }
            }
            text.visible = isTextVisible;
        });
    };
    PieSeries.prototype.updateInnerCircle = function () {
        var circle = this.innerCircleNode;
        if (!circle) {
            return;
        }
        var innerRadius = this.getInnerRadius();
        if (innerRadius === 0) {
            circle.size = 0;
        } else {
            var circleRadius = Math.min(innerRadius, this.getOuterRadius());
            var antiAliasingPadding = 1;
            circle.size = Math.ceil(circleRadius * 2 + antiAliasingPadding);
        }
    };
    PieSeries.prototype.updateInnerLabelNodes = function () {
        var textBBoxes = [];
        var margins = [];
        this.innerLabelsSelection.each(function (text, datum) {
            var fontStyle = datum.fontStyle,
                fontWeight = datum.fontWeight,
                fontSize = datum.fontSize,
                fontFamily = datum.fontFamily,
                color = datum.color;
            text.fontStyle = fontStyle;
            text.fontWeight = fontWeight;
            text.fontSize = fontSize;
            text.fontFamily = fontFamily;
            text.text = datum.text;
            text.x = 0;
            text.y = 0;
            text.fill = color;
            text.textAlign = 'center';
            text.textBaseline = 'alphabetic';
            textBBoxes.push(text.computeBBox());
            margins.push(datum.margin);
        });
        var getMarginTop = function (index) {
            return index === 0 ? 0 : margins[index];
        };
        var getMarginBottom = function (index) {
            return index === margins.length - 1 ? 0 : margins[index];
        };
        var totalHeight = textBBoxes.reduce(function (sum, bbox, i) {
            return sum + bbox.height + getMarginTop(i) + getMarginBottom(i);
        }, 0);
        var totalWidth = Math.max.apply(
            Math,
            __spreadArray$p(
                [],
                __read$I(
                    textBBoxes.map(function (bbox) {
                        return bbox.width;
                    }),
                ),
            ),
        );
        var innerRadius = this.getInnerRadius();
        var labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
        var labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
        var textBottoms = [];
        for (var i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++) {
            var bbox = textBBoxes[i];
            var bottom = bbox.height + prev + getMarginTop(i);
            textBottoms.push(bottom);
            prev = bottom + getMarginBottom(i);
        }
        this.innerLabelsSelection.each(function (text, _datum, index) {
            text.y = textBottoms[index];
            text.visible = labelsVisible;
        });
    };
    PieSeries.prototype.getNodeClickEvent = function (event, datum) {
        return new PieSeriesNodeClickEvent(
            this.angleKey,
            this.calloutLabelKey,
            this.sectorLabelKey,
            this.radiusKey,
            event,
            datum,
            this,
        );
    };
    PieSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        return new PieSeriesNodeDoubleClickEvent(
            this.angleKey,
            this.calloutLabelKey,
            this.sectorLabelKey,
            this.radiusKey,
            event,
            datum,
            this,
        );
    };
    PieSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a;
        var angleKey = this.angleKey;
        if (!angleKey) {
            return '';
        }
        var _b = this,
            tooltip = _b.tooltip,
            angleName = _b.angleName,
            radiusKey = _b.radiusKey,
            radiusName = _b.radiusName,
            calloutLabelKey = _b.calloutLabelKey,
            sectorLabelKey = _b.sectorLabelKey,
            calloutLabelName = _b.calloutLabelName,
            sectorLabelName = _b.sectorLabelName,
            seriesId = _b.id;
        var tooltipRenderer = tooltip.renderer;
        var datum = nodeDatum.datum,
            angleValue = nodeDatum.angleValue,
            radiusValue = nodeDatum.radiusValue,
            color = nodeDatum.sectorFormat.fill,
            _c = nodeDatum.calloutLabel,
            _d = _c === void 0 ? {} : _c,
            _e = _d.text,
            label = _e === void 0 ? '' : _e;
        var formattedAngleValue = typeof angleValue === 'number' ? toFixed(angleValue) : String(angleValue);
        var title = (_a = this.title) === null || _a === void 0 ? void 0 : _a.text;
        var content = '' + (label ? label + ': ' : '') + formattedAngleValue;
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        if (tooltipRenderer) {
            return toTooltipHtml$1(
                tooltipRenderer({
                    datum: datum,
                    angleKey: angleKey,
                    angleValue: angleValue,
                    angleName: angleName,
                    radiusKey: radiusKey,
                    radiusValue: radiusValue,
                    radiusName: radiusName,
                    calloutLabelKey: calloutLabelKey,
                    calloutLabelName: calloutLabelName,
                    sectorLabelKey: sectorLabelKey,
                    sectorLabelName: sectorLabelName,
                    title: title,
                    color: color,
                    seriesId: seriesId,
                }),
                defaults,
            );
        }
        return toTooltipHtml$1(defaults);
    };
    PieSeries.prototype.getLegendData = function () {
        var _a, _b, _c;
        var _d = this,
            processedData = _d.processedData,
            calloutLabelKey = _d.calloutLabelKey,
            legendItemKey = _d.legendItemKey,
            id = _d.id,
            dataModel = _d.dataModel;
        if (!dataModel || !processedData || processedData.data.length === 0) return [];
        if (!legendItemKey && !calloutLabelKey) return [];
        var _e = this.getProcessedDataIndexes(dataModel),
            angleIdx = _e.angleIdx,
            radiusIdx = _e.radiusIdx,
            calloutLabelIdx = _e.calloutLabelIdx,
            sectorLabelIdx = _e.sectorLabelIdx,
            legendItemIdx = _e.legendItemIdx;
        var titleText = ((_a = this.title) === null || _a === void 0 ? void 0 : _a.showInLegend) && this.title.text;
        var legendData = [];
        for (var index = 0; index < processedData.data.length; index++) {
            var _f = processedData.data[index],
                datum = _f.datum,
                values = _f.values;
            var labelParts = [];
            if (titleText) {
                labelParts.push(titleText);
            }
            var labels = this.getLabels(
                datum,
                2 * Math.PI,
                2 * Math.PI,
                false,
                values[angleIdx],
                values[radiusIdx],
                values[calloutLabelIdx],
                values[sectorLabelIdx],
                values[legendItemIdx],
            );
            if (legendItemKey && labels.legendItem !== undefined) {
                labelParts.push(labels.legendItem.text);
            } else if (
                calloutLabelKey &&
                ((_b = labels.calloutLabel) === null || _b === void 0 ? void 0 : _b.text) !== undefined
            ) {
                labelParts.push((_c = labels.calloutLabel) === null || _c === void 0 ? void 0 : _c.text);
            }
            if (labelParts.length === 0) continue;
            var sectorFormat = this.getSectorFormat(datum, index, index, false);
            legendData.push({
                legendType: 'category',
                id: id,
                itemId: index,
                seriesId: id,
                enabled: this.seriesItemEnabled[index],
                label: {
                    text: labelParts.join(' - '),
                },
                marker: {
                    fill: sectorFormat.fill,
                    stroke: sectorFormat.stroke,
                    fillOpacity: this.fillOpacity,
                    strokeOpacity: this.strokeOpacity,
                },
            });
        }
        return legendData;
    };
    PieSeries.prototype.onLegendItemClick = function (event) {
        var enabled = event.enabled,
            itemId = event.itemId,
            series = event.series;
        if (series.id === this.id) {
            this.toggleSeriesItem(itemId, enabled);
        } else if (series.type === 'pie') {
            this.toggleOtherSeriesItems(series, itemId, enabled);
        }
    };
    PieSeries.prototype.toggleSeriesItem = function (itemId, enabled) {
        this.seriesItemEnabled[itemId] = enabled;
        this.nodeDataRefresh = true;
    };
    PieSeries.prototype.toggleOtherSeriesItems = function (series, itemId, enabled) {
        var _this = this;
        var _a, _b;
        var _c = this,
            legendItemKey = _c.legendItemKey,
            dataModel = _c.dataModel;
        if (!legendItemKey || !dataModel) return;
        var datumToggledLegendItemValue =
            series.legendItemKey &&
            ((_a = series.data) === null || _a === void 0
                ? void 0
                : _a.find(function (_, index) {
                      return index === itemId;
                  })[series.legendItemKey]);
        if (!datumToggledLegendItemValue) return;
        var legendItemIdx = dataModel.resolveProcessedDataIndexById(this, 'legendItemValue').index;
        (_b = this.processedData) === null || _b === void 0
            ? void 0
            : _b.data.forEach(function (_a, datumItemId) {
                  var values = _a.values;
                  if (values[legendItemIdx] === datumToggledLegendItemValue) {
                      _this.toggleSeriesItem(datumItemId, enabled);
                  }
              });
    };
    PieSeries.prototype.animateEmptyUpdateReady = function () {
        var _this = this;
        var _a, _b;
        var duration =
            (_b = (_a = this.ctx.animationManager) === null || _a === void 0 ? void 0 : _a.defaultOptions.duration) !==
                null && _b !== void 0
                ? _b
                : 1000;
        var labelDuration = 200;
        var rotation = Math.PI / -2 + toRadians$1(this.rotation);
        this.groupSelection.selectByTag(PieNodeTag.Sector).forEach(function (node) {
            var _a;
            var datum = node.datum;
            (_a = _this.ctx.animationManager) === null || _a === void 0
                ? void 0
                : _a.animateMany(
                      _this.id + '_empty-update-ready_' + node.id,
                      [
                          { from: rotation, to: datum.startAngle },
                          { from: rotation, to: datum.endAngle },
                      ],
                      {
                          duration: duration,
                          ease: easeOut,
                          onUpdate: function (_a) {
                              var _b = __read$I(_a, 2),
                                  startAngle = _b[0],
                                  endAngle = _b[1];
                              node.startAngle = startAngle;
                              node.endAngle = endAngle;
                          },
                      },
                  );
        });
        var labelAnimationOptions = {
            from: 0,
            to: 1,
            delay: duration,
            duration: labelDuration,
        };
        this.calloutLabelSelection.each(function (label) {
            var _a;
            (_a = _this.ctx.animationManager) === null || _a === void 0
                ? void 0
                : _a.animate(
                      _this.id + '_empty-update-ready_' + label.id,
                      __assign$I(__assign$I({}, labelAnimationOptions), {
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      }),
                  );
        });
        this.sectorLabelSelection.each(function (label) {
            var _a;
            (_a = _this.ctx.animationManager) === null || _a === void 0
                ? void 0
                : _a.animate(
                      _this.id + '_empty-update-ready_' + label.id,
                      __assign$I(__assign$I({}, labelAnimationOptions), {
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      }),
                  );
        });
        this.innerLabelsSelection.each(function (label) {
            var _a;
            (_a = _this.ctx.animationManager) === null || _a === void 0
                ? void 0
                : _a.animate(
                      _this.id + '_empty-update-ready_' + label.id,
                      __assign$I(__assign$I({}, labelAnimationOptions), {
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      }),
                  );
        });
    };
    PieSeries.prototype.animateReadyUpdateReady = function () {
        this.groupSelection.selectByTag(PieNodeTag.Sector).forEach(function (node) {
            var datum = node.datum;
            node.startAngle = datum.startAngle;
            node.endAngle = datum.endAngle;
        });
    };
    PieSeries.className = 'PieSeries';
    PieSeries.type = 'pie';
    __decorate$1z([Validate(STRING)], PieSeries.prototype, 'angleKey', void 0);
    __decorate$1z([Validate(STRING)], PieSeries.prototype, 'angleName', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'radiusKey', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'radiusName', void 0);
    __decorate$1z([Validate(OPT_NUMBER(0))], PieSeries.prototype, 'radiusMin', void 0);
    __decorate$1z([Validate(OPT_NUMBER(0))], PieSeries.prototype, 'radiusMax', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'calloutLabelKey', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'calloutLabelName', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'sectorLabelKey', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'sectorLabelName', void 0);
    __decorate$1z([Validate(OPT_STRING)], PieSeries.prototype, 'legendItemKey', void 0);
    __decorate$1z([Validate(COLOR_STRING_ARRAY)], PieSeries.prototype, 'fills', void 0);
    __decorate$1z([Validate(COLOR_STRING_ARRAY)], PieSeries.prototype, 'strokes', void 0);
    __decorate$1z([Validate(NUMBER(0, 1))], PieSeries.prototype, 'fillOpacity', void 0);
    __decorate$1z([Validate(NUMBER(0, 1))], PieSeries.prototype, 'strokeOpacity', void 0);
    __decorate$1z([Validate(OPT_LINE_DASH)], PieSeries.prototype, 'lineDash', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeries.prototype, 'lineDashOffset', void 0);
    __decorate$1z([Validate(OPT_FUNCTION)], PieSeries.prototype, 'formatter', void 0);
    __decorate$1z([Validate(NUMBER(-360, 360))], PieSeries.prototype, 'rotation', void 0);
    __decorate$1z([Validate(NUMBER())], PieSeries.prototype, 'outerRadiusOffset', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeries.prototype, 'outerRadiusRatio', void 0);
    __decorate$1z([Validate(NUMBER())], PieSeries.prototype, 'innerRadiusOffset', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeries.prototype, 'innerRadiusRatio', void 0);
    __decorate$1z([Validate(NUMBER(0))], PieSeries.prototype, 'strokeWidth', void 0);
    return PieSeries;
})(PolarSeries);

var __assign$H =
    (undefined && undefined.__assign) ||
    function () {
        __assign$H =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$H.apply(this, arguments);
    };
var JSON_APPLY_PLUGINS = {
    constructors: {},
    constructedArrays: new WeakMap(),
};
function assignJsonApplyConstructedArray(array, ctor) {
    var _a;
    (_a = JSON_APPLY_PLUGINS.constructedArrays) === null || _a === void 0 ? void 0 : _a.set(array, ctor);
}
var JSON_APPLY_OPTIONS = {
    constructors: {
        'title': Caption,
        'subtitle': Caption,
        'footnote': Caption,
        'shadow': DropShadow,
        'innerCircle': DoughnutInnerCircle,
        'axes[].title': AxisTitle,
        'series[].innerLabels[]': DoughnutInnerLabel,
    },
    allowedTypes: {
        'legend.pagination.marker.shape': ['primitive', 'function'],
        'series[].marker.shape': ['primitive', 'function'],
        'axis[].tick.count': ['primitive', 'class-instance'],
    },
};
function getJsonApplyOptions() {
    return {
        constructors: __assign$H(__assign$H({}, JSON_APPLY_OPTIONS.constructors), JSON_APPLY_PLUGINS.constructors),
        constructedArrays: JSON_APPLY_PLUGINS.constructedArrays,
        allowedTypes: __assign$H({}, JSON_APPLY_OPTIONS.allowedTypes),
    };
}

var horizontalCrosslineTranslationDirections = {
    top: { xTranslationDirection: 0, yTranslationDirection: -1 },
    bottom: { xTranslationDirection: 0, yTranslationDirection: 1 },
    left: { xTranslationDirection: -1, yTranslationDirection: 0 },
    right: { xTranslationDirection: 1, yTranslationDirection: 0 },
    topLeft: { xTranslationDirection: 1, yTranslationDirection: -1 },
    topRight: { xTranslationDirection: -1, yTranslationDirection: -1 },
    bottomLeft: { xTranslationDirection: 1, yTranslationDirection: 1 },
    bottomRight: { xTranslationDirection: -1, yTranslationDirection: 1 },
    inside: { xTranslationDirection: 0, yTranslationDirection: 0 },
    insideLeft: { xTranslationDirection: 1, yTranslationDirection: 0 },
    insideRight: { xTranslationDirection: -1, yTranslationDirection: 0 },
    insideTop: { xTranslationDirection: 0, yTranslationDirection: 1 },
    insideBottom: { xTranslationDirection: 0, yTranslationDirection: -1 },
    insideTopLeft: { xTranslationDirection: 1, yTranslationDirection: 1 },
    insideBottomLeft: { xTranslationDirection: 1, yTranslationDirection: -1 },
    insideTopRight: { xTranslationDirection: -1, yTranslationDirection: 1 },
    insideBottomRight: { xTranslationDirection: -1, yTranslationDirection: -1 },
};
var verticalCrossLineTranslationDirections = {
    top: { xTranslationDirection: 1, yTranslationDirection: 0 },
    bottom: { xTranslationDirection: -1, yTranslationDirection: 0 },
    left: { xTranslationDirection: 0, yTranslationDirection: -1 },
    right: { xTranslationDirection: 0, yTranslationDirection: 1 },
    topLeft: { xTranslationDirection: -1, yTranslationDirection: -1 },
    topRight: { xTranslationDirection: -1, yTranslationDirection: 1 },
    bottomLeft: { xTranslationDirection: 1, yTranslationDirection: -1 },
    bottomRight: { xTranslationDirection: 1, yTranslationDirection: 1 },
    inside: { xTranslationDirection: 0, yTranslationDirection: 0 },
    insideLeft: { xTranslationDirection: 0, yTranslationDirection: 1 },
    insideRight: { xTranslationDirection: 0, yTranslationDirection: -1 },
    insideTop: { xTranslationDirection: -1, yTranslationDirection: 0 },
    insideBottom: { xTranslationDirection: 1, yTranslationDirection: 0 },
    insideTopLeft: { xTranslationDirection: -1, yTranslationDirection: 1 },
    insideBottomLeft: { xTranslationDirection: 1, yTranslationDirection: 1 },
    insideTopRight: { xTranslationDirection: -1, yTranslationDirection: -1 },
    insideBottomRight: { xTranslationDirection: 1, yTranslationDirection: -1 },
};
function calculateLabelTranslation(_a) {
    var yDirection = _a.yDirection,
        _b = _a.padding,
        padding = _b === void 0 ? 0 : _b,
        _c = _a.position,
        position = _c === void 0 ? 'top' : _c,
        bbox = _a.bbox;
    var crossLineTranslationDirections = yDirection
        ? horizontalCrosslineTranslationDirections
        : verticalCrossLineTranslationDirections;
    var _d = crossLineTranslationDirections[position],
        xTranslationDirection = _d.xTranslationDirection,
        yTranslationDirection = _d.yTranslationDirection;
    var w = yDirection ? bbox.width : bbox.height;
    var h = yDirection ? bbox.height : bbox.width;
    var xTranslation = xTranslationDirection * (padding + w / 2);
    var yTranslation = yTranslationDirection * (padding + h / 2);
    var result = {
        xTranslation: xTranslation,
        yTranslation: yTranslation,
    };
    return result;
}
function calculateLabelChartPadding(_a) {
    var yDirection = _a.yDirection,
        bbox = _a.bbox,
        _b = _a.padding,
        padding = _b === void 0 ? 0 : _b,
        _c = _a.position,
        position = _c === void 0 ? 'top' : _c;
    var chartPadding = {};
    if (position.startsWith('inside')) return chartPadding;
    if (position === 'top' && !yDirection) {
        chartPadding.top = padding + bbox.height;
    } else if (position === 'bottom' && !yDirection) {
        chartPadding.bottom = padding + bbox.height;
    } else if (position === 'left' && yDirection) {
        chartPadding.left = padding + bbox.width;
    } else if (position === 'right' && yDirection) {
        chartPadding.right = padding + bbox.width;
    }
    return chartPadding;
}
var POSITION_TOP_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xEnd / 2, y: yStart };
    } else {
        return { x: xEnd, y: !isNaN(yEnd) ? (yStart + yEnd) / 2 : yStart };
    }
};
var POSITION_LEFT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xStart = _a.xStart,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xStart, y: !isNaN(yEnd) ? (yStart + yEnd) / 2 : yStart };
    } else {
        return { x: xEnd / 2, y: yStart };
    }
};
var POSITION_RIGHT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xEnd, y: !isNaN(yEnd) ? (yStart + yEnd) / 2 : yStart };
    } else {
        return { x: xEnd / 2, y: !isNaN(yEnd) ? yEnd : yStart };
    }
};
var POSITION_BOTTOM_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xStart = _a.xStart,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xEnd / 2, y: !isNaN(yEnd) ? yEnd : yStart };
    } else {
        return { x: xStart, y: !isNaN(yEnd) ? (yStart + yEnd) / 2 : yStart };
    }
};
var POSITION_INSIDE_COORDINATES = function (_a) {
    var xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    return { x: xEnd / 2, y: !isNaN(yEnd) ? (yStart + yEnd) / 2 : yStart };
};
var POSITION_TOP_LEFT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xStart = _a.xStart,
        xEnd = _a.xEnd,
        yStart = _a.yStart;
    if (yDirection) {
        return { x: xStart / 2, y: yStart };
    } else {
        return { x: xEnd, y: yStart };
    }
};
var POSITION_BOTTOM_LEFT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xStart = _a.xStart,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xStart, y: !isNaN(yEnd) ? yEnd : yStart };
    } else {
        return { x: xStart, y: yStart };
    }
};
var POSITION_TOP_RIGHT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xEnd, y: yStart };
    } else {
        return { x: xEnd, y: !isNaN(yEnd) ? yEnd : yStart };
    }
};
var POSITION_BOTTOM_RIGHT_COORDINATES = function (_a) {
    var yDirection = _a.yDirection,
        xStart = _a.xStart,
        xEnd = _a.xEnd,
        yStart = _a.yStart,
        yEnd = _a.yEnd;
    if (yDirection) {
        return { x: xEnd, y: !isNaN(yEnd) ? yEnd : yStart };
    } else {
        return { x: xStart, y: !isNaN(yEnd) ? yEnd : yStart };
    }
};
var labeldDirectionHandling = {
    top: { c: POSITION_TOP_COORDINATES },
    bottom: { c: POSITION_BOTTOM_COORDINATES },
    left: { c: POSITION_LEFT_COORDINATES },
    right: { c: POSITION_RIGHT_COORDINATES },
    topLeft: { c: POSITION_TOP_LEFT_COORDINATES },
    topRight: { c: POSITION_TOP_RIGHT_COORDINATES },
    bottomLeft: { c: POSITION_BOTTOM_LEFT_COORDINATES },
    bottomRight: { c: POSITION_BOTTOM_RIGHT_COORDINATES },
    inside: { c: POSITION_INSIDE_COORDINATES },
    insideLeft: { c: POSITION_LEFT_COORDINATES },
    insideRight: { c: POSITION_RIGHT_COORDINATES },
    insideTop: { c: POSITION_TOP_COORDINATES },
    insideBottom: { c: POSITION_BOTTOM_COORDINATES },
    insideTopLeft: { c: POSITION_TOP_LEFT_COORDINATES },
    insideBottomLeft: { c: POSITION_BOTTOM_LEFT_COORDINATES },
    insideTopRight: { c: POSITION_TOP_RIGHT_COORDINATES },
    insideBottomRight: { c: POSITION_BOTTOM_RIGHT_COORDINATES },
};

var __extends$2g =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$G =
    (undefined && undefined.__assign) ||
    function () {
        __assign$G =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$G.apply(this, arguments);
    };
var __decorate$1y =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Range = /** @class */ (function (_super) {
    __extends$2g(Range, _super);
    function Range() {
        var _this = _super.call(this) || this;
        _this.x1 = 0;
        _this.y1 = 0;
        _this.x2 = 0;
        _this.y2 = 0;
        _this.startLine = false;
        _this.endLine = false;
        _this.isRange = false;
        _this.restoreOwnStyles();
        return _this;
    }
    Range.prototype.computeBBox = function () {
        return new BBox(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
    };
    Range.prototype.isPointInPath = function (_x, _y) {
        return false;
    };
    Range.prototype.render = function (renderCtx) {
        var _a;
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        var _b = this,
            x1 = _b.x1,
            y1 = _b.y1,
            x2 = _b.x2,
            y2 = _b.y2;
        x1 = this.align(x1);
        y1 = this.align(y1);
        x2 = this.align(x2);
        y2 = this.align(y2);
        var _c = this,
            fill = _c.fill,
            opacity = _c.opacity,
            isRange = _c.isRange;
        var fillActive = !!(isRange && fill);
        if (fillActive) {
            var fillOpacity = this.fillOpacity;
            ctx.fillStyle = fill;
            ctx.globalAlpha = opacity * fillOpacity;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y1);
            ctx.lineTo(x2, y2);
            ctx.lineTo(x1, y2);
            ctx.closePath();
            ctx.fill();
        }
        var _d = this,
            stroke = _d.stroke,
            strokeWidth = _d.strokeWidth,
            startLine = _d.startLine,
            endLine = _d.endLine;
        var strokeActive = !!((startLine || endLine) && stroke && strokeWidth);
        if (strokeActive) {
            var _e = this,
                strokeOpacity = _e.strokeOpacity,
                lineDash = _e.lineDash,
                lineDashOffset = _e.lineDashOffset,
                lineCap = _e.lineCap,
                lineJoin = _e.lineJoin;
            ctx.strokeStyle = stroke;
            ctx.globalAlpha = opacity * strokeOpacity;
            ctx.lineWidth = strokeWidth;
            if (lineDash) {
                ctx.setLineDash(lineDash);
            }
            if (lineDashOffset) {
                ctx.lineDashOffset = lineDashOffset;
            }
            if (lineCap) {
                ctx.lineCap = lineCap;
            }
            if (lineJoin) {
                ctx.lineJoin = lineJoin;
            }
            ctx.beginPath();
            if (startLine) {
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y1);
            }
            if (endLine) {
                ctx.moveTo(x2, y2);
                ctx.lineTo(x1, y2);
            }
            ctx.stroke();
        }
        (_a = this.fillShadow) === null || _a === void 0 ? void 0 : _a.markClean();
        _super.prototype.render.call(this, renderCtx);
    };
    Range.className = 'Range';
    Range.defaultStyles = __assign$G(__assign$G({}, Shape.defaultStyles), { strokeWidth: 1 });
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'x1', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'y1', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'x2', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'y2', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'startLine', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'endLine', void 0);
    __decorate$1y([SceneChangeDetection({ redraw: RedrawType.MINOR })], Range.prototype, 'isRange', void 0);
    return Range;
})(Shape);

var __decorate$1x =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$H =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$o =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var CROSSLINE_LABEL_POSITIONS = [
    'top',
    'left',
    'right',
    'bottom',
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'inside',
    'insideLeft',
    'insideRight',
    'insideTop',
    'insideBottom',
    'insideTopLeft',
    'insideBottomLeft',
    'insideTopRight',
    'insideBottomRight',
];
var OPT_CROSSLINE_LABEL_POSITION = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, function (v) {
        return CROSSLINE_LABEL_POSITIONS.includes(v);
    });
}, "expecting an optional crossLine label position keyword such as 'topLeft', 'topRight' or 'inside'");
var OPT_CROSSLINE_TYPE = predicateWithMessage(function (v, ctx) {
    return OPTIONAL(v, ctx, function (v) {
        return v === 'range' || v === 'line';
    });
}, "expecting a crossLine type keyword such as 'range' or 'line'");
var CartesianCrossLineLabel = /** @class */ (function () {
    function CartesianCrossLineLabel() {
        this.enabled = undefined;
        this.text = undefined;
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.fontSize = 14;
        this.fontFamily = 'Verdana, sans-serif';
        /**
         * The padding between the label and the line.
         */
        this.padding = 5;
        /**
         * The color of the labels.
         */
        this.color = 'rgba(87, 87, 87, 1)';
        this.position = undefined;
        this.rotation = undefined;
        this.parallel = undefined;
    }
    __decorate$1x([Validate(OPT_BOOLEAN)], CartesianCrossLineLabel.prototype, 'enabled', void 0);
    __decorate$1x([Validate(OPT_STRING)], CartesianCrossLineLabel.prototype, 'text', void 0);
    __decorate$1x([Validate(OPT_FONT_STYLE)], CartesianCrossLineLabel.prototype, 'fontStyle', void 0);
    __decorate$1x([Validate(OPT_FONT_WEIGHT)], CartesianCrossLineLabel.prototype, 'fontWeight', void 0);
    __decorate$1x([Validate(NUMBER(0))], CartesianCrossLineLabel.prototype, 'fontSize', void 0);
    __decorate$1x([Validate(STRING)], CartesianCrossLineLabel.prototype, 'fontFamily', void 0);
    __decorate$1x([Validate(NUMBER(0))], CartesianCrossLineLabel.prototype, 'padding', void 0);
    __decorate$1x([Validate(OPT_COLOR_STRING)], CartesianCrossLineLabel.prototype, 'color', void 0);
    __decorate$1x([Validate(OPT_CROSSLINE_LABEL_POSITION)], CartesianCrossLineLabel.prototype, 'position', void 0);
    __decorate$1x([Validate(OPT_NUMBER(-360, 360))], CartesianCrossLineLabel.prototype, 'rotation', void 0);
    __decorate$1x([Validate(OPT_BOOLEAN)], CartesianCrossLineLabel.prototype, 'parallel', void 0);
    return CartesianCrossLineLabel;
})();
var CartesianCrossLine = /** @class */ (function () {
    function CartesianCrossLine() {
        this.id = createId$1(this);
        this.enabled = undefined;
        this.type = undefined;
        this.range = undefined;
        this.value = undefined;
        this.fill = undefined;
        this.fillOpacity = undefined;
        this.stroke = undefined;
        this.strokeWidth = undefined;
        this.strokeOpacity = undefined;
        this.lineDash = undefined;
        this.label = new CartesianCrossLineLabel();
        this.scale = undefined;
        this.clippedRange = [-Infinity, Infinity];
        this.gridLength = 0;
        this.sideFlag = -1;
        this.parallelFlipRotation = 0;
        this.regularFlipRotation = 0;
        this.direction = ChartAxisDirection.X;
        this.group = new Group({ name: '' + this.id, layer: true, zIndex: CartesianCrossLine.LINE_LAYER_ZINDEX });
        this.crossLineRange = new Range();
        this.crossLineLabel = new Text();
        this.labelPoint = undefined;
        this.data = [];
        this.startLine = false;
        this.endLine = false;
        this.isRange = false;
        var _a = this,
            group = _a.group,
            crossLineRange = _a.crossLineRange,
            crossLineLabel = _a.crossLineLabel;
        group.append([crossLineRange, crossLineLabel]);
        crossLineRange.pointerEvents = PointerEvents.None;
    }
    CartesianCrossLine.prototype.update = function (visible) {
        if (!this.enabled) {
            return;
        }
        this.group.visible = visible;
        if (!visible) {
            return;
        }
        var dataCreated = this.createNodeData();
        if (!dataCreated) {
            this.group.visible = false;
            return;
        }
        this.updateNodes();
        this.group.zIndex = this.getZIndex(this.isRange);
    };
    CartesianCrossLine.prototype.updateNodes = function () {
        this.updateRangeNode();
        if (this.label.enabled) {
            this.updateLabel();
            this.positionLabel();
        }
    };
    CartesianCrossLine.prototype.createNodeData = function () {
        var _a, _b, _c;
        var _d, _e;
        var _f = this,
            scale = _f.scale,
            gridLength = _f.gridLength,
            sideFlag = _f.sideFlag,
            direction = _f.direction,
            _g = _f.label.position,
            position = _g === void 0 ? 'top' : _g,
            clippedRange = _f.clippedRange,
            _h = _f.strokeWidth,
            strokeWidth = _h === void 0 ? 0 : _h;
        if (!scale) {
            return false;
        }
        var bandwidth = (_d = scale.bandwidth) !== null && _d !== void 0 ? _d : 0;
        var clippedRangeClamper = function (x) {
            return Math.max(
                Math.min.apply(Math, __spreadArray$o([], __read$H(clippedRange))),
                Math.min(Math.max.apply(Math, __spreadArray$o([], __read$H(clippedRange))), x),
            );
        };
        var _j = __read$H([0, sideFlag * gridLength], 2),
            xStart = _j[0],
            xEnd = _j[1];
        var _k = __read$H(this.getRange(), 2),
            yStart = _k[0],
            yEnd = _k[1];
        var _l = __read$H(
                [Number(scale.convert(yStart, { strict: false })), scale.convert(yEnd, { strict: false }) + bandwidth],
                2,
            ),
            clampedYStart = _l[0],
            clampedYEnd = _l[1];
        clampedYStart = clippedRangeClamper(clampedYStart);
        clampedYEnd = clippedRangeClamper(clampedYEnd);
        (_a = __read$H([Number(scale.convert(yStart)), scale.convert(yEnd) + bandwidth], 2)),
            (yStart = _a[0]),
            (yEnd = _a[1]);
        var validRange =
            !isNaN(clampedYStart) &&
            !isNaN(clampedYEnd) &&
            (yStart === clampedYStart || yEnd === clampedYEnd || clampedYStart !== clampedYEnd) &&
            Math.abs(clampedYEnd - clampedYStart) > 0;
        if (validRange) {
            var reverse = clampedYStart !== Math.min(clampedYStart, clampedYEnd);
            if (reverse) {
                (_b = __read$H([Math.min(clampedYStart, clampedYEnd), Math.max(clampedYStart, clampedYEnd)], 2)),
                    (clampedYStart = _b[0]),
                    (clampedYEnd = _b[1]);
                (_c = __read$H([yEnd, yStart], 2)), (yStart = _c[0]), (yEnd = _c[1]);
            }
        }
        this.isRange = validRange;
        this.startLine = !isNaN(yStart) && strokeWidth > 0 && yStart === clampedYStart;
        this.endLine = !isNaN(yEnd) && strokeWidth > 0 && yEnd === clampedYEnd;
        if (!validRange && !this.startLine && !this.endLine) {
            return false;
        }
        this.data = [clampedYStart, clampedYEnd];
        if (this.label.enabled) {
            var yDirection = direction === ChartAxisDirection.Y;
            var _m = ((_e = labeldDirectionHandling[position]) !== null && _e !== void 0 ? _e : {}).c,
                c = _m === void 0 ? POSITION_TOP_COORDINATES : _m;
            var _o = c({
                    yDirection: yDirection,
                    xStart: xStart,
                    xEnd: xEnd,
                    yStart: clampedYStart,
                    yEnd: clampedYEnd,
                }),
                labelX = _o.x,
                labelY = _o.y;
            this.labelPoint = {
                x: labelX,
                y: labelY,
            };
        }
        return true;
    };
    CartesianCrossLine.prototype.updateRangeNode = function () {
        var _a;
        var _b = this,
            crossLineRange = _b.crossLineRange,
            sideFlag = _b.sideFlag,
            gridLength = _b.gridLength,
            data = _b.data,
            startLine = _b.startLine,
            endLine = _b.endLine,
            isRange = _b.isRange,
            fill = _b.fill,
            fillOpacity = _b.fillOpacity,
            stroke = _b.stroke,
            strokeWidth = _b.strokeWidth,
            lineDash = _b.lineDash;
        crossLineRange.x1 = 0;
        crossLineRange.x2 = sideFlag * gridLength;
        crossLineRange.y1 = data[0];
        crossLineRange.y2 = data[1];
        crossLineRange.startLine = startLine;
        crossLineRange.endLine = endLine;
        crossLineRange.isRange = isRange;
        crossLineRange.fill = fill;
        crossLineRange.fillOpacity = fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : 1;
        crossLineRange.stroke = stroke;
        crossLineRange.strokeWidth = strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 1;
        crossLineRange.strokeOpacity = (_a = this.strokeOpacity) !== null && _a !== void 0 ? _a : 1;
        crossLineRange.lineDash = lineDash;
    };
    CartesianCrossLine.prototype.updateLabel = function () {
        var _a = this,
            crossLineLabel = _a.crossLineLabel,
            label = _a.label;
        if (!label.text) {
            return;
        }
        crossLineLabel.fontStyle = label.fontStyle;
        crossLineLabel.fontWeight = label.fontWeight;
        crossLineLabel.fontSize = label.fontSize;
        crossLineLabel.fontFamily = label.fontFamily;
        crossLineLabel.fill = label.color;
        crossLineLabel.text = label.text;
    };
    CartesianCrossLine.prototype.positionLabel = function () {
        var _a = this,
            crossLineLabel = _a.crossLineLabel,
            _b = _a.labelPoint,
            _c = _b === void 0 ? {} : _b,
            _d = _c.x,
            x = _d === void 0 ? undefined : _d,
            _e = _c.y,
            y = _e === void 0 ? undefined : _e,
            _f = _a.label,
            parallel = _f.parallel,
            rotation = _f.rotation,
            _g = _f.position,
            position = _g === void 0 ? 'top' : _g,
            _h = _f.padding,
            padding = _h === void 0 ? 0 : _h,
            direction = _a.direction,
            parallelFlipRotation = _a.parallelFlipRotation,
            regularFlipRotation = _a.regularFlipRotation;
        if (x === undefined || y === undefined) {
            return;
        }
        var _j = calculateLabelRotation({
                rotation: rotation,
                parallel: parallel,
                regularFlipRotation: regularFlipRotation,
                parallelFlipRotation: parallelFlipRotation,
            }),
            defaultRotation = _j.defaultRotation,
            configuredRotation = _j.configuredRotation;
        crossLineLabel.rotation = defaultRotation + configuredRotation;
        crossLineLabel.textBaseline = 'middle';
        crossLineLabel.textAlign = 'center';
        var bbox = this.computeLabelBBox();
        if (!bbox) {
            return;
        }
        var yDirection = direction === ChartAxisDirection.Y;
        var _k = calculateLabelTranslation({
                yDirection: yDirection,
                padding: padding,
                position: position,
                bbox: bbox,
            }),
            xTranslation = _k.xTranslation,
            yTranslation = _k.yTranslation;
        crossLineLabel.translationX = x + xTranslation;
        crossLineLabel.translationY = y + yTranslation;
    };
    CartesianCrossLine.prototype.getZIndex = function (isRange) {
        if (isRange === void 0) {
            isRange = false;
        }
        if (isRange) {
            return CartesianCrossLine.RANGE_LAYER_ZINDEX;
        }
        return CartesianCrossLine.LINE_LAYER_ZINDEX;
    };
    CartesianCrossLine.prototype.getRange = function () {
        var _a = this,
            value = _a.value,
            range = _a.range,
            scale = _a.scale;
        var isContinuous = scale instanceof ContinuousScale;
        var _b = __read$H(range !== null && range !== void 0 ? range : [value, undefined], 2),
            start = _b[0],
            end = _b[1];
        if (!isContinuous && end === undefined) {
            end = start;
        }
        start = checkDatum(start, isContinuous) != null ? start : undefined;
        end = checkDatum(end, isContinuous) != null ? end : undefined;
        if (isContinuous && start === end) {
            end = undefined;
        }
        if (start === undefined && end !== undefined) {
            start = end;
            end = undefined;
        }
        return [start, end];
    };
    CartesianCrossLine.prototype.computeLabelBBox = function () {
        return this.crossLineLabel.computeTransformedBBox();
    };
    CartesianCrossLine.prototype.calculatePadding = function (padding) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var _j = this,
            isRange = _j.isRange,
            startLine = _j.startLine,
            endLine = _j.endLine,
            direction = _j.direction,
            _k = _j.label,
            _l = _k.padding,
            labelPadding = _l === void 0 ? 0 : _l,
            _m = _k.position,
            position = _m === void 0 ? 'top' : _m;
        if (!isRange && !startLine && !endLine) {
            return;
        }
        var crossLineLabelBBox = this.computeLabelBBox();
        var labelX = crossLineLabelBBox === null || crossLineLabelBBox === void 0 ? void 0 : crossLineLabelBBox.x;
        var labelY = crossLineLabelBBox === null || crossLineLabelBBox === void 0 ? void 0 : crossLineLabelBBox.y;
        if (!crossLineLabelBBox || labelX == undefined || labelY == undefined) {
            return;
        }
        var chartPadding = calculateLabelChartPadding({
            yDirection: direction === ChartAxisDirection.Y,
            padding: labelPadding,
            position: position,
            bbox: crossLineLabelBBox,
        });
        padding.left = Math.max(
            (_a = padding.left) !== null && _a !== void 0 ? _a : 0,
            (_b = chartPadding.left) !== null && _b !== void 0 ? _b : 0,
        );
        padding.right = Math.max(
            (_c = padding.right) !== null && _c !== void 0 ? _c : 0,
            (_d = chartPadding.right) !== null && _d !== void 0 ? _d : 0,
        );
        padding.top = Math.max(
            (_e = padding.top) !== null && _e !== void 0 ? _e : 0,
            (_f = chartPadding.top) !== null && _f !== void 0 ? _f : 0,
        );
        padding.bottom = Math.max(
            (_g = padding.bottom) !== null && _g !== void 0 ? _g : 0,
            (_h = chartPadding.bottom) !== null && _h !== void 0 ? _h : 0,
        );
    };
    CartesianCrossLine.LINE_LAYER_ZINDEX = Layers.SERIES_CROSSLINE_LINE_ZINDEX;
    CartesianCrossLine.RANGE_LAYER_ZINDEX = Layers.SERIES_CROSSLINE_RANGE_ZINDEX;
    CartesianCrossLine.className = 'CrossLine';
    __decorate$1x([Validate(OPT_BOOLEAN)], CartesianCrossLine.prototype, 'enabled', void 0);
    __decorate$1x([Validate(OPT_CROSSLINE_TYPE)], CartesianCrossLine.prototype, 'type', void 0);
    __decorate$1x([Validate(OPT_ARRAY(2))], CartesianCrossLine.prototype, 'range', void 0);
    __decorate$1x([Validate(OPT_COLOR_STRING)], CartesianCrossLine.prototype, 'fill', void 0);
    __decorate$1x([Validate(OPT_NUMBER(0, 1))], CartesianCrossLine.prototype, 'fillOpacity', void 0);
    __decorate$1x([Validate(OPT_COLOR_STRING)], CartesianCrossLine.prototype, 'stroke', void 0);
    __decorate$1x([Validate(OPT_NUMBER())], CartesianCrossLine.prototype, 'strokeWidth', void 0);
    __decorate$1x([Validate(OPT_NUMBER(0, 1))], CartesianCrossLine.prototype, 'strokeOpacity', void 0);
    __decorate$1x([Validate(OPT_LINE_DASH)], CartesianCrossLine.prototype, 'lineDash', void 0);
    return CartesianCrossLine;
})();

var __extends$2f =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$F =
    (undefined && undefined.__assign) ||
    function () {
        __assign$F =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$F.apply(this, arguments);
    };
var __decorate$1w =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var CartesianAxis = /** @class */ (function (_super) {
    __extends$2f(CartesianAxis, _super);
    function CartesianAxis() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.thickness = 0;
        _this.position = 'left';
        return _this;
    }
    Object.defineProperty(CartesianAxis.prototype, 'direction', {
        get: function () {
            return ['top', 'bottom'].includes(this.position) ? ChartAxisDirection.X : ChartAxisDirection.Y;
        },
        enumerable: false,
        configurable: true,
    });
    CartesianAxis.prototype.updateDirection = function () {
        switch (this.position) {
            case 'top':
                this.rotation = -90;
                this.label.mirrored = true;
                this.label.parallel = true;
                break;
            case 'right':
                this.rotation = 0;
                this.label.mirrored = true;
                this.label.parallel = false;
                break;
            case 'bottom':
                this.rotation = -90;
                this.label.mirrored = false;
                this.label.parallel = true;
                break;
            case 'left':
                this.rotation = 0;
                this.label.mirrored = false;
                this.label.parallel = false;
                break;
        }
        if (this.axisContext) {
            this.axisContext.position = this.position;
            this.axisContext.direction = this.direction;
        }
    };
    CartesianAxis.prototype.update = function (primaryTickCount) {
        this.updateDirection();
        return _super.prototype.update.call(this, primaryTickCount);
    };
    CartesianAxis.prototype.createAxisContext = function () {
        return __assign$F(__assign$F({}, _super.prototype.createAxisContext.call(this)), { position: this.position });
    };
    CartesianAxis.prototype.assignCrossLineArrayConstructor = function (crossLines) {
        assignJsonApplyConstructedArray(crossLines, CartesianCrossLine);
    };
    __decorate$1w([Validate(NUMBER(0))], CartesianAxis.prototype, 'thickness', void 0);
    __decorate$1w([Validate(POSITION)], CartesianAxis.prototype, 'position', void 0);
    return CartesianAxis;
})(Axis);

var __extends$2e =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1v =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$k =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$G =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$n =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var CategoryAxis = /** @class */ (function (_super) {
    __extends$2e(CategoryAxis, _super);
    function CategoryAxis(moduleCtx) {
        var _this = _super.call(this, moduleCtx, new BandScale$5()) || this;
        _this._paddingOverrideEnabled = false;
        _this.groupPaddingInner = 0.1;
        _this.includeInvisibleDomains = true;
        return _this;
    }
    Object.defineProperty(CategoryAxis.prototype, 'paddingInner', {
        get: function () {
            this._paddingOverrideEnabled = true;
            return this.scale.paddingInner;
        },
        set: function (value) {
            this._paddingOverrideEnabled = true;
            this.scale.paddingInner = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(CategoryAxis.prototype, 'paddingOuter', {
        get: function () {
            return this.scale.paddingOuter;
        },
        set: function (value) {
            this.scale.paddingOuter = value;
        },
        enumerable: false,
        configurable: true,
    });
    CategoryAxis.prototype.normaliseDataDomain = function (d) {
        var e_1, _a;
        var _b;
        var _c;
        // Prevent duplicate categories.
        var valuesSet = {};
        try {
            for (var d_1 = __values$k(d), d_1_1 = d_1.next(); !d_1_1.done; d_1_1 = d_1.next()) {
                var next = d_1_1.value;
                (_b = valuesSet[(_c = String(next))]) !== null && _b !== void 0 ? _b : (valuesSet[_c] = next);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (d_1_1 && !d_1_1.done && (_a = d_1.return)) _a.call(d_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return Object.values(valuesSet);
    };
    CategoryAxis.prototype.calculateDomain = function () {
        if (!this._paddingOverrideEnabled) {
            var boundSeries = this.boundSeries;
            var paddings = boundSeries
                .map(function (s) {
                    var _a;
                    return (_a = s.getBandScalePadding) === null || _a === void 0 ? void 0 : _a.call(s);
                })
                .filter(function (p) {
                    return p != null;
                });
            if (paddings.length > 0) {
                this.scale.paddingInner = Math.min.apply(
                    Math,
                    __spreadArray$n(
                        [],
                        __read$G(
                            paddings.map(function (p) {
                                return p.inner;
                            }),
                        ),
                    ),
                );
                this.scale.paddingOuter = Math.max.apply(
                    Math,
                    __spreadArray$n(
                        [],
                        __read$G(
                            paddings.map(function (p) {
                                return p.outer;
                            }),
                        ),
                    ),
                );
            }
        }
        return _super.prototype.calculateDomain.call(this);
    };
    CategoryAxis.className = 'CategoryAxis';
    CategoryAxis.type = 'category';
    __decorate$1v([Validate(NUMBER(0, 1))], CategoryAxis.prototype, 'groupPaddingInner', void 0);
    return CategoryAxis;
})(CartesianAxis);

/**
 * The tree layout is calculated in abstract x/y coordinates, where the root is at (0, 0)
 * and the tree grows downward from the root.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode(label, parent, number) {
        if (label === void 0) {
            label = '';
        }
        if (number === void 0) {
            number = 0;
        }
        this.x = 0;
        this.y = 0;
        this.subtreeLeft = NaN;
        this.subtreeRight = NaN;
        this.screenX = 0;
        this.screenY = 0;
        this.children = [];
        this.leafCount = 0;
        this.prelim = 0;
        this.mod = 0;
        this.ancestor = this;
        this.change = 0;
        this.shift = 0;
        this.label = label;
        // screenX and screenY are meant to be recomputed from (layout) x and y
        // when the tree is resized (without performing another layout)
        this.parent = parent;
        this.depth = parent ? parent.depth + 1 : 0;
        this.number = number;
    }
    TreeNode.prototype.getLeftSibling = function () {
        return this.number > 0 && this.parent ? this.parent.children[this.number - 1] : undefined;
    };
    TreeNode.prototype.getLeftmostSibling = function () {
        return this.number > 0 && this.parent ? this.parent.children[0] : undefined;
    };
    // traverse the left contour of a subtree, return the successor of v on this contour
    TreeNode.prototype.nextLeft = function () {
        return this.children ? this.children[0] : this.thread;
    };
    // traverse the right contour of a subtree, return the successor of v on this contour
    TreeNode.prototype.nextRight = function () {
        return this.children ? this.children[this.children.length - 1] : this.thread;
    };
    TreeNode.prototype.getSiblings = function () {
        var _this = this;
        return this.parent
            ? this.parent.children.filter(function (_, i) {
                  return i !== _this.number;
              })
            : [];
    };
    return TreeNode;
})();
/**
 * Converts an array of ticks, where each tick has an array of labels, to a label tree.
 * If `pad` is `true`, will ensure that every branch matches the depth of the tree by
 * creating empty labels.
 */
function ticksToTree(ticks, pad) {
    if (pad === void 0) {
        pad = true;
    }
    var root = new TreeNode();
    var depth = 0;
    if (pad) {
        ticks.forEach(function (tick) {
            return (depth = Math.max(depth, tick.labels.length));
        });
    }
    ticks.forEach(function (tick) {
        if (pad) {
            while (tick.labels.length < depth) {
                tick.labels.unshift('');
            }
        }
        insertTick(root, tick);
    });
    return root;
}
function insertTick(root, tick) {
    var pathParts = tick.labels.slice().reverse(); // path elements from root to leaf label
    var lastPartIndex = pathParts.length - 1;
    pathParts.forEach(function (pathPart, partIndex) {
        var children = root.children;
        var existingNode = children.find(function (child) {
            return child.label === pathPart;
        });
        var isNotLeaf = partIndex !== lastPartIndex;
        if (existingNode && isNotLeaf) {
            // the isNotLeaf check is to allow duplicate leafs
            root = existingNode;
        } else {
            var node = new TreeNode(pathPart, root);
            node.number = children.length;
            children.push(node);
            if (isNotLeaf) {
                root = node;
            }
        }
    });
}
// Shift the subtree.
function moveSubtree(wm, wp, shift) {
    var subtrees = wp.number - wm.number;
    var ratio = shift / subtrees;
    wp.change -= ratio;
    wp.shift += shift;
    wm.change += ratio;
    wp.prelim += shift;
    wp.mod += shift;
}
function ancestor(vim, v, defaultAncestor) {
    return v.getSiblings().indexOf(vim.ancestor) >= 0 ? vim.ancestor : defaultAncestor;
}
// Spaces out the children.
function executeShifts(v) {
    var children = v.children;
    if (children) {
        var shift = 0;
        var change = 0;
        for (var i = children.length - 1; i >= 0; i--) {
            var w = children[i];
            w.prelim += shift;
            w.mod += shift;
            change += w.change;
            shift += w.shift + change;
        }
    }
}
// Moves current subtree with v as the root if some nodes are conflicting in space.
function apportion(v, defaultAncestor, distance) {
    var w = v.getLeftSibling();
    if (w) {
        var vop = v;
        var vip = v;
        var vim = w;
        var vom = vip.getLeftmostSibling();
        var sip = vip.mod;
        var sop = vop.mod;
        var sim = vim.mod;
        var som = vom.mod;
        while (vim.nextRight() && vip.nextLeft()) {
            vim = vim.nextRight();
            vip = vip.nextLeft();
            vom = vom.nextLeft();
            vop = vop.nextRight();
            vop.ancestor = v;
            var shift = vim.prelim + sim - (vip.prelim + sip) + distance;
            if (shift > 0) {
                moveSubtree(ancestor(vim, v, defaultAncestor), v, shift);
                sip += shift;
                sop += shift;
            }
            sim += vim.mod;
            sip += vip.mod;
            som += vom.mod;
            sop += vop.mod;
        }
        if (vim.nextRight() && !vop.nextRight()) {
            vop.thread = vim.nextRight();
            vop.mod += sim - sop;
        } else {
            if (vip.nextLeft() && !vom.nextLeft()) {
                vom.thread = vip.nextLeft();
                vom.mod += sip - som;
            }
            defaultAncestor = v;
        }
    }
    return defaultAncestor;
}
// Compute the preliminary x-coordinate of node and its children (recursively).
function firstWalk(node, distance) {
    var children = node.children;
    if (children.length) {
        var defaultAncestor_1 = children[0];
        children.forEach(function (child) {
            firstWalk(child, distance);
            defaultAncestor_1 = apportion(child, defaultAncestor_1, distance);
        });
        executeShifts(node);
        var midpoint = (children[0].prelim + children[children.length - 1].prelim) / 2;
        var leftSibling = node.getLeftSibling();
        if (leftSibling) {
            node.prelim = leftSibling.prelim + distance;
            node.mod = node.prelim - midpoint;
        } else {
            node.prelim = midpoint;
        }
    } else {
        var leftSibling = node.getLeftSibling();
        node.prelim = leftSibling ? leftSibling.prelim + distance : 0;
    }
}
var Dimensions = /** @class */ (function () {
    function Dimensions() {
        this.top = Infinity;
        this.right = -Infinity;
        this.bottom = -Infinity;
        this.left = Infinity;
    }
    Dimensions.prototype.update = function (node, xy) {
        var _a = xy(node),
            x = _a.x,
            y = _a.y;
        if (x > this.right) {
            this.right = x;
        }
        if (x < this.left) {
            this.left = x;
        }
        if (y > this.bottom) {
            this.bottom = y;
        }
        if (y < this.top) {
            this.top = y;
        }
    };
    return Dimensions;
})();
function secondWalk(v, m, layout) {
    v.x = v.prelim + m;
    v.y = v.depth;
    layout.update(v);
    v.children.forEach(function (w) {
        return secondWalk(w, m + v.mod, layout);
    });
}
// After the second walk the parent nodes are positioned at the center of their immediate children.
// If we want the parent nodes to be positioned at the center of the subtree for which they are roots,
// we need a third walk to adjust the positions.
function thirdWalk(v) {
    var children = v.children;
    var leafCount = 0;
    children.forEach(function (w) {
        thirdWalk(w);
        if (w.children.length) {
            leafCount += w.leafCount;
        } else {
            leafCount++;
        }
    });
    v.leafCount = leafCount;
    if (children.length) {
        v.subtreeLeft = children[0].subtreeLeft;
        v.subtreeRight = children[v.children.length - 1].subtreeRight;
        v.x = (v.subtreeLeft + v.subtreeRight) / 2;
    } else {
        v.subtreeLeft = v.x;
        v.subtreeRight = v.x;
    }
}
function treeLayout(root) {
    var layout = new TreeLayout();
    firstWalk(root, 1);
    secondWalk(root, -root.prelim, layout);
    thirdWalk(root);
    return layout;
}
var TreeLayout = /** @class */ (function () {
    function TreeLayout() {
        this.dimensions = new Dimensions();
        this.leafCount = 0;
        this.nodes = [];
        // One might want to process leaf nodes separately from the rest of the tree.
        // For example, position labels corresponding to leafs vertically, rather than horizontally.
        this.leafNodes = [];
        this.nonLeafNodes = [];
        this.depth = 0;
    }
    TreeLayout.prototype.update = function (node) {
        this.dimensions.update(node, function (node) {
            return { x: node.x, y: node.y };
        });
        if (!node.children.length) {
            this.leafCount++;
            this.leafNodes.push(node);
        } else {
            this.nonLeafNodes.push(node);
        }
        if (node.depth > this.depth) {
            this.depth = node.depth;
        }
        this.nodes.push(node);
    };
    TreeLayout.prototype.resize = function (width, height, shiftX, shiftY, flipX) {
        if (shiftX === void 0) {
            shiftX = 0;
        }
        if (shiftY === void 0) {
            shiftY = 0;
        }
        if (flipX === void 0) {
            flipX = false;
        }
        var xSteps = this.leafCount - 1;
        var ySteps = this.depth;
        var dimensions = this.dimensions;
        var scalingX = 1;
        var scalingY = 1;
        if (width > 0 && xSteps) {
            var existingSpacingX = (dimensions.right - dimensions.left) / xSteps;
            var desiredSpacingX = width / xSteps;
            scalingX = desiredSpacingX / existingSpacingX;
            if (flipX) {
                scalingX = -scalingX;
            }
        }
        if (height > 0 && ySteps) {
            var existingSpacingY = (dimensions.bottom - dimensions.top) / ySteps;
            var desiredSpacingY = height / ySteps;
            scalingY = desiredSpacingY / existingSpacingY;
        }
        var screenDimensions = new Dimensions();
        this.nodes.forEach(function (node) {
            node.screenX = node.x * scalingX;
            node.screenY = node.y * scalingY;
            screenDimensions.update(node, function (node) {
                return { x: node.screenX, y: node.screenY };
            });
        });
        // Normalize so that root top and leftmost leaf left start at zero.
        var offsetX = -screenDimensions.left;
        var offsetY = -screenDimensions.top;
        this.nodes.forEach(function (node) {
            node.screenX += offsetX + shiftX;
            node.screenY += offsetY + shiftY;
        });
    };
    return TreeLayout;
})();

var __extends$2d =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1u =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$F =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$m =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var GroupedCategoryAxisLabel = /** @class */ (function (_super) {
    __extends$2d(GroupedCategoryAxisLabel, _super);
    function GroupedCategoryAxisLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.grid = false;
        return _this;
    }
    __decorate$1u([Validate(BOOLEAN)], GroupedCategoryAxisLabel.prototype, 'grid', void 0);
    return GroupedCategoryAxisLabel;
})(AxisLabel);
var GroupedCategoryAxis = /** @class */ (function (_super) {
    __extends$2d(GroupedCategoryAxis, _super);
    function GroupedCategoryAxis(moduleCtx) {
        var _this = _super.call(this, moduleCtx, new BandScale$5()) || this;
        // Label scale (labels are positioned between ticks, tick count = label count + 1).
        // We don't call is `labelScale` for consistency with other axes.
        _this.tickScale = new BandScale$5();
        _this.translation = {
            x: 0,
            y: 0,
        };
        _this.line = new AxisLine();
        _this.label = new GroupedCategoryAxisLabel();
        /**
         * The color of the labels.
         * Use `undefined` rather than `rgba(0, 0, 0, 0)` to make labels invisible.
         */
        _this.labelColor = 'rgba(87, 87, 87, 1)';
        _this.includeInvisibleDomains = true;
        var _a = _this,
            tickLineGroup = _a.tickLineGroup,
            tickLabelGroup = _a.tickLabelGroup,
            gridLineGroup = _a.gridLineGroup,
            tickScale = _a.tickScale,
            scale = _a.scale;
        scale.paddingOuter = 0.1;
        scale.paddingInner = scale.paddingOuter * 2;
        _this.range = scale.range.slice();
        _this.refreshScale();
        tickScale.paddingInner = 1;
        tickScale.paddingOuter = 0;
        _this.gridLineSelection = Selection.select(gridLineGroup, Line);
        _this.axisLineSelection = Selection.select(tickLineGroup, Line);
        _this.separatorSelection = Selection.select(tickLineGroup, Line);
        _this.labelSelection = Selection.select(tickLabelGroup, Text);
        return _this;
    }
    GroupedCategoryAxis.prototype.updateRange = function () {
        var _a = this,
            rr = _a.range,
            vr = _a.visibleRange,
            scale = _a.scale;
        var span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        var shift = span * vr[0];
        var start = rr[0] - shift;
        this.tickScale.range = scale.range = [start, start + span];
        this.resizeTickTree();
    };
    GroupedCategoryAxis.prototype.resizeTickTree = function () {
        var _a;
        var s = this.scale;
        var range = s.domain.length ? [s.convert(s.domain[0]), s.convert(s.domain[s.domain.length - 1])] : s.range;
        var layout = this.tickTreeLayout;
        var lineHeight = this.lineHeight;
        if (layout) {
            layout.resize(
                Math.abs(range[1] - range[0]),
                layout.depth * lineHeight,
                (Math.min(range[0], range[1]) || 0) + ((_a = s.bandwidth) !== null && _a !== void 0 ? _a : 0) / 2,
                -layout.depth * lineHeight,
                range[1] - range[0] < 0,
            );
        }
    };
    Object.defineProperty(GroupedCategoryAxis.prototype, 'lineHeight', {
        get: function () {
            return this.label.fontSize * 1.5;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(GroupedCategoryAxis.prototype, 'gridLength', {
        get: function () {
            return this._gridLength;
        },
        /**
         * The length of the grid. The grid is only visible in case of a non-zero value.
         */
        set: function (value) {
            // Was visible and now invisible, or was invisible and now visible.
            if ((this._gridLength && !value) || (!this._gridLength && value)) {
                this.gridLineSelection.clear();
                this.labelSelection.clear();
            }
            this._gridLength = value;
        },
        enumerable: false,
        configurable: true,
    });
    GroupedCategoryAxis.prototype.calculateDomain = function () {
        var _a;
        var _b;
        var _c = this,
            direction = _c.direction,
            boundSeries = _c.boundSeries;
        var domains = [];
        var isNumericX = undefined;
        boundSeries
            .filter(function (s) {
                return s.visible;
            })
            .forEach(function (series) {
                if (direction === ChartAxisDirection.X) {
                    if (isNumericX === undefined) {
                        // always add first X domain
                        var domain_1 = series.getDomain(direction);
                        domains.push(domain_1);
                        isNumericX = typeof domain_1[0] === 'number';
                    } else if (isNumericX) {
                        // only add further X domains if the axis is numeric
                        domains.push(series.getDomain(direction));
                    }
                } else {
                    domains.push(series.getDomain(direction));
                }
            });
        var domain = (_a = new Array()).concat.apply(_a, __spreadArray$m([], __read$F(domains)));
        var values = (_b = extent$4(domain)) !== null && _b !== void 0 ? _b : domain;
        this.dataDomain = this.normaliseDataDomain(values);
        this.scale.domain = this.dataDomain;
    };
    GroupedCategoryAxis.prototype.normaliseDataDomain = function (d) {
        // Prevent duplicate categories.
        var values = d.filter(function (s, i, arr) {
            return arr.indexOf(s) === i;
        });
        var tickTree = ticksToTree(values);
        this.tickTreeLayout = treeLayout(tickTree);
        var tickScaleDomain = values.slice();
        tickScaleDomain.push('');
        this.tickScale.domain = tickScaleDomain;
        this.resizeTickTree();
        return values;
    };
    /**
     * Creates/removes/updates the scene graph nodes that constitute the axis.
     * Supposed to be called _manually_ after changing _any_ of the axis properties.
     * This allows to bulk set axis properties before updating the nodes.
     * The node changes made by this method are rendered on the next animation frame.
     * We could schedule this method call automatically on the next animation frame
     * when any of the axis properties change (the way we do when properties of scene graph's
     * nodes change), but this will mean that we first wait for the next animation
     * frame to make changes to the nodes of the axis, then wait for another animation
     * frame to render those changes. It's nice to have everything update automatically,
     * but this extra level of async indirection will not just introduce an unwanted delay,
     * it will also make it harder to reason about the program.
     */
    GroupedCategoryAxis.prototype.update = function (primaryTickCount) {
        var _this = this;
        this.updateDirection();
        this.calculateDomain();
        this.updateRange();
        var _a = this,
            scale = _a.scale,
            label = _a.label,
            parallel = _a.label.parallel,
            callbackCache = _a.moduleCtx.callbackCache,
            tickScale = _a.tickScale,
            requestedRange = _a.range,
            title = _a.title,
            _b = _a.title,
            _c = _b === void 0 ? {} : _b,
            _d = _c.formatter,
            formatter =
                _d === void 0
                    ? function (p) {
                          return p.defaultValue;
                      }
                    : _d,
            _titleCaption = _a._titleCaption;
        var rangeStart = scale.range[0];
        var rangeEnd = scale.range[1];
        var rangeLength = Math.abs(rangeEnd - rangeStart);
        var bandwidth = rangeLength / scale.domain.length || 0;
        var rotation = toRadians$1(this.rotation);
        var isHorizontal = Math.abs(Math.cos(rotation)) < 1e-8;
        var sideFlag = label.getSideFlag();
        this.updatePosition({ rotation: rotation, sideFlag: sideFlag });
        // The Text `node` of the Caption is not used to render the title of the grouped category axis.
        // The phantom root of the tree layout is used instead.
        _titleCaption.node.visible = false;
        var lineHeight = this.lineHeight;
        // Render ticks and labels.
        var tickTreeLayout = this.tickTreeLayout;
        var labels = scale.ticks();
        var treeLabels = tickTreeLayout ? tickTreeLayout.nodes : [];
        var isLabelTree = tickTreeLayout ? tickTreeLayout.depth > 1 : false;
        var ticks = tickScale.ticks();
        // When labels are parallel to the axis line, the `parallelFlipFlag` is used to
        // flip the labels to avoid upside-down text, when the axis is rotated
        // such that it is in the right hemisphere, i.e. the angle of rotation
        // is in the [0, π] interval.
        // The rotation angle is normalized, so that we have an easier time checking
        // if it's in the said interval. Since the axis is always rendered vertically
        // and then rotated, zero rotation means 12 (not 3) o-clock.
        // -1 = flip
        //  1 = don't flip (default)
        var _e = calculateLabelRotation({
                rotation: label.rotation,
                parallel: parallel,
                regularFlipRotation: normalizeAngle360(rotation - Math.PI / 2),
                parallelFlipRotation: normalizeAngle360(rotation),
            }),
            defaultRotation = _e.defaultRotation,
            configuredRotation = _e.configuredRotation,
            parallelFlipFlag = _e.parallelFlipFlag;
        var gridLineSelection = this.gridLineSelection.update(this.gridLength ? ticks : []);
        var labelSelection = this.labelSelection.update(treeLabels);
        var labelFormatter = label.formatter;
        var labelBBoxes = new Map();
        var maxLeafLabelWidth = 0;
        labelSelection.each(function (node, datum, index) {
            var _a;
            node.fontStyle = label.fontStyle;
            node.fontWeight = label.fontWeight;
            node.fontSize = label.fontSize;
            node.fontFamily = label.fontFamily;
            node.fill = label.color;
            node.textBaseline = parallelFlipFlag === -1 ? 'bottom' : 'hanging';
            node.textAlign = 'center';
            node.translationX = datum.screenY - label.fontSize * 0.25;
            node.translationY = datum.screenX;
            if (index === 0) {
                // use the phantom root as the axis title
                if ((title === null || title === void 0 ? void 0 : title.enabled) && labels.length > 0) {
                    node.visible = true;
                    node.text = callbackCache.call(formatter, _this.getTitleFormatterParams());
                    node.fontSize = title.fontSize;
                    node.fontStyle = title.fontStyle;
                    node.fontWeight = title.fontWeight;
                    node.fontFamily = title.fontFamily;
                    node.textBaseline = 'hanging';
                } else {
                    node.visible = false;
                }
            } else if (labelFormatter) {
                node.text =
                    (_a = callbackCache.call(labelFormatter, {
                        value: String(datum.label),
                        index: index,
                    })) !== null && _a !== void 0
                        ? _a
                        : String(datum.label);
                node.visible = datum.screenX >= requestedRange[0] && datum.screenX <= requestedRange[1];
            } else {
                node.text = String(datum.label);
                node.visible = datum.screenX >= requestedRange[0] && datum.screenX <= requestedRange[1];
            }
            var bbox = node.computeBBox();
            labelBBoxes.set(node.id, bbox);
            if (bbox.width > maxLeafLabelWidth) {
                maxLeafLabelWidth = bbox.width;
            }
        });
        var labelX = sideFlag * label.padding;
        var labelGrid = this.label.grid;
        var separatorData = [];
        labelSelection.each(function (label, datum, index) {
            label.x = labelX;
            label.rotationCenterX = labelX;
            if (!datum.children.length) {
                label.rotation = configuredRotation;
                label.textAlign = 'end';
                label.textBaseline = 'middle';
                var bbox = labelBBoxes.get(label.id);
                if (bbox && bbox.height > bandwidth) {
                    label.visible = false;
                }
            } else {
                label.translationX -= maxLeafLabelWidth - lineHeight + _this.label.padding;
                var availableRange = datum.leafCount * bandwidth;
                var bbox = labelBBoxes.get(label.id);
                if (bbox && bbox.width > availableRange) {
                    label.visible = false;
                } else if (isHorizontal) {
                    label.rotation = defaultRotation;
                } else {
                    label.rotation = -Math.PI / 2;
                }
            }
            // Calculate positions of label separators for all nodes except the root.
            // Each separator is placed to the top of the current label.
            if (datum.parent && isLabelTree) {
                var y = !datum.children.length
                    ? datum.screenX - bandwidth / 2
                    : datum.screenX - (datum.leafCount * bandwidth) / 2;
                if (!datum.children.length) {
                    if (datum.number !== datum.children.length - 1 || labelGrid) {
                        separatorData.push({
                            y: y,
                            x1: 0,
                            x2: -maxLeafLabelWidth - _this.label.padding * 2,
                            toString: function () {
                                return String(index);
                            },
                        });
                    }
                } else {
                    var x = -maxLeafLabelWidth - _this.label.padding * 2 + datum.screenY;
                    separatorData.push({
                        y: y,
                        x1: x + lineHeight,
                        x2: x,
                        toString: function () {
                            return String(index);
                        },
                    });
                }
            }
        });
        // Calculate the position of the long separator on the far bottom of the axis.
        var minX = 0;
        separatorData.forEach(function (d) {
            return (minX = Math.min(minX, d.x2));
        });
        separatorData.push({
            y: Math.max(rangeStart, rangeEnd),
            x1: 0,
            x2: minX,
            toString: function () {
                return String(separatorData.length);
            },
        });
        var separatorSelection = this.separatorSelection.update(separatorData);
        var epsilon = 0.0000001;
        separatorSelection.each(function (line, datum) {
            line.x1 = datum.x1;
            line.x2 = datum.x2;
            line.y1 = datum.y;
            line.y2 = datum.y;
            line.visible = datum.y >= requestedRange[0] - epsilon && datum.y <= requestedRange[1] + epsilon;
            line.stroke = _this.tick.color;
            line.fill = undefined;
            line.strokeWidth = 1;
        });
        this.gridLineSelection = gridLineSelection;
        this.labelSelection = labelSelection;
        // Render axis lines.
        var lineCount = tickTreeLayout ? tickTreeLayout.depth + 1 : 1;
        var lines = [];
        for (var i = 0; i < lineCount; i++) {
            lines.push(i);
        }
        var axisLineSelection = this.axisLineSelection.update(lines);
        axisLineSelection.each(function (line, _, index) {
            var x = index > 0 ? -maxLeafLabelWidth - _this.label.padding * 2 - (index - 1) * lineHeight : 0;
            line.x1 = x;
            line.x2 = x;
            line.y1 = requestedRange[0];
            line.y2 = requestedRange[1];
            line.strokeWidth = _this.line.width;
            line.stroke = _this.line.color;
            line.visible = labels.length > 0 && (index === 0 || (labelGrid && isLabelTree));
        });
        if (this.gridLength) {
            var styles_1 = this.gridStyle;
            var styleCount_1 = styles_1.length;
            gridLineSelection.each(function (line, datum, index) {
                var y = Math.round(tickScale.convert(datum));
                line.x1 = 0;
                line.x2 = -sideFlag * _this.gridLength;
                line.y1 = y;
                line.y2 = y;
                line.visible = y >= requestedRange[0] && y <= requestedRange[1];
                var style = styles_1[index % styleCount_1];
                line.stroke = style.stroke;
                line.strokeWidth = _this.tick.width;
                line.lineDash = style.lineDash;
                line.fill = undefined;
            });
        }
        return primaryTickCount;
    };
    GroupedCategoryAxis.className = 'GroupedCategoryAxis';
    GroupedCategoryAxis.type = 'groupedCategory';
    __decorate$1u([Validate(OPT_COLOR_STRING)], GroupedCategoryAxis.prototype, 'labelColor', void 0);
    return GroupedCategoryAxis;
})(CartesianAxis);

var __extends$2c =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$E =
    (undefined && undefined.__assign) ||
    function () {
        __assign$E =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$E.apply(this, arguments);
    };
var __awaiter$a =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$a =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __values$j =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$E =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var directions = ['top', 'right', 'bottom', 'left'];
var CartesianChart = /** @class */ (function (_super) {
    __extends$2c(CartesianChart, _super);
    function CartesianChart(document, overrideDevicePixelRatio, resources) {
        if (document === void 0) {
            document = window.document;
        }
        var _this = _super.call(this, document, overrideDevicePixelRatio, resources) || this;
        /** Integrated Charts feature state - not used in Standalone Charts. */
        _this.paired = true;
        _this._lastAxisWidths = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
        };
        _this._lastVisibility = {
            crossLines: true,
            series: true,
        };
        return _this;
    }
    CartesianChart.prototype.performLayout = function () {
        return __awaiter$a(this, void 0, void 0, function () {
            var shrinkRect,
                _a,
                seriesRect,
                visibility,
                clipSeries,
                _b,
                seriesRoot,
                seriesAreaPadding,
                seriesPaddedRect,
                hoverRectPadding,
                hoverRect;
            return __generator$a(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        return [4 /*yield*/, _super.prototype.performLayout.call(this)];
                    case 1:
                        shrinkRect = _c.sent();
                        (_a = this.updateAxes(shrinkRect)),
                            (seriesRect = _a.seriesRect),
                            (visibility = _a.visibility),
                            (clipSeries = _a.clipSeries);
                        this.seriesRoot.visible = visibility.series;
                        this.seriesRect = seriesRect;
                        this.seriesRoot.translationX = Math.floor(seriesRect.x);
                        this.seriesRoot.translationY = Math.floor(seriesRect.y);
                        (_b = this), (seriesRoot = _b.seriesRoot), (seriesAreaPadding = _b.seriesAreaPadding);
                        seriesPaddedRect = seriesRect.clone().grow({
                            top: seriesAreaPadding.top,
                            right: seriesAreaPadding.right,
                            bottom: seriesAreaPadding.bottom,
                            left: seriesAreaPadding.left,
                        });
                        hoverRectPadding = 20;
                        hoverRect = seriesPaddedRect.clone().grow(hoverRectPadding);
                        this.hoverRect = hoverRect;
                        this.layoutService.dispatchLayoutComplete({
                            type: 'layout-complete',
                            chart: { width: this.scene.width, height: this.scene.height },
                            series: {
                                rect: seriesRect,
                                paddedRect: seriesPaddedRect,
                                hoverRect: hoverRect,
                                visible: visibility.series,
                            },
                            axes: this.axes.map(function (axis) {
                                return __assign$E({ id: axis.id }, axis.getLayoutState());
                            }),
                        });
                        if (clipSeries) {
                            seriesRoot.setClipRectInGroupCoordinateSpace(seriesRect);
                        } else {
                            seriesRoot.setClipRectInGroupCoordinateSpace();
                        }
                        return [2 /*return*/, shrinkRect];
                }
            });
        });
    };
    CartesianChart.prototype.updateAxes = function (inputShrinkRect) {
        var e_1, _a;
        var _b;
        // Start with a good approximation from the last update - this should mean that in many resize
        // cases that only a single pass is needed \o/.
        var axisWidths = __assign$E({}, this._lastAxisWidths);
        var visibility = __assign$E({}, this._lastVisibility);
        // Clean any positions which aren't valid with the current axis status (otherwise we end up
        // never being able to find a stable result).
        var liveAxisWidths = new Set(
            this._axes.map(function (a) {
                return a.position;
            }),
        );
        try {
            for (var _c = __values$j(Object.keys(axisWidths)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var position = _d.value;
                if (!liveAxisWidths.has(position)) {
                    delete axisWidths[position];
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        var stableOutputs = function (otherAxisWidths, otherVisibility) {
            // Check for new axis positions.
            if (
                Object.keys(otherAxisWidths).some(function (k) {
                    return axisWidths[k] == null;
                })
            ) {
                return false;
            }
            return (
                visibility.crossLines === otherVisibility.crossLines &&
                visibility.series === otherVisibility.series &&
                // Check for existing axis positions and equality.
                Object.entries(axisWidths).every(function (_a) {
                    var _b = __read$E(_a, 2),
                        p = _b[0],
                        w = _b[1];
                    var otherW = otherAxisWidths[p];
                    if (w != null || otherW != null) {
                        return w === otherW;
                    }
                    return true;
                })
            );
        };
        var ceilValues = function (records) {
            return Object.entries(records).reduce(function (out, _a) {
                var _b = __read$E(_a, 2),
                    key = _b[0],
                    value = _b[1];
                if (value && Math.abs(value) === Infinity) {
                    value = 0;
                }
                out[key] = value != null ? Math.ceil(value) : value;
                return out;
            }, {});
        };
        // Iteratively try to resolve axis widths - since X axis width affects Y axis range,
        // and vice-versa, we need to iteratively try and find a fit for the axes and their
        // ticks/labels.
        var lastPassAxisWidths = {};
        var lastPassVisibility = {};
        var clipSeries = false;
        var seriesRect = (_b = this.seriesRect) === null || _b === void 0 ? void 0 : _b.clone();
        var count = 0;
        do {
            Object.assign(axisWidths, lastPassAxisWidths);
            Object.assign(visibility, lastPassVisibility);
            var result = this.updateAxesPass(axisWidths, inputShrinkRect.clone(), seriesRect);
            lastPassAxisWidths = ceilValues(result.axisWidths);
            lastPassVisibility = result.visibility;
            clipSeries = result.clipSeries;
            seriesRect = result.seriesRect;
            if (count++ > 10) {
                Logger.warn('unable to find stable axis layout.');
                break;
            }
        } while (!stableOutputs(lastPassAxisWidths, lastPassVisibility));
        var clipRectPadding = 5;
        this.axes.forEach(function (axis) {
            // update visibility of crosslines
            axis.setCrossLinesVisible(visibility.crossLines);
            if (!seriesRect) {
                return;
            }
            axis.clipGrid(
                seriesRect.x,
                seriesRect.y,
                seriesRect.width + clipRectPadding,
                seriesRect.height + clipRectPadding,
            );
            switch (axis.position) {
                case 'left':
                case 'right':
                    axis.clipTickLines(
                        inputShrinkRect.x,
                        seriesRect.y,
                        inputShrinkRect.width + clipRectPadding,
                        seriesRect.height + clipRectPadding,
                    );
                    break;
                case 'top':
                case 'bottom':
                    axis.clipTickLines(
                        seriesRect.x,
                        inputShrinkRect.y,
                        seriesRect.width + clipRectPadding,
                        inputShrinkRect.height + clipRectPadding,
                    );
                    break;
            }
        });
        this._lastAxisWidths = axisWidths;
        this._lastVisibility = visibility;
        return { seriesRect: seriesRect, visibility: visibility, clipSeries: clipSeries };
    };
    CartesianChart.prototype.updateAxesPass = function (axisWidths, bounds, lastPassSeriesRect) {
        var _this = this;
        var axes = this.axes;
        var visited = {};
        var newAxisWidths = {};
        var visibility = {
            series: true,
            crossLines: true,
        };
        var clipSeries = false;
        var primaryTickCounts = {};
        var paddedBounds = this.applySeriesPadding(bounds);
        var crossLinePadding = lastPassSeriesRect ? this.buildCrossLinePadding(axisWidths) : {};
        var axisBound = this.buildAxisBound(paddedBounds, axisWidths, crossLinePadding, visibility);
        var seriesRect = this.buildSeriesRect(axisBound, axisWidths);
        // Set the number of ticks for continuous axes based on the available range
        // before updating the axis domain via `this.updateAxes()` as the tick count has an effect on the calculated `nice` domain extent
        axes.forEach(function (axis) {
            var _a, _b;
            var _c = axis.position,
                position = _c === void 0 ? 'left' : _c;
            var _d = _this.calculateAxisDimensions({
                    axis: axis,
                    seriesRect: seriesRect,
                    paddedBounds: paddedBounds,
                    axisWidths: axisWidths,
                    newAxisWidths: newAxisWidths,
                    primaryTickCounts: primaryTickCounts,
                    clipSeries: clipSeries,
                    addInterAxisPadding: ((_a = visited[position]) !== null && _a !== void 0 ? _a : 0) > 0,
                }),
                newClipSeries = _d.clipSeries,
                axisThickness = _d.axisThickness,
                axisOffset = _d.axisOffset;
            visited[position] = ((_b = visited[position]) !== null && _b !== void 0 ? _b : 0) + 1;
            clipSeries = clipSeries || newClipSeries;
            _this.positionAxis({
                axis: axis,
                axisBound: axisBound,
                axisOffset: axisOffset,
                axisThickness: axisThickness,
                axisWidths: axisWidths,
                primaryTickCounts: primaryTickCounts,
                seriesRect: seriesRect,
            });
        });
        return { clipSeries: clipSeries, seriesRect: seriesRect, axisWidths: newAxisWidths, visibility: visibility };
    };
    CartesianChart.prototype.buildCrossLinePadding = function (axisWidths) {
        var e_2, _a;
        var _b;
        var crossLinePadding = {};
        this.axes.forEach(function (axis) {
            if (axis.crossLines) {
                axis.crossLines.forEach(function (crossLine) {
                    crossLine.calculatePadding(crossLinePadding);
                });
            }
        });
        try {
            // Reduce cross-line padding to account for overlap with axes.
            for (var _c = __values$j(Object.entries(crossLinePadding)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var _e = __read$E(_d.value, 2),
                    side = _e[0],
                    _f = _e[1],
                    padding = _f === void 0 ? 0 : _f;
                crossLinePadding[side] = Math.max(
                    padding - ((_b = axisWidths[side]) !== null && _b !== void 0 ? _b : 0),
                    0,
                );
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        return crossLinePadding;
    };
    CartesianChart.prototype.applySeriesPadding = function (bounds) {
        var _this = this;
        var paddedRect = bounds.clone();
        var reversedAxes = this.axes.slice().reverse();
        directions.forEach(function (dir) {
            var padding = _this.seriesAreaPadding[dir];
            var axis = reversedAxes.find(function (axis) {
                return axis.position === dir;
            });
            if (axis) {
                axis.seriesAreaPadding = padding;
            } else {
                paddedRect.shrink(padding, dir);
            }
        });
        return paddedRect;
    };
    CartesianChart.prototype.buildAxisBound = function (bounds, axisWidths, crossLinePadding, visibility) {
        var _a, _b, _c, _d;
        var result = bounds.clone();
        var _e = crossLinePadding.top,
            top = _e === void 0 ? 0 : _e,
            _f = crossLinePadding.right,
            right = _f === void 0 ? 0 : _f,
            _g = crossLinePadding.bottom,
            bottom = _g === void 0 ? 0 : _g,
            _h = crossLinePadding.left,
            left = _h === void 0 ? 0 : _h;
        var horizontalPadding = left + right;
        var verticalPadding = top + bottom;
        var totalWidth =
            ((_a = axisWidths.left) !== null && _a !== void 0 ? _a : 0) +
            ((_b = axisWidths.right) !== null && _b !== void 0 ? _b : 0) +
            horizontalPadding;
        var totalHeight =
            ((_c = axisWidths.top) !== null && _c !== void 0 ? _c : 0) +
            ((_d = axisWidths.bottom) !== null && _d !== void 0 ? _d : 0) +
            verticalPadding;
        if (result.width <= totalWidth || result.height <= totalHeight) {
            // Not enough space for crossLines and series
            visibility.crossLines = false;
            visibility.series = false;
            return result;
        }
        result.x += left;
        result.y += top;
        result.width -= horizontalPadding;
        result.height -= verticalPadding;
        return result;
    };
    CartesianChart.prototype.buildSeriesRect = function (axisBound, axisWidths) {
        var result = axisBound.clone();
        var top = axisWidths.top,
            bottom = axisWidths.bottom,
            left = axisWidths.left,
            right = axisWidths.right;
        result.x += left !== null && left !== void 0 ? left : 0;
        result.y += top !== null && top !== void 0 ? top : 0;
        result.width -=
            (left !== null && left !== void 0 ? left : 0) + (right !== null && right !== void 0 ? right : 0);
        result.height -=
            (top !== null && top !== void 0 ? top : 0) + (bottom !== null && bottom !== void 0 ? bottom : 0);
        // Width and height should not be negative.
        result.width = Math.max(0, result.width);
        result.height = Math.max(0, result.height);
        return result;
    };
    CartesianChart.prototype.clampToOutsideSeriesRect = function (seriesRect, value, dimension, direction) {
        var x = seriesRect.x,
            y = seriesRect.y,
            width = seriesRect.width,
            height = seriesRect.height;
        var clampBounds = [x, y, x + width, y + height];
        var fn = direction === 1 ? Math.min : Math.max;
        var compareTo = clampBounds[(dimension === 'x' ? 0 : 1) + (direction === 1 ? 0 : 2)];
        return fn(value, compareTo);
    };
    CartesianChart.prototype.calculateAxisDimensions = function (opts) {
        var _a, _b, _c, _d, _e;
        var axis = opts.axis,
            seriesRect = opts.seriesRect,
            paddedBounds = opts.paddedBounds,
            axisWidths = opts.axisWidths,
            newAxisWidths = opts.newAxisWidths,
            primaryTickCounts = opts.primaryTickCounts,
            addInterAxisPadding = opts.addInterAxisPadding;
        var clipSeries = opts.clipSeries;
        var _f = axis.position,
            position = _f === void 0 ? 'left' : _f,
            direction = axis.direction;
        var axisLeftRightRange = function (axis) {
            if (axis instanceof CategoryAxis || axis instanceof GroupedCategoryAxis) {
                return [0, seriesRect.height];
            }
            return [seriesRect.height, 0];
        };
        var axisOffset = (_a = newAxisWidths[position]) !== null && _a !== void 0 ? _a : 0;
        switch (position) {
            case 'top':
            case 'bottom':
                axis.range = [0, seriesRect.width];
                axis.gridLength = seriesRect.height;
                break;
            case 'right':
            case 'left':
                axis.range = axisLeftRightRange(axis);
                axis.gridLength = seriesRect.width;
                break;
        }
        var zoom = this.zoomManager.getAxisZoom(axis.id);
        var _g = zoom !== null && zoom !== void 0 ? zoom : {},
            _h = _g.min,
            min = _h === void 0 ? 0 : _h,
            _j = _g.max,
            max = _j === void 0 ? 1 : _j;
        axis.visibleRange = [min, max];
        if (!clipSeries && (axis.visibleRange[0] > 0 || axis.visibleRange[1] < 1)) {
            clipSeries = true;
        }
        var primaryTickCount = axis.nice ? primaryTickCounts[direction] : undefined;
        var paddedBoundsCoefficient = 0.3;
        if (axis.thickness != null && axis.thickness > 0) {
            axis.maxThickness = axis.thickness;
        } else if (direction === ChartAxisDirection.Y) {
            axis.maxThickness = paddedBounds.width * paddedBoundsCoefficient;
        } else {
            axis.maxThickness = paddedBounds.height * paddedBoundsCoefficient;
        }
        primaryTickCount = axis.update(primaryTickCount);
        primaryTickCounts[direction] =
            (_b = primaryTickCounts[direction]) !== null && _b !== void 0 ? _b : primaryTickCount;
        var axisThickness = 0;
        if (axis.thickness != null && axis.thickness > 0) {
            axisThickness = axis.thickness;
        } else {
            var bbox = axis.computeBBox();
            axisThickness = direction === ChartAxisDirection.X ? bbox.height : bbox.width;
        }
        // for multiple axes in the same direction and position, apply padding at the top of each inner axis (i.e. between axes).
        var axisPadding = 15;
        if (addInterAxisPadding) {
            axisThickness += axisPadding;
        }
        axisThickness = Math.ceil(axisThickness);
        newAxisWidths[position] = ((_c = newAxisWidths[position]) !== null && _c !== void 0 ? _c : 0) + axisThickness;
        axis.gridPadding =
            ((_d = axisWidths[position]) !== null && _d !== void 0 ? _d : 0) -
            ((_e = newAxisWidths[position]) !== null && _e !== void 0 ? _e : 0);
        return { clipSeries: clipSeries, axisThickness: axisThickness, axisOffset: axisOffset };
    };
    CartesianChart.prototype.positionAxis = function (opts) {
        var _a, _b, _c, _d;
        var axis = opts.axis,
            axisBound = opts.axisBound,
            axisWidths = opts.axisWidths,
            seriesRect = opts.seriesRect,
            axisOffset = opts.axisOffset,
            axisThickness = opts.axisThickness;
        var position = axis.position;
        switch (position) {
            case 'top':
                axis.translation.x = axisBound.x + ((_a = axisWidths.left) !== null && _a !== void 0 ? _a : 0);
                axis.translation.y = this.clampToOutsideSeriesRect(
                    seriesRect,
                    axisBound.y + 1 + axisOffset + axisThickness,
                    'y',
                    1,
                );
                break;
            case 'bottom':
                axis.translation.x = axisBound.x + ((_b = axisWidths.left) !== null && _b !== void 0 ? _b : 0);
                axis.translation.y = this.clampToOutsideSeriesRect(
                    seriesRect,
                    axisBound.y + axisBound.height + 1 - axisThickness - axisOffset,
                    'y',
                    -1,
                );
                break;
            case 'left':
                axis.translation.y = axisBound.y + ((_c = axisWidths.top) !== null && _c !== void 0 ? _c : 0);
                axis.translation.x = this.clampToOutsideSeriesRect(
                    seriesRect,
                    axisBound.x + axisOffset + axisThickness,
                    'x',
                    1,
                );
                break;
            case 'right':
                axis.translation.y = axisBound.y + ((_d = axisWidths.top) !== null && _d !== void 0 ? _d : 0);
                axis.translation.x = this.clampToOutsideSeriesRect(
                    seriesRect,
                    axisBound.x + axisBound.width - axisThickness - axisOffset,
                    'x',
                    -1,
                );
                break;
        }
        axis.updatePosition({ rotation: toRadians$1(axis.rotation), sideFlag: axis.label.getSideFlag() });
    };
    CartesianChart.className = 'CartesianChart';
    CartesianChart.type = 'cartesian';
    return CartesianChart;
})(Chart);

var __extends$2b =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var PolarAxis = /** @class */ (function (_super) {
    __extends$2b(PolarAxis, _super);
    function PolarAxis() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.shape = 'polygon';
        return _this;
    }
    PolarAxis.prototype.computeLabelsBBox = function (_options, _seriesRect) {
        return null;
    };
    return PolarAxis;
})(Axis);

var __extends$2a =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __awaiter$9 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$9 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$D =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$l =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$i =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var PolarChart = /** @class */ (function (_super) {
    __extends$2a(PolarChart, _super);
    function PolarChart(document, overrideDevicePixelRatio, resources) {
        if (document === void 0) {
            document = window.document;
        }
        var _this = _super.call(this, document, overrideDevicePixelRatio, resources) || this;
        _this.padding = new Padding$1(40);
        return _this;
    }
    PolarChart.prototype.performLayout = function () {
        return __awaiter$9(this, void 0, void 0, function () {
            var shrinkRect, fullSeriesRect, hoverRectPadding, hoverRect;
            return __generator$9(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, _super.prototype.performLayout.call(this)];
                    case 1:
                        shrinkRect = _a.sent();
                        fullSeriesRect = shrinkRect.clone();
                        this.computeSeriesRect(shrinkRect);
                        this.computeCircle(shrinkRect);
                        this.axes.forEach(function (axis) {
                            return axis.update();
                        });
                        hoverRectPadding = 20;
                        hoverRect = shrinkRect.clone().grow(hoverRectPadding);
                        this.hoverRect = hoverRect;
                        this.layoutService.dispatchLayoutComplete({
                            type: 'layout-complete',
                            chart: { width: this.scene.width, height: this.scene.height },
                            series: {
                                rect: fullSeriesRect,
                                paddedRect: shrinkRect,
                                hoverRect: hoverRect,
                                visible: true,
                            },
                            axes: [],
                        });
                        return [2 /*return*/, shrinkRect];
                }
            });
        });
    };
    PolarChart.prototype.updateAxes = function (cx, cy, radius) {
        var _a;
        this.axes.forEach(function (axis) {
            var _a;
            if (axis.direction === ChartAxisDirection.X) {
                var rotation = toRadians$1((_a = axis.rotation) !== null && _a !== void 0 ? _a : 0);
                axis.range = [-Math.PI / 2 + rotation, (3 * Math.PI) / 2 + rotation];
                axis.gridLength = radius;
                axis.translation.x = cx;
                axis.translation.y = cy;
            } else if (axis.direction === ChartAxisDirection.Y) {
                axis.range = [radius, 0];
                axis.translation.x = cx;
                axis.translation.y = cy - radius;
            }
            axis.updateScale();
        });
        var angleAxis = this.axes.find(function (axis) {
            return axis.direction === ChartAxisDirection.X;
        });
        var scale = angleAxis === null || angleAxis === void 0 ? void 0 : angleAxis.scale;
        var angles =
            (_a = scale === null || scale === void 0 ? void 0 : scale.ticks) === null || _a === void 0
                ? void 0
                : _a.call(scale).map(function (value) {
                      return scale.convert(value);
                  });
        this.axes
            .filter(function (axis) {
                return axis instanceof PolarAxis;
            })
            .forEach(function (axis) {
                return (axis.gridAngles = angles);
            });
    };
    PolarChart.prototype.computeSeriesRect = function (shrinkRect) {
        var seriesAreaPadding = this.seriesAreaPadding;
        shrinkRect.shrink(seriesAreaPadding.left, 'left');
        shrinkRect.shrink(seriesAreaPadding.top, 'top');
        shrinkRect.shrink(seriesAreaPadding.right, 'right');
        shrinkRect.shrink(seriesAreaPadding.bottom, 'bottom');
        this.seriesRect = shrinkRect;
    };
    PolarChart.prototype.computeCircle = function (seriesBox) {
        var _this = this;
        var polarSeries = this.series.filter(function (series) {
            return series instanceof PolarSeries;
        });
        var polarAxes = this.axes.filter(function (axis) {
            return axis instanceof PolarAxis;
        });
        var setSeriesCircle = function (cx, cy, r) {
            _this.updateAxes(cx, cy, r);
            polarSeries.forEach(function (series) {
                series.centerX = cx;
                series.centerY = cy;
                series.radius = r;
            });
            var pieSeries = polarSeries.filter(function (series) {
                return series instanceof PieSeries;
            });
            if (pieSeries.length > 1) {
                var innerRadii = pieSeries
                    .map(function (series) {
                        var innerRadius = series.getInnerRadius();
                        return { series: series, innerRadius: innerRadius };
                    })
                    .sort(function (a, b) {
                        return a.innerRadius - b.innerRadius;
                    });
                innerRadii[innerRadii.length - 1].series.surroundingRadius = undefined;
                for (var i = 0; i < innerRadii.length - 1; i++) {
                    innerRadii[i].series.surroundingRadius = innerRadii[i + 1].innerRadius;
                }
            }
        };
        var centerX = seriesBox.x + seriesBox.width / 2;
        var centerY = seriesBox.y + seriesBox.height / 2;
        var initialRadius = Math.max(0, Math.min(seriesBox.width, seriesBox.height) / 2);
        var radius = initialRadius;
        setSeriesCircle(centerX, centerY, radius);
        var shake = function (_a) {
            var e_1, _b;
            var _c = _a === void 0 ? {} : _a,
                _d = _c.hideWhenNecessary,
                hideWhenNecessary = _d === void 0 ? false : _d;
            var labelBoxes = [];
            try {
                for (
                    var _e = __values$i(
                            __spreadArray$l(__spreadArray$l([], __read$D(polarAxes)), __read$D(polarSeries)),
                        ),
                        _f = _e.next();
                    !_f.done;
                    _f = _e.next()
                ) {
                    var series = _f.value;
                    var box = series.computeLabelsBBox({ hideWhenNecessary: hideWhenNecessary }, seriesBox);
                    if (box) {
                        labelBoxes.push(box);
                    }
                }
            } catch (e_1_1) {
                e_1 = { error: e_1_1 };
            } finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                } finally {
                    if (e_1) throw e_1.error;
                }
            }
            if (labelBoxes.length === 0) {
                setSeriesCircle(centerX, centerY, initialRadius);
                return;
            }
            var labelBox = BBox.merge(labelBoxes);
            var refined = _this.refineCircle(labelBox, radius, seriesBox);
            setSeriesCircle(refined.centerX, refined.centerY, refined.radius);
            if (refined.radius === radius) {
                return;
            }
            radius = refined.radius;
        };
        shake(); // Initial attempt
        shake(); // Precise attempt
        shake(); // Just in case
        shake({ hideWhenNecessary: true }); // Hide unnecessary labels
        shake({ hideWhenNecessary: true }); // Final result
        return { radius: radius, centerX: centerX, centerY: centerY };
    };
    PolarChart.prototype.refineCircle = function (labelsBox, radius, seriesBox) {
        var minCircleRatio = 0.5; // Prevents reduced circle to be too small
        var circleLeft = -radius;
        var circleTop = -radius;
        var circleRight = radius;
        var circleBottom = radius;
        // Label padding around the circle
        var padLeft = Math.max(0, circleLeft - labelsBox.x);
        var padTop = Math.max(0, circleTop - labelsBox.y);
        var padRight = Math.max(0, labelsBox.x + labelsBox.width - circleRight);
        var padBottom = Math.max(0, labelsBox.y + labelsBox.height - circleBottom);
        // Available area for the circle (after the padding will be applied)
        var availCircleWidth = seriesBox.width - padLeft - padRight;
        var availCircleHeight = seriesBox.height - padTop - padBottom;
        var newRadius = Math.min(availCircleWidth, availCircleHeight) / 2;
        var minHorizontalRadius = (minCircleRatio * seriesBox.width) / 2;
        var minVerticalRadius = (minCircleRatio * seriesBox.height) / 2;
        var minRadius = Math.min(minHorizontalRadius, minVerticalRadius);
        if (newRadius < minRadius) {
            // If the radius is too small, reduce the label padding
            newRadius = minRadius;
            var horizontalPadding = padLeft + padRight;
            var verticalPadding = padTop + padBottom;
            if (2 * newRadius + verticalPadding > seriesBox.height) {
                var padHeight = seriesBox.height - 2 * newRadius;
                if (Math.min(padTop, padBottom) * 2 > padHeight) {
                    padTop = padHeight / 2;
                    padBottom = padHeight / 2;
                } else if (padTop > padBottom) {
                    padTop = padHeight - padBottom;
                } else {
                    padBottom = padHeight - padTop;
                }
            }
            if (2 * newRadius + horizontalPadding > seriesBox.width) {
                var padWidth = seriesBox.width - 2 * newRadius;
                if (Math.min(padLeft, padRight) * 2 > padWidth) {
                    padLeft = padWidth / 2;
                    padRight = padWidth / 2;
                } else if (padLeft > padRight) {
                    padLeft = padWidth - padRight;
                } else {
                    padRight = padWidth - padLeft;
                }
            }
        }
        var newWidth = padLeft + 2 * newRadius + padRight;
        var newHeight = padTop + 2 * newRadius + padBottom;
        return {
            centerX: seriesBox.x + (seriesBox.width - newWidth) / 2 + padLeft + newRadius,
            centerY: seriesBox.y + (seriesBox.height - newHeight) / 2 + padTop + newRadius,
            radius: newRadius,
        };
    };
    PolarChart.className = 'PolarChart';
    PolarChart.type = 'polar';
    return PolarChart;
})(Chart);

var __extends$29 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __awaiter$8 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$8 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var HierarchyChart = /** @class */ (function (_super) {
    __extends$29(HierarchyChart, _super);
    function HierarchyChart(document, overrideDevicePixelRatio, resources) {
        if (document === void 0) {
            document = window.document;
        }
        var _this = _super.call(this, document, overrideDevicePixelRatio, resources) || this;
        _this._data = {};
        return _this;
    }
    HierarchyChart.prototype.performLayout = function () {
        return __awaiter$8(this, void 0, void 0, function () {
            var shrinkRect, seriesAreaPadding, fullSeriesRect, hoverRectPadding, hoverRect, seriesRoot;
            var _this = this;
            return __generator$8(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, _super.prototype.performLayout.call(this)];
                    case 1:
                        shrinkRect = _a.sent();
                        seriesAreaPadding = this.seriesAreaPadding;
                        fullSeriesRect = shrinkRect.clone();
                        shrinkRect.shrink(seriesAreaPadding.left, 'left');
                        shrinkRect.shrink(seriesAreaPadding.top, 'top');
                        shrinkRect.shrink(seriesAreaPadding.right, 'right');
                        shrinkRect.shrink(seriesAreaPadding.bottom, 'bottom');
                        this.seriesRect = shrinkRect;
                        hoverRectPadding = 20;
                        hoverRect = shrinkRect.clone().grow(hoverRectPadding);
                        this.hoverRect = hoverRect;
                        this.seriesRoot.translationX = Math.floor(shrinkRect.x);
                        this.seriesRoot.translationY = Math.floor(shrinkRect.y);
                        return [
                            4 /*yield*/,
                            Promise.all(
                                this.series.map(function (series) {
                                    return __awaiter$8(_this, void 0, void 0, function () {
                                        return __generator$8(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    return [4 /*yield*/, series.update({ seriesRect: shrinkRect })];
                                                case 1:
                                                    _a.sent(); // this has to happen after the `updateAxes` call
                                                    return [2 /*return*/];
                                            }
                                        });
                                    });
                                }),
                            ),
                        ];
                    case 2:
                        _a.sent();
                        seriesRoot = this.seriesRoot;
                        seriesRoot.setClipRectInGroupCoordinateSpace(
                            new BBox(shrinkRect.x, shrinkRect.y, shrinkRect.width, shrinkRect.height),
                        );
                        this.layoutService.dispatchLayoutComplete({
                            type: 'layout-complete',
                            chart: { width: this.scene.width, height: this.scene.height },
                            series: {
                                rect: fullSeriesRect,
                                paddedRect: shrinkRect,
                                hoverRect: hoverRect,
                                visible: true,
                            },
                            axes: [],
                        });
                        return [2 /*return*/, shrinkRect];
                }
            });
        });
    };
    HierarchyChart.className = 'HierarchyChart';
    HierarchyChart.type = 'hierarchy';
    return HierarchyChart;
})(Chart);

function calculateNiceSecondaryAxis(domain, primaryTickCount) {
    // Make secondary axis domain nice using strict tick count, matching the tick count from the primary axis.
    // This is to make the secondary axis grid lines/ tick positions align with the ones from the primary axis.
    var start = Math.floor(domain[0]);
    var stop = domain[1];
    start = calculateNiceStart(start, stop, primaryTickCount);
    var step = getTickStep(start, stop, primaryTickCount);
    var segments = primaryTickCount - 1;
    stop = start + segments * step;
    var d = [start, stop];
    var ticks = getTicks(start, step, primaryTickCount);
    return [d, ticks];
}
function calculateNiceStart(a, b, count) {
    var rawStep = Math.abs(b - a) / (count - 1);
    var order = Math.floor(Math.log10(rawStep));
    var magnitude = Math.pow(10, order);
    return Math.floor(a / magnitude) * magnitude;
}
function getTicks(start, step, count) {
    // power of the step will be negative if the step is a fraction (between 0 and 1)
    var stepPower = Math.floor(Math.log10(step));
    var fractionDigits = step > 0 && step < 1 ? Math.abs(stepPower) : 0;
    var f = Math.pow(10, fractionDigits);
    var ticks = new NumericTicks(fractionDigits);
    for (var i = 0; i < count; i++) {
        var tick = start + step * i;
        ticks[i] = Math.round(tick * f) / f;
    }
    return ticks;
}
function getTickStep(start, stop, count) {
    var segments = count - 1;
    var rawStep = (stop - start) / segments;
    return calculateNextNiceStep(rawStep);
}
function calculateNextNiceStep(rawStep) {
    var order = Math.floor(Math.log10(rawStep));
    var magnitude = Math.pow(10, order);
    // Make order 1
    var step = (rawStep / magnitude) * 10;
    if (step > 0 && step <= 1) {
        return magnitude / 10;
    }
    if (step > 1 && step <= 2) {
        return (2 * magnitude) / 10;
    }
    if (step > 1 && step <= 5) {
        return (5 * magnitude) / 10;
    }
    if (step > 5 && step <= 10) {
        return (10 * magnitude) / 10;
    }
    if (step > 10 && step <= 20) {
        return (20 * magnitude) / 10;
    }
    if (step > 20 && step <= 40) {
        return (40 * magnitude) / 10;
    }
    if (step > 40 && step <= 50) {
        return (50 * magnitude) / 10;
    }
    if (step > 50 && step <= 100) {
        return (100 * magnitude) / 10;
    }
    return step;
}

var __extends$28 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1t =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$C =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var NumberAxisTick = /** @class */ (function (_super) {
    __extends$28(NumberAxisTick, _super);
    function NumberAxisTick() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.maxSpacing = NaN;
        return _this;
    }
    __decorate$1t(
        [Validate(AND(NUMBER_OR_NAN(1), GREATER_THAN('minSpacing'))), Default(NaN)],
        NumberAxisTick.prototype,
        'maxSpacing',
        void 0,
    );
    return NumberAxisTick;
})(AxisTick);
var NumberAxis = /** @class */ (function (_super) {
    __extends$28(NumberAxis, _super);
    function NumberAxis(moduleCtx, scale) {
        if (scale === void 0) {
            scale = new LinearScale$1();
        }
        var _this = _super.call(this, moduleCtx, scale) || this;
        _this.min = NaN;
        _this.max = NaN;
        scale.strictClampByDefault = true;
        return _this;
    }
    NumberAxis.prototype.normaliseDataDomain = function (d) {
        var _a = this,
            min = _a.min,
            max = _a.max;
        return normalisedExtent(d, min, max);
    };
    NumberAxis.prototype.formatDatum = function (datum) {
        if (typeof datum === 'number') {
            return datum.toFixed(2);
        } else {
            Logger.warnOnce(
                'data contains Date objects which are being plotted against a number axis, please only use a number axis for numbers.',
            );
            return String(datum);
        }
    };
    NumberAxis.prototype.createTick = function () {
        return new NumberAxisTick();
    };
    NumberAxis.prototype.updateSecondaryAxisTicks = function (primaryTickCount) {
        if (this.dataDomain == null) {
            throw new Error('AG Charts - dataDomain not calculated, cannot perform tick calculation.');
        }
        var _a = __read$C(
                calculateNiceSecondaryAxis(
                    this.dataDomain,
                    primaryTickCount !== null && primaryTickCount !== void 0 ? primaryTickCount : 0,
                ),
                2,
            ),
            d = _a[0],
            ticks = _a[1];
        this.scale.nice = false;
        this.scale.domain = d;
        this.scale.update();
        return ticks;
    };
    NumberAxis.className = 'NumberAxis';
    NumberAxis.type = 'number';
    __decorate$1t(
        [Validate(AND(NUMBER_OR_NAN(), LESS_THAN('max'))), Default(NaN)],
        NumberAxis.prototype,
        'min',
        void 0,
    );
    __decorate$1t(
        [Validate(AND(NUMBER_OR_NAN(), GREATER_THAN('min'))), Default(NaN)],
        NumberAxis.prototype,
        'max',
        void 0,
    );
    return NumberAxis;
})(CartesianAxis);

var __extends$27 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1s =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
function NON_ZERO_NUMBER() {
    // Cannot be 0
    var message = 'expecting a non-zero Number';
    return predicateWithMessage(function (v) {
        return typeof v === 'number' && v !== 0;
    }, message);
}
var LogAxis = /** @class */ (function (_super) {
    __extends$27(LogAxis, _super);
    function LogAxis(moduleCtx) {
        var _this = _super.call(this, moduleCtx, new LogScale()) || this;
        _this.min = NaN;
        _this.max = NaN;
        _this.scale.strictClampByDefault = true;
        return _this;
    }
    LogAxis.prototype.normaliseDataDomain = function (d) {
        var _a;
        var _b = this,
            min = _b.min,
            max = _b.max;
        if (d.length > 2) {
            d = (_a = extent$4(d)) !== null && _a !== void 0 ? _a : [NaN, NaN];
        }
        if (!isNaN(min)) {
            d = [min, d[1]];
        }
        if (!isNaN(max)) {
            d = [d[0], max];
        }
        var isInverted = d[0] > d[1];
        var crossesZero = d[0] < 0 && d[1] > 0;
        var hasZeroExtent = d[0] === 0 && d[1] === 0;
        var invalidDomain = isInverted || crossesZero || hasZeroExtent;
        if (invalidDomain) {
            d = [];
            if (crossesZero) {
                Logger.warn(
                    'the data domain crosses zero, the chart data cannot be rendered. See log axis documentation for more information.',
                );
            } else if (hasZeroExtent) {
                Logger.warn('the data domain has 0 extent, no data is rendered.');
            }
        }
        if (d[0] === 0) {
            d[0] = 1;
        }
        if (d[1] === 0) {
            d[1] = -1;
        }
        return d;
    };
    Object.defineProperty(LogAxis.prototype, 'base', {
        get: function () {
            return this.scale.base;
        },
        set: function (value) {
            this.scale.base = value;
        },
        enumerable: false,
        configurable: true,
    });
    LogAxis.className = 'LogAxis';
    LogAxis.type = 'log';
    __decorate$1s(
        [Validate(AND(NUMBER_OR_NAN(), LESS_THAN('max'), NON_ZERO_NUMBER())), Default(NaN)],
        LogAxis.prototype,
        'min',
        void 0,
    );
    __decorate$1s(
        [Validate(AND(NUMBER_OR_NAN(), GREATER_THAN('min'), NON_ZERO_NUMBER())), Default(NaN)],
        LogAxis.prototype,
        'max',
        void 0,
    );
    return LogAxis;
})(NumberAxis);

var __extends$26 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1r =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TimeAxisTick = /** @class */ (function (_super) {
    __extends$26(TimeAxisTick, _super);
    function TimeAxisTick() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.maxSpacing = NaN;
        return _this;
    }
    __decorate$1r(
        [Validate(AND(NUMBER_OR_NAN(1), GREATER_THAN('minSpacing'))), Default(NaN)],
        TimeAxisTick.prototype,
        'maxSpacing',
        void 0,
    );
    return TimeAxisTick;
})(AxisTick);
var TimeAxis = /** @class */ (function (_super) {
    __extends$26(TimeAxis, _super);
    function TimeAxis(moduleCtx) {
        var _this = _super.call(this, moduleCtx, new TimeScale$1()) || this;
        _this.datumFormat = '%m/%d/%y, %H:%M:%S';
        _this.min = undefined;
        _this.max = undefined;
        var scale = _this.scale;
        scale.strictClampByDefault = true;
        _this.refreshScale();
        _this.datumFormatter = scale.tickFormat({
            specifier: _this.datumFormat,
        });
        return _this;
    }
    TimeAxis.prototype.normaliseDataDomain = function (d) {
        var _a;
        var _b = this,
            min = _b.min,
            max = _b.max;
        if (typeof min === 'number') {
            min = new Date(min);
        }
        if (typeof max === 'number') {
            max = new Date(max);
        }
        if (d.length > 2) {
            d = ((_a = extent$4(d)) !== null && _a !== void 0 ? _a : [0, 1000]).map(function (x) {
                return new Date(x);
            });
        }
        if (min instanceof Date) {
            d = [min, d[1]];
        }
        if (max instanceof Date) {
            d = [d[0], max];
        }
        if (d[0] > d[1]) {
            d = [];
        }
        return d;
    };
    TimeAxis.prototype.createTick = function () {
        return new TimeAxisTick();
    };
    TimeAxis.prototype.onLabelFormatChange = function (ticks, format) {
        if (format) {
            _super.prototype.onLabelFormatChange.call(this, ticks, format);
        } else {
            // For time axis labels to look nice, even if date format wasn't set.
            this.labelFormatter = this.scale.tickFormat({ ticks: ticks });
        }
    };
    TimeAxis.prototype.formatDatum = function (datum) {
        var _a;
        return (_a = this.moduleCtx.callbackCache.call(this.datumFormatter, datum)) !== null && _a !== void 0
            ? _a
            : String(datum);
    };
    TimeAxis.prototype.calculatePadding = function (_min, _max) {
        // numbers in domain correspond to Unix timestamps
        // automatically expand domain by 1 in forward direction
        return [0, 1];
    };
    TimeAxis.className = 'TimeAxis';
    TimeAxis.type = 'time';
    __decorate$1r([Validate(AND(OPT_DATE_OR_DATETIME_MS, LESS_THAN('max')))], TimeAxis.prototype, 'min', void 0);
    __decorate$1r([Validate(AND(OPT_DATE_OR_DATETIME_MS, GREATER_THAN('min')))], TimeAxis.prototype, 'max', void 0);
    return TimeAxis;
})(CartesianAxis);

var _a$1;
var AXIS_CONSTRUCTORS =
    ((_a$1 = {}),
    (_a$1[NumberAxis.type] = NumberAxis),
    (_a$1[CategoryAxis.type] = CategoryAxis),
    (_a$1[TimeAxis.type] = TimeAxis),
    (_a$1[GroupedCategoryAxis.type] = GroupedCategoryAxis),
    (_a$1[LogAxis.type] = LogAxis),
    _a$1);
function registerAxis(axisType, ctor) {
    AXIS_CONSTRUCTORS[axisType] = ctor;
}
function getAxis(axisType, moduleCtx) {
    var axisConstructor = AXIS_CONSTRUCTORS[axisType];
    if (axisConstructor) {
        return new axisConstructor(moduleCtx);
    }
    throw new Error('AG Charts - unknown axis type: ' + axisType);
}
var AXIS_TYPES = {
    has: function (axisType) {
        return Object.prototype.hasOwnProperty.call(AXIS_CONSTRUCTORS, axisType);
    },
    get axesTypes() {
        return Object.keys(AXIS_CONSTRUCTORS);
    },
};
var AXIS_THEME_TEMPLATES = {};
function registerAxisThemeTemplate(axisType, theme) {
    AXIS_THEME_TEMPLATES[axisType] = theme;
}
function getAxisThemeTemplate(axisType) {
    var _a;
    return (_a = AXIS_THEME_TEMPLATES[axisType]) !== null && _a !== void 0 ? _a : {};
}

var __extends$25 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1q =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MARKER_SHAPES = ['circle', 'cross', 'diamond', 'heart', 'plus', 'square', 'triangle'];
var MARKER_SHAPE = predicateWithMessage(function (v) {
    return MARKER_SHAPES.includes(v) || Object.getPrototypeOf(v) === Marker;
}, "expecting a marker shape keyword such as 'circle', 'diamond' or 'square' or an object extending the Marker class");
var SeriesMarker = /** @class */ (function (_super) {
    __extends$25(SeriesMarker, _super);
    function SeriesMarker() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.enabled = true;
        /**
         * One of the predefined marker names, or a marker constructor function (for user-defined markers).
         * A series will create one marker instance per data point.
         */
        _this.shape = Circle;
        _this.size = 6;
        /**
         * In case a series has the `sizeKey` set, the `sizeKey` values along with the `size` and `maxSize` configs
         * will be used to determine the size of the marker. All values will be mapped to a marker size
         * within the `[size, maxSize]` range, where the largest values will correspond to the `maxSize`
         * and the lowest to the `size`.
         */
        _this.maxSize = 30;
        _this.domain = undefined;
        _this.fill = undefined;
        _this.stroke = undefined;
        _this.strokeWidth = 1;
        _this.fillOpacity = undefined;
        _this.strokeOpacity = undefined;
        return _this;
    }
    __decorate$1q(
        [Validate(BOOLEAN), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'enabled',
        void 0,
    );
    __decorate$1q(
        [Validate(MARKER_SHAPE), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'shape',
        void 0,
    );
    __decorate$1q(
        [Validate(NUMBER(0)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'size',
        void 0,
    );
    __decorate$1q(
        [Validate(NUMBER(0)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'maxSize',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_NUMBER_ARRAY), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'domain',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_COLOR_STRING), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'fill',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_COLOR_STRING), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'stroke',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_NUMBER(0)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'strokeWidth',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_NUMBER(0, 1)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'fillOpacity',
        void 0,
    );
    __decorate$1q(
        [Validate(OPT_NUMBER(0, 1)), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        SeriesMarker.prototype,
        'strokeOpacity',
        void 0,
    );
    return SeriesMarker;
})(ChangeDetectable);

var __extends$24 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$D =
    (undefined && undefined.__assign) ||
    function () {
        __assign$D =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$D.apply(this, arguments);
    };
var __decorate$1p =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$7 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$7 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __values$h =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$B =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var _a, _b;
var DEFAULT_DIRECTION_KEYS =
    ((_a = {}), (_a[ChartAxisDirection.X] = ['xKey']), (_a[ChartAxisDirection.Y] = ['yKey']), _a);
var DEFAULT_DIRECTION_NAMES =
    ((_b = {}), (_b[ChartAxisDirection.X] = ['xName']), (_b[ChartAxisDirection.Y] = ['yName']), _b);
var CartesianSeriesNodeBaseClickEvent = /** @class */ (function (_super) {
    __extends$24(CartesianSeriesNodeBaseClickEvent, _super);
    function CartesianSeriesNodeBaseClickEvent(xKey, yKey, nativeEvent, datum, series) {
        var _this = _super.call(this, nativeEvent, datum, series) || this;
        _this.xKey = xKey;
        _this.yKey = yKey;
        return _this;
    }
    return CartesianSeriesNodeBaseClickEvent;
})(SeriesNodeBaseClickEvent);
var CartesianSeriesNodeClickEvent = /** @class */ (function (_super) {
    __extends$24(CartesianSeriesNodeClickEvent, _super);
    function CartesianSeriesNodeClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeClick';
        return _this;
    }
    return CartesianSeriesNodeClickEvent;
})(CartesianSeriesNodeBaseClickEvent);
var CartesianSeriesNodeDoubleClickEvent = /** @class */ (function (_super) {
    __extends$24(CartesianSeriesNodeDoubleClickEvent, _super);
    function CartesianSeriesNodeDoubleClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeDoubleClick';
        return _this;
    }
    return CartesianSeriesNodeDoubleClickEvent;
})(CartesianSeriesNodeBaseClickEvent);
var CartesianStateMachine = /** @class */ (function (_super) {
    __extends$24(CartesianStateMachine, _super);
    function CartesianStateMachine() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    return CartesianStateMachine;
})(StateMachine);
var CartesianSeries = /** @class */ (function (_super) {
    __extends$24(CartesianSeries, _super);
    function CartesianSeries(opts) {
        var _this =
            _super.call(
                this,
                __assign$D(__assign$D({}, opts), {
                    useSeriesGroupLayer: true,
                    directionKeys: DEFAULT_DIRECTION_KEYS,
                    directionNames: DEFAULT_DIRECTION_NAMES,
                }),
            ) || this;
        _this.legendItemName = undefined;
        _this._contextNodeData = [];
        _this.nodeDataDependencies = {};
        _this.highlightSelection = Selection.select(_this.highlightNode, function () {
            return _this.opts.hasMarkers ? _this.markerFactory() : _this.nodeFactory();
        });
        _this.highlightLabelSelection = Selection.select(_this.highlightLabel, Text);
        _this.subGroups = [];
        _this.subGroupId = 0;
        _this.datumSelectionGarbageCollection = true;
        var _a = opts.pathsPerSeries,
            pathsPerSeries = _a === void 0 ? 1 : _a,
            _b = opts.hasMarkers,
            hasMarkers = _b === void 0 ? false : _b,
            _c = opts.hasHighlightedLabels,
            hasHighlightedLabels = _c === void 0 ? false : _c,
            _d = opts.pathsZIndexSubOrderOffset,
            pathsZIndexSubOrderOffset = _d === void 0 ? [] : _d;
        _this.opts = {
            pathsPerSeries: pathsPerSeries,
            hasMarkers: hasMarkers,
            hasHighlightedLabels: hasHighlightedLabels,
            pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset,
        };
        _this.animationState = new CartesianStateMachine('empty', {
            empty: {
                on: {
                    update: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateEmptyUpdateReady(data);
                        },
                    },
                },
            },
            ready: {
                on: {
                    updateData: {
                        target: 'waiting',
                        action: function () {},
                    },
                    update: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateReadyUpdate(data);
                        },
                    },
                    highlight: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateReadyHighlight(data);
                        },
                    },
                    highlightMarkers: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateReadyHighlightMarkers(data);
                        },
                    },
                    resize: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateReadyResize(data);
                        },
                    },
                },
            },
            waiting: {
                on: {
                    update: {
                        target: 'ready',
                        action: function (data) {
                            return _this.animateWaitingUpdateReady(data);
                        },
                    },
                },
            },
        });
        return _this;
    }
    Object.defineProperty(CartesianSeries.prototype, 'contextNodeData', {
        get: function () {
            var _a;
            return (_a = this._contextNodeData) === null || _a === void 0 ? void 0 : _a.slice();
        },
        enumerable: false,
        configurable: true,
    });
    CartesianSeries.prototype.addChartEventListeners = function () {
        var _this = this;
        var _a, _b;
        (_a = this.ctx.chartEventManager) === null || _a === void 0
            ? void 0
            : _a.addListener('legend-item-click', function (event) {
                  return _this.onLegendItemClick(event);
              });
        (_b = this.ctx.chartEventManager) === null || _b === void 0
            ? void 0
            : _b.addListener('legend-item-double-click', function (event) {
                  return _this.onLegendItemDoubleClick(event);
              });
    };
    CartesianSeries.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this._contextNodeData.splice(0, this._contextNodeData.length);
        this.subGroups.splice(0, this.subGroups.length);
    };
    /**
     * Note: we are passing `isContinuousX` and `isContinuousY` into this method because it will
     *       typically be called inside a loop and this check only needs to happen once.
     * @param x A domain value to be plotted along the x-axis.
     * @param y A domain value to be plotted along the y-axis.
     * @param isContinuousX Typically this will be the value of `xAxis.scale instanceof ContinuousScale`.
     * @param isContinuousY Typically this will be the value of `yAxis.scale instanceof ContinuousScale`.
     * @returns `[x, y]`, if both x and y are valid domain values for their respective axes/scales, or `undefined`.
     */
    CartesianSeries.prototype.checkDomainXY = function (x, y, isContinuousX, isContinuousY) {
        var isValidDatum =
            ((isContinuousX && isContinuous(x)) || (!isContinuousX && isDiscrete(x))) &&
            ((isContinuousY && isContinuous(y)) || (!isContinuousY && isDiscrete(y)));
        return isValidDatum ? [x, y] : undefined;
    };
    /**
     * Note: we are passing the xAxis and yAxis because the calling code is supposed to make sure
     *       that series has both of them defined, and also to avoid one level of indirection,
     *       e.g. `this.xAxis!.inRange(x)`, both of which are suboptimal in tight loops where this method is used.
     * @param x A range value to be plotted along the x-axis.
     * @param y A range value to be plotted along the y-axis.
     * @param xAxis The series' x-axis.
     * @param yAxis The series' y-axis.
     * @returns
     */
    CartesianSeries.prototype.checkRangeXY = function (x, y, xAxis, yAxis) {
        return !isNaN(x) && !isNaN(y) && xAxis.inRange(x) && yAxis.inRange(y);
    };
    CartesianSeries.prototype.update = function (_a) {
        var _b, _c;
        var seriesRect = _a.seriesRect;
        return __awaiter$7(this, void 0, void 0, function () {
            var visible, series, seriesHighlighted, newNodeDataDependencies, resize;
            return __generator$7(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        visible = this.visible;
                        series = (
                            (_c =
                                (_b = this.ctx.highlightManager) === null || _b === void 0
                                    ? void 0
                                    : _b.getActiveHighlight()) !== null && _c !== void 0
                                ? _c
                                : {}
                        ).series;
                        seriesHighlighted = series ? series === this : undefined;
                        newNodeDataDependencies = {
                            seriesRectWidth: seriesRect === null || seriesRect === void 0 ? void 0 : seriesRect.width,
                            seriesRectHeight: seriesRect === null || seriesRect === void 0 ? void 0 : seriesRect.height,
                        };
                        resize = jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
                        if (resize) {
                            this.nodeDataDependencies = newNodeDataDependencies;
                            this.markNodeDataDirty();
                        }
                        return [4 /*yield*/, this.updateSelections(seriesHighlighted, visible)];
                    case 1:
                        _d.sent();
                        return [4 /*yield*/, this.updateNodes(seriesHighlighted, visible)];
                    case 2:
                        _d.sent();
                        if (resize) {
                            this.animationState.transition('resize', {
                                datumSelections: this.subGroups.map(function (_a) {
                                    var datumSelection = _a.datumSelection;
                                    return datumSelection;
                                }),
                                markerSelections: this.subGroups.map(function (_a) {
                                    var markerSelection = _a.markerSelection;
                                    return markerSelection;
                                }),
                                contextData: this._contextNodeData,
                                paths: this.subGroups.map(function (_a) {
                                    var paths = _a.paths;
                                    return paths;
                                }),
                            });
                        }
                        this.animationState.transition('update', {
                            datumSelections: this.subGroups.map(function (_a) {
                                var datumSelection = _a.datumSelection;
                                return datumSelection;
                            }),
                            markerSelections: this.subGroups.map(function (_a) {
                                var markerSelection = _a.markerSelection;
                                return markerSelection;
                            }),
                            labelSelections: this.subGroups.map(function (_a) {
                                var labelSelection = _a.labelSelection;
                                return labelSelection;
                            }),
                            contextData: this._contextNodeData,
                            paths: this.subGroups.map(function (_a) {
                                var paths = _a.paths;
                                return paths;
                            }),
                            seriesRect: seriesRect,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    CartesianSeries.prototype.updateSelections = function (seriesHighlighted, anySeriesItemEnabled) {
        var _a;
        return __awaiter$7(this, void 0, void 0, function () {
            var _b;
            var _this = this;
            return __generator$7(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        return [4 /*yield*/, this.updateHighlightSelection(seriesHighlighted)];
                    case 1:
                        _c.sent();
                        if (!anySeriesItemEnabled) {
                            return [2 /*return*/];
                        }
                        if (!this.nodeDataRefresh && !this.isPathOrSelectionDirty()) {
                            return [2 /*return*/];
                        }
                        if (!this.nodeDataRefresh) return [3 /*break*/, 4];
                        this.nodeDataRefresh = false;
                        if ((_a = this.chart) === null || _a === void 0 ? void 0 : _a.debug) {
                            Logger.debug('CartesianSeries.updateSelections() - calling createNodeData() for', this.id);
                        }
                        _b = this;
                        return [4 /*yield*/, this.createNodeData()];
                    case 2:
                        _b._contextNodeData = _c.sent();
                        return [4 /*yield*/, this.updateSeriesGroups()];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        return [
                            4 /*yield*/,
                            Promise.all(
                                this.subGroups.map(function (g, i) {
                                    return _this.updateSeriesGroupSelections(g, i);
                                }),
                            ),
                        ];
                    case 5:
                        _c.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartesianSeries.prototype.updateSeriesGroupSelections = function (subGroup, seriesIdx) {
        return __awaiter$7(this, void 0, void 0, function () {
            var datumSelection, labelSelection, markerSelection, contextData, nodeData, labelData, _a, _b, _c;
            return __generator$7(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (datumSelection = subGroup.datumSelection),
                            (labelSelection = subGroup.labelSelection),
                            (markerSelection = subGroup.markerSelection);
                        contextData = this._contextNodeData[seriesIdx];
                        (nodeData = contextData.nodeData), (labelData = contextData.labelData);
                        _a = subGroup;
                        return [
                            4 /*yield*/,
                            this.updateDatumSelection({
                                nodeData: nodeData,
                                datumSelection: datumSelection,
                                seriesIdx: seriesIdx,
                            }),
                        ];
                    case 1:
                        _a.datumSelection = _d.sent();
                        _b = subGroup;
                        return [
                            4 /*yield*/,
                            this.updateLabelSelection({
                                labelData: labelData,
                                labelSelection: labelSelection,
                                seriesIdx: seriesIdx,
                            }),
                        ];
                    case 2:
                        _b.labelSelection = _d.sent();
                        if (!markerSelection) return [3 /*break*/, 4];
                        _c = subGroup;
                        return [
                            4 /*yield*/,
                            this.updateMarkerSelection({
                                nodeData: nodeData,
                                markerSelection: markerSelection,
                                seriesIdx: seriesIdx,
                            }),
                        ];
                    case 3:
                        _c.markerSelection = _d.sent();
                        _d.label = 4;
                    case 4:
                        return [2 /*return*/];
                }
            });
        });
    };
    CartesianSeries.prototype.nodeFactory = function () {
        return new Group();
    };
    CartesianSeries.prototype.markerFactory = function () {
        var MarkerShape = getMarker$1();
        return new MarkerShape();
    };
    CartesianSeries.prototype.updateSeriesGroups = function () {
        return __awaiter$7(this, void 0, void 0, function () {
            var _a,
                contextNodeData,
                contentGroup,
                subGroups,
                _b,
                pathsPerSeries,
                hasMarkers,
                totalGroups,
                layer,
                subGroupId,
                dataNodeGroup,
                markerGroup,
                labelGroup,
                paths,
                index;
            var _this = this;
            return __generator$7(this, function (_c) {
                (_a = this),
                    (contextNodeData = _a._contextNodeData),
                    (contentGroup = _a.contentGroup),
                    (subGroups = _a.subGroups),
                    (_b = _a.opts),
                    (pathsPerSeries = _b.pathsPerSeries),
                    (hasMarkers = _b.hasMarkers);
                if (contextNodeData.length === subGroups.length) {
                    return [2 /*return*/];
                }
                if (contextNodeData.length < subGroups.length) {
                    subGroups.splice(contextNodeData.length).forEach(function (_a) {
                        var e_1, _b;
                        var dataNodeGroup = _a.dataNodeGroup,
                            markerGroup = _a.markerGroup,
                            labelGroup = _a.labelGroup,
                            paths = _a.paths;
                        contentGroup.removeChild(dataNodeGroup);
                        if (markerGroup) {
                            contentGroup.removeChild(markerGroup);
                        }
                        if (labelGroup) {
                            contentGroup.removeChild(labelGroup);
                        }
                        try {
                            for (
                                var paths_1 = __values$h(paths), paths_1_1 = paths_1.next();
                                !paths_1_1.done;
                                paths_1_1 = paths_1.next()
                            ) {
                                var path = paths_1_1.value;
                                contentGroup.removeChild(path);
                            }
                        } catch (e_1_1) {
                            e_1 = { error: e_1_1 };
                        } finally {
                            try {
                                if (paths_1_1 && !paths_1_1.done && (_b = paths_1.return)) _b.call(paths_1);
                            } finally {
                                if (e_1) throw e_1.error;
                            }
                        }
                    });
                }
                totalGroups = contextNodeData.length;
                while (totalGroups > subGroups.length) {
                    layer = false;
                    subGroupId = this.subGroupId++;
                    dataNodeGroup = new Group({
                        name: this.id + '-series-sub' + subGroupId + '-dataNodes',
                        layer: layer,
                        zIndex: Layers.SERIES_LAYER_ZINDEX,
                        zIndexSubOrder: this.getGroupZIndexSubOrder('data', subGroupId),
                    });
                    markerGroup = hasMarkers
                        ? new Group({
                              name: this.id + '-series-sub' + this.subGroupId++ + '-markers',
                              layer: layer,
                              zIndex: Layers.SERIES_LAYER_ZINDEX,
                              zIndexSubOrder: this.getGroupZIndexSubOrder('marker', subGroupId),
                          })
                        : undefined;
                    labelGroup = new Group({
                        name: this.id + '-series-sub' + this.subGroupId++ + '-labels',
                        layer: layer,
                        zIndex: Layers.SERIES_LABEL_ZINDEX,
                        zIndexSubOrder: this.getGroupZIndexSubOrder('labels', subGroupId),
                    });
                    contentGroup.appendChild(dataNodeGroup);
                    contentGroup.appendChild(labelGroup);
                    if (markerGroup) {
                        contentGroup.appendChild(markerGroup);
                    }
                    paths = [];
                    for (index = 0; index < pathsPerSeries; index++) {
                        paths[index] = new Path();
                        paths[index].zIndex = Layers.SERIES_LAYER_ZINDEX;
                        paths[index].zIndexSubOrder = this.getGroupZIndexSubOrder('paths', index);
                        contentGroup.appendChild(paths[index]);
                    }
                    subGroups.push({
                        paths: paths,
                        dataNodeGroup: dataNodeGroup,
                        markerGroup: markerGroup,
                        labelGroup: labelGroup,
                        labelSelection: Selection.select(labelGroup, Text),
                        datumSelection: Selection.select(
                            dataNodeGroup,
                            function () {
                                return _this.nodeFactory();
                            },
                            this.datumSelectionGarbageCollection,
                        ),
                        markerSelection: markerGroup
                            ? Selection.select(markerGroup, function () {
                                  return _this.markerFactory();
                              })
                            : undefined,
                    });
                }
                return [2 /*return*/];
            });
        });
    };
    CartesianSeries.prototype.getGroupZIndexSubOrder = function (type, subIndex) {
        var _a;
        if (subIndex === void 0) {
            subIndex = 0;
        }
        var result = _super.prototype.getGroupZIndexSubOrder.call(this, type, subIndex);
        if (type === 'paths') {
            var pathOffset_1 = (_a = this.opts.pathsZIndexSubOrderOffset[subIndex]) !== null && _a !== void 0 ? _a : 0;
            var superFn_1 = result[0];
            if (typeof superFn_1 === 'function') {
                result[0] = function () {
                    return +superFn_1() + pathOffset_1;
                };
            } else {
                result[0] = +superFn_1 + pathOffset_1;
            }
        }
        return result;
    };
    CartesianSeries.prototype.updateNodes = function (seriesHighlighted, anySeriesItemEnabled) {
        var _a;
        return __awaiter$7(this, void 0, void 0, function () {
            var _b,
                highlightSelection,
                highlightLabelSelection,
                contextNodeData,
                _c,
                hasMarkers,
                hasHighlightedLabels,
                visible,
                subGroupOpacities;
            var _this = this;
            return __generator$7(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_b = this),
                            (highlightSelection = _b.highlightSelection),
                            (highlightLabelSelection = _b.highlightLabelSelection),
                            (contextNodeData = _b._contextNodeData),
                            (_c = _b.opts),
                            (hasMarkers = _c.hasMarkers),
                            (hasHighlightedLabels = _c.hasHighlightedLabels);
                        visible =
                            this.visible &&
                            ((_a = this._contextNodeData) === null || _a === void 0 ? void 0 : _a.length) > 0 &&
                            anySeriesItemEnabled;
                        this.rootGroup.visible = visible;
                        this.contentGroup.visible = visible;
                        this.highlightGroup.visible = visible && !!seriesHighlighted;
                        subGroupOpacities = this.subGroups.map(function (_, index) {
                            var itemId = contextNodeData[index].itemId;
                            return _this.getOpacity({ itemId: itemId });
                        });
                        if (!hasMarkers) return [3 /*break*/, 2];
                        return [
                            4 /*yield*/,
                            this.updateMarkerNodes({
                                markerSelection: highlightSelection,
                                isHighlight: true,
                                seriesIdx: -1,
                            }),
                        ];
                    case 1:
                        _d.sent();
                        this.animationState.transition('highlightMarkers', highlightSelection);
                        return [3 /*break*/, 4];
                    case 2:
                        return [
                            4 /*yield*/,
                            this.updateDatumNodes({
                                datumSelection: highlightSelection,
                                isHighlight: true,
                                seriesIdx: -1,
                            }),
                        ];
                    case 3:
                        _d.sent();
                        this.animationState.transition('highlight', highlightSelection);
                        _d.label = 4;
                    case 4:
                        if (!hasHighlightedLabels) return [3 /*break*/, 6];
                        return [
                            4 /*yield*/,
                            this.updateLabelNodes({ labelSelection: highlightLabelSelection, seriesIdx: -1 }),
                        ];
                    case 5:
                        _d.sent();
                        _d.label = 6;
                    case 6:
                        return [
                            4 /*yield*/,
                            Promise.all(
                                this.subGroups.map(function (subGroup, seriesIdx) {
                                    return __awaiter$7(_this, void 0, void 0, function () {
                                        var dataNodeGroup,
                                            markerGroup,
                                            datumSelection,
                                            labelSelection,
                                            markerSelection,
                                            paths,
                                            labelGroup,
                                            subGroupVisible,
                                            subGroupOpacity,
                                            paths_2,
                                            paths_2_1,
                                            path;
                                        var e_2, _a;
                                        return __generator$7(this, function (_b) {
                                            switch (_b.label) {
                                                case 0:
                                                    (dataNodeGroup = subGroup.dataNodeGroup),
                                                        (markerGroup = subGroup.markerGroup),
                                                        (datumSelection = subGroup.datumSelection),
                                                        (labelSelection = subGroup.labelSelection),
                                                        (markerSelection = subGroup.markerSelection),
                                                        (paths = subGroup.paths),
                                                        (labelGroup = subGroup.labelGroup);
                                                    subGroupVisible = visible;
                                                    subGroupOpacity = subGroupOpacities[seriesIdx];
                                                    dataNodeGroup.opacity = subGroupOpacity;
                                                    dataNodeGroup.visible = subGroupVisible;
                                                    labelGroup.visible = subGroupVisible;
                                                    if (markerGroup) {
                                                        markerGroup.opacity = subGroupOpacity;
                                                        markerGroup.zIndex =
                                                            dataNodeGroup.zIndex >= Layers.SERIES_LAYER_ZINDEX
                                                                ? dataNodeGroup.zIndex
                                                                : dataNodeGroup.zIndex + 1;
                                                        markerGroup.visible = subGroupVisible;
                                                    }
                                                    if (labelGroup) {
                                                        labelGroup.opacity = subGroupOpacity;
                                                    }
                                                    try {
                                                        for (
                                                            paths_2 = __values$h(paths), paths_2_1 = paths_2.next();
                                                            !paths_2_1.done;
                                                            paths_2_1 = paths_2.next()
                                                        ) {
                                                            path = paths_2_1.value;
                                                            path.opacity = subGroupOpacity;
                                                            path.visible = subGroupVisible;
                                                        }
                                                    } catch (e_2_1) {
                                                        e_2 = { error: e_2_1 };
                                                    } finally {
                                                        try {
                                                            if (paths_2_1 && !paths_2_1.done && (_a = paths_2.return))
                                                                _a.call(paths_2);
                                                        } finally {
                                                            if (e_2) throw e_2.error;
                                                        }
                                                    }
                                                    if (!dataNodeGroup.visible) {
                                                        return [2 /*return*/];
                                                    }
                                                    return [
                                                        4 /*yield*/,
                                                        this.updateDatumNodes({
                                                            datumSelection: datumSelection,
                                                            isHighlight: false,
                                                            seriesIdx: seriesIdx,
                                                        }),
                                                    ];
                                                case 1:
                                                    _b.sent();
                                                    return [
                                                        4 /*yield*/,
                                                        this.updateLabelNodes({
                                                            labelSelection: labelSelection,
                                                            seriesIdx: seriesIdx,
                                                        }),
                                                    ];
                                                case 2:
                                                    _b.sent();
                                                    if (!(hasMarkers && markerSelection)) return [3 /*break*/, 4];
                                                    return [
                                                        4 /*yield*/,
                                                        this.updateMarkerNodes({
                                                            markerSelection: markerSelection,
                                                            isHighlight: false,
                                                            seriesIdx: seriesIdx,
                                                        }),
                                                    ];
                                                case 3:
                                                    _b.sent();
                                                    _b.label = 4;
                                                case 4:
                                                    return [2 /*return*/];
                                            }
                                        });
                                    });
                                }),
                            ),
                        ];
                    case 7:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartesianSeries.prototype.updateHighlightSelection = function (seriesHighlighted) {
        var _a;
        return __awaiter$7(this, void 0, void 0, function () {
            var _b,
                highlightSelection,
                highlightLabelSelection,
                contextNodeData,
                highlightedDatum,
                item,
                _c,
                labelItem,
                _d,
                itemId_1,
                contextNodeData_1,
                contextNodeData_1_1,
                labelData,
                _e;
            var e_3, _f;
            return __generator$7(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        (_b = this),
                            (highlightSelection = _b.highlightSelection),
                            (highlightLabelSelection = _b.highlightLabelSelection),
                            (contextNodeData = _b._contextNodeData);
                        highlightedDatum =
                            (_a = this.ctx.highlightManager) === null || _a === void 0
                                ? void 0
                                : _a.getActiveHighlight();
                        item =
                            seriesHighlighted &&
                            (highlightedDatum === null || highlightedDatum === void 0 ? void 0 : highlightedDatum.datum)
                                ? highlightedDatum
                                : undefined;
                        _c = this;
                        return [
                            4 /*yield*/,
                            this.updateHighlightSelectionItem({ item: item, highlightSelection: highlightSelection }),
                        ];
                    case 1:
                        _c.highlightSelection = _g.sent();
                        if (this.isLabelEnabled() && item != null) {
                            (_d = item.itemId), (itemId_1 = _d === void 0 ? undefined : _d);
                            try {
                                for (
                                    contextNodeData_1 = __values$h(contextNodeData),
                                        contextNodeData_1_1 = contextNodeData_1.next();
                                    !contextNodeData_1_1.done;
                                    contextNodeData_1_1 = contextNodeData_1.next()
                                ) {
                                    labelData = contextNodeData_1_1.value.labelData;
                                    labelItem = labelData.find(function (ld) {
                                        return ld.datum === item.datum && ld.itemId === itemId_1;
                                    });
                                    if (labelItem != null) {
                                        break;
                                    }
                                }
                            } catch (e_3_1) {
                                e_3 = { error: e_3_1 };
                            } finally {
                                try {
                                    if (
                                        contextNodeData_1_1 &&
                                        !contextNodeData_1_1.done &&
                                        (_f = contextNodeData_1.return)
                                    )
                                        _f.call(contextNodeData_1);
                                } finally {
                                    if (e_3) throw e_3.error;
                                }
                            }
                        }
                        _e = this;
                        return [
                            4 /*yield*/,
                            this.updateHighlightSelectionLabel({
                                item: labelItem,
                                highlightLabelSelection: highlightLabelSelection,
                            }),
                        ];
                    case 2:
                        _e.highlightLabelSelection = _g.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CartesianSeries.prototype.pickNodeExactShape = function (point) {
        var e_4, _a;
        var result = _super.prototype.pickNodeExactShape.call(this, point);
        if (result) {
            return result;
        }
        var x = point.x,
            y = point.y;
        var hasMarkers = this.opts.hasMarkers;
        try {
            for (var _b = __values$h(this.subGroups), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = _c.value,
                    dataNodeGroup = _d.dataNodeGroup,
                    markerGroup = _d.markerGroup;
                var match = dataNodeGroup.pickNode(x, y);
                if (!match && hasMarkers) {
                    match = markerGroup === null || markerGroup === void 0 ? void 0 : markerGroup.pickNode(x, y);
                }
                if (match) {
                    return { datum: match.datum, distance: 0 };
                }
            }
        } catch (e_4_1) {
            e_4 = { error: e_4_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_4) throw e_4.error;
            }
        }
    };
    CartesianSeries.prototype.pickNodeClosestDatum = function (point) {
        var e_5, _a, e_6, _b;
        var _c, _d;
        var x = point.x,
            y = point.y;
        var _e = this,
            axes = _e.axes,
            rootGroup = _e.rootGroup,
            contextNodeData = _e._contextNodeData;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        var hitPoint = rootGroup.transformPoint(x, y);
        var minDistance = Infinity;
        var closestDatum;
        try {
            for (
                var contextNodeData_2 = __values$h(contextNodeData), contextNodeData_2_1 = contextNodeData_2.next();
                !contextNodeData_2_1.done;
                contextNodeData_2_1 = contextNodeData_2.next()
            ) {
                var context = contextNodeData_2_1.value;
                try {
                    for (
                        var _f = ((e_6 = void 0), __values$h(context.nodeData)), _g = _f.next();
                        !_g.done;
                        _g = _f.next()
                    ) {
                        var datum = _g.value;
                        var _h = datum.point,
                            _j = _h === void 0 ? {} : _h,
                            _k = _j.x,
                            datumX = _k === void 0 ? NaN : _k,
                            _l = _j.y,
                            datumY = _l === void 0 ? NaN : _l;
                        if (isNaN(datumX) || isNaN(datumY)) {
                            continue;
                        }
                        var isInRange =
                            (xAxis === null || xAxis === void 0 ? void 0 : xAxis.inRange(datumX)) &&
                            (yAxis === null || yAxis === void 0 ? void 0 : yAxis.inRange(datumY));
                        if (!isInRange) {
                            continue;
                        }
                        // No need to use Math.sqrt() since x < y implies Math.sqrt(x) < Math.sqrt(y) for
                        // values > 1
                        var distance = Math.max(Math.pow(hitPoint.x - datumX, 2) + Math.pow(hitPoint.y - datumY, 2), 0);
                        if (distance < minDistance) {
                            minDistance = distance;
                            closestDatum = datum;
                        }
                    }
                } catch (e_6_1) {
                    e_6 = { error: e_6_1 };
                } finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    } finally {
                        if (e_6) throw e_6.error;
                    }
                }
            }
        } catch (e_5_1) {
            e_5 = { error: e_5_1 };
        } finally {
            try {
                if (contextNodeData_2_1 && !contextNodeData_2_1.done && (_a = contextNodeData_2.return))
                    _a.call(contextNodeData_2);
            } finally {
                if (e_5) throw e_5.error;
            }
        }
        if (closestDatum) {
            var distance = Math.max(
                Math.sqrt(minDistance) -
                    ((_d = (_c = closestDatum.point) === null || _c === void 0 ? void 0 : _c.size) !== null &&
                    _d !== void 0
                        ? _d
                        : 0),
                0,
            );
            return { datum: closestDatum, distance: distance };
        }
    };
    CartesianSeries.prototype.pickNodeMainAxisFirst = function (point, requireCategoryAxis) {
        var e_7, _a, e_8, _b;
        var _c, _d;
        var x = point.x,
            y = point.y;
        var _e = this,
            axes = _e.axes,
            rootGroup = _e.rootGroup,
            contextNodeData = _e._contextNodeData;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        // Prefer to start search with any available category axis.
        var directions = [xAxis, yAxis]
            .filter(function (a) {
                return a instanceof CategoryAxis;
            })
            .map(function (a) {
                return a.direction;
            });
        if (requireCategoryAxis && directions.length === 0) {
            return;
        }
        // Default to X-axis unless we found a suitable category axis.
        var _f = __read$B(directions, 1),
            _g = _f[0],
            primaryDirection = _g === void 0 ? ChartAxisDirection.X : _g;
        var hitPoint = rootGroup.transformPoint(x, y);
        var hitPointCoords =
            primaryDirection === ChartAxisDirection.X ? [hitPoint.x, hitPoint.y] : [hitPoint.y, hitPoint.x];
        var minDistance = [Infinity, Infinity];
        var closestDatum = undefined;
        try {
            for (
                var contextNodeData_3 = __values$h(contextNodeData), contextNodeData_3_1 = contextNodeData_3.next();
                !contextNodeData_3_1.done;
                contextNodeData_3_1 = contextNodeData_3.next()
            ) {
                var context = contextNodeData_3_1.value;
                try {
                    for (
                        var _h = ((e_8 = void 0), __values$h(context.nodeData)), _j = _h.next();
                        !_j.done;
                        _j = _h.next()
                    ) {
                        var datum = _j.value;
                        var _k = datum.point,
                            _l = _k === void 0 ? {} : _k,
                            _m = _l.x,
                            datumX = _m === void 0 ? NaN : _m,
                            _o = _l.y,
                            datumY = _o === void 0 ? NaN : _o;
                        if (isNaN(datumX) || isNaN(datumY)) {
                            continue;
                        }
                        var isInRange =
                            (xAxis === null || xAxis === void 0 ? void 0 : xAxis.inRange(datumX)) &&
                            (yAxis === null || yAxis === void 0 ? void 0 : yAxis.inRange(datumY));
                        if (!isInRange) {
                            continue;
                        }
                        var point_1 = primaryDirection === ChartAxisDirection.X ? [datumX, datumY] : [datumY, datumX];
                        // Compare distances from most significant dimension to least.
                        var newMinDistance = true;
                        for (var i = 0; i < point_1.length; i++) {
                            var dist = Math.abs(point_1[i] - hitPointCoords[i]);
                            if (dist > minDistance[i]) {
                                newMinDistance = false;
                                break;
                            }
                            if (dist < minDistance[i]) {
                                minDistance[i] = dist;
                                minDistance.fill(Infinity, i + 1, minDistance.length);
                            }
                        }
                        if (newMinDistance) {
                            closestDatum = datum;
                        }
                    }
                } catch (e_8_1) {
                    e_8 = { error: e_8_1 };
                } finally {
                    try {
                        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                    } finally {
                        if (e_8) throw e_8.error;
                    }
                }
            }
        } catch (e_7_1) {
            e_7 = { error: e_7_1 };
        } finally {
            try {
                if (contextNodeData_3_1 && !contextNodeData_3_1.done && (_a = contextNodeData_3.return))
                    _a.call(contextNodeData_3);
            } finally {
                if (e_7) throw e_7.error;
            }
        }
        if (closestDatum) {
            var distance = Math.max(
                Math.sqrt(Math.pow(minDistance[0], 2) + Math.pow(minDistance[1], 2)) -
                    ((_d = (_c = closestDatum.point) === null || _c === void 0 ? void 0 : _c.size) !== null &&
                    _d !== void 0
                        ? _d
                        : 0),
                0,
            );
            return { datum: closestDatum, distance: distance };
        }
    };
    CartesianSeries.prototype.onLegendItemClick = function (event) {
        var enabled = event.enabled,
            itemId = event.itemId,
            series = event.series,
            legendItemName = event.legendItemName;
        var matchedLegendItemName = this.legendItemName != null && this.legendItemName === legendItemName;
        if (series.id === this.id) {
            this.toggleSeriesItem(itemId, enabled);
        } else if (matchedLegendItemName) {
            this.toggleSeriesItem(itemId, enabled);
        }
    };
    CartesianSeries.prototype.onLegendItemDoubleClick = function (event) {
        var enabled = event.enabled,
            itemId = event.itemId,
            series = event.series,
            numVisibleItems = event.numVisibleItems,
            legendItemName = event.legendItemName;
        var totalVisibleItems = Object.values(numVisibleItems).reduce(function (p, v) {
            return p + v;
        }, 0);
        var matchedLegendItemName = this.legendItemName != null && this.legendItemName === legendItemName;
        if (series.id === this.id || matchedLegendItemName) {
            // Double-clicked item should always become visible.
            this.toggleSeriesItem(itemId, true);
        } else if (enabled && totalVisibleItems === 1) {
            // Other items should become visible if there is only one existing visible item.
            this.toggleSeriesItem(itemId, true);
        } else {
            // Disable other items if not exactly one enabled.
            this.toggleSeriesItem(itemId, false);
        }
    };
    CartesianSeries.prototype.isPathOrSelectionDirty = function () {
        // Override point to allow more sophisticated dirty selection detection.
        return false;
    };
    CartesianSeries.prototype.getLabelData = function () {
        return [];
    };
    CartesianSeries.prototype.updateHighlightSelectionItem = function (opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            var hasMarkers, item, highlightSelection, nodeData, markerSelection;
            return __generator$7(this, function (_a) {
                hasMarkers = this.opts.hasMarkers;
                (item = opts.item), (highlightSelection = opts.highlightSelection);
                nodeData = item ? [item] : [];
                if (hasMarkers) {
                    markerSelection = highlightSelection;
                    return [
                        2 /*return*/,
                        this.updateMarkerSelection({
                            nodeData: nodeData,
                            markerSelection: markerSelection,
                            seriesIdx: -1,
                        }),
                    ];
                } else {
                    return [
                        2 /*return*/,
                        this.updateDatumSelection({
                            nodeData: nodeData,
                            datumSelection: highlightSelection,
                            seriesIdx: -1,
                        }),
                    ];
                }
            });
        });
    };
    CartesianSeries.prototype.updateHighlightSelectionLabel = function (opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            var item, highlightLabelSelection, labelData;
            return __generator$7(this, function (_a) {
                (item = opts.item), (highlightLabelSelection = opts.highlightLabelSelection);
                labelData = item ? [item] : [];
                return [
                    2 /*return*/,
                    this.updateLabelSelection({
                        labelData: labelData,
                        labelSelection: highlightLabelSelection,
                        seriesIdx: -1,
                    }),
                ];
            });
        });
    };
    CartesianSeries.prototype.updateDatumSelection = function (opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            return __generator$7(this, function (_a) {
                // Override point for sub-classes.
                return [2 /*return*/, opts.datumSelection];
            });
        });
    };
    CartesianSeries.prototype.updateDatumNodes = function (_opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            return __generator$7(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CartesianSeries.prototype.updateMarkerSelection = function (opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            return __generator$7(this, function (_a) {
                // Override point for sub-classes.
                return [2 /*return*/, opts.markerSelection];
            });
        });
    };
    CartesianSeries.prototype.updateMarkerNodes = function (_opts) {
        return __awaiter$7(this, void 0, void 0, function () {
            return __generator$7(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    CartesianSeries.prototype.animateEmptyUpdateReady = function (_data) {
        // Override point for sub-classes.
    };
    CartesianSeries.prototype.animateReadyUpdate = function (_data) {
        // Override point for sub-classes.
    };
    CartesianSeries.prototype.animateWaitingUpdateReady = function (_data) {
        // Override point for sub-classes.
    };
    CartesianSeries.prototype.animateReadyHighlight = function (_data) {
        // Override point for sub-classes.
    };
    CartesianSeries.prototype.animateReadyHighlightMarkers = function (_data) {
        // Override point for sub-classes.
    };
    CartesianSeries.prototype.animateReadyResize = function (_data) {
        // Override point for sub-classes.
    };
    __decorate$1p([Validate(OPT_STRING)], CartesianSeries.prototype, 'legendItemName', void 0);
    return CartesianSeries;
})(Series);
var CartesianSeriesMarker = /** @class */ (function (_super) {
    __extends$24(CartesianSeriesMarker, _super);
    function CartesianSeriesMarker() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1p(
        [Validate(OPT_FUNCTION), SceneChangeDetection({ redraw: RedrawType.MAJOR })],
        CartesianSeriesMarker.prototype,
        'formatter',
        void 0,
    );
    return CartesianSeriesMarker;
})(SeriesMarker);

var __read$A =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var interpolatePattern = /(#\{(.*?)\})/g;
function interpolate(input, values, formats) {
    return input.replace(interpolatePattern, function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var name = args[2];
        var _a = __read$A(name.split(':'), 2),
            valueName = _a[0],
            formatName = _a[1];
        var value = values[valueName];
        if (typeof value === 'number') {
            var format = formatName && formats && formats[formatName];
            if (format) {
                var _b = format,
                    locales = _b.locales,
                    options = _b.options;
                return value.toLocaleString(locales, options);
            }
            return String(value);
        }
        if (value instanceof Date) {
            var format = formatName && formats && formats[formatName];
            if (typeof format === 'string') {
                var formatter = buildFormatter(format);
                return formatter(value);
            }
            return value.toDateString();
        }
        if (typeof value === 'string' || (value === null || value === void 0 ? void 0 : value.toString)) {
            return String(value);
        }
        return '';
    });
}

var element = null;
function sanitizeHtml(text) {
    element = element !== null && element !== void 0 ? element : document.createElement('div');
    if (!text) {
        return '';
    }
    element.textContent = text;
    return element.innerHTML;
}

var __extends$23 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$C =
    (undefined && undefined.__assign) ||
    function () {
        __assign$C =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$C.apply(this, arguments);
    };
var __decorate$1o =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$6 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$6 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$z =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$k =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var AreaSeriesLabel = /** @class */ (function (_super) {
    __extends$23(AreaSeriesLabel, _super);
    function AreaSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1o([Validate(OPT_FUNCTION)], AreaSeriesLabel.prototype, 'formatter', void 0);
    return AreaSeriesLabel;
})(Label$1);
var AreaSeriesTooltip = /** @class */ (function (_super) {
    __extends$23(AreaSeriesTooltip, _super);
    function AreaSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        _this.format = undefined;
        return _this;
    }
    __decorate$1o([Validate(OPT_FUNCTION)], AreaSeriesTooltip.prototype, 'renderer', void 0);
    __decorate$1o([Validate(OPT_STRING)], AreaSeriesTooltip.prototype, 'format', void 0);
    return AreaSeriesTooltip;
})(SeriesTooltip);
var AreaSeriesTag;
(function (AreaSeriesTag) {
    AreaSeriesTag[(AreaSeriesTag['Fill'] = 0)] = 'Fill';
    AreaSeriesTag[(AreaSeriesTag['Stroke'] = 1)] = 'Stroke';
    AreaSeriesTag[(AreaSeriesTag['Marker'] = 2)] = 'Marker';
    AreaSeriesTag[(AreaSeriesTag['Label'] = 3)] = 'Label';
})(AreaSeriesTag || (AreaSeriesTag = {}));
var AreaSeries = /** @class */ (function (_super) {
    __extends$23(AreaSeries, _super);
    function AreaSeries(moduleCtx) {
        var _this =
            _super.call(this, {
                moduleCtx: moduleCtx,
                pathsPerSeries: 2,
                pathsZIndexSubOrderOffset: [0, 1000],
                hasMarkers: true,
            }) || this;
        _this.tooltip = new AreaSeriesTooltip();
        _this.marker = new CartesianSeriesMarker();
        _this.label = new AreaSeriesLabel();
        _this.fill = '#c16068';
        _this.stroke = '#874349';
        _this.fillOpacity = 1;
        _this.strokeOpacity = 1;
        _this.lineDash = [0];
        _this.lineDashOffset = 0;
        _this.xKey = undefined;
        _this.xName = undefined;
        _this.strokeWidth = 2;
        _this.shadow = undefined;
        var _a = _this,
            marker = _a.marker,
            label = _a.label;
        marker.enabled = false;
        label.enabled = false;
        return _this;
    }
    AreaSeries.prototype.processData = function (dataController) {
        return __awaiter$6(this, void 0, void 0, function () {
            var _a,
                xKey,
                yKey,
                axes,
                normalizedTo,
                data,
                visible,
                _b,
                _c,
                _d,
                groupIndex,
                xAxis,
                yAxis,
                isContinuousX,
                isContinuousY,
                ids,
                extraProps,
                normaliseTo,
                _e,
                dataModel,
                processedData;
            return __generator$6(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        (_a = this),
                            (xKey = _a.xKey),
                            (yKey = _a.yKey),
                            (axes = _a.axes),
                            (normalizedTo = _a.normalizedTo),
                            (data = _a.data),
                            (visible = _a.visible),
                            (_b = _a.seriesGrouping),
                            (_c = _b === void 0 ? {} : _b),
                            (_d = _c.groupIndex),
                            (groupIndex = _d === void 0 ? this.id : _d);
                        if (!xKey || !yKey || !data) return [2 /*return*/];
                        xAxis = axes[ChartAxisDirection.X];
                        yAxis = axes[ChartAxisDirection.Y];
                        isContinuousX =
                            (xAxis === null || xAxis === void 0 ? void 0 : xAxis.scale) instanceof ContinuousScale;
                        isContinuousY =
                            (yAxis === null || yAxis === void 0 ? void 0 : yAxis.scale) instanceof ContinuousScale;
                        ids = [
                            'area-stack-' + groupIndex + '-yValues',
                            'area-stack-' + groupIndex + '-yValues-trailing',
                            'area-stack-' + groupIndex + '-yValues-prev',
                            'area-stack-' + groupIndex + '-yValues-trailing-prev',
                            'area-stack-' + groupIndex + '-yValues-marker',
                        ];
                        extraProps = [];
                        normaliseTo = normalizedTo && isFinite(normalizedTo) ? normalizedTo : undefined;
                        if (normaliseTo) {
                            extraProps.push(normaliseGroupTo(this, [ids[0], ids[1], ids[4]], normaliseTo, 'range'));
                            extraProps.push(normaliseGroupTo(this, [ids[2], ids[3]], normaliseTo, 'range'));
                        }
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data, {
                                props: __spreadArray$k(
                                    __spreadArray$k(
                                        __spreadArray$k(
                                            __spreadArray$k(
                                                __spreadArray$k(
                                                    __spreadArray$k(
                                                        [
                                                            keyProperty(this, xKey, isContinuousX, { id: 'xValue' }),
                                                            valueProperty(this, yKey, isContinuousY, {
                                                                id: 'yValue-raw',
                                                                invalidValue: null,
                                                            }),
                                                        ],
                                                        __read$z(
                                                            groupAccumulativeValueProperty(
                                                                this,
                                                                yKey,
                                                                isContinuousY,
                                                                'window',
                                                                'current',
                                                                {
                                                                    id: 'yValue-end',
                                                                    invalidValue: null,
                                                                    groupId: ids[0],
                                                                },
                                                            ),
                                                        ),
                                                    ),
                                                    __read$z(
                                                        groupAccumulativeValueProperty(
                                                            this,
                                                            yKey,
                                                            isContinuousY,
                                                            'window-trailing',
                                                            'current',
                                                            {
                                                                id: 'yValue-start',
                                                                invalidValue: null,
                                                                groupId: ids[1],
                                                            },
                                                        ),
                                                    ),
                                                ),
                                                __read$z(
                                                    groupAccumulativeValueProperty(
                                                        this,
                                                        yKey,
                                                        isContinuousY,
                                                        'window',
                                                        'last',
                                                        {
                                                            id: 'yValue-previous-end',
                                                            invalidValue: null,
                                                            groupId: ids[2],
                                                        },
                                                    ),
                                                ),
                                            ),
                                            __read$z(
                                                groupAccumulativeValueProperty(
                                                    this,
                                                    yKey,
                                                    isContinuousY,
                                                    'window-trailing',
                                                    'last',
                                                    {
                                                        id: 'yValue-previous-start',
                                                        invalidValue: null,
                                                        groupId: ids[3],
                                                    },
                                                ),
                                            ),
                                        ),
                                        __read$z(
                                            groupAccumulativeValueProperty(
                                                this,
                                                yKey,
                                                isContinuousY,
                                                'normal',
                                                'current',
                                                {
                                                    id: 'yValue-cumulative',
                                                    invalidValue: null,
                                                    groupId: ids[4],
                                                },
                                            ),
                                        ),
                                    ),
                                    __read$z(extraProps),
                                ),
                                groupByKeys: true,
                                dataVisible: visible,
                            }),
                        ];
                    case 1:
                        (_e = _f.sent()), (dataModel = _e.dataModel), (processedData = _e.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        return [2 /*return*/];
                }
            });
        });
    };
    AreaSeries.prototype.getDomain = function (direction) {
        var _a = this,
            processedData = _a.processedData,
            dataModel = _a.dataModel,
            axes = _a.axes;
        if (!processedData || !dataModel) return [];
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        var keyDef = dataModel.resolveProcessedDataDefById(this, 'xValue');
        var keys = dataModel.getDomain(this, 'xValue', 'key', processedData);
        var yExtent = dataModel.getDomain(this, /yValue-(previous-)?end/, 'value', processedData);
        if (direction === ChartAxisDirection.X) {
            if (
                (keyDef === null || keyDef === void 0 ? void 0 : keyDef.def.type) === 'key' &&
                keyDef.def.valueType === 'category'
            ) {
                return keys;
            }
            return this.fixNumericExtent(extent$4(keys), xAxis);
        } else if (yAxis instanceof LogAxis || yAxis instanceof TimeAxis) {
            return this.fixNumericExtent(yExtent, yAxis);
        } else {
            var fixedYExtent = [yExtent[0] > 0 ? 0 : yExtent[0], yExtent[1] < 0 ? 0 : yExtent[1]];
            return this.fixNumericExtent(fixedYExtent, yAxis);
        }
    };
    AreaSeries.prototype.createNodeData = function () {
        var _a;
        return __awaiter$6(this, void 0, void 0, function () {
            var _b,
                axes,
                data,
                _c,
                _d,
                groupedData,
                dataModel,
                callbackCache,
                xAxis,
                yAxis,
                _e,
                _f,
                yKey,
                _g,
                xKey,
                marker,
                label,
                fill,
                stroke,
                seriesId,
                xScale,
                yScale,
                continuousY,
                xOffset,
                yStartIndex,
                yEndIndex,
                yRawIndex,
                yPreviousStartIndex,
                yPreviousEndIndex,
                yCumulativeIndex,
                createPathCoordinates,
                createMarkerCoordinate,
                labelSelectionData,
                markerSelectionData,
                strokeSelectionData,
                fillSelectionData,
                context,
                fillPoints,
                fillPhantomPoints,
                strokePoints,
                yValues,
                datumIdx,
                lastXDatum,
                i;
            var _this = this;
            return __generator$6(this, function (_h) {
                (_b = this),
                    (axes = _b.axes),
                    (data = _b.data),
                    (_c = _b.processedData),
                    (_d = _c === void 0 ? {} : _c),
                    (groupedData = _d.data),
                    (dataModel = _b.dataModel),
                    (callbackCache = _b.ctx.callbackCache);
                xAxis = axes[ChartAxisDirection.X];
                yAxis = axes[ChartAxisDirection.Y];
                if (!xAxis || !yAxis || !data || !dataModel) {
                    return [2 /*return*/, []];
                }
                (_e = this),
                    (_f = _e.yKey),
                    (yKey = _f === void 0 ? '' : _f),
                    (_g = _e.xKey),
                    (xKey = _g === void 0 ? '' : _g),
                    (marker = _e.marker),
                    (label = _e.label),
                    (fill = _e.fill),
                    (stroke = _e.stroke),
                    (seriesId = _e.id);
                xScale = xAxis.scale;
                yScale = yAxis.scale;
                continuousY = yScale instanceof ContinuousScale;
                xOffset = ((_a = xScale.bandwidth) !== null && _a !== void 0 ? _a : 0) / 2;
                yStartIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-start').index;
                yEndIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-end').index;
                yRawIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-raw').index;
                yPreviousStartIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-previous-start').index;
                yPreviousEndIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-previous-end').index;
                yCumulativeIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-cumulative').index;
                createPathCoordinates = function (xDatum, lastYEnd, yEnd) {
                    var x = xScale.convert(xDatum) + xOffset;
                    var prevYCoordinate = yScale.convert(lastYEnd, { strict: false });
                    var currYCoordinate = yScale.convert(yEnd, { strict: false });
                    return [
                        { x: x, y: currYCoordinate, size: marker.size },
                        { x: x, y: prevYCoordinate, size: marker.size },
                    ];
                };
                createMarkerCoordinate = function (xDatum, yEnd, rawYDatum) {
                    var currY;
                    // if not normalized, the invalid data points will be processed as `undefined` in processData()
                    // if normalized, the invalid data points will be processed as 0 rather than `undefined`
                    // check if unprocessed datum is valid as we only want to show markers for valid points
                    var normalized = _this.normalizedTo && isFinite(_this.normalizedTo);
                    var normalizedAndValid = normalized && continuousY && isContinuous(rawYDatum);
                    var valid = (!normalized && !isNaN(rawYDatum)) || normalizedAndValid;
                    if (valid) {
                        currY = yEnd;
                    }
                    var x = xScale.convert(xDatum) + xOffset;
                    var y = yScale.convert(currY, { strict: false });
                    return { x: x, y: y, size: marker.size };
                };
                labelSelectionData = [];
                markerSelectionData = [];
                strokeSelectionData = { itemId: yKey, points: [], yValues: [] };
                fillSelectionData = { itemId: yKey, points: [] };
                context = {
                    itemId: yKey,
                    fillSelectionData: fillSelectionData,
                    labelData: labelSelectionData,
                    nodeData: markerSelectionData,
                    strokeSelectionData: strokeSelectionData,
                };
                fillPoints = fillSelectionData.points;
                fillPhantomPoints = [];
                strokePoints = strokeSelectionData.points;
                yValues = strokeSelectionData.yValues;
                datumIdx = -1;
                groupedData === null || groupedData === void 0
                    ? void 0
                    : groupedData.forEach(function (datumGroup) {
                          var _a = __read$z(datumGroup.keys, 1),
                              xDatum = _a[0],
                              datumArray = datumGroup.datum,
                              valuesArray = datumGroup.values;
                          valuesArray.forEach(function (values, valueIdx) {
                              var _a;
                              datumIdx++;
                              var seriesDatum = datumArray[valueIdx];
                              var yRawDatum = values[yRawIndex];
                              var yStart = values[yStartIndex];
                              var yEnd = values[yEndIndex];
                              var yPreviousStart = values[yPreviousStartIndex];
                              var yPreviousEnd = values[yPreviousEndIndex];
                              var yCumulative = values[yCumulativeIndex];
                              var validPoint = yRawDatum != null;
                              // marker data
                              var point = createMarkerCoordinate(xDatum, +yCumulative, yRawDatum);
                              if (validPoint && marker) {
                                  markerSelectionData.push({
                                      index: datumIdx,
                                      series: _this,
                                      itemId: yKey,
                                      datum: seriesDatum,
                                      nodeMidPoint: { x: point.x, y: point.y },
                                      cumulativeValue: yEnd,
                                      yValue: yRawDatum,
                                      xValue: xDatum,
                                      yKey: yKey,
                                      xKey: xKey,
                                      point: point,
                                      fill: fill,
                                      stroke: stroke,
                                  });
                              }
                              // label data
                              if (validPoint && label) {
                                  var labelText = void 0;
                                  if (label.formatter) {
                                      labelText =
                                          (_a = callbackCache.call(label.formatter, {
                                              value: yRawDatum,
                                              seriesId: seriesId,
                                          })) !== null && _a !== void 0
                                              ? _a
                                              : '';
                                  } else {
                                      labelText = isNumber$4(yRawDatum)
                                          ? Number(yRawDatum).toFixed(2)
                                          : String(yRawDatum);
                                  }
                                  labelSelectionData.push({
                                      index: datumIdx,
                                      itemId: yKey,
                                      point: point,
                                      label: labelText
                                          ? {
                                                text: labelText,
                                                fontStyle: label.fontStyle,
                                                fontWeight: label.fontWeight,
                                                fontSize: label.fontSize,
                                                fontFamily: label.fontFamily,
                                                textAlign: 'center',
                                                textBaseline: 'bottom',
                                                fill: label.color,
                                            }
                                          : undefined,
                                  });
                              }
                              // fill data
                              // Handle data in pairs of current and next x and y values
                              var windowX = [lastXDatum, xDatum];
                              var windowYStart = [yPreviousStart, yStart];
                              var windowYEnd = [yPreviousEnd, yEnd];
                              if (
                                  windowX.some(function (v) {
                                      return v == undefined;
                                  })
                              ) {
                                  lastXDatum = xDatum;
                                  return;
                              }
                              if (
                                  windowYStart.some(function (v) {
                                      return v == undefined;
                                  })
                              ) {
                                  windowYStart[0] = 0;
                                  windowYStart[1] = 0;
                              }
                              if (
                                  windowYEnd.some(function (v) {
                                      return v == undefined;
                                  })
                              ) {
                                  windowYEnd[0] = 0;
                                  windowYEnd[1] = 0;
                              }
                              var prevCoordinates = createPathCoordinates(lastXDatum, +windowYStart[0], +windowYEnd[0]);
                              fillPoints.push(prevCoordinates[0]);
                              fillPhantomPoints.push(prevCoordinates[1]);
                              var nextCoordinates = createPathCoordinates(xDatum, +windowYStart[1], +windowYEnd[1]);
                              fillPoints.push(nextCoordinates[0]);
                              fillPhantomPoints.push(nextCoordinates[1]);
                              // stroke data
                              strokePoints.push({ x: NaN, y: NaN }); // moveTo
                              yValues.push(undefined);
                              if (yPreviousEnd != null) {
                                  strokePoints.push(prevCoordinates[0]);
                                  yValues.push(yPreviousEnd);
                              }
                              if (yEnd != undefined) {
                                  strokePoints.push(nextCoordinates[0]);
                                  yValues.push(yEnd);
                              }
                              lastXDatum = xDatum;
                          });
                      });
                for (i = fillPhantomPoints.length - 1; i >= 0; i--) {
                    fillPoints.push(fillPhantomPoints[i]);
                }
                return [2 /*return*/, [context]];
            });
        });
    };
    AreaSeries.prototype.isPathOrSelectionDirty = function () {
        return this.marker.isDirty();
    };
    AreaSeries.prototype.markerFactory = function () {
        var shape = this.marker.shape;
        var MarkerShape = getMarker$1(shape);
        return new MarkerShape();
    };
    AreaSeries.prototype.updateMarkerSelection = function (opts) {
        return __awaiter$6(this, void 0, void 0, function () {
            var nodeData, markerSelection, enabled, data;
            return __generator$6(this, function (_a) {
                (nodeData = opts.nodeData), (markerSelection = opts.markerSelection);
                enabled = this.marker.enabled;
                data = enabled && nodeData ? nodeData : [];
                if (this.marker.isDirty()) {
                    markerSelection.clear();
                }
                return [
                    2 /*return*/,
                    markerSelection.update(data, function (marker) {
                        marker.tag = AreaSeriesTag.Marker;
                    }),
                ];
            });
        });
    };
    AreaSeries.prototype.updateMarkerNodes = function (opts) {
        var _a;
        return __awaiter$6(this, void 0, void 0, function () {
            var markerSelection,
                isDatumHighlighted,
                _b,
                seriesId,
                _c,
                xKey,
                marker,
                seriesFill,
                seriesStroke,
                seriesFillOpacity,
                _d,
                markerFillOpacity,
                strokeOpacity,
                _e,
                highlightedFill,
                _f,
                highlightFillOpacity,
                highlightedStroke,
                highlightedDatumStrokeWidth,
                visible,
                callbackCache,
                size,
                formatter,
                markerStrokeWidth,
                customMarker;
            return __generator$6(this, function (_g) {
                (markerSelection = opts.markerSelection), (isDatumHighlighted = opts.isHighlight);
                (_b = this),
                    (seriesId = _b.id),
                    (_c = _b.xKey),
                    (xKey = _c === void 0 ? '' : _c),
                    (marker = _b.marker),
                    (seriesFill = _b.fill),
                    (seriesStroke = _b.stroke),
                    (seriesFillOpacity = _b.fillOpacity),
                    (_d = _b.marker.fillOpacity),
                    (markerFillOpacity = _d === void 0 ? seriesFillOpacity : _d),
                    (strokeOpacity = _b.strokeOpacity),
                    (_e = _b.highlightStyle.item),
                    (highlightedFill = _e.fill),
                    (_f = _e.fillOpacity),
                    (highlightFillOpacity = _f === void 0 ? markerFillOpacity : _f),
                    (highlightedStroke = _e.stroke),
                    (highlightedDatumStrokeWidth = _e.strokeWidth),
                    (visible = _b.visible),
                    (callbackCache = _b.ctx.callbackCache);
                (size = marker.size), (formatter = marker.formatter);
                markerStrokeWidth = (_a = marker.strokeWidth) !== null && _a !== void 0 ? _a : this.strokeWidth;
                customMarker = typeof marker.shape === 'function';
                markerSelection.each(function (node, datum) {
                    var _a, _b, _c, _d, _e, _f, _g, _h;
                    var fill =
                        isDatumHighlighted && highlightedFill !== undefined
                            ? highlightedFill
                            : (_a = marker.fill) !== null && _a !== void 0
                            ? _a
                            : seriesFill;
                    var fillOpacity = isDatumHighlighted ? highlightFillOpacity : markerFillOpacity;
                    var stroke =
                        isDatumHighlighted && highlightedStroke !== undefined
                            ? highlightedStroke
                            : (_b = marker.stroke) !== null && _b !== void 0
                            ? _b
                            : seriesStroke;
                    var strokeWidth =
                        isDatumHighlighted && highlightedDatumStrokeWidth !== undefined
                            ? highlightedDatumStrokeWidth
                            : markerStrokeWidth;
                    var format = undefined;
                    if (formatter) {
                        format = callbackCache.call(formatter, {
                            datum: datum.datum,
                            xKey: xKey,
                            yKey: datum.yKey,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            size: size,
                            highlighted: isDatumHighlighted,
                            seriesId: seriesId,
                        });
                    }
                    node.fill =
                        (_c = format === null || format === void 0 ? void 0 : format.fill) !== null && _c !== void 0
                            ? _c
                            : fill;
                    node.stroke =
                        (_d = format === null || format === void 0 ? void 0 : format.stroke) !== null && _d !== void 0
                            ? _d
                            : stroke;
                    node.strokeWidth =
                        (_e = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null &&
                        _e !== void 0
                            ? _e
                            : strokeWidth;
                    node.fillOpacity = fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : 1;
                    node.strokeOpacity =
                        (_g = (_f = marker.strokeOpacity) !== null && _f !== void 0 ? _f : strokeOpacity) !== null &&
                        _g !== void 0
                            ? _g
                            : 1;
                    node.size =
                        (_h = format === null || format === void 0 ? void 0 : format.size) !== null && _h !== void 0
                            ? _h
                            : size;
                    node.translationX = datum.point.x;
                    node.translationY = datum.point.y;
                    node.visible = node.size > 0 && visible && !isNaN(datum.point.x) && !isNaN(datum.point.y);
                    if (!customMarker || node.dirtyPath) {
                        return;
                    }
                    // Only for custom marker shapes
                    node.path.clear({ trackChanges: true });
                    node.updatePath();
                    node.checkPathDirty();
                });
                if (!isDatumHighlighted) {
                    this.marker.markClean();
                }
                return [2 /*return*/];
            });
        });
    };
    AreaSeries.prototype.updateLabelSelection = function (opts) {
        return __awaiter$6(this, void 0, void 0, function () {
            var labelData, labelSelection;
            return __generator$6(this, function (_a) {
                (labelData = opts.labelData), (labelSelection = opts.labelSelection);
                return [
                    2 /*return*/,
                    labelSelection.update(labelData, function (text) {
                        text.tag = AreaSeriesTag.Label;
                    }),
                ];
            });
        });
    };
    AreaSeries.prototype.updateLabelNodes = function (opts) {
        return __awaiter$6(this, void 0, void 0, function () {
            var labelSelection, _a, labelEnabled, fontStyle, fontWeight, fontSize, fontFamily, color;
            return __generator$6(this, function (_b) {
                labelSelection = opts.labelSelection;
                (_a = this.label),
                    (labelEnabled = _a.enabled),
                    (fontStyle = _a.fontStyle),
                    (fontWeight = _a.fontWeight),
                    (fontSize = _a.fontSize),
                    (fontFamily = _a.fontFamily),
                    (color = _a.color);
                labelSelection.each(function (text, datum) {
                    var point = datum.point,
                        label = datum.label;
                    if (label && labelEnabled) {
                        text.fontStyle = fontStyle;
                        text.fontWeight = fontWeight;
                        text.fontSize = fontSize;
                        text.fontFamily = fontFamily;
                        text.textAlign = label.textAlign;
                        text.textBaseline = label.textBaseline;
                        text.text = label.text;
                        text.x = point.x;
                        text.y = point.y - 10;
                        text.fill = color;
                        text.visible = true;
                    } else {
                        text.visible = false;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    AreaSeries.prototype.getNodeClickEvent = function (event, datum) {
        var _a;
        return new CartesianSeriesNodeClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            datum.yKey,
            event,
            datum,
            this,
        );
    };
    AreaSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        var _a;
        return new CartesianSeriesNodeDoubleClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            datum.yKey,
            event,
            datum,
            this,
        );
    };
    AreaSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a, _b, _c;
        var _d = this,
            xKey = _d.xKey,
            seriesId = _d.id,
            axes = _d.axes,
            xName = _d.xName,
            yName = _d.yName,
            seriesFill = _d.fill,
            seriesStroke = _d.stroke,
            tooltip = _d.tooltip,
            marker = _d.marker,
            dataModel = _d.dataModel;
        var yKey = nodeDatum.yKey,
            xValue = nodeDatum.xValue,
            yValue = nodeDatum.yValue,
            datum = nodeDatum.datum;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        if (!(xKey && yKey) || !(xAxis && yAxis && isNumber$4(yValue)) || !dataModel) {
            return '';
        }
        var yRawIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-raw').index;
        var size = marker.size,
            markerFormatter = marker.formatter,
            markerStrokeWidth = marker.strokeWidth,
            markerFill = marker.fill,
            markerStroke = marker.stroke;
        var xString = xAxis.formatDatum(xValue);
        var yString = yAxis.formatDatum(yValue);
        var processedYValue =
            (_b = (_a = this.processedData) === null || _a === void 0 ? void 0 : _a.data[nodeDatum.index]) === null ||
            _b === void 0
                ? void 0
                : _b.values[0][yRawIndex];
        var title = sanitizeHtml(yName);
        var content = sanitizeHtml(xString + ': ' + yString);
        var strokeWidth =
            markerStrokeWidth !== null && markerStrokeWidth !== void 0 ? markerStrokeWidth : this.strokeWidth;
        var fill = markerFill !== null && markerFill !== void 0 ? markerFill : seriesFill;
        var stroke = markerStroke !== null && markerStroke !== void 0 ? markerStroke : seriesStroke;
        var format = undefined;
        if (markerFormatter) {
            format = markerFormatter({
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size: size,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        var color =
            (_c = format === null || format === void 0 ? void 0 : format.fill) !== null && _c !== void 0 ? _c : fill;
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        var tooltipRenderer = tooltip.renderer,
            tooltipFormat = tooltip.format;
        if (tooltipFormat || tooltipRenderer) {
            var params = {
                datum: datum,
                xKey: xKey,
                xName: xName,
                xValue: xValue,
                yKey: yKey,
                yValue: yValue,
                processedYValue: processedYValue,
                yName: yName,
                color: color,
                title: title,
                seriesId: seriesId,
            };
            if (tooltipFormat) {
                return toTooltipHtml$1(
                    {
                        content: interpolate(tooltipFormat, params),
                    },
                    defaults,
                );
            }
            if (tooltipRenderer) {
                return toTooltipHtml$1(tooltipRenderer(params), defaults);
            }
        }
        return toTooltipHtml$1(defaults);
    };
    AreaSeries.prototype.getLegendData = function () {
        var _a, _b, _c, _d;
        var _e = this,
            data = _e.data,
            id = _e.id,
            xKey = _e.xKey,
            yKey = _e.yKey,
            yName = _e.yName,
            marker = _e.marker,
            fill = _e.fill,
            stroke = _e.stroke,
            fillOpacity = _e.fillOpacity,
            strokeOpacity = _e.strokeOpacity,
            visible = _e.visible;
        if (!(data === null || data === void 0 ? void 0 : data.length) || !xKey || !yKey) {
            return [];
        }
        // Area stacks should be listed in the legend in reverse order, for symmetry with the
        // vertical stack display order.
        return [
            {
                legendType: 'category',
                id: id,
                itemId: yKey,
                seriesId: id,
                enabled: visible,
                label: {
                    text: yName !== null && yName !== void 0 ? yName : yKey,
                },
                marker: {
                    shape: marker.shape,
                    fill: (_a = marker.fill) !== null && _a !== void 0 ? _a : fill,
                    stroke: (_b = marker.stroke) !== null && _b !== void 0 ? _b : stroke,
                    fillOpacity: (_c = marker.fillOpacity) !== null && _c !== void 0 ? _c : fillOpacity,
                    strokeOpacity: (_d = marker.strokeOpacity) !== null && _d !== void 0 ? _d : strokeOpacity,
                },
            },
        ];
    };
    AreaSeries.prototype.animateEmptyUpdateReady = function (_a) {
        var _this = this;
        var markerSelections = _a.markerSelections,
            labelSelections = _a.labelSelections,
            contextData = _a.contextData,
            paths = _a.paths,
            seriesRect = _a.seriesRect;
        var _b = this,
            seriesStroke = _b.stroke,
            seriesFill = _b.fill,
            fillOpacity = _b.fillOpacity,
            lineDash = _b.lineDash,
            lineDashOffset = _b.lineDashOffset,
            strokeOpacity = _b.strokeOpacity,
            strokeWidth = _b.strokeWidth,
            shadow = _b.shadow;
        contextData.forEach(function (_a, seriesIdx) {
            var _b, _c, _d, _e, _f;
            var fillSelectionData = _a.fillSelectionData,
                strokeSelectionData = _a.strokeSelectionData,
                itemId = _a.itemId;
            var _g = __read$z(paths[seriesIdx], 2),
                fill = _g[0],
                stroke = _g[1];
            var duration =
                (_c =
                    (_b = _this.ctx.animationManager) === null || _b === void 0
                        ? void 0
                        : _b.defaultOptions.duration) !== null && _c !== void 0
                    ? _c
                    : 1000;
            var markerDuration = 200;
            var animationOptions = {
                from: 0,
                to:
                    (_d = seriesRect === null || seriesRect === void 0 ? void 0 : seriesRect.width) !== null &&
                    _d !== void 0
                        ? _d
                        : 0,
                duration: duration,
            };
            // Stroke
            {
                var points_1 = strokeSelectionData.points,
                    yValues_1 = strokeSelectionData.yValues;
                stroke.tag = AreaSeriesTag.Stroke;
                stroke.fill = undefined;
                stroke.lineJoin = stroke.lineCap = 'round';
                stroke.pointerEvents = PointerEvents.None;
                stroke.stroke = seriesStroke;
                stroke.strokeWidth = _this.getStrokeWidth(_this.strokeWidth, { itemId: itemId });
                stroke.strokeOpacity = strokeOpacity;
                stroke.lineDash = lineDash;
                stroke.lineDashOffset = lineDashOffset;
                (_e = _this.ctx.animationManager) === null || _e === void 0
                    ? void 0
                    : _e.animate(
                          _this.id + '_empty-update-ready_stroke_' + seriesIdx,
                          __assign$C(__assign$C({}, animationOptions), {
                              onUpdate: function (xValue) {
                                  stroke.path.clear({ trackChanges: true });
                                  var moveTo = true;
                                  points_1.forEach(function (point, index) {
                                      // Draw/move the full segment if past the end of this segment
                                      if (yValues_1[index] === undefined || isNaN(point.x) || isNaN(point.y)) {
                                          moveTo = true;
                                      } else if (point.x <= xValue) {
                                          if (moveTo) {
                                              stroke.path.moveTo(point.x, point.y);
                                              moveTo = false;
                                          } else {
                                              stroke.path.lineTo(point.x, point.y);
                                          }
                                      } else if (
                                          index > 0 &&
                                          yValues_1[index] !== undefined &&
                                          yValues_1[index - 1] !== undefined &&
                                          points_1[index - 1].x <= xValue
                                      ) {
                                          // Draw/move partial line if in between the start and end of this segment
                                          var start = points_1[index - 1];
                                          var end = point;
                                          var x = xValue;
                                          var y = start.y + ((x - start.x) * (end.y - start.y)) / (end.x - start.x);
                                          stroke.path.lineTo(x, y);
                                      }
                                  });
                                  stroke.checkPathDirty();
                              },
                          }),
                      );
            }
            // Fill
            {
                var allPoints = fillSelectionData.points;
                var points_2 = allPoints.slice(0, allPoints.length / 2);
                var bottomPoints_1 = allPoints.slice(allPoints.length / 2);
                fill.tag = AreaSeriesTag.Fill;
                fill.stroke = undefined;
                fill.lineJoin = 'round';
                fill.pointerEvents = PointerEvents.None;
                fill.fill = seriesFill;
                fill.fillOpacity = fillOpacity;
                fill.strokeOpacity = strokeOpacity;
                fill.strokeWidth = strokeWidth;
                fill.lineDash = lineDash;
                fill.lineDashOffset = lineDashOffset;
                fill.fillShadow = shadow;
                (_f = _this.ctx.animationManager) === null || _f === void 0
                    ? void 0
                    : _f.animate(
                          _this.id + '_empty-update-ready_fill_' + seriesIdx,
                          __assign$C(__assign$C({}, animationOptions), {
                              onUpdate: function (xValue) {
                                  fill.path.clear({ trackChanges: true });
                                  var x = 0;
                                  var y = 0;
                                  points_2.forEach(function (point, index) {
                                      if (point.x <= xValue) {
                                          // Draw/move the full segment if past the end of this segment
                                          x = point.x;
                                          y = point.y;
                                          fill.path.lineTo(point.x, point.y);
                                      } else if (index > 0 && points_2[index - 1].x < xValue) {
                                          // Draw/move partial line if in between the start and end of this segment
                                          var start = points_2[index - 1];
                                          var end = point;
                                          x = xValue;
                                          y = start.y + ((x - start.x) * (end.y - start.y)) / (end.x - start.x);
                                          fill.path.lineTo(x, y);
                                      }
                                  });
                                  bottomPoints_1.forEach(function (point, index) {
                                      var reverseIndex = bottomPoints_1.length - index - 1;
                                      if (point.x <= xValue) {
                                          fill.path.lineTo(point.x, point.y);
                                      } else if (reverseIndex > 0 && points_2[reverseIndex - 1].x < xValue) {
                                          var start = point;
                                          var end = bottomPoints_1[index + 1];
                                          var bottomY =
                                              start.y + ((x - start.x) * (end.y - start.y)) / (end.x - start.x);
                                          fill.path.lineTo(x, bottomY);
                                      }
                                  });
                                  if (bottomPoints_1.length > 0) {
                                      fill.path.lineTo(
                                          bottomPoints_1[bottomPoints_1.length - 1].x,
                                          bottomPoints_1[bottomPoints_1.length - 1].y,
                                      );
                                  }
                                  fill.path.closePath();
                                  fill.checkPathDirty();
                              },
                          }),
                      );
            }
            markerSelections[seriesIdx].each(function (marker, datum) {
                var _a, _b, _c, _d;
                var delay = (seriesRect === null || seriesRect === void 0 ? void 0 : seriesRect.width)
                    ? (datum.point.x / seriesRect.width) * duration
                    : 0;
                var format = _this.animateFormatter(datum);
                var size =
                    (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0
                        ? _b
                        : 0;
                (_c = _this.ctx.animationManager) === null || _c === void 0
                    ? void 0
                    : _c.animate(
                          _this.id + '_empty-update-ready_' + marker.id,
                          __assign$C(__assign$C({}, animationOptions), {
                              to:
                                  (_d = format === null || format === void 0 ? void 0 : format.size) !== null &&
                                  _d !== void 0
                                      ? _d
                                      : size,
                              delay: delay,
                              duration: markerDuration,
                              onUpdate: function (size) {
                                  marker.size = size;
                              },
                          }),
                      );
            });
            labelSelections[seriesIdx].each(function (label, datum) {
                var _a;
                var delay = (seriesRect === null || seriesRect === void 0 ? void 0 : seriesRect.width)
                    ? (datum.point.x / seriesRect.width) * duration
                    : 0;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_empty-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: delay,
                          duration: markerDuration,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    AreaSeries.prototype.animateReadyUpdate = function (_a) {
        var _this = this;
        var contextData = _a.contextData,
            paths = _a.paths;
        var _b = this,
            seriesStroke = _b.stroke,
            seriesFill = _b.fill,
            fillOpacity = _b.fillOpacity,
            lineDash = _b.lineDash,
            lineDashOffset = _b.lineDashOffset,
            strokeOpacity = _b.strokeOpacity,
            strokeWidth = _b.strokeWidth,
            shadow = _b.shadow;
        contextData.forEach(function (_a, seriesIdx) {
            var strokeSelectionData = _a.strokeSelectionData,
                fillSelectionData = _a.fillSelectionData,
                itemId = _a.itemId;
            var _b = __read$z(paths[seriesIdx], 2),
                fill = _b[0],
                stroke = _b[1];
            // Stroke
            stroke.stroke = seriesStroke;
            stroke.strokeWidth = _this.getStrokeWidth(_this.strokeWidth, { itemId: itemId });
            stroke.strokeOpacity = strokeOpacity;
            stroke.lineDash = lineDash;
            stroke.lineDashOffset = lineDashOffset;
            stroke.path.clear({ trackChanges: true });
            var moveTo = true;
            strokeSelectionData.points.forEach(function (point, index) {
                if (strokeSelectionData.yValues[index] === undefined || isNaN(point.x) || isNaN(point.y)) {
                    moveTo = true;
                } else if (moveTo) {
                    stroke.path.moveTo(point.x, point.y);
                    moveTo = false;
                } else {
                    stroke.path.lineTo(point.x, point.y);
                }
            });
            stroke.checkPathDirty();
            // Fill
            fill.fill = seriesFill;
            fill.fillOpacity = fillOpacity;
            fill.strokeOpacity = strokeOpacity;
            fill.strokeWidth = strokeWidth;
            fill.lineDash = lineDash;
            fill.lineDashOffset = lineDashOffset;
            fill.fillShadow = shadow;
            fill.path.clear({ trackChanges: true });
            fillSelectionData.points.forEach(function (point) {
                fill.path.lineTo(point.x, point.y);
            });
            fill.path.closePath();
            fill.checkPathDirty();
        });
    };
    AreaSeries.prototype.animateFormatter = function (datum) {
        var _a, _b, _c;
        var _d = this,
            marker = _d.marker,
            seriesFill = _d.fill,
            seriesStroke = _d.stroke,
            _e = _d.xKey,
            xKey = _e === void 0 ? '' : _e,
            seriesId = _d.id,
            callbackCache = _d.ctx.callbackCache;
        var size = marker.size,
            formatter = marker.formatter;
        var fill = (_a = marker.fill) !== null && _a !== void 0 ? _a : seriesFill;
        var stroke = (_b = marker.stroke) !== null && _b !== void 0 ? _b : seriesStroke;
        var strokeWidth = (_c = marker.strokeWidth) !== null && _c !== void 0 ? _c : this.strokeWidth;
        var format = undefined;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: datum.datum,
                xKey: xKey,
                yKey: datum.yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size: size,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        return format;
    };
    AreaSeries.prototype.isLabelEnabled = function () {
        return this.label.enabled;
    };
    AreaSeries.className = 'AreaSeries';
    AreaSeries.type = 'area';
    __decorate$1o([Validate(COLOR_STRING)], AreaSeries.prototype, 'fill', void 0);
    __decorate$1o([Validate(COLOR_STRING)], AreaSeries.prototype, 'stroke', void 0);
    __decorate$1o([Validate(NUMBER(0, 1))], AreaSeries.prototype, 'fillOpacity', void 0);
    __decorate$1o([Validate(NUMBER(0, 1))], AreaSeries.prototype, 'strokeOpacity', void 0);
    __decorate$1o([Validate(OPT_LINE_DASH)], AreaSeries.prototype, 'lineDash', void 0);
    __decorate$1o([Validate(NUMBER(0))], AreaSeries.prototype, 'lineDashOffset', void 0);
    __decorate$1o([Validate(OPT_STRING)], AreaSeries.prototype, 'xKey', void 0);
    __decorate$1o([Validate(OPT_STRING)], AreaSeries.prototype, 'xName', void 0);
    __decorate$1o([Validate(OPT_STRING)], AreaSeries.prototype, 'yKey', void 0);
    __decorate$1o([Validate(OPT_STRING)], AreaSeries.prototype, 'yName', void 0);
    __decorate$1o([Validate(OPT_NUMBER(0))], AreaSeries.prototype, 'normalizedTo', void 0);
    __decorate$1o([Validate(NUMBER(0))], AreaSeries.prototype, 'strokeWidth', void 0);
    return AreaSeries;
})(CartesianSeries);

var __extends$22 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1n =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Rect = /** @class */ (function (_super) {
    __extends$22(Rect, _super);
    function Rect() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.borderPath = new Path2D();
        _this.x = 0;
        _this.y = 0;
        _this.width = 10;
        _this.height = 10;
        _this.radius = 0;
        /**
         * If `true`, the rect is aligned to the pixel grid for crisp looking lines.
         * Animated rects may not look nice with this option enabled, for example
         * when a rect is translated by a sub-pixel value on each frame.
         */
        _this.crisp = false;
        _this.lastUpdatePathStrokeWidth = Shape.defaultStyles.strokeWidth;
        _this.effectiveStrokeWidth = Shape.defaultStyles.strokeWidth;
        /**
         * When the rectangle's width or height is less than a pixel
         * and crisp mode is on, the rectangle will still fit into the pixel,
         * but will be less opaque to make an effect of holding less space.
         */
        _this.microPixelEffectOpacity = 1;
        return _this;
    }
    Rect.prototype.isDirtyPath = function () {
        var _a;
        if (this.lastUpdatePathStrokeWidth !== this.strokeWidth) {
            return true;
        }
        if (
            this.path.isDirty() ||
            this.borderPath.isDirty() ||
            ((_a = this.clipPath) === null || _a === void 0 ? void 0 : _a.isDirty())
        ) {
            return true;
        }
        return false;
    };
    Rect.prototype.updatePath = function () {
        var _a, _b, _c;
        var _d = this,
            path = _d.path,
            borderPath = _d.borderPath,
            crisp = _d.crisp;
        var _e = this,
            x = _e.x,
            y = _e.y,
            w = _e.width,
            h = _e.height,
            strokeWidth = _e.strokeWidth;
        var pixelRatio =
            (_b = (_a = this.layerManager) === null || _a === void 0 ? void 0 : _a.canvas.pixelRatio) !== null &&
            _b !== void 0
                ? _b
                : 1;
        var pixelSize = 1 / pixelRatio;
        var microPixelEffectOpacity = 1;
        path.clear({ trackChanges: true });
        borderPath.clear({ trackChanges: true });
        if (crisp) {
            if (w <= pixelSize) {
                microPixelEffectOpacity *= w / pixelSize;
            }
            if (h <= pixelSize) {
                microPixelEffectOpacity *= h / pixelSize;
            }
            w = this.align(x, w);
            h = this.align(y, h);
            x = this.align(x);
            y = this.align(y);
        }
        if (strokeWidth) {
            if (w < pixelSize) {
                // Too narrow, draw a vertical stroke
                var lx = x + pixelSize / 2;
                borderPath.moveTo(lx, y);
                borderPath.lineTo(lx, y + h);
                strokeWidth = pixelSize;
                this.borderClipPath = undefined;
            } else if (h < pixelSize) {
                // Too narrow, draw a horizontal stroke
                var ly = y + pixelSize / 2;
                borderPath.moveTo(x, ly);
                borderPath.lineTo(x + w, ly);
                strokeWidth = pixelSize;
                this.borderClipPath = undefined;
            } else if (strokeWidth < w && strokeWidth < h) {
                var halfStrokeWidth = strokeWidth / 2;
                x += halfStrokeWidth;
                y += halfStrokeWidth;
                w -= strokeWidth;
                h -= strokeWidth;
                // Clipping not needed in this case; fill to center of stroke.
                this.borderClipPath = undefined;
                path.rect(x, y, w, h);
                borderPath.rect(x, y, w, h);
            } else {
                // Skip the fill and just render the stroke.
                this.borderClipPath = (_c = this.borderClipPath) !== null && _c !== void 0 ? _c : new Path2D();
                this.borderClipPath.clear({ trackChanges: true });
                this.borderClipPath.rect(x, y, w, h);
                borderPath.rect(x, y, w, h);
            }
        } else {
            // No borderPath needed, and thus no clipPath needed either. Fill to full extent of
            // Rect.
            this.borderClipPath = undefined;
            path.rect(x, y, w, h);
        }
        this.effectiveStrokeWidth = strokeWidth;
        this.lastUpdatePathStrokeWidth = strokeWidth;
        this.microPixelEffectOpacity = microPixelEffectOpacity;
    };
    Rect.prototype.computeBBox = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height;
        return new BBox(x, y, width, height);
    };
    Rect.prototype.isPointInPath = function (x, y) {
        var point = this.transformPoint(x, y);
        var bbox = this.computeBBox();
        return bbox.containsPoint(point.x, point.y);
    };
    Rect.prototype.applyFillAlpha = function (ctx) {
        var _a = this,
            fillOpacity = _a.fillOpacity,
            microPixelEffectOpacity = _a.microPixelEffectOpacity,
            opacity = _a.opacity;
        var globalAlpha = ctx.globalAlpha;
        ctx.globalAlpha = globalAlpha * opacity * fillOpacity * microPixelEffectOpacity;
    };
    Rect.prototype.renderStroke = function (ctx) {
        var _a = this,
            stroke = _a.stroke,
            effectiveStrokeWidth = _a.effectiveStrokeWidth,
            borderPath = _a.borderPath,
            borderClipPath = _a.borderClipPath,
            opacity = _a.opacity,
            microPixelEffectOpacity = _a.microPixelEffectOpacity;
        var borderActive = !!stroke && !!effectiveStrokeWidth;
        if (borderActive) {
            var _b = this,
                strokeOpacity = _b.strokeOpacity,
                lineDash = _b.lineDash,
                lineDashOffset = _b.lineDashOffset,
                lineCap = _b.lineCap,
                lineJoin = _b.lineJoin;
            if (borderClipPath) {
                // strokeWidth is larger than width or height, so use clipping to render correctly.
                // This is the simplest way to achieve the correct rendering due to nuances with ~0
                // width/height lines in Canvas operations.
                borderClipPath.draw(ctx);
                ctx.clip();
            }
            borderPath.draw(ctx);
            var globalAlpha = ctx.globalAlpha;
            ctx.strokeStyle = stroke;
            ctx.globalAlpha = globalAlpha * opacity * strokeOpacity * microPixelEffectOpacity;
            ctx.lineWidth = effectiveStrokeWidth;
            if (lineDash) {
                ctx.setLineDash(lineDash);
            }
            if (lineDashOffset) {
                ctx.lineDashOffset = lineDashOffset;
            }
            if (lineCap) {
                ctx.lineCap = lineCap;
            }
            if (lineJoin) {
                ctx.lineJoin = lineJoin;
            }
            ctx.stroke();
            ctx.globalAlpha = globalAlpha;
        }
    };
    Rect.className = 'Rect';
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'x', void 0);
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'y', void 0);
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'width', void 0);
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'height', void 0);
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'radius', void 0);
    __decorate$1n([ScenePathChangeDetection()], Rect.prototype, 'crisp', void 0);
    return Rect;
})(Path);

var __assign$B =
    (undefined && undefined.__assign) ||
    function () {
        __assign$B =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$B.apply(this, arguments);
    };
var __rest$3 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __read$y =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
function createLabelData(_a) {
    var value = _a.value,
        rect = _a.rect,
        placement = _a.placement,
        seriesId = _a.seriesId,
        _b = _a.padding,
        padding = _b === void 0 ? 0 : _b,
        formatter = _a.formatter,
        barAlongX = _a.barAlongX,
        callbackCache = _a.ctx.callbackCache;
    var labelText;
    if (formatter) {
        labelText = callbackCache.call(formatter, {
            value: isNumber$4(value) ? value : undefined,
            seriesId: seriesId,
        });
    }
    if (labelText === undefined) {
        labelText = isNumber$4(value) ? value.toFixed(2) : '';
    }
    var labelX = rect.x + rect.width / 2;
    var labelY = rect.y + rect.height / 2;
    var labelTextAlign = 'center';
    var labelTextBaseline = 'middle';
    var isPositive = value >= 0;
    switch (placement) {
        case 'start': {
            if (barAlongX) {
                labelX = isPositive ? rect.x - padding : rect.x + rect.width + padding;
                labelTextAlign = isPositive ? 'start' : 'end';
            } else {
                labelY = isPositive ? rect.y + rect.height + padding : rect.y - padding;
                labelTextBaseline = isPositive ? 'top' : 'bottom';
            }
            break;
        }
        case 'outside':
        case 'end': {
            if (barAlongX) {
                labelX = isPositive ? rect.x + rect.width + padding : rect.x - padding;
                labelTextAlign = isPositive ? 'start' : 'end';
            } else {
                labelY = isPositive ? rect.y - padding : rect.y + rect.height + padding;
                labelTextBaseline = isPositive ? 'bottom' : 'top';
            }
            break;
        }
        case 'inside':
        default: {
            labelTextBaseline = 'middle';
            break;
        }
    }
    return {
        text: labelText,
        textAlign: labelTextAlign,
        textBaseline: labelTextBaseline,
        x: labelX,
        y: labelY,
    };
}
function updateRect(_a) {
    var rect = _a.rect,
        config = _a.config;
    var _b = config.crisp,
        crisp = _b === void 0 ? true : _b,
        fill = config.fill,
        stroke = config.stroke,
        strokeWidth = config.strokeWidth,
        fillOpacity = config.fillOpacity,
        strokeOpacity = config.strokeOpacity,
        lineDash = config.lineDash,
        lineDashOffset = config.lineDashOffset,
        fillShadow = config.fillShadow,
        _c = config.visible,
        visible = _c === void 0 ? true : _c;
    rect.crisp = crisp;
    rect.fill = fill;
    rect.stroke = stroke;
    rect.strokeWidth = strokeWidth;
    rect.fillOpacity = fillOpacity;
    rect.strokeOpacity = strokeOpacity;
    rect.lineDash = lineDash;
    rect.lineDashOffset = lineDashOffset;
    rect.fillShadow = fillShadow;
    rect.visible = visible;
}
function getRectConfig(_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var datum = _a.datum,
        isHighlighted = _a.isHighlighted,
        style = _a.style,
        highlightStyle = _a.highlightStyle,
        formatter = _a.formatter,
        seriesId = _a.seriesId,
        stackGroup = _a.stackGroup,
        callbackCache = _a.ctx.callbackCache,
        opts = __rest$3(_a, [
            'datum',
            'isHighlighted',
            'style',
            'highlightStyle',
            'formatter',
            'seriesId',
            'stackGroup',
            'ctx',
        ]);
    var itemFill = isHighlighted
        ? (_b = highlightStyle.fill) !== null && _b !== void 0
            ? _b
            : style.fill
        : style.fill;
    var itemStroke = isHighlighted
        ? (_c = highlightStyle.stroke) !== null && _c !== void 0
            ? _c
            : style.stroke
        : style.stroke;
    var itemStrokeWidth = isHighlighted
        ? (_d = highlightStyle.strokeWidth) !== null && _d !== void 0
            ? _d
            : style.strokeWidth
        : style.strokeWidth;
    var fillOpacity = isHighlighted
        ? (_e = highlightStyle.fillOpacity) !== null && _e !== void 0
            ? _e
            : style.fillOpacity
        : style.fillOpacity;
    var strokeOpacity = style.strokeOpacity,
        fillShadow = style.fillShadow,
        lineDash = style.lineDash,
        lineDashOffset = style.lineDashOffset;
    var format = undefined;
    if (formatter) {
        format = callbackCache.call(
            formatter,
            __assign$B(
                {
                    datum: datum.datum,
                    xKey: datum.xKey,
                    yKey: datum.yKey,
                    fill: itemFill,
                    stroke: itemStroke,
                    strokeWidth: itemStrokeWidth,
                    highlighted: isHighlighted,
                    seriesId: seriesId,
                    stackGroup: stackGroup,
                },
                opts,
            ),
        );
    }
    return {
        fill:
            (_f = format === null || format === void 0 ? void 0 : format.fill) !== null && _f !== void 0
                ? _f
                : itemFill,
        stroke:
            (_g = format === null || format === void 0 ? void 0 : format.stroke) !== null && _g !== void 0
                ? _g
                : itemStroke,
        strokeWidth:
            (_h = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null && _h !== void 0
                ? _h
                : itemStrokeWidth,
        fillOpacity: fillOpacity,
        strokeOpacity: strokeOpacity,
        lineDash: lineDash,
        lineDashOffset: lineDashOffset,
        fillShadow: fillShadow,
    };
}
function checkCrisp(visibleRange) {
    if (visibleRange === void 0) {
        visibleRange = [];
    }
    var _a = __read$y(visibleRange, 2),
        visibleMin = _a[0],
        visibleMax = _a[1];
    var isZoomed = visibleMin !== 0 || visibleMax !== 1;
    var crisp = !isZoomed;
    return crisp;
}
function updateLabel(_a) {
    var labelNode = _a.labelNode,
        labelDatum = _a.labelDatum,
        config = _a.config,
        visible = _a.visible;
    if (labelDatum && config && config.enabled) {
        var x = labelDatum.x,
            y = labelDatum.y,
            text = labelDatum.text,
            textAlign = labelDatum.textAlign,
            textBaseline = labelDatum.textBaseline;
        var fontStyle = config.fontStyle,
            fontWeight = config.fontWeight,
            fontSize = config.fontSize,
            fontFamily = config.fontFamily,
            color = config.color;
        labelNode.fontStyle = fontStyle;
        labelNode.fontWeight = fontWeight;
        labelNode.fontSize = fontSize;
        labelNode.fontFamily = fontFamily;
        labelNode.textAlign = textAlign;
        labelNode.textBaseline = textBaseline;
        labelNode.text = text;
        labelNode.x = x;
        labelNode.y = y;
        labelNode.fill = color;
        labelNode.visible = visible;
    } else {
        labelNode.visible = false;
    }
}

var __extends$21 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1m =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$5 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$5 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$x =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$j =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var BAR_LABEL_PLACEMENTS = ['inside', 'outside'];
var OPT_BAR_LABEL_PLACEMENT = function (v, ctx) {
    return OPTIONAL(v, ctx, function (v) {
        return BAR_LABEL_PLACEMENTS.includes(v);
    });
};
var BarSeriesNodeTag;
(function (BarSeriesNodeTag) {
    BarSeriesNodeTag[(BarSeriesNodeTag['Bar'] = 0)] = 'Bar';
    BarSeriesNodeTag[(BarSeriesNodeTag['Label'] = 1)] = 'Label';
})(BarSeriesNodeTag || (BarSeriesNodeTag = {}));
var BarSeriesLabel = /** @class */ (function (_super) {
    __extends$21(BarSeriesLabel, _super);
    function BarSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        _this.placement = 'inside';
        return _this;
    }
    __decorate$1m([Validate(OPT_FUNCTION)], BarSeriesLabel.prototype, 'formatter', void 0);
    __decorate$1m([Validate(OPT_BAR_LABEL_PLACEMENT)], BarSeriesLabel.prototype, 'placement', void 0);
    return BarSeriesLabel;
})(Label$1);
var BarSeriesTooltip = /** @class */ (function (_super) {
    __extends$21(BarSeriesTooltip, _super);
    function BarSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        return _this;
    }
    __decorate$1m([Validate(OPT_FUNCTION)], BarSeriesTooltip.prototype, 'renderer', void 0);
    return BarSeriesTooltip;
})(SeriesTooltip);
var BarSeries = /** @class */ (function (_super) {
    __extends$21(BarSeries, _super);
    function BarSeries(moduleCtx) {
        var _this =
            _super.call(this, {
                moduleCtx: moduleCtx,
                pickModes: [SeriesNodePickMode.EXACT_SHAPE_MATCH],
                pathsPerSeries: 0,
                hasHighlightedLabels: true,
            }) || this;
        _this.label = new BarSeriesLabel();
        _this.tooltip = new BarSeriesTooltip();
        _this.fill = '#c16068';
        _this.stroke = '#874349';
        _this.fillOpacity = 1;
        _this.strokeOpacity = 1;
        _this.lineDash = [0];
        _this.lineDashOffset = 0;
        _this.formatter = undefined;
        _this.xKey = undefined;
        _this.xName = undefined;
        _this.yKey = undefined;
        _this.yName = undefined;
        /**
         * Used to get the position of bars within each group.
         */
        _this.groupScale = new BandScale$5();
        _this.stackGroup = undefined;
        _this.strokeWidth = 1;
        _this.shadow = undefined;
        _this.smallestDataInterval = undefined;
        _this.datumSelectionGarbageCollection = false;
        _this.label.enabled = false;
        return _this;
    }
    BarSeries.prototype.resolveKeyDirection = function (direction) {
        if (this.getBarDirection() === ChartAxisDirection.X) {
            if (direction === ChartAxisDirection.X) {
                return ChartAxisDirection.Y;
            }
            return ChartAxisDirection.X;
        }
        return direction;
    };
    BarSeries.prototype.processData = function (dataController) {
        var _a, _b, _c, _d, _e;
        return __awaiter$5(this, void 0, void 0, function () {
            var _f,
                xKey,
                yKey,
                normalizedTo,
                _g,
                _h,
                _j,
                groupIndex,
                _k,
                data,
                normalizedToAbs,
                isContinuousX,
                isContinuousY,
                stackGroupName,
                stackGroupTrailingName,
                normaliseTo,
                extraProps,
                _l,
                dataModel,
                processedData;
            return __generator$5(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        (_f = this),
                            (xKey = _f.xKey),
                            (yKey = _f.yKey),
                            (normalizedTo = _f.normalizedTo),
                            (_g = _f.seriesGrouping),
                            (_h = _g === void 0 ? {} : _g),
                            (_j = _h.groupIndex),
                            (groupIndex = _j === void 0 ? this.id : _j),
                            (_k = _f.data),
                            (data = _k === void 0 ? [] : _k);
                        normalizedToAbs = Math.abs(
                            normalizedTo !== null && normalizedTo !== void 0 ? normalizedTo : NaN,
                        );
                        isContinuousX =
                            ((_a = this.getCategoryAxis()) === null || _a === void 0 ? void 0 : _a.scale) instanceof
                            ContinuousScale;
                        isContinuousY =
                            ((_b = this.getValueAxis()) === null || _b === void 0 ? void 0 : _b.scale) instanceof
                            ContinuousScale;
                        stackGroupName = 'bar-stack-' + groupIndex + '-yValues';
                        stackGroupTrailingName = stackGroupName + '-trailing';
                        normaliseTo = normalizedToAbs && isFinite(normalizedToAbs) ? normalizedToAbs : undefined;
                        extraProps = [];
                        if (normaliseTo) {
                            extraProps.push(
                                normaliseGroupTo(this, [stackGroupName, stackGroupTrailingName], normaliseTo, 'range'),
                            );
                        }
                        if (
                            !((_c = this.ctx.animationManager) === null || _c === void 0
                                ? void 0
                                : _c.skipAnimations) &&
                            this.processedData
                        ) {
                            extraProps.push(diff(this.processedData));
                        }
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data, {
                                props: __spreadArray$j(
                                    __spreadArray$j(
                                        __spreadArray$j(
                                            __spreadArray$j(
                                                [
                                                    keyProperty(this, xKey, isContinuousX, { id: 'xValue' }),
                                                    valueProperty(this, yKey, isContinuousY, {
                                                        id: 'yValue-raw',
                                                        invalidValue: null,
                                                    }),
                                                ],
                                                __read$x(
                                                    groupAccumulativeValueProperty(
                                                        this,
                                                        yKey,
                                                        isContinuousY,
                                                        'normal',
                                                        'current',
                                                        {
                                                            id: 'yValue-end',
                                                            invalidValue: null,
                                                            groupId: stackGroupName,
                                                        },
                                                    ),
                                                ),
                                            ),
                                            __read$x(
                                                groupAccumulativeValueProperty(
                                                    this,
                                                    yKey,
                                                    isContinuousY,
                                                    'trailing',
                                                    'current',
                                                    {
                                                        id: 'yValue-start',
                                                        invalidValue: null,
                                                        groupId: stackGroupTrailingName,
                                                    },
                                                ),
                                            ),
                                        ),
                                        __read$x(isContinuousX ? [SMALLEST_KEY_INTERVAL] : []),
                                    ),
                                    __read$x(extraProps),
                                ),
                                groupByKeys: true,
                                dataVisible: this.visible,
                            }),
                        ];
                    case 1:
                        (_l = _m.sent()), (dataModel = _l.dataModel), (processedData = _l.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        this.smallestDataInterval = {
                            x:
                                (_e =
                                    (_d = processedData.reduced) === null || _d === void 0
                                        ? void 0
                                        : _d[SMALLEST_KEY_INTERVAL.property]) !== null && _e !== void 0
                                    ? _e
                                    : Infinity,
                            y: Infinity,
                        };
                        this.animationState.transition('updateData');
                        return [2 /*return*/];
                }
            });
        });
    };
    BarSeries.prototype.getDomain = function (direction) {
        var _a;
        var _b = this,
            processedData = _b.processedData,
            dataModel = _b.dataModel;
        if (!processedData || !dataModel) return [];
        var _c = processedData,
            _d = _c.reduced,
            _e = _d === void 0 ? {} : _d,
            _f = SMALLEST_KEY_INTERVAL.property,
            smallestX = _e[_f];
        var categoryAxis = this.getCategoryAxis();
        var valueAxis = this.getValueAxis();
        var keyDef = dataModel.resolveProcessedDataDefById(this, 'xValue');
        var keys = dataModel.getDomain(this, 'xValue', 'key', processedData);
        var yExtent = dataModel.getDomain(this, 'yValue-end', 'value', processedData);
        if (direction === this.getCategoryDirection()) {
            if (
                (keyDef === null || keyDef === void 0 ? void 0 : keyDef.def.type) === 'key' &&
                (keyDef === null || keyDef === void 0 ? void 0 : keyDef.def.valueType) === 'category'
            ) {
                return keys;
            }
            var scalePadding = isFinite(smallestX) ? smallestX : 0;
            var keysExtent = (_a = extent$4(keys)) !== null && _a !== void 0 ? _a : [NaN, NaN];
            if (direction === ChartAxisDirection.Y) {
                return this.fixNumericExtent([keysExtent[0] + -scalePadding, keysExtent[1]], categoryAxis);
            }
            return this.fixNumericExtent([keysExtent[0], keysExtent[1] + scalePadding], categoryAxis);
        } else if (this.getValueAxis() instanceof LogAxis) {
            return this.fixNumericExtent(yExtent, valueAxis);
        } else {
            var fixedYExtent = [yExtent[0] > 0 ? 0 : yExtent[0], yExtent[1] < 0 ? 0 : yExtent[1]];
            return this.fixNumericExtent(fixedYExtent, valueAxis);
        }
    };
    BarSeries.prototype.getNodeClickEvent = function (event, datum) {
        var _a;
        return new CartesianSeriesNodeClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            datum.yKey,
            event,
            datum,
            this,
        );
    };
    BarSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        var _a;
        return new CartesianSeriesNodeDoubleClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            datum.yKey,
            event,
            datum,
            this,
        );
    };
    BarSeries.prototype.getCategoryAxis = function () {
        var direction = this.getCategoryDirection();
        return this.axes[direction];
    };
    BarSeries.prototype.getValueAxis = function () {
        var direction = this.getBarDirection();
        return this.axes[direction];
    };
    BarSeries.prototype.calculateStep = function (range) {
        var _a;
        var smallestInterval = this.smallestDataInterval;
        var xAxis = this.getCategoryAxis();
        if (!xAxis) {
            return;
        }
        // calculate step
        var domainLength = xAxis.dataDomain[1] - xAxis.dataDomain[0];
        var intervals =
            domainLength /
                ((_a = smallestInterval === null || smallestInterval === void 0 ? void 0 : smallestInterval.x) !==
                    null && _a !== void 0
                    ? _a
                    : 1) +
            1;
        // The number of intervals/bands is used to determine the width of individual bands by dividing the available range.
        // Allow a maximum number of bands to ensure the step does not fall below 1 pixel.
        // This means there could be some overlap of the bands in the chart.
        var maxBands = Math.floor(range); // A minimum of 1px per bar/column means the maximum number of bands will equal the available range
        var bands = Math.min(intervals, maxBands);
        var step = range / Math.max(1, bands);
        return step;
    };
    BarSeries.prototype.createNodeData = function () {
        return __awaiter$5(this, void 0, void 0, function () {
            var _a,
                visible,
                dataModel,
                xAxis,
                yAxis,
                xScale,
                yScale,
                _b,
                groupScale,
                _c,
                yKey,
                _d,
                xKey,
                fill,
                stroke,
                strokeWidth,
                label,
                seriesId,
                processedData,
                ctx,
                seriesStateManager,
                xBandWidth,
                availableRange,
                step,
                domain,
                _e,
                groupIndex,
                visibleGroupCount,
                groupIdx,
                barWidth,
                xIndex,
                yRawIndex,
                yStartIndex,
                yEndIndex,
                context;
            var _this = this;
            return __generator$5(this, function (_f) {
                (_a = this), (visible = _a.visible), (dataModel = _a.dataModel);
                xAxis = this.getCategoryAxis();
                yAxis = this.getValueAxis();
                if (!(dataModel && visible && xAxis && yAxis)) {
                    return [2 /*return*/, []];
                }
                xScale = xAxis.scale;
                yScale = yAxis.scale;
                (_b = this),
                    (groupScale = _b.groupScale),
                    (_c = _b.yKey),
                    (yKey = _c === void 0 ? '' : _c),
                    (_d = _b.xKey),
                    (xKey = _d === void 0 ? '' : _d),
                    (fill = _b.fill),
                    (stroke = _b.stroke),
                    (strokeWidth = _b.strokeWidth),
                    (label = _b.label),
                    (seriesId = _b.id),
                    (processedData = _b.processedData),
                    (ctx = _b.ctx),
                    (seriesStateManager = _b.ctx.seriesStateManager);
                xBandWidth = xScale.bandwidth;
                if (xScale instanceof ContinuousScale) {
                    availableRange = Math.max(xAxis.range[0], xAxis.range[1]);
                    step = this.calculateStep(availableRange);
                    xBandWidth = step;
                }
                domain = [];
                (_e = seriesStateManager.getVisiblePeerGroupIndex(this)),
                    (groupIndex = _e.index),
                    (visibleGroupCount = _e.visibleGroupCount);
                for (groupIdx = 0; groupIdx < visibleGroupCount; groupIdx++) {
                    domain.push(String(groupIdx));
                }
                groupScale.domain = domain;
                groupScale.range = [0, xBandWidth !== null && xBandWidth !== void 0 ? xBandWidth : 0];
                if (xAxis instanceof CategoryAxis) {
                    groupScale.padding = xAxis.groupPaddingInner;
                } else if (xAxis instanceof GroupedCategoryAxis) {
                    groupScale.padding = 0.1;
                } else {
                    // Number or Time axis
                    groupScale.padding = 0;
                }
                // To get exactly `0` padding we need to turn off rounding
                if (groupScale.padding === 0) {
                    groupScale.round = false;
                } else {
                    groupScale.round = true;
                }
                barWidth =
                    groupScale.bandwidth >= 1
                        ? // Pixel-rounded value for low-volume bar charts.
                          groupScale.bandwidth
                        : // Handle high-volume bar charts gracefully.
                          groupScale.rawBandwidth;
                xIndex = dataModel.resolveProcessedDataIndexById(this, 'xValue', 'key').index;
                yRawIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-raw').index;
                yStartIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-start').index;
                yEndIndex = dataModel.resolveProcessedDataIndexById(this, 'yValue-end').index;
                context = {
                    itemId: yKey,
                    nodeData: [],
                    labelData: [],
                };
                processedData === null || processedData === void 0
                    ? void 0
                    : processedData.data.forEach(function (_a, dataIndex) {
                          var keys = _a.keys,
                              seriesDatum = _a.datum,
                              values = _a.values;
                          var xValue = keys[xIndex];
                          var x = xScale.convert(xValue);
                          var currY = +values[0][yEndIndex];
                          var prevY = +values[0][yStartIndex];
                          var yRawValue = values[0][yRawIndex];
                          var barX = x + groupScale.convert(String(groupIndex));
                          // Bars outside of visible range are not rendered, so we create node data
                          // only for the visible subset of user data.
                          if (!xAxis.inRange(barX, barWidth)) {
                              return;
                          }
                          if (isNaN(currY)) {
                              return;
                          }
                          var y = yScale.convert(currY, { strict: false });
                          var bottomY = yScale.convert(prevY, { strict: false });
                          var barAlongX = _this.getBarDirection() === ChartAxisDirection.X;
                          var rect = {
                              x: barAlongX ? Math.min(y, bottomY) : barX,
                              y: barAlongX ? barX : Math.min(y, bottomY),
                              width: barAlongX ? Math.abs(bottomY - y) : barWidth,
                              height: barAlongX ? barWidth : Math.abs(bottomY - y),
                          };
                          var nodeMidPoint = {
                              x: rect.x + rect.width / 2,
                              y: rect.y + rect.height / 2,
                          };
                          var labelFontStyle = label.fontStyle,
                              labelFontWeight = label.fontWeight,
                              labelFontSize = label.fontSize,
                              labelFontFamily = label.fontFamily,
                              labelColor = label.color,
                              formatter = label.formatter,
                              placement = label.placement;
                          var _b = createLabelData({
                                  value: yRawValue,
                                  rect: rect,
                                  formatter: formatter,
                                  placement: placement,
                                  seriesId: seriesId,
                                  barAlongX: barAlongX,
                                  ctx: ctx,
                              }),
                              labelText = _b.text,
                              labelTextAlign = _b.textAlign,
                              labelTextBaseline = _b.textBaseline,
                              labelX = _b.x,
                              labelY = _b.y;
                          var nodeData = {
                              index: dataIndex,
                              series: _this,
                              itemId: yKey,
                              datum: seriesDatum[0],
                              cumulativeValue: prevY + currY,
                              xValue: xValue,
                              yValue: yRawValue,
                              yKey: yKey,
                              xKey: xKey,
                              x: rect.x,
                              y: rect.y,
                              width: rect.width,
                              height: rect.height,
                              nodeMidPoint: nodeMidPoint,
                              fill: fill,
                              stroke: stroke,
                              strokeWidth: strokeWidth,
                              label: labelText
                                  ? {
                                        text: labelText,
                                        fontStyle: labelFontStyle,
                                        fontWeight: labelFontWeight,
                                        fontSize: labelFontSize,
                                        fontFamily: labelFontFamily,
                                        textAlign: labelTextAlign,
                                        textBaseline: labelTextBaseline,
                                        fill: labelColor,
                                        x: labelX,
                                        y: labelY,
                                    }
                                  : undefined,
                          };
                          context.nodeData.push(nodeData);
                          context.labelData.push(nodeData);
                      });
                return [2 /*return*/, [context]];
            });
        });
    };
    BarSeries.prototype.nodeFactory = function () {
        return new Rect();
    };
    BarSeries.prototype.updateDatumSelection = function (opts) {
        return __awaiter$5(this, void 0, void 0, function () {
            var nodeData, datumSelection, getDatumId;
            return __generator$5(this, function (_a) {
                (nodeData = opts.nodeData), (datumSelection = opts.datumSelection);
                getDatumId = function (datum) {
                    return datum.xValue;
                };
                return [
                    2 /*return*/,
                    datumSelection.update(
                        nodeData,
                        function (rect) {
                            return (rect.tag = BarSeriesNodeTag.Bar);
                        },
                        getDatumId,
                    ),
                ];
            });
        });
    };
    BarSeries.prototype.updateDatumNodes = function (opts) {
        return __awaiter$5(this, void 0, void 0, function () {
            var datumSelection,
                isHighlight,
                _a,
                fill,
                stroke,
                fillOpacity,
                strokeOpacity,
                lineDash,
                lineDashOffset,
                shadow,
                formatter,
                seriesId,
                itemHighlightStyle,
                ctx,
                stackGroup,
                xAxis,
                crisp,
                categoryAlongX;
            var _this = this;
            return __generator$5(this, function (_b) {
                (datumSelection = opts.datumSelection), (isHighlight = opts.isHighlight);
                (_a = this),
                    (fill = _a.fill),
                    (stroke = _a.stroke),
                    (fillOpacity = _a.fillOpacity),
                    (strokeOpacity = _a.strokeOpacity),
                    (lineDash = _a.lineDash),
                    (lineDashOffset = _a.lineDashOffset),
                    (shadow = _a.shadow),
                    (formatter = _a.formatter),
                    (seriesId = _a.id),
                    (itemHighlightStyle = _a.highlightStyle.item),
                    (ctx = _a.ctx),
                    (stackGroup = _a.stackGroup);
                xAxis = this.axes[ChartAxisDirection.X];
                crisp = checkCrisp(xAxis === null || xAxis === void 0 ? void 0 : xAxis.visibleRange);
                categoryAlongX = this.getCategoryDirection() === ChartAxisDirection.X;
                datumSelection.each(function (rect, datum) {
                    var style = {
                        fill: fill,
                        stroke: stroke,
                        fillOpacity: fillOpacity,
                        strokeOpacity: strokeOpacity,
                        lineDash: lineDash,
                        lineDashOffset: lineDashOffset,
                        fillShadow: shadow,
                        strokeWidth: _this.getStrokeWidth(_this.strokeWidth, datum),
                    };
                    var visible = categoryAlongX ? datum.width > 0 : datum.height > 0;
                    var config = getRectConfig({
                        datum: datum,
                        isHighlighted: isHighlight,
                        style: style,
                        highlightStyle: itemHighlightStyle,
                        formatter: formatter,
                        seriesId: seriesId,
                        stackGroup: stackGroup,
                        ctx: ctx,
                    });
                    config.crisp = crisp;
                    config.visible = visible;
                    updateRect({ rect: rect, config: config });
                });
                return [2 /*return*/];
            });
        });
    };
    BarSeries.prototype.updateLabelSelection = function (opts) {
        return __awaiter$5(this, void 0, void 0, function () {
            var labelData, labelSelection, enabled, data;
            return __generator$5(this, function (_a) {
                (labelData = opts.labelData), (labelSelection = opts.labelSelection);
                enabled = this.label.enabled;
                data = enabled ? labelData : [];
                return [
                    2 /*return*/,
                    labelSelection.update(data, function (text) {
                        text.tag = BarSeriesNodeTag.Label;
                        text.pointerEvents = PointerEvents.None;
                    }),
                ];
            });
        });
    };
    BarSeries.prototype.updateLabelNodes = function (opts) {
        return __awaiter$5(this, void 0, void 0, function () {
            var labelSelection;
            var _this = this;
            return __generator$5(this, function (_a) {
                labelSelection = opts.labelSelection;
                labelSelection.each(function (text, datum) {
                    var labelDatum = datum.label;
                    updateLabel({ labelNode: text, labelDatum: labelDatum, config: _this.label, visible: true });
                });
                return [2 /*return*/];
            });
        });
    };
    BarSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a;
        var _b = this,
            xKey = _b.xKey,
            yKey = _b.yKey,
            processedData = _b.processedData,
            callbackCache = _b.ctx.callbackCache;
        var xAxis = this.getCategoryAxis();
        var yAxis = this.getValueAxis();
        var xValue = nodeDatum.xValue,
            yValue = nodeDatum.yValue,
            datum = nodeDatum.datum;
        if (!processedData || !xKey || !yKey || !xAxis || !yAxis) {
            return '';
        }
        var _c = this,
            xName = _c.xName,
            yName = _c.yName,
            fill = _c.fill,
            stroke = _c.stroke,
            tooltip = _c.tooltip,
            formatter = _c.formatter,
            seriesId = _c.id,
            stackGroup = _c.stackGroup;
        var tooltipRenderer = tooltip.renderer;
        var strokeWidth = this.getStrokeWidth(this.strokeWidth);
        var xString = sanitizeHtml(xAxis.formatDatum(xValue));
        var yString = sanitizeHtml(yAxis.formatDatum(yValue));
        var title = sanitizeHtml(yName);
        var content = xString + ': ' + yString;
        var format = undefined;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: datum,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                highlighted: false,
                xKey: xKey,
                yKey: yKey,
                seriesId: seriesId,
                stackGroup: stackGroup,
            });
        }
        var color =
            (_a = format === null || format === void 0 ? void 0 : format.fill) !== null && _a !== void 0 ? _a : fill;
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        if (tooltipRenderer) {
            return toTooltipHtml$1(
                tooltipRenderer({
                    datum: datum,
                    xKey: xKey,
                    xValue: xValue,
                    xName: xName,
                    yKey: yKey,
                    yValue: yValue,
                    yName: yName,
                    color: color,
                    title: title,
                    seriesId: seriesId,
                    stackGroup: stackGroup,
                }),
                defaults,
            );
        }
        return toTooltipHtml$1(defaults);
    };
    BarSeries.prototype.getLegendData = function () {
        var _a;
        var _b = this,
            id = _b.id,
            data = _b.data,
            xKey = _b.xKey,
            yKey = _b.yKey,
            yName = _b.yName,
            legendItemName = _b.legendItemName,
            fill = _b.fill,
            stroke = _b.stroke,
            fillOpacity = _b.fillOpacity,
            strokeOpacity = _b.strokeOpacity,
            visible = _b.visible,
            showInLegend = _b.showInLegend;
        if (!showInLegend || !(data === null || data === void 0 ? void 0 : data.length) || !xKey || !yKey) {
            return [];
        }
        var legendData = [];
        legendData.push({
            legendType: 'category',
            id: id,
            itemId: yKey,
            seriesId: id,
            enabled: visible,
            label: {
                text:
                    (_a = legendItemName !== null && legendItemName !== void 0 ? legendItemName : yName) !== null &&
                    _a !== void 0
                        ? _a
                        : yKey,
            },
            legendItemName: legendItemName,
            marker: {
                fill: fill,
                stroke: stroke,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity,
            },
        });
        return legendData;
    };
    BarSeries.prototype.animateEmptyUpdateReady = function (_a) {
        var _this = this;
        var _b, _c;
        var datumSelections = _a.datumSelections,
            labelSelections = _a.labelSelections;
        var duration =
            (_c = (_b = this.ctx.animationManager) === null || _b === void 0 ? void 0 : _b.defaultOptions.duration) !==
                null && _c !== void 0
                ? _c
                : 1000;
        var labelDuration = 200;
        var _d = this.getDirectionStartingValues(datumSelections),
            startingX = _d.startingX,
            startingY = _d.startingY;
        datumSelections.forEach(function (datumSelection) {
            datumSelection.each(function (rect, datum) {
                var _a;
                var contextX = startingX;
                var contextWidth = 0;
                var contextY = datum.y;
                var contextHeight = datum.height;
                if (_this.getBarDirection() === ChartAxisDirection.Y) {
                    contextX = datum.x;
                    contextWidth = datum.width;
                    contextY = startingY;
                    contextHeight = 0;
                }
                var props = [
                    { from: contextX, to: datum.x },
                    { from: contextWidth, to: datum.width },
                    { from: contextY, to: datum.y },
                    { from: contextHeight, to: datum.height },
                ];
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animateMany(_this.id + '_empty-update-ready_' + rect.id, props, {
                          duration: duration,
                          ease: easeOut,
                          onUpdate: function (_a) {
                              var _b = __read$x(_a, 4),
                                  x = _b[0],
                                  width = _b[1],
                                  y = _b[2],
                                  height = _b[3];
                              rect.x = x;
                              rect.width = width;
                              rect.y = y;
                              rect.height = height;
                          },
                      });
            });
        });
        labelSelections.forEach(function (labelSelection) {
            labelSelection.each(function (label) {
                var _a;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_empty-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: duration,
                          duration: labelDuration,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    BarSeries.prototype.animateReadyHighlight = function (highlightSelection) {
        this.resetSelectionRects(highlightSelection);
    };
    BarSeries.prototype.animateReadyResize = function (_a) {
        var _this = this;
        var _b;
        var datumSelections = _a.datumSelections;
        (_b = this.ctx.animationManager) === null || _b === void 0 ? void 0 : _b.reset();
        datumSelections.forEach(function (datumSelection) {
            _this.resetSelectionRects(datumSelection);
        });
    };
    BarSeries.prototype.animateWaitingUpdateReady = function (_a) {
        var _this = this;
        var _b, _c, _d, _e, _f;
        var datumSelections = _a.datumSelections,
            labelSelections = _a.labelSelections;
        var processedData = this.processedData;
        var diff =
            (_b = processedData === null || processedData === void 0 ? void 0 : processedData.reduced) === null ||
            _b === void 0
                ? void 0
                : _b.diff;
        if (!(diff === null || diff === void 0 ? void 0 : diff.changed)) {
            datumSelections.forEach(function (datumSelection) {
                _this.resetSelectionRects(datumSelection);
            });
            return;
        }
        var totalDuration =
            (_d = (_c = this.ctx.animationManager) === null || _c === void 0 ? void 0 : _c.defaultOptions.duration) !==
                null && _d !== void 0
                ? _d
                : 1000;
        var labelDuration = 200;
        var sectionDuration = totalDuration;
        if (diff.added.length > 0 || diff.removed.length > 0) {
            sectionDuration = Math.floor(totalDuration / 2);
        }
        var _g = this.getDirectionStartingValues(datumSelections),
            startingX = _g.startingX,
            startingY = _g.startingY;
        var datumIdKey =
            (_f = (_e = this.processedData) === null || _e === void 0 ? void 0 : _e.defs.keys) === null || _f === void 0
                ? void 0
                : _f[0];
        var addedIds = {};
        diff.added.forEach(function (d) {
            addedIds[d[0]] = true;
        });
        var removedIds = {};
        diff.removed.forEach(function (d) {
            removedIds[d[0]] = true;
        });
        var rectThrottleGroup = this.id + '_' + Math.random();
        var labelThrottleGroup = this.id + '_' + Math.random();
        datumSelections.forEach(function (datumSelection) {
            datumSelection.each(function (rect, datum) {
                var _a;
                var props = [
                    { from: rect.x, to: datum.x },
                    { from: rect.width, to: datum.width },
                    { from: rect.y, to: datum.y },
                    { from: rect.height, to: datum.height },
                ];
                var delay = diff.removed.length > 0 ? sectionDuration : 0;
                var duration = sectionDuration;
                var cleanup = false;
                var datumId = datumIdKey ? datum.xValue : '';
                var contextX = startingX;
                var contextWidth = 0;
                var contextY = datum.y;
                var contextHeight = datum.height;
                if (_this.getBarDirection() === ChartAxisDirection.Y) {
                    contextX = datum.x;
                    contextWidth = datum.width;
                    contextY = startingY;
                    contextHeight = 0;
                }
                var isAdded = datumId !== undefined && addedIds[datumId] !== undefined;
                var isRemoved = datumId !== undefined && removedIds[datumId] !== undefined;
                if (isAdded) {
                    props = [
                        { from: contextX, to: datum.x },
                        { from: contextWidth, to: datum.width },
                        { from: contextY, to: datum.y },
                        { from: contextHeight, to: datum.height },
                    ];
                    duration = sectionDuration;
                } else if (isRemoved) {
                    props = [
                        { from: datum.x, to: contextX },
                        { from: datum.width, to: contextWidth },
                        { from: datum.y, to: contextY },
                        { from: datum.height, to: contextHeight },
                    ];
                    delay = 0;
                    duration = sectionDuration;
                    cleanup = true;
                }
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animateManyWithThrottle(_this.id + '_waiting-update-ready_' + rect.id, props, {
                          delay: delay,
                          duration: duration,
                          ease: easeOut,
                          throttleId: _this.id + '_rects',
                          throttleGroup: rectThrottleGroup,
                          onUpdate: function (_a) {
                              var _b = __read$x(_a, 4),
                                  x = _b[0],
                                  width = _b[1],
                                  y = _b[2],
                                  height = _b[3];
                              rect.x = x;
                              rect.width = width;
                              rect.y = y;
                              rect.height = height;
                          },
                          onComplete: function () {
                              if (cleanup) datumSelection.cleanup();
                          },
                      });
            });
        });
        labelSelections.forEach(function (labelSelection) {
            labelSelection.each(function (label) {
                var _a;
                label.opacity = 0;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animateWithThrottle(_this.id + '_waiting-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: totalDuration,
                          duration: labelDuration,
                          throttleId: _this.id + '_labels',
                          throttleGroup: labelThrottleGroup,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    BarSeries.prototype.resetSelectionRects = function (selection) {
        selection.each(function (rect, datum) {
            rect.x = datum.x;
            rect.y = datum.y;
            rect.width = datum.width;
            rect.height = datum.height;
        });
        selection.cleanup();
    };
    BarSeries.prototype.getDirectionStartingValues = function (datumSelections) {
        var isColumnSeries = this.getBarDirection() === ChartAxisDirection.Y;
        var xAxis = this.axes[ChartAxisDirection.X];
        var yAxis = this.axes[ChartAxisDirection.Y];
        var isContinuousX = (xAxis === null || xAxis === void 0 ? void 0 : xAxis.scale) instanceof ContinuousScale;
        var isContinuousY = (yAxis === null || yAxis === void 0 ? void 0 : yAxis.scale) instanceof ContinuousScale;
        var startingX = Infinity;
        var startingY = 0;
        if (yAxis && isColumnSeries) {
            if (isContinuousY) {
                startingY = yAxis.scale.convert(0);
            } else {
                datumSelections.forEach(function (datumSelection) {
                    return datumSelection.each(function (_, datum) {
                        if (datum.yValue >= 0) {
                            startingY = Math.max(startingY, datum.height + datum.y);
                        }
                    });
                });
            }
        }
        if (xAxis && !isColumnSeries) {
            if (isContinuousX) {
                startingX = xAxis.scale.convert(0);
            } else {
                datumSelections.forEach(function (datumSelection) {
                    return datumSelection.each(function (_, datum) {
                        if (datum.yValue >= 0) {
                            startingX = Math.min(startingX, datum.x);
                        }
                    });
                });
            }
        }
        return { startingX: startingX, startingY: startingY };
    };
    BarSeries.prototype.isLabelEnabled = function () {
        return this.label.enabled;
    };
    BarSeries.prototype.getBandScalePadding = function () {
        return { inner: 0.2, outer: 0.3 };
    };
    BarSeries.prototype.getBarDirection = function () {
        return ChartAxisDirection.X;
    };
    BarSeries.prototype.getCategoryDirection = function () {
        return ChartAxisDirection.Y;
    };
    BarSeries.className = 'BarSeries';
    BarSeries.type = 'bar';
    __decorate$1m([Validate(OPT_COLOR_STRING)], BarSeries.prototype, 'fill', void 0);
    __decorate$1m([Validate(OPT_COLOR_STRING)], BarSeries.prototype, 'stroke', void 0);
    __decorate$1m([Validate(NUMBER(0, 1))], BarSeries.prototype, 'fillOpacity', void 0);
    __decorate$1m([Validate(NUMBER(0, 1))], BarSeries.prototype, 'strokeOpacity', void 0);
    __decorate$1m([Validate(OPT_LINE_DASH)], BarSeries.prototype, 'lineDash', void 0);
    __decorate$1m([Validate(NUMBER(0))], BarSeries.prototype, 'lineDashOffset', void 0);
    __decorate$1m([Validate(OPT_FUNCTION)], BarSeries.prototype, 'formatter', void 0);
    __decorate$1m([Validate(OPT_STRING)], BarSeries.prototype, 'xKey', void 0);
    __decorate$1m([Validate(OPT_STRING)], BarSeries.prototype, 'xName', void 0);
    __decorate$1m([Validate(OPT_STRING)], BarSeries.prototype, 'yKey', void 0);
    __decorate$1m([Validate(OPT_STRING)], BarSeries.prototype, 'yName', void 0);
    __decorate$1m([Validate(OPT_STRING)], BarSeries.prototype, 'stackGroup', void 0);
    __decorate$1m([Validate(OPT_NUMBER())], BarSeries.prototype, 'normalizedTo', void 0);
    __decorate$1m([Validate(NUMBER(0))], BarSeries.prototype, 'strokeWidth', void 0);
    return BarSeries;
})(CartesianSeries);
var ColumnSeries = /** @class */ (function (_super) {
    __extends$21(ColumnSeries, _super);
    function ColumnSeries() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ColumnSeries.prototype.getBarDirection = function () {
        return ChartAxisDirection.Y;
    };
    ColumnSeries.prototype.getCategoryDirection = function () {
        return ChartAxisDirection.X;
    };
    ColumnSeries.type = 'column';
    ColumnSeries.className = 'ColumnSeries';
    return ColumnSeries;
})(BarSeries);

var __extends$20 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1l =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$4 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$4 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$w =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$i =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var HISTOGRAM_AGGREGATIONS = ['count', 'sum', 'mean'];
var HISTOGRAM_AGGREGATION = predicateWithMessage(function (v) {
    return HISTOGRAM_AGGREGATIONS.includes(v);
}, "expecting a histogram aggregation keyword such as 'count', 'sum' or 'mean");
var HistogramSeriesNodeTag;
(function (HistogramSeriesNodeTag) {
    HistogramSeriesNodeTag[(HistogramSeriesNodeTag['Bin'] = 0)] = 'Bin';
    HistogramSeriesNodeTag[(HistogramSeriesNodeTag['Label'] = 1)] = 'Label';
})(HistogramSeriesNodeTag || (HistogramSeriesNodeTag = {}));
var HistogramSeriesLabel = /** @class */ (function (_super) {
    __extends$20(HistogramSeriesLabel, _super);
    function HistogramSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1l([Validate(OPT_FUNCTION)], HistogramSeriesLabel.prototype, 'formatter', void 0);
    return HistogramSeriesLabel;
})(Label$1);
var defaultBinCount = 10;
var HistogramSeriesTooltip = /** @class */ (function (_super) {
    __extends$20(HistogramSeriesTooltip, _super);
    function HistogramSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        return _this;
    }
    __decorate$1l([Validate(OPT_FUNCTION)], HistogramSeriesTooltip.prototype, 'renderer', void 0);
    return HistogramSeriesTooltip;
})(SeriesTooltip);
var HistogramSeries = /** @class */ (function (_super) {
    __extends$20(HistogramSeries, _super);
    function HistogramSeries(moduleCtx) {
        var _this =
            _super.call(this, { moduleCtx: moduleCtx, pickModes: [SeriesNodePickMode.EXACT_SHAPE_MATCH] }) || this;
        _this.label = new HistogramSeriesLabel();
        _this.tooltip = new HistogramSeriesTooltip();
        _this.fill = undefined;
        _this.stroke = undefined;
        _this.fillOpacity = 1;
        _this.strokeOpacity = 1;
        _this.lineDash = [0];
        _this.lineDashOffset = 0;
        _this.xKey = undefined;
        _this.areaPlot = false;
        _this.bins = undefined;
        _this.aggregation = 'count';
        _this.binCount = undefined;
        _this.xName = undefined;
        _this.yKey = undefined;
        _this.yName = undefined;
        _this.strokeWidth = 1;
        _this.shadow = undefined;
        _this.calculatedBins = [];
        _this.datumSelectionGarbageCollection = false;
        _this.label.enabled = false;
        return _this;
    }
    // During processData phase, used to unify different ways of the user specifying
    // the bins. Returns bins in format[[min1, max1], [min2, max2], ... ].
    HistogramSeries.prototype.deriveBins = function (xDomain) {
        if (this.binCount === undefined) {
            var binStarts = ticks(xDomain[0], xDomain[1], defaultBinCount);
            var binSize_1 = tickStep(xDomain[0], xDomain[1], defaultBinCount);
            var firstBinEnd = binStarts[0];
            var expandStartToBin = function (n) {
                return [n, n + binSize_1];
            };
            return __spreadArray$i([[firstBinEnd - binSize_1, firstBinEnd]], __read$w(binStarts.map(expandStartToBin)));
        } else {
            return this.calculateNiceBins(xDomain, this.binCount);
        }
    };
    HistogramSeries.prototype.calculateNiceBins = function (domain, binCount) {
        var startGuess = Math.floor(domain[0]);
        var stop = domain[1];
        var segments = binCount || 1;
        var _a = this.calculateNiceStart(startGuess, stop, segments),
            start = _a.start,
            binSize = _a.binSize;
        return this.getBins(start, stop, binSize, segments);
    };
    HistogramSeries.prototype.getBins = function (start, stop, step, count) {
        var bins = [];
        for (var i = 0; i < count; i++) {
            var a = Math.round((start + i * step) * 10) / 10;
            var b = Math.round((start + (i + 1) * step) * 10) / 10;
            if (i === count - 1) {
                b = Math.max(b, stop);
            }
            bins[i] = [a, b];
        }
        return bins;
    };
    HistogramSeries.prototype.calculateNiceStart = function (a, b, segments) {
        var binSize = Math.abs(b - a) / segments;
        var order = Math.floor(Math.log10(binSize));
        var magnitude = Math.pow(10, order);
        var start = Math.floor(a / magnitude) * magnitude;
        return {
            start: start,
            binSize: binSize,
        };
    };
    HistogramSeries.prototype.processData = function (dataController) {
        var _a;
        return __awaiter$4(this, void 0, void 0, function () {
            var _b,
                xKey,
                yKey,
                data,
                areaPlot,
                aggregation,
                props,
                aggProp,
                aggProp,
                groupByFn,
                _c,
                dataModel,
                processedData;
            var _this = this;
            return __generator$4(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        (_b = this),
                            (xKey = _b.xKey),
                            (yKey = _b.yKey),
                            (data = _b.data),
                            (areaPlot = _b.areaPlot),
                            (aggregation = _b.aggregation);
                        props = [keyProperty(this, xKey, true), SORT_DOMAIN_GROUPS];
                        if (yKey) {
                            aggProp = groupCount(this, 'groupCount');
                            if (aggregation === 'count');
                            else if (aggregation === 'sum') {
                                aggProp = groupSum(this, 'groupAgg');
                            } else if (aggregation === 'mean') {
                                aggProp = groupAverage(this, 'groupAgg');
                            }
                            if (areaPlot) {
                                aggProp = area(this, 'groupAgg', aggProp);
                            }
                            props.push(valueProperty(this, yKey, true, { invalidValue: undefined }), aggProp);
                        } else {
                            aggProp = groupCount(this, 'groupAgg');
                            if (areaPlot) {
                                aggProp = area(this, 'groupAgg', aggProp);
                            }
                            props.push(aggProp);
                        }
                        groupByFn = function (dataSet) {
                            var _a;
                            var xExtent = fixNumericExtent(dataSet.domain.keys[0]);
                            if (xExtent.length === 0) {
                                // No buckets can be calculated.
                                dataSet.domain.groups = [];
                                return function () {
                                    return [];
                                };
                            }
                            var bins = (_a = _this.bins) !== null && _a !== void 0 ? _a : _this.deriveBins(xExtent);
                            var binCount = bins.length;
                            _this.calculatedBins = __spreadArray$i([], __read$w(bins));
                            return function (item) {
                                var xValue = item.keys[0];
                                for (var i = 0; i < binCount; i++) {
                                    var nextBin = bins[i];
                                    if (xValue >= nextBin[0] && xValue < nextBin[1]) {
                                        return nextBin;
                                    }
                                    if (i === binCount - 1 && xValue <= nextBin[1]) {
                                        // Handle edge case of a value being at the maximum extent, and the
                                        // final bin aligning with it.
                                        return nextBin;
                                    }
                                }
                                return [];
                            };
                        };
                        if (
                            !((_a = this.ctx.animationManager) === null || _a === void 0
                                ? void 0
                                : _a.skipAnimations) &&
                            this.processedData
                        ) {
                            props.push(diff(this.processedData, false));
                        }
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data !== null && data !== void 0 ? data : [], {
                                props: props,
                                dataVisible: this.visible,
                                groupByFn: groupByFn,
                            }),
                        ];
                    case 1:
                        (_c = _d.sent()), (dataModel = _c.dataModel), (processedData = _c.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        this.animationState.transition('updateData');
                        return [2 /*return*/];
                }
            });
        });
    };
    HistogramSeries.prototype.getDomain = function (direction) {
        var _a, _b, _c, _d;
        var _e = this,
            processedData = _e.processedData,
            dataModel = _e.dataModel;
        if (!processedData || !dataModel) return [];
        var yDomain = dataModel.getDomain(this, 'groupAgg', 'aggregate', processedData);
        var xDomainMin = (_a = this.calculatedBins) === null || _a === void 0 ? void 0 : _a[0][0];
        var xDomainMax =
            (_b = this.calculatedBins) === null || _b === void 0
                ? void 0
                : _b[
                      ((_d = (_c = this.calculatedBins) === null || _c === void 0 ? void 0 : _c.length) !== null &&
                      _d !== void 0
                          ? _d
                          : 0) - 1
                  ][1];
        if (direction === ChartAxisDirection.X) {
            return fixNumericExtent([xDomainMin, xDomainMax]);
        }
        return fixNumericExtent(yDomain);
    };
    HistogramSeries.prototype.getNodeClickEvent = function (event, datum) {
        var _a, _b;
        return new CartesianSeriesNodeClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    HistogramSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        var _a, _b;
        return new CartesianSeriesNodeDoubleClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    HistogramSeries.prototype.createNodeData = function () {
        var _a;
        return __awaiter$4(this, void 0, void 0, function () {
            var _b,
                axes,
                processedData,
                callbackCache,
                xAxis,
                yAxis,
                xScale,
                yScale,
                _c,
                fill,
                stroke,
                strokeWidth,
                seriesId,
                _d,
                yKey,
                _e,
                xKey,
                nodeData,
                defaultLabelFormatter,
                _f,
                _g,
                labelFormatter,
                labelFontStyle,
                labelFontWeight,
                labelFontSize,
                labelFontFamily,
                labelColor;
            var _this = this;
            return __generator$4(this, function (_h) {
                (_b = this),
                    (axes = _b.axes),
                    (processedData = _b.processedData),
                    (callbackCache = _b.ctx.callbackCache);
                xAxis = axes[ChartAxisDirection.X];
                yAxis = axes[ChartAxisDirection.Y];
                if (!this.visible || !xAxis || !yAxis || !processedData || processedData.type !== 'grouped') {
                    return [2 /*return*/, []];
                }
                xScale = xAxis.scale;
                yScale = yAxis.scale;
                (_c = this),
                    (fill = _c.fill),
                    (stroke = _c.stroke),
                    (strokeWidth = _c.strokeWidth),
                    (seriesId = _c.id),
                    (_d = _c.yKey),
                    (yKey = _d === void 0 ? '' : _d),
                    (_e = _c.xKey),
                    (xKey = _e === void 0 ? '' : _e);
                nodeData = [];
                defaultLabelFormatter = function (params) {
                    return String(params.value);
                };
                (_f = this.label),
                    (_g = _f.formatter),
                    (labelFormatter = _g === void 0 ? defaultLabelFormatter : _g),
                    (labelFontStyle = _f.fontStyle),
                    (labelFontWeight = _f.fontWeight),
                    (labelFontSize = _f.fontSize),
                    (labelFontFamily = _f.fontFamily),
                    (labelColor = _f.color);
                processedData.data.forEach(function (group) {
                    var _a;
                    var _b = group.aggValues,
                        _c = _b === void 0 ? [[0, 0]] : _b,
                        _d = __read$w(_c, 1),
                        _e = __read$w(_d[0], 2),
                        negativeAgg = _e[0],
                        positiveAgg = _e[1],
                        datum = group.datum,
                        frequency = group.datum.length,
                        domain = group.keys,
                        _f = __read$w(group.keys, 2),
                        xDomainMin = _f[0],
                        xDomainMax = _f[1];
                    var xMinPx = xScale.convert(xDomainMin);
                    var xMaxPx = xScale.convert(xDomainMax);
                    var total = negativeAgg + positiveAgg;
                    var yZeroPx = yScale.convert(0);
                    var yMaxPx = yScale.convert(total);
                    var w = xMaxPx - xMinPx;
                    var h = Math.abs(yMaxPx - yZeroPx);
                    var selectionDatumLabel =
                        total !== 0
                            ? {
                                  text:
                                      (_a = callbackCache.call(labelFormatter, {
                                          value: total,
                                          seriesId: seriesId,
                                      })) !== null && _a !== void 0
                                          ? _a
                                          : String(total),
                                  fontStyle: labelFontStyle,
                                  fontWeight: labelFontWeight,
                                  fontSize: labelFontSize,
                                  fontFamily: labelFontFamily,
                                  fill: labelColor,
                                  x: xMinPx + w / 2,
                                  y: yMaxPx + h / 2,
                              }
                            : undefined;
                    var nodeMidPoint = {
                        x: xMinPx + w / 2,
                        y: yMaxPx + h / 2,
                    };
                    nodeData.push({
                        series: _this,
                        datum: datum,
                        // since each selection is an aggregation of multiple data.
                        aggregatedValue: total,
                        frequency: frequency,
                        domain: domain,
                        yKey: yKey,
                        xKey: xKey,
                        x: xMinPx,
                        y: yMaxPx,
                        xValue: xMinPx,
                        yValue: yMaxPx,
                        width: w,
                        height: h,
                        nodeMidPoint: nodeMidPoint,
                        fill: fill,
                        stroke: stroke,
                        strokeWidth: strokeWidth,
                        label: selectionDatumLabel,
                    });
                });
                return [
                    2 /*return*/,
                    [
                        {
                            itemId: (_a = this.yKey) !== null && _a !== void 0 ? _a : this.id,
                            nodeData: nodeData,
                            labelData: nodeData,
                        },
                    ],
                ];
            });
        });
    };
    HistogramSeries.prototype.nodeFactory = function () {
        return new Rect();
    };
    HistogramSeries.prototype.updateDatumSelection = function (opts) {
        return __awaiter$4(this, void 0, void 0, function () {
            var nodeData, datumSelection;
            return __generator$4(this, function (_a) {
                (nodeData = opts.nodeData), (datumSelection = opts.datumSelection);
                return [
                    2 /*return*/,
                    datumSelection.update(
                        nodeData,
                        function (rect) {
                            rect.tag = HistogramSeriesNodeTag.Bin;
                            rect.crisp = true;
                        },
                        function (datum) {
                            return datum.domain.join('_');
                        },
                    ),
                ];
            });
        });
    };
    HistogramSeries.prototype.updateDatumNodes = function (opts) {
        return __awaiter$4(this, void 0, void 0, function () {
            var datumSelection,
                isDatumHighlighted,
                _a,
                seriesFillOpacity,
                strokeOpacity,
                shadow,
                _b,
                highlightedFill,
                _c,
                highlightFillOpacity,
                highlightedStroke,
                highlightedDatumStrokeWidth;
            var _this = this;
            return __generator$4(this, function (_d) {
                (datumSelection = opts.datumSelection), (isDatumHighlighted = opts.isHighlight);
                (_a = this),
                    (seriesFillOpacity = _a.fillOpacity),
                    (strokeOpacity = _a.strokeOpacity),
                    (shadow = _a.shadow),
                    (_b = _a.highlightStyle.item),
                    (highlightedFill = _b.fill),
                    (_c = _b.fillOpacity),
                    (highlightFillOpacity = _c === void 0 ? seriesFillOpacity : _c),
                    (highlightedStroke = _b.stroke),
                    (highlightedDatumStrokeWidth = _b.strokeWidth);
                datumSelection.each(function (rect, datum, index) {
                    var _a, _b;
                    var strokeWidth =
                        isDatumHighlighted && highlightedDatumStrokeWidth !== undefined
                            ? highlightedDatumStrokeWidth
                            : datum.strokeWidth;
                    var fillOpacity = isDatumHighlighted ? highlightFillOpacity : seriesFillOpacity;
                    rect.fill =
                        (_a = isDatumHighlighted ? highlightedFill : undefined) !== null && _a !== void 0
                            ? _a
                            : datum.fill;
                    rect.stroke =
                        (_b = isDatumHighlighted ? highlightedStroke : undefined) !== null && _b !== void 0
                            ? _b
                            : datum.stroke;
                    rect.fillOpacity = fillOpacity;
                    rect.strokeOpacity = strokeOpacity;
                    rect.strokeWidth = strokeWidth;
                    rect.lineDash = _this.lineDash;
                    rect.lineDashOffset = _this.lineDashOffset;
                    rect.fillShadow = shadow;
                    rect.zIndex = isDatumHighlighted ? Series.highlightedZIndex : index;
                    rect.visible = datum.height > 0; // prevent stroke from rendering for zero height columns
                });
                return [2 /*return*/];
            });
        });
    };
    HistogramSeries.prototype.updateLabelSelection = function (opts) {
        return __awaiter$4(this, void 0, void 0, function () {
            var labelData, labelSelection;
            return __generator$4(this, function (_a) {
                (labelData = opts.labelData), (labelSelection = opts.labelSelection);
                return [
                    2 /*return*/,
                    labelSelection.update(labelData, function (text) {
                        text.tag = HistogramSeriesNodeTag.Label;
                        text.pointerEvents = PointerEvents.None;
                        text.textAlign = 'center';
                        text.textBaseline = 'middle';
                    }),
                ];
            });
        });
    };
    HistogramSeries.prototype.updateLabelNodes = function (opts) {
        return __awaiter$4(this, void 0, void 0, function () {
            var labelSelection, labelEnabled;
            return __generator$4(this, function (_a) {
                labelSelection = opts.labelSelection;
                labelEnabled = this.label.enabled;
                labelSelection.each(function (text, datum) {
                    var label = datum.label;
                    if (label && labelEnabled) {
                        text.text = label.text;
                        text.x = label.x;
                        text.y = label.y;
                        text.fontStyle = label.fontStyle;
                        text.fontWeight = label.fontWeight;
                        text.fontSize = label.fontSize;
                        text.fontFamily = label.fontFamily;
                        text.fill = label.fill;
                        text.visible = true;
                    } else {
                        text.visible = false;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    HistogramSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a = this,
            xKey = _a.xKey,
            _b = _a.yKey,
            yKey = _b === void 0 ? '' : _b,
            axes = _a.axes;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        if (!xKey || !xAxis || !yAxis) {
            return '';
        }
        var _c = this,
            xName = _c.xName,
            yName = _c.yName,
            color = _c.fill,
            tooltip = _c.tooltip,
            aggregation = _c.aggregation,
            seriesId = _c.id;
        var tooltipRenderer = tooltip.renderer;
        var aggregatedValue = nodeDatum.aggregatedValue,
            frequency = nodeDatum.frequency,
            domain = nodeDatum.domain,
            _d = __read$w(nodeDatum.domain, 2),
            rangeMin = _d[0],
            rangeMax = _d[1];
        var title =
            sanitizeHtml(xName !== null && xName !== void 0 ? xName : xKey) +
            ': ' +
            xAxis.formatDatum(rangeMin) +
            ' - ' +
            xAxis.formatDatum(rangeMax);
        var content = yKey
            ? '<b>' +
              sanitizeHtml(yName !== null && yName !== void 0 ? yName : yKey) +
              ' (' +
              aggregation +
              ')</b>: ' +
              yAxis.formatDatum(aggregatedValue) +
              '<br>'
            : '';
        content += '<b>Frequency</b>: ' + frequency;
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        if (tooltipRenderer) {
            return toTooltipHtml$1(
                tooltipRenderer({
                    datum: {
                        data: nodeDatum.datum,
                        aggregatedValue: nodeDatum.aggregatedValue,
                        domain: nodeDatum.domain,
                        frequency: nodeDatum.frequency,
                    },
                    xKey: xKey,
                    xValue: domain,
                    xName: xName,
                    yKey: yKey,
                    yValue: aggregatedValue,
                    yName: yName,
                    color: color,
                    title: title,
                    seriesId: seriesId,
                }),
                defaults,
            );
        }
        return toTooltipHtml$1(defaults);
    };
    HistogramSeries.prototype.getLegendData = function () {
        var _a;
        var _b = this,
            id = _b.id,
            data = _b.data,
            xKey = _b.xKey,
            yName = _b.yName,
            visible = _b.visible,
            fill = _b.fill,
            stroke = _b.stroke,
            fillOpacity = _b.fillOpacity,
            strokeOpacity = _b.strokeOpacity;
        if (!data || data.length === 0) {
            return [];
        }
        var legendData = [
            {
                legendType: 'category',
                id: id,
                itemId: xKey,
                seriesId: id,
                enabled: visible,
                label: {
                    text:
                        (_a = yName !== null && yName !== void 0 ? yName : xKey) !== null && _a !== void 0
                            ? _a
                            : 'Frequency',
                },
                marker: {
                    fill: fill !== null && fill !== void 0 ? fill : 'rgba(0, 0, 0, 0)',
                    stroke: stroke !== null && stroke !== void 0 ? stroke : 'rgba(0, 0, 0, 0)',
                    fillOpacity: fillOpacity,
                    strokeOpacity: strokeOpacity,
                },
            },
        ];
        return legendData;
    };
    HistogramSeries.prototype.animateEmptyUpdateReady = function (_a) {
        var _this = this;
        var _b, _c;
        var datumSelections = _a.datumSelections,
            labelSelections = _a.labelSelections;
        var duration =
            (_c = (_b = this.ctx.animationManager) === null || _b === void 0 ? void 0 : _b.defaultOptions.duration) !==
                null && _c !== void 0
                ? _c
                : 1000;
        var labelDuration = 200;
        var startingY = 0;
        datumSelections.forEach(function (datumSelection) {
            return datumSelection.each(function (_, datum) {
                startingY = Math.max(startingY, datum.height + datum.y);
            });
        });
        datumSelections.forEach(function (datumSelection) {
            datumSelection.each(function (rect, datum) {
                var _a;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animateMany(
                          _this.id + '_empty-update-ready_' + rect.id,
                          [
                              { from: startingY, to: datum.y },
                              { from: 0, to: datum.height },
                          ],
                          {
                              duration: duration,
                              ease: easeOut,
                              onUpdate: function (_a) {
                                  var _b = __read$w(_a, 2),
                                      y = _b[0],
                                      height = _b[1];
                                  rect.y = y;
                                  rect.height = height;
                                  rect.x = datum.x;
                                  rect.width = datum.width;
                              },
                          },
                      );
            });
        });
        labelSelections.forEach(function (labelSelection) {
            labelSelection.each(function (label) {
                var _a;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_empty-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: duration,
                          duration: labelDuration,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    HistogramSeries.prototype.animateReadyUpdate = function (_a) {
        var _this = this;
        var datumSelections = _a.datumSelections;
        datumSelections.forEach(function (datumSelection) {
            _this.resetSelectionRects(datumSelection);
        });
    };
    HistogramSeries.prototype.animateReadyHighlight = function (highlightSelection) {
        this.resetSelectionRects(highlightSelection);
    };
    HistogramSeries.prototype.animateReadyResize = function (_a) {
        var _this = this;
        var _b;
        var datumSelections = _a.datumSelections;
        (_b = this.ctx.animationManager) === null || _b === void 0 ? void 0 : _b.reset();
        datumSelections.forEach(function (datumSelection) {
            _this.resetSelectionRects(datumSelection);
        });
    };
    HistogramSeries.prototype.animateWaitingUpdateReady = function (_a) {
        var _this = this;
        var _b, _c, _d;
        var datumSelections = _a.datumSelections,
            labelSelections = _a.labelSelections;
        var processedData = this.processedData;
        var diff =
            (_b = processedData === null || processedData === void 0 ? void 0 : processedData.reduced) === null ||
            _b === void 0
                ? void 0
                : _b.diff;
        if (!(diff === null || diff === void 0 ? void 0 : diff.changed)) {
            datumSelections.forEach(function (datumSelection) {
                _this.resetSelectionRects(datumSelection);
            });
            return;
        }
        var totalDuration =
            (_d = (_c = this.ctx.animationManager) === null || _c === void 0 ? void 0 : _c.defaultOptions.duration) !==
                null && _d !== void 0
                ? _d
                : 1000;
        var labelDuration = 200;
        var sectionDuration = totalDuration;
        if (diff.added.length > 0 && diff.removed.length > 0) {
            sectionDuration = Math.floor(totalDuration / 3);
        } else if (diff.added.length > 0 || diff.removed.length > 0) {
            sectionDuration = Math.floor(totalDuration / 2);
        }
        var startingY = 0;
        datumSelections.forEach(function (datumSelection) {
            return datumSelection.each(function (_, datum) {
                startingY = Math.max(startingY, datum.height + datum.y);
            });
        });
        var addedIds = {};
        diff.added.forEach(function (d) {
            addedIds[d.join('_')] = true;
        });
        var removedIds = {};
        diff.removed.forEach(function (d) {
            removedIds[d.join('_')] = true;
        });
        datumSelections.forEach(function (datumSelection) {
            datumSelection.each(function (rect, datum) {
                var _a;
                var props = [
                    { from: rect.x, to: datum.x },
                    { from: rect.width, to: datum.width },
                    { from: rect.y, to: datum.y },
                    { from: rect.height, to: datum.height },
                ];
                var delay = diff.removed.length > 0 ? sectionDuration : 0;
                var cleanup = false;
                var datumId = datum.domain.join('_');
                var contextY = startingY;
                var contextHeight = 0;
                if (datumId !== undefined && addedIds[datumId] !== undefined) {
                    props = [
                        { from: datum.x, to: datum.x },
                        { from: datum.width, to: datum.width },
                        { from: contextY, to: datum.y },
                        { from: contextHeight, to: datum.height },
                    ];
                    delay += sectionDuration;
                } else if (datumId !== undefined && removedIds[datumId] !== undefined) {
                    props = [
                        { from: rect.x, to: datum.x },
                        { from: rect.width, to: datum.width },
                        { from: datum.y, to: contextY },
                        { from: datum.height, to: contextHeight },
                    ];
                    delay = 0;
                    cleanup = true;
                }
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animateMany(_this.id + '_waiting-update-ready_' + rect.id, props, {
                          disableInteractions: true,
                          delay: delay,
                          duration: sectionDuration,
                          ease: easeOut,
                          repeat: 0,
                          onUpdate: function (_a) {
                              var _b = __read$w(_a, 4),
                                  x = _b[0],
                                  width = _b[1],
                                  y = _b[2],
                                  height = _b[3];
                              rect.x = x;
                              rect.width = width;
                              rect.y = y;
                              rect.height = height;
                          },
                          onComplete: function () {
                              if (cleanup) datumSelection.cleanup();
                          },
                      });
            });
        });
        labelSelections.forEach(function (labelSelection) {
            labelSelection.each(function (label) {
                var _a;
                label.opacity = 0;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_waiting-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: totalDuration,
                          duration: labelDuration,
                          ease: linear,
                          repeat: 0,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    HistogramSeries.prototype.resetSelectionRects = function (selection) {
        selection.each(function (rect, datum) {
            rect.x = datum.x;
            rect.y = datum.y;
            rect.width = datum.width;
            rect.height = datum.height;
        });
    };
    HistogramSeries.prototype.isLabelEnabled = function () {
        return this.label.enabled;
    };
    HistogramSeries.className = 'HistogramSeries';
    HistogramSeries.type = 'histogram';
    __decorate$1l([Validate(OPT_COLOR_STRING)], HistogramSeries.prototype, 'fill', void 0);
    __decorate$1l([Validate(OPT_COLOR_STRING)], HistogramSeries.prototype, 'stroke', void 0);
    __decorate$1l([Validate(NUMBER(0, 1))], HistogramSeries.prototype, 'fillOpacity', void 0);
    __decorate$1l([Validate(NUMBER(0, 1))], HistogramSeries.prototype, 'strokeOpacity', void 0);
    __decorate$1l([Validate(OPT_LINE_DASH)], HistogramSeries.prototype, 'lineDash', void 0);
    __decorate$1l([Validate(NUMBER(0))], HistogramSeries.prototype, 'lineDashOffset', void 0);
    __decorate$1l([Validate(OPT_STRING)], HistogramSeries.prototype, 'xKey', void 0);
    __decorate$1l([Validate(BOOLEAN)], HistogramSeries.prototype, 'areaPlot', void 0);
    __decorate$1l([Validate(OPT_ARRAY())], HistogramSeries.prototype, 'bins', void 0);
    __decorate$1l([Validate(HISTOGRAM_AGGREGATION)], HistogramSeries.prototype, 'aggregation', void 0);
    __decorate$1l([Validate(OPT_NUMBER(0))], HistogramSeries.prototype, 'binCount', void 0);
    __decorate$1l([Validate(OPT_STRING)], HistogramSeries.prototype, 'xName', void 0);
    __decorate$1l([Validate(OPT_STRING)], HistogramSeries.prototype, 'yKey', void 0);
    __decorate$1l([Validate(OPT_STRING)], HistogramSeries.prototype, 'yName', void 0);
    __decorate$1l([Validate(NUMBER(0))], HistogramSeries.prototype, 'strokeWidth', void 0);
    return HistogramSeries;
})(CartesianSeries);

var __extends$1$ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$A =
    (undefined && undefined.__assign) ||
    function () {
        __assign$A =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$A.apply(this, arguments);
    };
var __decorate$1k =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$3 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$3 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$v =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var LineSeriesLabel = /** @class */ (function (_super) {
    __extends$1$(LineSeriesLabel, _super);
    function LineSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1k([Validate(OPT_FUNCTION)], LineSeriesLabel.prototype, 'formatter', void 0);
    return LineSeriesLabel;
})(Label$1);
var LineSeriesTooltip = /** @class */ (function (_super) {
    __extends$1$(LineSeriesTooltip, _super);
    function LineSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        _this.format = undefined;
        return _this;
    }
    __decorate$1k([Validate(OPT_FUNCTION)], LineSeriesTooltip.prototype, 'renderer', void 0);
    __decorate$1k([Validate(OPT_STRING)], LineSeriesTooltip.prototype, 'format', void 0);
    return LineSeriesTooltip;
})(SeriesTooltip);
var LineSeries = /** @class */ (function (_super) {
    __extends$1$(LineSeries, _super);
    function LineSeries(moduleCtx) {
        var _this =
            _super.call(this, {
                moduleCtx: moduleCtx,
                hasMarkers: true,
                pickModes: [
                    SeriesNodePickMode.NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST,
                    SeriesNodePickMode.NEAREST_NODE,
                    SeriesNodePickMode.EXACT_SHAPE_MATCH,
                ],
            }) || this;
        _this.marker = new CartesianSeriesMarker();
        _this.label = new LineSeriesLabel();
        _this.title = undefined;
        _this.stroke = '#874349';
        _this.lineDash = [0];
        _this.lineDashOffset = 0;
        _this.strokeWidth = 2;
        _this.strokeOpacity = 1;
        _this.tooltip = new LineSeriesTooltip();
        _this.xKey = undefined;
        _this.xName = undefined;
        _this.yKey = undefined;
        _this.yName = undefined;
        var _a = _this,
            marker = _a.marker,
            label = _a.label;
        marker.fill = '#c16068';
        marker.stroke = '#874349';
        label.enabled = false;
        return _this;
    }
    LineSeries.prototype.processData = function (dataController) {
        return __awaiter$3(this, void 0, void 0, function () {
            var _a,
                axes,
                _b,
                xKey,
                _c,
                yKey,
                data,
                xAxis,
                yAxis,
                isContinuousX,
                isContinuousY,
                _d,
                dataModel,
                processedData;
            return __generator$3(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        (_a = this),
                            (axes = _a.axes),
                            (_b = _a.xKey),
                            (xKey = _b === void 0 ? '' : _b),
                            (_c = _a.yKey),
                            (yKey = _c === void 0 ? '' : _c);
                        data = xKey && yKey && this.data ? this.data : [];
                        xAxis = axes[ChartAxisDirection.X];
                        yAxis = axes[ChartAxisDirection.Y];
                        isContinuousX =
                            (xAxis === null || xAxis === void 0 ? void 0 : xAxis.scale) instanceof ContinuousScale;
                        isContinuousY =
                            (yAxis === null || yAxis === void 0 ? void 0 : yAxis.scale) instanceof ContinuousScale;
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data !== null && data !== void 0 ? data : [], {
                                props: [
                                    valueProperty(this, xKey, isContinuousX, { id: 'xValue' }),
                                    valueProperty(this, yKey, isContinuousY, { id: 'yValue', invalidValue: undefined }),
                                ],
                                dataVisible: this.visible,
                            }),
                        ];
                    case 1:
                        (_d = _e.sent()), (dataModel = _d.dataModel), (processedData = _d.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        return [2 /*return*/];
                }
            });
        });
    };
    LineSeries.prototype.getDomain = function (direction) {
        var _a = this,
            axes = _a.axes,
            dataModel = _a.dataModel,
            processedData = _a.processedData;
        if (!processedData || !dataModel) return [];
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        var xDef = dataModel.resolveProcessedDataDefById(this, 'xValue');
        if (direction === ChartAxisDirection.X) {
            var domain = dataModel.getDomain(this, 'xValue', 'value', processedData);
            if (
                (xDef === null || xDef === void 0 ? void 0 : xDef.def.type) === 'value' &&
                xDef.def.valueType === 'category'
            ) {
                return domain;
            }
            return this.fixNumericExtent(extent$4(domain), xAxis);
        } else {
            var domain = dataModel.getDomain(this, 'yValue', 'value', processedData);
            return this.fixNumericExtent(domain, yAxis);
        }
    };
    LineSeries.prototype.createNodeData = function () {
        var _a, _b, _c, _d, _e;
        return __awaiter$3(this, void 0, void 0, function () {
            var _f,
                processedData,
                dataModel,
                axes,
                _g,
                markerEnabled,
                markerSize,
                strokeWidth,
                callbackCache,
                xAxis,
                yAxis,
                _h,
                label,
                _j,
                yKey,
                _k,
                xKey,
                seriesId,
                xScale,
                yScale,
                xOffset,
                yOffset,
                nodeData,
                size,
                xIdx,
                yIdx,
                moveTo,
                prevXInRange,
                nextPoint,
                actualLength,
                i,
                _l,
                datum,
                values,
                xDatum,
                yDatum,
                x,
                tolerance,
                nextXDatum,
                xInRange,
                nextXInRange,
                y,
                labelText;
            return __generator$3(this, function (_m) {
                (_f = this),
                    (processedData = _f.processedData),
                    (dataModel = _f.dataModel),
                    (axes = _f.axes),
                    (_g = _f.marker),
                    (markerEnabled = _g.enabled),
                    (markerSize = _g.size),
                    (strokeWidth = _g.strokeWidth),
                    (callbackCache = _f.ctx.callbackCache);
                xAxis = axes[ChartAxisDirection.X];
                yAxis = axes[ChartAxisDirection.Y];
                if (!processedData || !dataModel || !xAxis || !yAxis) {
                    return [2 /*return*/, []];
                }
                (_h = this),
                    (label = _h.label),
                    (_j = _h.yKey),
                    (yKey = _j === void 0 ? '' : _j),
                    (_k = _h.xKey),
                    (xKey = _k === void 0 ? '' : _k),
                    (seriesId = _h.id);
                xScale = xAxis.scale;
                yScale = yAxis.scale;
                xOffset = ((_a = xScale.bandwidth) !== null && _a !== void 0 ? _a : 0) / 2;
                yOffset = ((_b = yScale.bandwidth) !== null && _b !== void 0 ? _b : 0) / 2;
                nodeData = new Array(processedData.data.length);
                size = markerEnabled ? markerSize : 0;
                xIdx = dataModel.resolveProcessedDataIndexById(this, 'xValue').index;
                yIdx = dataModel.resolveProcessedDataIndexById(this, 'yValue').index;
                moveTo = true;
                prevXInRange = undefined;
                nextPoint = undefined;
                actualLength = 0;
                for (i = 0; i < processedData.data.length; i++) {
                    (_l = nextPoint !== null && nextPoint !== void 0 ? nextPoint : processedData.data[i]),
                        (datum = _l.datum),
                        (values = _l.values);
                    xDatum = values[xIdx];
                    yDatum = values[yIdx];
                    if (yDatum === undefined) {
                        prevXInRange = undefined;
                        moveTo = true;
                    } else {
                        x = xScale.convert(xDatum) + xOffset;
                        if (isNaN(x)) {
                            prevXInRange = undefined;
                            moveTo = true;
                            nextPoint = undefined;
                            continue;
                        }
                        tolerance =
                            ((_c = xScale.bandwidth) !== null && _c !== void 0
                                ? _c
                                : markerSize * 0.5 +
                                  (strokeWidth !== null && strokeWidth !== void 0 ? strokeWidth : 0)) + 1;
                        nextPoint =
                            ((_d = processedData.data[i + 1]) === null || _d === void 0 ? void 0 : _d.values[yIdx]) ===
                            undefined
                                ? undefined
                                : processedData.data[i + 1];
                        nextXDatum =
                            (_e = processedData.data[i + 1]) === null || _e === void 0 ? void 0 : _e.values[xIdx];
                        xInRange = xAxis.inRangeEx(x, 0, tolerance);
                        nextXInRange = nextPoint && xAxis.inRangeEx(xScale.convert(nextXDatum) + xOffset, 0, tolerance);
                        if (xInRange === -1 && nextXInRange === -1) {
                            moveTo = true;
                            continue;
                        }
                        if (xInRange === 1 && prevXInRange === 1) {
                            moveTo = true;
                            continue;
                        }
                        prevXInRange = xInRange;
                        y = yScale.convert(yDatum) + yOffset;
                        labelText = void 0;
                        if (label.formatter) {
                            labelText = callbackCache.call(label.formatter, { value: yDatum, seriesId: seriesId });
                        }
                        if (labelText !== undefined);
                        else if (typeof yDatum === 'number' && isFinite(yDatum)) {
                            labelText = yDatum.toFixed(2);
                        } else if (yDatum) {
                            labelText = String(yDatum);
                        }
                        nodeData[actualLength++] = {
                            series: this,
                            datum: datum,
                            yKey: yKey,
                            xKey: xKey,
                            point: { x: x, y: y, moveTo: moveTo, size: size },
                            nodeMidPoint: { x: x, y: y },
                            yValue: yDatum,
                            xValue: xDatum,
                            label: labelText
                                ? {
                                      text: labelText,
                                      fontStyle: label.fontStyle,
                                      fontWeight: label.fontWeight,
                                      fontSize: label.fontSize,
                                      fontFamily: label.fontFamily,
                                      textAlign: 'center',
                                      textBaseline: 'bottom',
                                      fill: label.color,
                                  }
                                : undefined,
                        };
                        moveTo = false;
                    }
                }
                nodeData.length = actualLength;
                return [2 /*return*/, [{ itemId: yKey, nodeData: nodeData, labelData: nodeData }]];
            });
        });
    };
    LineSeries.prototype.isPathOrSelectionDirty = function () {
        return this.marker.isDirty();
    };
    LineSeries.prototype.markerFactory = function () {
        var shape = this.marker.shape;
        var MarkerShape = getMarker$1(shape);
        return new MarkerShape();
    };
    LineSeries.prototype.updateMarkerSelection = function (opts) {
        return __awaiter$3(this, void 0, void 0, function () {
            var nodeData, markerSelection, _a, shape, enabled;
            return __generator$3(this, function (_b) {
                nodeData = opts.nodeData;
                markerSelection = opts.markerSelection;
                (_a = this.marker), (shape = _a.shape), (enabled = _a.enabled);
                nodeData = shape && enabled ? nodeData : [];
                if (this.marker.isDirty()) {
                    markerSelection.clear();
                }
                return [2 /*return*/, markerSelection.update(nodeData)];
            });
        });
    };
    LineSeries.prototype.updateMarkerNodes = function (opts) {
        var _a;
        return __awaiter$3(this, void 0, void 0, function () {
            var markerSelection,
                isDatumHighlighted,
                _b,
                marker,
                markerFillOpacity,
                _c,
                xKey,
                _d,
                yKey,
                lineStroke,
                strokeOpacity,
                _e,
                highlightedFill,
                _f,
                highlightFillOpacity,
                highlightedStroke,
                highlightedDatumStrokeWidth,
                seriesId,
                callbackCache,
                size,
                formatter,
                markerStrokeWidth,
                customMarker;
            return __generator$3(this, function (_g) {
                (markerSelection = opts.markerSelection), (isDatumHighlighted = opts.isHighlight);
                (_b = this),
                    (marker = _b.marker),
                    (markerFillOpacity = _b.marker.fillOpacity),
                    (_c = _b.xKey),
                    (xKey = _c === void 0 ? '' : _c),
                    (_d = _b.yKey),
                    (yKey = _d === void 0 ? '' : _d),
                    (lineStroke = _b.stroke),
                    (strokeOpacity = _b.strokeOpacity),
                    (_e = _b.highlightStyle.item),
                    (highlightedFill = _e.fill),
                    (_f = _e.fillOpacity),
                    (highlightFillOpacity = _f === void 0 ? markerFillOpacity : _f),
                    (highlightedStroke = _e.stroke),
                    (highlightedDatumStrokeWidth = _e.strokeWidth),
                    (seriesId = _b.id),
                    (callbackCache = _b.ctx.callbackCache);
                (size = marker.size), (formatter = marker.formatter);
                markerStrokeWidth = (_a = marker.strokeWidth) !== null && _a !== void 0 ? _a : this.strokeWidth;
                customMarker = typeof marker.shape === 'function';
                markerSelection.each(function (node, datum) {
                    var _a, _b, _c, _d, _e, _f, _g;
                    var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : marker.fill;
                    var fillOpacity = isDatumHighlighted ? highlightFillOpacity : markerFillOpacity;
                    var stroke =
                        isDatumHighlighted && highlightedStroke !== undefined
                            ? highlightedStroke
                            : (_a = marker.stroke) !== null && _a !== void 0
                            ? _a
                            : lineStroke;
                    var strokeWidth =
                        isDatumHighlighted && highlightedDatumStrokeWidth !== undefined
                            ? highlightedDatumStrokeWidth
                            : markerStrokeWidth;
                    var format = undefined;
                    if (formatter) {
                        format = callbackCache.call(formatter, {
                            datum: datum.datum,
                            xKey: xKey,
                            yKey: yKey,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            size: size,
                            highlighted: isDatumHighlighted,
                            seriesId: seriesId,
                        });
                    }
                    node.fill =
                        (_b = format === null || format === void 0 ? void 0 : format.fill) !== null && _b !== void 0
                            ? _b
                            : fill;
                    node.stroke =
                        (_c = format === null || format === void 0 ? void 0 : format.stroke) !== null && _c !== void 0
                            ? _c
                            : stroke;
                    node.strokeWidth =
                        (_d = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null &&
                        _d !== void 0
                            ? _d
                            : strokeWidth;
                    node.fillOpacity = fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : 1;
                    node.strokeOpacity =
                        (_f = (_e = marker.strokeOpacity) !== null && _e !== void 0 ? _e : strokeOpacity) !== null &&
                        _f !== void 0
                            ? _f
                            : 1;
                    node.size =
                        (_g = format === null || format === void 0 ? void 0 : format.size) !== null && _g !== void 0
                            ? _g
                            : size;
                    node.translationX = datum.point.x;
                    node.translationY = datum.point.y;
                    node.visible = node.size > 0 && !isNaN(datum.point.x) && !isNaN(datum.point.y);
                    if (!customMarker || node.dirtyPath) {
                        return;
                    }
                    // Only for cutom marker shapes
                    node.path.clear({ trackChanges: true });
                    node.updatePath();
                    node.checkPathDirty();
                });
                if (!isDatumHighlighted) {
                    this.marker.markClean();
                }
                return [2 /*return*/];
            });
        });
    };
    LineSeries.prototype.updateLabelSelection = function (opts) {
        return __awaiter$3(this, void 0, void 0, function () {
            var labelData, labelSelection, _a, shape, enabled;
            return __generator$3(this, function (_b) {
                labelData = opts.labelData;
                labelSelection = opts.labelSelection;
                (_a = this.marker), (shape = _a.shape), (enabled = _a.enabled);
                labelData = shape && enabled ? labelData : [];
                return [2 /*return*/, labelSelection.update(labelData)];
            });
        });
    };
    LineSeries.prototype.updateLabelNodes = function (opts) {
        return __awaiter$3(this, void 0, void 0, function () {
            var labelSelection, _a, labelEnabled, fontStyle, fontWeight, fontSize, fontFamily, color;
            return __generator$3(this, function (_b) {
                labelSelection = opts.labelSelection;
                (_a = this.label),
                    (labelEnabled = _a.enabled),
                    (fontStyle = _a.fontStyle),
                    (fontWeight = _a.fontWeight),
                    (fontSize = _a.fontSize),
                    (fontFamily = _a.fontFamily),
                    (color = _a.color);
                labelSelection.each(function (text, datum) {
                    var point = datum.point,
                        label = datum.label;
                    if (datum && label && labelEnabled) {
                        text.fontStyle = fontStyle;
                        text.fontWeight = fontWeight;
                        text.fontSize = fontSize;
                        text.fontFamily = fontFamily;
                        text.textAlign = label.textAlign;
                        text.textBaseline = label.textBaseline;
                        text.text = label.text;
                        text.x = point.x;
                        text.y = point.y - 10;
                        text.fill = color;
                        text.visible = true;
                    } else {
                        text.visible = false;
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    LineSeries.prototype.getNodeClickEvent = function (event, datum) {
        var _a, _b;
        return new CartesianSeriesNodeClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    LineSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        var _a, _b;
        return new CartesianSeriesNodeDoubleClickEvent(
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    LineSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a, _b;
        var _c = this,
            xKey = _c.xKey,
            yKey = _c.yKey,
            axes = _c.axes;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        if (!xKey || !yKey || !xAxis || !yAxis) {
            return '';
        }
        var _d = this,
            xName = _d.xName,
            yName = _d.yName,
            tooltip = _d.tooltip,
            marker = _d.marker,
            seriesId = _d.id;
        var tooltipRenderer = tooltip.renderer,
            tooltipFormat = tooltip.format;
        var datum = nodeDatum.datum,
            xValue = nodeDatum.xValue,
            yValue = nodeDatum.yValue;
        var xString = xAxis.formatDatum(xValue);
        var yString = yAxis.formatDatum(yValue);
        var title = sanitizeHtml((_a = this.title) !== null && _a !== void 0 ? _a : yName);
        var content = sanitizeHtml(xString + ': ' + yString);
        var markerFormatter = marker.formatter,
            fill = marker.fill,
            stroke = marker.stroke,
            markerStrokeWidth = marker.strokeWidth,
            size = marker.size;
        var strokeWidth =
            markerStrokeWidth !== null && markerStrokeWidth !== void 0 ? markerStrokeWidth : this.strokeWidth;
        var format = undefined;
        if (markerFormatter) {
            format = markerFormatter({
                datum: datum,
                xKey: xKey,
                yKey: yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size: size,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        var color =
            (_b = format === null || format === void 0 ? void 0 : format.fill) !== null && _b !== void 0 ? _b : fill;
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        if (tooltipFormat || tooltipRenderer) {
            var params = {
                datum: datum,
                xKey: xKey,
                xValue: xValue,
                xName: xName,
                yKey: yKey,
                yValue: yValue,
                yName: yName,
                title: title,
                color: color,
                seriesId: seriesId,
            };
            if (tooltipFormat) {
                return toTooltipHtml$1(
                    {
                        content: interpolate(tooltipFormat, params),
                    },
                    defaults,
                );
            }
            if (tooltipRenderer) {
                return toTooltipHtml$1(tooltipRenderer(params), defaults);
            }
        }
        return toTooltipHtml$1(defaults);
    };
    LineSeries.prototype.getLegendData = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this,
            id = _h.id,
            data = _h.data,
            xKey = _h.xKey,
            yKey = _h.yKey,
            yName = _h.yName,
            visible = _h.visible,
            title = _h.title,
            marker = _h.marker,
            stroke = _h.stroke,
            strokeOpacity = _h.strokeOpacity;
        if (!((data === null || data === void 0 ? void 0 : data.length) && xKey && yKey)) {
            return [];
        }
        var legendData = [
            {
                legendType: 'category',
                id: id,
                itemId: yKey,
                seriesId: id,
                enabled: visible,
                label: {
                    text:
                        (_a = title !== null && title !== void 0 ? title : yName) !== null && _a !== void 0 ? _a : yKey,
                },
                marker: {
                    shape: marker.shape,
                    fill: (_b = marker.fill) !== null && _b !== void 0 ? _b : 'rgba(0, 0, 0, 0)',
                    stroke:
                        (_d = (_c = marker.stroke) !== null && _c !== void 0 ? _c : stroke) !== null && _d !== void 0
                            ? _d
                            : 'rgba(0, 0, 0, 0)',
                    fillOpacity: (_e = marker.fillOpacity) !== null && _e !== void 0 ? _e : 1,
                    strokeOpacity:
                        (_g = (_f = marker.strokeOpacity) !== null && _f !== void 0 ? _f : strokeOpacity) !== null &&
                        _g !== void 0
                            ? _g
                            : 1,
                },
            },
        ];
        return legendData;
    };
    LineSeries.prototype.animateEmptyUpdateReady = function (_a) {
        var _this = this;
        var markerSelections = _a.markerSelections,
            labelSelections = _a.labelSelections,
            contextData = _a.contextData,
            paths = _a.paths;
        contextData.forEach(function (_a, contextDataIndex) {
            var _b, _c, _d;
            var nodeData = _a.nodeData;
            var _e = __read$v(paths[contextDataIndex], 1),
                lineNode = _e[0];
            var linePath = lineNode.path;
            var nodeLengths = [0];
            var lineLength = nodeData.reduce(function (sum, datum, index) {
                if (index === 0) return sum;
                var prev = nodeData[index - 1];
                if (isNaN(datum.point.x) || isNaN(datum.point.y) || isNaN(prev.point.x) || isNaN(prev.point.y)) {
                    nodeLengths.push(sum);
                    return sum;
                }
                var length = Math.sqrt(
                    Math.pow(datum.point.x - prev.point.x, 2) + Math.pow(datum.point.y - prev.point.y, 2),
                );
                nodeLengths.push(sum + length);
                return sum + length;
            }, 0);
            lineNode.fill = undefined;
            lineNode.lineJoin = 'round';
            lineNode.pointerEvents = PointerEvents.None;
            lineNode.stroke = _this.stroke;
            lineNode.strokeWidth = _this.getStrokeWidth(_this.strokeWidth);
            lineNode.strokeOpacity = _this.strokeOpacity;
            lineNode.lineDash = _this.lineDash;
            lineNode.lineDashOffset = _this.lineDashOffset;
            var duration =
                (_c =
                    (_b = _this.ctx.animationManager) === null || _b === void 0
                        ? void 0
                        : _b.defaultOptions.duration) !== null && _c !== void 0
                    ? _c
                    : 1000;
            var markerDuration = 200;
            var animationOptions = {
                from: 0,
                to: lineLength,
            };
            (_d = _this.ctx.animationManager) === null || _d === void 0
                ? void 0
                : _d.animate(
                      _this.id + '_empty-update-ready',
                      __assign$A(__assign$A({}, animationOptions), {
                          duration: duration,
                          onUpdate: function (length) {
                              linePath.clear({ trackChanges: true });
                              nodeData.forEach(function (datum, index) {
                                  if (nodeLengths[index] <= length) {
                                      // Draw/move the full segment if past the end of this segment
                                      if (datum.point.moveTo) {
                                          linePath.moveTo(datum.point.x, datum.point.y);
                                      } else {
                                          linePath.lineTo(datum.point.x, datum.point.y);
                                      }
                                  } else if (index > 0 && nodeLengths[index - 1] < length) {
                                      // Draw/move partial line if in between the start and end of this segment
                                      var start = nodeData[index - 1].point;
                                      var end = datum.point;
                                      var segmentLength = nodeLengths[index] - nodeLengths[index - 1];
                                      var remainingLength = nodeLengths[index] - length;
                                      var ratio = (segmentLength - remainingLength) / segmentLength;
                                      var x = (1 - ratio) * start.x + ratio * end.x;
                                      var y = (1 - ratio) * start.y + ratio * end.y;
                                      if (datum.point.moveTo) {
                                          linePath.moveTo(x, y);
                                      } else {
                                          linePath.lineTo(x, y);
                                      }
                                  }
                              });
                              lineNode.checkPathDirty();
                          },
                      }),
                  );
            markerSelections[contextDataIndex].each(function (marker, datum, index) {
                var _a, _b, _c, _d;
                var delay = lineLength > 0 ? (nodeLengths[index] / lineLength) * duration : 0;
                var format = _this.animateFormatter(datum);
                var size =
                    (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0
                        ? _b
                        : 0;
                (_c = _this.ctx.animationManager) === null || _c === void 0
                    ? void 0
                    : _c.animate(
                          _this.id + '_empty-update-ready_' + marker.id,
                          __assign$A(__assign$A({}, animationOptions), {
                              to:
                                  (_d = format === null || format === void 0 ? void 0 : format.size) !== null &&
                                  _d !== void 0
                                      ? _d
                                      : size,
                              delay: delay,
                              duration: markerDuration,
                              onUpdate: function (size) {
                                  marker.size = size;
                              },
                          }),
                      );
            });
            labelSelections[contextDataIndex].each(function (label, _, index) {
                var _a;
                var delay = (nodeLengths[index] / lineLength) * duration;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_empty-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: delay,
                          duration: markerDuration,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    LineSeries.prototype.animateReadyUpdate = function (data) {
        this.resetMarkersAndPaths(data);
    };
    LineSeries.prototype.animateReadyResize = function (data) {
        var _a;
        (_a = this.ctx.animationManager) === null || _a === void 0 ? void 0 : _a.reset();
        this.resetMarkersAndPaths(data);
    };
    LineSeries.prototype.resetMarkersAndPaths = function (_a) {
        var _this = this;
        var markerSelections = _a.markerSelections,
            contextData = _a.contextData,
            paths = _a.paths;
        contextData.forEach(function (_a, contextDataIndex) {
            var nodeData = _a.nodeData;
            var _b = __read$v(paths[contextDataIndex], 1),
                lineNode = _b[0];
            var linePath = lineNode.path;
            lineNode.stroke = _this.stroke;
            lineNode.strokeWidth = _this.getStrokeWidth(_this.strokeWidth);
            lineNode.strokeOpacity = _this.strokeOpacity;
            lineNode.lineDash = _this.lineDash;
            lineNode.lineDashOffset = _this.lineDashOffset;
            linePath.clear({ trackChanges: true });
            nodeData.forEach(function (datum) {
                if (datum.point.moveTo) {
                    linePath.moveTo(datum.point.x, datum.point.y);
                } else {
                    linePath.lineTo(datum.point.x, datum.point.y);
                }
            });
            lineNode.checkPathDirty();
            markerSelections[contextDataIndex].each(function (marker, datum) {
                var _a, _b, _c;
                var format = _this.animateFormatter(datum);
                var size =
                    (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0
                        ? _b
                        : 0;
                marker.size =
                    (_c = format === null || format === void 0 ? void 0 : format.size) !== null && _c !== void 0
                        ? _c
                        : size;
            });
        });
    };
    LineSeries.prototype.animateFormatter = function (datum) {
        var _a, _b;
        var _c = this,
            marker = _c.marker,
            _d = _c.xKey,
            xKey = _d === void 0 ? '' : _d,
            _e = _c.yKey,
            yKey = _e === void 0 ? '' : _e,
            lineStroke = _c.stroke,
            seriesId = _c.id,
            callbackCache = _c.ctx.callbackCache;
        var size = marker.size,
            formatter = marker.formatter;
        var fill = marker.fill;
        var stroke = (_a = marker.stroke) !== null && _a !== void 0 ? _a : lineStroke;
        var strokeWidth = (_b = marker.strokeWidth) !== null && _b !== void 0 ? _b : this.strokeWidth;
        var format = undefined;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: datum.datum,
                xKey: xKey,
                yKey: yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size: size,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        return format;
    };
    LineSeries.prototype.isLabelEnabled = function () {
        return this.label.enabled;
    };
    LineSeries.className = 'LineSeries';
    LineSeries.type = 'line';
    __decorate$1k([Validate(OPT_STRING)], LineSeries.prototype, 'title', void 0);
    __decorate$1k([Validate(OPT_COLOR_STRING)], LineSeries.prototype, 'stroke', void 0);
    __decorate$1k([Validate(OPT_LINE_DASH)], LineSeries.prototype, 'lineDash', void 0);
    __decorate$1k([Validate(NUMBER(0))], LineSeries.prototype, 'lineDashOffset', void 0);
    __decorate$1k([Validate(NUMBER(0))], LineSeries.prototype, 'strokeWidth', void 0);
    __decorate$1k([Validate(NUMBER(0, 1))], LineSeries.prototype, 'strokeOpacity', void 0);
    __decorate$1k([Validate(OPT_STRING)], LineSeries.prototype, 'xKey', void 0);
    __decorate$1k([Validate(OPT_STRING)], LineSeries.prototype, 'xName', void 0);
    __decorate$1k([Validate(OPT_STRING)], LineSeries.prototype, 'yKey', void 0);
    __decorate$1k([Validate(OPT_STRING)], LineSeries.prototype, 'yName', void 0);
    return LineSeries;
})(CartesianSeries);

var ColorScale = /** @class */ (function () {
    function ColorScale() {
        this.domain = [0, 1];
        this.range = ['red', 'blue'];
        this.parsedRange = this.range.map(function (v) {
            return Color.fromString(v);
        });
    }
    ColorScale.prototype.update = function () {
        var _a = this,
            domain = _a.domain,
            range = _a.range;
        if (domain.length < 2) {
            Logger.warnOnce('`colorDomain` should have at least 2 values.');
            if (domain.length === 0) {
                domain.push(0, 1);
            } else if (domain.length === 1) {
                domain.push(domain[0] + 1);
            }
        }
        for (var i = 1; i < domain.length; i++) {
            var a = domain[i - 1];
            var b = domain[i];
            if (a >= b) {
                Logger.warnOnce('`colorDomain` values should be supplied in ascending order.');
                domain.sort(function (a, b) {
                    return a - b;
                });
                break;
            }
        }
        var isSmallRange = range.length < domain.length;
        if (isSmallRange || (domain.length > 2 && range.length > domain.length)) {
            Logger.warnOnce(
                'Number of elements in `colorRange` needs to match the number of elements in `colorDomain`.',
            );
            if (isSmallRange) {
                for (var i = range.length; i < domain.length; i++) {
                    range.push('black');
                }
            } else {
                range.splice(domain.length);
            }
        }
        this.parsedRange = this.range.map(function (v) {
            return Color.fromString(v);
        });
    };
    ColorScale.prototype.convert = function (x) {
        var _a = this,
            domain = _a.domain,
            range = _a.range,
            parsedRange = _a.parsedRange;
        var d0 = domain[0];
        var d1 = domain[domain.length - 1];
        var r0 = range[0];
        var r1 = range[range.length - 1];
        if (x <= d0) {
            return r0;
        }
        if (x >= d1) {
            return r1;
        }
        var index;
        var q;
        if (domain.length === 2) {
            var t = (x - d0) / (d1 - d0);
            var step = 1 / (range.length - 1);
            index = range.length <= 2 ? 0 : Math.min(Math.floor(t * (range.length - 1)), range.length - 2);
            q = (t - index * step) / step;
        } else {
            for (index = 0; index < domain.length - 2; index++) {
                if (x < domain[index + 1]) {
                    break;
                }
            }
            var a = domain[index];
            var b = domain[index + 1];
            q = (x - a) / (b - a);
        }
        var c0 = parsedRange[index];
        var c1 = parsedRange[index + 1];
        return interpolateColor(c0, c1)(q);
    };
    return ColorScale;
})();

var __extends$1_ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$z =
    (undefined && undefined.__assign) ||
    function () {
        __assign$z =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$z.apply(this, arguments);
    };
var __decorate$1j =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$2 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$2 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$u =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$h =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$g =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var ScatterSeriesLabel = /** @class */ (function (_super) {
    __extends$1_(ScatterSeriesLabel, _super);
    function ScatterSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        return _this;
    }
    __decorate$1j([Validate(OPT_FUNCTION)], ScatterSeriesLabel.prototype, 'formatter', void 0);
    return ScatterSeriesLabel;
})(Label$1);
var ScatterSeriesNodeBaseClickEvent = /** @class */ (function (_super) {
    __extends$1_(ScatterSeriesNodeBaseClickEvent, _super);
    function ScatterSeriesNodeBaseClickEvent(sizeKey, xKey, yKey, nativeEvent, datum, series) {
        var _this = _super.call(this, xKey, yKey, nativeEvent, datum, series) || this;
        _this.sizeKey = sizeKey;
        return _this;
    }
    return ScatterSeriesNodeBaseClickEvent;
})(CartesianSeriesNodeBaseClickEvent);
var ScatterSeriesNodeClickEvent = /** @class */ (function (_super) {
    __extends$1_(ScatterSeriesNodeClickEvent, _super);
    function ScatterSeriesNodeClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeClick';
        return _this;
    }
    return ScatterSeriesNodeClickEvent;
})(ScatterSeriesNodeBaseClickEvent);
var ScatterSeriesNodeDoubleClickEvent = /** @class */ (function (_super) {
    __extends$1_(ScatterSeriesNodeDoubleClickEvent, _super);
    function ScatterSeriesNodeDoubleClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeDoubleClick';
        return _this;
    }
    return ScatterSeriesNodeDoubleClickEvent;
})(ScatterSeriesNodeBaseClickEvent);
var ScatterSeriesTooltip = /** @class */ (function (_super) {
    __extends$1_(ScatterSeriesTooltip, _super);
    function ScatterSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        return _this;
    }
    __decorate$1j([Validate(OPT_FUNCTION)], ScatterSeriesTooltip.prototype, 'renderer', void 0);
    return ScatterSeriesTooltip;
})(SeriesTooltip);
var ScatterSeries = /** @class */ (function (_super) {
    __extends$1_(ScatterSeries, _super);
    function ScatterSeries(moduleCtx) {
        var _this =
            _super.call(this, {
                moduleCtx: moduleCtx,
                pickModes: [
                    SeriesNodePickMode.NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST,
                    SeriesNodePickMode.NEAREST_NODE,
                    SeriesNodePickMode.EXACT_SHAPE_MATCH,
                ],
                pathsPerSeries: 0,
                hasMarkers: true,
            }) || this;
        _this.sizeScale = new LinearScale$1();
        _this.marker = new CartesianSeriesMarker();
        _this.label = new ScatterSeriesLabel();
        _this.title = undefined;
        _this.labelKey = undefined;
        _this.xName = undefined;
        _this.yName = undefined;
        _this.sizeName = 'Size';
        _this.labelName = 'Label';
        _this.xKey = undefined;
        _this.yKey = undefined;
        _this.sizeKey = undefined;
        _this.colorKey = undefined;
        _this.colorName = 'Color';
        _this.colorDomain = undefined;
        _this.colorRange = ['#ffff00', '#00ff00', '#0000ff'];
        _this.colorScale = new ColorScale();
        _this.tooltip = new ScatterSeriesTooltip();
        var label = _this.label;
        label.enabled = false;
        return _this;
    }
    ScatterSeries.prototype.processData = function (dataController) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function () {
            var _c,
                _d,
                xKey,
                _e,
                yKey,
                sizeKey,
                labelKey,
                axes,
                marker,
                data,
                xAxis,
                yAxis,
                isContinuousX,
                isContinuousY,
                _f,
                colorScale,
                colorDomain,
                colorRange,
                colorKey,
                _g,
                dataModel,
                processedData,
                sizeKeyIdx,
                processedSize,
                colorKeyIdx;
            return __generator$2(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        (_c = this),
                            (_d = _c.xKey),
                            (xKey = _d === void 0 ? '' : _d),
                            (_e = _c.yKey),
                            (yKey = _e === void 0 ? '' : _e),
                            (sizeKey = _c.sizeKey),
                            (labelKey = _c.labelKey),
                            (axes = _c.axes),
                            (marker = _c.marker),
                            (data = _c.data);
                        xAxis = axes[ChartAxisDirection.X];
                        yAxis = axes[ChartAxisDirection.Y];
                        isContinuousX =
                            (xAxis === null || xAxis === void 0 ? void 0 : xAxis.scale) instanceof ContinuousScale;
                        isContinuousY =
                            (yAxis === null || yAxis === void 0 ? void 0 : yAxis.scale) instanceof ContinuousScale;
                        (_f = this),
                            (colorScale = _f.colorScale),
                            (colorDomain = _f.colorDomain),
                            (colorRange = _f.colorRange),
                            (colorKey = _f.colorKey);
                        return [
                            4 /*yield*/,
                            dataController.request(this.id, data !== null && data !== void 0 ? data : [], {
                                props: __spreadArray$h(
                                    __spreadArray$h(
                                        __spreadArray$h(
                                            [
                                                valueProperty(this, xKey, isContinuousX, { id: 'xValue' }),
                                                valueProperty(this, yKey, isContinuousY, { id: 'yValue' }),
                                            ],
                                            __read$u(
                                                sizeKey
                                                    ? [valueProperty(this, sizeKey, true, { id: 'sizeValue' })]
                                                    : [],
                                            ),
                                        ),
                                        __read$u(
                                            colorKey ? [valueProperty(this, colorKey, true, { id: 'colorValue' })] : [],
                                        ),
                                    ),
                                    __read$u(
                                        labelKey ? [valueProperty(this, labelKey, false, { id: 'labelValue' })] : [],
                                    ),
                                ),
                                dataVisible: this.visible,
                            }),
                        ];
                    case 1:
                        (_g = _h.sent()), (dataModel = _g.dataModel), (processedData = _g.processedData);
                        this.dataModel = dataModel;
                        this.processedData = processedData;
                        if (sizeKey) {
                            sizeKeyIdx = dataModel.resolveProcessedDataIndexById(this, 'sizeValue').index;
                            processedSize =
                                (_a = processedData.domain.values[sizeKeyIdx]) !== null && _a !== void 0 ? _a : [];
                            this.sizeScale.domain = marker.domain ? marker.domain : processedSize;
                        }
                        if (colorKey) {
                            colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, 'colorValue').index;
                            colorScale.domain =
                                (_b =
                                    colorDomain !== null && colorDomain !== void 0
                                        ? colorDomain
                                        : processedData.domain.values[colorKeyIdx]) !== null && _b !== void 0
                                    ? _b
                                    : [];
                            colorScale.range = colorRange;
                            colorScale.update();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ScatterSeries.prototype.getDomain = function (direction) {
        var _a = this,
            dataModel = _a.dataModel,
            processedData = _a.processedData;
        if (!processedData || !dataModel) return [];
        var id = direction === ChartAxisDirection.X ? 'xValue' : 'yValue';
        var dataDef = dataModel.resolveProcessedDataDefById(this, id, 'value');
        var domain = dataModel.getDomain(this, id, 'value', processedData);
        if (
            (dataDef === null || dataDef === void 0 ? void 0 : dataDef.def.type) === 'value' &&
            (dataDef === null || dataDef === void 0 ? void 0 : dataDef.def.valueType) === 'category'
        ) {
            return domain;
        }
        var axis = this.axes[direction];
        return this.fixNumericExtent(extent$4(domain), axis);
    };
    ScatterSeries.prototype.getNodeClickEvent = function (event, datum) {
        var _a, _b;
        return new ScatterSeriesNodeClickEvent(
            this.sizeKey,
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    ScatterSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        var _a, _b;
        return new ScatterSeriesNodeDoubleClickEvent(
            this.sizeKey,
            (_a = this.xKey) !== null && _a !== void 0 ? _a : '',
            (_b = this.yKey) !== null && _b !== void 0 ? _b : '',
            event,
            datum,
            this,
        );
    };
    ScatterSeries.prototype.createNodeData = function () {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter$2(this, void 0, void 0, function () {
            var _g,
                visible,
                axes,
                _h,
                yKey,
                _j,
                xKey,
                label,
                labelKey,
                callbackCache,
                dataModel,
                processedData,
                xAxis,
                yAxis,
                xDataIdx,
                yDataIdx,
                sizeDataIdx,
                colorDataIdx,
                labelDataIdx,
                _k,
                colorScale,
                sizeKey,
                colorKey,
                seriesId,
                xScale,
                yScale,
                xOffset,
                yOffset,
                _l,
                sizeScale,
                marker,
                nodeData,
                font,
                actualLength,
                _m,
                _o,
                _p,
                values,
                datum,
                xDatum,
                yDatum,
                x,
                y,
                text,
                size,
                markerSize,
                fill;
            var e_1, _q;
            return __generator$2(this, function (_r) {
                (_g = this),
                    (visible = _g.visible),
                    (axes = _g.axes),
                    (_h = _g.yKey),
                    (yKey = _h === void 0 ? '' : _h),
                    (_j = _g.xKey),
                    (xKey = _j === void 0 ? '' : _j),
                    (label = _g.label),
                    (labelKey = _g.labelKey),
                    (callbackCache = _g.ctx.callbackCache),
                    (dataModel = _g.dataModel),
                    (processedData = _g.processedData);
                xAxis = axes[ChartAxisDirection.X];
                yAxis = axes[ChartAxisDirection.Y];
                if (!(dataModel && processedData && visible && xAxis && yAxis)) return [2 /*return*/, []];
                xDataIdx = dataModel.resolveProcessedDataIndexById(this, 'xValue').index;
                yDataIdx = dataModel.resolveProcessedDataIndexById(this, 'yValue').index;
                sizeDataIdx = this.sizeKey ? dataModel.resolveProcessedDataIndexById(this, 'sizeValue').index : -1;
                colorDataIdx = this.colorKey ? dataModel.resolveProcessedDataIndexById(this, 'colorValue').index : -1;
                labelDataIdx = this.labelKey ? dataModel.resolveProcessedDataIndexById(this, 'labelValue').index : -1;
                (_k = this),
                    (colorScale = _k.colorScale),
                    (sizeKey = _k.sizeKey),
                    (colorKey = _k.colorKey),
                    (seriesId = _k.id);
                xScale = xAxis.scale;
                yScale = yAxis.scale;
                xOffset = ((_a = xScale.bandwidth) !== null && _a !== void 0 ? _a : 0) / 2;
                yOffset = ((_b = yScale.bandwidth) !== null && _b !== void 0 ? _b : 0) / 2;
                (_l = this), (sizeScale = _l.sizeScale), (marker = _l.marker);
                nodeData = new Array(
                    (_d = (_c = this.processedData) === null || _c === void 0 ? void 0 : _c.data.length) !== null &&
                    _d !== void 0
                        ? _d
                        : 0,
                );
                sizeScale.range = [marker.size, marker.maxSize];
                font = label.getFont();
                actualLength = 0;
                try {
                    for (
                        _m = __values$g((_e = processedData.data) !== null && _e !== void 0 ? _e : []), _o = _m.next();
                        !_o.done;
                        _o = _m.next()
                    ) {
                        (_p = _o.value), (values = _p.values), (datum = _p.datum);
                        xDatum = values[xDataIdx];
                        yDatum = values[yDataIdx];
                        x = xScale.convert(xDatum) + xOffset;
                        y = yScale.convert(yDatum) + yOffset;
                        if (!this.checkRangeXY(x, y, xAxis, yAxis)) {
                            continue;
                        }
                        text = void 0;
                        if (label.formatter) {
                            text = callbackCache.call(label.formatter, {
                                value: yDatum,
                                seriesId: seriesId,
                                datum: datum,
                            });
                        }
                        if (text === undefined) {
                            text = labelKey ? String(values[labelDataIdx]) : '';
                        }
                        size = HdpiCanvas.getTextSize(text, font);
                        markerSize = sizeKey ? sizeScale.convert(values[sizeDataIdx]) : marker.size;
                        fill = colorKey ? colorScale.convert(values[colorDataIdx]) : undefined;
                        nodeData[actualLength++] = {
                            series: this,
                            itemId: yKey,
                            yKey: yKey,
                            xKey: xKey,
                            datum: datum,
                            xValue: xDatum,
                            yValue: yDatum,
                            sizeValue: values[sizeDataIdx],
                            point: { x: x, y: y, size: markerSize },
                            nodeMidPoint: { x: x, y: y },
                            fill: fill,
                            label: __assign$z({ text: text }, size),
                        };
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (_o && !_o.done && (_q = _m.return)) _q.call(_m);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
                nodeData.length = actualLength;
                return [
                    2 /*return*/,
                    [
                        {
                            itemId: (_f = this.yKey) !== null && _f !== void 0 ? _f : this.id,
                            nodeData: nodeData,
                            labelData: nodeData,
                        },
                    ],
                ];
            });
        });
    };
    ScatterSeries.prototype.isPathOrSelectionDirty = function () {
        return this.marker.isDirty();
    };
    ScatterSeries.prototype.getLabelData = function () {
        var _a;
        return (_a = this.contextNodeData) === null || _a === void 0
            ? void 0
            : _a.reduce(function (r, n) {
                  return r.concat(n.labelData);
              }, []);
    };
    ScatterSeries.prototype.markerFactory = function () {
        var shape = this.marker.shape;
        var MarkerShape = getMarker$1(shape);
        return new MarkerShape();
    };
    ScatterSeries.prototype.updateMarkerSelection = function (opts) {
        return __awaiter$2(this, void 0, void 0, function () {
            var nodeData, markerSelection, enabled, data;
            return __generator$2(this, function (_a) {
                (nodeData = opts.nodeData), (markerSelection = opts.markerSelection);
                enabled = this.marker.enabled;
                if (this.marker.isDirty()) {
                    markerSelection.clear();
                }
                data = enabled ? nodeData : [];
                return [2 /*return*/, markerSelection.update(data)];
            });
        });
    };
    ScatterSeries.prototype.updateMarkerNodes = function (opts) {
        return __awaiter$2(this, void 0, void 0, function () {
            var markerSelection,
                isDatumHighlighted,
                _a,
                marker,
                _b,
                xKey,
                _c,
                yKey,
                sizeScale,
                _d,
                markerFillOpacity,
                markerStrokeOpacity,
                markerStrokeWidth,
                _e,
                highlightedFill,
                _f,
                highlightFillOpacity,
                highlightedStroke,
                highlightedDatumStrokeWidth,
                seriesId,
                callbackCache,
                formatter,
                customMarker;
            return __generator$2(this, function (_g) {
                (markerSelection = opts.markerSelection), (isDatumHighlighted = opts.isHighlight);
                (_a = this),
                    (marker = _a.marker),
                    (_b = _a.xKey),
                    (xKey = _b === void 0 ? '' : _b),
                    (_c = _a.yKey),
                    (yKey = _c === void 0 ? '' : _c),
                    (sizeScale = _a.sizeScale),
                    (_d = _a.marker),
                    (markerFillOpacity = _d.fillOpacity),
                    (markerStrokeOpacity = _d.strokeOpacity),
                    (markerStrokeWidth = _d.strokeWidth),
                    (_e = _a.highlightStyle.item),
                    (highlightedFill = _e.fill),
                    (_f = _e.fillOpacity),
                    (highlightFillOpacity = _f === void 0 ? markerFillOpacity : _f),
                    (highlightedStroke = _e.stroke),
                    (highlightedDatumStrokeWidth = _e.strokeWidth),
                    (seriesId = _a.id),
                    (callbackCache = _a.ctx.callbackCache);
                formatter = marker.formatter;
                sizeScale.range = [marker.size, marker.maxSize];
                customMarker = typeof marker.shape === 'function';
                markerSelection.each(function (node, datum) {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
                    var fill =
                        isDatumHighlighted && highlightedFill !== undefined
                            ? highlightedFill
                            : (_a = datum.fill) !== null && _a !== void 0
                            ? _a
                            : marker.fill;
                    var fillOpacity = isDatumHighlighted ? highlightFillOpacity : markerFillOpacity;
                    var stroke =
                        isDatumHighlighted && highlightedStroke !== undefined ? highlightedStroke : marker.stroke;
                    var strokeOpacity = markerStrokeOpacity;
                    var strokeWidth =
                        isDatumHighlighted && highlightedDatumStrokeWidth !== undefined
                            ? highlightedDatumStrokeWidth
                            : markerStrokeWidth !== null && markerStrokeWidth !== void 0
                            ? markerStrokeWidth
                            : 1;
                    var size =
                        (_c = (_b = datum.point) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0
                            ? _c
                            : 0;
                    var format = undefined;
                    if (formatter) {
                        format = callbackCache.call(formatter, {
                            datum: datum.datum,
                            xKey: xKey,
                            yKey: yKey,
                            fill: fill,
                            stroke: stroke,
                            strokeWidth: strokeWidth,
                            size: size,
                            highlighted: isDatumHighlighted,
                            seriesId: seriesId,
                        });
                    }
                    node.fill =
                        (_d = format === null || format === void 0 ? void 0 : format.fill) !== null && _d !== void 0
                            ? _d
                            : fill;
                    node.stroke =
                        (_e = format === null || format === void 0 ? void 0 : format.stroke) !== null && _e !== void 0
                            ? _e
                            : stroke;
                    node.strokeWidth =
                        (_f = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null &&
                        _f !== void 0
                            ? _f
                            : strokeWidth;
                    node.fillOpacity = fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : 1;
                    node.strokeOpacity = strokeOpacity !== null && strokeOpacity !== void 0 ? strokeOpacity : 1;
                    node.translationX =
                        (_h = (_g = datum.point) === null || _g === void 0 ? void 0 : _g.x) !== null && _h !== void 0
                            ? _h
                            : 0;
                    node.translationY =
                        (_k = (_j = datum.point) === null || _j === void 0 ? void 0 : _j.y) !== null && _k !== void 0
                            ? _k
                            : 0;
                    node.visible = node.size > 0;
                    if (!customMarker || node.dirtyPath) {
                        return;
                    }
                    // Only for custom marker shapes.
                    node.path.clear({ trackChanges: true });
                    node.updatePath();
                    node.checkPathDirty();
                });
                if (!isDatumHighlighted) {
                    this.marker.markClean();
                }
                return [2 /*return*/];
            });
        });
    };
    ScatterSeries.prototype.updateLabelSelection = function (opts) {
        var _a, _b;
        return __awaiter$2(this, void 0, void 0, function () {
            var labelSelection, enabled, placedLabels, placedNodeDatum;
            return __generator$2(this, function (_c) {
                labelSelection = opts.labelSelection;
                enabled = this.label.enabled;
                placedLabels = enabled
                    ? (_b = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.placeLabels().get(this)) !==
                          null && _b !== void 0
                        ? _b
                        : []
                    : [];
                placedNodeDatum = placedLabels.map(function (v) {
                    return __assign$z(__assign$z({}, v.datum), {
                        point: {
                            x: v.x,
                            y: v.y,
                            size: v.datum.point.size,
                        },
                    });
                });
                return [2 /*return*/, labelSelection.update(placedNodeDatum)];
            });
        });
    };
    ScatterSeries.prototype.updateLabelNodes = function (opts) {
        return __awaiter$2(this, void 0, void 0, function () {
            var labelSelection, label;
            return __generator$2(this, function (_a) {
                labelSelection = opts.labelSelection;
                label = this.label;
                labelSelection.each(function (text, datum) {
                    var _a, _b, _c, _d;
                    text.text = datum.label.text;
                    text.fill = label.color;
                    text.x =
                        (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0
                            ? _b
                            : 0;
                    text.y =
                        (_d = (_c = datum.point) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0
                            ? _d
                            : 0;
                    text.fontStyle = label.fontStyle;
                    text.fontWeight = label.fontWeight;
                    text.fontSize = label.fontSize;
                    text.fontFamily = label.fontFamily;
                    text.textAlign = 'left';
                    text.textBaseline = 'top';
                });
                return [2 /*return*/];
            });
        });
    };
    ScatterSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a, _b, _c, _d, _e, _f, _g;
        var _h = this,
            xKey = _h.xKey,
            yKey = _h.yKey,
            axes = _h.axes;
        var xAxis = axes[ChartAxisDirection.X];
        var yAxis = axes[ChartAxisDirection.Y];
        if (!xKey || !yKey || !xAxis || !yAxis) {
            return '';
        }
        var _j = this,
            marker = _j.marker,
            tooltip = _j.tooltip,
            xName = _j.xName,
            yName = _j.yName,
            sizeKey = _j.sizeKey,
            sizeName = _j.sizeName,
            labelKey = _j.labelKey,
            labelName = _j.labelName,
            seriesId = _j.id,
            callbackCache = _j.ctx.callbackCache;
        var stroke = marker.stroke;
        var fill = (_a = nodeDatum.fill) !== null && _a !== void 0 ? _a : marker.fill;
        var strokeWidth = this.getStrokeWidth((_b = marker.strokeWidth) !== null && _b !== void 0 ? _b : 1);
        var formatter = this.marker.formatter;
        var format = undefined;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: nodeDatum,
                xKey: xKey,
                yKey: yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size:
                    (_d = (_c = nodeDatum.point) === null || _c === void 0 ? void 0 : _c.size) !== null && _d !== void 0
                        ? _d
                        : 0,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        var color =
            (_f =
                (_e = format === null || format === void 0 ? void 0 : format.fill) !== null && _e !== void 0
                    ? _e
                    : fill) !== null && _f !== void 0
                ? _f
                : 'gray';
        var title = (_g = this.title) !== null && _g !== void 0 ? _g : yName;
        var datum = nodeDatum.datum,
            xValue = nodeDatum.xValue,
            yValue = nodeDatum.yValue,
            sizeValue = nodeDatum.sizeValue,
            labelText = nodeDatum.label.text;
        var xString = sanitizeHtml(xAxis.formatDatum(xValue));
        var yString = sanitizeHtml(yAxis.formatDatum(yValue));
        var content =
            '<b>' +
            sanitizeHtml(xName !== null && xName !== void 0 ? xName : xKey) +
            '</b>: ' +
            xString +
            '<br>' +
            ('<b>' + sanitizeHtml(yName !== null && yName !== void 0 ? yName : yKey) + '</b>: ' + yString);
        if (sizeKey) {
            content +=
                '<br><b>' +
                sanitizeHtml(sizeName !== null && sizeName !== void 0 ? sizeName : sizeKey) +
                '</b>: ' +
                sanitizeHtml(sizeValue);
        }
        if (labelKey) {
            content =
                '<b>' +
                sanitizeHtml(labelName !== null && labelName !== void 0 ? labelName : labelKey) +
                '</b>: ' +
                sanitizeHtml(labelText) +
                '<br>' +
                content;
        }
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        var tooltipRenderer = tooltip.renderer;
        if (tooltipRenderer) {
            return toTooltipHtml$1(
                tooltipRenderer({
                    datum: datum,
                    xKey: xKey,
                    xValue: xValue,
                    xName: xName,
                    yKey: yKey,
                    yValue: yValue,
                    yName: yName,
                    sizeKey: sizeKey,
                    sizeName: sizeName,
                    labelKey: labelKey,
                    labelName: labelName,
                    title: title,
                    color: color,
                    seriesId: seriesId,
                }),
                defaults,
            );
        }
        return toTooltipHtml$1(defaults);
    };
    ScatterSeries.prototype.getLegendData = function () {
        var _a, _b, _c, _d, _e;
        var _f = this,
            id = _f.id,
            data = _f.data,
            xKey = _f.xKey,
            yKey = _f.yKey,
            yName = _f.yName,
            title = _f.title,
            visible = _f.visible,
            marker = _f.marker;
        var fill = marker.fill,
            stroke = marker.stroke,
            fillOpacity = marker.fillOpacity,
            strokeOpacity = marker.strokeOpacity;
        if (!((data === null || data === void 0 ? void 0 : data.length) && xKey && yKey)) {
            return [];
        }
        var legendData = [
            {
                legendType: 'category',
                id: id,
                itemId: yKey,
                seriesId: id,
                enabled: visible,
                label: {
                    text:
                        (_a = title !== null && title !== void 0 ? title : yName) !== null && _a !== void 0 ? _a : yKey,
                },
                marker: {
                    shape: marker.shape,
                    fill:
                        (_c = (_b = marker.fill) !== null && _b !== void 0 ? _b : fill) !== null && _c !== void 0
                            ? _c
                            : 'rgba(0, 0, 0, 0)',
                    stroke:
                        (_e = (_d = marker.stroke) !== null && _d !== void 0 ? _d : stroke) !== null && _e !== void 0
                            ? _e
                            : 'rgba(0, 0, 0, 0)',
                    fillOpacity: fillOpacity !== null && fillOpacity !== void 0 ? fillOpacity : 1,
                    strokeOpacity: strokeOpacity !== null && strokeOpacity !== void 0 ? strokeOpacity : 1,
                },
            },
        ];
        return legendData;
    };
    ScatterSeries.prototype.animateEmptyUpdateReady = function (_a) {
        var _this = this;
        var _b, _c;
        var markerSelections = _a.markerSelections,
            labelSelections = _a.labelSelections;
        var duration =
            (_c = (_b = this.ctx.animationManager) === null || _b === void 0 ? void 0 : _b.defaultOptions.duration) !==
                null && _c !== void 0
                ? _c
                : 1000;
        var labelDuration = 200;
        markerSelections.forEach(function (markerSelection) {
            markerSelection.each(function (marker, datum) {
                var _a, _b, _c, _d;
                var format = _this.animateFormatter(marker, datum);
                var size =
                    (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0
                        ? _b
                        : 0;
                var to =
                    (_c = format === null || format === void 0 ? void 0 : format.size) !== null && _c !== void 0
                        ? _c
                        : size;
                (_d = _this.ctx.animationManager) === null || _d === void 0
                    ? void 0
                    : _d.animate(_this.id + '_empty-update-ready_' + marker.id, {
                          from: 0,
                          to: to,
                          duration: duration,
                          onUpdate: function (size) {
                              marker.size = size;
                          },
                      });
            });
        });
        labelSelections.forEach(function (labelSelection) {
            labelSelection.each(function (label) {
                var _a;
                (_a = _this.ctx.animationManager) === null || _a === void 0
                    ? void 0
                    : _a.animate(_this.id + '_empty-update-ready_' + label.id, {
                          from: 0,
                          to: 1,
                          delay: duration,
                          duration: labelDuration,
                          onUpdate: function (opacity) {
                              label.opacity = opacity;
                          },
                      });
            });
        });
    };
    ScatterSeries.prototype.animateReadyUpdate = function (_a) {
        var _this = this;
        var markerSelections = _a.markerSelections;
        markerSelections.forEach(function (markerSelection) {
            _this.resetMarkers(markerSelection);
        });
    };
    ScatterSeries.prototype.animateReadyHighlightMarkers = function (markerSelection) {
        this.resetMarkers(markerSelection);
    };
    ScatterSeries.prototype.resetMarkers = function (markerSelection) {
        var _this = this;
        markerSelection.each(function (marker, datum) {
            var _a, _b, _c;
            var format = _this.animateFormatter(marker, datum);
            var size =
                (_b = (_a = datum.point) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0
                    ? _b
                    : 0;
            marker.size =
                (_c = format === null || format === void 0 ? void 0 : format.size) !== null && _c !== void 0
                    ? _c
                    : size;
        });
    };
    ScatterSeries.prototype.animateFormatter = function (marker, datum) {
        var _a, _b, _c;
        var _d = this,
            _e = _d.xKey,
            xKey = _e === void 0 ? '' : _e,
            _f = _d.yKey,
            yKey = _f === void 0 ? '' : _f,
            markerStrokeWidth = _d.marker.strokeWidth,
            seriesId = _d.id,
            callbackCache = _d.ctx.callbackCache;
        var formatter = this.marker.formatter;
        var fill = (_a = datum.fill) !== null && _a !== void 0 ? _a : marker.fill;
        var stroke = marker.stroke;
        var strokeWidth = markerStrokeWidth !== null && markerStrokeWidth !== void 0 ? markerStrokeWidth : 1;
        var size =
            (_c = (_b = datum.point) === null || _b === void 0 ? void 0 : _b.size) !== null && _c !== void 0 ? _c : 0;
        var format = undefined;
        if (formatter) {
            format = callbackCache.call(formatter, {
                datum: datum.datum,
                xKey: xKey,
                yKey: yKey,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                size: size,
                highlighted: false,
                seriesId: seriesId,
            });
        }
        return format;
    };
    ScatterSeries.prototype.isLabelEnabled = function () {
        return this.label.enabled;
    };
    ScatterSeries.className = 'ScatterSeries';
    ScatterSeries.type = 'scatter';
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'title', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'labelKey', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'xName', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'yName', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'sizeName', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'labelName', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'xKey', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'yKey', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'sizeKey', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'colorKey', void 0);
    __decorate$1j([Validate(OPT_STRING)], ScatterSeries.prototype, 'colorName', void 0);
    __decorate$1j([Validate(OPT_NUMBER_ARRAY)], ScatterSeries.prototype, 'colorDomain', void 0);
    __decorate$1j([Validate(COLOR_STRING_ARRAY)], ScatterSeries.prototype, 'colorRange', void 0);
    return ScatterSeries;
})(CartesianSeries);

var __extends$1Z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var HierarchySeries = /** @class */ (function (_super) {
    __extends$1Z(HierarchySeries, _super);
    function HierarchySeries(moduleCtx) {
        return _super.call(this, { moduleCtx: moduleCtx, pickModes: [SeriesNodePickMode.EXACT_SHAPE_MATCH] }) || this;
    }
    HierarchySeries.prototype.getLabelData = function () {
        return [];
    };
    return HierarchySeries;
})(Series);

var __extends$1Y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$y =
    (undefined && undefined.__assign) ||
    function () {
        __assign$y =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$y.apply(this, arguments);
    };
var __decorate$1i =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __awaiter$1 =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator$1 =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __values$f =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var TreemapSeriesTooltip = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesTooltip, _super);
    function TreemapSeriesTooltip() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.renderer = undefined;
        return _this;
    }
    __decorate$1i([Validate(OPT_FUNCTION)], TreemapSeriesTooltip.prototype, 'renderer', void 0);
    return TreemapSeriesTooltip;
})(SeriesTooltip);
var TreemapSeriesNodeBaseClickEvent = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesNodeBaseClickEvent, _super);
    function TreemapSeriesNodeBaseClickEvent(labelKey, sizeKey, colorKey, nativeEvent, datum, series) {
        var _this = _super.call(this, nativeEvent, datum, series) || this;
        _this.labelKey = labelKey;
        _this.sizeKey = sizeKey;
        _this.colorKey = colorKey;
        return _this;
    }
    return TreemapSeriesNodeBaseClickEvent;
})(SeriesNodeBaseClickEvent);
var TreemapSeriesNodeClickEvent = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesNodeClickEvent, _super);
    function TreemapSeriesNodeClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeClick';
        return _this;
    }
    return TreemapSeriesNodeClickEvent;
})(TreemapSeriesNodeBaseClickEvent);
var TreemapSeriesNodeDoubleClickEvent = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesNodeDoubleClickEvent, _super);
    function TreemapSeriesNodeDoubleClickEvent() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.type = 'nodeDoubleClick';
        return _this;
    }
    return TreemapSeriesNodeDoubleClickEvent;
})(TreemapSeriesNodeBaseClickEvent);
var TreemapSeriesLabel = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesLabel, _super);
    function TreemapSeriesLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.padding = 10;
        return _this;
    }
    __decorate$1i([Validate(NUMBER(0))], TreemapSeriesLabel.prototype, 'padding', void 0);
    return TreemapSeriesLabel;
})(Label$1);
var TreemapSeriesTileLabel = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeriesTileLabel, _super);
    function TreemapSeriesTileLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.wrapping = 'on-space';
        return _this;
    }
    __decorate$1i([Validate(TEXT_WRAP)], TreemapSeriesTileLabel.prototype, 'wrapping', void 0);
    return TreemapSeriesTileLabel;
})(Label$1);
var TreemapValueLabel = /** @class */ (function () {
    function TreemapValueLabel() {
        this.style = (function () {
            var label = new Label$1();
            label.color = 'white';
            return label;
        })();
    }
    __decorate$1i([Validate(OPT_STRING)], TreemapValueLabel.prototype, 'key', void 0);
    __decorate$1i([Validate(OPT_STRING)], TreemapValueLabel.prototype, 'name', void 0);
    __decorate$1i([Validate(OPT_FUNCTION)], TreemapValueLabel.prototype, 'formatter', void 0);
    return TreemapValueLabel;
})();
var TextNodeTag;
(function (TextNodeTag) {
    TextNodeTag[(TextNodeTag['Name'] = 0)] = 'Name';
    TextNodeTag[(TextNodeTag['Value'] = 1)] = 'Value';
})(TextNodeTag || (TextNodeTag = {}));
var tempText = new Text();
function getTextSize(text, style) {
    var fontStyle = style.fontStyle,
        fontWeight = style.fontWeight,
        fontSize = style.fontSize,
        fontFamily = style.fontFamily;
    tempText.fontStyle = fontStyle;
    tempText.fontWeight = fontWeight;
    tempText.fontSize = fontSize;
    tempText.fontFamily = fontFamily;
    tempText.text = text;
    tempText.x = 0;
    tempText.y = 0;
    tempText.textAlign = 'left';
    tempText.textBaseline = 'top';
    var _a = tempText.computeBBox(),
        width = _a.width,
        height = _a.height;
    return { width: width, height: height };
}
function validateColor(color) {
    if (typeof color === 'string' && !Color.validColorString(color)) {
        var fallbackColor = 'black';
        Logger.warnOnce(
            'invalid Treemap tile colour string "' +
                color +
                '". Affected treemap tiles will be coloured ' +
                fallbackColor +
                '.',
        );
        return 'black';
    }
    return color;
}
var TreemapTextHighlightStyle = /** @class */ (function () {
    function TreemapTextHighlightStyle() {
        this.color = 'black';
    }
    __decorate$1i([Validate(OPT_COLOR_STRING)], TreemapTextHighlightStyle.prototype, 'color', void 0);
    return TreemapTextHighlightStyle;
})();
var TreemapHighlightStyle = /** @class */ (function (_super) {
    __extends$1Y(TreemapHighlightStyle, _super);
    function TreemapHighlightStyle() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.text = new TreemapTextHighlightStyle();
        return _this;
    }
    return TreemapHighlightStyle;
})(HighlightStyle);
var TreemapSeries = /** @class */ (function (_super) {
    __extends$1Y(TreemapSeries, _super);
    function TreemapSeries() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.groupSelection = Selection.select(_this.contentGroup, Group);
        _this.highlightSelection = Selection.select(_this.highlightGroup, Group);
        _this.title = (function () {
            var label = new TreemapSeriesLabel();
            label.color = 'white';
            label.fontWeight = 'bold';
            label.fontSize = 12;
            label.fontFamily = 'Verdana, sans-serif';
            label.padding = 15;
            return label;
        })();
        _this.subtitle = (function () {
            var label = new TreemapSeriesLabel();
            label.color = 'white';
            label.fontSize = 9;
            label.fontFamily = 'Verdana, sans-serif';
            label.padding = 13;
            return label;
        })();
        _this.labels = {
            large: (function () {
                var label = new TreemapSeriesTileLabel();
                label.color = 'white';
                label.fontWeight = 'bold';
                label.fontSize = 18;
                return label;
            })(),
            medium: (function () {
                var label = new TreemapSeriesTileLabel();
                label.color = 'white';
                label.fontWeight = 'bold';
                label.fontSize = 14;
                return label;
            })(),
            small: (function () {
                var label = new TreemapSeriesTileLabel();
                label.color = 'white';
                label.fontWeight = 'bold';
                label.fontSize = 10;
                return label;
            })(),
            formatter: undefined,
            value: new TreemapValueLabel(),
        };
        _this.nodePadding = 2;
        _this.nodeGap = 0;
        _this.labelKey = 'label';
        _this.sizeKey = 'size';
        _this.colorKey = 'color';
        _this.colorDomain = [-5, 5];
        _this.colorRange = ['#cb4b3f', '#6acb64'];
        _this.groupFill = '#272931';
        _this.groupStroke = 'black';
        _this.groupStrokeWidth = 1;
        _this.tileStroke = 'black';
        _this.tileStrokeWidth = 1;
        _this.gradient = true;
        _this.formatter = undefined;
        _this.colorName = 'Change';
        _this.rootName = 'Root';
        _this.highlightGroups = true;
        _this.tileShadow = new DropShadow();
        _this.labelShadow = new DropShadow();
        _this.tooltip = new TreemapSeriesTooltip();
        _this.highlightStyle = new TreemapHighlightStyle();
        return _this;
    }
    TreemapSeries.prototype.getNodePaddingTop = function (nodeDatum, bbox) {
        var _a;
        var _b = this,
            title = _b.title,
            subtitle = _b.subtitle,
            nodePadding = _b.nodePadding;
        var label = nodeDatum.label;
        if (nodeDatum.isLeaf || !label || nodeDatum.depth === 0) {
            return nodePadding;
        }
        var font = nodeDatum.depth > 1 ? subtitle : title;
        var textSize = getTextSize(label, font);
        var heightRatioThreshold = 3;
        if (font.fontSize > bbox.width / heightRatioThreshold || font.fontSize > bbox.height / heightRatioThreshold) {
            return nodePadding;
        }
        if (textSize.height >= bbox.height) {
            return nodePadding;
        }
        return textSize.height + nodePadding + ((_a = font.padding) !== null && _a !== void 0 ? _a : 0);
    };
    TreemapSeries.prototype.getNodePadding = function (nodeDatum, bbox) {
        var nodePadding = this.nodePadding;
        var top = this.getNodePaddingTop(nodeDatum, bbox);
        return {
            top: top,
            right: nodePadding,
            bottom: nodePadding,
            left: nodePadding,
        };
    };
    /**
     * Squarified Treemap algorithm
     * https://www.win.tue.nl/~vanwijk/stm.pdf
     */
    TreemapSeries.prototype.squarify = function (nodeDatum, bbox, outputNodesBoxes) {
        if (outputNodesBoxes === void 0) {
            outputNodesBoxes = new Map();
        }
        if (bbox.width <= 0 || bbox.height <= 0) {
            return outputNodesBoxes;
        }
        outputNodesBoxes.set(nodeDatum, bbox);
        var targetTileAspectRatio = 1; // The width and height will tend to this ratio
        var padding = this.getNodePadding(nodeDatum, bbox);
        var width = bbox.width - padding.left - padding.right;
        var height = bbox.height - padding.top - padding.bottom;
        if (width <= 0 || height <= 0 || nodeDatum.value <= 0) {
            return outputNodesBoxes;
        }
        var stackSum = 0;
        var startIndex = 0;
        var minRatioDiff = Infinity;
        var partitionSum = nodeDatum.value;
        var children = nodeDatum.children;
        var innerBox = new BBox(bbox.x + padding.left, bbox.y + padding.top, width, height);
        var partition = innerBox.clone();
        for (var i = 0; i < children.length; i++) {
            var value = children[i].value;
            var firstValue = children[startIndex].value;
            var isVertical_1 = partition.width < partition.height;
            stackSum += value;
            var partThickness = isVertical_1 ? partition.height : partition.width;
            var partLength = isVertical_1 ? partition.width : partition.height;
            var firstTileLength = (partLength * firstValue) / stackSum;
            var stackThickness = (partThickness * stackSum) / partitionSum;
            var ratio = Math.max(firstTileLength, stackThickness) / Math.min(firstTileLength, stackThickness);
            var diff = Math.abs(targetTileAspectRatio - ratio);
            if (diff < minRatioDiff) {
                minRatioDiff = diff;
                continue;
            }
            // Go one step back and process the best match
            stackSum -= value;
            stackThickness = (partThickness * stackSum) / partitionSum;
            var start_1 = isVertical_1 ? partition.x : partition.y;
            for (var j = startIndex; j < i; j++) {
                var child = children[j];
                var x = isVertical_1 ? start_1 : partition.x;
                var y = isVertical_1 ? partition.y : start_1;
                var length_1 = (partLength * child.value) / stackSum;
                var width_1 = isVertical_1 ? length_1 : stackThickness;
                var height_1 = isVertical_1 ? stackThickness : length_1;
                var childBox = new BBox(x, y, width_1, height_1);
                this.applyGap(innerBox, childBox);
                this.squarify(child, childBox, outputNodesBoxes);
                partitionSum -= child.value;
                start_1 += length_1;
            }
            if (isVertical_1) {
                partition.y += stackThickness;
                partition.height -= stackThickness;
            } else {
                partition.x += stackThickness;
                partition.width -= stackThickness;
            }
            startIndex = i;
            stackSum = 0;
            minRatioDiff = Infinity;
            i--;
        }
        // Process remaining space
        var isVertical = partition.width < partition.height;
        var start = isVertical ? partition.x : partition.y;
        for (var i = startIndex; i < children.length; i++) {
            var x = isVertical ? start : partition.x;
            var y = isVertical ? partition.y : start;
            var part = children[i].value / partitionSum;
            var width_2 = partition.width * (isVertical ? part : 1);
            var height_2 = partition.height * (isVertical ? 1 : part);
            var childBox = new BBox(x, y, width_2, height_2);
            this.applyGap(innerBox, childBox);
            this.squarify(children[i], childBox, outputNodesBoxes);
            start += isVertical ? width_2 : height_2;
        }
        return outputNodesBoxes;
    };
    TreemapSeries.prototype.applyGap = function (innerBox, childBox) {
        var gap = this.nodeGap / 2;
        var getBounds = function (box) {
            return {
                left: box.x,
                top: box.y,
                right: box.x + box.width,
                bottom: box.y + box.height,
            };
        };
        var innerBounds = getBounds(innerBox);
        var childBounds = getBounds(childBox);
        var sides = Object.keys(innerBounds);
        sides.forEach(function (side) {
            if (!isEqual(innerBounds[side], childBounds[side])) {
                childBox.shrink(gap, side);
            }
        });
    };
    TreemapSeries.prototype.processData = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a,
                data,
                sizeKey,
                labelKey,
                colorKey,
                colorDomain,
                colorRange,
                groupFill,
                labelFormatter,
                colorScale,
                createTreeNodeDatum;
            var _this = this;
            return __generator$1(this, function (_b) {
                if (!this.data) {
                    return [2 /*return*/];
                }
                (_a = this),
                    (data = _a.data),
                    (sizeKey = _a.sizeKey),
                    (labelKey = _a.labelKey),
                    (colorKey = _a.colorKey),
                    (colorDomain = _a.colorDomain),
                    (colorRange = _a.colorRange),
                    (groupFill = _a.groupFill);
                labelFormatter = this.labels.formatter;
                colorScale = new ColorScale();
                colorScale.domain = colorDomain;
                colorScale.range = colorRange;
                colorScale.update();
                createTreeNodeDatum = function (datum, depth, parent) {
                    var _a, _b, _c, _d;
                    if (depth === void 0) {
                        depth = 0;
                    }
                    var label;
                    if (labelFormatter) {
                        label = _this.ctx.callbackCache.call(labelFormatter, { datum: datum });
                    }
                    if (label !== undefined);
                    else if (labelKey) {
                        label = (_a = datum[labelKey]) !== null && _a !== void 0 ? _a : '';
                    } else {
                        label = '';
                    }
                    var colorScaleValue = colorKey
                        ? (_b = datum[colorKey]) !== null && _b !== void 0
                            ? _b
                            : depth
                        : depth;
                    colorScaleValue = validateColor(colorScaleValue);
                    var isLeaf = !datum.children;
                    var fill = groupFill;
                    if (typeof colorScaleValue === 'string') {
                        fill = colorScaleValue;
                    } else if (isLeaf || !groupFill) {
                        fill = colorScale.convert(colorScaleValue);
                    }
                    var nodeDatum = {
                        datum: datum,
                        depth: depth,
                        parent: parent,
                        value: 0,
                        label: label,
                        fill: fill,
                        series: _this,
                        isLeaf: isLeaf,
                        children: [],
                    };
                    if (isLeaf) {
                        nodeDatum.value = sizeKey ? ((_c = datum[sizeKey]) !== null && _c !== void 0 ? _c : 1) : 1;
                    } else {
                        (_d = datum.children) === null || _d === void 0
                            ? void 0
                            : _d.forEach(function (child) {
                                  var childNodeDatum = createTreeNodeDatum(child, depth + 1, nodeDatum);
                                  var value = childNodeDatum.value;
                                  if (isNaN(value) || !isFinite(value) || value === 0) {
                                      return;
                                  }
                                  nodeDatum.value += value;
                                  nodeDatum.children.push(childNodeDatum);
                              });
                        nodeDatum.children.sort(function (a, b) {
                            return b.value - a.value;
                        });
                    }
                    return nodeDatum;
                };
                this.dataRoot = createTreeNodeDatum(data);
                return [2 /*return*/];
            });
        });
    };
    TreemapSeries.prototype.createNodeData = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                return [2 /*return*/, []];
            });
        });
    };
    TreemapSeries.prototype.update = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            return __generator$1(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, this.updateSelections()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.updateNodes()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TreemapSeries.prototype.updateSelections = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a, chart, dataRoot, seriesRect, descendants, traverse, _b, groupSelection, highlightSelection, update;
            return __generator$1(this, function (_c) {
                if (!this.nodeDataRefresh) {
                    return [2 /*return*/];
                }
                this.nodeDataRefresh = false;
                (_a = this), (chart = _a.chart), (dataRoot = _a.dataRoot);
                if (!chart || !dataRoot) {
                    return [2 /*return*/];
                }
                seriesRect = chart.getSeriesRect();
                if (!seriesRect) {
                    return [2 /*return*/];
                }
                descendants = [];
                traverse = function (datum) {
                    var _a;
                    descendants.push(datum);
                    (_a = datum.children) === null || _a === void 0 ? void 0 : _a.forEach(traverse);
                };
                traverse(dataRoot);
                (_b = this), (groupSelection = _b.groupSelection), (highlightSelection = _b.highlightSelection);
                update = function (selection) {
                    return selection.update(descendants, function (group) {
                        var rect = new Rect();
                        var nameLabel = new Text();
                        nameLabel.tag = TextNodeTag.Name;
                        var valueLabel = new Text();
                        valueLabel.tag = TextNodeTag.Value;
                        group.append([rect, nameLabel, valueLabel]);
                    });
                };
                this.groupSelection = update(groupSelection);
                this.highlightSelection = update(highlightSelection);
                return [2 /*return*/];
            });
        });
    };
    TreemapSeries.prototype.isDatumHighlighted = function (datum) {
        var _a;
        var highlightedDatum =
            (_a = this.ctx.highlightManager) === null || _a === void 0 ? void 0 : _a.getActiveHighlight();
        return datum === highlightedDatum && (datum.isLeaf || this.highlightGroups);
    };
    TreemapSeries.prototype.getTileFormat = function (datum, isHighlighted) {
        var _a;
        var _b = this,
            formatter = _b.formatter,
            callbackCache = _b.ctx.callbackCache;
        if (!formatter) {
            return {};
        }
        var _c = this,
            gradient = _c.gradient,
            colorKey = _c.colorKey,
            labelKey = _c.labelKey,
            sizeKey = _c.sizeKey,
            tileStroke = _c.tileStroke,
            tileStrokeWidth = _c.tileStrokeWidth,
            groupStroke = _c.groupStroke,
            groupStrokeWidth = _c.groupStrokeWidth;
        var stroke = datum.isLeaf ? tileStroke : groupStroke;
        var strokeWidth = datum.isLeaf ? tileStrokeWidth : groupStrokeWidth;
        var result = callbackCache.call(formatter, {
            seriesId: this.id,
            datum: datum.datum,
            depth: datum.depth,
            parent: (_a = datum.parent) === null || _a === void 0 ? void 0 : _a.datum,
            colorKey: colorKey,
            sizeKey: sizeKey,
            labelKey: labelKey,
            fill: datum.fill,
            stroke: stroke,
            strokeWidth: strokeWidth,
            gradient: gradient,
            highlighted: isHighlighted,
        });
        return result !== null && result !== void 0 ? result : {};
    };
    TreemapSeries.prototype.updateNodes = function () {
        return __awaiter$1(this, void 0, void 0, function () {
            var _a,
                gradient,
                _b,
                _c,
                highlightedFill,
                highlightedFillOpacity,
                highlightedStroke,
                highlightedDatumStrokeWidth,
                highlightedTextColor,
                tileStroke,
                tileStrokeWidth,
                groupStroke,
                groupStrokeWidth,
                tileShadow,
                labelShadow,
                dataRoot,
                seriesRect,
                boxes,
                labelMeta,
                highlightedSubtree,
                updateRectFn,
                updateLabelFn;
            var _this = this;
            return __generator$1(this, function (_d) {
                if (!this.chart) return [2 /*return*/];
                (_a = this),
                    (gradient = _a.gradient),
                    (_b = _a.highlightStyle),
                    (_c = _b.item),
                    (highlightedFill = _c.fill),
                    (highlightedFillOpacity = _c.fillOpacity),
                    (highlightedStroke = _c.stroke),
                    (highlightedDatumStrokeWidth = _c.strokeWidth),
                    (highlightedTextColor = _b.text.color),
                    (tileStroke = _a.tileStroke),
                    (tileStrokeWidth = _a.tileStrokeWidth),
                    (groupStroke = _a.groupStroke),
                    (groupStrokeWidth = _a.groupStrokeWidth),
                    (tileShadow = _a.tileShadow),
                    (labelShadow = _a.labelShadow),
                    (dataRoot = _a.dataRoot);
                if (!dataRoot) return [2 /*return*/];
                seriesRect = this.chart.getSeriesRect();
                boxes = this.squarify(dataRoot, new BBox(0, 0, seriesRect.width, seriesRect.height));
                labelMeta = this.buildLabelMeta(boxes);
                highlightedSubtree = this.getHighlightedSubtree(dataRoot);
                this.updateNodeMidPoint(boxes);
                updateRectFn = function (rect, datum, isDatumHighlighted) {
                    var _a, _b, _c, _d, _e, _f;
                    var box = boxes.get(datum);
                    if (!box) {
                        rect.visible = false;
                        return;
                    }
                    var fill = isDatumHighlighted && highlightedFill !== undefined ? highlightedFill : datum.fill;
                    var fillOpacity =
                        (_a = isDatumHighlighted ? highlightedFillOpacity : 1) !== null && _a !== void 0 ? _a : 1;
                    var stroke = groupStroke;
                    if (isDatumHighlighted && highlightedStroke !== undefined) {
                        stroke = highlightedStroke;
                    } else if (datum.isLeaf) {
                        stroke = tileStroke;
                    }
                    var strokeWidth = groupStrokeWidth;
                    if (isDatumHighlighted && highlightedDatumStrokeWidth !== undefined) {
                        strokeWidth = highlightedDatumStrokeWidth;
                    } else if (datum.isLeaf) {
                        strokeWidth = tileStrokeWidth;
                    }
                    var format = _this.getTileFormat(datum, isDatumHighlighted);
                    var fillColor = validateColor(
                        (_b = format === null || format === void 0 ? void 0 : format.fill) !== null && _b !== void 0
                            ? _b
                            : fill,
                    );
                    if (
                        (_c = format === null || format === void 0 ? void 0 : format.gradient) !== null && _c !== void 0
                            ? _c
                            : gradient
                    ) {
                        var start = Color.tryParseFromString(fill).brighter().toString();
                        var end = Color.tryParseFromString(fill).darker().toString();
                        rect.fill = 'linear-gradient(180deg, ' + start + ', ' + end + ')';
                    } else {
                        rect.fill = fillColor;
                    }
                    rect.fillOpacity =
                        (_d = format === null || format === void 0 ? void 0 : format.fillOpacity) !== null &&
                        _d !== void 0
                            ? _d
                            : fillOpacity;
                    rect.stroke = validateColor(
                        (_e = format === null || format === void 0 ? void 0 : format.stroke) !== null && _e !== void 0
                            ? _e
                            : stroke,
                    );
                    rect.strokeWidth =
                        (_f = format === null || format === void 0 ? void 0 : format.strokeWidth) !== null &&
                        _f !== void 0
                            ? _f
                            : strokeWidth;
                    rect.fillShadow = tileShadow;
                    rect.crisp = true;
                    rect.x = box.x;
                    rect.y = box.y;
                    rect.width = box.width;
                    rect.height = box.height;
                    rect.visible = true;
                };
                this.groupSelection.selectByClass(Rect).forEach(function (rect) {
                    return updateRectFn(rect, rect.datum, false);
                });
                this.highlightSelection.selectByClass(Rect).forEach(function (rect) {
                    var isDatumHighlighted = _this.isDatumHighlighted(rect.datum);
                    rect.visible = isDatumHighlighted || highlightedSubtree.has(rect.datum);
                    if (rect.visible) {
                        updateRectFn(rect, rect.datum, isDatumHighlighted);
                    }
                });
                updateLabelFn = function (text, datum, highlighted, key) {
                    var meta = labelMeta.get(datum);
                    var label = meta === null || meta === void 0 ? void 0 : meta[key];
                    if (!label) {
                        text.visible = false;
                        return;
                    }
                    text.text = label.text;
                    text.fontFamily = label.style.fontFamily;
                    text.fontSize = label.style.fontSize;
                    text.fontWeight = label.style.fontWeight;
                    text.fill = highlighted
                        ? highlightedTextColor !== null && highlightedTextColor !== void 0
                            ? highlightedTextColor
                            : label.style.color
                        : label.style.color;
                    text.fillShadow = highlighted ? undefined : labelShadow;
                    text.textAlign = label.hAlign;
                    text.textBaseline = label.vAlign;
                    text.x = label.x;
                    text.y = label.y;
                    text.visible = true;
                };
                this.groupSelection.selectByTag(TextNodeTag.Name).forEach(function (text) {
                    return updateLabelFn(text, text.datum, false, 'label');
                });
                this.highlightSelection.selectByTag(TextNodeTag.Name).forEach(function (text) {
                    var isDatumHighlighted = _this.isDatumHighlighted(text.datum);
                    text.visible = isDatumHighlighted || highlightedSubtree.has(text.datum);
                    if (text.visible) {
                        updateLabelFn(text, text.datum, isDatumHighlighted, 'label');
                    }
                });
                this.groupSelection.selectByTag(TextNodeTag.Value).forEach(function (text) {
                    return updateLabelFn(text, text.datum, false, 'value');
                });
                this.highlightSelection.selectByTag(TextNodeTag.Value).forEach(function (text) {
                    var isDatumHighlighted = _this.isDatumHighlighted(text.datum);
                    text.visible = isDatumHighlighted || highlightedSubtree.has(text.datum);
                    if (text.visible) {
                        updateLabelFn(text, text.datum, isDatumHighlighted, 'value');
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    TreemapSeries.prototype.updateNodeMidPoint = function (boxes) {
        boxes.forEach(function (box, treeNodeDatum) {
            treeNodeDatum.nodeMidPoint = {
                x: box.x + box.width / 2,
                y: box.y,
            };
        });
    };
    TreemapSeries.prototype.getHighlightedSubtree = function (dataRoot) {
        var _this = this;
        var items = new Set();
        var traverse = function (datum) {
            var _a;
            if (_this.isDatumHighlighted(datum) || (datum.parent && items.has(datum.parent))) {
                items.add(datum);
            }
            (_a = datum.children) === null || _a === void 0 ? void 0 : _a.forEach(traverse);
        };
        traverse(dataRoot);
        return items;
    };
    TreemapSeries.prototype.buildLabelMeta = function (boxes) {
        var _a = this,
            labels = _a.labels,
            title = _a.title,
            subtitle = _a.subtitle,
            nodePadding = _a.nodePadding,
            labelKey = _a.labelKey,
            callbackCache = _a.ctx.callbackCache;
        var wrappedRegExp = /-$/m;
        var labelMeta = new Map();
        boxes.forEach(function (box, datum) {
            var _a, _b, _c;
            if (!labelKey || datum.depth === 0) {
                return;
            }
            var availTextWidth = box.width - 2 * nodePadding;
            var availTextHeight = box.height - 2 * nodePadding;
            var isBoxTooSmall = function (labelStyle) {
                var minSizeRatio = 3;
                return (
                    labelStyle.fontSize > box.width / minSizeRatio || labelStyle.fontSize > box.height / minSizeRatio
                );
            };
            var labelText = datum.isLeaf ? datum.label : datum.label.toUpperCase();
            var valueText = '';
            var valueConfig = labels.value;
            var valueStyle = valueConfig.style;
            var valueMargin = Math.ceil(valueStyle.fontSize * 2 * (Text.defaultLineHeightRatio - 1));
            if (datum.isLeaf) {
                if (valueConfig.formatter) {
                    valueText =
                        (_a = callbackCache.call(valueConfig.formatter, { datum: datum.datum })) !== null &&
                        _a !== void 0
                            ? _a
                            : '';
                } else if (valueConfig.key) {
                    valueText = datum.datum[valueConfig.key];
                }
            }
            var valueSize = getTextSize(valueText, valueStyle);
            if (valueText && valueSize.width > availTextWidth) {
                valueText = '';
            }
            var labelStyle;
            var wrappedText = '';
            if (datum.isLeaf) {
                var pickStyle = function () {
                    var e_1, _a;
                    var availHeight = availTextHeight - (valueText ? valueStyle.fontSize + valueMargin : 0);
                    var labelStyles = [labels.large, labels.medium, labels.small];
                    try {
                        for (
                            var labelStyles_1 = __values$f(labelStyles), labelStyles_1_1 = labelStyles_1.next();
                            !labelStyles_1_1.done;
                            labelStyles_1_1 = labelStyles_1.next()
                        ) {
                            var style = labelStyles_1_1.value;
                            var _b = getTextSize(labelText, style),
                                width = _b.width,
                                height = _b.height;
                            if (height > availHeight || isBoxTooSmall(style)) {
                                continue;
                            }
                            if (width <= availTextWidth) {
                                return { style: style, wrappedText: undefined };
                            }
                            // Avoid hyphens and ellipsis for large and medium label styles
                            var wrapped = Text.wrap(labelText, availTextWidth, availHeight, style, style.wrapping);
                            if (
                                wrapped &&
                                wrapped !== '\u2026' &&
                                (style === labels.small || !(wrappedRegExp.exec(wrapped) || wrapped.endsWith('\u2026')))
                            ) {
                                return { style: style, wrappedText: wrapped };
                            }
                        }
                    } catch (e_1_1) {
                        e_1 = { error: e_1_1 };
                    } finally {
                        try {
                            if (labelStyles_1_1 && !labelStyles_1_1.done && (_a = labelStyles_1.return))
                                _a.call(labelStyles_1);
                        } finally {
                            if (e_1) throw e_1.error;
                        }
                    }
                    // Check if small font fits by height
                    var smallSize = getTextSize(labelText, labels.small);
                    if (smallSize.height <= availHeight && !isBoxTooSmall(labels.small)) {
                        return { style: labels.small, wrappedText: undefined };
                    }
                    return { style: undefined, wrappedText: undefined };
                };
                var result = pickStyle();
                if (!result.style && valueText) {
                    valueText = '';
                    result = pickStyle();
                }
                labelStyle = (_b = result.style) !== null && _b !== void 0 ? _b : labels.small;
                wrappedText = (_c = result.wrappedText) !== null && _c !== void 0 ? _c : '';
            } else if (datum.depth === 1) {
                labelStyle = title;
            } else {
                labelStyle = subtitle;
            }
            var labelSize = getTextSize(wrappedText || labelText, labelStyle);
            if (isBoxTooSmall(labelStyle)) {
                // Avoid labels on too small tiles
                return;
            }
            // Crop text if not enough space
            if (labelSize.width > availTextWidth) {
                var textLength = Math.floor((labelText.length * availTextWidth) / labelSize.width) - 1;
                labelText = labelText.substring(0, textLength).trim() + '\u2026';
            }
            valueSize = getTextSize(valueText, valueStyle);
            var hasValueText =
                valueText &&
                valueSize.width < availTextWidth &&
                valueSize.height + labelSize.height + valueMargin < availTextHeight;
            labelMeta.set(datum, {
                label: __assign$y(
                    { text: wrappedText || labelText, style: labelStyle },
                    datum.isLeaf
                        ? {
                              hAlign: 'center',
                              vAlign: 'middle',
                              x: box.x + box.width / 2,
                              y: box.y + box.height / 2 - (hasValueText ? valueSize.height / 2 + valueMargin / 2 : 0),
                          }
                        : {
                              hAlign: 'left',
                              vAlign: 'top',
                              x: box.x + nodePadding,
                              y: box.y + nodePadding,
                          },
                ),
                value: hasValueText
                    ? {
                          text: valueText,
                          style: valueStyle,
                          hAlign: 'center',
                          vAlign: 'middle',
                          x: box.x + box.width / 2,
                          y: box.y + box.height / 2 + labelSize.height / 2 + valueMargin / 2,
                      }
                    : undefined,
            });
        });
        return labelMeta;
    };
    TreemapSeries.prototype.getDomain = function (_direction) {
        return [0, 1];
    };
    TreemapSeries.prototype.getNodeClickEvent = function (event, datum) {
        return new TreemapSeriesNodeClickEvent(this.labelKey, this.sizeKey, this.colorKey, event, datum, this);
    };
    TreemapSeries.prototype.getNodeDoubleClickEvent = function (event, datum) {
        return new TreemapSeriesNodeDoubleClickEvent(this.labelKey, this.sizeKey, this.colorKey, event, datum, this);
    };
    TreemapSeries.prototype.getTooltipHtml = function (nodeDatum) {
        var _a, _b, _c, _d;
        if (!this.highlightGroups && !nodeDatum.isLeaf) {
            return '';
        }
        var _e = this,
            tooltip = _e.tooltip,
            sizeKey = _e.sizeKey,
            labelKey = _e.labelKey,
            colorKey = _e.colorKey,
            rootName = _e.rootName,
            seriesId = _e.id,
            labels = _e.labels,
            callbackCache = _e.ctx.callbackCache;
        var datum = nodeDatum.datum;
        var tooltipRenderer = tooltip.renderer;
        var title = nodeDatum.depth
            ? datum[labelKey]
            : (_a = datum[labelKey]) !== null && _a !== void 0
            ? _a
            : rootName;
        var content = '';
        var format = this.getTileFormat(nodeDatum, false);
        var color =
            (_c =
                (_b = format === null || format === void 0 ? void 0 : format.fill) !== null && _b !== void 0
                    ? _b
                    : nodeDatum.fill) !== null && _c !== void 0
                ? _c
                : 'gray';
        var valueKey = labels.value.key;
        var valueFormatter = labels.value.formatter;
        if (valueKey || valueFormatter) {
            var valueText = '';
            if (valueFormatter) {
                valueText = callbackCache.call(valueFormatter, { datum: datum });
            } else if (valueKey != null) {
                var value = datum[valueKey];
                if (typeof value === 'number' && isFinite(value)) {
                    valueText = toFixed(value);
                }
            }
            if (valueText) {
                if (labels.value.name) {
                    content += '<b>' + labels.value.name + ':</b> ';
                }
                content += valueText;
            }
        }
        var defaults = {
            title: title,
            backgroundColor: color,
            content: content,
        };
        if (tooltipRenderer) {
            return toTooltipHtml$1(
                tooltipRenderer({
                    datum: nodeDatum.datum,
                    parent: (_d = nodeDatum.parent) === null || _d === void 0 ? void 0 : _d.datum,
                    depth: nodeDatum.depth,
                    sizeKey: sizeKey,
                    labelKey: labelKey,
                    colorKey: colorKey,
                    title: title,
                    color: color,
                    seriesId: seriesId,
                }),
                defaults,
            );
        }
        if (!title && !content) {
            return '';
        }
        return toTooltipHtml$1(defaults);
    };
    TreemapSeries.prototype.getLegendData = function () {
        // Override point for subclasses.
        return [];
    };
    TreemapSeries.className = 'TreemapSeries';
    TreemapSeries.type = 'treemap';
    __decorate$1i([Validate(NUMBER(0))], TreemapSeries.prototype, 'nodePadding', void 0);
    __decorate$1i([Validate(NUMBER(0))], TreemapSeries.prototype, 'nodeGap', void 0);
    __decorate$1i([Validate(STRING)], TreemapSeries.prototype, 'labelKey', void 0);
    __decorate$1i([Validate(OPT_STRING)], TreemapSeries.prototype, 'sizeKey', void 0);
    __decorate$1i([Validate(OPT_STRING)], TreemapSeries.prototype, 'colorKey', void 0);
    __decorate$1i([Validate(NUMBER_ARRAY)], TreemapSeries.prototype, 'colorDomain', void 0);
    __decorate$1i([Validate(COLOR_STRING_ARRAY)], TreemapSeries.prototype, 'colorRange', void 0);
    __decorate$1i([Validate(OPT_STRING)], TreemapSeries.prototype, 'groupFill', void 0);
    __decorate$1i([Validate(OPT_COLOR_STRING)], TreemapSeries.prototype, 'groupStroke', void 0);
    __decorate$1i([Validate(OPT_NUMBER(0))], TreemapSeries.prototype, 'groupStrokeWidth', void 0);
    __decorate$1i([Validate(OPT_COLOR_STRING)], TreemapSeries.prototype, 'tileStroke', void 0);
    __decorate$1i([Validate(OPT_NUMBER(0))], TreemapSeries.prototype, 'tileStrokeWidth', void 0);
    __decorate$1i([Validate(BOOLEAN)], TreemapSeries.prototype, 'gradient', void 0);
    __decorate$1i([Validate(OPT_FUNCTION)], TreemapSeries.prototype, 'formatter', void 0);
    __decorate$1i([Validate(STRING)], TreemapSeries.prototype, 'colorName', void 0);
    __decorate$1i([Validate(STRING)], TreemapSeries.prototype, 'rootName', void 0);
    __decorate$1i([Validate(OPT_BOOLEAN)], TreemapSeries.prototype, 'highlightGroups', void 0);
    return TreemapSeries;
})(HierarchySeries);

var TYPES = {
    area: 'cartesian',
    bar: 'cartesian',
    column: 'cartesian',
    histogram: 'cartesian',
    line: 'cartesian',
    scatter: 'cartesian',
    treemap: 'hierarchy',
    pie: 'polar',
};
var DEFAULTS = {};
var CHART_TYPES = {
    has: function (seriesType) {
        return Object.prototype.hasOwnProperty.call(TYPES, seriesType);
    },
    isCartesian: function (seriesType) {
        return TYPES[seriesType] === 'cartesian';
    },
    isPolar: function (seriesType) {
        return TYPES[seriesType] === 'polar';
    },
    isHierarchy: function (seriesType) {
        return TYPES[seriesType] === 'hierarchy';
    },
    get seriesTypes() {
        return Object.keys(TYPES);
    },
    get cartesianTypes() {
        var _this = this;
        return this.seriesTypes.filter(function (t) {
            return _this.isCartesian(t);
        });
    },
    get polarTypes() {
        var _this = this;
        return this.seriesTypes.filter(function (t) {
            return _this.isPolar(t);
        });
    },
    get hierarchyTypes() {
        var _this = this;
        return this.seriesTypes.filter(function (t) {
            return _this.isHierarchy(t);
        });
    },
};
function registerChartSeriesType(seriesType, chartType) {
    TYPES[seriesType] = chartType;
}
function registerChartDefaults(chartType, defaults) {
    var _a;
    DEFAULTS[chartType] = jsonMerge([(_a = DEFAULTS[chartType]) !== null && _a !== void 0 ? _a : {}, defaults]);
}
function getChartDefaults(chartType) {
    var _a;
    return (_a = DEFAULTS[chartType]) !== null && _a !== void 0 ? _a : {};
}

var BUILT_IN_SERIES_FACTORIES = {
    area: AreaSeries,
    bar: BarSeries,
    column: ColumnSeries,
    histogram: HistogramSeries,
    line: LineSeries,
    pie: PieSeries,
    scatter: ScatterSeries,
    treemap: TreemapSeries,
};
var SERIES_FACTORIES = {};
var SERIES_DEFAULTS = {};
var SERIES_THEME_TEMPLATES = {};
var SERIES_PALETTE_FACTORIES = {};
function registerSeries(seriesType, chartType, cstr, defaults, theme, paletteFactory) {
    SERIES_FACTORIES[seriesType] = cstr;
    SERIES_DEFAULTS[seriesType] = defaults;
    SERIES_THEME_TEMPLATES[seriesType] = theme;
    if (paletteFactory) {
        addSeriesPaletteFactory(seriesType, paletteFactory);
    }
    registerChartSeriesType(seriesType, chartType);
}
function getSeries(chartType, moduleCtx) {
    var _a;
    var seriesConstructor =
        (_a = SERIES_FACTORIES[chartType]) !== null && _a !== void 0 ? _a : BUILT_IN_SERIES_FACTORIES[chartType];
    if (seriesConstructor) {
        return new seriesConstructor(moduleCtx);
    }
    throw new Error('AG Charts - unknown series type: ' + chartType);
}
function getSeriesDefaults(chartType) {
    return SERIES_DEFAULTS[chartType];
}
function getSeriesThemeTemplate(chartType) {
    return SERIES_THEME_TEMPLATES[chartType];
}
function addSeriesPaletteFactory(seriesType, factory) {
    SERIES_PALETTE_FACTORIES[seriesType] = factory;
}
function getSeriesPaletteFactory(seriesType) {
    return SERIES_PALETTE_FACTORIES[seriesType];
}

var DEFAULT_CARTESIAN_CHART_OVERRIDES = {
    axes: [
        {
            type: NumberAxis.type,
            position: 'left',
        },
        {
            type: CategoryAxis.type,
            position: 'bottom',
        },
    ],
};
var DEFAULT_BAR_CHART_OVERRIDES = {
    axes: [
        {
            type: 'number',
            position: 'bottom',
        },
        {
            type: 'category',
            position: 'left',
        },
    ],
};
var DEFAULT_SCATTER_HISTOGRAM_CHART_OVERRIDES = {
    axes: [
        {
            type: 'number',
            position: 'bottom',
        },
        {
            type: 'number',
            position: 'left',
        },
    ],
};

function deepMerge$1(target, source) {
    if (isPlainObject(target) && isPlainObject(source)) {
        var result_1 = {};
        Object.keys(target).forEach(function (key) {
            if (key in source) {
                result_1[key] = deepMerge$1(target[key], source[key]);
            } else {
                result_1[key] = target[key];
            }
        });
        Object.keys(source).forEach(function (key) {
            if (!(key in target)) {
                result_1[key] = source[key];
            }
        });
        return result_1;
    }
    if ((Array.isArray(target) && !Array.isArray(source)) || (isObject(target) && !isObject(source))) {
        return target;
    }
    return source;
}
function isObject(value) {
    return value && typeof value === 'object';
}
function isPlainObject(x) {
    return isObject(x) && x.constructor === Object;
}

var __assign$x =
    (undefined && undefined.__assign) ||
    function () {
        __assign$x =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$x.apply(this, arguments);
    };
var __read$t =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __values$e =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var palette$8 = {
    fills: ['#f3622d', '#fba71b', '#57b757', '#41a9c9', '#4258c9', '#9a42c8', '#c84164', '#888888'],
    strokes: ['#aa4520', '#b07513', '#3d803d', '#2d768d', '#2e3e8d', '#6c2e8c', '#8c2d46', '#5f5f5f'],
};
var EXTENDS_AXES_DEFAULTS = Symbol('extends-axes-defaults');
var EXTENDS_AXES_LABEL_DEFAULTS = Symbol('extends-axes-label-defaults');
var EXTENDS_AXES_LINE_DEFAULTS = Symbol('extends-axes-line-defaults');
var EXTENDS_SERIES_DEFAULTS = Symbol('extends-series-defaults');
var OVERRIDE_SERIES_LABEL_DEFAULTS = Symbol('override-series-label-defaults');
var DEFAULT_FONT_FAMILY = Symbol('default-font');
var BOLD = 'bold';
var INSIDE = 'inside';
var BOTTOM = 'bottom';
var ChartTheme = /** @class */ (function () {
    function ChartTheme(options) {
        options = deepMerge$1({}, options !== null && options !== void 0 ? options : {});
        var _a = options.overrides,
            overrides = _a === void 0 ? null : _a,
            _b = options.palette,
            palette = _b === void 0 ? null : _b;
        var defaults = this.createChartConfigPerChartType(this.getDefaults());
        if (overrides) {
            var common = overrides.common,
                cartesian = overrides.cartesian,
                polar = overrides.polar,
                hierarchy = overrides.hierarchy;
            var applyOverrides = function (type, seriesTypes, overrideOpts) {
                if (overrideOpts) {
                    defaults[type] = deepMerge$1(defaults[type], overrideOpts);
                    seriesTypes.forEach(function (s) {
                        var seriesType = s;
                        defaults[seriesType] = deepMerge$1(defaults[seriesType], overrideOpts);
                    });
                }
            };
            applyOverrides('common', Object.keys(defaults), common);
            applyOverrides('cartesian', CHART_TYPES.cartesianTypes, cartesian);
            applyOverrides('polar', CHART_TYPES.polarTypes, polar);
            applyOverrides('hierarchy', CHART_TYPES.hierarchyTypes, hierarchy);
            CHART_TYPES.seriesTypes.forEach(function (s) {
                var _a;
                var seriesType = s;
                var chartConfig = overrides[seriesType];
                if (chartConfig) {
                    if (chartConfig.series) {
                        chartConfig.series = ((_a = {}), (_a[seriesType] = chartConfig.series), _a);
                    }
                    defaults[seriesType] = deepMerge$1(defaults[seriesType], chartConfig);
                }
            });
        }
        this.palette = palette !== null && palette !== void 0 ? palette : this.getPalette();
        this.config = Object.freeze(defaults);
    }
    ChartTheme.prototype.getPalette = function () {
        return palette$8;
    };
    ChartTheme.getAxisDefaults = function () {
        return {
            top: {},
            right: {},
            bottom: {},
            left: {},
            title: {
                enabled: false,
                text: 'Axis Title',
                fontStyle: undefined,
                fontWeight: BOLD,
                fontSize: 12,
                fontFamily: this.fontFamily,
                color: 'rgb(70, 70, 70)',
            },
            label: {
                fontStyle: undefined,
                fontWeight: undefined,
                fontSize: 12,
                fontFamily: this.fontFamily,
                padding: 5,
                rotation: undefined,
                color: 'rgb(87, 87, 87)',
                formatter: undefined,
                autoRotate: false,
                avoidCollisions: true,
            },
            line: {
                width: 1,
                color: 'rgb(195, 195, 195)',
            },
            tick: {
                width: 1,
                size: 6,
                color: 'rgb(195, 195, 195)',
            },
            gridStyle: [
                {
                    stroke: 'rgb(219, 219, 219)',
                    lineDash: [4, 2],
                },
            ],
            crossLines: {
                enabled: false,
                fill: 'rgb(187,221,232)',
                stroke: 'rgb(70,162,192)',
                strokeWidth: 1,
                label: {
                    enabled: false,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: this.fontFamily,
                    padding: 5,
                    color: 'rgb(87, 87, 87)',
                    rotation: undefined,
                },
            },
        };
    };
    ChartTheme.getSeriesDefaults = function () {
        return {
            tooltip: {
                enabled: true,
                renderer: undefined,
            },
            visible: true,
            showInLegend: true,
            highlightStyle: {
                item: {
                    fill: 'yellow',
                    fillOpacity: 1,
                },
                series: {
                    dimOpacity: 1,
                },
                text: {
                    color: 'black',
                },
            },
            nodeClickRange: 'exact',
        };
    };
    ChartTheme.getBarSeriesDefaults = function () {
        return __assign$x(__assign$x({}, this.getSeriesDefaults()), {
            fillOpacity: 1,
            strokeOpacity: 1,
            normalizedTo: undefined,
            strokeWidth: 1,
            lineDash: [0],
            lineDashOffset: 0,
            label: {
                enabled: false,
                fontStyle: undefined,
                fontWeight: undefined,
                fontSize: 12,
                fontFamily: this.fontFamily,
                color: 'rgb(70, 70, 70)',
                formatter: undefined,
                placement: INSIDE,
            },
            shadow: {
                enabled: false,
                color: 'rgba(0, 0, 0, 0.5)',
                xOffset: 3,
                yOffset: 3,
                blur: 5,
            },
        });
    };
    ChartTheme.getLineSeriesDefaults = function () {
        var seriesDefaults = this.getSeriesDefaults();
        return __assign$x(__assign$x({}, seriesDefaults), {
            tooltip: __assign$x(__assign$x({}, seriesDefaults.tooltip), {
                format: undefined,
                position: {
                    type: 'node',
                },
            }),
        });
    };
    ChartTheme.getAreaSeriesDefaults = function () {
        var seriesDefaults = this.getSeriesDefaults();
        return __assign$x(__assign$x({}, seriesDefaults), {
            nodeClickRange: 'nearest',
            tooltip: __assign$x(__assign$x({}, seriesDefaults.tooltip), {
                position: {
                    type: 'node',
                },
            }),
        });
    };
    ChartTheme.getScatterSeriesDefaults = function () {
        var seriesDefaults = this.getSeriesDefaults();
        return __assign$x(__assign$x({}, seriesDefaults), {
            tooltip: __assign$x(__assign$x({}, seriesDefaults.tooltip), {
                position: {
                    type: 'node',
                },
            }),
        });
    };
    ChartTheme.getCartesianSeriesMarkerDefaults = function () {
        return {
            enabled: true,
            shape: 'circle',
            size: 6,
            maxSize: 30,
            strokeWidth: 1,
            formatter: undefined,
        };
    };
    ChartTheme.getCaptionWrappingDefaults = function () {
        return 'hyphenate';
    };
    ChartTheme.getChartDefaults = function () {
        return {
            background: {
                visible: true,
                fill: 'white',
            },
            padding: {
                top: 20,
                right: 20,
                bottom: 20,
                left: 20,
            },
            title: {
                enabled: false,
                text: 'Title',
                fontStyle: undefined,
                fontWeight: BOLD,
                fontSize: 16,
                fontFamily: this.fontFamily,
                color: 'rgb(70, 70, 70)',
                wrapping: ChartTheme.getCaptionWrappingDefaults(),
            },
            subtitle: {
                enabled: false,
                text: 'Subtitle',
                fontStyle: undefined,
                fontWeight: undefined,
                fontSize: 12,
                fontFamily: this.fontFamily,
                color: 'rgb(140, 140, 140)',
                wrapping: ChartTheme.getCaptionWrappingDefaults(),
            },
            footnote: {
                enabled: false,
                text: 'Footnote',
                fontStyle: undefined,
                fontWeight: undefined,
                fontSize: 12,
                fontFamily: this.fontFamily,
                color: 'rgb(140, 140, 140)',
                spacing: 30,
                wrapping: ChartTheme.getCaptionWrappingDefaults(),
            },
            legend: {
                position: BOTTOM,
                spacing: 20,
                listeners: {},
                item: {
                    paddingX: 16,
                    paddingY: 8,
                    marker: {
                        shape: undefined,
                        size: 15,
                        strokeWidth: 1,
                        padding: 8,
                    },
                    label: {
                        color: 'black',
                        fontStyle: undefined,
                        fontWeight: undefined,
                        fontSize: 12,
                        fontFamily: this.fontFamily,
                        formatter: undefined,
                    },
                },
                reverseOrder: false,
                pagination: {
                    marker: {
                        size: 12,
                    },
                    activeStyle: {
                        fill: 'rgb(70, 70, 70)',
                    },
                    inactiveStyle: {
                        fill: 'rgb(219, 219, 219)',
                    },
                    highlightStyle: {
                        fill: 'rgb(70, 70, 70)',
                    },
                    label: {
                        color: 'rgb(70, 70, 70)',
                    },
                },
            },
            tooltip: {
                enabled: true,
                range: 'nearest',
                delay: 0,
            },
            listeners: {},
        };
    };
    ChartTheme.prototype.createChartConfigPerChartType = function (config) {
        var _this = this;
        var typeToAliases = {
            cartesian: CHART_TYPES.cartesianTypes,
            polar: CHART_TYPES.polarTypes,
            hierarchy: CHART_TYPES.hierarchyTypes,
            groupedCategory: [],
        };
        Object.entries(typeToAliases).forEach(function (_a) {
            var _b = __read$t(_a, 2),
                nextType = _b[0],
                aliases = _b[1];
            var type = nextType;
            var typeDefaults = _this.templateTheme(getChartDefaults(type));
            aliases.forEach(function (next) {
                var alias = next;
                if (!config[alias]) {
                    config[alias] = deepMerge$1({}, config[type]);
                    deepMerge$1(config[alias], typeDefaults);
                }
            });
        });
        return config;
    };
    ChartTheme.prototype.getDefaults = function () {
        var _this = this;
        var defaults = deepMerge$1({}, ChartTheme.defaults);
        var getOverridesByType = function (chartType, seriesTypes) {
            var result = _this.templateTheme(getChartDefaults(chartType));
            result.series = seriesTypes.reduce(function (obj, seriesType) {
                var template = getSeriesThemeTemplate(seriesType);
                if (template) {
                    obj[seriesType] = _this.templateTheme(template);
                }
                return obj;
            }, {});
            if (chartType === 'cartesian' || chartType === 'polar') {
                result.axes = AXIS_TYPES.axesTypes.reduce(function (obj, axisType) {
                    var template = getAxisThemeTemplate(axisType);
                    if (template) {
                        obj[axisType] = _this.templateTheme(template);
                    }
                    return obj;
                }, {});
            }
            return result;
        };
        var extension = {
            cartesian: getOverridesByType('cartesian', CHART_TYPES.cartesianTypes),
            groupedCategory: getOverridesByType('cartesian', CHART_TYPES.cartesianTypes),
            polar: getOverridesByType('polar', CHART_TYPES.polarTypes),
            hierarchy: getOverridesByType('hierarchy', CHART_TYPES.hierarchyTypes),
        };
        return deepMerge$1(defaults, extension);
    };
    ChartTheme.prototype.templateTheme = function (themeTemplate) {
        var themeInstance = jsonMerge([themeTemplate]);
        var _a = this.getTemplateParameters(),
            extensions = _a.extensions,
            properties = _a.properties;
        jsonWalk(
            themeInstance,
            function (_, node) {
                var e_1, _a;
                if (node['__extends__']) {
                    var key = node['__extends__'];
                    var source_1 = extensions.get(key);
                    if (source_1 == null) {
                        throw new Error('AG Charts - no template variable provided for: ' + key);
                    }
                    Object.keys(source_1).forEach(function (key) {
                        if (!(key in node)) {
                            node[key] = source_1[key];
                        }
                    });
                    delete node['__extends__'];
                }
                if (node['__overrides__']) {
                    var key = node['__overrides__'];
                    var source = extensions.get(key);
                    if (source == null) {
                        throw new Error('AG Charts - no template variable provided for: ' + key);
                    }
                    Object.assign(node, source);
                    delete node['__overrides__'];
                }
                try {
                    for (var _b = __values$e(Object.entries(node)), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var _d = __read$t(_c.value, 2),
                            name_1 = _d[0],
                            value = _d[1];
                        if (properties.has(value)) {
                            node[name_1] = properties.get(value);
                        }
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
            },
            {},
        );
        return themeInstance;
    };
    ChartTheme.prototype.getTemplateParameters = function () {
        var extensions = new Map();
        extensions.set(EXTENDS_AXES_DEFAULTS, ChartTheme.getAxisDefaults());
        extensions.set(EXTENDS_AXES_LABEL_DEFAULTS, ChartTheme.getAxisDefaults().label);
        extensions.set(EXTENDS_AXES_LINE_DEFAULTS, ChartTheme.getAxisDefaults().line);
        extensions.set(EXTENDS_SERIES_DEFAULTS, ChartTheme.getSeriesDefaults());
        extensions.set(OVERRIDE_SERIES_LABEL_DEFAULTS, {});
        var properties = new Map();
        properties.set(DEFAULT_FONT_FAMILY, ChartTheme.fontFamily);
        return {
            extensions: extensions,
            properties: properties,
        };
    };
    ChartTheme.prototype.mergeWithParentDefaults = function (parentDefaults, defaults) {
        return deepMerge$1(parentDefaults, defaults);
    };
    ChartTheme.fontFamily = 'Verdana, sans-serif';
    ChartTheme.cartesianDefaults = __assign$x(__assign$x({}, ChartTheme.getChartDefaults()), {
        axes: {
            number: __assign$x({}, ChartTheme.getAxisDefaults()),
            log: __assign$x(__assign$x({}, ChartTheme.getAxisDefaults()), { base: 10 }),
            category: __assign$x(__assign$x({}, ChartTheme.getAxisDefaults()), {
                groupPaddingInner: 0.1,
                label: __assign$x(__assign$x({}, ChartTheme.getAxisDefaults().label), { autoRotate: true }),
            }),
            groupedCategory: __assign$x({}, ChartTheme.getAxisDefaults()),
            time: __assign$x({}, ChartTheme.getAxisDefaults()),
        },
        series: {
            column: __assign$x({}, ChartTheme.getBarSeriesDefaults()),
            bar: __assign$x({}, ChartTheme.getBarSeriesDefaults()),
            line: __assign$x(__assign$x({}, ChartTheme.getLineSeriesDefaults()), {
                title: undefined,
                strokeWidth: 2,
                strokeOpacity: 1,
                lineDash: [0],
                lineDashOffset: 0,
                marker: __assign$x(__assign$x({}, ChartTheme.getCartesianSeriesMarkerDefaults()), {
                    fillOpacity: 1,
                    strokeOpacity: 1,
                }),
                label: {
                    enabled: false,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    formatter: undefined,
                },
            }),
            scatter: __assign$x(__assign$x({}, ChartTheme.getScatterSeriesDefaults()), {
                sizeName: 'Size',
                labelName: 'Label',
                marker: __assign$x({}, ChartTheme.getCartesianSeriesMarkerDefaults()),
                label: {
                    enabled: false,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                },
            }),
            area: __assign$x(__assign$x({}, ChartTheme.getAreaSeriesDefaults()), {
                normalizedTo: undefined,
                fillOpacity: 0.8,
                strokeOpacity: 1,
                strokeWidth: 2,
                lineDash: [0],
                lineDashOffset: 0,
                shadow: {
                    enabled: false,
                    color: 'rgba(0, 0, 0, 0.5)',
                    xOffset: 3,
                    yOffset: 3,
                    blur: 5,
                },
                marker: __assign$x(__assign$x({}, ChartTheme.getCartesianSeriesMarkerDefaults()), {
                    fillOpacity: 1,
                    strokeOpacity: 1,
                    enabled: false,
                }),
                label: {
                    enabled: false,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    formatter: undefined,
                },
            }),
            histogram: __assign$x(__assign$x({}, ChartTheme.getSeriesDefaults()), {
                strokeWidth: 1,
                fillOpacity: 1,
                strokeOpacity: 1,
                lineDash: [0],
                lineDashOffset: 0,
                areaPlot: false,
                bins: undefined,
                aggregation: 'sum',
                label: {
                    enabled: false,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    formatter: undefined,
                },
                shadow: {
                    enabled: true,
                    color: 'rgba(0, 0, 0, 0.5)',
                    xOffset: 0,
                    yOffset: 0,
                    blur: 5,
                },
            }),
        },
    });
    ChartTheme.polarDefaults = __assign$x(__assign$x({}, ChartTheme.getChartDefaults()), {
        series: {
            pie: __assign$x(__assign$x({}, ChartTheme.getSeriesDefaults()), {
                title: {
                    enabled: true,
                    fontStyle: undefined,
                    fontWeight: 'bold',
                    fontSize: 14,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    spacing: 0,
                },
                radiusKey: undefined,
                radiusName: undefined,
                calloutLabelKey: undefined,
                calloutLabelName: undefined,
                sectorLabelKey: undefined,
                sectorLabelName: undefined,
                calloutLabel: {
                    enabled: true,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    offset: 3,
                    minAngle: 0,
                },
                sectorLabel: {
                    enabled: true,
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    positionOffset: 0,
                    positionRatio: 0.5,
                },
                calloutLine: {
                    length: 10,
                    strokeWidth: 2,
                },
                fillOpacity: 1,
                strokeOpacity: 1,
                strokeWidth: 1,
                lineDash: [0],
                lineDashOffset: 0,
                rotation: 0,
                outerRadiusOffset: 0,
                innerRadiusOffset: 0,
                shadow: {
                    enabled: false,
                    color: 'rgba(0, 0, 0, 0.5)',
                    xOffset: 3,
                    yOffset: 3,
                    blur: 5,
                },
                innerLabels: {
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 12,
                    fontFamily: ChartTheme.fontFamily,
                    color: 'rgb(70, 70, 70)',
                    margin: 2,
                },
            }),
        },
    });
    ChartTheme.hierarchyDefaults = __assign$x(__assign$x({}, ChartTheme.getChartDefaults()), {
        series: {
            treemap: __assign$x(__assign$x({}, ChartTheme.getSeriesDefaults()), {
                showInLegend: false,
                labelKey: 'label',
                sizeKey: 'size',
                colorKey: 'color',
                colorDomain: [-5, 5],
                colorRange: ['#cb4b3f', '#6acb64'],
                groupFill: '#272931',
                groupStroke: 'black',
                groupStrokeWidth: 1,
                tileStroke: 'black',
                tileStrokeWidth: 1,
                gradient: true,
                tileShadow: {
                    enabled: false,
                    color: 'rgba(0, 0, 0, 0.5)',
                    xOffset: 3,
                    yOffset: 3,
                    blur: 5,
                },
                labelShadow: {
                    enabled: true,
                    color: 'rgba(0, 0, 0, 0.4)',
                    xOffset: 1.5,
                    yOffset: 1.5,
                    blur: 5,
                },
                highlightGroups: true,
                nodePadding: 2,
                nodeGap: 0,
                title: {
                    enabled: true,
                    color: 'white',
                    fontStyle: undefined,
                    fontWeight: 'bold',
                    fontSize: 12,
                    fontFamily: 'Verdana, sans-serif',
                    padding: 2,
                },
                subtitle: {
                    enabled: true,
                    color: 'white',
                    fontStyle: undefined,
                    fontWeight: undefined,
                    fontSize: 9,
                    fontFamily: 'Verdana, sans-serif',
                    padding: 2,
                },
                labels: {
                    large: {
                        enabled: true,
                        fontStyle: undefined,
                        fontWeight: 'bold',
                        fontSize: 18,
                        fontFamily: 'Verdana, sans-serif',
                        color: 'white',
                        wrapping: 'on-space',
                    },
                    medium: {
                        enabled: true,
                        fontStyle: undefined,
                        fontWeight: 'bold',
                        fontSize: 14,
                        fontFamily: 'Verdana, sans-serif',
                        color: 'white',
                        wrapping: 'on-space',
                    },
                    small: {
                        enabled: true,
                        fontStyle: undefined,
                        fontWeight: 'bold',
                        fontSize: 10,
                        fontFamily: 'Verdana, sans-serif',
                        color: 'white',
                        wrapping: 'on-space',
                    },
                    value: {
                        style: {
                            enabled: true,
                            fontStyle: undefined,
                            fontWeight: undefined,
                            fontSize: 12,
                            fontFamily: 'Verdana, sans-serif',
                            color: 'white',
                        },
                    },
                },
            }),
        },
    });
    ChartTheme.defaults = {
        cartesian: ChartTheme.cartesianDefaults,
        groupedCategory: ChartTheme.cartesianDefaults,
        polar: ChartTheme.polarDefaults,
        hierarchy: ChartTheme.hierarchyDefaults,
    };
    return ChartTheme;
})();

var __extends$1X =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$w =
    (undefined && undefined.__assign) ||
    function () {
        __assign$w =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$w.apply(this, arguments);
    };
var DarkTheme = /** @class */ (function (_super) {
    __extends$1X(DarkTheme, _super);
    function DarkTheme(options) {
        return _super.call(this, options) || this;
    }
    DarkTheme.prototype.getDefaults = function () {
        var _this = this;
        var fontColor = DarkTheme.fontColor;
        var mutedFontColor = DarkTheme.mutedFontColor;
        var axisDefaults = {
            title: {
                color: fontColor,
            },
            label: {
                color: fontColor,
            },
            gridStyle: [
                {
                    stroke: 'rgb(88, 88, 88)',
                    lineDash: [4, 2],
                },
            ],
        };
        var seriesLabelDefaults = {
            label: {
                color: fontColor,
            },
        };
        var chartAxesDefaults = {
            axes: {
                number: __assign$w({}, axisDefaults),
                category: __assign$w({}, axisDefaults),
                time: __assign$w({}, axisDefaults),
            },
        };
        var chartDefaults = {
            background: {
                fill: 'rgb(34, 38, 41)',
            },
            title: {
                color: fontColor,
            },
            subtitle: {
                color: mutedFontColor,
            },
            legend: {
                item: {
                    label: {
                        color: fontColor,
                    },
                },
                pagination: {
                    activeStyle: {
                        fill: fontColor,
                    },
                    inactiveStyle: {
                        fill: mutedFontColor,
                    },
                    highlightStyle: {
                        fill: fontColor,
                    },
                    label: {
                        color: fontColor,
                    },
                },
            },
        };
        var getOverridesByType = function (seriesTypes) {
            return seriesTypes.reduce(function (obj, seriesType) {
                var template = getSeriesThemeTemplate(seriesType);
                if (template) {
                    obj[seriesType] = _this.templateTheme(template);
                }
                return obj;
            }, {});
        };
        return this.mergeWithParentDefaults(_super.prototype.getDefaults.call(this), {
            cartesian: __assign$w(__assign$w(__assign$w({}, chartDefaults), chartAxesDefaults), {
                series: __assign$w(
                    {
                        line: __assign$w({}, seriesLabelDefaults),
                        bar: __assign$w({}, seriesLabelDefaults),
                        column: __assign$w({}, seriesLabelDefaults),
                        histogram: __assign$w({}, seriesLabelDefaults),
                    },
                    getOverridesByType(CHART_TYPES.cartesianTypes),
                ),
            }),
            groupedCategory: __assign$w(__assign$w(__assign$w({}, chartDefaults), chartAxesDefaults), {
                series: __assign$w(
                    {
                        bar: __assign$w({}, seriesLabelDefaults),
                        column: __assign$w({}, seriesLabelDefaults),
                        histogram: __assign$w({}, seriesLabelDefaults),
                    },
                    getOverridesByType(CHART_TYPES.cartesianTypes),
                ),
            }),
            polar: __assign$w(__assign$w({}, chartDefaults), {
                series: __assign$w(
                    {
                        pie: {
                            calloutLabel: {
                                color: fontColor,
                            },
                            sectorLabel: {
                                color: fontColor,
                            },
                            title: {
                                color: fontColor,
                            },
                            innerLabels: {
                                color: fontColor,
                            },
                        },
                    },
                    getOverridesByType(CHART_TYPES.polarTypes),
                ),
            }),
            hierarchy: __assign$w(__assign$w({}, chartDefaults), {
                series: __assign$w(
                    {
                        treemap: {
                            tileStroke: 'white',
                            groupStroke: 'white',
                            title: {
                                color: fontColor,
                            },
                            subtitle: {
                                color: mutedFontColor,
                            },
                            labels: {
                                large: {
                                    color: fontColor,
                                },
                                medium: {
                                    color: fontColor,
                                },
                                small: {
                                    color: fontColor,
                                },
                                value: {
                                    style: {
                                        color: fontColor,
                                    },
                                },
                            },
                        },
                    },
                    getOverridesByType(CHART_TYPES.hierarchyTypes),
                ),
            }),
        });
    };
    DarkTheme.prototype.getTemplateParameters = function () {
        var result = _super.prototype.getTemplateParameters.call(this);
        result.extensions.set(OVERRIDE_SERIES_LABEL_DEFAULTS, DarkTheme.seriesLabelDefaults.label);
        return result;
    };
    DarkTheme.fontColor = 'rgb(200, 200, 200)';
    DarkTheme.mutedFontColor = 'rgb(150, 150, 150)';
    DarkTheme.seriesLabelDefaults = {
        label: {
            color: DarkTheme.fontColor,
        },
    };
    return DarkTheme;
})(ChartTheme);

var __extends$1W =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$7 = {
    fills: [
        '#f44336',
        '#e91e63',
        '#9c27b0',
        '#673ab7',
        '#3f51b5',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        '#4caf50',
        '#8bc34a',
        '#cddc39',
        '#ffeb3b',
        '#ffc107',
        '#ff9800',
        '#ff5722',
    ],
    strokes: [
        '#ab2f26',
        '#a31545',
        '#6d1b7b',
        '#482980',
        '#2c397f',
        '#1769aa',
        '#0276ab',
        '#008494',
        '#00695f',
        '#357a38',
        '#618834',
        '#909a28',
        '#b3a429',
        '#b38705',
        '#b36a00',
        '#b33d18',
    ],
};
var MaterialLight = /** @class */ (function (_super) {
    __extends$1W(MaterialLight, _super);
    function MaterialLight() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    MaterialLight.prototype.getPalette = function () {
        return palette$7;
    };
    return MaterialLight;
})(ChartTheme);

var __extends$1V =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$6 = {
    fills: [
        '#f44336',
        '#e91e63',
        '#9c27b0',
        '#673ab7',
        '#3f51b5',
        '#2196f3',
        '#03a9f4',
        '#00bcd4',
        '#009688',
        '#4caf50',
        '#8bc34a',
        '#cddc39',
        '#ffeb3b',
        '#ffc107',
        '#ff9800',
        '#ff5722',
    ],
    strokes: [
        '#ab2f26',
        '#a31545',
        '#6d1b7b',
        '#482980',
        '#2c397f',
        '#1769aa',
        '#0276ab',
        '#008494',
        '#00695f',
        '#357a38',
        '#618834',
        '#909a28',
        '#b3a429',
        '#b38705',
        '#b36a00',
        '#b33d18',
    ],
};
var MaterialDark = /** @class */ (function (_super) {
    __extends$1V(MaterialDark, _super);
    function MaterialDark() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    MaterialDark.prototype.getPalette = function () {
        return palette$6;
    };
    return MaterialDark;
})(DarkTheme);

var __extends$1U =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$5 = {
    fills: ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'],
    strokes: ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'],
};
var PastelLight = /** @class */ (function (_super) {
    __extends$1U(PastelLight, _super);
    function PastelLight() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    PastelLight.prototype.getPalette = function () {
        return palette$5;
    };
    return PastelLight;
})(ChartTheme);

var __extends$1T =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$4 = {
    fills: ['#c16068', '#a2bf8a', '#ebcc87', '#80a0c3', '#b58dae', '#85c0d1'],
    strokes: ['#874349', '#718661', '#a48f5f', '#5a7088', '#7f637a', '#5d8692'],
};
var PastelDark = /** @class */ (function (_super) {
    __extends$1T(PastelDark, _super);
    function PastelDark() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    PastelDark.prototype.getPalette = function () {
        return palette$4;
    };
    return PastelDark;
})(DarkTheme);

var __extends$1S =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$3 = {
    fills: [
        '#febe76',
        '#ff7979',
        '#badc58',
        '#f9ca23',
        '#f0932b',
        '#eb4c4b',
        '#6ab04c',
        '#7ed6df',
        '#e056fd',
        '#686de0',
    ],
    strokes: [
        '#b28553',
        '#b35555',
        '#829a3e',
        '#ae8d19',
        '#a8671e',
        '#a43535',
        '#4a7b35',
        '#58969c',
        '#9d3cb1',
        '#494c9d',
    ],
};
var SolarLight = /** @class */ (function (_super) {
    __extends$1S(SolarLight, _super);
    function SolarLight() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SolarLight.prototype.getPalette = function () {
        return palette$3;
    };
    return SolarLight;
})(ChartTheme);

var __extends$1R =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$2 = {
    fills: [
        '#febe76',
        '#ff7979',
        '#badc58',
        '#f9ca23',
        '#f0932b',
        '#eb4c4b',
        '#6ab04c',
        '#7ed6df',
        '#e056fd',
        '#686de0',
    ],
    strokes: [
        '#b28553',
        '#b35555',
        '#829a3e',
        '#ae8d19',
        '#a8671e',
        '#a43535',
        '#4a7b35',
        '#58969c',
        '#9d3cb1',
        '#494c9d',
    ],
};
var SolarDark = /** @class */ (function (_super) {
    __extends$1R(SolarDark, _super);
    function SolarDark() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SolarDark.prototype.getPalette = function () {
        return palette$2;
    };
    return SolarDark;
})(DarkTheme);

var __extends$1Q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette$1 = {
    fills: ['#5BC0EB', '#FDE74C', '#9BC53D', '#E55934', '#FA7921', '#fa3081'],
    strokes: ['#4086a4', '#b1a235', '#6c8a2b', '#a03e24', '#af5517', '#af225a'],
};
var VividLight = /** @class */ (function (_super) {
    __extends$1Q(VividLight, _super);
    function VividLight() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    VividLight.prototype.getPalette = function () {
        return palette$1;
    };
    return VividLight;
})(ChartTheme);

var __extends$1P =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var palette = {
    fills: ['#5BC0EB', '#FDE74C', '#9BC53D', '#E55934', '#FA7921', '#fa3081'],
    strokes: ['#4086a4', '#b1a235', '#6c8a2b', '#a03e24', '#af5517', '#af225a'],
};
var VividDark = /** @class */ (function (_super) {
    __extends$1P(VividDark, _super);
    function VividDark() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    VividDark.prototype.getPalette = function () {
        return palette;
    };
    return VividDark;
})(DarkTheme);

var __assign$v =
    (undefined && undefined.__assign) ||
    function () {
        __assign$v =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$v.apply(this, arguments);
    };
var lightTheme = function () {
    return new ChartTheme();
};
var darkTheme = function () {
    return new DarkTheme();
};
var lightThemes = {
    'undefined': lightTheme,
    'null': lightTheme,
    'ag-default': lightTheme,
    'ag-material': function () {
        return new MaterialLight();
    },
    'ag-pastel': function () {
        return new PastelLight();
    },
    'ag-solar': function () {
        return new SolarLight();
    },
    'ag-vivid': function () {
        return new VividLight();
    },
};
var darkThemes = {
    'undefined': darkTheme,
    'null': darkTheme,
    'ag-default-dark': darkTheme,
    'ag-material-dark': function () {
        return new MaterialDark();
    },
    'ag-pastel-dark': function () {
        return new PastelDark();
    },
    'ag-solar-dark': function () {
        return new SolarDark();
    },
    'ag-vivid-dark': function () {
        return new VividDark();
    },
};
var themes$1 = __assign$v(__assign$v({}, darkThemes), lightThemes);
function getChartTheme(value) {
    var _a;
    if (value instanceof ChartTheme) {
        return value;
    }
    var stockTheme = themes$1[value];
    if (stockTheme) {
        return stockTheme();
    }
    value = value;
    // Flatten recursive themes.
    var overrides = [];
    var palette;
    while (typeof value === 'object') {
        overrides.push((_a = value.overrides) !== null && _a !== void 0 ? _a : {});
        // Use first palette found, they can't be merged.
        if (value.palette && palette == null) {
            palette = value.palette;
        }
        value = value.baseTheme;
    }
    overrides.reverse();
    var flattenedTheme = __assign$v(
        { baseTheme: value, overrides: jsonMerge(overrides) },
        palette ? { palette: palette } : {},
    );
    if (flattenedTheme.baseTheme || flattenedTheme.overrides) {
        var baseTheme = getChartTheme(flattenedTheme.baseTheme);
        return new baseTheme.constructor(flattenedTheme);
    }
    return lightTheme();
}

var __assign$u =
    (undefined && undefined.__assign) ||
    function () {
        __assign$u =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$u.apply(this, arguments);
    };
var __values$d =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$s =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$g =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var STACKABLE_SERIES_TYPES = ['bar', 'column', 'area'];
var GROUPABLE_SERIES_TYPES = ['bar', 'column'];
/**
 * Groups the series options objects if they are of type `column` or `bar` and places them in an array at the index where the first instance of this series type was found.
 * Returns an array of arrays containing the ordered and grouped series options objects.
 */
function groupSeriesByType(seriesOptions) {
    var e_1, _a, e_2, _b;
    var _c, _d, _e, _f, _g, _h;
    var groupMap = {};
    var stackMap = {};
    var anyStacked = {};
    var defaultUnstackedGroup = 'default-ag-charts-group';
    var result = [];
    try {
        for (
            var seriesOptions_1 = __values$d(seriesOptions), seriesOptions_1_1 = seriesOptions_1.next();
            !seriesOptions_1_1.done;
            seriesOptions_1_1 = seriesOptions_1.next()
        ) {
            var s = seriesOptions_1_1.value;
            var type = (_c = s.type) !== null && _c !== void 0 ? _c : 'line';
            var stackable = STACKABLE_SERIES_TYPES.includes(type);
            var groupable = GROUPABLE_SERIES_TYPES.includes(type);
            if (!stackable && !groupable) {
                // No need to use index for these cases.
                result.push({ type: 'ungrouped', opts: [s] });
                continue;
            }
            var _j = s,
                sStacked = _j.stacked,
                sStackGroup = _j.stackGroup,
                _k = _j.grouped,
                sGrouped = _k === void 0 ? undefined : _k,
                xKey = _j.xKey;
            var stacked = sStackGroup != null || sStacked === true;
            (_d = anyStacked[type]) !== null && _d !== void 0 ? _d : (anyStacked[type] = false);
            anyStacked[type] || (anyStacked[type] = stacked);
            var grouped = sGrouped === true;
            var groupingKey = [
                sStackGroup !== null && sStackGroup !== void 0
                    ? sStackGroup
                    : sStacked === true
                    ? 'stacked'
                    : undefined,
                grouped ? 'grouped' : undefined,
            ]
                .filter(function (v) {
                    return v != null;
                })
                .join('-');
            if (!groupingKey) {
                groupingKey = defaultUnstackedGroup;
            }
            var indexKey = type + '-' + xKey + '-' + groupingKey;
            if (stacked && stackable) {
                var updated =
                    (_e = stackMap[indexKey]) !== null && _e !== void 0
                        ? _e
                        : (stackMap[indexKey] = { type: 'stack', opts: [] });
                if (updated.opts.length === 0) result.push(updated);
                updated.opts.push(s);
            } else if (grouped && groupable) {
                var updated =
                    (_f = groupMap[indexKey]) !== null && _f !== void 0
                        ? _f
                        : (groupMap[indexKey] = { type: 'group', opts: [] });
                if (updated.opts.length === 0) result.push(updated);
                updated.opts.push(s);
            } else {
                result.push({ type: 'ungrouped', opts: [s] });
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (seriesOptions_1_1 && !seriesOptions_1_1.done && (_a = seriesOptions_1.return)) _a.call(seriesOptions_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    if (
        !Object.values(anyStacked).some(function (v) {
            return v;
        })
    ) {
        return result;
    }
    try {
        for (var _l = __values$d(Object.entries(groupMap)), _m = _l.next(); !_m.done; _m = _l.next()) {
            var _o = __read$s(_m.value, 2),
                group = _o[1];
            var type =
                (_h = (_g = group.opts[0]) === null || _g === void 0 ? void 0 : _g.type) !== null && _h !== void 0
                    ? _h
                    : 'line';
            if (anyStacked[type] !== true) continue;
            group.type = 'stack';
        }
    } catch (e_2_1) {
        e_2 = { error: e_2_1 };
    } finally {
        try {
            if (_m && !_m.done && (_b = _l.return)) _b.call(_l);
        } finally {
            if (e_2) throw e_2.error;
        }
    }
    return result;
}
var DEBUG = function () {
    return [true, 'opts'].includes(windowValue('agChartsDebug'));
};
/**
 * Transforms provided series options array into an array containing series options which are compatible with standalone charts series options.
 */
function processSeriesOptions(_opts, seriesOptions) {
    var e_3, _a;
    var result = [];
    var preprocessed = seriesOptions.map(function (series) {
        var _a;
        // Change the default for bar/columns when yKey is used to be grouped rather than stacked.
        if ((series.type === 'bar' || series.type === 'column') && series.yKey != null && !series.stacked) {
            return __assign$u(__assign$u({}, series), {
                grouped: (_a = series.grouped) !== null && _a !== void 0 ? _a : true,
            });
        }
        return series;
    });
    var grouped = groupSeriesByType(preprocessed);
    var groupCount = grouped.reduce(function (result, next) {
        var _a, _b;
        if (next.type === 'ungrouped') return result;
        var seriesType = (_a = next.opts[0].type) !== null && _a !== void 0 ? _a : 'line';
        (_b = result[seriesType]) !== null && _b !== void 0 ? _b : (result[seriesType] = 0);
        result[seriesType] += next.type === 'stack' ? 1 : next.opts.length;
        return result;
    }, {});
    var groupIdx = {};
    var addSeriesGroupingMeta = function (group) {
        var e_4, _a, e_5, _b, e_6, _c;
        var _d, _e;
        var stackIdx = 0;
        var seriesType = (_d = group.opts[0].type) !== null && _d !== void 0 ? _d : 'line';
        (_e = groupIdx[seriesType]) !== null && _e !== void 0 ? _e : (groupIdx[seriesType] = 0);
        if (group.type === 'stack') {
            try {
                for (var _f = __values$d(group.opts), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var opts = _g.value;
                    opts.seriesGrouping = {
                        groupIndex: groupIdx[seriesType],
                        groupCount: groupCount[seriesType],
                        stackIndex: stackIdx++,
                        stackCount: group.opts.length,
                    };
                }
            } catch (e_4_1) {
                e_4 = { error: e_4_1 };
            } finally {
                try {
                    if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                } finally {
                    if (e_4) throw e_4.error;
                }
            }
            groupIdx[seriesType]++;
        } else if (group.type === 'group') {
            try {
                for (var _h = __values$d(group.opts), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var opts = _j.value;
                    opts.seriesGrouping = {
                        groupIndex: groupIdx[seriesType],
                        groupCount: groupCount[seriesType],
                        stackIndex: 0,
                        stackCount: 0,
                    };
                    groupIdx[seriesType]++;
                }
            } catch (e_5_1) {
                e_5 = { error: e_5_1 };
            } finally {
                try {
                    if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                } finally {
                    if (e_5) throw e_5.error;
                }
            }
        } else {
            try {
                for (var _k = __values$d(group.opts), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var opts = _l.value;
                    opts.seriesGrouping = undefined;
                }
            } catch (e_6_1) {
                e_6 = { error: e_6_1 };
            } finally {
                try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                } finally {
                    if (e_6) throw e_6.error;
                }
            }
        }
        return group.opts;
    };
    if (DEBUG()) {
        Logger.debug('processSeriesOptions() - series grouping: ', grouped);
    }
    try {
        for (
            var grouped_1 = __values$d(grouped), grouped_1_1 = grouped_1.next();
            !grouped_1_1.done;
            grouped_1_1 = grouped_1.next()
        ) {
            var group = grouped_1_1.value;
            switch (group.opts[0].type) {
                case 'column':
                case 'bar':
                case 'area':
                    result.push.apply(result, __spreadArray$g([], __read$s(addSeriesGroupingMeta(group))));
                    break;
                case 'line':
                default:
                    if (group.opts.length > 1) {
                        Logger.warn('unexpected grouping of series type: ' + group.opts[0].type);
                    }
                    result.push.apply(result, __spreadArray$g([], __read$s(group.opts)));
                    break;
            }
        }
    } catch (e_3_1) {
        e_3 = { error: e_3_1 };
    } finally {
        try {
            if (grouped_1_1 && !grouped_1_1.done && (_a = grouped_1.return)) _a.call(grouped_1);
        } finally {
            if (e_3) throw e_3.error;
        }
    }
    return result;
}

var __assign$t =
    (undefined && undefined.__assign) ||
    function () {
        __assign$t =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$t.apply(this, arguments);
    };
var __values$c =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$r =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$f =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
function optionsType(input) {
    var _a, _b, _c, _d;
    return (_d =
        (_a = input.type) !== null && _a !== void 0
            ? _a
            : (_c = (_b = input.series) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0
            ? void 0
            : _c.type) !== null && _d !== void 0
        ? _d
        : 'line';
}
function isAgCartesianChartOptions(input) {
    var specifiedType = optionsType(input);
    if (specifiedType == null) {
        return true;
    }
    if (specifiedType === 'cartesian') {
        Logger.warnOnce("type '" + specifiedType + "' is deprecated, use a series type instead");
        return true;
    }
    return CHART_TYPES.isCartesian(specifiedType);
}
function isAgHierarchyChartOptions(input) {
    var specifiedType = optionsType(input);
    if (specifiedType == null) {
        return false;
    }
    if (specifiedType === 'hierarchy') {
        Logger.warnOnce("type '" + specifiedType + "' is deprecated, use a series type instead");
        return true;
    }
    return CHART_TYPES.isHierarchy(specifiedType);
}
function isAgPolarChartOptions(input) {
    var specifiedType = optionsType(input);
    if (specifiedType == null) {
        return false;
    }
    if (specifiedType === 'polar') {
        Logger.warnOnce("type '" + specifiedType + "' is deprecated, use a series type instead");
        return true;
    }
    return CHART_TYPES.isPolar(specifiedType);
}
function isSeriesOptionType(input) {
    if (input == null) {
        return false;
    }
    return CHART_TYPES.has(input);
}
function isAxisOptionType(input) {
    if (input == null) {
        return false;
    }
    return AXIS_TYPES.has(input);
}
function countArrayElements(input) {
    var e_1, _a;
    var count = 0;
    try {
        for (var input_1 = __values$c(input), input_1_1 = input_1.next(); !input_1_1.done; input_1_1 = input_1.next()) {
            var next = input_1_1.value;
            if (next instanceof Array) {
                count += countArrayElements(next);
            }
            if (next != null) {
                count++;
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (input_1_1 && !input_1_1.done && (_a = input_1.return)) _a.call(input_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return count;
}
function takeColours(context, colours, maxCount) {
    var result = [];
    for (var count = 0; count < maxCount; count++) {
        result.push(colours[(count + context.colourIndex) % colours.length]);
    }
    return result;
}
var noDataCloneMergeOptions = {
    avoidDeepClone: ['data'],
};
function prepareOptions(newOptions, fallbackOptions) {
    var e_2, _a, e_3, _b;
    var _c, _d, _e, _f, _g, _h;
    var options = jsonMerge([fallbackOptions, newOptions], noDataCloneMergeOptions);
    sanityCheckOptions(options);
    // Determine type and ensure it's explicit in the options config.
    var userSuppliedOptionsType = options.type;
    var type = optionsType(options);
    var globalTooltipPositionOptions =
        (_d = (_c = options.tooltip) === null || _c === void 0 ? void 0 : _c.position) !== null && _d !== void 0
            ? _d
            : {};
    var checkSeriesType = function (type) {
        if (type != null && !(isSeriesOptionType(type) || getSeriesDefaults(type))) {
            throw new Error(
                'AG Charts - unknown series type: ' + type + '; expected one of: ' + CHART_TYPES.seriesTypes,
            );
        }
    };
    checkSeriesType(type);
    try {
        for (
            var _j = __values$c((_e = options.series) !== null && _e !== void 0 ? _e : []), _k = _j.next();
            !_k.done;
            _k = _j.next()
        ) {
            var seriesType = _k.value.type;
            if (seriesType == null) continue;
            checkSeriesType(seriesType);
        }
    } catch (e_2_1) {
        e_2 = { error: e_2_1 };
    } finally {
        try {
            if (_k && !_k.done && (_a = _j.return)) _a.call(_j);
        } finally {
            if (e_2) throw e_2.error;
        }
    }
    options = __assign$t(__assign$t({}, options), { type: type });
    var defaultSeriesType = 'line';
    if (isAgCartesianChartOptions(options)) {
        defaultSeriesType = 'line';
    } else if (isAgHierarchyChartOptions(options)) {
        defaultSeriesType = 'treemap';
    } else if (isAgPolarChartOptions(options)) {
        defaultSeriesType = 'pie';
    }
    var defaultOverrides = {};
    var seriesDefaults = getSeriesDefaults(type);
    if (seriesDefaults) {
        defaultOverrides = seriesDefaults;
    } else if (type === 'bar') {
        defaultOverrides = DEFAULT_BAR_CHART_OVERRIDES;
    } else if (type === 'scatter' || type === 'histogram') {
        defaultOverrides = DEFAULT_SCATTER_HISTOGRAM_CHART_OVERRIDES;
    } else if (isAgCartesianChartOptions(options)) {
        defaultOverrides = DEFAULT_CARTESIAN_CHART_OVERRIDES;
    }
    removeDisabledOptions(options);
    var _l = prepareMainOptions(defaultOverrides, options),
        context = _l.context,
        mergedOptions = _l.mergedOptions,
        axesThemes = _l.axesThemes,
        seriesThemes = _l.seriesThemes;
    // Special cases where we have arrays of elements which need their own defaults.
    // Apply series themes before calling processSeriesOptions() as it reduces and renames some
    // properties, and in that case then cannot correctly have themes applied.
    mergedOptions.series = processSeriesOptions(
        mergedOptions,
        ((_f = mergedOptions.series) !== null && _f !== void 0 ? _f : []).map(function (s) {
            var type = defaultSeriesType;
            if (s.type) {
                type = s.type;
            } else if (isSeriesOptionType(userSuppliedOptionsType)) {
                type = userSuppliedOptionsType;
            }
            var mergedSeries = mergeSeriesOptions(s, type, seriesThemes, globalTooltipPositionOptions);
            if (type === 'pie') {
                preparePieOptions(seriesThemes.pie, s, mergedSeries);
            }
            return mergedSeries;
        }),
    ).map(function (s) {
        return prepareSeries(context, s);
    });
    var checkAxisType = function (type) {
        var isAxisType = isAxisOptionType(type);
        if (!isAxisType) {
            Logger.warnOnce(
                'AG Charts - unknown axis type: ' + type + '; expected one of: ' + AXIS_TYPES.axesTypes + ', ignoring.',
            );
        }
        return isAxisType;
    };
    if ('axes' in mergedOptions) {
        var validAxesTypes = true;
        try {
            for (
                var _m = __values$c((_g = mergedOptions.axes) !== null && _g !== void 0 ? _g : []), _o = _m.next();
                !_o.done;
                _o = _m.next()
            ) {
                var axisType = _o.value.type;
                if (!checkAxisType(axisType)) {
                    validAxesTypes = false;
                }
            }
        } catch (e_3_1) {
            e_3 = { error: e_3_1 };
        } finally {
            try {
                if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
            } finally {
                if (e_3) throw e_3.error;
            }
        }
        if (!validAxesTypes) {
            mergedOptions.axes = defaultOverrides.axes;
        } else {
            mergedOptions.axes =
                (_h = mergedOptions.axes) === null || _h === void 0
                    ? void 0
                    : _h.map(function (axis) {
                          var _a, _b;
                          var axisType = axis.type;
                          var axesTheme = jsonMerge([
                              axesThemes[axisType],
                              (_b =
                                  axesThemes[axisType][
                                      (_a = axis.position) !== null && _a !== void 0 ? _a : 'unknown'
                                  ]) !== null && _b !== void 0
                                  ? _b
                                  : {},
                          ]);
                          return prepareAxis(axis, axesTheme);
                      });
        }
        prepareLegendEnabledOption(options, mergedOptions);
    }
    prepareEnabledOptions(options, mergedOptions);
    return mergedOptions;
}
function sanityCheckOptions(options) {
    var deprecatedArrayProps = {
        yKeys: 'yKey',
        yNames: 'yName',
    };
    Object.entries(deprecatedArrayProps).forEach(function (_a) {
        var _b;
        var _c = __read$r(_a, 2),
            oldProp = _c[0],
            newProp = _c[1];
        if (
            (_b = options.series) === null || _b === void 0
                ? void 0
                : _b.some(function (s) {
                      return s[oldProp] != null;
                  })
        ) {
            Logger.warnOnce(
                'property [series.' +
                    oldProp +
                    '] is deprecated, please use [series.' +
                    newProp +
                    '] and multiple series instead.',
            );
        }
    });
}
function mergeSeriesOptions(series, type, seriesThemes, globalTooltipPositionOptions) {
    var _a, _b;
    var mergedTooltipPosition = jsonMerge(
        [
            __assign$t({}, globalTooltipPositionOptions),
            (_a = series.tooltip) === null || _a === void 0 ? void 0 : _a.position,
        ],
        noDataCloneMergeOptions,
    );
    var mergedSeries = jsonMerge(
        [
            (_b = seriesThemes[type]) !== null && _b !== void 0 ? _b : {},
            __assign$t(__assign$t({}, series), {
                type: type,
                tooltip: __assign$t(__assign$t({}, series.tooltip), { position: mergedTooltipPosition }),
            }),
        ],
        noDataCloneMergeOptions,
    );
    return mergedSeries;
}
function prepareMainOptions(defaultOverrides, options) {
    var _a = prepareTheme(options),
        theme = _a.theme,
        cleanedTheme = _a.cleanedTheme,
        axesThemes = _a.axesThemes,
        seriesThemes = _a.seriesThemes;
    var context = { colourIndex: 0, palette: theme.palette };
    var mergedOptions = jsonMerge([defaultOverrides, cleanedTheme, options], noDataCloneMergeOptions);
    return { context: context, mergedOptions: mergedOptions, axesThemes: axesThemes, seriesThemes: seriesThemes };
}
function prepareTheme(options) {
    var _a, _b;
    var theme = getChartTheme(options.theme);
    var themeConfig = theme.config[(_a = optionsType(options)) !== null && _a !== void 0 ? _a : 'cartesian'];
    var seriesThemes = Object.entries(theme.config).reduce(function (result, _a) {
        var _b = __read$r(_a, 2),
            seriesType = _b[0],
            series = _b[1].series;
        result[seriesType] = series === null || series === void 0 ? void 0 : series[seriesType];
        return result;
    }, {});
    return {
        theme: theme,
        axesThemes: (_b = themeConfig['axes']) !== null && _b !== void 0 ? _b : {},
        seriesThemes: seriesThemes,
        cleanedTheme: jsonMerge([themeConfig, { axes: DELETE, series: DELETE }]),
    };
}
function prepareSeries(context, input) {
    var defaults = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        defaults[_i - 2] = arguments[_i];
    }
    var paletteOptions = calculateSeriesPalette(context, input);
    // Part of the options interface, but not directly consumed by the series implementations.
    var removeOptions = { stacked: DELETE, grouped: DELETE };
    return jsonMerge(
        __spreadArray$f(__spreadArray$f([], __read$r(defaults)), [paletteOptions, input, removeOptions]),
        noDataCloneMergeOptions,
    );
}
addSeriesPaletteFactory('pie', function (_a) {
    var takeColors = _a.takeColors,
        colorsCount = _a.colorsCount;
    return takeColors(colorsCount);
});
var singleSeriesPaletteFactory = function (_a) {
    var takeColors = _a.takeColors;
    var _b = takeColors(1),
        _c = __read$r(_b.fills, 1),
        fill = _c[0],
        _d = __read$r(_b.strokes, 1),
        stroke = _d[0];
    return { fill: fill, stroke: stroke };
};
addSeriesPaletteFactory('area', singleSeriesPaletteFactory);
addSeriesPaletteFactory('bar', singleSeriesPaletteFactory);
addSeriesPaletteFactory('column', singleSeriesPaletteFactory);
addSeriesPaletteFactory('histogram', singleSeriesPaletteFactory);
addSeriesPaletteFactory('scatter', function (params) {
    var _a = singleSeriesPaletteFactory(params),
        fill = _a.fill,
        stroke = _a.stroke;
    return { marker: { fill: fill, stroke: stroke } };
});
addSeriesPaletteFactory('line', function (params) {
    var _a = singleSeriesPaletteFactory(params),
        fill = _a.fill,
        stroke = _a.stroke;
    return {
        stroke: fill,
        marker: { fill: fill, stroke: stroke },
    };
});
function calculateSeriesPalette(context, input) {
    var _a;
    var paletteFactory = getSeriesPaletteFactory(input.type);
    if (!paletteFactory) {
        return {};
    }
    var _b = context.palette,
        fills = _b.fills,
        strokes = _b.strokes;
    var inputAny = input;
    var seriesCount = countArrayElements((_a = inputAny['yKeys']) !== null && _a !== void 0 ? _a : []) || 1; // Defaults to 1 if no yKeys.
    var colorsCount = Math.max(fills.length, strokes.length);
    return paletteFactory({
        seriesCount: seriesCount,
        colorsCount: colorsCount,
        takeColors: function (count) {
            var colors = {
                fills: takeColours(context, fills, count),
                strokes: takeColours(context, strokes, count),
            };
            context.colourIndex += count;
            return colors;
        },
    });
}
function prepareAxis(axis, axisTheme) {
    // Remove redundant theme overload keys.
    var removeOptions = { top: DELETE, bottom: DELETE, left: DELETE, right: DELETE };
    // Special cross lines case where we have an array of cross line elements which need their own defaults.
    if (axis.crossLines) {
        if (!Array.isArray(axis.crossLines)) {
            Logger.warn('axis[].crossLines should be an array.');
            axis.crossLines = [];
        }
        var crossLinesTheme_1 = axisTheme.crossLines;
        axis.crossLines = axis.crossLines.map(function (crossLine) {
            return jsonMerge([crossLinesTheme_1, crossLine]);
        });
    }
    var cleanTheme = { crossLines: DELETE };
    return jsonMerge([axisTheme, cleanTheme, axis, removeOptions], noDataCloneMergeOptions);
}
function removeDisabledOptions(options) {
    // Remove configurations from all option objects with a `false` value for the `enabled` property.
    jsonWalk(
        options,
        function (_, visitingUserOpts) {
            if (!('enabled' in visitingUserOpts)) return;
            if (visitingUserOpts.enabled === false) {
                Object.entries(visitingUserOpts).forEach(function (_a) {
                    var _b = __read$r(_a, 1),
                        key = _b[0];
                    if (key === 'enabled') return;
                    delete visitingUserOpts[key];
                });
            }
        },
        { skip: ['data', 'theme'] },
    );
}
function prepareLegendEnabledOption(options, mergedOptions) {
    var _a, _b, _c, _d;
    // Disable legend by default for single series cartesian charts
    if (
        ((_a = options.legend) === null || _a === void 0 ? void 0 : _a.enabled) !== undefined ||
        ((_b = mergedOptions.legend) === null || _b === void 0 ? void 0 : _b.enabled) !== undefined
    ) {
        return;
    }
    (_c = mergedOptions.legend) !== null && _c !== void 0 ? _c : (mergedOptions.legend = {});
    if (((_d = options.series) !== null && _d !== void 0 ? _d : []).length > 1) {
        mergedOptions.legend.enabled = true;
        return;
    }
    mergedOptions.legend.enabled = false;
}
function prepareEnabledOptions(options, mergedOptions) {
    // Set `enabled: true` for all option objects where the user has provided values.
    jsonWalk(
        options,
        function (_, visitingUserOpts, visitingMergedOpts) {
            if (!visitingMergedOpts) return;
            var _enabledFromTheme = visitingMergedOpts._enabledFromTheme;
            if (_enabledFromTheme != null) {
                // Do not apply special handling, base enablement on theme.
                delete visitingMergedOpts._enabledFromTheme;
            }
            if (!('enabled' in visitingMergedOpts)) return;
            if (_enabledFromTheme) return;
            if (visitingUserOpts.enabled == null) {
                visitingMergedOpts.enabled = true;
            }
        },
        { skip: ['data', 'theme'] },
        mergedOptions,
    );
    // Cleanup any special properties.
    jsonWalk(
        mergedOptions,
        function (_, visitingMergedOpts) {
            if (visitingMergedOpts._enabledFromTheme != null) {
                // Do not apply special handling, base enablement on theme.
                delete visitingMergedOpts._enabledFromTheme;
            }
        },
        { skip: ['data', 'theme'] },
    );
}
function preparePieOptions(pieSeriesTheme, seriesOptions, mergedSeries) {
    if (Array.isArray(seriesOptions.innerLabels)) {
        mergedSeries.innerLabels = seriesOptions.innerLabels.map(function (ln) {
            return jsonMerge([pieSeriesTheme.innerLabels, ln]);
        });
    } else {
        mergedSeries.innerLabels = DELETE;
    }
}

var __values$b =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var BaseModuleInstance = /** @class */ (function () {
    function BaseModuleInstance() {
        this.destroyFns = [];
    }
    BaseModuleInstance.prototype.destroy = function () {
        var e_1, _a;
        try {
            for (var _b = __values$b(this.destroyFns), _c = _b.next(); !_c.done; _c = _b.next()) {
                var destroyFn = _c.value;
                destroyFn();
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    return BaseModuleInstance;
})();
var REGISTERED_MODULES = [];
function registerModule(module) {
    var otherModule = REGISTERED_MODULES.find(function (other) {
        return (
            module.type === other.type &&
            module.optionsKey === other.optionsKey &&
            module.identifier === other.identifier
        );
    });
    if (otherModule) {
        if (module.packageType === 'enterprise' && otherModule.packageType === 'community') {
            // Replace the community module with an enterprise version
            var index = REGISTERED_MODULES.indexOf(otherModule);
            REGISTERED_MODULES.splice(index, 1, module);
        }
    } else {
        // Simply register the module
        REGISTERED_MODULES.push(module);
    }
}

var __extends$1O =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1h =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var RangeHandle$1 = /** @class */ (function (_super) {
    __extends$1O(RangeHandle, _super);
    function RangeHandle() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this._fill = '#f2f2f2';
        _this._stroke = '#999999';
        _this._strokeWidth = 1;
        _this._lineCap = 'square';
        _this._centerX = 0;
        _this._centerY = 0;
        // Use an even number for better looking results.
        _this._width = 8;
        // Use an even number for better looking results.
        _this._gripLineGap = 2;
        // Use an even number for better looking results.
        _this._gripLineLength = 8;
        _this._height = 16;
        return _this;
    }
    Object.defineProperty(RangeHandle.prototype, 'centerX', {
        get: function () {
            return this._centerX;
        },
        set: function (value) {
            if (this._centerX !== value) {
                this._centerX = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeHandle.prototype, 'centerY', {
        get: function () {
            return this._centerY;
        },
        set: function (value) {
            if (this._centerY !== value) {
                this._centerY = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeHandle.prototype, 'width', {
        get: function () {
            return this._width;
        },
        set: function (value) {
            if (this._width !== value) {
                this._width = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeHandle.prototype, 'gripLineGap', {
        get: function () {
            return this._gripLineGap;
        },
        set: function (value) {
            if (this._gripLineGap !== value) {
                this._gripLineGap = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeHandle.prototype, 'gripLineLength', {
        get: function () {
            return this._gripLineLength;
        },
        set: function (value) {
            if (this._gripLineLength !== value) {
                this._gripLineLength = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeHandle.prototype, 'height', {
        get: function () {
            return this._height;
        },
        set: function (value) {
            if (this._height !== value) {
                this._height = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    RangeHandle.prototype.computeBBox = function () {
        var _a = this,
            centerX = _a.centerX,
            centerY = _a.centerY,
            width = _a.width,
            height = _a.height;
        var x = centerX - width / 2;
        var y = centerY - height / 2;
        return new BBox(x, y, width, height);
    };
    RangeHandle.prototype.isPointInPath = function (x, y) {
        var point = this.transformPoint(x, y);
        var bbox = this.computeBBox();
        return bbox.containsPoint(point.x, point.y);
    };
    RangeHandle.prototype.updatePath = function () {
        var _a = this,
            path = _a.path,
            centerX = _a.centerX,
            centerY = _a.centerY,
            width = _a.width,
            height = _a.height;
        path.clear();
        var x = centerX - width / 2;
        var y = centerY - height / 2;
        var ax = this.align(x);
        var ay = this.align(y);
        var axw = ax + this.align(x, width);
        var ayh = ay + this.align(y, height);
        // Handle.
        path.moveTo(ax, ay);
        path.lineTo(axw, ay);
        path.lineTo(axw, ayh);
        path.lineTo(ax, ayh);
        path.lineTo(ax, ay);
        // Grip lines.
        var dx = this.gripLineGap / 2;
        var dy = this.gripLineLength / 2;
        path.moveTo(this.align(centerX - dx), this.align(centerY - dy));
        path.lineTo(this.align(centerX - dx), this.align(centerY + dy));
        path.moveTo(this.align(centerX + dx), this.align(centerY - dy));
        path.lineTo(this.align(centerX + dx), this.align(centerY + dy));
    };
    RangeHandle.className = 'RangeHandle';
    __decorate$1h([Validate(COLOR_STRING)], RangeHandle.prototype, '_fill', void 0);
    __decorate$1h([Validate(COLOR_STRING)], RangeHandle.prototype, '_stroke', void 0);
    __decorate$1h([Validate(NUMBER(0))], RangeHandle.prototype, '_strokeWidth', void 0);
    __decorate$1h([Validate(LINE_CAP)], RangeHandle.prototype, '_lineCap', void 0);
    __decorate$1h([Validate(NUMBER(0))], RangeHandle.prototype, '_width', void 0);
    __decorate$1h([Validate(NUMBER(0))], RangeHandle.prototype, '_gripLineGap', void 0);
    __decorate$1h([Validate(NUMBER(0))], RangeHandle.prototype, '_gripLineLength', void 0);
    __decorate$1h([Validate(NUMBER(0))], RangeHandle.prototype, '_height', void 0);
    return RangeHandle;
})(Path);

var __extends$1N =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1g =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var RangeMask = /** @class */ (function (_super) {
    __extends$1N(RangeMask, _super);
    function RangeMask() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this._stroke = '#999999';
        _this._strokeWidth = 1;
        _this._fill = '#999999';
        _this._fillOpacity = 0.2;
        _this._lineCap = 'square';
        _this._x = 0;
        _this._y = 0;
        _this._width = 200;
        _this._height = 30;
        _this.minRange = 0.05;
        _this._min = 0;
        _this._max = 1;
        return _this;
    }
    Object.defineProperty(RangeMask.prototype, 'x', {
        get: function () {
            return this._x;
        },
        set: function (value) {
            if (this._x !== value) {
                this._x = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeMask.prototype, 'y', {
        get: function () {
            return this._y;
        },
        set: function (value) {
            if (this._y !== value) {
                this._y = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeMask.prototype, 'width', {
        get: function () {
            return this._width;
        },
        set: function (value) {
            if (this._width !== value) {
                this._width = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeMask.prototype, 'height', {
        get: function () {
            return this._height;
        },
        set: function (value) {
            if (this._height !== value) {
                this._height = value;
                this.dirtyPath = true;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeMask.prototype, 'min', {
        get: function () {
            return this._min;
        },
        set: function (value) {
            var _a;
            value = Math.min(Math.max(value, 0), this.max - this.minRange);
            if (isNaN(value)) {
                return;
            }
            if (this._min !== value) {
                this._min = value;
                this.dirtyPath = true;
                (_a = this.onRangeChange) === null || _a === void 0 ? void 0 : _a.call(this);
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeMask.prototype, 'max', {
        get: function () {
            return this._max;
        },
        set: function (value) {
            var _a;
            value = Math.max(Math.min(value, 1), this.min + this.minRange);
            if (isNaN(value)) {
                return;
            }
            if (this._max !== value) {
                this._max = value;
                this.dirtyPath = true;
                (_a = this.onRangeChange) === null || _a === void 0 ? void 0 : _a.call(this);
            }
        },
        enumerable: false,
        configurable: true,
    });
    RangeMask.prototype.computeBBox = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height;
        return new BBox(x, y, width, height);
    };
    RangeMask.prototype.computeVisibleRangeBBox = function () {
        var _a = this,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height,
            min = _a.min,
            max = _a.max;
        var minX = x + width * min;
        var maxX = x + width * max;
        return new BBox(minX, y, maxX - minX, height);
    };
    RangeMask.prototype.updatePath = function () {
        var _a = this,
            path = _a.path,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height,
            min = _a.min,
            max = _a.max;
        path.clear();
        var ax = this.align(x);
        var ay = this.align(y);
        var axw = ax + this.align(x, width);
        var ayh = ay + this.align(y, height);
        // Whole range.
        path.moveTo(ax, ay);
        path.lineTo(axw, ay);
        path.lineTo(axw, ayh);
        path.lineTo(ax, ayh);
        path.lineTo(ax, ay);
        var minX = this.align(x + width * min);
        var maxX = this.align(x + width * max);
        // Visible range.
        path.moveTo(minX, ay);
        path.lineTo(minX, ayh);
        path.lineTo(maxX, ayh);
        path.lineTo(maxX, ay);
        path.lineTo(minX, ay);
    };
    RangeMask.className = 'RangeMask';
    __decorate$1g([Validate(COLOR_STRING)], RangeMask.prototype, '_stroke', void 0);
    __decorate$1g([Validate(NUMBER(0))], RangeMask.prototype, '_strokeWidth', void 0);
    __decorate$1g([Validate(COLOR_STRING)], RangeMask.prototype, '_fill', void 0);
    __decorate$1g([Validate(NUMBER(0, 1))], RangeMask.prototype, '_fillOpacity', void 0);
    __decorate$1g([Validate(LINE_CAP)], RangeMask.prototype, '_lineCap', void 0);
    __decorate$1g([Validate(NUMBER(0))], RangeMask.prototype, '_width', void 0);
    __decorate$1g([Validate(NUMBER(0))], RangeMask.prototype, '_height', void 0);
    __decorate$1g([Validate(NUMBER())], RangeMask.prototype, '_min', void 0);
    __decorate$1g([Validate(NUMBER())], RangeMask.prototype, '_max', void 0);
    return RangeMask;
})(Path);

var __extends$1M =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$s =
    (undefined && undefined.__assign) ||
    function () {
        __assign$s =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$s.apply(this, arguments);
    };
var RangeSelector = /** @class */ (function (_super) {
    __extends$1M(RangeSelector, _super);
    function RangeSelector() {
        var _this = _super.call(this, { name: 'rangeSelectorGroup' }) || this;
        _this.minHandle = new RangeHandle$1();
        _this.maxHandle = new RangeHandle$1();
        _this.mask = (function () {
            var _a = RangeSelector.defaults,
                x = _a.x,
                y = _a.y,
                width = _a.width,
                height = _a.height,
                min = _a.min,
                max = _a.max;
            var mask = new RangeMask();
            mask.x = x;
            mask.y = y;
            mask.width = width;
            mask.height = height;
            mask.min = min;
            mask.max = max;
            var _b = _this,
                minHandle = _b.minHandle,
                maxHandle = _b.maxHandle;
            minHandle.centerX = x;
            maxHandle.centerX = x + width;
            minHandle.centerY = maxHandle.centerY = y + height / 2;
            _this.append([mask, minHandle, maxHandle]);
            mask.onRangeChange = function () {
                var _a;
                _this.updateHandles();
                (_a = _this.onRangeChange) === null || _a === void 0 ? void 0 : _a.call(_this);
            };
            return mask;
        })();
        _this._x = RangeSelector.defaults.x;
        _this._y = RangeSelector.defaults.y;
        _this._width = RangeSelector.defaults.width;
        _this._height = RangeSelector.defaults.height;
        _this._min = RangeSelector.defaults.min;
        _this._max = RangeSelector.defaults.max;
        _this.isContainerNode = true;
        return _this;
    }
    Object.defineProperty(RangeSelector.prototype, 'x', {
        get: function () {
            return this.mask.x;
        },
        set: function (value) {
            this.mask.x = value;
            this.updateHandles();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeSelector.prototype, 'y', {
        get: function () {
            return this.mask.y;
        },
        set: function (value) {
            this.mask.y = value;
            this.updateHandles();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeSelector.prototype, 'width', {
        get: function () {
            return this.mask.width;
        },
        set: function (value) {
            this.mask.width = value;
            this.updateHandles();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeSelector.prototype, 'height', {
        get: function () {
            return this.mask.height;
        },
        set: function (value) {
            this.mask.height = value;
            this.updateHandles();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeSelector.prototype, 'min', {
        get: function () {
            return this.mask.min;
        },
        set: function (value) {
            this.mask.min = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(RangeSelector.prototype, 'max', {
        get: function () {
            return this.mask.max;
        },
        set: function (value) {
            this.mask.max = value;
        },
        enumerable: false,
        configurable: true,
    });
    RangeSelector.prototype.updateHandles = function () {
        var _a = this,
            minHandle = _a.minHandle,
            maxHandle = _a.maxHandle,
            x = _a.x,
            y = _a.y,
            width = _a.width,
            height = _a.height,
            mask = _a.mask;
        minHandle.centerX = x + width * mask.min;
        maxHandle.centerX = x + width * mask.max;
        minHandle.centerY = maxHandle.centerY = y + height / 2;
    };
    RangeSelector.prototype.computeBBox = function () {
        return this.mask.computeBBox();
    };
    RangeSelector.prototype.computeVisibleRangeBBox = function () {
        return this.mask.computeVisibleRangeBBox();
    };
    RangeSelector.prototype.render = function (renderCtx) {
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped++;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        var _a = this,
            mask = _a.mask,
            minHandle = _a.minHandle,
            maxHandle = _a.maxHandle;
        [mask, minHandle, maxHandle].forEach(function (child) {
            if (child.visible && (forceRender || child.dirty > RedrawType.NONE)) {
                ctx.save();
                child.render(__assign$s(__assign$s({}, renderCtx), { ctx: ctx, forceRender: forceRender }));
                ctx.restore();
            }
        });
        this.markClean({ force: true });
        if (stats) stats.nodesRendered++;
    };
    RangeSelector.className = 'Range';
    RangeSelector.defaults = {
        x: 0,
        y: 0,
        width: 200,
        height: 30,
        min: 0,
        max: 1,
    };
    return RangeSelector;
})(Group);

var NavigatorMask = /** @class */ (function () {
    function NavigatorMask(rangeMask) {
        this.rm = rangeMask;
    }
    Object.defineProperty(NavigatorMask.prototype, 'fill', {
        get: function () {
            return this.rm.fill;
        },
        set: function (value) {
            this.rm.fill = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorMask.prototype, 'stroke', {
        get: function () {
            return this.rm.stroke;
        },
        set: function (value) {
            this.rm.stroke = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorMask.prototype, 'strokeWidth', {
        get: function () {
            return this.rm.strokeWidth;
        },
        set: function (value) {
            this.rm.strokeWidth = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorMask.prototype, 'fillOpacity', {
        get: function () {
            return this.rm.fillOpacity;
        },
        set: function (value) {
            this.rm.fillOpacity = value;
        },
        enumerable: false,
        configurable: true,
    });
    return NavigatorMask;
})();

var NavigatorHandle = /** @class */ (function () {
    function NavigatorHandle(rangeHandle) {
        this.rh = rangeHandle;
    }
    Object.defineProperty(NavigatorHandle.prototype, 'fill', {
        get: function () {
            return this.rh.fill;
        },
        set: function (value) {
            this.rh.fill = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'stroke', {
        get: function () {
            return this.rh.stroke;
        },
        set: function (value) {
            this.rh.stroke = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'strokeWidth', {
        get: function () {
            return this.rh.strokeWidth;
        },
        set: function (value) {
            this.rh.strokeWidth = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'width', {
        get: function () {
            return this.rh.width;
        },
        set: function (value) {
            this.rh.width = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'height', {
        get: function () {
            return this.rh.height;
        },
        set: function (value) {
            this.rh.height = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'gripLineGap', {
        get: function () {
            return this.rh.gripLineGap;
        },
        set: function (value) {
            this.rh.gripLineGap = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(NavigatorHandle.prototype, 'gripLineLength', {
        get: function () {
            return this.rh.gripLineLength;
        },
        set: function (value) {
            this.rh.gripLineLength = value;
        },
        enumerable: false,
        configurable: true,
    });
    return NavigatorHandle;
})();

var __extends$1L =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1f =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Navigator = /** @class */ (function (_super) {
    __extends$1L(Navigator, _super);
    function Navigator(ctx) {
        var _a;
        var _this = _super.call(this) || this;
        _this.ctx = ctx;
        _this.rs = new RangeSelector();
        // Wrappers to allow option application to the scene graph nodes.
        _this.mask = new NavigatorMask(_this.rs.mask);
        _this.minHandle = new NavigatorHandle(_this.rs.minHandle);
        _this.maxHandle = new NavigatorHandle(_this.rs.maxHandle);
        _this.minHandleDragging = false;
        _this.maxHandleDragging = false;
        _this.panHandleOffset = NaN;
        _this._enabled = false;
        _this.margin = 10;
        _this._visible = true;
        _this.rs.onRangeChange = function () {
            return _this.ctx.zoomManager.updateZoom('navigator', { x: { min: _this.rs.min, max: _this.rs.max } });
        };
        [
            ctx.interactionManager.addListener('drag-start', function (event) {
                return _this.onDragStart(event);
            }),
            ctx.interactionManager.addListener('drag', function (event) {
                return _this.onDrag(event);
            }),
            ctx.interactionManager.addListener('hover', function (event) {
                return _this.onDrag(event);
            }),
            ctx.interactionManager.addListener('drag-end', function () {
                return _this.onDragStop();
            }),
        ].forEach(function (s) {
            return _this.destroyFns.push(function () {
                return ctx.interactionManager.removeListener(s);
            });
        });
        [
            ctx.layoutService.addListener('before-series', function (event) {
                return _this.layout(event);
            }),
            ctx.layoutService.addListener('layout-complete', function (event) {
                return _this.layoutComplete(event);
            }),
        ].forEach(function (s) {
            return _this.destroyFns.push(function () {
                return ctx.layoutService.removeListener(s);
            });
        });
        (_a = ctx.scene.root) === null || _a === void 0 ? void 0 : _a.appendChild(_this.rs);
        _this.destroyFns.push(function () {
            var _a;
            return (_a = ctx.scene.root) === null || _a === void 0 ? void 0 : _a.removeChild(_this.rs);
        });
        _this.destroyFns.push(function () {
            return _this.ctx.zoomManager.updateZoom('navigator');
        });
        _this.updateGroupVisibility();
        return _this;
    }
    Object.defineProperty(Navigator.prototype, 'enabled', {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Navigator.prototype, 'width', {
        get: function () {
            return this.rs.width;
        },
        set: function (value) {
            this.rs.width = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Navigator.prototype, 'height', {
        get: function () {
            return this.rs.height;
        },
        set: function (value) {
            this.rs.height = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Navigator.prototype, 'min', {
        get: function () {
            return this.rs.min;
        },
        set: function (value) {
            this.rs.min = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Navigator.prototype, 'max', {
        get: function () {
            return this.rs.max;
        },
        set: function (value) {
            this.rs.max = value;
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Navigator.prototype, 'visible', {
        get: function () {
            return this._visible;
        },
        set: function (value) {
            this._visible = value;
            this.updateGroupVisibility();
        },
        enumerable: false,
        configurable: true,
    });
    Navigator.prototype.updateGroupVisibility = function () {
        var visible = this.enabled && this.visible;
        this.rs.visible = visible;
        if (visible) {
            this.ctx.zoomManager.updateZoom('navigator', { x: { min: this.rs.min, max: this.rs.max } });
        } else {
            this.ctx.zoomManager.updateZoom('navigator');
        }
    };
    Navigator.prototype.layout = function (_a) {
        var shrinkRect = _a.shrinkRect;
        if (this.enabled) {
            var navigatorTotalHeight = this.rs.height + this.margin;
            shrinkRect.shrink(navigatorTotalHeight, 'bottom');
            this.rs.y = shrinkRect.y + shrinkRect.height + this.margin;
        }
        return { shrinkRect: shrinkRect };
    };
    Navigator.prototype.layoutComplete = function (_a) {
        var _b = _a.series,
            rect = _b.rect,
            visible = _b.visible;
        if (this.enabled && visible) {
            this.rs.x = rect.x;
            this.rs.width = rect.width;
        }
        this.visible = visible;
    };
    Navigator.prototype.onDragStart = function (offset) {
        if (!this.enabled) {
            return;
        }
        var offsetX = offset.offsetX,
            offsetY = offset.offsetY;
        var rs = this.rs;
        var minHandle = rs.minHandle,
            maxHandle = rs.maxHandle,
            x = rs.x,
            width = rs.width,
            min = rs.min;
        var visibleRange = rs.computeVisibleRangeBBox();
        if (!(this.minHandleDragging || this.maxHandleDragging)) {
            if (minHandle.containsPoint(offsetX, offsetY)) {
                this.minHandleDragging = true;
            } else if (maxHandle.containsPoint(offsetX, offsetY)) {
                this.maxHandleDragging = true;
            } else if (visibleRange.containsPoint(offsetX, offsetY)) {
                this.panHandleOffset = (offsetX - x) / width - min;
            }
        }
    };
    Navigator.prototype.onDrag = function (offset) {
        if (!this.enabled) {
            return;
        }
        var _a = this,
            rs = _a.rs,
            panHandleOffset = _a.panHandleOffset;
        var x = rs.x,
            y = rs.y,
            width = rs.width,
            height = rs.height,
            minHandle = rs.minHandle,
            maxHandle = rs.maxHandle;
        var offsetX = offset.offsetX,
            offsetY = offset.offsetY;
        var minX = x + width * rs.min;
        var maxX = x + width * rs.max;
        var visibleRange = new BBox(minX, y, maxX - minX, height);
        var getRatio = function () {
            return Math.min(Math.max((offsetX - x) / width, 0), 1);
        };
        if (minHandle.containsPoint(offsetX, offsetY) || maxHandle.containsPoint(offsetX, offsetY)) {
            this.ctx.cursorManager.updateCursor('navigator', 'ew-resize');
        } else if (visibleRange.containsPoint(offsetX, offsetY)) {
            this.ctx.cursorManager.updateCursor('navigator', 'grab');
        } else {
            this.ctx.cursorManager.updateCursor('navigator');
        }
        if (this.minHandleDragging) {
            rs.min = getRatio();
        } else if (this.maxHandleDragging) {
            rs.max = getRatio();
        } else if (!isNaN(panHandleOffset)) {
            var span = rs.max - rs.min;
            var min = Math.min(getRatio() - panHandleOffset, 1 - span);
            if (min <= rs.min) {
                // pan left
                rs.min = min;
                rs.max = rs.min + span;
            } else {
                // pan right
                rs.max = min + span;
                rs.min = rs.max - span;
            }
        }
    };
    Navigator.prototype.onDragStop = function () {
        this.stopHandleDragging();
    };
    Navigator.prototype.stopHandleDragging = function () {
        this.minHandleDragging = this.maxHandleDragging = false;
        this.panHandleOffset = NaN;
    };
    __decorate$1f([Validate(BOOLEAN)], Navigator.prototype, '_enabled', void 0);
    __decorate$1f([Validate(NUMBER(0))], Navigator.prototype, 'margin', void 0);
    return Navigator;
})(BaseModuleInstance);

var CHART_NAVIGATOR_MODULE = {
    type: 'root',
    optionsKey: 'navigator',
    packageType: 'community',
    chartTypes: ['cartesian'],
    instanceConstructor: Navigator,
    themeTemplate: {
        navigator: {
            enabled: false,
            height: 30,
            mask: {
                fill: '#999999',
                stroke: '#999999',
                strokeWidth: 1,
                fillOpacity: 0.2,
            },
            minHandle: {
                fill: '#f2f2f2',
                stroke: '#999999',
                strokeWidth: 1,
                width: 8,
                height: 16,
                gripLineGap: 2,
                gripLineLength: 8,
            },
            maxHandle: {
                fill: '#f2f2f2',
                stroke: '#999999',
                strokeWidth: 1,
                width: 8,
                height: 16,
                gripLineGap: 2,
                gripLineLength: 8,
            },
        },
    },
};
registerModule(CHART_NAVIGATOR_MODULE);

var __extends$1K =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1e =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var Background = /** @class */ (function (_super) {
    __extends$1K(Background, _super);
    function Background(ctx) {
        var _a;
        var _this = _super.call(this) || this;
        _this.onLayoutComplete = function (e) {
            var _a = e.chart,
                width = _a.width,
                height = _a.height;
            _this.rectNode.width = width;
            _this.rectNode.height = height;
        };
        _this.node = new Group({ name: 'background' });
        _this.node.zIndex = Layers.SERIES_BACKGROUND_ZINDEX;
        _this.rectNode = new Rect();
        _this.node.appendChild(_this.rectNode);
        _this.fill = 'white';
        _this.visible = true;
        (_a = ctx.scene.root) === null || _a === void 0 ? void 0 : _a.appendChild(_this.node);
        _this.destroyFns.push(function () {
            var _a;
            return (_a = ctx.scene.root) === null || _a === void 0 ? void 0 : _a.removeChild(_this.node);
        });
        var layoutHandle = ctx.layoutService.addListener('layout-complete', _this.onLayoutComplete);
        _this.destroyFns.push(function () {
            return ctx.layoutService.removeListener(layoutHandle);
        });
        return _this;
    }
    __decorate$1e(
        [Validate(BOOLEAN), ProxyPropertyOnWrite('node', 'visible')],
        Background.prototype,
        'visible',
        void 0,
    );
    __decorate$1e(
        [Validate(OPT_COLOR_STRING), ProxyPropertyOnWrite('rectNode', 'fill')],
        Background.prototype,
        'fill',
        void 0,
    );
    return Background;
})(BaseModuleInstance);

var CHART_BACKGROUND_MODULE = {
    type: 'root',
    optionsKey: 'background',
    packageType: 'community',
    chartTypes: ['cartesian', 'polar', 'hierarchy'],
    instanceConstructor: Background,
};
registerModule(CHART_BACKGROUND_MODULE);

var __values$a =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function setupModules() {
    var e_1, _a, e_2, _b, e_3, _c;
    try {
        for (
            var REGISTERED_MODULES_1 = __values$a(REGISTERED_MODULES),
                REGISTERED_MODULES_1_1 = REGISTERED_MODULES_1.next();
            !REGISTERED_MODULES_1_1.done;
            REGISTERED_MODULES_1_1 = REGISTERED_MODULES_1.next()
        ) {
            var m = REGISTERED_MODULES_1_1.value;
            if (JSON_APPLY_PLUGINS.constructors != null && m.optionConstructors != null) {
                Object.assign(JSON_APPLY_PLUGINS.constructors, m.optionConstructors);
            }
            if (m.type === 'root') {
                if (m.themeTemplate) {
                    try {
                        for (
                            var _d = ((e_2 = void 0), __values$a(m.chartTypes)), _e = _d.next();
                            !_e.done;
                            _e = _d.next()
                        ) {
                            var chartType = _e.value;
                            registerChartDefaults(chartType, m.themeTemplate);
                        }
                    } catch (e_2_1) {
                        e_2 = { error: e_2_1 };
                    } finally {
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        } finally {
                            if (e_2) throw e_2.error;
                        }
                    }
                }
            }
            if (m.type === 'series') {
                if (m.chartTypes.length > 1) throw new Error('AG Charts - Module definition error: ' + m.identifier);
                registerSeries(
                    m.identifier,
                    m.chartTypes[0],
                    m.instanceConstructor,
                    m.seriesDefaults,
                    m.themeTemplate,
                    m.paletteFactory,
                );
            }
            if (m.type === 'axis-option') {
                if (m.themeTemplate) {
                    try {
                        for (
                            var _f = ((e_3 = void 0), __values$a(m.axisTypes)), _g = _f.next();
                            !_g.done;
                            _g = _f.next()
                        ) {
                            var axisType = _g.value;
                            registerAxisThemeTemplate(axisType, m.themeTemplate);
                        }
                    } catch (e_3_1) {
                        e_3 = { error: e_3_1 };
                    } finally {
                        try {
                            if (_g && !_g.done && (_c = _f.return)) _c.call(_f);
                        } finally {
                            if (e_3) throw e_3.error;
                        }
                    }
                }
            }
            if (m.type === 'axis') {
                registerAxis(m.identifier, m.instanceConstructor);
                if (m.themeTemplate) {
                    registerAxisThemeTemplate(m.identifier, m.themeTemplate);
                }
            }
            if (m.type === 'legend') {
                registerLegend(m.identifier, m.instanceConstructor);
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (REGISTERED_MODULES_1_1 && !REGISTERED_MODULES_1_1.done && (_a = REGISTERED_MODULES_1.return))
                _a.call(REGISTERED_MODULES_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
}

var __assign$r =
    (undefined && undefined.__assign) ||
    function () {
        __assign$r =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$r.apply(this, arguments);
    };
var __awaiter =
    (undefined && undefined.__awaiter) ||
    function (thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P
                ? value
                : new P(function (resolve) {
                      resolve(value);
                  });
        }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator['throw'](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
var __generator =
    (undefined && undefined.__generator) ||
    function (thisArg, body) {
        var _ = {
                label: 0,
                sent: function () {
                    if (t[0] & 1) throw t[1];
                    return t[1];
                },
                trys: [],
                ops: [],
            },
            f,
            y,
            t,
            g;
        return (
            (g = { next: verb(0), throw: verb(1), return: verb(2) }),
            typeof Symbol === 'function' &&
                (g[Symbol.iterator] = function () {
                    return this;
                }),
            g
        );
        function verb(n) {
            return function (v) {
                return step([n, v]);
            };
        }
        function step(op) {
            if (f) throw new TypeError('Generator is already executing.');
            while (_)
                try {
                    if (
                        ((f = 1),
                        y &&
                            (t =
                                op[0] & 2
                                    ? y['return']
                                    : op[0]
                                    ? y['throw'] || ((t = y['return']) && t.call(y), 0)
                                    : y.next) &&
                            !(t = t.call(y, op[1])).done)
                    )
                        return t;
                    if (((y = 0), t)) op = [op[0] & 2, t.value];
                    switch (op[0]) {
                        case 0:
                        case 1:
                            t = op;
                            break;
                        case 4:
                            _.label++;
                            return { value: op[1], done: false };
                        case 5:
                            _.label++;
                            y = op[1];
                            op = [0];
                            continue;
                        case 7:
                            op = _.ops.pop();
                            _.trys.pop();
                            continue;
                        default:
                            if (
                                !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                                (op[0] === 6 || op[0] === 2)
                            ) {
                                _ = 0;
                                continue;
                            }
                            if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                                _.label = op[1];
                                break;
                            }
                            if (op[0] === 6 && _.label < t[1]) {
                                _.label = t[1];
                                t = op;
                                break;
                            }
                            if (t && _.label < t[2]) {
                                _.label = t[2];
                                _.ops.push(op);
                                break;
                            }
                            if (t[2]) _.ops.pop();
                            _.trys.pop();
                            continue;
                    }
                    op = body.call(thisArg, _);
                } catch (e) {
                    op = [6, e];
                    y = 0;
                } finally {
                    f = t = 0;
                }
            if (op[0] & 5) throw op[1];
            return { value: op[0] ? op[1] : void 0, done: true };
        }
    };
var __read$q =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$e =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$9 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function chartType(options) {
    if (isAgCartesianChartOptions(options)) {
        return 'cartesian';
    } else if (isAgPolarChartOptions(options)) {
        return 'polar';
    } else if (isAgHierarchyChartOptions(options)) {
        return 'hierarchy';
    }
    throw new Error('AG Chart - unknown type of chart for options with type: ' + options.type);
}
/**
 * Factory for creating and updating instances of AgChartInstance.
 *
 * @docsInterface
 */
var AgChart = /** @class */ (function () {
    function AgChart() {}
    /**
     * Create a new `AgChartInstance` based upon the given configuration options.
     */
    AgChart.create = function (options) {
        return AgChartInternal.createOrUpdate(options);
    };
    /**
     * Update an existing `AgChartInstance`. Options provided should be complete and not
     * partial.
     * <br/>
     * <br/>
     * **NOTE**: As each call could trigger a chart redraw, multiple calls to update options in
     * quick succession could result in undesirable flickering, so callers should batch up and/or
     * debounce changes to avoid unintended partial update renderings.
     */
    AgChart.update = function (chart, options) {
        if (!AgChartInstanceProxy.isInstance(chart)) {
            throw new Error('AG Charts - invalid chart reference passed');
        }
        AgChartInternal.createOrUpdate(options, chart);
    };
    /**
     * Update an existing `AgChartInstance` by applying a partial set of option changes.
     * <br/>
     * <br/>
     * **NOTE**: As each call could trigger a chart redraw, each individual delta options update
     * should leave the chart in a valid options state. Also, multiple calls to update options in
     * quick succession could result in undesirable flickering, so callers should batch up and/or
     * debounce changes to avoid unintended partial update renderings.
     */
    AgChart.updateDelta = function (chart, deltaOptions) {
        if (!AgChartInstanceProxy.isInstance(chart)) {
            throw new Error('AG Charts - invalid chart reference passed');
        }
        return AgChartInternal.updateUserDelta(chart, deltaOptions);
    };
    /**
     * Starts a browser-based image download for the given `AgChartInstance`.
     */
    AgChart.download = function (chart, options) {
        if (!(chart instanceof AgChartInstanceProxy)) {
            throw new Error('AG Charts - invalid chart reference passed');
        }
        return AgChartInternal.download(chart, options);
    };
    /**
     * Returns a base64-encoded image data URL for the given `AgChartInstance`.
     */
    AgChart.getImageDataURL = function (chart, options) {
        if (!(chart instanceof AgChartInstanceProxy)) {
            throw new Error('AG Charts - invalid chart reference passed');
        }
        return AgChartInternal.getImageDataURL(chart, options);
    };
    return AgChart;
})();
/**
 * Proxy class, to allow library users to keep a stable reference to their chart, even if we need
 * to switch concrete class (e.g. when switching between CartesianChart vs. PolarChart).
 */
var AgChartInstanceProxy = /** @class */ (function () {
    function AgChartInstanceProxy(chart) {
        this.chart = chart;
    }
    AgChartInstanceProxy.isInstance = function (x) {
        var _a, _b;
        if (x instanceof AgChartInstanceProxy) {
            // Simple case.
            return true;
        }
        if (
            ((_a = x.constructor) === null || _a === void 0 ? void 0 : _a.name) === 'AgChartInstanceProxy' &&
            x.chart != null
        ) {
            // instanceof can fail if mixing bundles (e.g. grid all-modules vs. standalone).
            return true;
        }
        var signatureProps = Object.keys((_b = x.constructor) === null || _b === void 0 ? void 0 : _b.prototype);
        var heuristicTypeCheck = Object.keys(AgChartInstanceProxy.prototype).every(function (prop) {
            return signatureProps.includes(prop);
        });
        if (heuristicTypeCheck && x.chart != null) {
            // minimised code case - the constructor name is mangled but prototype names are not :P
            return true;
        }
        return false;
    };
    AgChartInstanceProxy.prototype.getOptions = function () {
        return this.chart.getOptions();
    };
    AgChartInstanceProxy.prototype.destroy = function () {
        this.chart.destroy();
    };
    return AgChartInstanceProxy;
})();
var AgChartInternal = /** @class */ (function () {
    function AgChartInternal() {}
    AgChartInternal.initialiseModules = function () {
        if (AgChartInternal.initialised) return;
        setupModules();
        AgChartInternal.initialised = true;
    };
    AgChartInternal.createOrUpdate = function (userOptions, proxy) {
        var _this = this;
        AgChartInternal.initialiseModules();
        debug('>>> AgChartV2.createOrUpdate() user options', userOptions);
        var mixinOpts = {};
        if (AgChartInternal.DEBUG() === true) {
            mixinOpts['debug'] = true;
        }
        var overrideDevicePixelRatio = userOptions.overrideDevicePixelRatio;
        delete userOptions['overrideDevicePixelRatio'];
        var processedOptions = prepareOptions(userOptions, mixinOpts);
        var chart = proxy === null || proxy === void 0 ? void 0 : proxy.chart;
        if (chart == null || chartType(userOptions) !== chartType(chart.processedOptions)) {
            chart = AgChartInternal.createChartInstance(processedOptions, overrideDevicePixelRatio, chart);
        }
        if (proxy == null) {
            proxy = new AgChartInstanceProxy(chart);
        } else {
            proxy.chart = chart;
        }
        var chartToUpdate = chart;
        chartToUpdate.queuedUserOptions.push(userOptions);
        var dequeue = function () {
            // If there are a lot of update calls, `requestFactoryUpdate()` may skip callbacks,
            // so we need to remove all queue items up to the last successfully applied item.
            var queuedOptionsIdx = chartToUpdate.queuedUserOptions.indexOf(userOptions);
            chartToUpdate.queuedUserOptions.splice(0, queuedOptionsIdx);
        };
        chartToUpdate.requestFactoryUpdate(function () {
            return __awaiter(_this, void 0, void 0, function () {
                var deltaOptions;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // Chart destroyed, skip processing.
                            if (chartToUpdate.destroyed) return [2 /*return*/];
                            deltaOptions = jsonDiff(chartToUpdate.processedOptions, processedOptions);
                            if (deltaOptions == null) {
                                dequeue();
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, AgChartInternal.updateDelta(chartToUpdate, deltaOptions, userOptions)];
                        case 1:
                            _a.sent();
                            dequeue();
                            return [2 /*return*/];
                    }
                });
            });
        });
        return proxy;
    };
    AgChartInternal.updateUserDelta = function (proxy, deltaOptions) {
        var _a;
        var chart = proxy.chart,
            queuedUserOptions = proxy.chart.queuedUserOptions;
        var lastUpdateOptions =
            (_a = queuedUserOptions[queuedUserOptions.length - 1]) !== null && _a !== void 0 ? _a : chart.userOptions;
        var userOptions = jsonMerge([lastUpdateOptions, deltaOptions]);
        debug('>>> AgChartV2.updateUserDelta() user delta', deltaOptions);
        debug('AgChartV2.updateUserDelta() - base options', lastUpdateOptions);
        AgChartInternal.createOrUpdate(userOptions, proxy);
    };
    /**
     * Returns the content of the current canvas as an image.
     * @param opts The download options including `width` and `height` of the image as well as `fileName` and `fileFormat`.
     */
    AgChartInternal.download = function (proxy, opts) {
        var _this = this;
        var asyncDownload = function () {
            return __awaiter(_this, void 0, void 0, function () {
                var maybeClone, chart;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            return [4 /*yield*/, AgChartInternal.prepareResizedChart(proxy, opts)];
                        case 1:
                            maybeClone = _a.sent();
                            chart = maybeClone.chart;
                            chart.scene.download(
                                opts === null || opts === void 0 ? void 0 : opts.fileName,
                                opts === null || opts === void 0 ? void 0 : opts.fileFormat,
                            );
                            if (maybeClone !== proxy) {
                                maybeClone.destroy();
                            }
                            return [2 /*return*/];
                    }
                });
            });
        };
        asyncDownload().catch(function (e) {
            return Logger.errorOnce(e);
        });
    };
    AgChartInternal.getImageDataURL = function (proxy, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var maybeClone, chart, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        return [4 /*yield*/, AgChartInternal.prepareResizedChart(proxy, opts)];
                    case 1:
                        maybeClone = _a.sent();
                        chart = maybeClone.chart;
                        result = chart.scene.canvas.getDataURL(
                            opts === null || opts === void 0 ? void 0 : opts.fileFormat,
                        );
                        if (maybeClone !== proxy) {
                            maybeClone.destroy();
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AgChartInternal.prepareResizedChart = function (proxy, opts) {
        return __awaiter(this, void 0, void 0, function () {
            var chart, _a, width, height, currentWidth, currentHeight, unchanged, options, clonedChart;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        chart = proxy.chart;
                        (_a = opts !== null && opts !== void 0 ? opts : {}), (width = _a.width), (height = _a.height);
                        currentWidth = chart.width;
                        currentHeight = chart.height;
                        unchanged =
                            (width === undefined && height === undefined) ||
                            (chart.scene.canvas.pixelRatio === 1 && currentWidth === width && currentHeight === height);
                        if (unchanged) {
                            return [2 /*return*/, proxy];
                        }
                        width = width !== null && width !== void 0 ? width : currentWidth;
                        height = height !== null && height !== void 0 ? height : currentHeight;
                        options = __assign$r(__assign$r({}, chart.userOptions), {
                            container: document.createElement('div'),
                            width: width,
                            height: height,
                            autoSize: false,
                            overrideDevicePixelRatio: 1,
                        });
                        clonedChart = AgChartInternal.createOrUpdate(options);
                        return [4 /*yield*/, clonedChart.chart.waitForUpdate()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, clonedChart];
                }
            });
        });
    };
    AgChartInternal.createChartInstance = function (options, overrideDevicePixelRatio, oldChart) {
        var transferableResource =
            oldChart === null || oldChart === void 0 ? void 0 : oldChart.destroy({ keepTransferableResources: true });
        if (isAgCartesianChartOptions(options)) {
            return new CartesianChart(document, overrideDevicePixelRatio, transferableResource);
        } else if (isAgHierarchyChartOptions(options)) {
            return new HierarchyChart(document, overrideDevicePixelRatio, transferableResource);
        } else if (isAgPolarChartOptions(options)) {
            return new PolarChart(document, overrideDevicePixelRatio, transferableResource);
        }
        throw new Error("AG Charts - couldn't apply configuration, check type of options: " + options['type']);
    };
    AgChartInternal.updateDelta = function (chart, processedOptions, userOptions) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (processedOptions.type == null) {
                            processedOptions = __assign$r(__assign$r({}, processedOptions), {
                                type:
                                    (_a = chart.processedOptions.type) !== null && _a !== void 0
                                        ? _a
                                        : optionsType(processedOptions),
                            });
                        }
                        return [4 /*yield*/, chart.awaitUpdateCompletion()];
                    case 1:
                        _b.sent();
                        if (chart.destroyed) return [2 /*return*/];
                        debug('AgChartV2.updateDelta() - applying delta', processedOptions);
                        applyChartOptions(chart, processedOptions, userOptions);
                        return [2 /*return*/];
                }
            });
        });
    };
    AgChartInternal.DEBUG = function () {
        var _a;
        return (_a = windowValue('agChartsDebug')) !== null && _a !== void 0 ? _a : false;
    };
    AgChartInternal.initialised = false;
    return AgChartInternal;
})();
function debug(message) {
    var optionalParams = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        optionalParams[_i - 1] = arguments[_i];
    }
    if ([true, 'opts'].includes(AgChartInternal.DEBUG())) {
        Logger.debug.apply(Logger, __spreadArray$e([message], __read$q(optionalParams)));
    }
}
function applyChartOptions(chart, processedOptions, userOptions) {
    var _a, _b, _c, _d;
    var completeOptions = jsonMerge(
        [(_a = chart.processedOptions) !== null && _a !== void 0 ? _a : {}, processedOptions],
        noDataCloneMergeOptions,
    );
    var modulesChanged = applyModules(chart, completeOptions);
    var skip = ['type', 'data', 'series', 'listeners', 'theme', 'legend'];
    if (isAgCartesianChartOptions(processedOptions) || isAgPolarChartOptions(processedOptions)) {
        // Append axes to defaults.
        skip.push('axes');
    } else if (isAgHierarchyChartOptions(processedOptions));
    else {
        throw new Error(
            "AG Charts - couldn't apply configuration, check type of options and chart: " + processedOptions['type'],
        );
    }
    // Needs to be done before applying the series to detect if a seriesNode[Double]Click listener has been added
    if (processedOptions.listeners) {
        registerListeners(chart, processedOptions.listeners);
    }
    applyOptionValues(chart, processedOptions, { skip: skip });
    var forceNodeDataRefresh = false;
    if (processedOptions.series && processedOptions.series.length > 0) {
        applySeries(chart, processedOptions);
        forceNodeDataRefresh = true;
    }
    if ('axes' in processedOptions && Array.isArray(processedOptions.axes)) {
        var axesPresent = applyAxes(chart, processedOptions);
        if (axesPresent) {
            forceNodeDataRefresh = true;
        }
    }
    applyLegend(chart, processedOptions);
    var seriesOpts = processedOptions.series;
    var seriesDataUpdate =
        !!processedOptions.data ||
        (seriesOpts === null || seriesOpts === void 0
            ? void 0
            : seriesOpts.some(function (s) {
                  return s.data != null;
              }));
    var otherRefreshUpdate =
        (_c = (_b = processedOptions.legend) !== null && _b !== void 0 ? _b : processedOptions.title) !== null &&
        _c !== void 0
            ? _c
            : processedOptions.subtitle;
    forceNodeDataRefresh = forceNodeDataRefresh || seriesDataUpdate || !!otherRefreshUpdate;
    if (processedOptions.data) {
        chart.data = processedOptions.data;
    }
    if (processedOptions.listeners) {
        chart.updateAllSeriesListeners();
    }
    chart.processedOptions = completeOptions;
    chart.userOptions = jsonMerge(
        [(_d = chart.userOptions) !== null && _d !== void 0 ? _d : {}, userOptions],
        noDataCloneMergeOptions,
    );
    var majorChange = forceNodeDataRefresh || modulesChanged;
    var updateType = majorChange ? ChartUpdateType.PROCESS_DATA : ChartUpdateType.PERFORM_LAYOUT;
    debug('AgChartV2.applyChartOptions() - update type', ChartUpdateType[updateType]);
    chart.update(updateType, { forceNodeDataRefresh: forceNodeDataRefresh });
}
function applyModules(chart, options) {
    var e_1, _a;
    var matchingChartType = function (module) {
        return (
            (chart instanceof CartesianChart && module.chartTypes.includes('cartesian')) ||
            (chart instanceof PolarChart && module.chartTypes.includes('polar')) ||
            (chart instanceof HierarchyChart && module.chartTypes.includes('hierarchy'))
        );
    };
    var modulesChanged = false;
    var rootModules = REGISTERED_MODULES.filter(function (m) {
        return m.type === 'root';
    });
    try {
        for (
            var rootModules_1 = __values$9(rootModules), rootModules_1_1 = rootModules_1.next();
            !rootModules_1_1.done;
            rootModules_1_1 = rootModules_1.next()
        ) {
            var next = rootModules_1_1.value;
            var shouldBeEnabled = matchingChartType(next) && options[next.optionsKey] != null;
            var isEnabled = chart.isModuleEnabled(next);
            if (shouldBeEnabled === isEnabled) continue;
            modulesChanged = true;
            if (shouldBeEnabled) {
                chart.addModule(next);
            } else {
                chart.removeModule(next);
            }
        }
    } catch (e_1_1) {
        e_1 = { error: e_1_1 };
    } finally {
        try {
            if (rootModules_1_1 && !rootModules_1_1.done && (_a = rootModules_1.return)) _a.call(rootModules_1);
        } finally {
            if (e_1) throw e_1.error;
        }
    }
    return modulesChanged;
}
function applySeries(chart, options) {
    var optSeries = options.series;
    if (!optSeries) {
        return;
    }
    var matchingTypes =
        chart.series.length === optSeries.length &&
        chart.series.every(function (s, i) {
            var _a;
            return s.type === ((_a = optSeries[i]) === null || _a === void 0 ? void 0 : _a.type);
        });
    // Try to optimise series updates if series count and types didn't change.
    if (matchingTypes) {
        chart.series.forEach(function (s, i) {
            var _a, _b, _c, _d;
            var previousOpts =
                (_c =
                    (_b = (_a = chart.processedOptions) === null || _a === void 0 ? void 0 : _a.series) === null ||
                    _b === void 0
                        ? void 0
                        : _b[i]) !== null && _c !== void 0
                    ? _c
                    : {};
            var seriesDiff = jsonDiff(previousOpts, (_d = optSeries[i]) !== null && _d !== void 0 ? _d : {});
            if (!seriesDiff) {
                return;
            }
            debug('AgChartV2.applySeries() - applying series diff idx ' + i, seriesDiff);
            applySeriesValues(s, seriesDiff, { path: 'series[' + i + ']', index: i });
            s.markNodeDataDirty();
        });
        return;
    }
    chart.series = createSeries(chart, optSeries);
}
function applyAxes(chart, options) {
    var optAxes = options.axes;
    if (!optAxes) {
        return false;
    }
    var matchingTypes =
        chart.axes.length === optAxes.length &&
        chart.axes.every(function (a, i) {
            return a.type === optAxes[i].type;
        });
    // Try to optimise series updates if series count and types didn't change.
    if (matchingTypes) {
        var oldOpts_1 = chart.processedOptions;
        if (isAgCartesianChartOptions(oldOpts_1)) {
            chart.axes.forEach(function (a, i) {
                var _a, _b;
                var previousOpts =
                    (_b = (_a = oldOpts_1.axes) === null || _a === void 0 ? void 0 : _a[i]) !== null && _b !== void 0
                        ? _b
                        : {};
                var axisDiff = jsonDiff(previousOpts, optAxes[i]);
                debug('AgChartV2.applyAxes() - applying axis diff idx ' + i, axisDiff);
                var path = 'axes[' + i + ']';
                var skip = ['axes[].type'];
                applyOptionValues(a, axisDiff, { path: path, skip: skip });
            });
            return true;
        }
    }
    chart.axes = createAxis(chart, optAxes);
    return true;
}
function applyLegend(chart, options) {
    var skip = ['listeners'];
    chart.setLegendInit(function (legend) {
        var _a, _b, _c, _d;
        applyOptionValues(legend, (_a = options.legend) !== null && _a !== void 0 ? _a : {}, { skip: skip });
        if ((_b = options.legend) === null || _b === void 0 ? void 0 : _b.listeners) {
            Object.assign(
                (_c = chart.legend) === null || _c === void 0 ? void 0 : _c.listeners,
                (_d = options.legend.listeners) !== null && _d !== void 0 ? _d : {},
            );
        }
    });
}
function createSeries(chart, options) {
    var e_2, _a;
    var _b;
    var series = [];
    var moduleContext = chart.getModuleContext();
    var index = 0;
    try {
        for (
            var _c = __values$9(options !== null && options !== void 0 ? options : []), _d = _c.next();
            !_d.done;
            _d = _c.next()
        ) {
            var seriesOptions = _d.value;
            var path = 'series[' + index++ + ']';
            var seriesInstance = getSeries(
                (_b = seriesOptions.type) !== null && _b !== void 0 ? _b : 'unknown',
                moduleContext,
            );
            applySeriesValues(seriesInstance, seriesOptions, { path: path, index: index });
            series.push(seriesInstance);
        }
    } catch (e_2_1) {
        e_2 = { error: e_2_1 };
    } finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        } finally {
            if (e_2) throw e_2.error;
        }
    }
    return series;
}
function createAxis(chart, options) {
    var e_3, _a;
    var axes = [];
    var skip = ['axes[].type'];
    var moduleContext = chart.getModuleContext();
    var index = 0;
    try {
        for (
            var _b = __values$9(options !== null && options !== void 0 ? options : []), _c = _b.next();
            !_c.done;
            _c = _b.next()
        ) {
            var axisOptions = _c.value;
            var axis = getAxis(axisOptions.type, moduleContext);
            var path = 'axes[' + index++ + ']';
            applyAxisModules(axis, axisOptions);
            applyOptionValues(axis, axisOptions, { path: path, skip: skip });
            axes.push(axis);
        }
    } catch (e_3_1) {
        e_3 = { error: e_3_1 };
    } finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally {
            if (e_3) throw e_3.error;
        }
    }
    return axes;
}
function applyAxisModules(axis, options) {
    var e_4, _a;
    var modulesChanged = false;
    var rootModules = REGISTERED_MODULES.filter(function (m) {
        return m.type === 'axis-option';
    });
    try {
        for (
            var rootModules_2 = __values$9(rootModules), rootModules_2_1 = rootModules_2.next();
            !rootModules_2_1.done;
            rootModules_2_1 = rootModules_2.next()
        ) {
            var next = rootModules_2_1.value;
            var shouldBeEnabled = options[next.optionsKey] != null;
            var isEnabled = axis.isModuleEnabled(next);
            if (shouldBeEnabled === isEnabled) continue;
            modulesChanged = true;
            if (shouldBeEnabled) {
                axis.addModule(next);
            } else {
                axis.removeModule(next);
            }
        }
    } catch (e_4_1) {
        e_4 = { error: e_4_1 };
    } finally {
        try {
            if (rootModules_2_1 && !rootModules_2_1.done && (_a = rootModules_2.return)) _a.call(rootModules_2);
        } finally {
            if (e_4) throw e_4.error;
        }
    }
    return modulesChanged;
}
function registerListeners(source, listeners) {
    source.clearEventListeners();
    for (var property in listeners) {
        var listener = listeners[property];
        if (typeof listener !== 'function') continue;
        source.addEventListener(property, listener);
    }
}
function applyOptionValues(target, options, _a) {
    var _b = _a === void 0 ? {} : _a,
        skip = _b.skip,
        path = _b.path;
    var applyOpts = __assign$r(
        __assign$r(__assign$r({}, getJsonApplyOptions()), { skip: skip }),
        path ? { path: path } : {},
    );
    return jsonApply(target, options, applyOpts);
}
function applySeriesValues(target, options, _a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a,
        path = _d.path,
        index = _d.index;
    var skip = ['series[].listeners', 'series[].seriesGrouping'];
    var jsonApplyOptions = getJsonApplyOptions();
    var ctrs = (_b = jsonApplyOptions.constructors) !== null && _b !== void 0 ? _b : {};
    var seriesTypeOverrides = {
        constructors: __assign$r(__assign$r({}, ctrs), { title: target.type === 'pie' ? PieTitle : ctrs['title'] }),
    };
    var applyOpts = __assign$r(
        __assign$r(
            __assign$r(__assign$r(__assign$r({}, jsonApplyOptions), seriesTypeOverrides), {
                skip: __spreadArray$e(['series[].type'], __read$q(skip !== null && skip !== void 0 ? skip : [])),
            }),
            path ? { path: path } : {},
        ),
        { idx: index !== null && index !== void 0 ? index : -1 },
    );
    var result = jsonApply(target, options, applyOpts);
    var listeners = options === null || options === void 0 ? void 0 : options.listeners;
    if (listeners != null) {
        registerListeners(target, listeners);
    }
    var seriesGrouping = options.seriesGrouping;
    if ('seriesGrouping' in (options !== null && options !== void 0 ? options : {})) {
        if (seriesGrouping) {
            var newSeriesGroup = Object.freeze(
                __assign$r(
                    __assign$r({}, (_c = target.seriesGrouping) !== null && _c !== void 0 ? _c : {}),
                    seriesGrouping,
                ),
            );
            target.seriesGrouping = newSeriesGroup;
        } else {
            target.seriesGrouping = seriesGrouping;
        }
    }
    return result;
}

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$b = '8.2.0';

var __extends$1J =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1d =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ArcType;
(function (ArcType) {
    ArcType[(ArcType['Open'] = 0)] = 'Open';
    ArcType[(ArcType['Chord'] = 1)] = 'Chord';
    ArcType[(ArcType['Round'] = 2)] = 'Round';
})(ArcType || (ArcType = {}));
/**
 * Elliptical arc node.
 */
var Arc = /** @class */ (function (_super) {
    __extends$1J(Arc, _super);
    function Arc() {
        var _this = _super.call(this) || this;
        _this.centerX = 0;
        _this.centerY = 0;
        _this.radius = 10;
        _this.startAngle = 0;
        _this.endAngle = Math.PI * 2;
        _this.counterClockwise = false;
        /**
         * The type of arc to render:
         * - {@link ArcType.Open} - end points of the arc segment are not connected (default)
         * - {@link ArcType.Chord} - end points of the arc segment are connected by a line segment
         * - {@link ArcType.Round} - each of the end points of the arc segment are connected
         *                           to the center of the arc
         * Arcs with {@link ArcType.Open} do not support hit testing, even if they have their
         * {@link Shape.fillStyle} set, because they are not closed paths. Hit testing support
         * would require using two paths - one for rendering, another for hit testing - and there
         * doesn't seem to be a compelling reason to do that, when one can just use {@link ArcType.Chord}
         * to create a closed path.
         */
        _this.type = ArcType.Open;
        _this.restoreOwnStyles();
        return _this;
    }
    Object.defineProperty(Arc.prototype, 'fullPie', {
        get: function () {
            return isEqual(normalizeAngle360(this.startAngle), normalizeAngle360(this.endAngle));
        },
        enumerable: false,
        configurable: true,
    });
    Arc.prototype.updatePath = function () {
        var path = this.path;
        path.clear(); // No need to recreate the Path, can simply clear the existing one.
        path.arc(this.centerX, this.centerY, this.radius, this.startAngle, this.endAngle, this.counterClockwise);
        if (this.type === ArcType.Chord) {
            path.closePath();
        } else if (this.type === ArcType.Round && !this.fullPie) {
            path.lineTo(this.centerX, this.centerY);
            path.closePath();
        }
    };
    Arc.prototype.computeBBox = function () {
        // Only works with full arcs (circles) and untransformed ellipses.
        return new BBox(this.centerX - this.radius, this.centerY - this.radius, this.radius * 2, this.radius * 2);
    };
    Arc.prototype.isPointInPath = function (x, y) {
        var point = this.transformPoint(x, y);
        var bbox = this.computeBBox();
        return (
            this.type !== ArcType.Open &&
            bbox.containsPoint(point.x, point.y) &&
            this.path.isPointInPath(point.x, point.y)
        );
    };
    Arc.className = 'Arc';
    Arc.defaultStyles = Object.assign({}, Shape.defaultStyles, {
        lineWidth: 1,
        fillStyle: null,
    });
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'centerX', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'centerY', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'radius', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'startAngle', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'endAngle', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'counterClockwise', void 0);
    __decorate$1d([ScenePathChangeDetection()], Arc.prototype, 'type', void 0);
    return Arc;
})(Path);

var __extends$1I =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1c =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
/** @class */ (function (_super) {
    __extends$1I(Image, _super);
    function Image(sourceImage) {
        var _this = _super.call(this) || this;
        _this.x = 0;
        _this.y = 0;
        _this.width = 0;
        _this.height = 0;
        _this.opacity = 1;
        _this.sourceImage = sourceImage;
        return _this;
    }
    Image.prototype.render = function (renderCtx) {
        var ctx = renderCtx.ctx,
            forceRender = renderCtx.forceRender,
            stats = renderCtx.stats;
        if (this.dirty === RedrawType.NONE && !forceRender) {
            if (stats) stats.nodesSkipped++;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        var image = this.sourceImage;
        ctx.globalAlpha = this.opacity;
        ctx.drawImage(image, 0, 0, image.width, image.height, this.x, this.y, this.width, this.height);
        _super.prototype.render.call(this, renderCtx);
    };
    __decorate$1c([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Image.prototype, 'x', void 0);
    __decorate$1c([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Image.prototype, 'y', void 0);
    __decorate$1c([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Image.prototype, 'width', void 0);
    __decorate$1c([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Image.prototype, 'height', void 0);
    __decorate$1c([SceneChangeDetection({ redraw: RedrawType.MAJOR })], Image.prototype, 'opacity', void 0);
    return Image;
})(Node);

var __read$p =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var themes = Object.entries(themes$1).reduce(function (obj, _a) {
    var _b = __read$p(_a, 2),
        name = _b[0],
        factory = _b[1];
    obj[name] = factory();
    return obj;
}, {});

var VALID_SERIES_TYPES = ['area', 'bar', 'column', 'histogram', 'line', 'pie', 'scatter'];
function getSeriesType(chartType) {
    switch (chartType) {
        case 'bar':
        case 'groupedBar':
        case 'stackedBar':
        case 'normalizedBar':
            return 'bar';
        case 'column':
        case 'groupedColumn':
        case 'stackedColumn':
        case 'normalizedColumn':
            return 'column';
        case 'line':
            return 'line';
        case 'area':
        case 'stackedArea':
        case 'normalizedArea':
            return 'area';
        case 'scatter':
        case 'bubble':
            return 'scatter';
        case 'histogram':
            return 'histogram';
        case 'pie':
        case 'doughnut':
            return 'pie';
        default:
            return 'cartesian';
    }
}

var ALL_AXIS_TYPES = ['number', 'category', 'groupedCategory', 'log', 'time'];
function getLegacyAxisType(chartType) {
    switch (chartType) {
        case 'bar':
        case 'stackedBar':
        case 'normalizedBar':
            return ['number', 'category'];
        case 'groupedBar':
            return ['number', 'groupedCategory'];
        case 'column':
        case 'stackedColumn':
        case 'normalizedColumn':
        case 'line':
        case 'area':
        case 'stackedArea':
        case 'normalizedArea':
        case 'histogram':
            return ['category', 'number'];
        case 'groupedColumn':
            return ['groupedCategory', 'number'];
        case 'scatter':
        case 'bubble':
            return ['number', 'number'];
        default:
            return undefined;
    }
}

var __assign$q =
    (undefined && undefined.__assign) ||
    function () {
        __assign$q =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$q.apply(this, arguments);
    };
function createAgChartTheme(chartProxyParams, proxy) {
    var _a;
    var chartOptionsToRestore = chartProxyParams.chartOptionsToRestore,
        chartPaletteToRestore = chartProxyParams.chartPaletteToRestore,
        chartThemeToRestore = chartProxyParams.chartThemeToRestore;
    var themeName = getSelectedTheme(chartProxyParams);
    var stockTheme = isStockTheme(themeName);
    var rootTheme = stockTheme
        ? { baseTheme: themeName }
        : (_a = lookupCustomChartTheme(chartProxyParams, themeName)) !== null && _a !== void 0
        ? _a
        : {};
    var gridOptionsThemeOverrides = chartProxyParams.getGridOptionsChartThemeOverrides();
    var apiThemeOverrides = chartProxyParams.apiChartThemeOverrides;
    var standaloneChartType = getSeriesType(chartProxyParams.chartType);
    var crossFilterThemeOverridePoint = standaloneChartType === 'pie' ? 'polar' : 'cartesian';
    var crossFilteringOverrides = chartProxyParams.crossFiltering
        ? createCrossFilterThemeOverrides(proxy, chartProxyParams, crossFilterThemeOverridePoint)
        : undefined;
    var formattingPanelOverrides = __assign$q(
        {},
        chartOptionsToRestore !== null && chartOptionsToRestore !== void 0 ? chartOptionsToRestore : {},
    );
    var isTitleEnabled = function () {
        var isTitleEnabled = function (obj) {
            if (!obj) {
                return false;
            }
            return Object.keys(obj).some(function (key) {
                return _.get(obj[key], 'title.enabled', false);
            });
        };
        return isTitleEnabled(gridOptionsThemeOverrides) || isTitleEnabled(apiThemeOverrides);
    };
    // Overrides in ascending precedence ordering.
    var overrides = [
        stockTheme ? inbuiltStockThemeOverrides(chartProxyParams, isTitleEnabled()) : undefined,
        crossFilteringOverrides,
        gridOptionsThemeOverrides,
        apiThemeOverrides,
        formattingPanelOverrides,
    ];
    // Recursively nest theme overrides so they are applied with correct precedence in
    // Standalone Charts - this is an undocumented feature.
    // Outermost theme overrides will be the formatting panel configured values, so they are
    // differentiated from grid-config and inbuilt overrides.
    var theme = overrides
        .filter(function (v) {
            return !!v;
        })
        .reduce(function (r, n) {
            return {
                baseTheme: r,
                overrides: n,
            };
        }, rootTheme);
    // Avoid explicitly setting the `theme.palette` property unless we're using the restored theme
    // AND the palette is actually different.
    if (chartPaletteToRestore && themeName === chartThemeToRestore) {
        var rootThemePalette = getChartTheme(rootTheme).palette;
        if (!isIdenticalPalette(chartPaletteToRestore, rootThemePalette)) {
            theme.palette = chartPaletteToRestore;
        }
    }
    return theme;
}
function isIdenticalPalette(paletteA, paletteB) {
    var arrayCompare = function (arrA, arrB) {
        if (arrA.length !== arrB.length) return false;
        return arrA.every(function (v, i) {
            return v === arrB[i];
        });
    };
    return arrayCompare(paletteA.fills, paletteB.fills) && arrayCompare(paletteA.strokes, paletteB.strokes);
}
function isStockTheme(themeName) {
    return _.includes(Object.keys(themes), themeName);
}
function createCrossFilterThemeOverrides(proxy, chartProxyParams, overrideType) {
    var _a;
    var legend = {
        listeners: {
            legendItemClick: function (e) {
                var chart = proxy.getChart();
                chart.series.forEach(function (s) {
                    s.toggleSeriesItem(e.itemId, e.enabled);
                    s.toggleSeriesItem(e.itemId + '-filtered-out', e.enabled);
                });
            },
        },
    };
    var series = {};
    if (overrideType === 'polar') {
        series.pie = {
            tooltip: {
                renderer: function (_a) {
                    var angleName = _a.angleName,
                        datum = _a.datum,
                        calloutLabelKey = _a.calloutLabelKey,
                        radiusKey = _a.radiusKey,
                        angleValue = _a.angleValue;
                    var title = angleName;
                    var label = datum[calloutLabelKey];
                    var ratio = datum[radiusKey];
                    var totalValue = angleValue;
                    return { title: title, content: label + ': ' + totalValue * ratio };
                },
            },
        };
    }
    return (
        (_a = {}),
        (_a[overrideType] = {
            tooltip: {
                delay: 500,
            },
            legend: legend,
            listeners: {
                click: function (e) {
                    return chartProxyParams.crossFilterCallback(e, true);
                },
            },
            series: series,
        }),
        _a
    );
}
var STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES = ALL_AXIS_TYPES.reduce(function (r, n) {
    var _a;
    return __assign$q(__assign$q({}, r), ((_a = {}), (_a[n] = { title: { _enabledFromTheme: true } }), _a));
}, {});
function inbuiltStockThemeOverrides(params, titleEnabled) {
    var extraPadding = params.getExtraPaddingDirections();
    return {
        common: {
            axes: STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES,
            padding: {
                // don't add extra padding when a title is present!
                top: !titleEnabled && extraPadding.includes('top') ? 40 : 20,
                right: extraPadding.includes('right') ? 30 : 20,
                bottom: extraPadding.includes('bottom') ? 40 : 20,
                left: extraPadding.includes('left') ? 30 : 20,
            },
        },
        pie: {
            series: {
                title: { _enabledFromTheme: true },
                calloutLabel: { _enabledFromTheme: true },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true,
                },
            },
        },
    };
}
function getSelectedTheme(chartProxyParams) {
    var chartThemeName = chartProxyParams.getChartThemeName();
    var availableThemes = chartProxyParams.getChartThemes();
    if (!_.includes(availableThemes, chartThemeName)) {
        chartThemeName = availableThemes[0];
    }
    return chartThemeName;
}
function lookupCustomChartTheme(chartProxyParams, name) {
    var customChartThemes = chartProxyParams.customChartThemes;
    var customChartTheme = customChartThemes && customChartThemes[name];
    if (!customChartTheme) {
        console.warn(
            "AG Grid: no stock theme exists with the name '" +
                name +
                "' and no " +
                "custom chart theme with that name was supplied to 'customChartThemes'",
        );
    }
    return customChartTheme;
}

var __read$o =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$d =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$8 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var validateIfDefined = function (validationFn) {
    return function (value) {
        if (value === undefined) return true;
        return validationFn(value);
    };
};
var isString$1 = function (value) {
    return typeof value === 'string';
};
var isBoolean = function (value) {
    return typeof value === 'boolean';
};
var isValidSeriesChartType = function (value) {
    return typeof value === 'object';
};
var createWarnMessage = function (property, expectedType) {
    return function (value) {
        return (
            'AG Grid - unable to update chart as invalid params supplied:  `' +
            property +
            ': ' +
            value +
            '`, expected ' +
            expectedType +
            '.'
        );
    };
};
var UpdateParamsValidator = /** @class */ (function () {
    function UpdateParamsValidator() {}
    UpdateParamsValidator.validateChartParams = function (params) {
        var paramsToValidate = params;
        switch (paramsToValidate.type) {
            case 'rangeChartUpdate':
                return UpdateParamsValidator.validateUpdateRangeChartParams(params);
            case 'pivotChartUpdate':
                return UpdateParamsValidator.validateUpdatePivotChartParams(params);
            case 'crossFilterChartUpdate':
                return UpdateParamsValidator.validateUpdateCrossFilterChartParams(params);
            default:
                console.warn(
                    "AG Grid - Invalid value supplied for 'type': " +
                        params.type +
                        ". It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
                );
                return false;
        }
    };
    UpdateParamsValidator.validateUpdateRangeChartParams = function (params) {
        var validations = __spreadArray$d(
            __spreadArray$d(
                __spreadArray$d([], __read$o(UpdateParamsValidator.commonValidations)),
                __read$o(UpdateParamsValidator.cellRangeValidations),
            ),
            [
                {
                    property: 'seriesChartTypes',
                    validationFn: function (value) {
                        return value === undefined || (Array.isArray(value) && value.every(isValidSeriesChartType));
                    },
                    warnMessage: createWarnMessage('seriesChartTypes', 'Array of SeriesChartType'),
                },
            ],
        );
        return UpdateParamsValidator.validateProperties(
            params,
            validations,
            [
                'type',
                'chartId',
                'chartType',
                'chartThemeName',
                'chartThemeOverrides',
                'unlinkChart',
                'cellRange',
                'suppressChartRanges',
                'aggFunc',
                'seriesChartTypes',
            ],
            'UpdateRangeChartParams',
        );
    };
    UpdateParamsValidator.validateUpdatePivotChartParams = function (params) {
        var validations = __spreadArray$d([], __read$o(UpdateParamsValidator.commonValidations));
        return UpdateParamsValidator.validateProperties(
            params,
            validations,
            ['type', 'chartId', 'chartType', 'chartThemeName', 'chartThemeOverrides', 'unlinkChart'],
            'UpdatePivotChartParams',
        );
    };
    UpdateParamsValidator.validateUpdateCrossFilterChartParams = function (params) {
        var validations = __spreadArray$d(
            __spreadArray$d([], __read$o(UpdateParamsValidator.commonValidations)),
            __read$o(UpdateParamsValidator.cellRangeValidations),
        );
        return UpdateParamsValidator.validateProperties(
            params,
            validations,
            [
                'type',
                'chartId',
                'chartType',
                'chartThemeName',
                'chartThemeOverrides',
                'unlinkChart',
                'cellRange',
                'suppressChartRanges',
                'aggFunc',
            ],
            'UpdateCrossFilterChartParams',
        );
    };
    UpdateParamsValidator.validateProperties = function (params, validations, validPropertyNames, paramsType) {
        var e_1, _a;
        try {
            for (
                var validations_1 = __values$8(validations), validations_1_1 = validations_1.next();
                !validations_1_1.done;
                validations_1_1 = validations_1.next()
            ) {
                var validation = validations_1_1.value;
                var property = validation.property,
                    validationFn = validation.validationFn,
                    warnMessage = validation.warnMessage;
                if (property in params) {
                    var value = params[property];
                    if (!validationFn(value)) {
                        console.warn(warnMessage(value));
                        return false;
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (validations_1_1 && !validations_1_1.done && (_a = validations_1.return)) _a.call(validations_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        // Check for unexpected properties
        for (var property in params) {
            if (!validPropertyNames.includes(property)) {
                console.warn(
                    'AG Grid - Unexpected property supplied. ' + paramsType + ' does not contain: `' + property + '`.',
                );
                return false;
            }
        }
        return true;
    };
    UpdateParamsValidator.validChartTypes = [
        'column',
        'groupedColumn',
        'stackedColumn',
        'normalizedColumn',
        'bar',
        'groupedBar',
        'stackedBar',
        'normalizedBar',
        'line',
        'scatter',
        'bubble',
        'pie',
        'doughnut',
        'area',
        'stackedArea',
        'normalizedArea',
        'histogram',
        'columnLineCombo',
        'areaColumnCombo',
        'customCombo',
    ];
    UpdateParamsValidator.validateChartType = validateIfDefined(function (chartType) {
        return UpdateParamsValidator.validChartTypes.includes(chartType);
    });
    UpdateParamsValidator.validateAgChartThemeOverrides = validateIfDefined(function (themeOverrides) {
        // ensure supplied AgChartThemeOverrides is an object - can be improved if necessary?
        return typeof themeOverrides === 'object';
    });
    UpdateParamsValidator.validateChartParamsCellRange = validateIfDefined(function (cellRange) {
        // ensure supplied ChartParamsCellRange is an object - can be improved if necessary?
        return typeof cellRange === 'object';
    });
    UpdateParamsValidator.validateAggFunc = validateIfDefined(function (aggFunc) {
        // ensure supplied aggFunc is a `string` or `function` - can be improved if necessary?
        return typeof aggFunc === 'string' || typeof aggFunc === 'function';
    });
    UpdateParamsValidator.commonValidations = [
        { property: 'chartId', validationFn: isString$1, warnMessage: createWarnMessage('chartId', 'string') },
        {
            property: 'chartType',
            validationFn: UpdateParamsValidator.validateChartType,
            warnMessage: createWarnMessage('chartType', UpdateParamsValidator.validChartTypes.join(', ')),
        },
        {
            property: 'chartThemeName',
            validationFn: isString$1,
            warnMessage: createWarnMessage('chartThemeName', 'string'),
        },
        {
            property: 'chartThemeOverrides',
            validationFn: UpdateParamsValidator.validateAgChartThemeOverrides,
            warnMessage: createWarnMessage('chartThemeOverrides', 'AgChartThemeOverrides'),
        },
        { property: 'unlinkChart', validationFn: isBoolean, warnMessage: createWarnMessage('unlinkChart', 'boolean') },
    ];
    UpdateParamsValidator.cellRangeValidations = [
        {
            property: 'cellRange',
            validationFn: UpdateParamsValidator.validateChartParamsCellRange,
            warnMessage: createWarnMessage('cellRange', 'ChartParamsCellRange'),
        },
        {
            property: 'suppressChartRanges',
            validationFn: isBoolean,
            warnMessage: createWarnMessage('suppressChartRanges', 'boolean'),
        },
        {
            property: 'aggFunc',
            validationFn: UpdateParamsValidator.validateAggFunc,
            warnMessage: createWarnMessage('aggFunc', 'string or IAggFunc'),
        },
    ];
    return UpdateParamsValidator;
})();

var __extends$1H =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$p =
    (undefined && undefined.__assign) ||
    function () {
        __assign$p =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$p.apply(this, arguments);
    };
var __decorate$1b =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DEFAULT_THEMES = ['ag-default', 'ag-material', 'ag-pastel', 'ag-vivid', 'ag-solar'];
var ChartController = /** @class */ (function (_super) {
    __extends$1H(ChartController, _super);
    function ChartController(model) {
        var _this = _super.call(this) || this;
        _this.model = model;
        return _this;
    }
    ChartController.prototype.init = function () {
        var _this = this;
        this.setChartRange();
        this.addManagedListener(this.eventService, Events.EVENT_RANGE_SELECTION_CHANGED, function (event) {
            if (event.id && event.id === _this.model.chartId) {
                _this.updateForRangeChange();
            }
        });
        if (this.model.unlinked) {
            if (this.rangeService) {
                this.rangeService.setCellRanges([]);
            }
        }
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.updateForGridChange.bind(this));
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_ROW_GROUP_CHANGED,
            this.updateForGridChange.bind(this),
        );
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.updateForGridChange.bind(this));
        this.addManagedListener(
            this.eventService,
            Events.EVENT_CELL_VALUE_CHANGED,
            this.updateForDataChange.bind(this),
        );
    };
    ChartController.prototype.update = function (params) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!this.validUpdateType(params) || !UpdateParamsValidator.validateChartParams(params)) {
            return false;
        }
        var chartId = params.chartId,
            chartType = params.chartType,
            chartThemeName = params.chartThemeName,
            unlinkChart = params.unlinkChart;
        // create a common base for the chart model parameters (this covers pivot chart updates)
        var common = {
            chartId: chartId,
            pivotChart: this.model.pivotChart,
            chartType: chartType !== null && chartType !== void 0 ? chartType : this.model.chartType,
            chartThemeName:
                chartThemeName !== null && chartThemeName !== void 0 ? chartThemeName : this.model.chartThemeName,
            unlinkChart: unlinkChart !== null && unlinkChart !== void 0 ? unlinkChart : this.model.unlinked,
            cellRange: this.model.suppliedCellRange,
            aggFunc: this.model.aggFunc,
            seriesChartTypes: undefined,
            suppressChartRanges: false,
            crossFiltering: false,
        };
        var chartModelParams = __assign$p({}, common);
        // modify the chart model properties based on the type of update
        switch (params.type) {
            case 'rangeChartUpdate':
                chartModelParams.cellRange =
                    (_a = this.createCellRange(params)) !== null && _a !== void 0 ? _a : this.model.suppliedCellRange;
                chartModelParams.aggFunc = (_b = params.aggFunc) !== null && _b !== void 0 ? _b : this.model.aggFunc;
                chartModelParams.seriesChartTypes = params.seriesChartTypes;
                chartModelParams.suppressChartRanges =
                    (_c = params.suppressChartRanges) !== null && _c !== void 0 ? _c : this.model.suppressChartRanges;
                break;
            case 'crossFilterChartUpdate':
                chartModelParams.cellRange =
                    (_d = this.createCellRange(params)) !== null && _d !== void 0 ? _d : this.model.suppliedCellRange;
                chartModelParams.aggFunc = (_e = params.aggFunc) !== null && _e !== void 0 ? _e : this.model.aggFunc;
                chartModelParams.crossFiltering = true;
                chartModelParams.suppressChartRanges =
                    (_f = params.suppressChartRanges) !== null && _f !== void 0 ? _f : this.model.suppressChartRanges;
                break;
        }
        this.model.updateModel(chartModelParams);
        // if the chart should be unlinked or chart ranges suppressed, remove all cell ranges; otherwise, set the chart range
        var removeChartCellRanges = chartModelParams.unlinkChart || chartModelParams.suppressChartRanges;
        removeChartCellRanges
            ? (_g = this.rangeService) === null || _g === void 0
                ? void 0
                : _g.setCellRanges([])
            : this.setChartRange();
        return true;
    };
    ChartController.prototype.updateForGridChange = function () {
        if (this.model.unlinked) {
            return;
        }
        this.model.updateCellRanges();
        this.model.updateData();
        this.setChartRange();
    };
    ChartController.prototype.updateForDataChange = function () {
        if (this.model.unlinked) {
            return;
        }
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    };
    ChartController.prototype.updateForRangeChange = function () {
        this.updateForGridChange();
        this.raiseChartRangeSelectionChangedEvent();
    };
    ChartController.prototype.updateForPanelChange = function (updatedCol) {
        this.model.updateCellRanges(updatedCol);
        this.model.updateData();
        this.setChartRange();
        this.raiseChartRangeSelectionChangedEvent();
    };
    ChartController.prototype.getChartUpdateParams = function (updatedOverrides) {
        var selectedCols = this.getSelectedValueColState();
        var fields = selectedCols.map(function (c) {
            return { colId: c.colId, displayName: c.displayName };
        });
        var data = this.getChartData();
        var selectedDimension = this.getSelectedDimension();
        return {
            data: data,
            grouping: this.isGrouping(),
            category: {
                id: selectedDimension.colId,
                name: selectedDimension.displayName,
                chartDataType: this.model.getChartDataType(selectedDimension.colId),
            },
            fields: fields,
            chartId: this.getChartId(),
            getCrossFilteringContext: function () {
                return { lastSelectedChartId: 'xxx' };
            },
            seriesChartTypes: this.getSeriesChartTypes(),
            updatedOverrides: updatedOverrides,
        };
    };
    ChartController.prototype.getChartModel = function () {
        var modelType = this.model.pivotChart ? 'pivot' : 'range';
        var seriesChartTypes = this.isComboChart() ? this.model.comboChartModel.seriesChartTypes : undefined;
        return {
            modelType: modelType,
            chartId: this.model.chartId,
            chartType: this.model.chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy.getChartThemeOverrides(),
            chartPalette: this.chartProxy.getChartPalette(),
            cellRange: this.getCellRangeParams(),
            suppressChartRanges: this.model.suppressChartRanges,
            aggFunc: this.model.aggFunc,
            unlinkChart: this.model.unlinked,
            seriesChartTypes: seriesChartTypes,
        };
    };
    ChartController.prototype.getChartId = function () {
        return this.model.chartId;
    };
    ChartController.prototype.getChartData = function () {
        return this.model.chartData;
    };
    ChartController.prototype.getChartType = function () {
        return this.model.chartType;
    };
    ChartController.prototype.setChartType = function (chartType) {
        this.model.chartType = chartType;
        this.model.comboChartModel.updateSeriesChartTypes();
        this.raiseChartModelUpdateEvent();
        this.raiseChartOptionsChangedEvent();
    };
    ChartController.prototype.setChartThemeName = function (chartThemeName) {
        this.model.chartThemeName = chartThemeName;
        this.raiseChartModelUpdateEvent();
        this.raiseChartOptionsChangedEvent();
    };
    ChartController.prototype.getChartThemeName = function () {
        return this.model.chartThemeName;
    };
    ChartController.prototype.isPivotChart = function () {
        return this.model.pivotChart;
    };
    ChartController.prototype.isPivotMode = function () {
        return this.model.isPivotMode();
    };
    ChartController.prototype.isGrouping = function () {
        return this.model.isGrouping();
    };
    ChartController.prototype.isCrossFilterChart = function () {
        return this.model.crossFiltering;
    };
    ChartController.prototype.getThemes = function () {
        return this.gridOptionsService.get('chartThemes') || DEFAULT_THEMES;
    };
    ChartController.prototype.getPalettes = function () {
        var _this = this;
        var themeNames = this.getThemes();
        return themeNames.map(function (themeName) {
            var stockTheme = isStockTheme(themeName);
            var theme = stockTheme ? themeName : _this.chartProxy.lookupCustomChartTheme(themeName);
            return getChartTheme(theme).palette;
        });
    };
    ChartController.prototype.getValueColState = function () {
        return this.model.valueColState.map(this.displayNameMapper.bind(this));
    };
    ChartController.prototype.getSelectedValueColState = function () {
        return this.getValueColState().filter(function (cs) {
            return cs.selected;
        });
    };
    ChartController.prototype.getSelectedDimension = function () {
        return this.model.getSelectedDimension();
    };
    ChartController.prototype.displayNameMapper = function (col) {
        var columnNames = this.model.columnNames[col.colId];
        col.displayName = columnNames ? columnNames.join(' - ') : this.model.getColDisplayName(col.column);
        return col;
    };
    ChartController.prototype.getColStateForMenu = function () {
        return { dimensionCols: this.model.dimensionColState, valueCols: this.getValueColState() };
    };
    ChartController.prototype.setChartRange = function (silent) {
        if (silent === void 0) {
            silent = false;
        }
        if (this.rangeService && !this.model.suppressChartRanges && !this.model.unlinked) {
            this.rangeService.setCellRanges(this.getCellRanges());
        }
        if (!silent) {
            this.raiseChartModelUpdateEvent();
        }
    };
    ChartController.prototype.detachChartRange = function () {
        // when chart is detached it won't listen to changes from the grid
        this.model.unlinked = !this.model.unlinked;
        if (this.model.unlinked) {
            // remove range from grid
            if (this.rangeService) {
                this.rangeService.setCellRanges([]);
            }
        } else {
            // update chart data may have changed
            this.updateForGridChange();
        }
    };
    ChartController.prototype.setChartProxy = function (chartProxy) {
        this.chartProxy = chartProxy;
    };
    ChartController.prototype.getChartProxy = function () {
        return this.chartProxy;
    };
    ChartController.prototype.isActiveXYChart = function () {
        return _.includes(['scatter', 'bubble'], this.getChartType());
    };
    ChartController.prototype.isChartLinked = function () {
        return !this.model.unlinked;
    };
    ChartController.prototype.customComboExists = function () {
        var savedCustomSeriesChartTypes = this.model.comboChartModel.savedCustomSeriesChartTypes;
        return savedCustomSeriesChartTypes && savedCustomSeriesChartTypes.length > 0;
    };
    ChartController.prototype.getSeriesChartTypes = function () {
        return this.model.comboChartModel.seriesChartTypes;
    };
    ChartController.prototype.isComboChart = function () {
        return this.model.isComboChart();
    };
    ChartController.prototype.updateSeriesChartType = function (colId, chartType, secondaryAxis) {
        var seriesChartType = this.model.comboChartModel.seriesChartTypes.find(function (s) {
            return s.colId === colId;
        });
        if (seriesChartType) {
            // once a combo chart has been modified it is now a 'customCombo' chart
            var updateChartType = this.model.chartType !== 'customCombo';
            if (updateChartType) {
                this.model.chartType = 'customCombo';
            }
            var prevSeriesChartType = seriesChartType.chartType;
            if (chartType != null) {
                seriesChartType.chartType = chartType;
            }
            if (secondaryAxis != null) {
                seriesChartType.secondaryAxis = secondaryAxis;
            }
            // replace existing custom series types with this latest version
            this.model.comboChartModel.savedCustomSeriesChartTypes = this.model.comboChartModel.seriesChartTypes;
            // series chart types can be modified, i.e. column chart types should be moved to primary axis
            this.model.comboChartModel.updateSeriesChartTypes();
            this.updateForDataChange();
            if (updateChartType) {
                // update the settings panel by raising an EVENT_CHART_TYPE_CHANGED event
                this.dispatchEvent({
                    type: ChartController.EVENT_CHART_TYPE_CHANGED,
                });
            }
            if (prevSeriesChartType !== chartType) {
                // update the format panel by raising an EVENT_CHART_SERIES_CHART_TYPE_CHANGED event
                this.dispatchEvent({
                    type: ChartController.EVENT_CHART_SERIES_CHART_TYPE_CHANGED,
                });
            }
            this.raiseChartOptionsChangedEvent();
        }
    };
    ChartController.prototype.getActiveSeriesChartTypes = function () {
        var selectedColIds = this.getSelectedValueColState().map(function (c) {
            return c.colId;
        });
        return this.getSeriesChartTypes().filter(function (s) {
            return selectedColIds.includes(s.colId);
        });
    };
    ChartController.prototype.getChartSeriesTypes = function () {
        var supportedComboSeriesTypes = ['line', 'column', 'area'];
        return this.isComboChart() ? supportedComboSeriesTypes : [getSeriesType(this.getChartType())];
    };
    ChartController.prototype.getCellRanges = function () {
        return [this.model.dimensionCellRange, this.model.valueCellRange].filter(function (r) {
            return r;
        });
    };
    ChartController.prototype.createCellRange = function (params) {
        var _a;
        return (
            params.cellRange &&
            ((_a = this.rangeService) === null || _a === void 0
                ? void 0
                : _a.createCellRangeFromCellRangeParams(params.cellRange))
        );
    };
    ChartController.prototype.validUpdateType = function (params) {
        var _this = this;
        var _a;
        if (!params.type) {
            console.warn(
                "AG Grid - Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.",
            );
            return false;
        }
        var chartTypeMap = {
            'Range Chart': function () {
                return !_this.isPivotChart() && !_this.isCrossFilterChart();
            },
            'Pivot Chart': function () {
                return _this.isPivotChart();
            },
            'Cross Filter Chart': function () {
                return _this.isCrossFilterChart();
            },
        };
        var currentChartType =
            (_a = Object.keys(chartTypeMap).find(function (type) {
                return chartTypeMap[type]();
            })) !== null && _a !== void 0
                ? _a
                : 'Range Chart';
        var valid =
            params.type ===
            '' + currentChartType[0].toLowerCase() + currentChartType.slice(1).replace(/ /g, '') + 'Update';
        if (!valid) {
            console.warn(
                "AG Grid - Unable to update chart as a '" +
                    params.type +
                    "' update type is not permitted on a " +
                    currentChartType +
                    '.',
            );
        }
        return valid;
    };
    ChartController.prototype.getCellRangeParams = function () {
        var cellRanges = this.getCellRanges();
        var firstCellRange = cellRanges[0];
        var startRow = (firstCellRange && firstCellRange.startRow) || null;
        var endRow = (firstCellRange && firstCellRange.endRow) || null;
        return {
            rowStartIndex: startRow && startRow.rowIndex,
            rowStartPinned: startRow && startRow.rowPinned,
            rowEndIndex: endRow && endRow.rowIndex,
            rowEndPinned: endRow && endRow.rowPinned,
            columns: cellRanges.reduce(function (columns, value) {
                return columns.concat(
                    value.columns.map(function (c) {
                        return c.getId();
                    }),
                );
            }, []),
        };
    };
    ChartController.prototype.raiseChartModelUpdateEvent = function () {
        var event = {
            type: ChartController.EVENT_CHART_MODEL_UPDATE,
        };
        this.dispatchEvent(event);
    };
    ChartController.prototype.raiseChartUpdatedEvent = function () {
        var event = {
            type: ChartController.EVENT_CHART_UPDATED,
        };
        this.dispatchEvent(event);
    };
    ChartController.prototype.raiseChartApiUpdateEvent = function () {
        var event = {
            type: ChartController.EVENT_CHART_API_UPDATE,
        };
        this.dispatchEvent(event);
    };
    ChartController.prototype.raiseChartOptionsChangedEvent = function () {
        var _a = this.getChartModel(),
            chartId = _a.chartId,
            chartType = _a.chartType;
        var event = {
            type: Events.EVENT_CHART_OPTIONS_CHANGED,
            chartId: chartId,
            chartType: chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy.getChartThemeOverrides(),
        };
        this.eventService.dispatchEvent(event);
    };
    ChartController.prototype.raiseChartRangeSelectionChangedEvent = function () {
        var event = {
            type: Events.EVENT_CHART_RANGE_SELECTION_CHANGED,
            id: this.model.chartId,
            chartId: this.model.chartId,
            cellRange: this.getCellRangeParams(),
        };
        this.eventService.dispatchEvent(event);
    };
    ChartController.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.rangeService) {
            this.rangeService.setCellRanges([]);
        }
    };
    ChartController.EVENT_CHART_UPDATED = 'chartUpdated';
    ChartController.EVENT_CHART_API_UPDATE = 'chartApiUpdate';
    ChartController.EVENT_CHART_MODEL_UPDATE = 'chartModelUpdate';
    ChartController.EVENT_CHART_TYPE_CHANGED = 'chartTypeChanged';
    ChartController.EVENT_CHART_SERIES_CHART_TYPE_CHANGED = 'chartSeriesChartTypeChanged';
    __decorate$1b([Autowired('rangeService')], ChartController.prototype, 'rangeService', void 0);
    __decorate$1b([PostConstruct], ChartController.prototype, 'init', null);
    return ChartController;
})(BeanStub);

var __extends$1G =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$1a =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$n =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$c =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$7 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var DefaultDataPanelDef = {
    groups: [
        { type: 'categories', isOpen: true },
        { type: 'series', isOpen: true },
        { type: 'seriesChartType', isOpen: true },
    ],
};
var ChartDataPanel = /** @class */ (function (_super) {
    __extends$1G(ChartDataPanel, _super);
    function ChartDataPanel(chartController, chartOptionsService) {
        var _this = _super.call(this, ChartDataPanel.TEMPLATE) || this;
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.columnComps = new Map();
        return _this;
    }
    ChartDataPanel.prototype.init = function () {
        this.updatePanels();
        this.addManagedListener(
            this.chartController,
            ChartController.EVENT_CHART_MODEL_UPDATE,
            this.updatePanels.bind(this),
        );
        this.addManagedListener(
            this.chartController,
            ChartController.EVENT_CHART_API_UPDATE,
            this.updatePanels.bind(this),
        );
        this.createAutoScrollService();
    };
    ChartDataPanel.prototype.destroy = function () {
        this.clearComponents();
        _super.prototype.destroy.call(this);
    };
    ChartDataPanel.prototype.updatePanels = function () {
        var _this = this;
        var _a, _b;
        var currentChartType = this.chartType;
        var _c = this.chartController.getColStateForMenu(),
            dimensionCols = _c.dimensionCols,
            valueCols = _c.valueCols;
        var colIds = dimensionCols
            .map(function (c) {
                return c.colId;
            })
            .concat(
                valueCols.map(function (c) {
                    return c.colId;
                }),
            );
        this.chartType = this.chartController.getChartType();
        var groupExpandedState = this.getGroupExpandedState();
        if (_.areEqual(_.keys(this.columnComps), colIds) && this.chartType === currentChartType) {
            // if possible, we just update existing components
            __spreadArray$c(__spreadArray$c([], __read$n(dimensionCols)), __read$n(valueCols)).forEach(function (col) {
                _this.columnComps.get(col.colId).setValue(col.selected, true);
            });
            if (this.chartController.isActiveXYChart()) {
                var getSeriesLabel_1 = this.generateGetSeriesLabel();
                valueCols.forEach(function (col) {
                    _this.columnComps.get(col.colId).setLabel(getSeriesLabel_1(col));
                });
            }
            // recreate series chart type group if it exists as series may be added or removed via series group panel
            _.removeFromParent(this.getGui().querySelector('#seriesChartTypeGroup'));
            this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp);
            var seriesChartTypeIndex =
                (_a = this.getDataPanelDef().groups) === null || _a === void 0
                    ? void 0
                    : _a.reduce(function (prevVal, _a, index) {
                          var type = _a.type;
                          if (type === 'seriesChartType') {
                              return index;
                          }
                          return prevVal;
                      }, -1);
            if (seriesChartTypeIndex !== -1) {
                this.createSeriesChartTypeGroup(valueCols, seriesChartTypeIndex);
            }
        } else {
            // otherwise, we re-create everything
            this.clearComponents();
            (_b = this.getDataPanelDef().groups) === null || _b === void 0
                ? void 0
                : _b.forEach(function (_a) {
                      var type = _a.type;
                      if (type === 'categories') {
                          _this.createCategoriesGroup(dimensionCols);
                      } else if (type === 'series') {
                          _this.createSeriesGroup(valueCols);
                      } else if (type === 'seriesChartType') {
                          _this.createSeriesChartTypeGroup(valueCols);
                      } else {
                          console.warn("AG Grid: invalid charts data panel group name supplied: '" + type + "'");
                      }
                  });
        }
        this.restoreGroupExpandedState(groupExpandedState);
    };
    ChartDataPanel.prototype.getGroupExpandedState = function () {
        var _this = this;
        var groups = [
            { groupType: 'categories', comp: this.categoriesGroupComp },
            { groupType: 'series', comp: this.seriesGroupComp },
            { groupType: 'seriesChartType', comp: this.seriesChartTypeGroupComp },
        ];
        return groups.map(function (_a) {
            var _b, _c;
            var groupType = _a.groupType,
                comp = _a.comp;
            var defaultExpanded = Boolean(
                (_c =
                    (_b = _this.getDataPanelDef().groups) === null || _b === void 0
                        ? void 0
                        : _b.find(function (_a) {
                              var type = _a.type;
                              return type === groupType;
                          })) === null || _c === void 0
                    ? void 0
                    : _c.isOpen,
            );
            return !comp ? defaultExpanded : comp.isExpanded();
        });
    };
    ChartDataPanel.prototype.restoreGroupExpandedState = function (groupExpandedState) {
        [this.categoriesGroupComp, this.seriesGroupComp, this.seriesChartTypeGroupComp].forEach(function (group, idx) {
            if (!group) {
                return;
            }
            group.toggleGroupExpand(groupExpandedState[idx]);
        });
    };
    ChartDataPanel.prototype.createAutoScrollService = function () {
        var eGui = this.getGui();
        this.autoScrollService = new AutoScrollService({
            scrollContainer: eGui,
            scrollAxis: 'y',
            getVerticalPosition: function () {
                return eGui.scrollTop;
            },
            setVerticalPosition: function (position) {
                return (eGui.scrollTop = position);
            },
        });
    };
    ChartDataPanel.prototype.createComponent = function (component, id) {
        var eDiv = document.createElement('div');
        eDiv.id = id;
        eDiv.className = 'ag-chart-data-section';
        eDiv.appendChild(component.getGui());
        return eDiv;
    };
    ChartDataPanel.prototype.addComponent = function (parent, component, id) {
        var eDiv = this.createComponent(component, id);
        parent.appendChild(eDiv);
    };
    ChartDataPanel.prototype.addComponentAtIndex = function (parent, component, id, index) {
        var eDiv = this.createComponent(component, id);
        parent.insertBefore(eDiv, parent.children[index]);
    };
    ChartDataPanel.prototype.addChangeListener = function (component, columnState) {
        var _this = this;
        this.addManagedListener(component, Events.EVENT_FIELD_VALUE_CHANGED, function () {
            columnState.selected = component.getValue();
            _this.chartController.updateForPanelChange(columnState);
        });
    };
    ChartDataPanel.prototype.createCategoriesGroup = function (columns) {
        var _this = this;
        this.categoriesGroupComp = this.createBean(
            new AgGroupComponent({
                title: this.getCategoryGroupTitle(),
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: false,
                cssIdentifier: 'charts-data',
            }),
        );
        var inputName = 'chartDimension' + this.getCompId();
        columns.forEach(function (col) {
            var comp = _this.categoriesGroupComp.createManagedBean(new AgRadioButton());
            comp.setLabel(_.escapeString(col.displayName));
            comp.setValue(col.selected);
            comp.setInputName(inputName);
            _this.addChangeListener(comp, col);
            _this.categoriesGroupComp.addItem(comp);
            _this.columnComps.set(col.colId, comp);
        });
        this.addComponent(this.getGui(), this.categoriesGroupComp, 'categoriesGroup');
    };
    ChartDataPanel.prototype.createSeriesGroup = function (columns) {
        var _this = this;
        this.seriesGroupComp = this.createManagedBean(
            new AgGroupComponent({
                title: this.getSeriesGroupTitle(),
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: false,
                cssIdentifier: 'charts-data',
            }),
        );
        if (this.chartController.isActiveXYChart()) {
            var pairedModeToggle = this.seriesGroupComp.createManagedBean(new AgToggleButton());
            pairedModeToggle
                .setLabel(this.chartTranslationService.translate('paired'))
                .setLabelAlignment('left')
                .setLabelWidth('flex')
                .setInputWidth(45)
                .setValue(this.chartOptionsService.getPairedMode())
                .onValueChange(function (newValue) {
                    _this.chartOptionsService.setPairedMode(!!newValue);
                    _this.chartController.updateForGridChange();
                });
            this.seriesGroupComp.addItem(pairedModeToggle);
        }
        var getSeriesLabel = this.generateGetSeriesLabel();
        columns.forEach(function (col) {
            var comp = _this.seriesGroupComp.createManagedBean(new AgCheckbox());
            comp.addCssClass('ag-data-select-checkbox');
            var label = getSeriesLabel(col);
            comp.setLabel(label);
            comp.setValue(col.selected);
            _this.addChangeListener(comp, col);
            _this.seriesGroupComp.addItem(comp);
            _this.columnComps.set(col.colId, comp);
            _this.addDragHandle(comp, col);
        });
        var eGui = this.getGui();
        var seriesGroupGui = this.seriesGroupComp.getGui();
        this.addComponent(eGui, this.seriesGroupComp, 'seriesGroup');
        var dropTarget = {
            getIconName: function () {
                return DragAndDropService.ICON_MOVE;
            },
            getContainer: function () {
                return seriesGroupGui;
            },
            onDragging: function (params) {
                return _this.onDragging(params);
            },
            onDragLeave: function () {
                return _this.onDragLeave();
            },
            isInterestedIn: this.isInterestedIn.bind(this),
            targetContainsSource: true,
        };
        this.dragAndDropService.addDropTarget(dropTarget);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDropTarget(dropTarget);
        });
    };
    ChartDataPanel.prototype.createSeriesChartTypeGroup = function (columns, index) {
        var _this = this;
        if (!this.chartController.isComboChart()) {
            return;
        }
        this.seriesChartTypeGroupComp = this.createManagedBean(
            new AgGroupComponent({
                title: this.chartTranslationService.translate('seriesChartType'),
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: false,
                cssIdentifier: 'charts-data',
            }),
        );
        var seriesChartTypes = this.chartController.getSeriesChartTypes();
        columns.forEach(function (col) {
            if (!col.selected) {
                return;
            }
            var seriesChartType = seriesChartTypes.filter(function (s) {
                return s.colId === col.colId;
            })[0];
            if (!seriesChartType) {
                return;
            }
            var seriesItemGroup = _this.seriesChartTypeGroupComp.createManagedBean(
                new AgGroupComponent({
                    title: col.displayName,
                    enabled: true,
                    suppressEnabledCheckbox: true,
                    suppressOpenCloseIcons: true,
                    cssIdentifier: 'charts-format-sub-level',
                }),
            );
            var secondaryAxisComp = _this.seriesChartTypeGroupComp
                .createManagedBean(new AgCheckbox())
                .setLabel(_this.chartTranslationService.translate('secondaryAxis'))
                .setLabelWidth('flex')
                .setDisabled(['groupedColumn', 'stackedColumn', 'stackedArea'].includes(seriesChartType.chartType))
                .setValue(!!seriesChartType.secondaryAxis)
                .onValueChange(function (enabled) {
                    return _this.chartController.updateSeriesChartType(col.colId, undefined, enabled);
                });
            seriesItemGroup.addItem(secondaryAxisComp);
            var translate = function (key, defaultText) {
                return _this.chartTranslationService.translate(key, defaultText);
            };
            var availableChartTypes = [
                { value: 'line', text: translate('line', 'Line') },
                { value: 'area', text: translate('area', 'Area') },
                { value: 'stackedArea', text: translate('stackedArea', 'StackedArea') },
                { value: 'groupedColumn', text: translate('groupedColumn', 'Grouped Column') },
                { value: 'stackedColumn', text: translate('stackedColumn', 'Stacked Column') },
            ];
            var chartTypeComp = seriesItemGroup.createManagedBean(new AgSelect());
            chartTypeComp
                .setLabelAlignment('left')
                .setLabelWidth('flex')
                .addOptions(availableChartTypes)
                .setValue(seriesChartType.chartType)
                .onValueChange(function (chartType) {
                    return _this.chartController.updateSeriesChartType(col.colId, chartType);
                });
            seriesItemGroup.addItem(chartTypeComp);
            _this.seriesChartTypeGroupComp.addItem(seriesItemGroup);
        });
        if (index === undefined) {
            this.addComponent(this.getGui(), this.seriesChartTypeGroupComp, 'seriesChartTypeGroup');
        } else {
            this.addComponentAtIndex(this.getGui(), this.seriesChartTypeGroupComp, 'seriesChartTypeGroup', index);
        }
    };
    ChartDataPanel.prototype.addDragHandle = function (comp, col) {
        var _this = this;
        var eDragHandle = _.createIconNoSpan('columnDrag', this.gridOptionsService);
        eDragHandle.classList.add('ag-drag-handle', 'ag-chart-data-column-drag-handle');
        comp.getGui().insertAdjacentElement('beforeend', eDragHandle);
        var dragSource = {
            type: DragSourceType.ChartPanel,
            eElement: eDragHandle,
            dragItemName: col.displayName,
            getDragItem: function () {
                return { columns: [col.column] };
            },
            onDragStopped: function () {
                return _this.onDragStop();
            },
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(function () {
            return _this.dragAndDropService.removeDragSource(dragSource);
        });
    };
    ChartDataPanel.prototype.generateGetSeriesLabel = function () {
        if (!this.chartController.isActiveXYChart()) {
            return function (col) {
                return _.escapeString(col.displayName);
            };
        }
        var isBubble = this.chartType === 'bubble';
        var isInPairedMode = this.isInPairedMode();
        var selectedValuesCount = 0;
        var indexToAxisLabel = new Map();
        indexToAxisLabel.set(0, 'X');
        indexToAxisLabel.set(1, 'Y');
        indexToAxisLabel.set(2, 'size');
        return function (col) {
            var escapedLabel = _.escapeString(col.displayName);
            if (!col.selected) {
                return escapedLabel;
            }
            var axisLabel;
            if (isInPairedMode) {
                axisLabel = indexToAxisLabel.get(selectedValuesCount % (isBubble ? 3 : 2));
            } else {
                if (selectedValuesCount === 0) {
                    axisLabel = 'X';
                } else {
                    axisLabel = isBubble && selectedValuesCount % 2 === 0 ? 'size' : 'Y';
                }
            }
            selectedValuesCount++;
            return escapedLabel + ' (' + axisLabel + ')';
        };
    };
    ChartDataPanel.prototype.getCategoryGroupTitle = function () {
        return this.chartTranslationService.translate(this.chartController.isActiveXYChart() ? 'labels' : 'categories');
    };
    ChartDataPanel.prototype.getSeriesGroupTitle = function () {
        return this.chartTranslationService.translate(this.chartController.isActiveXYChart() ? 'xyValues' : 'series');
    };
    ChartDataPanel.prototype.getDataPanelDef = function () {
        var _a;
        var userProvidedDataPanelDef =
            (_a = this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0 ? void 0 : _a.dataPanel;
        return userProvidedDataPanelDef ? userProvidedDataPanelDef : DefaultDataPanelDef;
    };
    ChartDataPanel.prototype.isInPairedMode = function () {
        return this.chartController.isActiveXYChart() && this.chartOptionsService.getSeriesOption('paired', 'scatter');
    };
    ChartDataPanel.prototype.clearComponents = function () {
        _.clearElement(this.getGui());
        this.categoriesGroupComp = this.destroyBean(this.categoriesGroupComp);
        this.seriesGroupComp = this.destroyBean(this.seriesGroupComp);
        this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp);
        this.columnComps.clear();
    };
    ChartDataPanel.prototype.onDragging = function (draggingEvent) {
        var itemHovered = this.checkHoveredItem(draggingEvent);
        if (!itemHovered) {
            return;
        }
        this.lastDraggedColumn = draggingEvent.dragItem.columns[0];
        var comp = itemHovered.comp,
            position = itemHovered.position;
        var _a = this.lastHoveredItem || {},
            lastHoveredComp = _a.comp,
            lastHoveredPosition = _a.position;
        if (comp === lastHoveredComp && position === lastHoveredPosition) {
            return;
        }
        this.autoScrollService.check(draggingEvent.event);
        this.clearHoveredItems();
        this.lastHoveredItem = { comp: comp, position: position };
        var eGui = comp.getGui();
        eGui.classList.add('ag-list-item-hovered', 'ag-item-highlight-' + position);
    };
    ChartDataPanel.prototype.checkHoveredItem = function (draggingEvent) {
        var e_1, _a;
        if (_.missing(draggingEvent.vDirection)) {
            return null;
        }
        var mouseEvent = draggingEvent.event;
        try {
            for (var _b = __values$7(this.columnComps.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var comp = _c.value;
                var eGui = comp.getGui();
                if (!eGui.querySelector('.ag-chart-data-column-drag-handle')) {
                    continue;
                }
                var rect = eGui.getBoundingClientRect();
                var isOverComp = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
                if (isOverComp) {
                    var height = eGui.clientHeight;
                    var position = mouseEvent.clientY > rect.top + height / 2 ? 'bottom' : 'top';
                    return { comp: comp, position: position };
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return null;
    };
    ChartDataPanel.prototype.onDragLeave = function () {
        this.clearHoveredItems();
    };
    ChartDataPanel.prototype.onDragStop = function () {
        var _this = this;
        if (this.lastHoveredItem) {
            var _a = this.chartController.getColStateForMenu(),
                dimensionCols = _a.dimensionCols,
                valueCols = _a.valueCols;
            var draggedColumnState = __spreadArray$c(
                __spreadArray$c([], __read$n(dimensionCols)),
                __read$n(valueCols),
            ).find(function (state) {
                return state.column === _this.lastDraggedColumn;
            });
            if (draggedColumnState) {
                var targetIndex = Array.from(this.columnComps.values()).indexOf(this.lastHoveredItem.comp);
                if (this.lastHoveredItem.position === 'bottom') {
                    targetIndex++;
                }
                draggedColumnState.order = targetIndex;
                this.chartController.updateForPanelChange(draggedColumnState);
            }
        }
        this.clearHoveredItems();
        this.lastDraggedColumn = undefined;
        this.autoScrollService.ensureCleared();
    };
    ChartDataPanel.prototype.clearHoveredItems = function () {
        this.columnComps.forEach(function (columnComp) {
            columnComp
                .getGui()
                .classList.remove('ag-list-item-hovered', 'ag-item-highlight-top', 'ag-item-highlight-bottom');
        });
        this.lastHoveredItem = undefined;
    };
    ChartDataPanel.prototype.isInterestedIn = function (type) {
        return type === DragSourceType.ChartPanel;
    };
    ChartDataPanel.TEMPLATE = '<div class="ag-chart-data-wrapper ag-scrollable-container"></div>';
    __decorate$1a([Autowired('dragAndDropService')], ChartDataPanel.prototype, 'dragAndDropService', void 0);
    __decorate$1a([Autowired('chartTranslationService')], ChartDataPanel.prototype, 'chartTranslationService', void 0);
    __decorate$1a([PostConstruct], ChartDataPanel.prototype, 'init', null);
    return ChartDataPanel;
})(Component);

var __extends$1F =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$19 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FontPanel = /** @class */ (function (_super) {
    __extends$1F(FontPanel, _super);
    function FontPanel(params) {
        var _this = _super.call(this) || this;
        _this.activeComps = [];
        _this.params = params;
        return _this;
    }
    FontPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
            suppressOpenCloseIcons: true,
        };
        this.setTemplate(FontPanel.TEMPLATE, { fontGroup: groupParams });
        this.initGroup();
        this.initFontFamilySelect();
        this.initFontWeightStyleSelect();
        this.initFontSizeSelect();
        this.initFontColorPicker();
    };
    FontPanel.prototype.addCompToPanel = function (comp) {
        this.fontGroup.addItem(comp);
        this.activeComps.push(comp);
    };
    FontPanel.prototype.setEnabled = function (enabled) {
        this.fontGroup.setEnabled(enabled);
    };
    FontPanel.prototype.initGroup = function () {
        var _this = this;
        this.fontGroup
            .setTitle(this.params.name || this.chartTranslationService.translate('font'))
            .setEnabled(this.params.enabled)
            .hideEnabledCheckbox(!!this.params.suppressEnabledCheckbox)
            .hideOpenCloseIcons(true)
            .onEnableChange(function (enabled) {
                if (_this.params.setEnabled) {
                    _this.params.setEnabled(enabled);
                }
            });
    };
    FontPanel.prototype.initFontFamilySelect = function () {
        var _this = this;
        var families = [
            'Arial, sans-serif',
            'Aria Black, sans-serif',
            'Book Antiqua,  serif',
            'Charcoal, sans-serif',
            'Comic Sans MS, cursive',
            'Courier, monospace',
            'Courier New, monospace',
            'Gadget, sans-serif',
            'Geneva, sans-serif',
            'Helvetica, sans-serif',
            'Impact, sans-serif',
            'Lucida Console, monospace',
            'Lucida Grande, sans-serif',
            'Lucida Sans Unicode,  sans-serif',
            'Monaco, monospace',
            'Palatino Linotype, serif',
            'Palatino, serif',
            'Times New Roman, serif',
            'Times, serif',
            'Verdana, sans-serif',
        ];
        var family = this.params.initialFont.family;
        var initialValue = families[0];
        if (family) {
            // check for known values using lowercase
            var lowerCaseValues = families.map(function (f) {
                return f.toLowerCase();
            });
            var valueIndex = lowerCaseValues.indexOf(family.toLowerCase());
            if (valueIndex >= 0) {
                initialValue = families[valueIndex];
            } else {
                // add user provided value to list
                var capitalisedFontValue = _.capitalise(family);
                families.push(capitalisedFontValue);
                initialValue = capitalisedFontValue;
            }
        }
        var options = families.sort().map(function (value) {
            return { value: value, text: value };
        });
        this.familySelect
            .addOptions(options)
            .setInputWidth('flex')
            .setValue('' + initialValue)
            .onValueChange(function (newValue) {
                return _this.params.setFont({ family: newValue });
            });
    };
    FontPanel.prototype.initFontSizeSelect = function () {
        var _this = this;
        var sizes = [8, 10, 12, 14, 16, 18, 20, 22, 24, 26, 28, 30, 32, 34, 36];
        var size = this.params.initialFont.size;
        if (!_.includes(sizes, size)) {
            sizes.push(size);
        }
        var options = sizes
            .sort(function (a, b) {
                return a - b;
            })
            .map(function (value) {
                return { value: '' + value, text: '' + value };
            });
        this.sizeSelect
            .addOptions(options)
            .setInputWidth('flex')
            .setValue('' + size)
            .onValueChange(function (newValue) {
                return _this.params.setFont({ size: parseInt(newValue, 10) });
            });
        this.sizeSelect.setLabel(this.chartTranslationService.translate('size'));
    };
    FontPanel.prototype.initFontWeightStyleSelect = function () {
        var _this = this;
        var _a = this.params.initialFont,
            _b = _a.weight,
            weight = _b === void 0 ? 'normal' : _b,
            _c = _a.style,
            style = _c === void 0 ? 'normal' : _c;
        var weightStyles = [
            { name: 'normal', weight: 'normal', style: 'normal' },
            { name: 'bold', weight: 'bold', style: 'normal' },
            { name: 'italic', weight: 'normal', style: 'italic' },
            { name: 'boldItalic', weight: 'bold', style: 'italic' },
        ];
        var selectedOption = weightStyles.find(function (x) {
            return x.weight === weight && x.style === style;
        });
        if (!selectedOption) {
            selectedOption = { name: 'predefined', weight: weight, style: style };
            weightStyles.unshift(selectedOption);
        }
        var options = weightStyles.map(function (ws) {
            return {
                value: ws.name,
                text: _this.chartTranslationService.translate(ws.name),
            };
        });
        this.weightStyleSelect
            .addOptions(options)
            .setInputWidth('flex')
            .setValue(selectedOption.name)
            .onValueChange(function (newValue) {
                var selectedWeightStyle = weightStyles.find(function (x) {
                    return x.name === newValue;
                });
                _this.params.setFont({ weight: selectedWeightStyle.weight, style: selectedWeightStyle.style });
            });
    };
    FontPanel.prototype.initFontColorPicker = function () {
        var _this = this;
        this.colorPicker
            .setLabel(this.chartTranslationService.translate('color'))
            .setInputWidth(45)
            .setValue('' + this.params.initialFont.color)
            .onValueChange(function (newColor) {
                return _this.params.setFont({ color: newColor });
            });
    };
    FontPanel.prototype.addItemToPanel = function (item) {
        this.fontGroup.addItem(item);
        this.activeComps.push(item);
    };
    FontPanel.prototype.destroyActiveComps = function () {
        var _this = this;
        this.activeComps.forEach(function (comp) {
            _.removeFromParent(comp.getGui());
            _this.destroyBean(comp);
        });
    };
    FontPanel.prototype.destroy = function () {
        this.destroyActiveComps();
        _super.prototype.destroy.call(this);
    };
    FontPanel.TEMPLATE =
        '<div class="ag-font-panel">\n            <ag-group-component ref="fontGroup">\n                <ag-select ref="familySelect"></ag-select>\n                <ag-select ref="weightStyleSelect"></ag-select>\n                <div class="ag-charts-font-size-color">\n                    <ag-select ref="sizeSelect"></ag-select>\n                    <ag-color-picker ref="colorPicker"></ag-color-picker>\n                </div>\n            </ag-group-component>\n        </div>';
    __decorate$19([RefSelector('fontGroup')], FontPanel.prototype, 'fontGroup', void 0);
    __decorate$19([RefSelector('familySelect')], FontPanel.prototype, 'familySelect', void 0);
    __decorate$19([RefSelector('weightStyleSelect')], FontPanel.prototype, 'weightStyleSelect', void 0);
    __decorate$19([RefSelector('sizeSelect')], FontPanel.prototype, 'sizeSelect', void 0);
    __decorate$19([RefSelector('colorPicker')], FontPanel.prototype, 'colorPicker', void 0);
    __decorate$19([Autowired('chartTranslationService')], FontPanel.prototype, 'chartTranslationService', void 0);
    __decorate$19([PostConstruct], FontPanel.prototype, 'init', null);
    return FontPanel;
})(Component);

var __extends$1E =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$18 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var LegendPanel = /** @class */ (function (_super) {
    __extends$1E(LegendPanel, _super);
    function LegendPanel(_a) {
        var chartOptionsService = _a.chartOptionsService,
            _b = _a.isExpandedOnInit,
            isExpandedOnInit = _b === void 0 ? false : _b;
        var _this = _super.call(this) || this;
        _this.activePanels = [];
        _this.chartOptionsService = chartOptionsService;
        _this.isExpandedOnInit = isExpandedOnInit;
        return _this;
    }
    LegendPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-top-level',
            direction: 'vertical',
        };
        this.setTemplate(LegendPanel.TEMPLATE, { legendGroup: groupParams });
        this.initLegendGroup();
        this.initLegendPosition();
        this.initLegendPadding();
        this.initLegendItems();
        this.initLabelPanel();
    };
    LegendPanel.prototype.initLegendGroup = function () {
        var _this = this;
        this.legendGroup
            .setTitle(this.chartTranslationService.translate('legend'))
            .hideEnabledCheckbox(false)
            .setEnabled(this.chartOptionsService.getChartOption('legend.enabled') || false)
            .toggleGroupExpand(this.isExpandedOnInit)
            .onEnableChange(function (enabled) {
                _this.chartOptionsService.setChartOption('legend.enabled', enabled);
                _this.legendGroup.toggleGroupExpand(true);
            });
    };
    LegendPanel.prototype.initLegendPosition = function () {
        var _this = this;
        var positions = ['top', 'right', 'bottom', 'left'];
        this.legendPositionSelect
            .setLabel(this.chartTranslationService.translate('position'))
            .setLabelWidth('flex')
            .setInputWidth(80)
            .addOptions(
                positions.map(function (position) {
                    return {
                        value: position,
                        text: _this.chartTranslationService.translate(position),
                    };
                }),
            )
            .setValue(this.chartOptionsService.getChartOption('legend.position'))
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setChartOption('legend.position', newValue);
            });
    };
    LegendPanel.prototype.initLegendPadding = function () {
        var _this = this;
        var currentValue = this.chartOptionsService.getChartOption('legend.spacing');
        this.legendPaddingSlider
            .setLabel(this.chartTranslationService.translate('spacing'))
            .setMaxValue(getMaxValue(currentValue, 200))
            .setValue('' + currentValue)
            .setTextFieldWidth(45)
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setChartOption('legend.spacing', newValue);
            });
    };
    LegendPanel.prototype.initLegendItems = function () {
        var _this = this;
        var initSlider = function (expression, labelKey, input, defaultMaxValue) {
            var currentValue = _this.chartOptionsService.getChartOption('legend.' + expression);
            input
                .setLabel(_this.chartTranslationService.translate(labelKey))
                .setMaxValue(getMaxValue(currentValue, defaultMaxValue))
                .setValue('' + currentValue)
                .setTextFieldWidth(45)
                .onValueChange(function (newValue) {
                    _this.chartOptionsService.setChartOption('legend.' + expression, newValue);
                });
        };
        initSlider('item.marker.size', 'markerSize', this.markerSizeSlider, 40);
        initSlider('item.marker.strokeWidth', 'markerStroke', this.markerStrokeSlider, 10);
        initSlider('item.marker.padding', 'itemSpacing', this.markerPaddingSlider, 20);
        initSlider('item.paddingX', 'layoutHorizontalSpacing', this.itemPaddingXSlider, 50);
        initSlider('item.paddingY', 'layoutVerticalSpacing', this.itemPaddingYSlider, 50);
    };
    LegendPanel.prototype.initLabelPanel = function () {
        var _this = this;
        var chartProxy = this.chartOptionsService;
        var initialFont = {
            family: chartProxy.getChartOption('legend.item.label.fontFamily'),
            style: chartProxy.getChartOption('legend.item.label.fontStyle'),
            weight: chartProxy.getChartOption('legend.item.label.fontWeight'),
            size: chartProxy.getChartOption('legend.item.label.fontSize'),
            color: chartProxy.getChartOption('legend.item.label.color'),
        };
        var setFont = function (font) {
            var proxy = _this.chartOptionsService;
            if (font.family) {
                proxy.setChartOption('legend.item.label.fontFamily', font.family);
            }
            if (font.weight) {
                proxy.setChartOption('legend.item.label.fontWeight', font.weight);
            }
            if (font.style) {
                proxy.setChartOption('legend.item.label.fontStyle', font.style);
            }
            if (font.size) {
                proxy.setChartOption('legend.item.label.fontSize', font.size);
            }
            if (font.color) {
                proxy.setChartOption('legend.item.label.color', font.color);
            }
        };
        var params = {
            enabled: true,
            suppressEnabledCheckbox: true,
            initialFont: initialFont,
            setFont: setFont,
        };
        var fontPanelComp = this.createBean(new FontPanel(params));
        this.legendGroup.addItem(fontPanelComp);
        this.activePanels.push(fontPanelComp);
    };
    LegendPanel.prototype.destroyActivePanels = function () {
        var _this = this;
        this.activePanels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    LegendPanel.prototype.destroy = function () {
        this.destroyActivePanels();
        _super.prototype.destroy.call(this);
    };
    LegendPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="legendGroup">\n                <ag-select ref="legendPositionSelect"></ag-select>\n                <ag-slider ref="legendPaddingSlider"></ag-slider>\n                <ag-slider ref="markerSizeSlider"></ag-slider>\n                <ag-slider ref="markerStrokeSlider"></ag-slider>\n                <ag-slider ref="markerPaddingSlider"></ag-slider>\n                <ag-slider ref="itemPaddingXSlider"></ag-slider>\n                <ag-slider ref="itemPaddingYSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$18([RefSelector('legendGroup')], LegendPanel.prototype, 'legendGroup', void 0);
    __decorate$18([RefSelector('legendPositionSelect')], LegendPanel.prototype, 'legendPositionSelect', void 0);
    __decorate$18([RefSelector('legendPaddingSlider')], LegendPanel.prototype, 'legendPaddingSlider', void 0);
    __decorate$18([RefSelector('markerSizeSlider')], LegendPanel.prototype, 'markerSizeSlider', void 0);
    __decorate$18([RefSelector('markerStrokeSlider')], LegendPanel.prototype, 'markerStrokeSlider', void 0);
    __decorate$18([RefSelector('markerPaddingSlider')], LegendPanel.prototype, 'markerPaddingSlider', void 0);
    __decorate$18([RefSelector('itemPaddingXSlider')], LegendPanel.prototype, 'itemPaddingXSlider', void 0);
    __decorate$18([RefSelector('itemPaddingYSlider')], LegendPanel.prototype, 'itemPaddingYSlider', void 0);
    __decorate$18([Autowired('chartTranslationService')], LegendPanel.prototype, 'chartTranslationService', void 0);
    __decorate$18([PostConstruct], LegendPanel.prototype, 'init', null);
    return LegendPanel;
})(Component);

var __extends$1D =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$17 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AxisTicksPanel = /** @class */ (function (_super) {
    __extends$1D(AxisTicksPanel, _super);
    function AxisTicksPanel(chartOptionsService) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        return _this;
    }
    AxisTicksPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
            suppressOpenCloseIcons: true,
        };
        this.setTemplate(AxisTicksPanel.TEMPLATE, { axisTicksGroup: groupParams });
        this.initAxisTicks();
    };
    AxisTicksPanel.prototype.initAxisTicks = function () {
        var _this = this;
        this.axisTicksGroup
            .setTitle(this.chartTranslationService.translate('ticks'))
            .hideOpenCloseIcons(true)
            .hideEnabledCheckbox(true);
        this.axisTicksColorPicker
            .setLabel(this.chartTranslationService.translate('color'))
            .setLabelWidth('flex')
            .setInputWidth(45)
            .setValue(this.chartOptionsService.getAxisProperty('tick.color'))
            .onValueChange(function (newColor) {
                return _this.chartOptionsService.setAxisProperty('tick.color', newColor);
            });
        var initInput = function (expression, input, label, defaultMaxValue) {
            var currentValue = _this.chartOptionsService.getAxisProperty(expression);
            input
                .setLabel(label)
                .setMaxValue(getMaxValue(currentValue, defaultMaxValue))
                .setValue('' + currentValue)
                .setTextFieldWidth(45)
                .onValueChange(function (newValue) {
                    return _this.chartOptionsService.setAxisProperty(expression, newValue);
                });
        };
        initInput('tick.width', this.axisTicksWidthSlider, this.chartTranslationService.translate('width'), 10);
        initInput('tick.size', this.axisTicksSizeSlider, this.chartTranslationService.translate('length'), 30);
    };
    AxisTicksPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="axisTicksGroup">\n                <ag-color-picker ref="axisTicksColorPicker"></ag-color-picker>\n                <ag-slider ref="axisTicksWidthSlider"></ag-slider>\n                <ag-slider ref="axisTicksSizeSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$17([RefSelector('axisTicksGroup')], AxisTicksPanel.prototype, 'axisTicksGroup', void 0);
    __decorate$17([RefSelector('axisTicksColorPicker')], AxisTicksPanel.prototype, 'axisTicksColorPicker', void 0);
    __decorate$17([RefSelector('axisTicksWidthSlider')], AxisTicksPanel.prototype, 'axisTicksWidthSlider', void 0);
    __decorate$17([RefSelector('axisTicksSizeSlider')], AxisTicksPanel.prototype, 'axisTicksSizeSlider', void 0);
    __decorate$17([Autowired('chartTranslationService')], AxisTicksPanel.prototype, 'chartTranslationService', void 0);
    __decorate$17([PostConstruct], AxisTicksPanel.prototype, 'init', null);
    return AxisTicksPanel;
})(Component);

var __extends$1C =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$16 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AgAngleSelect = /** @class */ (function (_super) {
    __extends$1C(AgAngleSelect, _super);
    function AgAngleSelect(config) {
        var _this = _super.call(this, config, AgAngleSelect.TEMPLATE) || this;
        _this.radius = 0;
        _this.offsetX = 0;
        _this.offsetY = 0;
        return _this;
    }
    AgAngleSelect.prototype.postConstruct = function () {
        var _this = this;
        _super.prototype.postConstruct.call(this);
        this.dragListener = {
            eElement: this.eParentCircle,
            dragStartPixels: 0,
            onDragStart: function (e) {
                _this.parentCircleRect = _this.eParentCircle.getBoundingClientRect();
            },
            onDragging: function (e) {
                return _this.calculateAngleDrag(e);
            },
            onDragStop: function () {},
        };
        this.dragService.addDragSource(this.dragListener);
        this.eAngleValue
            .setLabel('')
            .setLabelWidth(5)
            .setInputWidth(45)
            .setMin(0)
            .setMax(360)
            .setValue('' + this.degrees)
            .onValueChange(function (value) {
                if (value == null || value === '') {
                    value = '0';
                }
                value = _this.eAngleValue.normalizeValue(value);
                var floatValue = parseFloat(value);
                if (floatValue > 180) {
                    floatValue = floatValue - 360;
                }
                _this.setValue(floatValue);
            });
        this.updateNumberInput();
        if (_.exists(this.getValue())) {
            this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
        }
        this.addManagedListener(this, Events.EVENT_FIELD_VALUE_CHANGED, function () {
            var eDocument = _this.gridOptionsService.getDocument();
            if (_this.eAngleValue.getInputElement().contains(eDocument.activeElement)) {
                return;
            }
            _this.updateNumberInput();
        });
    };
    AgAngleSelect.prototype.updateNumberInput = function () {
        var normalizedValue = this.normalizeNegativeValue(this.getValue());
        this.eAngleValue.setValue(normalizedValue.toString());
    };
    AgAngleSelect.prototype.positionChildCircle = function (radians) {
        var rect = this.parentCircleRect || { width: 24, height: 24 };
        var eChildCircle = this.eChildCircle;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        eChildCircle.style.left = centerX + Math.cos(radians) * 8 + 'px';
        eChildCircle.style.top = centerY + Math.sin(radians) * 8 + 'px';
    };
    AgAngleSelect.prototype.calculatePolar = function () {
        var x = this.offsetX;
        var y = this.offsetY;
        var radians = Math.atan2(y, x);
        this.degrees = this.toDegrees(radians);
        this.radius = Math.sqrt(x * x + y * y);
        this.positionChildCircle(radians);
    };
    AgAngleSelect.prototype.calculateCartesian = function () {
        var radians = this.toRadians(this.getValue());
        var radius = this.getRadius();
        this.setOffsetX(Math.cos(radians) * radius).setOffsetY(Math.sin(radians) * radius);
    };
    AgAngleSelect.prototype.setOffsetX = function (offset) {
        if (this.offsetX !== offset) {
            this.offsetX = offset;
            this.calculatePolar();
        }
        return this;
    };
    AgAngleSelect.prototype.setOffsetY = function (offset) {
        if (this.offsetY !== offset) {
            this.offsetY = offset;
            this.calculatePolar();
        }
        return this;
    };
    AgAngleSelect.prototype.calculateAngleDrag = function (e) {
        var rect = this.parentCircleRect;
        var centerX = rect.width / 2;
        var centerY = rect.height / 2;
        var x = e.clientX - rect.left;
        var y = e.clientY - rect.top;
        var dx = x - centerX;
        var dy = y - centerY;
        var radians = Math.atan2(dy, dx);
        this.setValue(radians, true);
    };
    AgAngleSelect.prototype.toDegrees = function (radians) {
        return (radians / Math.PI) * 180;
    };
    AgAngleSelect.prototype.toRadians = function (degrees) {
        return (degrees / 180) * Math.PI;
    };
    AgAngleSelect.prototype.normalizeNegativeValue = function (degrees) {
        return degrees < 0 ? 360 + degrees : degrees;
    };
    AgAngleSelect.prototype.normalizeAngle180 = function (radians) {
        radians %= Math.PI * 2;
        if (radians < -Math.PI) {
            radians += Math.PI * 2;
        } else if (radians >= Math.PI) {
            radians -= Math.PI * 2;
        }
        return radians;
    };
    AgAngleSelect.prototype.getRadius = function () {
        return this.radius;
    };
    AgAngleSelect.prototype.setRadius = function (r) {
        if (this.radius === r) {
            return this;
        }
        this.radius = r;
        this.calculateCartesian();
        return this;
    };
    AgAngleSelect.prototype.onValueChange = function (callbackFn) {
        var _this = this;
        this.addManagedListener(this, Events.EVENT_FIELD_VALUE_CHANGED, function () {
            callbackFn(_this.degrees);
        });
        return this;
    };
    AgAngleSelect.prototype.getValue = function (radians) {
        return radians ? this.toRadians(this.degrees) : this.degrees;
    };
    AgAngleSelect.prototype.setValue = function (degrees, radians) {
        var radiansValue;
        if (!radians) {
            radiansValue = this.normalizeAngle180(this.toRadians(degrees));
        } else {
            radiansValue = degrees;
        }
        degrees = this.toDegrees(radiansValue);
        if (this.degrees !== degrees) {
            this.degrees = Math.floor(degrees);
            this.calculateCartesian();
            this.positionChildCircle(radiansValue);
            this.dispatchEvent({ type: Events.EVENT_FIELD_VALUE_CHANGED });
        }
        return this;
    };
    AgAngleSelect.prototype.setWidth = function (width) {
        _.setFixedWidth(this.getGui(), width);
        return this;
    };
    AgAngleSelect.prototype.setDisabled = function (disabled) {
        _super.prototype.setDisabled.call(this, disabled);
        this.eAngleValue.setDisabled(disabled);
        return this;
    };
    AgAngleSelect.prototype.destroy = function () {
        this.dragService.removeDragSource(this.dragListener);
        _super.prototype.destroy.call(this);
    };
    AgAngleSelect.TEMPLATE =
        '<div class="ag-angle-select">\n            <div ref="eLabel"></div>\n            <div class="ag-wrapper ag-angle-select-wrapper">\n                <div ref="eAngleSelectField" class="ag-angle-select-field">\n                    <div ref="eParentCircle" class="ag-angle-select-parent-circle">\n                        <div ref="eChildCircle" class="ag-angle-select-child-circle"></div>\n                    </div>\n                </div>\n                <ag-input-number-field ref="eAngleValue"></ag-input-number-field>\n            </div>\n        </div>';
    __decorate$16([RefSelector('eLabel')], AgAngleSelect.prototype, 'eLabel', void 0);
    __decorate$16([RefSelector('eParentCircle')], AgAngleSelect.prototype, 'eParentCircle', void 0);
    __decorate$16([RefSelector('eChildCircle')], AgAngleSelect.prototype, 'eChildCircle', void 0);
    __decorate$16([RefSelector('eAngleValue')], AgAngleSelect.prototype, 'eAngleValue', void 0);
    __decorate$16([Autowired('dragService')], AgAngleSelect.prototype, 'dragService', void 0);
    return AgAngleSelect;
})(AgAbstractLabel);

var __extends$1B =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$15 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AxisPanel = /** @class */ (function (_super) {
    __extends$1B(AxisPanel, _super);
    function AxisPanel(_a) {
        var chartController = _a.chartController,
            chartOptionsService = _a.chartOptionsService,
            _b = _a.isExpandedOnInit,
            isExpandedOnInit = _b === void 0 ? false : _b;
        var _this = _super.call(this) || this;
        _this.activePanels = [];
        _this.axisLabelUpdateFuncs = [];
        _this.prevXRotation = 0;
        _this.prevYRotation = 0;
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.isExpandedOnInit = isExpandedOnInit;
        return _this;
    }
    AxisPanel.prototype.init = function () {
        var _this = this;
        var groupParams = {
            cssIdentifier: 'charts-format-top-level',
            direction: 'vertical',
        };
        this.setTemplate(AxisPanel.TEMPLATE, { axisGroup: groupParams });
        this.initAxis();
        this.initAxisTicks();
        this.initAxisLabels();
        var updateAxisLabelRotations = function () {
            return _this.axisLabelUpdateFuncs.forEach(function (func) {
                return func();
            });
        };
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, updateAxisLabelRotations);
    };
    AxisPanel.prototype.initAxis = function () {
        var _this = this;
        this.axisGroup
            .setTitle(this.translate('axis'))
            .toggleGroupExpand(this.isExpandedOnInit)
            .hideEnabledCheckbox(true);
        this.axisColorInput
            .setLabel(this.translate('color'))
            .setLabelWidth('flex')
            .setInputWidth(45)
            .setValue(this.chartOptionsService.getAxisProperty('line.color'))
            .onValueChange(function (newColor) {
                return _this.chartOptionsService.setAxisProperty('line.color', newColor);
            });
        var currentValue = this.chartOptionsService.getAxisProperty('line.width');
        this.axisLineWidthSlider
            .setMaxValue(getMaxValue(currentValue, 10))
            .setLabel(this.translate('thickness'))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setAxisProperty('line.width', newValue);
            });
    };
    AxisPanel.prototype.initAxisTicks = function () {
        var axisTicksComp = this.createBean(new AxisTicksPanel(this.chartOptionsService));
        this.axisGroup.addItem(axisTicksComp);
        this.activePanels.push(axisTicksComp);
    };
    AxisPanel.prototype.initAxisLabels = function () {
        var _this = this;
        var initialFont = {
            family: this.chartOptionsService.getAxisProperty('label.fontFamily'),
            style: this.chartOptionsService.getAxisProperty('label.fontStyle'),
            weight: this.chartOptionsService.getAxisProperty('label.fontWeight'),
            size: this.chartOptionsService.getAxisProperty('label.fontSize'),
            color: this.chartOptionsService.getAxisProperty('label.color'),
        };
        var setFont = function (font) {
            if (font.family) {
                _this.chartOptionsService.setAxisProperty('label.fontFamily', font.family);
            }
            if (font.weight) {
                _this.chartOptionsService.setAxisProperty('label.fontWeight', font.weight);
            }
            if (font.style) {
                _this.chartOptionsService.setAxisProperty('label.fontStyle', font.style);
            }
            if (font.size) {
                _this.chartOptionsService.setAxisProperty('label.fontSize', font.size);
            }
            if (font.color) {
                _this.chartOptionsService.setAxisProperty('label.color', font.color);
            }
        };
        var params = {
            name: this.translate('labels'),
            enabled: true,
            suppressEnabledCheckbox: true,
            initialFont: initialFont,
            setFont: setFont,
        };
        var labelPanelComp = this.createBean(new FontPanel(params));
        this.axisGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
        this.addAdditionalLabelComps(labelPanelComp);
    };
    AxisPanel.prototype.addAdditionalLabelComps = function (labelPanelComp) {
        this.addLabelPadding(labelPanelComp);
        var _a = this.createRotationWidgets(),
            xRotationComp = _a.xRotationComp,
            yRotationComp = _a.yRotationComp;
        var autoRotateCb = this.initLabelRotations(xRotationComp, yRotationComp);
        labelPanelComp.addCompToPanel(autoRotateCb);
        labelPanelComp.addCompToPanel(xRotationComp);
        labelPanelComp.addCompToPanel(yRotationComp);
    };
    AxisPanel.prototype.initLabelRotations = function (xRotationComp, yRotationComp) {
        var _this = this;
        var getLabelRotation = function (axisType) {
            return _this.chartOptionsService.getLabelRotation(axisType);
        };
        var setLabelRotation = function (axisType, value) {
            _this.chartOptionsService.setLabelRotation(axisType, value);
        };
        var updateAutoRotate = function (autoRotate) {
            _this.chartOptionsService.setAxisProperty('label.autoRotate', autoRotate);
            if (autoRotate) {
                // store prev rotations before we remove them from the options
                _this.prevXRotation = getLabelRotation('xAxis');
                _this.prevYRotation = getLabelRotation('yAxis');
                // `autoRotate` is only
                setLabelRotation('xAxis', undefined);
                setLabelRotation('yAxis', undefined);
            } else {
                // reinstate prev rotations
                setLabelRotation('xAxis', _this.prevXRotation);
                setLabelRotation('yAxis', _this.prevYRotation);
            }
            xRotationComp.setDisabled(autoRotate);
            yRotationComp.setDisabled(autoRotate);
        };
        var getAutoRotateValue = function () {
            var xRotation = getLabelRotation('xAxis');
            var yRotation = getLabelRotation('yAxis');
            if (xRotation == undefined && yRotation == undefined) {
                return _this.chartOptionsService.getAxisProperty('label.autoRotate');
            }
            return false;
        };
        var autoRotate = getAutoRotateValue();
        var autoRotateCheckbox = this.createBean(new AgCheckbox())
            .setLabel(this.translate('autoRotate'))
            .setValue(autoRotate)
            .onValueChange(updateAutoRotate);
        // init rotation comp state
        xRotationComp.setDisabled(autoRotate);
        yRotationComp.setDisabled(autoRotate);
        return autoRotateCheckbox;
    };
    AxisPanel.prototype.createRotationWidgets = function () {
        var _this = this;
        var degreesSymbol = String.fromCharCode(176);
        var createRotationComp = function (labelKey, axisType) {
            var label = _this.chartTranslationService.translate(labelKey) + ' ' + degreesSymbol;
            var value = _this.chartOptionsService.getLabelRotation(axisType);
            var angleSelect = new AgAngleSelect()
                .setLabel(label)
                .setLabelWidth('flex')
                .setValue(value || 0)
                .onValueChange(function (newValue) {
                    return _this.chartOptionsService.setLabelRotation(axisType, newValue);
                });
            // the axis label rotation needs to be updated when the default category changes in the data panel
            _this.axisLabelUpdateFuncs.push(function () {
                var value = _this.chartOptionsService.getLabelRotation(axisType);
                angleSelect.setValue(value || 0);
            });
            return _this.createBean(angleSelect);
        };
        return {
            xRotationComp: createRotationComp('xRotation', 'xAxis'),
            yRotationComp: createRotationComp('yRotation', 'yAxis'),
        };
    };
    AxisPanel.prototype.addLabelPadding = function (labelPanelComp) {
        var _this = this;
        var labelPaddingSlider = this.createBean(new AgSlider());
        var currentValue = this.chartOptionsService.getAxisProperty('label.padding');
        labelPaddingSlider
            .setLabel(this.chartTranslationService.translate('padding'))
            .setMaxValue(getMaxValue(currentValue, 30))
            .setValue('' + currentValue)
            .setTextFieldWidth(45)
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setAxisProperty('label.padding', newValue);
            });
        labelPanelComp.addCompToPanel(labelPaddingSlider);
    };
    AxisPanel.prototype.translate = function (key, defaultText) {
        return this.chartTranslationService.translate(key, defaultText);
    };
    AxisPanel.prototype.destroyActivePanels = function () {
        var _this = this;
        this.activePanels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    AxisPanel.prototype.destroy = function () {
        this.destroyActivePanels();
        _super.prototype.destroy.call(this);
    };
    AxisPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="axisGroup">\n                <ag-color-picker ref="axisColorInput"></ag-color-picker>\n                <ag-slider ref="axisLineWidthSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$15([RefSelector('axisGroup')], AxisPanel.prototype, 'axisGroup', void 0);
    __decorate$15([RefSelector('axisColorInput')], AxisPanel.prototype, 'axisColorInput', void 0);
    __decorate$15([RefSelector('axisLineWidthSlider')], AxisPanel.prototype, 'axisLineWidthSlider', void 0);
    __decorate$15([Autowired('chartTranslationService')], AxisPanel.prototype, 'chartTranslationService', void 0);
    __decorate$15([PostConstruct], AxisPanel.prototype, 'init', null);
    return AxisPanel;
})(Component);

var __extends$1A =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$14 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var NavigatorPanel = /** @class */ (function (_super) {
    __extends$1A(NavigatorPanel, _super);
    function NavigatorPanel(_a) {
        var chartOptionsService = _a.chartOptionsService,
            _b = _a.isExpandedOnInit,
            isExpandedOnInit = _b === void 0 ? false : _b;
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.isExpandedOnInit = isExpandedOnInit;
        return _this;
    }
    NavigatorPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-top-level',
            direction: 'vertical',
        };
        this.setTemplate(NavigatorPanel.TEMPLATE, { navigatorGroup: groupParams });
        this.initNavigator();
    };
    NavigatorPanel.prototype.initNavigator = function () {
        var _this = this;
        var chartTranslationService = this.chartTranslationService;
        this.navigatorGroup
            .setTitle(chartTranslationService.translate('navigator'))
            .hideEnabledCheckbox(false)
            .setEnabled(this.chartOptionsService.getChartOption('navigator.enabled') || false)
            .onEnableChange(function (enabled) {
                _this.chartOptionsService.setChartOption('navigator.enabled', enabled);
                _this.navigatorGroup.toggleGroupExpand(true);
            })
            .toggleGroupExpand(this.isExpandedOnInit);
        var currentValue = this.chartOptionsService.getChartOption('navigator.height');
        this.navigatorHeightSlider
            .setLabel(chartTranslationService.translate('height'))
            .setMinValue(10)
            .setMaxValue(getMaxValue(currentValue, 60))
            .setTextFieldWidth(45)
            .setValue('' + (currentValue || 30))
            .onValueChange(function (height) {
                return _this.chartOptionsService.setChartOption('navigator.height', height);
            });
    };
    NavigatorPanel.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    NavigatorPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="navigatorGroup">\n                <ag-slider ref="navigatorHeightSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$14([RefSelector('navigatorGroup')], NavigatorPanel.prototype, 'navigatorGroup', void 0);
    __decorate$14([RefSelector('navigatorHeightSlider')], NavigatorPanel.prototype, 'navigatorHeightSlider', void 0);
    __decorate$14([Autowired('chartTranslationService')], NavigatorPanel.prototype, 'chartTranslationService', void 0);
    __decorate$14([PostConstruct], NavigatorPanel.prototype, 'init', null);
    return NavigatorPanel;
})(Component);

var __extends$1z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$13 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var PaddingPanel = /** @class */ (function (_super) {
    __extends$1z(PaddingPanel, _super);
    function PaddingPanel(chartOptionsService, chartController) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.chartController = chartController;
        return _this;
    }
    PaddingPanel.prototype.init = function () {
        var _this = this;
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
            suppressOpenCloseIcons: true,
        };
        this.setTemplate(PaddingPanel.TEMPLATE, { chartPaddingGroup: groupParams });
        this.addManagedListener(this.eventService, Events.EVENT_CHART_OPTIONS_CHANGED, function (e) {
            _this.updateTopPadding(e.chartOptions);
        });
        this.initGroup();
        this.initChartPaddingItems();
    };
    PaddingPanel.prototype.initGroup = function () {
        this.chartPaddingGroup
            .setTitle(this.chartTranslationService.translate('padding'))
            .hideOpenCloseIcons(true)
            .hideEnabledCheckbox(true);
    };
    PaddingPanel.prototype.initChartPaddingItems = function () {
        var _this = this;
        var initInput = function (property, input) {
            var currentValue = _this.chartOptionsService.getChartOption('padding.' + property);
            input
                .setLabel(_this.chartTranslationService.translate(property))
                .setMaxValue(getMaxValue(currentValue, 200))
                .setValue('' + currentValue)
                .setTextFieldWidth(45)
                .onValueChange(function (newValue) {
                    return _this.chartOptionsService.setChartOption('padding.' + property, newValue);
                });
        };
        initInput('top', this.paddingTopSlider);
        initInput('right', this.paddingRightSlider);
        initInput('bottom', this.paddingBottomSlider);
        initInput('left', this.paddingLeftSlider);
    };
    PaddingPanel.prototype.updateTopPadding = function (chartOptions) {
        var _a, _b;
        // keep 'top' padding in sync with chart as toggling chart title on / off change the 'top' padding
        var seriesType = this.chartController.getChartSeriesTypes()[0];
        var topPadding =
            (_b = (_a = chartOptions[seriesType]) === null || _a === void 0 ? void 0 : _a.padding) === null ||
            _b === void 0
                ? void 0
                : _b.top;
        if (topPadding != null) {
            this.paddingTopSlider.setValue(topPadding);
        }
    };
    PaddingPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="chartPaddingGroup">\n                <ag-slider ref="paddingTopSlider"></ag-slider>\n                <ag-slider ref="paddingRightSlider"></ag-slider>\n                <ag-slider ref="paddingBottomSlider"></ag-slider>\n                <ag-slider ref="paddingLeftSlider"></ag-slider>\n            </ag-group-component>\n        <div>';
    __decorate$13([RefSelector('chartPaddingGroup')], PaddingPanel.prototype, 'chartPaddingGroup', void 0);
    __decorate$13([RefSelector('paddingTopSlider')], PaddingPanel.prototype, 'paddingTopSlider', void 0);
    __decorate$13([RefSelector('paddingRightSlider')], PaddingPanel.prototype, 'paddingRightSlider', void 0);
    __decorate$13([RefSelector('paddingBottomSlider')], PaddingPanel.prototype, 'paddingBottomSlider', void 0);
    __decorate$13([RefSelector('paddingLeftSlider')], PaddingPanel.prototype, 'paddingLeftSlider', void 0);
    __decorate$13([Autowired('chartTranslationService')], PaddingPanel.prototype, 'chartTranslationService', void 0);
    __decorate$13([PostConstruct], PaddingPanel.prototype, 'init', null);
    return PaddingPanel;
})(Component);

var __extends$1y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$12 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var BackgroundPanel = /** @class */ (function (_super) {
    __extends$1y(BackgroundPanel, _super);
    function BackgroundPanel(chartOptionsService) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        return _this;
    }
    BackgroundPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
            suppressOpenCloseIcons: true,
        };
        this.setTemplate(BackgroundPanel.TEMPLATE, { chartBackgroundGroup: groupParams });
        this.initGroup();
        this.initColorPicker();
    };
    BackgroundPanel.prototype.initGroup = function () {
        var _this = this;
        this.group
            .setTitle(this.chartTranslationService.translate('background'))
            .setEnabled(this.chartOptionsService.getChartOption('background.visible'))
            .hideOpenCloseIcons(true)
            .hideEnabledCheckbox(false)
            .onEnableChange(function (enabled) {
                return _this.chartOptionsService.setChartOption('background.visible', enabled);
            });
    };
    BackgroundPanel.prototype.initColorPicker = function () {
        var _this = this;
        this.colorPicker
            .setLabel(this.chartTranslationService.translate('color'))
            .setLabelWidth('flex')
            .setInputWidth(45)
            .setValue(this.chartOptionsService.getChartOption('background.fill'))
            .onValueChange(function (newColor) {
                return _this.chartOptionsService.setChartOption('background.fill', newColor);
            });
    };
    BackgroundPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="chartBackgroundGroup">\n                <ag-color-picker ref="colorPicker"></ag-color-picker>\n            </ag-group-component>\n        <div>';
    __decorate$12([RefSelector('chartBackgroundGroup')], BackgroundPanel.prototype, 'group', void 0);
    __decorate$12([RefSelector('colorPicker')], BackgroundPanel.prototype, 'colorPicker', void 0);
    __decorate$12([Autowired('chartTranslationService')], BackgroundPanel.prototype, 'chartTranslationService', void 0);
    __decorate$12([PostConstruct], BackgroundPanel.prototype, 'init', null);
    return BackgroundPanel;
})(Component);

var __extends$1x =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$11 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TitlePanel = /** @class */ (function (_super) {
    __extends$1x(TitlePanel, _super);
    function TitlePanel(chartOptionsService) {
        var _this = _super.call(this, TitlePanel.TEMPLATE) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.activePanels = [];
        return _this;
    }
    TitlePanel.prototype.init = function () {
        this.initFontPanel();
        this.titlePlaceholder = this.chartTranslationService.translate('titlePlaceholder');
    };
    TitlePanel.prototype.hasTitle = function () {
        var title = this.getOption('title');
        return title && title.enabled && title.text && title.text.length > 0;
    };
    TitlePanel.prototype.initFontPanel = function () {
        var _this = this;
        var hasTitle = this.hasTitle();
        var setFont = function (font, isSilent) {
            if (font.family) {
                _this.setOption('title.fontFamily', font.family, isSilent);
            }
            if (font.weight) {
                _this.setOption('title.fontWeight', font.weight, isSilent);
            }
            if (font.style) {
                _this.setOption('title.fontStyle', font.style, isSilent);
            }
            if (font.size) {
                _this.setOption('title.fontSize', font.size, isSilent);
            }
            if (font.color) {
                _this.setOption('title.color', font.color, isSilent);
            }
        };
        var initialFont = {
            family: this.getOption('title.fontFamily'),
            style: this.getOption('title.fontStyle'),
            weight: this.getOption('title.fontWeight'),
            size: this.getOption('title.fontSize'),
            color: this.getOption('title.color'),
        };
        if (!hasTitle) {
            setFont(initialFont, true);
        }
        var fontPanelParams = {
            name: this.chartTranslationService.translate('title'),
            enabled: hasTitle,
            suppressEnabledCheckbox: false,
            initialFont: initialFont,
            setFont: setFont,
            setEnabled: function (enabled) {
                if (_this.toolbarExists()) {
                    // extra padding is only included when the toolbar is present
                    var topPadding = _this.getOption('padding.top');
                    _this.setOption('padding.top', enabled ? topPadding - 20 : topPadding + 20);
                }
                _this.setOption('title.enabled', enabled);
                var currentTitleText = _this.getOption('title.text');
                var replaceableTitleText =
                    currentTitleText === 'Title' ||
                    (currentTitleText === null || currentTitleText === void 0
                        ? void 0
                        : currentTitleText.trim().length) === 0;
                if (enabled && replaceableTitleText) {
                    _this.setOption('title.text', _this.titlePlaceholder);
                }
            },
        };
        var fontPanelComp = this.createBean(new FontPanel(fontPanelParams));
        // add the title spacing slider to font panel
        fontPanelComp.addItemToPanel(this.createSpacingSlicer());
        this.getGui().appendChild(fontPanelComp.getGui());
        this.activePanels.push(fontPanelComp);
        // edits to the title can disable it, so keep the checkbox in sync:
        this.addManagedListener(this.eventService, 'chartTitleEdit', function () {
            fontPanelComp.setEnabled(_this.hasTitle());
        });
    };
    TitlePanel.prototype.createSpacingSlicer = function () {
        var _this = this;
        var spacingSlider = this.createBean(new AgSlider());
        var currentValue = this.chartOptionsService.getChartOption('title.spacing');
        spacingSlider
            .setLabel(this.chartTranslationService.translate('spacing'))
            .setMaxValue(Math.max(currentValue, 100))
            .setValue('' + currentValue)
            .setTextFieldWidth(45)
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setChartOption('title.spacing', newValue);
            });
        return spacingSlider;
    };
    TitlePanel.prototype.toolbarExists = function () {
        var toolbarItemsFunc = this.gridOptionsService.getCallback('getChartToolbarItems');
        if (!toolbarItemsFunc) {
            return true;
        }
        var params = {
            defaultItems: ['chartUnlink', 'chartDownload'],
        };
        var topItems = ['chartLink', 'chartUnlink', 'chartDownload'];
        return topItems.some(function (v) {
            var _a;
            return (_a = toolbarItemsFunc && toolbarItemsFunc(params)) === null || _a === void 0
                ? void 0
                : _a.includes(v);
        });
    };
    TitlePanel.prototype.getOption = function (expression) {
        return this.chartOptionsService.getChartOption(expression);
    };
    TitlePanel.prototype.setOption = function (property, value, isSilent) {
        this.chartOptionsService.setChartOption(property, value, isSilent);
    };
    TitlePanel.prototype.destroyActivePanels = function () {
        var _this = this;
        this.activePanels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    TitlePanel.prototype.destroy = function () {
        this.destroyActivePanels();
        _super.prototype.destroy.call(this);
    };
    TitlePanel.TEMPLATE = '<div></div>';
    __decorate$11([Autowired('chartTranslationService')], TitlePanel.prototype, 'chartTranslationService', void 0);
    __decorate$11([PostConstruct], TitlePanel.prototype, 'init', null);
    return TitlePanel;
})(Component);

var __extends$1w =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$10 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartPanel = /** @class */ (function (_super) {
    __extends$1w(ChartPanel, _super);
    function ChartPanel(_a) {
        var chartController = _a.chartController,
            chartOptionsService = _a.chartOptionsService,
            _b = _a.isExpandedOnInit,
            isExpandedOnInit = _b === void 0 ? false : _b;
        var _this = _super.call(this) || this;
        _this.activePanels = [];
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.isExpandedOnInit = isExpandedOnInit;
        return _this;
    }
    ChartPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-top-level',
            direction: 'vertical',
        };
        this.setTemplate(ChartPanel.TEMPLATE, { chartGroup: groupParams });
        this.initGroup();
        this.initTitles();
        this.initPaddingPanel();
        this.initBackgroundPanel();
    };
    ChartPanel.prototype.initGroup = function () {
        this.chartGroup
            .setTitle(this.chartTranslationService.translate('chart'))
            .toggleGroupExpand(this.isExpandedOnInit)
            .hideEnabledCheckbox(true);
    };
    ChartPanel.prototype.initTitles = function () {
        var titlePanelComp = this.createBean(new TitlePanel(this.chartOptionsService));
        this.chartGroup.addItem(titlePanelComp);
        this.activePanels.push(titlePanelComp);
    };
    ChartPanel.prototype.initPaddingPanel = function () {
        var paddingPanelComp = this.createBean(new PaddingPanel(this.chartOptionsService, this.chartController));
        this.chartGroup.addItem(paddingPanelComp);
        this.activePanels.push(paddingPanelComp);
    };
    ChartPanel.prototype.initBackgroundPanel = function () {
        var backgroundPanelComp = this.createBean(new BackgroundPanel(this.chartOptionsService));
        this.chartGroup.addItem(backgroundPanelComp);
        this.activePanels.push(backgroundPanelComp);
    };
    ChartPanel.prototype.destroyActivePanels = function () {
        var _this = this;
        this.activePanels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    ChartPanel.prototype.destroy = function () {
        this.destroyActivePanels();
        _super.prototype.destroy.call(this);
    };
    ChartPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="chartGroup"></ag-group-component>\n        </div>';
    __decorate$10([RefSelector('chartGroup')], ChartPanel.prototype, 'chartGroup', void 0);
    __decorate$10([Autowired('chartTranslationService')], ChartPanel.prototype, 'chartTranslationService', void 0);
    __decorate$10([PostConstruct], ChartPanel.prototype, 'init', null);
    return ChartPanel;
})(Component);

var __extends$1v =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$$ =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ShadowPanel = /** @class */ (function (_super) {
    __extends$1v(ShadowPanel, _super);
    function ShadowPanel(chartOptionsService, getSelectedSeries) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.getSelectedSeries = getSelectedSeries;
        return _this;
    }
    ShadowPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
            suppressOpenCloseIcons: true,
        };
        this.setTemplate(ShadowPanel.TEMPLATE, { shadowGroup: groupParams });
        this.shadowBlurSlider.setTextFieldWidth(45);
        this.shadowXOffsetSlider.setTextFieldWidth(45);
        this.shadowYOffsetSlider.setTextFieldWidth(45);
        this.initSeriesShadow();
    };
    ShadowPanel.prototype.initSeriesShadow = function () {
        var _this = this;
        this.shadowGroup
            .setTitle(this.chartTranslationService.translate('shadow'))
            .setEnabled(this.chartOptionsService.getSeriesOption('shadow.enabled', this.getSelectedSeries()))
            .hideOpenCloseIcons(true)
            .hideEnabledCheckbox(false)
            .onEnableChange(function (newValue) {
                return _this.chartOptionsService.setSeriesOption('shadow.enabled', newValue, _this.getSelectedSeries());
            });
        this.shadowColorPicker
            .setLabel(this.chartTranslationService.translate('color'))
            .setLabelWidth('flex')
            .setInputWidth(45)
            .setValue(this.chartOptionsService.getSeriesOption('shadow.color', this.getSelectedSeries()))
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setSeriesOption('shadow.color', newValue, _this.getSelectedSeries());
            });
        var initInput = function (input, property, minValue, defaultMaxValue) {
            var currentValue = _this.chartOptionsService.getSeriesOption(
                'shadow.' + property,
                _this.getSelectedSeries(),
            );
            input
                .setLabel(_this.chartTranslationService.translate(property))
                .setMinValue(minValue)
                .setMaxValue(getMaxValue(currentValue, defaultMaxValue))
                .setValue('' + currentValue)
                .onValueChange(function (newValue) {
                    return _this.chartOptionsService.setSeriesOption(
                        'shadow.' + property,
                        newValue,
                        _this.getSelectedSeries(),
                    );
                });
        };
        initInput(this.shadowBlurSlider, 'blur', 0, 20);
        initInput(this.shadowXOffsetSlider, 'xOffset', -10, 10);
        initInput(this.shadowYOffsetSlider, 'yOffset', -10, 10);
    };
    ShadowPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="shadowGroup">\n                <ag-color-picker ref="shadowColorPicker"></ag-color-picker>\n                <ag-slider ref="shadowBlurSlider"></ag-slider>\n                <ag-slider ref="shadowXOffsetSlider"></ag-slider>\n                <ag-slider ref="shadowYOffsetSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$$([RefSelector('shadowGroup')], ShadowPanel.prototype, 'shadowGroup', void 0);
    __decorate$$([RefSelector('shadowColorPicker')], ShadowPanel.prototype, 'shadowColorPicker', void 0);
    __decorate$$([RefSelector('shadowBlurSlider')], ShadowPanel.prototype, 'shadowBlurSlider', void 0);
    __decorate$$([RefSelector('shadowXOffsetSlider')], ShadowPanel.prototype, 'shadowXOffsetSlider', void 0);
    __decorate$$([RefSelector('shadowYOffsetSlider')], ShadowPanel.prototype, 'shadowYOffsetSlider', void 0);
    __decorate$$([Autowired('chartTranslationService')], ShadowPanel.prototype, 'chartTranslationService', void 0);
    __decorate$$([PostConstruct], ShadowPanel.prototype, 'init', null);
    return ShadowPanel;
})(Component);

function initFontPanelParams(_a) {
    var labelName = _a.labelName,
        chartOptionsService = _a.chartOptionsService,
        getSelectedSeries = _a.getSelectedSeries,
        seriesOptionLabelProperty = _a.seriesOptionLabelProperty;
    var getFontOptionExpression = function (fontOption) {
        return seriesOptionLabelProperty + '.' + fontOption;
    };
    var getFontOption = function (fontOption) {
        var expression = getFontOptionExpression(fontOption);
        return chartOptionsService.getSeriesOption(expression, getSelectedSeries());
    };
    var setFontOption = function (fontOption, value) {
        var expression = getFontOptionExpression(fontOption);
        chartOptionsService.setSeriesOption(expression, value, getSelectedSeries());
    };
    var initialFont = {
        family: getFontOption('fontFamily'),
        style: getFontOption('fontStyle'),
        weight: getFontOption('fontWeight'),
        size: getFontOption('fontSize'),
        color: getFontOption('color'),
    };
    var setFont = function (font) {
        if (font.family) {
            setFontOption('fontFamily', font.family);
        }
        if (font.weight) {
            setFontOption('fontWeight', font.weight);
        }
        if (font.style) {
            setFontOption('fontStyle', font.style);
        }
        if (font.size) {
            setFontOption('fontSize', font.size);
        }
        if (font.color) {
            setFontOption('color', font.color);
        }
    };
    var params = {
        name: labelName,
        enabled: getFontOption('enabled') || false,
        setEnabled: function (enabled) {
            return setFontOption('enabled', enabled);
        },
        suppressEnabledCheckbox: false,
        initialFont: initialFont,
        setFont: setFont,
    };
    return params;
}

var __extends$1u =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$_ =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MarkersPanel = /** @class */ (function (_super) {
    __extends$1u(MarkersPanel, _super);
    function MarkersPanel(chartOptionsService, getSelectedSeries) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.getSelectedSeries = getSelectedSeries;
        return _this;
    }
    MarkersPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
        };
        this.setTemplate(MarkersPanel.TEMPLATE, { seriesMarkersGroup: groupParams });
        this.initMarkers();
    };
    MarkersPanel.prototype.initMarkers = function () {
        var _this = this;
        var seriesMarkerShapeOptions = [
            {
                value: 'square',
                text: 'Square',
            },
            {
                value: 'circle',
                text: 'Circle',
            },
            {
                value: 'cross',
                text: 'Cross',
            },
            {
                value: 'diamond',
                text: 'Diamond',
            },
            {
                value: 'plus',
                text: 'Plus',
            },
            {
                value: 'triangle',
                text: 'Triangle',
            },
            {
                value: 'heart',
                text: 'Heart',
            },
        ];
        this.seriesMarkerShapeSelect
            .addOptions(seriesMarkerShapeOptions)
            .setLabel(this.chartTranslationService.translate('shape'))
            .setValue(this.getSeriesOption('marker.shape'))
            .onValueChange(function (value) {
                return _this.setSeriesOption('marker.shape', value);
            });
        // scatter charts should always show markers
        var chartType = this.chartOptionsService.getChartType();
        var shouldHideEnabledCheckbox = _.includes(['scatter', 'bubble'], chartType);
        this.seriesMarkersGroup
            .setTitle(this.chartTranslationService.translate('markers'))
            .hideEnabledCheckbox(shouldHideEnabledCheckbox)
            .setEnabled(this.getSeriesOption('marker.enabled') || false)
            .hideOpenCloseIcons(true)
            .onEnableChange(function (newValue) {
                return _this.setSeriesOption('marker.enabled', newValue);
            });
        var initInput = function (expression, input, labelKey, defaultMaxValue) {
            var currentValue = _this.getSeriesOption(expression);
            input
                .setLabel(_this.chartTranslationService.translate(labelKey))
                .setMaxValue(getMaxValue(currentValue, defaultMaxValue))
                .setValue('' + currentValue)
                .setTextFieldWidth(45)
                .onValueChange(function (newValue) {
                    return _this.setSeriesOption(expression, newValue);
                });
        };
        if (chartType === 'bubble') {
            initInput('marker.maxSize', this.seriesMarkerMinSizeSlider, 'maxSize', 60);
            initInput('marker.size', this.seriesMarkerSizeSlider, 'minSize', 60);
        } else {
            this.seriesMarkerMinSizeSlider.setDisplayed(false);
            initInput('marker.size', this.seriesMarkerSizeSlider, 'size', 60);
        }
        initInput('marker.strokeWidth', this.seriesMarkerStrokeWidthSlider, 'strokeWidth', 10);
    };
    MarkersPanel.prototype.getSeriesOption = function (expression) {
        return this.chartOptionsService.getSeriesOption(expression, this.getSelectedSeries());
    };
    MarkersPanel.prototype.setSeriesOption = function (expression, newValue) {
        this.chartOptionsService.setSeriesOption(expression, newValue, this.getSelectedSeries());
    };
    MarkersPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="seriesMarkersGroup">\n                <ag-select ref="seriesMarkerShapeSelect"></ag-select>\n                <ag-slider ref="seriesMarkerMinSizeSlider"></ag-slider>\n                <ag-slider ref="seriesMarkerSizeSlider"></ag-slider>\n                <ag-slider ref="seriesMarkerStrokeWidthSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$_([RefSelector('seriesMarkersGroup')], MarkersPanel.prototype, 'seriesMarkersGroup', void 0);
    __decorate$_([RefSelector('seriesMarkerShapeSelect')], MarkersPanel.prototype, 'seriesMarkerShapeSelect', void 0);
    __decorate$_([RefSelector('seriesMarkerSizeSlider')], MarkersPanel.prototype, 'seriesMarkerSizeSlider', void 0);
    __decorate$_(
        [RefSelector('seriesMarkerMinSizeSlider')],
        MarkersPanel.prototype,
        'seriesMarkerMinSizeSlider',
        void 0,
    );
    __decorate$_(
        [RefSelector('seriesMarkerStrokeWidthSlider')],
        MarkersPanel.prototype,
        'seriesMarkerStrokeWidthSlider',
        void 0,
    );
    __decorate$_([Autowired('chartTranslationService')], MarkersPanel.prototype, 'chartTranslationService', void 0);
    __decorate$_([PostConstruct], MarkersPanel.prototype, 'init', null);
    return MarkersPanel;
})(Component);

var __extends$1t =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$Z =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var CalloutPanel = /** @class */ (function (_super) {
    __extends$1t(CalloutPanel, _super);
    function CalloutPanel(chartOptionsService, getSelectedSeries) {
        var _this = _super.call(this) || this;
        _this.chartOptionsService = chartOptionsService;
        _this.getSelectedSeries = getSelectedSeries;
        return _this;
    }
    CalloutPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-sub-level',
            direction: 'vertical',
        };
        this.setTemplate(CalloutPanel.TEMPLATE, { calloutGroup: groupParams });
        this.initCalloutOptions();
    };
    CalloutPanel.prototype.initCalloutOptions = function () {
        var _this = this;
        this.calloutGroup
            .setTitle(this.chartTranslationService.translate('callout'))
            .setEnabled(true)
            .hideOpenCloseIcons(true)
            .hideEnabledCheckbox(true);
        var initInput = function (expression, input, labelKey, defaultMaxValue) {
            var currentValue = _this.chartOptionsService.getSeriesOption(expression, _this.getSelectedSeries());
            input
                .setLabel(_this.chartTranslationService.translate(labelKey))
                .setMaxValue(getMaxValue(currentValue, defaultMaxValue))
                .setValue('' + currentValue)
                .setTextFieldWidth(45)
                .onValueChange(function (newValue) {
                    return _this.chartOptionsService.setSeriesOption(expression, newValue, _this.getSelectedSeries());
                });
        };
        initInput('calloutLine.length', this.calloutLengthSlider, 'length', 40);
        initInput('calloutLine.strokeWidth', this.calloutStrokeWidthSlider, 'strokeWidth', 10);
        initInput('calloutLabel.offset', this.labelOffsetSlider, 'offset', 30);
    };
    CalloutPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="calloutGroup">\n                <ag-slider ref="calloutLengthSlider"></ag-slider>\n                <ag-slider ref="calloutStrokeWidthSlider"></ag-slider>\n                <ag-slider ref="labelOffsetSlider"></ag-slider>\n            </ag-group-component>\n        </div>';
    __decorate$Z([RefSelector('calloutGroup')], CalloutPanel.prototype, 'calloutGroup', void 0);
    __decorate$Z([RefSelector('calloutLengthSlider')], CalloutPanel.prototype, 'calloutLengthSlider', void 0);
    __decorate$Z([RefSelector('calloutStrokeWidthSlider')], CalloutPanel.prototype, 'calloutStrokeWidthSlider', void 0);
    __decorate$Z([RefSelector('labelOffsetSlider')], CalloutPanel.prototype, 'labelOffsetSlider', void 0);
    __decorate$Z([Autowired('chartTranslationService')], CalloutPanel.prototype, 'chartTranslationService', void 0);
    __decorate$Z([PostConstruct], CalloutPanel.prototype, 'init', null);
    return CalloutPanel;
})(Component);

var __extends$1s =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$Y =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SeriesPanel = /** @class */ (function (_super) {
    __extends$1s(SeriesPanel, _super);
    function SeriesPanel(_a) {
        var chartController = _a.chartController,
            chartOptionsService = _a.chartOptionsService,
            seriesType = _a.seriesType,
            _b = _a.isExpandedOnInit,
            isExpandedOnInit = _b === void 0 ? false : _b;
        var _this = _super.call(this) || this;
        _this.activePanels = [];
        _this.widgetFuncs = {
            lineWidth: function () {
                return _this.initLineWidth();
            },
            strokeWidth: function () {
                return _this.initStrokeWidth();
            },
            lineDash: function () {
                return _this.initLineDash();
            },
            lineOpacity: function () {
                return _this.initLineOpacity();
            },
            fillOpacity: function () {
                return _this.initFillOpacity();
            },
            markers: function () {
                return _this.initMarkers();
            },
            labels: function () {
                return _this.initLabels();
            },
            shadow: function () {
                return _this.initShadow();
            },
            tooltips: function () {
                return _this.initTooltips();
            },
            bins: function () {
                return _this.initBins();
            },
        };
        _this.seriesWidgetMappings = {
            area: ['tooltips', 'lineWidth', 'lineDash', 'lineOpacity', 'fillOpacity', 'markers', 'labels', 'shadow'],
            bar: ['tooltips', 'strokeWidth', 'lineDash', 'lineOpacity', 'fillOpacity', 'labels', 'shadow'],
            column: ['tooltips', 'strokeWidth', 'lineDash', 'lineOpacity', 'fillOpacity', 'labels', 'shadow'],
            line: ['tooltips', 'lineWidth', 'lineDash', 'lineOpacity', 'markers', 'labels'],
            histogram: [
                'tooltips',
                'bins',
                'strokeWidth',
                'lineDash',
                'lineOpacity',
                'fillOpacity',
                'labels',
                'shadow',
            ],
            scatter: ['tooltips', 'markers', 'labels'],
            pie: ['tooltips', 'strokeWidth', 'lineOpacity', 'fillOpacity', 'labels', 'shadow'],
        };
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.seriesType = seriesType || _this.getChartSeriesType();
        _this.isExpandedOnInit = isExpandedOnInit;
        return _this;
    }
    SeriesPanel.prototype.init = function () {
        var groupParams = {
            cssIdentifier: 'charts-format-top-level',
            direction: 'vertical',
        };
        this.setTemplate(SeriesPanel.TEMPLATE, { seriesGroup: groupParams });
        this.seriesGroup
            .setTitle(this.translate('series'))
            .toggleGroupExpand(this.isExpandedOnInit)
            .hideEnabledCheckbox(true);
        this.addManagedListener(
            this.chartController,
            ChartController.EVENT_CHART_SERIES_CHART_TYPE_CHANGED,
            this.refreshWidgets.bind(this),
        );
        this.refreshWidgets();
    };
    SeriesPanel.prototype.refreshWidgets = function () {
        var _this = this;
        this.destroyActivePanels();
        var chart = this.chartController.getChartProxy().getChart();
        chart
            .waitForUpdate()
            .then(function () {
                if (_this.chartController.isComboChart()) {
                    _this.updateSeriesType();
                    _this.initSeriesSelect();
                }
                _this.seriesWidgetMappings[_this.seriesType].forEach(function (w) {
                    return _this.widgetFuncs[w]();
                });
            })
            .catch(function (e) {
                return console.error('AG Grid - chart rendering failed', e);
            });
    };
    SeriesPanel.prototype.initSeriesSelect = function () {
        var _this = this;
        var seriesSelect = this.seriesGroup.createManagedBean(new AgSelect());
        seriesSelect
            .setLabel(this.translate('seriesType'))
            .setLabelAlignment('left')
            .setLabelWidth('flex')
            .setInputWidth(100)
            .addOptions(this.getSeriesSelectOptions())
            .setValue('' + this.seriesType)
            .onValueChange(function (newValue) {
                _this.seriesType = newValue;
                _this.refreshWidgets();
            });
        this.seriesGroup.addItem(seriesSelect);
        this.activePanels.push(seriesSelect);
    };
    SeriesPanel.prototype.initTooltips = function () {
        var _this = this;
        var seriesTooltipsToggle = this.createBean(new AgToggleButton());
        seriesTooltipsToggle
            .setLabel(this.translate('tooltips'))
            .setLabelAlignment('left')
            .setLabelWidth('flex')
            .setInputWidth(45)
            .setValue(this.getSeriesOption('tooltip.enabled') || false)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('tooltip.enabled', newValue);
            });
        this.addWidget(seriesTooltipsToggle);
    };
    SeriesPanel.prototype.initStrokeWidth = function () {
        var _this = this;
        var currentValue = this.getSeriesOption('strokeWidth');
        var seriesStrokeWidthSlider = this.createBean(new AgSlider());
        seriesStrokeWidthSlider
            .setLabel(this.translate('strokeWidth'))
            .setMaxValue(getMaxValue(currentValue, 10))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('strokeWidth', newValue);
            });
        this.addWidget(seriesStrokeWidthSlider);
    };
    SeriesPanel.prototype.initLineWidth = function () {
        var _this = this;
        var currentValue = this.getSeriesOption('strokeWidth');
        var seriesLineWidthSlider = this.createBean(new AgSlider());
        seriesLineWidthSlider
            .setLabel(this.translate('lineWidth'))
            .setMaxValue(getMaxValue(currentValue, 10))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('strokeWidth', newValue);
            });
        this.addWidget(seriesLineWidthSlider);
    };
    SeriesPanel.prototype.initLineDash = function () {
        var _this = this;
        var lineDash = this.getSeriesOption('lineDash');
        var currentValue = lineDash ? lineDash[0] : 0;
        var seriesLineDashSlider = this.createBean(new AgSlider());
        seriesLineDashSlider
            .setLabel(this.translate('lineDash'))
            .setMaxValue(getMaxValue(currentValue, 30))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('lineDash', [newValue]);
            });
        this.addWidget(seriesLineDashSlider);
    };
    SeriesPanel.prototype.initLineOpacity = function () {
        var _this = this;
        var currentValue = this.getSeriesOption('strokeOpacity');
        var seriesLineOpacitySlider = this.createBean(new AgSlider());
        seriesLineOpacitySlider
            .setLabel(this.translate('strokeOpacity'))
            .setStep(0.05)
            .setMaxValue(getMaxValue(currentValue, 1))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('strokeOpacity', newValue);
            });
        this.addWidget(seriesLineOpacitySlider);
    };
    SeriesPanel.prototype.initFillOpacity = function () {
        var _this = this;
        var currentValue = this.getSeriesOption('fillOpacity');
        var seriesFillOpacitySlider = this.createBean(new AgSlider());
        seriesFillOpacitySlider
            .setLabel(this.translate('fillOpacity'))
            .setStep(0.05)
            .setMaxValue(getMaxValue(currentValue, 1))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('fillOpacity', newValue);
            });
        this.addWidget(seriesFillOpacitySlider);
    };
    SeriesPanel.prototype.initLabels = function () {
        var _this = this;
        var seriesOptionLabelProperty = this.seriesType === 'pie' ? 'calloutLabel' : 'label';
        var labelName =
            this.seriesType === 'pie'
                ? this.chartTranslationService.translate('calloutLabels')
                : this.chartTranslationService.translate('labels');
        var labelParams = initFontPanelParams({
            labelName: labelName,
            chartOptionsService: this.chartOptionsService,
            getSelectedSeries: function () {
                return _this.seriesType;
            },
            seriesOptionLabelProperty: seriesOptionLabelProperty,
        });
        var labelPanelComp = this.createBean(new FontPanel(labelParams));
        if (this.seriesType === 'pie') {
            var calloutPanelComp = this.createBean(
                new CalloutPanel(this.chartOptionsService, function () {
                    return _this.seriesType;
                }),
            );
            labelPanelComp.addCompToPanel(calloutPanelComp);
            this.activePanels.push(calloutPanelComp);
        }
        this.addWidget(labelPanelComp);
        if (this.seriesType === 'pie') {
            var sectorParams = initFontPanelParams({
                labelName: this.chartTranslationService.translate('sectorLabels'),
                chartOptionsService: this.chartOptionsService,
                getSelectedSeries: function () {
                    return _this.seriesType;
                },
                seriesOptionLabelProperty: 'sectorLabel',
            });
            var sectorPanelComp = this.createBean(new FontPanel(sectorParams));
            var positionRatioComp = this.getSectorLabelPositionRatio();
            sectorPanelComp.addCompToPanel(positionRatioComp);
            this.addWidget(sectorPanelComp);
        }
    };
    SeriesPanel.prototype.getSectorLabelPositionRatio = function () {
        var _this = this;
        var expression = 'sectorLabel.positionRatio';
        var currentValue = this.chartOptionsService.getSeriesOption(expression, this.seriesType);
        var sectorLabelPositionRatioSlider = this.createBean(new AgSlider());
        return sectorLabelPositionRatioSlider
            .setLabel(this.translate('positionRatio'))
            .setStep(0.05)
            .setMaxValue(getMaxValue(currentValue, 1))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.chartOptionsService.setSeriesOption(expression, newValue, _this.seriesType);
            });
    };
    SeriesPanel.prototype.initShadow = function () {
        var _this = this;
        var shadowPanelComp = this.createBean(
            new ShadowPanel(this.chartOptionsService, function () {
                return _this.seriesType;
            }),
        );
        this.addWidget(shadowPanelComp);
    };
    SeriesPanel.prototype.initMarkers = function () {
        var _this = this;
        var markersPanelComp = this.createBean(
            new MarkersPanel(this.chartOptionsService, function () {
                return _this.seriesType;
            }),
        );
        this.addWidget(markersPanelComp);
    };
    SeriesPanel.prototype.initBins = function () {
        var _this = this;
        var _a;
        var currentValue = (
            (_a = this.getSeriesOption('bins')) !== null && _a !== void 0 ? _a : this.getSeriesOption('calculatedBins')
        ).length;
        var seriesBinCountSlider = this.createBean(new AgSlider());
        seriesBinCountSlider
            .setLabel(this.translate('histogramBinCount'))
            .setMinValue(0)
            .setMaxValue(getMaxValue(currentValue, 20))
            .setTextFieldWidth(45)
            .setValue('' + currentValue)
            .onValueChange(function (newValue) {
                return _this.setSeriesOption('binCount', newValue);
            });
        this.addWidget(seriesBinCountSlider);
    };
    SeriesPanel.prototype.addWidget = function (widget) {
        this.seriesGroup.addItem(widget);
        this.activePanels.push(widget);
    };
    SeriesPanel.prototype.getSeriesOption = function (expression) {
        return this.chartOptionsService.getSeriesOption(expression, this.seriesType);
    };
    SeriesPanel.prototype.setSeriesOption = function (expression, newValue) {
        this.chartOptionsService.setSeriesOption(expression, newValue, this.seriesType);
    };
    SeriesPanel.prototype.getChartSeriesType = function () {
        if (this.chartController.getSeriesChartTypes().length === 0) return 'column';
        var ct = this.chartController.getSeriesChartTypes()[0].chartType;
        if (ct === 'columnLineCombo') return 'column';
        if (ct === 'areaColumnCombo') return 'area';
        return getSeriesType(ct);
    };
    SeriesPanel.prototype.getSeriesSelectOptions = function () {
        var _this = this;
        if (!this.seriesSelectOptions) {
            // lazy init options as they are only required for combo charts
            this.seriesSelectOptions = new Map([
                ['area', { value: 'area', text: this.translate('area', 'Area') }],
                ['bar', { value: 'bar', text: this.translate('bar', 'Bar') }],
                ['column', { value: 'column', text: this.translate('column', 'Column') }],
                ['line', { value: 'line', text: this.translate('line', 'Line') }],
                ['scatter', { value: 'scatter', text: this.translate('scatter', 'Scatter') }],
                ['histogram', { value: 'histogram', text: this.translate('histogram', 'Histogram') }],
                ['pie', { value: 'pie', text: this.translate('pie', 'Pie') }],
            ]);
        }
        var seriesSelectOptions = new Set();
        this.chartController.getActiveSeriesChartTypes().forEach(function (s) {
            var chartType = getSeriesType(s.chartType);
            seriesSelectOptions.add(_this.seriesSelectOptions.get(chartType));
        });
        return Array.from(seriesSelectOptions);
    };
    SeriesPanel.prototype.updateSeriesType = function () {
        var activeChartTypes = this.chartController.getActiveSeriesChartTypes().map(function (s) {
            return getSeriesType(s.chartType);
        });
        var invalidSeriesType = !activeChartTypes.includes(this.seriesType);
        if (invalidSeriesType && activeChartTypes.length > 0) {
            this.seriesType = activeChartTypes[0]; // default to first active series type
        }
    };
    SeriesPanel.prototype.translate = function (key, defaultText) {
        return this.chartTranslationService.translate(key, defaultText);
    };
    SeriesPanel.prototype.destroyActivePanels = function () {
        var _this = this;
        this.activePanels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    SeriesPanel.prototype.destroy = function () {
        this.destroyActivePanels();
        _super.prototype.destroy.call(this);
    };
    SeriesPanel.TEMPLATE =
        '<div>\n            <ag-group-component ref="seriesGroup">\n            </ag-group-component>\n        </div>';
    __decorate$Y([RefSelector('seriesGroup')], SeriesPanel.prototype, 'seriesGroup', void 0);
    __decorate$Y([Autowired('chartTranslationService')], SeriesPanel.prototype, 'chartTranslationService', void 0);
    __decorate$Y([PostConstruct], SeriesPanel.prototype, 'init', null);
    return SeriesPanel;
})(Component);

var __extends$1r =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$X =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
function getMaxValue(currentValue, defaultMaxValue) {
    return Math.max(currentValue, defaultMaxValue);
}
var DefaultFormatPanelDef = {
    groups: [{ type: 'chart' }, { type: 'legend' }, { type: 'series' }, { type: 'axis' }, { type: 'navigator' }],
};
var FormatPanel = /** @class */ (function (_super) {
    __extends$1r(FormatPanel, _super);
    function FormatPanel(chartController, chartOptionsService) {
        var _this = _super.call(this, FormatPanel.TEMPLATE) || this;
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.panels = [];
        _this.isGroupPanelShownInSeries = function (group, seriesType) {
            var commonGroupPanels = ['chart', 'legend', 'series'];
            if (commonGroupPanels.includes(group)) {
                return true;
            }
            var cartesianOnlyGroupPanels = ['axis', 'navigator'];
            var cartesianSeries = ['bar', 'column', 'line', 'area', 'scatter', 'histogram', 'cartesian'];
            return !!(cartesianOnlyGroupPanels.includes(group) && cartesianSeries.includes(seriesType));
        };
        return _this;
    }
    FormatPanel.prototype.init = function () {
        var _this = this;
        this.createPanels();
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_UPDATED, function () {
            return _this.createPanels(true);
        });
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_API_UPDATE, function () {
            return _this.createPanels(false);
        });
    };
    FormatPanel.prototype.createPanels = function (reuse) {
        var _this = this;
        var _a;
        var chartType = this.chartController.getChartType();
        var isGrouping = this.chartController.isGrouping();
        var seriesType = getSeriesType(chartType);
        if (reuse && chartType === this.chartType && isGrouping === this.isGrouping) {
            // existing panels can be re-used
            return;
        }
        this.destroyPanels();
        (_a = this.getFormatPanelDef().groups) === null || _a === void 0
            ? void 0
            : _a.forEach(function (groupDef) {
                  var group = groupDef.type;
                  // ensure the group should be displayed for the current series type
                  if (!_this.isGroupPanelShownInSeries(group, seriesType)) {
                      return;
                  }
                  var opts = {
                      chartController: _this.chartController,
                      chartOptionsService: _this.chartOptionsService,
                      isExpandedOnInit: groupDef.isOpen,
                      seriesType: seriesType,
                  };
                  if (group === 'chart') {
                      _this.addComponent(new ChartPanel(opts));
                  } else if (group === 'legend') {
                      _this.addComponent(new LegendPanel(opts));
                  } else if (group === 'axis') {
                      _this.addComponent(new AxisPanel(opts));
                  } else if (group === 'series') {
                      _this.addComponent(new SeriesPanel(opts));
                  } else if (group === 'navigator') {
                      _this.addComponent(new NavigatorPanel(opts));
                  } else {
                      console.warn("AG Grid: invalid charts format panel group name supplied: '" + groupDef.type + "'");
                  }
              });
        this.chartType = chartType;
        this.isGrouping = isGrouping;
    };
    FormatPanel.prototype.getFormatPanelDef = function () {
        var _a;
        var userProvidedFormatPanelDef =
            (_a = this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0
                ? void 0
                : _a.formatPanel;
        return userProvidedFormatPanelDef ? userProvidedFormatPanelDef : DefaultFormatPanelDef;
    };
    FormatPanel.prototype.addComponent = function (component) {
        this.createBean(component);
        this.panels.push(component);
        component.addCssClass('ag-chart-format-section');
        this.getGui().appendChild(component.getGui());
    };
    FormatPanel.prototype.destroyPanels = function () {
        var _this = this;
        this.panels.forEach(function (panel) {
            _.removeFromParent(panel.getGui());
            _this.destroyBean(panel);
        });
    };
    FormatPanel.prototype.destroy = function () {
        this.destroyPanels();
        _super.prototype.destroy.call(this);
    };
    FormatPanel.TEMPLATE = '<div class="ag-chart-format-wrapper"></div>';
    __decorate$X([PostConstruct], FormatPanel.prototype, 'init', null);
    return FormatPanel;
})(Component);

var __extends$1q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$W =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MiniChart = /** @class */ (function (_super) {
    __extends$1q(MiniChart, _super);
    function MiniChart(container, tooltipName) {
        var _this = _super.call(this) || this;
        _this.size = 58;
        _this.padding = 5;
        _this.root = new Group();
        var scene = new Scene({ document: window.document, width: _this.size, height: _this.size });
        scene.canvas.element.classList.add('ag-chart-mini-thumbnail-canvas');
        scene.root = _this.root;
        scene.container = container;
        _this.scene = scene;
        _this.tooltipName = tooltipName;
        return _this;
    }
    MiniChart.prototype.init = function () {
        this.scene.canvas.element.title = this.chartTranslationService.translate(this.tooltipName);
        // necessary to force scene graph render as we are not using the standalone factory!
        this.scene.render().catch(function (e) {
            return console.error('AG Grid - chart update failed', e);
        });
    };
    __decorate$W([Autowired('chartTranslationService')], MiniChart.prototype, 'chartTranslationService', void 0);
    __decorate$W([PostConstruct], MiniChart.prototype, 'init', null);
    return MiniChart;
})(Component);

var __extends$1p =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$V =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MiniChartWithAxes = /** @class */ (function (_super) {
    __extends$1p(MiniChartWithAxes, _super);
    function MiniChartWithAxes(container, tooltipName) {
        var _this = _super.call(this, container, tooltipName) || this;
        _this.stroke = 'gray';
        _this.axisOvershoot = 3;
        return _this;
    }
    MiniChartWithAxes.prototype.addAxes = function () {
        var size = this.size;
        var padding = this.padding;
        var leftAxis = new Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + this.axisOvershoot;
        leftAxis.stroke = this.stroke;
        var bottomAxis = new Line();
        bottomAxis.x1 = padding - this.axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = this.stroke;
        var root = this.root;
        root.append(leftAxis);
        root.append(bottomAxis);
    };
    __decorate$V([PostConstruct], MiniChartWithAxes.prototype, 'addAxes', null);
    return MiniChartWithAxes;
})(MiniChart);

function createColumnRects(params) {
    var stacked = params.stacked,
        size = params.size,
        padding = params.padding,
        xScalePadding = params.xScalePadding,
        xScaleDomain = params.xScaleDomain,
        yScaleDomain = params.yScaleDomain;
    var xScale = new BandScale$5();
    xScale.domain = xScaleDomain;
    xScale.range = [padding, size - padding];
    xScale.paddingInner = xScalePadding;
    xScale.paddingOuter = xScalePadding;
    var yScale = new LinearScale$1();
    yScale.domain = yScaleDomain;
    yScale.range = [size - padding, padding];
    var createBars = function (series, xScale, yScale) {
        return series.map(function (datum, i) {
            var top = yScale.convert(datum);
            var rect = new Rect();
            rect.x = xScale.convert(i);
            rect.y = top;
            rect.width = xScale.bandwidth;
            rect.height = yScale.convert(0) - top;
            rect.strokeWidth = 1;
            rect.crisp = true;
            return rect;
        });
    };
    if (stacked) {
        return params.data.map(function (d) {
            return createBars(d, xScale, yScale);
        });
    }
    return createBars(params.data, xScale, yScale);
}
function createLinePaths(root, data, size, padding) {
    var xScale = new LinearScale$1();
    xScale.domain = [0, 4];
    xScale.range = [padding, size - padding];
    var yScale = new LinearScale$1();
    yScale.domain = [0, 10];
    yScale.range = [size - padding, padding];
    var lines = data.map(function (series) {
        var line = new Path();
        line.strokeWidth = 3;
        line.lineCap = 'round';
        line.fill = undefined;
        series.forEach(function (datum, i) {
            line.path[i > 0 ? 'lineTo' : 'moveTo'](xScale.convert(i), yScale.convert(datum));
        });
        return line;
    });
    var linesGroup = new Group();
    linesGroup.setClipRectInGroupCoordinateSpace(new BBox(padding, padding, size - padding * 2, size - padding * 2));
    linesGroup.append(lines);
    root.append(linesGroup);
    return lines;
}

var __extends$1o =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniColumn = /** @class */ (function (_super) {
    __extends$1o(MiniColumn, _super);
    function MiniColumn(container, fills, strokes) {
        var _this = _super.call(this, container, 'groupedColumnTooltip') || this;
        _this.columnData = [2, 3, 4];
        var _a = _this,
            root = _a.root,
            columnData = _a.columnData,
            size = _a.size,
            padding = _a.padding;
        _this.columns = createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [0, 1, 2],
            yScaleDomain: [0, 4],
            xScalePadding: 0.3,
        });
        root.append(_this.columns);
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniColumn.prototype.updateColors = function (fills, strokes) {
        this.columns.forEach(function (column, i) {
            column.fill = fills[i];
            column.stroke = strokes[i];
        });
    };
    MiniColumn.chartType = 'groupedColumn';
    return MiniColumn;
})(MiniChartWithAxes);

var __extends$1n =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniStackedColumn = /** @class */ (function (_super) {
    __extends$1n(MiniStackedColumn, _super);
    function MiniStackedColumn(container, fills, strokes, data, yScaleDomain, tooltipName) {
        if (data === void 0) {
            data = MiniStackedColumn.data;
        }
        if (yScaleDomain === void 0) {
            yScaleDomain = [0, 16];
        }
        if (tooltipName === void 0) {
            tooltipName = 'stackedColumnTooltip';
        }
        var _this = _super.call(this, container, tooltipName) || this;
        var _a = _this,
            root = _a.root,
            size = _a.size,
            padding = _a.padding;
        _this.stackedColumns = createColumnRects({
            stacked: true,
            root: root,
            data: data,
            size: size,
            padding: padding,
            xScaleDomain: [0, 1, 2],
            yScaleDomain: yScaleDomain,
            xScalePadding: 0.3,
        });
        root.append([].concat.apply([], _this.stackedColumns));
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniStackedColumn.prototype.updateColors = function (fills, strokes) {
        this.stackedColumns.forEach(function (series, i) {
            return series.forEach(function (column) {
                column.fill = fills[i];
                column.stroke = strokes[i];
            });
        });
    };
    MiniStackedColumn.chartType = 'stackedColumn';
    MiniStackedColumn.data = [
        [8, 12, 16],
        [6, 9, 12],
        [2, 3, 4],
    ];
    return MiniStackedColumn;
})(MiniChartWithAxes);

var __extends$1m =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniNormalizedColumn = /** @class */ (function (_super) {
    __extends$1m(MiniNormalizedColumn, _super);
    function MiniNormalizedColumn(container, fills, strokes) {
        return (
            _super.call(
                this,
                container,
                fills,
                strokes,
                MiniNormalizedColumn.data,
                [0, 10],
                'normalizedColumnTooltip',
            ) || this
        );
    }
    MiniNormalizedColumn.chartType = 'normalizedColumn';
    MiniNormalizedColumn.data = [
        [10, 10, 10],
        [6, 7, 8],
        [2, 4, 6],
    ];
    return MiniNormalizedColumn;
})(MiniStackedColumn);

var __extends$1l =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniBar = /** @class */ (function (_super) {
    __extends$1l(MiniBar, _super);
    function MiniBar(container, fills, strokes) {
        var _this = _super.call(this, container, 'groupedBarTooltip') || this;
        var padding = _this.padding;
        var size = _this.size;
        var data = [2, 3, 4];
        var yScale = new BandScale$5();
        yScale.domain = [0, 1, 2];
        yScale.range = [padding, size - padding];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        var xScale = new LinearScale$1();
        xScale.domain = [0, 4];
        xScale.range = [size - padding, padding];
        var bottom = xScale.convert(0);
        var height = yScale.bandwidth;
        _this.bars = data.map(function (datum, i) {
            var rect = new Rect();
            rect.x = padding;
            rect.y = yScale.convert(i);
            rect.width = bottom - xScale.convert(datum);
            rect.height = height;
            rect.strokeWidth = 1;
            rect.crisp = true;
            return rect;
        });
        _this.updateColors(fills, strokes);
        _this.root.append(_this.bars);
        return _this;
    }
    MiniBar.prototype.updateColors = function (fills, strokes) {
        this.bars.forEach(function (bar, i) {
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    };
    MiniBar.chartType = 'groupedBar';
    return MiniBar;
})(MiniChartWithAxes);

var __extends$1k =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniStackedBar = /** @class */ (function (_super) {
    __extends$1k(MiniStackedBar, _super);
    function MiniStackedBar(container, fills, strokes, data, xScaleDomain, tooltipName) {
        if (data === void 0) {
            data = MiniStackedBar.data;
        }
        if (xScaleDomain === void 0) {
            xScaleDomain = [0, 16];
        }
        if (tooltipName === void 0) {
            tooltipName = 'stackedBarTooltip';
        }
        var _this = _super.call(this, container, tooltipName) || this;
        var size = _this.size;
        var padding = _this.padding;
        var yScale = new BandScale$5();
        yScale.domain = [0, 1, 2];
        yScale.range = [padding, size - padding];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        var xScale = new LinearScale$1();
        xScale.domain = xScaleDomain;
        xScale.range = [size - padding, padding];
        var bottom = xScale.convert(0);
        var height = yScale.bandwidth;
        _this.bars = data.map(function (series) {
            return series.map(function (datum, i) {
                var rect = new Rect();
                rect.x = padding;
                rect.y = yScale.convert(i);
                rect.width = bottom - xScale.convert(datum);
                rect.height = height;
                rect.strokeWidth = 1;
                rect.crisp = true;
                return rect;
            });
        });
        _this.updateColors(fills, strokes);
        _this.root.append([].concat.apply([], _this.bars));
        return _this;
    }
    MiniStackedBar.prototype.updateColors = function (fills, strokes) {
        this.bars.forEach(function (series, i) {
            return series.forEach(function (bar) {
                bar.fill = fills[i];
                bar.stroke = strokes[i];
            });
        });
    };
    MiniStackedBar.chartType = 'stackedBar';
    MiniStackedBar.data = [
        [8, 12, 16],
        [6, 9, 12],
        [2, 3, 4],
    ];
    return MiniStackedBar;
})(MiniChartWithAxes);

var __extends$1j =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniNormalizedBar = /** @class */ (function (_super) {
    __extends$1j(MiniNormalizedBar, _super);
    function MiniNormalizedBar(container, fills, strokes) {
        return (
            _super.call(this, container, fills, strokes, MiniNormalizedBar.data, [0, 10], 'normalizedBarTooltip') ||
            this
        );
    }
    MiniNormalizedBar.chartType = 'normalizedBar';
    MiniNormalizedBar.data = [
        [10, 10, 10],
        [6, 7, 8],
        [2, 4, 6],
    ];
    return MiniNormalizedBar;
})(MiniStackedBar);

var __extends$1i =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$m =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var toRadians = toRadians$1;
var MiniDoughnut = /** @class */ (function (_super) {
    __extends$1i(MiniDoughnut, _super);
    function MiniDoughnut(container, fills, strokes, centerRadiusScaler, tooltipName) {
        if (centerRadiusScaler === void 0) {
            centerRadiusScaler = 0.6;
        }
        if (tooltipName === void 0) {
            tooltipName = 'doughnutTooltip';
        }
        var _this = _super.call(this, container, tooltipName) || this;
        var radius = (_this.size - _this.padding * 2) / 2;
        var center = radius + _this.padding;
        var angles = [
            [toRadians(-90), toRadians(30)],
            [toRadians(30), toRadians(120)],
            [toRadians(120), toRadians(180)],
            [toRadians(180), toRadians(210)],
            [toRadians(210), toRadians(240)],
            [toRadians(240), toRadians(270)],
        ];
        _this.sectors = angles.map(function (_a) {
            var _b = __read$m(_a, 2),
                startAngle = _b[0],
                endAngle = _b[1];
            var sector = new Sector();
            sector.centerX = center;
            sector.centerY = center;
            sector.innerRadius = radius * centerRadiusScaler;
            sector.outerRadius = radius;
            sector.startAngle = startAngle;
            sector.endAngle = endAngle;
            sector.stroke = undefined;
            sector.strokeWidth = 1;
            return sector;
        });
        _this.updateColors(fills, strokes);
        _this.root.append(_this.sectors);
        return _this;
    }
    MiniDoughnut.prototype.updateColors = function (fills, strokes) {
        this.sectors.forEach(function (sector, i) {
            sector.fill = fills[i % fills.length];
            sector.stroke = strokes[i % strokes.length];
        });
    };
    MiniDoughnut.chartType = 'doughnut';
    return MiniDoughnut;
})(MiniChart);

var __extends$1h =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniPie = /** @class */ (function (_super) {
    __extends$1h(MiniPie, _super);
    function MiniPie(container, fills, strokes) {
        return _super.call(this, container, fills, strokes, 0, 'pieTooltip') || this;
    }
    MiniPie.chartType = 'pie';
    return MiniPie;
})(MiniDoughnut);

var __extends$1g =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniLine = /** @class */ (function (_super) {
    __extends$1g(MiniLine, _super);
    function MiniLine(container, fills, strokes) {
        var _this = _super.call(this, container, 'lineTooltip') || this;
        _this.data = [
            [9, 7, 8, 5, 6],
            [5, 6, 3, 4, 1],
            [1, 3, 4, 8, 7],
        ];
        _this.lines = createLinePaths(_this.root, _this.data, _this.size, _this.padding);
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniLine.prototype.updateColors = function (fills, strokes) {
        this.lines.forEach(function (line, i) {
            line.stroke = fills[i];
        });
    };
    MiniLine.chartType = 'line';
    return MiniLine;
})(MiniChartWithAxes);

var __extends$1f =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$l =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var MiniScatter = /** @class */ (function (_super) {
    __extends$1f(MiniScatter, _super);
    function MiniScatter(container, fills, strokes) {
        var _this = _super.call(this, container, 'scatterTooltip') || this;
        var size = _this.size;
        var padding = _this.padding;
        // [x, y] pairs
        var data = [
            [
                [0.3, 3],
                [1.1, 0.9],
                [2, 0.4],
                [3.4, 2.4],
            ],
            [
                [0, 0.3],
                [1, 2],
                [2.4, 1.4],
                [3, 0],
            ],
        ];
        var xScale = new LinearScale$1();
        xScale.domain = [-0.5, 4];
        xScale.range = [padding * 2, size - padding];
        var yScale = new LinearScale$1();
        yScale.domain = [-0.5, 3.5];
        yScale.range = [size - padding, padding];
        var points = [];
        data.forEach(function (series) {
            series.forEach(function (_a) {
                var _b = __read$l(_a, 2),
                    x = _b[0],
                    y = _b[1];
                var arc = new Arc();
                arc.strokeWidth = 1;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = 2.5;
                points.push(arc);
            });
        });
        _this.points = points;
        _this.updateColors(fills, strokes);
        var pointsGroup = new Group();
        pointsGroup.setClipRectInGroupCoordinateSpace(
            new BBox(padding, padding, size - padding * 2, size - padding * 2),
        );
        pointsGroup.append(_this.points);
        _this.root.append(pointsGroup);
        return _this;
    }
    MiniScatter.prototype.updateColors = function (fills, strokes) {
        this.points.forEach(function (line, i) {
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    };
    MiniScatter.chartType = 'scatter';
    return MiniScatter;
})(MiniChartWithAxes);

var __extends$1e =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$k =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var MiniBubble = /** @class */ (function (_super) {
    __extends$1e(MiniBubble, _super);
    function MiniBubble(container, fills, strokes) {
        var _this = _super.call(this, container, 'bubbleTooltip') || this;
        var size = _this.size;
        var padding = _this.padding;
        // [x, y, radius] triples
        var data = [
            [
                [0.1, 0.3, 5],
                [0.5, 0.4, 7],
                [0.2, 0.8, 7],
            ],
            [
                [0.8, 0.7, 5],
                [0.7, 0.3, 9],
            ],
        ];
        var xScale = new LinearScale$1();
        xScale.domain = [0, 1];
        xScale.range = [padding * 2, size - padding];
        var yScale = new LinearScale$1();
        yScale.domain = [0, 1];
        yScale.range = [size - padding, padding];
        var points = [];
        data.forEach(function (series) {
            series.forEach(function (_a) {
                var _b = __read$k(_a, 3),
                    x = _b[0],
                    y = _b[1],
                    radius = _b[2];
                var arc = new Arc();
                arc.strokeWidth = 1;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = radius;
                arc.fillOpacity = 0.7;
                points.push(arc);
            });
        });
        _this.points = points;
        _this.updateColors(fills, strokes);
        var pointsGroup = new Group();
        pointsGroup.setClipRectInGroupCoordinateSpace(
            new BBox(padding, padding, size - padding * 2, size - padding * 2),
        );
        pointsGroup.append(_this.points);
        _this.root.append(pointsGroup);
        return _this;
    }
    MiniBubble.prototype.updateColors = function (fills, strokes) {
        this.points.forEach(function (line, i) {
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    };
    MiniBubble.chartType = 'bubble';
    return MiniBubble;
})(MiniChartWithAxes);

var __extends$1d =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniArea = /** @class */ (function (_super) {
    __extends$1d(MiniArea, _super);
    function MiniArea(container, fills, strokes, data) {
        if (data === void 0) {
            data = MiniArea.data;
        }
        var _this = _super.call(this, container, 'groupedAreaTooltip') || this;
        var size = _this.size;
        var padding = _this.padding;
        var xScale = new BandScale$5();
        xScale.domain = [0, 1, 2];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        xScale.range = [padding + 0.5, size - padding - 0.5];
        var yScale = new LinearScale$1();
        yScale.domain = [0, 6];
        yScale.range = [size - padding + 0.5, padding];
        var xCount = data.length;
        var last = xCount * 2 - 1;
        var pathData = [];
        var bottomY = yScale.convert(0);
        data.forEach(function (datum, i) {
            var x = xScale.convert(i);
            datum.forEach(function (yDatum, j) {
                var y = yScale.convert(yDatum);
                var points = pathData[j] || (pathData[j] = []);
                points[i] = {
                    x: x,
                    y: y,
                };
                points[last - i] = {
                    x: x,
                    y: bottomY,
                };
            });
        });
        _this.areas = pathData.reverse().map(function (points) {
            var area = new Path();
            area.strokeWidth = 1;
            area.fillOpacity = 0.7;
            var path = area.path;
            path.clear();
            points.forEach(function (point, i) {
                return path[i > 0 ? 'lineTo' : 'moveTo'](point.x, point.y);
            });
            path.closePath();
            return area;
        });
        _this.updateColors(fills, strokes);
        _this.root.append(_this.areas);
        return _this;
    }
    MiniArea.prototype.updateColors = function (fills, strokes) {
        this.areas.forEach(function (area, i) {
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    };
    MiniArea.chartType = 'area';
    MiniArea.data = [
        [1, 3, 5],
        [2, 6, 4],
        [5, 3, 1],
    ];
    return MiniArea;
})(MiniChartWithAxes);

var __extends$1c =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniStackedArea = /** @class */ (function (_super) {
    __extends$1c(MiniStackedArea, _super);
    function MiniStackedArea(container, fills, strokes, data, tooltipName) {
        if (data === void 0) {
            data = MiniStackedArea.data;
        }
        if (tooltipName === void 0) {
            tooltipName = 'stackedAreaTooltip';
        }
        var _this = _super.call(this, container, tooltipName) || this;
        var size = _this.size;
        var padding = _this.padding;
        var xScale = new BandScale$5();
        xScale.domain = [0, 1, 2];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        xScale.range = [padding + 0.5, size - padding - 0.5];
        var yScale = new LinearScale$1();
        yScale.domain = [0, 16];
        yScale.range = [size - padding + 0.5, padding + 0.5];
        var xCount = data.length;
        var last = xCount * 2 - 1;
        var pathData = [];
        data.forEach(function (datum, i) {
            var x = xScale.convert(i);
            var total = 0;
            datum.forEach(function (yDatum, j) {
                var y = yScale.convert(total + yDatum);
                var points = pathData[j] || (pathData[j] = []);
                points[i] = {
                    x: x,
                    y: y,
                };
                points[last - i] = {
                    x: x,
                    y: yScale.convert(total), // bottom y
                };
                total += yDatum;
            });
        });
        _this.areas = pathData.map(function (points) {
            var area = new Path();
            area.strokeWidth = 1;
            var path = area.path;
            path.clear();
            points.forEach(function (point, i) {
                return path[i > 0 ? 'lineTo' : 'moveTo'](point.x, point.y);
            });
            path.closePath();
            return area;
        });
        _this.updateColors(fills, strokes);
        _this.root.append(_this.areas);
        return _this;
    }
    MiniStackedArea.prototype.updateColors = function (fills, strokes) {
        this.areas.forEach(function (area, i) {
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    };
    MiniStackedArea.chartType = 'stackedArea';
    MiniStackedArea.data = [
        [2, 3, 2],
        [3, 6, 5],
        [6, 2, 2],
    ];
    return MiniStackedArea;
})(MiniChartWithAxes);

var __extends$1b =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniNormalizedArea = /** @class */ (function (_super) {
    __extends$1b(MiniNormalizedArea, _super);
    function MiniNormalizedArea(container, fills, strokes, data) {
        if (data === void 0) {
            data = MiniNormalizedArea.data;
        }
        return _super.call(this, container, fills, strokes, data, 'normalizedAreaTooltip') || this;
    }
    MiniNormalizedArea.chartType = 'normalizedArea';
    MiniNormalizedArea.data = MiniStackedArea.data.map(function (stack) {
        var sum = stack.reduce(function (p, c) {
            return p + c;
        }, 0);
        return stack.map(function (v) {
            return (v / sum) * 16;
        });
    });
    return MiniNormalizedArea;
})(MiniStackedArea);

var __extends$1a =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __read$j =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var MiniHistogram = /** @class */ (function (_super) {
    __extends$1a(MiniHistogram, _super);
    function MiniHistogram(container, fills, strokes) {
        var _this = _super.call(this, container, 'histogramTooltip') || this;
        var padding = _this.padding;
        var size = _this.size;
        // approx normal curve
        var data = [2, 5, 11, 13, 10, 6, 1];
        var xScale = new LinearScale$1();
        xScale.domain = [0, data.length];
        xScale.range = [padding, size - padding];
        var yScale = new LinearScale$1();
        yScale.domain = [
            0,
            data.reduce(function (a, b) {
                return Math.max(a, b);
            }, 0),
        ];
        yScale.range = [size - padding, padding];
        var bottom = yScale.convert(0);
        _this.bars = data.map(function (datum, i) {
            var top = yScale.convert(datum);
            var left = xScale.convert(i);
            var right = xScale.convert(i + 1);
            var rect = new Rect();
            rect.x = left;
            rect.y = top;
            rect.width = right - left;
            rect.height = bottom - top;
            rect.strokeWidth = 1;
            rect.crisp = true;
            return rect;
        });
        _this.updateColors(fills, strokes);
        _this.root.append(_this.bars);
        return _this;
    }
    MiniHistogram.prototype.updateColors = function (_a, _b) {
        var _c = __read$j(_a, 1),
            fill = _c[0];
        var _d = __read$j(_b, 1),
            stroke = _d[0];
        this.bars.forEach(function (bar) {
            bar.fill = fill;
            bar.stroke = stroke;
        });
    };
    MiniHistogram.chartType = 'histogram';
    return MiniHistogram;
})(MiniChartWithAxes);

var __extends$19 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniColumnLineCombo = /** @class */ (function (_super) {
    __extends$19(MiniColumnLineCombo, _super);
    function MiniColumnLineCombo(container, fills, strokes) {
        var _this = _super.call(this, container, 'columnLineComboTooltip') || this;
        _this.columnData = [3, 4];
        _this.lineData = [[5, 4, 6, 5, 4]];
        var _a = _this,
            root = _a.root,
            columnData = _a.columnData,
            lineData = _a.lineData,
            size = _a.size,
            padding = _a.padding;
        _this.columns = createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [0, 1],
            yScaleDomain: [0, 4],
            xScalePadding: 0.5,
        });
        root.append(_this.columns);
        _this.lines = createLinePaths(root, lineData, size, padding);
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniColumnLineCombo.prototype.updateColors = function (fills, strokes) {
        this.columns.forEach(function (bar, i) {
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach(function (line, i) {
            line.stroke = fills[i + 2];
        });
    };
    MiniColumnLineCombo.chartType = 'columnLineCombo';
    return MiniColumnLineCombo;
})(MiniChartWithAxes);

var __extends$18 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniAreaColumnCombo = /** @class */ (function (_super) {
    __extends$18(MiniAreaColumnCombo, _super);
    function MiniAreaColumnCombo(container, fills, strokes) {
        var _this = _super.call(this, container, 'areaColumnComboTooltip') || this;
        _this.columnData = [3, 4.5];
        _this.areaData = [[5, 4, 6, 5, 4]];
        var _a = _this,
            root = _a.root,
            columnData = _a.columnData,
            areaData = _a.areaData,
            size = _a.size,
            padding = _a.padding;
        _this.columns = createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [0, 1],
            yScaleDomain: [0, 6],
            xScalePadding: 0.5,
        });
        // scale for area series
        var xScale = new BandScale$5();
        xScale.range = [padding, size - padding];
        xScale.domain = [0, 1, 2, 3, 4];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        var yScale = new LinearScale$1();
        yScale.range = [size - padding, padding];
        yScale.domain = [0, 6];
        var pathData = [];
        var yZero = yScale.convert(0);
        var firstX = xScale.convert(0);
        areaData.forEach(function (series, i) {
            var points = pathData[i] || (pathData[i] = []);
            series.forEach(function (data, j) {
                var yDatum = data;
                var xDatum = j;
                var x = xScale.convert(xDatum);
                var y = yScale.convert(yDatum);
                points[j] = { x: x, y: y };
            });
            var lastX = xScale.convert(series.length - 1);
            pathData[i].push(
                {
                    x: lastX,
                    y: yZero,
                },
                {
                    x: firstX,
                    y: yZero,
                },
            );
        });
        _this.areas = pathData.map(function (points) {
            var area = new Path();
            area.strokeWidth = 1;
            area.fillOpacity = 0.8;
            var path = area.path;
            points.forEach(function (point, i) {
                return path[i > 0 ? 'lineTo' : 'moveTo'](point.x, point.y);
            });
            return area;
        });
        root.append(_this.areas);
        root.append([].concat.apply([], _this.columns));
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniAreaColumnCombo.prototype.updateColors = function (fills, strokes) {
        this.areas.forEach(function (area, i) {
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
        this.columns.forEach(function (bar, i) {
            bar.fill = fills[i + 1];
            bar.stroke = strokes[i + 1];
        });
    };
    MiniAreaColumnCombo.chartType = 'areaColumnCombo';
    return MiniAreaColumnCombo;
})(MiniChartWithAxes);

var __extends$17 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var MiniCustomCombo = /** @class */ (function (_super) {
    __extends$17(MiniCustomCombo, _super);
    function MiniCustomCombo(container, fills, strokes) {
        var _this = _super.call(this, container, 'customComboTooltip') || this;
        _this.columnData = [3, 4];
        _this.lineData = [[5, 4, 6, 5, 4]];
        var _a = _this,
            root = _a.root,
            columnData = _a.columnData,
            lineData = _a.lineData,
            size = _a.size,
            padding = _a.padding;
        _this.columns = createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [0, 1],
            yScaleDomain: [0, 4],
            xScalePadding: 0.5,
        });
        root.append(_this.columns);
        _this.lines = createLinePaths(root, lineData, size, padding);
        var axisStroke = 'grey';
        var axisOvershoot = 3;
        var leftAxis = new Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + axisOvershoot;
        leftAxis.stroke = axisStroke;
        var bottomAxis = new Line();
        bottomAxis.x1 = padding - axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = axisStroke;
        var penIcon = new Path();
        _this.buildPenIconPath(penIcon);
        penIcon.fill = 'whitesmoke';
        penIcon.stroke = 'darkslategrey';
        penIcon.strokeWidth = 1;
        root.append([bottomAxis, leftAxis, penIcon]);
        _this.updateColors(fills, strokes);
        return _this;
    }
    MiniCustomCombo.prototype.updateColors = function (fills, strokes) {
        this.columns.forEach(function (bar, i) {
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach(function (line, i) {
            line.stroke = fills[i + 2];
        });
    };
    MiniCustomCombo.prototype.buildPenIconPath = function (penIcon) {
        var path = penIcon.path;
        path.moveTo(25.76, 43.46);
        path.lineTo(31.27, 48.53);
        path.moveTo(49.86, 22);
        path.lineTo(49.86, 22);
        path.cubicCurveTo(49.01994659053345, 21.317514933510974, 47.89593834348529, 21.09645997825817, 46.86, 21.41);
        path.lineTo(46.86, 21.41);
        path.cubicCurveTo(45.55460035985361, 21.77260167850787, 44.38777081121966, 22.517979360321792, 43.51, 23.55);
        path.lineTo(25.51, 43.8);
        path.lineTo(25.43, 43.89);
        path.lineTo(23.01, 51.89);
        path.lineTo(22.83, 52.46);
        path.lineTo(31.02, 48.86);
        path.lineTo(49.02, 28.52);
        path.lineTo(49.02, 28.52);
        path.cubicCurveTo(49.940716461596224, 27.521914221246085, 50.54302631059587, 26.2720342455763, 50.75, 24.93);
        path.lineTo(50.75, 24.93);
        path.cubicCurveTo(50.95363374988308, 23.866379846512814, 50.62080640232334, 22.77066734274871, 49.86, 22.0);
        path.closePath();
        path.moveTo(41.76, 25.5);
        path.lineTo(47.34, 30.5);
        path.moveTo(40.74, 26.65);
        path.lineTo(46.25, 31.71);
    };
    MiniCustomCombo.chartType = 'customCombo';
    return MiniCustomCombo;
})(MiniChart);

var __extends$16 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$o =
    (undefined && undefined.__assign) ||
    function () {
        __assign$o =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$o.apply(this, arguments);
    };
var __decorate$U =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var miniChartMapping = {
    columnGroup: {
        column: MiniColumn,
        stackedColumn: MiniStackedColumn,
        normalizedColumn: MiniNormalizedColumn,
    },
    barGroup: {
        bar: MiniBar,
        stackedBar: MiniStackedBar,
        normalizedBar: MiniNormalizedBar,
    },
    pieGroup: {
        pie: MiniPie,
        doughnut: MiniDoughnut,
    },
    lineGroup: {
        line: MiniLine,
    },
    scatterGroup: {
        scatter: MiniScatter,
        bubble: MiniBubble,
    },
    areaGroup: {
        area: MiniArea,
        stackedArea: MiniStackedArea,
        normalizedArea: MiniNormalizedArea,
    },
    histogramGroup: {
        histogram: MiniHistogram,
    },
    combinationGroup: {
        columnLineCombo: MiniColumnLineCombo,
        areaColumnCombo: MiniAreaColumnCombo,
        customCombo: MiniCustomCombo,
    },
};
var MiniChartsContainer = /** @class */ (function (_super) {
    __extends$16(MiniChartsContainer, _super);
    function MiniChartsContainer(chartController, fills, strokes, chartGroups) {
        if (chartGroups === void 0) {
            chartGroups = DEFAULT_CHART_GROUPS;
        }
        var _this = _super.call(this, MiniChartsContainer.TEMPLATE) || this;
        _this.wrappers = {};
        _this.chartController = chartController;
        _this.fills = fills;
        _this.strokes = strokes;
        _this.chartGroups = __assign$o({}, chartGroups);
        return _this;
    }
    MiniChartsContainer.prototype.init = function () {
        var _this = this;
        // hide MiniCustomCombo if no custom combo exists
        if (!this.chartController.customComboExists() && this.chartGroups.combinationGroup) {
            this.chartGroups.combinationGroup = this.chartGroups.combinationGroup.filter(function (chartType) {
                return chartType !== 'customCombo';
            });
        }
        var eGui = this.getGui();
        Object.keys(this.chartGroups).forEach(function (group) {
            var chartGroupValues = _this.chartGroups[group];
            var groupComponent = _this.createBean(
                new AgGroupComponent({
                    title: _this.chartTranslationService.translate(group),
                    suppressEnabledCheckbox: true,
                    enabled: true,
                    suppressOpenCloseIcons: true,
                    cssIdentifier: 'charts-settings',
                    direction: 'horizontal',
                }),
            );
            chartGroupValues.forEach(function (chartType) {
                var _a;
                var MiniClass = (_a = miniChartMapping[group]) === null || _a === void 0 ? void 0 : _a[chartType];
                if (!MiniClass) {
                    if (miniChartMapping[group]) {
                        _.doOnce(function () {
                            return console.warn(
                                "AG Grid - invalid chartGroupsDef config '" + group + '.' + chartType + "'",
                            );
                        }, 'invalid_chartGroupsDef' + chartType + '_' + group);
                    } else {
                        _.doOnce(function () {
                            return console.warn("AG Grid - invalid chartGroupsDef config '" + group + "'");
                        }, 'invalid_chartGroupsDef' + group);
                    }
                    return;
                }
                var miniWrapper = document.createElement('div');
                miniWrapper.classList.add('ag-chart-mini-thumbnail');
                var miniClassChartType = MiniClass.chartType;
                _this.addManagedListener(miniWrapper, 'click', function () {
                    _this.chartController.setChartType(miniClassChartType);
                    _this.updateSelectedMiniChart();
                });
                _this.wrappers[miniClassChartType] = miniWrapper;
                _this.createBean(new MiniClass(miniWrapper, _this.fills, _this.strokes));
                groupComponent.addItem(miniWrapper);
            });
            eGui.appendChild(groupComponent.getGui());
        });
        this.updateSelectedMiniChart();
    };
    MiniChartsContainer.prototype.updateSelectedMiniChart = function () {
        var selectedChartType = this.chartController.getChartType();
        for (var miniChartType in this.wrappers) {
            var miniChart = this.wrappers[miniChartType];
            var selected = miniChartType === selectedChartType;
            miniChart.classList.toggle('ag-selected', selected);
        }
    };
    MiniChartsContainer.TEMPLATE = '<div class="ag-chart-settings-mini-wrapper"></div>';
    __decorate$U(
        [Autowired('chartTranslationService')],
        MiniChartsContainer.prototype,
        'chartTranslationService',
        void 0,
    );
    __decorate$U([PostConstruct], MiniChartsContainer.prototype, 'init', null);
    return MiniChartsContainer;
})(Component);

var __extends$15 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$T =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartSettingsPanel = /** @class */ (function (_super) {
    __extends$15(ChartSettingsPanel, _super);
    function ChartSettingsPanel(chartController) {
        var _this = _super.call(this, ChartSettingsPanel.TEMPLATE) || this;
        _this.miniChartsContainers = [];
        _this.cardItems = [];
        _this.activePaletteIndex = 0;
        _this.palettes = [];
        _this.themes = [];
        _this.chartController = chartController;
        return _this;
    }
    ChartSettingsPanel.prototype.postConstruct = function () {
        var _this = this;
        this.resetPalettes();
        this.ePrevBtn.insertAdjacentElement('afterbegin', _.createIconNoSpan('previous', this.gridOptionsService));
        this.eNextBtn.insertAdjacentElement('afterbegin', _.createIconNoSpan('next', this.gridOptionsService));
        this.addManagedListener(this.ePrevBtn, 'click', function () {
            return _this.setActivePalette(_this.getPrev(), 'left');
        });
        this.addManagedListener(this.eNextBtn, 'click', function () {
            return _this.setActivePalette(_this.getNext(), 'right');
        });
        // change the selected chart when a combo chart is modified via the data panel, i.e. the custom combo should be selected
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_TYPE_CHANGED, function () {
            return _this.resetPalettes(true);
        });
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_API_UPDATE, function () {
            return _this.resetPalettes(true);
        });
        this.scrollSelectedIntoView();
    };
    ChartSettingsPanel.prototype.scrollSelectedIntoView = function () {
        var _this = this;
        // the panel is not immediately visible due to the slide animation, so we add a
        // setTimeout to wait until the panel animation is over and is able to scroll
        setTimeout(function () {
            var isMiniChartsContainerVisible = function (miniChartsContainers) {
                return !miniChartsContainers.getGui().classList.contains('ag-hidden');
            };
            var currentMiniChartContainer = _this.miniChartsContainers.find(isMiniChartsContainerVisible);
            var currentChart = currentMiniChartContainer.getGui().querySelector('.ag-selected');
            if (currentChart) {
                var parent_1 = currentChart.offsetParent;
                if (parent_1) {
                    _this.eMiniChartsContainer.scrollTo(0, parent_1.offsetTop);
                }
            }
        }, 250);
    };
    ChartSettingsPanel.prototype.resetPalettes = function (forceReset) {
        var _this = this;
        var _a, _b;
        var palettes = this.chartController.getPalettes();
        var chartGroups =
            (_b =
                (_a = this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0
                    ? void 0
                    : _a.settingsPanel) === null || _b === void 0
                ? void 0
                : _b.chartGroupsDef;
        if ((_.shallowCompare(palettes, this.palettes) && !forceReset) || this.isAnimating) {
            return;
        }
        this.palettes = palettes;
        this.themes = this.chartController.getThemes();
        this.activePaletteIndex = this.themes.findIndex(function (name) {
            return name === _this.chartController.getChartThemeName();
        });
        this.cardItems = [];
        _.clearElement(this.eCardSelector);
        this.destroyMiniCharts();
        this.palettes.forEach(function (palette, index) {
            var isActivePalette = _this.activePaletteIndex === index;
            var fills = palette.fills,
                strokes = palette.strokes;
            var miniChartsContainer = _this.createBean(
                new MiniChartsContainer(_this.chartController, fills, strokes, chartGroups),
            );
            _this.miniChartsContainers.push(miniChartsContainer);
            _this.eMiniChartsContainer.appendChild(miniChartsContainer.getGui());
            _this.addCardLink(index);
            if (isActivePalette) {
                miniChartsContainer.updateSelectedMiniChart();
            } else {
                miniChartsContainer.setDisplayed(false);
            }
        });
        _.setDisplayed(this.eNavBar, this.palettes.length > 1);
        _.radioCssClass(this.cardItems[this.activePaletteIndex], 'ag-selected', 'ag-not-selected');
    };
    ChartSettingsPanel.prototype.addCardLink = function (index) {
        var _this = this;
        var link = document.createElement('div');
        link.classList.add('ag-chart-settings-card-item');
        this.addManagedListener(link, 'click', function () {
            _this.setActivePalette(index, index < _this.activePaletteIndex ? 'left' : 'right');
        });
        this.eCardSelector.appendChild(link);
        this.cardItems.push(link);
    };
    ChartSettingsPanel.prototype.getPrev = function () {
        var prev = this.activePaletteIndex - 1;
        if (prev < 0) {
            prev = this.palettes.length - 1;
        }
        return prev;
    };
    ChartSettingsPanel.prototype.getNext = function () {
        var next = this.activePaletteIndex + 1;
        if (next >= this.palettes.length) {
            next = 0;
        }
        return next;
    };
    ChartSettingsPanel.prototype.setActivePalette = function (index, animationDirection) {
        var _this = this;
        if (this.isAnimating || this.activePaletteIndex === index) {
            return;
        }
        _.radioCssClass(this.cardItems[index], 'ag-selected', 'ag-not-selected');
        var currentPalette = this.miniChartsContainers[this.activePaletteIndex];
        var currentGui = currentPalette.getGui();
        var futurePalette = this.miniChartsContainers[index];
        var nextGui = futurePalette.getGui();
        currentPalette.updateSelectedMiniChart();
        futurePalette.updateSelectedMiniChart();
        var multiplier = animationDirection === 'left' ? -1 : 1;
        var final = (nextGui.style.left = _.getAbsoluteWidth(this.getGui()) * multiplier + 'px');
        this.activePaletteIndex = index;
        this.isAnimating = true;
        var animatingClass = 'ag-animating';
        futurePalette.setDisplayed(true);
        currentPalette.addCssClass(animatingClass);
        futurePalette.addCssClass(animatingClass);
        this.chartController.setChartThemeName(this.themes[index]);
        window.setTimeout(function () {
            currentGui.style.left = -parseFloat(final) + 'px';
            nextGui.style.left = '0px';
        }, 0);
        window.setTimeout(function () {
            _this.isAnimating = false;
            currentPalette.removeCssClass(animatingClass);
            futurePalette.removeCssClass(animatingClass);
            currentPalette.setDisplayed(false);
        }, 300);
    };
    ChartSettingsPanel.prototype.destroyMiniCharts = function () {
        _.clearElement(this.eMiniChartsContainer);
        this.miniChartsContainers = this.destroyBeans(this.miniChartsContainers);
    };
    ChartSettingsPanel.prototype.destroy = function () {
        this.destroyMiniCharts();
        _super.prototype.destroy.call(this);
    };
    ChartSettingsPanel.TEMPLATE =
        '<div class="ag-chart-settings-wrapper">\n            <div ref="eMiniChartsContainer" class="ag-chart-settings-mini-charts-container ag-scrollable-container"></div>\n            <div ref="eNavBar" class="ag-chart-settings-nav-bar">\n                <div ref="ePrevBtn" class="ag-chart-settings-prev">\n                    <button type="button" class="ag-button ag-chart-settings-prev-button"></button>\n                </div>\n                <div ref="eCardSelector" class="ag-chart-settings-card-selector"></div>\n                <div ref="eNextBtn" class="ag-chart-settings-next">\n                    <button type="button" class="ag-button ag-chart-settings-next-button"></button>\n                </div>\n            </div>\n        </div>';
    __decorate$T([Autowired('resizeObserverService')], ChartSettingsPanel.prototype, 'resizeObserverService', void 0);
    __decorate$T([RefSelector('eMiniChartsContainer')], ChartSettingsPanel.prototype, 'eMiniChartsContainer', void 0);
    __decorate$T([RefSelector('eNavBar')], ChartSettingsPanel.prototype, 'eNavBar', void 0);
    __decorate$T([RefSelector('eCardSelector')], ChartSettingsPanel.prototype, 'eCardSelector', void 0);
    __decorate$T([RefSelector('ePrevBtn')], ChartSettingsPanel.prototype, 'ePrevBtn', void 0);
    __decorate$T([RefSelector('eNextBtn')], ChartSettingsPanel.prototype, 'eNextBtn', void 0);
    __decorate$T([PostConstruct], ChartSettingsPanel.prototype, 'postConstruct', null);
    return ChartSettingsPanel;
})(Component);

var __extends$14 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$S =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TabbedChartMenu = /** @class */ (function (_super) {
    __extends$14(TabbedChartMenu, _super);
    function TabbedChartMenu(params) {
        var _this = _super.call(this) || this;
        _this.tabs = [];
        var controller = params.controller,
            panels = params.panels,
            chartOptionsService = params.chartOptionsService;
        _this.chartController = controller;
        _this.chartOptionsService = chartOptionsService;
        _this.panels = panels;
        return _this;
    }
    TabbedChartMenu.prototype.init = function () {
        var _this = this;
        this.panels.forEach(function (panel) {
            var panelType = panel.replace('chart', '').toLowerCase();
            var _a = _this.createTab(panel, panelType, _this.getPanelClass(panelType)),
                comp = _a.comp,
                tab = _a.tab;
            _this.tabs.push(tab);
            _this.addDestroyFunc(function () {
                return _this.destroyBean(comp);
            });
        });
        this.tabbedLayout = new TabbedLayout({
            items: this.tabs,
            cssClass: 'ag-chart-tabbed-menu',
            keepScrollPosition: true,
        });
        this.getContext().createBean(this.tabbedLayout);
    };
    TabbedChartMenu.prototype.createTab = function (name, title, TabPanelClass) {
        var eWrapperDiv = document.createElement('div');
        eWrapperDiv.classList.add('ag-chart-tab', 'ag-chart-' + title);
        var comp = new TabPanelClass(this.chartController, this.chartOptionsService);
        this.getContext().createBean(comp);
        eWrapperDiv.appendChild(comp.getGui());
        var titleEl = document.createElement('div');
        var translatedTitle = this.chartTranslationService.translate(title);
        titleEl.innerText = translatedTitle;
        return {
            comp: comp,
            tab: {
                title: titleEl,
                titleLabel: translatedTitle,
                bodyPromise: AgPromise.resolve(eWrapperDiv),
                getScrollableContainer: function () {
                    var scrollableContainer = eWrapperDiv.querySelector('.ag-scrollable-container');
                    return scrollableContainer || eWrapperDiv;
                },
                name: name,
            },
        };
    };
    TabbedChartMenu.prototype.showTab = function (tab) {
        var tabItem = this.tabs[tab];
        this.tabbedLayout.showItem(tabItem);
    };
    TabbedChartMenu.prototype.getGui = function () {
        return this.tabbedLayout && this.tabbedLayout.getGui();
    };
    TabbedChartMenu.prototype.destroy = function () {
        if (this.parentComponent && this.parentComponent.isAlive()) {
            this.destroyBean(this.parentComponent);
        }
        _super.prototype.destroy.call(this);
    };
    TabbedChartMenu.prototype.getPanelClass = function (panelType) {
        switch (panelType) {
            case TabbedChartMenu.TAB_DATA:
                return ChartDataPanel;
            case TabbedChartMenu.TAB_FORMAT:
                return FormatPanel;
            default:
                return ChartSettingsPanel;
        }
    };
    TabbedChartMenu.TAB_DATA = 'data';
    TabbedChartMenu.TAB_FORMAT = 'format';
    __decorate$S([Autowired('chartTranslationService')], TabbedChartMenu.prototype, 'chartTranslationService', void 0);
    __decorate$S([PostConstruct], TabbedChartMenu.prototype, 'init', null);
    return TabbedChartMenu;
})(Component);

var __extends$13 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$R =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$i =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$b =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var ChartMenu = /** @class */ (function (_super) {
    __extends$13(ChartMenu, _super);
    function ChartMenu(eChartContainer, eMenuPanelContainer, chartController, chartOptionsService) {
        var _this = _super.call(this, ChartMenu.TEMPLATE) || this;
        _this.eChartContainer = eChartContainer;
        _this.eMenuPanelContainer = eMenuPanelContainer;
        _this.chartController = chartController;
        _this.chartOptionsService = chartOptionsService;
        _this.buttons = {
            chartSettings: [
                'menu',
                function () {
                    return _this.showMenu(_this.defaultPanel);
                },
            ],
            chartData: [
                'menu',
                function () {
                    return _this.showMenu('chartData');
                },
            ],
            chartFormat: [
                'menu',
                function () {
                    return _this.showMenu('chartFormat');
                },
            ],
            chartLink: [
                'linked',
                function (e) {
                    return _this.toggleDetached(e);
                },
            ],
            chartUnlink: [
                'unlinked',
                function (e) {
                    return _this.toggleDetached(e);
                },
            ],
            chartDownload: [
                'save',
                function () {
                    return _this.saveChart();
                },
            ],
        };
        _this.panels = [];
        _this.buttonListenersDestroyFuncs = [];
        _this.menuVisible = false;
        return _this;
    }
    ChartMenu.prototype.postConstruct = function () {
        var _this = this;
        this.createButtons();
        this.addManagedListener(this.eventService, Events.EVENT_CHART_CREATED, function (e) {
            var _a;
            if (e.chartId === _this.chartController.getChartId()) {
                var showDefaultToolPanel = Boolean(
                    (_a = _this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0
                        ? void 0
                        : _a.defaultToolPanel,
                );
                if (showDefaultToolPanel) {
                    _this.showMenu(_this.defaultPanel, false);
                }
            }
        });
        this.refreshMenuClasses();
        if (!this.gridOptionsService.is('suppressChartToolPanelsButton') && this.panels.length > 0) {
            this.getGui().classList.add('ag-chart-tool-panel-button-enable');
            this.addManagedListener(this.eHideButton, 'click', this.toggleMenu.bind(this));
        }
        this.addManagedListener(
            this.chartController,
            ChartController.EVENT_CHART_API_UPDATE,
            this.createButtons.bind(this),
        );
    };
    ChartMenu.prototype.isVisible = function () {
        return this.menuVisible;
    };
    ChartMenu.prototype.getExtraPaddingDirections = function () {
        var _this = this;
        var topItems = ['chartLink', 'chartUnlink', 'chartDownload'];
        var rightItems = ['chartSettings', 'chartData', 'chartFormat'];
        var result = [];
        if (
            topItems.some(function (v) {
                return _this.chartToolbarOptions.includes(v);
            })
        ) {
            result.push('top');
        }
        if (
            rightItems.some(function (v) {
                return _this.chartToolbarOptions.includes(v);
            })
        ) {
            result.push(this.gridOptionsService.is('enableRtl') ? 'left' : 'right');
        }
        return result;
    };
    ChartMenu.prototype.getToolbarOptions = function () {
        var _this = this;
        var _a, _b, _c;
        var useChartToolPanelCustomisation = Boolean(this.gridOptionsService.get('chartToolPanelsDef'));
        if (useChartToolPanelCustomisation) {
            var defaultChartToolbarOptions = [
                this.chartController.isChartLinked() ? 'chartLink' : 'chartUnlink',
                'chartDownload',
            ];
            var toolbarItemsFunc = this.gridOptionsService.getCallback('getChartToolbarItems');
            var params = {
                defaultItems: defaultChartToolbarOptions,
            };
            var chartToolbarOptions = toolbarItemsFunc
                ? toolbarItemsFunc(params).filter(function (option) {
                      if (!CHART_TOOLBAR_ALLOW_LIST.includes(option)) {
                          var msg = CHART_TOOL_PANEL_ALLOW_LIST.includes(option)
                              ? "AG Grid: '" +
                                option +
                                "' is a Chart Tool Panel option and will be ignored since 'chartToolPanelsDef' is used. Please use 'chartToolPanelsDef.panels' grid option instead"
                              : "AG Grid: '" + option + "' is not a valid Chart Toolbar Option";
                          console.warn(msg);
                          return false;
                      }
                      return true;
                  })
                : defaultChartToolbarOptions;
            var panelsOverride =
                (_b =
                    (_a = this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0
                        ? void 0
                        : _a.panels) === null || _b === void 0
                    ? void 0
                    : _b
                          .map(function (panel) {
                              var menuOption = CHART_TOOL_PANEL_MENU_OPTIONS[panel];
                              if (!menuOption) {
                                  console.warn("AG Grid - invalid panel in chartToolPanelsDef.panels: '" + panel + "'");
                              }
                              return menuOption;
                          })
                          .filter(function (panel) {
                              return Boolean(panel);
                          });
            this.panels = panelsOverride ? panelsOverride : Object.values(CHART_TOOL_PANEL_MENU_OPTIONS);
            // pivot charts use the column tool panel instead of the data panel
            if (this.chartController.isPivotChart()) {
                this.panels = this.panels.filter(function (panel) {
                    return panel !== 'chartData';
                });
            }
            var defaultToolPanel =
                (_c = this.gridOptionsService.get('chartToolPanelsDef')) === null || _c === void 0
                    ? void 0
                    : _c.defaultToolPanel;
            this.defaultPanel = (defaultToolPanel && CHART_TOOL_PANEL_MENU_OPTIONS[defaultToolPanel]) || this.panels[0];
            return this.panels.length > 0
                ? // Only one panel is required to display menu icon in toolbar
                  __spreadArray$b([this.panels[0]], __read$i(chartToolbarOptions))
                : chartToolbarOptions;
        } else {
            // To be deprecated in future. Toolbar options will be different to chart tool panels.
            var tabOptions = [
                'chartSettings',
                'chartData',
                'chartFormat',
                this.chartController.isChartLinked() ? 'chartLink' : 'chartUnlink',
                'chartDownload',
            ];
            var toolbarItemsFunc = this.gridOptionsService.getCallback('getChartToolbarItems');
            if (toolbarItemsFunc) {
                var isLegacyToolbar_1 = this.gridOptionsService.is('suppressChartToolPanelsButton');
                var params = {
                    defaultItems: isLegacyToolbar_1 ? tabOptions : CHART_TOOLBAR_ALLOW_LIST,
                };
                tabOptions = toolbarItemsFunc(params).filter(function (option) {
                    if (!_this.buttons[option]) {
                        console.warn("AG Grid: '" + option + "' is not a valid Chart Toolbar Option");
                        return false;
                    }
                    // If not legacy, remove chart tool panel options here,
                    // and add them all in one go below
                    else if (!isLegacyToolbar_1 && CHART_TOOL_PANEL_ALLOW_LIST.includes(option)) {
                        var msg =
                            "AG Grid: '" +
                            option +
                            "' is a Chart Tool Panel option and will be ignored. Please use 'chartToolPanelsDef.panels' grid option instead";
                        console.warn(msg);
                        return false;
                    }
                    return true;
                });
                if (!isLegacyToolbar_1) {
                    // Add all the chart tool panels, as `chartToolPanelsDef.panels`
                    // should be used for configuration
                    tabOptions = tabOptions.concat(CHART_TOOL_PANEL_ALLOW_LIST);
                }
            }
            // pivot charts use the column tool panel instead of the data panel
            if (this.chartController.isPivotChart()) {
                tabOptions = tabOptions.filter(function (option) {
                    return option !== 'chartData';
                });
            }
            var ignoreOptions_1 = ['chartUnlink', 'chartLink', 'chartDownload'];
            this.panels = tabOptions.filter(function (option) {
                return ignoreOptions_1.indexOf(option) === -1;
            });
            this.defaultPanel = this.panels[0];
            return tabOptions.filter(function (value) {
                return ignoreOptions_1.indexOf(value) !== -1 || (_this.panels.length && value === _this.panels[0]);
            });
        }
    };
    ChartMenu.prototype.toggleDetached = function (e) {
        var target = e.target;
        var active = target.classList.contains('ag-icon-linked');
        target.classList.toggle('ag-icon-linked', !active);
        target.classList.toggle('ag-icon-unlinked', active);
        var tooltipKey = active ? 'chartUnlinkToolbarTooltip' : 'chartLinkToolbarTooltip';
        var tooltipTitle = this.chartTranslationService.translate(tooltipKey);
        if (tooltipTitle) {
            target.title = tooltipTitle;
        }
        this.chartController.detachChartRange();
    };
    ChartMenu.prototype.createButtons = function () {
        var _this = this;
        this.buttonListenersDestroyFuncs.forEach(function (func) {
            return func();
        });
        this.buttonListenersDestroyFuncs = [];
        this.chartToolbarOptions = this.getToolbarOptions();
        var menuEl = this.eMenu;
        _.clearElement(menuEl);
        this.chartToolbarOptions.forEach(function (button) {
            var buttonConfig = _this.buttons[button];
            var _a = __read$i(buttonConfig, 2),
                iconName = _a[0],
                callback = _a[1];
            var buttonEl = _.createIconNoSpan(iconName, _this.gridOptionsService, undefined, true);
            buttonEl.classList.add('ag-chart-menu-icon');
            var tooltipTitle = _this.chartTranslationService.translate(button + 'ToolbarTooltip');
            if (tooltipTitle && buttonEl instanceof HTMLElement) {
                buttonEl.title = tooltipTitle;
            }
            _this.buttonListenersDestroyFuncs.push(_this.addManagedListener(buttonEl, 'click', callback));
            menuEl.appendChild(buttonEl);
        });
    };
    ChartMenu.prototype.saveChart = function () {
        var event = { type: ChartMenu.EVENT_DOWNLOAD_CHART };
        this.dispatchEvent(event);
    };
    ChartMenu.prototype.createMenuPanel = function (defaultTab) {
        var _this = this;
        var width = this.environment.chartMenuPanelWidth();
        var menuPanel = (this.menuPanel = this.createBean(
            new AgPanel({
                minWidth: width,
                width: width,
                height: '100%',
                closable: true,
                hideTitleBar: true,
                cssIdentifier: 'chart-menu',
            }),
        ));
        menuPanel.setParentComponent(this);
        this.eMenuPanelContainer.appendChild(menuPanel.getGui());
        this.tabbedMenu = this.createBean(
            new TabbedChartMenu({
                controller: this.chartController,
                type: this.chartController.getChartType(),
                panels: this.panels,
                chartOptionsService: this.chartOptionsService,
            }),
        );
        this.addManagedListener(menuPanel, Component.EVENT_DESTROYED, function () {
            return _this.destroyBean(_this.tabbedMenu);
        });
        return new AgPromise(function (res) {
            window.setTimeout(function () {
                menuPanel.setBodyComponent(_this.tabbedMenu);
                _this.tabbedMenu.showTab(defaultTab);
                res(menuPanel);
                _this.addManagedListener(_this.eChartContainer, 'click', function (event) {
                    if (_this.getGui().contains(event.target)) {
                        return;
                    }
                    if (_this.menuVisible) {
                        _this.hideMenu();
                    }
                });
            }, 100);
        });
    };
    ChartMenu.prototype.showContainer = function () {
        if (!this.menuPanel) {
            return;
        }
        this.menuVisible = true;
        this.showParent(this.menuPanel.getWidth());
        this.refreshMenuClasses();
    };
    ChartMenu.prototype.toggleMenu = function () {
        this.menuVisible ? this.hideMenu() : this.showMenu();
    };
    ChartMenu.prototype.showMenu = function (
        /**
         * Menu panel to show. If empty, shows the existing menu, or creates the default menu if menu panel has not been created
         */
        panel,
        /**
         * Whether to animate the menu opening
         */
        animate,
    ) {
        var _this = this;
        if (animate === void 0) {
            animate = true;
        }
        if (!animate) {
            this.eMenuPanelContainer.classList.add('ag-no-transition');
        }
        if (this.menuPanel && !panel) {
            this.showContainer();
        } else {
            var menuPanel = panel || this.defaultPanel;
            var tab = this.panels.indexOf(menuPanel);
            if (tab < 0) {
                console.warn("AG Grid: '" + panel + "' is not a valid Chart Tool Panel name");
                tab = this.panels.indexOf(this.defaultPanel);
            }
            if (this.menuPanel) {
                this.tabbedMenu.showTab(tab);
                this.showContainer();
            } else {
                this.createMenuPanel(tab).then(this.showContainer.bind(this));
            }
        }
        if (!animate) {
            // Wait for menu to render
            setTimeout(function () {
                if (!_this.isAlive()) {
                    return;
                }
                _this.eMenuPanelContainer.classList.remove('ag-no-transition');
            }, 500);
        }
    };
    ChartMenu.prototype.hideMenu = function () {
        var _this = this;
        this.hideParent();
        window.setTimeout(function () {
            _this.menuVisible = false;
            _this.refreshMenuClasses();
        }, 500);
    };
    ChartMenu.prototype.refreshMenuClasses = function () {
        this.eChartContainer.classList.toggle('ag-chart-menu-visible', this.menuVisible);
        this.eChartContainer.classList.toggle('ag-chart-menu-hidden', !this.menuVisible);
        if (!this.gridOptionsService.is('suppressChartToolPanelsButton')) {
            this.eHideButtonIcon.classList.toggle('ag-icon-contracted', this.menuVisible);
            this.eHideButtonIcon.classList.toggle('ag-icon-expanded', !this.menuVisible);
        }
    };
    ChartMenu.prototype.showParent = function (width) {
        this.eMenuPanelContainer.style.minWidth = width + 'px';
    };
    ChartMenu.prototype.hideParent = function () {
        this.eMenuPanelContainer.style.minWidth = '0';
    };
    ChartMenu.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.menuPanel && this.menuPanel.isAlive()) {
            this.destroyBean(this.menuPanel);
        }
        if (this.tabbedMenu && this.tabbedMenu.isAlive()) {
            this.destroyBean(this.tabbedMenu);
        }
    };
    ChartMenu.EVENT_DOWNLOAD_CHART = 'downloadChart';
    ChartMenu.TEMPLATE =
        '<div>\n        <div class="ag-chart-menu" ref="eMenu"></div>\n        <button class="ag-button ag-chart-menu-close" ref="eHideButton">\n            <span class="ag-icon ag-icon-contracted" ref="eHideButtonIcon"></span>\n        </button>\n    </div>';
    __decorate$R([Autowired('chartTranslationService')], ChartMenu.prototype, 'chartTranslationService', void 0);
    __decorate$R([RefSelector('eMenu')], ChartMenu.prototype, 'eMenu', void 0);
    __decorate$R([RefSelector('eHideButton')], ChartMenu.prototype, 'eHideButton', void 0);
    __decorate$R([RefSelector('eHideButtonIcon')], ChartMenu.prototype, 'eHideButtonIcon', void 0);
    __decorate$R([PostConstruct], ChartMenu.prototype, 'postConstruct', null);
    return ChartMenu;
})(Component);

var __extends$12 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$n =
    (undefined && undefined.__assign) ||
    function () {
        __assign$n =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$n.apply(this, arguments);
    };
var __decorate$Q =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __values$6 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var TitleEdit = /** @class */ (function (_super) {
    __extends$12(TitleEdit, _super);
    function TitleEdit(chartMenu) {
        var _this = _super.call(this, TitleEdit.TEMPLATE) || this;
        _this.chartMenu = chartMenu;
        _this.destroyableChartListeners = [];
        _this.editing = false;
        return _this;
    }
    TitleEdit.prototype.init = function () {
        var _this = this;
        this.addManagedListener(this.getGui(), 'keydown', function (e) {
            if (_this.editing && e.key === 'Enter' && !e.shiftKey) {
                _this.handleEndEditing();
                e.preventDefault();
            }
        });
        this.addManagedListener(this.getGui(), 'input', function () {
            if (_this.editing) {
                _this.updateHeight();
            }
        });
        this.addManagedListener(this.getGui(), 'blur', function () {
            return _this.endEditing();
        });
    };
    /* should be called when the containing component changes to a new chart proxy */
    TitleEdit.prototype.refreshTitle = function (chartController, chartOptionsService) {
        var e_1, _a;
        var _this = this;
        this.chartController = chartController;
        this.chartOptionsService = chartOptionsService;
        try {
            for (var _b = __values$6(this.destroyableChartListeners), _c = _b.next(); !_c.done; _c = _b.next()) {
                var destroyFn = _c.value;
                destroyFn();
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        this.destroyableChartListeners = [];
        var chartProxy = this.chartController.getChartProxy();
        var chart = chartProxy.getChart();
        var canvas = chart.scene.canvas.element;
        var destroyDbleClickListener = this.addManagedListener(canvas, 'dblclick', function (event) {
            var title = chart.title;
            if (title && title.node.containsPoint(event.offsetX, event.offsetY)) {
                var bbox = title.node.computeBBox();
                var xy = title.node.inverseTransformPoint(bbox.x, bbox.y);
                _this.startEditing(__assign$n(__assign$n({}, bbox), xy), canvas.width);
            }
        });
        var wasInTitle = false;
        var destroyMouseMoveListener = this.addManagedListener(canvas, 'mousemove', function (event) {
            var title = chart.title;
            var inTitle = !!(title && title.enabled && title.node.containsPoint(event.offsetX, event.offsetY));
            if (wasInTitle !== inTitle) {
                canvas.style.cursor = inTitle ? 'pointer' : '';
            }
            wasInTitle = inTitle;
        });
        this.destroyableChartListeners = [destroyDbleClickListener, destroyMouseMoveListener];
    };
    TitleEdit.prototype.startEditing = function (titleBBox, canvasWidth) {
        if (this.chartMenu && this.chartMenu.isVisible()) {
            // currently, we ignore requests to edit the chart title while the chart menu is showing
            // because the click to edit the chart will also close the chart menu, making the position
            // of the title change.
            return;
        }
        if (this.editing) {
            return;
        }
        this.editing = true;
        var minimumTargetInputWidth = 300;
        var inputWidth = Math.max(Math.min(titleBBox.width + 20, canvasWidth), minimumTargetInputWidth);
        var element = this.getGui();
        element.classList.add('currently-editing');
        var inputStyle = element.style;
        // match style of input to title that we're editing
        inputStyle.fontFamily = this.chartOptionsService.getChartOption('title.fontFamily');
        inputStyle.fontWeight = this.chartOptionsService.getChartOption('title.fontWeight');
        inputStyle.fontStyle = this.chartOptionsService.getChartOption('title.fontStyle');
        inputStyle.fontSize = this.chartOptionsService.getChartOption('title.fontSize') + 'px';
        inputStyle.color = this.chartOptionsService.getChartOption('title.color');
        // populate the input with the title, unless the title is the placeholder:
        var oldTitle = this.chartOptionsService.getChartOption('title.text');
        var isTitlePlaceholder = oldTitle === this.chartTranslationService.translate('titlePlaceholder');
        element.value = isTitlePlaceholder ? '' : oldTitle;
        var oldTitleLines = oldTitle.split(/\r?\n/g).length;
        inputStyle.left = Math.round(titleBBox.x + titleBBox.width / 2 - inputWidth / 2 - 1) + 'px';
        inputStyle.top =
            Math.round(titleBBox.y + titleBBox.height / 2 - (oldTitleLines * this.getLineHeight()) / 2 - 2) + 'px';
        inputStyle.width = Math.round(inputWidth) + 'px';
        inputStyle.lineHeight = this.getLineHeight() + 'px';
        this.updateHeight();
        element.focus();
    };
    TitleEdit.prototype.updateHeight = function () {
        var element = this.getGui();
        // The element should cover the title and provide enough space for the new one.
        var oldTitleLines = this.chartOptionsService.getChartOption('title.text').split(/\r?\n/g).length;
        var currentTitleLines = element.value.split(/\r?\n/g).length;
        element.style.height = Math.round(Math.max(oldTitleLines, currentTitleLines) * this.getLineHeight()) + 4 + 'px';
    };
    TitleEdit.prototype.getLineHeight = function () {
        var fixedLineHeight = this.chartOptionsService.getChartOption('title.lineHeight');
        if (fixedLineHeight) {
            return parseInt(fixedLineHeight);
        }
        return Math.round(parseInt(this.chartOptionsService.getChartOption('title.fontSize')) * 1.2);
    };
    TitleEdit.prototype.handleEndEditing = function () {
        // special handling to avoid flicker caused by delay when swapping old and new titles
        var _this = this;
        // 1 - store current title color
        var titleColor = this.chartOptionsService.getChartOption('title.color');
        // 2 - hide title by making it transparent
        var transparentColor = 'rgba(0, 0, 0, 0)';
        this.chartOptionsService.setChartOption('title.color', transparentColor);
        // 3 - trigger 'end editing' - this will update the chart with the new title
        this.chartOptionsService.awaitChartOptionUpdate(function () {
            return _this.endEditing();
        });
        // 4 - restore title color to its original value
        this.chartOptionsService.awaitChartOptionUpdate(function () {
            _this.chartOptionsService.setChartOption('title.color', titleColor);
        });
    };
    TitleEdit.prototype.endEditing = function () {
        var _this = this;
        if (!this.editing) {
            return;
        }
        this.editing = false;
        var value = this.getGui().value;
        if (value && value.trim() !== '') {
            this.chartOptionsService.setChartOption('title.text', value);
            this.chartOptionsService.setChartOption('title.enabled', true);
        } else {
            this.chartOptionsService.setChartOption('title.text', '');
            this.chartOptionsService.setChartOption('title.enabled', false);
        }
        this.getGui().classList.remove('currently-editing');
        // await chart updates so `chartTitleEdit` event consumers can read the new state correctly
        this.chartOptionsService.awaitChartOptionUpdate(function () {
            _this.eventService.dispatchEvent({ type: 'chartTitleEdit' });
        });
    };
    TitleEdit.TEMPLATE =
        '<textarea\n             class="ag-chart-title-edit"\n             style="padding:0; border:none; border-radius: 0; min-height: 0; text-align: center; resize: none;" />\n        ';
    __decorate$Q([Autowired('chartTranslationService')], TitleEdit.prototype, 'chartTranslationService', void 0);
    __decorate$Q([PostConstruct], TitleEdit.prototype, 'init', null);
    return TitleEdit;
})(Component);

var __extends$11 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$P =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartDatasource = /** @class */ (function (_super) {
    __extends$11(ChartDatasource, _super);
    function ChartDatasource() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartDatasource.prototype.getData = function (params) {
        if (params.crossFiltering) {
            if (params.grouping) {
                console.warn('AG Grid: crossing filtering with row grouping is not supported.');
                return { chartData: [], columnNames: {} };
            }
            if (!this.gridOptionsService.isRowModelType('clientSide')) {
                console.warn('AG Grid: crossing filtering is only supported in the client side row model.');
                return { chartData: [], columnNames: {} };
            }
        }
        var isServerSide = this.gridOptionsService.isRowModelType('serverSide');
        if (isServerSide && params.pivoting) {
            this.updatePivotKeysForSSRM();
        }
        var result = this.extractRowsFromGridRowModel(params);
        result.chartData = this.aggregateRowsByDimension(params, result.chartData);
        return result;
    };
    ChartDatasource.prototype.extractRowsFromGridRowModel = function (params) {
        var _this = this;
        var extractedRowData = [];
        var columnNames = {};
        // maps used to keep track of expanded groups that need to be removed
        var groupNodeIndexes = {};
        var groupsToRemove = {};
        // only used when cross filtering
        var filteredNodes = {};
        var allRowNodes = [];
        var numRows;
        if (params.crossFiltering) {
            filteredNodes = this.getFilteredRowNodes();
            allRowNodes = this.getAllRowNodes();
            numRows = allRowNodes.length;
        } else {
            // make sure enough rows in range to chart. if user filters and less rows, then end row will be
            // the last displayed row, not where the range ends.
            var modelLastRow = this.gridRowModel.getRowCount() - 1;
            var rangeLastRow = params.endRow >= 0 ? Math.min(params.endRow, modelLastRow) : modelLastRow;
            numRows = rangeLastRow - params.startRow + 1;
        }
        var _loop_1 = function (i) {
            var data = {};
            var rowNode = params.crossFiltering ? allRowNodes[i] : this_1.gridRowModel.getRow(i + params.startRow);
            // first get data for dimensions columns
            params.dimensionCols.forEach(function (col) {
                var colId = col.colId;
                var column = _this.columnModel.getGridColumn(colId);
                if (column) {
                    var valueObject = _this.valueService.getValue(column, rowNode);
                    // when grouping we also need to build up multi category labels for charts
                    if (params.grouping) {
                        var valueString = valueObject && valueObject.toString ? String(valueObject.toString()) : '';
                        // traverse parents to extract group label path
                        var labels = ChartDatasource.getGroupLabels(rowNode, valueString);
                        data[colId] = {
                            labels: labels,
                            toString: function () {
                                return this.labels
                                    .filter(function (l) {
                                        return !!l;
                                    })
                                    .reverse()
                                    .join(' - ');
                            },
                        };
                        // keep track of group node indexes, so they can be padded when other groups are expanded
                        if (rowNode.group) {
                            groupNodeIndexes[labels.toString()] = i;
                        }
                        // if node (group or leaf) has parents then it is expanded and should be removed
                        var groupKey = labels.slice(1, labels.length).toString();
                        if (groupKey) {
                            groupsToRemove[groupKey] = groupNodeIndexes[groupKey];
                        }
                    } else {
                        // leaf nodes can be directly added to dimension columns
                        data[colId] = valueObject;
                    }
                } else {
                    // introduce a default category when no dimensions exist with a value based off row index (+1)
                    data[ChartDataModel.DEFAULT_CATEGORY] = i + 1;
                }
            });
            // then get data for value columns
            params.valueCols.forEach(function (col) {
                var columnNamesArr = [];
                // pivot keys should be added first
                var pivotKeys = col.getColDef().pivotKeys;
                if (pivotKeys) {
                    columnNamesArr = pivotKeys.slice();
                }
                // then add column header name to results
                var headerName = col.getColDef().headerName;
                if (headerName) {
                    columnNamesArr.push(headerName);
                }
                // add array of column names to results
                if (columnNamesArr.length > 0) {
                    columnNames[col.getId()] = columnNamesArr;
                }
                var colId = col.getColId();
                if (params.crossFiltering) {
                    var filteredOutColId = colId + '-filtered-out';
                    // add data value to value column
                    var value = _this.valueService.getValue(col, rowNode);
                    var actualValue = value != null && typeof value.toNumber === 'function' ? value.toNumber() : value;
                    if (filteredNodes[rowNode.id]) {
                        data[colId] = actualValue;
                        data[filteredOutColId] = params.aggFunc || params.isScatter ? undefined : 0;
                    } else {
                        data[colId] = params.aggFunc || params.isScatter ? undefined : 0;
                        data[filteredOutColId] = actualValue;
                    }
                } else {
                    // add data value to value column
                    var value = _this.valueService.getValue(col, rowNode);
                    // aggregated value
                    if (value && value.hasOwnProperty('toString')) {
                        value = parseFloat(value.toString());
                    }
                    data[colId] = value != null && typeof value.toNumber === 'function' ? value.toNumber() : value;
                }
            });
            // row data from footer nodes should not be included in charts
            if (rowNode.footer) {
                // 'stamping' data as footer to avoid impacting previously calculated `groupIndexesToRemove` and will
                // be removed from the results along with any expanded group nodes
                data.footer = true;
            }
            // add data to results
            extractedRowData.push(data);
        };
        var this_1 = this;
        for (var i = 0; i < numRows; i++) {
            _loop_1(i);
        }
        if (params.grouping) {
            var groupIndexesToRemove_1 = _.values(groupsToRemove);
            var filterFunc = function (data, index) {
                return !data.footer && !_.includes(groupIndexesToRemove_1, index);
            };
            extractedRowData = extractedRowData.filter(filterFunc);
        }
        return { chartData: extractedRowData, columnNames: columnNames };
    };
    ChartDatasource.prototype.aggregateRowsByDimension = function (params, dataFromGrid) {
        var _this = this;
        var dimensionCols = params.dimensionCols;
        if (!params.aggFunc || dimensionCols.length === 0) {
            return dataFromGrid;
        }
        var lastCol = _.last(dimensionCols);
        var lastColId = lastCol && lastCol.colId;
        var map = {};
        var dataAggregated = [];
        dataFromGrid.forEach(function (data) {
            var currentMap = map;
            dimensionCols.forEach(function (col) {
                var colId = col.colId;
                var key = data[colId];
                if (colId === lastColId) {
                    var groupItem_1 = currentMap[key];
                    if (!groupItem_1) {
                        groupItem_1 = { __children: [] };
                        dimensionCols.forEach(function (dimCol) {
                            var dimColId = dimCol.colId;
                            groupItem_1[dimColId] = data[dimColId];
                        });
                        currentMap[key] = groupItem_1;
                        dataAggregated.push(groupItem_1);
                    }
                    groupItem_1.__children.push(data);
                } else {
                    // map of maps
                    if (!currentMap[key]) {
                        currentMap[key] = {};
                    }
                    currentMap = currentMap[key];
                }
            });
        });
        if (
            ModuleRegistry.__assertRegistered(
                ModuleNames.RowGroupingModule,
                'Charting Aggregation',
                this.context.getGridId(),
            )
        ) {
            dataAggregated.forEach(function (groupItem) {
                return params.valueCols.forEach(function (col) {
                    if (params.crossFiltering) {
                        params.valueCols.forEach(function (valueCol) {
                            var colId = valueCol.getColId();
                            // filtered data
                            var dataToAgg = groupItem.__children
                                .filter(function (child) {
                                    return typeof child[colId] !== 'undefined';
                                })
                                .map(function (child) {
                                    return child[colId];
                                });
                            var aggResult = _this.aggregationStage.aggregateValues(dataToAgg, params.aggFunc);
                            groupItem[valueCol.getId()] =
                                aggResult && typeof aggResult.value !== 'undefined' ? aggResult.value : aggResult;
                            // filtered out data
                            var filteredOutColId = colId + '-filtered-out';
                            var dataToAggFiltered = groupItem.__children
                                .filter(function (child) {
                                    return typeof child[filteredOutColId] !== 'undefined';
                                })
                                .map(function (child) {
                                    return child[filteredOutColId];
                                });
                            var aggResultFiltered = _this.aggregationStage.aggregateValues(
                                dataToAggFiltered,
                                params.aggFunc,
                            );
                            groupItem[filteredOutColId] =
                                aggResultFiltered && typeof aggResultFiltered.value !== 'undefined'
                                    ? aggResultFiltered.value
                                    : aggResultFiltered;
                        });
                    } else {
                        var dataToAgg = groupItem.__children.map(function (child) {
                            return child[col.getId()];
                        });
                        var aggResult = 0;
                        if (
                            ModuleRegistry.__assertRegistered(
                                ModuleNames.RowGroupingModule,
                                'Charting Aggregation',
                                _this.context.getGridId(),
                            )
                        ) {
                            aggResult = _this.aggregationStage.aggregateValues(dataToAgg, params.aggFunc);
                        }
                        groupItem[col.getId()] =
                            aggResult && typeof aggResult.value !== 'undefined' ? aggResult.value : aggResult;
                    }
                });
            });
        }
        return dataAggregated;
    };
    ChartDatasource.prototype.updatePivotKeysForSSRM = function () {
        var secondaryColumns = this.columnModel.getSecondaryColumns();
        if (!secondaryColumns) {
            return;
        }
        // we don't know what the application will use for the pivot key separator (i.e. '_' or '|' ) as the
        // secondary columns are provided to grid by the application via columnApi.setSecondaryColumns()
        var pivotKeySeparator = this.extractPivotKeySeparator(secondaryColumns);
        // `pivotKeys` is not used by the SSRM for pivoting, so it is safe to reuse this colDef property. This way
        // the same logic can be used for CSRM and SSRM to extract legend names in extractRowsFromGridRowModel()
        secondaryColumns.forEach(function (col) {
            if (pivotKeySeparator === '') {
                col.getColDef().pivotKeys = [];
            } else {
                var keys = col.getColId().split(pivotKeySeparator);
                col.getColDef().pivotKeys = keys.slice(0, keys.length - 1);
            }
        });
    };
    ChartDatasource.prototype.extractPivotKeySeparator = function (secondaryColumns) {
        if (secondaryColumns.length === 0) {
            return '';
        }
        var extractSeparator = function (columnGroup, childId) {
            var groupId = columnGroup.getGroupId();
            if (!columnGroup.getParent()) {
                // removing groupId ('2000') from childId ('2000|Swimming') yields '|Swimming' so first char is separator
                return childId.split(groupId)[1][0];
            }
            return extractSeparator(columnGroup.getParent(), groupId);
        };
        var firstSecondaryCol = secondaryColumns[0];
        if (firstSecondaryCol.getParent() == null) {
            return '';
        }
        return extractSeparator(firstSecondaryCol.getParent(), firstSecondaryCol.getColId());
    };
    ChartDatasource.getGroupLabels = function (rowNode, initialLabel) {
        var labels = [initialLabel];
        while (rowNode && rowNode.level !== 0) {
            rowNode = rowNode.parent;
            if (rowNode) {
                labels.push(rowNode.key);
            }
        }
        return labels;
    };
    ChartDatasource.prototype.getFilteredRowNodes = function () {
        var filteredNodes = {};
        this.gridRowModel.forEachNodeAfterFilterAndSort(function (rowNode) {
            filteredNodes[rowNode.id] = rowNode;
        });
        return filteredNodes;
    };
    ChartDatasource.prototype.getAllRowNodes = function () {
        var allRowNodes = [];
        this.gridRowModel.forEachNode(function (rowNode) {
            allRowNodes.push(rowNode);
        });
        return this.sortRowNodes(allRowNodes);
    };
    ChartDatasource.prototype.sortRowNodes = function (rowNodes) {
        var sortOptions = this.sortController.getSortOptions();
        var noSort = !sortOptions || sortOptions.length == 0;
        if (noSort) return rowNodes;
        return this.rowNodeSorter.doFullSort(rowNodes, sortOptions);
    };
    __decorate$P([Autowired('rowModel')], ChartDatasource.prototype, 'gridRowModel', void 0);
    __decorate$P([Autowired('valueService')], ChartDatasource.prototype, 'valueService', void 0);
    __decorate$P([Autowired('columnModel')], ChartDatasource.prototype, 'columnModel', void 0);
    __decorate$P([Autowired('rowNodeSorter')], ChartDatasource.prototype, 'rowNodeSorter', void 0);
    __decorate$P([Autowired('sortController')], ChartDatasource.prototype, 'sortController', void 0);
    __decorate$P([Optional('aggregationStage')], ChartDatasource.prototype, 'aggregationStage', void 0);
    return ChartDatasource;
})(BeanStub);

var __extends$10 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$O =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartColumnService = /** @class */ (function (_super) {
    __extends$10(ChartColumnService, _super);
    function ChartColumnService() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartColumnService.prototype.getColumn = function (colId) {
        return this.columnModel.getPrimaryColumn(colId);
    };
    ChartColumnService.prototype.getAllDisplayedColumns = function () {
        return this.columnModel.getAllDisplayedColumns();
    };
    ChartColumnService.prototype.getColDisplayName = function (col) {
        return this.columnModel.getDisplayNameForColumn(col, 'chart');
    };
    ChartColumnService.prototype.getRowGroupColumns = function () {
        return this.columnModel.getRowGroupColumns();
    };
    ChartColumnService.prototype.getGroupDisplayColumns = function () {
        return this.columnModel.getGroupDisplayColumns();
    };
    ChartColumnService.prototype.isPivotMode = function () {
        return this.columnModel.isPivotMode();
    };
    ChartColumnService.prototype.isPivotActive = function () {
        return this.columnModel.isPivotActive();
    };
    ChartColumnService.prototype.getChartColumns = function () {
        var _this = this;
        var displayedCols = this.columnModel.getAllDisplayedColumns();
        var dimensionCols = new Set();
        var valueCols = new Set();
        displayedCols.forEach(function (col) {
            var colDef = col.getColDef();
            var chartDataType = colDef.chartDataType;
            if (chartDataType) {
                // chart data type was specified explicitly
                switch (chartDataType) {
                    case 'category':
                    case 'time':
                        dimensionCols.add(col);
                        return;
                    case 'series':
                        valueCols.add(col);
                        return;
                    case 'excluded':
                        return;
                    default:
                        console.warn(
                            "AG Grid: unexpected chartDataType value '" +
                                chartDataType +
                                "' supplied, instead use 'category', 'series' or 'excluded'",
                        );
                        break;
                }
            }
            if (colDef.colId === 'ag-Grid-AutoColumn') {
                dimensionCols.add(col);
                return;
            }
            if (!col.isPrimary()) {
                valueCols.add(col);
                return;
            }
            // if 'chartDataType' is not provided then infer type based data contained in first row
            (_this.isNumberCol(col) ? valueCols : dimensionCols).add(col);
        });
        return { dimensionCols: dimensionCols, valueCols: valueCols };
    };
    ChartColumnService.prototype.isNumberCol = function (col) {
        if (col.getColId() === 'ag-Grid-AutoColumn') {
            return false;
        }
        var row = this.rowRenderer.getRowNode({ rowIndex: 0, rowPinned: null });
        if (!row) {
            return false;
        }
        var cellValue = this.valueService.getValue(col, row);
        if (cellValue == null) {
            cellValue = this.extractLeafData(row, col);
        }
        if (cellValue != null && typeof cellValue.toNumber === 'function') {
            cellValue = cellValue.toNumber();
        }
        return typeof cellValue === 'number';
    };
    ChartColumnService.prototype.extractLeafData = function (row, col) {
        if (!row.allLeafChildren) {
            return null;
        }
        for (var i = 0; i < row.allLeafChildren.length; i++) {
            var childRow = row.allLeafChildren[i];
            var value = this.valueService.getValue(col, childRow);
            if (value != null) {
                return value;
            }
        }
        return null;
    };
    __decorate$O([Autowired('columnModel')], ChartColumnService.prototype, 'columnModel', void 0);
    __decorate$O([Autowired('valueService')], ChartColumnService.prototype, 'valueService', void 0);
    __decorate$O([Autowired('rowRenderer')], ChartColumnService.prototype, 'rowRenderer', void 0);
    ChartColumnService = __decorate$O([Bean('chartColumnService')], ChartColumnService);
    return ChartColumnService;
})(BeanStub);

var __extends$$ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$N =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ComboChartModel = /** @class */ (function (_super) {
    __extends$$(ComboChartModel, _super);
    function ComboChartModel(chartDataModel) {
        var _a;
        var _this = _super.call(this) || this;
        // this control flag is used to only log warning for the initial user config
        _this.suppressComboChartWarnings = false;
        _this.chartDataModel = chartDataModel;
        _this.seriesChartTypes = (_a = chartDataModel.params.seriesChartTypes) !== null && _a !== void 0 ? _a : [];
        return _this;
    }
    ComboChartModel.prototype.init = function () {
        this.initComboCharts();
    };
    ComboChartModel.prototype.update = function (seriesChartTypes) {
        this.seriesChartTypes =
            seriesChartTypes !== null && seriesChartTypes !== void 0 ? seriesChartTypes : this.seriesChartTypes;
        this.initComboCharts();
        this.updateSeriesChartTypes();
    };
    ComboChartModel.prototype.initComboCharts = function () {
        var seriesChartTypesExist = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        var customCombo = this.chartDataModel.chartType === 'customCombo' || seriesChartTypesExist;
        if (customCombo) {
            // it is not necessary to supply a chart type for combo charts when `seriesChartTypes` is supplied
            this.chartDataModel.chartType = 'customCombo';
            // cache supplied `seriesChartTypes` to allow switching between different chart types in the settings panel
            this.savedCustomSeriesChartTypes = this.seriesChartTypes || [];
        }
    };
    ComboChartModel.prototype.updateSeriesChartTypes = function () {
        if (!this.chartDataModel.isComboChart()) {
            return;
        }
        // ensure primary only chart types are not placed on secondary axis
        this.seriesChartTypes = this.seriesChartTypes.map(function (seriesChartType) {
            var primaryOnly = ['groupedColumn', 'stackedColumn', 'stackedArea'].includes(seriesChartType.chartType);
            seriesChartType.secondaryAxis = primaryOnly ? false : seriesChartType.secondaryAxis;
            return seriesChartType;
        });
        // note that when seriesChartTypes are supplied the chart type is also changed to 'customCombo'
        if (this.chartDataModel.chartType === 'customCombo') {
            this.updateSeriesChartTypesForCustomCombo();
            return;
        }
        this.updateChartSeriesTypesForBuiltInCombos();
    };
    ComboChartModel.prototype.updateSeriesChartTypesForCustomCombo = function () {
        var _this = this;
        var seriesChartTypesSupplied = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        if (!seriesChartTypesSupplied && !this.suppressComboChartWarnings) {
            console.warn("AG Grid: 'seriesChartTypes' are required when the 'customCombo' chart type is specified.");
        }
        // ensure correct chartTypes are supplied
        this.seriesChartTypes = this.seriesChartTypes.map(function (s) {
            if (!ComboChartModel.SUPPORTED_COMBO_CHART_TYPES.includes(s.chartType)) {
                console.warn(
                    "AG Grid: invalid chartType '" +
                        s.chartType +
                        "' supplied in 'seriesChartTypes', converting to 'line' instead.",
                );
                s.chartType = 'line';
            }
            return s;
        });
        var getSeriesChartType = function (valueCol) {
            if (!_this.savedCustomSeriesChartTypes || _this.savedCustomSeriesChartTypes.length === 0) {
                _this.savedCustomSeriesChartTypes = _this.seriesChartTypes;
            }
            var providedSeriesChartType = _this.savedCustomSeriesChartTypes.find(function (s) {
                return s.colId === valueCol.colId;
            });
            if (!providedSeriesChartType) {
                if (valueCol.selected && !_this.suppressComboChartWarnings) {
                    console.warn(
                        "AG Grid: no 'seriesChartType' found for colId = '" +
                            valueCol.colId +
                            "', defaulting to 'line'.",
                    );
                }
                return {
                    colId: valueCol.colId,
                    chartType: 'line',
                    secondaryAxis: false,
                };
            }
            return providedSeriesChartType;
        };
        var updatedSeriesChartTypes = this.chartDataModel.valueColState.map(getSeriesChartType);
        this.seriesChartTypes = updatedSeriesChartTypes;
        // also cache custom `seriesChartTypes` to allow for switching between different chart types
        this.savedCustomSeriesChartTypes = updatedSeriesChartTypes;
        // turn off warnings as first combo chart attempt has completed
        this.suppressComboChartWarnings = true;
    };
    ComboChartModel.prototype.updateChartSeriesTypesForBuiltInCombos = function () {
        var _a = this.chartDataModel,
            chartType = _a.chartType,
            valueColState = _a.valueColState;
        var primaryChartType = chartType === 'columnLineCombo' ? 'groupedColumn' : 'stackedArea';
        var secondaryChartType = chartType === 'columnLineCombo' ? 'line' : 'groupedColumn';
        var selectedCols = valueColState.filter(function (cs) {
            return cs.selected;
        });
        var lineIndex = Math.ceil(selectedCols.length / 2);
        this.seriesChartTypes = selectedCols.map(function (valueCol, i) {
            var seriesType = i >= lineIndex ? secondaryChartType : primaryChartType;
            return { colId: valueCol.colId, chartType: seriesType, secondaryAxis: false };
        });
    };
    ComboChartModel.SUPPORTED_COMBO_CHART_TYPES = ['line', 'groupedColumn', 'stackedColumn', 'area', 'stackedArea'];
    __decorate$N([PostConstruct], ComboChartModel.prototype, 'init', null);
    return ComboChartModel;
})(BeanStub);

var __extends$_ =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$m =
    (undefined && undefined.__assign) ||
    function () {
        __assign$m =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$m.apply(this, arguments);
    };
var __decorate$M =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$h =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$a =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var ChartDataModel = /** @class */ (function (_super) {
    __extends$_(ChartDataModel, _super);
    function ChartDataModel(params) {
        var _this = _super.call(this) || this;
        _this.unlinked = false;
        _this.chartData = [];
        _this.valueColState = [];
        _this.dimensionColState = [];
        _this.columnNames = {};
        _this.crossFiltering = false;
        _this.grouping = false;
        _this.params = params;
        _this.chartId = params.chartId;
        _this.chartType = params.chartType;
        _this.pivotChart = params.pivotChart;
        _this.chartThemeName = params.chartThemeName;
        _this.aggFunc = params.aggFunc;
        _this.referenceCellRange = params.cellRange;
        _this.suppliedCellRange = params.cellRange;
        _this.suppressChartRanges = params.suppressChartRanges;
        _this.unlinked = !!params.unlinkChart;
        _this.crossFiltering = !!params.crossFiltering;
        return _this;
    }
    ChartDataModel.prototype.init = function () {
        this.datasource = this.createManagedBean(new ChartDatasource());
        this.chartColumnService = this.createManagedBean(new ChartColumnService());
        this.comboChartModel = this.createManagedBean(new ComboChartModel(this));
        this.updateCellRanges();
        this.updateData();
    };
    ChartDataModel.prototype.updateModel = function (params) {
        var cellRange = params.cellRange,
            chartType = params.chartType,
            pivotChart = params.pivotChart,
            chartThemeName = params.chartThemeName,
            aggFunc = params.aggFunc,
            suppressChartRanges = params.suppressChartRanges,
            unlinkChart = params.unlinkChart,
            crossFiltering = params.crossFiltering,
            seriesChartTypes = params.seriesChartTypes;
        if (cellRange !== this.suppliedCellRange) {
            this.dimensionCellRange = undefined;
            this.valueCellRange = undefined;
        }
        this.chartType = chartType;
        this.pivotChart = pivotChart;
        this.chartThemeName = chartThemeName;
        this.aggFunc = aggFunc;
        this.referenceCellRange = cellRange;
        this.suppliedCellRange = cellRange;
        this.suppressChartRanges = suppressChartRanges;
        this.unlinked = !!unlinkChart;
        this.crossFiltering = !!crossFiltering;
        this.updateSelectedDimension(cellRange === null || cellRange === void 0 ? void 0 : cellRange.columns);
        this.updateCellRanges();
        var shouldUpdateComboModel = this.isComboChart() || seriesChartTypes;
        if (shouldUpdateComboModel) {
            this.comboChartModel.update(seriesChartTypes);
        }
        if (!this.unlinked) {
            this.updateData();
        }
    };
    ChartDataModel.prototype.updateCellRanges = function (updatedColState) {
        if (this.valueCellRange) {
            this.referenceCellRange = this.valueCellRange;
        }
        var _a = this.chartColumnService.getChartColumns(),
            dimensionCols = _a.dimensionCols,
            valueCols = _a.valueCols;
        var allColsFromRanges = this.getAllColumnsFromRanges();
        if (updatedColState) {
            this.updateColumnState(updatedColState);
        }
        this.setDimensionCellRange(dimensionCols, allColsFromRanges, updatedColState);
        this.setValueCellRange(valueCols, allColsFromRanges, updatedColState);
        if (!updatedColState) {
            this.resetColumnState();
            // dimension / category cell range could be out of sync after resetting column state when row grouping
            this.syncDimensionCellRange();
        }
        this.comboChartModel.updateSeriesChartTypes();
    };
    ChartDataModel.prototype.updateData = function () {
        var _a = this.getRowIndexes(),
            startRow = _a.startRow,
            endRow = _a.endRow;
        if (this.pivotChart) {
            this.resetColumnState();
        }
        this.grouping = this.isGrouping();
        var params = {
            aggFunc: this.aggFunc,
            dimensionCols: [this.getSelectedDimension()],
            grouping: this.grouping,
            pivoting: this.isPivotActive(),
            crossFiltering: this.crossFiltering,
            valueCols: this.getSelectedValueCols(),
            startRow: startRow,
            endRow: endRow,
            isScatter: _.includes(['scatter', 'bubble'], this.chartType),
        };
        var _b = this.datasource.getData(params),
            chartData = _b.chartData,
            columnNames = _b.columnNames;
        this.chartData = chartData;
        this.columnNames = columnNames;
    };
    ChartDataModel.prototype.isGrouping = function () {
        var usingTreeData = this.gridOptionsService.is('treeData');
        var groupedCols = usingTreeData ? null : this.chartColumnService.getRowGroupColumns();
        var isGroupActive = usingTreeData || (groupedCols && groupedCols.length > 0);
        // charts only group when the selected category is a group column
        var colId = this.getSelectedDimension().colId;
        var displayedGroupCols = this.chartColumnService.getGroupDisplayColumns();
        var groupDimensionSelected = displayedGroupCols
            .map(function (col) {
                return col.getColId();
            })
            .some(function (id) {
                return id === colId;
            });
        return !!isGroupActive && groupDimensionSelected;
    };
    ChartDataModel.prototype.getSelectedValueCols = function () {
        return this.valueColState
            .filter(function (cs) {
                return cs.selected;
            })
            .map(function (cs) {
                return cs.column;
            });
    };
    ChartDataModel.prototype.getSelectedDimension = function () {
        return this.dimensionColState.filter(function (cs) {
            return cs.selected;
        })[0];
    };
    ChartDataModel.prototype.getColDisplayName = function (col) {
        return this.chartColumnService.getColDisplayName(col);
    };
    ChartDataModel.prototype.isPivotMode = function () {
        return this.chartColumnService.isPivotMode();
    };
    ChartDataModel.prototype.getChartDataType = function (colId) {
        var column = this.chartColumnService.getColumn(colId);
        return column ? column.getColDef().chartDataType : undefined;
    };
    ChartDataModel.prototype.isPivotActive = function () {
        return this.chartColumnService.isPivotActive();
    };
    ChartDataModel.prototype.createCellRange = function (type) {
        var columns = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            columns[_i - 1] = arguments[_i];
        }
        return {
            id: this.chartId,
            startRow: this.referenceCellRange.startRow,
            endRow: this.referenceCellRange.endRow,
            columns: columns,
            startColumn: type === CellRangeType.DIMENSION ? columns[0] : this.referenceCellRange.startColumn,
            type: type,
        };
    };
    ChartDataModel.prototype.getAllColumnsFromRanges = function () {
        if (this.pivotChart) {
            return _.convertToSet(this.chartColumnService.getAllDisplayedColumns());
        }
        var columns = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
        if (this.dimensionCellRange) {
            columns.push.apply(columns, __spreadArray$a([], __read$h(this.dimensionCellRange.columns)));
        }
        if (this.valueCellRange) {
            columns.push.apply(columns, __spreadArray$a([], __read$h(this.valueCellRange.columns)));
        }
        return _.convertToSet(columns);
    };
    ChartDataModel.prototype.getRowIndexes = function () {
        var startRow = 0,
            endRow = 0;
        var _a = this,
            rangeService = _a.rangeService,
            valueCellRange = _a.valueCellRange;
        if (rangeService && valueCellRange) {
            startRow = rangeService.getRangeStartRow(valueCellRange).rowIndex;
            // when the last row the cell range is a pinned 'bottom' row, the `endRow` index is set to -1 which results
            // in the ChartDatasource processing all non pinned rows from the `startRow` index.
            var endRowPosition = rangeService.getRangeEndRow(valueCellRange);
            endRow = endRowPosition.rowPinned === 'bottom' ? -1 : endRowPosition.rowIndex;
        }
        return { startRow: startRow, endRow: endRow };
    };
    ChartDataModel.prototype.resetColumnState = function () {
        var _this = this;
        var _a = this.chartColumnService.getChartColumns(),
            dimensionCols = _a.dimensionCols,
            valueCols = _a.valueCols;
        var allCols = this.getAllColumnsFromRanges();
        var isInitialising = this.valueColState.length < 1;
        this.dimensionColState = [];
        this.valueColState = [];
        var hasSelectedDimension = false;
        var order = 1;
        var aggFuncDimension = this.suppliedCellRange.columns[0]; //TODO
        dimensionCols.forEach(function (column) {
            var isAutoGroupCol = column.getColId() === 'ag-Grid-AutoColumn';
            var selected = false;
            if (_this.crossFiltering && _this.aggFunc) {
                if (aggFuncDimension.getColId() === column.getColId()) {
                    selected = true;
                }
            } else {
                selected = isAutoGroupCol ? true : !hasSelectedDimension && allCols.has(column);
            }
            _this.dimensionColState.push({
                column: column,
                colId: column.getColId(),
                displayName: _this.getColDisplayName(column),
                selected: selected,
                order: order++,
            });
            if (selected) {
                hasSelectedDimension = true;
            }
        });
        var defaultCategory = {
            colId: ChartDataModel.DEFAULT_CATEGORY,
            displayName: this.chartTranslationService.translate('defaultCategory'),
            selected: !hasSelectedDimension,
            order: 0,
        };
        this.dimensionColState.unshift(defaultCategory);
        var valueColumnsFromReferenceRange = this.referenceCellRange.columns.filter(function (c) {
            return valueCols.has(c);
        });
        valueCols.forEach(function (column) {
            // first time the value cell range is set, preserve the column order from the supplied range
            if (isInitialising && _.includes(_this.referenceCellRange.columns, column)) {
                column = valueColumnsFromReferenceRange.shift();
            }
            _this.valueColState.push({
                column: column,
                colId: column.getColId(),
                displayName: _this.getColDisplayName(column),
                selected: allCols.has(column),
                order: order++,
            });
        });
    };
    ChartDataModel.prototype.updateColumnState = function (updatedCol) {
        var idsMatch = function (cs) {
            return cs.colId === updatedCol.colId;
        };
        var _a = this,
            dimensionColState = _a.dimensionColState,
            valueColState = _a.valueColState;
        if (dimensionColState.filter(idsMatch).length > 0) {
            // only one dimension should be selected
            dimensionColState.forEach(function (cs) {
                return (cs.selected = idsMatch(cs));
            });
        } else {
            // just update the selected value on the supplied value column
            valueColState.filter(idsMatch).forEach(function (cs) {
                return (cs.selected = updatedCol.selected);
            });
        }
        var allColumns = __spreadArray$a(__spreadArray$a([], __read$h(dimensionColState)), __read$h(valueColState));
        var orderedColIds = [];
        // calculate new order
        allColumns.forEach(function (col, i) {
            if (i === updatedCol.order) {
                orderedColIds.push(updatedCol.colId);
            }
            if (col.colId !== updatedCol.colId) {
                orderedColIds.push(col.colId);
            }
        });
        // update col state with new order
        allColumns.forEach(function (col) {
            var order = orderedColIds.indexOf(col.colId);
            col.order = order >= 0 ? orderedColIds.indexOf(col.colId) : allColumns.length - 1;
        });
        this.reorderColState();
    };
    ChartDataModel.prototype.reorderColState = function () {
        var ascColStateOrder = function (a, b) {
            return a.order - b.order;
        };
        this.dimensionColState.sort(ascColStateOrder);
        this.valueColState.sort(ascColStateOrder);
    };
    ChartDataModel.prototype.setDimensionCellRange = function (dimensionCols, colsInRange, updatedColState) {
        var _this = this;
        this.dimensionCellRange = undefined;
        if (!updatedColState && !this.dimensionColState.length) {
            // use first dimension column in range by default
            dimensionCols.forEach(function (col) {
                if (_this.dimensionCellRange || !colsInRange.has(col)) {
                    return;
                }
                _this.dimensionCellRange = _this.createCellRange(CellRangeType.DIMENSION, col);
            });
            return;
        }
        var selectedDimensionColState = updatedColState;
        if (this.crossFiltering && this.aggFunc) {
            var aggFuncDimension_1 = this.suppliedCellRange.columns[0]; //TODO
            selectedDimensionColState = this.dimensionColState.filter(function (cs) {
                return cs.colId === aggFuncDimension_1.getColId();
            })[0];
        } else if (!selectedDimensionColState || !dimensionCols.has(selectedDimensionColState.column)) {
            selectedDimensionColState = this.dimensionColState.filter(function (cs) {
                return cs.selected;
            })[0];
        }
        if (selectedDimensionColState && selectedDimensionColState.colId !== ChartDataModel.DEFAULT_CATEGORY) {
            this.dimensionCellRange = this.createCellRange(CellRangeType.DIMENSION, selectedDimensionColState.column);
        }
    };
    ChartDataModel.prototype.setValueCellRange = function (valueCols, colsInRange, updatedColState) {
        this.valueCellRange = undefined;
        var selectedValueCols = [];
        valueCols.forEach(function (col) {
            if (updatedColState && updatedColState.colId === col.getColId()) {
                if (updatedColState.selected) {
                    selectedValueCols.push(updatedColState.column);
                }
            } else if (colsInRange.has(col)) {
                selectedValueCols.push(col);
            }
        });
        if (selectedValueCols.length > 0) {
            var orderedColIds_1 = [];
            if (this.valueColState.length > 0) {
                orderedColIds_1 = this.valueColState.map(function (c) {
                    return c.colId;
                });
            } else {
                colsInRange.forEach(function (c) {
                    return orderedColIds_1.push(c.getColId());
                });
            }
            selectedValueCols.sort(function (a, b) {
                return orderedColIds_1.indexOf(a.getColId()) - orderedColIds_1.indexOf(b.getColId());
            });
            this.valueCellRange = this.createCellRange.apply(
                this,
                __spreadArray$a([CellRangeType.VALUE], __read$h(selectedValueCols)),
            );
        }
    };
    ChartDataModel.prototype.updateSelectedDimension = function (columns) {
        var colIdSet = new Set(
            columns.map(function (column) {
                return column.getColId();
            }),
        );
        // if no dimension found in supplied columns use the default category (always index = 0)
        var foundColState =
            this.dimensionColState.find(function (colState) {
                return colIdSet.has(colState.colId);
            }) || this.dimensionColState[0];
        this.dimensionColState = this.dimensionColState.map(function (colState) {
            return __assign$m(__assign$m({}, colState), { selected: colState.colId === foundColState.colId });
        });
    };
    ChartDataModel.prototype.syncDimensionCellRange = function () {
        var selectedDimension = this.getSelectedDimension();
        if (selectedDimension && selectedDimension.column) {
            this.dimensionCellRange = this.createCellRange(CellRangeType.DIMENSION, selectedDimension.column);
        }
    };
    ChartDataModel.prototype.isComboChart = function () {
        return ['columnLineCombo', 'areaColumnCombo', 'customCombo'].includes(this.chartType);
    };
    ChartDataModel.DEFAULT_CATEGORY = 'AG-GRID-DEFAULT-CATEGORY';
    __decorate$M([Autowired('rangeService')], ChartDataModel.prototype, 'rangeService', void 0);
    __decorate$M([Autowired('chartTranslationService')], ChartDataModel.prototype, 'chartTranslationService', void 0);
    __decorate$M([PostConstruct], ChartDataModel.prototype, 'init', null);
    return ChartDataModel;
})(BeanStub);

function deproxy(chartOrProxy) {
    if (chartOrProxy.chart != null) {
        return chartOrProxy.chart;
    }
    return chartOrProxy;
}

var __assign$l =
    (undefined && undefined.__assign) ||
    function () {
        __assign$l =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$l.apply(this, arguments);
    };
var ChartProxy = /** @class */ (function () {
    function ChartProxy(chartProxyParams) {
        this.chartProxyParams = chartProxyParams;
        this.clearThemeOverrides = false;
        this.chart = chartProxyParams.chartInstance;
        this.chartType = chartProxyParams.chartType;
        this.crossFiltering = chartProxyParams.crossFiltering;
        this.crossFilterCallback = chartProxyParams.crossFilterCallback;
        this.standaloneChartType = getSeriesType(this.chartType);
        if (this.chart == null) {
            this.chart = AgChart.create(this.getCommonChartOptions());
        } else {
            // On chart change, reset formatting panel changes.
            this.clearThemeOverrides = true;
        }
    }
    ChartProxy.prototype.getChart = function () {
        return deproxy(this.chart);
    };
    ChartProxy.prototype.getChartRef = function () {
        return this.chart;
    };
    ChartProxy.prototype.downloadChart = function (dimensions, fileName, fileFormat) {
        var chart = this.chart;
        var rawChart = deproxy(chart);
        var imageFileName = fileName || (rawChart.title ? rawChart.title.text : 'chart');
        var _a = dimensions || {},
            width = _a.width,
            height = _a.height;
        AgChart.download(chart, { width: width, height: height, fileName: imageFileName, fileFormat: fileFormat });
    };
    ChartProxy.prototype.getChartImageDataURL = function (type) {
        return this.getChart().scene.getDataURL(type);
    };
    ChartProxy.prototype.getChartOptions = function () {
        return this.chart.getOptions();
    };
    ChartProxy.prototype.getChartThemeOverrides = function () {
        var _a;
        var chartOptionsTheme = this.getChartOptions().theme;
        return (_a = chartOptionsTheme.overrides) !== null && _a !== void 0 ? _a : {};
    };
    ChartProxy.prototype.getChartPalette = function () {
        return getChartTheme(this.getChartOptions().theme).palette;
    };
    ChartProxy.prototype.setPaired = function (paired) {
        var _a;
        // Special handling to make scatter charts operate in paired mode by default, where
        // columns alternate between being X and Y (and size for bubble). In standard mode,
        // the first column is used for X and every other column is treated as Y
        // (or alternates between Y and size for bubble)
        var seriesType = getSeriesType(this.chartProxyParams.chartType);
        AgChart.updateDelta(this.chart, {
            theme: { overrides: ((_a = {}), (_a[seriesType] = { paired: paired }), _a) },
        });
    };
    ChartProxy.prototype.isPaired = function () {
        var seriesType = getSeriesType(this.chartProxyParams.chartType);
        return _.get(this.getChartThemeOverrides(), seriesType + '.paired', true);
    };
    ChartProxy.prototype.lookupCustomChartTheme = function (themeName) {
        return lookupCustomChartTheme(this.chartProxyParams, themeName);
    };
    ChartProxy.prototype.transformData = function (data, categoryKey, categoryAxis) {
        if (categoryAxis) {
            // replace the values for the selected category with a complex object to allow for duplicated categories
            return data.map(function (d, index) {
                var value = d[categoryKey];
                var valueString = value && value.toString ? value.toString() : '';
                var datum = __assign$l({}, d);
                datum[categoryKey] = {
                    id: index,
                    value: value,
                    toString: function () {
                        return valueString;
                    },
                };
                return datum;
            });
        }
        return data;
    };
    ChartProxy.prototype.getCommonChartOptions = function (updatedOverrides) {
        var _a, _b;
        // Only apply active overrides if chart is initialised.
        var existingOptions = this.clearThemeOverrides
            ? {}
            : (_b = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.getOptions()) !== null && _b !== void 0
            ? _b
            : {};
        var formattingPanelOverrides =
            this.chart != null ? { overrides: this.getActiveFormattingPanelOverrides() } : {};
        this.clearThemeOverrides = false;
        return __assign$l(__assign$l({}, existingOptions), {
            theme: __assign$l(
                __assign$l({}, createAgChartTheme(this.chartProxyParams, this)),
                updatedOverrides ? { overrides: updatedOverrides } : formattingPanelOverrides,
            ),
            container: this.chartProxyParams.parentElement,
            mode: 'integrated',
        });
    };
    ChartProxy.prototype.getActiveFormattingPanelOverrides = function () {
        var _a, _b;
        if (this.clearThemeOverrides) {
            return {};
        }
        var inUseTheme = (_a = this.chart) === null || _a === void 0 ? void 0 : _a.getOptions().theme;
        return (_b = inUseTheme === null || inUseTheme === void 0 ? void 0 : inUseTheme.overrides) !== null &&
            _b !== void 0
            ? _b
            : {};
    };
    ChartProxy.prototype.destroy = function (_a) {
        var _b = _a === void 0 ? {} : _a,
            _c = _b.keepChartInstance,
            keepChartInstance = _c === void 0 ? false : _c;
        if (keepChartInstance) {
            return this.chart;
        }
        this.destroyChart();
    };
    ChartProxy.prototype.destroyChart = function () {
        if (this.chart) {
            this.chart.destroy();
            this.chart = undefined;
        }
    };
    return ChartProxy;
})();

var __extends$Z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$k =
    (undefined && undefined.__assign) ||
    function () {
        __assign$k =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$k.apply(this, arguments);
    };
var CartesianChartProxy = /** @class */ (function (_super) {
    __extends$Z(CartesianChartProxy, _super);
    function CartesianChartProxy(params) {
        var _this = _super.call(this, params) || this;
        _this.crossFilteringAllPoints = new Set();
        _this.crossFilteringSelectedPoints = [];
        return _this;
    }
    CartesianChartProxy.prototype.update = function (params) {
        var axes = this.getAxes(params);
        var options = __assign$k(__assign$k({}, this.getCommonChartOptions(params.updatedOverrides)), {
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params),
        });
        AgChart.update(this.getChartRef(), options);
    };
    CartesianChartProxy.prototype.getData = function (params, axes) {
        var _a;
        var supportsCrossFiltering = ['area', 'line'].includes(this.standaloneChartType);
        var xPosition = this.standaloneChartType === 'bar' ? 'left' : 'bottom';
        var xAxisIsCategory =
            ((_a = axes.find(function (o) {
                return o.position === xPosition;
            })) === null || _a === void 0
                ? void 0
                : _a.type) === 'category';
        return this.crossFiltering && supportsCrossFiltering
            ? this.getCrossFilterData(params)
            : this.getDataTransformedData(params, xAxisIsCategory);
    };
    CartesianChartProxy.prototype.getDataTransformedData = function (params, isCategoryAxis) {
        return this.transformData(params.data, params.category.id, isCategoryAxis);
    };
    CartesianChartProxy.prototype.getXAxisType = function (params) {
        if (params.grouping) {
            return 'groupedCategory';
        } else if (CartesianChartProxy.isTimeAxis(params)) {
            return 'time';
        }
        return 'category';
    };
    CartesianChartProxy.isTimeAxis = function (params) {
        if (params.category && params.category.chartDataType) {
            return params.category.chartDataType === 'time';
        }
        var testDatum = params.data[0];
        return (testDatum && testDatum[params.category.id]) instanceof Date;
    };
    CartesianChartProxy.prototype.crossFilteringReset = function () {
        this.crossFilteringSelectedPoints = [];
        this.crossFilteringAllPoints.clear();
    };
    CartesianChartProxy.prototype.crossFilteringPointSelected = function (point) {
        return this.crossFilteringSelectedPoints.length == 0 || this.crossFilteringSelectedPoints.includes(point);
    };
    CartesianChartProxy.prototype.crossFilteringDeselectedPoints = function () {
        return (
            this.crossFilteringSelectedPoints.length > 0 &&
            this.crossFilteringAllPoints.size !== this.crossFilteringSelectedPoints.length
        );
    };
    CartesianChartProxy.prototype.extractLineAreaCrossFilterSeries = function (series, params) {
        var _this = this;
        var getYKey = function (yKey) {
            if (_this.standaloneChartType === 'area') {
                var lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
                return lastSelectedChartId === params.chartId ? yKey + '-total' : yKey;
            }
            return yKey + '-total';
        };
        return series.map(function (s) {
            s.yKey = getYKey(s.yKey);
            s.listeners = {
                nodeClick: function (e) {
                    var value = e.datum[s.xKey];
                    var multiSelection = e.event.metaKey || e.event.ctrlKey;
                    _this.crossFilteringAddSelectedPoint(multiSelection, value);
                    _this.crossFilterCallback(e);
                },
            };
            s.marker = {
                formatter: function (p) {
                    var category = p.datum[params.category.id];
                    return {
                        fill: p.highlighted ? 'yellow' : p.fill,
                        size: p.highlighted ? 14 : _this.crossFilteringPointSelected(category) ? 8 : 0,
                    };
                },
            };
            if (_this.standaloneChartType === 'area') {
                s.fillOpacity = _this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            }
            if (_this.standaloneChartType === 'line') {
                s.strokeOpacity = _this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            }
            return s;
        });
    };
    CartesianChartProxy.prototype.getCrossFilterData = function (params) {
        var _this = this;
        this.crossFilteringAllPoints.clear();
        var colId = params.fields[0].colId;
        var filteredOutColId = colId + '-filtered-out';
        var lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
        return params.data.map(function (d) {
            var category = d[params.category.id];
            _this.crossFilteringAllPoints.add(category);
            var pointSelected = _this.crossFilteringPointSelected(category);
            if (_this.standaloneChartType === 'area' && lastSelectedChartId === params.chartId) {
                d[colId + '-total'] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            }
            if (_this.standaloneChartType === 'line') {
                d[colId + '-total'] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            }
            return d;
        });
    };
    CartesianChartProxy.prototype.crossFilteringAddSelectedPoint = function (multiSelection, value) {
        multiSelection ? this.crossFilteringSelectedPoints.push(value) : (this.crossFilteringSelectedPoints = [value]);
    };
    return CartesianChartProxy;
})(ChartProxy);

// deepMerge
function emptyTarget(value) {
    return Array.isArray(value) ? [] : {};
}
function cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value)
        ? deepMerge(emptyTarget(value), value, options)
        : value;
}
function defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function (element) {
        return cloneUnlessOtherwiseSpecified(element, options);
    });
}
function getMergeFunction(key, options) {
    if (!options.customMerge) {
        return deepMerge;
    }
    var customMerge = options.customMerge(key);
    return typeof customMerge === 'function' ? customMerge : deepMerge;
}
function getEnumerableOwnPropertySymbols(target) {
    // @ts-ignore
    return Object.getOwnPropertySymbols
        ? // @ts-ignore
          Object.getOwnPropertySymbols(target).filter(function (symbol) {
              return target.propertyIsEnumerable(symbol);
          })
        : [];
}
function getKeys(target) {
    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
}
function propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
    return (
        propertyIsOnObject(target, key) && // Properties are safe to merge if they don't exist in the target yet,
        !(
            Object.hasOwnProperty.call(target, key) && // unsafe if they exist up the prototype chain,
            Object.propertyIsEnumerable.call(target, key)
        )
    ); // and also unsafe if they're nonenumerable.
}
function mergeObject(target, source, options) {
    if (target === void 0) {
        target = {};
    }
    if (source === void 0) {
        source = {};
    }
    var destination = {};
    if (options.isMergeableObject(target)) {
        getKeys(target).forEach(function (key) {
            destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
        });
    }
    getKeys(source).forEach(function (key) {
        if (propertyIsUnsafe(target, key)) {
            return;
        }
        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
            destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
        } else {
            destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
        }
    });
    return destination;
}
function defaultIsMergeableObject(value) {
    return isNonNullObject(value) && !isSpecial(value);
}
function isNonNullObject(value) {
    return !!value && typeof value === 'object';
}
function isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === '[object RegExp]' || stringValue === '[object Date]';
}
function deepMerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || defaultIsMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) {
        return cloneUnlessOtherwiseSpecified(source, options);
    } else if (sourceIsArray) {
        return options.arrayMerge(target, source, options);
    } else {
        return mergeObject(target, source, options);
    }
}

function hexToRGBA(hex, alpha) {
    var r = parseInt(hex.slice(1, 3), 16);
    var g = parseInt(hex.slice(3, 5), 16);
    var b = parseInt(hex.slice(5, 7), 16);
    return alpha ? 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')' : 'rgba(' + r + ', ' + g + ', ' + b + ')';
}
function changeOpacity(fills, alpha) {
    return fills.map(function (fill) {
        var c = Color.fromString(fill);
        return new Color(c.r, c.g, c.b, alpha).toHexString();
    });
}

var __extends$Y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$j =
    (undefined && undefined.__assign) ||
    function () {
        __assign$j =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$j.apply(this, arguments);
    };
var BarChartProxy = /** @class */ (function (_super) {
    __extends$Y(BarChartProxy, _super);
    function BarChartProxy(params) {
        return _super.call(this, params) || this;
    }
    BarChartProxy.prototype.getAxes = function (params) {
        var isBar = this.standaloneChartType === 'bar';
        var axes = [
            {
                type: this.getXAxisType(params),
                position: isBar ? 'left' : 'bottom',
            },
            {
                type: 'number',
                position: isBar ? 'bottom' : 'left',
            },
        ];
        // Add a default label formatter to show '%' for normalized charts if none is provided
        if (this.isNormalised()) {
            var numberAxis = axes[1];
            numberAxis.label = __assign$j(__assign$j({}, numberAxis.label), {
                formatter: function (params) {
                    return Math.round(params.value) + '%';
                },
            });
        }
        return axes;
    };
    BarChartProxy.prototype.getSeries = function (params) {
        var _this = this;
        var groupedCharts = ['groupedColumn', 'groupedBar'];
        var isGrouped = !this.crossFiltering && _.includes(groupedCharts, this.chartType);
        var series = params.fields.map(function (f) {
            return {
                type: _this.standaloneChartType,
                grouped: isGrouped,
                stacked: ['stackedColumn', 'normalizedColumn', 'stackedBar', 'normalizedBar'].includes(_this.chartType),
                normalizedTo: _this.isNormalised() ? 100 : undefined,
                xKey: params.category.id,
                xName: params.category.name,
                yKey: f.colId,
                yName: f.displayName,
            };
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    };
    BarChartProxy.prototype.extractCrossFilterSeries = function (series) {
        var _this = this;
        var palette = this.getChartPalette();
        var updatePrimarySeries = function (seriesOptions, index) {
            return __assign$j(__assign$j({}, seriesOptions), {
                highlightStyle: { item: { fill: undefined } },
                fill: palette === null || palette === void 0 ? void 0 : palette.fills[index],
                stroke: palette === null || palette === void 0 ? void 0 : palette.strokes[index],
                listeners: {
                    nodeClick: _this.crossFilterCallback,
                },
            });
        };
        var updateFilteredOutSeries = function (seriesOptions) {
            var yKey = seriesOptions.yKey + '-filtered-out';
            return __assign$j(__assign$j({}, deepMerge({}, seriesOptions)), {
                yKey: yKey,
                fill: hexToRGBA(seriesOptions.fill, '0.3'),
                stroke: hexToRGBA(seriesOptions.stroke, '0.3'),
                showInLegend: false,
            });
        };
        var allSeries = [];
        for (var i = 0; i < series.length; i++) {
            // update primary series
            var primarySeries = updatePrimarySeries(series[i], i);
            allSeries.push(primarySeries);
            // add 'filtered-out' series
            allSeries.push(updateFilteredOutSeries(primarySeries));
        }
        return allSeries;
    };
    BarChartProxy.prototype.isNormalised = function () {
        var normalisedCharts = ['normalizedColumn', 'normalizedBar'];
        return !this.crossFiltering && _.includes(normalisedCharts, this.chartType);
    };
    return BarChartProxy;
})(CartesianChartProxy);

var __extends$X =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$i =
    (undefined && undefined.__assign) ||
    function () {
        __assign$i =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$i.apply(this, arguments);
    };
var AreaChartProxy = /** @class */ (function (_super) {
    __extends$X(AreaChartProxy, _super);
    function AreaChartProxy(params) {
        return _super.call(this, params) || this;
    }
    AreaChartProxy.prototype.getAxes = function (params) {
        var axes = [
            {
                type: this.getXAxisType(params),
                position: 'bottom',
            },
            {
                type: 'number',
                position: 'left',
            },
        ];
        // Add a default label formatter to show '%' for normalized charts if none is provided
        if (this.isNormalised()) {
            var numberAxis = axes[1];
            numberAxis.label = __assign$i(__assign$i({}, numberAxis.label), {
                formatter: function (params) {
                    return Math.round(params.value) + '%';
                },
            });
        }
        return axes;
    };
    AreaChartProxy.prototype.getSeries = function (params) {
        var _this = this;
        var series = params.fields.map(function (f) {
            return {
                type: _this.standaloneChartType,
                xKey: params.category.id,
                xName: params.category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: _this.chartType === 'normalizedArea' ? 100 : undefined,
                stacked: ['normalizedArea', 'stackedArea'].includes(_this.chartType),
            };
        });
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    };
    AreaChartProxy.prototype.isNormalised = function () {
        return !this.crossFiltering && this.chartType === 'normalizedArea';
    };
    return AreaChartProxy;
})(CartesianChartProxy);

var __extends$W =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var LineChartProxy = /** @class */ (function (_super) {
    __extends$W(LineChartProxy, _super);
    function LineChartProxy(params) {
        return _super.call(this, params) || this;
    }
    LineChartProxy.prototype.getAxes = function (params) {
        return [
            {
                type: this.getXAxisType(params),
                position: 'bottom',
            },
            {
                type: 'number',
                position: 'left',
            },
        ];
    };
    LineChartProxy.prototype.getSeries = function (params) {
        var _this = this;
        var series = params.fields.map(function (f) {
            return {
                type: _this.standaloneChartType,
                xKey: params.category.id,
                xName: params.category.name,
                yKey: f.colId,
                yName: f.displayName,
            };
        });
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    };
    return LineChartProxy;
})(CartesianChartProxy);

var __extends$V =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$h =
    (undefined && undefined.__assign) ||
    function () {
        __assign$h =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$h.apply(this, arguments);
    };
var PieChartProxy = /** @class */ (function (_super) {
    __extends$V(PieChartProxy, _super);
    function PieChartProxy(params) {
        return _super.call(this, params) || this;
    }
    PieChartProxy.prototype.update = function (params) {
        var data = params.data,
            category = params.category;
        var options = __assign$h(__assign$h({}, this.getCommonChartOptions(params.updatedOverrides)), {
            data: this.crossFiltering ? this.getCrossFilterData(params) : this.transformData(data, category.id),
            series: this.getSeries(params),
        });
        AgChart.update(this.getChartRef(), options);
    };
    PieChartProxy.prototype.getSeries = function (params) {
        var _this = this;
        var numFields = params.fields.length;
        var offset = {
            currentOffset: 0,
            offsetAmount: numFields > 1 ? 20 : 40,
        };
        var series = this.getFields(params).map(function (f) {
            var _a;
            // options shared by 'pie' and 'doughnut' charts
            var options = {
                type: _this.standaloneChartType,
                angleKey: f.colId,
                angleName: f.displayName,
                sectorLabelKey: f.colId,
                calloutLabelKey: params.category.id,
                calloutLabelName: params.category.name,
            };
            if (_this.chartType === 'doughnut') {
                var _b = PieChartProxy.calculateOffsets(offset),
                    outerRadiusOffset = _b.outerRadiusOffset,
                    innerRadiusOffset = _b.innerRadiusOffset;
                var title = f.displayName
                    ? {
                          title: { text: f.displayName, showInLegend: numFields > 1 },
                      }
                    : undefined;
                // augment shared options with 'doughnut' specific options
                return __assign$h(
                    __assign$h(
                        __assign$h(__assign$h({}, options), {
                            outerRadiusOffset: outerRadiusOffset,
                            innerRadiusOffset: innerRadiusOffset,
                        }),
                        title,
                    ),
                    {
                        calloutLine: {
                            colors: (_a = _this.getChartPalette()) === null || _a === void 0 ? void 0 : _a.strokes,
                        },
                    },
                );
            }
            return options;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    };
    PieChartProxy.prototype.getCrossFilterData = function (params) {
        var colId = params.fields[0].colId;
        var filteredOutColId = colId + '-filtered-out';
        return params.data.map(function (d) {
            var total = d[colId] + d[filteredOutColId];
            d[colId + '-total'] = total;
            d[filteredOutColId] = 1; // normalise to 1
            d[colId] = d[colId] / total; // fraction of 1
            return d;
        });
    };
    PieChartProxy.prototype.extractCrossFilterSeries = function (series) {
        var _this = this;
        var palette = this.getChartPalette();
        var primaryOptions = function (seriesOptions) {
            return __assign$h(__assign$h({}, seriesOptions), {
                calloutLabel: { enabled: false },
                highlightStyle: { item: { fill: undefined } },
                radiusKey: seriesOptions.angleKey,
                angleKey: seriesOptions.angleKey + '-total',
                radiusMin: 0,
                radiusMax: 1,
                listeners: {
                    nodeClick: _this.crossFilterCallback,
                },
            });
        };
        var filteredOutOptions = function (seriesOptions, angleKey) {
            var _a, _b;
            return __assign$h(__assign$h({}, deepMerge({}, primaryOpts)), {
                radiusKey: angleKey + '-filtered-out',
                fills: changeOpacity((_a = seriesOptions.fills) !== null && _a !== void 0 ? _a : palette.fills, 0.3),
                strokes: changeOpacity(
                    (_b = seriesOptions.strokes) !== null && _b !== void 0 ? _b : palette.strokes,
                    0.3,
                ),
                showInLegend: false,
            });
        };
        // currently, only single 'doughnut' cross-filter series are supported
        var primarySeries = series[0];
        // update primary series
        var angleKey = primarySeries.angleKey;
        var primaryOpts = primaryOptions(primarySeries);
        return [filteredOutOptions(primarySeries, angleKey), primaryOpts];
    };
    PieChartProxy.calculateOffsets = function (offset) {
        var outerRadiusOffset = offset.currentOffset;
        offset.currentOffset -= offset.offsetAmount;
        var innerRadiusOffset = offset.currentOffset;
        offset.currentOffset -= offset.offsetAmount;
        return { outerRadiusOffset: outerRadiusOffset, innerRadiusOffset: innerRadiusOffset };
    };
    PieChartProxy.prototype.getFields = function (params) {
        return this.chartType === 'pie' ? params.fields.slice(0, 1) : params.fields;
    };
    PieChartProxy.prototype.crossFilteringReset = function () {
        // not required in pie charts
    };
    return PieChartProxy;
})(ChartProxy);

var __extends$U =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$g =
    (undefined && undefined.__assign) ||
    function () {
        __assign$g =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$g.apply(this, arguments);
    };
var __values$5 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var __read$g =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$9 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var ScatterChartProxy = /** @class */ (function (_super) {
    __extends$U(ScatterChartProxy, _super);
    function ScatterChartProxy(params) {
        return _super.call(this, params) || this;
    }
    ScatterChartProxy.prototype.getAxes = function (_params) {
        return [
            {
                type: 'number',
                position: 'bottom',
            },
            {
                type: 'number',
                position: 'left',
            },
        ];
    };
    ScatterChartProxy.prototype.getSeries = function (params) {
        var _this = this;
        var paired = this.isPaired();
        var seriesDefinitions = this.getSeriesDefinitions(params.fields, paired);
        var labelFieldDefinition = params.category.id === ChartDataModel.DEFAULT_CATEGORY ? undefined : params.category;
        var series = seriesDefinitions.map(function (seriesDefinition) {
            return {
                type: _this.standaloneChartType,
                xKey: seriesDefinition.xField.colId,
                xName: seriesDefinition.xField.displayName,
                yKey: seriesDefinition.yField.colId,
                yName: seriesDefinition.yField.displayName,
                title: seriesDefinition.yField.displayName + ' vs ' + seriesDefinition.xField.displayName,
                sizeKey: seriesDefinition.sizeField ? seriesDefinition.sizeField.colId : undefined,
                sizeName: seriesDefinition.sizeField ? seriesDefinition.sizeField.displayName : undefined,
                labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                labelName: labelFieldDefinition ? labelFieldDefinition.name : undefined,
            };
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series, params) : series;
    };
    ScatterChartProxy.prototype.extractCrossFilterSeries = function (series, params) {
        var _this = this;
        var data = params.data;
        var palette = this.getChartPalette();
        var filteredOutKey = function (key) {
            return key + '-filtered-out';
        };
        var calcMarkerDomain = function (data, sizeKey) {
            var e_1, _a;
            var _b;
            var markerDomain = [Infinity, -Infinity];
            if (sizeKey != null) {
                try {
                    for (
                        var data_1 = __values$5(data), data_1_1 = data_1.next();
                        !data_1_1.done;
                        data_1_1 = data_1.next()
                    ) {
                        var datum = data_1_1.value;
                        var value =
                            (_b = datum[sizeKey]) !== null && _b !== void 0 ? _b : datum[filteredOutKey(sizeKey)];
                        if (value < markerDomain[0]) {
                            markerDomain[0] = value;
                        }
                        if (value > markerDomain[1]) {
                            markerDomain[1] = value;
                        }
                    }
                } catch (e_1_1) {
                    e_1 = { error: e_1_1 };
                } finally {
                    try {
                        if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
                    } finally {
                        if (e_1) throw e_1.error;
                    }
                }
            }
            if (markerDomain[0] <= markerDomain[1]) {
                return markerDomain;
            }
            return undefined;
        };
        var updatePrimarySeries = function (series, idx) {
            var sizeKey = series.sizeKey;
            var fill = palette === null || palette === void 0 ? void 0 : palette.fills[idx];
            var stroke = palette === null || palette === void 0 ? void 0 : palette.strokes[idx];
            var markerDomain = calcMarkerDomain(data, sizeKey);
            var marker = __assign$g(__assign$g({}, series.marker), {
                fill: fill,
                stroke: stroke,
                domain: markerDomain,
            });
            return __assign$g(__assign$g({}, series), {
                marker: marker,
                highlightStyle: { item: { fill: 'yellow' } },
                listeners: __assign$g(__assign$g({}, series.listeners), { nodeClick: _this.crossFilterCallback }),
            });
        };
        var updateFilteredOutSeries = function (series) {
            var sizeKey = series.sizeKey,
                yKey = series.yKey,
                xKey = series.xKey;
            if (sizeKey != null) {
                sizeKey = filteredOutKey(sizeKey);
            }
            return __assign$g(__assign$g({}, series), {
                yKey: filteredOutKey(yKey),
                xKey: filteredOutKey(xKey),
                marker: __assign$g(__assign$g({}, series.marker), { fillOpacity: 0.3, strokeOpacity: 0.3 }),
                sizeKey: sizeKey,
                showInLegend: false,
                listeners: __assign$g(__assign$g({}, series.listeners), {
                    nodeClick: function (e) {
                        var _a;
                        var value = e.datum[filteredOutKey(xKey)];
                        // Need to remove the `-filtered-out` suffixes from the event so that
                        // upstream processing maps the event correctly onto grid column ids.
                        var filterableEvent = __assign$g(__assign$g({}, e), {
                            xKey: xKey,
                            datum: __assign$g(__assign$g({}, e.datum), ((_a = {}), (_a[xKey] = value), _a)),
                        });
                        _this.crossFilterCallback(filterableEvent);
                    },
                }),
            });
        };
        var updatedSeries = series.map(updatePrimarySeries);
        return __spreadArray$9(
            __spreadArray$9([], __read$g(updatedSeries)),
            __read$g(updatedSeries.map(updateFilteredOutSeries)),
        );
    };
    ScatterChartProxy.prototype.getSeriesDefinitions = function (fields, paired) {
        if (fields.length < 2) {
            return [];
        }
        var isBubbleChart = this.chartType === 'bubble';
        if (paired) {
            if (isBubbleChart) {
                return fields
                    .map(function (currentXField, i) {
                        return i % 3 === 0
                            ? {
                                  xField: currentXField,
                                  yField: fields[i + 1],
                                  sizeField: fields[i + 2],
                              }
                            : null;
                    })
                    .filter(function (x) {
                        return x && x.yField && x.sizeField;
                    });
            }
            return fields
                .map(function (currentXField, i) {
                    return i % 2 === 0
                        ? {
                              xField: currentXField,
                              yField: fields[i + 1],
                          }
                        : null;
                })
                .filter(function (x) {
                    return x && x.yField;
                });
        }
        var xField = fields[0];
        if (isBubbleChart) {
            return fields
                .map(function (yField, i) {
                    return i % 2 === 1
                        ? {
                              xField: xField,
                              yField: yField,
                              sizeField: fields[i + 1],
                          }
                        : null;
                })
                .filter(function (x) {
                    return x && x.sizeField;
                });
        }
        return fields
            .filter(function (value, i) {
                return i > 0;
            })
            .map(function (yField) {
                return { xField: xField, yField: yField };
            });
    };
    return ScatterChartProxy;
})(CartesianChartProxy);

var __extends$T =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var HistogramChartProxy = /** @class */ (function (_super) {
    __extends$T(HistogramChartProxy, _super);
    function HistogramChartProxy(params) {
        return _super.call(this, params) || this;
    }
    HistogramChartProxy.prototype.getSeries = function (params) {
        var firstField = params.fields[0]; // multiple series are not supported!
        return [
            {
                type: this.standaloneChartType,
                xKey: firstField.colId,
                xName: firstField.displayName,
                yName: this.chartProxyParams.translate('histogramFrequency'),
                areaPlot: false, // only constant width is supported via integrated charts
            },
        ];
    };
    HistogramChartProxy.prototype.getAxes = function (_params) {
        return [
            {
                type: 'number',
                position: 'bottom',
            },
            {
                type: 'number',
                position: 'left',
            },
        ];
    };
    return HistogramChartProxy;
})(CartesianChartProxy);

var __extends$S =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var ChartOptionsService = /** @class */ (function (_super) {
    __extends$S(ChartOptionsService, _super);
    function ChartOptionsService(chartController) {
        var _this = _super.call(this) || this;
        _this.chartController = chartController;
        return _this;
    }
    ChartOptionsService.prototype.getChartOption = function (expression) {
        // TODO: We shouldn't be reading the chart implementation directly, but right now
        // it isn't possible to either get option defaults OR retrieve themed options.
        return _.get(this.getChart(), expression, undefined);
    };
    ChartOptionsService.prototype.setChartOption = function (expression, value, isSilent) {
        var _this = this;
        var chartSeriesTypes = this.chartController.getChartSeriesTypes();
        if (this.chartController.isComboChart()) {
            chartSeriesTypes.push('cartesian');
        }
        var chartOptions = {};
        // we need to update chart options on each series type for combo charts
        chartSeriesTypes.forEach(function (seriesType) {
            chartOptions = deepMerge(
                chartOptions,
                _this.createChartOptions({
                    seriesType: seriesType,
                    expression: expression,
                    value: value,
                }),
            );
        });
        this.updateChart(chartOptions);
        if (!isSilent) {
            this.raiseChartOptionsChangedEvent();
        }
    };
    ChartOptionsService.prototype.awaitChartOptionUpdate = function (func) {
        var chart = this.chartController.getChartProxy().getChart();
        chart
            .waitForUpdate()
            .then(function () {
                return func();
            })
            .catch(function (e) {
                return console.error('AG Grid - chart update failed', e);
            });
    };
    ChartOptionsService.prototype.getAxisProperty = function (expression) {
        var _a;
        return _.get((_a = this.getChart().axes) === null || _a === void 0 ? void 0 : _a[0], expression, undefined);
    };
    ChartOptionsService.prototype.setAxisProperty = function (expression, value) {
        var _this = this;
        var _a;
        // update axis options
        var chart = this.getChart();
        var chartOptions = {};
        (_a = chart.axes) === null || _a === void 0
            ? void 0
            : _a.forEach(function (axis) {
                  chartOptions = deepMerge(chartOptions, _this.getUpdateAxisOptions(axis, expression, value));
              });
        this.updateChart(chartOptions);
        this.raiseChartOptionsChangedEvent();
    };
    ChartOptionsService.prototype.getLabelRotation = function (axisType) {
        var axis = this.getAxis(axisType);
        return _.get(axis, 'label.rotation', undefined);
    };
    ChartOptionsService.prototype.setLabelRotation = function (axisType, value) {
        var chartAxis = this.getAxis(axisType);
        if (chartAxis) {
            var chartOptions = this.getUpdateAxisOptions(chartAxis, 'label.rotation', value);
            this.updateChart(chartOptions);
            this.raiseChartOptionsChangedEvent();
        }
    };
    ChartOptionsService.prototype.getSeriesOption = function (expression, seriesType) {
        var series = this.getChart().series.find(function (s) {
            return ChartOptionsService.isMatchingSeries(seriesType, s);
        });
        return _.get(series, expression, undefined);
    };
    ChartOptionsService.prototype.setSeriesOption = function (expression, value, seriesType) {
        var chartOptions = this.createChartOptions({
            seriesType: seriesType,
            expression: 'series.' + expression,
            value: value,
        });
        this.updateChart(chartOptions);
        this.raiseChartOptionsChangedEvent();
    };
    ChartOptionsService.prototype.getPairedMode = function () {
        return this.chartController.getChartProxy().isPaired();
    };
    ChartOptionsService.prototype.setPairedMode = function (paired) {
        this.chartController.getChartProxy().setPaired(paired);
    };
    ChartOptionsService.prototype.getAxis = function (axisType) {
        var chart = this.getChart();
        if (!chart.axes || chart.axes.length < 1) {
            return undefined;
        }
        if (axisType === 'xAxis') {
            return chart.axes && chart.axes[0].direction === 'x' ? chart.axes[0] : chart.axes[1];
        }
        return chart.axes && chart.axes[1].direction === 'y' ? chart.axes[1] : chart.axes[0];
    };
    ChartOptionsService.prototype.getUpdateAxisOptions = function (chartAxis, expression, value) {
        var seriesType = getSeriesType(this.getChartType());
        var validAxisTypes = ['number', 'category', 'time', 'groupedCategory'];
        if (!validAxisTypes.includes(chartAxis.type)) {
            return {};
        }
        return this.createChartOptions({
            seriesType: seriesType,
            expression: 'axes.' + chartAxis.type + '.' + expression,
            value: value,
        });
    };
    ChartOptionsService.prototype.getChartType = function () {
        return this.chartController.getChartType();
    };
    ChartOptionsService.prototype.getChart = function () {
        return this.chartController.getChartProxy().getChart();
    };
    ChartOptionsService.prototype.updateChart = function (chartOptions) {
        var chartRef = this.chartController.getChartProxy().getChartRef();
        AgChart.updateDelta(chartRef, chartOptions);
    };
    ChartOptionsService.prototype.createChartOptions = function (_a) {
        var seriesType = _a.seriesType,
            expression = _a.expression,
            value = _a.value;
        var overrides = {};
        var chartOptions = {
            theme: {
                overrides: overrides,
            },
        };
        _.set(overrides, seriesType + '.' + expression, value);
        return chartOptions;
    };
    ChartOptionsService.prototype.raiseChartOptionsChangedEvent = function () {
        var chartModel = this.chartController.getChartModel();
        var event = {
            type: Events.EVENT_CHART_OPTIONS_CHANGED,
            chartId: chartModel.chartId,
            chartType: chartModel.chartType,
            chartThemeName: this.chartController.getChartThemeName(),
            chartOptions: chartModel.chartOptions,
        };
        this.eventService.dispatchEvent(event);
    };
    ChartOptionsService.isMatchingSeries = function (seriesType, series) {
        return VALID_SERIES_TYPES.includes(seriesType) && series.type === seriesType;
    };
    ChartOptionsService.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    return ChartOptionsService;
})(BeanStub);

var __extends$R =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$f =
    (undefined && undefined.__assign) ||
    function () {
        __assign$f =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$f.apply(this, arguments);
    };
var ComboChartProxy = /** @class */ (function (_super) {
    __extends$R(ComboChartProxy, _super);
    function ComboChartProxy(params) {
        return _super.call(this, params) || this;
    }
    ComboChartProxy.prototype.getAxes = function (params) {
        var fields = params ? params.fields : [];
        var fieldsMap = new Map(
            fields.map(function (f) {
                return [f.colId, f];
            }),
        );
        var _a = this.getYKeys(fields, params.seriesChartTypes),
            primaryYKeys = _a.primaryYKeys,
            secondaryYKeys = _a.secondaryYKeys;
        var axes = [
            {
                type: this.getXAxisType(params),
                position: 'bottom',
                gridStyle: [{ stroke: undefined }],
            },
        ];
        if (primaryYKeys.length > 0) {
            axes.push({
                type: 'number',
                keys: primaryYKeys,
                position: 'left',
            });
        }
        if (secondaryYKeys.length > 0) {
            secondaryYKeys.forEach(function (secondaryYKey, i) {
                var field = fieldsMap.get(secondaryYKey);
                var secondaryAxisIsVisible = field && field.colId === secondaryYKey;
                if (!secondaryAxisIsVisible) {
                    return;
                }
                var secondaryAxisOptions = {
                    type: 'number',
                    keys: [secondaryYKey],
                    position: 'right',
                };
                var primaryYAxis = primaryYKeys.some(function (primaryYKey) {
                    return !!fieldsMap.get(primaryYKey);
                });
                var lastSecondaryAxis = i === secondaryYKeys.length - 1;
                if (!primaryYAxis && lastSecondaryAxis);
                else {
                    secondaryAxisOptions.gridStyle = [{ stroke: undefined }];
                }
                axes.push(secondaryAxisOptions);
            });
        }
        return axes;
    };
    ComboChartProxy.prototype.getSeries = function (params) {
        var fields = params.fields,
            category = params.category,
            seriesChartTypes = params.seriesChartTypes;
        return fields.map(function (field) {
            var seriesChartType = seriesChartTypes.find(function (s) {
                return s.colId === field.colId;
            });
            if (seriesChartType) {
                var chartType = seriesChartType.chartType;
                var grouped = ['groupedColumn', 'groupedBar'].includes(chartType);
                var groupedOpts = grouped ? { grouped: true } : {};
                return __assign$f(
                    {
                        type: getSeriesType(chartType),
                        xKey: category.id,
                        yKey: field.colId,
                        yName: field.displayName,
                        stacked: ['stackedArea', 'stackedColumn'].includes(chartType),
                    },
                    groupedOpts,
                );
            }
        });
    };
    ComboChartProxy.prototype.getYKeys = function (fields, seriesChartTypes) {
        var primaryYKeys = [];
        var secondaryYKeys = [];
        fields.forEach(function (field) {
            var colId = field.colId;
            var seriesChartType = seriesChartTypes.find(function (s) {
                return s.colId === colId;
            });
            if (seriesChartType) {
                seriesChartType.secondaryAxis ? secondaryYKeys.push(colId) : primaryYKeys.push(colId);
            }
        });
        return { primaryYKeys: primaryYKeys, secondaryYKeys: secondaryYKeys };
    };
    return ComboChartProxy;
})(CartesianChartProxy);

var __extends$Q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$L =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$f =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var GridChartComp = /** @class */ (function (_super) {
    __extends$Q(GridChartComp, _super);
    function GridChartComp(params) {
        var _this = _super.call(this, GridChartComp.TEMPLATE) || this;
        _this.params = params;
        return _this;
    }
    GridChartComp.prototype.init = function () {
        var _this = this;
        var availableChartThemes = this.gridOptionsService.get('chartThemes') || DEFAULT_THEMES;
        if (availableChartThemes.length < 1) {
            throw new Error('Cannot create chart: no chart themes are available to be used.');
        }
        var chartThemeName = this.params.chartThemeName;
        if (!_.includes(availableChartThemes, chartThemeName)) {
            chartThemeName = availableChartThemes[0];
        }
        var modelParams = {
            chartId: this.params.chartId,
            pivotChart: this.params.pivotChart,
            chartType: this.params.chartType,
            chartThemeName: chartThemeName,
            aggFunc: this.params.aggFunc,
            cellRange: this.params.cellRange,
            suppressChartRanges: this.params.suppressChartRanges,
            unlinkChart: this.params.unlinkChart,
            crossFiltering: this.params.crossFiltering,
            seriesChartTypes: this.params.seriesChartTypes,
        };
        var isRtl = this.gridOptionsService.is('enableRtl');
        this.addCssClass(isRtl ? 'ag-rtl' : 'ag-ltr');
        // only the chart controller interacts with the chart model
        var model = this.createBean(new ChartDataModel(modelParams));
        this.chartController = this.createManagedBean(new ChartController(model));
        this.validateCustomThemes();
        // create chart before dialog to ensure dialog is correct size
        this.createChart();
        if (this.params.insideDialog) {
            this.addDialog();
        }
        this.addMenu();
        this.addTitleEditComp();
        this.addManagedListener(this.getGui(), 'focusin', this.setActiveChartCellRange.bind(this));
        this.addManagedListener(this.chartController, ChartController.EVENT_CHART_MODEL_UPDATE, this.update.bind(this));
        if (this.chartMenu) {
            // chart menu may not exist, i.e. cross filtering
            this.addManagedListener(this.chartMenu, ChartMenu.EVENT_DOWNLOAD_CHART, function () {
                return _this.downloadChart();
            });
        }
        this.update();
        this.raiseChartCreatedEvent();
    };
    GridChartComp.prototype.validateCustomThemes = function () {
        var suppliedThemes = this.getChartThemes();
        var customChartThemes = this.gridOptionsService.get('customChartThemes');
        if (customChartThemes) {
            _.getAllKeysInObjects([customChartThemes]).forEach(function (customThemeName) {
                if (!_.includes(suppliedThemes, customThemeName)) {
                    console.warn(
                        "AG Grid: a custom chart theme with the name '" +
                            customThemeName +
                            "' has been " +
                            "supplied but not added to the 'chartThemes' list",
                    );
                }
            });
        }
    };
    GridChartComp.prototype.createChart = function () {
        var _this = this;
        // if chart already exists, destroy it and remove it from DOM
        var chartInstance = undefined;
        if (this.chartProxy) {
            chartInstance = this.chartProxy.destroy({ keepChartInstance: true });
        }
        var crossFilterCallback = function (event, reset) {
            var ctx = _this.params.crossFilteringContext;
            ctx.lastSelectedChartId = reset ? '' : _this.chartController.getChartId();
            if (reset) {
                _this.params.crossFilteringResetCallback();
            }
            _this.crossFilterService.filter(event, reset);
        };
        var chartType = this.chartController.getChartType();
        var chartProxyParams = {
            chartType: chartType,
            chartInstance: chartInstance,
            getChartThemeName: this.getChartThemeName.bind(this),
            getChartThemes: this.getChartThemes.bind(this),
            customChartThemes: this.gridOptionsService.get('customChartThemes'),
            getGridOptionsChartThemeOverrides: function () {
                return _this.getGridOptionsChartThemeOverrides();
            },
            getExtraPaddingDirections: function () {
                var _a, _b;
                return (_b =
                    (_a = _this.chartMenu) === null || _a === void 0 ? void 0 : _a.getExtraPaddingDirections()) !==
                    null && _b !== void 0
                    ? _b
                    : [];
            },
            apiChartThemeOverrides: this.params.chartThemeOverrides,
            crossFiltering: this.params.crossFiltering,
            crossFilterCallback: crossFilterCallback,
            parentElement: this.eChart,
            grouping: this.chartController.isGrouping(),
            chartThemeToRestore: this.params.chartThemeName,
            chartOptionsToRestore: this.params.chartOptionsToRestore,
            chartPaletteToRestore: this.params.chartPaletteToRestore,
            seriesChartTypes: this.chartController.getSeriesChartTypes(),
            translate: function (toTranslate, defaultText) {
                return _this.chartTranslationService.translate(toTranslate, defaultText);
            },
        };
        // ensure 'restoring' options are not reused when switching chart types
        this.params.chartOptionsToRestore = undefined;
        // set local state used to detect when chart changes
        this.chartType = chartType;
        this.chartThemeName = this.chartController.getChartThemeName();
        this.chartProxy = GridChartComp.createChartProxy(chartProxyParams);
        if (!this.chartProxy) {
            console.warn('AG Grid: invalid chart type supplied: ', chartProxyParams.chartType);
            return;
        }
        var canvas = this.eChart.querySelector('canvas');
        if (canvas) {
            canvas.classList.add('ag-charts-canvas');
        }
        this.chartController.setChartProxy(this.chartProxy);
        this.chartOptionsService = this.createBean(new ChartOptionsService(this.chartController));
        this.titleEdit && this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
    };
    GridChartComp.prototype.getChartThemeName = function () {
        return this.chartController.getChartThemeName();
    };
    GridChartComp.prototype.getChartThemes = function () {
        return this.chartController.getThemes();
    };
    GridChartComp.prototype.getGridOptionsChartThemeOverrides = function () {
        return this.gridOptionsService.get('chartThemeOverrides');
    };
    GridChartComp.createChartProxy = function (chartProxyParams) {
        switch (chartProxyParams.chartType) {
            case 'column':
            case 'bar':
            case 'groupedColumn':
            case 'stackedColumn':
            case 'normalizedColumn':
            case 'groupedBar':
            case 'stackedBar':
            case 'normalizedBar':
                return new BarChartProxy(chartProxyParams);
            case 'pie':
            case 'doughnut':
                return new PieChartProxy(chartProxyParams);
            case 'area':
            case 'stackedArea':
            case 'normalizedArea':
                return new AreaChartProxy(chartProxyParams);
            case 'line':
                return new LineChartProxy(chartProxyParams);
            case 'scatter':
            case 'bubble':
                return new ScatterChartProxy(chartProxyParams);
            case 'histogram':
                return new HistogramChartProxy(chartProxyParams);
            case 'columnLineCombo':
            case 'areaColumnCombo':
            case 'customCombo':
                return new ComboChartProxy(chartProxyParams);
            default:
                throw (
                    "AG Grid: Unable to create chart as an invalid chartType = '" +
                    chartProxyParams.chartType +
                    "' was supplied."
                );
        }
    };
    GridChartComp.prototype.addDialog = function () {
        var _this = this;
        var title = this.chartTranslationService.translate(
            this.params.pivotChart ? 'pivotChartTitle' : 'rangeChartTitle',
        );
        var _a = this.getBestDialogSize(),
            width = _a.width,
            height = _a.height;
        this.chartDialog = new AgDialog({
            resizable: true,
            movable: true,
            maximizable: true,
            title: title,
            width: width,
            height: height,
            component: this,
            centered: true,
            closable: true,
        });
        this.getContext().createBean(this.chartDialog);
        this.chartDialog.addEventListener(AgDialog.EVENT_DESTROYED, function () {
            return _this.destroy();
        });
    };
    GridChartComp.prototype.getBestDialogSize = function () {
        var popupParent = this.popupService.getPopupParent();
        var maxWidth = _.getAbsoluteWidth(popupParent) * 0.75;
        var maxHeight = _.getAbsoluteHeight(popupParent) * 0.75;
        var ratio = 0.553;
        var chart = this.chartProxy.getChart();
        var width = this.params.insideDialog ? 850 : chart.width;
        var height = this.params.insideDialog ? 470 : chart.height;
        if (width > maxWidth || height > maxHeight) {
            width = Math.min(width, maxWidth);
            height = Math.round(width * ratio);
            if (height > maxHeight) {
                height = maxHeight;
                width = Math.min(width, Math.round(height / ratio));
            }
        }
        return { width: width, height: height };
    };
    GridChartComp.prototype.addMenu = function () {
        if (!this.params.crossFiltering) {
            this.chartMenu = this.createBean(
                new ChartMenu(
                    this.eChartContainer,
                    this.eMenuContainer,
                    this.chartController,
                    this.chartOptionsService,
                ),
            );
            this.eChartContainer.appendChild(this.chartMenu.getGui());
        }
    };
    GridChartComp.prototype.addTitleEditComp = function () {
        this.titleEdit = this.createBean(new TitleEdit(this.chartMenu));
        this.eTitleEditContainer.appendChild(this.titleEdit.getGui());
        if (this.chartProxy) {
            this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
        }
    };
    GridChartComp.prototype.update = function (params) {
        var _this = this;
        // update chart model for api.updateChart()
        if (params === null || params === void 0 ? void 0 : params.chartId) {
            var validUpdate = this.chartController.update(params);
            if (!validUpdate) {
                return; // warning already logged!
            }
        }
        var chartTypeChanged = this.chartTypeChanged(params);
        // recreate chart if chart type has changed
        if (chartTypeChanged) this.createChart();
        // update chart options if chart type hasn't changed or if overrides are supplied
        this.updateChart(params === null || params === void 0 ? void 0 : params.chartThemeOverrides);
        if (params === null || params === void 0 ? void 0 : params.chartId) {
            this.chartProxy
                .getChart()
                .waitForUpdate()
                .then(function () {
                    _this.chartController.raiseChartApiUpdateEvent();
                });
        }
    };
    GridChartComp.prototype.updateChart = function (updatedOverrides) {
        var _this = this;
        var chartProxy = this.chartProxy;
        var selectedCols = this.chartController.getSelectedValueColState();
        var fields = selectedCols.map(function (c) {
            return { colId: c.colId, displayName: c.displayName };
        });
        var data = this.chartController.getChartData();
        var chartEmpty = this.handleEmptyChart(data, fields);
        if (chartEmpty) {
            return;
        }
        var chartUpdateParams = this.chartController.getChartUpdateParams(updatedOverrides);
        chartProxy.update(chartUpdateParams);
        this.chartProxy
            .getChart()
            .waitForUpdate()
            .then(function () {
                _this.chartController.raiseChartUpdatedEvent();
            });
        this.titleEdit.refreshTitle(this.chartController, this.chartOptionsService);
    };
    GridChartComp.prototype.chartTypeChanged = function (updateParams) {
        var _a = __read$f(
                [
                    this.chartController.getChartType(),
                    updateParams === null || updateParams === void 0 ? void 0 : updateParams.chartType,
                ],
                2,
            ),
            currentType = _a[0],
            updatedChartType = _a[1];
        return this.chartType !== currentType || (!!updatedChartType && this.chartType !== updatedChartType);
    };
    GridChartComp.prototype.getChartModel = function () {
        return this.chartController.getChartModel();
    };
    GridChartComp.prototype.getChartImageDataURL = function (fileFormat) {
        return this.chartProxy.getChartImageDataURL(fileFormat);
    };
    GridChartComp.prototype.handleEmptyChart = function (data, fields) {
        var pivotModeDisabled = this.chartController.isPivotChart() && !this.chartController.isPivotMode();
        var minFieldsRequired = 1;
        if (this.chartController.isActiveXYChart()) {
            minFieldsRequired = this.chartController.getChartType() === 'bubble' ? 3 : 2;
        }
        var isEmptyChart = fields.length < minFieldsRequired || data.length === 0;
        if (this.eChart) {
            var isEmpty = pivotModeDisabled || isEmptyChart;
            _.setDisplayed(this.eChart, !isEmpty);
            _.setDisplayed(this.eEmpty, isEmpty);
        }
        if (pivotModeDisabled) {
            this.eEmpty.innerText = this.chartTranslationService.translate('pivotChartRequiresPivotMode');
            return true;
        }
        if (isEmptyChart) {
            this.eEmpty.innerText = this.chartTranslationService.translate('noDataToChart');
            return true;
        }
        return false;
    };
    GridChartComp.prototype.downloadChart = function (dimensions, fileName, fileFormat) {
        this.chartProxy.downloadChart(dimensions, fileName, fileFormat);
    };
    GridChartComp.prototype.openChartToolPanel = function (panel) {
        var menuPanel = panel ? CHART_TOOL_PANEL_MENU_OPTIONS[panel] : panel;
        this.chartMenu.showMenu(menuPanel);
    };
    GridChartComp.prototype.closeChartToolPanel = function () {
        this.chartMenu.hideMenu();
    };
    GridChartComp.prototype.getChartId = function () {
        return this.chartController.getChartId();
    };
    GridChartComp.prototype.getUnderlyingChart = function () {
        return this.chartProxy.getChartRef();
    };
    GridChartComp.prototype.crossFilteringReset = function () {
        this.chartProxy.crossFilteringReset();
    };
    GridChartComp.prototype.setActiveChartCellRange = function (focusEvent) {
        if (this.getGui().contains(focusEvent.relatedTarget)) {
            return;
        }
        this.chartController.setChartRange(true);
        this.gridApi.focusService.clearFocusedCell();
    };
    GridChartComp.prototype.raiseChartCreatedEvent = function () {
        var _this = this;
        var event = {
            type: Events.EVENT_CHART_CREATED,
            chartId: this.chartController.getChartId(),
        };
        this.chartProxy
            .getChart()
            .waitForUpdate()
            .then(function () {
                _this.eventService.dispatchEvent(event);
            });
    };
    GridChartComp.prototype.raiseChartDestroyedEvent = function () {
        var event = {
            type: Events.EVENT_CHART_DESTROYED,
            chartId: this.chartController.getChartId(),
        };
        this.eventService.dispatchEvent(event);
    };
    GridChartComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        if (this.chartProxy) {
            this.chartProxy.destroy();
        }
        this.destroyBean(this.chartMenu);
        this.destroyBean(this.titleEdit);
        // don't want to invoke destroy() on the Dialog (prevents destroy loop)
        if (this.chartDialog && this.chartDialog.isAlive()) {
            this.destroyBean(this.chartDialog);
        }
        // if the user is providing containers for the charts, we need to clean up, otherwise the old chart
        // data will still be visible although the chart is no longer bound to the grid
        var eGui = this.getGui();
        _.clearElement(eGui);
        // remove from parent, so if user provided container, we detach from the provided dom element
        _.removeFromParent(eGui);
        this.raiseChartDestroyedEvent();
    };
    GridChartComp.TEMPLATE =
        '<div class="ag-chart" tabindex="-1">\n            <div ref="eChartContainer" tabindex="-1" class="ag-chart-components-wrapper">\n                <div ref="eChart" class="ag-chart-canvas-wrapper"></div>\n                <div ref="eEmpty" class="ag-chart-empty-text ag-unselectable"></div>\n            </div>\n            <div ref="eTitleEditContainer"></div>\n            <div ref="eMenuContainer" class="ag-chart-docked-container"></div>\n        </div>';
    __decorate$L([RefSelector('eChart')], GridChartComp.prototype, 'eChart', void 0);
    __decorate$L([RefSelector('eChartContainer')], GridChartComp.prototype, 'eChartContainer', void 0);
    __decorate$L([RefSelector('eMenuContainer')], GridChartComp.prototype, 'eMenuContainer', void 0);
    __decorate$L([RefSelector('eEmpty')], GridChartComp.prototype, 'eEmpty', void 0);
    __decorate$L([RefSelector('eTitleEditContainer')], GridChartComp.prototype, 'eTitleEditContainer', void 0);
    __decorate$L([Autowired('chartCrossFilterService')], GridChartComp.prototype, 'crossFilterService', void 0);
    __decorate$L([Autowired('chartTranslationService')], GridChartComp.prototype, 'chartTranslationService', void 0);
    __decorate$L([Autowired('gridApi')], GridChartComp.prototype, 'gridApi', void 0);
    __decorate$L([Autowired('popupService')], GridChartComp.prototype, 'popupService', void 0);
    __decorate$L([PostConstruct], GridChartComp.prototype, 'init', null);
    return GridChartComp;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$a = '30.2.0';

var __assign$e =
    (undefined && undefined.__assign) ||
    function () {
        __assign$e =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$e.apply(this, arguments);
    };
var __rest$2 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __read$e =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __values$4 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
function upgradeChartModel(model) {
    model.version;
    if (model.version == null) {
        // Try to guess the version so we can apply the right subset of migrations.
        model.version = heuristicVersionDetection(model);
    }
    model = migrateIfBefore('23.0.0', model, migrateV23);
    model = migrateIfBefore('24.0.0', model, migrateV24);
    model = migrateIfBefore('25.1.0', model, migrateV25_1);
    model = migrateIfBefore('26.0.0', model, migrateV26);
    model = migrateIfBefore('26.1.0', model, migrateV26_1);
    // Switch from iChartOptions to iAgChartOptions....
    model = migrateIfBefore('26.2.0', model, migrateV26_2);
    model = migrateIfBefore('28.0.0', model, migrateV28);
    model = migrateIfBefore('28.2.0', model, migrateV28_2);
    model = migrateIfBefore('29.0.0', model, migrateV29);
    model = migrateIfBefore('29.1.0', model, migrateV29_1);
    model = migrateIfBefore('29.2.0', model, migrateV29_2);
    model = migrateIfBefore('30.0.0', model, migrateV30);
    model = cleanup(model);
    // Bump version to latest.
    model = migrateIfBefore(VERSION$a, model, function (m) {
        return m;
    });
    return model;
}
function migrateV23(model) {
    // https://github.com/ag-grid/ag-grid/commit/76c6744ff2b732d298d1ade73c122188854b5bac
    model = jsonRename('chartOptions.legend.item.marker.type', 'shape', model);
    model = jsonRename('chartOptions.seriesDefaults.marker.type', 'shape', model);
    // https://github.com/ag-grid/ag-grid/commit/7bdf2cfd666acda758a818733a9f9cb35ac1d7a7
    model = jsonRename('chartOptions.legend.padding', 'spacing', model);
    return model;
}
function migrateV24(model) {
    var _a;
    // https://github.com/ag-grid/ag-grid/commit/f4e854e3dc459400fa00e6da2873cb8e9cfff6fe#
    model = jsonDelete('chartOptions.seriesDefaults.marker.minSize', model);
    var _b = model,
        chartType = _b.chartType,
        chartPalette = _b.chartPalette, // Migrate.
        _c = _b.chartOptions,
        xAxis = _c.xAxis,
        yAxis = _c.yAxis,
        chartOptions = __rest$2(_c, ['xAxis', 'yAxis']),
        chartModel = __rest$2(_b, ['chartType', 'chartPalette', 'chartOptions']);
    var axesTypes = getLegacyAxisType(chartType);
    var axes =
        axesTypes === null || axesTypes === void 0
            ? void 0
            : axesTypes.map(function (type, i) {
                  return __assign$e({ type: type }, i === 0 ? xAxis : yAxis);
              });
    return __assign$e(
        {
            chartType: chartType,
            chartThemeName: (_a = LEGACY_PALETTES[chartPalette]) !== null && _a !== void 0 ? _a : 'ag-default',
            chartOptions: __assign$e(__assign$e({}, chartOptions), { axes: axes, xAxis: xAxis, yAxis: yAxis }),
        },
        chartModel,
    );
}
function migrateV25_1(model) {
    // https://github.com/ag-grid/ag-grid/commit/61943f9fecbfb5ac1b9a1fd93788f9fdd8687181
    model = jsonRename('chartOptions.seriesDefaults.label.minRequiredAngle', 'minAngle', model);
    return model;
}
function migrateV26(model) {
    // https://github.com/ag-grid/ag-grid/commit/df2445d88e64cb4e831d6163104a0fa60ccde3b5
    var highlightOptUpdate = function (_a) {
        var dimOpacity = _a.dimOpacity,
            opts = __rest$2(_a, ['dimOpacity']);
        return __assign$e(__assign$e({}, opts), dimOpacity != null ? { series: { dimOpacity: dimOpacity } } : {});
    };
    model = jsonMutate('chartOptions.seriesDefaults.highlightStyle', model, highlightOptUpdate);
    // https://github.com/ag-grid/ag-grid/commit/f4e854e3dc459400fa00e6da2873cb8e9cfff6fe#
    model = jsonDelete('chart', model);
    model = jsonDelete('chartOptions.seriesDefaults.tooltipClass', model);
    model = jsonDelete('chartOptions.seriesDefaults.tooltipTracking', model);
    // Cleanup label.rotation === 0, which was treated as 'use the default' on reload prior to 26.
    model = jsonDeleteDefault('chartOptions.axes[].label.rotation', 0, model);
    model = jsonDeleteDefault('chartOptions.axes[].label.rotation', 335, model);
    return model;
}
function migrateV26_1(model) {
    // https://github.com/ag-grid/ag-grid/commit/df2445d88e64cb4e831d6163104a0fa60ccde3b5
    var highlightOptUpdate = function (_a) {
        var item = _a.item,
            series = _a.series,
            opts = __rest$2(_a, ['item', 'series']);
        return __assign$e({ item: __assign$e(__assign$e({}, opts), item) }, series ? { series: series } : {});
    };
    model = jsonMutate('chartOptions.seriesDefaults.highlightStyle', model, highlightOptUpdate);
    model = jsonMutate('chartOptions.series[].highlightStyle', model, highlightOptUpdate);
    return model;
}
function migrateV26_2(model) {
    // https://github.com/ag-grid/ag-grid/commit/8b2e223cb1a687cb6c1d70b9f75f52fa29d00341
    model = jsonMove('chartOptions.seriesDefaults.fill.opacity', 'chartOptions.seriesDefaults.fillOpacity', model);
    model = jsonMove('chartOptions.seriesDefaults.stroke.opacity', 'chartOptions.seriesDefaults.strokeOpacity', model);
    model = jsonMove('chartOptions.seriesDefaults.stroke.width', 'chartOptions.seriesDefaults.strokeWidth', model);
    model = jsonDelete('chartOptions.seriesDefaults.fill', model);
    model = jsonDelete('chartOptions.seriesDefaults.stroke', model);
    model = jsonDelete('chartOptions.seriesDefaults.callout.colors', model);
    model = jsonDelete('chartOptions.xAxis', model);
    model = jsonDelete('chartOptions.yAxis', model);
    var _a = model,
        chartType = _a.chartType,
        _b = _a.chartOptions,
        axes = _b.axes;
    _b.series;
    var seriesDefaults = _b.seriesDefaults,
        otherChartOptions = __rest$2(_b, ['axes', 'series', 'seriesDefaults']),
        otherModelProps = __rest$2(_a, ['chartType', 'chartOptions']);
    // At 26.2.0 combination charts weren't supported, so we can safely assume a single series type.
    // We can't rely on the `series.type` field as it was incorrect (in v25.0.0 line chart has an
    // `area` series).
    var seriesTypes = [getSeriesType(chartType)];
    var chartTypeMixin = {};
    if (!seriesTypes.includes('pie')) {
        var minimalAxis_1 = { top: {}, bottom: {}, left: {}, right: {} };
        var updatedAxes_1 = axes
            .map(function (_a) {
                var _b;
                var type = _a.type,
                    axisProps = __rest$2(_a, ['type']);
                return (_b = {}), (_b[type] = __assign$e(__assign$e({}, minimalAxis_1), axisProps)), _b;
            })
            .reduce(merge, {});
        ALL_AXIS_TYPES.filter(function (v) {
            return updatedAxes_1[v] == null;
        }).forEach(function (v) {
            updatedAxes_1[v] = __assign$e({}, minimalAxis_1);
        });
        chartTypeMixin.axes = updatedAxes_1;
    }
    var updatedChartOptions = seriesTypes
        .map(function (t) {
            var _a;
            return (
                (_a = {}),
                (_a[t] = __assign$e(
                    __assign$e(__assign$e({}, chartTypeMixin), { series: seriesDefaults }),
                    otherChartOptions,
                )),
                _a
            );
        })
        .reduce(merge, {});
    model = __assign$e(__assign$e({}, otherModelProps), { chartType: chartType, chartOptions: updatedChartOptions });
    return model;
}
function migrateV28(model) {
    model = jsonDelete('chartOptions.*.title.padding', model);
    model = jsonDelete('chartOptions.*.subtitle.padding', model);
    model = jsonDelete('chartOptions.*.axes.*.title.padding', model);
    model = jsonBackfill('chartOptions.*.axes.*.title.enabled', false, model);
    return model;
}
function migrateV28_2(model) {
    model = jsonRename('chartOptions.pie.series.callout', 'calloutLine', model);
    model = jsonRename('chartOptions.pie.series.label', 'calloutLabel', model);
    model = jsonRename('chartOptions.pie.series.labelKey', 'sectorLabelKey', model);
    model = jsonRename('chartOptions.pie.series.labelName', 'sectorLabelName', model);
    // series.yKeys => yKey ?
    // series.yNames => yName ?
    return model;
}
function migrateV29(model) {
    model = jsonMoveIfMissing('chartOptions.scatter.series.fill', 'chartOptions.scatter.series.marker.fill', model);
    model = jsonMoveIfMissing(
        'chartOptions.scatter.series.fillOpacity',
        'chartOptions.scatter.series.marker.fillOpacity',
        model,
    );
    model = jsonMoveIfMissing('chartOptions.scatter.series.stroke', 'chartOptions.scatter.series.marker.stroke', model);
    model = jsonMoveIfMissing(
        'chartOptions.scatter.series.strokeOpacity',
        'chartOptions.scatter.series.marker.strokeOpacity',
        model,
    );
    model = jsonMoveIfMissing(
        'chartOptions.scatter.series.strokeWidth',
        'chartOptions.scatter.series.marker.strokeWidth',
        model,
    );
    model = jsonMove('chartOptions.scatter.series.paired', 'chartOptions.scatter.paired', model);
    return model;
}
function migrateV29_1(model) {
    model = jsonDelete('chartOptions.axes[].tick.count', model);
    return model;
}
function migrateV29_2(model) {
    // https://github.com/ag-grid/ag-grid/commit/ce11956492e42e845932edb4e05d7b0b21db5c61
    var tooltipOptUpdate = function (_a) {
        var _b, _c, _d, _e;
        var tracking = _a.tracking,
            opts = __rest$2(_a, ['tracking']);
        var output = __assign$e({}, opts);
        if (tracking === false) {
            (_b = output.position) !== null && _b !== void 0 ? _b : (output.position = { type: 'pointer' });
            (_c = output.range) !== null && _c !== void 0 ? _c : (output.range = 'nearest');
        } else if (tracking === true) {
            (_d = output.position) !== null && _d !== void 0 ? _d : (output.position = { type: 'node' });
            (_e = output.range) !== null && _e !== void 0 ? _e : (output.range = 'nearest');
        }
        return output;
    };
    model = jsonMutate('chartOptions.*.tooltip', model, tooltipOptUpdate);
    return model;
}
function migrateV30(model) {
    // Repeated from migrateV28_2() as they were applied retrospectively for the v30 release.
    model = jsonRename('chartOptions.pie.series.labelKey', 'sectorLabelKey', model);
    model = jsonRename('chartOptions.pie.series.labelName', 'sectorLabelName', model);
    // Late-applied migrations for deprecations in the 29.x.y range.
    model = migrateV29_1(model);
    model = migrateV29_2(model);
    // Actual v30 changes.
    model = jsonDelete('chartOptions.*.series.flipXY', model);
    model = jsonAdd('chartOptions.common.legend.enabled', true, model);
    model = jsonBackfill('chartOptions.common.legend.position', 'right', model);
    return model;
}
function cleanup(model) {
    // Remove fixed width/height - this has never been supported via UI configuration.
    model = jsonDelete('chartOptions.*.width', model);
    model = jsonDelete('chartOptions.*.height', model);
    model = jsonBackfill('chartOptions.*.axes.category.label.autoRotate', true, model);
    return model;
}
function heuristicVersionDetection(model) {
    var _a, _b;
    var modelAny = model;
    if (model.version != null) {
        return model.version;
    }
    var hasKey = function (obj) {
        var keys = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            keys[_i - 1] = arguments[_i];
        }
        return Object.keys(obj || {}).some(function (k) {
            return keys.includes(k);
        });
    };
    var chartOptions = modelAny.chartOptions;
    var seriesOptions = hasKey(chartOptions, 'seriesDefaults')
        ? chartOptions === null || chartOptions === void 0
            ? void 0
            : chartOptions.seriesDefaults
        : chartOptions === null || chartOptions === void 0
        ? void 0
        : chartOptions[Object.keys(chartOptions)[0]];
    var hints = {
        '27.0.0': hasKey(modelAny, 'seriesChartTypes'),
        '26.2.0': !hasKey(chartOptions, 'seriesDefaults'),
        '26.1.0': hasKey(
            seriesOptions === null || seriesOptions === void 0 ? void 0 : seriesOptions.highlightStyle,
            'item',
        ),
        '26.0.0': hasKey(
            seriesOptions === null || seriesOptions === void 0 ? void 0 : seriesOptions.highlightStyle,
            'series',
        ),
        // '26.0.0': modelAny.chart === undefined,
        '25.1.0': hasKey(seriesOptions === null || seriesOptions === void 0 ? void 0 : seriesOptions.label, 'minAngle'),
        '25.0.0':
            hasKey(modelAny, 'modelType', 'aggFunc', 'unlinkChart', 'suppressChartRanges') ||
            hasKey(seriesOptions, 'lineDash', 'lineDashOffset'),
        '24.0.0': hasKey(modelAny, 'chartThemeName', 'chart') || hasKey(chartOptions, 'series'),
        '23.2.0': hasKey(chartOptions, 'navigator'),
        '23.0.0': hasKey(
            (_b =
                (_a = chartOptions === null || chartOptions === void 0 ? void 0 : chartOptions.legend) === null ||
                _a === void 0
                    ? void 0
                    : _a.item) === null || _b === void 0
                ? void 0
                : _b.marker,
            'shape',
        ),
        '22.1.0': hasKey(modelAny, 'chartPalette', 'chartType'),
    };
    // Default to 27.1.0, the last version before we added `version`.
    var defaultVersion = '27.1.0';
    var matchingHints = Object.entries(hints).filter(function (_a) {
        var _b = __read$e(_a, 2);
        _b[0];
        var match = _b[1];
        return match;
    });
    var _c = __read$e(matchingHints[0], 1),
        _d = _c[0],
        heuristicVersion = _d === void 0 ? defaultVersion : _d;
    return heuristicVersion;
}
function migrateIfBefore(maxVersion, model, migration) {
    if (versionNumber(maxVersion) > versionNumber(model.version)) {
        var result = migration(model);
        result.version = maxVersion;
        return result;
    }
    return model;
}
function versionParts(version) {
    var split =
        typeof version === 'string'
            ? version.split('.').map(function (v) {
                  return Number(v);
              })
            : [];
    if (
        split.length !== 3 ||
        split.some(function (v) {
            return isNaN(v);
        })
    ) {
        throw new Error('AG Grid - Illegal version string: ' + version);
    }
    return {
        major: split[0],
        minor: split[1],
        patch: split[2],
    };
}
function versionNumber(version) {
    var _a = versionParts(version),
        major = _a.major,
        minor = _a.minor,
        patch = _a.patch;
    // Return a number of the form MMmmPP.
    return major * 10000 + minor * 100 + patch;
}
function jsonDeleteDefault(path, defaultValue, json) {
    return jsonMutateProperty(path, true, json, function (parent, prop) {
        if (parent[prop] === defaultValue) {
            delete parent[prop];
        }
    });
}
function jsonBackfill(path, defaultValue, json) {
    return jsonMutateProperty(path, false, json, function (parent, prop) {
        if (parent[prop] == null) {
            parent[prop] = defaultValue;
        }
    });
}
function jsonAdd(path, value, json) {
    var _a;
    if (typeof path === 'string') {
        path = path.split('.');
    }
    var nextPath = path[0];
    if (path.length > 1) {
        json[nextPath] = jsonAdd(path.slice(1), value, (_a = json[nextPath]) !== null && _a !== void 0 ? _a : {});
    }
    var hasProperty = Object.keys(json).includes(nextPath);
    if (!hasProperty) {
        json[nextPath] = value;
    }
    return json;
}
function jsonMove(from, to, json) {
    var valueToMove = undefined;
    var valueFound = false;
    json = jsonMutateProperty(from, true, json, function (parent, prop) {
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) {
        return json;
    }
    return jsonMutateProperty(to, false, json, function (parent, prop) {
        parent[prop] = valueToMove;
    });
}
function jsonMoveIfMissing(from, to, json) {
    var valueToMove = undefined;
    var valueFound = false;
    json = jsonMutateProperty(from, true, json, function (parent, prop) {
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) {
        return json;
    }
    return jsonMutateProperty(to, false, json, function (parent, prop) {
        if (parent[prop] === undefined) {
            parent[prop] = valueToMove;
        }
    });
}
function jsonRename(path, renameTo, json) {
    return jsonMutateProperty(path, true, json, function (parent, prop) {
        parent[renameTo] = parent[prop];
        delete parent[prop];
    });
}
function jsonDelete(path, json) {
    return jsonMutateProperty(path, true, json, function (parent, prop) {
        return delete parent[prop];
    });
}
function jsonMutateProperty(path, skipMissing, json, mutator) {
    var pathElements = path instanceof Array ? path : path.split('.');
    var parentPathElements = pathElements.slice(0, pathElements.length - 1);
    var targetName = pathElements[pathElements.length - 1];
    return jsonMutate(parentPathElements, json, function (parent) {
        var hasProperty = Object.keys(parent).includes(targetName);
        if (skipMissing && !hasProperty) {
            return parent;
        }
        var result = __assign$e({}, parent);
        mutator(result, targetName);
        return result;
    });
}
function jsonMutate(path, json, mutator) {
    var e_1, _a;
    var pathElements = path instanceof Array ? path : path.split('.');
    // Clone to avoid mutating original input.
    json = __assign$e({}, json);
    if (pathElements.length === 0) {
        return mutator(json);
    } else if (pathElements[0].startsWith('{')) {
        var pathOptions = pathElements[0].substring(1, pathElements[0].lastIndexOf('}')).split(',');
        try {
            for (
                var pathOptions_1 = __values$4(pathOptions), pathOptions_1_1 = pathOptions_1.next();
                !pathOptions_1_1.done;
                pathOptions_1_1 = pathOptions_1.next()
            ) {
                var pathOption = pathOptions_1_1.value;
                if (json[pathOption] != null) {
                    json[pathOption] = jsonMutate(pathElements.slice(1), json[pathOption], mutator);
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (pathOptions_1_1 && !pathOptions_1_1.done && (_a = pathOptions_1.return)) _a.call(pathOptions_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    } else if (pathElements[0].endsWith('[]')) {
        var arrayName = pathElements[0].substring(0, path[0].indexOf('['));
        if (json[arrayName] instanceof Array) {
            json[arrayName] = json[arrayName].map(function (v) {
                return jsonMutate(pathElements.slice(1), v, mutator);
            });
        }
    } else if (pathElements[0] === '*') {
        for (var jsonProp in json) {
            json[jsonProp] = jsonMutate(pathElements.slice(1), json[jsonProp], mutator);
        }
    } else if (json[pathElements[0]] != null) {
        json[pathElements[0]] = jsonMutate(pathElements.slice(1), json[pathElements[0]], mutator);
    }
    return json;
}
var merge = function (r, n) {
    return __assign$e(__assign$e({}, r), n);
};
// Precise legacy palette fills/strokes can be found here for future reference:
// https://github.com/ag-grid/ag-grid/blob/b22.1.0/grid-enterprise-modules/charts/src/charts/chart/palettes.ts
var LEGACY_PALETTES = {
    borneo: 'ag-default',
    material: 'ag-material',
    pastel: 'ag-pastel',
    bright: 'ag-vivid',
    flat: 'ag-solar',
};

var __extends$P =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$d =
    (undefined && undefined.__assign) ||
    function () {
        __assign$d =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$d.apply(this, arguments);
    };
var __decorate$K =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$d =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$8 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var ChartService = /** @class */ (function (_super) {
    __extends$P(ChartService, _super);
    function ChartService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        // we destroy all charts bound to this grid when grid is destroyed. activeCharts contains all charts, including
        // those in developer provided containers.
        _this.activeCharts = new Set();
        _this.activeChartComps = new Set();
        // this shared (singleton) context is used by cross filtering in line and area charts
        _this.crossFilteringContext = {
            lastSelectedChartId: '',
        };
        return _this;
    }
    ChartService.prototype.updateChart = function (params) {
        if (this.activeChartComps.size === 0) {
            console.warn('AG Grid - No active charts to update.');
            return;
        }
        var chartComp = __spreadArray$8([], __read$d(this.activeChartComps)).find(function (chartComp) {
            return chartComp.getChartId() === params.chartId;
        });
        if (!chartComp) {
            console.warn('AG Grid - Unable to update chart. No active chart found with ID: ' + params.chartId + '.');
            return;
        }
        chartComp.update(params);
    };
    ChartService.prototype.getChartModels = function () {
        var models = [];
        var versionedModel = function (c) {
            return __assign$d(__assign$d({}, c), { version: VERSION$a });
        };
        this.activeChartComps.forEach(function (c) {
            return models.push(versionedModel(c.getChartModel()));
        });
        return models;
    };
    ChartService.prototype.getChartRef = function (chartId) {
        var chartRef;
        this.activeCharts.forEach(function (cr) {
            if (cr.chartId === chartId) {
                chartRef = cr;
            }
        });
        return chartRef;
    };
    ChartService.prototype.getChartComp = function (chartId) {
        var chartComp;
        this.activeChartComps.forEach(function (comp) {
            if (comp.getChartId() === chartId) {
                chartComp = comp;
            }
        });
        return chartComp;
    };
    ChartService.prototype.getChartImageDataURL = function (params) {
        var url;
        this.activeChartComps.forEach(function (c) {
            if (c.getChartId() === params.chartId) {
                url = c.getChartImageDataURL(params.fileFormat);
            }
        });
        return url;
    };
    ChartService.prototype.downloadChart = function (params) {
        var chartComp = Array.from(this.activeChartComps).find(function (c) {
            return c.getChartId() === params.chartId;
        });
        chartComp === null || chartComp === void 0
            ? void 0
            : chartComp.downloadChart(params.dimensions, params.fileName, params.fileFormat);
    };
    ChartService.prototype.openChartToolPanel = function (params) {
        var chartComp = Array.from(this.activeChartComps).find(function (c) {
            return c.getChartId() === params.chartId;
        });
        chartComp === null || chartComp === void 0 ? void 0 : chartComp.openChartToolPanel(params.panel);
    };
    ChartService.prototype.closeChartToolPanel = function (chartId) {
        var chartComp = Array.from(this.activeChartComps).find(function (c) {
            return c.getChartId() === chartId;
        });
        chartComp === null || chartComp === void 0 ? void 0 : chartComp.closeChartToolPanel();
    };
    ChartService.prototype.createChartFromCurrentRange = function (chartType) {
        if (chartType === void 0) {
            chartType = 'groupedColumn';
        }
        var selectedRange = this.getSelectedRange();
        return this.createChart(selectedRange, chartType);
    };
    ChartService.prototype.restoreChart = function (model, chartContainer) {
        var _this = this;
        if (!model) {
            console.warn('AG Grid - unable to restore chart as no chart model is provided');
            return;
        }
        if (model.version !== VERSION$a) {
            model = upgradeChartModel(model);
        }
        var params = {
            cellRange: model.cellRange,
            chartType: model.chartType,
            chartThemeName: model.chartThemeName,
            chartContainer: chartContainer,
            suppressChartRanges: model.suppressChartRanges,
            aggFunc: model.aggFunc,
            unlinkChart: model.unlinkChart,
            seriesChartTypes: model.seriesChartTypes,
        };
        var getCellRange = function (cellRangeParams) {
            return _this.rangeService
                ? _this.rangeService.createCellRangeFromCellRangeParams(cellRangeParams)
                : undefined;
        };
        if (model.modelType === 'pivot') {
            // if required enter pivot mode
            if (!this.columnModel.isPivotMode()) {
                this.columnModel.setPivotMode(true, 'pivotChart');
            }
            // pivot chart range contains all visible column without a row range to include all rows
            var columns = this.columnModel.getAllDisplayedColumns().map(function (col) {
                return col.getColId();
            });
            var chartAllRangeParams = {
                rowStartIndex: null,
                rowStartPinned: undefined,
                rowEndIndex: null,
                rowEndPinned: undefined,
                columns: columns,
            };
            var cellRange_1 = getCellRange(chartAllRangeParams);
            if (!cellRange_1) {
                console.warn('AG Grid - unable to create chart as there are no columns in the grid.');
                return;
            }
            return this.createChart(
                cellRange_1,
                params.chartType,
                params.chartThemeName,
                true,
                true,
                params.chartContainer,
                undefined,
                undefined,
                params.unlinkChart,
                false,
                model.chartOptions,
            );
        }
        var cellRange = getCellRange(params.cellRange);
        if (!cellRange) {
            console.warn('AG Grid - unable to create chart as no range is selected');
            return;
        }
        return this.createChart(
            cellRange,
            params.chartType,
            params.chartThemeName,
            false,
            params.suppressChartRanges,
            params.chartContainer,
            params.aggFunc,
            undefined,
            params.unlinkChart,
            false,
            model.chartOptions,
            model.chartPalette,
            params.seriesChartTypes,
        );
    };
    ChartService.prototype.createRangeChart = function (params) {
        var _a;
        var cellRange =
            (_a = this.rangeService) === null || _a === void 0
                ? void 0
                : _a.createCellRangeFromCellRangeParams(params.cellRange);
        if (!cellRange) {
            console.warn('AG Grid - unable to create chart as no range is selected');
            return;
        }
        return this.createChart(
            cellRange,
            params.chartType,
            params.chartThemeName,
            false,
            params.suppressChartRanges,
            params.chartContainer,
            params.aggFunc,
            params.chartThemeOverrides,
            params.unlinkChart,
            undefined,
            undefined,
            undefined,
            params.seriesChartTypes,
        );
    };
    ChartService.prototype.createPivotChart = function (params) {
        // if required enter pivot mode
        if (!this.columnModel.isPivotMode()) {
            this.columnModel.setPivotMode(true, 'pivotChart');
        }
        // pivot chart range contains all visible column without a row range to include all rows
        var chartAllRangeParams = {
            rowStartIndex: null,
            rowStartPinned: undefined,
            rowEndIndex: null,
            rowEndPinned: undefined,
            columns: this.columnModel.getAllDisplayedColumns().map(function (col) {
                return col.getColId();
            }),
        };
        var cellRange = this.rangeService
            ? this.rangeService.createCellRangeFromCellRangeParams(chartAllRangeParams)
            : undefined;
        if (!cellRange) {
            console.warn('AG Grid - unable to create chart as there are no columns in the grid.');
            return;
        }
        return this.createChart(
            cellRange,
            params.chartType,
            params.chartThemeName,
            true,
            true,
            params.chartContainer,
            undefined,
            params.chartThemeOverrides,
            params.unlinkChart,
        );
    };
    ChartService.prototype.createCrossFilterChart = function (params) {
        var _a;
        var cellRange =
            (_a = this.rangeService) === null || _a === void 0
                ? void 0
                : _a.createCellRangeFromCellRangeParams(params.cellRange);
        if (!cellRange) {
            console.warn('AG Grid - unable to create chart as no range is selected');
            return;
        }
        var crossFiltering = true;
        var suppressChartRangesSupplied =
            typeof params.suppressChartRanges !== 'undefined' && params.suppressChartRanges !== null;
        var suppressChartRanges = suppressChartRangesSupplied ? params.suppressChartRanges : true;
        return this.createChart(
            cellRange,
            params.chartType,
            params.chartThemeName,
            false,
            suppressChartRanges,
            params.chartContainer,
            params.aggFunc,
            params.chartThemeOverrides,
            params.unlinkChart,
            crossFiltering,
        );
    };
    ChartService.prototype.createChart = function (
        cellRange,
        chartType,
        chartThemeName,
        pivotChart,
        suppressChartRanges,
        container,
        aggFunc,
        chartThemeOverrides,
        unlinkChart,
        crossFiltering,
        chartOptionsToRestore,
        chartPaletteToRestore,
        seriesChartTypes,
    ) {
        var _this = this;
        if (pivotChart === void 0) {
            pivotChart = false;
        }
        if (suppressChartRanges === void 0) {
            suppressChartRanges = false;
        }
        if (unlinkChart === void 0) {
            unlinkChart = false;
        }
        if (crossFiltering === void 0) {
            crossFiltering = false;
        }
        var createChartContainerFunc = this.gridOptionsService.getCallback('createChartContainer');
        var params = {
            chartId: this.generateId(),
            pivotChart: pivotChart,
            cellRange: cellRange,
            chartType: chartType,
            chartThemeName: chartThemeName,
            insideDialog: !(container || createChartContainerFunc),
            suppressChartRanges: suppressChartRanges,
            aggFunc: aggFunc,
            chartThemeOverrides: chartThemeOverrides,
            unlinkChart: unlinkChart,
            crossFiltering: crossFiltering,
            crossFilteringContext: this.crossFilteringContext,
            chartOptionsToRestore: chartOptionsToRestore,
            chartPaletteToRestore: chartPaletteToRestore,
            seriesChartTypes: seriesChartTypes,
            crossFilteringResetCallback: function () {
                return _this.activeChartComps.forEach(function (c) {
                    return c.crossFilteringReset();
                });
            },
        };
        var chartComp = new GridChartComp(params);
        this.context.createBean(chartComp);
        var chartRef = this.createChartRef(chartComp);
        if (container) {
            // if container exists, means developer initiated chart create via API, so place in provided container
            container.appendChild(chartComp.getGui());
            // if the chart container was placed outside an element that
            // has the grid's theme, we manually add the current theme to
            // make sure all styles for the chartMenu are rendered correctly
            var theme = this.environment.getTheme();
            if (theme.el && !theme.el.contains(container)) {
                container.classList.add(theme.theme);
            }
        } else if (createChartContainerFunc) {
            // otherwise, user created chart via grid UI, check if developer provides containers (e.g. if the application
            // is using its own dialogs rather than the grid provided dialogs)
            createChartContainerFunc(chartRef);
        } else {
            // add listener to remove from active charts list when charts are destroyed, e.g. closing chart dialog
            chartComp.addEventListener(GridChartComp.EVENT_DESTROYED, function () {
                _this.activeChartComps.delete(chartComp);
                _this.activeCharts.delete(chartRef);
            });
        }
        return chartRef;
    };
    ChartService.prototype.createChartRef = function (chartComp) {
        var _this = this;
        var chartRef = {
            destroyChart: function () {
                if (_this.activeCharts.has(chartRef)) {
                    _this.context.destroyBean(chartComp);
                    _this.activeChartComps.delete(chartComp);
                    _this.activeCharts.delete(chartRef);
                }
            },
            chartElement: chartComp.getGui(),
            chart: chartComp.getUnderlyingChart(),
            chartId: chartComp.getChartModel().chartId,
        };
        this.activeCharts.add(chartRef);
        this.activeChartComps.add(chartComp);
        return chartRef;
    };
    ChartService.prototype.getSelectedRange = function () {
        var ranges = this.rangeService.getCellRanges();
        return ranges.length > 0 ? ranges[0] : {};
    };
    ChartService.prototype.generateId = function () {
        return 'id-' + Math.random().toString(36).substring(2, 18);
    };
    ChartService.prototype.destroyAllActiveCharts = function () {
        this.activeCharts.forEach(function (chart) {
            return chart.destroyChart();
        });
    };
    ChartService.CHARTS_VERSION = VERSION$b;
    __decorate$K([Optional('rangeService')], ChartService.prototype, 'rangeService', void 0);
    __decorate$K([Autowired('columnModel')], ChartService.prototype, 'columnModel', void 0);
    __decorate$K([PreDestroy], ChartService.prototype, 'destroyAllActiveCharts', null);
    ChartService = __decorate$K([Bean('chartService')], ChartService);
    return ChartService;
})(BeanStub);

var __extends$O =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$J =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartTranslationService = /** @class */ (function (_super) {
    __extends$O(ChartTranslationService, _super);
    function ChartTranslationService() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartTranslationService_1 = ChartTranslationService;
    ChartTranslationService.prototype.translate = function (toTranslate, defaultText) {
        var translate = this.localeService.getLocaleTextFunc();
        var defaultTranslation = ChartTranslationService_1.DEFAULT_TRANSLATIONS[toTranslate] || defaultText;
        return translate(toTranslate, defaultTranslation);
    };
    var ChartTranslationService_1;
    ChartTranslationService.DEFAULT_TRANSLATIONS = {
        pivotChartTitle: 'Pivot Chart',
        rangeChartTitle: 'Range Chart',
        settings: 'Settings',
        data: 'Data',
        format: 'Format',
        categories: 'Categories',
        defaultCategory: '(None)',
        series: 'Series',
        xyValues: 'X Y Values',
        paired: 'Paired Mode',
        axis: 'Axis',
        navigator: 'Navigator',
        color: 'Color',
        thickness: 'Thickness',
        xType: 'X Type',
        automatic: 'Automatic',
        category: 'Category',
        number: 'Number',
        time: 'Time',
        autoRotate: 'Auto Rotate',
        xRotation: 'X Rotation',
        yRotation: 'Y Rotation',
        ticks: 'Ticks',
        width: 'Width',
        height: 'Height',
        length: 'Length',
        padding: 'Padding',
        spacing: 'Spacing',
        chart: 'Chart',
        title: 'Title',
        titlePlaceholder: 'Chart title - double click to edit',
        background: 'Background',
        font: 'Font',
        top: 'Top',
        right: 'Right',
        bottom: 'Bottom',
        left: 'Left',
        labels: 'Labels',
        calloutLabels: 'Callout Labels',
        sectorLabels: 'Sector Labels',
        positionRatio: 'Position Ratio',
        size: 'Size',
        shape: 'Shape',
        minSize: 'Minimum Size',
        maxSize: 'Maximum Size',
        legend: 'Legend',
        position: 'Position',
        markerSize: 'Marker Size',
        markerStroke: 'Marker Stroke',
        markerPadding: 'Marker Padding',
        itemSpacing: 'Item Spacing',
        itemPaddingX: 'Item Padding X',
        itemPaddingY: 'Item Padding Y',
        layoutHorizontalSpacing: 'Horizontal Spacing',
        layoutVerticalSpacing: 'Vertical Spacing',
        strokeWidth: 'Stroke Width',
        offset: 'Offset',
        offsets: 'Offsets',
        tooltips: 'Tooltips',
        callout: 'Callout',
        markers: 'Markers',
        shadow: 'Shadow',
        blur: 'Blur',
        xOffset: 'X Offset',
        yOffset: 'Y Offset',
        lineWidth: 'Line Width',
        lineDash: 'Line Dash',
        normal: 'Normal',
        bold: 'Bold',
        italic: 'Italic',
        boldItalic: 'Bold Italic',
        predefined: 'Predefined',
        fillOpacity: 'Fill Opacity',
        strokeOpacity: 'Line Opacity',
        histogramBinCount: 'Bin count',
        columnGroup: 'Column',
        barGroup: 'Bar',
        pieGroup: 'Pie',
        lineGroup: 'Line',
        scatterGroup: 'X Y (Scatter)',
        areaGroup: 'Area',
        histogramGroup: 'Histogram',
        combinationGroup: 'Combination',
        groupedColumnTooltip: 'Grouped',
        stackedColumnTooltip: 'Stacked',
        normalizedColumnTooltip: '100% Stacked',
        groupedBarTooltip: 'Grouped',
        stackedBarTooltip: 'Stacked',
        normalizedBarTooltip: '100% Stacked',
        pieTooltip: 'Pie',
        doughnutTooltip: 'Doughnut',
        lineTooltip: 'Line',
        groupedAreaTooltip: 'Area',
        stackedAreaTooltip: 'Stacked',
        normalizedAreaTooltip: '100% Stacked',
        scatterTooltip: 'Scatter',
        bubbleTooltip: 'Bubble',
        histogramTooltip: 'Histogram',
        columnLineComboTooltip: 'Column & Line',
        areaColumnComboTooltip: 'Area & Column',
        customComboTooltip: 'Custom Combination',
        noDataToChart: 'No data available to be charted.',
        pivotChartRequiresPivotMode: 'Pivot Chart requires Pivot Mode enabled.',
        chartSettingsToolbarTooltip: 'Menu',
        chartLinkToolbarTooltip: 'Linked to Grid',
        chartUnlinkToolbarTooltip: 'Unlinked from Grid',
        chartDownloadToolbarTooltip: 'Download Chart',
        histogramFrequency: 'Frequency',
        seriesChartType: 'Series Chart Type',
        seriesType: 'Series Type',
        secondaryAxis: 'Secondary Axis',
    };
    ChartTranslationService = ChartTranslationService_1 = __decorate$J(
        [Bean('chartTranslationService')],
        ChartTranslationService,
    );
    return ChartTranslationService;
})(BeanStub);

var __extends$N =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$I =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ChartCrossFilterService = /** @class */ (function (_super) {
    __extends$N(ChartCrossFilterService, _super);
    function ChartCrossFilterService() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartCrossFilterService_1 = ChartCrossFilterService;
    ChartCrossFilterService.prototype.filter = function (event, reset) {
        if (reset === void 0) {
            reset = false;
        }
        var filterModel = this.gridApi.getFilterModel();
        // filters should be reset when user clicks on canvas background
        if (reset) {
            this.resetFilters(filterModel);
            return;
        }
        var colId = ChartCrossFilterService_1.extractFilterColId(event);
        if (this.isValidColumnFilter(colId)) {
            // update filters based on current chart selections
            this.updateFilters(filterModel, event, colId);
        } else {
            console.warn(
                "AG Grid: cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' " +
                    "to be defined on the column with id: '" +
                    colId +
                    "'",
            );
        }
    };
    ChartCrossFilterService.prototype.resetFilters = function (filterModel) {
        var filtersExist = Object.keys(filterModel).length > 0;
        if (filtersExist) {
            // only reset filters / charts when necessary to prevent undesirable flickering effect
            this.gridApi.setFilterModel(null);
            this.gridApi.onFilterChanged();
        }
    };
    ChartCrossFilterService.prototype.updateFilters = function (filterModel, event, colId) {
        var _a;
        var dataKey = ChartCrossFilterService_1.extractFilterColId(event);
        var rawValue = event.datum[dataKey];
        if (rawValue === undefined) {
            return;
        }
        var selectedValue = rawValue.toString();
        if (event.event.metaKey || event.event.ctrlKey) {
            var existingGridValues = this.getCurrentGridValuesForCategory(colId);
            var valueAlreadyExists = _.includes(existingGridValues, selectedValue);
            var updatedValues = void 0;
            if (valueAlreadyExists) {
                updatedValues = existingGridValues.filter(function (v) {
                    return v !== selectedValue;
                });
            } else {
                updatedValues = existingGridValues;
                updatedValues.push(selectedValue);
            }
            filterModel[colId] = this.getUpdatedFilterModel(colId, updatedValues);
        } else {
            var updatedValues = [selectedValue];
            filterModel = ((_a = {}), (_a[colId] = this.getUpdatedFilterModel(colId, updatedValues)), _a);
        }
        this.gridApi.setFilterModel(filterModel);
    };
    ChartCrossFilterService.prototype.getUpdatedFilterModel = function (colId, updatedValues) {
        var columnFilterType = this.getColumnFilterType(colId);
        if (columnFilterType === 'agMultiColumnFilter') {
            return { filterType: 'multi', filterModels: [null, { filterType: 'set', values: updatedValues }] };
        }
        return { filterType: 'set', values: updatedValues };
    };
    ChartCrossFilterService.prototype.getCurrentGridValuesForCategory = function (colId) {
        var _this = this;
        var filteredValues = [];
        var column = this.getColumnById(colId);
        this.gridApi.forEachNodeAfterFilter(function (rowNode) {
            if (column && !rowNode.group) {
                var value = _this.valueService.getValue(column, rowNode) + '';
                if (!filteredValues.includes(value)) {
                    filteredValues.push(value);
                }
            }
        });
        return filteredValues;
    };
    ChartCrossFilterService.extractFilterColId = function (event) {
        return event.xKey || event.calloutLabelKey;
    };
    ChartCrossFilterService.prototype.isValidColumnFilter = function (colId) {
        if (colId.indexOf('-filtered-out')) {
            colId = colId.replace('-filtered-out', '');
        }
        var filterType = this.getColumnFilterType(colId);
        if (typeof filterType === 'boolean') {
            return filterType;
        }
        return _.includes(['agSetColumnFilter', 'agMultiColumnFilter'], filterType);
    };
    ChartCrossFilterService.prototype.getColumnFilterType = function (colId) {
        var gridColumn = this.getColumnById(colId);
        if (gridColumn) {
            var colDef = gridColumn.getColDef();
            return colDef.filter;
        }
    };
    ChartCrossFilterService.prototype.getColumnById = function (colId) {
        return this.columnModel.getGridColumn(colId);
    };
    var ChartCrossFilterService_1;
    __decorate$I([Autowired('gridApi')], ChartCrossFilterService.prototype, 'gridApi', void 0);
    __decorate$I([Autowired('columnModel')], ChartCrossFilterService.prototype, 'columnModel', void 0);
    __decorate$I([Autowired('valueService')], ChartCrossFilterService.prototype, 'valueService', void 0);
    ChartCrossFilterService = ChartCrossFilterService_1 = __decorate$I(
        [Bean('chartCrossFilterService')],
        ChartCrossFilterService,
    );
    return ChartCrossFilterService;
})(BeanStub);

var __extends$M =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$c =
    (undefined && undefined.__assign) ||
    function () {
        __assign$c =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$c.apply(this, arguments);
    };
var __decorate$H =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$c =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$7 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$3 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var RangeService = /** @class */ (function (_super) {
    __extends$M(RangeService, _super);
    function RangeService() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.cellRanges = [];
        _this.bodyScrollListener = _this.onBodyScroll.bind(_this);
        _this.dragging = false;
        _this.intersectionRange = false; // When dragging ends, the current range will be used to intersect all other ranges
        return _this;
    }
    RangeService.prototype.init = function () {
        var _this = this;
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, function () {
            return _this.onColumnsChanged();
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VISIBLE, this.onColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, this.onColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, function () {
            return _this.removeAllCellRanges();
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
            return _this.removeAllCellRanges();
        });
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, function () {
            return _this.removeAllCellRanges();
        });
        this.addManagedListener(
            this.eventService,
            Events.EVENT_COLUMN_GROUP_OPENED,
            this.refreshLastRangeStart.bind(this),
        );
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_MOVED, this.refreshLastRangeStart.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PINNED, this.refreshLastRangeStart.bind(this));
        this.ctrlsService.whenReady(function () {
            var gridBodyCtrl = _this.ctrlsService.getGridBodyCtrl();
            _this.autoScrollService = new AutoScrollService({
                scrollContainer: gridBodyCtrl.getBodyViewportElement(),
                scrollAxis: 'xy',
                getVerticalPosition: function () {
                    return gridBodyCtrl.getScrollFeature().getVScrollPosition().top;
                },
                setVerticalPosition: function (position) {
                    return gridBodyCtrl.getScrollFeature().setVerticalScrollPosition(position);
                },
                getHorizontalPosition: function () {
                    return gridBodyCtrl.getScrollFeature().getHScrollPosition().left;
                },
                setHorizontalPosition: function (position) {
                    return gridBodyCtrl.getScrollFeature().setHorizontalScrollPosition(position);
                },
                shouldSkipVerticalScroll: function () {
                    return !_this.gridOptionsService.isDomLayout('normal');
                },
                shouldSkipHorizontalScroll: function () {
                    return !gridBodyCtrl.getScrollFeature().isHorizontalScrollShowing();
                },
            });
        });
    };
    // Called for both columns loaded & column visibility events
    RangeService.prototype.onColumnsChanged = function () {
        var _this = this;
        // first move start column in last cell range (i.e. series chart range)
        this.refreshLastRangeStart();
        var allColumns = this.columnModel.getAllDisplayedColumns();
        // check that the columns in each range still exist and are visible
        this.cellRanges.forEach(function (cellRange) {
            var beforeCols = cellRange.columns;
            // remove hidden or removed cols from cell range
            cellRange.columns = cellRange.columns.filter(function (col) {
                return col.isVisible() && allColumns.indexOf(col) !== -1;
            });
            var colsInRangeChanged = !_.areEqual(beforeCols, cellRange.columns);
            if (colsInRangeChanged) {
                // notify users and other parts of grid (i.e. status panel) that range has changed
                _this.dispatchChangedEvent(false, true, cellRange.id);
            }
        });
        // Remove empty cell ranges
        var countBefore = this.cellRanges.length;
        this.cellRanges = this.cellRanges.filter(function (range) {
            return range.columns.length > 0;
        });
        if (countBefore > this.cellRanges.length) {
            this.dispatchChangedEvent(false, true);
        }
    };
    RangeService.prototype.refreshLastRangeStart = function () {
        var lastRange = _.last(this.cellRanges);
        if (!lastRange) {
            return;
        }
        this.refreshRangeStart(lastRange);
    };
    RangeService.prototype.isContiguousRange = function (cellRange) {
        var rangeColumns = cellRange.columns;
        if (!rangeColumns.length) {
            return false;
        }
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var allPositions = rangeColumns
            .map(function (c) {
                return allColumns.indexOf(c);
            })
            .sort(function (a, b) {
                return a - b;
            });
        return _.last(allPositions) - allPositions[0] + 1 === rangeColumns.length;
    };
    RangeService.prototype.getRangeStartRow = function (cellRange) {
        if (cellRange.startRow && cellRange.endRow) {
            return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow)
                ? cellRange.startRow
                : cellRange.endRow;
        }
        var rowPinned = this.pinnedRowModel.getPinnedTopRowCount() > 0 ? 'top' : null;
        return { rowIndex: 0, rowPinned: rowPinned };
    };
    RangeService.prototype.getRangeEndRow = function (cellRange) {
        if (cellRange.startRow && cellRange.endRow) {
            return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow)
                ? cellRange.endRow
                : cellRange.startRow;
        }
        var pinnedBottomRowCount = this.pinnedRowModel.getPinnedBottomRowCount();
        var pinnedBottom = pinnedBottomRowCount > 0;
        if (pinnedBottom) {
            return {
                rowIndex: pinnedBottomRowCount - 1,
                rowPinned: 'bottom',
            };
        }
        return {
            rowIndex: this.rowModel.getRowCount() - 1,
            rowPinned: null,
        };
    };
    RangeService.prototype.setRangeToCell = function (cell, appendRange) {
        if (appendRange === void 0) {
            appendRange = false;
        }
        if (!this.gridOptionsService.is('enableRangeSelection')) {
            return;
        }
        var columns = this.calculateColumnsBetween(cell.column, cell.column);
        if (!columns) {
            return;
        }
        var suppressMultiRangeSelections = this.gridOptionsService.is('suppressMultiRangeSelection');
        // if not appending, then clear previous range selections
        if (suppressMultiRangeSelections || !appendRange || _.missing(this.cellRanges)) {
            this.removeAllCellRanges(true);
        }
        var rowForCell = {
            rowIndex: cell.rowIndex,
            rowPinned: cell.rowPinned,
        };
        var cellRange = {
            startRow: rowForCell,
            endRow: rowForCell,
            columns: columns,
            startColumn: cell.column,
        };
        this.cellRanges.push(cellRange);
        this.setNewestRangeStartCell(cell);
        this.onDragStop();
        this.dispatchChangedEvent(true, true);
    };
    RangeService.prototype.extendLatestRangeToCell = function (cellPosition) {
        if (this.isEmpty() || !this.newestRangeStartCell) {
            return;
        }
        var cellRange = _.last(this.cellRanges);
        this.updateRangeEnd(cellRange, cellPosition);
    };
    RangeService.prototype.updateRangeEnd = function (cellRange, cellPosition, silent) {
        if (silent === void 0) {
            silent = false;
        }
        var endColumn = cellPosition.column;
        var colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
        if (!colsToAdd || this.isLastCellOfRange(cellRange, cellPosition)) {
            return;
        }
        cellRange.columns = colsToAdd;
        cellRange.endRow = { rowIndex: cellPosition.rowIndex, rowPinned: cellPosition.rowPinned };
        if (!silent) {
            this.dispatchChangedEvent(true, true, cellRange.id);
        }
    };
    RangeService.prototype.refreshRangeStart = function (cellRange) {
        var startColumn = cellRange.startColumn,
            columns = cellRange.columns;
        var moveColInCellRange = function (colToMove, moveToFront) {
            var otherCols = cellRange.columns.filter(function (col) {
                return col !== colToMove;
            });
            if (colToMove) {
                cellRange.startColumn = colToMove;
                cellRange.columns = moveToFront
                    ? __spreadArray$7([colToMove], __read$c(otherCols))
                    : __spreadArray$7(__spreadArray$7([], __read$c(otherCols)), [colToMove]);
            } else {
                cellRange.columns = otherCols;
            }
        };
        var _a = this.getRangeEdgeColumns(cellRange),
            left = _a.left,
            right = _a.right;
        var shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
        if (shouldMoveLeftCol) {
            moveColInCellRange(left, true);
            return;
        }
        var shouldMoveRightCol = startColumn === _.last(columns) && startColumn === right;
        if (shouldMoveRightCol) {
            moveColInCellRange(right, false);
            return;
        }
    };
    RangeService.prototype.getRangeEdgeColumns = function (cellRange) {
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var allIndices = cellRange.columns
            .map(function (c) {
                return allColumns.indexOf(c);
            })
            .filter(function (i) {
                return i > -1;
            })
            .sort(function (a, b) {
                return a - b;
            });
        return {
            left: allColumns[allIndices[0]],
            right: allColumns[_.last(allIndices)],
        };
    };
    // returns true if successful, false if not successful
    RangeService.prototype.extendLatestRangeInDirection = function (event) {
        if (this.isEmpty() || !this.newestRangeStartCell) {
            return;
        }
        var key = event.key;
        var ctrlKey = event.ctrlKey || event.metaKey;
        var lastRange = _.last(this.cellRanges);
        var startCell = this.newestRangeStartCell;
        var firstCol = lastRange.columns[0];
        var lastCol = _.last(lastRange.columns);
        // find the cell that is at the furthest away corner from the starting cell
        var endCellIndex = lastRange.endRow.rowIndex;
        var endCellFloating = lastRange.endRow.rowPinned;
        var endCellColumn = startCell.column === firstCol ? lastCol : firstCol;
        var endCell = { column: endCellColumn, rowIndex: endCellIndex, rowPinned: endCellFloating };
        var newEndCell = this.cellNavigationService.getNextCellToFocus(key, endCell, ctrlKey);
        // if user is at end of grid, so no cell to extend to, we return false
        if (!newEndCell) {
            return;
        }
        this.setCellRange({
            rowStartIndex: startCell.rowIndex,
            rowStartPinned: startCell.rowPinned,
            rowEndIndex: newEndCell.rowIndex,
            rowEndPinned: newEndCell.rowPinned,
            columnStart: startCell.column,
            columnEnd: newEndCell.column,
        });
        return newEndCell;
    };
    RangeService.prototype.setCellRange = function (params) {
        if (!this.gridOptionsService.is('enableRangeSelection')) {
            return;
        }
        this.removeAllCellRanges(true);
        this.addCellRange(params);
    };
    RangeService.prototype.setCellRanges = function (cellRanges) {
        var _this = this;
        if (_.shallowCompare(this.cellRanges, cellRanges)) {
            return;
        }
        this.removeAllCellRanges(true);
        cellRanges.forEach(function (newRange) {
            if (newRange.columns && newRange.startRow) {
                _this.setNewestRangeStartCell({
                    rowIndex: newRange.startRow.rowIndex,
                    rowPinned: newRange.startRow.rowPinned,
                    column: newRange.columns[0],
                });
            }
            _this.cellRanges.push(newRange);
        });
        this.dispatchChangedEvent(false, true);
    };
    RangeService.prototype.setNewestRangeStartCell = function (position) {
        this.newestRangeStartCell = position;
    };
    RangeService.prototype.clearCellRangeCellValues = function (params) {
        var _this = this;
        var cellRanges = params.cellRanges;
        var _a = params.cellEventSource,
            cellEventSource = _a === void 0 ? 'rangeService' : _a,
            dispatchWrapperEvents = params.dispatchWrapperEvents,
            _b = params.wrapperEventSource,
            wrapperEventSource = _b === void 0 ? 'deleteKey' : _b;
        if (dispatchWrapperEvents) {
            var startEvent = {
                type: Events.EVENT_RANGE_DELETE_START,
                source: wrapperEventSource,
            };
            this.eventService.dispatchEvent(startEvent);
        }
        if (!cellRanges) {
            cellRanges = this.cellRanges;
        }
        cellRanges.forEach(function (cellRange) {
            _this.forEachRowInRange(cellRange, function (rowPosition) {
                var rowNode = _this.rowPositionUtils.getRowNode(rowPosition);
                if (!rowNode) {
                    return;
                }
                for (var i = 0; i < cellRange.columns.length; i++) {
                    var column = _this.columnModel.getGridColumn(cellRange.columns[i]);
                    if (!column || !column.isCellEditable(rowNode)) {
                        return;
                    }
                    rowNode.setDataValue(column, null, cellEventSource);
                }
            });
        });
        if (dispatchWrapperEvents) {
            var endEvent = {
                type: Events.EVENT_RANGE_DELETE_END,
                source: wrapperEventSource,
            };
            this.eventService.dispatchEvent(endEvent);
        }
    };
    RangeService.prototype.createCellRangeFromCellRangeParams = function (params) {
        var _this = this;
        var columns;
        var startsOnTheRight = false;
        if (params.columns) {
            columns = params.columns
                .map(function (c) {
                    return _this.columnModel.getColumnWithValidation(c);
                })
                .filter(function (c) {
                    return c;
                });
        } else {
            var columnStart = this.columnModel.getColumnWithValidation(params.columnStart);
            var columnEnd = this.columnModel.getColumnWithValidation(params.columnEnd);
            if (!columnStart || !columnEnd) {
                return;
            }
            columns = this.calculateColumnsBetween(columnStart, columnEnd);
            if (columns && columns.length) {
                startsOnTheRight = columns[0] !== columnStart;
            }
        }
        if (!columns) {
            return;
        }
        var startRow =
            params.rowStartIndex != null
                ? {
                      rowIndex: params.rowStartIndex,
                      rowPinned: params.rowStartPinned || null,
                  }
                : undefined;
        var endRow =
            params.rowEndIndex != null
                ? {
                      rowIndex: params.rowEndIndex,
                      rowPinned: params.rowEndPinned || null,
                  }
                : undefined;
        return {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: startsOnTheRight ? _.last(columns) : columns[0],
        };
    };
    RangeService.prototype.addCellRange = function (params) {
        if (!this.gridOptionsService.is('enableRangeSelection')) {
            return;
        }
        var newRange = this.createCellRangeFromCellRangeParams(params);
        if (newRange) {
            if (newRange.startRow) {
                this.setNewestRangeStartCell({
                    rowIndex: newRange.startRow.rowIndex,
                    rowPinned: newRange.startRow.rowPinned,
                    column: newRange.startColumn,
                });
            }
            this.cellRanges.push(newRange);
            this.dispatchChangedEvent(false, true, newRange.id);
        }
    };
    RangeService.prototype.getCellRanges = function () {
        return this.cellRanges;
    };
    RangeService.prototype.isEmpty = function () {
        return this.cellRanges.length === 0;
    };
    RangeService.prototype.isMoreThanOneCell = function () {
        var len = this.cellRanges.length;
        if (len === 0) {
            return false;
        }
        if (len > 1) {
            return true; // Assumes a cell range must contain at least one cell
        }
        // only one range, return true if range has more than one
        var range = this.cellRanges[0];
        var startRow = this.getRangeStartRow(range);
        var endRow = this.getRangeEndRow(range);
        return (
            startRow.rowPinned !== endRow.rowPinned ||
            startRow.rowIndex !== endRow.rowIndex ||
            range.columns.length !== 1
        );
    };
    RangeService.prototype.areAllRangesAbleToMerge = function () {
        var e_1, _a;
        var _this = this;
        var rowToColumnMap = new Map();
        var len = this.cellRanges.length;
        if (len <= 1) return true;
        this.cellRanges.forEach(function (range) {
            _this.forEachRowInRange(range, function (row) {
                var rowName = (row.rowPinned || 'normal') + '_' + row.rowIndex;
                var columns = rowToColumnMap.get(rowName);
                var currentRangeColIds = range.columns.map(function (col) {
                    return col.getId();
                });
                if (columns) {
                    var filteredColumns = currentRangeColIds.filter(function (col) {
                        return columns.indexOf(col) === -1;
                    });
                    columns.push.apply(columns, __spreadArray$7([], __read$c(filteredColumns)));
                } else {
                    rowToColumnMap.set(rowName, currentRangeColIds);
                }
            });
        });
        var columnsString;
        try {
            for (var _b = __values$3(rowToColumnMap.values()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var val = _c.value;
                var currentValString = val.sort().join();
                if (columnsString === undefined) {
                    columnsString = currentValString;
                    continue;
                }
                if (columnsString !== currentValString) {
                    return false;
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        return true;
    };
    RangeService.prototype.forEachRowInRange = function (cellRange, callback) {
        var topRow = this.getRangeStartRow(cellRange);
        var bottomRow = this.getRangeEndRow(cellRange);
        var currentRow = topRow;
        while (currentRow) {
            callback(currentRow);
            if (this.rowPositionUtils.sameRow(currentRow, bottomRow)) {
                break;
            }
            currentRow = this.cellNavigationService.getRowBelow(currentRow);
        }
    };
    RangeService.prototype.removeAllCellRanges = function (silent) {
        if (this.isEmpty()) {
            return;
        }
        this.onDragStop();
        this.cellRanges.length = 0;
        if (!silent) {
            this.dispatchChangedEvent(false, true);
        }
    };
    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
    // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
    // the selection my mimicking a new mouse event
    RangeService.prototype.onBodyScroll = function () {
        if (this.dragging && this.lastMouseEvent) {
            this.onDragging(this.lastMouseEvent);
        }
    };
    RangeService.prototype.isCellInAnyRange = function (cell) {
        return this.getCellRangeCount(cell) > 0;
    };
    RangeService.prototype.isCellInSpecificRange = function (cell, range) {
        var columnInRange = range.columns !== null && _.includes(range.columns, cell.column);
        var rowInRange = this.isRowInRange(cell.rowIndex, cell.rowPinned, range);
        return columnInRange && rowInRange;
    };
    RangeService.prototype.isLastCellOfRange = function (cellRange, cell) {
        var startRow = cellRange.startRow,
            endRow = cellRange.endRow;
        var lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
        var isLastRow = cell.rowIndex === lastRow.rowIndex && cell.rowPinned === lastRow.rowPinned;
        var rangeFirstIndexColumn = cellRange.columns[0];
        var rangeLastIndexColumn = _.last(cellRange.columns);
        var lastRangeColumn =
            cellRange.startColumn === rangeFirstIndexColumn ? rangeLastIndexColumn : rangeFirstIndexColumn;
        var isLastColumn = cell.column === lastRangeColumn;
        return isLastColumn && isLastRow;
    };
    RangeService.prototype.isBottomRightCell = function (cellRange, cell) {
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var allPositions = cellRange.columns
            .map(function (c) {
                return allColumns.indexOf(c);
            })
            .sort(function (a, b) {
                return a - b;
            });
        var startRow = cellRange.startRow,
            endRow = cellRange.endRow;
        var lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
        var isRightColumn = allColumns.indexOf(cell.column) === _.last(allPositions);
        var isLastRow =
            cell.rowIndex === lastRow.rowIndex && _.makeNull(cell.rowPinned) === _.makeNull(lastRow.rowPinned);
        return isRightColumn && isLastRow;
    };
    // returns the number of ranges this cell is in
    RangeService.prototype.getCellRangeCount = function (cell) {
        var _this = this;
        if (this.isEmpty()) {
            return 0;
        }
        return this.cellRanges.filter(function (cellRange) {
            return _this.isCellInSpecificRange(cell, cellRange);
        }).length;
    };
    RangeService.prototype.isRowInRange = function (rowIndex, floating, cellRange) {
        var firstRow = this.getRangeStartRow(cellRange);
        var lastRow = this.getRangeEndRow(cellRange);
        var thisRow = { rowIndex: rowIndex, rowPinned: floating || null };
        // compare rowPinned with == instead of === because it can be `null` or `undefined`
        var equalsFirstRow = thisRow.rowIndex === firstRow.rowIndex && thisRow.rowPinned == firstRow.rowPinned;
        var equalsLastRow = thisRow.rowIndex === lastRow.rowIndex && thisRow.rowPinned == lastRow.rowPinned;
        if (equalsFirstRow || equalsLastRow) {
            return true;
        }
        var afterFirstRow = !this.rowPositionUtils.before(thisRow, firstRow);
        var beforeLastRow = this.rowPositionUtils.before(thisRow, lastRow);
        return afterFirstRow && beforeLastRow;
    };
    RangeService.prototype.getDraggingRange = function () {
        return this.draggingRange;
    };
    RangeService.prototype.onDragStart = function (mouseEvent) {
        if (!this.gridOptionsService.is('enableRangeSelection')) {
            return;
        }
        var ctrlKey = mouseEvent.ctrlKey,
            metaKey = mouseEvent.metaKey,
            shiftKey = mouseEvent.shiftKey;
        // ctrlKey for windows, metaKey for Apple
        var isMultiKey = ctrlKey || metaKey;
        var allowMulti = !this.gridOptionsService.is('suppressMultiRangeSelection');
        var isMultiSelect = allowMulti ? isMultiKey : false;
        var extendRange = shiftKey && _.existsAndNotEmpty(this.cellRanges);
        if (!isMultiSelect && (!extendRange || _.exists(_.last(this.cellRanges).type))) {
            this.removeAllCellRanges(true);
        }
        // The browser changes the Event target of cached events when working with the ShadowDOM
        // so we need to retrieve the initial DragStartTarget.
        var startTarget = this.dragService.getStartTarget();
        if (startTarget) {
            this.updateValuesOnMove(startTarget);
        }
        if (!this.lastCellHovered) {
            return;
        }
        this.dragging = true;
        this.lastMouseEvent = mouseEvent;
        this.intersectionRange = isMultiSelect && this.getCellRangeCount(this.lastCellHovered) > 1;
        if (!extendRange) {
            this.setNewestRangeStartCell(this.lastCellHovered);
        }
        // if we didn't clear the ranges, then dragging means the user clicked, and when the
        // user clicks it means a range of one cell was created. we need to extend this range
        // rather than creating another range. otherwise we end up with two distinct ranges
        // from a drag operation (one from click, and one from drag).
        if (this.cellRanges.length > 0) {
            this.draggingRange = _.last(this.cellRanges);
        } else {
            var mouseRowPosition = {
                rowIndex: this.lastCellHovered.rowIndex,
                rowPinned: this.lastCellHovered.rowPinned,
            };
            this.draggingRange = {
                startRow: mouseRowPosition,
                endRow: mouseRowPosition,
                columns: [this.lastCellHovered.column],
                startColumn: this.newestRangeStartCell.column,
            };
            this.cellRanges.push(this.draggingRange);
        }
        this.ctrlsService.getGridBodyCtrl().addScrollEventListener(this.bodyScrollListener);
        this.dispatchChangedEvent(true, false, this.draggingRange.id);
    };
    RangeService.prototype.intersectLastRange = function (fromMouseClick) {
        var _this = this;
        // when ranges are created due to a mouse click without drag (happens in cellMouseListener)
        // this method will be called with `fromMouseClick=true`.
        if (fromMouseClick && this.dragging) {
            return;
        }
        if (this.gridOptionsService.is('suppressMultiRangeSelection')) {
            return;
        }
        if (this.isEmpty()) {
            return;
        }
        var lastRange = _.last(this.cellRanges);
        var intersectionStartRow = this.getRangeStartRow(lastRange);
        var intersectionEndRow = this.getRangeEndRow(lastRange);
        var newRanges = [];
        this.cellRanges.slice(0, -1).forEach(function (range) {
            var startRow = _this.getRangeStartRow(range);
            var endRow = _this.getRangeEndRow(range);
            var cols = range.columns;
            var intersectCols = cols.filter(function (col) {
                return lastRange.columns.indexOf(col) === -1;
            });
            if (intersectCols.length === cols.length) {
                // No overlapping columns, retain previous range
                newRanges.push(range);
                return;
            }
            if (
                _this.rowPositionUtils.before(intersectionEndRow, startRow) ||
                _this.rowPositionUtils.before(endRow, intersectionStartRow)
            ) {
                // No overlapping rows, retain previous range
                newRanges.push(range);
                return;
            }
            var rangeCountBefore = newRanges.length;
            // Top
            if (_this.rowPositionUtils.before(startRow, intersectionStartRow)) {
                var top_1 = {
                    columns: __spreadArray$7([], __read$c(cols)),
                    startColumn: lastRange.startColumn,
                    startRow: __assign$c({}, startRow),
                    endRow: _this.cellNavigationService.getRowAbove(intersectionStartRow),
                };
                newRanges.push(top_1);
            }
            // Left & Right (not contiguous with columns)
            if (intersectCols.length > 0) {
                var middle = {
                    columns: intersectCols,
                    startColumn: _.includes(intersectCols, lastRange.startColumn)
                        ? lastRange.startColumn
                        : intersectCols[0],
                    startRow: _this.rowPositionUtils.rowMax([
                        __assign$c({}, intersectionStartRow),
                        __assign$c({}, startRow),
                    ]),
                    endRow: _this.rowPositionUtils.rowMin([__assign$c({}, intersectionEndRow), __assign$c({}, endRow)]),
                };
                newRanges.push(middle);
            }
            // Bottom
            if (_this.rowPositionUtils.before(intersectionEndRow, endRow)) {
                newRanges.push({
                    columns: __spreadArray$7([], __read$c(cols)),
                    startColumn: lastRange.startColumn,
                    startRow: _this.cellNavigationService.getRowBelow(intersectionEndRow),
                    endRow: __assign$c({}, endRow),
                });
            }
            if (newRanges.length - rangeCountBefore === 1) {
                // Only one range result from the intersection.
                // Copy the source range's id, since essentially we just reduced it's size
                newRanges[newRanges.length - 1].id = range.id;
            }
        });
        this.cellRanges = newRanges;
        // when this is called because of a clickEvent and the ranges were changed
        // we need to force a dragEnd event to update the UI.
        if (fromMouseClick) {
            this.dispatchChangedEvent(false, true);
        }
    };
    RangeService.prototype.updateValuesOnMove = function (eventTarget) {
        var cellCtrl = _.getCtrlForEventTarget(this.gridOptionsService, eventTarget, CellCtrl.DOM_DATA_KEY_CELL_CTRL);
        var cell = cellCtrl === null || cellCtrl === void 0 ? void 0 : cellCtrl.getCellPosition();
        this.cellHasChanged = false;
        if (!cell || (this.lastCellHovered && this.cellPositionUtils.equals(cell, this.lastCellHovered))) {
            return;
        }
        if (this.lastCellHovered) {
            this.cellHasChanged = true;
        }
        this.lastCellHovered = cell;
    };
    RangeService.prototype.onDragging = function (mouseEvent) {
        var _this = this;
        if (!this.dragging || !mouseEvent) {
            return;
        }
        this.updateValuesOnMove(mouseEvent.target);
        this.lastMouseEvent = mouseEvent;
        var cellPosition = this.lastCellHovered;
        var isMouseAndStartInPinned = function (position) {
            return (
                cellPosition && cellPosition.rowPinned === position && _this.newestRangeStartCell.rowPinned === position
            );
        };
        var skipVerticalScroll = isMouseAndStartInPinned('top') || isMouseAndStartInPinned('bottom');
        this.autoScrollService.check(mouseEvent, skipVerticalScroll);
        if (!this.cellHasChanged) {
            return;
        }
        var columns = this.calculateColumnsBetween(this.newestRangeStartCell.column, cellPosition.column);
        if (!columns) {
            return;
        }
        this.draggingRange.endRow = {
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
        };
        this.draggingRange.columns = columns;
        this.dispatchChangedEvent(false, false, this.draggingRange.id);
    };
    RangeService.prototype.onDragStop = function () {
        if (!this.dragging) {
            return;
        }
        var id = this.draggingRange.id;
        this.autoScrollService.ensureCleared();
        this.ctrlsService.getGridBodyCtrl().removeScrollEventListener(this.bodyScrollListener);
        this.lastMouseEvent = null;
        this.dragging = false;
        this.draggingRange = undefined;
        this.lastCellHovered = undefined;
        if (this.intersectionRange) {
            this.intersectionRange = false;
            this.intersectLastRange();
        }
        this.dispatchChangedEvent(false, true, id);
    };
    RangeService.prototype.dispatchChangedEvent = function (started, finished, id) {
        var event = {
            type: Events.EVENT_RANGE_SELECTION_CHANGED,
            started: started,
            finished: finished,
            id: id,
        };
        this.eventService.dispatchEvent(event);
    };
    RangeService.prototype.calculateColumnsBetween = function (columnFrom, columnTo) {
        var allColumns = this.columnModel.getAllDisplayedColumns();
        var isSameColumn = columnFrom === columnTo;
        var fromIndex = allColumns.indexOf(columnFrom);
        if (fromIndex < 0) {
            console.warn('AG Grid: column ' + columnFrom.getId() + ' is not visible');
            return;
        }
        var toIndex = isSameColumn ? fromIndex : allColumns.indexOf(columnTo);
        if (toIndex < 0) {
            console.warn('AG Grid: column ' + columnTo.getId() + ' is not visible');
            return;
        }
        if (isSameColumn) {
            return [columnFrom];
        }
        var firstIndex = Math.min(fromIndex, toIndex);
        var lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
        var columns = [];
        for (var i = firstIndex; i <= lastIndex; i++) {
            columns.push(allColumns[i]);
        }
        return columns;
    };
    __decorate$H([Autowired('rowModel')], RangeService.prototype, 'rowModel', void 0);
    __decorate$H([Autowired('dragService')], RangeService.prototype, 'dragService', void 0);
    __decorate$H([Autowired('columnModel')], RangeService.prototype, 'columnModel', void 0);
    __decorate$H([Autowired('cellNavigationService')], RangeService.prototype, 'cellNavigationService', void 0);
    __decorate$H([Autowired('pinnedRowModel')], RangeService.prototype, 'pinnedRowModel', void 0);
    __decorate$H([Autowired('rowPositionUtils')], RangeService.prototype, 'rowPositionUtils', void 0);
    __decorate$H([Autowired('cellPositionUtils')], RangeService.prototype, 'cellPositionUtils', void 0);
    __decorate$H([Autowired('ctrlsService')], RangeService.prototype, 'ctrlsService', void 0);
    __decorate$H([PostConstruct], RangeService.prototype, 'init', null);
    RangeService = __decorate$H([Bean('rangeService')], RangeService);
    return RangeService;
})(BeanStub);

var __extends$L =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$G =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AbstractSelectionHandle = /** @class */ (function (_super) {
    __extends$L(AbstractSelectionHandle, _super);
    function AbstractSelectionHandle() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.changedCalculatedValues = false;
        _this.dragging = false;
        _this.shouldDestroyOnEndDragging = false;
        return _this;
    }
    AbstractSelectionHandle.prototype.init = function () {
        var _this = this;
        this.dragService.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragStart: this.onDragStart.bind(this),
            onDragging: function (e) {
                _this.dragging = true;
                _this.rangeService.autoScrollService.check(e);
                if (_this.changedCalculatedValues) {
                    _this.onDrag(e);
                    _this.changedCalculatedValues = false;
                }
            },
            onDragStop: function (e) {
                _this.dragging = false;
                _this.onDragEnd(e);
                _this.clearValues();
                _this.rangeService.autoScrollService.ensureCleared();
                // TODO: this causes a bug where if there are multiple grids in the same page, all of them will
                // be affected by a drag on any. Move it to the root element.
                document.body.classList.remove(_this.getDraggingCssClass());
                if (_this.shouldDestroyOnEndDragging) {
                    _this.destroy();
                }
            },
        });
        this.addManagedListener(this.getGui(), 'mousedown', this.preventRangeExtension.bind(this));
    };
    AbstractSelectionHandle.prototype.isDragging = function () {
        return this.dragging;
    };
    AbstractSelectionHandle.prototype.getCellCtrl = function () {
        return this.cellCtrl;
    };
    AbstractSelectionHandle.prototype.setCellCtrl = function (cellComp) {
        this.cellCtrl = cellComp;
    };
    AbstractSelectionHandle.prototype.getCellRange = function () {
        return this.cellRange;
    };
    AbstractSelectionHandle.prototype.setCellRange = function (range) {
        this.cellRange = range;
    };
    AbstractSelectionHandle.prototype.getRangeStartRow = function () {
        return this.rangeStartRow;
    };
    AbstractSelectionHandle.prototype.setRangeStartRow = function (row) {
        this.rangeStartRow = row;
    };
    AbstractSelectionHandle.prototype.getRangeEndRow = function () {
        return this.rangeEndRow;
    };
    AbstractSelectionHandle.prototype.setRangeEndRow = function (row) {
        this.rangeEndRow = row;
    };
    AbstractSelectionHandle.prototype.getLastCellHovered = function () {
        return this.lastCellHovered;
    };
    AbstractSelectionHandle.prototype.preventRangeExtension = function (e) {
        e.stopPropagation();
    };
    AbstractSelectionHandle.prototype.onDragStart = function (e) {
        this.cellHoverListener = this.addManagedListener(
            this.ctrlsService.getGridCtrl().getGui(),
            'mousemove',
            this.updateValuesOnMove.bind(this),
        );
        document.body.classList.add(this.getDraggingCssClass());
    };
    AbstractSelectionHandle.prototype.getDraggingCssClass = function () {
        return 'ag-dragging-' + (this.type === SelectionHandleType.FILL ? 'fill' : 'range') + '-handle';
    };
    AbstractSelectionHandle.prototype.updateValuesOnMove = function (e) {
        var cell = this.mouseEventService.getCellPositionForEvent(e);
        if (!cell || (this.lastCellHovered && this.cellPositionUtils.equals(cell, this.lastCellHovered))) {
            return;
        }
        this.lastCellHovered = cell;
        this.changedCalculatedValues = true;
    };
    AbstractSelectionHandle.prototype.getType = function () {
        return this.type;
    };
    AbstractSelectionHandle.prototype.refresh = function (cellCtrl) {
        var oldCellComp = this.getCellCtrl();
        var eGui = this.getGui();
        var cellRange = _.last(this.rangeService.getCellRanges());
        var start = cellRange.startRow;
        var end = cellRange.endRow;
        if (start && end) {
            var isBefore = this.rowPositionUtils.before(end, start);
            if (isBefore) {
                this.setRangeStartRow(end);
                this.setRangeEndRow(start);
            } else {
                this.setRangeStartRow(start);
                this.setRangeEndRow(end);
            }
        }
        if (oldCellComp !== cellCtrl || !_.isVisible(eGui)) {
            this.setCellCtrl(cellCtrl);
            var eParentOfValue = cellCtrl.getComp().getParentOfValue();
            if (eParentOfValue) {
                eParentOfValue.appendChild(eGui);
            }
        }
        this.setCellRange(cellRange);
    };
    AbstractSelectionHandle.prototype.clearValues = function () {
        this.lastCellHovered = undefined;
        this.removeListeners();
    };
    AbstractSelectionHandle.prototype.removeListeners = function () {
        if (this.cellHoverListener) {
            this.cellHoverListener();
            this.cellHoverListener = undefined;
        }
    };
    AbstractSelectionHandle.prototype.destroy = function () {
        if (!this.shouldDestroyOnEndDragging && this.isDragging()) {
            _.setDisplayed(this.getGui(), false);
            this.shouldDestroyOnEndDragging = true;
            return;
        }
        this.shouldDestroyOnEndDragging = false;
        _super.prototype.destroy.call(this);
        this.removeListeners();
        var eGui = this.getGui();
        if (eGui.parentElement) {
            eGui.parentElement.removeChild(eGui);
        }
    };
    __decorate$G([Autowired('rowRenderer')], AbstractSelectionHandle.prototype, 'rowRenderer', void 0);
    __decorate$G([Autowired('dragService')], AbstractSelectionHandle.prototype, 'dragService', void 0);
    __decorate$G([Autowired('rangeService')], AbstractSelectionHandle.prototype, 'rangeService', void 0);
    __decorate$G([Autowired('mouseEventService')], AbstractSelectionHandle.prototype, 'mouseEventService', void 0);
    __decorate$G([Autowired('columnModel')], AbstractSelectionHandle.prototype, 'columnModel', void 0);
    __decorate$G(
        [Autowired('cellNavigationService')],
        AbstractSelectionHandle.prototype,
        'cellNavigationService',
        void 0,
    );
    __decorate$G([Autowired('navigationService')], AbstractSelectionHandle.prototype, 'navigationService', void 0);
    __decorate$G([Autowired('rowPositionUtils')], AbstractSelectionHandle.prototype, 'rowPositionUtils', void 0);
    __decorate$G([Autowired('cellPositionUtils')], AbstractSelectionHandle.prototype, 'cellPositionUtils', void 0);
    __decorate$G([Autowired('ctrlsService')], AbstractSelectionHandle.prototype, 'ctrlsService', void 0);
    __decorate$G([PostConstruct], AbstractSelectionHandle.prototype, 'init', null);
    return AbstractSelectionHandle;
})(Component);

function findLineByLeastSquares(values) {
    var len = values.length;
    var maxDecimals = 0;
    if (len <= 1) {
        return values;
    }
    for (var i = 0; i < values.length; i++) {
        var value = values[i];
        var splitExponent = value.toString().split('e-');
        if (splitExponent.length > 1) {
            maxDecimals = Math.max(maxDecimals, parseInt(splitExponent[1], 10));
            continue;
        }
        if (Math.floor(value) === value) {
            continue;
        }
        maxDecimals = Math.max(maxDecimals, value.toString().split('.')[1].length);
    }
    var sum_x = 0;
    var sum_y = 0;
    var sum_xy = 0;
    var sum_xx = 0;
    var y = 0;
    for (var x = 0; x < len; x++) {
        y = values[x];
        sum_x += x;
        sum_y += y;
        sum_xx += x * x;
        sum_xy += x * y;
    }
    var m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
    var b = sum_y / len - (m * sum_x) / len;
    var result = [];
    for (var x = 0; x <= len; x++) {
        result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
    }
    return result;
}

var __extends$K =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$b =
    (undefined && undefined.__assign) ||
    function () {
        __assign$b =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$b.apply(this, arguments);
    };
var __decorate$F =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$b =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$6 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var FillHandle = /** @class */ (function (_super) {
    __extends$K(FillHandle, _super);
    function FillHandle() {
        var _this = _super.call(this, FillHandle.TEMPLATE) || this;
        _this.markedCells = [];
        _this.cellValues = [];
        _this.isUp = false;
        _this.isLeft = false;
        _this.isReduce = false;
        _this.type = SelectionHandleType.FILL;
        return _this;
    }
    FillHandle.prototype.updateValuesOnMove = function (e) {
        _super.prototype.updateValuesOnMove.call(this, e);
        if (!this.initialXY) {
            this.initialXY = this.mouseEventService.getNormalisedPosition(e);
        }
        var _a = this.initialXY,
            x = _a.x,
            y = _a.y;
        var _b = this.mouseEventService.getNormalisedPosition(e),
            newX = _b.x,
            newY = _b.y;
        var diffX = Math.abs(x - newX);
        var diffY = Math.abs(y - newY);
        var allowedDirection = this.getFillHandleDirection();
        var direction;
        if (allowedDirection === 'xy') {
            direction = diffX > diffY ? 'x' : 'y';
        } else {
            direction = allowedDirection;
        }
        if (direction !== this.dragAxis) {
            this.dragAxis = direction;
            this.changedCalculatedValues = true;
        }
    };
    FillHandle.prototype.onDrag = function (e) {
        if (!this.initialPosition) {
            var cellCtrl = this.getCellCtrl();
            if (!cellCtrl) {
                return;
            }
            this.initialPosition = cellCtrl.getCellPosition();
        }
        var lastCellHovered = this.getLastCellHovered();
        if (lastCellHovered) {
            this.markPathFrom(this.initialPosition, lastCellHovered);
        }
    };
    FillHandle.prototype.onDragEnd = function (e) {
        this.initialXY = null;
        if (!this.markedCells.length) {
            return;
        }
        var isX = this.dragAxis === 'x';
        var initialRange = this.getCellRange();
        var colLen = initialRange.columns.length;
        var rangeStartRow = this.getRangeStartRow();
        var rangeEndRow = this.getRangeEndRow();
        var finalRange;
        if (!this.isUp && !this.isLeft) {
            finalRange = this.rangeService.createCellRangeFromCellRangeParams({
                rowStartIndex: rangeStartRow.rowIndex,
                rowStartPinned: rangeStartRow.rowPinned,
                columnStart: initialRange.columns[0],
                rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
                rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
                columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1],
            });
        } else {
            var startRow = isX ? rangeStartRow : this.lastCellMarked;
            finalRange = this.rangeService.createCellRangeFromCellRangeParams({
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
                rowEndIndex: rangeEndRow.rowIndex,
                rowEndPinned: rangeEndRow.rowPinned,
                columnEnd: initialRange.columns[colLen - 1],
            });
        }
        if (finalRange) {
            // raising fill events for undo / redo
            this.raiseFillStartEvent();
            this.handleValueChanged(initialRange, finalRange, e);
            this.rangeService.setCellRanges([finalRange]);
            this.raiseFillEndEvent(initialRange, finalRange);
        }
    };
    FillHandle.prototype.getFillHandleDirection = function () {
        var direction = this.gridOptionsService.get('fillHandleDirection');
        if (!direction) {
            return 'xy';
        }
        if (direction !== 'x' && direction !== 'y' && direction !== 'xy') {
            _.doOnce(function () {
                return console.warn(
                    "AG Grid: valid values for fillHandleDirection are 'x', 'y' and 'xy'. Default to 'xy'.",
                );
            }, 'warn invalid fill direction');
            return 'xy';
        }
        return direction;
    };
    FillHandle.prototype.raiseFillStartEvent = function () {
        var fillStartEvent = {
            type: Events.EVENT_FILL_START,
        };
        this.eventService.dispatchEvent(fillStartEvent);
    };
    FillHandle.prototype.raiseFillEndEvent = function (initialRange, finalRange) {
        var fillEndEvent = {
            type: Events.EVENT_FILL_END,
            initialRange: initialRange,
            finalRange: finalRange,
        };
        this.eventService.dispatchEvent(fillEndEvent);
    };
    FillHandle.prototype.handleValueChanged = function (initialRange, finalRange, e) {
        var _this = this;
        var initialRangeEndRow = this.rangeService.getRangeEndRow(initialRange);
        var initialRangeStartRow = this.rangeService.getRangeStartRow(initialRange);
        var finalRangeEndRow = this.rangeService.getRangeEndRow(finalRange);
        var finalRangeStartRow = this.rangeService.getRangeStartRow(finalRange);
        var isVertical = this.dragAxis === 'y';
        // if the range is being reduced in size, all we need to do is
        // clear the cells that are no longer part of the range
        if (this.isReduce && !this.gridOptionsService.is('suppressClearOnFillReduction')) {
            var columns = isVertical
                ? initialRange.columns
                : initialRange.columns.filter(function (col) {
                      return finalRange.columns.indexOf(col) < 0;
                  });
            var startRow = isVertical ? this.cellNavigationService.getRowBelow(finalRangeEndRow) : finalRangeStartRow;
            if (startRow) {
                this.clearCellsInRange(startRow, initialRangeEndRow, columns);
            }
            return;
        }
        var withinInitialRange = true;
        var values = [];
        var initialValues = [];
        var idx = 0;
        var resetValues = function () {
            values.length = 0;
            initialValues.length = 0;
            idx = 0;
        };
        var iterateAcrossCells = function (column, columns) {
            var currentRow = _this.isUp ? initialRangeEndRow : initialRangeStartRow;
            var finished = false;
            if (isVertical) {
                withinInitialRange = true;
                resetValues();
            }
            var _loop_1 = function () {
                var rowNode = _this.rowPositionUtils.getRowNode(currentRow);
                if (!rowNode) {
                    return 'break';
                }
                if (isVertical && column) {
                    fillValues(values, column, rowNode, function () {
                        return !_this.rowPositionUtils.sameRow(
                            currentRow,
                            _this.isUp ? initialRangeStartRow : initialRangeEndRow,
                        );
                    });
                } else if (columns) {
                    withinInitialRange = true;
                    resetValues();
                    columns.forEach(function (col) {
                        return fillValues(values, col, rowNode, function () {
                            return col !== (_this.isLeft ? initialRange.columns[0] : _.last(initialRange.columns));
                        });
                    });
                }
                finished = _this.rowPositionUtils.sameRow(
                    currentRow,
                    _this.isUp ? finalRangeStartRow : finalRangeEndRow,
                );
                currentRow = _this.isUp
                    ? _this.cellNavigationService.getRowAbove(currentRow)
                    : _this.cellNavigationService.getRowBelow(currentRow);
            };
            while (!finished && currentRow) {
                var state_1 = _loop_1();
                if (state_1 === 'break') break;
            }
        };
        var fillValues = function (currentValues, col, rowNode, updateInitialSet) {
            var _a, _b;
            var currentValue;
            var skipValue = false;
            if (withinInitialRange) {
                currentValue = _this.valueService.getValue(col, rowNode);
                initialValues.push(currentValue);
                withinInitialRange = updateInitialSet();
            } else {
                var _c = _this.processValues(e, currentValues, initialValues, col, rowNode, idx++),
                    value = _c.value,
                    fromUserFunction = _c.fromUserFunction,
                    sourceCol = _c.sourceCol,
                    sourceRowNode = _c.sourceRowNode;
                currentValue = value;
                if (col.isCellEditable(rowNode)) {
                    var cellValue = _this.valueService.getValue(col, rowNode);
                    if (!fromUserFunction) {
                        if (
                            (_a = sourceCol === null || sourceCol === void 0 ? void 0 : sourceCol.getColDef()) ===
                                null || _a === void 0
                                ? void 0
                                : _a.useValueFormatterForExport
                        ) {
                            currentValue =
                                (_b = _this.valueFormatterService.formatValue(
                                    sourceCol,
                                    sourceRowNode,
                                    currentValue,
                                )) !== null && _b !== void 0
                                    ? _b
                                    : currentValue;
                        }
                        if (col.getColDef().useValueParserForImport) {
                            currentValue = _this.valueParserService.parseValue(
                                col,
                                rowNode,
                                // if no sourceCol, then currentValue is a number
                                sourceCol ? currentValue : _.toStringOrNull(currentValue),
                                cellValue,
                            );
                        }
                    }
                    if (!fromUserFunction || cellValue !== currentValue) {
                        rowNode.setDataValue(col, currentValue, 'rangeService');
                    } else {
                        skipValue = true;
                    }
                }
            }
            if (!skipValue) {
                currentValues.push({
                    value: currentValue,
                    column: col,
                    rowNode: rowNode,
                });
            }
        };
        if (isVertical) {
            initialRange.columns.forEach(function (col) {
                iterateAcrossCells(col);
            });
        } else {
            var columns = this.isLeft
                ? __spreadArray$6([], __read$b(finalRange.columns)).reverse()
                : finalRange.columns;
            iterateAcrossCells(undefined, columns);
        }
    };
    FillHandle.prototype.clearCellsInRange = function (startRow, endRow, columns) {
        var cellRange = {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: columns[0],
        };
        this.rangeService.clearCellRangeCellValues({ cellRanges: [cellRange] });
    };
    FillHandle.prototype.processValues = function (event, values, initialValues, col, rowNode, idx) {
        var userFillOperation = this.gridOptionsService.getCallback('fillOperation');
        var isVertical = this.dragAxis === 'y';
        var direction;
        if (isVertical) {
            direction = this.isUp ? 'up' : 'down';
        } else {
            direction = this.isLeft ? 'left' : 'right';
        }
        if (userFillOperation) {
            var params = {
                event: event,
                values: values.map(function (_a) {
                    var value = _a.value;
                    return value;
                }),
                initialValues: initialValues,
                currentIndex: idx,
                currentCellValue: this.valueService.getValue(col, rowNode),
                direction: direction,
                column: col,
                rowNode: rowNode,
            };
            var userResult = userFillOperation(params);
            if (userResult !== false) {
                return { value: userResult, fromUserFunction: true };
            }
        }
        var allNumbers = !values.some(function (_a) {
            var value = _a.value;
            var asFloat = parseFloat(value);
            return isNaN(asFloat) || asFloat.toString() !== value.toString();
        });
        // values should be copied in order if the alt key is pressed
        // or if the values contain strings and numbers
        // However, if we only have one initial value selected, and that
        // value is a number and we are also pressing alt, then we should
        // increment or decrement the value by 1 based on direction.
        if (event.altKey || !allNumbers) {
            if (allNumbers && initialValues.length === 1) {
                var multiplier = this.isUp || this.isLeft ? -1 : 1;
                return { value: parseFloat(_.last(values).value) + 1 * multiplier, fromUserFunction: false };
            }
            var _a = values[idx % values.length],
                value = _a.value,
                sourceCol = _a.column,
                sourceRowNode = _a.rowNode;
            return { value: value, fromUserFunction: false, sourceCol: sourceCol, sourceRowNode: sourceRowNode };
        }
        return {
            value: _.last(
                findLineByLeastSquares(
                    values.map(function (_a) {
                        var value = _a.value;
                        return Number(value);
                    }),
                ),
            ),
            fromUserFunction: false,
        };
    };
    FillHandle.prototype.clearValues = function () {
        this.clearMarkedPath();
        this.clearCellValues();
        this.lastCellMarked = undefined;
        _super.prototype.clearValues.call(this);
    };
    FillHandle.prototype.clearMarkedPath = function () {
        this.markedCells.forEach(function (cell) {
            if (!cell.isAlive()) {
                return;
            }
            var comp = cell.getComp();
            comp.addOrRemoveCssClass('ag-selection-fill-top', false);
            comp.addOrRemoveCssClass('ag-selection-fill-right', false);
            comp.addOrRemoveCssClass('ag-selection-fill-bottom', false);
            comp.addOrRemoveCssClass('ag-selection-fill-left', false);
        });
        this.markedCells.length = 0;
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
    };
    FillHandle.prototype.clearCellValues = function () {
        this.cellValues.length = 0;
    };
    FillHandle.prototype.markPathFrom = function (initialPosition, currentPosition) {
        this.clearMarkedPath();
        this.clearCellValues();
        if (this.dragAxis === 'y') {
            if (this.rowPositionUtils.sameRow(currentPosition, initialPosition)) {
                return;
            }
            var isBefore = this.rowPositionUtils.before(currentPosition, initialPosition);
            var rangeStartRow = this.getRangeStartRow();
            var rangeEndRow = this.getRangeEndRow();
            if (
                isBefore &&
                ((currentPosition.rowPinned == rangeStartRow.rowPinned &&
                    currentPosition.rowIndex >= rangeStartRow.rowIndex) ||
                    (rangeStartRow.rowPinned != rangeEndRow.rowPinned &&
                        currentPosition.rowPinned == rangeEndRow.rowPinned &&
                        currentPosition.rowIndex <= rangeEndRow.rowIndex))
            ) {
                this.reduceVertical(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendVertical(initialPosition, currentPosition, isBefore);
                this.isReduce = false;
            }
        } else {
            var initialColumn = initialPosition.column;
            var currentColumn = currentPosition.column;
            if (initialColumn === currentColumn) {
                return;
            }
            var displayedColumns = this.columnModel.getAllDisplayedColumns();
            var initialIndex = displayedColumns.indexOf(initialColumn);
            var currentIndex = displayedColumns.indexOf(currentColumn);
            if (
                currentIndex <= initialIndex &&
                currentIndex >= displayedColumns.indexOf(this.getCellRange().columns[0])
            ) {
                this.reduceHorizontal(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
                this.isReduce = false;
            }
        }
        this.lastCellMarked = currentPosition;
    };
    FillHandle.prototype.extendVertical = function (initialPosition, endPosition, isMovingUp) {
        var _a = this,
            navigationService = _a.navigationService,
            rangeService = _a.rangeService;
        var row = initialPosition;
        do {
            var cellRange = this.getCellRange();
            var colLen = cellRange.columns.length;
            for (var i = 0; i < colLen; i++) {
                var column = cellRange.columns[i];
                var rowPos = { rowIndex: row.rowIndex, rowPinned: row.rowPinned };
                var cellPos = __assign$b(__assign$b({}, rowPos), { column: column });
                var cellInRange = rangeService.isCellInSpecificRange(cellPos, cellRange);
                var isInitialRow = this.rowPositionUtils.sameRow(row, initialPosition);
                if (isMovingUp) {
                    this.isUp = true;
                }
                if (!isInitialRow) {
                    var cell = navigationService.getCellByPosition(cellPos);
                    if (cell) {
                        this.markedCells.push(cell);
                        var cellCtrl = cell.getComp();
                        if (!cellInRange) {
                            cellCtrl.addOrRemoveCssClass('ag-selection-fill-left', i === 0);
                            cellCtrl.addOrRemoveCssClass('ag-selection-fill-right', i === colLen - 1);
                        }
                        cellCtrl.addOrRemoveCssClass(
                            isMovingUp ? 'ag-selection-fill-top' : 'ag-selection-fill-bottom',
                            this.rowPositionUtils.sameRow(row, endPosition),
                        );
                    }
                }
            }
            if (this.rowPositionUtils.sameRow(row, endPosition)) {
                break;
            }
        } while (
            // tslint:disable-next-line
            (row = isMovingUp
                ? this.cellNavigationService.getRowAbove(row)
                : this.cellNavigationService.getRowBelow(row))
        );
    };
    FillHandle.prototype.reduceVertical = function (initialPosition, endPosition) {
        var row = initialPosition;
        do {
            var cellRange = this.getCellRange();
            var colLen = cellRange.columns.length;
            var isLastRow = this.rowPositionUtils.sameRow(row, endPosition);
            for (var i = 0; i < colLen; i++) {
                var rowPos = { rowIndex: row.rowIndex, rowPinned: row.rowPinned };
                var celPos = __assign$b(__assign$b({}, rowPos), { column: cellRange.columns[i] });
                var cell = this.navigationService.getCellByPosition(celPos);
                if (cell) {
                    this.markedCells.push(cell);
                    var cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass(
                        'ag-selection-fill-bottom',
                        this.rowPositionUtils.sameRow(row, endPosition),
                    );
                }
            }
            if (isLastRow) {
                break;
            }
            // tslint:disable-next-line
        } while ((row = this.cellNavigationService.getRowAbove(row)));
    };
    FillHandle.prototype.extendHorizontal = function (initialPosition, endPosition, isMovingLeft) {
        var _this = this;
        var allCols = this.columnModel.getAllDisplayedColumns();
        var startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
        var endCol = allCols.indexOf(isMovingLeft ? this.getCellRange().columns[0] : endPosition.column);
        var offset = isMovingLeft ? 0 : 1;
        var colsToMark = allCols.slice(startCol + offset, endCol + offset);
        var rangeStartRow = this.getRangeStartRow();
        var rangeEndRow = this.getRangeEndRow();
        colsToMark.forEach(function (column) {
            var row = rangeStartRow;
            var isLastRow = false;
            do {
                isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
                var cell = _this.navigationService.getCellByPosition({
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column,
                });
                if (cell) {
                    _this.markedCells.push(cell);
                    var cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass(
                        'ag-selection-fill-top',
                        _this.rowPositionUtils.sameRow(row, rangeStartRow),
                    );
                    cellComp.addOrRemoveCssClass(
                        'ag-selection-fill-bottom',
                        _this.rowPositionUtils.sameRow(row, rangeEndRow),
                    );
                    if (isMovingLeft) {
                        _this.isLeft = true;
                        cellComp.addOrRemoveCssClass('ag-selection-fill-left', column === colsToMark[0]);
                    } else {
                        cellComp.addOrRemoveCssClass('ag-selection-fill-right', column === _.last(colsToMark));
                    }
                }
                row = _this.cellNavigationService.getRowBelow(row);
            } while (!isLastRow);
        });
    };
    FillHandle.prototype.reduceHorizontal = function (initialPosition, endPosition) {
        var _this = this;
        var allCols = this.columnModel.getAllDisplayedColumns();
        var startCol = allCols.indexOf(endPosition.column);
        var endCol = allCols.indexOf(initialPosition.column);
        var colsToMark = allCols.slice(startCol, endCol);
        var rangeStartRow = this.getRangeStartRow();
        var rangeEndRow = this.getRangeEndRow();
        colsToMark.forEach(function (column) {
            var row = rangeStartRow;
            var isLastRow = false;
            do {
                isLastRow = _this.rowPositionUtils.sameRow(row, rangeEndRow);
                var cell = _this.navigationService.getCellByPosition({
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column,
                });
                if (cell) {
                    _this.markedCells.push(cell);
                    var cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass('ag-selection-fill-right', column === colsToMark[0]);
                }
                row = _this.cellNavigationService.getRowBelow(row);
            } while (!isLastRow);
        });
    };
    FillHandle.prototype.refresh = function (cellCtrl) {
        var cellRange = this.rangeService.getCellRanges()[0];
        var isColumnRange = !cellRange.startRow || !cellRange.endRow;
        if (isColumnRange) {
            this.destroy();
            return;
        }
        _super.prototype.refresh.call(this, cellCtrl);
    };
    FillHandle.TEMPLATE = '<div class="ag-fill-handle"></div>';
    __decorate$F([Autowired('valueService')], FillHandle.prototype, 'valueService', void 0);
    __decorate$F([Autowired('valueParserService')], FillHandle.prototype, 'valueParserService', void 0);
    __decorate$F([Autowired('valueFormatterService')], FillHandle.prototype, 'valueFormatterService', void 0);
    return FillHandle;
})(AbstractSelectionHandle);

var __extends$J =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$a =
    (undefined && undefined.__assign) ||
    function () {
        __assign$a =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$a.apply(this, arguments);
    };
var RangeHandle = /** @class */ (function (_super) {
    __extends$J(RangeHandle, _super);
    function RangeHandle() {
        var _this = _super.call(this, RangeHandle.TEMPLATE) || this;
        _this.type = SelectionHandleType.RANGE;
        _this.rangeFixed = false;
        return _this;
    }
    RangeHandle.prototype.onDrag = function (e) {
        var lastCellHovered = this.getLastCellHovered();
        if (!lastCellHovered) {
            return;
        }
        var cellRanges = this.rangeService.getCellRanges();
        var lastRange = _.last(cellRanges);
        if (!this.rangeFixed) {
            this.fixRangeStartEnd(lastRange);
            this.rangeFixed = true;
        }
        this.endPosition = {
            rowIndex: lastCellHovered.rowIndex,
            rowPinned: lastCellHovered.rowPinned,
            column: lastCellHovered.column,
        };
        // check if the cell ranges are for a chart
        if (
            cellRanges.length === 2 &&
            cellRanges[0].type === CellRangeType.DIMENSION &&
            lastRange.type === CellRangeType.VALUE
        ) {
            var rowChanged = !this.rowPositionUtils.sameRow(
                this.endPosition,
                this.rangeService.getRangeEndRow(lastRange),
            );
            if (rowChanged) {
                // ensure the dimension range is kept in sync with the value range (which has the handle)
                this.rangeService.updateRangeEnd(
                    cellRanges[0],
                    __assign$a(__assign$a({}, this.endPosition), { column: cellRanges[0].columns[0] }),
                    true,
                );
            }
        }
        this.rangeService.extendLatestRangeToCell(this.endPosition);
    };
    RangeHandle.prototype.onDragEnd = function (e) {
        var cellRange = _.last(this.rangeService.getCellRanges());
        this.fixRangeStartEnd(cellRange);
        this.rangeFixed = false;
    };
    RangeHandle.prototype.fixRangeStartEnd = function (cellRange) {
        var startRow = this.rangeService.getRangeStartRow(cellRange);
        var endRow = this.rangeService.getRangeEndRow(cellRange);
        var column = cellRange.columns[0];
        cellRange.startRow = startRow;
        cellRange.endRow = endRow;
        cellRange.startColumn = column;
    };
    RangeHandle.TEMPLATE = '<div class="ag-range-handle"></div>';
    return RangeHandle;
})(AbstractSelectionHandle);

var __extends$I =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$E =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SelectionHandleFactory = /** @class */ (function (_super) {
    __extends$I(SelectionHandleFactory, _super);
    function SelectionHandleFactory() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SelectionHandleFactory.prototype.createSelectionHandle = function (type) {
        return this.createBean(type === SelectionHandleType.RANGE ? new RangeHandle() : new FillHandle());
    };
    SelectionHandleFactory = __decorate$E([Bean('selectionHandleFactory')], SelectionHandleFactory);
    return SelectionHandleFactory;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$9 = '30.2.0';

var RangeSelectionModule = {
    version: VERSION$9,
    moduleName: ModuleNames.RangeSelectionModule,
    beans: [RangeService, SelectionHandleFactory],
    agStackComponents: [
        { componentName: 'AgFillHandle', componentClass: FillHandle },
        { componentName: 'AgRangeHandle', componentClass: RangeHandle },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$H =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$D =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$a =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var AgColorPanel = /** @class */ (function (_super) {
    __extends$H(AgColorPanel, _super);
    function AgColorPanel(config) {
        var _this = _super.call(this, AgColorPanel.TEMPLATE) || this;
        _this.H = 1; // in the [0, 1] range
        _this.S = 1; // in the [0, 1] range
        _this.B = 1; // in the [0, 1] range
        _this.A = 1; // in the [0, 1] range
        _this.isSpectrumDragging = false;
        _this.isSpectrumHueDragging = false;
        _this.isSpectrumAlphaDragging = false;
        _this.colorChanged = false;
        _this.picker = config.picker;
        return _this;
    }
    AgColorPanel.prototype.postConstruct = function () {
        var _this = this;
        this.initTabIndex();
        this.initRecentColors();
        this.addGuiEventListener('focus', function () {
            return _this.spectrumColor.focus();
        });
        this.addGuiEventListener('keydown', function (e) {
            if (e.key === KeyCode.ENTER && !e.defaultPrevented) {
                _this.destroy();
            }
        });
        this.addManagedListener(this.spectrumColor, 'keydown', function (e) {
            return _this.moveDragger(e);
        });
        this.addManagedListener(this.spectrumAlphaSlider, 'keydown', function (e) {
            return _this.moveAlphaSlider(e);
        });
        this.addManagedListener(this.spectrumHueSlider, 'keydown', function (e) {
            return _this.moveHueSlider(e);
        });
        this.addManagedListener(this.spectrumVal, 'mousedown', this.onSpectrumDraggerDown.bind(this));
        this.addManagedListener(this.spectrumHue, 'mousedown', this.onSpectrumHueDown.bind(this));
        this.addManagedListener(this.spectrumAlpha, 'mousedown', this.onSpectrumAlphaDown.bind(this));
        this.addGuiEventListener('mousemove', function (e) {
            _this.onSpectrumDraggerMove(e);
            _this.onSpectrumHueMove(e);
            _this.onSpectrumAlphaMove(e);
        });
        // Listening to `mouseup` on the document on purpose. The user might release the mouse button
        // outside the UI control. When the mouse returns back to the control's area, the dragging
        // of the thumb is not expected and seen as a bug.
        this.addManagedListener(document, 'mouseup', this.onMouseUp.bind(this));
        this.addManagedListener(this.recentColors, 'click', this.onRecentColorClick.bind(this));
        this.addManagedListener(this.recentColors, 'keydown', function (e) {
            if (e.key === KeyCode.ENTER || e.key === KeyCode.SPACE) {
                e.preventDefault();
                _this.onRecentColorClick(e);
            }
        });
    };
    AgColorPanel.prototype.initTabIndex = function () {
        var tabIndex = (this.tabIndex = (this.gridOptionsService.getNum('tabIndex') || 0).toString());
        this.spectrumColor.setAttribute('tabindex', tabIndex);
        this.spectrumHueSlider.setAttribute('tabindex', tabIndex);
        this.spectrumAlphaSlider.setAttribute('tabindex', tabIndex);
    };
    AgColorPanel.prototype.refreshSpectrumRect = function () {
        return (this.spectrumValRect = this.spectrumVal.getBoundingClientRect());
    };
    AgColorPanel.prototype.refreshHueRect = function () {
        return (this.spectrumHueRect = this.spectrumHue.getBoundingClientRect());
    };
    AgColorPanel.prototype.refreshAlphaRect = function () {
        return (this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect());
    };
    AgColorPanel.prototype.onSpectrumDraggerDown = function (e) {
        this.refreshSpectrumRect();
        this.isSpectrumDragging = true;
        this.moveDragger(e);
    };
    AgColorPanel.prototype.onSpectrumDraggerMove = function (e) {
        if (this.isSpectrumDragging) {
            this.moveDragger(e);
        }
    };
    AgColorPanel.prototype.onSpectrumHueDown = function (e) {
        this.refreshHueRect();
        this.isSpectrumHueDragging = true;
        this.moveHueSlider(e);
    };
    AgColorPanel.prototype.onSpectrumHueMove = function (e) {
        if (this.isSpectrumHueDragging) {
            this.moveHueSlider(e);
        }
    };
    AgColorPanel.prototype.onSpectrumAlphaDown = function (e) {
        this.refreshAlphaRect();
        this.isSpectrumAlphaDragging = true;
        this.moveAlphaSlider(e);
    };
    AgColorPanel.prototype.onSpectrumAlphaMove = function (e) {
        if (this.isSpectrumAlphaDragging) {
            this.moveAlphaSlider(e);
        }
    };
    AgColorPanel.prototype.onMouseUp = function () {
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
    };
    AgColorPanel.prototype.moveDragger = function (e) {
        var valRect = this.spectrumValRect;
        if (!valRect) {
            return;
        }
        var x;
        var y;
        if (e instanceof MouseEvent) {
            x = e.clientX - valRect.left;
            y = e.clientY - valRect.top;
        } else {
            var isLeft = e.key === KeyCode.LEFT;
            var isRight = e.key === KeyCode.RIGHT;
            var isUp = e.key === KeyCode.UP;
            var isDown = e.key === KeyCode.DOWN;
            var isVertical = isUp || isDown;
            var isHorizontal = isLeft || isRight;
            if (!isVertical && !isHorizontal) {
                return;
            }
            e.preventDefault();
            var _a = this.getSpectrumValue(),
                currentX = _a.x,
                currentY = _a.y;
            x = currentX + (isHorizontal ? (isLeft ? -5 : 5) : 0);
            y = currentY + (isVertical ? (isUp ? -5 : 5) : 0);
        }
        x = Math.max(x, 0);
        x = Math.min(x, valRect.width);
        y = Math.max(y, 0);
        y = Math.min(y, valRect.height);
        this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
    };
    AgColorPanel.prototype.moveHueSlider = function (e) {
        var rect = this.spectrumHueRect;
        if (!rect) {
            return;
        }
        var x = this.moveSlider(this.spectrumHueSlider, e);
        if (x == null) {
            return;
        }
        this.H = 1 - x / rect.width;
        this.update();
    };
    AgColorPanel.prototype.moveAlphaSlider = function (e) {
        var rect = this.spectrumAlphaRect;
        if (!rect) {
            return;
        }
        var x = this.moveSlider(this.spectrumAlphaSlider, e);
        if (x == null) {
            return;
        }
        this.A = x / rect.width;
        this.update();
    };
    AgColorPanel.prototype.moveSlider = function (slider, e) {
        var _a;
        var sliderRect = slider.getBoundingClientRect();
        var parentRect = (_a = slider.parentElement) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        if (!slider || !parentRect) {
            return null;
        }
        var x;
        if (e instanceof MouseEvent) {
            x = e.clientX - parentRect.left;
        } else {
            var isLeft = e.key === KeyCode.LEFT;
            var isRight = e.key === KeyCode.RIGHT;
            if (!isLeft && !isRight) {
                return null;
            }
            e.preventDefault();
            var diff = isLeft ? -5 : 5;
            x = parseFloat(slider.style.left) - sliderRect.width / 2 + diff;
        }
        x = Math.max(x, 0);
        x = Math.min(x, parentRect.width);
        slider.style.left = x + sliderRect.width / 2 + 'px';
        return x;
    };
    AgColorPanel.prototype.update = function () {
        var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        var spectrumColor = Color.fromHSB(this.H * 360, 1, 1);
        var rgbaColor = color.toRgbaString();
        // the recent color list needs to know color has actually changed
        var colorPicker = this.picker;
        var existingColor = Color.fromString(colorPicker.getValue());
        if (existingColor.toRgbaString() !== rgbaColor) {
            this.colorChanged = true;
        }
        colorPicker.setValue(rgbaColor);
        this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
        this.spectrumDragger.style.backgroundColor = rgbaColor;
    };
    /**
     * @param saturation In the [0, 1] interval.
     * @param brightness In the [0, 1] interval.
     */
    AgColorPanel.prototype.setSpectrumValue = function (saturation, brightness) {
        var valRect = this.spectrumValRect || this.refreshSpectrumRect();
        if (valRect == null) {
            return;
        }
        var dragger = this.spectrumDragger;
        var draggerRect = dragger.getBoundingClientRect();
        saturation = Math.max(0, saturation);
        saturation = Math.min(1, saturation);
        brightness = Math.max(0, brightness);
        brightness = Math.min(1, brightness);
        this.S = saturation;
        this.B = brightness;
        dragger.style.left = saturation * valRect.width - draggerRect.width / 2 + 'px';
        dragger.style.top = (1 - brightness) * valRect.height - draggerRect.height / 2 + 'px';
        this.update();
    };
    AgColorPanel.prototype.getSpectrumValue = function () {
        var dragger = this.spectrumDragger;
        var draggerRect = dragger.getBoundingClientRect();
        var x = parseFloat(dragger.style.left) + draggerRect.width / 2;
        var y = parseFloat(dragger.style.top) + draggerRect.height / 2;
        return { x: x, y: y };
    };
    AgColorPanel.prototype.initRecentColors = function () {
        var _this = this;
        var recentColors = AgColorPanel.recentColors;
        var innerHtml = recentColors.map(function (color, index) {
            return (
                /* html */ '<div class="ag-recent-color" id=' +
                index +
                ' style="background-color: ' +
                color +
                '; width: 15px; height: 15px;" recent-color="' +
                color +
                '" tabIndex="' +
                _this.tabIndex +
                '"></div>'
            );
        });
        this.recentColors.innerHTML = innerHtml.join('');
    };
    AgColorPanel.prototype.setValue = function (val) {
        var color = Color.fromString(val);
        var _a = __read$a(color.toHSB(), 3),
            h = _a[0],
            s = _a[1],
            b = _a[2];
        this.H = (isNaN(h) ? 0 : h) / 360;
        this.A = color.a;
        var spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
        var spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
        this.spectrumHueSlider.style.left = (this.H - 1) * -spectrumHueRect.width + 'px';
        this.spectrumAlphaSlider.style.left = this.A * spectrumAlphaRect.width + 'px';
        this.setSpectrumValue(s, b);
    };
    AgColorPanel.prototype.onRecentColorClick = function (e) {
        var target = e.target;
        if (!_.exists(target.id)) {
            return;
        }
        var id = parseInt(target.id, 10);
        this.setValue(AgColorPanel.recentColors[id]);
        this.destroy();
    };
    AgColorPanel.prototype.addRecentColor = function () {
        var color = Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        var rgbaColor = color.toRgbaString();
        var recentColors = AgColorPanel.recentColors;
        if (!this.colorChanged || recentColors[0] === rgbaColor) {
            return;
        }
        // remove duplicate color
        recentColors = recentColors.filter(function (currentColor) {
            return currentColor != rgbaColor;
        });
        // add color to head
        recentColors = [rgbaColor].concat(recentColors);
        // ensure we don't exceed max number of recent colors
        if (recentColors.length > AgColorPanel.maxRecentColors) {
            recentColors = recentColors.slice(0, AgColorPanel.maxRecentColors);
        }
        AgColorPanel.recentColors = recentColors;
    };
    AgColorPanel.prototype.destroy = function () {
        this.addRecentColor();
        _super.prototype.destroy.call(this);
    };
    AgColorPanel.maxRecentColors = 8;
    AgColorPanel.recentColors = [];
    AgColorPanel.TEMPLATE =
        '<div class="ag-color-panel" tabindex="-1">\n            <div ref="spectrumColor" class="ag-spectrum-color">\n                <div class="ag-spectrum-sat ag-spectrum-fill">\n                    <div ref="spectrumVal" class="ag-spectrum-val ag-spectrum-fill">\n                        <div ref="spectrumDragger" class="ag-spectrum-dragger"></div>\n                    </div>\n                </div>\n            </div>\n            <div class="ag-spectrum-tools">\n                <div ref="spectrumHue" class="ag-spectrum-hue ag-spectrum-tool">\n                    <div class="ag-spectrum-hue-background"></div>\n                    <div ref="spectrumHueSlider" class="ag-spectrum-slider"></div>\n                </div>\n                <div ref="spectrumAlpha" class="ag-spectrum-alpha ag-spectrum-tool">\n                    <div class="ag-spectrum-alpha-background"></div>\n                    <div ref="spectrumAlphaSlider" class="ag-spectrum-slider"></div>\n                </div>\n                <div ref="recentColors" class="ag-recent-colors"></div>\n            </div>\n        </div>';
    __decorate$D([RefSelector('spectrumColor')], AgColorPanel.prototype, 'spectrumColor', void 0);
    __decorate$D([RefSelector('spectrumVal')], AgColorPanel.prototype, 'spectrumVal', void 0);
    __decorate$D([RefSelector('spectrumDragger')], AgColorPanel.prototype, 'spectrumDragger', void 0);
    __decorate$D([RefSelector('spectrumHue')], AgColorPanel.prototype, 'spectrumHue', void 0);
    __decorate$D([RefSelector('spectrumHueSlider')], AgColorPanel.prototype, 'spectrumHueSlider', void 0);
    __decorate$D([RefSelector('spectrumAlpha')], AgColorPanel.prototype, 'spectrumAlpha', void 0);
    __decorate$D([RefSelector('spectrumAlphaSlider')], AgColorPanel.prototype, 'spectrumAlphaSlider', void 0);
    __decorate$D([RefSelector('recentColors')], AgColorPanel.prototype, 'recentColors', void 0);
    __decorate$D([PostConstruct], AgColorPanel.prototype, 'postConstruct', null);
    return AgColorPanel;
})(Component);

var __extends$G =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$9 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$9 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$9.apply(this, arguments);
    };
var AgColorPicker = /** @class */ (function (_super) {
    __extends$G(AgColorPicker, _super);
    function AgColorPicker(config) {
        var _this =
            _super.call(
                this,
                __assign$9(
                    {
                        pickerAriaLabelKey: 'ariaLabelColorPicker',
                        pickerAriaLabelValue: 'Color Picker',
                        pickerType: 'ag-list',
                        className: 'ag-color-picker',
                        pickerIcon: 'colorPicker',
                    },
                    config,
                ),
            ) || this;
        if (config && config.color) {
            _this.value = config.color;
        }
        return _this;
    }
    AgColorPicker.prototype.postConstruct = function () {
        _super.prototype.postConstruct.call(this);
        if (this.value) {
            this.setValue(this.value);
        }
    };
    AgColorPicker.prototype.createPickerComponent = function () {
        var eGuiRect = this.getGui().getBoundingClientRect();
        var colorDialog = this.createBean(
            new AgDialog({
                closable: false,
                modal: true,
                hideTitleBar: true,
                minWidth: 190,
                width: 190,
                height: 250,
                x: eGuiRect.right - 190,
                y: eGuiRect.top - 250,
            }),
        );
        return colorDialog;
    };
    AgColorPicker.prototype.renderAndPositionPicker = function () {
        var _this = this;
        var pickerComponent = this.pickerComponent;
        var colorPanel = this.createBean(new AgColorPanel({ picker: this }));
        pickerComponent.addCssClass('ag-color-dialog');
        colorPanel.addDestroyFunc(function () {
            if (pickerComponent.isAlive()) {
                _this.destroyBean(pickerComponent);
            }
        });
        pickerComponent.setParentComponent(this);
        pickerComponent.setBodyComponent(colorPanel);
        colorPanel.setValue(this.getValue());
        colorPanel.getGui().focus();
        pickerComponent.addDestroyFunc(function () {
            // here we check if the picker was already being
            // destroyed to avoid a stack overflow
            if (!_this.isDestroyingPicker) {
                _this.beforeHidePicker();
                _this.isDestroyingPicker = true;
                if (colorPanel.isAlive()) {
                    _this.destroyBean(colorPanel);
                }
                if (_this.isAlive()) {
                    _this.getFocusableElement().focus();
                }
            } else {
                _this.isDestroyingPicker = false;
            }
        });
        return function () {
            var _a;
            return (_a = _this.pickerComponent) === null || _a === void 0 ? void 0 : _a.close();
        };
    };
    AgColorPicker.prototype.setValue = function (color) {
        if (this.value === color) {
            return this;
        }
        this.eDisplayField.style.backgroundColor = color;
        return _super.prototype.setValue.call(this, color);
    };
    AgColorPicker.prototype.getValue = function () {
        return this.value;
    };
    return AgColorPicker;
})(AgPickerField);

var __read$9 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION = 28;
var VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION = 6;
function isValidVersion(version) {
    return version && version.match(/\d+\.\d+\.\d+/);
}
function isValidMajorVersion(_a) {
    var gridMajorVersion = _a.gridMajorVersion,
        chartsMajorVersion = _a.chartsMajorVersion;
    var gridMajor = parseInt(gridMajorVersion, 10);
    var chartsMajor = parseInt(chartsMajorVersion, 10);
    var gridMajorDifference = gridMajor - VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION;
    var chartsMajorDifference = chartsMajor - VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    var isFirstOrAfterVersion = gridMajorDifference >= 0;
    return gridMajorDifference === chartsMajorDifference && isFirstOrAfterVersion;
}
function gridChartVersion(gridVersion) {
    if (!gridVersion || !isValidVersion(gridVersion)) {
        return undefined;
    }
    var _a = __read$9(gridVersion.split('.') || [], 2),
        gridMajor = _a[0],
        gridMinor = _a[1];
    var gridMajorMinor = gridMajor + '.' + gridMinor + '.x';
    var gridMajorNumber = parseInt(gridMajor, 10);
    var chartsMajor =
        gridMajorNumber - VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION + VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    if (chartsMajor < 0) {
        return undefined;
    }
    var chartsMinor = gridMinor;
    var chartsMajorMinor = chartsMajor + '.' + chartsMinor + '.x';
    return {
        gridMajorMinor: gridMajorMinor,
        chartsMajorMinor: chartsMajorMinor,
    };
}
function validGridChartsVersionErrorMessage(_a) {
    var type = _a.type,
        gridVersion = _a.gridVersion,
        chartsVersion = _a.chartsVersion;
    var invalidMessage =
        'AG Grid: AG Grid version is incompatible. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.';
    if (!gridVersion) {
        return invalidMessage;
    }
    var version = gridChartVersion(gridVersion);
    if (!version) {
        return invalidMessage;
    }
    var gridMajorMinor = version.gridMajorMinor,
        chartsMajorMinor = version.chartsMajorMinor;
    if (type === 'incompatible') {
        return (
            'AG Grid version ' +
            gridVersion +
            ' and AG Charts version ' +
            chartsVersion +
            ' is not supported. AG Grid version ' +
            gridMajorMinor +
            ' should be used with AG Chart ' +
            chartsMajorMinor +
            '. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.'
        );
    } else if (type === 'invalidCharts') {
        return (
            'AG Grid version ' +
            gridMajorMinor +
            ' should be used with AG Chart ' +
            chartsMajorMinor +
            '. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.'
        );
    }
    return invalidMessage;
}
function validGridChartsVersion(_a) {
    var gridVersion = _a.gridVersion,
        chartsVersion = _a.chartsVersion;
    if (!isValidVersion(chartsVersion)) {
        return {
            isValid: false,
            message: validGridChartsVersionErrorMessage({
                type: 'invalidCharts',
                gridVersion: gridVersion,
                chartsVersion: chartsVersion,
            }),
        };
    }
    if (!isValidVersion(gridVersion)) {
        return {
            isValid: false,
            message: validGridChartsVersionErrorMessage({
                type: 'invalidGrid',
                gridVersion: gridVersion,
                chartsVersion: chartsVersion,
            }),
        };
    }
    var _b = __read$9(gridVersion.split('.') || [], 2),
        gridMajor = _b[0],
        gridMinor = _b[1];
    var _c = __read$9(chartsVersion.split('.') || [], 2),
        chartsMajor = _c[0],
        chartsMinor = _c[1];
    var isValidMajor = isValidMajorVersion({
        gridMajorVersion: gridMajor,
        chartsMajorVersion: chartsMajor,
    });
    if (isValidMajor && gridMinor === chartsMinor) {
        return {
            isValid: true,
        };
    } else if (!isValidMajor || gridMinor !== chartsMinor) {
        return {
            isValid: false,
            message: validGridChartsVersionErrorMessage({
                type: 'incompatible',
                gridVersion: gridVersion,
                chartsVersion: chartsVersion,
            }),
        };
    }
    return {
        isValid: false,
        message: validGridChartsVersionErrorMessage({
            type: 'invalid',
            gridVersion: gridVersion,
            chartsVersion: chartsVersion,
        }),
    };
}

var GridChartsModule = {
    version: VERSION$a,
    validate: function () {
        return validGridChartsVersion({
            gridVersion: VERSION$a,
            chartsVersion: ChartService.CHARTS_VERSION,
        });
    },
    moduleName: ModuleNames.GridChartsModule,
    beans: [ChartService, ChartTranslationService, ChartCrossFilterService],
    agStackComponents: [
        { componentName: 'AgColorPicker', componentClass: AgColorPicker },
        { componentName: 'AgAngleSelect', componentClass: AgAngleSelect },
    ],
    dependantModules: [RangeSelectionModule, EnterpriseCoreModule],
};

/**
 * Internal Use Only: Used to ensure this file is treated as a module until we can use moduleDetection flag in Ts v4.7
 */
var __FORCE_MODULE_DETECTION_AG_GRID_CORE_EXT = 0;

var agCharts = {
    time: time,
    AgChart: AgChart,
};

var __extends$F =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$8 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$8 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$8.apply(this, arguments);
    };
var __decorate$C =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DetailCellRendererCtrl = /** @class */ (function (_super) {
    __extends$F(DetailCellRendererCtrl, _super);
    function DetailCellRendererCtrl() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.loadRowDataVersion = 0;
        return _this;
    }
    DetailCellRendererCtrl.prototype.init = function (comp, params) {
        this.params = params;
        this.comp = comp;
        var doNothingBecauseInsidePinnedSection = params.pinned != null;
        if (doNothingBecauseInsidePinnedSection) {
            return;
        }
        this.setAutoHeightClasses();
        this.setupRefreshStrategy();
        this.addThemeToDetailGrid();
        this.createDetailGrid();
        this.loadRowData();
        this.addManagedListener(
            this.eventService,
            Events.EVENT_FULL_WIDTH_ROW_FOCUSED,
            this.onFullWidthRowFocused.bind(this),
        );
    };
    DetailCellRendererCtrl.prototype.onFullWidthRowFocused = function (e) {
        var params = this.params;
        var row = { rowIndex: params.node.rowIndex, rowPinned: params.node.rowPinned };
        var eventRow = { rowIndex: e.rowIndex, rowPinned: e.rowPinned };
        var isSameRow = this.rowPositionUtils.sameRow(row, eventRow);
        if (!isSameRow) {
            return;
        }
        this.focusService.focusInto(this.comp.getGui(), e.fromBelow);
    };
    DetailCellRendererCtrl.prototype.setAutoHeightClasses = function () {
        var autoHeight = this.gridOptionsService.is('detailRowAutoHeight');
        var parentClass = autoHeight ? 'ag-details-row-auto-height' : 'ag-details-row-fixed-height';
        var detailClass = autoHeight ? 'ag-details-grid-auto-height' : 'ag-details-grid-fixed-height';
        this.comp.addOrRemoveCssClass(parentClass, true);
        this.comp.addOrRemoveDetailGridCssClass(detailClass, true);
    };
    DetailCellRendererCtrl.prototype.setupRefreshStrategy = function () {
        var providedStrategy = this.params.refreshStrategy;
        var validSelection =
            providedStrategy == 'everything' || providedStrategy == 'nothing' || providedStrategy == 'rows';
        if (validSelection) {
            this.refreshStrategy = providedStrategy;
            return;
        }
        if (providedStrategy != null) {
            console.warn(
                "AG Grid: invalid cellRendererParams.refreshStrategy = '" +
                    providedStrategy +
                    "' supplied, defaulting to refreshStrategy = 'rows'.",
            );
        }
        this.refreshStrategy = 'rows';
    };
    DetailCellRendererCtrl.prototype.addThemeToDetailGrid = function () {
        // this is needed by environment service of the child grid, the class needs to be on
        // the grid div itself - the browser's CSS on the other hand just inherits from the parent grid theme.
        var theme = this.environment.getTheme().theme;
        if (theme) {
            this.comp.addOrRemoveDetailGridCssClass(theme, true);
        }
    };
    DetailCellRendererCtrl.prototype.createDetailGrid = function () {
        if (_.missing(this.params.detailGridOptions)) {
            console.warn(
                'AG Grid: could not find detail grid options for master detail, ' +
                    'please set gridOptions.detailCellRendererParams.detailGridOptions',
            );
            return;
        }
        var autoHeight = this.gridOptionsService.is('detailRowAutoHeight');
        // we clone the detail grid options, as otherwise it would be shared
        // across many instances, and that would be a problem because we set
        // api and columnApi into gridOptions
        var gridOptions = __assign$8({}, this.params.detailGridOptions);
        if (autoHeight) {
            gridOptions.domLayout = 'autoHeight';
        }
        this.comp.setDetailGrid(gridOptions);
    };
    DetailCellRendererCtrl.prototype.registerDetailWithMaster = function (api, columnApi) {
        var rowId = this.params.node.id;
        var masterGridApi = this.params.api;
        var gridInfo = {
            id: rowId,
            api: api,
            columnApi: columnApi,
        };
        var rowNode = this.params.node;
        // register with api
        masterGridApi.addDetailGridInfo(rowId, gridInfo);
        // register with node
        rowNode.detailGridInfo = gridInfo;
        this.addDestroyFunc(function () {
            // the gridInfo can be stale if a refresh happens and
            // a new row is created before the old one is destroyed.
            if (rowNode.detailGridInfo !== gridInfo) {
                return;
            }
            masterGridApi.removeDetailGridInfo(rowId); // unregister from api
            rowNode.detailGridInfo = null; // unregister from node
        });
    };
    DetailCellRendererCtrl.prototype.loadRowData = function () {
        var _this = this;
        // in case a refresh happens before the last refresh completes (as we depend on async
        // application logic) we keep track on what the latest call was.
        this.loadRowDataVersion++;
        var versionThisCall = this.loadRowDataVersion;
        var userFunc = this.params.getDetailRowData;
        if (!userFunc) {
            console.warn(
                'AG Grid: could not find getDetailRowData for master / detail, ' +
                    'please set gridOptions.detailCellRendererParams.getDetailRowData',
            );
            return;
        }
        var successCallback = function (rowData) {
            var mostRecentCall = _this.loadRowDataVersion === versionThisCall;
            if (mostRecentCall) {
                _this.comp.setRowData(rowData);
            }
        };
        var funcParams = {
            node: this.params.node,
            // we take data from node, rather than params.data
            // as the data could have been updated with new instance
            data: this.params.node.data,
            successCallback: successCallback,
            context: this.gridOptionsService.context,
        };
        userFunc(funcParams);
    };
    DetailCellRendererCtrl.prototype.refresh = function () {
        var GET_GRID_TO_REFRESH = false;
        var GET_GRID_TO_DO_NOTHING = true;
        switch (this.refreshStrategy) {
            // ignore this refresh, make grid think we've refreshed but do nothing
            case 'nothing':
                return GET_GRID_TO_DO_NOTHING;
            // grid will destroy and recreate the cell
            case 'everything':
                return GET_GRID_TO_REFRESH;
        }
        // do the refresh here, and tell the grid to do nothing
        this.loadRowData();
        return GET_GRID_TO_DO_NOTHING;
    };
    __decorate$C([Autowired('rowPositionUtils')], DetailCellRendererCtrl.prototype, 'rowPositionUtils', void 0);
    __decorate$C([Autowired('focusService')], DetailCellRendererCtrl.prototype, 'focusService', void 0);
    return DetailCellRendererCtrl;
})(BeanStub);

var __extends$E =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$B =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DetailCellRenderer = /** @class */ (function (_super) {
    __extends$E(DetailCellRenderer, _super);
    function DetailCellRenderer() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    DetailCellRenderer.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.selectAndSetTemplate();
        var compProxy = {
            addOrRemoveCssClass: function (cssClassName, on) {
                return _this.addOrRemoveCssClass(cssClassName, on);
            },
            addOrRemoveDetailGridCssClass: function (cssClassName, on) {
                return _this.eDetailGrid.classList.toggle(cssClassName, on);
            },
            setDetailGrid: function (gridOptions) {
                return _this.setDetailGrid(gridOptions);
            },
            setRowData: function (rowData) {
                return _this.setRowData(rowData);
            },
            getGui: function () {
                return _this.eDetailGrid;
            },
        };
        this.ctrl = this.createManagedBean(new DetailCellRendererCtrl());
        this.ctrl.init(compProxy, params);
    };
    DetailCellRenderer.prototype.refresh = function () {
        return this.ctrl && this.ctrl.refresh();
    };
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    DetailCellRenderer.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    DetailCellRenderer.prototype.selectAndSetTemplate = function () {
        var _this = this;
        if (this.params.pinned) {
            this.setTemplate('<div class="ag-details-row"></div>');
            return;
        }
        var setDefaultTemplate = function () {
            _this.setTemplate(DetailCellRenderer.TEMPLATE);
        };
        if (_.missing(this.params.template)) {
            // use default template
            setDefaultTemplate();
        } else {
            // use user provided template
            if (typeof this.params.template === 'string') {
                this.setTemplate(this.params.template);
            } else if (typeof this.params.template === 'function') {
                var templateFunc = this.params.template;
                var template = templateFunc(this.params);
                this.setTemplate(template);
            } else {
                console.warn('AG Grid: detailCellRendererParams.template should be function or string');
                setDefaultTemplate();
            }
        }
        if (this.eDetailGrid == null) {
            console.warn(
                'AG Grid: reference to eDetailGrid was missing from the details template. ' +
                    'Please add ref="eDetailGrid" to the template.',
            );
        }
    };
    DetailCellRenderer.prototype.setDetailGrid = function (gridOptions) {
        if (!this.eDetailGrid) {
            return;
        }
        // AG-1715
        // this is only needed when suppressReactUi=true, once we remove the old way
        // of doing react, and Master / Details is all native React, then we
        // can remove this code.
        var agGridReact = this.context.getBean('agGridReact');
        var agGridReactCloned = agGridReact ? _.cloneObject(agGridReact) : undefined;
        // when we create detail grid, the detail grid needs frameworkComponentWrapper so that
        // it created child components correctly, ie  Angular detail grid can have Angular cell renderer.
        // this is only used by Angular and Vue, as React uses native React AG Grid detail grids
        var frameworkComponentWrapper = this.context.getBean('frameworkComponentWrapper');
        var frameworkOverrides = this.getFrameworkOverrides();
        // tslint:disable-next-line
        new Grid(this.eDetailGrid, gridOptions, {
            frameworkOverrides: frameworkOverrides,
            providedBeanInstances: {
                agGridReact: agGridReactCloned,
                frameworkComponentWrapper: frameworkComponentWrapper,
            },
            modules: ModuleRegistry.__getGridRegisteredModules(this.params.api.getGridId()),
        });
        this.detailApi = gridOptions.api;
        this.ctrl.registerDetailWithMaster(gridOptions.api, gridOptions.columnApi);
        this.addDestroyFunc(function () {
            if (gridOptions.api) {
                gridOptions.api.destroy();
            }
        });
    };
    DetailCellRenderer.prototype.setRowData = function (rowData) {
        // ensure detail grid api still exists (grid may be destroyed when async call tries to set data)
        this.detailApi && this.detailApi.setRowData(rowData);
    };
    DetailCellRenderer.TEMPLATE =
        '<div class="ag-details-row" role="gridcell">\n            <div ref="eDetailGrid" class="ag-details-grid" role="presentation"></div>\n        </div>';
    __decorate$B([RefSelector('eDetailGrid')], DetailCellRenderer.prototype, 'eDetailGrid', void 0);
    return DetailCellRenderer;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$8 = '30.2.0';

var MasterDetailModule = {
    version: VERSION$8,
    moduleName: ModuleNames.MasterDetailModule,
    beans: [],
    userComponents: [{ componentName: 'agDetailCellRenderer', componentClass: DetailCellRenderer }],
    controllers: [{ controllerName: 'detailCellRenderer', controllerClass: DetailCellRendererCtrl }],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$D =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$A =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var EnterpriseMenuFactory = /** @class */ (function (_super) {
    __extends$D(EnterpriseMenuFactory, _super);
    function EnterpriseMenuFactory() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    EnterpriseMenuFactory.prototype.hideActiveMenu = function () {
        this.destroyBean(this.activeMenu);
    };
    EnterpriseMenuFactory.prototype.showMenuAfterMouseEvent = function (column, mouseEvent, defaultTab) {
        var _this = this;
        this.showMenu(
            column,
            function (menu) {
                var ePopup = menu.getGui();
                _this.popupService.positionPopupUnderMouseEvent({
                    type: 'columnMenu',
                    column: column,
                    mouseEvent: mouseEvent,
                    ePopup: ePopup,
                });
                if (defaultTab) {
                    menu.showTab(defaultTab);
                }
            },
            'columnMenu',
            defaultTab,
            undefined,
            mouseEvent.target,
        );
    };
    EnterpriseMenuFactory.prototype.showMenuAfterButtonClick = function (
        column,
        eventSource,
        containerType,
        defaultTab,
        restrictToTabs,
    ) {
        var _this = this;
        var multiplier = -1;
        var alignSide = 'left';
        if (this.gridOptionsService.is('enableRtl')) {
            multiplier = 1;
            alignSide = 'right';
        }
        this.showMenu(
            column,
            function (menu) {
                var ePopup = menu.getGui();
                _this.popupService.positionPopupByComponent({
                    type: containerType,
                    column: column,
                    eventSource: eventSource,
                    ePopup: ePopup,
                    alignSide: alignSide,
                    nudgeX: 9 * multiplier,
                    nudgeY: -23,
                    position: 'under',
                    keepWithinBounds: true,
                });
                if (defaultTab) {
                    menu.showTab(defaultTab);
                }
            },
            containerType,
            defaultTab,
            restrictToTabs,
            eventSource,
        );
    };
    EnterpriseMenuFactory.prototype.showMenu = function (
        column,
        positionCallback,
        containerType,
        defaultTab,
        restrictToTabs,
        eventSource,
    ) {
        var _this = this;
        var _a = this.getMenuParams(column, restrictToTabs, eventSource),
            menu = _a.menu,
            eMenuGui = _a.eMenuGui,
            currentHeaderPosition = _a.currentHeaderPosition,
            currentColumnIndex = _a.currentColumnIndex,
            anchorToElement = _a.anchorToElement;
        var closedFuncs = [];
        closedFuncs.push(this.getClosedCallback(column, menu, currentHeaderPosition, currentColumnIndex, eventSource));
        var translate = this.localeService.getLocaleTextFunc();
        // need to show filter before positioning, as only after filter
        // is visible can we find out what the width of it is
        this.popupService.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: function (e) {
                closedFuncs.forEach(function (f) {
                    return f(e);
                });
            },
            afterGuiAttached: function (params) {
                return menu.afterGuiAttached(Object.assign({}, { container: containerType }, params));
            },
            // if defaultTab is not present, positionCallback will be called
            // after `showTabBasedOnPreviousSelection` is called.
            positionCallback: !!defaultTab
                ? function () {
                      return positionCallback(menu);
                  }
                : undefined,
            ariaLabel: translate('ariaLabelColumnMenu', 'Column Menu'),
        });
        if (!defaultTab) {
            menu.showTabBasedOnPreviousSelection();
            // reposition the menu because the method above could load
            // an element that is bigger than enterpriseMenu header.
            positionCallback(menu);
        }
        // if user starts showing / hiding columns, or otherwise move the underlying column
        // for this menu, we want to stop tracking the menu with the column position. otherwise
        // the menu would move as the user is using the columns tab inside the menu.
        var stopAnchoringPromise = this.popupService.setPopupPositionRelatedToElement(eMenuGui, anchorToElement);
        if (stopAnchoringPromise) {
            this.addStopAnchoring(stopAnchoringPromise, column, closedFuncs);
        }
        menu.addEventListener(EnterpriseMenu.EVENT_TAB_SELECTED, function (event) {
            _this.lastSelectedTab = event.key;
        });
        column.setMenuVisible(true, 'contextMenu');
        this.activeMenu = menu;
        menu.addEventListener(BeanStub.EVENT_DESTROYED, function () {
            if (_this.activeMenu === menu) {
                _this.activeMenu = null;
            }
        });
    };
    EnterpriseMenuFactory.prototype.addStopAnchoring = function (stopAnchoringPromise, column, closedFuncsArr) {
        stopAnchoringPromise.then(function (stopAnchoringFunc) {
            column.addEventListener('leftChanged', stopAnchoringFunc);
            column.addEventListener('visibleChanged', stopAnchoringFunc);
            closedFuncsArr.push(function () {
                column.removeEventListener('leftChanged', stopAnchoringFunc);
                column.removeEventListener('visibleChanged', stopAnchoringFunc);
            });
        });
    };
    EnterpriseMenuFactory.prototype.getClosedCallback = function (
        column,
        menu,
        headerPosition,
        columnIndex,
        eventSource,
    ) {
        var _this = this;
        return function (e) {
            _this.destroyBean(menu);
            column.setMenuVisible(false, 'contextMenu');
            var isKeyboardEvent = e instanceof KeyboardEvent;
            if (!isKeyboardEvent || !eventSource) {
                return;
            }
            var isColumnStillVisible = _this.columnModel.getAllDisplayedColumns().some(function (col) {
                return col === column;
            });
            if (isColumnStillVisible && _.isVisible(eventSource)) {
                var focusableEl = _this.focusService.findTabbableParent(eventSource);
                if (focusableEl) {
                    if (column) {
                        _this.headerNavigationService.scrollToColumn(column);
                    }
                    focusableEl.focus();
                }
            }
            // if the focusEl is no longer in the DOM, we try to focus
            // the header that is closest to the previous header position
            else if (headerPosition && columnIndex !== -1) {
                var allColumns = _this.columnModel.getAllDisplayedColumns();
                var columnToFocus = allColumns[columnIndex] || _.last(allColumns);
                if (columnToFocus) {
                    _this.focusService.focusHeaderPosition({
                        headerPosition: {
                            headerRowIndex: headerPosition.headerRowIndex,
                            column: columnToFocus,
                        },
                    });
                }
            }
        };
    };
    EnterpriseMenuFactory.prototype.getMenuParams = function (column, restrictToTabs, eventSource) {
        var menu = this.createBean(new EnterpriseMenu(column, this.lastSelectedTab, restrictToTabs));
        return {
            menu: menu,
            eMenuGui: menu.getGui(),
            currentHeaderPosition: this.focusService.getFocusedHeader(),
            currentColumnIndex: this.columnModel.getAllDisplayedColumns().indexOf(column),
            anchorToElement: eventSource || this.ctrlsService.getGridBodyCtrl().getGui(),
        };
    };
    EnterpriseMenuFactory.prototype.isMenuEnabled = function (column) {
        return column.getMenuTabs(EnterpriseMenu.TABS_DEFAULT).length > 0;
    };
    __decorate$A([Autowired('popupService')], EnterpriseMenuFactory.prototype, 'popupService', void 0);
    __decorate$A([Autowired('focusService')], EnterpriseMenuFactory.prototype, 'focusService', void 0);
    __decorate$A(
        [Autowired('headerNavigationService')],
        EnterpriseMenuFactory.prototype,
        'headerNavigationService',
        void 0,
    );
    __decorate$A([Autowired('ctrlsService')], EnterpriseMenuFactory.prototype, 'ctrlsService', void 0);
    __decorate$A([Autowired('columnModel')], EnterpriseMenuFactory.prototype, 'columnModel', void 0);
    EnterpriseMenuFactory = __decorate$A([Bean('menuFactory')], EnterpriseMenuFactory);
    return EnterpriseMenuFactory;
})(BeanStub);
var EnterpriseMenu = /** @class */ (function (_super) {
    __extends$D(EnterpriseMenu, _super);
    function EnterpriseMenu(column, initialSelection, restrictTo) {
        var _this = _super.call(this) || this;
        _this.tabFactories = {};
        _this.includeChecks = {};
        _this.column = column;
        _this.initialSelection = initialSelection;
        _this.tabFactories[EnterpriseMenu.TAB_GENERAL] = _this.createMainPanel.bind(_this);
        _this.tabFactories[EnterpriseMenu.TAB_FILTER] = _this.createFilterPanel.bind(_this);
        _this.tabFactories[EnterpriseMenu.TAB_COLUMNS] = _this.createColumnsPanel.bind(_this);
        _this.includeChecks[EnterpriseMenu.TAB_GENERAL] = function () {
            return true;
        };
        _this.includeChecks[EnterpriseMenu.TAB_FILTER] = function () {
            return _this.filterManager.isFilterAllowed(column);
        };
        _this.includeChecks[EnterpriseMenu.TAB_COLUMNS] = function () {
            return true;
        };
        _this.restrictTo = restrictTo;
        return _this;
    }
    EnterpriseMenu.prototype.init = function () {
        var _this = this;
        var tabs = this.getTabsToCreate().map(function (name) {
            return _this.createTab(name);
        });
        this.tabbedLayout = new TabbedLayout({
            items: tabs,
            cssClass: 'ag-menu',
            onActiveItemClicked: this.onHidePopup.bind(this),
            onItemClicked: this.onTabItemClicked.bind(this),
        });
        this.createBean(this.tabbedLayout);
        if (this.mainMenuList) {
            this.mainMenuList.setParentComponent(this.tabbedLayout);
        }
        this.addDestroyFunc(function () {
            return _this.destroyBean(_this.tabbedLayout);
        });
    };
    EnterpriseMenu.prototype.getTabsToCreate = function () {
        var _this = this;
        if (this.restrictTo) {
            return this.restrictTo;
        }
        return this.column
            .getMenuTabs(EnterpriseMenu.TABS_DEFAULT)
            .filter(function (tabName) {
                return _this.isValidMenuTabItem(tabName);
            })
            .filter(function (tabName) {
                return _this.isNotSuppressed(tabName);
            })
            .filter(function (tabName) {
                return _this.isModuleLoaded(tabName);
            });
    };
    EnterpriseMenu.prototype.isModuleLoaded = function (menuTabName) {
        if (menuTabName === EnterpriseMenu.TAB_COLUMNS) {
            return ModuleRegistry.__isRegistered(ModuleNames.ColumnsToolPanelModule, this.context.getGridId());
        }
        return true;
    };
    EnterpriseMenu.prototype.isValidMenuTabItem = function (menuTabName) {
        var isValid = true;
        var itemsToConsider = EnterpriseMenu.TABS_DEFAULT;
        if (this.restrictTo != null) {
            isValid = this.restrictTo.indexOf(menuTabName) > -1;
            itemsToConsider = this.restrictTo;
        }
        isValid = isValid && EnterpriseMenu.TABS_DEFAULT.indexOf(menuTabName) > -1;
        if (!isValid) {
            console.warn(
                "AG Grid: Trying to render an invalid menu item '" +
                    menuTabName +
                    "'. Check that your 'menuTabs' contains one of [" +
                    itemsToConsider +
                    ']',
            );
        }
        return isValid;
    };
    EnterpriseMenu.prototype.isNotSuppressed = function (menuTabName) {
        return this.includeChecks[menuTabName]();
    };
    EnterpriseMenu.prototype.createTab = function (name) {
        return this.tabFactories[name]();
    };
    EnterpriseMenu.prototype.showTabBasedOnPreviousSelection = function () {
        // show the tab the user was on last time they had a menu open
        this.showTab(this.initialSelection);
    };
    EnterpriseMenu.prototype.showTab = function (toShow) {
        if (this.tabItemColumns && toShow === EnterpriseMenu.TAB_COLUMNS) {
            this.tabbedLayout.showItem(this.tabItemColumns);
        } else if (this.tabItemFilter && toShow === EnterpriseMenu.TAB_FILTER) {
            this.tabbedLayout.showItem(this.tabItemFilter);
        } else if (this.tabItemGeneral && toShow === EnterpriseMenu.TAB_GENERAL) {
            this.tabbedLayout.showItem(this.tabItemGeneral);
        } else {
            this.tabbedLayout.showFirstItem();
        }
    };
    EnterpriseMenu.prototype.onTabItemClicked = function (event) {
        var key = null;
        switch (event.item) {
            case this.tabItemColumns:
                key = EnterpriseMenu.TAB_COLUMNS;
                break;
            case this.tabItemFilter:
                key = EnterpriseMenu.TAB_FILTER;
                break;
            case this.tabItemGeneral:
                key = EnterpriseMenu.TAB_GENERAL;
                break;
        }
        if (key) {
            this.activateTab(key);
        }
    };
    EnterpriseMenu.prototype.activateTab = function (tab) {
        var ev = {
            type: EnterpriseMenu.EVENT_TAB_SELECTED,
            key: tab,
        };
        this.dispatchEvent(ev);
    };
    EnterpriseMenu.prototype.getMenuItems = function () {
        var defaultMenuOptions = this.getDefaultMenuOptions();
        var result;
        var userFunc = this.gridOptionsService.getCallback('getMainMenuItems');
        if (userFunc) {
            result = userFunc({
                column: this.column,
                defaultItems: defaultMenuOptions,
            });
        } else {
            result = defaultMenuOptions;
        }
        // GUI looks weird when two separators are side by side. this can happen accidentally
        // if we remove items from the menu then two separators can edit up adjacent.
        _.removeRepeatsFromArray(result, EnterpriseMenu.MENU_ITEM_SEPARATOR);
        return result;
    };
    EnterpriseMenu.prototype.getDefaultMenuOptions = function () {
        var result = [];
        var allowPinning = !this.column.getColDef().lockPinned;
        var rowGroupCount = this.columnModel.getRowGroupColumns().length;
        var doingGrouping = rowGroupCount > 0;
        var groupedByThisColumn = this.columnModel.getRowGroupColumns().indexOf(this.column) >= 0;
        var allowValue = this.column.isAllowValue();
        var allowRowGroup = this.column.isAllowRowGroup();
        var isPrimary = this.column.isPrimary();
        var pivotModeOn = this.columnModel.isPivotMode();
        var isInMemoryRowModel = this.rowModel.getType() === 'clientSide';
        var usingTreeData = this.gridOptionsService.is('treeData');
        var allowValueAgg =
            // if primary, then only allow aggValue if grouping and it's a value columns
            (isPrimary && doingGrouping && allowValue) ||
            // secondary columns can always have aggValue, as it means it's a pivot value column
            !isPrimary;
        if (allowPinning) {
            result.push('pinSubMenu');
        }
        if (allowValueAgg) {
            result.push('valueAggSubMenu');
        }
        if (allowPinning || allowValueAgg) {
            result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        }
        result.push('autoSizeThis');
        result.push('autoSizeAll');
        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        if (!!this.column.getColDef().showRowGroup) {
            result.push('rowUnGroup');
        }
        if (allowRowGroup && this.column.isPrimary()) {
            if (groupedByThisColumn) {
                result.push('rowUnGroup');
            } else {
                result.push('rowGroup');
            }
        }
        result.push(EnterpriseMenu.MENU_ITEM_SEPARATOR);
        result.push('resetColumns');
        // only add grouping expand/collapse if grouping in the InMemoryRowModel
        // if pivoting, we only have expandable groups if grouping by 2 or more columns
        // as the lowest level group is not expandable while pivoting.
        // if not pivoting, then any active row group can be expanded.
        var allowExpandAndContract = isInMemoryRowModel && (usingTreeData || rowGroupCount > (pivotModeOn ? 1 : 0));
        if (allowExpandAndContract) {
            result.push('expandAll');
            result.push('contractAll');
        }
        return result;
    };
    EnterpriseMenu.prototype.createMainPanel = function () {
        this.mainMenuList = this.createManagedBean(new AgMenuList());
        var menuItems = this.getMenuItems();
        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(menuItems, this.column);
        this.mainMenuList.addMenuItems(menuItemsMapped);
        this.mainMenuList.addEventListener(AgMenuItemComponent.EVENT_MENU_ITEM_SELECTED, this.onHidePopup.bind(this));
        this.tabItemGeneral = {
            title: _.createIconNoSpan('menu', this.gridOptionsService, this.column),
            titleLabel: EnterpriseMenu.TAB_GENERAL.replace('MenuTab', ''),
            bodyPromise: AgPromise.resolve(this.mainMenuList.getGui()),
            name: EnterpriseMenu.TAB_GENERAL,
        };
        return this.tabItemGeneral;
    };
    EnterpriseMenu.prototype.onHidePopup = function (event) {
        var keyboardEvent;
        if (event && event.event && event.event instanceof KeyboardEvent) {
            keyboardEvent = event.event;
        }
        this.hidePopupFunc(keyboardEvent && { keyboardEvent: keyboardEvent });
        // this method only gets called when the menu was closed by selection an option
        // in this case we highlight the cell that was previously highlighted
        var focusedCell = this.focusService.getFocusedCell();
        var eDocument = this.gridOptionsService.getDocument();
        if (eDocument.activeElement === eDocument.body && focusedCell) {
            var rowIndex = focusedCell.rowIndex,
                rowPinned = focusedCell.rowPinned,
                column = focusedCell.column;
            this.focusService.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: true,
            });
        }
    };
    EnterpriseMenu.prototype.createFilterPanel = function () {
        var filterWrapper = this.filterManager.getOrCreateFilterWrapper(this.column, 'COLUMN_MENU');
        if (!filterWrapper) {
            throw new Error('AG Grid - Unable to instantiate filter');
        }
        var afterFilterAttachedCallback = function (params) {
            if (!(filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.filterPromise)) {
                return;
            }
            // slightly odd block this - this promise will always have been resolved by the time it gets here, so won't be
            // async (_unless_ in react or similar, but if so why not encountered before now?).
            // I'd suggest a future improvement would be to remove/replace this promise as this block just wont work if it is
            // async and is confusing if you don't have this context
            filterWrapper.filterPromise.then(function (filter) {
                if (filter && filter.afterGuiAttached) {
                    filter.afterGuiAttached(params);
                }
            });
        };
        // see comment above
        var afterDetachedCallback = function () {
            var _a;
            return (_a = filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.filterPromise) ===
                null || _a === void 0
                ? void 0
                : _a.then(function (filter) {
                      var _a;
                      return (_a = filter === null || filter === void 0 ? void 0 : filter.afterGuiDetached) === null ||
                          _a === void 0
                          ? void 0
                          : _a.call(filter);
                  });
        };
        this.tabItemFilter = {
            title: _.createIconNoSpan('filter', this.gridOptionsService, this.column),
            titleLabel: EnterpriseMenu.TAB_FILTER.replace('MenuTab', ''),
            bodyPromise: filterWrapper === null || filterWrapper === void 0 ? void 0 : filterWrapper.guiPromise,
            afterAttachedCallback: afterFilterAttachedCallback,
            afterDetachedCallback: afterDetachedCallback,
            name: EnterpriseMenu.TAB_FILTER,
        };
        return this.tabItemFilter;
    };
    EnterpriseMenu.prototype.createColumnsPanel = function () {
        var eWrapperDiv = document.createElement('div');
        eWrapperDiv.classList.add('ag-menu-column-select-wrapper');
        var columnSelectPanel = this.createManagedBean(new PrimaryColsPanel());
        var columnsMenuParams = this.column.getColDef().columnsMenuParams;
        if (!columnsMenuParams) {
            columnsMenuParams = {};
        }
        var contractColumnSelection = columnsMenuParams.contractColumnSelection,
            suppressColumnExpandAll = columnsMenuParams.suppressColumnExpandAll,
            suppressColumnFilter = columnsMenuParams.suppressColumnFilter,
            suppressColumnSelectAll = columnsMenuParams.suppressColumnSelectAll,
            suppressSyncLayoutWithGrid = columnsMenuParams.suppressSyncLayoutWithGrid,
            columnLayout = columnsMenuParams.columnLayout;
        columnSelectPanel.init(
            false,
            {
                suppressColumnMove: false,
                suppressValues: false,
                suppressPivots: false,
                suppressRowGroups: false,
                suppressPivotMode: false,
                contractColumnSelection: !!contractColumnSelection,
                suppressColumnExpandAll: !!suppressColumnExpandAll,
                suppressColumnFilter: !!suppressColumnFilter,
                suppressColumnSelectAll: !!suppressColumnSelectAll,
                suppressSyncLayoutWithGrid: !!columnLayout || !!suppressSyncLayoutWithGrid,
                api: this.gridApi,
                columnApi: this.columnApi,
                context: this.gridOptionsService.context,
            },
            'columnMenu',
        );
        if (columnLayout) {
            columnSelectPanel.setColumnLayout(columnLayout);
        }
        var columnSelectPanelGui = columnSelectPanel.getGui();
        columnSelectPanelGui.classList.add('ag-menu-column-select');
        eWrapperDiv.appendChild(columnSelectPanelGui);
        this.tabItemColumns = {
            title: _.createIconNoSpan('columns', this.gridOptionsService, this.column),
            titleLabel: EnterpriseMenu.TAB_COLUMNS.replace('MenuTab', ''),
            bodyPromise: AgPromise.resolve(eWrapperDiv),
            name: EnterpriseMenu.TAB_COLUMNS,
        };
        return this.tabItemColumns;
    };
    EnterpriseMenu.prototype.afterGuiAttached = function (params) {
        var container = params.container,
            hidePopup = params.hidePopup;
        this.tabbedLayout.setAfterAttachedParams({ container: container, hidePopup: hidePopup });
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
    };
    EnterpriseMenu.prototype.getGui = function () {
        return this.tabbedLayout.getGui();
    };
    EnterpriseMenu.EVENT_TAB_SELECTED = 'tabSelected';
    EnterpriseMenu.TAB_FILTER = 'filterMenuTab';
    EnterpriseMenu.TAB_GENERAL = 'generalMenuTab';
    EnterpriseMenu.TAB_COLUMNS = 'columnsMenuTab';
    EnterpriseMenu.TABS_DEFAULT = [EnterpriseMenu.TAB_GENERAL, EnterpriseMenu.TAB_FILTER, EnterpriseMenu.TAB_COLUMNS];
    EnterpriseMenu.MENU_ITEM_SEPARATOR = 'separator';
    __decorate$A([Autowired('columnModel')], EnterpriseMenu.prototype, 'columnModel', void 0);
    __decorate$A([Autowired('filterManager')], EnterpriseMenu.prototype, 'filterManager', void 0);
    __decorate$A([Autowired('gridApi')], EnterpriseMenu.prototype, 'gridApi', void 0);
    __decorate$A([Autowired('columnApi')], EnterpriseMenu.prototype, 'columnApi', void 0);
    __decorate$A([Autowired('menuItemMapper')], EnterpriseMenu.prototype, 'menuItemMapper', void 0);
    __decorate$A([Autowired('rowModel')], EnterpriseMenu.prototype, 'rowModel', void 0);
    __decorate$A([Autowired('focusService')], EnterpriseMenu.prototype, 'focusService', void 0);
    __decorate$A([PostConstruct], EnterpriseMenu.prototype, 'init', null);
    return EnterpriseMenu;
})(BeanStub);

var __extends$C =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$7 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$7 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$7.apply(this, arguments);
    };
var __decorate$z =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var CSS_MENU = 'ag-menu';
var CSS_CONTEXT_MENU_OPEN = 'ag-context-menu-open';
var ContextMenuFactory = /** @class */ (function (_super) {
    __extends$C(ContextMenuFactory, _super);
    function ContextMenuFactory() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ContextMenuFactory.prototype.hideActiveMenu = function () {
        this.destroyBean(this.activeMenu);
    };
    ContextMenuFactory.prototype.getMenuItems = function (node, column, value) {
        var defaultMenuOptions = [];
        if (_.exists(node) && ModuleRegistry.__isRegistered(ModuleNames.ClipboardModule, this.context.getGridId())) {
            if (column) {
                // only makes sense if column exists, could have originated from a row
                if (!this.gridOptionsService.is('suppressCutToClipboard')) {
                    defaultMenuOptions.push('cut');
                }
                defaultMenuOptions.push('copy', 'copyWithHeaders', 'copyWithGroupHeaders', 'paste', 'separator');
            }
        }
        if (
            this.gridOptionsService.is('enableCharts') &&
            ModuleRegistry.__isRegistered(ModuleNames.GridChartsModule, this.context.getGridId())
        ) {
            if (this.columnModel.isPivotMode()) {
                defaultMenuOptions.push('pivotChart');
            }
            if (this.rangeService && !this.rangeService.isEmpty()) {
                defaultMenuOptions.push('chartRange');
            }
        }
        if (_.exists(node)) {
            // if user clicks a cell
            var csvModuleMissing = !ModuleRegistry.__isRegistered(
                ModuleNames.CsvExportModule,
                this.context.getGridId(),
            );
            var excelModuleMissing = !ModuleRegistry.__isRegistered(
                ModuleNames.ExcelExportModule,
                this.context.getGridId(),
            );
            var suppressExcel = this.gridOptionsService.is('suppressExcelExport') || excelModuleMissing;
            var suppressCsv = this.gridOptionsService.is('suppressCsvExport') || csvModuleMissing;
            var onIPad = _.isIOSUserAgent();
            var anyExport = !onIPad && (!suppressExcel || !suppressCsv);
            if (anyExport) {
                defaultMenuOptions.push('export');
            }
        }
        var userFunc = this.gridOptionsService.getCallback('getContextMenuItems');
        if (userFunc) {
            var params = {
                node: node,
                column: column,
                value: value,
                defaultItems: defaultMenuOptions.length ? defaultMenuOptions : undefined,
            };
            return userFunc(params);
        }
        return defaultMenuOptions;
    };
    ContextMenuFactory.prototype.onContextMenu = function (
        mouseEvent,
        touchEvent,
        rowNode,
        column,
        value,
        anchorToElement,
    ) {
        // to allow us to debug in chrome, we ignore the event if ctrl is pressed.
        // not everyone wants this, so first 'if' below allows to turn this hack off.
        if (!this.gridOptionsService.is('allowContextMenuWithControlKey')) {
            // then do the check
            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) {
                return;
            }
        }
        // need to do this regardless of context menu showing or not, so doing
        // before the isSuppressContextMenu() check
        if (mouseEvent) {
            this.blockMiddleClickScrollsIfNeeded(mouseEvent);
        }
        if (this.gridOptionsService.is('suppressContextMenu')) {
            return;
        }
        var eventOrTouch = mouseEvent ? mouseEvent : touchEvent.touches[0];
        if (this.showMenu(rowNode, column, value, eventOrTouch, anchorToElement)) {
            var event_1 = mouseEvent ? mouseEvent : touchEvent;
            event_1.preventDefault();
        }
    };
    ContextMenuFactory.prototype.blockMiddleClickScrollsIfNeeded = function (mouseEvent) {
        // if we don't do this, then middle click will never result in a 'click' event, as 'mousedown'
        // will be consumed by the browser to mean 'scroll' (as you can scroll with the middle mouse
        // button in the browser). so this property allows the user to receive middle button clicks if
        // they want.
        var gridOptionsService = this.gridOptionsService;
        var which = mouseEvent.which;
        if (gridOptionsService.is('suppressMiddleClickScrolls') && which === 2) {
            mouseEvent.preventDefault();
        }
    };
    ContextMenuFactory.prototype.showMenu = function (node, column, value, mouseEvent, anchorToElement) {
        var _this = this;
        var menuItems = this.getMenuItems(node, column, value);
        var eGridBodyGui = this.ctrlsService.getGridBodyCtrl().getGui();
        if (menuItems === undefined || _.missingOrEmpty(menuItems)) {
            return false;
        }
        var menu = new ContextMenu(menuItems);
        this.createBean(menu);
        var eMenuGui = menu.getGui();
        var positionParams = {
            column: column,
            rowNode: node,
            type: 'contextMenu',
            mouseEvent: mouseEvent,
            ePopup: eMenuGui,
            // move one pixel away so that accidentally double clicking
            // won't show the browser's contextmenu
            nudgeY: 1,
        };
        var translate = this.localeService.getLocaleTextFunc();
        var addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: function () {
                eGridBodyGui.classList.remove(CSS_CONTEXT_MENU_OPEN);
                _this.destroyBean(menu);
            },
            click: mouseEvent,
            positionCallback: function () {
                var isRtl = _this.gridOptionsService.is('enableRtl');
                _this.popupService.positionPopupUnderMouseEvent(
                    __assign$7(__assign$7({}, positionParams), { nudgeX: isRtl ? (eMenuGui.offsetWidth + 1) * -1 : 1 }),
                );
            },
            // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
            anchorToElement: anchorToElement,
            ariaLabel: translate('ariaLabelContextMenu', 'Context Menu'),
        });
        if (addPopupRes) {
            eGridBodyGui.classList.add(CSS_CONTEXT_MENU_OPEN);
            menu.afterGuiAttached({ container: 'contextMenu', hidePopup: addPopupRes.hideFunc });
        }
        // there should never be an active menu at this point, however it was found
        // that you could right click a second time just 1 or 2 pixels from the first
        // click, and another menu would pop up. so somehow the logic for closing the
        // first menu (clicking outside should close it) was glitchy somehow. an easy
        // way to avoid this is just remove the old context menu here if it exists.
        if (this.activeMenu) {
            this.hideActiveMenu();
        }
        this.activeMenu = menu;
        menu.addEventListener(BeanStub.EVENT_DESTROYED, function () {
            if (_this.activeMenu === menu) {
                _this.activeMenu = null;
            }
        });
        // hide the popup if something gets selected
        if (addPopupRes) {
            menu.addEventListener(AgMenuItemComponent.EVENT_MENU_ITEM_SELECTED, addPopupRes.hideFunc);
        }
        return true;
    };
    __decorate$z([Autowired('popupService')], ContextMenuFactory.prototype, 'popupService', void 0);
    __decorate$z([Optional('rangeService')], ContextMenuFactory.prototype, 'rangeService', void 0);
    __decorate$z([Autowired('ctrlsService')], ContextMenuFactory.prototype, 'ctrlsService', void 0);
    __decorate$z([Autowired('columnModel')], ContextMenuFactory.prototype, 'columnModel', void 0);
    ContextMenuFactory = __decorate$z([Bean('contextMenuFactory')], ContextMenuFactory);
    return ContextMenuFactory;
})(BeanStub);
var ContextMenu = /** @class */ (function (_super) {
    __extends$C(ContextMenu, _super);
    function ContextMenu(menuItems) {
        var _this = _super.call(this, /* html */ '<div class="' + CSS_MENU + '" role="presentation"></div>') || this;
        _this.menuList = null;
        _this.focusedCell = null;
        _this.menuItems = menuItems;
        return _this;
    }
    ContextMenu.prototype.addMenuItems = function () {
        var _this = this;
        var menuList = this.createManagedBean(new AgMenuList());
        var menuItemsMapped = this.menuItemMapper.mapWithStockItems(this.menuItems, null);
        menuList.addMenuItems(menuItemsMapped);
        this.appendChild(menuList);
        this.menuList = menuList;
        menuList.addEventListener(AgMenuItemComponent.EVENT_MENU_ITEM_SELECTED, function (e) {
            return _this.dispatchEvent(e);
        });
    };
    ContextMenu.prototype.afterGuiAttached = function (params) {
        if (params.hidePopup) {
            this.addDestroyFunc(params.hidePopup);
        }
        this.focusedCell = this.focusService.getFocusedCell();
        if (this.menuList) {
            this.focusService.focusInto(this.menuList.getGui());
        }
    };
    ContextMenu.prototype.restoreFocusedCell = function () {
        var currentFocusedCell = this.focusService.getFocusedCell();
        if (
            currentFocusedCell &&
            this.focusedCell &&
            this.cellPositionUtils.equals(currentFocusedCell, this.focusedCell)
        ) {
            var _a = this.focusedCell,
                rowIndex = _a.rowIndex,
                rowPinned = _a.rowPinned,
                column = _a.column;
            var doc = this.gridOptionsService.getDocument();
            if (doc.activeElement === doc.body) {
                this.focusService.setFocusedCell({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                });
            }
        }
    };
    ContextMenu.prototype.destroy = function () {
        this.restoreFocusedCell();
        _super.prototype.destroy.call(this);
    };
    __decorate$z([Autowired('menuItemMapper')], ContextMenu.prototype, 'menuItemMapper', void 0);
    __decorate$z([Autowired('focusService')], ContextMenu.prototype, 'focusService', void 0);
    __decorate$z([Autowired('cellPositionUtils')], ContextMenu.prototype, 'cellPositionUtils', void 0);
    __decorate$z([PostConstruct], ContextMenu.prototype, 'addMenuItems', null);
    return ContextMenu;
})(Component);

var __extends$B =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$6 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$6 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$6.apply(this, arguments);
    };
var __decorate$y =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MenuItemMapper = /** @class */ (function (_super) {
    __extends$B(MenuItemMapper, _super);
    function MenuItemMapper() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    MenuItemMapper.prototype.mapWithStockItems = function (originalList, column) {
        var _this = this;
        if (!originalList) {
            return [];
        }
        var resultList = [];
        originalList.forEach(function (menuItemOrString) {
            var result;
            if (typeof menuItemOrString === 'string') {
                result = _this.getStockMenuItem(menuItemOrString, column);
            } else {
                // Spread to prevent leaking mapped subMenus back into the original menuItem
                result = __assign$6({}, menuItemOrString);
            }
            // if no mapping, can happen when module is not loaded but user tries to use module anyway
            if (!result) {
                return;
            }
            var resultDef = result;
            var subMenu = resultDef.subMenu;
            if (subMenu && subMenu instanceof Array) {
                resultDef.subMenu = _this.mapWithStockItems(subMenu, column);
            }
            if (result != null) {
                resultList.push(result);
            }
        });
        return resultList;
    };
    MenuItemMapper.prototype.getStockMenuItem = function (key, column) {
        var _this = this;
        var _a, _b;
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var skipHeaderOnAutoSize = this.gridOptionsService.is('skipHeaderOnAutoSize');
        switch (key) {
            case 'pinSubMenu':
                return {
                    name: localeTextFunc('pinColumn', 'Pin Column'),
                    icon: _.createIconNoSpan('menuPin', this.gridOptionsService, null),
                    subMenu: ['clearPinned', 'pinLeft', 'pinRight'],
                };
            case 'pinLeft':
                return {
                    name: localeTextFunc('pinLeft', 'Pin Left'),
                    action: function () {
                        return _this.columnModel.setColumnPinned(column, 'left', 'contextMenu');
                    },
                    checked: !!column && column.isPinnedLeft(),
                };
            case 'pinRight':
                return {
                    name: localeTextFunc('pinRight', 'Pin Right'),
                    action: function () {
                        return _this.columnModel.setColumnPinned(column, 'right', 'contextMenu');
                    },
                    checked: !!column && column.isPinnedRight(),
                };
            case 'clearPinned':
                return {
                    name: localeTextFunc('noPin', 'No Pin'),
                    action: function () {
                        return _this.columnModel.setColumnPinned(column, null, 'contextMenu');
                    },
                    checked: !!column && !column.isPinned(),
                };
            case 'valueAggSubMenu':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.RowGroupingModule,
                        'Aggregation from Menu',
                        this.context.getGridId(),
                    )
                ) {
                    if (
                        !(column === null || column === void 0 ? void 0 : column.isPrimary()) &&
                        !(column === null || column === void 0 ? void 0 : column.getColDef().pivotValueColumn)
                    ) {
                        return null;
                    }
                    return {
                        name: localeTextFunc('valueAggregation', 'Value Aggregation'),
                        icon: _.createIconNoSpan('menuValue', this.gridOptionsService, null),
                        subMenu: this.createAggregationSubMenu(column),
                    };
                } else {
                    return null;
                }
            case 'autoSizeThis':
                return {
                    name: localeTextFunc('autosizeThiscolumn', 'Autosize This Column'),
                    action: function () {
                        return _this.columnModel.autoSizeColumn(column, skipHeaderOnAutoSize, 'contextMenu');
                    },
                };
            case 'autoSizeAll':
                return {
                    name: localeTextFunc('autosizeAllColumns', 'Autosize All Columns'),
                    action: function () {
                        return _this.columnModel.autoSizeAllColumns(skipHeaderOnAutoSize, 'contextMenu');
                    },
                };
            case 'rowGroup':
                return {
                    name:
                        localeTextFunc('groupBy', 'Group by') +
                        ' ' +
                        _.escapeString(this.columnModel.getDisplayNameForColumn(column, 'header')),
                    disabled:
                        (column === null || column === void 0 ? void 0 : column.isRowGroupActive()) ||
                        !(column === null || column === void 0 ? void 0 : column.getColDef().enableRowGroup),
                    action: function () {
                        return _this.columnModel.addRowGroupColumn(column, 'contextMenu');
                    },
                    icon: _.createIconNoSpan('menuAddRowGroup', this.gridOptionsService, null),
                };
            case 'rowUnGroup':
                var icon = _.createIconNoSpan('menuRemoveRowGroup', this.gridOptionsService, null);
                var showRowGroup_1 = column === null || column === void 0 ? void 0 : column.getColDef().showRowGroup;
                // Handle single auto group column
                if (showRowGroup_1 === true) {
                    return {
                        name: localeTextFunc('ungroupAll', 'Un-Group All'),
                        disabled: !(column === null || column === void 0 ? void 0 : column.getColDef().showRowGroup),
                        action: function () {
                            return _this.columnModel.setRowGroupColumns([], 'contextMenu');
                        },
                        icon: icon,
                    };
                }
                // Handle multiple auto group columns
                if (typeof showRowGroup_1 === 'string') {
                    var underlyingColumn =
                        (_a = this.columnModel.getSourceColumnsForGroupColumn(column)) === null || _a === void 0
                            ? void 0
                            : _a[0];
                    var ungroupByName =
                        underlyingColumn != null
                            ? _.escapeString(this.columnModel.getDisplayNameForColumn(underlyingColumn, 'header'))
                            : showRowGroup_1;
                    return {
                        name: localeTextFunc('ungroupBy', 'Un-Group by') + ' ' + ungroupByName,
                        disabled: !(column === null || column === void 0 ? void 0 : column.getColDef().showRowGroup),
                        action: function () {
                            return _this.columnModel.removeRowGroupColumn(showRowGroup_1, 'contextMenu');
                        },
                        icon: icon,
                    };
                }
                // Handle primary column
                return {
                    name:
                        localeTextFunc('ungroupBy', 'Un-Group by') +
                        ' ' +
                        _.escapeString(this.columnModel.getDisplayNameForColumn(column, 'header')),
                    disabled:
                        !(column === null || column === void 0 ? void 0 : column.isRowGroupActive()) ||
                        !(column === null || column === void 0 ? void 0 : column.getColDef().enableRowGroup),
                    action: function () {
                        return _this.columnModel.removeRowGroupColumn(column, 'contextMenu');
                    },
                    icon: icon,
                };
            case 'resetColumns':
                return {
                    name: localeTextFunc('resetColumns', 'Reset Columns'),
                    action: function () {
                        return _this.columnModel.resetColumnState('contextMenu');
                    },
                };
            case 'expandAll':
                return {
                    name: localeTextFunc('expandAll', 'Expand All Row Groups'),
                    action: function () {
                        return _this.gridApi.expandAll();
                    },
                };
            case 'contractAll':
                return {
                    name: localeTextFunc('collapseAll', 'Collapse All Row Groups'),
                    action: function () {
                        return _this.gridApi.collapseAll();
                    },
                };
            case 'copy':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.ClipboardModule,
                        'Copy from Menu',
                        this.context.getGridId(),
                    )
                ) {
                    return {
                        name: localeTextFunc('copy', 'Copy'),
                        shortcut: localeTextFunc('ctrlC', 'Ctrl+C'),
                        icon: _.createIconNoSpan('clipboardCopy', this.gridOptionsService, null),
                        action: function () {
                            return _this.clipboardService.copyToClipboard();
                        },
                    };
                } else {
                    return null;
                }
            case 'copyWithHeaders':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.ClipboardModule,
                        'Copy with Headers from Menu',
                        this.context.getGridId(),
                    )
                ) {
                    return {
                        name: localeTextFunc('copyWithHeaders', 'Copy with Headers'),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: _.createIconNoSpan('clipboardCopy', this.gridOptionsService, null),
                        action: function () {
                            return _this.clipboardService.copyToClipboard({ includeHeaders: true });
                        },
                    };
                } else {
                    return null;
                }
            case 'copyWithGroupHeaders':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.ClipboardModule,
                        'Copy with Group Headers from Menu',
                        this.context.getGridId(),
                    )
                ) {
                    return {
                        name: localeTextFunc('copyWithGroupHeaders', 'Copy with Group Headers'),
                        // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                        icon: _.createIconNoSpan('clipboardCopy', this.gridOptionsService, null),
                        action: function () {
                            return _this.clipboardService.copyToClipboard({
                                includeHeaders: true,
                                includeGroupHeaders: true,
                            });
                        },
                    };
                } else {
                    return null;
                }
            case 'cut':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.ClipboardModule,
                        'Cut from Menu',
                        this.context.getGridId(),
                    )
                ) {
                    var focusedCell = this.focusService.getFocusedCell();
                    var rowNode = focusedCell ? this.rowPositionUtils.getRowNode(focusedCell) : null;
                    var isEditable = rowNode
                        ? focusedCell === null || focusedCell === void 0
                            ? void 0
                            : focusedCell.column.isCellEditable(rowNode)
                        : false;
                    return {
                        name: localeTextFunc('cut', 'Cut'),
                        shortcut: localeTextFunc('ctrlX', 'Ctrl+X'),
                        icon: _.createIconNoSpan('clipboardCut', this.gridOptionsService, null),
                        disabled: !isEditable || this.gridOptionsService.is('suppressCutToClipboard'),
                        action: function () {
                            return _this.clipboardService.cutToClipboard(undefined, 'contextMenu');
                        },
                    };
                } else {
                    return null;
                }
            case 'paste':
                if (
                    ModuleRegistry.__assertRegistered(
                        ModuleNames.ClipboardModule,
                        'Paste from Clipboard',
                        this.context.getGridId(),
                    )
                ) {
                    return {
                        name: localeTextFunc('paste', 'Paste'),
                        shortcut: localeTextFunc('ctrlV', 'Ctrl+V'),
                        disabled: true,
                        icon: _.createIconNoSpan('clipboardPaste', this.gridOptionsService, null),
                        action: function () {
                            return _this.clipboardService.pasteFromClipboard();
                        },
                    };
                } else {
                    return null;
                }
            case 'export':
                var exportSubMenuItems = [];
                var csvModuleLoaded = ModuleRegistry.__isRegistered(
                    ModuleNames.CsvExportModule,
                    this.context.getGridId(),
                );
                var excelModuleLoaded = ModuleRegistry.__isRegistered(
                    ModuleNames.ExcelExportModule,
                    this.context.getGridId(),
                );
                if (!this.gridOptionsService.is('suppressCsvExport') && csvModuleLoaded) {
                    exportSubMenuItems.push('csvExport');
                }
                if (!this.gridOptionsService.is('suppressExcelExport') && excelModuleLoaded) {
                    exportSubMenuItems.push('excelExport');
                }
                return {
                    name: localeTextFunc('export', 'Export'),
                    subMenu: exportSubMenuItems,
                    icon: _.createIconNoSpan('save', this.gridOptionsService, null),
                };
            case 'csvExport':
                return {
                    name: localeTextFunc('csvExport', 'CSV Export'),
                    icon: _.createIconNoSpan('csvExport', this.gridOptionsService, null),
                    action: function () {
                        return _this.gridApi.exportDataAsCsv({});
                    },
                };
            case 'excelExport':
                return {
                    name: localeTextFunc('excelExport', 'Excel Export'),
                    icon: _.createIconNoSpan('excelExport', this.gridOptionsService, null),
                    action: function () {
                        return _this.gridApi.exportDataAsExcel();
                    },
                };
            case 'separator':
                return 'separator';
            case 'pivotChart':
            case 'chartRange':
                return (_b = this.chartMenuItemMapper.getChartItems(key)) !== null && _b !== void 0 ? _b : null;
            default: {
                console.warn('AG Grid: unknown menu item type ' + key);
                return null;
            }
        }
    };
    MenuItemMapper.prototype.createAggregationSubMenu = function (column) {
        var _this = this;
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var columnToUse;
        if (column.isPrimary()) {
            columnToUse = column;
        } else {
            var pivotValueColumn = column.getColDef().pivotValueColumn;
            columnToUse = _.exists(pivotValueColumn) ? pivotValueColumn : undefined;
        }
        var result = [];
        if (columnToUse) {
            var columnIsAlreadyAggValue_1 = columnToUse.isValueActive();
            var funcNames = this.aggFuncService.getFuncNames(columnToUse);
            result.push({
                name: localeTextFunc('noAggregation', 'None'),
                action: function () {
                    _this.columnModel.removeValueColumn(columnToUse, 'contextMenu');
                    _this.columnModel.setColumnAggFunc(columnToUse, undefined, 'contextMenu');
                },
                checked: !columnIsAlreadyAggValue_1,
            });
            funcNames.forEach(function (funcName) {
                result.push({
                    name: localeTextFunc(funcName, _.capitalise(funcName)),
                    action: function () {
                        _this.columnModel.setColumnAggFunc(columnToUse, funcName, 'contextMenu');
                        _this.columnModel.addValueColumn(columnToUse, 'contextMenu');
                    },
                    checked: columnIsAlreadyAggValue_1 && columnToUse.getAggFunc() === funcName,
                });
            });
        }
        return result;
    };
    __decorate$y([Autowired('columnModel')], MenuItemMapper.prototype, 'columnModel', void 0);
    __decorate$y([Autowired('gridApi')], MenuItemMapper.prototype, 'gridApi', void 0);
    __decorate$y([Optional('clipboardService')], MenuItemMapper.prototype, 'clipboardService', void 0);
    __decorate$y([Optional('aggFuncService')], MenuItemMapper.prototype, 'aggFuncService', void 0);
    __decorate$y([Autowired('focusService')], MenuItemMapper.prototype, 'focusService', void 0);
    __decorate$y([Autowired('rowPositionUtils')], MenuItemMapper.prototype, 'rowPositionUtils', void 0);
    __decorate$y([Autowired('chartMenuItemMapper')], MenuItemMapper.prototype, 'chartMenuItemMapper', void 0);
    MenuItemMapper = __decorate$y([Bean('menuItemMapper')], MenuItemMapper);
    return MenuItemMapper;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$7 = '30.2.0';

var __extends$A =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$5 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$5 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$5.apply(this, arguments);
    };
var __decorate$x =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$8 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var ChartMenuItemMapper = /** @class */ (function (_super) {
    __extends$A(ChartMenuItemMapper, _super);
    function ChartMenuItemMapper() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ChartMenuItemMapper_1 = ChartMenuItemMapper;
    ChartMenuItemMapper.prototype.getChartItems = function (key) {
        var _a, _b;
        if (!this.chartService) {
            ModuleRegistry.__assertRegistered(
                ModuleNames.GridChartsModule,
                'the Context Menu key "' + key + '"',
                this.context.getGridId(),
            );
            return undefined;
        }
        var builder =
            key === 'pivotChart'
                ? new PivotMenuItemMapper(this.gridOptionsService, this.chartService, this.localeService)
                : new RangeMenuItemMapper(this.gridOptionsService, this.chartService, this.localeService);
        var topLevelMenuItem = builder.getMenuItem();
        var chartGroupsDef =
            (_b =
                (_a = this.gridOptionsService.get('chartToolPanelsDef')) === null || _a === void 0
                    ? void 0
                    : _a.settingsPanel) === null || _b === void 0
                ? void 0
                : _b.chartGroupsDef;
        if (chartGroupsDef) {
            // Apply filtering and ordering if chartGroupsDef provided
            topLevelMenuItem = ChartMenuItemMapper_1.filterAndOrderChartMenu(
                topLevelMenuItem,
                chartGroupsDef,
                builder.getConfigLookup(),
            );
        }
        return this.cleanInternals(topLevelMenuItem);
    };
    // Remove our internal _key properties so this does not leak out of the class on the menu items.
    ChartMenuItemMapper.prototype.cleanInternals = function (menuItem) {
        if (!menuItem) {
            return menuItem;
        }
        var removeKey = function (m) {
            var _a;
            m === null || m === void 0 ? true : delete m._key;
            (_a = m === null || m === void 0 ? void 0 : m.subMenu) === null || _a === void 0
                ? void 0
                : _a.forEach(function (s) {
                      return removeKey(s);
                  });
            return m;
        };
        return removeKey(menuItem);
    };
    ChartMenuItemMapper.buildLookup = function (menuItem) {
        var itemLookup = {};
        var addItem = function (item) {
            itemLookup[item._key] = item;
            if (item.subMenu) {
                item.subMenu.forEach(function (s) {
                    return addItem(s);
                });
            }
        };
        addItem(menuItem);
        return itemLookup;
    };
    /**
     * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
     */
    ChartMenuItemMapper.filterAndOrderChartMenu = function (topLevelMenuItem, chartGroupsDef, configLookup) {
        var _a;
        var menuItemLookup = this.buildLookup(topLevelMenuItem);
        var orderedAndFiltered = __assign$5(__assign$5({}, topLevelMenuItem), { subMenu: [] });
        Object.entries(chartGroupsDef).forEach(function (_a) {
            var _b, _c;
            var _d = __read$8(_a, 2),
                group = _d[0],
                chartTypes = _d[1];
            var chartConfigGroup = configLookup[group];
            if (chartConfigGroup == undefined) {
                _.doOnce(function () {
                    return console.warn("AG Grid - invalid chartGroupsDef config '" + group + "'");
                }, 'invalid_chartGroupsDef' + group);
                return undefined;
            }
            var menuItem = menuItemLookup[chartConfigGroup._key];
            if (menuItem) {
                if (menuItem.subMenu) {
                    var subMenus = chartTypes
                        .map(function (chartType) {
                            var itemKey = chartConfigGroup[chartType];
                            if (itemKey == undefined) {
                                _.doOnce(function () {
                                    return console.warn(
                                        "AG Grid - invalid chartGroupsDef config '" + group + '.' + chartType + "'",
                                    );
                                }, 'invalid_chartGroupsDef' + chartType + '_' + group);
                                return undefined;
                            }
                            return menuItemLookup[itemKey];
                        })
                        .filter(function (s) {
                            return s !== undefined;
                        });
                    if (subMenus.length > 0) {
                        menuItem.subMenu = subMenus;
                        (_b = orderedAndFiltered.subMenu) === null || _b === void 0 ? void 0 : _b.push(menuItem);
                    }
                } else {
                    // Handles line case which is not actually a sub subMenu
                    (_c = orderedAndFiltered.subMenu) === null || _c === void 0 ? void 0 : _c.push(menuItem);
                }
            }
        });
        if (((_a = orderedAndFiltered.subMenu) === null || _a === void 0 ? void 0 : _a.length) == 0) {
            return undefined;
        }
        return orderedAndFiltered;
    };
    var ChartMenuItemMapper_1;
    __decorate$x([Optional('chartService')], ChartMenuItemMapper.prototype, 'chartService', void 0);
    ChartMenuItemMapper = ChartMenuItemMapper_1 = __decorate$x([Bean('chartMenuItemMapper')], ChartMenuItemMapper);
    return ChartMenuItemMapper;
})(BeanStub);
var PivotMenuItemMapper = /** @class */ (function () {
    function PivotMenuItemMapper(gridOptionsService, chartService, localeService) {
        this.gridOptionsService = gridOptionsService;
        this.chartService = chartService;
        this.localeService = localeService;
    }
    PivotMenuItemMapper.prototype.getMenuItem = function () {
        var _this = this;
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var getMenuItem = function (localeKey, defaultText, chartType, key) {
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: function () {
                    return _this.chartService.createPivotChart({ chartType: chartType });
                },
                _key: key,
            };
        };
        return {
            name: localeTextFunc('pivotChart', 'Pivot Chart'),
            _key: 'pivotChart',
            subMenu: [
                {
                    _key: 'pivotColumnChart',
                    name: localeTextFunc('columnChart', 'Column'),
                    subMenu: [
                        getMenuItem('groupedColumn', 'Grouped&lrm;', 'groupedColumn', 'pivotGroupedColumn'),
                        getMenuItem('stackedColumn', 'Stacked&lrm;', 'stackedColumn', 'pivotStackedColumn'),
                        getMenuItem(
                            'normalizedColumn',
                            '100% Stacked&lrm;',
                            'normalizedColumn',
                            'pivotNormalizedColumn',
                        ),
                    ],
                },
                {
                    _key: 'pivotBarChart',
                    name: localeTextFunc('barChart', 'Bar'),
                    subMenu: [
                        getMenuItem('groupedBar', 'Grouped&lrm;', 'groupedBar', 'pivotGroupedBar'),
                        getMenuItem('stackedBar', 'Stacked&lrm;', 'stackedBar', 'pivotStackedBar'),
                        getMenuItem('normalizedBar', '100% Stacked&lrm;', 'normalizedBar', 'pivotNormalizedBar'),
                    ],
                },
                {
                    _key: 'pivotPieChart',
                    name: localeTextFunc('pieChart', 'Pie'),
                    subMenu: [
                        getMenuItem('pie', 'Pie&lrm;', 'pie', 'pivotPie'),
                        getMenuItem('doughnut', 'Doughnut&lrm;', 'doughnut', 'pivotDoughnut'),
                    ],
                },
                getMenuItem('line', 'Line&lrm;', 'line', 'pivotLineChart'),
                {
                    _key: 'pivotXYChart',
                    name: localeTextFunc('xyChart', 'X Y (Scatter)'),
                    subMenu: [
                        getMenuItem('scatter', 'Scatter&lrm;', 'scatter', 'pivotScatter'),
                        getMenuItem('bubble', 'Bubble&lrm;', 'bubble', 'pivotBubble'),
                    ],
                },
                {
                    _key: 'pivotAreaChart',
                    name: localeTextFunc('areaChart', 'Area'),
                    subMenu: [
                        getMenuItem('area', 'Area&lrm;', 'area', 'pivotArea'),
                        getMenuItem('stackedArea', 'Stacked&lrm;', 'stackedArea', 'pivotStackedArea'),
                        getMenuItem('normalizedArea', '100% Stacked&lrm;', 'normalizedArea', 'pivotNormalizedArea'),
                    ],
                },
                getMenuItem('histogramChart', 'Histogram&lrm;', 'histogram', 'pivotHistogramChart'),
                {
                    _key: 'pivotCombinationChart',
                    name: localeTextFunc('combinationChart', 'Combination'),
                    subMenu: [
                        getMenuItem('columnLineCombo', 'Column & Line&lrm;', 'columnLineCombo', 'pivotColumnLineCombo'),
                        getMenuItem('AreaColumnCombo', 'Area & Column&lrm;', 'areaColumnCombo', 'pivotAreaColumnCombo'),
                    ],
                },
            ],
            icon: _.createIconNoSpan('chart', this.gridOptionsService, undefined),
        };
    };
    PivotMenuItemMapper.prototype.getConfigLookup = function () {
        return {
            columnGroup: {
                _key: 'pivotColumnChart',
                column: 'pivotGroupedColumn',
                stackedColumn: 'pivotStackedColumn',
                normalizedColumn: 'pivotNormalizedColumn',
            },
            barGroup: {
                _key: 'pivotBarChart',
                bar: 'pivotGroupedBar',
                stackedBar: 'pivotStackedBar',
                normalizedBar: 'pivotNormalizedBar',
            },
            pieGroup: {
                _key: 'pivotPieChart',
                pie: 'pivotPie',
                doughnut: 'pivotDoughnut',
            },
            lineGroup: {
                _key: 'pivotLineChart',
                line: 'pivotLineChart',
            },
            scatterGroup: {
                _key: 'pivotXYChart',
                bubble: 'pivotBubble',
                scatter: 'pivotScatter',
            },
            areaGroup: {
                _key: 'pivotAreaChart',
                area: 'pivotArea',
                stackedArea: 'pivotStackedArea',
                normalizedArea: 'pivotNormalizedArea',
            },
            histogramGroup: {
                _key: 'pivotHistogramChart',
                histogram: 'pivotHistogramChart',
            },
            combinationGroup: {
                _key: 'pivotCombinationChart',
                columnLineCombo: 'pivotColumnLineCombo',
                areaColumnCombo: 'pivotAreaColumnCombo',
                customCombo: '', // Not currently supported but needs a value to separate from a missing value
            },
        };
    };
    return PivotMenuItemMapper;
})();
var RangeMenuItemMapper = /** @class */ (function () {
    function RangeMenuItemMapper(gridOptionsService, chartService, localeService) {
        this.gridOptionsService = gridOptionsService;
        this.chartService = chartService;
        this.localeService = localeService;
    }
    RangeMenuItemMapper.prototype.getMenuItem = function () {
        var _this = this;
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var getMenuItem = function (localeKey, defaultText, chartType, key) {
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: function () {
                    return _this.chartService.createChartFromCurrentRange(chartType);
                },
                _key: key,
            };
        };
        return {
            name: localeTextFunc('chartRange', 'Chart Range'),
            _key: 'chartRange',
            subMenu: [
                {
                    name: localeTextFunc('columnChart', 'Column'),
                    subMenu: [
                        getMenuItem('groupedColumn', 'Grouped&lrm;', 'groupedColumn', 'rangeGroupedColumn'),
                        getMenuItem('stackedColumn', 'Stacked&lrm;', 'stackedColumn', 'rangeStackedColumn'),
                        getMenuItem(
                            'normalizedColumn',
                            '100% Stacked&lrm;',
                            'normalizedColumn',
                            'rangeNormalizedColumn',
                        ),
                    ],
                    _key: 'rangeColumnChart',
                },
                {
                    name: localeTextFunc('barChart', 'Bar'),
                    subMenu: [
                        getMenuItem('groupedBar', 'Grouped&lrm;', 'groupedBar', 'rangeGroupedBar'),
                        getMenuItem('stackedBar', 'Stacked&lrm;', 'stackedBar', 'rangeStackedBar'),
                        getMenuItem('normalizedBar', '100% Stacked&lrm;', 'normalizedBar', 'rangeNormalizedBar'),
                    ],
                    _key: 'rangeBarChart',
                },
                {
                    name: localeTextFunc('pieChart', 'Pie'),
                    subMenu: [
                        getMenuItem('pie', 'Pie&lrm;', 'pie', 'rangePie'),
                        getMenuItem('doughnut', 'Doughnut&lrm;', 'doughnut', 'rangeDoughnut'),
                    ],
                    _key: 'rangePieChart',
                },
                getMenuItem('line', 'Line&lrm;', 'line', 'rangeLineChart'),
                {
                    name: localeTextFunc('xyChart', 'X Y (Scatter)'),
                    subMenu: [
                        getMenuItem('scatter', 'Scatter&lrm;', 'scatter', 'rangeScatter'),
                        getMenuItem('bubble', 'Bubble&lrm;', 'bubble', 'rangeBubble'),
                    ],
                    _key: 'rangeXYChart',
                },
                {
                    name: localeTextFunc('areaChart', 'Area'),
                    subMenu: [
                        getMenuItem('area', 'Area&lrm;', 'area', 'rangeArea'),
                        getMenuItem('stackedArea', 'Stacked&lrm;', 'stackedArea', 'rangeStackedArea'),
                        getMenuItem('normalizedArea', '100% Stacked&lrm;', 'normalizedArea', 'rangeNormalizedArea'),
                    ],
                    _key: 'rangeAreaChart',
                },
                getMenuItem('histogramChart', 'Histogram&lrm;', 'histogram', 'rangeHistogramChart'),
                {
                    name: localeTextFunc('combinationChart', 'Combination'),
                    subMenu: [
                        getMenuItem('columnLineCombo', 'Column & Line&lrm;', 'columnLineCombo', 'rangeColumnLineCombo'),
                        getMenuItem('AreaColumnCombo', 'Area & Column&lrm;', 'areaColumnCombo', 'rangeAreaColumnCombo'),
                    ],
                    _key: 'rangeCombinationChart',
                },
            ],
            icon: _.createIconNoSpan('chart', this.gridOptionsService, undefined),
        };
    };
    RangeMenuItemMapper.prototype.getConfigLookup = function () {
        return {
            columnGroup: {
                _key: 'rangeColumnChart',
                column: 'rangeGroupedColumn',
                stackedColumn: 'rangeStackedColumn',
                normalizedColumn: 'rangeNormalizedColumn',
            },
            barGroup: {
                _key: 'rangeBarChart',
                bar: 'rangeGroupedBar',
                stackedBar: 'rangeStackedBar',
                normalizedBar: 'rangeNormalizedBar',
            },
            pieGroup: {
                _key: 'rangePieChart',
                pie: 'rangePie',
                doughnut: 'rangeDoughnut',
            },
            lineGroup: {
                _key: 'rangeLineChart',
                line: 'rangeLineChart',
            },
            scatterGroup: {
                _key: 'rangeXYChart',
                bubble: 'rangeBubble',
                scatter: 'rangeScatter',
            },
            areaGroup: {
                _key: 'rangeAreaChart',
                area: 'rangeArea',
                stackedArea: 'rangeStackedArea',
                normalizedArea: 'rangeNormalizedArea',
            },
            histogramGroup: {
                _key: 'rangeHistogramChart',
                histogram: 'rangeHistogramChart',
            },
            combinationGroup: {
                _key: 'rangeCombinationChart',
                columnLineCombo: 'rangeColumnLineCombo',
                areaColumnCombo: 'rangeAreaColumnCombo',
                customCombo: '', // Not currently supported but needs a value to separate from a missing value
            },
        };
    };
    return RangeMenuItemMapper;
})();

var MenuModule = {
    version: VERSION$7,
    moduleName: ModuleNames.MenuModule,
    beans: [EnterpriseMenuFactory, ContextMenuFactory, MenuItemMapper, ChartMenuItemMapper],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$z =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$4 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$4 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$4.apply(this, arguments);
    };
var __decorate$w =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MultiFilter = /** @class */ (function (_super) {
    __extends$z(MultiFilter, _super);
    function MultiFilter() {
        var _this = _super.call(this, /* html */ '<div class="ag-multi-filter ag-menu-list-compact"></div>') || this;
        _this.filterDefs = [];
        _this.filters = [];
        _this.guiDestroyFuncs = [];
        _this.activeFilterIndices = [];
        _this.lastActivatedMenuItem = null;
        _this.afterFiltersReadyFuncs = [];
        return _this;
    }
    MultiFilter.prototype.postConstruct = function () {
        var _this = this;
        this.initialiseTabGuard({
            onFocusIn: function (e) {
                return _this.onFocusIn(e);
            },
        });
    };
    MultiFilter.getFilterDefs = function (params) {
        var filters = params.filters;
        return filters && filters.length > 0
            ? filters
            : [{ filter: 'agTextColumnFilter' }, { filter: 'agSetColumnFilter' }];
    };
    MultiFilter.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.filterDefs = MultiFilter.getFilterDefs(params);
        var column = params.column,
            filterChangedCallback = params.filterChangedCallback;
        this.column = column;
        this.filterChangedCallback = filterChangedCallback;
        var filterPromises = [];
        this.filterDefs.forEach(function (filterDef, index) {
            var filterPromise = _this.createFilter(filterDef, index);
            if (filterPromise != null) {
                filterPromises.push(filterPromise);
            }
        });
        // we have to refresh the GUI here to ensure that Angular components are not rendered in odd places
        return AgPromise.all(filterPromises).then(function (filters) {
            _this.filters = filters;
            _this.refreshGui('columnMenu');
            _this.afterFiltersReadyFuncs.forEach(function (f) {
                return f();
            });
            _this.afterFiltersReadyFuncs.length = 0;
        });
    };
    MultiFilter.prototype.refreshGui = function (container) {
        var _this = this;
        if (container === this.lastOpenedInContainer) {
            return;
        }
        this.removeAllChildrenExceptTabGuards();
        this.destroyChildren();
        this.filters.forEach(function (filter, index) {
            if (index > 0) {
                _this.appendChild(_.loadTemplate(/* html */ '<div class="ag-filter-separator"></div>'));
            }
            var filterDef = _this.filterDefs[index];
            var filterTitle = _this.getFilterTitle(filter, filterDef);
            var filterGui;
            if (filterDef.display === 'subMenu' && container !== 'toolPanel') {
                // prevent sub-menu being used in tool panel
                var menuItem = _this.insertFilterMenu(filter, filterTitle);
                filterGui = menuItem.getGui();
            } else if (filterDef.display === 'subMenu' || filterDef.display === 'accordion') {
                // sub-menus should appear as groups in the tool panel
                var group = _this.insertFilterGroup(filter, filterTitle);
                filterGui = group.getGui();
            } else {
                // display inline
                filterGui = filter.getGui();
            }
            _this.appendChild(filterGui);
        });
        this.lastOpenedInContainer = container;
    };
    MultiFilter.prototype.getFilterTitle = function (filter, filterDef) {
        if (filterDef.title != null) {
            return filterDef.title;
        }
        var filterWithoutType = filter;
        return typeof filterWithoutType.getFilterTitle === 'function' ? filterWithoutType.getFilterTitle() : 'Filter';
    };
    MultiFilter.prototype.destroyChildren = function () {
        this.guiDestroyFuncs.forEach(function (func) {
            return func();
        });
        this.guiDestroyFuncs.length = 0;
    };
    MultiFilter.prototype.insertFilterMenu = function (filter, name) {
        var _this = this;
        var menuItem = this.createBean(
            new AgMenuItemComponent({
                name: name,
                subMenu: filter,
                cssClasses: ['ag-multi-filter-menu-item'],
                isCompact: true,
                isAnotherSubMenuOpen: function () {
                    return false;
                },
            }),
        );
        menuItem.setParentComponent(this);
        this.guiDestroyFuncs.push(function () {
            return _this.destroyBean(menuItem);
        });
        this.addManagedListener(menuItem, AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED, function (event) {
            if (_this.lastActivatedMenuItem && _this.lastActivatedMenuItem !== event.menuItem) {
                _this.lastActivatedMenuItem.deactivate();
            }
            _this.lastActivatedMenuItem = event.menuItem;
        });
        menuItem.addGuiEventListener('focusin', function () {
            return menuItem.activate();
        });
        menuItem.addGuiEventListener('focusout', function () {
            if (!menuItem.isSubMenuOpen()) {
                menuItem.deactivate();
            }
        });
        return menuItem;
    };
    MultiFilter.prototype.insertFilterGroup = function (filter, title) {
        var _this = this;
        var group = this.createBean(
            new AgGroupComponent({
                title: title,
                cssIdentifier: 'multi-filter',
            }),
        );
        this.guiDestroyFuncs.push(function () {
            return _this.destroyBean(group);
        });
        group.addItem(filter.getGui());
        group.toggleGroupExpand(false);
        if (filter.afterGuiAttached) {
            group.addManagedListener(group, AgGroupComponent.EVENT_EXPANDED, function () {
                return filter.afterGuiAttached({
                    container: _this.lastOpenedInContainer,
                    suppressFocus: true,
                    hidePopup: _this.hidePopup,
                });
            });
        }
        return group;
    };
    MultiFilter.prototype.isFilterActive = function () {
        return this.filters.some(function (filter) {
            return filter.isFilterActive();
        });
    };
    MultiFilter.prototype.getLastActiveFilterIndex = function () {
        return this.activeFilterIndices.length > 0
            ? this.activeFilterIndices[this.activeFilterIndices.length - 1]
            : null;
    };
    MultiFilter.prototype.doesFilterPass = function (params, filterToSkip) {
        var rowPasses = true;
        this.filters.forEach(function (filter) {
            if (!rowPasses || filter === filterToSkip || !filter.isFilterActive()) {
                return;
            }
            rowPasses = filter.doesFilterPass(params);
        });
        return rowPasses;
    };
    MultiFilter.prototype.getFilterType = function () {
        return 'multi';
    };
    MultiFilter.prototype.getModelFromUi = function () {
        var model = {
            filterType: this.getFilterType(),
            filterModels: this.filters.map(function (filter) {
                var providedFilter = filter;
                if (typeof providedFilter.getModelFromUi === 'function') {
                    return providedFilter.getModelFromUi();
                }
                return null;
            }),
        };
        return model;
    };
    MultiFilter.prototype.getModel = function () {
        if (!this.isFilterActive()) {
            return null;
        }
        var model = {
            filterType: this.getFilterType(),
            filterModels: this.filters.map(function (filter) {
                if (filter.isFilterActive()) {
                    return filter.getModel();
                }
                return null;
            }),
        };
        return model;
    };
    MultiFilter.prototype.setModel = function (model) {
        var _this = this;
        var setFilterModel = function (filter, filterModel) {
            return new AgPromise(function (resolve) {
                var promise = filter.setModel(filterModel);
                promise
                    ? promise.then(function () {
                          return resolve();
                      })
                    : resolve();
            });
        };
        var promises = [];
        if (model == null) {
            promises = this.filters.map(function (filter, index) {
                var res = setFilterModel(filter, null).then(function () {
                    _this.updateActiveList(index);
                });
                return res;
            });
        } else {
            this.filters.forEach(function (filter, index) {
                var filterModel = model.filterModels.length > index ? model.filterModels[index] : null;
                var res = setFilterModel(filter, filterModel).then(function () {
                    _this.updateActiveList(index);
                });
                promises.push(res);
            });
        }
        return AgPromise.all(promises).then(function () {});
    };
    MultiFilter.prototype.applyModel = function (source) {
        if (source === void 0) {
            source = 'api';
        }
        var result = false;
        this.filters.forEach(function (filter) {
            if (filter instanceof ProvidedFilter) {
                result = filter.applyModel(source) || result;
            }
        });
        return result;
    };
    MultiFilter.prototype.getChildFilterInstance = function (index) {
        return this.filters[index];
    };
    MultiFilter.prototype.afterGuiAttached = function (params) {
        if (params) {
            this.hidePopup = params.hidePopup;
            this.refreshGui(params.container);
        } else {
            this.hidePopup = undefined;
        }
        var filters = this.params.filters;
        var suppressFocus =
            filters &&
            filters.some(function (filter) {
                return filter.display && filter.display !== 'inline';
            });
        this.executeFunctionIfExists(
            'afterGuiAttached',
            __assign$4(__assign$4({}, params || {}), { suppressFocus: suppressFocus }),
        );
        var eDocument = this.gridOptionsService.getDocument();
        var activeEl = eDocument.activeElement;
        // if suppress focus is true, we might run into two scenarios:
        // 1 - we are loading the filter for the first time and the component isn't ready,
        //     which means the document will have focus.
        // 2 - The focus will be somewhere inside the component due to auto focus
        // In both cases we need to force the focus somewhere valid but outside the filter.
        if (suppressFocus && (activeEl === eDocument.body || this.getGui().contains(activeEl))) {
            // reset focus to the top of the container, and blur
            this.forceFocusOutOfContainer(true);
        }
    };
    MultiFilter.prototype.afterGuiDetached = function () {
        this.executeFunctionIfExists('afterGuiDetached');
    };
    MultiFilter.prototype.onAnyFilterChanged = function () {
        this.executeFunctionIfExists('onAnyFilterChanged');
    };
    MultiFilter.prototype.onNewRowsLoaded = function () {
        this.executeFunctionIfExists('onNewRowsLoaded');
    };
    MultiFilter.prototype.destroy = function () {
        var _this = this;
        this.filters.forEach(function (filter) {
            filter.setModel(null);
            _this.destroyBean(filter);
        });
        this.filters.length = 0;
        this.destroyChildren();
        this.hidePopup = undefined;
        _super.prototype.destroy.call(this);
    };
    MultiFilter.prototype.executeFunctionIfExists = function (name) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        // The first filter is always the "dominant" one. By iterating in reverse order we ensure the first filter
        // always gets the last say
        _.forEachReverse(this.filters, function (filter) {
            var func = filter[name];
            if (typeof func === 'function') {
                func.apply(filter, params);
            }
        });
    };
    MultiFilter.prototype.createFilter = function (filterDef, index) {
        var _this = this;
        var _a = this.params,
            filterModifiedCallback = _a.filterModifiedCallback,
            doesRowPassOtherFilter = _a.doesRowPassOtherFilter;
        var filterInstance;
        var filterParams = __assign$4(
            __assign$4({}, this.filterManager.createFilterParams(this.column, this.column.getColDef())),
            {
                filterModifiedCallback: filterModifiedCallback,
                filterChangedCallback: function (additionalEventAttributes) {
                    _this.executeWhenAllFiltersReady(function () {
                        return _this.filterChanged(index, additionalEventAttributes);
                    });
                },
                doesRowPassOtherFilter: function (node) {
                    return (
                        doesRowPassOtherFilter(node) &&
                        _this.doesFilterPass({ node: node, data: node.data }, filterInstance)
                    );
                },
            },
        );
        var compDetails = this.userComponentFactory.getFilterDetails(filterDef, filterParams, 'agTextColumnFilter');
        if (!compDetails) {
            return null;
        }
        var filterPromise = compDetails.newAgStackInstance();
        if (filterPromise) {
            filterPromise.then(function (filter) {
                return (filterInstance = filter);
            });
        }
        return filterPromise;
    };
    MultiFilter.prototype.executeWhenAllFiltersReady = function (action) {
        if (this.filters && this.filters.length > 0) {
            action();
        } else {
            this.afterFiltersReadyFuncs.push(action);
        }
    };
    MultiFilter.prototype.updateActiveList = function (index) {
        var changedFilter = this.filters[index];
        _.removeFromArray(this.activeFilterIndices, index);
        if (changedFilter.isFilterActive()) {
            this.activeFilterIndices.push(index);
        }
    };
    MultiFilter.prototype.filterChanged = function (index, additionalEventAttributes) {
        this.updateActiveList(index);
        this.filterChangedCallback(additionalEventAttributes);
        var changedFilter = this.filters[index];
        this.filters.forEach(function (filter) {
            if (filter === changedFilter) {
                return;
            }
            if (typeof filter.onAnyFilterChanged === 'function') {
                filter.onAnyFilterChanged();
            }
        });
    };
    MultiFilter.prototype.onFocusIn = function (e) {
        if (this.lastActivatedMenuItem != null && !this.lastActivatedMenuItem.getGui().contains(e.target)) {
            this.lastActivatedMenuItem.deactivate();
            this.lastActivatedMenuItem = null;
        }
        return true;
    };
    MultiFilter.prototype.getModelAsString = function (model) {
        var _a, _b, _c, _d;
        if (
            !this.filters ||
            !((_a = model === null || model === void 0 ? void 0 : model.filterModels) === null || _a === void 0
                ? void 0
                : _a.length)
        ) {
            return '';
        }
        var lastActiveIndex = (_b = this.getLastActiveFilterIndex()) !== null && _b !== void 0 ? _b : 0;
        var activeFilter = this.filters[lastActiveIndex];
        return (_d =
            (_c = activeFilter.getModelAsString) === null || _c === void 0
                ? void 0
                : _c.call(activeFilter, model.filterModels[lastActiveIndex])) !== null && _d !== void 0
            ? _d
            : '';
    };
    __decorate$w([Autowired('filterManager')], MultiFilter.prototype, 'filterManager', void 0);
    __decorate$w([Autowired('userComponentFactory')], MultiFilter.prototype, 'userComponentFactory', void 0);
    __decorate$w([PostConstruct], MultiFilter.prototype, 'postConstruct', null);
    return MultiFilter;
})(TabGuardComp);

var __extends$y =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$3 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$3 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$3.apply(this, arguments);
    };
var __decorate$v =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var MultiFloatingFilterComp = /** @class */ (function (_super) {
    __extends$y(MultiFloatingFilterComp, _super);
    function MultiFloatingFilterComp() {
        var _this =
            _super.call(this, /* html */ '<div class="ag-multi-floating-filter ag-floating-filter-input"></div>') ||
            this;
        _this.floatingFilters = [];
        _this.compDetailsList = [];
        return _this;
    }
    MultiFloatingFilterComp.prototype.init = function (params) {
        this.params = params;
        var compDetailsList = this.getCompDetailsList(params).compDetailsList;
        return this.setParams(compDetailsList);
    };
    MultiFloatingFilterComp.prototype.setParams = function (compDetailsList) {
        var _this = this;
        var floatingFilterPromises = [];
        compDetailsList.forEach(function (compDetails) {
            var floatingFilterPromise =
                compDetails === null || compDetails === void 0 ? void 0 : compDetails.newAgStackInstance();
            if (floatingFilterPromise != null) {
                _this.compDetailsList.push(compDetails);
                floatingFilterPromises.push(floatingFilterPromise);
            }
        });
        return AgPromise.all(floatingFilterPromises).then(function (floatingFilters) {
            floatingFilters.forEach(function (floatingFilter, index) {
                _this.floatingFilters.push(floatingFilter);
                var gui = floatingFilter.getGui();
                _this.appendChild(gui);
                if (index > 0) {
                    _.setDisplayed(gui, false);
                }
            });
        });
    };
    MultiFloatingFilterComp.prototype.onParamsUpdated = function (params) {
        var _this = this;
        this.params = params;
        var _a = this.getCompDetailsList(params),
            newCompDetailsList = _a.compDetailsList,
            floatingFilterParamsList = _a.floatingFilterParamsList;
        var allFloatingFilterCompsUnchanged =
            newCompDetailsList.length === this.compDetailsList.length &&
            newCompDetailsList.every(function (newCompDetails, index) {
                return !_this.filterManager.areFilterCompsDifferent(_this.compDetailsList[index], newCompDetails);
            });
        if (allFloatingFilterCompsUnchanged) {
            floatingFilterParamsList.forEach(function (floatingFilterParams, index) {
                var _a;
                var floatingFilter = _this.floatingFilters[index];
                (_a = floatingFilter.onParamsUpdated) === null || _a === void 0
                    ? void 0
                    : _a.call(floatingFilter, floatingFilterParams);
            });
        } else {
            _.clearElement(this.getGui());
            this.destroyBeans(this.floatingFilters);
            this.floatingFilters = [];
            this.compDetailsList = [];
            this.setParams(newCompDetailsList);
        }
    };
    MultiFloatingFilterComp.prototype.getCompDetailsList = function (params) {
        var _this = this;
        var compDetailsList = [];
        var floatingFilterParamsList = [];
        var filterParams = params.filterParams;
        MultiFilter.getFilterDefs(filterParams).forEach(function (filterDef, index) {
            var floatingFilterParams = __assign$3(__assign$3({}, params), {
                // set the parent filter instance for each floating filter to the relevant child filter instance
                parentFilterInstance: function (callback) {
                    _this.parentMultiFilterInstance(function (parent) {
                        var child = parent.getChildFilterInstance(index);
                        if (child == null) {
                            return;
                        }
                        callback(child);
                    });
                },
            });
            _.mergeDeep(floatingFilterParams.filterParams, filterDef.filterParams);
            var compDetails = _this.getCompDetails(filterDef, floatingFilterParams);
            if (compDetails) {
                compDetailsList.push(compDetails);
                floatingFilterParamsList.push(floatingFilterParams);
            }
        });
        return { compDetailsList: compDetailsList, floatingFilterParamsList: floatingFilterParamsList };
    };
    MultiFloatingFilterComp.prototype.onParentModelChanged = function (model, event) {
        var _this = this;
        // We don't want to update the floating filter if the floating filter caused the change,
        // because the UI is already in sync. if we didn't do this, the UI would behave strangely
        // as it would be updating as the user is typing
        if (event && event.afterFloatingFilter) {
            return;
        }
        this.parentMultiFilterInstance(function (parent) {
            if (model == null) {
                _this.floatingFilters.forEach(function (filter, i) {
                    filter.onParentModelChanged(null, event);
                    _.setDisplayed(filter.getGui(), i === 0);
                });
            } else {
                var lastActiveFloatingFilterIndex_1 = parent.getLastActiveFilterIndex();
                _this.floatingFilters.forEach(function (filter, i) {
                    var filterModel = model.filterModels.length > i ? model.filterModels[i] : null;
                    filter.onParentModelChanged(filterModel, event);
                    var shouldShow =
                        lastActiveFloatingFilterIndex_1 == null ? i === 0 : i === lastActiveFloatingFilterIndex_1;
                    _.setDisplayed(filter.getGui(), shouldShow);
                });
            }
        });
    };
    MultiFloatingFilterComp.prototype.destroy = function () {
        this.destroyBeans(this.floatingFilters);
        this.floatingFilters.length = 0;
        _super.prototype.destroy.call(this);
    };
    MultiFloatingFilterComp.prototype.getCompDetails = function (filterDef, params) {
        var _this = this;
        var _a;
        var defaultComponentName =
            (_a = this.userComponentFactory.getDefaultFloatingFilterType(filterDef, function () {
                return _this.filterManager.getDefaultFloatingFilter(_this.params.column);
            })) !== null && _a !== void 0
                ? _a
                : 'agReadOnlyFloatingFilter';
        return this.userComponentFactory.getFloatingFilterCompDetails(filterDef, params, defaultComponentName);
    };
    MultiFloatingFilterComp.prototype.parentMultiFilterInstance = function (cb) {
        this.params.parentFilterInstance(function (parent) {
            if (!(parent instanceof MultiFilter)) {
                throw new Error('AG Grid - MultiFloatingFilterComp expects MultiFilter as its parent');
            }
            cb(parent);
        });
    };
    __decorate$v(
        [Autowired('userComponentFactory')],
        MultiFloatingFilterComp.prototype,
        'userComponentFactory',
        void 0,
    );
    __decorate$v([Autowired('filterManager')], MultiFloatingFilterComp.prototype, 'filterManager', void 0);
    return MultiFloatingFilterComp;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$6 = '30.2.0';

var MultiFilterModule = {
    version: VERSION$6,
    moduleName: ModuleNames.MultiFilterModule,
    beans: [],
    userComponents: [
        { componentName: 'agMultiColumnFilter', componentClass: MultiFilter },
        { componentName: 'agMultiColumnFloatingFilter', componentClass: MultiFloatingFilterComp },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$x =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var RichSelectCellEditor = /** @class */ (function (_super) {
    __extends$x(RichSelectCellEditor, _super);
    function RichSelectCellEditor() {
        return _super.call(this, /* html */ '<div class="ag-cell-edit-wrapper"></div>') || this;
    }
    RichSelectCellEditor.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        var cellStartedEdit = params.cellStartedEdit,
            cellHeight = params.cellHeight,
            values = params.values;
        if (_.missing(values)) {
            console.warn('AG Grid: richSelectCellEditor requires values for it to work');
            return;
        }
        var _a = this.buildRichSelectParams(),
            richSelectParams = _a.params,
            valuesPromise = _a.valuesPromise;
        this.richSelect = this.createManagedBean(new AgRichSelect(richSelectParams));
        this.appendChild(this.richSelect);
        if (valuesPromise) {
            valuesPromise.then(function (values) {
                _this.richSelect.setValueList({ valueList: values, refresh: true });
                var searchStringCallback = _this.getSearchStringCallback(values);
                if (searchStringCallback) {
                    _this.richSelect.setSearchStringCreator(searchStringCallback);
                }
            });
        }
        this.addManagedListener(
            this.richSelect,
            Events.EVENT_FIELD_PICKER_VALUE_SELECTED,
            this.onEditorPickerValueSelected.bind(this),
        );
        this.addManagedListener(this.richSelect.getGui(), 'focusout', this.onEditorFocusOut.bind(this));
        this.focusAfterAttached = cellStartedEdit;
        if (_.exists(cellHeight)) {
            this.richSelect.setRowHeight(cellHeight);
        }
    };
    RichSelectCellEditor.prototype.onEditorPickerValueSelected = function (e) {
        this.params.stopEditing(!e.fromEnterKey);
    };
    RichSelectCellEditor.prototype.onEditorFocusOut = function (e) {
        if (this.richSelect.getGui().contains(e.relatedTarget)) {
            return;
        }
        this.params.stopEditing(true);
    };
    RichSelectCellEditor.prototype.buildRichSelectParams = function () {
        var _a = this.params,
            cellRenderer = _a.cellRenderer,
            value = _a.value,
            values = _a.values,
            formatValue = _a.formatValue,
            searchDebounceDelay = _a.searchDebounceDelay,
            valueListGap = _a.valueListGap,
            valueListMaxHeight = _a.valueListMaxHeight,
            valueListMaxWidth = _a.valueListMaxWidth,
            allowTyping = _a.allowTyping,
            filterList = _a.filterList,
            searchType = _a.searchType,
            highlightMatch = _a.highlightMatch,
            valuePlaceholder = _a.valuePlaceholder;
        var ret = {
            value: value,
            cellRenderer: cellRenderer,
            searchDebounceDelay: searchDebounceDelay,
            valueFormatter: formatValue,
            pickerAriaLabelKey: 'ariaLabelRichSelectField',
            pickerAriaLabelValue: 'Rich Select Field',
            pickerType: 'virtual-list',
            pickerGap: valueListGap,
            allowTyping: allowTyping,
            filterList: filterList,
            searchType: searchType,
            highlightMatch: highlightMatch,
            maxPickerHeight: valueListMaxHeight,
            maxPickerWidth: valueListMaxWidth,
            placeholder: valuePlaceholder,
        };
        var valuesResult;
        var valuesPromise;
        if (typeof values === 'function') {
            valuesResult = values(this.params);
        } else {
            valuesResult = values;
        }
        if (Array.isArray(valuesResult)) {
            ret.valueList = valuesResult;
            ret.searchStringCreator = this.getSearchStringCallback(valuesResult);
        } else {
            valuesPromise = valuesResult;
        }
        return { params: ret, valuesPromise: valuesPromise };
    };
    RichSelectCellEditor.prototype.getSearchStringCallback = function (values) {
        var _this = this;
        var colDef = this.params.colDef;
        if (typeof values[0] !== 'object' || !colDef.keyCreator) {
            return;
        }
        return function (values) {
            return values.map(function (value) {
                var keyParams = {
                    value: value,
                    colDef: _this.params.colDef,
                    column: _this.params.column,
                    node: _this.params.node,
                    data: _this.params.data,
                    api: _this.gridOptionsService.api,
                    columnApi: _this.gridOptionsService.columnApi,
                    context: _this.gridOptionsService.context,
                };
                return colDef.keyCreator(keyParams);
            });
        };
    };
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state
    RichSelectCellEditor.prototype.afterGuiAttached = function () {
        var _this = this;
        var _a = this,
            focusAfterAttached = _a.focusAfterAttached,
            params = _a.params;
        setTimeout(function () {
            if (!_this.isAlive()) {
                return;
            }
            if (focusAfterAttached) {
                _this.richSelect.getFocusableElement().focus();
            }
            _this.richSelect.showPicker();
            var eventKey = params.eventKey;
            if (eventKey) {
                if ((eventKey === null || eventKey === void 0 ? void 0 : eventKey.length) === 1) {
                    _this.richSelect.searchTextFromString(eventKey);
                }
            }
        });
    };
    RichSelectCellEditor.prototype.getValue = function () {
        return this.richSelect.getValue();
    };
    RichSelectCellEditor.prototype.isPopup = function () {
        return false;
    };
    return RichSelectCellEditor;
})(PopupComponent);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$5 = '30.2.0';

var RichSelectModule = {
    version: VERSION$5,
    moduleName: ModuleNames.RichSelectModule,
    beans: [],
    userComponents: [
        { componentName: 'agRichSelect', componentClass: RichSelectCellEditor },
        { componentName: 'agRichSelectCellEditor', componentClass: RichSelectCellEditor },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$w =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$u =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FullStore = /** @class */ (function (_super) {
    __extends$w(FullStore, _super);
    function FullStore(ssrmParams, storeParams, parentRowNode) {
        var _this =
            // finite block represents a cache with just one block, thus 0 is the id, it's the first block
            _super.call(this, 0) || this;
        _this.nodeIdSequence = new NumberSequence();
        _this.info = {};
        _this.ssrmParams = ssrmParams;
        _this.parentRowNode = parentRowNode;
        _this.level = parentRowNode.level + 1;
        _this.groupLevel = ssrmParams.rowGroupCols ? _this.level < ssrmParams.rowGroupCols.length : undefined;
        _this.leafGroup = ssrmParams.rowGroupCols ? _this.level === ssrmParams.rowGroupCols.length - 1 : false;
        return _this;
    }
    FullStore.prototype.postConstruct = function () {
        var _this = this;
        this.usingTreeData = this.gridOptionsService.is('treeData');
        this.nodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.parentRowNode);
        if (!this.usingTreeData && this.groupLevel) {
            var groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
        }
        var initialRowCount = 1;
        var isRootStore = this.parentRowNode.level === -1;
        var userInitialRowCount = this.storeUtils.getServerSideInitialRowCount();
        if (isRootStore && userInitialRowCount !== undefined) {
            initialRowCount = userInitialRowCount;
        }
        this.initialiseRowNodes(initialRowCount);
        this.rowNodeBlockLoader.addBlock(this);
        this.addDestroyFunc(function () {
            return _this.rowNodeBlockLoader.removeBlock(_this);
        });
        this.postSortFunc = this.gridOptionsService.getCallback('postSortRows');
    };
    FullStore.prototype.destroyRowNodes = function () {
        this.blockUtils.destroyRowNodes(this.allRowNodes);
        this.allRowNodes = [];
        this.nodesAfterSort = [];
        this.nodesAfterFilter = [];
        this.allNodesMap = {};
    };
    FullStore.prototype.initialiseRowNodes = function (loadingRowsCount, failedLoad) {
        if (failedLoad === void 0) {
            failedLoad = false;
        }
        this.destroyRowNodes();
        for (var i = 0; i < loadingRowsCount; i++) {
            var loadingRowNode = this.blockUtils.createRowNode({
                field: this.groupField,
                group: this.groupLevel,
                leafGroup: this.leafGroup,
                level: this.level,
                parent: this.parentRowNode,
                rowGroupColumn: this.rowGroupColumn,
            });
            if (failedLoad) {
                loadingRowNode.failedLoad = true;
            }
            this.allRowNodes.push(loadingRowNode);
            this.nodesAfterFilter.push(loadingRowNode);
            this.nodesAfterSort.push(loadingRowNode);
        }
    };
    FullStore.prototype.getBlockStateJson = function () {
        return {
            id: this.nodeIdPrefix ? this.nodeIdPrefix : '',
            state: this.getState(),
        };
    };
    FullStore.prototype.loadFromDatasource = function () {
        this.storeUtils.loadFromDatasource({
            startRow: undefined,
            endRow: undefined,
            parentBlock: this,
            parentNode: this.parentRowNode,
            storeParams: this.ssrmParams,
            successCallback: this.pageLoaded.bind(this, this.getVersion()),
            success: this.success.bind(this, this.getVersion()),
            failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
            fail: this.pageLoadFailed.bind(this, this.getVersion()),
        });
    };
    FullStore.prototype.getStartRow = function () {
        return 0; // always zero as not in a cache
    };
    FullStore.prototype.getEndRow = function () {
        return this.nodesAfterSort.length;
    };
    FullStore.prototype.createDataNode = function (data, index) {
        var rowNode = this.blockUtils.createRowNode({
            field: this.groupField,
            group: this.groupLevel,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn,
        });
        if (index != null) {
            _.insertIntoArray(this.allRowNodes, rowNode, index);
        } else {
            this.allRowNodes.push(rowNode);
        }
        var defaultId = this.prefixId(this.nodeIdSequence.next());
        this.blockUtils.setDataIntoRowNode(rowNode, data, defaultId, undefined);
        this.nodeManager.addRowNode(rowNode);
        this.blockUtils.checkOpenByDefault(rowNode);
        this.allNodesMap[rowNode.id] = rowNode;
        return rowNode;
    };
    FullStore.prototype.prefixId = function (id) {
        if (this.nodeIdPrefix) {
            return this.nodeIdPrefix + '-' + id;
        } else {
            return id.toString();
        }
    };
    FullStore.prototype.processServerFail = function () {
        this.initialiseRowNodes(1, true);
        this.fireStoreUpdatedEvent();
        this.flushAsyncTransactions();
    };
    FullStore.prototype.processServerResult = function (params) {
        if (!this.isAlive()) {
            return;
        }
        var info = params.storeInfo || params.groupLevelInfo;
        if (info) {
            Object.assign(this.info, info);
        }
        if (params.pivotResultFields) {
            this.serverSideRowModel.generateSecondaryColumns(params.pivotResultFields);
        }
        var nodesToRecycle = this.allRowNodes.length > 0 ? this.allNodesMap : undefined;
        this.allRowNodes = [];
        this.nodesAfterSort = [];
        this.nodesAfterFilter = [];
        this.allNodesMap = {};
        if (!params.rowData) {
            var message_1 =
                'AG Grid: "params.data" is missing from Server-Side Row Model success() callback. Please use the "data" attribute. If no data is returned, set an empty list.';
            _.doOnce(function () {
                return console.warn(message_1, params);
            }, 'FullStore.noData');
        }
        this.createOrRecycleNodes(nodesToRecycle, params.rowData);
        if (nodesToRecycle) {
            this.blockUtils.destroyRowNodes(_.getAllValuesInObject(nodesToRecycle));
        }
        this.filterAndSortNodes();
        this.fireStoreUpdatedEvent();
        this.flushAsyncTransactions();
    };
    FullStore.prototype.createOrRecycleNodes = function (nodesToRecycle, rowData) {
        var _this = this;
        if (!rowData) {
            return;
        }
        var lookupNodeToRecycle = function (data) {
            if (!nodesToRecycle) {
                return undefined;
            }
            var getRowIdFunc = _this.gridOptionsService.getCallback('getRowId');
            if (!getRowIdFunc) {
                return undefined;
            }
            var parentKeys = _this.parentRowNode.getGroupKeys();
            var level = _this.level;
            var id = getRowIdFunc({
                data: data,
                parentKeys: parentKeys.length > 0 ? parentKeys : undefined,
                level: level,
            });
            var foundNode = nodesToRecycle[id];
            if (!foundNode) {
                return undefined;
            }
            delete nodesToRecycle[id];
            return foundNode;
        };
        var recycleNode = function (rowNode, dataItem) {
            _this.allNodesMap[rowNode.id] = rowNode;
            _this.blockUtils.updateDataIntoRowNode(rowNode, dataItem);
            _this.allRowNodes.push(rowNode);
        };
        rowData.forEach(function (dataItem) {
            var nodeToRecycle = lookupNodeToRecycle(dataItem);
            if (nodeToRecycle) {
                recycleNode(nodeToRecycle, dataItem);
            } else {
                _this.createDataNode(dataItem);
            }
        });
    };
    FullStore.prototype.flushAsyncTransactions = function () {
        var _this = this;
        // we want to update the store with any outstanding transactions straight away,
        // as otherwise if waitTimeMillis is large (eg 5s), then the user could be looking
        // at old data for a few seconds before the transactions is applied, which isn't what
        // you would expect when we advertise 'transaction is applied when data is loaded'.
        // we do this in a timeout as flushAsyncTransactions expects the grid to be in a settled
        // state, not in the middle of loading rows! keeps the VM Turns more simple and deterministic.
        window.setTimeout(function () {
            return _this.transactionManager.flushAsyncTransactions();
        }, 0);
    };
    FullStore.prototype.filterAndSortNodes = function () {
        this.filterRowNodes();
        this.sortRowNodes();
    };
    FullStore.prototype.sortRowNodes = function () {
        var serverIsSorting = this.storeUtils.isServerSideSortAllLevels() || this.storeUtils.isServerSideSortOnServer();
        var sortOptions = this.sortController.getSortOptions();
        var noSortApplied = !sortOptions || sortOptions.length == 0;
        if (serverIsSorting || noSortApplied) {
            this.nodesAfterSort = this.nodesAfterFilter;
            return;
        }
        this.nodesAfterSort = this.rowNodeSorter.doFullSort(this.nodesAfterFilter, sortOptions);
        if (this.postSortFunc) {
            var params = { nodes: this.nodesAfterSort };
            this.postSortFunc(params);
        }
    };
    FullStore.prototype.filterRowNodes = function () {
        var _this = this;
        var serverIsFiltering =
            !this.storeUtils.isServerSideOnlyRefreshFilteredGroups() || this.storeUtils.isServerSideFilterOnServer();
        // filtering for InFullStore only works at lowest level details.
        // reason is the logic for group filtering was to difficult to work out how it should work at time of writing.
        var groupLevel = this.groupLevel;
        if (serverIsFiltering || groupLevel) {
            this.nodesAfterFilter = this.allRowNodes;
            return;
        }
        this.nodesAfterFilter = this.allRowNodes.filter(function (rowNode) {
            return _this.filterManager.doesRowPassFilter({ rowNode: rowNode });
        });
    };
    FullStore.prototype.clearDisplayIndexes = function () {
        var _this = this;
        this.displayIndexStart = undefined;
        this.displayIndexEnd = undefined;
        this.allRowNodes.forEach(function (rowNode) {
            return _this.blockUtils.clearDisplayIndex(rowNode);
        });
    };
    FullStore.prototype.getDisplayIndexEnd = function () {
        return this.displayIndexEnd;
    };
    FullStore.prototype.isDisplayIndexInStore = function (displayIndex) {
        if (this.getRowCount() === 0) {
            return false;
        }
        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
    };
    FullStore.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
        var _this = this;
        this.displayIndexStart = displayIndexSeq.peek();
        this.topPx = nextRowTop.value;
        var visibleNodeIds = {};
        // set on all visible nodes
        this.nodesAfterSort.forEach(function (rowNode) {
            _this.blockUtils.setDisplayIndex(rowNode, displayIndexSeq, nextRowTop);
            visibleNodeIds[rowNode.id] = true;
        });
        // and clear on all non-visible nodes
        this.allRowNodes.forEach(function (rowNode) {
            if (!visibleNodeIds[rowNode.id]) {
                _this.blockUtils.clearDisplayIndex(rowNode);
            }
        });
        this.displayIndexEnd = displayIndexSeq.peek();
        this.heightPx = nextRowTop.value - this.topPx;
    };
    FullStore.prototype.forEachStoreDeep = function (callback, sequence) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        callback(this, sequence.next());
        this.allRowNodes.forEach(function (rowNode) {
            var childCache = rowNode.childStore;
            if (childCache) {
                childCache.forEachStoreDeep(callback, sequence);
            }
        });
    };
    FullStore.prototype.forEachNodeDeep = function (callback, sequence) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        this.allRowNodes.forEach(function (rowNode) {
            callback(rowNode, sequence.next());
            var childCache = rowNode.childStore;
            if (childCache) {
                childCache.forEachNodeDeep(callback, sequence);
            }
        });
    };
    FullStore.prototype.forEachNodeDeepAfterFilterAndSort = function (callback, sequence, includeFooterNodes) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        if (includeFooterNodes === void 0) {
            includeFooterNodes = false;
        }
        this.nodesAfterSort.forEach(function (rowNode) {
            callback(rowNode, sequence.next());
            var childCache = rowNode.childStore;
            if (childCache) {
                childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
            }
        });
        if (includeFooterNodes && this.parentRowNode.sibling) {
            callback(this.parentRowNode.sibling, sequence.next());
        }
    };
    FullStore.prototype.getRowUsingDisplayIndex = function (displayRowIndex) {
        // this can happen if asking for a row that doesn't exist in the model,
        // eg if a cell range is selected, and the user filters so rows no longer exists
        if (!this.isDisplayIndexInStore(displayRowIndex)) {
            return undefined;
        }
        var res = this.blockUtils.binarySearchForDisplayIndex(displayRowIndex, this.nodesAfterSort);
        return res;
    };
    FullStore.prototype.getRowBounds = function (index) {
        for (var i = 0; i < this.nodesAfterSort.length; i++) {
            var rowNode = this.nodesAfterSort[i];
            var res = this.blockUtils.extractRowBounds(rowNode, index);
            if (res) {
                return res;
            }
        }
        return null;
    };
    FullStore.prototype.isPixelInRange = function (pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    };
    FullStore.prototype.getRowIndexAtPixel = function (pixel) {
        var _this = this;
        // if pixel before block, return first row
        var pixelBeforeThisStore = pixel <= this.topPx;
        if (pixelBeforeThisStore) {
            var firstNode = this.nodesAfterSort[0];
            return firstNode.rowIndex;
        }
        // if pixel after store, return last row, however the last
        // row could be a child store
        var pixelAfterThisStore = pixel >= this.topPx + this.heightPx;
        if (pixelAfterThisStore) {
            var lastRowNode = this.nodesAfterSort[this.nodesAfterSort.length - 1];
            var lastRowNodeBottomPx = lastRowNode.rowTop + lastRowNode.rowHeight;
            if (pixel >= lastRowNodeBottomPx && lastRowNode.expanded) {
                if (lastRowNode.childStore && lastRowNode.childStore.getRowCount() > 0) {
                    return lastRowNode.childStore.getRowIndexAtPixel(pixel);
                }
                if (lastRowNode.detailNode) {
                    return lastRowNode.detailNode.rowIndex;
                }
            }
            return lastRowNode.rowIndex;
        }
        var res = null;
        this.nodesAfterSort.forEach(function (rowNode) {
            var res2 = _this.blockUtils.getIndexAtPixel(rowNode, pixel);
            if (res2 != null) {
                res = res2;
            }
        });
        var pixelIsPastLastRow = res == null;
        if (pixelIsPastLastRow) {
            return this.displayIndexEnd - 1;
        }
        return res;
    };
    FullStore.prototype.getChildStore = function (keys) {
        var _this = this;
        return this.storeUtils.getChildStore(keys, this, function (key) {
            var rowNode = _this.allRowNodes.find(function (currentRowNode) {
                return currentRowNode.key == key;
            });
            return rowNode;
        });
    };
    FullStore.prototype.forEachChildStoreShallow = function (callback) {
        this.allRowNodes.forEach(function (rowNode) {
            var childStore = rowNode.childStore;
            if (childStore) {
                callback(childStore);
            }
        });
    };
    FullStore.prototype.refreshAfterFilter = function (params) {
        var serverIsFiltering = this.storeUtils.isServerSideFilterOnServer();
        var storeIsImpacted = this.storeUtils.isServerRefreshNeeded(
            this.parentRowNode,
            this.ssrmParams.rowGroupCols,
            params,
        );
        var serverIsFilteringAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (serverIsFilteringAllLevels || (serverIsFiltering && storeIsImpacted)) {
            this.refreshStore(true);
            this.sortRowNodes();
            return;
        }
        this.filterRowNodes();
        this.sortRowNodes();
        this.forEachChildStoreShallow(function (store) {
            return store.refreshAfterFilter(params);
        });
    };
    FullStore.prototype.refreshAfterSort = function (params) {
        var serverIsSorting = this.storeUtils.isServerSideSortOnServer();
        var storeIsImpacted = this.storeUtils.isServerRefreshNeeded(
            this.parentRowNode,
            this.ssrmParams.rowGroupCols,
            params,
        );
        var serverIsSortingAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (serverIsSortingAllLevels || (serverIsSorting && storeIsImpacted)) {
            this.refreshStore(true);
            this.filterRowNodes();
            return;
        }
        this.filterRowNodes();
        this.sortRowNodes();
        this.forEachChildStoreShallow(function (store) {
            return store.refreshAfterSort(params);
        });
    };
    FullStore.prototype.applyTransaction = function (transaction) {
        // we only apply transactions to loaded state
        switch (this.getState()) {
            case RowNodeBlock.STATE_FAILED:
                return { status: ServerSideTransactionResultStatus.StoreLoadingFailed };
            case RowNodeBlock.STATE_LOADING:
                return { status: ServerSideTransactionResultStatus.StoreLoading };
            case RowNodeBlock.STATE_WAITING_TO_LOAD:
                return { status: ServerSideTransactionResultStatus.StoreWaitingToLoad };
        }
        var applyCallback = this.gridOptionsService.getCallback('isApplyServerSideTransaction');
        if (applyCallback) {
            var params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                storeInfo: this.info,
                groupLevelInfo: this.info,
            };
            var apply = applyCallback(params);
            if (!apply) {
                return { status: ServerSideTransactionResultStatus.Cancelled };
            }
        }
        var res = {
            status: ServerSideTransactionResultStatus.Applied,
            remove: [],
            update: [],
            add: [],
        };
        var nodesToUnselect = [];
        this.executeAdd(transaction, res);
        this.executeRemove(transaction, res, nodesToUnselect);
        this.executeUpdate(transaction, res, nodesToUnselect);
        this.filterAndSortNodes();
        this.updateSelection(nodesToUnselect);
        return res;
    };
    FullStore.prototype.updateSelection = function (nodesToUnselect) {
        var selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) {
            this.selectionService.setNodesSelected({
                newValue: false,
                nodes: nodesToUnselect,
                suppressFinishActions: true,
                clearSelection: false,
                source: 'rowDataChanged',
            });
            var event_1 = {
                type: Events.EVENT_SELECTION_CHANGED,
                source: 'rowDataChanged',
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    FullStore.prototype.executeAdd = function (rowDataTran, rowNodeTransaction) {
        var _this = this;
        var add = rowDataTran.add,
            addIndex = rowDataTran.addIndex;
        if (_.missingOrEmpty(add)) {
            return;
        }
        var useIndex = typeof addIndex === 'number' && addIndex >= 0;
        if (useIndex) {
            // items get inserted in reverse order for index insertion
            add.reverse().forEach(function (item) {
                var newRowNode = _this.createDataNode(item, addIndex);
                rowNodeTransaction.add.push(newRowNode);
            });
        } else {
            add.forEach(function (item) {
                var newRowNode = _this.createDataNode(item);
                rowNodeTransaction.add.push(newRowNode);
            });
        }
    };
    FullStore.prototype.executeRemove = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
        var _this = this;
        var remove = rowDataTran.remove;
        if (remove == null) {
            return;
        }
        var rowIdsRemoved = {};
        remove.forEach(function (item) {
            var rowNode = _this.lookupRowNode(item);
            if (!rowNode) {
                return;
            }
            // do delete - setting 'suppressFinishActions = true' to ensure EVENT_SELECTION_CHANGED is not raised for
            // each row node updated, instead it is raised once by the calling code if any selected nodes exist.
            if (rowNode.isSelected()) {
                nodesToUnselect.push(rowNode);
            }
            // so row renderer knows to fade row out (and not reposition it)
            rowNode.clearRowTopAndRowIndex();
            // NOTE: were we could remove from allLeaveChildren, however _.removeFromArray() is expensive, especially
            // if called multiple times (eg deleting lots of rows) and if allLeafChildren is a large list
            rowIdsRemoved[rowNode.id] = true;
            // _.removeFromArray(this.rootNode.allLeafChildren, rowNode);
            delete _this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
            _this.nodeManager.removeNode(rowNode);
        });
        this.allRowNodes = this.allRowNodes.filter(function (rowNode) {
            return !rowIdsRemoved[rowNode.id];
        });
    };
    FullStore.prototype.executeUpdate = function (rowDataTran, rowNodeTransaction, nodesToUnselect) {
        var _this = this;
        var update = rowDataTran.update;
        if (update == null) {
            return;
        }
        update.forEach(function (item) {
            var rowNode = _this.lookupRowNode(item);
            if (!rowNode) {
                return;
            }
            _this.blockUtils.updateDataIntoRowNode(rowNode, item);
            if (!rowNode.selectable && rowNode.isSelected()) {
                nodesToUnselect.push(rowNode);
            }
            rowNodeTransaction.update.push(rowNode);
        });
    };
    FullStore.prototype.lookupRowNode = function (data) {
        var getRowIdFunc = this.gridOptionsService.getCallback('getRowId');
        var rowNode;
        if (getRowIdFunc != null) {
            // find rowNode using id
            var level = this.level;
            var parentKeys = this.parentRowNode.getGroupKeys();
            var id = getRowIdFunc({
                data: data,
                parentKeys: parentKeys.length > 0 ? parentKeys : undefined,
                level: level,
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                console.error('AG Grid: could not find row id=' + id + ', data item was not found for this id');
                return null;
            }
        } else {
            // find rowNode using object references
            rowNode = this.allRowNodes.find(function (currentRowNode) {
                return currentRowNode.data === data;
            });
            if (!rowNode) {
                console.error('AG Grid: could not find data item as object was not found', data);
                return null;
            }
        }
        return rowNode;
    };
    FullStore.prototype.addStoreStates = function (result) {
        result.push({
            suppressInfiniteScroll: true,
            route: this.parentRowNode.getGroupKeys(),
            rowCount: this.allRowNodes.length,
            info: this.info,
        });
        this.forEachChildStoreShallow(function (childStore) {
            return childStore.addStoreStates(result);
        });
    };
    FullStore.prototype.refreshStore = function (purge) {
        if (purge) {
            var loadingRowsToShow = this.nodesAfterSort ? this.nodesAfterSort.length : 1;
            this.initialiseRowNodes(loadingRowsToShow);
        }
        this.scheduleLoad();
        this.fireStoreUpdatedEvent();
    };
    FullStore.prototype.retryLoads = function () {
        if (this.getState() === RowNodeBlock.STATE_FAILED) {
            this.initialiseRowNodes(1);
            this.scheduleLoad();
        }
        this.forEachChildStoreShallow(function (store) {
            return store.retryLoads();
        });
    };
    FullStore.prototype.scheduleLoad = function () {
        this.setStateWaitingToLoad();
        this.rowNodeBlockLoader.checkBlockToLoad();
    };
    // gets called 1) row count changed 2) cache purged 3) items inserted
    FullStore.prototype.fireStoreUpdatedEvent = function () {
        // this results in row model firing ModelUpdated.
        // server side row model also updates the row indexes first
        var event = {
            type: Events.EVENT_STORE_UPDATED,
        };
        this.eventService.dispatchEvent(event);
    };
    FullStore.prototype.getRowCount = function () {
        return this.nodesAfterSort.length;
    };
    FullStore.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
        var rowNode = this.nodesAfterSort[topLevelIndex];
        return rowNode.rowIndex;
    };
    FullStore.prototype.isLastRowIndexKnown = function () {
        return this.getState() == RowNodeBlock.STATE_LOADED;
    };
    FullStore.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
        var result = [];
        var inActiveRange = false;
        // if only one node passed, we start the selection at the top
        if (_.missing(firstInRange)) {
            inActiveRange = true;
        }
        this.nodesAfterSort.forEach(function (rowNode) {
            var hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
            if (inActiveRange || hitFirstOrLast) {
                result.push(rowNode);
            }
            if (hitFirstOrLast) {
                inActiveRange = !inActiveRange;
            }
        });
        // inActiveRange will be still true if we never hit the second rowNode
        var invalidRange = inActiveRange;
        return invalidRange ? [] : result;
    };
    FullStore.prototype.getStoreBounds = function () {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx,
        };
    };
    __decorate$u([Autowired('ssrmStoreUtils')], FullStore.prototype, 'storeUtils', void 0);
    __decorate$u([Autowired('ssrmBlockUtils')], FullStore.prototype, 'blockUtils', void 0);
    __decorate$u([Autowired('columnModel')], FullStore.prototype, 'columnModel', void 0);
    __decorate$u([Autowired('rowNodeBlockLoader')], FullStore.prototype, 'rowNodeBlockLoader', void 0);
    __decorate$u([Autowired('rowNodeSorter')], FullStore.prototype, 'rowNodeSorter', void 0);
    __decorate$u([Autowired('sortController')], FullStore.prototype, 'sortController', void 0);
    __decorate$u([Autowired('selectionService')], FullStore.prototype, 'selectionService', void 0);
    __decorate$u([Autowired('ssrmNodeManager')], FullStore.prototype, 'nodeManager', void 0);
    __decorate$u([Autowired('filterManager')], FullStore.prototype, 'filterManager', void 0);
    __decorate$u([Autowired('ssrmTransactionManager')], FullStore.prototype, 'transactionManager', void 0);
    __decorate$u([Autowired('rowModel')], FullStore.prototype, 'serverSideRowModel', void 0);
    __decorate$u([PostConstruct], FullStore.prototype, 'postConstruct', null);
    __decorate$u([PreDestroy], FullStore.prototype, 'destroyRowNodes', null);
    return FullStore;
})(RowNodeBlock);

var __extends$v =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$t =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$7 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var LazyBlockLoader = /** @class */ (function (_super) {
    __extends$v(LazyBlockLoader, _super);
    function LazyBlockLoader(cache, parentNode, storeParams) {
        var _this = _super.call(this) || this;
        _this.loadingNodes = new Set();
        _this.checkForLoadQueued = false;
        _this.loaderTimeout = undefined;
        _this.nextBlockToLoad = undefined;
        _this.parentNode = parentNode;
        _this.cache = cache;
        _this.storeParams = storeParams;
        return _this;
    }
    LazyBlockLoader.prototype.init = function () {
        var _this = this;
        this.addManagedListener(this.rowNodeBlockLoader, RowNodeBlockLoader.BLOCK_LOADED_EVENT, function () {
            return _this.queueLoadAction();
        });
    };
    LazyBlockLoader.prototype.isRowLoading = function (index) {
        return this.loadingNodes.has(index);
    };
    LazyBlockLoader.prototype.getBlockToLoad = function () {
        var _this = this;
        var _a;
        var firstRowInViewport = this.api.getFirstDisplayedRow();
        var lastRowInViewport = this.api.getLastDisplayedRow();
        // quick look-up for priority rows needing loading in viewport.
        for (var i = firstRowInViewport; i <= lastRowInViewport; i++) {
            var node = this.cache.getNodeCachedByDisplayIndex(i);
            if (!node) {
                // if no row details, ignore, as row hasn't been created
                // and it's too expensive to work out its location here
                continue;
            }
            var lazyNode = this.cache.getNodes().getBy('node', node);
            if (!lazyNode) {
                continue;
            }
            if (this.isRowLoading(lazyNode.index)) {
                continue;
            }
            if (node.__needsRefreshWhenVisible || (node.stub && !node.failedLoad)) {
                return this.getBlockStartIndexForIndex(lazyNode.index);
            }
        }
        var nodesToRefresh = this.cache.getNodesToRefresh();
        var nodeToRefresh = null;
        var nodeToRefreshDist = Number.MAX_SAFE_INTEGER;
        nodesToRefresh.forEach(function (node) {
            if (node.rowIndex == null) {
                nodeToRefresh = node;
                return;
            }
            if (_this.isRowLoading(node.rowIndex)) {
                return;
            }
            var distToViewportTop = Math.abs(firstRowInViewport - node.rowIndex);
            var distToViewportBottom = Math.abs(node.rowIndex - lastRowInViewport);
            if (distToViewportTop < nodeToRefreshDist) {
                nodeToRefresh = node;
                nodeToRefreshDist = distToViewportTop;
            }
            if (distToViewportBottom < nodeToRefreshDist) {
                nodeToRefresh = node;
                nodeToRefreshDist = distToViewportBottom;
            }
        });
        var lazyIndex =
            (_a = this.cache.getNodes().getBy('node', nodeToRefresh)) === null || _a === void 0 ? void 0 : _a.index;
        return lazyIndex == null ? undefined : this.getBlockStartIndexForIndex(lazyIndex);
    };
    LazyBlockLoader.prototype.reset = function () {
        this.loadingNodes.clear();
        clearTimeout(this.loaderTimeout);
        this.loaderTimeout = undefined;
    };
    LazyBlockLoader.prototype.executeLoad = function (startRow, endRow) {
        var _this = this;
        var _a;
        var ssrmParams = this.cache.getSsrmParams();
        var request = {
            startRow: startRow,
            endRow: endRow,
            rowGroupCols: ssrmParams.rowGroupCols,
            valueCols: ssrmParams.valueCols,
            pivotCols: ssrmParams.pivotCols,
            pivotMode: ssrmParams.pivotMode,
            groupKeys: this.parentNode.getGroupKeys(),
            filterModel: ssrmParams.filterModel,
            sortModel: ssrmParams.sortModel,
        };
        var removeNodesFromLoadingMap = function () {
            for (var i = 0; i < endRow - startRow; i++) {
                _this.loadingNodes.delete(startRow + i);
            }
        };
        var addNodesToLoadingMap = function () {
            for (var i = 0; i < endRow - startRow; i++) {
                _this.loadingNodes.add(startRow + i);
            }
        };
        var success = function (params) {
            _this.rowNodeBlockLoader.loadComplete();
            _this.cache.onLoadSuccess(startRow, endRow - startRow, params);
            removeNodesFromLoadingMap();
            _this.queueLoadAction();
        };
        var fail = function () {
            _this.rowNodeBlockLoader.loadComplete();
            _this.cache.onLoadFailed(startRow, endRow - startRow);
            removeNodesFromLoadingMap();
            _this.queueLoadAction();
        };
        var params = {
            request: request,
            successCallback: function (rowData, rowCount) {
                return success({ rowData: rowData, rowCount: rowCount });
            },
            success: success,
            failCallback: fail,
            fail: fail,
            parentNode: this.parentNode,
            api: this.api,
            columnApi: this.columnApi,
            context: this.gridOptionsService.context,
        };
        addNodesToLoadingMap();
        (_a = this.cache.getSsrmParams().datasource) === null || _a === void 0 ? void 0 : _a.getRows(params);
    };
    LazyBlockLoader.prototype.getNextBlockToLoad = function () {
        var result = this.getBlockToLoad();
        if (result != null) {
            return [String(result), result + this.getBlockSize()];
        }
        return null;
    };
    LazyBlockLoader.prototype.queueLoadCheck = function () {
        var _this = this;
        // already going to check next cycle, ignore.
        if (this.checkForLoadQueued) {
            return;
        }
        this.checkForLoadQueued = true;
        window.queueMicrotask(function () {
            _this.checkForLoadQueued = false;
            _this.queueLoadAction();
        });
    };
    LazyBlockLoader.prototype.queueLoadAction = function () {
        var _this = this;
        var _a;
        var nextBlockToLoad = this.getNextBlockToLoad();
        if (!nextBlockToLoad) {
            // there's no block we should be loading right now, clear the timeouts
            window.clearTimeout(this.loaderTimeout);
            this.loaderTimeout = undefined;
            this.nextBlockToLoad = undefined;
            return;
        }
        // if the next required block has changed, reset the loading timeout
        if (
            !this.nextBlockToLoad ||
            (this.nextBlockToLoad[0] !== nextBlockToLoad[0] && this.nextBlockToLoad[1] !== nextBlockToLoad[1])
        ) {
            this.nextBlockToLoad = nextBlockToLoad;
            window.clearTimeout(this.loaderTimeout);
            var _b = __read$7(this.nextBlockToLoad, 2),
                startRowString = _b[0],
                endRow_1 = _b[1];
            var startRow_1 = Number(startRowString);
            this.loaderTimeout = window.setTimeout(
                function () {
                    if (!_this.cache.isAlive()) {
                        return;
                    }
                    _this.loaderTimeout = undefined;
                    _this.attemptLoad(startRow_1, endRow_1);
                    _this.nextBlockToLoad = undefined;
                },
                (_a = this.gridOptionsService.getNum('blockLoadDebounceMillis')) !== null && _a !== void 0 ? _a : 0,
            );
        }
    };
    LazyBlockLoader.prototype.attemptLoad = function (start, end) {
        var availableLoadingCount = this.rowNodeBlockLoader.getAvailableLoadingCount();
        // too many loads already, ignore the request as a successful request will requeue itself anyway
        if (availableLoadingCount != null && availableLoadingCount === 0) {
            return;
        }
        this.rowNodeBlockLoader.registerLoads(1);
        this.executeLoad(start, end);
        this.queueLoadAction();
    };
    LazyBlockLoader.prototype.getBlockSize = function () {
        return this.storeParams.cacheBlockSize || LazyBlockLoader.DEFAULT_BLOCK_SIZE;
    };
    LazyBlockLoader.prototype.getBlockStartIndexForIndex = function (storeIndex) {
        var blockSize = this.getBlockSize();
        return storeIndex - (storeIndex % blockSize);
    };
    LazyBlockLoader.prototype.getBlockBoundsForIndex = function (storeIndex) {
        var startOfBlock = this.getBlockStartIndexForIndex(storeIndex);
        var blockSize = this.getBlockSize();
        return [startOfBlock, startOfBlock + blockSize];
    };
    LazyBlockLoader.DEFAULT_BLOCK_SIZE = 100;
    __decorate$t([Autowired('gridApi')], LazyBlockLoader.prototype, 'api', void 0);
    __decorate$t([Autowired('columnApi')], LazyBlockLoader.prototype, 'columnApi', void 0);
    __decorate$t([Autowired('rowNodeBlockLoader')], LazyBlockLoader.prototype, 'rowNodeBlockLoader', void 0);
    __decorate$t([PostConstruct], LazyBlockLoader.prototype, 'init', null);
    return LazyBlockLoader;
})(BeanStub);

var MultiIndexMap = /** @class */ (function () {
    function MultiIndexMap() {
        var indexes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            indexes[_i] = arguments[_i];
        }
        if (indexes.length < 1) {
            throw new Error('AG Grid: At least one index must be provided.');
        }
        this.indexes = indexes;
        this.maps = new Map(
            this.indexes.map(function (index) {
                return [index, new Map()];
            }),
        );
    }
    MultiIndexMap.prototype.getBy = function (index, key) {
        var map = this.maps.get(index);
        if (!map) {
            throw new Error('AG Grid: ' + String(index) + ' not found');
        }
        return map.get(key);
    };
    MultiIndexMap.prototype.set = function (item) {
        var _this = this;
        this.indexes.forEach(function (index) {
            var map = _this.maps.get(index);
            if (!map) {
                throw new Error('AG Grid: ' + String(index) + ' not found');
            }
            map.set(item[index], item);
        });
    };
    MultiIndexMap.prototype.delete = function (item) {
        var _this = this;
        this.indexes.forEach(function (index) {
            var map = _this.maps.get(index);
            if (!map) {
                throw new Error('AG Grid: ' + String(index) + ' not found');
            }
            map.delete(item[index]);
        });
    };
    MultiIndexMap.prototype.clear = function () {
        this.maps.forEach(function (map) {
            return map.clear();
        });
    };
    MultiIndexMap.prototype.getIterator = function (index) {
        var map = this.maps.get(index);
        if (!map) {
            throw new Error('AG Grid: ' + String(index) + ' not found');
        }
        return map.values();
    };
    MultiIndexMap.prototype.forEach = function (callback) {
        var iterator = this.getIterator(this.indexes[0]);
        var pointer;
        while ((pointer = iterator.next())) {
            if (pointer.done) break;
            callback(pointer.value);
        }
    };
    MultiIndexMap.prototype.find = function (callback) {
        var iterator = this.getIterator(this.indexes[0]);
        var pointer;
        while ((pointer = iterator.next())) {
            if (pointer.done) break;
            if (callback(pointer.value)) {
                return pointer.value;
            }
        }
    };
    MultiIndexMap.prototype.filter = function (predicate) {
        var iterator = this.getIterator(this.indexes[0]);
        var pointer;
        var result = [];
        while ((pointer = iterator.next())) {
            if (pointer.done) break;
            if (predicate(pointer.value)) {
                result.push(pointer.value);
            }
        }
        return result;
    };
    return MultiIndexMap;
})();

var __extends$u =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$s =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$6 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$5 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var LazyCache = /** @class */ (function (_super) {
    __extends$u(LazyCache, _super);
    function LazyCache(store, numberOfRows, storeParams) {
        var _this = _super.call(this) || this;
        /**
         * Indicates whether this is still the live dataset for this store (used for ignoring old requests after purge)
         */
        _this.live = true;
        /**
         * A cache of removed group nodes, this is retained for preserving group
         * state when the node moves in and out of the cache. Generally caused by
         * rows moving blocks.
         */
        _this.removedNodeCache = new Map();
        _this.store = store;
        _this.numberOfRows = numberOfRows;
        _this.isLastRowKnown = false;
        _this.storeParams = storeParams;
        return _this;
    }
    LazyCache.prototype.init = function () {
        // initiate the node map to be indexed at 'index', 'id' and 'node' for quick look-up.
        // it's important id isn't first, as stub nodes overwrite each-other, and the first index is
        // used for iteration.
        this.nodeMap = new MultiIndexMap('index', 'id', 'node');
        this.nodeDisplayIndexMap = new Map();
        this.nodesToRefresh = new Set();
        this.defaultNodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        this.rowLoader = this.createManagedBean(
            new LazyBlockLoader(this, this.store.getParentNode(), this.storeParams),
        );
        this.getRowIdFunc = this.gridOptionsService.getCallback('getRowId');
        this.isMasterDetail = this.gridOptionsService.is('masterDetail');
    };
    LazyCache.prototype.destroyRowNodes = function () {
        var _this = this;
        this.numberOfRows = 0;
        this.nodeMap.forEach(function (node) {
            return _this.blockUtils.destroyRowNode(node.node);
        });
        this.nodeMap.clear();
        this.nodeDisplayIndexMap.clear();
        this.nodesToRefresh.clear();
        this.live = false;
    };
    /**
     * Get the row node for a specific display index from this store
     * @param displayIndex the display index of the node to find
     * @returns undefined if the node is not in the store bounds, otherwise will always return a node
     */
    LazyCache.prototype.getRowByDisplayIndex = function (displayIndex) {
        var _a, _b, _c, _d;
        // if index isn't in store, nothing to return
        if (!this.store.isDisplayIndexInStore(displayIndex)) {
            return undefined;
        }
        // first try to directly look this node up in the display index map
        var node = this.nodeDisplayIndexMap.get(displayIndex);
        if (node) {
            // if we have the node, check if it needs refreshed when rendered
            if (node.stub || node.__needsRefreshWhenVisible) {
                this.rowLoader.queueLoadCheck();
            }
            return node;
        }
        // next check if this is the first row, if so return a stub node
        // this is a performance optimisation, as it is the most common scenario
        // and enables the node - 1 check to kick in more often.
        if (displayIndex === this.store.getDisplayIndexStart()) {
            return this.createStubNode(0, displayIndex);
        }
        // check if the row immediately prior is available in the store
        var contiguouslyPreviousNode = this.nodeDisplayIndexMap.get(displayIndex - 1);
        if (contiguouslyPreviousNode) {
            // if previous row is master detail, and expanded, this node must be detail
            if (this.isMasterDetail && contiguouslyPreviousNode.master && contiguouslyPreviousNode.expanded) {
                return contiguouslyPreviousNode.detailNode;
            }
            // if previous row is expanded group, this node will belong to that group.
            if (
                contiguouslyPreviousNode.expanded &&
                ((_a = contiguouslyPreviousNode.childStore) === null || _a === void 0
                    ? void 0
                    : _a.isDisplayIndexInStore(displayIndex))
            ) {
                return (_b = contiguouslyPreviousNode.childStore) === null || _b === void 0
                    ? void 0
                    : _b.getRowUsingDisplayIndex(displayIndex);
            }
            // otherwise, row must be a stub node
            var lazyCacheNode = this.nodeMap.getBy('node', contiguouslyPreviousNode);
            return this.createStubNode(lazyCacheNode.index + 1, displayIndex);
        }
        var adjacentNodes = this.getSurroundingNodesByDisplayIndex(displayIndex);
        // if no bounds skipped includes this, calculate from end index
        if (adjacentNodes == null) {
            var storeIndexFromEndIndex_1 = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
            return this.createStubNode(storeIndexFromEndIndex_1, displayIndex);
        }
        var previousNode = adjacentNodes.previousNode,
            nextNode = adjacentNodes.nextNode;
        // if the node before this node is expanded, this node might be a child of that node
        if (
            previousNode &&
            previousNode.node.expanded &&
            ((_c = previousNode.node.childStore) === null || _c === void 0
                ? void 0
                : _c.isDisplayIndexInStore(displayIndex))
        ) {
            return (_d = previousNode.node.childStore) === null || _d === void 0
                ? void 0
                : _d.getRowUsingDisplayIndex(displayIndex);
        }
        // if we have the node after this node, we can calculate the store index of this node by the difference
        // in display indexes between the two nodes.
        if (nextNode) {
            var displayIndexDiff = nextNode.node.rowIndex - displayIndex;
            var newStoreIndex = nextNode.index - displayIndexDiff;
            return this.createStubNode(newStoreIndex, displayIndex);
        }
        // if no next node, calculate from end index of this store
        var storeIndexFromEndIndex = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
        return this.createStubNode(storeIndexFromEndIndex, displayIndex);
    };
    /**
     * Used for creating and positioning a stub node without firing a store updated event
     */
    LazyCache.prototype.createStubNode = function (storeIndex, displayIndex) {
        var _this = this;
        // bounds are acquired before creating the node, as otherwise it'll use it's own empty self to calculate
        var rowBounds = this.store.getRowBounds(displayIndex);
        var newNode = this.createRowAtIndex(storeIndex, null, function (node) {
            node.setRowIndex(displayIndex);
            node.setRowTop(rowBounds.rowTop);
            _this.nodeDisplayIndexMap.set(displayIndex, node);
        });
        this.rowLoader.queueLoadCheck();
        return newNode;
    };
    /**
     * @param index The row index relative to this store
     * @returns A rowNode at the given store index
     */
    LazyCache.prototype.getRowByStoreIndex = function (index) {
        var _a;
        return (_a = this.nodeMap.getBy('index', index)) === null || _a === void 0 ? void 0 : _a.node;
    };
    /**
     * Given a number of rows, skips through the given sequence & row top reference (using default row height)
     * @param numberOfRowsToSkip number of rows to skip over in the given sequence
     * @param displayIndexSeq the sequence in which to skip
     * @param nextRowTop the row top reference in which to skip
     */
    LazyCache.prototype.skipDisplayIndexes = function (numberOfRowsToSkip, displayIndexSeq, nextRowTop) {
        if (numberOfRowsToSkip === 0) {
            return;
        }
        var defaultRowHeight = this.gridOptionsService.getRowHeightAsNumber();
        displayIndexSeq.skip(numberOfRowsToSkip);
        nextRowTop.value += numberOfRowsToSkip * defaultRowHeight;
    };
    /**
     * @param displayIndexSeq the number sequence for generating the display index of each row
     * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
     */
    LazyCache.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
        // Create a map of display index nodes for access speed
        this.nodeDisplayIndexMap.clear();
        // create an object indexed by store index, as this will sort all of the nodes when we iterate
        // the object
        var orderedMap = {};
        this.nodeMap.forEach(function (lazyNode) {
            orderedMap[lazyNode.index] = lazyNode.node;
        });
        var lastIndex = -1;
        // iterate over the nodes in order, setting the display index on each node.
        for (var stringIndex in orderedMap) {
            var node = orderedMap[stringIndex];
            var numericIndex = Number(stringIndex);
            // if any nodes aren't currently in the store, skip the display indexes too
            var numberOfRowsToSkip_1 = numericIndex - 1 - lastIndex;
            this.skipDisplayIndexes(numberOfRowsToSkip_1, displayIndexSeq, nextRowTop);
            // set this nodes index and row top
            this.blockUtils.setDisplayIndex(node, displayIndexSeq, nextRowTop);
            this.nodeDisplayIndexMap.set(node.rowIndex, node);
            // store this index for skipping after this
            lastIndex = numericIndex;
        }
        // need to skip rows until the end of this store
        var numberOfRowsToSkip = this.numberOfRows - 1 - lastIndex;
        this.skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop);
        // this is not terribly efficient, and could probs be improved
        this.purgeExcessRows();
    };
    LazyCache.prototype.getRowCount = function () {
        return this.numberOfRows;
    };
    LazyCache.prototype.setRowCount = function (rowCount, isLastRowIndexKnown) {
        if (rowCount < 0) {
            throw new Error('AG Grid: setRowCount can only accept a positive row count.');
        }
        this.numberOfRows = rowCount;
        if (isLastRowIndexKnown != null) {
            this.isLastRowKnown = isLastRowIndexKnown;
            if (isLastRowIndexKnown === false) {
                this.numberOfRows += 1;
            }
        }
        this.fireStoreUpdatedEvent();
    };
    LazyCache.prototype.getNodes = function () {
        return this.nodeMap;
    };
    LazyCache.prototype.getNodeCachedByDisplayIndex = function (displayIndex) {
        var _a;
        return (_a = this.nodeDisplayIndexMap.get(displayIndex)) !== null && _a !== void 0 ? _a : null;
    };
    LazyCache.prototype.getNodesToRefresh = function () {
        return this.nodesToRefresh;
    };
    /**
     * @returns the previous and next loaded row nodes surrounding the given display index
     */
    LazyCache.prototype.getSurroundingNodesByDisplayIndex = function (displayIndex) {
        var nextNode;
        var previousNode;
        this.nodeMap.forEach(function (lazyNode) {
            // previous node
            if (displayIndex > lazyNode.node.rowIndex) {
                // get the largest previous node
                if (previousNode == null || previousNode.node.rowIndex < lazyNode.node.rowIndex) {
                    previousNode = lazyNode;
                }
                return;
            }
            // next node
            // get the smallest next node
            if (nextNode == null || nextNode.node.rowIndex > lazyNode.node.rowIndex) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!previousNode && !nextNode) return null;
        return { previousNode: previousNode, nextNode: nextNode };
    };
    /**
     * Get or calculate the display index for a given store index
     * @param storeIndex the rows index within this store
     * @returns the rows visible display index relative to the grid
     */
    LazyCache.prototype.getDisplayIndexFromStoreIndex = function (storeIndex) {
        var _a, _b;
        var nodeAtIndex = this.nodeMap.getBy('index', storeIndex);
        if (nodeAtIndex) {
            return nodeAtIndex.node.rowIndex;
        }
        var nextNode;
        var previousNode;
        this.nodeMap.forEach(function (lazyNode) {
            // previous node
            if (storeIndex > lazyNode.index) {
                // get the largest previous node
                if (previousNode == null || previousNode.index < lazyNode.index) {
                    previousNode = lazyNode;
                }
                return;
            }
            // next node
            // get the smallest next node
            if (nextNode == null || nextNode.index > lazyNode.index) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!nextNode) {
            return this.store.getDisplayIndexEnd() - (this.numberOfRows - storeIndex);
        }
        if (!previousNode) {
            return this.store.getDisplayIndexStart() + storeIndex;
        }
        var storeIndexDiff = storeIndex - previousNode.index;
        var previousDisplayIndex =
            (_b = (_a = previousNode.node.childStore) === null || _a === void 0 ? void 0 : _a.getDisplayIndexEnd()) !==
                null && _b !== void 0
                ? _b
                : previousNode.node.rowIndex;
        return previousDisplayIndex + storeIndexDiff;
    };
    /**
     * Creates a new row and inserts it at the given index
     * @param atStoreIndex the node index relative to this store
     * @param data the data object to populate the node with
     * @returns the new row node
     */
    LazyCache.prototype.createRowAtIndex = function (atStoreIndex, data, createNodeCallback) {
        var _a, _b;
        // make sure an existing node isn't being overwritten
        var lazyNode = this.nodeMap.getBy('index', atStoreIndex);
        // if node already exists, update it or destroy it
        if (lazyNode) {
            var node = lazyNode.node;
            node.__needsRefreshWhenVisible = false;
            // if the node is the same, just update the content
            if (this.doesNodeMatch(data, node)) {
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodesToRefresh.delete(node);
                return node;
            }
            // if there's no id and this is an open group, protect this node from changes
            // hasChildren also checks for tree data and master detail
            if (this.getRowIdFunc == null && node.hasChildren() && node.expanded) {
                this.nodesToRefresh.delete(node);
                return node;
            }
            // destroy the old node, might be worth caching state here
            this.destroyRowAtIndex(atStoreIndex);
        }
        // if the node already exists elsewhere, update it and move it to the new location
        if (data && this.getRowIdFunc != null) {
            var id = this.getRowId(data);
            // the node was deleted at some point, but as we're refreshing
            // it's been cached and we can retrieve it for reuse.
            var deletedNode = id && ((_a = this.removedNodeCache) === null || _a === void 0 ? void 0 : _a.get(id));
            if (deletedNode) {
                (_b = this.removedNodeCache) === null || _b === void 0 ? void 0 : _b.delete(id);
                this.blockUtils.updateDataIntoRowNode(deletedNode, data);
                this.nodeMap.set({
                    id: deletedNode.id,
                    node: deletedNode,
                    index: atStoreIndex,
                });
                return deletedNode;
            }
            var lazyNode_1 = this.nodeMap.getBy('id', id);
            if (lazyNode_1) {
                // delete old lazy node so we can insert it at different location
                this.nodeMap.delete(lazyNode_1);
                var node = lazyNode_1.node,
                    index = lazyNode_1.index;
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodeMap.set({
                    id: node.id,
                    node: node,
                    index: atStoreIndex,
                });
                this.nodesToRefresh.delete(node);
                if (
                    this.rowLoader.getBlockStartIndexForIndex(index) ===
                    this.rowLoader.getBlockStartIndexForIndex(atStoreIndex)
                ) {
                    // if the block hasn't changed and we have a nodes map, we don't need to refresh the original block, as this block
                    // has just been refreshed.
                    return node;
                }
                // mark all of the old block as needsVerify to trigger it for a refresh, as nodes
                // should not be out of place
                this.markBlockForVerify(index);
                return node;
            }
        }
        // node doesn't exist, create a new one
        var newNode = this.blockUtils.createRowNode(this.store.getRowDetails());
        if (data != null) {
            var defaultId = this.getPrefixedId(this.store.getIdSequence().next());
            this.blockUtils.setDataIntoRowNode(newNode, data, defaultId, undefined);
            this.blockUtils.checkOpenByDefault(newNode);
            this.nodeManager.addRowNode(newNode);
        }
        // add the new node to the store, has to be done after the display index is calculated so it doesn't take itself into account
        this.nodeMap.set({
            id: newNode.id,
            node: newNode,
            index: atStoreIndex,
        });
        if (createNodeCallback) {
            createNodeCallback(newNode);
        }
        return newNode;
    };
    LazyCache.prototype.getBlockStates = function () {
        var _this = this;
        var blockCounts = {};
        var blockStates = {};
        this.nodeMap.forEach(function (_a) {
            var _b;
            var node = _a.node,
                index = _a.index;
            var blockStart = _this.rowLoader.getBlockStartIndexForIndex(index);
            if (!node.stub && !node.failedLoad) {
                blockCounts[blockStart] = ((_b = blockCounts[blockStart]) !== null && _b !== void 0 ? _b : 0) + 1;
            }
            var rowState = 'loaded';
            if (node.failedLoad) {
                rowState = 'failed';
            } else if (_this.rowLoader.isRowLoading(blockStart)) {
                rowState = 'loading';
            } else if (_this.nodesToRefresh.has(node) || node.stub) {
                rowState = 'needsLoading';
            }
            if (!blockStates[blockStart]) {
                blockStates[blockStart] = new Set();
            }
            blockStates[blockStart].add(rowState);
        });
        var statePriorityMap = {
            loading: 4,
            failed: 3,
            needsLoading: 2,
            loaded: 1,
        };
        var blockPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        var results = {};
        Object.entries(blockStates).forEach(function (_a) {
            var _b;
            var _c = __read$6(_a, 2),
                blockStart = _c[0],
                uniqueStates = _c[1];
            var sortedStates = __spreadArray$5([], __read$6(uniqueStates)).sort(function (a, b) {
                var _a, _b;
                return (
                    ((_a = statePriorityMap[a]) !== null && _a !== void 0 ? _a : 0) -
                    ((_b = statePriorityMap[b]) !== null && _b !== void 0 ? _b : 0)
                );
            });
            var priorityState = sortedStates[0];
            var blockNumber = Number(blockStart) / _this.rowLoader.getBlockSize();
            var blockId = blockPrefix ? blockPrefix + '-' + blockNumber : String(blockNumber);
            results[blockId] = {
                blockNumber: blockNumber,
                startRow: Number(blockStart),
                endRow: Number(blockStart) + _this.rowLoader.getBlockSize(),
                pageStatus: priorityState,
                loadedRowCount: (_b = blockCounts[blockStart]) !== null && _b !== void 0 ? _b : 0,
            };
        });
        return results;
    };
    LazyCache.prototype.destroyRowAtIndex = function (atStoreIndex) {
        var lazyNode = this.nodeMap.getBy('index', atStoreIndex);
        if (!lazyNode) {
            return;
        }
        this.nodeMap.delete(lazyNode);
        this.nodeDisplayIndexMap.delete(lazyNode.node.rowIndex);
        if (lazyNode.node.hasChildren() && this.nodesToRefresh.size > 0) {
            // while refreshing, we retain the group nodes so they can be moved
            // without losing state
            this.removedNodeCache.set(lazyNode.node.id, lazyNode.node);
        } else {
            this.blockUtils.destroyRowNode(lazyNode.node);
        }
        this.nodesToRefresh.delete(lazyNode.node);
    };
    LazyCache.prototype.getSsrmParams = function () {
        return this.store.getSsrmParams();
    };
    /**
     * @param id the base id to be prefixed
     * @returns a node id with prefix if required
     */
    LazyCache.prototype.getPrefixedId = function (id) {
        if (this.defaultNodeIdPrefix) {
            return this.defaultNodeIdPrefix + '-' + id;
        } else {
            return id.toString();
        }
    };
    LazyCache.prototype.markBlockForVerify = function (rowIndex) {
        var _a = __read$6(this.rowLoader.getBlockBoundsForIndex(rowIndex), 2),
            start = _a[0],
            end = _a[1];
        var lazyNodesInRange = this.nodeMap.filter(function (lazyNode) {
            return lazyNode.index >= start && lazyNode.index < end;
        });
        lazyNodesInRange.forEach(function (_a) {
            var node = _a.node;
            node.__needsRefreshWhenVisible = true;
        });
    };
    LazyCache.prototype.doesNodeMatch = function (data, node) {
        if (node.stub) {
            return false;
        }
        if (this.getRowIdFunc != null) {
            var id = this.getRowId(data);
            return node.id === id;
        }
        return node.data === data;
    };
    /**
     * Deletes any stub nodes not within the given range
     */
    LazyCache.prototype.purgeStubsOutsideOfViewport = function () {
        var _this = this;
        var firstRow = this.api.getFirstDisplayedRow();
        var lastRow = this.api.getLastDisplayedRow();
        var firstRowBlockStart = this.rowLoader.getBlockStartIndexForIndex(firstRow);
        var _a = __read$6(this.rowLoader.getBlockBoundsForIndex(lastRow), 2);
        _a[0];
        var lastRowBlockEnd = _a[1];
        this.nodeMap.forEach(function (lazyNode) {
            // failed loads are still useful, so we don't purge them
            if (_this.rowLoader.isRowLoading(lazyNode.index) || lazyNode.node.failedLoad) {
                return;
            }
            if (lazyNode.node.stub && (lazyNode.index < firstRowBlockStart || lazyNode.index > lastRowBlockEnd)) {
                _this.destroyRowAtIndex(lazyNode.index);
            }
        });
    };
    LazyCache.prototype.getBlocksDistanceFromRow = function (nodes, otherDisplayIndex) {
        var _this = this;
        var blockDistanceToMiddle = {};
        nodes.forEach(function (_a) {
            var node = _a.node,
                index = _a.index;
            var _b = __read$6(_this.rowLoader.getBlockBoundsForIndex(index), 2),
                blockStart = _b[0],
                blockEnd = _b[1];
            if (blockStart in blockDistanceToMiddle) {
                return;
            }
            var distStart = Math.abs(node.rowIndex - otherDisplayIndex);
            var distEnd;
            // may not have an end node if the block came back small
            var lastLazyNode = _this.nodeMap.getBy('index', [blockEnd - 1]);
            if (lastLazyNode) distEnd = Math.abs(lastLazyNode.node.rowIndex - otherDisplayIndex);
            var farthest = distEnd == null || distStart < distEnd ? distStart : distEnd;
            blockDistanceToMiddle[blockStart] = farthest;
        });
        return Object.entries(blockDistanceToMiddle);
    };
    LazyCache.prototype.purgeExcessRows = function () {
        var _this = this;
        var _a;
        // Delete all stub nodes which aren't in the viewport or already loading
        this.purgeStubsOutsideOfViewport();
        if (this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null) {
            // if group is collapsed, or max blocks missing, ignore the event
            return;
        }
        var firstRowInViewport = this.api.getFirstDisplayedRow();
        var lastRowInViewport = this.api.getLastDisplayedRow();
        // the start storeIndex of every block in this store
        var allLoadedBlocks = new Set();
        // the start storeIndex of every displayed block in this store
        var blocksInViewport = new Set();
        this.nodeMap.forEach(function (_a) {
            var index = _a.index,
                node = _a.node;
            var blockStart = _this.rowLoader.getBlockStartIndexForIndex(index);
            allLoadedBlocks.add(blockStart);
            var isInViewport = node.rowIndex >= firstRowInViewport && node.rowIndex <= lastRowInViewport;
            if (isInViewport) {
                blocksInViewport.add(blockStart);
            }
        });
        // if the viewport is larger than the max blocks, then the viewport size is minimum cache size
        var numberOfBlocksToRetain = Math.max(
            blocksInViewport.size,
            (_a = this.storeParams.maxBlocksInCache) !== null && _a !== void 0 ? _a : 0,
        );
        // ensure there is blocks that can be removed
        var loadedBlockCount = allLoadedBlocks.size;
        var blocksToRemove = loadedBlockCount - numberOfBlocksToRetain;
        if (blocksToRemove <= 0) {
            return;
        }
        // the first and last block in the viewport
        var firstRowBlockStart = Number.MAX_SAFE_INTEGER;
        var lastRowBlockStart = Number.MIN_SAFE_INTEGER;
        blocksInViewport.forEach(function (blockStart) {
            if (firstRowBlockStart > blockStart) {
                firstRowBlockStart = blockStart;
            }
            if (lastRowBlockStart < blockStart) {
                lastRowBlockStart = blockStart;
            }
        });
        // all nodes which aren't cached or in the viewport, and so can be removed
        var disposableNodes = this.nodeMap.filter(function (_a) {
            var node = _a.node,
                index = _a.index;
            var rowBlockStart = _this.rowLoader.getBlockStartIndexForIndex(index);
            var rowBlockInViewport = rowBlockStart >= firstRowBlockStart && rowBlockStart <= lastRowBlockStart;
            return !rowBlockInViewport && !_this.isNodeCached(node);
        });
        if (disposableNodes.length === 0) {
            return;
        }
        var midViewportRow = firstRowInViewport + (lastRowInViewport - firstRowInViewport) / 2;
        var blockDistanceArray = this.getBlocksDistanceFromRow(disposableNodes, midViewportRow);
        var blockSize = this.rowLoader.getBlockSize();
        // sort the blocks by distance from middle of viewport
        blockDistanceArray.sort(function (a, b) {
            return Math.sign(b[1] - a[1]);
        });
        // remove excess blocks, starting from furthest from viewport
        for (var i = 0; i < Math.min(blocksToRemove, blockDistanceArray.length); i++) {
            var blockStart = Number(blockDistanceArray[i][0]);
            for (var x = blockStart; x < blockStart + blockSize; x++) {
                var lazyNode = this.nodeMap.getBy('index', x);
                if (!lazyNode || this.isNodeCached(lazyNode.node)) {
                    continue;
                }
                this.destroyRowAtIndex(x);
            }
        }
    };
    LazyCache.prototype.isNodeFocused = function (node) {
        var focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) {
            return false;
        }
        if (focusedCell.rowPinned != null) {
            return false;
        }
        var hasFocus = focusedCell.rowIndex === node.rowIndex;
        return hasFocus;
    };
    LazyCache.prototype.isNodeCached = function (node) {
        return (node.isExpandable() && node.expanded) || this.isNodeFocused(node);
    };
    LazyCache.prototype.extractDuplicateIds = function (rows) {
        var _this = this;
        if (this.getRowIdFunc != null) {
            return [];
        }
        var newIds = new Set();
        var duplicates = new Set();
        rows.forEach(function (data) {
            var id = _this.getRowId(data);
            if (newIds.has(id)) {
                duplicates.add(id);
                return;
            }
            newIds.add(id);
        });
        return __spreadArray$5([], __read$6(duplicates));
    };
    LazyCache.prototype.onLoadSuccess = function (firstRowIndex, numberOfRowsExpected, response) {
        var _this = this;
        var _a;
        if (!this.live) return;
        var info = (_a = response.groupLevelInfo) !== null && _a !== void 0 ? _a : response.storeInfo;
        this.store.setStoreInfo(info);
        if (this.getRowIdFunc != null) {
            var duplicates = this.extractDuplicateIds(response.rowData);
            if (duplicates.length > 0) {
                var duplicateIdText = duplicates.join(', ');
                console.warn(
                    'AG Grid: Unable to display rows as duplicate row ids (' +
                        duplicateIdText +
                        ') were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.',
                );
                this.onLoadFailed(firstRowIndex, numberOfRowsExpected);
                return;
            }
        }
        if (response.pivotResultFields) {
            this.serverSideRowModel.generateSecondaryColumns(response.pivotResultFields);
        }
        var wasRefreshing = this.nodesToRefresh.size > 0;
        response.rowData.forEach(function (data, responseRowIndex) {
            var _a;
            var rowIndex = firstRowIndex + responseRowIndex;
            var nodeFromCache = _this.nodeMap.getBy('index', rowIndex);
            // if stub, overwrite
            if (
                (_a = nodeFromCache === null || nodeFromCache === void 0 ? void 0 : nodeFromCache.node) === null ||
                _a === void 0
                    ? void 0
                    : _a.stub
            ) {
                _this.createRowAtIndex(rowIndex, data);
                return;
            }
            // node already exists, and same as node at designated position, update data
            if (nodeFromCache && _this.doesNodeMatch(data, nodeFromCache.node)) {
                _this.blockUtils.updateDataIntoRowNode(nodeFromCache.node, data);
                _this.nodesToRefresh.delete(nodeFromCache.node);
                nodeFromCache.node.__needsRefreshWhenVisible = false;
                return;
            }
            // create row will handle deleting the overwritten row
            _this.createRowAtIndex(rowIndex, data);
        });
        var finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) {
            this.fireRefreshFinishedEvent();
        }
        if (response.rowCount != undefined && response.rowCount !== -1) {
            // if the rowCount has been provided, set the row count
            this.numberOfRows = response.rowCount;
            this.isLastRowKnown = true;
        } else if (numberOfRowsExpected > response.rowData.length) {
            // infer the last row as the response came back short
            this.numberOfRows = firstRowIndex + response.rowData.length;
            this.isLastRowKnown = true;
        } else if (!this.isLastRowKnown) {
            // add 1 for loading row, as we don't know the last row
            var lastInferredRow = firstRowIndex + response.rowData.length + 1;
            if (lastInferredRow > this.numberOfRows) {
                this.numberOfRows = lastInferredRow;
            }
        }
        if (this.isLastRowKnown) {
            // delete any rows after the last index
            var lazyNodesAfterStoreEnd = this.nodeMap.filter(function (lazyNode) {
                return lazyNode.index >= _this.numberOfRows;
            });
            lazyNodesAfterStoreEnd.forEach(function (lazyNode) {
                return _this.destroyRowAtIndex(lazyNode.index);
            });
        }
        this.fireStoreUpdatedEvent();
    };
    LazyCache.prototype.fireRefreshFinishedEvent = function () {
        var _this = this;
        var finishedRefreshing = this.nodesToRefresh.size === 0;
        // if anything refreshing currently, skip.
        if (!finishedRefreshing) {
            return;
        }
        // any nodes left in the map need to be cleaned up, this prevents us preserving nodes
        // indefinitely
        this.removedNodeCache.forEach(function (node) {
            _this.blockUtils.destroyRowNode(node);
        });
        this.removedNodeCache = new Map();
        this.store.fireRefreshFinishedEvent();
    };
    LazyCache.prototype.isLastRowIndexKnown = function () {
        return this.isLastRowKnown;
    };
    LazyCache.prototype.onLoadFailed = function (firstRowIndex, numberOfRowsExpected) {
        var _a;
        if (!this.live) return;
        var wasRefreshing = this.nodesToRefresh.size > 0;
        for (var i = firstRowIndex; i < firstRowIndex + numberOfRowsExpected && i < this.getRowCount(); i++) {
            var node = ((_a = this.nodeMap.getBy('index', i)) !== null && _a !== void 0 ? _a : {}).node;
            if (node) {
                this.nodesToRefresh.delete(node);
            }
            if (!node || !node.stub) {
                if (node && !node.stub) {
                    // if node is not a stub, we destroy it and recreate as nodes can't go from data to stub
                    this.destroyRowAtIndex(i);
                }
                node = this.createRowAtIndex(i);
            }
            // this node has been refreshed, even if it wasn't successful
            node.__needsRefreshWhenVisible = false;
            node.failedLoad = true;
        }
        var finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) {
            this.fireRefreshFinishedEvent();
        }
        this.fireStoreUpdatedEvent();
    };
    LazyCache.prototype.markNodesForRefresh = function () {
        var _this = this;
        this.nodeMap.forEach(function (lazyNode) {
            if (lazyNode.node.stub && !lazyNode.node.failedLoad) {
                return;
            }
            _this.nodesToRefresh.add(lazyNode.node);
        });
        this.rowLoader.queueLoadCheck();
        if (this.isLastRowKnown && this.numberOfRows === 0) {
            this.numberOfRows = 1;
            this.isLastRowKnown = false;
            this.fireStoreUpdatedEvent();
        }
    };
    LazyCache.prototype.isNodeInCache = function (id) {
        return !!this.nodeMap.getBy('id', id);
    };
    // gets called 1) row count changed 2) cache purged 3) items inserted
    LazyCache.prototype.fireStoreUpdatedEvent = function () {
        if (!this.live) {
            return;
        }
        this.store.fireStoreUpdatedEvent();
    };
    LazyCache.prototype.getRowId = function (data) {
        if (this.getRowIdFunc == null) {
            return null;
        }
        // find rowNode using id
        var level = this.store.getRowDetails().level;
        var parentKeys = this.store.getParentNode().getGroupKeys();
        var id = this.getRowIdFunc({
            data: data,
            parentKeys: parentKeys.length > 0 ? parentKeys : undefined,
            level: level,
        });
        return String(id);
    };
    LazyCache.prototype.updateRowNodes = function (updates) {
        var _this = this;
        if (this.getRowIdFunc == null) {
            // throw error, as this is type checked in the store. User likely abusing internal apis if here.
            throw new Error('AG Grid: Transactions can only be applied when row ids are supplied.');
        }
        var updatedNodes = [];
        updates.forEach(function (data) {
            var id = _this.getRowId(data);
            var lazyNode = _this.nodeMap.getBy('id', id);
            if (lazyNode) {
                _this.blockUtils.updateDataIntoRowNode(lazyNode.node, data);
                updatedNodes.push(lazyNode.node);
            }
        });
        return updatedNodes;
    };
    LazyCache.prototype.insertRowNodes = function (inserts, indexToAdd) {
        var _this = this;
        // adjust row count to allow for footer row
        var realRowCount = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0);
        // if missing and we know the last row, we're inserting at the end
        var addIndex = indexToAdd == null && this.isLastRowKnown ? realRowCount : indexToAdd;
        // can't insert nodes past the end of the store
        if (addIndex == null || realRowCount < addIndex) {
            return [];
        }
        if (this.getRowIdFunc == null) {
            // throw error, as this is type checked in the store. User likely abusing internal apis if here.
            throw new Error('AG Grid: Transactions can only be applied when row ids are supplied.');
        }
        var uniqueInsertsMap = {};
        inserts.forEach(function (data) {
            var dataId = _this.getRowId(data);
            if (dataId && _this.isNodeInCache(dataId)) {
                return;
            }
            uniqueInsertsMap[dataId] = data;
        });
        var uniqueInserts = Object.values(uniqueInsertsMap);
        var numberOfInserts = uniqueInserts.length;
        if (numberOfInserts === 0) {
            return [];
        }
        var nodesToMove = this.nodeMap.filter(function (node) {
            return node.index >= addIndex;
        });
        // delete all nodes which need moved first, so they don't get overwritten
        nodesToMove.forEach(function (lazyNode) {
            return _this.nodeMap.delete(lazyNode);
        });
        // then move the nodes to their new locations
        nodesToMove.forEach(function (lazyNode) {
            _this.nodeMap.set({
                node: lazyNode.node,
                index: lazyNode.index + numberOfInserts,
                id: lazyNode.id,
            });
        });
        // increase the store size to accommodate
        this.numberOfRows += numberOfInserts;
        // finally insert the new rows
        return uniqueInserts.map(function (data, uniqueInsertOffset) {
            return _this.createRowAtIndex(addIndex + uniqueInsertOffset, data);
        });
    };
    LazyCache.prototype.getOrderedNodeMap = function () {
        var obj = {};
        this.nodeMap.forEach(function (node) {
            return (obj[node.index] = node);
        });
        return obj;
    };
    LazyCache.prototype.clearDisplayIndexes = function () {
        this.nodeDisplayIndexMap.clear();
    };
    LazyCache.prototype.removeRowNodes = function (idsToRemove) {
        if (this.getRowIdFunc == null) {
            // throw error, as this is type checked in the store. User likely abusing internal apis if here.
            throw new Error('AG Grid: Transactions can only be applied when row ids are supplied.');
        }
        var removedNodes = [];
        var nodesToVerify = [];
        // track how many nodes have been deleted, as when we pass other nodes we need to shift them up
        var deletedNodeCount = 0;
        var remainingIdsToRemove = __spreadArray$5([], __read$6(idsToRemove));
        var allNodes = this.getOrderedNodeMap();
        var contiguousIndex = -1;
        var _loop_1 = function (stringIndex) {
            contiguousIndex += 1;
            var node = allNodes[stringIndex];
            // finding the index allows the use of splice which should be slightly faster than both a check and filter
            var matchIndex = remainingIdsToRemove.findIndex(function (idToRemove) {
                return idToRemove === node.id;
            });
            if (matchIndex !== -1) {
                // found node, remove it from nodes to remove
                remainingIdsToRemove.splice(matchIndex, 1);
                this_1.destroyRowAtIndex(Number(stringIndex));
                removedNodes.push(node.node);
                deletedNodeCount += 1;
                return 'continue';
            }
            // no nodes removed and this node doesn't match, so no need to shift
            if (deletedNodeCount === 0) {
                return 'continue';
            }
            var numericStoreIndex = Number(stringIndex);
            if (contiguousIndex !== numericStoreIndex) {
                nodesToVerify.push(node.node);
            }
            // shift normal node up by number of deleted prior to this point
            this_1.nodeMap.delete(allNodes[stringIndex]);
            this_1.nodeMap.set({
                id: node.id,
                node: node.node,
                index: numericStoreIndex - deletedNodeCount,
            });
        };
        var this_1 = this;
        for (var stringIndex in allNodes) {
            _loop_1(stringIndex);
        }
        this.numberOfRows -= this.isLastRowIndexKnown() ? idsToRemove.length : deletedNodeCount;
        if (remainingIdsToRemove.length > 0 && nodesToVerify.length > 0) {
            nodesToVerify.forEach(function (node) {
                return (node.__needsRefreshWhenVisible = true);
            });
            this.rowLoader.queueLoadCheck();
        }
        return removedNodes;
    };
    __decorate$s([Autowired('gridApi')], LazyCache.prototype, 'api', void 0);
    __decorate$s([Autowired('ssrmBlockUtils')], LazyCache.prototype, 'blockUtils', void 0);
    __decorate$s([Autowired('focusService')], LazyCache.prototype, 'focusService', void 0);
    __decorate$s([Autowired('ssrmNodeManager')], LazyCache.prototype, 'nodeManager', void 0);
    __decorate$s([Autowired('rowModel')], LazyCache.prototype, 'serverSideRowModel', void 0);
    __decorate$s([PostConstruct], LazyCache.prototype, 'init', null);
    __decorate$s([PreDestroy], LazyCache.prototype, 'destroyRowNodes', null);
    return LazyCache;
})(BeanStub);

var __extends$t =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$r =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$5 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$4 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var LazyStore = /** @class */ (function (_super) {
    __extends$t(LazyStore, _super);
    function LazyStore(ssrmParams, storeParams, parentRowNode) {
        var _this = _super.call(this) || this;
        _this.idSequence = new NumberSequence();
        _this.ssrmParams = ssrmParams;
        _this.parentRowNode = parentRowNode;
        _this.storeParams = storeParams;
        _this.level = parentRowNode.level + 1;
        _this.group = ssrmParams.rowGroupCols ? _this.level < ssrmParams.rowGroupCols.length : false;
        _this.leafGroup = ssrmParams.rowGroupCols ? _this.level === ssrmParams.rowGroupCols.length - 1 : false;
        _this.info = {};
        return _this;
    }
    LazyStore.prototype.init = function () {
        var numberOfRows = 1;
        if (this.level === 0) {
            numberOfRows = this.storeUtils.getServerSideInitialRowCount();
        }
        this.cache = this.createManagedBean(new LazyCache(this, numberOfRows, this.storeParams));
        var usingTreeData = this.gridOptionsService.is('treeData');
        if (!usingTreeData && this.group) {
            var groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
        }
    };
    LazyStore.prototype.destroyRowNodes = function () {
        this.displayIndexStart = undefined;
        this.displayIndexEnd = undefined;
        this.destroyBean(this.cache);
    };
    /**
     * Given a server response, ingest the rows outside of the data source lifecycle.
     *
     * @param rowDataParams the server response containing the rows to ingest
     * @param startRow the index to start ingesting rows
     * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
     */
    LazyStore.prototype.applyRowData = function (rowDataParams, startRow, expectedRows) {
        this.cache.onLoadSuccess(startRow, expectedRows, rowDataParams);
    };
    /**
     * Applies a given transaction to the data set within this store
     *
     * @param transaction an object containing delta instructions determining the changes to apply to this store
     * @returns an object determining the status of this transaction and effected nodes
     */
    LazyStore.prototype.applyTransaction = function (transaction) {
        var _this = this;
        var _a, _b, _c;
        var idFunc = this.gridOptionsService.getCallback('getRowId');
        if (!idFunc) {
            console.warn(
                'AG Grid: getRowId callback must be implemented for transactions to work. Transaction was ignored.',
            );
            return {
                status: ServerSideTransactionResultStatus.Cancelled,
            };
        }
        var applyCallback = this.gridOptionsService.getCallback('isApplyServerSideTransaction');
        if (applyCallback) {
            var params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                storeInfo: this.info,
                groupLevelInfo: this.info,
            };
            var apply = applyCallback(params);
            if (!apply) {
                return { status: ServerSideTransactionResultStatus.Cancelled };
            }
        }
        var updatedNodes = undefined;
        if ((_a = transaction.update) === null || _a === void 0 ? void 0 : _a.length) {
            updatedNodes = this.cache.updateRowNodes(transaction.update);
        }
        var insertedNodes = undefined;
        if ((_b = transaction.add) === null || _b === void 0 ? void 0 : _b.length) {
            var addIndex = transaction.addIndex;
            if (addIndex != null && addIndex < 0) {
                addIndex = undefined;
            }
            insertedNodes = this.cache.insertRowNodes(transaction.add, addIndex);
        }
        var removedNodes = undefined;
        if ((_c = transaction.remove) === null || _c === void 0 ? void 0 : _c.length) {
            var allIdsToRemove = transaction.remove.map(function (data) {
                return idFunc({ level: _this.level, parentKeys: _this.parentRowNode.getGroupKeys(), data: data });
            });
            var allUniqueIdsToRemove = __spreadArray$4([], __read$5(new Set(allIdsToRemove)));
            removedNodes = this.cache.removeRowNodes(allUniqueIdsToRemove);
        }
        this.updateSelectionAfterTransaction(updatedNodes, removedNodes);
        return {
            status: ServerSideTransactionResultStatus.Applied,
            update: updatedNodes,
            add: insertedNodes,
            remove: removedNodes,
        };
    };
    LazyStore.prototype.updateSelectionAfterTransaction = function (updatedNodes, removedNodes) {
        var nodesToDeselect = [];
        updatedNodes === null || updatedNodes === void 0
            ? void 0
            : updatedNodes.forEach(function (node) {
                  if (node.isSelected() && !node.selectable) {
                      nodesToDeselect.push(node);
                  }
              });
        removedNodes === null || removedNodes === void 0
            ? void 0
            : removedNodes.forEach(function (node) {
                  if (node.isSelected()) {
                      nodesToDeselect.push(node);
                  }
              });
        if (nodesToDeselect.length) {
            this.selectionService.setNodesSelected({
                newValue: false,
                clearSelection: false,
                nodes: nodesToDeselect,
                source: 'rowDataChanged',
            });
        }
    };
    /**
     * Clear the display indexes, used for fading rows out when stores are not being destroyed
     */
    LazyStore.prototype.clearDisplayIndexes = function () {
        var _this = this;
        this.displayIndexStart = undefined;
        this.displayIndexEnd = undefined;
        this.cache.getNodes().forEach(function (lazyNode) {
            return _this.blockUtils.clearDisplayIndex(lazyNode.node);
        });
        if (this.parentRowNode.sibling) {
            this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling);
        }
        this.cache.clearDisplayIndexes();
    };
    /**
     * @returns an index representing the last sequentially displayed row in the grid for this store
     */
    LazyStore.prototype.getDisplayIndexStart = function () {
        return this.displayIndexStart;
    };
    /**
     * @returns the index representing one after the last sequentially displayed row in the grid for this store
     */
    LazyStore.prototype.getDisplayIndexEnd = function () {
        return this.displayIndexEnd;
    };
    /**
     * @returns the virtual size of this store
     */
    LazyStore.prototype.getRowCount = function () {
        if (this.parentRowNode.sibling) {
            return this.cache.getRowCount() + 1;
        }
        return this.cache.getRowCount();
    };
    /**
     * Sets the current row count of the store, and whether the last row index is known
     */
    LazyStore.prototype.setRowCount = function (rowCount, isLastRowIndexKnown) {
        this.cache.setRowCount(rowCount, isLastRowIndexKnown);
    };
    /**
     * Given a display index, returns whether that row is within this store or a child store of this store
     *
     * @param displayIndex the visible index of a row
     * @returns whether or not the row exists within this store
     */
    LazyStore.prototype.isDisplayIndexInStore = function (displayIndex) {
        if (this.cache.getRowCount() === 0) return false;
        return this.displayIndexStart <= displayIndex && displayIndex < this.getDisplayIndexEnd();
    };
    /**
     * Recursively sets up the display indexes and top position of every node belonging to this store.
     *
     * Called after a row height changes, or a store updated event.
     *
     * @param displayIndexSeq the number sequence for generating the display index of each row
     * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
     */
    LazyStore.prototype.setDisplayIndexes = function (displayIndexSeq, nextRowTop) {
        this.displayIndexStart = displayIndexSeq.peek();
        this.topPx = nextRowTop.value;
        // delegate to the store to set the row display indexes
        this.cache.setDisplayIndexes(displayIndexSeq, nextRowTop);
        if (this.parentRowNode.sibling) {
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop);
        }
        this.displayIndexEnd = displayIndexSeq.peek();
        this.heightPx = nextRowTop.value - this.topPx;
    };
    /**
     * Recursively applies a provided function to every node
     *
     * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
     */
    LazyStore.prototype.forEachStoreDeep = function (callback, sequence) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        callback(this, sequence.next());
        this.cache.getNodes().forEach(function (lazyNode) {
            var childCache = lazyNode.node.childStore;
            if (childCache) {
                childCache.forEachStoreDeep(callback, sequence);
            }
        });
    };
    /**
     * Recursively applies a provided function to every node
     *
     * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
     */
    LazyStore.prototype.forEachNodeDeep = function (callback, sequence) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        this.cache.getNodes().forEach(function (lazyNode) {
            callback(lazyNode.node, sequence.next());
            var childCache = lazyNode.node.childStore;
            if (childCache) {
                childCache.forEachNodeDeep(callback, sequence);
            }
        });
    };
    /**
     * Recursively applies a provided function to every node
     *
     * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
     */
    LazyStore.prototype.forEachNodeDeepAfterFilterAndSort = function (callback, sequence, includeFooterNodes) {
        if (sequence === void 0) {
            sequence = new NumberSequence();
        }
        if (includeFooterNodes === void 0) {
            includeFooterNodes = false;
        }
        var orderedNodes = this.cache.getOrderedNodeMap();
        for (var key in orderedNodes) {
            var lazyNode = orderedNodes[key];
            callback(lazyNode.node, sequence.next());
            var childCache = lazyNode.node.childStore;
            if (childCache) {
                childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
            }
        }
        if (includeFooterNodes && this.parentRowNode.sibling) {
            callback(this.parentRowNode.sibling, sequence.next());
        }
    };
    /**
     * Removes the failed status from all nodes, and marks them as stub to encourage reloading
     */
    LazyStore.prototype.retryLoads = function () {
        this.cache.getNodes().forEach(function (_a) {
            var node = _a.node;
            if (node.failedLoad) {
                node.failedLoad = false;
                node.__needsRefreshWhenVisible = true;
                node.stub = true;
            }
        });
        this.forEachChildStoreShallow(function (store) {
            return store.retryLoads();
        });
        this.fireStoreUpdatedEvent();
    };
    /**
     * Given a display index, returns the row at that location.
     *
     * @param displayRowIndex the displayed index within the grid to search for
     * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
     */
    LazyStore.prototype.getRowUsingDisplayIndex = function (displayRowIndex) {
        if (this.parentRowNode.sibling && displayRowIndex === this.parentRowNode.sibling.rowIndex) {
            return this.parentRowNode.sibling;
        }
        return this.cache.getRowByDisplayIndex(displayRowIndex);
    };
    /**
     * Given a display index, returns the row top and height for the row at that index.
     *
     * @param displayIndex the display index of the node
     * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
     */
    LazyStore.prototype.getRowBounds = function (displayIndex) {
        var _a;
        if (!this.isDisplayIndexInStore(displayIndex)) {
            return null;
        }
        var thisNode = this.cache.getNodeCachedByDisplayIndex(displayIndex);
        if (thisNode) {
            var boundsFromRow = this.blockUtils.extractRowBounds(thisNode, displayIndex);
            if (boundsFromRow) {
                return boundsFromRow;
            }
        }
        var _b = (_a = this.cache.getSurroundingNodesByDisplayIndex(displayIndex)) !== null && _a !== void 0 ? _a : {},
            previousNode = _b.previousNode,
            nextNode = _b.nextNode;
        // previous node may equal, or catch via detail node or child of group
        if (previousNode) {
            var boundsFromRow = this.blockUtils.extractRowBounds(previousNode.node, displayIndex);
            if (boundsFromRow != null) {
                return boundsFromRow;
            }
        }
        var defaultRowHeight = this.gridOptionsService.getRowHeightAsNumber();
        // if node after this, can calculate backwards (and ignore detail/grouping)
        if (nextNode) {
            var numberOfRowDiff_1 = (nextNode.node.rowIndex - displayIndex) * defaultRowHeight;
            return {
                rowTop: nextNode.node.rowTop - numberOfRowDiff_1,
                rowHeight: defaultRowHeight,
            };
        }
        // otherwise calculate from end of store
        var lastTop = this.topPx + this.heightPx;
        var numberOfRowDiff = (this.getDisplayIndexEnd() - displayIndex) * defaultRowHeight;
        return {
            rowTop: lastTop - numberOfRowDiff,
            rowHeight: defaultRowHeight,
        };
    };
    /**
     * Given a vertical pixel, determines whether this store contains a row at that pixel
     *
     * @param pixel a vertical pixel position from the grid
     * @returns whether that pixel points to a virtual space belonging to this store
     */
    LazyStore.prototype.isPixelInRange = function (pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    };
    /**
     * Given a vertical pixel, returns the row existing at that pixel location
     *
     * @param pixel a vertical pixel position from the grid
     * @returns the display index at the given pixel location
     */
    LazyStore.prototype.getRowIndexAtPixel = function (pixel) {
        if (pixel < this.topPx) {
            return this.getDisplayIndexStart();
        }
        if (pixel >= this.topPx + this.heightPx) {
            return this.getDisplayIndexEnd() - 1;
        }
        var distToPreviousNodeTop = Number.MAX_SAFE_INTEGER;
        var previousNode = null;
        var distToNextNodeTop = Number.MAX_SAFE_INTEGER;
        var nextNode = null;
        this.cache.getNodes().forEach(function (_a) {
            var node = _a.node;
            var distBetween = Math.abs(pixel - node.rowTop);
            // previous node
            if (node.rowTop < pixel) {
                if (distBetween < distToPreviousNodeTop) {
                    distToPreviousNodeTop = distBetween;
                    previousNode = node;
                }
                return;
            }
            // next node
            if (distBetween < distToNextNodeTop) {
                distToNextNodeTop = distBetween;
                nextNode = node;
            }
        });
        // cast these back as typescript doesn't understand the forEach above
        previousNode = previousNode;
        nextNode = nextNode;
        // previous node may equal, or catch via detail node or child of group
        if (previousNode) {
            var indexOfRow = this.blockUtils.getIndexAtPixel(previousNode, pixel);
            if (indexOfRow != null) {
                return indexOfRow;
            }
        }
        var defaultRowHeight = this.gridOptionsService.getRowHeightAsNumber();
        // if node after this, can calculate backwards (and ignore detail/grouping)
        if (nextNode) {
            var nextTop_1 = nextNode.rowTop;
            var numberOfRowDiff_2 = Math.ceil((nextTop_1 - pixel) / defaultRowHeight);
            return nextNode.rowIndex - numberOfRowDiff_2;
        }
        // otherwise calculate from end of store
        var nextTop = this.topPx + this.heightPx;
        var numberOfRowDiff = Math.floor((nextTop - pixel) / defaultRowHeight);
        return this.getDisplayIndexEnd() - numberOfRowDiff;
    };
    /**
     * Given a path of group keys, returns the child store for that group.
     *
     * @param keys the grouping path to the desired store
     * @returns the child store for the given keys, or null if not found
     */
    LazyStore.prototype.getChildStore = function (keys) {
        var _this = this;
        return this.storeUtils.getChildStore(keys, this, function (key) {
            var lazyNode = _this.cache.getNodes().find(function (lazyNode) {
                return lazyNode.node.key == key;
            });
            if (!lazyNode) {
                return null;
            }
            return lazyNode.node;
        });
    };
    /**
     * Executes a provided callback on each child store belonging to this store
     *
     * @param cb the callback to execute
     */
    LazyStore.prototype.forEachChildStoreShallow = function (cb) {
        this.cache.getNodes().forEach(function (_a) {
            var node = _a.node;
            if (node.childStore) {
                cb(node.childStore);
            }
        });
    };
    /**
     * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
     *
     * If a purge refresh occurs, the row count is preserved.
     *
     * @param params a set of properties pertaining to the sort changes
     */
    LazyStore.prototype.refreshAfterSort = function (params) {
        var serverSortsAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (
            serverSortsAllLevels ||
            this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)
        ) {
            var oldCount = this.cache.getRowCount();
            this.destroyBean(this.cache);
            this.cache = this.createManagedBean(new LazyCache(this, oldCount, this.storeParams));
            this.fireStoreUpdatedEvent();
            return;
        }
        // call refreshAfterSort on children, as we did not purge.
        // if we did purge, no need to do this as all children were destroyed
        this.forEachChildStoreShallow(function (store) {
            return store.refreshAfterSort(params);
        });
    };
    /**
     * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
     *
     * If a refresh occurs, the row count is reset.
     *
     * @param params a set of properties pertaining to the filter changes
     */
    LazyStore.prototype.refreshAfterFilter = function (params) {
        var serverFiltersAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (
            serverFiltersAllLevels ||
            this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)
        ) {
            this.refreshStore(true);
            return;
        }
        // call refreshAfterSort on children, as we did not purge.
        // if we did purge, no need to do this as all children were destroyed
        this.forEachChildStoreShallow(function (store) {
            return store.refreshAfterFilter(params);
        });
    };
    /**
     * Marks all existing nodes as requiring reloaded, and triggers a load check
     *
     * @param purge whether to remove all nodes and data in favour of stub nodes
     */
    LazyStore.prototype.refreshStore = function (purge) {
        if (purge) {
            this.destroyBean(this.cache);
            this.cache = this.createManagedBean(new LazyCache(this, 1, this.storeParams));
            this.fireStoreUpdatedEvent();
            return;
        }
        this.cache.markNodesForRefresh();
    };
    /**
     * Used for pagination, given a local/store index, returns the display index of that row
     *
     * @param topLevelIndex the store index of a row
     * @returns the display index for the given store index
     */
    LazyStore.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
        var displayIndex = this.cache.getDisplayIndexFromStoreIndex(topLevelIndex);
        return displayIndex !== null && displayIndex !== void 0 ? displayIndex : topLevelIndex;
    };
    /**
     * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
     *
     * @returns whether the last index of this store is known, or if lazy loading still required
     */
    LazyStore.prototype.isLastRowIndexKnown = function () {
        return this.cache.isLastRowIndexKnown();
    };
    /**
     * Used by the selection service to select a range of nodes
     *
     * @param firstInRange the first node in the range to find
     * @param lastInRange the last node in the range to find
     * @returns a range of nodes between firstInRange and lastInRange inclusive
     */
    LazyStore.prototype.getRowNodesInRange = function (firstInRange, lastInRange) {
        // if only one node passed, we start the selection at the top
        if (_.missing(firstInRange));
        return this.cache
            .getNodes()
            .filter(function (_a) {
                var node = _a.node;
                return node.rowIndex >= firstInRange.rowIndex && node.rowIndex <= lastInRange.rowIndex;
            })
            .map(function (_a) {
                var node = _a.node;
                return node;
            });
    };
    /**
     * Mutates a given array to add this stores state, and recursively add all the children store states.
     *
     * @param result a mutable results array
     */
    LazyStore.prototype.addStoreStates = function (result) {
        result.push({
            suppressInfiniteScroll: false,
            route: this.parentRowNode.getGroupKeys(),
            rowCount: this.getRowCount(),
            lastRowIndexKnown: this.isLastRowIndexKnown(),
            info: this.info,
            maxBlocksInCache: this.storeParams.maxBlocksInCache,
            cacheBlockSize: this.storeParams.cacheBlockSize,
        });
        this.forEachChildStoreShallow(function (childStore) {
            return childStore.addStoreStates(result);
        });
    };
    LazyStore.prototype.getIdSequence = function () {
        return this.idSequence;
    };
    LazyStore.prototype.getParentNode = function () {
        return this.parentRowNode;
    };
    LazyStore.prototype.getRowDetails = function () {
        return {
            field: this.groupField,
            group: this.group,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn,
        };
    };
    LazyStore.prototype.getSsrmParams = function () {
        return this.ssrmParams;
    };
    LazyStore.prototype.setStoreInfo = function (info) {
        if (info) {
            Object.assign(this.info, info);
        }
    };
    // gets called 1) row count changed 2) cache purged
    LazyStore.prototype.fireStoreUpdatedEvent = function () {
        // this results in row model firing ModelUpdated.
        // server side row model also updates the row indexes first
        var event = {
            type: Events.EVENT_STORE_UPDATED,
        };
        this.eventService.dispatchEvent(event);
    };
    // gets called when row data updated, and no more refreshing needed
    LazyStore.prototype.fireRefreshFinishedEvent = function () {
        var event = {
            type: Events.EVENT_STORE_REFRESHED,
            route: this.parentRowNode.getRoute(),
        };
        this.eventService.dispatchEvent(event);
    };
    LazyStore.prototype.getBlockStates = function () {
        return this.cache.getBlockStates();
    };
    LazyStore.prototype.getStoreBounds = function () {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx,
        };
    };
    __decorate$r([Autowired('ssrmBlockUtils')], LazyStore.prototype, 'blockUtils', void 0);
    __decorate$r([Autowired('ssrmStoreUtils')], LazyStore.prototype, 'storeUtils', void 0);
    __decorate$r([Autowired('columnModel')], LazyStore.prototype, 'columnModel', void 0);
    __decorate$r([Autowired('selectionService')], LazyStore.prototype, 'selectionService', void 0);
    __decorate$r([PostConstruct], LazyStore.prototype, 'init', null);
    __decorate$r([PreDestroy], LazyStore.prototype, 'destroyRowNodes', null);
    return LazyStore;
})(BeanStub);

var __extends$s =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$q =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$4 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var ServerSideRowModel = /** @class */ (function (_super) {
    __extends$s(ServerSideRowModel, _super);
    function ServerSideRowModel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.onRowHeightChanged_debounced = _.debounce(_this.onRowHeightChanged.bind(_this), 100);
        _this.pauseStoreUpdateListening = false;
        _this.started = false;
        _this.managingPivotResultColumns = false;
        return _this;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ServerSideRowModel.prototype.ensureRowHeightsValid = function () {
        return false;
    };
    ServerSideRowModel.prototype.start = function () {
        this.started = true;
        var datasource = this.gridOptionsService.get('serverSideDatasource');
        if (datasource) {
            this.setDatasource(datasource);
        }
    };
    ServerSideRowModel.prototype.destroyDatasource = function () {
        if (!this.datasource) {
            return;
        }
        if (this.datasource.destroy) {
            this.datasource.destroy();
        }
        this.rowRenderer.datasourceChanged();
        this.datasource = undefined;
    };
    ServerSideRowModel.prototype.addEventListeners = function () {
        this.addManagedListener(this.eventService, Events.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
        this.addManagedListener(this.eventService, Events.EVENT_STORE_UPDATED, this.onStoreUpdated.bind(this));
        var resetListener = this.resetRootStore.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_VALUE_CHANGED, resetListener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_CHANGED, resetListener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, resetListener);
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_PIVOT_MODE_CHANGED, resetListener);
        this.addManagedPropertyListener('treeData', resetListener);
        this.verifyProps();
    };
    ServerSideRowModel.prototype.verifyProps = function () {
        if (this.gridOptionsService.exists('initialGroupOrderComparator')) {
            var message_1 =
                'AG Grid: initialGroupOrderComparator cannot be used with Server Side Row Model. If using Full Store, then provide the rows to the grid in the desired sort order. If using Infinite Scroll, then sorting is done on the server side, nothing to do with the client.';
            _.doOnce(function () {
                return console.warn(message_1);
            }, 'SSRM.InitialGroupOrderComparator');
        }
        if (this.gridOptionsService.isRowSelection() && !this.gridOptionsService.exists('getRowId')) {
            var message_2 =
                'AG Grid: getRowId callback must be provided for Server Side Row Model selection to work correctly.';
            _.doOnce(function () {
                return console.warn(message_2);
            }, 'SSRM.SelectionNeedsRowNodeIdFunc');
        }
    };
    ServerSideRowModel.prototype.setDatasource = function (datasource) {
        // sometimes React, due to async, can call gridApi.setDatasource() before we have started.
        // this happens when React app does this:
        //      useEffect(() => setDatasource(ds), []);
        // thus if we set the datasource before the grid UI has finished initialising, we do not set it,
        // and the ssrm.start() method will set the datasoure when the grid is ready.
        if (!this.started) {
            return;
        }
        this.destroyDatasource();
        this.datasource = datasource;
        this.resetRootStore();
    };
    ServerSideRowModel.prototype.applyRowData = function (rowDataParams, startRow, route) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        var storeToExecuteOn = rootStore.getChildStore(route);
        if (!storeToExecuteOn) {
            return;
        }
        if (storeToExecuteOn instanceof LazyStore) {
            storeToExecuteOn.applyRowData(rowDataParams, startRow, rowDataParams.rowData.length);
        } else if (storeToExecuteOn instanceof FullStore) {
            storeToExecuteOn.processServerResult(rowDataParams);
        }
    };
    ServerSideRowModel.prototype.isLastRowIndexKnown = function () {
        var cache = this.getRootStore();
        if (!cache) {
            return false;
        }
        return cache.isLastRowIndexKnown();
    };
    ServerSideRowModel.prototype.onColumnEverything = function () {
        // if first time, always reset
        if (!this.storeParams) {
            this.resetRootStore();
            return;
        }
        // check if anything pertaining to fetching data has changed, and if it has, reset, but if
        // it has not, don't reset
        var rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
        var valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
        var pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
        // compares two sets of columns, ensuring no columns have been added or removed (unless specified via allowRemovedColumns)
        // if the columns are found, also ensures the field and aggFunc properties have not been changed.
        var areColsSame = function (params) {
            var oldColsMap = {};
            params.oldCols.forEach(function (col) {
                return (oldColsMap[col.id] = col);
            });
            var allColsUnchanged = params.newCols.every(function (col) {
                var equivalentCol = oldColsMap[col.id];
                if (equivalentCol) {
                    delete oldColsMap[col.id];
                }
                return equivalentCol && equivalentCol.field === col.field && equivalentCol.aggFunc === col.aggFunc;
            });
            var missingCols = !params.allowRemovedColumns && !!Object.values(oldColsMap).length;
            return allColsUnchanged && !missingCols;
        };
        var sortModelDifferent = !_.jsonEquals(this.storeParams.sortModel, this.sortListener.extractSortModel());
        var rowGroupDifferent = !areColsSame({
            oldCols: this.storeParams.rowGroupCols,
            newCols: rowGroupColumnVos,
        });
        var pivotDifferent = !areColsSame({
            oldCols: this.storeParams.pivotCols,
            newCols: pivotColumnVos,
        });
        var valuesDifferent =
            !!(rowGroupColumnVos === null || rowGroupColumnVos === void 0 ? void 0 : rowGroupColumnVos.length) &&
            !areColsSame({
                oldCols: this.storeParams.valueCols,
                newCols: valueColumnVos,
                allowRemovedColumns: true,
            });
        var resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
        if (resetRequired) {
            this.resetRootStore();
        } else {
            // cols may have changed even if we didn't do a reset. storeParams ref will be provided when getRows
            // is called, so it's important to keep it up to date.
            var newParams = this.createStoreParams();
            this.storeParams.rowGroupCols = newParams.rowGroupCols;
            this.storeParams.pivotCols = newParams.pivotCols;
            this.storeParams.valueCols = newParams.valueCols;
        }
    };
    ServerSideRowModel.prototype.destroyRootStore = function () {
        if (!this.rootNode || !this.rootNode.childStore) {
            return;
        }
        this.rootNode.childStore = this.destroyBean(this.rootNode.childStore);
        this.nodeManager.clear();
    };
    ServerSideRowModel.prototype.refreshAfterSort = function (newSortModel, params) {
        if (this.storeParams) {
            this.storeParams.sortModel = newSortModel;
        }
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.refreshAfterSort(params);
        this.onStoreUpdated();
    };
    ServerSideRowModel.prototype.generateSecondaryColumns = function (pivotFields) {
        var pivotColumnGroupDefs = this.pivotColDefService.createColDefsFromFields(pivotFields);
        this.managingPivotResultColumns = true;
        this.columnModel.setSecondaryColumns(pivotColumnGroupDefs, 'rowModelUpdated');
    };
    ServerSideRowModel.prototype.resetRootStore = function () {
        this.destroyRootStore();
        this.rootNode = new RowNode(this.beans);
        this.rootNode.group = true;
        this.rootNode.level = -1;
        if (this.datasource) {
            this.storeParams = this.createStoreParams();
            this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode));
            this.updateRowIndexesAndBounds();
        }
        if (this.managingPivotResultColumns) {
            // if managing pivot columns, also reset secondary columns.
            this.columnModel.setSecondaryColumns(null);
            this.managingPivotResultColumns = false;
        }
        // this event shows/hides 'no rows' overlay
        var rowDataChangedEvent = {
            type: Events.EVENT_ROW_DATA_UPDATED,
        };
        this.eventService.dispatchEvent(rowDataChangedEvent);
        // this gets the row to render rows (or remove the previously rendered rows, as it's blank to start).
        // important to NOT pass in an event with keepRenderedRows or animate, as we want the renderer
        // to treat the rows as new rows, as it's all new data
        this.dispatchModelUpdated(true);
    };
    ServerSideRowModel.prototype.columnsToValueObjects = function (columns) {
        var _this = this;
        return columns.map(function (col) {
            return {
                id: col.getId(),
                aggFunc: col.getAggFunc(),
                displayName: _this.columnModel.getDisplayNameForColumn(col, 'model'),
                field: col.getColDef().field,
            };
        });
    };
    ServerSideRowModel.prototype.createStoreParams = function () {
        var rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
        var valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
        var pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
        var dynamicRowHeight = this.gridOptionsService.isGetRowHeightFunction();
        var params = {
            // the columns the user has grouped and aggregated by
            valueCols: valueColumnVos,
            rowGroupCols: rowGroupColumnVos,
            pivotCols: pivotColumnVos,
            pivotMode: this.columnModel.isPivotMode(),
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortListener.extractSortModel(),
            datasource: this.datasource,
            lastAccessedSequence: new NumberSequence(),
            // blockSize: blockSize == null ? 100 : blockSize,
            dynamicRowHeight: dynamicRowHeight,
        };
        return params;
    };
    ServerSideRowModel.prototype.getParams = function () {
        return this.storeParams;
    };
    ServerSideRowModel.prototype.dispatchModelUpdated = function (reset) {
        if (reset === void 0) {
            reset = false;
        }
        var modelUpdatedEvent = {
            type: Events.EVENT_MODEL_UPDATED,
            animate: !reset,
            keepRenderedRows: !reset,
            newPage: false,
            newData: false,
        };
        this.eventService.dispatchEvent(modelUpdatedEvent);
    };
    ServerSideRowModel.prototype.onStoreUpdated = function () {
        // sometimes if doing a batch update, we do the batch first,
        // then call onStoreUpdated manually. eg expandAll() method.
        if (this.pauseStoreUpdateListening) {
            return;
        }
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    };
    /** This method is debounced. It is used for row auto-height. If we don't debounce,
     * then the Row Models will end up recalculating each row position
     * for each row height change and result in the Row Renderer laying out rows.
     * This is particularly bad if using print layout, and showing eg 1,000 rows,
     * each row will change it's height, causing Row Model to update 1,000 times.
     */
    ServerSideRowModel.prototype.onRowHeightChangedDebounced = function () {
        this.onRowHeightChanged_debounced();
    };
    ServerSideRowModel.prototype.onRowHeightChanged = function () {
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    };
    ServerSideRowModel.prototype.updateRowIndexesAndBounds = function () {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.setDisplayIndexes(new NumberSequence(), { value: 0 });
    };
    ServerSideRowModel.prototype.retryLoads = function () {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.retryLoads();
        this.onStoreUpdated();
    };
    ServerSideRowModel.prototype.getRow = function (index) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return undefined;
        }
        return rootStore.getRowUsingDisplayIndex(index);
    };
    ServerSideRowModel.prototype.expandAll = function (value) {
        // if we don't pause store updating, we are needlessly
        // recalculating row-indexes etc, and also getting rendering
        // engine to re-render (listens on ModelUpdated event)
        this.pauseStoreUpdateListening = true;
        this.forEachNode(function (node) {
            if (node.stub) {
                return;
            }
            if (node.hasChildren()) {
                node.setExpanded(value);
            }
        });
        this.pauseStoreUpdateListening = false;
        this.onStoreUpdated();
    };
    ServerSideRowModel.prototype.refreshAfterFilter = function (newFilterModel, params) {
        if (this.storeParams) {
            this.storeParams.filterModel = newFilterModel;
        }
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.refreshAfterFilter(params);
        this.onStoreUpdated();
    };
    ServerSideRowModel.prototype.getRootStore = function () {
        if (this.rootNode && this.rootNode.childStore) {
            return this.rootNode.childStore;
        }
    };
    ServerSideRowModel.prototype.getRowCount = function () {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return 0;
        }
        return rootStore.getDisplayIndexEnd();
    };
    ServerSideRowModel.prototype.getTopLevelRowCount = function () {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return 1;
        }
        return rootStore.getRowCount();
    };
    ServerSideRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return topLevelIndex;
        }
        return rootStore.getTopLevelRowDisplayedIndex(topLevelIndex);
    };
    ServerSideRowModel.prototype.getRowBounds = function (index) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            var rowHeight = this.gridOptionsService.getRowHeightAsNumber();
            return {
                rowTop: 0,
                rowHeight: rowHeight,
            };
        }
        return rootStore.getRowBounds(index);
    };
    ServerSideRowModel.prototype.getBlockStates = function () {
        var root = this.getRootStore();
        if (!root) {
            return undefined;
        }
        var states = {};
        root.forEachStoreDeep(function (store) {
            if (store instanceof FullStore) {
                var _a = store.getBlockStateJson(),
                    id = _a.id,
                    state = _a.state;
                states[id] = state;
            } else if (store instanceof LazyStore) {
                Object.entries(store.getBlockStates()).forEach(function (_a) {
                    var _b = __read$4(_a, 2),
                        block = _b[0],
                        state = _b[1];
                    states[block] = state;
                });
            } else {
                throw new Error('AG Grid: Unsupported store type');
            }
        });
        return states;
    };
    ServerSideRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        var rootStore = this.getRootStore();
        if (pixel <= 0 || !rootStore) {
            return 0;
        }
        return rootStore.getRowIndexAtPixel(pixel);
    };
    ServerSideRowModel.prototype.isEmpty = function () {
        return false;
    };
    ServerSideRowModel.prototype.isRowsToRender = function () {
        return this.getRootStore() != null && this.getRowCount() > 0;
    };
    ServerSideRowModel.prototype.getType = function () {
        return 'serverSide';
    };
    ServerSideRowModel.prototype.forEachNode = function (callback) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.forEachNodeDeep(callback);
    };
    ServerSideRowModel.prototype.forEachNodeAfterFilterAndSort = function (callback, includeFooterNodes) {
        if (includeFooterNodes === void 0) {
            includeFooterNodes = false;
        }
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        rootStore.forEachNodeDeepAfterFilterAndSort(callback, undefined, includeFooterNodes);
    };
    ServerSideRowModel.prototype.executeOnStore = function (route, callback) {
        var rootStore = this.getRootStore();
        if (!rootStore) {
            return;
        }
        var storeToExecuteOn = rootStore.getChildStore(route);
        if (storeToExecuteOn) {
            callback(storeToExecuteOn);
        }
    };
    ServerSideRowModel.prototype.refreshStore = function (params) {
        if (params === void 0) {
            params = {};
        }
        var route = params.route ? params.route : [];
        this.executeOnStore(route, function (store) {
            return store.refreshStore(params.purge == true);
        });
    };
    ServerSideRowModel.prototype.getStoreState = function () {
        var res = [];
        var rootStore = this.getRootStore();
        if (rootStore) {
            rootStore.addStoreStates(res);
        }
        return res;
    };
    ServerSideRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        if (!_.exists(firstInRange)) {
            return [];
        }
        if (!lastInRange) {
            return [firstInRange];
        }
        var startIndex = firstInRange.rowIndex;
        var endIndex = lastInRange.rowIndex;
        if (startIndex === null || endIndex === null) {
            return [firstInRange];
        }
        var nodeRange = [];
        var _a = __read$4(
                [startIndex, endIndex].sort(function (a, b) {
                    return a - b;
                }),
                2,
            ),
            firstIndex = _a[0],
            lastIndex = _a[1];
        this.forEachNode(function (node) {
            var thisRowIndex = node.rowIndex;
            if (thisRowIndex == null || node.stub) {
                return;
            }
            if (thisRowIndex >= firstIndex && thisRowIndex <= lastIndex) {
                nodeRange.push(node);
            }
        });
        // don't allow range selection if we don't have the full range of rows
        if (nodeRange.length !== lastIndex - firstIndex + 1) {
            return [firstInRange];
        }
        return nodeRange;
    };
    ServerSideRowModel.prototype.getRowNode = function (id) {
        var result;
        this.forEachNode(function (rowNode) {
            if (rowNode.id === id) {
                result = rowNode;
            }
            if (rowNode.detailNode && rowNode.detailNode.id === id) {
                result = rowNode.detailNode;
            }
        });
        return result;
    };
    ServerSideRowModel.prototype.isRowPresent = function (rowNode) {
        var foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    };
    ServerSideRowModel.prototype.setRowCount = function (rowCount, lastRowIndexKnown) {
        var rootStore = this.getRootStore();
        if (rootStore) {
            if (rootStore instanceof LazyStore) {
                rootStore.setRowCount(rowCount, lastRowIndexKnown);
                return;
            }
            console.error('AG Grid: Infinite scrolling must be enabled in order to set the row count.');
        }
    };
    __decorate$q([Autowired('columnModel')], ServerSideRowModel.prototype, 'columnModel', void 0);
    __decorate$q([Autowired('filterManager')], ServerSideRowModel.prototype, 'filterManager', void 0);
    __decorate$q([Autowired('rowRenderer')], ServerSideRowModel.prototype, 'rowRenderer', void 0);
    __decorate$q([Autowired('ssrmSortService')], ServerSideRowModel.prototype, 'sortListener', void 0);
    __decorate$q([Autowired('ssrmNodeManager')], ServerSideRowModel.prototype, 'nodeManager', void 0);
    __decorate$q([Autowired('ssrmStoreFactory')], ServerSideRowModel.prototype, 'storeFactory', void 0);
    __decorate$q([Autowired('beans')], ServerSideRowModel.prototype, 'beans', void 0);
    __decorate$q([Optional('pivotColDefService')], ServerSideRowModel.prototype, 'pivotColDefService', void 0);
    __decorate$q([PreDestroy], ServerSideRowModel.prototype, 'destroyDatasource', null);
    __decorate$q([PostConstruct], ServerSideRowModel.prototype, 'addEventListeners', null);
    __decorate$q([PreDestroy], ServerSideRowModel.prototype, 'destroyRootStore', null);
    ServerSideRowModel = __decorate$q([Bean('rowModel')], ServerSideRowModel);
    return ServerSideRowModel;
})(BeanStub);

var __extends$r =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$p =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var StoreUtils = /** @class */ (function (_super) {
    __extends$r(StoreUtils, _super);
    function StoreUtils() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    StoreUtils.prototype.loadFromDatasource = function (p) {
        var storeParams = p.storeParams,
            parentBlock = p.parentBlock,
            parentNode = p.parentNode;
        var groupKeys = parentNode.getGroupKeys();
        if (!storeParams.datasource) {
            return;
        }
        var request = {
            startRow: p.startRow,
            endRow: p.endRow,
            rowGroupCols: storeParams.rowGroupCols,
            valueCols: storeParams.valueCols,
            pivotCols: storeParams.pivotCols,
            pivotMode: storeParams.pivotMode,
            groupKeys: groupKeys,
            filterModel: storeParams.filterModel,
            sortModel: storeParams.sortModel,
        };
        var getRowsParams = {
            successCallback: p.successCallback,
            success: p.success,
            failCallback: p.failCallback,
            fail: p.fail,
            request: request,
            parentNode: p.parentNode,
            api: this.gridApi,
            columnApi: this.columnApi,
            context: this.gridOptionsService.context,
        };
        window.setTimeout(function () {
            if (!storeParams.datasource || !parentBlock.isAlive()) {
                // failCallback() is important, to reduce the 'RowNodeBlockLoader.activeBlockLoadsCount' count
                p.failCallback();
                return;
            }
            storeParams.datasource.getRows(getRowsParams);
        }, 0);
    };
    StoreUtils.prototype.getChildStore = function (keys, currentCache, findNodeFunc) {
        if (_.missingOrEmpty(keys)) {
            return currentCache;
        }
        var nextKey = keys[0];
        var nextNode = findNodeFunc(nextKey);
        if (nextNode) {
            // if we have the final node, but not the final store, we create it to allow
            // early population of data
            if (keys.length === 1 && !nextNode.childStore) {
                var storeParams = this.serverSideRowModel.getParams();
                nextNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, nextNode));
            }
            var keyListForNextLevel = keys.slice(1, keys.length);
            var nextStore = nextNode.childStore;
            return nextStore ? nextStore.getChildStore(keyListForNextLevel) : null;
        }
        return null;
    };
    StoreUtils.prototype.isServerRefreshNeeded = function (parentRowNode, rowGroupCols, params) {
        if (params.valueColChanged || params.secondaryColChanged) {
            return true;
        }
        var level = parentRowNode.level + 1;
        var grouping = level < rowGroupCols.length;
        var leafNodes = !grouping;
        if (leafNodes) {
            return true;
        }
        var colIdThisGroup = rowGroupCols[level].id;
        var actionOnThisGroup = params.changedColumns.indexOf(colIdThisGroup) > -1;
        if (actionOnThisGroup) {
            return true;
        }
        var allCols = this.columnModel.getAllGridColumns();
        var affectedGroupCols = allCols
            // find all impacted cols which also a group display column
            .filter(function (col) {
                return col.getColDef().showRowGroup && params.changedColumns.includes(col.getId());
            })
            .map(function (col) {
                return col.getColDef().showRowGroup;
            })
            // if displaying all groups, or displaying the effected col for this group, refresh
            .some(function (group) {
                return group === true || group === colIdThisGroup;
            });
        return affectedGroupCols;
    };
    StoreUtils.prototype.getServerSideInitialRowCount = function () {
        var rowCount = this.gridOptionsService.getNum('serverSideInitialRowCount');
        if (typeof rowCount === 'number' && rowCount > 0) {
            return rowCount;
        }
        return 1;
    };
    StoreUtils.prototype.assertRowModelIsServerSide = function (key) {
        if (!this.gridOptionsService.isRowModelType('serverSide')) {
            _.doOnce(function () {
                return console.warn(
                    "AG Grid: The '" + key + "' property can only be used with the Server Side Row Model.",
                );
            }, key);
            return false;
        }
        return true;
    };
    StoreUtils.prototype.assertNotTreeData = function (key) {
        if (this.gridOptionsService.is('treeData')) {
            _.doOnce(function () {
                return console.warn("AG Grid: The '" + key + "' property cannot be used while using tree data.");
            }, key + '_TreeData');
            return false;
        }
        return true;
    };
    StoreUtils.prototype.isServerSideSortAllLevels = function () {
        return (
            this.gridOptionsService.is('serverSideSortAllLevels') &&
            this.assertRowModelIsServerSide('serverSideSortAllLevels')
        );
    };
    StoreUtils.prototype.isServerSideOnlyRefreshFilteredGroups = function () {
        return (
            this.gridOptionsService.is('serverSideOnlyRefreshFilteredGroups') &&
            this.assertRowModelIsServerSide('serverSideOnlyRefreshFilteredGroups')
        );
    };
    StoreUtils.prototype.isServerSideSortOnServer = function () {
        return (
            this.gridOptionsService.is('serverSideSortOnServer') &&
            this.assertRowModelIsServerSide('serverSideSortOnServer') &&
            this.assertNotTreeData('serverSideSortOnServer')
        );
    };
    StoreUtils.prototype.isServerSideFilterOnServer = function () {
        return (
            this.gridOptionsService.is('serverSideFilterOnServer') &&
            this.assertRowModelIsServerSide('serverSideFilterOnServer') &&
            this.assertNotTreeData('serverSideFilterOnServer')
        );
    };
    __decorate$p([Autowired('columnApi')], StoreUtils.prototype, 'columnApi', void 0);
    __decorate$p([Autowired('columnModel')], StoreUtils.prototype, 'columnModel', void 0);
    __decorate$p([Autowired('gridApi')], StoreUtils.prototype, 'gridApi', void 0);
    __decorate$p([Autowired('rowModel')], StoreUtils.prototype, 'serverSideRowModel', void 0);
    __decorate$p([Autowired('ssrmStoreFactory')], StoreUtils.prototype, 'storeFactory', void 0);
    StoreUtils = __decorate$p([Bean('ssrmStoreUtils')], StoreUtils);
    return StoreUtils;
})(BeanStub);

var __extends$q =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$o =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var GROUP_MISSING_KEY_ID = 'ag-Grid-MissingKey';
var BlockUtils = /** @class */ (function (_super) {
    __extends$q(BlockUtils, _super);
    function BlockUtils() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    BlockUtils.prototype.postConstruct = function () {
        this.rowHeight = this.gridOptionsService.getRowHeightAsNumber();
        this.usingMasterDetail = this.gridOptionsService.is('masterDetail');
    };
    BlockUtils.prototype.createRowNode = function (params) {
        var rowNode = new RowNode(this.beans);
        var rowHeight = params.rowHeight != null ? params.rowHeight : this.rowHeight;
        rowNode.setRowHeight(rowHeight);
        rowNode.group = params.group;
        rowNode.leafGroup = params.leafGroup;
        rowNode.level = params.level;
        rowNode.uiLevel = params.level;
        rowNode.parent = params.parent;
        // stub gets set to true here, and then false when this rowNode gets it's data
        rowNode.stub = true;
        rowNode.__needsRefreshWhenVisible = false;
        if (rowNode.group) {
            rowNode.expanded = false;
            rowNode.field = params.field;
            rowNode.rowGroupColumn = params.rowGroupColumn;
        }
        return rowNode;
    };
    BlockUtils.prototype.destroyRowNodes = function (rowNodes) {
        var _this = this;
        if (rowNodes) {
            rowNodes.forEach(function (row) {
                return _this.destroyRowNode(row);
            });
        }
    };
    BlockUtils.prototype.destroyRowNode = function (rowNode, preserveStore) {
        if (preserveStore === void 0) {
            preserveStore = false;
        }
        if (rowNode.childStore && !preserveStore) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
        }
        // if this has a footer, destroy that too
        if (rowNode.sibling && !rowNode.footer) {
            this.destroyRowNode(rowNode.sibling, false);
        }
        // this is needed, so row render knows to fade out the row, otherwise it
        // sees row top is present, and thinks the row should be shown. maybe
        // rowNode should have a flag on whether it is visible???
        rowNode.clearRowTopAndRowIndex();
        if (rowNode.id != null) {
            this.nodeManager.removeNode(rowNode);
        }
    };
    BlockUtils.prototype.setTreeGroupInfo = function (rowNode) {
        rowNode.updateHasChildren();
        var getKeyFunc = this.gridOptionsService.get('getServerSideGroupKey');
        if (rowNode.hasChildren() && getKeyFunc != null) {
            rowNode.key = getKeyFunc(rowNode.data);
        }
        if (!rowNode.hasChildren() && rowNode.childStore != null) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
            rowNode.expanded = false;
        }
    };
    BlockUtils.prototype.setRowGroupInfo = function (rowNode) {
        rowNode.key = this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
        if (rowNode.key === null || rowNode.key === undefined) {
            _.doOnce(function () {
                console.warn('AG Grid: null and undefined values are not allowed for server side row model keys');
                if (rowNode.rowGroupColumn) {
                    console.warn('column = ' + rowNode.rowGroupColumn.getId());
                }
                console.warn('data is ', rowNode.data);
            }, 'ServerSideBlock-CannotHaveNullOrUndefinedForKey');
        }
        var getGroupIncludeFooter = this.beans.gridOptionsService.getGroupIncludeFooter();
        var doesRowShowFooter = getGroupIncludeFooter({ node: rowNode });
        if (doesRowShowFooter) {
            rowNode.createFooter();
            if (rowNode.sibling) {
                rowNode.sibling.uiLevel = rowNode.uiLevel + 1;
            }
        }
    };
    BlockUtils.prototype.setMasterDetailInfo = function (rowNode) {
        var isMasterFunc = this.gridOptionsService.get('isRowMaster');
        if (isMasterFunc != null) {
            rowNode.master = isMasterFunc(rowNode.data);
        } else {
            rowNode.master = true;
        }
    };
    BlockUtils.prototype.updateDataIntoRowNode = function (rowNode, data) {
        rowNode.updateData(data);
        if (this.gridOptionsService.is('treeData')) {
            this.setTreeGroupInfo(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        } else if (rowNode.group) {
            this.setChildCountIntoRowNode(rowNode);
            if (!rowNode.footer) {
                var getGroupIncludeFooter = this.beans.gridOptionsService.getGroupIncludeFooter();
                var doesRowShowFooter = getGroupIncludeFooter({ node: rowNode });
                if (doesRowShowFooter) {
                    if (rowNode.sibling) {
                        rowNode.sibling.updateData(data);
                    } else {
                        rowNode.createFooter();
                    }
                } else if (rowNode.sibling) {
                    rowNode.destroyFooter();
                }
            }
            // it's not possible for a node to change whether it's a group or not
            // when doing row grouping (as only rows at certain levels are groups),
            // so nothing to do here
        } else if (this.usingMasterDetail);
    };
    BlockUtils.prototype.setDataIntoRowNode = function (rowNode, data, defaultId, cachedRowHeight) {
        var _a;
        rowNode.stub = false;
        var treeData = this.gridOptionsService.is('treeData');
        if (_.exists(data)) {
            rowNode.setDataAndId(data, defaultId);
            if (treeData) {
                this.setTreeGroupInfo(rowNode);
            } else if (rowNode.group) {
                this.setRowGroupInfo(rowNode);
            } else if (this.usingMasterDetail) {
                this.setMasterDetailInfo(rowNode);
            }
        } else {
            rowNode.setDataAndId(undefined, undefined);
            rowNode.key = null;
        }
        if (treeData || rowNode.group) {
            this.setGroupDataIntoRowNode(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        }
        // this needs to be done AFTER setGroupDataIntoRowNode(), as the height can depend on the group data
        // getting set, if it's a group node and colDef.autoHeight=true
        if (_.exists(data)) {
            rowNode.setRowHeight(this.gridOptionsService.getRowHeightForNode(rowNode, false, cachedRowHeight).height);
            (_a = rowNode.sibling) === null || _a === void 0
                ? void 0
                : _a.setRowHeight(
                      this.gridOptionsService.getRowHeightForNode(rowNode.sibling, false, cachedRowHeight).height,
                  );
        }
    };
    BlockUtils.prototype.setChildCountIntoRowNode = function (rowNode) {
        var getChildCount = this.gridOptionsService.get('getChildCount');
        if (getChildCount) {
            rowNode.setAllChildrenCount(getChildCount(rowNode.data));
        }
    };
    BlockUtils.prototype.setGroupDataIntoRowNode = function (rowNode) {
        var _this = this;
        var groupDisplayCols = this.columnModel.getGroupDisplayColumns();
        var usingTreeData = this.gridOptionsService.is('treeData');
        groupDisplayCols.forEach(function (col) {
            if (rowNode.groupData == null) {
                rowNode.groupData = {};
            }
            if (usingTreeData) {
                rowNode.groupData[col.getColId()] = rowNode.key;
            } else if (col.isRowGroupDisplayed(rowNode.rowGroupColumn.getId())) {
                var groupValue = _this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
                rowNode.groupData[col.getColId()] = groupValue;
            }
        });
    };
    BlockUtils.prototype.clearDisplayIndex = function (rowNode) {
        rowNode.clearRowTopAndRowIndex();
        var hasChildStore = rowNode.hasChildren() && _.exists(rowNode.childStore);
        if (hasChildStore) {
            var childStore = rowNode.childStore;
            childStore.clearDisplayIndexes();
        }
        var hasDetailNode = rowNode.master && rowNode.detailNode;
        if (hasDetailNode) {
            rowNode.detailNode.clearRowTopAndRowIndex();
        }
    };
    BlockUtils.prototype.setDisplayIndex = function (rowNode, displayIndexSeq, nextRowTop) {
        // set this row
        rowNode.setRowIndex(displayIndexSeq.next());
        rowNode.setRowTop(nextRowTop.value);
        nextRowTop.value += rowNode.rowHeight;
        if (rowNode.footer) {
            return;
        }
        // set child for master / detail
        var hasDetailRow = rowNode.master;
        if (hasDetailRow) {
            if (rowNode.expanded && rowNode.detailNode) {
                rowNode.detailNode.setRowIndex(displayIndexSeq.next());
                rowNode.detailNode.setRowTop(nextRowTop.value);
                nextRowTop.value += rowNode.detailNode.rowHeight;
            } else if (rowNode.detailNode) {
                rowNode.detailNode.clearRowTopAndRowIndex();
            }
        }
        // set children for SSRM child rows
        var hasChildStore = rowNode.hasChildren() && _.exists(rowNode.childStore);
        if (hasChildStore) {
            var childStore = rowNode.childStore;
            if (rowNode.expanded) {
                childStore.setDisplayIndexes(displayIndexSeq, nextRowTop);
            } else {
                // we need to clear the row tops, as the row renderer depends on
                // this to know if the row should be faded out
                childStore.clearDisplayIndexes();
            }
        }
    };
    BlockUtils.prototype.binarySearchForDisplayIndex = function (displayRowIndex, rowNodes) {
        var bottomPointer = 0;
        var topPointer = rowNodes.length - 1;
        if (_.missing(topPointer) || _.missing(bottomPointer)) {
            console.warn('AG Grid: error: topPointer = ' + topPointer + ', bottomPointer = ' + bottomPointer);
            return undefined;
        }
        while (true) {
            var midPointer = Math.floor((bottomPointer + topPointer) / 2);
            var currentRowNode = rowNodes[midPointer];
            // first check current row for index
            if (currentRowNode.rowIndex === displayRowIndex) {
                return currentRowNode;
            }
            // then check if current row contains a detail row with the index
            var expandedMasterRow = currentRowNode.master && currentRowNode.expanded;
            var detailNode = currentRowNode.detailNode;
            if (expandedMasterRow && detailNode && detailNode.rowIndex === displayRowIndex) {
                return currentRowNode.detailNode;
            }
            // then check if child cache contains index
            var childStore = currentRowNode.childStore;
            if (currentRowNode.expanded && childStore && childStore.isDisplayIndexInStore(displayRowIndex)) {
                return childStore.getRowUsingDisplayIndex(displayRowIndex);
            }
            // otherwise adjust pointers to continue searching for index
            if (currentRowNode.rowIndex < displayRowIndex) {
                bottomPointer = midPointer + 1;
            } else if (currentRowNode.rowIndex > displayRowIndex) {
                topPointer = midPointer - 1;
            } else {
                console.warn('AG Grid: error: unable to locate rowIndex = ' + displayRowIndex + ' in cache');
                return undefined;
            }
        }
    };
    BlockUtils.prototype.extractRowBounds = function (rowNode, index) {
        var extractRowBounds = function (currentRowNode) {
            return {
                rowHeight: currentRowNode.rowHeight,
                rowTop: currentRowNode.rowTop,
            };
        };
        if (rowNode.rowIndex === index) {
            return extractRowBounds(rowNode);
        }
        if (rowNode.hasChildren() && rowNode.expanded && _.exists(rowNode.childStore)) {
            var childStore = rowNode.childStore;
            if (childStore.isDisplayIndexInStore(index)) {
                return childStore.getRowBounds(index);
            }
        } else if (rowNode.master && rowNode.expanded && _.exists(rowNode.detailNode)) {
            if (rowNode.detailNode.rowIndex === index) {
                return extractRowBounds(rowNode.detailNode);
            }
        }
    };
    BlockUtils.prototype.getIndexAtPixel = function (rowNode, pixel) {
        // first check if pixel is in range of current row
        if (rowNode.isPixelInRange(pixel)) {
            return rowNode.rowIndex;
        }
        // then check if current row contains a detail row with pixel in range
        var expandedMasterRow = rowNode.master && rowNode.expanded;
        var detailNode = rowNode.detailNode;
        if (expandedMasterRow && detailNode && detailNode.isPixelInRange(pixel)) {
            return rowNode.detailNode.rowIndex;
        }
        // then check if it's a group row with a child cache with pixel in range
        if (rowNode.hasChildren() && rowNode.expanded && _.exists(rowNode.childStore)) {
            var childStore = rowNode.childStore;
            if (childStore.isPixelInRange(pixel)) {
                return childStore.getRowIndexAtPixel(pixel);
            }
        }
        return null;
        // pixel is not within this row node or it's children / detail, so return undefined
    };
    BlockUtils.prototype.createNodeIdPrefix = function (parentRowNode) {
        var parts = [];
        var rowNode = parentRowNode;
        // pull keys from all parent nodes, but do not include the root node
        while (rowNode && rowNode.level >= 0) {
            if (rowNode.key === '') {
                parts.push(GROUP_MISSING_KEY_ID);
            } else {
                parts.push(rowNode.key);
            }
            rowNode = rowNode.parent;
        }
        if (parts.length > 0) {
            return parts.reverse().join('-');
        }
        // no prefix, so node id's are left as they are
        return undefined;
    };
    BlockUtils.prototype.checkOpenByDefault = function (rowNode) {
        if (!rowNode.isExpandable()) {
            return;
        }
        var userFunc = this.gridOptionsService.getCallback('isServerSideGroupOpenByDefault');
        if (!userFunc) {
            return;
        }
        var params = {
            data: rowNode.data,
            rowNode: rowNode,
        };
        var userFuncRes = userFunc(params);
        if (userFuncRes) {
            // we do this in a timeout, so that we don't expand a row node while in the middle
            // of setting up rows, setting up rows is complex enough without another chunk of work
            // getting added to the call stack. this is also helpful as openByDefault may or may
            // not happen (so makes setting up rows more deterministic by expands never happening)
            // and also checkOpenByDefault is shard with both store types, so easier control how it
            // impacts things by keeping it in new VM turn.
            window.setTimeout(function () {
                return rowNode.setExpanded(true);
            }, 0);
        }
    };
    __decorate$o([Autowired('valueService')], BlockUtils.prototype, 'valueService', void 0);
    __decorate$o([Autowired('columnModel')], BlockUtils.prototype, 'columnModel', void 0);
    __decorate$o([Autowired('ssrmNodeManager')], BlockUtils.prototype, 'nodeManager', void 0);
    __decorate$o([Autowired('beans')], BlockUtils.prototype, 'beans', void 0);
    __decorate$o([PostConstruct], BlockUtils.prototype, 'postConstruct', null);
    BlockUtils = __decorate$o([Bean('ssrmBlockUtils')], BlockUtils);
    return BlockUtils;
})(BeanStub);

var __decorate$n =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var NodeManager = /** @class */ (function () {
    function NodeManager() {
        this.rowNodes = {};
    }
    NodeManager.prototype.addRowNode = function (rowNode) {
        var id = rowNode.id;
        if (this.rowNodes[id]) {
            console.warn(
                'AG Grid: Duplicate node id ' +
                    rowNode.id +
                    ". Row ID's are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.",
            );
            console.warn('first instance', this.rowNodes[id].data);
            console.warn('second instance', rowNode.data);
        }
        this.rowNodes[id] = rowNode;
    };
    NodeManager.prototype.removeNode = function (rowNode) {
        var id = rowNode.id;
        if (this.rowNodes[id]) {
            this.rowNodes[id] = undefined;
        }
    };
    NodeManager.prototype.clear = function () {
        this.rowNodes = {};
    };
    __decorate$n([PreDestroy], NodeManager.prototype, 'clear', null);
    NodeManager = __decorate$n([Bean('ssrmNodeManager')], NodeManager);
    return NodeManager;
})();

var __extends$p =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$m =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TransactionManager = /** @class */ (function (_super) {
    __extends$p(TransactionManager, _super);
    function TransactionManager() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.asyncTransactions = [];
        return _this;
    }
    TransactionManager.prototype.postConstruct = function () {
        // only want to be active if SSRM active, otherwise would be interfering with other row models
        if (!this.gridOptionsService.isRowModelType('serverSide')) {
            return;
        }
    };
    TransactionManager.prototype.applyTransactionAsync = function (transaction, callback) {
        if (this.asyncTransactionsTimeout == null) {
            this.scheduleExecuteAsync();
        }
        this.asyncTransactions.push({ transaction: transaction, callback: callback });
    };
    TransactionManager.prototype.scheduleExecuteAsync = function () {
        var _this = this;
        var waitMillis = this.gridOptionsService.getAsyncTransactionWaitMillis();
        this.asyncTransactionsTimeout = window.setTimeout(function () {
            _this.executeAsyncTransactions();
        }, waitMillis);
    };
    TransactionManager.prototype.executeAsyncTransactions = function () {
        var _this = this;
        if (!this.asyncTransactions) {
            return;
        }
        var resultFuncs = [];
        var resultsForEvent = [];
        var transactionsToRetry = [];
        var atLeastOneTransactionApplied = false;
        this.asyncTransactions.forEach(function (txWrapper) {
            var result;
            _this.serverSideRowModel.executeOnStore(txWrapper.transaction.route, function (cache) {
                result = cache.applyTransaction(txWrapper.transaction);
            });
            if (result == undefined) {
                result = { status: ServerSideTransactionResultStatus.StoreNotFound };
            }
            resultsForEvent.push(result);
            var retryTransaction = result.status == ServerSideTransactionResultStatus.StoreLoading;
            if (retryTransaction) {
                transactionsToRetry.push(txWrapper);
                return;
            }
            if (txWrapper.callback) {
                resultFuncs.push(function () {
                    return txWrapper.callback(result);
                });
            }
            if (result.status === ServerSideTransactionResultStatus.Applied) {
                atLeastOneTransactionApplied = true;
            }
        });
        // do callbacks in next VM turn so it's async
        if (resultFuncs.length > 0) {
            window.setTimeout(function () {
                resultFuncs.forEach(function (func) {
                    return func();
                });
            }, 0);
        }
        this.asyncTransactionsTimeout = undefined;
        // this will be empty list if nothing to retry
        this.asyncTransactions = transactionsToRetry;
        if (atLeastOneTransactionApplied) {
            this.valueCache.onDataChanged();
            this.eventService.dispatchEvent({ type: Events.EVENT_STORE_UPDATED });
        }
        if (resultsForEvent.length > 0) {
            var event_1 = {
                type: Events.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
                results: resultsForEvent,
            };
            this.eventService.dispatchEvent(event_1);
        }
    };
    TransactionManager.prototype.flushAsyncTransactions = function () {
        // the timeout could be missing, if we are flushing due to row data loaded
        if (this.asyncTransactionsTimeout != null) {
            clearTimeout(this.asyncTransactionsTimeout);
        }
        this.executeAsyncTransactions();
    };
    TransactionManager.prototype.applyTransaction = function (transaction) {
        var res;
        this.serverSideRowModel.executeOnStore(transaction.route, function (store) {
            res = store.applyTransaction(transaction);
        });
        if (res) {
            this.valueCache.onDataChanged();
            if (res.remove) {
                var removedRowIds = res.remove.map(function (row) {
                    return row.id;
                });
                this.selectionService.deleteSelectionStateFromParent(transaction.route || [], removedRowIds);
            }
            this.eventService.dispatchEvent({ type: Events.EVENT_STORE_UPDATED });
            return res;
        } else {
            return { status: ServerSideTransactionResultStatus.StoreNotFound };
        }
    };
    __decorate$m([Autowired('rowNodeBlockLoader')], TransactionManager.prototype, 'rowNodeBlockLoader', void 0);
    __decorate$m([Autowired('valueCache')], TransactionManager.prototype, 'valueCache', void 0);
    __decorate$m([Autowired('rowModel')], TransactionManager.prototype, 'serverSideRowModel', void 0);
    __decorate$m([Autowired('rowRenderer')], TransactionManager.prototype, 'rowRenderer', void 0);
    __decorate$m([Autowired('selectionService')], TransactionManager.prototype, 'selectionService', void 0);
    __decorate$m([PostConstruct], TransactionManager.prototype, 'postConstruct', null);
    TransactionManager = __decorate$m([Bean('ssrmTransactionManager')], TransactionManager);
    return TransactionManager;
})(BeanStub);

var __extends$o =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$l =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ExpandListener = /** @class */ (function (_super) {
    __extends$o(ExpandListener, _super);
    function ExpandListener() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ExpandListener.prototype.postConstruct = function () {
        // only want to be active if SSRM active, otherwise would be interfering with other row models
        if (!this.gridOptionsService.isRowModelType('serverSide')) {
            return;
        }
        this.addManagedListener(this.eventService, Events.EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
    };
    ExpandListener.prototype.onRowGroupOpened = function (event) {
        var rowNode = event.node;
        if (rowNode.expanded) {
            if (rowNode.master) {
                this.createDetailNode(rowNode);
            } else if (_.missing(rowNode.childStore)) {
                var storeParams = this.serverSideRowModel.getParams();
                rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
            }
        } else if (this.gridOptionsService.is('purgeClosedRowNodes') && _.exists(rowNode.childStore)) {
            rowNode.childStore = this.destroyBean(rowNode.childStore);
        }
        var storeUpdatedEvent = { type: Events.EVENT_STORE_UPDATED };
        this.eventService.dispatchEvent(storeUpdatedEvent);
    };
    ExpandListener.prototype.createDetailNode = function (masterNode) {
        if (_.exists(masterNode.detailNode)) {
            return masterNode.detailNode;
        }
        var detailNode = new RowNode(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if (_.exists(masterNode.id)) {
            detailNode.id = 'detail_' + masterNode.id;
        }
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        var defaultDetailRowHeight = 200;
        var rowHeight = this.gridOptionsService.getRowHeightForNode(detailNode).height;
        detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
        masterNode.detailNode = detailNode;
        return detailNode;
    };
    __decorate$l([Autowired('rowModel')], ExpandListener.prototype, 'serverSideRowModel', void 0);
    __decorate$l([Autowired('ssrmStoreFactory')], ExpandListener.prototype, 'storeFactory', void 0);
    __decorate$l([Autowired('beans')], ExpandListener.prototype, 'beans', void 0);
    __decorate$l([PostConstruct], ExpandListener.prototype, 'postConstruct', null);
    ExpandListener = __decorate$l([Bean('ssrmExpandListener')], ExpandListener);
    return ExpandListener;
})(BeanStub);

var __extends$n =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$k =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SortListener = /** @class */ (function (_super) {
    __extends$n(SortListener, _super);
    function SortListener() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SortListener.prototype.postConstruct = function () {
        // only want to be active if SSRM active, otherwise would be interfering with other row models
        if (!this.gridOptionsService.isRowModelType('serverSide')) {
            return;
        }
        this.addManagedListener(this.eventService, Events.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    };
    SortListener.prototype.extractSortModel = function () {
        var sortModel = this.sortController.getSortModel();
        // when using tree data we just return the sort model with the 'ag-Grid-AutoColumn' as is, i.e not broken out
        // into it's constitute group columns as they are not defined up front and can vary per node.
        if (this.gridOptionsService.is('treeData')) {
            return sortModel;
        }
        // it autoCol is active, we don't want to send this to the server. instead we want to
        // send the
        this.replaceAutoGroupColumnWithActualRowGroupColumns(sortModel);
        this.removeMultiColumnPrefixOnColumnIds(sortModel);
        return sortModel;
    };
    SortListener.prototype.removeMultiColumnPrefixOnColumnIds = function (sortModel) {
        if (this.gridOptionsService.isGroupMultiAutoColumn()) {
            var multiColumnPrefix = GROUP_AUTO_COLUMN_ID + '-';
            for (var i = 0; i < sortModel.length; ++i) {
                if (sortModel[i].colId.indexOf(multiColumnPrefix) > -1) {
                    sortModel[i].colId = sortModel[i].colId.substr(multiColumnPrefix.length);
                }
            }
        }
    };
    SortListener.prototype.replaceAutoGroupColumnWithActualRowGroupColumns = function (sortModel) {
        // find index of auto group column in sort model
        var autoGroupSortModel = sortModel.find(function (sm) {
            return sm.colId == GROUP_AUTO_COLUMN_ID;
        });
        // replace auto column with individual group columns
        if (autoGroupSortModel) {
            // remove auto group column
            var autoGroupIndex = sortModel.indexOf(autoGroupSortModel);
            _.removeFromArray(sortModel, autoGroupSortModel);
            var isNotInSortModel = function (col) {
                return (
                    sortModel.filter(function (sm) {
                        return sm.colId === col.getColId();
                    }).length == 0
                );
            };
            var mapColumnToSortModel = function (col) {
                return { colId: col.getId(), sort: autoGroupSortModel.sort };
            };
            var newModels = this.columnModel.getRowGroupColumns().filter(isNotInSortModel).map(mapColumnToSortModel);
            _.insertArrayIntoArray(sortModel, newModels, autoGroupIndex);
        }
    };
    SortListener.prototype.onSortChanged = function () {
        var storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) {
            return;
        } // params is undefined if no datasource set
        var newSortModel = this.extractSortModel();
        var oldSortModel = storeParams.sortModel;
        var changedColumns = this.findChangedColumnsInSort(newSortModel, oldSortModel);
        var valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        var secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        var params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns,
        };
        this.serverSideRowModel.refreshAfterSort(newSortModel, params);
    };
    // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
    // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
    // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
    // was previously sorted by A and then the A sort now needs to be cleared.
    SortListener.prototype.findChangedColumnsInSort = function (newSortModel, oldSortModel) {
        var allColsInBothSorts = [];
        [newSortModel, oldSortModel].forEach(function (sortModel) {
            if (sortModel) {
                var ids = sortModel.map(function (sm) {
                    return sm.colId;
                });
                allColsInBothSorts = allColsInBothSorts.concat(ids);
            }
        });
        var differentSorts = function (oldSortItem, newSortItem) {
            var oldSort = oldSortItem ? oldSortItem.sort : null;
            var newSort = newSortItem ? newSortItem.sort : null;
            return oldSort !== newSort;
        };
        var differentIndexes = function (oldSortItem, newSortItem) {
            var oldIndex = oldSortItem ? oldSortModel.indexOf(oldSortItem) : -1;
            var newIndex = newSortItem ? newSortModel.indexOf(newSortItem) : -1;
            return oldIndex !== newIndex;
        };
        return allColsInBothSorts.filter(function (colId) {
            var oldSortItem = oldSortModel.find(function (sm) {
                return sm.colId === colId;
            });
            var newSortItem = newSortModel.find(function (sm) {
                return sm.colId === colId;
            });
            return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
        });
    };
    __decorate$k([Autowired('sortController')], SortListener.prototype, 'sortController', void 0);
    __decorate$k([Autowired('columnModel')], SortListener.prototype, 'columnModel', void 0);
    __decorate$k([Autowired('rowModel')], SortListener.prototype, 'serverSideRowModel', void 0);
    __decorate$k([Autowired('ssrmListenerUtils')], SortListener.prototype, 'listenerUtils', void 0);
    __decorate$k([PostConstruct], SortListener.prototype, 'postConstruct', null);
    SortListener = __decorate$k([Bean('ssrmSortService')], SortListener);
    return SortListener;
})(BeanStub);

var __extends$m =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$j =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FilterListener = /** @class */ (function (_super) {
    __extends$m(FilterListener, _super);
    function FilterListener() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    FilterListener.prototype.postConstruct = function () {
        // only want to be active if SSRM active, otherwise would be interfering with other row models
        if (!this.gridOptionsService.isRowModelType('serverSide')) {
            return;
        }
        this.addManagedListener(this.eventService, Events.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    };
    FilterListener.prototype.onFilterChanged = function () {
        var storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) {
            return;
        } // params is undefined if no datasource set
        var newModel = this.filterManager.getFilterModel();
        var oldModel = storeParams ? storeParams.filterModel : {};
        var changedColumns = this.findChangedColumns(newModel, oldModel);
        var valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        var secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        var params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns,
        };
        this.serverSideRowModel.refreshAfterFilter(newModel, params);
    };
    FilterListener.prototype.findChangedColumns = function (oldModel, newModel) {
        var allColKeysMap = {};
        Object.keys(oldModel).forEach(function (key) {
            return (allColKeysMap[key] = true);
        });
        Object.keys(newModel).forEach(function (key) {
            return (allColKeysMap[key] = true);
        });
        var res = [];
        Object.keys(allColKeysMap).forEach(function (key) {
            var oldJson = JSON.stringify(oldModel[key]);
            var newJson = JSON.stringify(newModel[key]);
            var filterChanged = oldJson != newJson;
            if (filterChanged) {
                res.push(key);
            }
        });
        return res;
    };
    __decorate$j([Autowired('rowModel')], FilterListener.prototype, 'serverSideRowModel', void 0);
    __decorate$j([Autowired('filterManager')], FilterListener.prototype, 'filterManager', void 0);
    __decorate$j([Autowired('ssrmListenerUtils')], FilterListener.prototype, 'listenerUtils', void 0);
    __decorate$j([PostConstruct], FilterListener.prototype, 'postConstruct', null);
    FilterListener = __decorate$j([Bean('ssrmFilterListener')], FilterListener);
    return FilterListener;
})(BeanStub);

var __decorate$i =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var StoreFactory = /** @class */ (function () {
    function StoreFactory() {}
    StoreFactory.prototype.createStore = function (ssrmParams, parentNode) {
        var storeParams = this.getStoreParams(ssrmParams, parentNode);
        var CacheClass = storeParams.suppressInfiniteScroll ? FullStore : LazyStore;
        return new CacheClass(ssrmParams, storeParams, parentNode);
    };
    StoreFactory.prototype.getStoreParams = function (ssrmParams, parentNode) {
        var userStoreParams = this.getLevelSpecificParams(parentNode);
        // if user provided overrideParams, we take infiniteScroll from there if it exists
        var infiniteScroll = this.isInfiniteScroll(userStoreParams);
        var cacheBlockSize = this.getBlockSize(infiniteScroll, userStoreParams);
        var maxBlocksInCache = this.getMaxBlocksInCache(infiniteScroll, ssrmParams, userStoreParams);
        var storeParams = {
            suppressInfiniteScroll: !infiniteScroll,
            cacheBlockSize: cacheBlockSize,
            maxBlocksInCache: maxBlocksInCache,
        };
        return storeParams;
    };
    StoreFactory.prototype.getMaxBlocksInCache = function (infiniteScroll, ssrmParams, userStoreParams) {
        if (!infiniteScroll) {
            return undefined;
        }
        var maxBlocksInCache =
            userStoreParams && userStoreParams.maxBlocksInCache != null
                ? userStoreParams.maxBlocksInCache
                : this.gridOptionsService.getNum('maxBlocksInCache');
        var maxBlocksActive = maxBlocksInCache != null && maxBlocksInCache >= 0;
        if (!maxBlocksActive) {
            return undefined;
        }
        if (ssrmParams.dynamicRowHeight) {
            var message_1 =
                'AG Grid: Server Side Row Model does not support Dynamic Row Height and Cache Purging. ' +
                'Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.';
            _.doOnce(function () {
                return console.warn(message_1);
            }, 'storeFactory.maxBlocksInCache.dynamicRowHeight');
            return undefined;
        }
        if (this.columnModel.isAutoRowHeightActive()) {
            var message_2 =
                'AG Grid: Server Side Row Model does not support Auto Row Height and Cache Purging. ' +
                'Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.';
            _.doOnce(function () {
                return console.warn(message_2);
            }, 'storeFactory.maxBlocksInCache.autoRowHeightActive');
            return undefined;
        }
        return maxBlocksInCache;
    };
    StoreFactory.prototype.getBlockSize = function (infiniteScroll, userStoreParams) {
        if (!infiniteScroll) {
            return undefined;
        }
        var blockSize =
            userStoreParams && userStoreParams.cacheBlockSize != null
                ? userStoreParams.cacheBlockSize
                : this.gridOptionsService.getNum('cacheBlockSize');
        if (blockSize != null && blockSize > 0) {
            return blockSize;
        } else {
            return 100;
        }
    };
    StoreFactory.prototype.getLevelSpecificParams = function (parentNode) {
        var callback = this.gridOptionsService.getCallback('getServerSideGroupLevelParams');
        if (!callback) {
            return undefined;
        }
        var params = {
            level: parentNode.level + 1,
            parentRowNode: parentNode.level >= 0 ? parentNode : undefined,
            rowGroupColumns: this.columnModel.getRowGroupColumns(),
            pivotColumns: this.columnModel.getPivotColumns(),
            pivotMode: this.columnModel.isPivotMode(),
        };
        var res = callback(params);
        if (res.storeType != null) {
            res.suppressInfiniteScroll = res.storeType !== 'partial';
        }
        return res;
    };
    StoreFactory.prototype.isInfiniteScroll = function (storeParams) {
        var res =
            storeParams && storeParams.suppressInfiniteScroll != null
                ? storeParams.suppressInfiniteScroll
                : this.isSuppressServerSideInfiniteScroll();
        return !res;
    };
    StoreFactory.prototype.isSuppressServerSideInfiniteScroll = function () {
        return this.gridOptionsService.is('suppressServerSideInfiniteScroll');
    };
    __decorate$i([Autowired('gridOptionsService')], StoreFactory.prototype, 'gridOptionsService', void 0);
    __decorate$i([Autowired('columnModel')], StoreFactory.prototype, 'columnModel', void 0);
    StoreFactory = __decorate$i([Bean('ssrmStoreFactory')], StoreFactory);
    return StoreFactory;
})();

var __decorate$h =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var ListenerUtils = /** @class */ (function () {
    function ListenerUtils() {}
    ListenerUtils.prototype.isSortingWithValueColumn = function (changedColumnsInSort) {
        var valueColIds = this.columnModel.getValueColumns().map(function (col) {
            return col.getColId();
        });
        for (var i = 0; i < changedColumnsInSort.length; i++) {
            if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) {
                return true;
            }
        }
        return false;
    };
    ListenerUtils.prototype.isSortingWithSecondaryColumn = function (changedColumnsInSort) {
        if (!this.columnModel.getSecondaryColumns()) {
            return false;
        }
        var secondaryColIds = this.columnModel.getSecondaryColumns().map(function (col) {
            return col.getColId();
        });
        for (var i = 0; i < changedColumnsInSort.length; i++) {
            if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) {
                return true;
            }
        }
        return false;
    };
    __decorate$h([Autowired('columnModel')], ListenerUtils.prototype, 'columnModel', void 0);
    ListenerUtils = __decorate$h([Bean('ssrmListenerUtils')], ListenerUtils);
    return ListenerUtils;
})();

var __extends$l =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$g =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __read$3 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$3 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var DefaultStrategy = /** @class */ (function (_super) {
    __extends$l(DefaultStrategy, _super);
    function DefaultStrategy() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.selectedState = { selectAll: false, toggledNodes: new Set() };
        _this.lastSelected = null;
        _this.selectAllUsed = false;
        // this is to prevent regressions, default selectionService retains reference of clicked nodes.
        _this.selectedNodes = {};
        return _this;
    }
    DefaultStrategy.prototype.init = function () {
        var _this = this;
        this.rowSelection = this.gridOptionsService.get('rowSelection');
        this.addManagedPropertyListener('rowSelection', function (propChange) {
            _this.rowSelection = propChange.currentValue;
        });
    };
    DefaultStrategy.prototype.getSelectedState = function () {
        return {
            selectAll: this.selectedState.selectAll,
            toggledNodes: __spreadArray$3([], __read$3(this.selectedState.toggledNodes)),
        };
    };
    DefaultStrategy.prototype.setSelectedState = function (state) {
        // fire selection changed event
        var newState = {
            selectAll: false,
            toggledNodes: new Set(),
        };
        if (typeof state !== 'object') {
            console.error('AG Grid: The provided selection state should be an object.');
            return;
        }
        if ('selectAll' in state && typeof state.selectAll === 'boolean') {
            newState.selectAll = state.selectAll;
        } else {
            console.error('AG Grid: Select all status should be of boolean type.');
            return;
        }
        if ('toggledNodes' in state && Array.isArray(state.toggledNodes)) {
            state.toggledNodes.forEach(function (key) {
                if (typeof key === 'string') {
                    newState.toggledNodes.add(key);
                } else {
                    console.warn('AG Grid: Provided ids must be of string type. Invalid id provided: ' + key);
                }
            });
        } else {
            console.error('AG Grid: `toggledNodes` must be an array of string ids.');
            return;
        }
        this.selectedState = newState;
    };
    DefaultStrategy.prototype.deleteSelectionStateFromParent = function (parentPath, removedNodeIds) {
        var _this = this;
        if (this.selectedState.toggledNodes.size === 0) {
            return false;
        }
        var anyNodesToggled = false;
        removedNodeIds.forEach(function (id) {
            if (_this.selectedState.toggledNodes.delete(id)) {
                anyNodesToggled = true;
            }
        });
        return anyNodesToggled;
    };
    DefaultStrategy.prototype.setNodesSelected = function (params) {
        var _a;
        var _this = this;
        if (params.nodes.length === 0) return 0;
        var onlyThisNode = params.clearSelection && params.newValue && !params.rangeSelect;
        if (this.rowSelection !== 'multiple' || onlyThisNode) {
            if (params.nodes.length > 1) {
                throw new Error("AG Grid: cannot select multiple rows when rowSelection is set to 'single'");
            }
            var node = params.nodes[0];
            if (params.newValue) {
                this.selectedNodes = ((_a = {}), (_a[node.id] = node), _a);
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: new Set([node.id]),
                };
            } else {
                this.selectedNodes = {};
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: new Set(),
                };
            }
            this.lastSelected = node.id;
            return 1;
        }
        var updateNodeState = function (node) {
            if (params.newValue) {
                _this.selectedNodes[node.id] = node;
            } else {
                delete _this.selectedNodes[node.id];
            }
            var isNodeSelectable = node.selectable;
            var doesNodeConform = params.newValue === _this.selectedState.selectAll;
            if (doesNodeConform || !isNodeSelectable) {
                _this.selectedState.toggledNodes.delete(node.id);
                return;
            }
            _this.selectedState.toggledNodes.add(node.id);
        };
        if (params.rangeSelect && this.lastSelected) {
            if (params.nodes.length > 1) {
                throw new Error('AG Grid: cannot select multiple rows when using rangeSelect');
            }
            var node = params.nodes[0];
            var lastSelectedNode = this.rowModel.getRowNode(this.lastSelected);
            this.rowModel
                .getNodesInRangeForSelection(
                    node,
                    lastSelectedNode !== null && lastSelectedNode !== void 0 ? lastSelectedNode : null,
                )
                .forEach(updateNodeState);
            this.lastSelected = node.id;
            return 1;
        }
        params.nodes.forEach(updateNodeState);
        this.lastSelected = params.nodes[params.nodes.length - 1].id;
        return 1;
    };
    DefaultStrategy.prototype.processNewRow = function (node) {
        if (this.selectedNodes[node.id]) {
            this.selectedNodes[node.id] = node;
        }
    };
    DefaultStrategy.prototype.isNodeSelected = function (node) {
        var isToggled = this.selectedState.toggledNodes.has(node.id);
        return this.selectedState.selectAll ? !isToggled : isToggled;
    };
    DefaultStrategy.prototype.getSelectedNodes = function () {
        if (this.selectAllUsed) {
            console.warn(
                'AG Grid: getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model.\n                Use `api.getServerSideSelectionState()` instead.',
            );
        }
        return Object.values(this.selectedNodes);
    };
    DefaultStrategy.prototype.getSelectedRows = function () {
        return this.getSelectedNodes().map(function (node) {
            return node.data;
        });
    };
    DefaultStrategy.prototype.getSelectionCount = function () {
        if (this.selectedState.selectAll) {
            return -1;
        }
        return this.selectedState.toggledNodes.size;
    };
    DefaultStrategy.prototype.clearOtherNodes = function (rowNodeToKeepSelected, source) {
        var clearedRows = this.selectedState.selectAll ? 1 : this.selectedState.toggledNodes.size - 1;
        this.selectedState = {
            selectAll: false,
            toggledNodes: new Set([rowNodeToKeepSelected.id]),
        };
        this.rowModel.forEachNode(function (node) {
            if (node !== rowNodeToKeepSelected) {
                node.selectThisNode(false, undefined, source);
            }
        });
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: source,
        };
        this.eventService.dispatchEvent(event);
        return clearedRows;
    };
    DefaultStrategy.prototype.isEmpty = function () {
        var _a;
        return (
            !this.selectedState.selectAll &&
            !((_a = this.selectedState.toggledNodes) === null || _a === void 0 ? void 0 : _a.size)
        );
    };
    DefaultStrategy.prototype.selectAllRowNodes = function (params) {
        this.selectedState = { selectAll: true, toggledNodes: new Set() };
        this.selectedNodes = {};
        this.selectAllUsed = true;
    };
    DefaultStrategy.prototype.deselectAllRowNodes = function (params) {
        this.selectedState = { selectAll: false, toggledNodes: new Set() };
        this.selectedNodes = {};
    };
    DefaultStrategy.prototype.getSelectAllState = function (justFiltered, justCurrentPage) {
        if (this.selectedState.selectAll) {
            if (this.selectedState.toggledNodes.size > 0) {
                return null;
            }
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) {
            return null;
        }
        return false;
    };
    __decorate$g([Autowired('rowModel')], DefaultStrategy.prototype, 'rowModel', void 0);
    __decorate$g([PostConstruct], DefaultStrategy.prototype, 'init', null);
    return DefaultStrategy;
})(BeanStub);

var __extends$k =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$2 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$2 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$2.apply(this, arguments);
    };
var __decorate$f =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __rest$1 =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var __read$2 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$2 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var GroupSelectsChildrenStrategy = /** @class */ (function (_super) {
    __extends$k(GroupSelectsChildrenStrategy, _super);
    function GroupSelectsChildrenStrategy() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.selectedState = { selectAllChildren: false, toggledNodes: new Map() };
        _this.lastSelected = null;
        return _this;
    }
    GroupSelectsChildrenStrategy.prototype.init = function () {
        var _this = this;
        // if model has updated, a store may now be fully loaded to clean up indeterminate states
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, function () {
            return _this.removeRedundantState();
        });
        // when the grouping changes, the state no longer makes sense, so reset the state.
        this.addManagedListener(this.eventService, Events.EVENT_COLUMN_ROW_GROUP_CHANGED, function () {
            return _this.selectionService.reset();
        });
    };
    GroupSelectsChildrenStrategy.prototype.getSelectedState = function () {
        var _this = this;
        var recursivelySerializeState = function (state, level, nodeId) {
            var normalisedState = {
                nodeId: nodeId,
            };
            if (level <= _this.columnModel.getRowGroupColumns().length) {
                normalisedState.selectAllChildren = state.selectAllChildren;
            }
            // omit toggledNodes if empty
            if (state.toggledNodes.size) {
                var toggledNodes_1 = [];
                state.toggledNodes.forEach(function (value, key) {
                    var newState = recursivelySerializeState(value, level + 1, key);
                    toggledNodes_1.push(newState);
                });
                normalisedState.toggledNodes = toggledNodes_1;
            }
            return normalisedState;
        };
        return recursivelySerializeState(this.selectedState, 0);
    };
    GroupSelectsChildrenStrategy.prototype.setSelectedState = function (state) {
        var recursivelyDeserializeState = function (normalisedState, parentSelected) {
            var _a, _b;
            if (typeof normalisedState !== 'object') {
                throw new Error('AG Grid: Each provided state object must be an object.');
            }
            if ('selectAllChildren' in normalisedState && typeof normalisedState.selectAllChildren !== 'boolean') {
                throw new Error('AG Grid: `selectAllChildren` must be a boolean value or undefined.');
            }
            if ('toggledNodes' in normalisedState) {
                if (!Array.isArray(normalisedState.toggledNodes)) {
                    throw new Error('AG Grid: `toggledNodes` must be an array.');
                }
                var allHaveIds = normalisedState.toggledNodes.every(function (innerState) {
                    return (
                        typeof innerState === 'object' &&
                        'nodeId' in innerState &&
                        typeof innerState.nodeId === 'string'
                    );
                });
                if (!allHaveIds) {
                    throw new Error('AG Grid: Every `toggledNode` requires an associated string id.');
                }
            }
            var isThisNodeSelected =
                (_a = normalisedState.selectAllChildren) !== null && _a !== void 0 ? _a : !parentSelected;
            var convertedChildren =
                (_b = normalisedState.toggledNodes) === null || _b === void 0
                    ? void 0
                    : _b.map(function (innerState) {
                          return [innerState.nodeId, recursivelyDeserializeState(innerState, isThisNodeSelected)];
                      });
            var doesRedundantStateExist =
                convertedChildren === null || convertedChildren === void 0
                    ? void 0
                    : convertedChildren.some(function (_a) {
                          var _b = __read$2(_a, 2);
                          _b[0];
                          var innerState = _b[1];
                          return (
                              isThisNodeSelected === innerState.selectAllChildren && innerState.toggledNodes.size === 0
                          );
                      });
            if (doesRedundantStateExist) {
                throw new Error(
                    '\n                    AG Grid: AG Grid: Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule.\n                    Please rebuild the selection state and reapply it.\n                ',
                );
            }
            return {
                selectAllChildren: isThisNodeSelected,
                toggledNodes: new Map(convertedChildren),
            };
        };
        try {
            this.selectedState = recursivelyDeserializeState(state, !!state.selectAllChildren);
        } catch (e) {
            console.error(e.message);
        }
    };
    GroupSelectsChildrenStrategy.prototype.deleteSelectionStateFromParent = function (parentRoute, removedNodeIds) {
        var parentState = this.selectedState;
        var remainingRoute = __spreadArray$2([], __read$2(parentRoute));
        while (parentState && remainingRoute.length) {
            parentState = parentState.toggledNodes.get(remainingRoute.pop());
        }
        // parent has no explicit state, nothing to remove
        if (!parentState) {
            return false;
        }
        var anyStateChanged = false;
        removedNodeIds.forEach(function (id) {
            if (parentState === null || parentState === void 0 ? void 0 : parentState.toggledNodes.delete(id)) {
                anyStateChanged = true;
            }
        });
        if (anyStateChanged) {
            this.removeRedundantState();
        }
        return anyStateChanged;
    };
    GroupSelectsChildrenStrategy.prototype.setNodesSelected = function (params) {
        var _this = this;
        var nodes = params.nodes,
            other = __rest$1(params, ['nodes']);
        if (nodes.length === 0) return 0;
        if (params.rangeSelect) {
            if (nodes.length > 1) {
                throw new Error('AG Grid: cannot select multiple rows when using rangeSelect');
            }
            var node_1 = nodes[0];
            var rangeOfNodes = this.rowModel.getNodesInRangeForSelection(node_1, this.lastSelected);
            // sort the routes by route length, high to low, this means we can do the lowest level children first
            var routes = rangeOfNodes.map(this.getRouteToNode).sort(function (a, b) {
                return b.length - a.length;
            });
            // skip routes if we've already done a descendent
            var completedRoutes_1 = new Set();
            routes.forEach(function (route) {
                // skip routes if we've already selected a descendent
                if (completedRoutes_1.has(route[route.length - 1])) {
                    return;
                }
                route.forEach(function (part) {
                    return completedRoutes_1.add(part);
                });
                _this.recursivelySelectNode(route, _this.selectedState, __assign$2({ node: node_1 }, other));
            });
            this.removeRedundantState();
            this.lastSelected = node_1;
            return 1;
        }
        params.nodes.forEach(function (node) {
            var idPathToNode = _this.getRouteToNode(node);
            _this.recursivelySelectNode(
                idPathToNode,
                _this.selectedState,
                __assign$2(__assign$2({}, other), { node: node }),
            );
        });
        this.removeRedundantState();
        this.lastSelected = params.nodes[params.nodes.length - 1];
        return 1;
    };
    GroupSelectsChildrenStrategy.prototype.isNodeSelected = function (node) {
        var path = this.getRouteToNode(node);
        return this.isNodePathSelected(path, this.selectedState);
    };
    GroupSelectsChildrenStrategy.prototype.isNodePathSelected = function (_a, state) {
        var _b = __read$2(_a),
            nextNode = _b[0],
            nodes = _b.slice(1);
        if (nodes.length === 0) {
            var isToggled = state.toggledNodes.has(nextNode.id);
            if (nextNode.hasChildren()) {
                var groupState = state.toggledNodes.get(nextNode.id);
                if (groupState && groupState.toggledNodes.size) {
                    return undefined;
                }
            }
            return state.selectAllChildren ? !isToggled : isToggled;
        }
        // if there's a deeper level, check recursively
        if (state.toggledNodes.has(nextNode.id)) {
            var nextState = state.toggledNodes.get(nextNode.id);
            if (nextState) {
                return this.isNodePathSelected(nodes, nextState);
            }
        }
        // no deeper custom state, respect the closest default
        return !!state.selectAllChildren;
    };
    GroupSelectsChildrenStrategy.prototype.getRouteToNode = function (node) {
        var pathToNode = [];
        var tempNode = node;
        while (tempNode.parent) {
            pathToNode.push(tempNode);
            tempNode = tempNode.parent;
        }
        return pathToNode.reverse();
    };
    GroupSelectsChildrenStrategy.prototype.removeRedundantState = function () {
        var _this = this;
        if (this.filterManager.isAnyFilterPresent()) {
            return;
        }
        var recursivelyRemoveState = function (selectedState, store, node) {
            if (selectedState === void 0) {
                selectedState = _this.selectedState;
            }
            if (store === void 0) {
                store = _this.serverSideRowModel.getRootStore();
            }
            var allChildNodesFound = true;
            var noIndeterminateChildren = true;
            selectedState.toggledNodes.forEach(function (state, id) {
                var parentNode = _this.rowModel.getRowNode(id);
                if (!parentNode) {
                    allChildNodesFound = false;
                }
                var nextStore = parentNode === null || parentNode === void 0 ? void 0 : parentNode.childStore;
                if (!nextStore) {
                    if (state.toggledNodes.size > 0) {
                        noIndeterminateChildren = false;
                    }
                    return;
                }
                // if child was cleared, check if this state is still relevant
                if (recursivelyRemoveState(state, nextStore, parentNode)) {
                    // cleans out groups which have no toggled nodes and an equivalent default to its parent
                    if (selectedState.selectAllChildren === state.selectAllChildren) {
                        selectedState.toggledNodes.delete(id);
                    }
                }
                if (state.toggledNodes.size > 0) {
                    noIndeterminateChildren = false;
                }
            });
            if (!store || !store.isLastRowIndexKnown() || store.getRowCount() !== selectedState.toggledNodes.size) {
                // if row count unknown, or doesn't match the size of toggledNodes, ignore.
                return false;
            }
            if (noIndeterminateChildren && allChildNodesFound) {
                selectedState.toggledNodes.clear();
                selectedState.selectAllChildren = !selectedState.selectAllChildren;
                // if node was indeterminate, it's not any more.
                if (
                    node &&
                    (node === null || node === void 0 ? void 0 : node.isSelected()) !== selectedState.selectAllChildren
                ) {
                    node.selectThisNode(selectedState.selectAllChildren, undefined, 'api');
                }
                return true;
            }
            return false;
        };
        recursivelyRemoveState();
    };
    GroupSelectsChildrenStrategy.prototype.recursivelySelectNode = function (_a, selectedState, params) {
        var _b = __read$2(_a),
            nextNode = _b[0],
            nodes = _b.slice(1);
        if (!nextNode) {
            return;
        }
        // if this is the last node, hard add/remove based on its selectAllChildren state
        var isLastNode = !nodes.length;
        if (isLastNode) {
            // if the node is not selectable, we should never have it in selection state
            var isNodeSelectable = nextNode.selectable;
            var doesNodeConform = selectedState.selectAllChildren === params.newValue;
            if (doesNodeConform || !isNodeSelectable) {
                selectedState.toggledNodes.delete(nextNode.id);
                return;
            }
            var newState = {
                selectAllChildren: params.newValue,
                toggledNodes: new Map(),
            };
            selectedState.toggledNodes.set(nextNode.id, newState);
            return;
        }
        var doesStateAlreadyExist = selectedState.toggledNodes.has(nextNode.id);
        var childState = doesStateAlreadyExist
            ? selectedState.toggledNodes.get(nextNode.id)
            : {
                  selectAllChildren: selectedState.selectAllChildren,
                  toggledNodes: new Map(),
              };
        if (!doesStateAlreadyExist) {
            selectedState.toggledNodes.set(nextNode.id, childState);
        }
        this.recursivelySelectNode(nodes, childState, params);
        // cleans out groups which have no toggled nodes and an equivalent default to its parent
        if (selectedState.selectAllChildren === childState.selectAllChildren && childState.toggledNodes.size === 0) {
            selectedState.toggledNodes.delete(nextNode.id);
        }
    };
    GroupSelectsChildrenStrategy.prototype.getSelectedNodes = function () {
        console.warn(
            'AG Grid: `getSelectedNodes` and `getSelectedRows` functions cannot be used with `groupSelectsChildren` and the server-side row model.\n            Use `api.getServerSideSelectionState()` instead.',
        );
        var selectedNodes = [];
        this.rowModel.forEachNode(function (node) {
            if (node.isSelected()) {
                selectedNodes.push(node);
            }
        });
        return selectedNodes;
    };
    GroupSelectsChildrenStrategy.prototype.processNewRow = function (node) {
        // This is used for updating outdated node refs, as this model entirely uses ids it's irrelevant
    };
    GroupSelectsChildrenStrategy.prototype.getSelectedRows = function () {
        return this.getSelectedNodes().map(function (node) {
            return node.data;
        });
    };
    GroupSelectsChildrenStrategy.prototype.getSelectionCount = function () {
        return -1;
    };
    GroupSelectsChildrenStrategy.prototype.isEmpty = function () {
        var _a;
        return (
            !this.selectedState.selectAllChildren &&
            !((_a = this.selectedState.toggledNodes) === null || _a === void 0 ? void 0 : _a.size)
        );
    };
    GroupSelectsChildrenStrategy.prototype.selectAllRowNodes = function (params) {
        this.selectedState = { selectAllChildren: true, toggledNodes: new Map() };
    };
    GroupSelectsChildrenStrategy.prototype.deselectAllRowNodes = function (params) {
        this.selectedState = { selectAllChildren: false, toggledNodes: new Map() };
    };
    GroupSelectsChildrenStrategy.prototype.getSelectAllState = function (justFiltered, justCurrentPage) {
        if (this.selectedState.selectAllChildren) {
            if (this.selectedState.toggledNodes.size > 0) {
                return null;
            }
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) {
            return null;
        }
        return false;
    };
    __decorate$f([Autowired('rowModel')], GroupSelectsChildrenStrategy.prototype, 'rowModel', void 0);
    __decorate$f([Autowired('columnModel')], GroupSelectsChildrenStrategy.prototype, 'columnModel', void 0);
    __decorate$f([Autowired('filterManager')], GroupSelectsChildrenStrategy.prototype, 'filterManager', void 0);
    __decorate$f([Autowired('rowModel')], GroupSelectsChildrenStrategy.prototype, 'serverSideRowModel', void 0);
    __decorate$f([Autowired('selectionService')], GroupSelectsChildrenStrategy.prototype, 'selectionService', void 0);
    __decorate$f([PostConstruct], GroupSelectsChildrenStrategy.prototype, 'init', null);
    return GroupSelectsChildrenStrategy;
})(BeanStub);

var __extends$j =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign$1 =
    (undefined && undefined.__assign) ||
    function () {
        __assign$1 =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign$1.apply(this, arguments);
    };
var __decorate$e =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var __rest =
    (undefined && undefined.__rest) ||
    function (s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === 'function')
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
            }
        return t;
    };
var ServerSideSelectionService = /** @class */ (function (_super) {
    __extends$j(ServerSideSelectionService, _super);
    function ServerSideSelectionService() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ServerSideSelectionService.prototype.init = function () {
        var _this = this;
        var groupSelectsChildren = this.gridOptionsService.is('groupSelectsChildren');
        this.addManagedPropertyListener('groupSelectsChildren', function (propChange) {
            _this.destroyBean(_this.selectionStrategy);
            var StrategyClazz = !propChange.currentValue ? DefaultStrategy : GroupSelectsChildrenStrategy;
            _this.selectionStrategy = _this.createManagedBean(new StrategyClazz());
            _this.shotgunResetNodeSelectionState();
            var event = {
                type: Events.EVENT_SELECTION_CHANGED,
                source: 'api',
            };
            _this.eventService.dispatchEvent(event);
        });
        this.rowSelection = this.gridOptionsService.get('rowSelection');
        this.addManagedPropertyListener('rowSelection', function (propChange) {
            return (_this.rowSelection = propChange.currentValue);
        });
        var StrategyClazz = !groupSelectsChildren ? DefaultStrategy : GroupSelectsChildrenStrategy;
        this.selectionStrategy = this.createManagedBean(new StrategyClazz());
    };
    ServerSideSelectionService.prototype.getServerSideSelectionState = function () {
        return this.selectionStrategy.getSelectedState();
    };
    ServerSideSelectionService.prototype.setServerSideSelectionState = function (state) {
        this.selectionStrategy.setSelectedState(state);
        this.shotgunResetNodeSelectionState();
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: 'api',
        };
        this.eventService.dispatchEvent(event);
    };
    ServerSideSelectionService.prototype.setNodesSelected = function (params) {
        var nodes = params.nodes,
            otherParams = __rest(params, ['nodes']);
        if (nodes.length > 1 && this.rowSelection !== 'multiple') {
            console.warn("AG Grid: cannot multi select while rowSelection='single'");
            return 0;
        }
        if (nodes.length > 1 && params.rangeSelect) {
            console.warn('AG Grid: cannot use range selection when multi selecting rows');
            return 0;
        }
        var adjustedParams = __assign$1(
            {
                nodes: nodes.filter(function (node) {
                    return node.selectable;
                }),
            },
            otherParams,
        );
        // if no selectable nodes, then return 0
        if (!adjustedParams.nodes.length) {
            return 0;
        }
        var changedNodes = this.selectionStrategy.setNodesSelected(adjustedParams);
        this.shotgunResetNodeSelectionState(adjustedParams.source);
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: adjustedParams.source,
        };
        this.eventService.dispatchEvent(event);
        return changedNodes;
    };
    /**
     * Deletes the selection state for a set of nodes, for use after deleting nodes via
     * transaction. As this is designed for transactions, all nodes should belong to the same group.
     */
    ServerSideSelectionService.prototype.deleteSelectionStateFromParent = function (storeRoute, removedNodeIds) {
        var stateChanged = this.selectionStrategy.deleteSelectionStateFromParent(storeRoute, removedNodeIds);
        if (!stateChanged) {
            return;
        }
        this.shotgunResetNodeSelectionState();
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: 'api',
        };
        this.eventService.dispatchEvent(event);
    };
    ServerSideSelectionService.prototype.shotgunResetNodeSelectionState = function (source) {
        var _this = this;
        this.rowModel.forEachNode(function (node) {
            if (node.stub) {
                return;
            }
            var isNodeSelected = _this.selectionStrategy.isNodeSelected(node);
            if (isNodeSelected !== node.isSelected()) {
                node.selectThisNode(isNodeSelected, undefined, source);
            }
        });
    };
    ServerSideSelectionService.prototype.getSelectedNodes = function () {
        return this.selectionStrategy.getSelectedNodes();
    };
    ServerSideSelectionService.prototype.getSelectedRows = function () {
        return this.selectionStrategy.getSelectedRows();
    };
    ServerSideSelectionService.prototype.getSelectionCount = function () {
        return this.selectionStrategy.getSelectionCount();
    };
    ServerSideSelectionService.prototype.syncInRowNode = function (rowNode, oldNode) {
        // update any refs being held in the strategies
        this.selectionStrategy.processNewRow(rowNode);
        var isNodeSelected = this.selectionStrategy.isNodeSelected(rowNode);
        // if the node was selected but node is not selectable, we deselect the node.
        // (could be due to user applying selected state directly, or a change in selectable)
        if (isNodeSelected != false && !rowNode.selectable) {
            this.selectionStrategy.setNodesSelected({
                nodes: [rowNode],
                newValue: false,
                source: 'api',
            });
            // we need to shotgun reset here as if this was hierarchical, some group nodes
            // may be changing from indeterminate to unchecked.
            this.shotgunResetNodeSelectionState();
            var event_1 = {
                type: Events.EVENT_SELECTION_CHANGED,
                source: 'api',
            };
            this.eventService.dispatchEvent(event_1);
            return;
        }
        rowNode.setSelectedInitialValue(isNodeSelected);
    };
    ServerSideSelectionService.prototype.reset = function () {
        this.selectionStrategy.deselectAllRowNodes({ source: 'api' });
    };
    ServerSideSelectionService.prototype.isEmpty = function () {
        return this.selectionStrategy.isEmpty();
    };
    ServerSideSelectionService.prototype.selectAllRowNodes = function (params) {
        if (params.justCurrentPage || params.justFiltered) {
            console.warn("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
        }
        this.selectionStrategy.selectAllRowNodes(params);
        this.rowModel.forEachNode(function (node) {
            if (node.stub) {
                return;
            }
            node.selectThisNode(true, undefined, params.source);
        });
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: params.source,
        };
        this.eventService.dispatchEvent(event);
    };
    ServerSideSelectionService.prototype.deselectAllRowNodes = function (params) {
        if (params.justCurrentPage || params.justFiltered) {
            console.warn("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
        }
        this.selectionStrategy.deselectAllRowNodes(params);
        this.rowModel.forEachNode(function (node) {
            if (node.stub) {
                return;
            }
            node.selectThisNode(false, undefined, params.source);
        });
        var event = {
            type: Events.EVENT_SELECTION_CHANGED,
            source: params.source,
        };
        this.eventService.dispatchEvent(event);
    };
    ServerSideSelectionService.prototype.getSelectAllState = function (justFiltered, justCurrentPage) {
        return this.selectionStrategy.getSelectAllState(justFiltered, justCurrentPage);
    };
    // used by CSRM
    ServerSideSelectionService.prototype.updateGroupsFromChildrenSelections = function (source, changedPath) {
        return false;
    };
    // used by CSRM
    ServerSideSelectionService.prototype.getBestCostNodeSelection = function () {
        console.warn(
            'AG Grid: calling gridApi.getBestCostNodeSelection() is only possible when using rowModelType=`clientSide`.',
        );
        return undefined;
    };
    // used by CSRM
    ServerSideSelectionService.prototype.filterFromSelection = function () {
        return;
    };
    __decorate$e([Autowired('rowModel')], ServerSideSelectionService.prototype, 'rowModel', void 0);
    __decorate$e([PostConstruct], ServerSideSelectionService.prototype, 'init', null);
    ServerSideSelectionService = __decorate$e([Bean('selectionService')], ServerSideSelectionService);
    return ServerSideSelectionService;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$4 = '30.2.0';

var ServerSideRowModelModule = {
    version: VERSION$4,
    moduleName: ModuleNames.ServerSideRowModelModule,
    rowModel: 'serverSide',
    beans: [
        ServerSideRowModel,
        ExpandListener,
        SortListener,
        StoreUtils,
        BlockUtils,
        NodeManager,
        TransactionManager,
        FilterListener,
        StoreFactory,
        ListenerUtils,
        ServerSideSelectionService,
    ],
    dependantModules: [EnterpriseCoreModule],
};

/** @param V type of value in the Set Filter */
var ClientSideValuesExtractor = /** @class */ (function () {
    function ClientSideValuesExtractor(
        rowModel,
        filterParams,
        createKey,
        caseFormat,
        columnModel,
        valueService,
        treeDataOrGrouping,
        treeData,
        getDataPath,
        groupAllowUnbalanced,
    ) {
        this.rowModel = rowModel;
        this.filterParams = filterParams;
        this.createKey = createKey;
        this.caseFormat = caseFormat;
        this.columnModel = columnModel;
        this.valueService = valueService;
        this.treeDataOrGrouping = treeDataOrGrouping;
        this.treeData = treeData;
        this.getDataPath = getDataPath;
        this.groupAllowUnbalanced = groupAllowUnbalanced;
    }
    ClientSideValuesExtractor.prototype.extractUniqueValues = function (predicate, existingValues) {
        var _this = this;
        var values = new Map();
        var existingFormattedKeys = this.extractExistingFormattedKeys(existingValues);
        var formattedKeys = new Set();
        var treeData = this.treeData && !!this.getDataPath;
        var groupedCols = this.columnModel.getRowGroupColumns();
        var addValue = function (unformattedKey, value) {
            var formattedKey = _this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                var keyToAdd = unformattedKey;
                var valueToAdd = _.makeNull(value);
                // when case insensitive, we pick the first value to use. if this is later filtered out,
                // we still want to use the original value and not one with a different case
                var existingUnformattedKey =
                    existingFormattedKeys === null || existingFormattedKeys === void 0
                        ? void 0
                        : existingFormattedKeys.get(formattedKey);
                if (existingUnformattedKey != null) {
                    keyToAdd = existingUnformattedKey;
                    valueToAdd = existingValues.get(existingUnformattedKey);
                }
                values.set(keyToAdd, valueToAdd);
            }
        };
        this.rowModel.forEachLeafNode(function (node) {
            // only pull values from rows that have data. this means we skip filler group nodes.
            if (!node.data || !predicate(node)) {
                return;
            }
            if (_this.treeDataOrGrouping) {
                _this.addValueForTreeDataOrGrouping(node, treeData, groupedCols, addValue);
                return;
            }
            var value = _this.getValue(node);
            if (_this.filterParams.convertValuesToStrings) {
                // for backwards compatibility - keeping separate as it will eventually be removed
                _this.addValueForConvertValuesToString(node, value, addValue);
                return;
            }
            if (value != null && Array.isArray(value)) {
                value.forEach(function (x) {
                    addValue(_this.createKey(x, node), x);
                });
                if (value.length === 0) {
                    addValue(null, null);
                }
            } else {
                addValue(_this.createKey(value, node), value);
            }
        });
        return values;
    };
    ClientSideValuesExtractor.prototype.addValueForConvertValuesToString = function (node, value, addValue) {
        var key = this.createKey(value, node);
        if (key != null && Array.isArray(key)) {
            key.forEach(function (part) {
                var processedPart = _.toStringOrNull(_.makeNull(part));
                addValue(processedPart, processedPart);
            });
            if (key.length === 0) {
                addValue(null, null);
            }
        } else {
            addValue(key, key);
        }
    };
    ClientSideValuesExtractor.prototype.addValueForTreeDataOrGrouping = function (
        node,
        treeData,
        groupedCols,
        addValue,
    ) {
        var _this = this;
        var _a;
        var dataPath;
        if (treeData) {
            if ((_a = node.childrenAfterGroup) === null || _a === void 0 ? void 0 : _a.length) {
                return;
            }
            dataPath = this.getDataPath(node.data);
        } else {
            dataPath = groupedCols.map(function (groupCol) {
                return _this.valueService.getKeyForNode(groupCol, node);
            });
            dataPath.push(this.getValue(node));
        }
        if (dataPath) {
            dataPath = dataPath.map(function (treeKey) {
                return _.toStringOrNull(_.makeNull(treeKey));
            });
        }
        if (
            !treeData &&
            this.groupAllowUnbalanced &&
            (dataPath === null || dataPath === void 0
                ? void 0
                : dataPath.some(function (treeKey) {
                      return treeKey == null;
                  }))
        ) {
            dataPath = dataPath.filter(function (treeKey) {
                return treeKey != null;
            });
        }
        addValue(this.createKey(dataPath), dataPath);
    };
    ClientSideValuesExtractor.prototype.getValue = function (node) {
        var _a = this.filterParams,
            api = _a.api,
            colDef = _a.colDef,
            column = _a.column,
            columnApi = _a.columnApi,
            context = _a.context;
        return this.filterParams.valueGetter({
            api: api,
            colDef: colDef,
            column: column,
            columnApi: columnApi,
            context: context,
            data: node.data,
            getValue: function (field) {
                return node.data[field];
            },
            node: node,
        });
    };
    ClientSideValuesExtractor.prototype.extractExistingFormattedKeys = function (existingValues) {
        var _this = this;
        if (!existingValues) {
            return null;
        }
        var existingFormattedKeys = new Map();
        existingValues.forEach(function (_value, key) {
            existingFormattedKeys.set(_this.caseFormat(key), key);
        });
        return existingFormattedKeys;
    };
    return ClientSideValuesExtractor;
})();

var SetFilterDisplayValue = /** @class */ (function () {
    function SetFilterDisplayValue() {}
    SetFilterDisplayValue.SELECT_ALL = '__AG_SELECT_ALL__';
    SetFilterDisplayValue.ADD_SELECTION_TO_FILTER = '__AG_ADD_SELECTION_TO_FILTER__';
    return SetFilterDisplayValue;
})();

var __values$2 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var FlatSetDisplayValueModel = /** @class */ (function () {
    function FlatSetDisplayValueModel(valueFormatterService, valueFormatter, formatter, column) {
        this.valueFormatterService = valueFormatterService;
        this.valueFormatter = valueFormatter;
        this.formatter = formatter;
        this.column = column;
        /** All keys that are currently displayed, after the mini-filter has been applied. */
        this.displayedKeys = [];
    }
    FlatSetDisplayValueModel.prototype.updateDisplayedValuesToAllAvailable = function (
        _getValue,
        _allKeys,
        availableKeys,
    ) {
        this.displayedKeys = Array.from(availableKeys);
    };
    FlatSetDisplayValueModel.prototype.updateDisplayedValuesToMatchMiniFilter = function (
        getValue,
        _allKeys,
        availableKeys,
        matchesFilter,
        nullMatchesFilter,
    ) {
        var e_1, _a;
        this.displayedKeys = [];
        try {
            for (
                var availableKeys_1 = __values$2(availableKeys), availableKeys_1_1 = availableKeys_1.next();
                !availableKeys_1_1.done;
                availableKeys_1_1 = availableKeys_1.next()
            ) {
                var key = availableKeys_1_1.value;
                if (key == null) {
                    if (nullMatchesFilter) {
                        this.displayedKeys.push(key);
                    }
                } else {
                    var value = getValue(key);
                    var valueFormatterValue = this.valueFormatterService.formatValue(
                        this.column,
                        null,
                        value,
                        this.valueFormatter,
                        false,
                    );
                    var textFormatterValue = this.formatter(valueFormatterValue);
                    if (matchesFilter(textFormatterValue)) {
                        this.displayedKeys.push(key);
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (availableKeys_1_1 && !availableKeys_1_1.done && (_a = availableKeys_1.return))
                    _a.call(availableKeys_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    FlatSetDisplayValueModel.prototype.getDisplayedValueCount = function () {
        return this.displayedKeys.length;
    };
    FlatSetDisplayValueModel.prototype.getDisplayedItem = function (index) {
        return this.displayedKeys[index];
    };
    FlatSetDisplayValueModel.prototype.getSelectAllItem = function () {
        return SetFilterDisplayValue.SELECT_ALL;
    };
    FlatSetDisplayValueModel.prototype.getAddSelectionToFilterItem = function () {
        return SetFilterDisplayValue.ADD_SELECTION_TO_FILTER;
    };
    FlatSetDisplayValueModel.prototype.getDisplayedKeys = function () {
        return this.displayedKeys;
    };
    FlatSetDisplayValueModel.prototype.forEachDisplayedKey = function (func) {
        this.displayedKeys.forEach(func);
    };
    FlatSetDisplayValueModel.prototype.someDisplayedKey = function (func) {
        return this.displayedKeys.some(func);
    };
    FlatSetDisplayValueModel.prototype.hasGroups = function () {
        return false;
    };
    FlatSetDisplayValueModel.prototype.refresh = function () {
        // not used
    };
    return FlatSetDisplayValueModel;
})();

var __read$1 =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray$1 =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var __values$1 =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var TreeSetDisplayValueModel = /** @class */ (function () {
    function TreeSetDisplayValueModel(formatter, treeListPathGetter, treeListFormatter, treeDataOrGrouping) {
        this.formatter = formatter;
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
        this.treeDataOrGrouping = treeDataOrGrouping;
        /** all displayed items in a tree structure */
        this.allDisplayedItemsTree = [];
        /** all displayed items flattened and filtered */
        this.activeDisplayedItemsFlat = [];
        this.selectAllItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: SetFilterDisplayValue.SELECT_ALL,
            children: this.allDisplayedItemsTree,
            expanded: true,
            key: SetFilterDisplayValue.SELECT_ALL,
            parentTreeKeys: [],
        };
        this.addSelectionToFilterItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: SetFilterDisplayValue.ADD_SELECTION_TO_FILTER,
            expanded: true,
            key: SetFilterDisplayValue.ADD_SELECTION_TO_FILTER,
            parentTreeKeys: [],
        };
    }
    TreeSetDisplayValueModel.prototype.updateDisplayedValuesToAllAvailable = function (
        getValue,
        allKeys,
        availableKeys,
        source,
    ) {
        if (source === 'reload') {
            this.generateItemTree(getValue, allKeys, availableKeys);
        } else if (source === 'otherFilter') {
            this.updateAvailable(availableKeys);
            this.updateExpandAll();
        } else if (source === 'miniFilter') {
            this.resetFilter();
            this.updateExpandAll();
        }
        this.flattenItems();
    };
    TreeSetDisplayValueModel.prototype.updateDisplayedValuesToMatchMiniFilter = function (
        getValue,
        allKeys,
        availableKeys,
        matchesFilter,
        nullMatchesFilter,
        source,
    ) {
        if (source === 'reload') {
            this.generateItemTree(getValue, allKeys, availableKeys);
        } else if (source === 'otherFilter') {
            this.updateAvailable(availableKeys);
        }
        this.updateFilter(matchesFilter, nullMatchesFilter);
        this.updateExpandAll();
        this.flattenItems();
    };
    TreeSetDisplayValueModel.prototype.generateItemTree = function (getValue, allKeys, availableKeys) {
        var e_1, _a;
        var _b;
        this.allDisplayedItemsTree = [];
        this.groupsExist = false;
        var treeListPathGetter = this.getTreeListPathGetter(getValue, availableKeys);
        var _loop_1 = function (key) {
            var value = getValue(key);
            var dataPath = (_b = treeListPathGetter(value)) !== null && _b !== void 0 ? _b : [null];
            if (dataPath.length > 1) {
                this_1.groupsExist = true;
            }
            var available = availableKeys.has(key);
            var children = this_1.allDisplayedItemsTree;
            var item;
            var parentTreeKeys = [];
            dataPath.forEach(function (treeKey, depth) {
                if (!children) {
                    children = [];
                    item.children = children;
                }
                item = children.find(function (child) {
                    var _a;
                    return (
                        ((_a = child.treeKey) === null || _a === void 0 ? void 0 : _a.toUpperCase()) ===
                        (treeKey === null || treeKey === void 0 ? void 0 : treeKey.toUpperCase())
                    );
                });
                if (!item) {
                    item = {
                        treeKey: treeKey,
                        depth: depth,
                        filterPasses: true,
                        expanded: false,
                        available: available,
                        parentTreeKeys: parentTreeKeys,
                    };
                    if (depth === dataPath.length - 1) {
                        item.key = key;
                    }
                    children.push(item);
                }
                children = item.children;
                parentTreeKeys = __spreadArray$1(__spreadArray$1([], __read$1(parentTreeKeys)), [treeKey]);
            });
        };
        var this_1 = this;
        try {
            for (
                var allKeys_1 = __values$1(allKeys), allKeys_1_1 = allKeys_1.next();
                !allKeys_1_1.done;
                allKeys_1_1 = allKeys_1.next()
            ) {
                var key = allKeys_1_1.value;
                _loop_1(key);
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (allKeys_1_1 && !allKeys_1_1.done && (_a = allKeys_1.return)) _a.call(allKeys_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
        // update the parent availability based on the children
        this.updateAvailable(availableKeys);
        this.selectAllItem.children = this.allDisplayedItemsTree;
        this.selectAllItem.expanded = false;
    };
    TreeSetDisplayValueModel.prototype.getTreeListPathGetter = function (getValue, availableKeys) {
        var e_2, _a;
        if (this.treeListPathGetter) {
            return this.treeListPathGetter;
        }
        if (this.treeDataOrGrouping) {
            return function (value) {
                return value;
            };
        }
        // infer from data
        var isDate = false;
        try {
            for (
                var availableKeys_1 = __values$1(availableKeys), availableKeys_1_1 = availableKeys_1.next();
                !availableKeys_1_1.done;
                availableKeys_1_1 = availableKeys_1.next()
            ) {
                var availableKey = availableKeys_1_1.value;
                // find the first non-null value
                var value = getValue(availableKey);
                if (value instanceof Date) {
                    isDate = true;
                    break;
                } else if (value != null) {
                    break;
                }
            }
        } catch (e_2_1) {
            e_2 = { error: e_2_1 };
        } finally {
            try {
                if (availableKeys_1_1 && !availableKeys_1_1.done && (_a = availableKeys_1.return))
                    _a.call(availableKeys_1);
            } finally {
                if (e_2) throw e_2.error;
            }
        }
        if (isDate) {
            return TreeSetDisplayValueModel.DATE_TREE_LIST_PATH_GETTER;
        }
        _.doOnce(function () {
            return console.warn(
                'AG Grid: property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.',
            );
        }, 'getTreeListPathGetter');
        return function (value) {
            return [String(value)];
        };
    };
    TreeSetDisplayValueModel.prototype.flattenItems = function () {
        var _this = this;
        this.activeDisplayedItemsFlat = [];
        var recursivelyFlattenDisplayedItems = function (items) {
            items.forEach(function (item) {
                if (!item.filterPasses || !item.available) {
                    return;
                }
                _this.activeDisplayedItemsFlat.push(item);
                if (item.children && item.expanded) {
                    recursivelyFlattenDisplayedItems(item.children);
                }
            });
        };
        recursivelyFlattenDisplayedItems(this.allDisplayedItemsTree);
    };
    TreeSetDisplayValueModel.prototype.resetFilter = function () {
        var recursiveFilterReset = function (item) {
            if (item.children) {
                item.children.forEach(function (child) {
                    recursiveFilterReset(child);
                });
            }
            item.filterPasses = true;
        };
        this.allDisplayedItemsTree.forEach(function (item) {
            return recursiveFilterReset(item);
        });
    };
    TreeSetDisplayValueModel.prototype.updateFilter = function (matchesFilter, nullMatchesFilter) {
        var _this = this;
        var passesFilter = function (item) {
            if (!item.available) {
                return false;
            }
            if (item.treeKey == null) {
                return nullMatchesFilter;
            }
            return matchesFilter(
                _this.formatter(
                    _this.treeListFormatter
                        ? _this.treeListFormatter(item.treeKey, item.depth, item.parentTreeKeys)
                        : item.treeKey,
                ),
            );
        };
        this.allDisplayedItemsTree.forEach(function (item) {
            return _this.recursiveItemCheck(item, false, passesFilter, 'filterPasses');
        });
    };
    TreeSetDisplayValueModel.prototype.getDisplayedValueCount = function () {
        return this.activeDisplayedItemsFlat.length;
    };
    TreeSetDisplayValueModel.prototype.getDisplayedItem = function (index) {
        return this.activeDisplayedItemsFlat[index];
    };
    TreeSetDisplayValueModel.prototype.getSelectAllItem = function () {
        return this.selectAllItem;
    };
    TreeSetDisplayValueModel.prototype.getAddSelectionToFilterItem = function () {
        return this.addSelectionToFilterItem;
    };
    TreeSetDisplayValueModel.prototype.getDisplayedKeys = function () {
        var displayedKeys = [];
        this.forEachDisplayedKey(function (key) {
            return displayedKeys.push(key);
        });
        return displayedKeys;
    };
    TreeSetDisplayValueModel.prototype.forEachDisplayedKey = function (func) {
        var recursiveForEachItem = function (item, topParentExpanded) {
            if (item.children) {
                if (!item.expanded || !topParentExpanded) {
                    // if the parent is not expanded, we need to iterate the entire tree
                    item.children.forEach(function (child) {
                        if (child.filterPasses) {
                            recursiveForEachItem(child, false);
                        }
                    });
                }
            } else {
                func(item.key);
            }
        };
        this.activeDisplayedItemsFlat.forEach(function (item) {
            return recursiveForEachItem(item, true);
        });
    };
    TreeSetDisplayValueModel.prototype.someDisplayedKey = function (func) {
        var recursiveSomeItem = function (item, topParentExpanded) {
            if (item.children) {
                if (!item.expanded || !topParentExpanded) {
                    // if the parent is not expanded, we need to iterate the entire tree
                    return item.children.some(function (child) {
                        if (child.filterPasses) {
                            return recursiveSomeItem(child, false);
                        }
                        return false;
                    });
                }
            } else {
                return func(item.key);
            }
            return false;
        };
        return this.activeDisplayedItemsFlat.some(function (item) {
            return recursiveSomeItem(item, true);
        });
    };
    TreeSetDisplayValueModel.prototype.hasGroups = function () {
        return this.groupsExist;
    };
    TreeSetDisplayValueModel.prototype.refresh = function () {
        this.updateExpandAll();
        this.flattenItems();
    };
    TreeSetDisplayValueModel.prototype.updateExpandAll = function () {
        var recursiveExpansionCheck = function (items, someTrue, someFalse) {
            var e_3, _a;
            try {
                for (
                    var items_1 = __values$1(items), items_1_1 = items_1.next();
                    !items_1_1.done;
                    items_1_1 = items_1.next()
                ) {
                    var item_1 = items_1_1.value;
                    if (!item_1.filterPasses || !item_1.available || !item_1.children) {
                        continue;
                    }
                    // indeterminate state only exists for expand all, so don't need to check for the current item
                    someTrue = someTrue || !!item_1.expanded;
                    someFalse = someFalse || !item_1.expanded;
                    if (someTrue && someFalse) {
                        // already indeterminate. No need to check the children
                        return undefined;
                    }
                    var childExpanded = recursiveExpansionCheck(item_1.children, someTrue, someFalse);
                    if (childExpanded === undefined) {
                        return undefined;
                    } else if (childExpanded) {
                        someTrue = true;
                    } else {
                        someFalse = true;
                    }
                }
            } catch (e_3_1) {
                e_3 = { error: e_3_1 };
            } finally {
                try {
                    if (items_1_1 && !items_1_1.done && (_a = items_1.return)) _a.call(items_1);
                } finally {
                    if (e_3) throw e_3.error;
                }
            }
            return someTrue && someFalse ? undefined : someTrue;
        };
        var item = this.getSelectAllItem();
        item.expanded = recursiveExpansionCheck(item.children, false, false);
    };
    TreeSetDisplayValueModel.prototype.recursiveItemCheck = function (item, parentPasses, checkFunction, itemProp) {
        var _this = this;
        var atLeastOneChildPassed = false;
        if (item.children) {
            item.children.forEach(function (child) {
                var childPasses = _this.recursiveItemCheck(
                    child,
                    parentPasses || checkFunction(item),
                    checkFunction,
                    itemProp,
                );
                atLeastOneChildPassed = atLeastOneChildPassed || childPasses;
            });
        }
        var itemPasses = parentPasses || atLeastOneChildPassed || checkFunction(item);
        item[itemProp] = itemPasses;
        return itemPasses;
    };
    TreeSetDisplayValueModel.prototype.updateAvailable = function (availableKeys) {
        var _this = this;
        var isAvailable = function (item) {
            return availableKeys.has(item.key);
        };
        this.allDisplayedItemsTree.forEach(function (item) {
            return _this.recursiveItemCheck(item, false, isAvailable, 'available');
        });
    };
    TreeSetDisplayValueModel.DATE_TREE_LIST_PATH_GETTER = function (date) {
        return date ? [String(date.getFullYear()), String(date.getMonth() + 1), String(date.getDate())] : null;
    };
    return TreeSetDisplayValueModel;
})();

var SetValueModelFilteringKeys = /** @class */ (function () {
    function SetValueModelFilteringKeys(_a) {
        var caseFormat = _a.caseFormat;
        // To make the filtering fast, we store the keys in a Set rather than using the default array.
        this.filteringKeys = null;
        // This attribute contains keys that are actually used for filtering.
        // These keys take into account case sensitivity:
        // - When filtering is case-insensitive, all filtering keys are converted to upper case and stored here.
        // - When filtering is case-sensitive, this is the same as filteringKeys.
        this.filteringKeysCaseFormatted = null;
        this.hasNoAppliedFilteringKeys = false;
        this.caseFormat = caseFormat;
    }
    SetValueModelFilteringKeys.prototype.allFilteringKeys = function () {
        return this.filteringKeys;
    };
    SetValueModelFilteringKeys.prototype.allFilteringKeysCaseFormatted = function () {
        return this.filteringKeysCaseFormatted;
    };
    SetValueModelFilteringKeys.prototype.noAppliedFilteringKeys = function () {
        return this.hasNoAppliedFilteringKeys;
    };
    SetValueModelFilteringKeys.prototype.setFilteringKeys = function (filteringKeys) {
        var _this = this;
        this.filteringKeys = new Set(filteringKeys);
        this.hasNoAppliedFilteringKeys = !this.filteringKeys || this.filteringKeys.size === 0;
        this.filteringKeysCaseFormatted = new Set();
        this.filteringKeys.forEach(function (key) {
            return _this.filteringKeysCaseFormatted.add(_this.caseFormat(key));
        });
    };
    SetValueModelFilteringKeys.prototype.addFilteringKey = function (key) {
        if (this.filteringKeys == null) {
            this.filteringKeys = new Set();
            this.filteringKeysCaseFormatted = new Set();
        }
        this.filteringKeys.add(key);
        this.filteringKeysCaseFormatted.add(this.caseFormat(key));
        if (this.hasNoAppliedFilteringKeys) {
            this.hasNoAppliedFilteringKeys = false;
        }
    };
    SetValueModelFilteringKeys.prototype.hasCaseFormattedFilteringKey = function (key) {
        return this.filteringKeysCaseFormatted.has(this.caseFormat(key));
    };
    SetValueModelFilteringKeys.prototype.hasFilteringKey = function (key) {
        return this.filteringKeys.has(key);
    };
    SetValueModelFilteringKeys.prototype.reset = function () {
        this.filteringKeys = null;
        this.filteringKeysCaseFormatted = null;
        this.hasNoAppliedFilteringKeys = false;
    };
    return SetValueModelFilteringKeys;
})();

var __read =
    (undefined && undefined.__read) ||
    function (o, n) {
        var m = typeof Symbol === 'function' && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o),
            r,
            ar = [],
            e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        } catch (error) {
            e = { error: error };
        } finally {
            try {
                if (r && !r.done && (m = i['return'])) m.call(i);
            } finally {
                if (e) throw e.error;
            }
        }
        return ar;
    };
var __spreadArray =
    (undefined && undefined.__spreadArray) ||
    function (to, from) {
        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];
        return to;
    };
var SetFilterModelValuesType;
(function (SetFilterModelValuesType) {
    SetFilterModelValuesType[(SetFilterModelValuesType['PROVIDED_LIST'] = 0)] = 'PROVIDED_LIST';
    SetFilterModelValuesType[(SetFilterModelValuesType['PROVIDED_CALLBACK'] = 1)] = 'PROVIDED_CALLBACK';
    SetFilterModelValuesType[(SetFilterModelValuesType['TAKEN_FROM_GRID_VALUES'] = 2)] = 'TAKEN_FROM_GRID_VALUES';
})(SetFilterModelValuesType || (SetFilterModelValuesType = {}));
/** @param V type of value in the Set Filter */
var SetValueModel = /** @class */ (function () {
    function SetValueModel(params) {
        var _this = this;
        var _a;
        this.localEventService = new EventService();
        this.miniFilterText = null;
        /** When true, in excelMode = 'windows', it adds previously selected filter items to newly checked filter selection */
        this.addCurrentSelectionToFilter = false;
        /** Values provided to the filter for use. */
        this.providedValues = null;
        /** All possible values for the filter, sorted if required. */
        this.allValues = new Map();
        /** Remaining keys when filters from other columns have been applied. */
        this.availableKeys = new Set();
        /** Keys that have been selected for this filter. */
        this.selectedKeys = new Set();
        this.initialised = false;
        var usingComplexObjects = params.usingComplexObjects,
            columnModel = params.columnModel,
            valueService = params.valueService,
            treeDataTreeList = params.treeDataTreeList,
            groupingTreeList = params.groupingTreeList,
            filterParams = params.filterParams,
            gridOptionsService = params.gridOptionsService,
            valueFormatterService = params.valueFormatterService,
            valueFormatter = params.valueFormatter;
        var column = filterParams.column,
            colDef = filterParams.colDef,
            textFormatter = filterParams.textFormatter,
            doesRowPassOtherFilter = filterParams.doesRowPassOtherFilter,
            suppressSorting = filterParams.suppressSorting,
            comparator = filterParams.comparator,
            rowModel = filterParams.rowModel,
            values = filterParams.values,
            caseSensitive = filterParams.caseSensitive,
            convertValuesToStrings = filterParams.convertValuesToStrings,
            treeList = filterParams.treeList,
            treeListPathGetter = filterParams.treeListPathGetter,
            treeListFormatter = filterParams.treeListFormatter;
        this.filterParams = filterParams;
        this.setIsLoading = params.setIsLoading;
        this.translate = params.translate;
        this.caseFormat = params.caseFormat;
        this.createKey = params.createKey;
        this.usingComplexObjects = !!params.usingComplexObjects;
        this.formatter = textFormatter || TextFilter.DEFAULT_FORMATTER;
        this.doesRowPassOtherFilters = doesRowPassOtherFilter;
        this.suppressSorting = suppressSorting || false;
        this.convertValuesToStrings = !!convertValuesToStrings;
        this.filteringKeys = new SetValueModelFilteringKeys({ caseFormat: this.caseFormat });
        var keyComparator = comparator !== null && comparator !== void 0 ? comparator : colDef.comparator;
        var treeDataOrGrouping = !!treeDataTreeList || !!groupingTreeList;
        // If using complex objects and a comparator is provided, sort by values, otherwise need to sort by the string keys.
        // Also if tree data, grouping, or date with tree list, then need to do value sort
        this.compareByValue = !!(
            (usingComplexObjects && keyComparator) ||
            treeDataOrGrouping ||
            (treeList && !treeListPathGetter)
        );
        if (treeDataOrGrouping && !keyComparator) {
            this.entryComparator = this.createTreeDataOrGroupingComparator();
        } else if (treeList && !treeListPathGetter && !keyComparator) {
            this.entryComparator = function (_a, _b) {
                var _c = __read(_a, 2);
                _c[0];
                var aValue = _c[1];
                var _d = __read(_b, 2);
                _d[0];
                var bValue = _d[1];
                return _.defaultComparator(aValue, bValue);
            };
        } else {
            this.entryComparator = function (_a, _b) {
                var _c = __read(_a, 2);
                _c[0];
                var aValue = _c[1];
                var _d = __read(_b, 2);
                _d[0];
                var bValue = _d[1];
                return keyComparator(aValue, bValue);
            };
        }
        this.keyComparator = (_a = keyComparator) !== null && _a !== void 0 ? _a : _.defaultComparator;
        this.caseSensitive = !!caseSensitive;
        var getDataPath = gridOptionsService.get('getDataPath');
        var groupAllowUnbalanced = gridOptionsService.is('groupAllowUnbalanced');
        if (rowModel.getType() === 'clientSide') {
            this.clientSideValuesExtractor = new ClientSideValuesExtractor(
                rowModel,
                this.filterParams,
                this.createKey,
                this.caseFormat,
                columnModel,
                valueService,
                treeDataOrGrouping,
                !!treeDataTreeList,
                getDataPath,
                groupAllowUnbalanced,
            );
        }
        if (values == null) {
            this.valuesType = SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES;
        } else {
            this.valuesType = Array.isArray(values)
                ? SetFilterModelValuesType.PROVIDED_LIST
                : SetFilterModelValuesType.PROVIDED_CALLBACK;
            this.providedValues = values;
        }
        this.displayValueModel = treeList
            ? new TreeSetDisplayValueModel(
                  this.formatter,
                  treeListPathGetter,
                  treeListFormatter,
                  treeDataTreeList || groupingTreeList,
              )
            : new FlatSetDisplayValueModel(valueFormatterService, valueFormatter, this.formatter, column);
        this.updateAllValues().then(function (updatedKeys) {
            return _this.resetSelectionState(updatedKeys || []);
        });
    }
    SetValueModel.prototype.addEventListener = function (eventType, listener, async) {
        this.localEventService.addEventListener(eventType, listener, async);
    };
    SetValueModel.prototype.removeEventListener = function (eventType, listener, async) {
        this.localEventService.removeEventListener(eventType, listener, async);
    };
    /**
     * Re-fetches the values used in the filter from the value source.
     * If keepSelection is false, the filter selection will be reset to everything selected,
     * otherwise the current selection will be preserved.
     */
    SetValueModel.prototype.refreshValues = function () {
        var currentModel = this.getModel();
        this.updateAllValues();
        // ensure model is updated for new values
        return this.setModel(currentModel);
    };
    /**
     * Overrides the current values being used for the set filter.
     * If keepSelection is false, the filter selection will be reset to everything selected,
     * otherwise the current selection will be preserved.
     */
    SetValueModel.prototype.overrideValues = function (valuesToUse) {
        var _this = this;
        return new AgPromise(function (resolve) {
            // wait for any existing values to be populated before overriding
            _this.allValuesPromise.then(function () {
                _this.valuesType = SetFilterModelValuesType.PROVIDED_LIST;
                _this.providedValues = valuesToUse;
                _this.refreshValues().then(function () {
                    return resolve();
                });
            });
        });
    };
    /** @return has anything been updated */
    SetValueModel.prototype.refreshAfterAnyFilterChanged = function () {
        var _this = this;
        if (this.showAvailableOnly()) {
            return this.allValuesPromise.then(function (keys) {
                _this.updateAvailableKeys(keys !== null && keys !== void 0 ? keys : [], 'otherFilter');
                return true;
            });
        }
        return AgPromise.resolve(false);
    };
    SetValueModel.prototype.isInitialised = function () {
        return this.initialised;
    };
    SetValueModel.prototype.updateAllValues = function () {
        var _this = this;
        this.allValuesPromise = new AgPromise(function (resolve) {
            switch (_this.valuesType) {
                case SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES:
                case SetFilterModelValuesType.PROVIDED_LIST: {
                    resolve(
                        _this.processAllKeys(
                            _this.valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES,
                            _this.providedValues,
                        ),
                    );
                    break;
                }
                case SetFilterModelValuesType.PROVIDED_CALLBACK: {
                    _this.setIsLoading(true);
                    var callback_1 = _this.providedValues;
                    var _a = _this.filterParams,
                        columnApi = _a.columnApi,
                        api = _a.api,
                        context = _a.context,
                        column = _a.column,
                        colDef = _a.colDef;
                    var params_1 = {
                        success: function (values) {
                            _this.setIsLoading(false);
                            resolve(_this.processAllKeys(false, values));
                        },
                        colDef: colDef,
                        column: column,
                        columnApi: columnApi,
                        api: api,
                        context: context,
                    };
                    window.setTimeout(function () {
                        return callback_1(params_1);
                    }, 0);
                    break;
                }
                default:
                    throw new Error('Unrecognised valuesType');
            }
        });
        this.allValuesPromise
            .then(function (values) {
                return _this.updateAvailableKeys(values || [], 'reload');
            })
            .then(function () {
                return (_this.initialised = true);
            });
        return this.allValuesPromise;
    };
    SetValueModel.prototype.processAllKeys = function (getFromRows, providedValues) {
        var values = getFromRows
            ? this.getValuesFromRows(false)
            : this.uniqueValues(this.validateProvidedValues(providedValues));
        var sortedKeys = this.sortKeys(values);
        this.allValues = values !== null && values !== void 0 ? values : new Map();
        return sortedKeys;
    };
    SetValueModel.prototype.validateProvidedValues = function (values) {
        if (this.usingComplexObjects && (values === null || values === void 0 ? void 0 : values.length)) {
            var firstValue = values[0];
            if (firstValue && typeof firstValue !== 'object' && typeof firstValue !== 'function') {
                var firstKey = this.createKey(firstValue);
                if (firstKey == null) {
                    _.doOnce(function () {
                        return console.warn(
                            'Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects or set convertValuesToStrings=true in the filterParams. See https://www.ag-grid.com/javascript-data-grid/filter-set-filter-list/#filter-value-types',
                        );
                    }, 'setFilterComplexObjectsProvidedNull');
                } else {
                    _.doOnce(function () {
                        return console.warn(
                            'AG Grid: Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects or enable convertValuesToStrings?',
                        );
                    }, 'setFilterComplexObjectsProvidedPrimitive');
                }
            }
        }
        return values;
    };
    SetValueModel.prototype.setValuesType = function (value) {
        this.valuesType = value;
    };
    SetValueModel.prototype.getValuesType = function () {
        return this.valuesType;
    };
    SetValueModel.prototype.isKeyAvailable = function (key) {
        return this.availableKeys.has(key);
    };
    SetValueModel.prototype.showAvailableOnly = function () {
        return this.valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES;
    };
    SetValueModel.prototype.updateAvailableKeys = function (allKeys, source) {
        var availableKeys = this.showAvailableOnly() ? this.sortKeys(this.getValuesFromRows(true)) : allKeys;
        this.availableKeys = new Set(availableKeys);
        this.localEventService.dispatchEvent({ type: SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED });
        this.updateDisplayedValues(source, allKeys);
    };
    SetValueModel.prototype.sortKeys = function (nullableValues) {
        var values = nullableValues !== null && nullableValues !== void 0 ? nullableValues : new Map();
        if (this.suppressSorting) {
            return Array.from(values.keys());
        }
        var sortedKeys;
        if (this.compareByValue) {
            sortedKeys = Array.from(values.entries())
                .sort(this.entryComparator)
                .map(function (_a) {
                    var _b = __read(_a, 1),
                        key = _b[0];
                    return key;
                });
        } else {
            sortedKeys = Array.from(values.keys()).sort(this.keyComparator);
        }
        if (this.filterParams.excelMode && values.has(null)) {
            // ensure the blank value always appears last
            sortedKeys = sortedKeys.filter(function (v) {
                return v != null;
            });
            sortedKeys.push(null);
        }
        return sortedKeys;
    };
    SetValueModel.prototype.getValuesFromRows = function (removeUnavailableValues) {
        var _this = this;
        if (removeUnavailableValues === void 0) {
            removeUnavailableValues = false;
        }
        if (!this.clientSideValuesExtractor) {
            console.error(
                'AG Grid: Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values',
            );
            return null;
        }
        var predicate = function (node) {
            return !removeUnavailableValues || _this.doesRowPassOtherFilters(node);
        };
        return this.clientSideValuesExtractor.extractUniqueValues(
            predicate,
            removeUnavailableValues && !this.caseSensitive ? this.allValues : undefined,
        );
    };
    /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */
    SetValueModel.prototype.setMiniFilter = function (value) {
        value = _.makeNull(value);
        if (this.miniFilterText === value) {
            //do nothing if filter has not changed
            return false;
        }
        if (value === null) {
            // Reset 'Add current selection to filter' checkbox when clearing mini filter
            this.setAddCurrentSelectionToFilter(false);
        }
        this.miniFilterText = value;
        this.updateDisplayedValues('miniFilter');
        return true;
    };
    SetValueModel.prototype.getMiniFilter = function () {
        return this.miniFilterText;
    };
    SetValueModel.prototype.updateDisplayedValues = function (source, allKeys) {
        var _this = this;
        if (source === 'expansion') {
            this.displayValueModel.refresh();
            return;
        }
        // if no filter, just display all available values
        if (this.miniFilterText == null) {
            this.displayValueModel.updateDisplayedValuesToAllAvailable(
                function (key) {
                    return _this.getValue(key);
                },
                allKeys,
                this.availableKeys,
                source,
            );
            return;
        }
        // if filter present, we filter down the list
        // to allow for case insensitive searches, upper-case both filter text and value
        var formattedFilterText = this.caseFormat(this.formatter(this.miniFilterText) || '');
        var matchesFilter = function (valueToCheck) {
            return valueToCheck != null && _this.caseFormat(valueToCheck).indexOf(formattedFilterText) >= 0;
        };
        var nullMatchesFilter = !!this.filterParams.excelMode && matchesFilter(this.translate('blanks'));
        this.displayValueModel.updateDisplayedValuesToMatchMiniFilter(
            function (key) {
                return _this.getValue(key);
            },
            allKeys,
            this.availableKeys,
            matchesFilter,
            nullMatchesFilter,
            source,
        );
    };
    SetValueModel.prototype.getDisplayedValueCount = function () {
        return this.displayValueModel.getDisplayedValueCount();
    };
    SetValueModel.prototype.getDisplayedItem = function (index) {
        return this.displayValueModel.getDisplayedItem(index);
    };
    SetValueModel.prototype.getSelectAllItem = function () {
        return this.displayValueModel.getSelectAllItem();
    };
    SetValueModel.prototype.getAddSelectionToFilterItem = function () {
        return this.displayValueModel.getAddSelectionToFilterItem();
    };
    SetValueModel.prototype.hasSelections = function () {
        return this.filterParams.defaultToNothingSelected
            ? this.selectedKeys.size > 0
            : this.allValues.size !== this.selectedKeys.size;
    };
    SetValueModel.prototype.getKeys = function () {
        return Array.from(this.allValues.keys());
    };
    SetValueModel.prototype.getValues = function () {
        return Array.from(this.allValues.values());
    };
    SetValueModel.prototype.getValue = function (key) {
        return this.allValues.get(key);
    };
    SetValueModel.prototype.setAddCurrentSelectionToFilter = function (value) {
        this.addCurrentSelectionToFilter = value;
    };
    SetValueModel.prototype.isInWindowsExcelMode = function () {
        return this.filterParams.excelMode === 'windows';
    };
    SetValueModel.prototype.isAddCurrentSelectionToFilterChecked = function () {
        return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
    };
    SetValueModel.prototype.showAddCurrentSelectionToFilter = function () {
        // We only show the 'Add current selection to filter' option
        // when excel mode is enabled with 'windows' mode
        // and when the users types a value in the mini filter.
        return this.isInWindowsExcelMode() && _.exists(this.miniFilterText) && this.miniFilterText.length > 0;
    };
    SetValueModel.prototype.selectAllMatchingMiniFilter = function (clearExistingSelection) {
        var _this = this;
        if (clearExistingSelection === void 0) {
            clearExistingSelection = false;
        }
        if (this.miniFilterText == null) {
            // ensure everything is selected
            this.selectedKeys = new Set(this.allValues.keys());
        } else {
            // ensure everything that matches the mini filter is selected
            if (clearExistingSelection) {
                this.selectedKeys.clear();
            }
            this.displayValueModel.forEachDisplayedKey(function (key) {
                return _this.selectedKeys.add(key);
            });
        }
    };
    SetValueModel.prototype.deselectAllMatchingMiniFilter = function () {
        var _this = this;
        if (this.miniFilterText == null) {
            // ensure everything is deselected
            this.selectedKeys.clear();
        } else {
            // ensure everything that matches the mini filter is deselected
            this.displayValueModel.forEachDisplayedKey(function (key) {
                return _this.selectedKeys.delete(key);
            });
        }
    };
    SetValueModel.prototype.selectKey = function (key) {
        this.selectedKeys.add(key);
    };
    SetValueModel.prototype.deselectKey = function (key) {
        if (this.filterParams.excelMode && this.isEverythingVisibleSelected()) {
            // ensure we're starting from the correct "everything selected" state
            this.resetSelectionState(this.displayValueModel.getDisplayedKeys());
        }
        this.selectedKeys.delete(key);
    };
    SetValueModel.prototype.isKeySelected = function (key) {
        return this.selectedKeys.has(key);
    };
    SetValueModel.prototype.isEverythingVisibleSelected = function () {
        var _this = this;
        return !this.displayValueModel.someDisplayedKey(function (it) {
            return !_this.isKeySelected(it);
        });
    };
    SetValueModel.prototype.isNothingVisibleSelected = function () {
        var _this = this;
        return !this.displayValueModel.someDisplayedKey(function (it) {
            return _this.isKeySelected(it);
        });
    };
    SetValueModel.prototype.getModel = function () {
        if (!this.hasSelections()) {
            return null;
        }
        // When excelMode = 'windows' and the user has ticked 'Add current selection to filter'
        // the filtering keys can be different from the selected keys, and they should be included
        // in the model.
        var filteringKeys = this.isAddCurrentSelectionToFilterChecked() ? this.filteringKeys.allFilteringKeys() : null;
        if (filteringKeys && filteringKeys.size > 0) {
            if (this.selectedKeys) {
                // When existing filtering keys are present along with selected keys,
                // we combine them and return the result.
                // We use a set structure to avoid duplicates
                var modelKeys = new Set(
                    __spreadArray(
                        __spreadArray([], __read(Array.from(filteringKeys))),
                        __read(
                            Array.from(this.selectedKeys).filter(function (key) {
                                return !filteringKeys.has(key);
                            }),
                        ),
                    ),
                );
                return Array.from(modelKeys);
            } else {
                return Array.from(filteringKeys);
            }
        }
        // No extra filtering keys are present - so just return the selected keys
        return Array.from(this.selectedKeys);
    };
    SetValueModel.prototype.setModel = function (model) {
        var _this = this;
        return this.allValuesPromise.then(function (keys) {
            if (model == null) {
                _this.resetSelectionState(keys !== null && keys !== void 0 ? keys : []);
            } else {
                // select all values from the model that exist in the filter
                _this.selectedKeys.clear();
                var existingFormattedKeys_1 = new Map();
                _this.allValues.forEach(function (_value, key) {
                    existingFormattedKeys_1.set(_this.caseFormat(key), key);
                });
                model.forEach(function (unformattedKey) {
                    var formattedKey = _this.caseFormat(_.makeNull(unformattedKey));
                    var existingUnformattedKey = existingFormattedKeys_1.get(formattedKey);
                    if (existingUnformattedKey !== undefined) {
                        _this.selectKey(existingUnformattedKey);
                    }
                });
            }
        });
    };
    SetValueModel.prototype.uniqueValues = function (values) {
        var _this = this;
        var uniqueValues = new Map();
        var formattedKeys = new Set();
        (values !== null && values !== void 0 ? values : []).forEach(function (value) {
            var valueToUse = _.makeNull(value);
            var unformattedKey = _this.convertAndGetKey(valueToUse);
            var formattedKey = _this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                uniqueValues.set(unformattedKey, valueToUse);
            }
        });
        return uniqueValues;
    };
    SetValueModel.prototype.convertAndGetKey = function (value) {
        return this.convertValuesToStrings ? value : this.createKey(value);
    };
    SetValueModel.prototype.resetSelectionState = function (keys) {
        if (this.filterParams.defaultToNothingSelected) {
            this.selectedKeys.clear();
        } else {
            this.selectedKeys = new Set(keys);
        }
    };
    SetValueModel.prototype.hasGroups = function () {
        return this.displayValueModel.hasGroups();
    };
    SetValueModel.prototype.createTreeDataOrGroupingComparator = function () {
        return function (_a, _b) {
            var _c = __read(_a, 2);
            _c[0];
            var aValue = _c[1];
            var _d = __read(_b, 2);
            _d[0];
            var bValue = _d[1];
            if (aValue == null) {
                return bValue == null ? 0 : -1;
            } else if (bValue == null) {
                return 1;
            }
            for (var i = 0; i < aValue.length; i++) {
                if (i >= bValue.length) {
                    return 1;
                }
                var diff = _.defaultComparator(aValue[i], bValue[i]);
                if (diff !== 0) {
                    return diff;
                }
            }
            return 0;
        };
    };
    SetValueModel.prototype.setAppliedModelKeys = function (appliedModelKeys) {
        this.filteringKeys.setFilteringKeys(appliedModelKeys);
    };
    SetValueModel.prototype.addToAppliedModelKeys = function (appliedModelKey) {
        this.filteringKeys.addFilteringKey(appliedModelKey);
    };
    SetValueModel.prototype.getAppliedModelKeys = function () {
        return this.filteringKeys.allFilteringKeys();
    };
    SetValueModel.prototype.getCaseFormattedAppliedModelKeys = function () {
        return this.filteringKeys.allFilteringKeysCaseFormatted();
    };
    SetValueModel.prototype.hasAppliedModelKey = function (appliedModelKey) {
        return this.filteringKeys.hasCaseFormattedFilteringKey(appliedModelKey);
    };
    SetValueModel.prototype.hasAnyAppliedModelKey = function () {
        return !this.filteringKeys.noAppliedFilteringKeys();
    };
    SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED = 'availableValuesChanged';
    return SetValueModel;
})();

var __extends$i =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$d =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
/** @param V type of value in the Set Filter */
var SetFilterListItem = /** @class */ (function (_super) {
    __extends$i(SetFilterListItem, _super);
    function SetFilterListItem(params) {
        var _a;
        var _this =
            _super.call(this, params.isGroup ? SetFilterListItem.GROUP_TEMPLATE : SetFilterListItem.TEMPLATE) || this;
        _this.focusWrapper = params.focusWrapper;
        _this.value = params.value;
        _this.params = params.params;
        _this.translate = params.translate;
        _this.valueFormatter = params.valueFormatter;
        _this.item = params.item;
        _this.isSelected = params.isSelected;
        _this.isTree = params.isTree;
        _this.depth = (_a = params.depth) !== null && _a !== void 0 ? _a : 0;
        _this.isGroup = params.isGroup;
        _this.groupsExist = params.groupsExist;
        _this.isExpanded = params.isExpanded;
        _this.hasIndeterminateExpandState = params.hasIndeterminateExpandState;
        return _this;
    }
    SetFilterListItem.prototype.init = function () {
        var _this = this;
        this.addDestroyFunc(function () {
            var _a;
            return (_a = _this.destroyCellRendererComponent) === null || _a === void 0 ? void 0 : _a.call(_this);
        });
        this.render();
        this.eCheckbox.setLabelEllipsis(true);
        this.eCheckbox.setValue(this.isSelected, true);
        this.eCheckbox.setDisabled(!!this.params.readOnly);
        this.eCheckbox.getInputElement().setAttribute('tabindex', '-1');
        this.refreshVariableAriaLabels();
        if (this.isTree) {
            if (this.depth > 0) {
                this.addCssClass('ag-set-filter-indent-' + this.depth);
            }
            if (this.isGroup) {
                this.setupExpansion();
            } else {
                if (this.groupsExist) {
                    this.addCssClass('ag-set-filter-add-group-indent');
                }
            }
            _.setAriaLevel(this.focusWrapper, this.depth + 1);
        }
        if (!!this.params.readOnly) {
            // Don't add event listeners if we're read-only.
            return;
        }
        this.eCheckbox.onValueChange(function (value) {
            return _this.onCheckboxChanged(!!value);
        });
    };
    SetFilterListItem.prototype.setupExpansion = function () {
        this.eGroupClosedIcon.appendChild(_.createIcon('setFilterGroupClosed', this.gridOptionsService, null));
        this.eGroupOpenedIcon.appendChild(_.createIcon('setFilterGroupOpen', this.gridOptionsService, null));
        this.addManagedListener(this.eGroupClosedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        this.addManagedListener(this.eGroupOpenedIcon, 'click', this.onExpandOrContractClicked.bind(this));
        if (this.hasIndeterminateExpandState) {
            this.eGroupIndeterminateIcon.appendChild(
                _.createIcon('setFilterGroupIndeterminate', this.gridOptionsService, null),
            );
            this.addManagedListener(this.eGroupIndeterminateIcon, 'click', this.onExpandOrContractClicked.bind(this));
        }
        this.setExpandedIcons();
        this.refreshAriaExpanded();
    };
    SetFilterListItem.prototype.onExpandOrContractClicked = function () {
        this.setExpanded(!this.isExpanded);
    };
    SetFilterListItem.prototype.setExpanded = function (isExpanded, silent) {
        if (this.isGroup && isExpanded !== this.isExpanded) {
            this.isExpanded = isExpanded;
            var event_1 = {
                type: SetFilterListItem.EVENT_EXPANDED_CHANGED,
                isExpanded: !!isExpanded,
                item: this.item,
            };
            if (!silent) {
                this.dispatchEvent(event_1);
            }
            this.setExpandedIcons();
            this.refreshAriaExpanded();
        }
    };
    SetFilterListItem.prototype.refreshAriaExpanded = function () {
        _.setAriaExpanded(this.focusWrapper, !!this.isExpanded);
    };
    SetFilterListItem.prototype.setExpandedIcons = function () {
        _.setDisplayed(
            this.eGroupClosedIcon,
            this.hasIndeterminateExpandState ? this.isExpanded === false : !this.isExpanded,
        );
        _.setDisplayed(this.eGroupOpenedIcon, this.isExpanded === true);
        if (this.hasIndeterminateExpandState) {
            _.setDisplayed(this.eGroupIndeterminateIcon, this.isExpanded === undefined);
        }
    };
    SetFilterListItem.prototype.onCheckboxChanged = function (isSelected) {
        this.isSelected = isSelected;
        var event = {
            type: SetFilterListItem.EVENT_SELECTION_CHANGED,
            isSelected: isSelected,
            item: this.item,
        };
        this.dispatchEvent(event);
        this.refreshVariableAriaLabels();
    };
    SetFilterListItem.prototype.toggleSelected = function () {
        if (!!this.params.readOnly) {
            return;
        }
        this.setSelected(!this.isSelected);
    };
    SetFilterListItem.prototype.setSelected = function (isSelected, silent) {
        this.isSelected = isSelected;
        this.eCheckbox.setValue(this.isSelected, silent);
    };
    SetFilterListItem.prototype.refreshVariableAriaLabels = function () {
        if (!this.isTree) {
            return;
        }
        var translate = this.localeService.getLocaleTextFunc();
        var checkboxValue = this.eCheckbox.getValue();
        var state =
            checkboxValue === undefined
                ? translate('ariaIndeterminate', 'indeterminate')
                : checkboxValue
                ? translate('ariaVisible', 'visible')
                : translate('ariaHidden', 'hidden');
        var visibilityLabel = translate('ariaToggleVisibility', 'Press SPACE to toggle visibility');
        _.setAriaLabelledBy(this.eCheckbox.getInputElement(), undefined);
        this.eCheckbox.setInputAriaLabel(visibilityLabel + ' (' + state + ')');
    };
    SetFilterListItem.prototype.setupFixedAriaLabels = function (value) {
        if (!this.isTree) {
            return;
        }
        var translate = this.localeService.getLocaleTextFunc();
        var itemLabel = translate('ariaFilterValue', 'Filter Value');
        _.setAriaLabel(this.focusWrapper, value + ' ' + itemLabel);
        _.setAriaDescribedBy(this.focusWrapper, this.eCheckbox.getInputElement().id);
    };
    SetFilterListItem.prototype.refresh = function (item, isSelected, isExpanded) {
        var _a, _b;
        this.item = item;
        // setExpanded checks if value has changed, setSelected does not
        if (isSelected !== this.isSelected) {
            this.setSelected(isSelected, true);
        }
        this.setExpanded(isExpanded, true);
        if (this.valueFunction) {
            // underlying value might have changed, so call again and re-render
            var value = this.valueFunction();
            this.setTooltipAndCellRendererParams(value, value);
            if (!this.cellRendererComponent) {
                this.renderCellWithoutCellRenderer();
            }
        }
        if (this.cellRendererComponent) {
            var success =
                (_b = (_a = this.cellRendererComponent).refresh) === null || _b === void 0
                    ? void 0
                    : _b.call(_a, this.cellRendererParams);
            if (!success) {
                var oldComponent = this.cellRendererComponent;
                this.renderCell();
                this.destroyBean(oldComponent);
            }
        }
    };
    SetFilterListItem.prototype.render = function () {
        var column = this.params.column;
        var value = this.value;
        var formattedValue = null;
        if (typeof value === 'function') {
            this.valueFunction = value;
            formattedValue = this.valueFunction();
            // backwards compatibility for select all in value
            value = formattedValue;
        } else if (this.isTree) {
            // tree values are already formatted via treeListFormatter
            formattedValue = _.toStringOrNull(value);
        } else {
            formattedValue = this.getFormattedValue(column, value);
        }
        this.setTooltipAndCellRendererParams(value, formattedValue);
        this.renderCell();
    };
    SetFilterListItem.prototype.setTooltipAndCellRendererParams = function (value, formattedValue) {
        if (this.params.showTooltips) {
            var tooltipValue = formattedValue != null ? formattedValue : _.toStringOrNull(value);
            this.setTooltip(tooltipValue);
        }
        this.cellRendererParams = {
            value: value,
            valueFormatted: formattedValue,
            api: this.gridOptionsService.api,
            columnApi: this.gridOptionsService.columnApi,
            context: this.gridOptionsService.context,
            colDef: this.params.colDef,
            column: this.params.column,
        };
    };
    SetFilterListItem.prototype.getTooltipParams = function () {
        var res = _super.prototype.getTooltipParams.call(this);
        res.location = 'setFilterValue';
        res.colDef = this.getComponentHolder();
        if (this.isTree) {
            res.level = this.depth;
        }
        return res;
    };
    SetFilterListItem.prototype.getFormattedValue = function (column, value) {
        return this.valueFormatterService.formatValue(column, null, value, this.valueFormatter, false);
    };
    SetFilterListItem.prototype.renderCell = function () {
        var _this = this;
        var compDetails = this.userComponentFactory.getSetFilterCellRendererDetails(
            this.params,
            this.cellRendererParams,
        );
        var cellRendererPromise = compDetails ? compDetails.newAgStackInstance() : undefined;
        if (cellRendererPromise == null) {
            this.renderCellWithoutCellRenderer();
            return;
        }
        cellRendererPromise.then(function (component) {
            if (component) {
                _this.cellRendererComponent = component;
                _this.eCheckbox.setLabel(component.getGui());
                _this.destroyCellRendererComponent = function () {
                    return _this.destroyBean(component);
                };
            }
        });
    };
    SetFilterListItem.prototype.renderCellWithoutCellRenderer = function () {
        var _a;
        var valueToRender =
            (_a =
                this.cellRendererParams.valueFormatted == null
                    ? this.cellRendererParams.value
                    : this.cellRendererParams.valueFormatted) !== null && _a !== void 0
                ? _a
                : this.translate('blanks');
        if (typeof valueToRender !== 'string') {
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects, or set convertValuesToStrings=true in the filterParams. See https://www.ag-grid.com/javascript-data-grid/filter-set-filter-list/#filter-value-types',
                );
            }, 'setFilterComplexObjectsValueFormatter');
            valueToRender = '';
        }
        this.eCheckbox.setLabel(valueToRender);
        this.setupFixedAriaLabels(valueToRender);
    };
    SetFilterListItem.prototype.getComponentHolder = function () {
        return this.params.column.getColDef();
    };
    SetFilterListItem.EVENT_SELECTION_CHANGED = 'selectionChanged';
    SetFilterListItem.EVENT_EXPANDED_CHANGED = 'expandedChanged';
    SetFilterListItem.GROUP_TEMPLATE =
        '\n        <div class="ag-set-filter-item" aria-hidden="true">\n            <span class="ag-set-filter-group-icons">\n                <span class="ag-set-filter-group-closed-icon" ref="eGroupClosedIcon"></span>\n                <span class="ag-set-filter-group-opened-icon" ref="eGroupOpenedIcon"></span>\n                <span class="ag-set-filter-group-indeterminate-icon" ref="eGroupIndeterminateIcon"></span>\n            </span>\n            <ag-checkbox ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>\n        </div>';
    SetFilterListItem.TEMPLATE =
        '\n        <div class="ag-set-filter-item">\n            <ag-checkbox ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>\n        </div>';
    __decorate$d([Autowired('valueFormatterService')], SetFilterListItem.prototype, 'valueFormatterService', void 0);
    __decorate$d([Autowired('userComponentFactory')], SetFilterListItem.prototype, 'userComponentFactory', void 0);
    __decorate$d([RefSelector('eCheckbox')], SetFilterListItem.prototype, 'eCheckbox', void 0);
    __decorate$d([RefSelector('eGroupOpenedIcon')], SetFilterListItem.prototype, 'eGroupOpenedIcon', void 0);
    __decorate$d([RefSelector('eGroupClosedIcon')], SetFilterListItem.prototype, 'eGroupClosedIcon', void 0);
    __decorate$d(
        [RefSelector('eGroupIndeterminateIcon')],
        SetFilterListItem.prototype,
        'eGroupIndeterminateIcon',
        void 0,
    );
    __decorate$d([PostConstruct], SetFilterListItem.prototype, 'init', null);
    return SetFilterListItem;
})(Component);

var DEFAULT_LOCALE_TEXT = {
    loadingOoo: 'Loading...',
    blanks: '(Blanks)',
    searchOoo: 'Search...',
    selectAll: '(Select All)',
    selectAllSearchResults: '(Select All Search Results)',
    addCurrentSelectionToFilter: 'Add current selection to filter',
    noMatches: 'No matches.',
};

var SetFilterModelFormatter = /** @class */ (function () {
    function SetFilterModelFormatter() {}
    SetFilterModelFormatter.prototype.getModelAsString = function (model, setFilter) {
        var values = (model || setFilter.getModel() || {}).values;
        var valueModel = setFilter.getValueModel();
        if (values == null || valueModel == null) {
            return '';
        }
        var availableKeys = values.filter(function (v) {
            return valueModel.isKeyAvailable(v);
        });
        var numValues = availableKeys.length;
        var formattedValues = availableKeys.slice(0, 10).map(function (key) {
            return setFilter.getFormattedValue(key);
        });
        return '(' + numValues + ') ' + formattedValues.join(',') + (numValues > 10 ? ',...' : '');
    };
    return SetFilterModelFormatter;
})();

var __extends$h =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$c =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
/** @param V type of value in the Set Filter */
var SetFilter = /** @class */ (function (_super) {
    __extends$h(SetFilter, _super);
    function SetFilter() {
        var _this = _super.call(this, 'setFilter') || this;
        _this.valueModel = null;
        _this.setFilterParams = null;
        _this.virtualList = null;
        _this.caseSensitive = false;
        _this.convertValuesToStrings = false;
        _this.treeDataTreeList = false;
        _this.groupingTreeList = false;
        _this.hardRefreshVirtualList = false;
        _this.noValueFormatterSupplied = false;
        _this.filterModelFormatter = new SetFilterModelFormatter();
        return _this;
    }
    SetFilter.prototype.postConstruct = function () {
        _super.prototype.postConstruct.call(this);
    };
    // unlike the simple filters, nothing in the set filter UI shows/hides.
    // maybe this method belongs in abstractSimpleFilter???
    SetFilter.prototype.updateUiVisibility = function () {};
    SetFilter.prototype.createBodyTemplate = function () {
        return (
            /* html */ '\n            <div class="ag-set-filter">\n                <div ref="eFilterLoading" class="ag-filter-loading ag-hidden">' +
            this.translateForSetFilter('loadingOoo') +
            '</div>\n                <ag-input-text-field class="ag-mini-filter" ref="eMiniFilter"></ag-input-text-field>\n                <div ref="eFilterNoMatches" class="ag-filter-no-matches ag-hidden">' +
            this.translateForSetFilter('noMatches') +
            '</div>\n                <div ref="eSetFilterList" class="ag-set-filter-list" role="presentation"></div>\n            </div>'
        );
    };
    SetFilter.prototype.handleKeyDown = function (e) {
        _super.prototype.handleKeyDown.call(this, e);
        if (e.defaultPrevented) {
            return;
        }
        switch (e.key) {
            case KeyCode.SPACE:
                this.handleKeySpace(e);
                break;
            case KeyCode.ENTER:
                this.handleKeyEnter(e);
                break;
            case KeyCode.LEFT:
                this.handleKeyLeft(e);
                break;
            case KeyCode.RIGHT:
                this.handleKeyRight(e);
                break;
        }
    };
    SetFilter.prototype.handleKeySpace = function (e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) === null || _a === void 0 ? void 0 : _a.toggleSelected();
    };
    SetFilter.prototype.handleKeyEnter = function (e) {
        if (!this.setFilterParams) {
            return;
        }
        var _a = this.setFilterParams || {},
            excelMode = _a.excelMode,
            readOnly = _a.readOnly;
        if (!excelMode || !!readOnly) {
            return;
        }
        e.preventDefault();
        // in Excel Mode, hitting Enter is the same as pressing the Apply button
        this.onBtApply(false, false, e);
        if (this.setFilterParams.excelMode === 'mac') {
            // in Mac version, select all the input text
            this.eMiniFilter.getInputElement().select();
        }
    };
    SetFilter.prototype.handleKeyLeft = function (e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) === null || _a === void 0 ? void 0 : _a.setExpanded(false);
    };
    SetFilter.prototype.handleKeyRight = function (e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) === null || _a === void 0 ? void 0 : _a.setExpanded(true);
    };
    SetFilter.prototype.getComponentForKeyEvent = function (e) {
        var _a;
        var eDocument = this.gridOptionsService.getDocument();
        if (!this.eSetFilterList.contains(eDocument.activeElement) || !this.virtualList) {
            return;
        }
        var currentItem = this.virtualList.getLastFocusedRow();
        if (currentItem == null) {
            return;
        }
        var component = this.virtualList.getComponentAt(currentItem);
        if (component == null) {
            return;
        }
        e.preventDefault();
        var readOnly = ((_a = this.setFilterParams) !== null && _a !== void 0 ? _a : {}).readOnly;
        if (!!readOnly) {
            return;
        }
        return component;
    };
    SetFilter.prototype.getCssIdentifier = function () {
        return 'set-filter';
    };
    SetFilter.prototype.setModel = function (model) {
        var _a;
        if (model == null && ((_a = this.valueModel) === null || _a === void 0 ? void 0 : _a.getModel()) == null) {
            // refreshing is expensive. if new and old model are both null (e.g. nothing set), skip.
            // mini filter isn't contained within the model, so always reset
            this.setMiniFilter(null);
            return AgPromise.resolve();
        }
        return _super.prototype.setModel.call(this, model);
    };
    SetFilter.prototype.setModelAndRefresh = function (values) {
        var _this = this;
        return this.valueModel
            ? this.valueModel.setModel(values).then(function () {
                  return _this.refresh();
              })
            : AgPromise.resolve();
    };
    SetFilter.prototype.resetUiToDefaults = function () {
        this.setMiniFilter(null);
        return this.setModelAndRefresh(null);
    };
    SetFilter.prototype.setModelIntoUi = function (model) {
        this.setMiniFilter(null);
        var values = model == null ? null : model.values;
        return this.setModelAndRefresh(values);
    };
    SetFilter.prototype.getModelFromUi = function () {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var values = this.valueModel.getModel();
        if (!values) {
            return null;
        }
        return { values: values, filterType: this.getFilterType() };
    };
    SetFilter.prototype.getFilterType = function () {
        return 'set';
    };
    SetFilter.prototype.getValueModel = function () {
        return this.valueModel;
    };
    SetFilter.prototype.areModelsEqual = function (a, b) {
        // both are missing
        if (a == null && b == null) {
            return true;
        }
        return a != null && b != null && _.areEqual(a.values, b.values);
    };
    SetFilter.prototype.setParams = function (params) {
        var _this = this;
        var _a;
        this.applyExcelModeOptions(params);
        _super.prototype.setParams.call(this, params);
        this.setFilterParams = params;
        this.convertValuesToStrings = !!params.convertValuesToStrings;
        this.caseSensitive = !!params.caseSensitive;
        var keyCreator = (_a = params.keyCreator) !== null && _a !== void 0 ? _a : params.colDef.keyCreator;
        this.setValueFormatter(
            params.valueFormatter,
            keyCreator,
            this.convertValuesToStrings,
            !!params.treeList,
            !!params.colDef.refData,
        );
        var isGroupCol = params.column.getId().startsWith(GROUP_AUTO_COLUMN_ID);
        this.treeDataTreeList = this.gridOptionsService.is('treeData') && !!params.treeList && isGroupCol;
        this.getDataPath = this.gridOptionsService.get('getDataPath');
        this.groupingTreeList = !!this.columnModel.getRowGroupColumns().length && !!params.treeList && isGroupCol;
        this.createKey = this.generateCreateKey(
            keyCreator,
            this.convertValuesToStrings,
            this.treeDataTreeList || this.groupingTreeList,
        );
        this.valueModel = new SetValueModel({
            filterParams: params,
            setIsLoading: function (loading) {
                return _this.setIsLoading(loading);
            },
            valueFormatterService: this.valueFormatterService,
            translate: function (key) {
                return _this.translateForSetFilter(key);
            },
            caseFormat: function (v) {
                return _this.caseFormat(v);
            },
            createKey: this.createKey,
            valueFormatter: this.valueFormatter,
            usingComplexObjects: !!keyCreator,
            gridOptionsService: this.gridOptionsService,
            columnModel: this.columnModel,
            valueService: this.valueService,
            treeDataTreeList: this.treeDataTreeList,
            groupingTreeList: this.groupingTreeList,
        });
        this.initialiseFilterBodyUi();
        this.addEventListenersForDataChanges();
    };
    SetFilter.prototype.onAddCurrentSelectionToFilterChange = function (newValue) {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        this.valueModel.setAddCurrentSelectionToFilter(newValue);
    };
    SetFilter.prototype.setValueFormatter = function (
        providedValueFormatter,
        keyCreator,
        convertValuesToStrings,
        treeList,
        isRefData,
    ) {
        var valueFormatter = providedValueFormatter;
        if (!valueFormatter) {
            if (keyCreator && !convertValuesToStrings && !treeList) {
                throw new Error(
                    'AG Grid: Must supply a Value Formatter in Set Filter params when using a Key Creator unless convertValuesToStrings is enabled',
                );
            }
            this.noValueFormatterSupplied = true;
            // ref data is handled by ValueFormatterService
            if (!isRefData) {
                valueFormatter = function (params) {
                    return _.toStringOrNull(params.value);
                };
            }
        }
        this.valueFormatter = valueFormatter;
    };
    SetFilter.prototype.generateCreateKey = function (keyCreator, convertValuesToStrings, treeDataOrGrouping) {
        var _this = this;
        if (treeDataOrGrouping && !keyCreator) {
            throw new Error(
                'AG Grid: Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.',
            );
        }
        if (keyCreator) {
            return function (value, node) {
                if (node === void 0) {
                    node = null;
                }
                var params = _this.getKeyCreatorParams(value, node);
                return _.makeNull(keyCreator(params));
            };
        }
        if (convertValuesToStrings) {
            // for backwards compatibility - keeping separate as it will eventually be removed
            return function (value) {
                return Array.isArray(value) ? value : _.makeNull(_.toStringOrNull(value));
            };
        } else {
            return function (value) {
                return _.makeNull(_.toStringOrNull(value));
            };
        }
    };
    SetFilter.prototype.getFormattedValue = function (key) {
        var _a;
        var value = this.valueModel.getValue(key);
        if (this.noValueFormatterSupplied && (this.treeDataTreeList || this.groupingTreeList) && Array.isArray(value)) {
            // essentially get back the cell value
            value = _.last(value);
        }
        var formattedValue = this.valueFormatterService.formatValue(
            this.setFilterParams.column,
            null,
            value,
            this.valueFormatter,
            false,
        );
        return (_a = formattedValue == null ? _.toStringOrNull(value) : formattedValue) !== null && _a !== void 0
            ? _a
            : this.translateForSetFilter('blanks');
    };
    SetFilter.prototype.applyExcelModeOptions = function (params) {
        // apply default options to match Excel behaviour, unless they have already been specified
        if (params.excelMode === 'windows') {
            if (!params.buttons) {
                params.buttons = ['apply', 'cancel'];
            }
            if (params.closeOnApply == null) {
                params.closeOnApply = true;
            }
        } else if (params.excelMode === 'mac') {
            if (!params.buttons) {
                params.buttons = ['reset'];
            }
            if (params.applyMiniFilterWhileTyping == null) {
                params.applyMiniFilterWhileTyping = true;
            }
            if (params.debounceMs == null) {
                params.debounceMs = 500;
            }
        }
        if (params.excelMode && params.defaultToNothingSelected) {
            params.defaultToNothingSelected = false;
            _.doOnce(function () {
                return console.warn(
                    'AG Grid: The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.',
                );
            }, 'setFilterExcelModeDefaultToNothingSelect');
        }
    };
    SetFilter.prototype.addEventListenersForDataChanges = function () {
        var _this = this;
        if (!this.isValuesTakenFromGrid()) {
            return;
        }
        this.addManagedListener(this.eventService, Events.EVENT_CELL_VALUE_CHANGED, function (event) {
            // only interested in changes to do with this column
            if (_this.setFilterParams && event.column === _this.setFilterParams.column) {
                _this.syncAfterDataChange();
            }
        });
    };
    SetFilter.prototype.syncAfterDataChange = function () {
        var _this = this;
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var promise = this.valueModel.refreshValues();
        return promise.then(function () {
            _this.refresh();
            _this.onBtApply(false, true);
        });
    };
    SetFilter.prototype.setIsLoading = function (isLoading) {
        _.setDisplayed(this.eFilterLoading, isLoading);
        if (!isLoading) {
            // hard refresh when async data received
            this.hardRefreshVirtualList = true;
        }
    };
    SetFilter.prototype.initialiseFilterBodyUi = function () {
        this.initVirtualList();
        this.initMiniFilter();
    };
    SetFilter.prototype.initVirtualList = function () {
        var _this = this;
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var translate = this.localeService.getLocaleTextFunc();
        var filterListName = translate('ariaFilterList', 'Filter List');
        var isTree = !!this.setFilterParams.treeList;
        var virtualList = (this.virtualList = this.createBean(
            new VirtualList({
                cssIdentifier: 'filter',
                ariaRole: isTree ? 'tree' : 'listbox',
                listName: filterListName,
            }),
        ));
        var eSetFilterList = this.getRefElement('eSetFilterList');
        if (isTree) {
            eSetFilterList.classList.add('ag-set-filter-tree-list');
        }
        if (eSetFilterList) {
            eSetFilterList.appendChild(virtualList.getGui());
        }
        var cellHeight = this.setFilterParams.cellHeight;
        if (cellHeight != null) {
            virtualList.setRowHeight(cellHeight);
        }
        var componentCreator = function (item, listItemElement) {
            return _this.createSetListItem(item, isTree, listItemElement);
        };
        virtualList.setComponentCreator(componentCreator);
        var componentUpdater = function (item, component) {
            return _this.updateSetListItem(item, component);
        };
        virtualList.setComponentUpdater(componentUpdater);
        var model;
        if (this.setFilterParams.suppressSelectAll) {
            model = new ModelWrapper(this.valueModel);
        } else {
            model = new ModelWrapperWithSelectAll(this.valueModel, function () {
                return _this.isSelectAllSelected();
            });
        }
        if (isTree) {
            model = new TreeModelWrapper(model);
        }
        virtualList.setModel(model);
    };
    SetFilter.prototype.getSelectAllLabel = function () {
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var key =
            this.valueModel.getMiniFilter() == null || !this.setFilterParams.excelMode
                ? 'selectAll'
                : 'selectAllSearchResults';
        return this.translateForSetFilter(key);
    };
    SetFilter.prototype.getAddSelectionToFilterLabel = function () {
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        return this.translateForSetFilter('addCurrentSelectionToFilter');
    };
    SetFilter.prototype.createSetListItem = function (item, isTree, focusWrapper) {
        var _this = this;
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var groupsExist = this.valueModel.hasGroups();
        var _a = this.isSelectedExpanded(item),
            isSelected = _a.isSelected,
            isExpanded = _a.isExpanded;
        var _b = this.newSetListItemAttributes(item, isTree),
            value = _b.value,
            depth = _b.depth,
            isGroup = _b.isGroup,
            hasIndeterminateExpandState = _b.hasIndeterminateExpandState,
            selectedListener = _b.selectedListener,
            expandedListener = _b.expandedListener;
        var itemParams = {
            focusWrapper: focusWrapper,
            value: value,
            params: this.setFilterParams,
            translate: function (translateKey) {
                return _this.translateForSetFilter(translateKey);
            },
            valueFormatter: this.valueFormatter,
            item: item,
            isSelected: isSelected,
            isTree: isTree,
            depth: depth,
            groupsExist: groupsExist,
            isGroup: isGroup,
            isExpanded: isExpanded,
            hasIndeterminateExpandState: hasIndeterminateExpandState,
        };
        var listItem = this.createBean(new SetFilterListItem(itemParams));
        listItem.addEventListener(SetFilterListItem.EVENT_SELECTION_CHANGED, selectedListener);
        if (expandedListener) {
            listItem.addEventListener(SetFilterListItem.EVENT_EXPANDED_CHANGED, expandedListener);
        }
        return listItem;
    };
    SetFilter.prototype.newSetTreeItemAttributes = function (item, isTree) {
        var _this = this;
        var _a, _b, _c, _d, _e, _f;
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var groupsExist = this.valueModel.hasGroups();
        // Select all option
        if (item.key === SetFilterDisplayValue.SELECT_ALL) {
            return {
                value: function () {
                    return _this.getSelectAllLabel();
                },
                isGroup: groupsExist,
                depth: item.depth,
                hasIndeterminateExpandState: true,
                selectedListener: function (e) {
                    return _this.onSelectAll(e.isSelected);
                },
                expandedListener: function (e) {
                    return _this.onExpandAll(e.item, e.isExpanded);
                },
            };
        }
        // Add selection to filter option
        if (item.key === SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) {
            return {
                value: function () {
                    return _this.getAddSelectionToFilterLabel();
                },
                depth: item.depth,
                isGroup: false,
                hasIndeterminateExpandState: false,
                selectedListener: function (e) {
                    _this.onAddCurrentSelectionToFilterChange(e.isSelected);
                },
            };
        }
        // Group
        if (item.children) {
            return {
                value:
                    (_c =
                        (_b = (_a = this.setFilterParams).treeListFormatter) === null || _b === void 0
                            ? void 0
                            : _b.call(_a, item.treeKey, item.depth, item.parentTreeKeys)) !== null && _c !== void 0
                        ? _c
                        : item.treeKey,
                depth: item.depth,
                isGroup: true,
                selectedListener: function (e) {
                    return _this.onGroupItemSelected(e.item, e.isSelected);
                },
                expandedListener: function (e) {
                    return _this.onExpandedChanged(e.item, e.isExpanded);
                },
            };
        }
        // Leaf
        return {
            value:
                (_f =
                    (_e = (_d = this.setFilterParams).treeListFormatter) === null || _e === void 0
                        ? void 0
                        : _e.call(_d, item.treeKey, item.depth, item.parentTreeKeys)) !== null && _f !== void 0
                    ? _f
                    : item.treeKey,
            depth: item.depth,
            selectedListener: function (e) {
                return _this.onItemSelected(e.item.key, e.isSelected);
            },
        };
    };
    SetFilter.prototype.newSetListItemAttributes = function (item, isTree) {
        var _this = this;
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        // Tree item
        if (this.isSetFilterModelTreeItem(item)) {
            return this.newSetTreeItemAttributes(item, isTree);
        }
        // List item - 'Select All'
        if (item === SetFilterDisplayValue.SELECT_ALL) {
            return {
                value: function () {
                    return _this.getSelectAllLabel();
                },
                selectedListener: function (e) {
                    return _this.onSelectAll(e.isSelected);
                },
            };
        }
        // List item - 'Add selection to filter'
        if (item === SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) {
            return {
                value: function () {
                    return _this.getAddSelectionToFilterLabel();
                },
                selectedListener: function (e) {
                    _this.onAddCurrentSelectionToFilterChange(e.isSelected);
                },
            };
        }
        // List item
        return {
            value: this.valueModel.getValue(item),
            selectedListener: function (e) {
                return _this.onItemSelected(e.item, e.isSelected);
            },
        };
    };
    SetFilter.prototype.updateSetListItem = function (item, component) {
        var _a = this.isSelectedExpanded(item),
            isSelected = _a.isSelected,
            isExpanded = _a.isExpanded;
        component.refresh(item, isSelected, isExpanded);
    };
    SetFilter.prototype.isSelectedExpanded = function (item) {
        var isSelected;
        var isExpanded;
        if (this.isSetFilterModelTreeItem(item)) {
            isExpanded = item.expanded;
            if (item.key === SetFilterDisplayValue.SELECT_ALL) {
                isSelected = this.isSelectAllSelected();
            } else if (item.key === SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) {
                isSelected = this.valueModel.isAddCurrentSelectionToFilterChecked();
            } else if (item.children) {
                isSelected = this.areAllChildrenSelected(item);
            } else {
                isSelected = this.valueModel.isKeySelected(item.key);
            }
        } else {
            if (item === SetFilterDisplayValue.SELECT_ALL) {
                isSelected = this.isSelectAllSelected();
            } else if (item === SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) {
                isSelected = this.valueModel.isAddCurrentSelectionToFilterChecked();
            } else {
                isSelected = this.valueModel.isKeySelected(item);
            }
        }
        return { isSelected: isSelected, isExpanded: isExpanded };
    };
    SetFilter.prototype.isSetFilterModelTreeItem = function (item) {
        return (item === null || item === void 0 ? void 0 : item.treeKey) !== undefined;
    };
    SetFilter.prototype.initMiniFilter = function () {
        var _this = this;
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var _a = this,
            eMiniFilter = _a.eMiniFilter,
            localeService = _a.localeService;
        var translate = localeService.getLocaleTextFunc();
        eMiniFilter.setDisplayed(!this.setFilterParams.suppressMiniFilter);
        eMiniFilter.setValue(this.valueModel.getMiniFilter());
        eMiniFilter.onValueChange(function () {
            return _this.onMiniFilterInput();
        });
        eMiniFilter.setInputAriaLabel(translate('ariaSearchFilterValues', 'Search filter values'));
        this.addManagedListener(eMiniFilter.getInputElement(), 'keydown', function (e) {
            return _this.onMiniFilterKeyDown(e);
        });
    };
    // we need to have the GUI attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the GUI state
    SetFilter.prototype.afterGuiAttached = function (params) {
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        _super.prototype.afterGuiAttached.call(this, params);
        // collapse all tree list items (if tree list)
        this.resetExpansion();
        this.refreshVirtualList();
        var eMiniFilter = this.eMiniFilter;
        eMiniFilter.setInputPlaceholder(this.translateForSetFilter('searchOoo'));
        if (!params || !params.suppressFocus) {
            eMiniFilter.getFocusableElement().focus();
        }
    };
    SetFilter.prototype.afterGuiDetached = function () {
        var _a, _b;
        _super.prototype.afterGuiDetached.call(this);
        // discard any unapplied UI state (reset to model)
        if ((_a = this.setFilterParams) === null || _a === void 0 ? void 0 : _a.excelMode) {
            this.resetMiniFilter();
        }
        var appliedModel = this.getModel();
        if (
            ((_b = this.setFilterParams) === null || _b === void 0 ? void 0 : _b.excelMode) ||
            !this.areModelsEqual(appliedModel, this.getModelFromUi())
        ) {
            this.resetUiToActiveModel(appliedModel);
            this.showOrHideResults();
        }
    };
    SetFilter.prototype.applyModel = function (source) {
        var _this = this;
        if (source === void 0) {
            source = 'api';
        }
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        if (
            this.setFilterParams.excelMode &&
            source !== 'rowDataUpdated' &&
            this.valueModel.isEverythingVisibleSelected()
        ) {
            // In Excel, if the filter is applied with all visible values selected, then any active filter on the
            // column is removed. This ensures the filter is removed in this situation.
            this.valueModel.selectAllMatchingMiniFilter();
        }
        // Here we implement AG-9090 TC2
        // When 'Add current selection to filter' is visible and checked, but no filter is applied:
        // Do NOT apply the current selection as filter.
        var shouldKeepCurrentSelection =
            this.valueModel.showAddCurrentSelectionToFilter() && this.valueModel.isAddCurrentSelectionToFilterChecked();
        if (shouldKeepCurrentSelection && !this.getModel()) {
            return false;
        }
        var result = _super.prototype.applyModel.call(this, source);
        // keep appliedModelKeys in sync with the applied model
        var appliedModel = this.getModel();
        if (appliedModel) {
            if (!shouldKeepCurrentSelection) {
                this.valueModel.setAppliedModelKeys(new Set());
            }
            appliedModel.values.forEach(function (key) {
                _this.valueModel.addToAppliedModelKeys(key);
            });
        } else {
            if (!shouldKeepCurrentSelection) {
                this.valueModel.setAppliedModelKeys(null);
            }
        }
        return result;
    };
    SetFilter.prototype.isModelValid = function (model) {
        return this.setFilterParams && this.setFilterParams.excelMode ? model == null || model.values.length > 0 : true;
    };
    SetFilter.prototype.doesFilterPass = function (params) {
        var _this = this;
        if (!this.setFilterParams || !this.valueModel || !this.valueModel.getCaseFormattedAppliedModelKeys()) {
            return true;
        }
        // if nothing selected, don't need to check value
        if (!this.valueModel.hasAnyAppliedModelKey()) {
            return false;
        }
        var node = params.node,
            data = params.data;
        if (this.treeDataTreeList) {
            return this.doesFilterPassForTreeData(node, data);
        }
        if (this.groupingTreeList) {
            return this.doesFilterPassForGrouping(node, data);
        }
        var value = this.getValueFromNode(node, data);
        if (this.convertValuesToStrings) {
            // for backwards compatibility - keeping separate as it will eventually be removed
            return this.doesFilterPassForConvertValuesToString(node, value);
        }
        if (value != null && Array.isArray(value)) {
            if (value.length === 0) {
                return this.valueModel.hasAppliedModelKey(null);
            }
            return value.some(function (v) {
                return _this.isInAppliedModel(_this.createKey(v, node));
            });
        }
        return this.isInAppliedModel(this.createKey(value, node));
    };
    SetFilter.prototype.doesFilterPassForConvertValuesToString = function (node, value) {
        var _this = this;
        var key = this.createKey(value, node);
        if (key != null && Array.isArray(key)) {
            if (key.length === 0) {
                return this.valueModel.hasAppliedModelKey(null);
            }
            return key.some(function (v) {
                return _this.isInAppliedModel(v);
            });
        }
        return this.isInAppliedModel(key);
    };
    SetFilter.prototype.doesFilterPassForTreeData = function (node, data) {
        var _a;
        if ((_a = node.childrenAfterGroup) === null || _a === void 0 ? void 0 : _a.length) {
            // only perform checking on leaves. The core filtering logic for tree data won't work properly otherwise
            return false;
        }
        return this.isInAppliedModel(this.createKey(this.checkMakeNullDataPath(this.getDataPath(data))));
    };
    SetFilter.prototype.doesFilterPassForGrouping = function (node, data) {
        var _this = this;
        var dataPath = this.columnModel.getRowGroupColumns().map(function (groupCol) {
            return _this.valueService.getKeyForNode(groupCol, node);
        });
        dataPath.push(this.getValueFromNode(node, data));
        return this.isInAppliedModel(this.createKey(this.checkMakeNullDataPath(dataPath)));
    };
    SetFilter.prototype.checkMakeNullDataPath = function (dataPath) {
        if (dataPath) {
            dataPath = dataPath.map(function (treeKey) {
                return _.toStringOrNull(_.makeNull(treeKey));
            });
        }
        if (
            dataPath === null || dataPath === void 0
                ? void 0
                : dataPath.some(function (treeKey) {
                      return treeKey == null;
                  })
        ) {
            return null;
        }
        return dataPath;
    };
    SetFilter.prototype.isInAppliedModel = function (key) {
        return this.valueModel.hasAppliedModelKey(key);
    };
    SetFilter.prototype.getValueFromNode = function (node, data) {
        var _a = this.setFilterParams,
            valueGetter = _a.valueGetter,
            api = _a.api,
            colDef = _a.colDef,
            column = _a.column,
            columnApi = _a.columnApi,
            context = _a.context;
        return valueGetter({
            api: api,
            colDef: colDef,
            column: column,
            columnApi: columnApi,
            context: context,
            data: data,
            getValue: function (field) {
                return data[field];
            },
            node: node,
        });
    };
    SetFilter.prototype.getKeyCreatorParams = function (value, node) {
        if (node === void 0) {
            node = null;
        }
        return {
            value: value,
            colDef: this.setFilterParams.colDef,
            column: this.setFilterParams.column,
            node: node,
            data: node === null || node === void 0 ? void 0 : node.data,
            api: this.setFilterParams.api,
            columnApi: this.setFilterParams.columnApi,
            context: this.setFilterParams.context,
        };
    };
    SetFilter.prototype.onNewRowsLoaded = function () {
        if (!this.isValuesTakenFromGrid()) {
            return;
        }
        this.syncAfterDataChange();
    };
    SetFilter.prototype.isValuesTakenFromGrid = function () {
        if (!this.valueModel) {
            return false;
        }
        var valuesType = this.valueModel.getValuesType();
        return valuesType === SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES;
    };
    //noinspection JSUnusedGlobalSymbols
    /**
     * Public method provided so the user can change the value of the filter once
     * the filter has been already started
     * @param values The values to use.
     */
    SetFilter.prototype.setFilterValues = function (values) {
        var _this = this;
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        this.valueModel.overrideValues(values).then(function () {
            _this.refresh();
            _this.onUiChanged();
        });
    };
    //noinspection JSUnusedGlobalSymbols
    /**
     * Public method provided so the user can reset the values of the filter once that it has started.
     */
    SetFilter.prototype.resetFilterValues = function () {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        this.valueModel.setValuesType(SetFilterModelValuesType.TAKEN_FROM_GRID_VALUES);
        this.syncAfterDataChange();
    };
    SetFilter.prototype.refreshFilterValues = function () {
        var _this = this;
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        // the model is still being initialised
        if (!this.valueModel.isInitialised()) {
            return;
        }
        this.valueModel.refreshValues().then(function () {
            _this.refresh();
            _this.onUiChanged();
        });
    };
    SetFilter.prototype.onAnyFilterChanged = function () {
        var _this = this;
        // don't block the current action when updating the values for this filter
        setTimeout(function () {
            if (!_this.isAlive()) {
                return;
            }
            if (!_this.valueModel) {
                throw new Error('Value model has not been created.');
            }
            _this.valueModel.refreshAfterAnyFilterChanged().then(function (refresh) {
                if (refresh) {
                    _this.refresh();
                    _this.showOrHideResults();
                }
            });
        }, 0);
    };
    SetFilter.prototype.onMiniFilterInput = function () {
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        if (!this.valueModel.setMiniFilter(this.eMiniFilter.getValue())) {
            return;
        }
        var _a = this.setFilterParams || {},
            applyMiniFilterWhileTyping = _a.applyMiniFilterWhileTyping,
            readOnly = _a.readOnly;
        if (!readOnly && applyMiniFilterWhileTyping) {
            this.filterOnAllVisibleValues(false);
        } else {
            this.updateUiAfterMiniFilterChange();
        }
    };
    SetFilter.prototype.updateUiAfterMiniFilterChange = function () {
        if (!this.setFilterParams) {
            throw new Error('Set filter params have not been provided.');
        }
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var _a = this.setFilterParams || {},
            excelMode = _a.excelMode,
            readOnly = _a.readOnly;
        if (excelMode == null || !!readOnly) {
            this.refresh();
        } else if (this.valueModel.getMiniFilter() == null) {
            this.resetUiToActiveModel(this.getModel());
        } else {
            this.valueModel.selectAllMatchingMiniFilter(true);
            this.refresh();
            this.onUiChanged();
        }
        this.showOrHideResults();
    };
    SetFilter.prototype.showOrHideResults = function () {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        var hideResults = this.valueModel.getMiniFilter() != null && this.valueModel.getDisplayedValueCount() < 1;
        _.setDisplayed(this.eNoMatches, hideResults);
        _.setDisplayed(this.eSetFilterList, !hideResults);
    };
    SetFilter.prototype.resetMiniFilter = function () {
        var _a;
        this.eMiniFilter.setValue(null, true);
        (_a = this.valueModel) === null || _a === void 0 ? void 0 : _a.setMiniFilter(null);
    };
    SetFilter.prototype.resetUiToActiveModel = function (currentModel, afterUiUpdatedFunc) {
        var _this = this;
        // override the default behaviour as we don't always want to clear the mini filter
        this.setModelAndRefresh(currentModel == null ? null : currentModel.values).then(function () {
            _this.onUiChanged(false, 'prevent');
            afterUiUpdatedFunc === null || afterUiUpdatedFunc === void 0 ? void 0 : afterUiUpdatedFunc();
        });
    };
    SetFilter.prototype.handleCancelEnd = function (e) {
        this.setMiniFilter(null);
        _super.prototype.handleCancelEnd.call(this, e);
    };
    SetFilter.prototype.onMiniFilterKeyDown = function (e) {
        var _a = this.setFilterParams || {},
            excelMode = _a.excelMode,
            readOnly = _a.readOnly;
        if (e.key === KeyCode.ENTER && !excelMode && !readOnly) {
            this.filterOnAllVisibleValues();
        }
    };
    SetFilter.prototype.filterOnAllVisibleValues = function (applyImmediately) {
        if (applyImmediately === void 0) {
            applyImmediately = true;
        }
        var readOnly = (this.setFilterParams || {}).readOnly;
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        if (!!readOnly) {
            throw new Error('Unable to filter in readOnly mode.');
        }
        this.valueModel.selectAllMatchingMiniFilter(true);
        this.refresh();
        this.onUiChanged(false, applyImmediately ? 'immediately' : 'debounce');
        this.showOrHideResults();
    };
    SetFilter.prototype.focusRowIfAlive = function (rowIndex) {
        var _this = this;
        if (rowIndex == null) {
            return;
        }
        window.setTimeout(function () {
            if (!_this.virtualList) {
                throw new Error('Virtual list has not been created.');
            }
            if (_this.isAlive()) {
                _this.virtualList.focusRow(rowIndex);
            }
        }, 0);
    };
    SetFilter.prototype.onSelectAll = function (isSelected) {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        if (!this.virtualList) {
            throw new Error('Virtual list has not been created.');
        }
        if (isSelected) {
            this.valueModel.selectAllMatchingMiniFilter();
        } else {
            this.valueModel.deselectAllMatchingMiniFilter();
        }
        this.refreshAfterSelection();
    };
    SetFilter.prototype.onGroupItemSelected = function (item, isSelected) {
        var _this = this;
        var recursiveGroupSelection = function (i) {
            if (i.children) {
                i.children.forEach(function (childItem) {
                    return recursiveGroupSelection(childItem);
                });
            } else {
                _this.selectItem(i.key, isSelected);
            }
        };
        recursiveGroupSelection(item);
        this.refreshAfterSelection();
    };
    SetFilter.prototype.onItemSelected = function (key, isSelected) {
        if (!this.valueModel) {
            throw new Error('Value model has not been created.');
        }
        if (!this.virtualList) {
            throw new Error('Virtual list has not been created.');
        }
        this.selectItem(key, isSelected);
        this.refreshAfterSelection();
    };
    SetFilter.prototype.selectItem = function (key, isSelected) {
        if (isSelected) {
            this.valueModel.selectKey(key);
        } else {
            this.valueModel.deselectKey(key);
        }
    };
    SetFilter.prototype.onExpandAll = function (item, isExpanded) {
        var recursiveExpansion = function (i) {
            if (i.filterPasses && i.available && i.children) {
                i.children.forEach(function (childItem) {
                    return recursiveExpansion(childItem);
                });
                i.expanded = isExpanded;
            }
        };
        recursiveExpansion(item);
        this.refreshAfterExpansion();
    };
    SetFilter.prototype.onExpandedChanged = function (item, isExpanded) {
        item.expanded = isExpanded;
        this.refreshAfterExpansion();
    };
    SetFilter.prototype.refreshAfterExpansion = function () {
        var focusedRow = this.virtualList.getLastFocusedRow();
        this.valueModel.updateDisplayedValues('expansion');
        this.refresh();
        this.focusRowIfAlive(focusedRow);
    };
    SetFilter.prototype.refreshAfterSelection = function () {
        var focusedRow = this.virtualList.getLastFocusedRow();
        this.refresh();
        this.onUiChanged();
        this.focusRowIfAlive(focusedRow);
    };
    SetFilter.prototype.setMiniFilter = function (newMiniFilter) {
        this.eMiniFilter.setValue(newMiniFilter);
        this.onMiniFilterInput();
    };
    SetFilter.prototype.getMiniFilter = function () {
        return this.valueModel ? this.valueModel.getMiniFilter() : null;
    };
    SetFilter.prototype.refresh = function () {
        if (!this.virtualList) {
            throw new Error('Virtual list has not been created.');
        }
        this.virtualList.refresh(!this.hardRefreshVirtualList);
        if (this.hardRefreshVirtualList) {
            this.hardRefreshVirtualList = false;
        }
    };
    SetFilter.prototype.getFilterKeys = function () {
        return this.valueModel ? this.valueModel.getKeys() : [];
    };
    SetFilter.prototype.getFilterValues = function () {
        return this.valueModel ? this.valueModel.getValues() : [];
    };
    SetFilter.prototype.getValues = function () {
        return this.getFilterKeys();
    };
    SetFilter.prototype.refreshVirtualList = function () {
        if (this.setFilterParams && this.setFilterParams.refreshValuesOnOpen) {
            this.refreshFilterValues();
        } else {
            this.refresh();
        }
    };
    SetFilter.prototype.translateForSetFilter = function (key) {
        var translate = this.localeService.getLocaleTextFunc();
        return translate(key, DEFAULT_LOCALE_TEXT[key]);
    };
    SetFilter.prototype.isSelectAllSelected = function () {
        if (!this.setFilterParams || !this.valueModel) {
            return false;
        }
        if (!this.setFilterParams.defaultToNothingSelected) {
            // everything selected by default
            if (this.valueModel.hasSelections() && this.valueModel.isNothingVisibleSelected()) {
                return false;
            }
            if (this.valueModel.isEverythingVisibleSelected()) {
                return true;
            }
        } else {
            // nothing selected by default
            if (this.valueModel.hasSelections() && this.valueModel.isEverythingVisibleSelected()) {
                return true;
            }
            if (this.valueModel.isNothingVisibleSelected()) {
                return false;
            }
        }
        // returning `undefined` means the checkbox status is indeterminate.
        return undefined;
    };
    SetFilter.prototype.areAllChildrenSelected = function (item) {
        var _this = this;
        var recursiveChildSelectionCheck = function (i) {
            if (i.children) {
                var someTrue_1 = false;
                var someFalse_1 = false;
                var mixed = i.children.some(function (child) {
                    if (!child.filterPasses || !child.available) {
                        return false;
                    }
                    var childSelected = recursiveChildSelectionCheck(child);
                    if (childSelected === undefined) {
                        return true;
                    }
                    if (childSelected) {
                        someTrue_1 = true;
                    } else {
                        someFalse_1 = true;
                    }
                    return someTrue_1 && someFalse_1;
                });
                // returning `undefined` means the checkbox status is indeterminate.
                // if not mixed and some true, all must be true
                return mixed ? undefined : someTrue_1;
            } else {
                return _this.valueModel.isKeySelected(i.key);
            }
        };
        if (!this.setFilterParams.defaultToNothingSelected) {
            // everything selected by default
            return recursiveChildSelectionCheck(item);
        } else {
            // nothing selected by default
            return this.valueModel.hasSelections() && recursiveChildSelectionCheck(item);
        }
    };
    SetFilter.prototype.destroy = function () {
        if (this.virtualList != null) {
            this.virtualList.destroy();
            this.virtualList = null;
        }
        _super.prototype.destroy.call(this);
    };
    SetFilter.prototype.caseFormat = function (valueToFormat) {
        if (valueToFormat == null || typeof valueToFormat !== 'string') {
            return valueToFormat;
        }
        return this.caseSensitive ? valueToFormat : valueToFormat.toUpperCase();
    };
    SetFilter.prototype.resetExpansion = function () {
        var _a, _b;
        if (!((_a = this.setFilterParams) === null || _a === void 0 ? void 0 : _a.treeList)) {
            return;
        }
        var selectAllItem = (_b = this.valueModel) === null || _b === void 0 ? void 0 : _b.getSelectAllItem();
        if (this.isSetFilterModelTreeItem(selectAllItem)) {
            var recursiveCollapse_1 = function (i) {
                if (i.children) {
                    i.children.forEach(function (childItem) {
                        return recursiveCollapse_1(childItem);
                    });
                    i.expanded = false;
                }
            };
            recursiveCollapse_1(selectAllItem);
            this.valueModel.updateDisplayedValues('expansion');
        }
    };
    SetFilter.prototype.getModelAsString = function (model) {
        return this.filterModelFormatter.getModelAsString(model, this);
    };
    SetFilter.prototype.getPositionableElement = function () {
        return this.eSetFilterList;
    };
    __decorate$c([RefSelector('eMiniFilter')], SetFilter.prototype, 'eMiniFilter', void 0);
    __decorate$c([RefSelector('eFilterLoading')], SetFilter.prototype, 'eFilterLoading', void 0);
    __decorate$c([RefSelector('eSetFilterList')], SetFilter.prototype, 'eSetFilterList', void 0);
    __decorate$c([RefSelector('eFilterNoMatches')], SetFilter.prototype, 'eNoMatches', void 0);
    __decorate$c([Autowired('valueFormatterService')], SetFilter.prototype, 'valueFormatterService', void 0);
    __decorate$c([Autowired('columnModel')], SetFilter.prototype, 'columnModel', void 0);
    __decorate$c([Autowired('valueService')], SetFilter.prototype, 'valueService', void 0);
    return SetFilter;
})(ProvidedFilter);
var ModelWrapper = /** @class */ (function () {
    function ModelWrapper(model) {
        this.model = model;
    }
    ModelWrapper.prototype.getRowCount = function () {
        return this.model.getDisplayedValueCount();
    };
    ModelWrapper.prototype.getRow = function (index) {
        return this.model.getDisplayedItem(index);
    };
    ModelWrapper.prototype.isRowSelected = function (index) {
        return this.model.isKeySelected(this.getRow(index));
    };
    ModelWrapper.prototype.areRowsEqual = function (oldRow, newRow) {
        return oldRow === newRow;
    };
    return ModelWrapper;
})();
var ModelWrapperWithSelectAll = /** @class */ (function () {
    function ModelWrapperWithSelectAll(model, isSelectAllSelected) {
        this.model = model;
        this.isSelectAllSelected = isSelectAllSelected;
    }
    ModelWrapperWithSelectAll.prototype.getRowCount = function () {
        var showAddCurrentSelectionToFilter = this.model.showAddCurrentSelectionToFilter();
        var outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        return this.model.getDisplayedValueCount() + outboundItems;
    };
    ModelWrapperWithSelectAll.prototype.getRow = function (index) {
        if (index === 0) {
            return this.model.getSelectAllItem();
        }
        var showAddCurrentSelectionToFilter = this.model.showAddCurrentSelectionToFilter();
        var outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        if (index === 1 && showAddCurrentSelectionToFilter) {
            return this.model.getAddSelectionToFilterItem();
        }
        return this.model.getDisplayedItem(index - outboundItems);
    };
    ModelWrapperWithSelectAll.prototype.isRowSelected = function (index) {
        if (index === 0) {
            return this.isSelectAllSelected();
        }
        if (index === 1 && this.model.showAddCurrentSelectionToFilter()) {
            return this.model.isAddCurrentSelectionToFilterChecked();
        }
        return this.model.isKeySelected(this.getRow(index));
    };
    ModelWrapperWithSelectAll.prototype.areRowsEqual = function (oldRow, newRow) {
        return oldRow === newRow;
    };
    return ModelWrapperWithSelectAll;
})();
// isRowSelected is used by VirtualList to add aria tags for flat lists. We want to suppress this when using trees
var TreeModelWrapper = /** @class */ (function () {
    function TreeModelWrapper(model) {
        this.model = model;
    }
    TreeModelWrapper.prototype.getRowCount = function () {
        return this.model.getRowCount();
    };
    TreeModelWrapper.prototype.getRow = function (index) {
        return this.model.getRow(index);
    };
    TreeModelWrapper.prototype.areRowsEqual = function (oldRow, newRow) {
        if (oldRow == null && newRow == null) {
            return true;
        }
        return oldRow != null && newRow != null && oldRow.treeKey === newRow.treeKey && oldRow.depth === newRow.depth;
    };
    return TreeModelWrapper;
})();

var __extends$g =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$b =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SetFloatingFilterComp = /** @class */ (function (_super) {
    __extends$g(SetFloatingFilterComp, _super);
    function SetFloatingFilterComp() {
        var _this =
            _super.call(
                this,
                /* html */ '\n            <div class="ag-floating-filter-input ag-set-floating-filter-input" role="presentation">\n                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>\n            </div>',
            ) || this;
        _this.availableValuesListenerAdded = false;
        _this.filterModelFormatter = new SetFilterModelFormatter();
        return _this;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    SetFloatingFilterComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    SetFloatingFilterComp.prototype.init = function (params) {
        var _this = this;
        this.params = params;
        this.eFloatingFilterText.setDisabled(true).addGuiEventListener('click', function () {
            return _this.params.showParentFilter();
        });
        this.setParams(params);
    };
    SetFloatingFilterComp.prototype.setParams = function (params) {
        var displayName = this.columnModel.getDisplayNameForColumn(params.column, 'header', true);
        var translate = this.localeService.getLocaleTextFunc();
        this.eFloatingFilterText.setInputAriaLabel(displayName + ' ' + translate('ariaFilterInput', 'Filter Input'));
    };
    SetFloatingFilterComp.prototype.onParamsUpdated = function (params) {
        this.params = params;
        this.setParams(params);
    };
    SetFloatingFilterComp.prototype.onParentModelChanged = function (parentModel) {
        this.updateFloatingFilterText(parentModel);
    };
    SetFloatingFilterComp.prototype.parentSetFilterInstance = function (cb) {
        this.params.parentFilterInstance(function (filter) {
            if (!(filter instanceof SetFilter)) {
                throw new Error('AG Grid - SetFloatingFilter expects SetFilter as its parent');
            }
            cb(filter);
        });
    };
    SetFloatingFilterComp.prototype.addAvailableValuesListener = function () {
        var _this = this;
        this.parentSetFilterInstance(function (setFilter) {
            var setValueModel = setFilter.getValueModel();
            if (!setValueModel) {
                return;
            }
            // unlike other filters, what we show in the floating filter can be different, even
            // if another filter changes. this is due to how set filter restricts its values based
            // on selections in other filters, e.g. if you filter Language to English, then the set filter
            // on Country will only show English speaking countries. Thus the list of items to show
            // in the floating filter can change.
            _this.addManagedListener(setValueModel, SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED, function () {
                return _this.updateFloatingFilterText();
            });
        });
        this.availableValuesListenerAdded = true;
    };
    SetFloatingFilterComp.prototype.updateFloatingFilterText = function (parentModel) {
        var _this = this;
        if (!this.availableValuesListenerAdded) {
            this.addAvailableValuesListener();
        }
        this.parentSetFilterInstance(function (setFilter) {
            _this.eFloatingFilterText.setValue(_this.filterModelFormatter.getModelAsString(parentModel, setFilter));
        });
    };
    __decorate$b([RefSelector('eFloatingFilterText')], SetFloatingFilterComp.prototype, 'eFloatingFilterText', void 0);
    __decorate$b([Autowired('columnModel')], SetFloatingFilterComp.prototype, 'columnModel', void 0);
    return SetFloatingFilterComp;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$3 = '30.2.0';

var SetFilterModule = {
    version: VERSION$3,
    moduleName: ModuleNames.SetFilterModule,
    beans: [],
    userComponents: [
        { componentName: 'agSetColumnFilter', componentClass: SetFilter },
        { componentName: 'agSetColumnFloatingFilter', componentClass: SetFloatingFilterComp },
    ],
    dependantModules: [EnterpriseCoreModule],
};

var __extends$f =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$a =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var StatusBarService = /** @class */ (function (_super) {
    __extends$f(StatusBarService, _super);
    // tslint:disable-next-line
    function StatusBarService() {
        var _this = _super.call(this) || this;
        _this.allComponents = {};
        return _this;
    }
    StatusBarService.prototype.registerStatusPanel = function (key, component) {
        this.allComponents[key] = component;
    };
    StatusBarService.prototype.getStatusPanel = function (key) {
        return this.allComponents[key];
    };
    StatusBarService = __decorate$a([Bean('statusBarService')], StatusBarService);
    return StatusBarService;
})(BeanStub);

var __extends$e =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$9 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var StatusBar = /** @class */ (function (_super) {
    __extends$e(StatusBar, _super);
    function StatusBar() {
        return _super.call(this, StatusBar.TEMPLATE) || this;
    }
    StatusBar.prototype.postConstruct = function () {
        var _a;
        var statusPanels =
            (_a = this.gridOptionsService.get('statusBar')) === null || _a === void 0 ? void 0 : _a.statusPanels;
        if (statusPanels) {
            var leftStatusPanelComponents = statusPanels.filter(function (componentConfig) {
                return componentConfig.align === 'left';
            });
            this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft);
            var centerStatusPanelComponents = statusPanels.filter(function (componentConfig) {
                return componentConfig.align === 'center';
            });
            this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter);
            var rightStatusPanelComponents = statusPanels.filter(function (componentConfig) {
                return !componentConfig.align || componentConfig.align === 'right';
            });
            this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight);
        } else {
            this.setDisplayed(false);
        }
    };
    StatusBar.prototype.createAndRenderComponents = function (statusBarComponents, ePanelComponent) {
        var _this = this;
        var componentDetails = [];
        statusBarComponents.forEach(function (componentConfig) {
            var params = {};
            var compDetails = _this.userComponentFactory.getStatusPanelCompDetails(componentConfig, params);
            var promise = compDetails.newAgStackInstance();
            if (!promise) {
                return;
            }
            componentDetails.push({
                // default to the component name if no key supplied
                key: componentConfig.key || componentConfig.statusPanel,
                promise: promise,
            });
        });
        AgPromise.all(
            componentDetails.map(function (details) {
                return details.promise;
            }),
        ).then(function () {
            componentDetails.forEach(function (componentDetail) {
                componentDetail.promise.then(function (component) {
                    var destroyFunc = function () {
                        _this.getContext().destroyBean(component);
                    };
                    if (_this.isAlive()) {
                        _this.statusBarService.registerStatusPanel(componentDetail.key, component);
                        ePanelComponent.appendChild(component.getGui());
                        _this.addDestroyFunc(destroyFunc);
                    } else {
                        destroyFunc();
                    }
                });
            });
        });
    };
    StatusBar.TEMPLATE =
        '<div class="ag-status-bar">\n            <div ref="eStatusBarLeft" class="ag-status-bar-left" role="status"></div>\n            <div ref="eStatusBarCenter" class="ag-status-bar-center" role="status"></div>\n            <div ref="eStatusBarRight" class="ag-status-bar-right" role="status"></div>\n        </div>';
    __decorate$9([Autowired('userComponentFactory')], StatusBar.prototype, 'userComponentFactory', void 0);
    __decorate$9([Autowired('statusBarService')], StatusBar.prototype, 'statusBarService', void 0);
    __decorate$9([RefSelector('eStatusBarLeft')], StatusBar.prototype, 'eStatusBarLeft', void 0);
    __decorate$9([RefSelector('eStatusBarCenter')], StatusBar.prototype, 'eStatusBarCenter', void 0);
    __decorate$9([RefSelector('eStatusBarRight')], StatusBar.prototype, 'eStatusBarRight', void 0);
    __decorate$9([PostConstruct], StatusBar.prototype, 'postConstruct', null);
    return StatusBar;
})(Component);

var __extends$d =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$8 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var NameValueComp = /** @class */ (function (_super) {
    __extends$d(NameValueComp, _super);
    function NameValueComp() {
        return _super.call(this, NameValueComp.TEMPLATE) || this;
    }
    NameValueComp.prototype.setLabel = function (key, defaultValue) {
        // we want to hide until the first value comes in
        this.setDisplayed(false);
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLabel.innerHTML = localeTextFunc(key, defaultValue);
    };
    NameValueComp.prototype.setValue = function (value) {
        this.eValue.innerHTML = value;
    };
    NameValueComp.TEMPLATE =
        '<div class="ag-status-name-value">\n            <span ref="eLabel"></span>:&nbsp;\n            <span ref="eValue" class="ag-status-name-value-value"></span>\n        </div>';
    __decorate$8([RefSelector('eLabel')], NameValueComp.prototype, 'eLabel', void 0);
    __decorate$8([RefSelector('eValue')], NameValueComp.prototype, 'eValue', void 0);
    return NameValueComp;
})(Component);

var __extends$c =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$7 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TotalAndFilteredRowsComp = /** @class */ (function (_super) {
    __extends$c(TotalAndFilteredRowsComp, _super);
    function TotalAndFilteredRowsComp() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    TotalAndFilteredRowsComp.prototype.postConstruct = function () {
        // this component is only really useful with client side row model
        if (this.gridApi.getModel().getType() !== 'clientSide') {
            console.warn(
                'AG Grid: agTotalAndFilteredRowCountComponent should only be used with the client side row model.',
            );
            return;
        }
        this.setLabel('totalAndFilteredRows', 'Rows');
        this.addCssClass('ag-status-panel');
        this.addCssClass('ag-status-panel-total-and-filtered-row-count');
        this.setDisplayed(true);
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
        this.onDataChanged();
    };
    TotalAndFilteredRowsComp.prototype.onDataChanged = function () {
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var thousandSeparator = localeTextFunc('thousandSeparator', ',');
        var decimalSeparator = localeTextFunc('decimalSeparator', '.');
        var rowCount = _.formatNumberCommas(this.getFilteredRowCountValue(), thousandSeparator, decimalSeparator);
        var totalRowCount = _.formatNumberCommas(this.getTotalRowCount(), thousandSeparator, decimalSeparator);
        if (rowCount === totalRowCount) {
            this.setValue(rowCount);
        } else {
            var localeTextFunc_1 = this.localeService.getLocaleTextFunc();
            this.setValue(rowCount + ' ' + localeTextFunc_1('of', 'of') + ' ' + totalRowCount);
        }
    };
    TotalAndFilteredRowsComp.prototype.getFilteredRowCountValue = function () {
        var filteredRowCount = 0;
        this.gridApi.forEachNodeAfterFilter(function (node) {
            if (!node.group) {
                filteredRowCount++;
            }
        });
        return filteredRowCount;
    };
    TotalAndFilteredRowsComp.prototype.getTotalRowCount = function () {
        var totalRowCount = 0;
        this.gridApi.forEachNode(function (node) {
            if (!node.group) {
                totalRowCount++;
            }
        });
        return totalRowCount;
    };
    TotalAndFilteredRowsComp.prototype.init = function () {};
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    TotalAndFilteredRowsComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    __decorate$7([Autowired('gridApi')], TotalAndFilteredRowsComp.prototype, 'gridApi', void 0);
    __decorate$7([PostConstruct], TotalAndFilteredRowsComp.prototype, 'postConstruct', null);
    return TotalAndFilteredRowsComp;
})(NameValueComp);

var __extends$b =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$6 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var FilteredRowsComp = /** @class */ (function (_super) {
    __extends$b(FilteredRowsComp, _super);
    function FilteredRowsComp() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    FilteredRowsComp.prototype.postConstruct = function () {
        this.setLabel('filteredRows', 'Filtered');
        // this component is only really useful with client side row model
        if (this.gridApi.getModel().getType() !== 'clientSide') {
            console.warn('AG Grid: agFilteredRowCountComponent should only be used with the client side row model.');
            return;
        }
        this.addCssClass('ag-status-panel');
        this.addCssClass('ag-status-panel-filtered-row-count');
        this.setDisplayed(true);
        var listener = this.onDataChanged.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, listener);
        listener();
    };
    FilteredRowsComp.prototype.onDataChanged = function () {
        var totalRowCountValue = this.getTotalRowCountValue();
        var filteredRowCountValue = this.getFilteredRowCountValue();
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var thousandSeparator = localeTextFunc('thousandSeparator', ',');
        var decimalSeparator = localeTextFunc('decimalSeparator', '.');
        this.setValue(_.formatNumberCommas(filteredRowCountValue, thousandSeparator, decimalSeparator));
        this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
    };
    FilteredRowsComp.prototype.getTotalRowCountValue = function () {
        var totalRowCount = 0;
        this.gridApi.forEachNode(function (node) {
            return (totalRowCount += 1);
        });
        return totalRowCount;
    };
    FilteredRowsComp.prototype.getFilteredRowCountValue = function () {
        var filteredRowCount = 0;
        this.gridApi.forEachNodeAfterFilter(function (node) {
            if (!node.group) {
                filteredRowCount += 1;
            }
        });
        return filteredRowCount;
    };
    FilteredRowsComp.prototype.init = function () {};
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    FilteredRowsComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    __decorate$6([Autowired('gridApi')], FilteredRowsComp.prototype, 'gridApi', void 0);
    __decorate$6([PostConstruct], FilteredRowsComp.prototype, 'postConstruct', null);
    return FilteredRowsComp;
})(NameValueComp);

var __extends$a =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$5 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var TotalRowsComp = /** @class */ (function (_super) {
    __extends$a(TotalRowsComp, _super);
    function TotalRowsComp() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    TotalRowsComp.prototype.postConstruct = function () {
        this.setLabel('totalRows', 'Total Rows');
        // this component is only really useful with client side row model
        if (this.gridApi.getModel().getType() !== 'clientSide') {
            console.warn('AG Grid: agTotalRowCountComponent should only be used with the client side row model.');
            return;
        }
        this.addCssClass('ag-status-panel');
        this.addCssClass('ag-status-panel-total-row-count');
        this.setDisplayed(true);
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
        this.onDataChanged();
    };
    TotalRowsComp.prototype.onDataChanged = function () {
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var thousandSeparator = localeTextFunc('thousandSeparator', ',');
        var decimalSeparator = localeTextFunc('decimalSeparator', '.');
        this.setValue(_.formatNumberCommas(this.getRowCountValue(), thousandSeparator, decimalSeparator));
    };
    TotalRowsComp.prototype.getRowCountValue = function () {
        var totalRowCount = 0;
        this.gridApi.forEachLeafNode(function (node) {
            return (totalRowCount += 1);
        });
        return totalRowCount;
    };
    TotalRowsComp.prototype.init = function () {};
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    TotalRowsComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    __decorate$5([Autowired('gridApi')], TotalRowsComp.prototype, 'gridApi', void 0);
    __decorate$5([PostConstruct], TotalRowsComp.prototype, 'postConstruct', null);
    return TotalRowsComp;
})(NameValueComp);

var __extends$9 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$4 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SelectedRowsComp = /** @class */ (function (_super) {
    __extends$9(SelectedRowsComp, _super);
    function SelectedRowsComp() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SelectedRowsComp.prototype.postConstruct = function () {
        if (!this.isValidRowModel()) {
            console.warn(
                'AG Grid: agSelectedRowCountComponent should only be used with the client and server side row model.',
            );
            return;
        }
        this.setLabel('selectedRows', 'Selected');
        this.addCssClass('ag-status-panel');
        this.addCssClass('ag-status-panel-selected-row-count');
        this.onRowSelectionChanged();
        var eventListener = this.onRowSelectionChanged.bind(this);
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, eventListener);
        this.addManagedListener(this.eventService, Events.EVENT_SELECTION_CHANGED, eventListener);
    };
    SelectedRowsComp.prototype.isValidRowModel = function () {
        // this component is only really useful with client or server side rowmodels
        var rowModelType = this.gridApi.getModel().getType();
        return rowModelType === 'clientSide' || rowModelType === 'serverSide';
    };
    SelectedRowsComp.prototype.onRowSelectionChanged = function () {
        var selectedRowCount = this.selectionService.getSelectionCount();
        if (selectedRowCount < 0) {
            this.setValue('?');
            this.setDisplayed(true);
            return;
        }
        var localeTextFunc = this.localeService.getLocaleTextFunc();
        var thousandSeparator = localeTextFunc('thousandSeparator', ',');
        var decimalSeparator = localeTextFunc('decimalSeparator', '.');
        this.setValue(_.formatNumberCommas(selectedRowCount, thousandSeparator, decimalSeparator));
        this.setDisplayed(selectedRowCount > 0);
    };
    SelectedRowsComp.prototype.init = function () {};
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    SelectedRowsComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    __decorate$4([Autowired('gridApi')], SelectedRowsComp.prototype, 'gridApi', void 0);
    __decorate$4([Autowired('selectionService')], SelectedRowsComp.prototype, 'selectionService', void 0);
    __decorate$4([PostConstruct], SelectedRowsComp.prototype, 'postConstruct', null);
    return SelectedRowsComp;
})(NameValueComp);

var __extends$8 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$3 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var AggregationComp = /** @class */ (function (_super) {
    __extends$8(AggregationComp, _super);
    function AggregationComp() {
        return _super.call(this, AggregationComp.TEMPLATE) || this;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    AggregationComp.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    AggregationComp.prototype.postConstruct = function () {
        if (!this.isValidRowModel()) {
            console.warn(
                'AG Grid: agAggregationComponent should only be used with the client and server side row model.',
            );
            return;
        }
        this.avgAggregationComp.setLabel('avg', 'Average');
        this.countAggregationComp.setLabel('count', 'Count');
        this.minAggregationComp.setLabel('min', 'Min');
        this.maxAggregationComp.setLabel('max', 'Max');
        this.sumAggregationComp.setLabel('sum', 'Sum');
        this.addManagedListener(
            this.eventService,
            Events.EVENT_RANGE_SELECTION_CHANGED,
            this.onRangeSelectionChanged.bind(this),
        );
        this.addManagedListener(this.eventService, Events.EVENT_MODEL_UPDATED, this.onRangeSelectionChanged.bind(this));
    };
    AggregationComp.prototype.isValidRowModel = function () {
        // this component is only really useful with client or server side rowmodels
        var rowModelType = this.gridApi.getModel().getType();
        return rowModelType === 'clientSide' || rowModelType === 'serverSide';
    };
    AggregationComp.prototype.init = function () {};
    AggregationComp.prototype.setAggregationComponentValue = function (aggFuncName, value, visible) {
        var statusBarValueComponent = this.getAggregationValueComponent(aggFuncName);
        if (_.exists(statusBarValueComponent) && statusBarValueComponent) {
            var localeTextFunc = this.localeService.getLocaleTextFunc();
            var thousandSeparator = localeTextFunc('thousandSeparator', ',');
            var decimalSeparator = localeTextFunc('decimalSeparator', '.');
            statusBarValueComponent.setValue(
                _.formatNumberTwoDecimalPlacesAndCommas(value, thousandSeparator, decimalSeparator),
            );
            statusBarValueComponent.setDisplayed(visible);
        }
    };
    AggregationComp.prototype.getAggregationValueComponent = function (aggFuncName) {
        // converts user supplied agg name to our reference - eg: sum => sumAggregationComp
        var refComponentName = aggFuncName + 'AggregationComp';
        // if the user has specified the agAggregationPanelComp but no aggFuncs we show the all
        // if the user has specified the agAggregationPanelComp and aggFuncs, then we only show the aggFuncs listed
        var statusBarValueComponent = null;
        var statusBar = this.gridOptionsService.get('statusBar');
        var aggregationPanelConfig =
            _.exists(statusBar) && statusBar
                ? statusBar.statusPanels.find(function (panel) {
                      return panel.statusPanel === 'agAggregationComponent';
                  })
                : null;
        if (_.exists(aggregationPanelConfig) && aggregationPanelConfig) {
            // a little defensive here - if no statusPanelParams show it, if componentParams we also expect aggFuncs
            if (
                !_.exists(aggregationPanelConfig.statusPanelParams) ||
                (_.exists(aggregationPanelConfig.statusPanelParams) &&
                    _.exists(aggregationPanelConfig.statusPanelParams.aggFuncs) &&
                    _.exists(
                        aggregationPanelConfig.statusPanelParams.aggFuncs.find(function (func) {
                            return func === aggFuncName;
                        }),
                    ))
            ) {
                statusBarValueComponent = this[refComponentName];
            }
        } else {
            // components not specified - assume we can show this component
            statusBarValueComponent = this[refComponentName];
        }
        // either we can't find it (which would indicate a typo or similar user side), or the user has deliberately
        // not listed the component in aggFuncs
        return statusBarValueComponent;
    };
    AggregationComp.prototype.onRangeSelectionChanged = function () {
        var _this = this;
        var cellRanges = this.rangeService ? this.rangeService.getCellRanges() : undefined;
        var sum = 0;
        var count = 0;
        var numberCount = 0;
        var min = null;
        var max = null;
        var cellsSoFar = {};
        if (cellRanges && !_.missingOrEmpty(cellRanges)) {
            cellRanges.forEach(function (cellRange) {
                var currentRow = _this.rangeService.getRangeStartRow(cellRange);
                var lastRow = _this.rangeService.getRangeEndRow(cellRange);
                while (true) {
                    var finishedAllRows =
                        _.missing(currentRow) || !currentRow || _this.rowPositionUtils.before(lastRow, currentRow);
                    if (finishedAllRows || !currentRow || !cellRange.columns) {
                        break;
                    }
                    cellRange.columns.forEach(function (col) {
                        if (currentRow === null) {
                            return;
                        }
                        // we only want to include each cell once, in case a cell is in multiple ranges
                        var cellId = _this.cellPositionUtils.createId({
                            rowPinned: currentRow.rowPinned,
                            column: col,
                            rowIndex: currentRow.rowIndex,
                        });
                        if (cellsSoFar[cellId]) {
                            return;
                        }
                        cellsSoFar[cellId] = true;
                        var rowNode = _this.rowRenderer.getRowNode(currentRow);
                        if (_.missing(rowNode)) {
                            return;
                        }
                        var value = _this.valueService.getValue(col, rowNode);
                        // if empty cell, skip it, doesn't impact count or anything
                        if (_.missing(value) || value === '') {
                            return;
                        }
                        count++;
                        // see if value is wrapped, can happen when doing count() or avg() functions
                        if (typeof value === 'object' && 'value' in value) {
                            value = value.value;
                            // ensure that the new value wouldn't have been skipped by the previous check
                            if (value === '') {
                                return;
                            }
                        }
                        if (typeof value === 'string') {
                            value = Number(value);
                        }
                        if (typeof value === 'number' && !isNaN(value)) {
                            sum += value;
                            if (max === null || value > max) {
                                max = value;
                            }
                            if (min === null || value < min) {
                                min = value;
                            }
                            numberCount++;
                        }
                    });
                    currentRow = _this.cellNavigationService.getRowBelow(currentRow);
                }
            });
        }
        var gotResult = count > 1;
        var gotNumberResult = numberCount > 1;
        // we show count even if no numbers
        this.setAggregationComponentValue('count', count, gotResult);
        // show if numbers found
        this.setAggregationComponentValue('sum', sum, gotNumberResult);
        this.setAggregationComponentValue('min', min, gotNumberResult);
        this.setAggregationComponentValue('max', max, gotNumberResult);
        this.setAggregationComponentValue('avg', sum / numberCount, gotNumberResult);
    };
    AggregationComp.TEMPLATE =
        '<div class="ag-status-panel ag-status-panel-aggregations">\n            <ag-name-value ref="avgAggregationComp"></ag-name-value>\n            <ag-name-value ref="countAggregationComp"></ag-name-value>\n            <ag-name-value ref="minAggregationComp"></ag-name-value>\n            <ag-name-value ref="maxAggregationComp"></ag-name-value>\n            <ag-name-value ref="sumAggregationComp"></ag-name-value>\n        </div>';
    __decorate$3([Optional('rangeService')], AggregationComp.prototype, 'rangeService', void 0);
    __decorate$3([Autowired('valueService')], AggregationComp.prototype, 'valueService', void 0);
    __decorate$3([Autowired('cellNavigationService')], AggregationComp.prototype, 'cellNavigationService', void 0);
    __decorate$3([Autowired('rowRenderer')], AggregationComp.prototype, 'rowRenderer', void 0);
    __decorate$3([Autowired('gridApi')], AggregationComp.prototype, 'gridApi', void 0);
    __decorate$3([Autowired('cellPositionUtils')], AggregationComp.prototype, 'cellPositionUtils', void 0);
    __decorate$3([Autowired('rowPositionUtils')], AggregationComp.prototype, 'rowPositionUtils', void 0);
    __decorate$3([RefSelector('sumAggregationComp')], AggregationComp.prototype, 'sumAggregationComp', void 0);
    __decorate$3([RefSelector('countAggregationComp')], AggregationComp.prototype, 'countAggregationComp', void 0);
    __decorate$3([RefSelector('minAggregationComp')], AggregationComp.prototype, 'minAggregationComp', void 0);
    __decorate$3([RefSelector('maxAggregationComp')], AggregationComp.prototype, 'maxAggregationComp', void 0);
    __decorate$3([RefSelector('avgAggregationComp')], AggregationComp.prototype, 'avgAggregationComp', void 0);
    __decorate$3([PostConstruct], AggregationComp.prototype, 'postConstruct', null);
    return AggregationComp;
})(Component);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$2 = '30.2.0';

var StatusBarModule = {
    version: VERSION$2,
    moduleName: ModuleNames.StatusBarModule,
    beans: [StatusBarService],
    agStackComponents: [
        { componentName: 'AgStatusBar', componentClass: StatusBar },
        { componentName: 'AgNameValue', componentClass: NameValueComp },
    ],
    userComponents: [
        { componentName: 'agAggregationComponent', componentClass: AggregationComp },
        { componentName: 'agSelectedRowCountComponent', componentClass: SelectedRowsComp },
        { componentName: 'agTotalRowCountComponent', componentClass: TotalRowsComp },
        { componentName: 'agFilteredRowCountComponent', componentClass: FilteredRowsComp },
        { componentName: 'agTotalAndFilteredRowCountComponent', componentClass: TotalAndFilteredRowsComp },
    ],
    dependantModules: [EnterpriseCoreModule],
};

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION$1 = '30.2.0';

var __extends$7 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate$2 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE = 5;
var DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE = 5;
var ViewportRowModel = /** @class */ (function (_super) {
    __extends$7(ViewportRowModel, _super);
    function ViewportRowModel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        // rowRenderer tells us these
        _this.firstRow = -1;
        _this.lastRow = -1;
        // datasource tells us this
        _this.rowCount = -1;
        _this.rowNodesByIndex = {};
        return _this;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ViewportRowModel.prototype.ensureRowHeightsValid = function (startPixel, endPixel, startLimitIndex, endLimitIndex) {
        return false;
    };
    ViewportRowModel.prototype.init = function () {
        this.rowHeight = this.gridOptionsService.getRowHeightAsNumber();
        this.addManagedListener(this.eventService, Events.EVENT_VIEWPORT_CHANGED, this.onViewportChanged.bind(this));
    };
    ViewportRowModel.prototype.start = function () {
        if (this.gridOptionsService.get('viewportDatasource')) {
            this.setViewportDatasource(this.gridOptionsService.get('viewportDatasource'));
        }
    };
    ViewportRowModel.prototype.isLastRowIndexKnown = function () {
        return true;
    };
    ViewportRowModel.prototype.destroyDatasource = function () {
        if (!this.viewportDatasource) {
            return;
        }
        if (this.viewportDatasource.destroy) {
            this.viewportDatasource.destroy();
        }
        this.rowRenderer.datasourceChanged();
        this.firstRow = -1;
        this.lastRow = -1;
    };
    ViewportRowModel.prototype.getViewportRowModelPageSize = function () {
        return _.oneOrGreater(
            this.gridOptionsService.getNum('viewportRowModelPageSize'),
            DEFAULT_VIEWPORT_ROW_MODEL_PAGE_SIZE,
        );
    };
    ViewportRowModel.prototype.getViewportRowModelBufferSize = function () {
        return _.zeroOrGreater(
            this.gridOptionsService.getNum('viewportRowModelBufferSize'),
            DEFAULT_VIEWPORT_ROW_MODEL_BUFFER_SIZE,
        );
    };
    ViewportRowModel.prototype.calculateFirstRow = function (firstRenderedRow) {
        var bufferSize = this.getViewportRowModelBufferSize();
        var pageSize = this.getViewportRowModelPageSize();
        var afterBuffer = firstRenderedRow - bufferSize;
        if (afterBuffer < 0) {
            return 0;
        }
        return Math.floor(afterBuffer / pageSize) * pageSize;
    };
    ViewportRowModel.prototype.calculateLastRow = function (lastRenderedRow) {
        if (lastRenderedRow === -1) {
            return lastRenderedRow;
        }
        var bufferSize = this.getViewportRowModelBufferSize();
        var pageSize = this.getViewportRowModelPageSize();
        var afterBuffer = lastRenderedRow + bufferSize;
        var result = Math.ceil(afterBuffer / pageSize) * pageSize;
        var lastRowIndex = this.rowCount - 1;
        return Math.min(result, lastRowIndex);
    };
    ViewportRowModel.prototype.onViewportChanged = function (event) {
        var newFirst = this.calculateFirstRow(event.firstRow);
        var newLast = this.calculateLastRow(event.lastRow);
        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
            this.firstRow = newFirst;
            this.lastRow = newLast;
            this.purgeRowsNotInViewport();
            if (this.viewportDatasource) {
                this.viewportDatasource.setViewportRange(this.firstRow, this.lastRow);
            }
        }
    };
    ViewportRowModel.prototype.purgeRowsNotInViewport = function () {
        var _this = this;
        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
            var index = parseInt(indexStr, 10);
            if (index < _this.firstRow || index > _this.lastRow) {
                if (_this.isRowFocused(index)) {
                    return;
                }
                delete _this.rowNodesByIndex[index];
            }
        });
    };
    ViewportRowModel.prototype.isRowFocused = function (rowIndex) {
        var focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) {
            return false;
        }
        if (focusedCell.rowPinned != null) {
            return false;
        }
        var hasFocus = focusedCell.rowIndex === rowIndex;
        return hasFocus;
    };
    ViewportRowModel.prototype.setViewportDatasource = function (viewportDatasource) {
        this.destroyDatasource();
        this.viewportDatasource = viewportDatasource;
        this.rowCount = -1;
        if (!viewportDatasource.init) {
            console.warn('AG Grid: viewport is missing init method.');
        } else {
            viewportDatasource.init({
                setRowCount: this.setRowCount.bind(this),
                setRowData: this.setRowData.bind(this),
                getRow: this.getRow.bind(this),
            });
        }
    };
    ViewportRowModel.prototype.getType = function () {
        return 'viewport';
    };
    ViewportRowModel.prototype.getRow = function (rowIndex) {
        if (!this.rowNodesByIndex[rowIndex]) {
            this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
        }
        return this.rowNodesByIndex[rowIndex];
    };
    ViewportRowModel.prototype.getRowNode = function (id) {
        var result;
        this.forEachNode(function (rowNode) {
            if (rowNode.id === id) {
                result = rowNode;
            }
        });
        return result;
    };
    ViewportRowModel.prototype.getRowCount = function () {
        return this.rowCount === -1 ? 0 : this.rowCount;
    };
    ViewportRowModel.prototype.getRowIndexAtPixel = function (pixel) {
        if (this.rowHeight !== 0) {
            // avoid divide by zero error
            return Math.floor(pixel / this.rowHeight);
        }
        return 0;
    };
    ViewportRowModel.prototype.getRowBounds = function (index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index,
        };
    };
    ViewportRowModel.prototype.getTopLevelRowCount = function () {
        return this.getRowCount();
    };
    ViewportRowModel.prototype.getTopLevelRowDisplayedIndex = function (topLevelIndex) {
        return topLevelIndex;
    };
    ViewportRowModel.prototype.isEmpty = function () {
        return this.rowCount > 0;
    };
    ViewportRowModel.prototype.isRowsToRender = function () {
        return this.rowCount > 0;
    };
    ViewportRowModel.prototype.getNodesInRangeForSelection = function (firstInRange, lastInRange) {
        var firstIndex = _.missing(firstInRange) ? 0 : firstInRange.rowIndex;
        var lastIndex = lastInRange.rowIndex;
        var firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
        var lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
        if (firstNodeOutOfRange || lastNodeOutOfRange) {
            return [];
        }
        var result = [];
        var startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
        var endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
        for (var i = startIndex; i <= endIndex; i++) {
            result.push(this.rowNodesByIndex[i]);
        }
        return result;
    };
    ViewportRowModel.prototype.forEachNode = function (callback) {
        var _this = this;
        var callbackCount = 0;
        Object.keys(this.rowNodesByIndex).forEach(function (indexStr) {
            var index = parseInt(indexStr, 10);
            var rowNode = _this.rowNodesByIndex[index];
            callback(rowNode, callbackCount);
            callbackCount++;
        });
    };
    ViewportRowModel.prototype.setRowData = function (rowData) {
        var _this = this;
        _.iterateObject(rowData, function (indexStr, dataItem) {
            var index = parseInt(indexStr, 10);
            // we should never keep rows that we didn't specifically ask for, this
            // guarantees the contract we have with the server.
            if (index >= _this.firstRow && index <= _this.lastRow) {
                var rowNode = _this.rowNodesByIndex[index];
                // the abnormal case is we requested a row even though the grid didn't need it
                // as a result of the paging and buffer (ie the row is off screen), in which
                // case we need to create a new node now
                if (_.missing(rowNode)) {
                    rowNode = _this.createBlankRowNode(index);
                    _this.rowNodesByIndex[index] = rowNode;
                }
                // now we deffo have a row node, so set in the details
                // if the grid already asked for this row (the normal case), then we would
                // of put a placeholder node in place.
                rowNode.setDataAndId(dataItem, index.toString());
            }
        });
    };
    ViewportRowModel.prototype.createBlankRowNode = function (rowIndex) {
        var rowNode = new RowNode(this.beans);
        rowNode.setRowHeight(this.rowHeight);
        rowNode.setRowTop(this.rowHeight * rowIndex);
        rowNode.setRowIndex(rowIndex);
        return rowNode;
    };
    ViewportRowModel.prototype.setRowCount = function (rowCount, keepRenderedRows) {
        if (keepRenderedRows === void 0) {
            keepRenderedRows = false;
        }
        if (rowCount === this.rowCount) {
            return;
        }
        this.rowCount = rowCount;
        var event = {
            type: Events.EVENT_MODEL_UPDATED,
            newData: false,
            newPage: false,
            keepRenderedRows: keepRenderedRows,
            animate: false,
        };
        this.eventService.dispatchEvent(event);
    };
    ViewportRowModel.prototype.isRowPresent = function (rowNode) {
        var foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    };
    __decorate$2([Autowired('rowRenderer')], ViewportRowModel.prototype, 'rowRenderer', void 0);
    __decorate$2([Autowired('focusService')], ViewportRowModel.prototype, 'focusService', void 0);
    __decorate$2([Autowired('beans')], ViewportRowModel.prototype, 'beans', void 0);
    __decorate$2([PostConstruct], ViewportRowModel.prototype, 'init', null);
    __decorate$2([PreDestroy], ViewportRowModel.prototype, 'destroyDatasource', null);
    ViewportRowModel = __decorate$2([Bean('rowModel')], ViewportRowModel);
    return ViewportRowModel;
})(BeanStub);

var ViewportRowModelModule = {
    version: VERSION$1,
    moduleName: ModuleNames.ViewportRowModelModule,
    rowModel: 'viewport',
    beans: [ViewportRowModel],
    dependantModules: [EnterpriseCoreModule],
};

var defaultTooltipCss =
    '\n.ag-sparkline-tooltip-wrapper {\n    position: absolute;\n    user-select: none;\n    pointer-events: none;\n}\n\n.ag-sparkline-tooltip {\n    position: relative;\n    font: 12px arial,sans-serif;\n    border-radius: 2px;\n    box-shadow: 0 1px 3px rgb(0 0 0 / 20%), 0 1px 1px rgb(0 0 0 / 14%);\n    line-height: 1.7em;\n    overflow: hidden;\n    white-space: nowrap;\n    z-index: 99999;\n    background-color: rgb(255, 255, 255);\n    color: rgba(0,0,0, 0.67);\n}\n\n.ag-sparkline-tooltip-content {\n    padding: 0 7px;\n    opacity: 1;\n}\n\n.ag-sparkline-tooltip-title {\n    padding-left: 7px;\n    opacity: 1;\n}\n\n.ag-sparkline-tooltip-wrapper-hidden {\n    top: -10000px !important;\n}\n\n.ag-sparkline-wrapper {\n    box-sizing: border-box;\n    overflow: hidden;\n}\n';

var __values =
    (undefined && undefined.__values) ||
    function (o) {
        var s = typeof Symbol === 'function' && Symbol.iterator,
            m = s && o[s],
            i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === 'number')
            return {
                next: function () {
                    if (o && i >= o.length) o = void 0;
                    return { value: o && o[i++], done: !o };
                },
            };
        throw new TypeError(s ? 'Object is not iterable.' : 'Symbol.iterator is not defined.');
    };
var extent$3 = extent$4,
    isNumber$3 = isNumber$4,
    isString = isString$2,
    isStringObject = isStringObject$1,
    isDate = isDate$1,
    createId = createId$1,
    Padding = Padding$1;
var LinearScale = LinearScale$1,
    BandScale$4 = BandScale$5,
    TimeScale = TimeScale$1;
/**
 * Constants to declare the expected nominal zIndex for nodes in a sparkline rendering.
 */
var ZINDICIES;
(function (ZINDICIES) {
    ZINDICIES[(ZINDICIES['SERIES_FILL_ZINDEX'] = 50)] = 'SERIES_FILL_ZINDEX';
    ZINDICIES[(ZINDICIES['AXIS_LINE_ZINDEX'] = 500)] = 'AXIS_LINE_ZINDEX';
    ZINDICIES[(ZINDICIES['SERIES_STROKE_ZINDEX'] = 1000)] = 'SERIES_STROKE_ZINDEX';
    ZINDICIES[(ZINDICIES['SERIES_LABEL_ZINDEX'] = 1500)] = 'SERIES_LABEL_ZINDEX';
    ZINDICIES[(ZINDICIES['CROSSHAIR_ZINDEX'] = 2000)] = 'CROSSHAIR_ZINDEX';
    ZINDICIES[(ZINDICIES['SERIES_MARKERS_ZINDEX'] = 2500)] = 'SERIES_MARKERS_ZINDEX';
})(ZINDICIES || (ZINDICIES = {}));
var SparklineAxis = /** @class */ (function () {
    function SparklineAxis() {
        this.type = 'category';
        this.stroke = 'rgb(204, 214, 235)';
        this.strokeWidth = 1;
    }
    return SparklineAxis;
})();
var Sparkline = /** @class */ (function () {
    function Sparkline() {
        this.id = createId(this);
        this.seriesRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
        };
        this._context = undefined;
        this._container = undefined;
        this._data = undefined;
        this.padding = new Padding(3);
        this.xKey = 'x';
        this.yKey = 'y';
        this.dataType = undefined;
        this.xData = [];
        this.yData = [];
        // Minimum y value in provided data.
        this.min = undefined;
        // Maximum y value in provided data.
        this.max = undefined;
        this.yScale = new LinearScale();
        this.axis = new SparklineAxis();
        this.highlightStyle = {
            size: 6,
            fill: 'yellow',
            stroke: 'silver',
            strokeWidth: 1,
        };
        this._width = 100;
        this._height = 100;
        this.smallestInterval = undefined;
        this.layoutId = 0;
        this.defaultDateFormatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
        this._onMouseMove = this.onMouseMove.bind(this);
        this._onMouseOut = this.onMouseOut.bind(this);
        var root = new Group();
        this.rootGroup = root;
        var element = document.createElement('div');
        element.setAttribute('class', 'ag-sparkline-wrapper');
        var scene = new Scene({ document: document });
        this.scene = scene;
        this.canvasElement = scene.canvas.element;
        scene.root = root;
        scene.container = element;
        scene.resize(this.width, this.height);
        this.seriesRect.width = this.width;
        this.seriesRect.height = this.height;
        // one style element for tooltip styles per document
        if (Sparkline.tooltipDocuments.indexOf(document) === -1) {
            var styleElement = document.createElement('style');
            styleElement.innerHTML = defaultTooltipCss;
            document.head.insertBefore(styleElement, document.head.querySelector('style'));
            Sparkline.tooltipDocuments.push(document);
        }
        this.setupDomEventListeners(this.scene.canvas.element);
    }
    Object.defineProperty(Sparkline.prototype, 'context', {
        get: function () {
            return this._context;
        },
        set: function (value) {
            if (this._context !== value) {
                this._context = value;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Sparkline.prototype, 'container', {
        get: function () {
            return this._container;
        },
        set: function (value) {
            if (this._container !== value) {
                var parentNode = this.canvasElement.parentNode;
                if (parentNode != null) {
                    parentNode.removeChild(this.canvasElement);
                }
                if (value) {
                    value.appendChild(this.canvasElement);
                }
                this._container = value;
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Sparkline.prototype, 'data', {
        get: function () {
            return this._data;
        },
        set: function (value) {
            if (this._data !== value) {
                this._data = value;
                this.processData();
                if (this.mouseMoveEvent && this.highlightedDatum) {
                    this.updateHitPoint(this.mouseMoveEvent);
                }
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Sparkline.prototype, 'width', {
        get: function () {
            return this._width;
        },
        set: function (value) {
            if (this._width !== value) {
                this._width = value;
                this.scene.resize(value, this.height);
                this.scheduleLayout();
            }
        },
        enumerable: false,
        configurable: true,
    });
    Object.defineProperty(Sparkline.prototype, 'height', {
        get: function () {
            return this._height;
        },
        set: function (value) {
            if (this._height !== value) {
                this._height = value;
                this.scene.resize(this.width, value);
                this.scheduleLayout();
            }
        },
        enumerable: false,
        configurable: true,
    });
    /**
     * Generate node data from processed data.
     * Produce data joins.
     * Update selection's nodes using node data.
     */
    Sparkline.prototype.update = function () {};
    // Update y scale based on processed data.
    Sparkline.prototype.updateYScale = function () {
        this.updateYScaleRange();
        this.updateYScaleDomain();
    };
    // Update y scale domain based on processed data.
    Sparkline.prototype.updateYScaleDomain = function () {};
    // Update y scale range based on height and padding (seriesRect).
    Sparkline.prototype.updateYScaleRange = function () {
        var _a = this,
            yScale = _a.yScale,
            seriesRect = _a.seriesRect;
        yScale.range = [seriesRect.height, 0];
    };
    // Update x scale based on processed data.
    Sparkline.prototype.updateXScale = function () {
        var type = this.axis.type;
        this.xScale = this.getXScale(type);
        this.updateXScaleRange();
        this.updateXScaleDomain();
    };
    // Update x scale range based on width and padding (seriesRect).
    Sparkline.prototype.updateXScaleRange = function () {
        this.xScale.range = [0, this.seriesRect.width];
    };
    // Update x scale domain based on processed data and type of scale.
    Sparkline.prototype.updateXScaleDomain = function () {
        var _a = this,
            xData = _a.xData,
            xScale = _a.xScale;
        var xMinMax;
        if (xScale instanceof LinearScale || xScale instanceof TimeScale) {
            xMinMax = extent$3(xData);
        }
        this.xScale.domain = xMinMax ? xMinMax.slice() : xData;
    };
    /**
     * Return xScale instance based on the provided type or return a `BandScale` by default.
     * The default type is `category`.
     * @param type
     */
    Sparkline.prototype.getXScale = function (type) {
        if (type === void 0) {
            type = 'category';
        }
        switch (type) {
            case 'number':
                return new LinearScale();
            case 'time':
                return new TimeScale();
            case 'category':
            default:
                return new BandScale$4();
        }
    };
    // Update axis line.
    Sparkline.prototype.updateAxisLine = function () {};
    // Update X and Y scales and the axis line.
    Sparkline.prototype.updateAxes = function () {
        this.updateYScale();
        this.updateXScale();
        this.updateAxisLine();
    };
    // Update horizontal and vertical crosshair lines.
    Sparkline.prototype.updateCrosshairs = function () {
        this.updateXCrosshairLine();
        this.updateYCrosshairLine();
    };
    // Using processed data, generate data that backs visible nodes.
    Sparkline.prototype.generateNodeData = function () {
        return [];
    };
    // Returns persisted node data associated with the sparkline's data.
    Sparkline.prototype.getNodeData = function () {
        return [];
    };
    // Update the selection's nodes.
    Sparkline.prototype.updateNodes = function () {};
    // Update the vertical crosshair line.
    Sparkline.prototype.updateXCrosshairLine = function () {};
    // Update the horizontal crosshair line.
    Sparkline.prototype.updateYCrosshairLine = function () {};
    Sparkline.prototype.highlightDatum = function (closestDatum) {
        this.updateNodes();
    };
    Sparkline.prototype.dehighlightDatum = function () {
        this.highlightedDatum = undefined;
        this.updateNodes();
        this.updateCrosshairs();
    };
    /**
     * Highlight closest datum and display tooltip if enabled.
     * Only update if necessary, i.e. only update if the highlighted datum is different from previously highlighted datum,
     * or if there is no previously highlighted datum.
     * @param event
     */
    Sparkline.prototype.onMouseMove = function (event) {
        this.mouseMoveEvent = event;
        this.updateHitPoint(event);
    };
    Sparkline.prototype.updateHitPoint = function (event) {
        var _a, _b, _c;
        var closestDatum = this.pickClosestSeriesNodeDatum(event.offsetX, event.offsetY);
        if (!closestDatum) {
            return;
        }
        var oldHighlightedDatum = this.highlightedDatum;
        this.highlightedDatum = closestDatum;
        if (
            (this.highlightedDatum && !oldHighlightedDatum) ||
            (this.highlightedDatum && oldHighlightedDatum && this.highlightedDatum !== oldHighlightedDatum)
        ) {
            this.highlightDatum(closestDatum);
            this.updateCrosshairs();
            this.scene.render().catch(function (e) {
                return console.error('AG Grid - chart rendering failed', e);
            });
        }
        var tooltipEnabled =
            (_c =
                (_b = (_a = this.processedOptions) === null || _a === void 0 ? void 0 : _a.tooltip) === null ||
                _b === void 0
                    ? void 0
                    : _b.enabled) !== null && _c !== void 0
                ? _c
                : true;
        if (tooltipEnabled) {
            this.handleTooltip(event, closestDatum);
        }
    };
    /**
     * Dehighlight all nodes and remove tooltip.
     * @param event
     */
    Sparkline.prototype.onMouseOut = function (event) {
        this.dehighlightDatum();
        this.tooltip.toggle(false);
        this.scene.render().catch(function (e) {
            return console.error('AG Grid - chart rendering failed', e);
        });
    };
    // Fetch required values from the data object and process them.
    Sparkline.prototype.processData = function () {
        var _this = this;
        var _a = this,
            data = _a.data,
            yData = _a.yData,
            xData = _a.xData;
        if (!data || this.invalidData(this.data)) {
            return;
        }
        yData.length = 0;
        xData.length = 0;
        var n = data.length;
        var dataType = this.getDataType(data);
        this.dataType = dataType;
        var xValueType = this.axis.type;
        var xType = xValueType !== 'number' && xValueType !== 'time' ? 'category' : xValueType;
        var isContinuousX = xType === 'number' || xType === 'time';
        var setSmallestXInterval = function (curr, prev) {
            if (_this.smallestInterval == undefined) {
                _this.smallestInterval = { x: Infinity, y: Infinity };
            }
            var x = _this.smallestInterval.x;
            var interval = Math.abs(curr - prev);
            if (interval > 0 && interval < x) {
                _this.smallestInterval.x = interval;
            }
        };
        var prevX;
        if (dataType === 'number') {
            for (var i = 0; i < n; i++) {
                var xDatum = i;
                var yDatum = data[i];
                var x = this.getDatum(xDatum, xType);
                var y = this.getDatum(yDatum, 'number');
                if (isContinuousX) {
                    setSmallestXInterval(x, prevX);
                }
                xData.push(x);
                yData.push(y);
                prevX = x;
            }
        } else if (dataType === 'array') {
            for (var i = 0; i < n; i++) {
                var datum = data[i];
                if (Array.isArray(datum)) {
                    var xDatum = datum[0];
                    var yDatum = datum[1];
                    var x = this.getDatum(xDatum, xType);
                    var y = this.getDatum(yDatum, 'number');
                    if (x == undefined) {
                        continue;
                    }
                    if (isContinuousX) {
                        setSmallestXInterval(x, prevX);
                    }
                    xData.push(x);
                    yData.push(y);
                    prevX = x;
                }
            }
        } else if (dataType === 'object') {
            var _b = this,
                yKey = _b.yKey,
                xKey = _b.xKey;
            for (var i = 0; i < n; i++) {
                var datum = data[i];
                if (typeof datum === 'object' && !Array.isArray(datum)) {
                    var xDatum = datum[xKey];
                    var yDatum = datum[yKey];
                    var x = this.getDatum(xDatum, xType);
                    var y = this.getDatum(yDatum, 'number');
                    if (x == undefined) {
                        continue;
                    }
                    if (isContinuousX) {
                        setSmallestXInterval(x, prevX);
                    }
                    xData.push(x);
                    yData.push(y);
                    prevX = x;
                }
            }
        }
        this.updateAxes();
        this.immediateLayout();
    };
    /**
     * Return the type of data provided to the sparkline based on the first truthy value in the data array.
     * If the value is not a number, array or object, return `undefined`.
     * @param data
     */
    Sparkline.prototype.getDataType = function (data) {
        var e_1, _a;
        try {
            for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
                var datum = data_1_1.value;
                if (datum != undefined) {
                    if (isNumber$3(datum)) {
                        return 'number';
                    } else if (Array.isArray(datum)) {
                        return 'array';
                    } else if (typeof datum === 'object') {
                        return 'object';
                    }
                }
            }
        } catch (e_1_1) {
            e_1 = { error: e_1_1 };
        } finally {
            try {
                if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
            } finally {
                if (e_1) throw e_1.error;
            }
        }
    };
    /**
     * Return the given value depending on the type of axis.
     * Return `undefined` if the value is invalid for the given axis type.
     * @param value
     */
    Sparkline.prototype.getDatum = function (value, type) {
        if ((type === 'number' && isNumber$3(value)) || (type === 'time' && (isNumber$3(value) || isDate(value)))) {
            return value;
        } else if (type === 'category') {
            if (isString(value) || isDate(value) || isNumber$3(value)) {
                return {
                    toString: function () {
                        return String(value);
                    },
                };
            } else if (isStringObject(value)) {
                return value;
            }
        }
    };
    Object.defineProperty(Sparkline.prototype, 'layoutScheduled', {
        /**
         * Only `true` while we are waiting for the layout to start.
         * This will be `false` if the layout has already started and is ongoing.
         */
        get: function () {
            return !!this.layoutId;
        },
        enumerable: false,
        configurable: true,
    });
    /**
     * Execute update method on the next available screen repaint to make changes to the canvas.
     * If we are waiting for a layout to start and a new layout is requested,
     * cancel the previous layout using the non 0 integer (this.layoutId) returned from requestAnimationFrame.
     */
    Sparkline.prototype.scheduleLayout = function () {
        var _this = this;
        if (this.layoutId) {
            cancelAnimationFrame(this.layoutId);
        }
        this.layoutId = requestAnimationFrame(function () {
            _this.immediateLayout();
            _this.layoutId = 0;
        });
    };
    Sparkline.prototype.immediateLayout = function () {
        this.setSparklineDimensions();
        if (this.invalidData(this.data)) {
            return;
        }
        // update axes ranges
        this.updateXScaleRange();
        this.updateYScaleRange();
        // update axis line
        this.updateAxisLine();
        // produce data joins and update selection's nodes
        this.update();
        this.scene.render().catch(function (e) {
            return console.error('AG Grid - chart rendering failed', e);
        });
    };
    Sparkline.prototype.setSparklineDimensions = function () {
        var _a = this,
            width = _a.width,
            height = _a.height,
            padding = _a.padding,
            seriesRect = _a.seriesRect,
            rootGroup = _a.rootGroup;
        var shrunkWidth = width - padding.left - padding.right;
        var shrunkHeight = height - padding.top - padding.bottom;
        seriesRect.width = shrunkWidth;
        seriesRect.height = shrunkHeight;
        seriesRect.x = padding.left;
        seriesRect.y = padding.top;
        rootGroup.translationX = seriesRect.x;
        rootGroup.translationY = seriesRect.y;
    };
    /**
     * Return the closest data point to x/y canvas coordinates.
     * @param x
     * @param y
     */
    Sparkline.prototype.pickClosestSeriesNodeDatum = function (x, y) {
        var minDistance = Infinity;
        var closestDatum;
        var hitPoint = this.rootGroup.transformPoint(x, y);
        var nodeData = this.getNodeData();
        for (var i = 0; i < nodeData.length; i++) {
            var datum = nodeData[i];
            if (!datum.point) {
                return;
            }
            var distance = this.getDistance(hitPoint, datum.point);
            if (distance <= minDistance) {
                minDistance = distance;
                closestDatum = datum;
            }
        }
        return closestDatum;
    };
    /**
     * Return the relevant distance between two points.
     * The distance will be calculated based on the x value of the points for all sparklines except bar sparkline, where the distance is based on the y values.
     * @param x
     * @param y
     */
    Sparkline.prototype.getDistance = function (p1, p2) {
        return Math.abs(p1.x - p2.x);
    };
    /**
     * calculate x/y coordinates for tooltip based on coordinates of highlighted datum, position of canvas and page offset.
     * @param datum
     */
    Sparkline.prototype.handleTooltip = function (event, datum) {
        var _a, _b;
        var seriesDatum = datum.seriesDatum;
        var canvasElement = this.canvasElement;
        var clientX = event.clientX,
            clientY = event.clientY;
        var tooltipOptions = (_a = this.processedOptions) === null || _a === void 0 ? void 0 : _a.tooltip;
        var meta = {
            pageX: clientX,
            pageY: clientY,
            position: {
                xOffset: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.xOffset,
                yOffset: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.yOffset,
            },
            container: tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.container,
        };
        // confine tooltip to sparkline width if tooltip container not provided.
        if (meta.container == undefined) {
            meta.container = canvasElement;
        }
        var yValue = seriesDatum.y;
        var xValue = seriesDatum.x;
        // check if tooltip is enabled for this specific data point
        var enabled =
            (_b = tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.enabled) !== null &&
            _b !== void 0
                ? _b
                : true;
        var tooltipRenderer = tooltipOptions === null || tooltipOptions === void 0 ? void 0 : tooltipOptions.renderer;
        if (tooltipRenderer) {
            var tooltipRendererResult = tooltipRenderer({
                context: this.context,
                datum: seriesDatum,
                yValue: yValue,
                xValue: xValue,
            });
            enabled =
                typeof tooltipRendererResult !== 'string' && tooltipRendererResult.enabled !== undefined
                    ? tooltipRendererResult.enabled
                    : enabled;
        }
        var html = enabled && seriesDatum.y !== undefined && this.getTooltipHtml(datum);
        if (html) {
            this.tooltip.show(meta, html);
        }
    };
    Sparkline.prototype.formatNumericDatum = function (datum) {
        return String(Math.round(datum * 10) / 10);
    };
    // locale.format('%m/%d/%y, %H:%M:%S');
    Sparkline.prototype.formatDatum = function (datum) {
        var type = this.axis.type || 'category';
        if (type === 'number' && typeof datum === 'number') {
            return this.formatNumericDatum(datum);
        } else if (type === 'time' && (datum instanceof Date || isNumber$3(datum))) {
            return this.defaultDateFormatter.format(datum);
        } else {
            return String(datum);
        }
    };
    Sparkline.prototype.setupDomEventListeners = function (chartElement) {
        chartElement.addEventListener('mousemove', this._onMouseMove);
        chartElement.addEventListener('mouseout', this._onMouseOut);
    };
    Sparkline.prototype.cleanupDomEventListeners = function (chartElement) {
        chartElement.removeEventListener('mousemove', this._onMouseMove);
        chartElement.removeEventListener('mouseout', this._onMouseOut);
    };
    Sparkline.prototype.invalidData = function (data) {
        return !data || !Array.isArray(data) || data.length === 0;
    };
    /**
     * Cleanup and remove canvas element from the DOM.
     */
    Sparkline.prototype.destroy = function () {
        this.scene.container = undefined;
        // remove canvas element from the DOM
        this.container = undefined;
        this.cleanupDomEventListeners(this.scene.canvas.element);
    };
    Sparkline.tooltipDocuments = [];
    return Sparkline;
})();

function toTooltipHtml(input, defaults) {
    var _a, _b, _c;
    if (typeof input === 'string') {
        return input;
    }
    defaults = defaults !== null && defaults !== void 0 ? defaults : {};
    var _d = input.content,
        content = _d === void 0 ? ((_a = defaults.content) !== null && _a !== void 0 ? _a : '') : _d,
        _e = input.title,
        title = _e === void 0 ? ((_b = defaults.title) !== null && _b !== void 0 ? _b : undefined) : _e,
        _f = input.color,
        color = _f === void 0 ? defaults.color : _f,
        _g = input.backgroundColor,
        backgroundColor = _g === void 0 ? defaults.backgroundColor : _g,
        _h = input.opacity,
        opacity = _h === void 0 ? ((_c = defaults.opacity) !== null && _c !== void 0 ? _c : 1) : _h;
    var titleHtml;
    var contentHtml;
    if (color) {
        titleHtml = title
            ? '<span class="' + SparklineTooltip.class + '-title"; style="color: ' + color + '">' + title + '</span>'
            : '';
        contentHtml =
            '<span class="' + SparklineTooltip.class + '-content" style="color: ' + color + '">' + content + '</span>';
    } else {
        titleHtml = title ? '<span class="' + SparklineTooltip.class + '-title">' + title + '</span>' : '';
        contentHtml = '<span class="' + SparklineTooltip.class + '-content">' + content + '</span>';
    }
    var style = 'opacity: ' + opacity;
    if (backgroundColor) {
        style += '; background-color: ' + backgroundColor.toLowerCase();
    }
    return (
        '<div class="' +
        SparklineTooltip.class +
        '" style="' +
        style +
        '">\n                ' +
        titleHtml +
        '\n                ' +
        contentHtml +
        '\n            </div>'
    );
}
var SparklineTooltip = /** @class */ (function () {
    function SparklineTooltip() {
        this.element = document.createElement('div');
        var tooltipRoot = document.body;
        tooltipRoot.appendChild(this.element);
    }
    SparklineTooltip.prototype.isVisible = function () {
        var element = this.element;
        if (element.classList) {
            return !element.classList.contains(SparklineTooltip.class + '-wrapper-hidden');
        }
        // IE11
        var classes = element.getAttribute('class');
        if (classes) {
            return classes.split(' ').indexOf(SparklineTooltip.class + '-wrapper-hidden') < 0;
        }
        return false;
    };
    SparklineTooltip.prototype.updateClass = function (visible) {
        var classList = [SparklineTooltip.class + '-wrapper'];
        if (visible !== true) {
            classList.push(SparklineTooltip.class + '-wrapper-hidden');
        }
        this.element.setAttribute('class', classList.join(' '));
    };
    SparklineTooltip.prototype.show = function (meta, html) {
        var _a, _b, _c, _d;
        this.toggle(false);
        var element = this.element;
        if (html !== undefined) {
            element.innerHTML = html;
        } else if (!element.innerHTML) {
            return;
        }
        var xOffset =
            (_b = (_a = meta.position) === null || _a === void 0 ? void 0 : _a.xOffset) !== null && _b !== void 0
                ? _b
                : 10;
        var yOffset =
            (_d = (_c = meta.position) === null || _c === void 0 ? void 0 : _c.yOffset) !== null && _d !== void 0
                ? _d
                : 0;
        var left = meta.pageX + xOffset;
        var top = meta.pageY + yOffset;
        var tooltipRect = element.getBoundingClientRect();
        var maxLeft = window.innerWidth - tooltipRect.width;
        if (meta.container) {
            var containerRect = meta.container.getBoundingClientRect();
            maxLeft = containerRect.left + (containerRect.width - tooltipRect.width);
        }
        if (left > maxLeft) {
            left = meta.pageX - element.clientWidth - xOffset;
        }
        if (typeof scrollX !== 'undefined') {
            left += scrollX;
        }
        if (typeof scrollY !== 'undefined') {
            top += scrollY;
        }
        element.style.left = Math.round(left) + 'px';
        element.style.top = Math.round(top) + 'px';
        this.toggle(true);
    };
    SparklineTooltip.prototype.toggle = function (visible) {
        this.updateClass(visible);
    };
    SparklineTooltip.prototype.destroy = function () {
        var parentNode = this.element.parentNode;
        if (parentNode) {
            parentNode.removeChild(this.element);
        }
    };
    SparklineTooltip.class = 'ag-sparkline-tooltip';
    return SparklineTooltip;
})();

function getMarker(shape) {
    switch (shape) {
        case 'circle':
            return Circle;
        case 'square':
            return Square;
        case 'diamond':
            return Diamond;
        default:
            return Circle;
    }
}

function getLineDash(lineCap, lineDash) {
    if (lineDash === void 0) {
        lineDash = 'solid';
    }
    var buttOrNull = {
        solid: [],
        dash: [4, 3],
        dot: [1, 3],
        dashDot: [4, 3, 1, 3],
        dashDotDot: [4, 3, 1, 3, 1, 3],
        shortDot: [1, 1],
        shortDash: [3, 1],
        shortDashDot: [3, 1, 1, 1],
        shortDashDotDot: [3, 1, 1, 1, 1, 1],
        longDash: [8, 3],
        longDashDot: [8, 3, 1, 3],
        longDashDotDot: [8, 3, 1, 3, 1, 3],
    };
    var roundOrSquare = {
        solid: [],
        dash: [3, 3],
        dot: [0, 3],
        dashDot: [3, 3, 0, 3],
        dashDotDot: [3, 3, 0, 3, 0, 3],
        shortDot: [0, 2],
        shortDash: [2, 2],
        shortDashDot: [2, 2, 0, 2],
        shortDashDotDot: [2, 2, 0, 2, 0, 2],
        longDash: [7, 3],
        longDashDot: [7, 3, 0, 3],
        longDashDotDot: [7, 3, 0, 3, 0, 3],
    };
    if (lineCap === 'round' || lineCap === 'square') {
        if (roundOrSquare[lineDash] == undefined) {
            console.warn("'" + lineDash + "' is not a valid 'lineDash' option.");
            return roundOrSquare.solid;
        }
        return roundOrSquare[lineDash];
    }
    if (buttOrNull[lineDash] == undefined) {
        console.warn("'" + lineDash + "' is not a valid 'lineDash' option.");
        return buttOrNull.solid;
    }
    return buttOrNull[lineDash];
}

var __extends$6 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var extent$2 = extent$4;
var BandScale$3 = BandScale$5;
var SparklineMarker$1 = /** @class */ (function () {
    function SparklineMarker() {
        this.enabled = true;
        this.shape = 'circle';
        this.size = 0;
        this.fill = 'rgb(124, 181, 236)';
        this.stroke = 'rgb(124, 181, 236)';
        this.strokeWidth = 1;
        this.formatter = undefined;
    }
    return SparklineMarker;
})();
var SparklineLine$1 = /** @class */ (function () {
    function SparklineLine() {
        this.stroke = 'rgb(124, 181, 236)';
        this.strokeWidth = 1;
    }
    return SparklineLine;
})();
var SparklineCrosshairs$1 = /** @class */ (function () {
    function SparklineCrosshairs() {
        this.xLine = {
            enabled: true,
            stroke: 'rgba(0,0,0, 0.54)',
            strokeWidth: 1,
            lineDash: 'solid',
            lineCap: undefined,
        };
        this.yLine = {
            enabled: false,
            stroke: 'rgba(0,0,0, 0.54)',
            strokeWidth: 1,
            lineDash: 'solid',
            lineCap: undefined,
        };
    }
    return SparklineCrosshairs;
})();
var AreaSparkline = /** @class */ (function (_super) {
    __extends$6(AreaSparkline, _super);
    function AreaSparkline() {
        var _this = _super.call(this) || this;
        _this.fill = 'rgba(124, 181, 236, 0.25)';
        _this.strokePath = new Path();
        _this.fillPath = new Path();
        _this.xCrosshairLine = new Line();
        _this.yCrosshairLine = new Line();
        _this.areaSparklineGroup = new Group();
        _this.xAxisLine = new Line();
        _this.markers = new Group();
        _this.markerSelection = Selection.select(_this.markers, function () {
            return _this.markerFactory();
        });
        _this.markerSelectionData = [];
        _this.marker = new SparklineMarker$1();
        _this.line = new SparklineLine$1();
        _this.crosshairs = new SparklineCrosshairs$1();
        _this.rootGroup.append(_this.areaSparklineGroup);
        _this.xAxisLine.zIndex = ZINDICIES.AXIS_LINE_ZINDEX;
        _this.fillPath.zIndex = ZINDICIES.SERIES_FILL_ZINDEX;
        _this.strokePath.zIndex = ZINDICIES.SERIES_STROKE_ZINDEX;
        _this.xCrosshairLine.zIndex = ZINDICIES.CROSSHAIR_ZINDEX;
        _this.yCrosshairLine.zIndex = ZINDICIES.CROSSHAIR_ZINDEX;
        _this.markers.zIndex = ZINDICIES.SERIES_MARKERS_ZINDEX;
        _this.areaSparklineGroup.append([
            _this.fillPath,
            _this.xAxisLine,
            _this.strokePath,
            _this.xCrosshairLine,
            _this.yCrosshairLine,
            _this.markers,
        ]);
        return _this;
    }
    AreaSparkline.prototype.markerFactory = function () {
        var shape = this.marker.shape;
        var MarkerShape = getMarker(shape);
        return new MarkerShape();
    };
    AreaSparkline.prototype.getNodeData = function () {
        return this.markerSelectionData;
    };
    AreaSparkline.prototype.update = function () {
        var data = this.generateNodeData();
        if (!data) {
            return;
        }
        var nodeData = data.nodeData,
            fillData = data.fillData,
            strokeData = data.strokeData;
        this.markerSelectionData = nodeData;
        this.updateSelection(nodeData);
        this.updateNodes();
        this.updateStroke(strokeData);
        this.updateFill(fillData);
    };
    AreaSparkline.prototype.updateYScaleDomain = function () {
        var _a = this,
            yData = _a.yData,
            yScale = _a.yScale;
        var yMinMax = extent$2(yData);
        var yMin = 0;
        var yMax = 1;
        if (yMinMax !== undefined) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        // if yMin is positive, set yMin to 0
        yMin = yMin < 0 ? yMin : 0;
        // if yMax is negative, set yMax to 0
        yMax = yMax < 0 ? 0 : yMax;
        yScale.domain = [yMin, yMax];
    };
    AreaSparkline.prototype.generateNodeData = function () {
        var _a = this,
            data = _a.data,
            yData = _a.yData,
            xData = _a.xData,
            xScale = _a.xScale,
            yScale = _a.yScale;
        if (!data) {
            return;
        }
        var continuous = !(xScale instanceof BandScale$3);
        var offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        var n = yData.length;
        var nodeData = [];
        var fillData = [];
        var strokeData = [];
        var firstValidX;
        var lastValidX;
        var previousX;
        var nextX;
        var yZero = yScale.convert(0);
        for (var i = 0; i < n; i++) {
            var yDatum = yData[i];
            var xDatum = xData[i];
            var x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            var y = yDatum === undefined ? NaN : yScale.convert(yDatum);
            // if this iteration is not the last, set nextX using the next value in the data array
            if (i + 1 < n) {
                nextX = xScale.convert(continuous ? xScale.toDomain(xData[i + 1]) : xData[i + 1]) + offsetX;
            }
            // set stroke data regardless of missing/ undefined values. Undefined values will be handled in the updateStroke() method
            strokeData.push({
                seriesDatum: { x: xDatum, y: yDatum },
                point: { x: x, y: y },
            });
            if (yDatum === undefined && previousX !== undefined) {
                // if yDatum is undefined and there is a valid previous data point, add a phantom point at yZero
                // if a next data point exists, add a phantom point at yZero at the next X
                fillData.push({ seriesDatum: undefined, point: { x: previousX, y: yZero } });
                if (nextX !== undefined) {
                    fillData.push({ seriesDatum: undefined, point: { x: nextX, y: yZero } });
                }
            } else if (yDatum !== undefined) {
                fillData.push({
                    seriesDatum: { x: xDatum, y: yDatum },
                    point: { x: x, y: y },
                });
                // set node data only if yDatum is not undefined. These values are used in the updateSelection() method to update markers
                nodeData.push({
                    seriesDatum: { x: xDatum, y: yDatum },
                    point: { x: x, y: y },
                });
                firstValidX = firstValidX !== undefined ? firstValidX : x;
                lastValidX = x;
            }
            previousX = x;
        }
        // phantom points for creating closed area
        fillData.push(
            { seriesDatum: undefined, point: { x: lastValidX, y: yZero } },
            { seriesDatum: undefined, point: { x: firstValidX, y: yZero } },
        );
        return { nodeData: nodeData, fillData: fillData, strokeData: strokeData };
    };
    AreaSparkline.prototype.updateAxisLine = function () {
        var _a = this,
            xScale = _a.xScale,
            yScale = _a.yScale,
            axis = _a.axis,
            xAxisLine = _a.xAxisLine;
        xAxisLine.x1 = xScale.range[0];
        xAxisLine.x2 = xScale.range[1];
        xAxisLine.y1 = xAxisLine.y2 = 0;
        xAxisLine.stroke = axis.stroke;
        xAxisLine.strokeWidth = axis.strokeWidth;
        var yZero = yScale.convert(0);
        xAxisLine.translationY = yZero;
    };
    AreaSparkline.prototype.updateSelection = function (selectionData) {
        this.markerSelection.update(selectionData);
    };
    AreaSparkline.prototype.updateNodes = function () {
        var _this = this;
        var _a = this,
            highlightedDatum = _a.highlightedDatum,
            highlightStyle = _a.highlightStyle,
            marker = _a.marker;
        var highlightSize = highlightStyle.size,
            highlightFill = highlightStyle.fill,
            highlightStroke = highlightStyle.stroke,
            highlightStrokeWidth = highlightStyle.strokeWidth;
        var markerFormatter = marker.formatter;
        this.markerSelection.each(function (node, datum, index) {
            var point = datum.point,
                seriesDatum = datum.seriesDatum;
            if (!point) {
                return;
            }
            var highlighted = datum === highlightedDatum;
            var markerFill = highlighted && highlightFill !== undefined ? highlightFill : marker.fill;
            var markerStroke = highlighted && highlightStroke !== undefined ? highlightStroke : marker.stroke;
            var markerStrokeWidth =
                highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : marker.strokeWidth;
            var markerSize = highlighted && highlightSize !== undefined ? highlightSize : marker.size;
            var markerFormat;
            if (markerFormatter) {
                var first = index === 0;
                var last = index === _this.markerSelectionData.length - 1;
                var min = seriesDatum.y === _this.min;
                var max = seriesDatum.y === _this.max;
                markerFormat = markerFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: markerFill,
                    stroke: markerStroke,
                    strokeWidth: markerStrokeWidth,
                    size: markerSize,
                    highlighted: highlighted,
                });
            }
            node.size = markerFormat && markerFormat.size != undefined ? markerFormat.size : markerSize;
            node.fill = markerFormat && markerFormat.fill != undefined ? markerFormat.fill : markerFill;
            node.stroke = markerFormat && markerFormat.stroke != undefined ? markerFormat.stroke : markerStroke;
            node.strokeWidth =
                markerFormat && markerFormat.strokeWidth != undefined ? markerFormat.strokeWidth : markerStrokeWidth;
            node.translationX = point.x;
            node.translationY = point.y;
            node.visible =
                markerFormat && markerFormat.enabled != undefined
                    ? markerFormat.enabled
                    : marker.enabled && node.size > 0;
        });
    };
    AreaSparkline.prototype.updateStroke = function (strokeData) {
        var _a = this,
            strokePath = _a.strokePath,
            yData = _a.yData,
            line = _a.line;
        if (yData.length < 2) {
            return;
        }
        var path = strokePath.path;
        var n = strokeData.length;
        var moveTo = true;
        path.clear();
        for (var i = 0; i < n; i++) {
            var _b = strokeData[i],
                point = _b.point,
                seriesDatum = _b.seriesDatum;
            var x = point.x;
            var y = point.y;
            if (seriesDatum.y == undefined) {
                moveTo = true;
            } else {
                if (moveTo) {
                    path.moveTo(x, y);
                    moveTo = false;
                } else {
                    path.lineTo(x, y);
                }
            }
        }
        strokePath.lineJoin = strokePath.lineCap = 'round';
        strokePath.fill = undefined;
        strokePath.stroke = line.stroke;
        strokePath.strokeWidth = line.strokeWidth;
    };
    AreaSparkline.prototype.updateFill = function (areaData) {
        var _a = this,
            fillPath = _a.fillPath,
            yData = _a.yData,
            fill = _a.fill;
        var path = fillPath.path;
        var n = areaData.length;
        path.clear();
        if (yData.length < 2) {
            return;
        }
        for (var i = 0; i < n; i++) {
            var point = areaData[i].point;
            var x = point.x;
            var y = point.y;
            if (i > 0) {
                path.lineTo(x, y);
            } else {
                path.moveTo(x, y);
            }
        }
        path.closePath();
        fillPath.lineJoin = 'round';
        fillPath.stroke = undefined;
        fillPath.fill = fill;
    };
    AreaSparkline.prototype.updateXCrosshairLine = function () {
        var _a;
        var _b = this,
            yScale = _b.yScale,
            xCrosshairLine = _b.xCrosshairLine,
            highlightedDatum = _b.highlightedDatum,
            xLine = _b.crosshairs.xLine;
        if (!xLine.enabled || highlightedDatum == undefined) {
            xCrosshairLine.strokeWidth = 0;
            return;
        }
        xCrosshairLine.y1 = yScale.range[0];
        xCrosshairLine.y2 = yScale.range[1];
        xCrosshairLine.x1 = xCrosshairLine.x2 = 0;
        xCrosshairLine.stroke = xLine.stroke;
        xCrosshairLine.strokeWidth = (_a = xLine.strokeWidth) !== null && _a !== void 0 ? _a : 1;
        xCrosshairLine.lineCap = xLine.lineCap === 'round' || xLine.lineCap === 'square' ? xLine.lineCap : undefined;
        var lineDash = xLine.lineDash;
        xCrosshairLine.lineDash = Array.isArray(lineDash)
            ? lineDash
            : getLineDash(xCrosshairLine.lineCap, xLine.lineDash);
        xCrosshairLine.translationX = highlightedDatum.point.x;
    };
    AreaSparkline.prototype.updateYCrosshairLine = function () {
        var _a;
        var _b = this,
            xScale = _b.xScale,
            yCrosshairLine = _b.yCrosshairLine,
            highlightedDatum = _b.highlightedDatum,
            yLine = _b.crosshairs.yLine;
        if (!yLine.enabled || highlightedDatum == undefined) {
            yCrosshairLine.strokeWidth = 0;
            return;
        }
        yCrosshairLine.x1 = xScale.range[0];
        yCrosshairLine.x2 = xScale.range[1];
        yCrosshairLine.y1 = yCrosshairLine.y2 = 0;
        yCrosshairLine.stroke = yLine.stroke;
        yCrosshairLine.strokeWidth = (_a = yLine.strokeWidth) !== null && _a !== void 0 ? _a : 1;
        yCrosshairLine.lineCap = yLine.lineCap === 'round' || yLine.lineCap === 'square' ? yLine.lineCap : undefined;
        var lineDash = yLine.lineDash;
        yCrosshairLine.lineDash = Array.isArray(lineDash)
            ? lineDash
            : getLineDash(yCrosshairLine.lineCap, yLine.lineDash);
        yCrosshairLine.translationY = highlightedDatum.point.y;
    };
    AreaSparkline.prototype.getTooltipHtml = function (datum) {
        var _a, _b;
        var dataType = this.dataType;
        var seriesDatum = datum.seriesDatum;
        var yValue = seriesDatum.y;
        var xValue = seriesDatum.x;
        var content = this.formatNumericDatum(yValue);
        var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
        var defaults = {
            content: content,
            title: title,
        };
        var tooltipRenderer =
            (_b = (_a = this.processedOptions) === null || _a === void 0 ? void 0 : _a.tooltip) === null ||
            _b === void 0
                ? void 0
                : _b.renderer;
        if (tooltipRenderer) {
            return toTooltipHtml(
                tooltipRenderer({
                    context: this.context,
                    datum: seriesDatum,
                    yValue: yValue,
                    xValue: xValue,
                }),
                defaults,
            );
        }
        return toTooltipHtml(defaults);
    };
    AreaSparkline.className = 'AreaSparkline';
    return AreaSparkline;
})(Sparkline);

var __extends$5 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var extent$1 = extent$4;
var BandScale$2 = BandScale$5;
var SparklineMarker = /** @class */ (function () {
    function SparklineMarker() {
        this.enabled = true;
        this.shape = 'circle';
        this.size = 0;
        this.fill = 'rgb(124, 181, 236)';
        this.stroke = 'rgb(124, 181, 236)';
        this.strokeWidth = 1;
        this.formatter = undefined;
    }
    return SparklineMarker;
})();
var SparklineLine = /** @class */ (function () {
    function SparklineLine() {
        this.stroke = 'rgb(124, 181, 236)';
        this.strokeWidth = 1;
    }
    return SparklineLine;
})();
var SparklineCrosshairs = /** @class */ (function () {
    function SparklineCrosshairs() {
        this.xLine = {
            enabled: true,
            stroke: 'rgba(0,0,0, 0.54)',
            strokeWidth: 1,
            lineDash: 'solid',
            lineCap: undefined,
        };
        this.yLine = {
            enabled: false,
            stroke: 'rgba(0,0,0, 0.54)',
            strokeWidth: 1,
            lineDash: 'solid',
            lineCap: undefined,
        };
    }
    return SparklineCrosshairs;
})();
var LineSparkline = /** @class */ (function (_super) {
    __extends$5(LineSparkline, _super);
    function LineSparkline() {
        var _this = _super.call(this) || this;
        _this.linePath = new Path();
        _this.xCrosshairLine = new Line();
        _this.yCrosshairLine = new Line();
        _this.lineSparklineGroup = new Group();
        _this.markers = new Group();
        _this.markerSelection = Selection.select(_this.markers, function () {
            return _this.markerFactory();
        });
        _this.markerSelectionData = [];
        _this.marker = new SparklineMarker();
        _this.line = new SparklineLine();
        _this.crosshairs = new SparklineCrosshairs();
        _this.rootGroup.append(_this.lineSparklineGroup);
        _this.linePath.zIndex = ZINDICIES.SERIES_STROKE_ZINDEX;
        _this.xCrosshairLine.zIndex = ZINDICIES.CROSSHAIR_ZINDEX;
        _this.yCrosshairLine.zIndex = ZINDICIES.CROSSHAIR_ZINDEX;
        _this.markers.zIndex = ZINDICIES.SERIES_MARKERS_ZINDEX;
        _this.lineSparklineGroup.append([_this.linePath, _this.xCrosshairLine, _this.yCrosshairLine, _this.markers]);
        return _this;
    }
    LineSparkline.prototype.getNodeData = function () {
        return this.markerSelectionData;
    };
    LineSparkline.prototype.markerFactory = function () {
        var shape = this.marker.shape;
        var MarkerShape = getMarker(shape);
        return new MarkerShape();
    };
    /**
     * If marker shape is changed, this method should be called to remove the previous marker nodes selection.
     */
    LineSparkline.prototype.onMarkerShapeChange = function () {
        this.markerSelection = this.markerSelection.clear();
        this.scheduleLayout();
    };
    LineSparkline.prototype.update = function () {
        var nodeData = this.generateNodeData();
        if (!nodeData) {
            return;
        }
        this.markerSelectionData = nodeData;
        this.updateSelection(nodeData);
        this.updateNodes();
        this.updateLine();
    };
    LineSparkline.prototype.updateYScaleDomain = function () {
        var _a = this,
            yData = _a.yData,
            yScale = _a.yScale;
        var yMinMax = extent$1(yData);
        var yMin = 0;
        var yMax = 1;
        if (yMinMax !== undefined) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        if (yMin === yMax) {
            // if all values in the data are the same, yMin and yMax will be equal, need to adjust the domain with some padding
            var padding = Math.abs(yMin * 0.01);
            yMin -= padding;
            yMax += padding;
        }
        yScale.domain = [yMin, yMax];
    };
    LineSparkline.prototype.generateNodeData = function () {
        var _a = this,
            data = _a.data,
            yData = _a.yData,
            xData = _a.xData,
            xScale = _a.xScale,
            yScale = _a.yScale;
        if (!data) {
            return;
        }
        var continuous = !(xScale instanceof BandScale$2);
        var offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        var nodeData = [];
        for (var i = 0; i < yData.length; i++) {
            var yDatum = yData[i];
            var xDatum = xData[i];
            if (yDatum == undefined) {
                continue;
            }
            var x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            var y = yDatum === undefined ? NaN : yScale.convert(yDatum);
            nodeData.push({
                seriesDatum: { x: xDatum, y: yDatum },
                point: { x: x, y: y },
            });
        }
        return nodeData;
    };
    LineSparkline.prototype.updateSelection = function (selectionData) {
        this.markerSelection.update(selectionData);
    };
    LineSparkline.prototype.updateNodes = function () {
        var _this = this;
        var _a = this,
            highlightedDatum = _a.highlightedDatum,
            highlightStyle = _a.highlightStyle,
            marker = _a.marker;
        var highlightSize = highlightStyle.size,
            highlightFill = highlightStyle.fill,
            highlightStroke = highlightStyle.stroke,
            highlightStrokeWidth = highlightStyle.strokeWidth;
        var markerFormatter = marker.formatter;
        this.markerSelection.each(function (node, datum, index) {
            var highlighted = datum === highlightedDatum;
            var markerFill = highlighted && highlightFill !== undefined ? highlightFill : marker.fill;
            var markerStroke = highlighted && highlightStroke !== undefined ? highlightStroke : marker.stroke;
            var markerStrokeWidth =
                highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : marker.strokeWidth;
            var markerSize = highlighted && highlightSize !== undefined ? highlightSize : marker.size;
            var markerFormat;
            var seriesDatum = datum.seriesDatum,
                point = datum.point;
            if (markerFormatter) {
                var first = index === 0;
                var last = index === _this.markerSelectionData.length - 1;
                var min = seriesDatum.y === _this.min;
                var max = seriesDatum.y === _this.max;
                markerFormat = markerFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: markerFill,
                    stroke: markerStroke,
                    strokeWidth: markerStrokeWidth,
                    size: markerSize,
                    highlighted: highlighted,
                });
            }
            node.size = markerFormat && markerFormat.size != undefined ? markerFormat.size : markerSize;
            node.fill = markerFormat && markerFormat.fill != undefined ? markerFormat.fill : markerFill;
            node.stroke = markerFormat && markerFormat.stroke != undefined ? markerFormat.stroke : markerStroke;
            node.strokeWidth =
                markerFormat && markerFormat.strokeWidth != undefined ? markerFormat.strokeWidth : markerStrokeWidth;
            node.translationX = point.x;
            node.translationY = point.y;
            node.visible =
                markerFormat && markerFormat.enabled != undefined
                    ? markerFormat.enabled
                    : marker.enabled && node.size > 0;
        });
    };
    LineSparkline.prototype.updateLine = function () {
        var _a = this,
            linePath = _a.linePath,
            yData = _a.yData,
            xData = _a.xData,
            xScale = _a.xScale,
            yScale = _a.yScale,
            line = _a.line;
        if (yData.length < 2) {
            return;
        }
        var continuous = !(xScale instanceof BandScale$2);
        var path = linePath.path;
        var n = yData.length;
        var offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        var moveTo = true;
        path.clear();
        for (var i = 0; i < n; i++) {
            var xDatum = xData[i];
            var yDatum = yData[i];
            var x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            var y = yDatum === undefined ? NaN : yScale.convert(yDatum);
            if (yDatum == undefined) {
                moveTo = true;
            } else {
                if (moveTo) {
                    path.moveTo(x, y);
                    moveTo = false;
                } else {
                    path.lineTo(x, y);
                }
            }
        }
        linePath.fill = undefined;
        linePath.stroke = line.stroke;
        linePath.strokeWidth = line.strokeWidth;
    };
    LineSparkline.prototype.updateXCrosshairLine = function () {
        var _a;
        var _b = this,
            yScale = _b.yScale,
            xCrosshairLine = _b.xCrosshairLine,
            highlightedDatum = _b.highlightedDatum,
            xLine = _b.crosshairs.xLine;
        if (!xLine.enabled || highlightedDatum == undefined) {
            xCrosshairLine.strokeWidth = 0;
            return;
        }
        xCrosshairLine.y1 = yScale.range[0];
        xCrosshairLine.y2 = yScale.range[1];
        xCrosshairLine.x1 = xCrosshairLine.x2 = 0;
        xCrosshairLine.stroke = xLine.stroke;
        xCrosshairLine.strokeWidth = (_a = xLine.strokeWidth) !== null && _a !== void 0 ? _a : 1;
        xCrosshairLine.lineCap = xLine.lineCap === 'round' || xLine.lineCap === 'square' ? xLine.lineCap : undefined;
        var lineDash = xLine.lineDash;
        xCrosshairLine.lineDash = Array.isArray(lineDash)
            ? lineDash
            : getLineDash(xCrosshairLine.lineCap, xLine.lineDash);
        xCrosshairLine.translationX = highlightedDatum.point.x;
    };
    LineSparkline.prototype.updateYCrosshairLine = function () {
        var _a;
        var _b = this,
            xScale = _b.xScale,
            yCrosshairLine = _b.yCrosshairLine,
            highlightedDatum = _b.highlightedDatum,
            yLine = _b.crosshairs.yLine;
        if (!yLine.enabled || highlightedDatum == undefined) {
            yCrosshairLine.strokeWidth = 0;
            return;
        }
        yCrosshairLine.x1 = xScale.range[0];
        yCrosshairLine.x2 = xScale.range[1];
        yCrosshairLine.y1 = yCrosshairLine.y2 = 0;
        yCrosshairLine.stroke = yLine.stroke;
        yCrosshairLine.strokeWidth = (_a = yLine.strokeWidth) !== null && _a !== void 0 ? _a : 1;
        yCrosshairLine.lineCap = yLine.lineCap === 'round' || yLine.lineCap === 'square' ? yLine.lineCap : undefined;
        var lineDash = yLine.lineDash;
        yCrosshairLine.lineDash = Array.isArray(lineDash)
            ? lineDash
            : getLineDash(yCrosshairLine.lineCap, yLine.lineDash);
        yCrosshairLine.translationY = highlightedDatum.point.y;
    };
    LineSparkline.prototype.getTooltipHtml = function (datum) {
        var _a, _b;
        var dataType = this.dataType;
        var seriesDatum = datum.seriesDatum;
        var yValue = seriesDatum.y;
        var xValue = seriesDatum.x;
        var content = this.formatNumericDatum(yValue);
        var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
        var defaults = {
            content: content,
            title: title,
        };
        var tooltipRenderer =
            (_b = (_a = this.processedOptions) === null || _a === void 0 ? void 0 : _a.tooltip) === null ||
            _b === void 0
                ? void 0
                : _b.renderer;
        if (tooltipRenderer) {
            return toTooltipHtml(
                tooltipRenderer({
                    context: this.context,
                    datum: seriesDatum,
                    yValue: yValue,
                    xValue: xValue,
                }),
                defaults,
            );
        }
        return toTooltipHtml(defaults);
    };
    LineSparkline.className = 'LineSparkline';
    return LineSparkline;
})(Sparkline);

var Label = /** @class */ (function () {
    function Label() {
        this.enabled = true;
        this.fontSize = 8;
        this.fontFamily = 'Verdana, sans-serif';
        this.fontStyle = undefined;
        this.fontWeight = undefined;
        this.color = 'rgba(70, 70, 70, 1)';
    }
    return Label;
})();

var __extends$4 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var extent = extent$4;
var BarColumnNodeTag;
(function (BarColumnNodeTag) {
    BarColumnNodeTag[(BarColumnNodeTag['Rect'] = 0)] = 'Rect';
    BarColumnNodeTag[(BarColumnNodeTag['Label'] = 1)] = 'Label';
})(BarColumnNodeTag || (BarColumnNodeTag = {}));
var BarColumnLabelPlacement;
(function (BarColumnLabelPlacement) {
    BarColumnLabelPlacement['InsideBase'] = 'insideBase';
    BarColumnLabelPlacement['InsideEnd'] = 'insideEnd';
    BarColumnLabelPlacement['Center'] = 'center';
    BarColumnLabelPlacement['OutsideEnd'] = 'outsideEnd';
})(BarColumnLabelPlacement || (BarColumnLabelPlacement = {}));
var BarColumnLabel = /** @class */ (function (_super) {
    __extends$4(BarColumnLabel, _super);
    function BarColumnLabel() {
        var _this = (_super !== null && _super.apply(this, arguments)) || this;
        _this.formatter = undefined;
        _this.placement = BarColumnLabelPlacement.InsideEnd;
        return _this;
    }
    return BarColumnLabel;
})(Label);
var BarColumnSparkline = /** @class */ (function (_super) {
    __extends$4(BarColumnSparkline, _super);
    function BarColumnSparkline() {
        var _this = _super.call(this) || this;
        _this.fill = 'rgb(124, 181, 236)';
        _this.stroke = 'silver';
        _this.strokeWidth = 0;
        _this.paddingInner = 0.1;
        _this.paddingOuter = 0.2;
        _this.valueAxisDomain = undefined;
        _this.formatter = undefined;
        _this.axisLine = new Line();
        _this.bandWidth = 0;
        _this.sparklineGroup = new Group();
        _this.rectGroup = new Group();
        _this.labelGroup = new Group();
        _this.rectSelection = Selection.select(_this.rectGroup, Rect);
        _this.labelSelection = Selection.select(_this.labelGroup, Text);
        _this.nodeSelectionData = [];
        _this.label = new BarColumnLabel();
        _this.rootGroup.append(_this.sparklineGroup);
        _this.rectGroup.zIndex = ZINDICIES.SERIES_FILL_ZINDEX;
        _this.axisLine.zIndex = ZINDICIES.AXIS_LINE_ZINDEX;
        _this.labelGroup.zIndex = ZINDICIES.SERIES_LABEL_ZINDEX;
        _this.sparklineGroup.append([_this.rectGroup, _this.axisLine, _this.labelGroup]);
        _this.axisLine.lineCap = 'round';
        _this.label.enabled = false;
        return _this;
    }
    BarColumnSparkline.prototype.getNodeData = function () {
        return this.nodeSelectionData;
    };
    BarColumnSparkline.prototype.update = function () {
        this.updateSelections();
        this.updateNodes();
    };
    BarColumnSparkline.prototype.updateSelections = function () {
        var nodeData = this.generateNodeData();
        if (!nodeData) {
            return;
        }
        this.nodeSelectionData = nodeData;
        this.updateRectSelection(nodeData);
        this.updateLabelSelection(nodeData);
    };
    BarColumnSparkline.prototype.updateNodes = function () {
        this.updateRectNodes();
        this.updateLabelNodes();
    };
    BarColumnSparkline.prototype.calculateStep = function (range) {
        var _a;
        var _b = this,
            xScale = _b.xScale,
            paddingInner = _b.paddingInner,
            paddingOuter = _b.paddingOuter,
            smallestInterval = _b.smallestInterval;
        // calculate step
        var domainLength = xScale.domain[1] - xScale.domain[0];
        var intervals =
            domainLength /
                ((_a = smallestInterval === null || smallestInterval === void 0 ? void 0 : smallestInterval.x) !==
                    null && _a !== void 0
                    ? _a
                    : 1) +
            1;
        // The number of intervals/bands is used to determine the width of individual bands by dividing the available range.
        // Allow a maximum of 50 bands to ensure the step (width of individual bands + padding) does not fall below a certain number of pixels.
        // If the number of intervals exceeds 50, calculate the step for 50 bands within the given range.
        // This means there could be some overlap of the bands in the sparkline.
        var maxBands = 50;
        var bands = Math.min(intervals, maxBands);
        var gaps = bands - 1; // number of gaps (padding between bands)
        var step = range / Math.max(1, 2 * paddingOuter + gaps * paddingInner + bands); // step width is a combination of band width and gap width
        return step;
    };
    BarColumnSparkline.prototype.updateYScaleDomain = function () {
        var _a = this,
            yScale = _a.yScale,
            yData = _a.yData,
            valueAxisDomain = _a.valueAxisDomain;
        var yMinMax = extent(yData);
        var yMin = 0;
        var yMax = 1;
        if (yMinMax !== undefined) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        // if yMin is positive, set yMin to 0
        yMin = yMin < 0 ? yMin : 0;
        // if yMax is negative, set yMax to 0
        yMax = yMax < 0 ? 0 : yMax;
        if (valueAxisDomain) {
            if (valueAxisDomain[1] < yMax) {
                valueAxisDomain[1] = yMax;
            }
            if (valueAxisDomain[0] > yMin) {
                valueAxisDomain[0] = yMin;
            }
        }
        yScale.domain = valueAxisDomain ? valueAxisDomain : [yMin, yMax];
    };
    BarColumnSparkline.prototype.updateRectSelection = function (selectionData) {
        this.rectSelection.update(selectionData);
    };
    BarColumnSparkline.prototype.updateRectNodes = function () {
        var _this = this;
        var _a = this,
            highlightedDatum = _a.highlightedDatum,
            nodeFormatter = _a.formatter,
            fill = _a.fill,
            stroke = _a.stroke,
            strokeWidth = _a.strokeWidth;
        var _b = this.highlightStyle,
            highlightFill = _b.fill,
            highlightStroke = _b.stroke,
            highlightStrokeWidth = _b.strokeWidth;
        this.rectSelection.each(function (node, datum, index) {
            var highlighted = datum === highlightedDatum;
            var nodeFill = highlighted && highlightFill !== undefined ? highlightFill : fill;
            var nodeStroke = highlighted && highlightStroke !== undefined ? highlightStroke : stroke;
            var nodeStrokeWidth =
                highlighted && highlightStrokeWidth !== undefined ? highlightStrokeWidth : strokeWidth;
            var nodeFormat;
            var x = datum.x,
                y = datum.y,
                width = datum.width,
                height = datum.height,
                seriesDatum = datum.seriesDatum;
            if (nodeFormatter) {
                var first = index === 0;
                var last = index === _this.nodeSelectionData.length - 1;
                var min = seriesDatum.y === _this.min;
                var max = seriesDatum.y === _this.max;
                nodeFormat = nodeFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    width: width,
                    height: height,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: nodeFill,
                    stroke: nodeStroke,
                    strokeWidth: nodeStrokeWidth,
                    highlighted: highlighted,
                });
            }
            node.fill = (nodeFormat && nodeFormat.fill) || nodeFill;
            node.stroke = (nodeFormat && nodeFormat.stroke) || nodeStroke;
            node.strokeWidth = (nodeFormat && nodeFormat.strokeWidth) || nodeStrokeWidth;
            node.x = node.y = 0;
            node.width = width;
            node.height = height;
            node.visible = node.height > 0;
            node.translationX = x;
            node.translationY = y;
            // shifts bars upwards?
            // node.crisp = true;
        });
    };
    BarColumnSparkline.prototype.updateLabelSelection = function (selectionData) {
        this.labelSelection.update(selectionData, function (text) {
            text.tag = BarColumnNodeTag.Label;
            text.pointerEvents = PointerEvents.None;
        });
    };
    BarColumnSparkline.prototype.updateLabelNodes = function () {
        var _a = this.label,
            labelEnabled = _a.enabled,
            fontStyle = _a.fontStyle,
            fontWeight = _a.fontWeight,
            fontSize = _a.fontSize,
            fontFamily = _a.fontFamily,
            color = _a.color;
        this.labelSelection.each(function (text, datum) {
            var label = datum.label;
            if (label && labelEnabled) {
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.textAlign = label.textAlign;
                text.textBaseline = label.textBaseline;
                text.text = label.text;
                text.x = label.x;
                text.y = label.y;
                text.fill = color;
                text.visible = true;
            } else {
                text.visible = false;
            }
        });
    };
    BarColumnSparkline.prototype.getTooltipHtml = function (datum) {
        var _a, _b;
        var dataType = this.dataType;
        var seriesDatum = datum.seriesDatum;
        var yValue = seriesDatum.y;
        var xValue = seriesDatum.x;
        var content = this.formatNumericDatum(yValue);
        var title = dataType === 'array' || dataType === 'object' ? this.formatDatum(xValue) : undefined;
        var defaults = {
            content: content,
            title: title,
        };
        var tooltipRenderer =
            (_b = (_a = this.processedOptions) === null || _a === void 0 ? void 0 : _a.tooltip) === null ||
            _b === void 0
                ? void 0
                : _b.renderer;
        if (tooltipRenderer) {
            return toTooltipHtml(
                tooltipRenderer({
                    context: this.context,
                    datum: seriesDatum,
                    yValue: yValue,
                    xValue: xValue,
                }),
                defaults,
            );
        }
        return toTooltipHtml(defaults);
    };
    BarColumnSparkline.prototype.formatLabelValue = function (value) {
        return value % 1 !== 0 ? value.toFixed(1) : value.toFixed(0);
    };
    return BarColumnSparkline;
})(Sparkline);

var __extends$3 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var isNumber$2 = isNumber$4;
var BandScale$1 = BandScale$5;
var BarSparkline = /** @class */ (function (_super) {
    __extends$3(BarSparkline, _super);
    function BarSparkline() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    BarSparkline.prototype.updateYScaleRange = function () {
        var _a = this,
            seriesRect = _a.seriesRect,
            yScale = _a.yScale;
        yScale.range = [0, seriesRect.width];
    };
    BarSparkline.prototype.updateXScaleRange = function () {
        var _a = this,
            xScale = _a.xScale,
            seriesRect = _a.seriesRect,
            paddingOuter = _a.paddingOuter,
            paddingInner = _a.paddingInner;
        if (xScale instanceof BandScale$1) {
            xScale.range = [0, seriesRect.height];
            xScale.paddingInner = paddingInner;
            xScale.paddingOuter = paddingOuter;
        } else {
            // last node will be clipped if the scale is not a band scale
            // subtract last band width from the range so that the last band is not clipped
            var step = this.calculateStep(seriesRect.height);
            // PaddingOuter and paddingInner are fractions of the step with values between 0 and 1
            var padding = step * paddingOuter; // left and right outer padding
            this.bandWidth = step * (1 - paddingInner);
            xScale.range = [padding, seriesRect.height - padding - this.bandWidth];
        }
    };
    BarSparkline.prototype.updateAxisLine = function () {
        var _a = this,
            yScale = _a.yScale,
            axis = _a.axis,
            axisLine = _a.axisLine,
            seriesRect = _a.seriesRect;
        var strokeWidth = axis.strokeWidth;
        axisLine.x1 = 0;
        axisLine.x2 = 0;
        axisLine.y1 = 0;
        axisLine.y2 = seriesRect.height;
        axisLine.stroke = axis.stroke;
        axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
        var yZero = yScale.convert(0);
        axisLine.translationX = yZero;
    };
    BarSparkline.prototype.generateNodeData = function () {
        var _a = this,
            data = _a.data,
            yData = _a.yData,
            xData = _a.xData,
            xScale = _a.xScale,
            yScale = _a.yScale,
            fill = _a.fill,
            stroke = _a.stroke,
            strokeWidth = _a.strokeWidth,
            label = _a.label;
        if (!data) {
            return;
        }
        var labelFontStyle = label.fontStyle,
            labelFontWeight = label.fontWeight,
            labelFontSize = label.fontSize,
            labelFontFamily = label.fontFamily,
            labelColor = label.color,
            labelFormatter = label.formatter,
            labelPlacement = label.placement;
        var nodeData = [];
        var yZero = yScale.convert(0);
        var continuous = !(xScale instanceof BandScale$1);
        for (var i = 0, n = yData.length; i < n; i++) {
            var yDatum = yData[i];
            var xDatum = xData[i];
            var invalidDatum = yDatum === undefined;
            if (invalidDatum) {
                yDatum = 0;
            }
            var y = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum);
            var x = Math.min(yDatum === undefined ? NaN : yScale.convert(yDatum), yZero);
            var bottom = Math.max(yDatum === undefined ? NaN : yScale.convert(yDatum), yZero);
            // if the scale is a band scale, the width of the rects will be the bandwidth, otherwise the width of the rects will be the range / number of items in the data
            var height = !continuous ? xScale.bandwidth : this.bandWidth;
            var width = bottom - x;
            var midPoint = {
                x: yZero,
                y: y,
            };
            var labelText = void 0;
            if (labelFormatter) {
                labelText = labelFormatter({ value: yDatum });
            } else {
                labelText = yDatum !== undefined && isNumber$2(yDatum) ? this.formatLabelValue(yDatum) : '';
            }
            var labelY = y + height / 2;
            var labelX = void 0;
            var labelTextBaseline = 'middle';
            var labelTextAlign = void 0;
            var isPositiveY = yDatum !== undefined && yDatum >= 0;
            var labelPadding = 4;
            if (labelPlacement === BarColumnLabelPlacement.Center) {
                labelX = x + width / 2;
                labelTextAlign = 'center';
            } else if (labelPlacement === BarColumnLabelPlacement.OutsideEnd) {
                labelX = x + (isPositiveY ? width + labelPadding : -labelPadding);
                labelTextAlign = isPositiveY ? 'start' : 'end';
            } else if (labelPlacement === BarColumnLabelPlacement.InsideEnd) {
                labelX = x + (isPositiveY ? width - labelPadding : labelPadding);
                labelTextAlign = isPositiveY ? 'end' : 'start';
                var textSize = HdpiCanvas.getTextSize(labelText, labelFontFamily);
                var textWidth = textSize.width || 20;
                var positiveBoundary = yZero + textWidth;
                var negativeBoundary = yZero - textWidth;
                var exceedsBoundaries =
                    (isPositiveY && labelX < positiveBoundary) || (!isPositiveY && labelX > negativeBoundary);
                if (exceedsBoundaries) {
                    // if labelX exceeds the boundary, labels should be positioned at `insideBase`.
                    labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
                    labelTextAlign = isPositiveY ? 'start' : 'end';
                }
            } else {
                // if labelPlacement === BarColumnLabelPlacement.InsideBase
                labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
                labelTextAlign = isPositiveY ? 'start' : 'end';
            }
            nodeData.push({
                x: x,
                y: y,
                width: width,
                height: height,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                seriesDatum: { x: xDatum, y: invalidDatum ? undefined : yDatum },
                point: midPoint,
                label: {
                    x: labelX,
                    y: labelY,
                    text: labelText,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    textAlign: labelTextAlign,
                    textBaseline: labelTextBaseline,
                    fill: labelColor,
                },
            });
        }
        return nodeData;
    };
    BarSparkline.prototype.getDistance = function (p1, p2) {
        return Math.abs(p1.y - p2.y);
    };
    BarSparkline.className = 'BarSparkline';
    return BarSparkline;
})(BarColumnSparkline);

var __extends$2 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var isNumber$1 = isNumber$4;
var BandScale = BandScale$5;
var ColumnSparkline = /** @class */ (function (_super) {
    __extends$2(ColumnSparkline, _super);
    function ColumnSparkline() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    ColumnSparkline.prototype.updateYScaleRange = function () {
        var _a = this,
            seriesRect = _a.seriesRect,
            yScale = _a.yScale;
        yScale.range = [seriesRect.height, 0];
    };
    ColumnSparkline.prototype.updateXScaleRange = function () {
        var _a = this,
            xScale = _a.xScale,
            seriesRect = _a.seriesRect,
            paddingOuter = _a.paddingOuter,
            paddingInner = _a.paddingInner;
        if (xScale instanceof BandScale) {
            xScale.range = [0, seriesRect.width];
            xScale.paddingInner = paddingInner;
            xScale.paddingOuter = paddingOuter;
        } else {
            // last node will be clipped if the scale is not a band scale
            // subtract last band width from the range so that the last band is not clipped
            var step = this.calculateStep(seriesRect.width);
            // PaddingOuter and paddingInner are fractions of the step with values between 0 and 1
            var padding = step * paddingOuter; // left and right outer padding
            this.bandWidth = step * (1 - paddingInner);
            xScale.range = [padding, seriesRect.width - padding - this.bandWidth];
        }
    };
    ColumnSparkline.prototype.updateAxisLine = function () {
        var _a = this,
            yScale = _a.yScale,
            axis = _a.axis,
            axisLine = _a.axisLine,
            seriesRect = _a.seriesRect;
        var strokeWidth = axis.strokeWidth;
        axisLine.x1 = 0;
        axisLine.x2 = seriesRect.width;
        axisLine.y1 = 0;
        axisLine.y2 = 0;
        axisLine.stroke = axis.stroke;
        axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
        var yZero = yScale.convert(0);
        axisLine.translationY = yZero;
    };
    ColumnSparkline.prototype.generateNodeData = function () {
        var _a = this,
            data = _a.data,
            yData = _a.yData,
            xData = _a.xData,
            xScale = _a.xScale,
            yScale = _a.yScale,
            fill = _a.fill,
            stroke = _a.stroke,
            strokeWidth = _a.strokeWidth,
            label = _a.label;
        if (!data) {
            return;
        }
        var labelFontStyle = label.fontStyle,
            labelFontWeight = label.fontWeight,
            labelFontSize = label.fontSize,
            labelFontFamily = label.fontFamily,
            labelColor = label.color,
            labelFormatter = label.formatter,
            labelPlacement = label.placement;
        var nodeData = [];
        var yZero = yScale.convert(0);
        var continuous = !(xScale instanceof BandScale);
        for (var i = 0, n = yData.length; i < n; i++) {
            var yDatum = yData[i];
            var xDatum = xData[i];
            var invalidDatum = yDatum === undefined;
            if (invalidDatum) {
                yDatum = 0;
            }
            var y = Math.min(yDatum === undefined ? NaN : yScale.convert(yDatum), yZero);
            var x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum);
            var bottom = Math.max(yDatum === undefined ? NaN : yScale.convert(yDatum), yZero);
            // if the scale is a band scale, the width of the rects will be the bandwidth, otherwise the width of the rects will be the range / number of items in the data
            var width = !continuous ? xScale.bandwidth : this.bandWidth;
            var height = bottom - y;
            var midPoint = {
                x: x + width / 2,
                y: yZero,
            };
            var labelText = void 0;
            if (labelFormatter) {
                labelText = labelFormatter({ value: yDatum });
            } else {
                labelText = yDatum !== undefined && isNumber$1(yDatum) ? this.formatLabelValue(yDatum) : '';
            }
            var labelX = x + width / 2;
            var labelY = void 0;
            var labelTextAlign = 'center';
            var labelTextBaseline = void 0;
            var isPositiveY = yDatum !== undefined && yDatum >= 0;
            var labelPadding = 2;
            if (labelPlacement === BarColumnLabelPlacement.Center) {
                labelY = y + height / 2;
                labelTextBaseline = 'middle';
            } else if (labelPlacement === BarColumnLabelPlacement.OutsideEnd) {
                labelY = y + (isPositiveY ? -labelPadding : height + labelPadding);
                labelTextBaseline = isPositiveY ? 'bottom' : 'top';
            } else if (labelPlacement === BarColumnLabelPlacement.InsideEnd) {
                labelY = y + (isPositiveY ? labelPadding : height - labelPadding);
                labelTextBaseline = isPositiveY ? 'top' : 'bottom';
                var textSize = HdpiCanvas.getTextSize(labelText, labelFontFamily);
                var textHeight = textSize.height || 10;
                var positiveBoundary = yZero - textHeight;
                var negativeBoundary = yZero + textHeight;
                var exceedsBoundaries =
                    (isPositiveY && labelY > positiveBoundary) || (!isPositiveY && labelY < negativeBoundary);
                if (exceedsBoundaries) {
                    // if labelY exceeds the y boundary, labels should be positioned at the insideBase
                    labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
                    labelTextBaseline = isPositiveY ? 'bottom' : 'top';
                }
            } else {
                // if labelPlacement === BarColumnLabelPlacement.InsideBase
                labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
                labelTextBaseline = isPositiveY ? 'bottom' : 'top';
            }
            nodeData.push({
                x: x,
                y: y,
                width: width,
                height: height,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                seriesDatum: { x: xDatum, y: invalidDatum ? undefined : yDatum },
                point: midPoint,
                label: {
                    x: labelX,
                    y: labelY,
                    text: labelText,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    textAlign: labelTextAlign,
                    textBaseline: labelTextBaseline,
                    fill: labelColor,
                },
            });
        }
        return nodeData;
    };
    ColumnSparkline.className = 'ColumnSparkline';
    return ColumnSparkline;
})(BarColumnSparkline);

var isNumber = isNumber$4;
var AgSparkline = /** @class */ (function () {
    function AgSparkline() {}
    AgSparkline.create = function (options, tooltip) {
        // avoid mutating user provided options
        options = jsonMerge([options]);
        var sparkline = getSparklineInstance(options.type);
        if (tooltip) {
            sparkline.tooltip = tooltip;
        }
        initSparkline(sparkline, options);
        initSparklineByType(sparkline, options);
        if (options.data) {
            sparkline.data = options.data;
        }
        sparkline.processedOptions = options;
        return sparkline;
    };
    return AgSparkline;
})();
function getSparklineInstance(type) {
    if (type === void 0) {
        type = 'line';
    }
    switch (type) {
        case 'column':
            return new ColumnSparkline();
        case 'bar':
            return new BarSparkline();
        case 'area':
            return new AreaSparkline();
        case 'line':
        default:
            return new LineSparkline();
    }
}
function initSparklineByType(sparkline, options) {
    switch (options.type) {
        case 'bar':
            initBarColumnSparkline(sparkline, options);
            break;
        case 'column':
            initBarColumnSparkline(sparkline, options);
            break;
        case 'area':
            initAreaSparkline(sparkline, options);
            break;
        case 'line':
        default:
            initLineSparkline(sparkline, options);
            break;
    }
}
function initSparkline(sparkline, options) {
    setValueIfPropertyExists(sparkline, 'context', options.context, options);
    setValueIfPropertyExists(sparkline, 'width', options.width, options);
    setValueIfPropertyExists(sparkline, 'height', options.height, options);
    setValueIfPropertyExists(sparkline, 'container', options.container, options);
    setValueIfPropertyExists(sparkline, 'xKey', options.xKey, options);
    setValueIfPropertyExists(sparkline, 'yKey', options.yKey, options);
    if (options.padding) {
        initPaddingOptions(sparkline.padding, options.padding);
    }
    if (options.axis) {
        initAxisOptions(sparkline.axis, options.axis);
    }
    if (options.highlightStyle) {
        initHighlightStyleOptions(sparkline.highlightStyle, options.highlightStyle);
    }
}
function initLineSparkline(sparkline, options) {
    if (options.marker) {
        initMarkerOptions(sparkline.marker, options.marker);
    }
    if (options.line) {
        initLineOptions(sparkline.line, options.line);
    }
    if (options.crosshairs) {
        initCrosshairsOptions(sparkline.crosshairs, options.crosshairs);
    }
}
function initAreaSparkline(sparkline, options) {
    setValueIfPropertyExists(sparkline, 'fill', options.fill, options);
    if (options.marker) {
        initMarkerOptions(sparkline.marker, options.marker);
    }
    if (options.line) {
        initLineOptions(sparkline.line, options.line);
    }
    if (options.crosshairs) {
        initCrosshairsOptions(sparkline.crosshairs, options.crosshairs);
    }
}
function initBarColumnSparkline(sparkline, options) {
    setValueIfPropertyExists(sparkline, 'valueAxisDomain', options.valueAxisDomain, options);
    setValueIfPropertyExists(sparkline, 'fill', options.fill, options);
    setValueIfPropertyExists(sparkline, 'stroke', options.stroke, options);
    setValueIfPropertyExists(sparkline, 'strokeWidth', options.strokeWidth, options);
    setValueIfPropertyExists(sparkline, 'paddingInner', options.paddingInner, options);
    setValueIfPropertyExists(sparkline, 'paddingOuter', options.paddingOuter, options);
    setValueIfPropertyExists(sparkline, 'formatter', options.formatter, options);
    if (options.label) {
        initLabelOptions(sparkline.label, options.label);
    }
}
function initPaddingOptions(target, options) {
    setValueIfPropertyExists(target, 'top', options.top, options);
    setValueIfPropertyExists(target, 'right', options.right, options);
    setValueIfPropertyExists(target, 'bottom', options.bottom, options);
    setValueIfPropertyExists(target, 'left', options.left, options);
}
function initMarkerOptions(target, options) {
    setValueIfPropertyExists(target, 'enabled', options.enabled, options);
    setValueIfPropertyExists(target, 'size', options.size, options);
    setValueIfPropertyExists(target, 'shape', options.shape, options);
    setValueIfPropertyExists(target, 'fill', options.fill, options);
    setValueIfPropertyExists(target, 'stroke', options.stroke, options);
    setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
    setValueIfPropertyExists(target, 'formatter', options.formatter, options);
}
function initLabelOptions(target, options) {
    setValueIfPropertyExists(target, 'enabled', options.enabled, options);
    setValueIfPropertyExists(target, 'fontStyle', options.fontStyle, options);
    setValueIfPropertyExists(target, 'fontWeight', options.fontWeight, options);
    setValueIfPropertyExists(target, 'fontSize', options.fontSize, options);
    setValueIfPropertyExists(target, 'fontFamily', options.fontFamily, options);
    setValueIfPropertyExists(target, 'textAlign', options.textAlign, options);
    setValueIfPropertyExists(target, 'textBaseline', options.textBaseline, options);
    setValueIfPropertyExists(target, 'color', options.color, options);
    setValueIfPropertyExists(target, 'formatter', options.formatter, options);
    setValueIfPropertyExists(target, 'placement', options.placement, options);
}
function initLineOptions(target, options) {
    setValueIfPropertyExists(target, 'stroke', options.stroke, options);
    setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initAxisOptions(target, options) {
    setValueIfPropertyExists(target, 'type', options.type, options);
    setValueIfPropertyExists(target, 'stroke', options.stroke, options);
    setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initHighlightStyleOptions(target, options) {
    setValueIfPropertyExists(target, 'fill', options.fill, options);
    setValueIfPropertyExists(target, 'size', options.size, options);
    setValueIfPropertyExists(target, 'stroke', options.stroke, options);
    setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
}
function initCrosshairsOptions(target, options) {
    if (target.xLine && options.xLine) {
        initCrosshairLineOptions(target.xLine, options.xLine);
    }
    if (target.yLine && options.yLine) {
        initCrosshairLineOptions(target.yLine, options.yLine);
    }
}
function initCrosshairLineOptions(target, options) {
    setValueIfPropertyExists(target, 'enabled', options.enabled, options);
    setValueIfPropertyExists(target, 'stroke', options.stroke, options);
    setValueIfPropertyExists(target, 'strokeWidth', options.strokeWidth, options);
    setValueIfPropertyExists(target, 'lineDash', options.lineDash, options);
    setValueIfPropertyExists(target, 'lineCap', options.lineCap, options);
}
var doOnceFlags = {};
/**
 * If the key was passed before, then doesn't execute the func
 * @param {Function} func
 * @param {string} key
 */
function doOnce(func, key) {
    if (doOnceFlags[key]) {
        return;
    }
    func();
    doOnceFlags[key] = true;
}
var offsetValidator = function (property, value, defaultOffset) {
    if (isNumber(value)) {
        return true;
    }
    var message =
        'AG Charts: ' +
        property +
        ' must be a number, the value you provided is not a valid number. Using the default of ' +
        defaultOffset +
        'px.';
    doOnce(function () {
        return console.warn(message);
    }, property + ' not a number');
    return false;
};
var validators = {
    xOffset: offsetValidator,
    yOffset: offsetValidator,
};
function setValueIfPropertyExists(target, property, value, options) {
    if (property in options) {
        if (property in target) {
            var validator = validators[property];
            var isValid = validator ? validator(property, value, target[property]) : true;
            if (isValid && target[property] !== value) {
                // only set property if the value is different to new value
                target[property] = value;
            }
        } else {
            console.warn('Property ' + property + ' does not exist on the target object.');
        }
    }
}

var __extends$1 =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __assign =
    (undefined && undefined.__assign) ||
    function () {
        __assign =
            Object.assign ||
            function (t) {
                for (var s, i = 1, n = arguments.length; i < n; i++) {
                    s = arguments[i];
                    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                }
                return t;
            };
        return __assign.apply(this, arguments);
    };
var __decorate$1 =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
var SparklineCellRenderer = /** @class */ (function (_super) {
    __extends$1(SparklineCellRenderer, _super);
    function SparklineCellRenderer() {
        return _super.call(this, SparklineCellRenderer.TEMPLATE) || this;
    }
    SparklineCellRenderer.prototype.init = function (params) {
        var _this = this;
        var firstTimeIn = true;
        var updateSparkline = function () {
            var _a = _this.getGui(),
                clientWidth = _a.clientWidth,
                clientHeight = _a.clientHeight;
            if (clientWidth === 0 || clientHeight === 0) {
                return;
            }
            if (firstTimeIn) {
                var options = __assign(
                    {
                        data: params.value,
                        width: clientWidth,
                        height: clientHeight,
                        context: {
                            data: params.data,
                        },
                    },
                    params.sparklineOptions,
                );
                // create new instance of sparkline
                _this.sparkline = AgSparkline.create(options, _this.sparklineTooltipSingleton.getSparklineTooltip());
                // append sparkline canvas to cell renderer element
                _this.eSparkline.appendChild(_this.sparkline.canvasElement);
                firstTimeIn = false;
            } else {
                _this.sparkline.width = clientWidth;
                _this.sparkline.height = clientHeight;
            }
        };
        var unsubscribeFromResize = this.resizeObserverService.observeResize(this.getGui(), updateSparkline);
        this.addDestroyFunc(function () {
            return unsubscribeFromResize();
        });
    };
    SparklineCellRenderer.prototype.refresh = function (params) {
        if (this.sparkline) {
            this.sparkline.data = params.value;
            return true;
        }
        return false;
    };
    SparklineCellRenderer.prototype.destroy = function () {
        if (this.sparkline) {
            this.sparkline.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    SparklineCellRenderer.TEMPLATE /* html */ =
        '<div class="ag-sparkline-wrapper">\n            <span ref="eSparkline"></span>\n        </div>';
    __decorate$1([RefSelector('eSparkline')], SparklineCellRenderer.prototype, 'eSparkline', void 0);
    __decorate$1(
        [Autowired('resizeObserverService')],
        SparklineCellRenderer.prototype,
        'resizeObserverService',
        void 0,
    );
    __decorate$1(
        [Autowired('sparklineTooltipSingleton')],
        SparklineCellRenderer.prototype,
        'sparklineTooltipSingleton',
        void 0,
    );
    return SparklineCellRenderer;
})(Component);

var __extends =
    (undefined && undefined.__extends) ||
    (function () {
        var extendStatics = function (d, b) {
            extendStatics =
                Object.setPrototypeOf ||
                ({ __proto__: [] } instanceof Array &&
                    function (d, b) {
                        d.__proto__ = b;
                    }) ||
                function (d, b) {
                    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                };
            return extendStatics(d, b);
        };
        return function (d, b) {
            if (typeof b !== 'function' && b !== null)
                throw new TypeError('Class extends value ' + String(b) + ' is not a constructor or null');
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
        };
    })();
var __decorate =
    (undefined && undefined.__decorate) ||
    function (decorators, target, key, desc) {
        var c = arguments.length,
            r = c < 3 ? target : desc === null ? (desc = Object.getOwnPropertyDescriptor(target, key)) : desc,
            d;
        if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')
            r = Reflect.decorate(decorators, target, key, desc);
        else
            for (var i = decorators.length - 1; i >= 0; i--)
                if ((d = decorators[i])) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
/**
 * This 'bean' creates a single sparkline tooltip that is bound to the grid lifecycle.
 */
var SparklineTooltipSingleton = /** @class */ (function (_super) {
    __extends(SparklineTooltipSingleton, _super);
    function SparklineTooltipSingleton() {
        return (_super !== null && _super.apply(this, arguments)) || this;
    }
    SparklineTooltipSingleton.prototype.postConstruct = function () {
        this.tooltip = new SparklineTooltip();
    };
    SparklineTooltipSingleton.prototype.getSparklineTooltip = function () {
        return this.tooltip;
    };
    SparklineTooltipSingleton.prototype.destroyTooltip = function () {
        if (this.tooltip) {
            this.tooltip.destroy();
        }
    };
    __decorate([PostConstruct], SparklineTooltipSingleton.prototype, 'postConstruct', null);
    __decorate([PreDestroy], SparklineTooltipSingleton.prototype, 'destroyTooltip', null);
    SparklineTooltipSingleton = __decorate([Bean('sparklineTooltipSingleton')], SparklineTooltipSingleton);
    return SparklineTooltipSingleton;
})(BeanStub);

// DO NOT UPDATE MANUALLY: Generated from script during build time
var VERSION = '30.2.0';

var SparklinesModule = {
    version: VERSION,
    moduleName: ModuleNames.SparklinesModule,
    beans: [SparklineTooltipSingleton],
    userComponents: [{ componentName: 'agSparklineCellRenderer', componentClass: SparklineCellRenderer }],
    dependantModules: [EnterpriseCoreModule],
};

const AllEnterpriseModules = [
    AdvancedFilterModule,
    ClipboardModule,
    ColumnsToolPanelModule,
    ExcelExportModule,
    FiltersToolPanelModule,
    GridChartsModule,
    MasterDetailModule,
    MenuModule,
    MultiFilterModule,
    RangeSelectionModule,
    RichSelectModule,
    RowGroupingModule,
    ServerSideRowModelModule,
    SetFilterModule,
    SideBarModule,
    StatusBarModule,
    ViewportRowModelModule,
    SparklinesModule,
];
const AllModules = AllCommunityModules.concat(AllEnterpriseModules);

ModuleRegistry.registerModules(AllEnterpriseModules);

export {
    AdvancedFilterModule,
    AllEnterpriseModules,
    AllModules,
    ClipboardModule,
    ColumnsToolPanelModule,
    EnterpriseCoreModule,
    ExcelExportModule,
    FiltersToolPanelModule,
    GridChartsModule,
    GridLicenseManager as LicenseManager,
    MasterDetailModule,
    MenuModule,
    MultiFilter,
    MultiFilterModule,
    PivotDropZonePanel,
    PrimaryColsPanel,
    RangeSelectionModule,
    RichSelectModule,
    RowGroupDropZonePanel,
    RowGroupingModule,
    ServerSideRowModelModule,
    SetFilter,
    SetFilterModule,
    SideBarModule,
    SparklinesModule,
    StatusBarModule,
    ToolPanelColDefService,
    ValuesDropZonePanel,
    ViewportRowModelModule,
    __FORCE_MODULE_DETECTION_AG_GRID_CORE_EXT,
    agCharts,
    exportMultipleSheetsAsExcel,
    getMultipleSheetsAsExcel,
};
